/******/ (function(modules) { // webpackBootstrap
/******/ 	function hotDisposeChunk(chunkId) {
/******/ 		delete installedChunks[chunkId];
/******/ 	}
/******/ 	var parentHotUpdateCallback = window["webpackHotUpdate"];
/******/ 	window["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	} ;
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		;
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(requestTimeout) { // eslint-disable-line no-unused-vars
/******/ 		requestTimeout = requestTimeout || 10000;
/******/ 		return new Promise(function(resolve, reject) {
/******/ 			if(typeof XMLHttpRequest === "undefined")
/******/ 				return reject(new Error("No browser support"));
/******/ 			try {
/******/ 				var request = new XMLHttpRequest();
/******/ 				var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 				request.open("GET", requestPath, true);
/******/ 				request.timeout = requestTimeout;
/******/ 				request.send(null);
/******/ 			} catch(err) {
/******/ 				return reject(err);
/******/ 			}
/******/ 			request.onreadystatechange = function() {
/******/ 				if(request.readyState !== 4) return;
/******/ 				if(request.status === 0) {
/******/ 					// timeout
/******/ 					reject(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 				} else if(request.status === 404) {
/******/ 					// no update available
/******/ 					resolve();
/******/ 				} else if(request.status !== 200 && request.status !== 304) {
/******/ 					// other failure
/******/ 					reject(new Error("Manifest request to " + requestPath + " failed."));
/******/ 				} else {
/******/ 					// success
/******/ 					try {
/******/ 						var update = JSON.parse(request.responseText);
/******/ 					} catch(e) {
/******/ 						reject(e);
/******/ 						return;
/******/ 					}
/******/ 					resolve(update);
/******/ 				}
/******/ 			};
/******/ 		});
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "277bc3a7f9de2b8bd56f"; // eslint-disable-line no-unused-vars
/******/ 	var hotRequestTimeout = 10000;
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentChildModule; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentParentsTemp = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 				} else {
/******/ 					hotCurrentParents = [moduleId];
/******/ 					hotCurrentChildModule = request;
/******/ 				}
/******/ 				if(me.children.indexOf(request) < 0)
/******/ 					me.children.push(request);
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		var ObjectFactory = function ObjectFactory(name) {
/******/ 			return {
/******/ 				configurable: true,
/******/ 				enumerable: true,
/******/ 				get: function() {
/******/ 					return __webpack_require__[name];
/******/ 				},
/******/ 				set: function(value) {
/******/ 					__webpack_require__[name] = value;
/******/ 				}
/******/ 			};
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name) && name !== "e") {
/******/ 				Object.defineProperty(fn, name, ObjectFactory(name));
/******/ 			}
/******/ 		}
/******/ 		fn.e = function(chunkId) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			return __webpack_require__.e(chunkId).then(finishChunkLoading, function(err) {
/******/ 				finishChunkLoading();
/******/ 				throw err;
/******/ 			});
/******/ 	
/******/ 			function finishChunkLoading() {
/******/ 				hotChunksLoading--;
/******/ 				if(hotStatus === "prepare") {
/******/ 					if(!hotWaitingFilesMap[chunkId]) {
/******/ 						hotEnsureUpdateChunk(chunkId);
/******/ 					}
/******/ 					if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 						hotUpdateDownloaded();
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 			_main: hotCurrentChildModule !== moduleId,
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback || function() {};
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback || function() {};
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 				else
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		hotCurrentChildModule = undefined;
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailableFilesMap = {};
/******/ 	var hotDeferred;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		hotApplyOnUpdate = apply;
/******/ 		hotSetStatus("check");
/******/ 		return hotDownloadManifest(hotRequestTimeout).then(function(update) {
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				return null;
/******/ 			}
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			hotAvailableFilesMap = update.c;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			var promise = new Promise(function(resolve, reject) {
/******/ 				hotDeferred = {
/******/ 					resolve: resolve,
/******/ 					reject: reject
/******/ 				};
/******/ 			});
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 0;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 			return promise;
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailableFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailableFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var deferred = hotDeferred;
/******/ 		hotDeferred = null;
/******/ 		if(!deferred) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			// Wrap deferred object in Promise to mark it as a well-handled Promise to
/******/ 			// avoid triggering uncaught exception warning in Chrome.
/******/ 			// See https://bugs.chromium.org/p/chromium/issues/detail?id=465666
/******/ 			Promise.resolve().then(function() {
/******/ 				return hotApply(hotApplyOnUpdate);
/******/ 			}).then(
/******/ 				function(result) {
/******/ 					deferred.resolve(result);
/******/ 				},
/******/ 				function(err) {
/******/ 					deferred.reject(err);
/******/ 				}
/******/ 			);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			deferred.resolve(outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		options = options || {};
/******/ 	
/******/ 		var cb;
/******/ 		var i;
/******/ 		var j;
/******/ 		var module;
/******/ 		var moduleId;
/******/ 	
/******/ 		function getAffectedStuff(updateModuleId) {
/******/ 			var outdatedModules = [updateModuleId];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice().map(function(id) {
/******/ 				return {
/******/ 					chain: [id],
/******/ 					id: id
/******/ 				};
/******/ 			});
/******/ 			while(queue.length > 0) {
/******/ 				var queueItem = queue.pop();
/******/ 				var moduleId = queueItem.id;
/******/ 				var chain = queueItem.chain;
/******/ 				module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return {
/******/ 						type: "self-declined",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				if(module.hot._main) {
/******/ 					return {
/******/ 						type: "unaccepted",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(!parent) continue;
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return {
/******/ 							type: "declined",
/******/ 							chain: chain.concat([parentId]),
/******/ 							moduleId: moduleId,
/******/ 							parentId: parentId
/******/ 						};
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push({
/******/ 						chain: chain.concat([parentId]),
/******/ 						id: parentId
/******/ 					});
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return {
/******/ 				type: "accepted",
/******/ 				moduleId: updateModuleId,
/******/ 				outdatedModules: outdatedModules,
/******/ 				outdatedDependencies: outdatedDependencies
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 	
/******/ 		var warnUnexpectedRequire = function warnUnexpectedRequire() {
/******/ 			console.warn("[HMR] unexpected require(" + result.moduleId + ") to disposed module");
/******/ 		};
/******/ 	
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				moduleId = toModuleId(id);
/******/ 				var result;
/******/ 				if(hotUpdate[id]) {
/******/ 					result = getAffectedStuff(moduleId);
/******/ 				} else {
/******/ 					result = {
/******/ 						type: "disposed",
/******/ 						moduleId: id
/******/ 					};
/******/ 				}
/******/ 				var abortError = false;
/******/ 				var doApply = false;
/******/ 				var doDispose = false;
/******/ 				var chainInfo = "";
/******/ 				if(result.chain) {
/******/ 					chainInfo = "\nUpdate propagation: " + result.chain.join(" -> ");
/******/ 				}
/******/ 				switch(result.type) {
/******/ 					case "self-declined":
/******/ 						if(options.onDeclined)
/******/ 							options.onDeclined(result);
/******/ 						if(!options.ignoreDeclined)
/******/ 							abortError = new Error("Aborted because of self decline: " + result.moduleId + chainInfo);
/******/ 						break;
/******/ 					case "declined":
/******/ 						if(options.onDeclined)
/******/ 							options.onDeclined(result);
/******/ 						if(!options.ignoreDeclined)
/******/ 							abortError = new Error("Aborted because of declined dependency: " + result.moduleId + " in " + result.parentId + chainInfo);
/******/ 						break;
/******/ 					case "unaccepted":
/******/ 						if(options.onUnaccepted)
/******/ 							options.onUnaccepted(result);
/******/ 						if(!options.ignoreUnaccepted)
/******/ 							abortError = new Error("Aborted because " + moduleId + " is not accepted" + chainInfo);
/******/ 						break;
/******/ 					case "accepted":
/******/ 						if(options.onAccepted)
/******/ 							options.onAccepted(result);
/******/ 						doApply = true;
/******/ 						break;
/******/ 					case "disposed":
/******/ 						if(options.onDisposed)
/******/ 							options.onDisposed(result);
/******/ 						doDispose = true;
/******/ 						break;
/******/ 					default:
/******/ 						throw new Error("Unexception type " + result.type);
/******/ 				}
/******/ 				if(abortError) {
/******/ 					hotSetStatus("abort");
/******/ 					return Promise.reject(abortError);
/******/ 				}
/******/ 				if(doApply) {
/******/ 					appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 					addAllToSet(outdatedModules, result.outdatedModules);
/******/ 					for(moduleId in result.outdatedDependencies) {
/******/ 						if(Object.prototype.hasOwnProperty.call(result.outdatedDependencies, moduleId)) {
/******/ 							if(!outdatedDependencies[moduleId])
/******/ 								outdatedDependencies[moduleId] = [];
/******/ 							addAllToSet(outdatedDependencies[moduleId], result.outdatedDependencies[moduleId]);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 				if(doDispose) {
/******/ 					addAllToSet(outdatedModules, [result.moduleId]);
/******/ 					appliedUpdate[moduleId] = warnUnexpectedRequire;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(i = 0; i < outdatedModules.length; i++) {
/******/ 			moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		Object.keys(hotAvailableFilesMap).forEach(function(chunkId) {
/******/ 			if(hotAvailableFilesMap[chunkId] === false) {
/******/ 				hotDisposeChunk(chunkId);
/******/ 			}
/******/ 		});
/******/ 	
/******/ 		var idx;
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			moduleId = queue.pop();
/******/ 			module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(j = 0; j < disposeHandlers.length; j++) {
/******/ 				cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// when disposing there is no need to call dispose handler
/******/ 			delete outdatedDependencies[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		var dependency;
/******/ 		var moduleOutdatedDependencies;
/******/ 		for(moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				module = installedModules[moduleId];
/******/ 				if(module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					for(j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 						dependency = moduleOutdatedDependencies[j];
/******/ 						idx = module.children.indexOf(dependency);
/******/ 						if(idx >= 0) module.children.splice(idx, 1);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				module = installedModules[moduleId];
/******/ 				if(module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					var callbacks = [];
/******/ 					for(i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 						dependency = moduleOutdatedDependencies[i];
/******/ 						cb = module.hot._acceptedDependencies[dependency];
/******/ 						if(cb) {
/******/ 							if(callbacks.indexOf(cb) >= 0) continue;
/******/ 							callbacks.push(cb);
/******/ 						}
/******/ 					}
/******/ 					for(i = 0; i < callbacks.length; i++) {
/******/ 						cb = callbacks[i];
/******/ 						try {
/******/ 							cb(moduleOutdatedDependencies);
/******/ 						} catch(err) {
/******/ 							if(options.onErrored) {
/******/ 								options.onErrored({
/******/ 									type: "accept-errored",
/******/ 									moduleId: moduleId,
/******/ 									dependencyId: moduleOutdatedDependencies[i],
/******/ 									error: err
/******/ 								});
/******/ 							}
/******/ 							if(!options.ignoreErrored) {
/******/ 								if(!error)
/******/ 									error = err;
/******/ 							}
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err2) {
/******/ 						if(options.onErrored) {
/******/ 							options.onErrored({
/******/ 								type: "self-accept-error-handler-errored",
/******/ 								moduleId: moduleId,
/******/ 								error: err2,
/******/ 								orginalError: err, // TODO remove in webpack 4
/******/ 								originalError: err
/******/ 							});
/******/ 						}
/******/ 						if(!options.ignoreErrored) {
/******/ 							if(!error)
/******/ 								error = err2;
/******/ 						}
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else {
/******/ 					if(options.onErrored) {
/******/ 						options.onErrored({
/******/ 							type: "self-accept-errored",
/******/ 							moduleId: moduleId,
/******/ 							error: err
/******/ 						});
/******/ 					}
/******/ 					if(!options.ignoreErrored) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return Promise.reject(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		return new Promise(function(resolve) {
/******/ 			resolve(outdatedModules);
/******/ 		});
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {},
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: (hotCurrentParentsTemp = hotCurrentParents, hotCurrentParents = [], hotCurrentParentsTemp),
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/extends.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/axios/lib/axios.js");

/***/ }),

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var settle = __webpack_require__("./node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("./node_modules/axios/lib/helpers/buildURL.js");
var buildFullPath = __webpack_require__("./node_modules/axios/lib/core/buildFullPath.js");
var parseHeaders = __webpack_require__("./node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("./node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("./node_modules/axios/lib/core/createError.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("./node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "./node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var bind = __webpack_require__("./node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("./node_modules/axios/lib/core/Axios.js");
var mergeConfig = __webpack_require__("./node_modules/axios/lib/core/mergeConfig.js");
var defaults = __webpack_require__("./node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("./node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("./node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("./node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("./node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "./node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("./node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "./node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var buildURL = __webpack_require__("./node_modules/axios/lib/helpers/buildURL.js");
var InterceptorManager = __webpack_require__("./node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("./node_modules/axios/lib/core/dispatchRequest.js");
var mergeConfig = __webpack_require__("./node_modules/axios/lib/core/mergeConfig.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "./node_modules/axios/lib/core/buildFullPath.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("./node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("./node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "./node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("./node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("./node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("./node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("./node_modules/axios/lib/defaults.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "./node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "./node_modules/axios/lib/core/mergeConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ "./node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("./node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "./node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "./node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("./node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("./node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("./node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("./node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("./node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "./node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "./node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("./node_modules/axios/lib/helpers/bind.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "./node_modules/babel-polyfill/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__("./node_modules/core-js/shim.js");

__webpack_require__("./node_modules/regenerator-runtime/runtime.js");

__webpack_require__("./node_modules/core-js/fn/regexp/escape.js");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/actualApply.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("./node_modules/function-bind/index.js");

var $apply = __webpack_require__("./node_modules/call-bind-apply-helpers/functionApply.js");
var $call = __webpack_require__("./node_modules/call-bind-apply-helpers/functionCall.js");
var $reflectApply = __webpack_require__("./node_modules/call-bind-apply-helpers/reflectApply.js");

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/functionApply.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/functionCall.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("./node_modules/function-bind/index.js");
var $TypeError = __webpack_require__("./node_modules/es-errors/type.js");

var $call = __webpack_require__("./node_modules/call-bind-apply-helpers/functionCall.js");
var $actualApply = __webpack_require__("./node_modules/call-bind-apply-helpers/actualApply.js");

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/reflectApply.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ "./node_modules/call-bound/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("./node_modules/get-intrinsic/index.js");

var callBindBasic = __webpack_require__("./node_modules/call-bind-apply-helpers/index.js");

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/core-js/fn/regexp/escape.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/core.regexp.escape.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_core.js").RegExp.escape;


/***/ }),

/***/ "./node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_a-number-value.js":
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_advance-string-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-fill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-from-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("./node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-reduce.js":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("./node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var invoke = __webpack_require__("./node_modules/core-js/modules/_invoke.js");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var TAG = __webpack_require__("./node_modules/core-js/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var $iterDefine = __webpack_require__("./node_modules/core-js/modules/_iter-define.js");
var step = __webpack_require__("./node_modules/core-js/modules/_iter-step.js");
var setSpecies = __webpack_require__("./node_modules/core-js/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var fastKey = __webpack_require__("./node_modules/core-js/modules/_meta.js").fastKey;
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection-to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var from = __webpack_require__("./node_modules/core-js/modules/_array-from-iterable.js");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection-weak.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var getWeak = __webpack_require__("./node_modules/core-js/modules/_meta.js").getWeak;
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var createArrayMethod = __webpack_require__("./node_modules/core-js/modules/_array-methods.js");
var $has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "./node_modules/core-js/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var $iterDetect = __webpack_require__("./node_modules/core-js/modules/_iter-detect.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var inheritIfRequired = __webpack_require__("./node_modules/core-js/modules/_inherit-if-required.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_date-to-iso-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),

/***/ "./node_modules/core-js/modules/_date-to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("./node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_fix-re-wks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("./node_modules/core-js/modules/es6.regexp.exec.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
var regexpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec.js");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_flags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_flatten-into-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__("./node_modules/core-js/modules/_is-array.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var IS_CONCAT_SPREADABLE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),

/***/ "./node_modules/core-js/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var call = __webpack_require__("./node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/modules/_is-array-iter.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var getIterFn = __webpack_require__("./node_modules/core-js/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "./node_modules/core-js/modules/_function-to-string.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);


/***/ }),

/***/ "./node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("./node_modules/core-js/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/modules/_inherit-if-required.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var setPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_set-proto.js").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("./node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var descriptor = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var $iterCreate = __webpack_require__("./node_modules/core-js/modules/_iter-create.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "./node_modules/core-js/modules/_math-expm1.js":
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),

/***/ "./node_modules/core-js/modules/_math-fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__("./node_modules/core-js/modules/_math-sign.js");
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_math-log1p.js":
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_math-scale.js":
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_math-sign.js":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("./node_modules/core-js/modules/_uid.js")('meta');
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var setDesc = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "./node_modules/core-js/modules/_metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__("./node_modules/core-js/modules/es6.map.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js")('metadata');
var store = shared.store || (shared.store = new (__webpack_require__("./node_modules/core-js/modules/es6.weak-map.js"))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),

/***/ "./node_modules/core-js/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var macrotask = __webpack_require__("./node_modules/core-js/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("./node_modules/core-js/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var dPs = __webpack_require__("./node_modules/core-js/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("./node_modules/core-js/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("./node_modules/core-js/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");

module.exports = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-forced-pam.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__("./node_modules/core-js/modules/_library.js") || !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__("./node_modules/core-js/modules/_global.js")[K];
});


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("./node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var Reflect = __webpack_require__("./node_modules/core-js/modules/_global.js").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_parse-float.js":
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__("./node_modules/core-js/modules/_global.js").parseFloat;
var $trim = __webpack_require__("./node_modules/core-js/modules/_string-trim.js").trim;

module.exports = 1 / $parseFloat(__webpack_require__("./node_modules/core-js/modules/_string-ws.js") + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),

/***/ "./node_modules/core-js/modules/_parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__("./node_modules/core-js/modules/_global.js").parseInt;
var $trim = __webpack_require__("./node_modules/core-js/modules/_string-trim.js").trim;
var ws = __webpack_require__("./node_modules/core-js/modules/_string-ws.js");
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "./node_modules/core-js/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("./node_modules/core-js/modules/_uid.js")('src');
var $toString = __webpack_require__("./node_modules/core-js/modules/_function-to-string.js");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "./node_modules/core-js/modules/_regexp-exec-abstract.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_regexp-exec.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("./node_modules/core-js/modules/_flags.js");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "./node_modules/core-js/modules/_replacer.js":
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_same-value.js":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-collection-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-collection-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("./node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var SPECIES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var TAG = __webpack_require__("./node_modules/core-js/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var SPECIES = __webpack_require__("./node_modules/core-js/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_strict-method.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-html.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-pad.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var repeat = __webpack_require__("./node_modules/core-js/modules/_string-repeat.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-repeat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_string-trim.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var spaces = __webpack_require__("./node_modules/core-js/modules/_string-ws.js");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "./node_modules/core-js/modules/_string-ws.js":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "./node_modules/core-js/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var invoke = __webpack_require__("./node_modules/core-js/modules/_invoke.js");
var html = __webpack_require__("./node_modules/core-js/modules/_html.js");
var cel = __webpack_require__("./node_modules/core-js/modules/_dom-create.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("./node_modules/core-js/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-index.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/modules/_typed-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__("./node_modules/core-js/modules/_descriptors.js")) {
  var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
  var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
  var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
  var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
  var $typed = __webpack_require__("./node_modules/core-js/modules/_typed.js");
  var $buffer = __webpack_require__("./node_modules/core-js/modules/_typed-buffer.js");
  var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
  var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
  var propertyDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
  var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
  var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
  var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
  var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
  var toIndex = __webpack_require__("./node_modules/core-js/modules/_to-index.js");
  var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
  var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
  var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
  var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
  var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
  var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
  var isArrayIter = __webpack_require__("./node_modules/core-js/modules/_is-array-iter.js");
  var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
  var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
  var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
  var getIterFn = __webpack_require__("./node_modules/core-js/modules/core.get-iterator-method.js");
  var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
  var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
  var createArrayMethod = __webpack_require__("./node_modules/core-js/modules/_array-methods.js");
  var createArrayIncludes = __webpack_require__("./node_modules/core-js/modules/_array-includes.js");
  var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
  var ArrayIterators = __webpack_require__("./node_modules/core-js/modules/es6.array.iterator.js");
  var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
  var $iterDetect = __webpack_require__("./node_modules/core-js/modules/_iter-detect.js");
  var setSpecies = __webpack_require__("./node_modules/core-js/modules/_set-species.js");
  var arrayFill = __webpack_require__("./node_modules/core-js/modules/_array-fill.js");
  var arrayCopyWithin = __webpack_require__("./node_modules/core-js/modules/_array-copy-within.js");
  var $DP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
  var $GOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js/modules/_typed-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var $typed = __webpack_require__("./node_modules/core-js/modules/_typed.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toIndex = __webpack_require__("./node_modules/core-js/modules/_to-index.js");
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var arrayFill = __webpack_require__("./node_modules/core-js/modules/_array-fill.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),

/***/ "./node_modules/core-js/modules/_typed.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),

/***/ "./node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "./node_modules/core-js/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var wksExt = __webpack_require__("./node_modules/core-js/modules/_wks-ext.js");
var defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "./node_modules/core-js/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("./node_modules/core-js/modules/_wks.js");


/***/ }),

/***/ "./node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("./node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
var Symbol = __webpack_require__("./node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "./node_modules/core-js/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/modules/core.regexp.escape.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $re = __webpack_require__("./node_modules/core-js/modules/_replacer.js")(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { copyWithin: __webpack_require__("./node_modules/core-js/modules/_array-copy-within.js") });

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('copyWithin');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.every.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $every = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(4);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.fill.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { fill: __webpack_require__("./node_modules/core-js/modules/_array-fill.js") });

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('fill');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.filter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $filter = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(2);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.find-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.for-each.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $forEach = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(0);
var STRICT = __webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var call = __webpack_require__("./node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/modules/_is-array-iter.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var createProperty = __webpack_require__("./node_modules/core-js/modules/_create-property.js");
var getIterFn = __webpack_require__("./node_modules/core-js/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.index-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $indexOf = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Array', { isArray: __webpack_require__("./node_modules/core-js/modules/_is-array.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js");
var step = __webpack_require__("./node_modules/core-js/modules/_iter-step.js");
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.join.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__("./node_modules/core-js/modules/_iobject.js") != Object || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.last-index-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $map = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(1);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var createProperty = __webpack_require__("./node_modules/core-js/modules/_create-property.js");

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.reduce-right.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $reduce = __webpack_require__("./node_modules/core-js/modules/_array-reduce.js");

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.reduce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $reduce = __webpack_require__("./node_modules/core-js/modules/_array-reduce.js");

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.slice.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var html = __webpack_require__("./node_modules/core-js/modules/_html.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.some.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $some = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(3);

$export($export.P + $export.F * !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.sort.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__("./node_modules/core-js/modules/_strict-method.js")($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.array.species.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_set-species.js")('Array');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.now.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-iso-string.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toISOString = __webpack_require__("./node_modules/core-js/modules/_date-to-iso-string.js");

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__("./node_modules/core-js/modules/_hide.js")(proto, TO_PRIMITIVE, __webpack_require__("./node_modules/core-js/modules/_date-to-primitive.js"));


/***/ }),

/***/ "./node_modules/core-js/modules/es6.date.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.function.bind.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'Function', { bind: __webpack_require__("./node_modules/core-js/modules/_bind.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.function.has-instance.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var HAS_INSTANCE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.function.name.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("./node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("./node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("./node_modules/core-js/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.acosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var log1p = __webpack_require__("./node_modules/core-js/modules/_math-log1p.js");
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.asinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.atanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.cbrt.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var sign = __webpack_require__("./node_modules/core-js/modules/_math-sign.js");

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.clz32.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.cosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.expm1.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $expm1 = __webpack_require__("./node_modules/core-js/modules/_math-expm1.js");

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { fround: __webpack_require__("./node_modules/core-js/modules/_math-fround.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.hypot.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.imul.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.log10.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.log1p.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { log1p: __webpack_require__("./node_modules/core-js/modules/_math-log1p.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.log2.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.sign.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { sign: __webpack_require__("./node_modules/core-js/modules/_math-sign.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.sinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("./node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.tanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("./node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.math.trunc.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
var inheritIfRequired = __webpack_require__("./node_modules/core-js/modules/_inherit-if-required.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var $trim = __webpack_require__("./node_modules/core-js/modules/_string-trim.js").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("./node_modules/core-js/modules/_object-create.js")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(global, NUMBER, $Number);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.epsilon.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-finite.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var _isFinite = __webpack_require__("./node_modules/core-js/modules/_global.js").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { isInteger: __webpack_require__("./node_modules/core-js/modules/_is-integer.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-nan.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.is-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var isInteger = __webpack_require__("./node_modules/core-js/modules/_is-integer.js");
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.max-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.min-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.parse-float.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseFloat = __webpack_require__("./node_modules/core-js/modules/_parse-float.js");
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseInt = __webpack_require__("./node_modules/core-js/modules/_parse-int.js");
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.to-fixed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var aNumberValue = __webpack_require__("./node_modules/core-js/modules/_a-number-value.js");
var repeat = __webpack_require__("./node_modules/core-js/modules/_string-repeat.js");
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.number.to-precision.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var aNumberValue = __webpack_require__("./node_modules/core-js/modules/_a-number-value.js");
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("./node_modules/core-js/modules/_object-create.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.define-properties.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_descriptors.js"), 'Object', { defineProperties: __webpack_require__("./node_modules/core-js/modules/_object-dps.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.freeze.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('getOwnPropertyNames', function () {
  return __webpack_require__("./node_modules/core-js/modules/_object-gopn-ext.js").f;
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is-frozen.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is-sealed.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.is.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { is: __webpack_require__("./node_modules/core-js/modules/_same-value.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.seal.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("./node_modules/core-js/modules/_object-sap.js")('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/core-js/modules/_set-proto.js").set });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var test = {};
test[__webpack_require__("./node_modules/core-js/modules/_wks.js")('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.parse-float.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseFloat = __webpack_require__("./node_modules/core-js/modules/_parse-float.js");
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.parse-int.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $parseInt = __webpack_require__("./node_modules/core-js/modules/_parse-int.js");
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/modules/_library.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var classof = __webpack_require__("./node_modules/core-js/modules/_classof.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var task = __webpack_require__("./node_modules/core-js/modules/_task.js").set;
var microtask = __webpack_require__("./node_modules/core-js/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("./node_modules/core-js/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/modules/_perform.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("./node_modules/core-js/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("./node_modules/core-js/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("./node_modules/core-js/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("./node_modules/core-js/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.apply.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var rApply = (__webpack_require__("./node_modules/core-js/modules/_global.js").Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.construct.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var bind = __webpack_require__("./node_modules/core-js/modules/_bind.js");
var rConstruct = (__webpack_require__("./node_modules/core-js/modules/_global.js").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.delete-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.enumerate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__("./node_modules/core-js/modules/_iter-create.js")(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var getProto = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.get.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.has.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', { ownKeys: __webpack_require__("./node_modules/core-js/modules/_own-keys.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var setProto = __webpack_require__("./node_modules/core-js/modules/_set-proto.js");

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.reflect.set.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var inheritIfRequired = __webpack_require__("./node_modules/core-js/modules/_inherit-if-required.js");
var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f;
var gOPN = __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f;
var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var $flags = __webpack_require__("./node_modules/core-js/modules/_flags.js");
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && (!CORRECT_NEW || __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  re2[__webpack_require__("./node_modules/core-js/modules/_wks.js")('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(global, 'RegExp', $RegExp);
}

__webpack_require__("./node_modules/core-js/modules/_set-species.js")('RegExp');


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.exec.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec.js");
__webpack_require__("./node_modules/core-js/modules/_export.js")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.flags.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__("./node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("./node_modules/core-js/modules/_flags.js")
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.match.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var advanceStringIndex = __webpack_require__("./node_modules/core-js/modules/_advance-string-index.js");
var regExpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec-abstract.js");

// @@match logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.replace.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var advanceStringIndex = __webpack_require__("./node_modules/core-js/modules/_advance-string-index.js");
var regExpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec-abstract.js");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.search.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var sameValue = __webpack_require__("./node_modules/core-js/modules/_same-value.js");
var regExpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec-abstract.js");

// @@search logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var advanceStringIndex = __webpack_require__("./node_modules/core-js/modules/_advance-string-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var callRegExpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec-abstract.js");
var regexpExec = __webpack_require__("./node_modules/core-js/modules/_regexp-exec.js");
var fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("./node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.regexp.to-string.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("./node_modules/core-js/modules/es6.regexp.flags.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var $flags = __webpack_require__("./node_modules/core-js/modules/_flags.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("./node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("./node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("./node_modules/core-js/modules/_collection.js")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.anchor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.big.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.blink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.bold.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.code-point-at.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.ends-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("./node_modules/core-js/modules/_string-context.js");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails-is-regexp.js")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.fixed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.fontcolor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.fontsize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.from-code-point.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var context = __webpack_require__("./node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.italics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("./node_modules/core-js/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.link.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.raw.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.repeat.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("./node_modules/core-js/modules/_string-repeat.js")
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.small.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.starts-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("./node_modules/core-js/modules/_string-context.js");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.strike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.sub.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.sup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__("./node_modules/core-js/modules/_string-html.js")('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.string.trim.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__("./node_modules/core-js/modules/_string-trim.js")('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/modules/_descriptors.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var META = __webpack_require__("./node_modules/core-js/modules/_meta.js").KEY;
var $fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");
var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/modules/_set-to-string-tag.js");
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
var wksExt = __webpack_require__("./node_modules/core-js/modules/_wks-ext.js");
var wksDefine = __webpack_require__("./node_modules/core-js/modules/_wks-define.js");
var enumKeys = __webpack_require__("./node_modules/core-js/modules/_enum-keys.js");
var isArray = __webpack_require__("./node_modules/core-js/modules/_is-array.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
var _create = __webpack_require__("./node_modules/core-js/modules/_object-create.js");
var gOPNExt = __webpack_require__("./node_modules/core-js/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var $GOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var $DP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("./node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("./node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("./node_modules/core-js/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.array-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $typed = __webpack_require__("./node_modules/core-js/modules/_typed.js");
var buffer = __webpack_require__("./node_modules/core-js/modules/_typed-buffer.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var ArrayBuffer = __webpack_require__("./node_modules/core-js/modules/_global.js").ArrayBuffer;
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__("./node_modules/core-js/modules/_set-species.js")(ARRAY_BUFFER);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.data-view.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
$export($export.G + $export.W + $export.F * !__webpack_require__("./node_modules/core-js/modules/_typed.js").ABV, {
  DataView: __webpack_require__("./node_modules/core-js/modules/_typed-buffer.js").DataView
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.float32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.float64-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.int16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.int32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.int8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es6.weak-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var each = __webpack_require__("./node_modules/core-js/modules/_array-methods.js")(0);
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var meta = __webpack_require__("./node_modules/core-js/modules/_meta.js");
var assign = __webpack_require__("./node_modules/core-js/modules/_object-assign.js");
var weak = __webpack_require__("./node_modules/core-js/modules/_collection-weak.js");
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var NATIVE_WEAK_MAP = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("./node_modules/core-js/modules/_collection.js")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "./node_modules/core-js/modules/es6.weak-set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__("./node_modules/core-js/modules/_collection-weak.js");
var validate = __webpack_require__("./node_modules/core-js/modules/_validate-collection.js");
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__("./node_modules/core-js/modules/_collection.js")(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),

/***/ "./node_modules/core-js/modules/es7.array.flat-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var flattenIntoArray = __webpack_require__("./node_modules/core-js/modules/_flatten-into-array.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var arraySpeciesCreate = __webpack_require__("./node_modules/core-js/modules/_array-species-create.js");

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('flatMap');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.array.flatten.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var flattenIntoArray = __webpack_require__("./node_modules/core-js/modules/_flatten-into-array.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var arraySpeciesCreate = __webpack_require__("./node_modules/core-js/modules/_array-species-create.js");

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('flatten');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("./node_modules/core-js/modules/_add-to-unscopables.js")('includes');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.asap.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var microtask = __webpack_require__("./node_modules/core-js/modules/_microtask.js")();
var process = __webpack_require__("./node_modules/core-js/modules/_global.js").process;
var isNode = __webpack_require__("./node_modules/core-js/modules/_cof.js")(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.error.is-error.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.global.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.G, { global: __webpack_require__("./node_modules/core-js/modules/_global.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('Map');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('Map');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.map.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("./node_modules/core-js/modules/_collection-to-json.js")('Map') });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.clamp.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.deg-per-rad.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.degrees.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.fscale.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var scale = __webpack_require__("./node_modules/core-js/modules/_math-scale.js");
var fround = __webpack_require__("./node_modules/core-js/modules/_math-fround.js");

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.iaddh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.imulh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.isubh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.rad-per-deg.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.radians.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.scale.js":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { scale: __webpack_require__("./node_modules/core-js/modules/_math-scale.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.signbit.js":
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.math.umulh.js":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.define-getter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var $defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.define-setter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var $defineProperty = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("./node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var ownKeys = __webpack_require__("./node_modules/core-js/modules/_own-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var gOPD = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js");
var createProperty = __webpack_require__("./node_modules/core-js/modules/_create-property.js");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.lookup-getter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.lookup-setter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/modules/_object-gopd.js").f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__("./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("./node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.observable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var microtask = __webpack_require__("./node_modules/core-js/modules/_microtask.js")();
var OBSERVABLE = __webpack_require__("./node_modules/core-js/modules/_wks.js")('observable');
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var anInstance = __webpack_require__("./node_modules/core-js/modules/_an-instance.js");
var redefineAll = __webpack_require__("./node_modules/core-js/modules/_redefine-all.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var forOf = __webpack_require__("./node_modules/core-js/modules/_for-of.js");
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__("./node_modules/core-js/modules/_set-species.js")('Observable');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/modules/_species-constructor.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/modules/_promise-resolve.js");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.promise.try.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/modules/_perform.js");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.define-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.delete-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-metadata-keys.js":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("./node_modules/core-js/modules/es6.set.js");
var from = __webpack_require__("./node_modules/core-js/modules/_array-from-iterable.js");
var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.get-own-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.has-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/modules/_object-gpo.js");
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.has-own-metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.reflect.metadata.js":
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__("./node_modules/core-js/modules/_metadata.js");
var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.set.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('Set');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.set.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('Set');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.set.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__("./node_modules/core-js/modules/_collection-to-json.js")('Set') });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.at.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $at = __webpack_require__("./node_modules/core-js/modules/_string-at.js")(true);
var $fails = __webpack_require__("./node_modules/core-js/modules/_fails.js");

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.match-all.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var isRegExp = __webpack_require__("./node_modules/core-js/modules/_is-regexp.js");
var getFlags = __webpack_require__("./node_modules/core-js/modules/_flags.js");
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__("./node_modules/core-js/modules/_iter-create.js")($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.pad-end.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("./node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.pad-start.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("./node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.trim-left.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__("./node_modules/core-js/modules/_string-trim.js")('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.string.trim-right.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__("./node_modules/core-js/modules/_string-trim.js")('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/_wks-define.js")('observable');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.system.global.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S, 'System', { global: __webpack_require__("./node_modules/core-js/modules/_global.js") });


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('WeakMap');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('WeakMap');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-set.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__("./node_modules/core-js/modules/_set-collection-from.js")('WeakSet');


/***/ }),

/***/ "./node_modules/core-js/modules/es7.weak-set.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__("./node_modules/core-js/modules/_set-collection-of.js")('WeakSet');


/***/ }),

/***/ "./node_modules/core-js/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("./node_modules/core-js/modules/es6.array.iterator.js");
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/modules/_iterators.js");
var wks = __webpack_require__("./node_modules/core-js/modules/_wks.js");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "./node_modules/core-js/modules/web.immediate.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var $task = __webpack_require__("./node_modules/core-js/modules/_task.js");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),

/***/ "./node_modules/core-js/modules/web.timers.js":
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");
var userAgent = __webpack_require__("./node_modules/core-js/modules/_user-agent.js");
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ "./node_modules/core-js/shim.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/modules/es6.symbol.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.create.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.define-property.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.define-properties.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.get-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.keys.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.get-own-property-names.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.freeze.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.seal.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.prevent-extensions.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is-frozen.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is-sealed.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is-extensible.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.assign.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.is.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.set-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.function.bind.js");
__webpack_require__("./node_modules/core-js/modules/es6.function.name.js");
__webpack_require__("./node_modules/core-js/modules/es6.function.has-instance.js");
__webpack_require__("./node_modules/core-js/modules/es6.parse-int.js");
__webpack_require__("./node_modules/core-js/modules/es6.parse-float.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.constructor.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.to-fixed.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.to-precision.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.epsilon.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-finite.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-nan.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.is-safe-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.max-safe-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.min-safe-integer.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.parse-float.js");
__webpack_require__("./node_modules/core-js/modules/es6.number.parse-int.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.acosh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.asinh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.atanh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.cbrt.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.clz32.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.cosh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.expm1.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.fround.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.hypot.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.imul.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.log10.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.log1p.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.log2.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.sign.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.sinh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.tanh.js");
__webpack_require__("./node_modules/core-js/modules/es6.math.trunc.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.from-code-point.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.raw.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.trim.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.code-point-at.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.ends-with.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.includes.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.repeat.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.starts-with.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.anchor.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.big.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.blink.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.bold.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.fixed.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.fontcolor.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.fontsize.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.italics.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.link.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.small.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.strike.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.sub.js");
__webpack_require__("./node_modules/core-js/modules/es6.string.sup.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.now.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-json.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-iso-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.date.to-primitive.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.is-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.from.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.of.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.join.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.slice.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.sort.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.for-each.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.map.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.filter.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.some.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.every.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.reduce.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.reduce-right.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.index-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.last-index-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.copy-within.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.fill.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.find.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.find-index.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.species.js");
__webpack_require__("./node_modules/core-js/modules/es6.array.iterator.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.constructor.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.exec.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.to-string.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.flags.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.match.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.replace.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.search.js");
__webpack_require__("./node_modules/core-js/modules/es6.regexp.split.js");
__webpack_require__("./node_modules/core-js/modules/es6.promise.js");
__webpack_require__("./node_modules/core-js/modules/es6.map.js");
__webpack_require__("./node_modules/core-js/modules/es6.set.js");
__webpack_require__("./node_modules/core-js/modules/es6.weak-map.js");
__webpack_require__("./node_modules/core-js/modules/es6.weak-set.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.array-buffer.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.data-view.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.int8-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint8-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.int16-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint16-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.int32-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.uint32-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.float32-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.typed.float64-array.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.apply.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.construct.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.define-property.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.delete-property.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.enumerate.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.get.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.get-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.has.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.is-extensible.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.own-keys.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.prevent-extensions.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.set.js");
__webpack_require__("./node_modules/core-js/modules/es6.reflect.set-prototype-of.js");
__webpack_require__("./node_modules/core-js/modules/es7.array.includes.js");
__webpack_require__("./node_modules/core-js/modules/es7.array.flat-map.js");
__webpack_require__("./node_modules/core-js/modules/es7.array.flatten.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.at.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.pad-start.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.pad-end.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.trim-left.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.trim-right.js");
__webpack_require__("./node_modules/core-js/modules/es7.string.match-all.js");
__webpack_require__("./node_modules/core-js/modules/es7.symbol.async-iterator.js");
__webpack_require__("./node_modules/core-js/modules/es7.symbol.observable.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.values.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.entries.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.define-getter.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.define-setter.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.lookup-getter.js");
__webpack_require__("./node_modules/core-js/modules/es7.object.lookup-setter.js");
__webpack_require__("./node_modules/core-js/modules/es7.map.to-json.js");
__webpack_require__("./node_modules/core-js/modules/es7.set.to-json.js");
__webpack_require__("./node_modules/core-js/modules/es7.map.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.set.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-map.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-set.of.js");
__webpack_require__("./node_modules/core-js/modules/es7.map.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.set.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-map.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.weak-set.from.js");
__webpack_require__("./node_modules/core-js/modules/es7.global.js");
__webpack_require__("./node_modules/core-js/modules/es7.system.global.js");
__webpack_require__("./node_modules/core-js/modules/es7.error.is-error.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.clamp.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.deg-per-rad.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.degrees.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.fscale.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.iaddh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.isubh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.imulh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.rad-per-deg.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.radians.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.scale.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.umulh.js");
__webpack_require__("./node_modules/core-js/modules/es7.math.signbit.js");
__webpack_require__("./node_modules/core-js/modules/es7.promise.finally.js");
__webpack_require__("./node_modules/core-js/modules/es7.promise.try.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.define-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.delete-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-metadata-keys.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-own-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.get-own-metadata-keys.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.has-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.has-own-metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.reflect.metadata.js");
__webpack_require__("./node_modules/core-js/modules/es7.asap.js");
__webpack_require__("./node_modules/core-js/modules/es7.observable.js");
__webpack_require__("./node_modules/core-js/modules/web.timers.js");
__webpack_require__("./node_modules/core-js/modules/web.immediate.js");
__webpack_require__("./node_modules/core-js/modules/web.dom.iterable.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_core.js");


/***/ }),

/***/ "./node_modules/country-flags-svg/dist/data/countries.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var flagUrlByIso3 = __webpack_require__("./node_modules/country-flags-svg/dist/data/flagUrlByIso3.js");

var CountryData = /*#__PURE__*/_createClass(function CountryData(name, demonym, iso2, iso3) {
  var altSpellings = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  _classCallCheck(this, CountryData);

  this.name = name;
  this.demonym = demonym;
  this.flag = flagUrlByIso3[iso3];
  this.iso2 = iso2;
  this.iso3 = iso3;
  this.altSpellings = altSpellings;
});

module.exports = [new CountryData("Afghanistan", "Afghan", "AF", "AFG"), new CountryData("Aland Islands", "Alandic", "AX", "ALA"), new CountryData("Albania", "Albanian", "AL", "ALB"), new CountryData("Algeria", "Algerian", "DZ", "DZA"), new CountryData("American Samoa", "American Samoan", "AS", "ASM"), new CountryData("Andorra", "Andorran", "AD", "AND"), new CountryData("Angola", "Angolan", "AO", "AGO"), new CountryData("Anguilla", "Anguillian", "AI", "AIA"), new CountryData("Antigua and Barbuda", "Antiguan Barbudan", "AG", "ATG"), new CountryData("Argentina", "Argentinian", "AR", "ARG"), new CountryData("Armenia", "Armenian", "AM", "ARM"), new CountryData("Aruba", "Arubian", "AW", "ABW"), new CountryData("Australia", "Australian", "AU", "AUS"), new CountryData("Austria", "Austrian", "AT", "AUT"), new CountryData("Azerbaijan", "Azerbaijani", "AZ", "AZE"), new CountryData("Bahamas", "Bahamian", "BS", "BHS"), new CountryData("Bahrain", "Bahraini", "BH", "BHR"), new CountryData("Bangladesh", "Bengali", "BD", "BGD"), new CountryData("Barbados", "Barbadian", "BB", "BRB"), new CountryData("Belarus", "Belarusian", "BY", "BLR"), new CountryData("Belgium", "Belgian", "BE", "BEL"), new CountryData("Belize", "Belizean", "BZ", "BLZ"), new CountryData("Benin", "Beninese", "BJ", "BEN"), new CountryData("Bermuda", "Bermudian", "BM", "BMU"), new CountryData("Bhutan", "Bhutanese", "BT", "BTN"), new CountryData("Bolivia", "Bolivian", "BO", "BOL"), new CountryData("Bonaire, Sint Eustatius and Saba", "Dutch", "BQ", "BES"), new CountryData("Bosnia and Herzegovina", "Bosnian", "BA", "BIH"), new CountryData("Botswana", "Batswana", "BW", "BWA"), new CountryData("Brazil", "Brazilian", "BR", "BRA"), new CountryData("British Virgin Islands", "Virgin Islander", "VG", "VGB"), new CountryData("Brunei", "Bruneian", "BN", "BRN"), new CountryData("Bulgaria", "Bulgarian", "BG", "BGR"), new CountryData("Burkina Faso", "Burkinabé", "BF", "BFA"), new CountryData("Burundi", "Burundian", "BI", "BDI"), new CountryData("Cambodia", "Cambodian", "KH", "KHM"), new CountryData("Cameroon", "Cameroonian", "CM", "CMR"), new CountryData("Canada", "Canadian", "CA", "CAN"), new CountryData("Cape Verde", "Cape Verdean", "CV", "CPV"), new CountryData("Cayman Islands", "Caymanian", "KY", "CYM"), new CountryData("Central African Republic", "Central African", "CF", "CAF"), new CountryData("Chad", "Chadian", "TD", "TCD"), new CountryData("Chile", "Chilean", "CL", "CHL"), new CountryData("China", "Chinese", "CN", "CHN"), new CountryData("Christmas Island", "Christmas Islander", "CX", "CXR"), new CountryData("Cocos Islands", "Taiwanese", "CC", "CCK"), new CountryData("Colombia", "Colombian", "CO", "COL"), new CountryData("Comoros", "Comorian", "KM", "COM"), new CountryData("Congo", "Congolese", "CG", "COG"), new CountryData("Cook Islands", "Cook Islander", "CK", "COK"), new CountryData("Costa Rica", "Costa Rican", "CR", "CRI"), new CountryData("Côte d'Ivoire", "Ivorian", "CI", "CIV"), new CountryData("Croatia", "Croatian", "HR", "HRV"), new CountryData("Cuba", "Cuban", "CU", "CUB"), new CountryData("Curaçao", "Dutch", "CW", "CUW"), new CountryData("Cyprus", "Cypriot", "CY", "CYP"), new CountryData("Czech Republic", "Czech", "CZ", "CZE"), new CountryData("Democratic Republic of the Congo", "Congolese", "CD", "COD"), new CountryData("Denmark", "Danish", "DK", "DNK"), new CountryData("Djibouti", "Djiboutian", "DJ", "DJI"), new CountryData("Dominica", "Dominican", "DM", "DMA"), new CountryData("Dominican Republic", "Dominican", "DO", "DOM"), new CountryData("Ecuador", "Ecuadorian", "EC", "ECU"), new CountryData("Egypt", "Egyptian", "EG", "EGY"), new CountryData("El Salvador", "Salvadoran", "SV", "SLV"), new CountryData("Equatorial Guinea", "Equatoguinean", "GQ", "GNQ"), new CountryData("Eritrea", "Eritrean", "ER", "ERI"), new CountryData("Estonia", "Estonian", "EE", "EST"), new CountryData("Ethiopia", "Ethiopian", "ET", "ETH"), new CountryData("Falkland Islands", "Falkland Islander", "FK", "FLK"), new CountryData("Faroe Islands", "Faroese", "FO", "FRO"), new CountryData("Fiji", "Fijian", "FJ", "FJI"), new CountryData("Finland", "Finnish", "FI", "FIN"), new CountryData("France", "French", "FR", "FRA"), new CountryData("French Guiana", "Guianan", "GF", "GUF"), new CountryData("French Polynesia", "French Polynesian", "PF", "PYF"), new CountryData("Gabon", "Gabonese", "GA", "GAB"), new CountryData("Gambia", "Gambian", "GM", "GMB"), new CountryData("Georgia", "Georgian", "GE", "GEO"), new CountryData("Germany", "German", "DE", "DEU"), new CountryData("Ghana", "Ghanaian", "GH", "GHA"), new CountryData("Gibraltar", "Gibraltarian", "GI", "GIB"), new CountryData("Greece", "Greek", "GR", "GRC"), new CountryData("Greenland", "Greenlander", "GL", "GRL"), new CountryData("Grenada", "Grenadian", "GD", "GRD"), new CountryData("Guadeloupe", "Guadeloupean", "GP", "GLP"), new CountryData("Guam", "Guamanian", "GU", "GUM"), new CountryData("Guatemala", "Guatemalan", "GT", "GTM"), new CountryData("Guernsey", "Guernseymen", "GG", "GGY"), new CountryData("Guinea-Bissau", "Bissau-Guinean", "GW", "GNB"), new CountryData("Guinea", "Guinean", "GN", "GIN"), new CountryData("Guyana", "Guyanese", "GY", "GUY"), new CountryData("Haiti", "Haitian", "HT", "HTI"), new CountryData("Holy See", "Papal", "VA", "VAT", ["Vatican"]), new CountryData("Honduras", "Honduran", "HN", "HND"), new CountryData("Hong Kong", "Hong Kongese", "HK", "HKG"), new CountryData("Hungary", "Hungarian", "HU", "HUN"), new CountryData("Iceland", "Icelander", "IS", "ISL"), new CountryData("India", "Indian", "IN", "IND"), new CountryData("Indonesia", "Indonesian", "ID", "IDN"), new CountryData("British Indian Ocean Territory", "British", "IO", "IOT"), new CountryData("Iran", "Iranian", "IR", "IRN"), new CountryData("Iraq", "Iraqi", "IQ", "IRQ"), new CountryData("Ireland", "Irish", "IE", "IRL"), new CountryData("Isle of Man", "Manx", "IM", "IMN"), new CountryData("Israel", "Israeli", "IL", "ISR"), new CountryData("Italy", "Italian", "IT", "ITA"), new CountryData("Jamaica", "Jamaican", "JM", "JAM"), new CountryData("Japan", "Japanese", "JP", "JPN"), new CountryData("Jersey", "Jerseyman", "JE", "JEY"), new CountryData("Jordan", "Jordanian", "JO", "JOR"), new CountryData("Kazakhstan", "Kazakhstani", "KZ", "KAZ"), new CountryData("Kenya", "Kenyan", "KE", "KEN"), new CountryData("Kiribati", "I-Kiribati", "KI", "KIR"), new CountryData("Kosovo", "Kosovar", "XK", "XXK"), new CountryData("Kuwait", "	Kuwaiti", "KW", "KWT"), new CountryData("Kyrgyzstan", "Kyrgyzstani", "KG", "KGZ"), new CountryData("Laos", "Lao", "LA", "LAO"), new CountryData("Latvia", "Latvian", "LV", "LVA"), new CountryData("Lebanon", "Lebanese", "LB", "LBN"), new CountryData("Lesotho", "Lesothonian", "LS", "LSO"), new CountryData("Liberia", "Liberian", "LR", "LBR"), new CountryData("Libya", "Libyan", "LY", "LBY"), new CountryData("Liechtenstein", "Liechtensteiner", "LI", "LIE"), new CountryData("Lithuania", "Lithuanian", "LT", "LTU"), new CountryData("Luxembourg", "Luxembourgish", "LU", "LUX"), new CountryData("Macao", "Macau", "MO", "MAC"), new CountryData("Madagascar", "Malagasy", "MG", "MDG"), new CountryData("Malawi", "Malawian", "MW", "MWI"), new CountryData("Malaysia", "Malaysian", "MY", "MYS"), new CountryData("Maldives", "Maldivian", "MV", "MDV"), new CountryData("Mali", "Malian", "ML", "MLI"), new CountryData("Malta", "Maltese", "MT", "MLT"), new CountryData("Marshall Islands", "Marshallese", "MH", "MHL"), new CountryData("Martinique", "Martinican", "MQ", "MTQ"), new CountryData("Mauritania", "Mauritanian", "MR", "MRT"), new CountryData("Mauritius", "Mauritian", "MU", "MUS"), new CountryData("Mayotte", "Mahoran", "YT", "MYT"), new CountryData("Mexico", "Mexican", "MX", "MEX"), new CountryData("Micronesia", "Micronesian", "FM", "FSM"), new CountryData("Moldova", "Moldovan", "MD", "MDA"), new CountryData("Monaco", "Monegasque", "MC", "MCO"), new CountryData("Mongolia", "Mongolian", "MN", "MNG"), new CountryData("Montenegro", "Montenegrin", "ME", "MNE"), new CountryData("Montserrat", "Montserratian", "MS", "MSR"), new CountryData("Morocco", "Moroccan", "MA", "MAR"), new CountryData("Mozambique", "Mozambican", "MZ", "MOZ"), new CountryData("Myanmar", "Myanma", "MM", "MMR"), new CountryData("Namibia", "Namibian", "NA", "NAM"), new CountryData("Nauru", "Nauruan", "NR", "NRU"), new CountryData("Nepal", "Nepalese", "NP", "NPL"), new CountryData("Netherlands Antilles", "Netherlands Antillean", "AN", "ANT"), new CountryData("Netherlands", "Dutch", "NL", "NLD"), new CountryData("New Caledonia", "New Caledonian", "NC", "NCL"), new CountryData("New Zealand", "New Zealander", "NZ", "NZL"), new CountryData("Nicaragua", "Nicaraguan", "NI", "NIC"), new CountryData("Niger", "Nigerien", "NE", "NER"), new CountryData("Nigeria", "Nigerian", "NG", "NGA"), new CountryData("Niue", "Niuean", "NU", "NIU"), new CountryData("Norfolk Island", "Norfolk Islander", "NF", "NFK"), new CountryData("North Korea", "North Korea", "KP", "PRK"), new CountryData("North Macedonia", "Macedonian", "MK", "MKD"), new CountryData("Northern Mariana Islands", "Northern Mariana Islander", "MP", "MNP"), new CountryData("Norway", "Norwegian", "NO", "NOR"), new CountryData("Oman", "Omani", "OM", "OMN"), new CountryData("Pakistan", "Pakistani", "PK", "PAK"), new CountryData("Palau", "Palauan", "PW", "PLW"), new CountryData("Palestine", "Palestinian", "PS", "PSE"), new CountryData("Panama", "Panamanian", "PA", "PAN"), new CountryData("Papua New Guinea", "Papua New Guinean", "PG", "PNG"), new CountryData("Paraguay", "Paraguayan", "PY", "PRY"), new CountryData("Peru", "Peruvian", "PE", "PER"), new CountryData("Philippines", "Filipino", "PH", "PHL"), new CountryData("Pitcairn", "Pitcairn Islander", "PN", "PCN"), new CountryData("Poland", "Polish", "PL", "POL"), new CountryData("Portugal", "Portuguese", "PT", "PRT"), new CountryData("Puerto Rico", "Puerto Rican", "PR", "PRI"), new CountryData("Qatar", "Qatari", "QA", "QAT"), new CountryData("Réunion", "Réunionese", "RE", "REU"), new CountryData("Romania", "Romanian", "RO", "ROU"), new CountryData("Russia", "Russian", "RU", "RUS"), new CountryData("Rwanda", "Rwandan", "RW", "RWA"), new CountryData("Saint Barthélemy", "Barthélemois", "BL", "BLM"), new CountryData("Saint Helena, Ascension and Tristan da Cunha", "Ascensionian", "SH", "SHN", ["Saint Helenian", "Tristanian"]), new CountryData("Saint Kitts and Nevis", "Kittitian", "KN", "KNA", ["Nevisian"]), new CountryData("Saint Lucia", "Saint Lucian", "LC", "LCA"), new CountryData("Saint Martin", "Saint-Martinois", "MF", "MAF"), new CountryData("Saint Pierre and Miquelon", "Saint-Pierrais", "PM", "SPM"), new CountryData("Saint Vincent and the Grenadines", "Saint Vincentian", "VC", "VCT"), new CountryData("Samoa", "Samoan", "WS", "WSM"), new CountryData("San Marino", "Sammarinese", "SM", "SMR"), new CountryData("Sao Tome and Principe", "São Toméan", "ST", "STP"), new CountryData("Saudi Arabia", "Saudi", "SA", "SAU"), new CountryData("Senegal", "Senegalese", "SN", "SEN"), new CountryData("Serbia", "Serbian", "RS", "SRB"), new CountryData("Seychelles", "Seychellois", "SC", "SYC"), new CountryData("Sierra Leone", "Sierra Leonean", "SL", "SLE"), new CountryData("Singapore", "Singaporean", "SG", "SGP", ["SG", "Singapura", "Republik Singapura"]), new CountryData("Sint Maarten", "St. Maartener", "SX", "SXM"), new CountryData("Slovakia", "Slovak", "SK", "SVK"), new CountryData("Slovenia", "Slovenian", "SI", "SVN"), new CountryData("Solomon Islands", "Solomon Islander", "SB", "SLB"), new CountryData("Somalia", "Somali", "SO", "SOM"), new CountryData("South Africa", "South African", "ZA", "ZAF"), new CountryData("South Georgia and the South Sandwich Islands", "South Georgian", "GS", "SGS"), new CountryData("South Korea", "South Korean", "KR", "KOR", ["Republic of Korea"]), new CountryData("South Sudan", "South Sudanese", "SS", "SSD"), new CountryData("Spain", "Spanish", "ES", "ESP"), new CountryData("Sri Lanka", "Sri Lankan", "LK", "LKA"), new CountryData("Sudan", "Sudanese", "SD", "SDN"), new CountryData("Suriname", "Surinamese", "SR", "SUR"), new CountryData("Svalbard and Jan Mayen", "Svalbard", "SJ", "SJM"), new CountryData("Swaziland", "Swazi", "SZ", "SWZ"), new CountryData("Sweden", "Swedish", "SE", "SWE"), new CountryData("Switzerland", "Swiss", "CH", "CHE"), new CountryData("Syria", "Syrian", "SY", "SYR"), new CountryData("Taiwan", "Taiwanese", "TW", "TWN"), new CountryData("Tajikistan", "Tajik", "TJ", "TJK"), new CountryData("Tanzania", "Tanzanian", "TZ", "TZA"), new CountryData("Thailand", "Thai", "TH", "THA"), new CountryData("Timor-Leste", "Timorese", "TL", "TLS"), new CountryData("Togo", "Togolese", "TG", "TGO"), new CountryData("Tokelau", "Tokelauan", "TK", "TKL"), new CountryData("Tonga", "Tongan", "TO", "TON"), new CountryData("Trinidad and Tobago", "Trinidadian and Tobagonian", "TT", "TTO"), new CountryData("Tunisia", "Tunisian", "TN", "TUN"), new CountryData("Turkey", "Turkish", "TR", "TUR"), new CountryData("Turkmenistan", "Turkmenistani", "TM", "TKM"), new CountryData("Turks and Caicos Islands", "Turks and Caicos Islander", "TC", "TCA"), new CountryData("Tuvalu", "Tuvaluan", "TV", "TUV"), new CountryData("Uganda", "Ugandan", "UG", "UGA"), new CountryData("Ukraine", "Ukrainian", "UA", "UKR"), new CountryData("United Arab Emirates", "Emirati", "AE", "ARE", ["AE", "UAE"]), new CountryData("United Kingdom", "British", "GB", "GBR", ["UK"]), new CountryData("United States Minor Outlying Islands", "American Islander", "UM", "UMI"), new CountryData("United States", "American", "US", "USA", ["USA"]), new CountryData("Uruguay", "Uruguayan", "UY", "URY"), new CountryData("Uzbekistan", "Uzbek", "UZ", "UZB"), new CountryData("Vanuatu", "Vanuatuan", "VU", "VUT"), new CountryData("Venezuela", "Venezuelan", "VE", "VEN"), new CountryData("Vietnam", "Vietnamese", "VN", "VNM", ["Viet Nam", "Republic of Viet Nam", "South Vietnam"]), new CountryData("Virgin Islands of the United States", "Virgin Islander", "VI", "VIR"), new CountryData("Wallis and Futuna", "Wallisian", "WF", "WLF", ["Futunan"]), new CountryData("Western Sahara", "Western Saharan", "EH", "ESH"), new CountryData("Yemen", "Yemeni", "YE", "YEM"), new CountryData("Zambia", "Zambian", "ZM", "ZMB"), new CountryData("Zimbabwe", "Zimbabwean", "ZW", "ZWE")];

/***/ }),

/***/ "./node_modules/country-flags-svg/dist/data/flagUrlByIso3.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function createUrl(svgUrl) {
  return "https://upload.wikimedia.org/wikipedia/".concat(svgUrl);
}

module.exports = {
  'ABW': createUrl('commons/f/f6/Flag_of_Aruba.svg'),
  'AFG': createUrl('commons/5/5c/Flag_of_the_Taliban.svg'),
  'AGO': createUrl('commons/9/9d/Flag_of_Angola.svg'),
  'AIA': createUrl('commons/b/b4/Flag_of_Anguilla.svg'),
  'ALA': createUrl('commons/5/52/Flag_of_%C3%85land.svg'),
  'ALB': createUrl('commons/3/36/Flag_of_Albania.svg'),
  'AND': createUrl('commons/1/19/Flag_of_Andorra.svg'),
  'ANT': createUrl('commons/e/eb/Flag_of_the_Netherlands_Antilles_(1959%E2%80%931986).svg'),
  'ARE': createUrl('commons/c/cb/Flag_of_the_United_Arab_Emirates.svg'),
  'ARG': createUrl('commons/1/1a/Flag_of_Argentina.svg'),
  'ARM': createUrl('commons/2/2f/Flag_of_Armenia.svg'),
  'ASM': createUrl('commons/8/87/Flag_of_American_Samoa.svg'),
  'ATG': createUrl('commons/8/89/Flag_of_Antigua_and_Barbuda.svg'),
  'AUS': createUrl('commons/8/88/Flag_of_Australia_(converted).svg'),
  'AUT': createUrl('commons/4/41/Flag_of_Austria.svg'),
  'AZE': createUrl('commons/d/dd/Flag_of_Azerbaijan.svg'),
  'BDI': createUrl('commons/5/50/Flag_of_Burundi.svg'),
  'BEL': createUrl('commons/6/65/Flag_of_Belgium.svg'),
  'BEN': createUrl('commons/0/0a/Flag_of_Benin.svg'),
  'BES': createUrl('commons/2/20/Flag_of_the_Netherlands.svg'),
  'BFA': createUrl('commons/3/31/Flag_of_Burkina_Faso.svg'),
  'BGD': createUrl('commons/f/f9/Flag_of_Bangladesh.svg'),
  'BGR': createUrl('commons/9/9a/Flag_of_Bulgaria.svg'),
  'BHR': createUrl('commons/2/2c/Flag_of_Bahrain.svg'),
  'BHS': createUrl('commons/9/93/Flag_of_the_Bahamas.svg'),
  'BIH': createUrl('commons/b/bf/Flag_of_Bosnia_and_Herzegovina.svg'),
  'BLM': createUrl('commons/0/03/Saint-Barthelémy_Icône.svg'),
  'BLR': createUrl('commons/8/85/Flag_of_Belarus.svg'),
  'BLZ': createUrl('commons/e/e7/Flag_of_Belize.svg'),
  'BMU': createUrl('commons/b/bf/Flag_of_Bermuda.svg'),
  'BOL': createUrl('commons/5/5b/Bolivia_Flag.svg'),
  'BRA': createUrl('commons/0/05/Flag_of_Brazil.svg'),
  'BRB': createUrl('commons/e/ef/Flag_of_Barbados.svg'),
  'BRN': createUrl('commons/9/9c/Flag_of_Brunei.svg'),
  'BTN': createUrl('commons/9/91/Flag_of_Bhutan.svg'),
  'BWA': createUrl('commons/f/fa/Flag_of_Botswana.svg'),
  'CAF': createUrl('commons/6/6f/Flag_of_the_Central_African_Republic.svg'),
  'CAN': createUrl('commons/d/d9/Flag_of_Canada_(Pantone).svg'),
  'CCK': createUrl('commons/7/74/Flag_of_the_Cocos_(Keeling)_Islands.svg'),
  'CHE': createUrl('commons/f/f3/Flag_of_Switzerland.svg'),
  'CHL': createUrl('commons/7/78/Flag_of_Chile.svg'),
  'CHN': createUrl('commons/f/fa/Flag_of_the_People%27s_Republic_of_China.svg'),
  'CIV': createUrl('commons/f/fe/Flag_of_Côte_d%27Ivoire.svg'),
  'CMR': createUrl('commons/4/4f/Flag_of_Cameroon.svg'),
  'COD': createUrl('commons/1/11/Flag_of_the_Democratic_Republic_of_the_Congo_(3-2).svg'),
  'COG': createUrl('commons/9/92/Flag_of_the_Republic_of_the_Congo.svg'),
  'COK': createUrl('commons/3/35/Flag_of_the_Cook_Islands.svg'),
  'COL': createUrl('commons/2/21/Flag_of_Colombia.svg'),
  'COM': createUrl('commons/d/df/Flag_of_the_Comoros_(3-2).svg'),
  'CPV': createUrl('commons/3/38/Flag_of_Cape_Verde.svg'),
  'CRI': createUrl('commons/b/bc/Flag_of_Costa_Rica_(state).svg'),
  'CUB': createUrl('commons/b/bd/Flag_of_Cuba.svg'),
  'CUW': createUrl('commons/b/b1/Flag_of_Curaçao.svg'),
  'CXR': createUrl('commons/6/67/Flag_of_Christmas_Island.svg'),
  'CYM': createUrl('commons/0/0f/Flag_of_the_Cayman_Islands.svg'),
  'CYP': createUrl('commons/d/d4/Flag_of_Cyprus.svg'),
  'CZE': createUrl('commons/c/cb/Flag_of_the_Czech_Republic.svg'),
  'DEU': createUrl('commons/b/ba/Flag_of_Germany.svg'),
  'DJI': createUrl('commons/3/34/Flag_of_Djibouti.svg'),
  'DMA': createUrl('commons/c/c4/Flag_of_Dominica.svg'),
  'DNK': createUrl('commons/9/9c/Flag_of_Denmark.svg'),
  'DOM': createUrl('commons/9/9f/Flag_of_the_Dominican_Republic.svg'),
  'DZA': createUrl('commons/7/77/Flag_of_Algeria.svg'),
  'ECU': createUrl('commons/e/e8/Flag_of_Ecuador.svg'),
  'EGY': createUrl('commons/f/fe/Flag_of_Egypt.svg'),
  'ERI': createUrl('commons/2/29/Flag_of_Eritrea.svg'),
  'ESH': createUrl('commons/2/26/Flag_of_the_Sahrawi_Arab_Democratic_Republic.svg'),
  'ESP': createUrl('commons/9/9a/Flag_of_Spain.svg'),
  'EST': createUrl('commons/8/8f/Flag_of_Estonia.svg'),
  'ETH': createUrl('commons/7/71/Flag_of_Ethiopia.svg'),
  'FIN': createUrl('commons/b/bc/Flag_of_Finland.svg'),
  'FJI': createUrl('commons/b/ba/Flag_of_Fiji.svg'),
  'FLK': createUrl('commons/8/83/Flag_of_the_Falkland_Islands.svg'),
  'FRA': createUrl('commons/c/c3/Flag_of_France.svg'),
  'FRO': createUrl('commons/3/3c/Flag_of_the_Faroe_Islands.svg'),
  'FSM': createUrl('commons/e/e4/Flag_of_the_Federated_States_of_Micronesia.svg'),
  'GAB': createUrl('commons/0/04/Flag_of_Gabon.svg'),
  'GBR': createUrl('commons/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg'),
  'GEO': createUrl('commons/0/0f/Flag_of_Georgia.svg'),
  'GGY': createUrl('commons/f/fa/Flag_of_Guernsey.svg'),
  'GHA': createUrl('commons/1/19/Flag_of_Ghana.svg'),
  'GIB': createUrl('commons/0/02/Flag_of_Gibraltar.svg'),
  'GIN': createUrl('commons/e/ed/Flag_of_Guinea.svg'),
  'GLP': createUrl('commons/9/9f/Flag_of_France_%287x10%29.svg'),
  'GMB': createUrl('commons/7/77/Flag_of_The_Gambia.svg'),
  'GNB': createUrl('commons/0/01/Flag_of_Guinea-Bissau.svg'),
  'GNQ': createUrl('commons/3/31/Flag_of_Equatorial_Guinea.svg'),
  'GRC': createUrl('commons/5/5c/Flag_of_Greece.svg'),
  'GRD': createUrl('commons/b/bc/Flag_of_Grenada.svg'),
  'GRL': createUrl('commons/0/09/Flag_of_Greenland.svg'),
  'GTM': createUrl('commons/e/ec/Flag_of_Guatemala.svg'),
  'GUF': createUrl('commons/e/ed/Flag_of_France_%28Pantone%29.svg'),
  'GUM': createUrl('commons/0/07/Flag_of_Guam.svg'),
  'GUY': createUrl('commons/9/99/Flag_of_Guyana.svg'),
  'HKG': createUrl('commons/5/5b/Flag_of_Hong_Kong.svg'),
  'HND': createUrl('commons/8/82/Flag_of_Honduras.svg'),
  'HRV': createUrl('commons/1/1b/Flag_of_Croatia.svg'),
  'HTI': createUrl('commons/5/56/Flag_of_Haiti.svg'),
  'HUN': createUrl('commons/c/c1/Flag_of_Hungary.svg'),
  'IDN': createUrl('commons/9/9f/Flag_of_Indonesia.svg'),
  'IMN': createUrl('commons/b/bc/Flag_of_the_Isle_of_Man.svg'),
  'IND': createUrl('commons/4/41/Flag_of_India.svg'),
  'IOT': createUrl('commons/6/65/Flag_of_the_Commissioner_of_the_British_Indian_Ocean_Territory.svg'),
  'IRL': createUrl('commons/c/c0/Republic_of_Ireland_Flag.svg'),
  'IRN': createUrl('commons/c/ca/Flag_of_Iran.svg'),
  'IRQ': createUrl('commons/f/f6/Flag_of_Iraq.svg'),
  'ISL': createUrl('commons/c/ce/Flag_of_Iceland.svg'),
  'ISR': createUrl('commons/d/d4/Flag_of_Israel.svg'),
  'ITA': createUrl('commons/0/03/Flag_of_Italy.svg'),
  'JAM': createUrl('commons/0/0a/Flag_of_Jamaica.svg'),
  'JEY': createUrl('commons/1/1c/Flag_of_Jersey.svg'),
  'JOR': createUrl('commons/c/c0/Flag_of_Jordan.svg'),
  'JPN': createUrl('commons/b/bc/Flag_of_Japan%28bordered%29.svg'),
  'KAZ': createUrl('commons/d/d3/Flag_of_Kazakhstan.svg'),
  'KEN': createUrl('commons/4/49/Flag_of_Kenya.svg'),
  'KGZ': createUrl('commons/c/c7/Flag_of_Kyrgyzstan.svg'),
  'KHM': createUrl('commons/8/83/Flag_of_Cambodia.svg'),
  'KIR': createUrl('commons/d/d3/Flag_of_Kiribati.svg'),
  'KNA': createUrl('commons/f/fe/Flag_of_Saint_Kitts_and_Nevis.svg'),
  'KOR': createUrl('commons/0/09/Flag_of_South_Korea.svg'),
  'KWT': createUrl('commons/a/aa/Flag_of_Kuwait.svg'),
  'LAO': createUrl('commons/5/56/Flag_of_Laos.svg'),
  'LBN': createUrl('commons/5/59/Flag_of_Lebanon.svg'),
  'LBR': createUrl('commons/b/b8/Flag_of_Liberia.svg'),
  'LBY': createUrl('commons/0/05/Flag_of_Libya.svg'),
  'LCA': createUrl('commons/9/9f/Flag_of_Saint_Lucia.svg'),
  'LIE': createUrl('commons/4/47/Flag_of_Liechtenstein.svg'),
  'LKA': createUrl('commons/1/11/Flag_of_Sri_Lanka.svg'),
  'LSO': createUrl('commons/4/4a/Flag_of_Lesotho.svg'),
  'LTU': createUrl('commons/1/11/Flag_of_Lithuania.svg'),
  'LUX': createUrl('commons/d/da/Flag_of_Luxembourg.svg'),
  'LVA': createUrl('commons/8/84/Flag_of_Latvia.svg'),
  'MAC': createUrl('commons/6/63/Flag_of_Macau.svg'),
  'MAF': createUrl('commons/d/dd/Flag_of_Saint-Martin_%28fictional%29.svg'),
  'MAR': createUrl('commons/2/2c/Flag_of_Morocco.svg'),
  'MCO': createUrl('commons/e/ea/Flag_of_Monaco.svg'),
  'MDA': createUrl('commons/2/27/Flag_of_Moldova.svg'),
  'MDG': createUrl('commons/b/bc/Flag_of_Madagascar.svg'),
  'MDV': createUrl('commons/0/0f/Flag_of_Maldives.svg'),
  'MEX': createUrl('commons/f/fc/Flag_of_Mexico.svg'),
  'MHL': createUrl('commons/2/2e/Flag_of_the_Marshall_Islands.svg'),
  'MKD': createUrl('commons/7/79/Flag_of_North_Macedonia.svg'),
  'MLI': createUrl('commons/9/92/Flag_of_Mali.svg'),
  'MLT': createUrl('commons/7/73/Flag_of_Malta.svg'),
  'MMR': createUrl('commons/8/8c/Flag_of_Myanmar.svg'),
  'MNE': createUrl('commons/6/64/Flag_of_Montenegro.svg'),
  'MNG': createUrl('commons/4/4c/Flag_of_Mongolia.svg'),
  'MNP': createUrl('commons/e/e0/Flag_of_the_Northern_Mariana_Islands.svg'),
  'MOZ': createUrl('commons/d/d0/Flag_of_Mozambique.svg'),
  'MRT': createUrl('commons/4/43/Flag_of_Mauritania.svg'),
  'MSR': createUrl('commons/d/d0/Flag_of_Montserrat.svg'),
  'MTQ': createUrl('commons/2/21/Flag_of_the_Territorial_Collectivity_of_Martinique.svg'),
  'MUS': createUrl('commons/7/77/Flag_of_Mauritius.svg'),
  'MWI': createUrl('commons/d/d1/Flag_of_Malawi.svg'),
  'MYS': createUrl('commons/6/66/Flag_of_Malaysia.svg'),
  'MYT': createUrl('commons/c/c3/Flag_of_France.svg'),
  'NAM': createUrl('commons/0/00/Flag_of_Namibia.svg'),
  'NCL': createUrl('commons/6/66/Flag_of_FLNKS.svg'),
  'NER': createUrl('commons/f/f4/Flag_of_Niger.svg'),
  'NFK': createUrl('commons/4/48/Flag_of_Norfolk_Island.svg'),
  'NGA': createUrl('commons/7/79/Flag_of_Nigeria.svg'),
  'NIC': createUrl('commons/1/19/Flag_of_Nicaragua.svg'),
  'NIU': createUrl('commons/0/01/Flag_of_Niue.svg'),
  'NLD': createUrl('commons/2/20/Flag_of_the_Netherlands.svg'),
  'NOR': createUrl('commons/d/d9/Flag_of_Norway.svg'),
  'NPL': createUrl('commons/9/9b/Flag_of_Nepal.svg'),
  'NRU': createUrl('commons/3/30/Flag_of_Nauru.svg'),
  'NZL': createUrl('commons/3/3e/Flag_of_New_Zealand.svg'),
  'OMN': createUrl('commons/d/dd/Flag_of_Oman.svg'),
  'PAK': createUrl('commons/3/32/Flag_of_Pakistan.svg'),
  'PAN': createUrl('commons/a/ab/Flag_of_Panama.svg'),
  'PCN': createUrl('commons/8/88/Flag_of_the_Pitcairn_Islands.svg'),
  'PER': createUrl('commons/c/cf/Flag_of_Peru.svg'),
  'PHL': createUrl('commons/9/99/Flag_of_the_Philippines.svg'),
  'PLW': createUrl('commons/4/48/Flag_of_Palau.svg'),
  'PNG': createUrl('commons/e/e3/Flag_of_Papua_New_Guinea.svg'),
  'POL': createUrl('commons/1/12/Flag_of_Poland.svg'),
  'PRI': createUrl('commons/2/28/Flag_of_Puerto_Rico.svg'),
  'PRK': createUrl('commons/5/51/Flag_of_North_Korea.svg'),
  'PRT': createUrl('commons/5/5c/Flag_of_Portugal.svg'),
  'PRY': createUrl('commons/2/27/Flag_of_Paraguay.svg'),
  'PSE': createUrl('commons/f/f4/Palestine_Flag.svg'),
  'PYF': createUrl('commons/d/db/Flag_of_French_Polynesia.svg'),
  'QAT': createUrl('commons/6/65/Flag_of_Qatar.svg'),
  'REU': createUrl('commons/5/5a/Flag_of_Réunion.svg'),
  'ROU': createUrl('commons/7/73/Flag_of_Romania.svg'),
  'RUS': createUrl('commons/f/f3/Flag_of_Russia.svg'),
  'RWA': createUrl('commons/1/17/Flag_of_Rwanda.svg'),
  'SAU': createUrl('commons/0/0d/Flag_of_Saudi_Arabia.svg'),
  'SDN': createUrl('commons/0/01/Flag_of_Sudan.svg'),
  'SEN': createUrl('commons/f/fd/Flag_of_Senegal.svg'),
  'SGP': createUrl('commons/4/48/Flag_of_Singapore.svg'),
  'SGS': createUrl('commons/e/ed/Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg'),
  'SHN': createUrl('commons/0/00/Flag_of_Saint_Helena.svg'),
  'SJM': createUrl('commons/d/d9/Flag_of_Norway.svg'),
  'SLB': createUrl('commons/7/74/Flag_of_the_Solomon_Islands.svg'),
  'SLE': createUrl('commons/1/17/Flag_of_Sierra_Leone.svg'),
  'SLV': createUrl('commons/3/34/Flag_of_El_Salvador.svg'),
  'SMR': createUrl('commons/b/b1/Flag_of_San_Marino.svg'),
  'SOM': createUrl('commons/a/a0/Flag_of_Somalia.svg'),
  'SPM': createUrl('commons/7/74/Flag_of_Saint-Pierre_and_Miquelon.svg'),
  'SRB': createUrl('commons/f/ff/Flag_of_Serbia.svg'),
  'SSD': createUrl('commons/7/7a/Flag_of_South_Sudan.svg'),
  'STP': createUrl('commons/4/4f/Flag_of_Sao_Tome_and_Principe.svg'),
  'SUR': createUrl('commons/6/60/Flag_of_Suriname.svg'),
  'SVK': createUrl('commons/e/e6/Flag_of_Slovakia.svg'),
  'SVN': createUrl('commons/f/f0/Flag_of_Slovenia.svg'),
  'SWE': createUrl('commons/4/4c/Flag_of_Sweden.svg'),
  'SWZ': createUrl('commons/f/fb/Flag_of_Eswatini.svg'),
  'SXM': createUrl('commons/d/d3/Flag_of_Sint_Maarten.svg'),
  'SYC': createUrl('commons/f/fc/Flag_of_Seychelles.svg'),
  'SYR': createUrl('commons/5/53/Flag_of_Syria.svg'),
  'TCA': createUrl('commons/a/a0/Flag_of_the_Turks_and_Caicos_Islands.svg'),
  'TCD': createUrl('commons/4/4b/Flag_of_Chad.svg'),
  'TGO': createUrl('commons/6/68/Flag_of_Togo.svg'),
  'THA': createUrl('commons/a/a9/Flag_of_Thailand.svg'),
  'TJK': createUrl('commons/d/d0/Flag_of_Tajikistan.svg'),
  'TKL': createUrl('commons/8/8e/Flag_of_Tokelau.svg'),
  'TKM': createUrl('commons/1/1b/Flag_of_Turkmenistan.svg'),
  'TLS': createUrl('commons/2/26/Flag_of_East_Timor.svg'),
  'TON': createUrl('commons/9/9a/Flag_of_Tonga.svg'),
  'TTO': createUrl('commons/6/64/Flag_of_Trinidad_and_Tobago.svg'),
  'TUN': createUrl('commons/c/ce/Flag_of_Tunisia.svg'),
  'TUR': createUrl('commons/b/b4/Flag_of_Turkey.svg'),
  'TUV': createUrl('commons/3/38/Flag_of_Tuvalu.svg'),
  'TWN': createUrl('commons/7/72/Flag_of_the_Republic_of_China.svg'),
  'TZA': createUrl('commons/3/38/Flag_of_Tanzania.svg'),
  'UGA': createUrl('commons/4/4e/Flag_of_Uganda.svg'),
  'UKR': createUrl('commons/4/49/Flag_of_Ukraine.svg'),
  'UMI': createUrl('commons/0/05/Flag_of_the_U.S..svg'),
  'URY': createUrl('commons/f/fe/Flag_of_Uruguay.svg'),
  'USA': createUrl('commons/a/a4/Flag_of_the_United_States.svg'),
  'UZB': createUrl('commons/8/84/Flag_of_Uzbekistan.svg'),
  'VAT': createUrl('commons/0/00/Flag_of_the_Vatican_City.svg'),
  'VCT': createUrl('commons/6/6d/Flag_of_Saint_Vincent_and_the_Grenadines.svg'),
  'VEN': createUrl('commons/7/7b/Flag_of_Venezuela_(state).svg'),
  'VGB': createUrl('commons/4/42/Flag_of_the_British_Virgin_Islands.svg'),
  'VIR': createUrl('commons/f/f8/Flag_of_the_United_States_Virgin_Islands.svg'),
  'VNM': createUrl('commons/2/21/Flag_of_Vietnam.svg'),
  'VUT': createUrl('commons/6/6e/Flag_of_Vanuatu_(official).svg'),
  'WLF': createUrl('commons/d/d2/Flag_of_Wallis_and_Futuna.svg'),
  'WSM': createUrl('commons/3/31/Flag_of_Samoa.svg'),
  'XXK': createUrl('commons/1/1f/Flag_of_Kosovo.svg'),
  'YEM': createUrl('commons/8/89/Flag_of_Yemen.svg'),
  'ZAF': createUrl('commons/a/af/Flag_of_South_Africa.svg'),
  'ZMB': createUrl('commons/0/06/Flag_of_Zambia.svg'),
  'ZWE': createUrl('commons/6/6a/Flag_of_Zimbabwe.svg')
};

/***/ }),

/***/ "./node_modules/country-flags-svg/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var countries = __webpack_require__("./node_modules/country-flags-svg/dist/data/countries.js");

var flagUrls = __webpack_require__("./node_modules/country-flags-svg/dist/data/flagUrlByIso3.js");

var _require = __webpack_require__("./node_modules/country-flags-svg/dist/lib/api.js"),
    findFlagUrlByCountryName = _require.findFlagUrlByCountryName,
    findFlagUrlByNationality = _require.findFlagUrlByNationality,
    findFlagUrlByIso2Code = _require.findFlagUrlByIso2Code,
    findFlagUrlByIso3Code = _require.findFlagUrlByIso3Code;

module.exports = {
  countries: countries,
  flagUrls: flagUrls,
  findFlagUrlByCountryName: findFlagUrlByCountryName,
  findFlagUrlByNationality: findFlagUrlByNationality,
  findFlagUrlByIso2Code: findFlagUrlByIso2Code,
  findFlagUrlByIso3Code: findFlagUrlByIso3Code
};

/***/ }),

/***/ "./node_modules/country-flags-svg/dist/lib/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var countries = __webpack_require__("./node_modules/country-flags-svg/dist/data/countries.js");

function isEqual(str1, str2) {
  return str1.toUpperCase() === str2.toUpperCase();
}

function findFlagUrlByPredicate(countries, predicate) {
  var country = countries.find(predicate);
  return country ? country.flag : "";
}

module.exports = {
  findFlagUrlByCountryName: function findFlagUrlByCountryName(countryName) {
    return findFlagUrlByPredicate(countries, function (_ref) {
      var name = _ref.name,
          altSpellings = _ref.altSpellings;
      return isEqual(name, countryName) || altSpellings.some(function (altSpelling) {
        return isEqual(altSpelling, countryName);
      });
    });
  },
  findFlagUrlByNationality: function findFlagUrlByNationality(nationality) {
    return findFlagUrlByPredicate(countries, function (_ref2) {
      var demonym = _ref2.demonym;
      return isEqual(demonym, nationality);
    });
  },
  findFlagUrlByIso2Code: function findFlagUrlByIso2Code(iso2Code) {
    return findFlagUrlByPredicate(countries, function (_ref3) {
      var iso2 = _ref3.iso2;
      return isEqual(iso2, iso2Code);
    });
  },
  findFlagUrlByIso3Code: function findFlagUrlByIso3Code(iso3Code) {
    return findFlagUrlByPredicate(countries, function (_ref4) {
      var iso3 = _ref4.iso3;
      return isEqual(iso3, iso3Code);
    });
  }
};

/***/ }),

/***/ "./node_modules/css-hot-loader/hotModuleReplacement.js":
/***/ (function(module, exports, __webpack_require__) {

var normalizeUrl = __webpack_require__("./node_modules/normalize-url/index.js");
var srcByModuleId = Object.create(null);
var debounce = __webpack_require__("./node_modules/lodash/debounce.js");

var noDocument = typeof document === 'undefined';
var forEach = Array.prototype.forEach;

var noop = function () {};

var getCurrentScriptUrl = function(moduleId) {
  var src = srcByModuleId[moduleId];

  if (!src) {
    if (document.currentScript) {
      src = document.currentScript.src;
    } else {
      var scripts = document.getElementsByTagName('script');
      var lastScriptTag = scripts[scripts.length - 1];

      if (lastScriptTag) {
        src = lastScriptTag.src;
      }
    }
    srcByModuleId[moduleId] = src;
  }

  return function(fileMap) {
    var splitResult = /([^\\/]+)\.js$/.exec(src);
    var filename = splitResult && splitResult[1];
    if (!filename) {
      return [src.replace('.js', '.css')];
    }
    return fileMap.split(',').map(function(mapRule) {
      var reg = new RegExp(filename + '\\.js$', 'g')
      return normalizeUrl(src.replace(reg, mapRule.replace(/{fileName}/g, filename) + '.css'), { stripWWW: false });
    });
  };
};

function updateCss(el, url) {
  if (!url) {
    url = el.href.split('?')[0];
  }
  if (el.isLoaded === false) {
    // We seem to be about to replace a css link that hasn't loaded yet.
    // We're probably changing the same file more than once.
    return;
  }
  if (!url || !(url.indexOf('.css') > -1)) return;

  el.visited = true;
  var newEl = el.cloneNode();

  newEl.isLoaded = false;
  newEl.addEventListener('load', function () {
    newEl.isLoaded = true;
    newEl.parentNode.removeChild(el);
  });

  newEl.addEventListener('error', function () {
    newEl.isLoaded = true;
    if (newEl.parentNode.contains(el)) {
      newEl.parentNode.removeChild(el);
    }
  });

  newEl.href = url + '?' + Date.now();
  // insert new <link /> right to the old one's position
  el.parentNode.insertBefore(newEl, el.nextSibling);
}

function reloadStyle(src) {
  var elements = document.querySelectorAll('link');
  var loaded = false;

  forEach.call(elements, function(el) {
    if (el.visited === true) return;

    var url = getReloadUrl(el.href, src);
    if (url) {
      updateCss(el, url);
      loaded = true;
    }
  });

  return loaded;
}

function getReloadUrl(href, src) {
  href = normalizeUrl(href, { stripWWW: false });
  var ret;
  src.some(function(url) {
    if (href.indexOf(src) > -1) {
      ret = url;
    }
  });
  return ret;
}

function reloadAll() {
  var elements = document.querySelectorAll('link');
  forEach.call(elements, function(el) {
    if (el.visited === true) return;
    updateCss(el);
  });
}

module.exports = function(moduleId, options) {
  var getScriptSrc;

  if (noDocument) {
    return noop;
  }

  getScriptSrc = getCurrentScriptUrl(moduleId);

  function update() {
    var src = getScriptSrc(options.fileMap);
    var reloaded = reloadStyle(src);
    if (reloaded && !options.reloadAll) {
      console.log('[HMR] css reload %s', src.join(' '));
    } else {
      console.log('[HMR] Reload all css');
      reloadAll();
    }
  }

  return debounce(update, 10);
};


/***/ }),

/***/ "./node_modules/detect-browser/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {function detect() {
  if (typeof navigator !== 'undefined') {
    return parseUserAgent(navigator.userAgent);
  }

  return getNodeVersion();
}

function detectOS(userAgentString) {
  var rules = getOperatingSystemRules();
  var detected = rules.filter(function (os) {
    return os.rule && os.rule.test(userAgentString);
  })[0];

  return detected ? detected.name : null;
}

function getNodeVersion() {
  var isNode = typeof process !== 'undefined' && process.version;
  return isNode && {
    name: 'node',
    version: process.version.slice(1),
    os: process.platform
  };
}

function parseUserAgent(userAgentString) {
  var browsers = getBrowserRules();
  if (!userAgentString) {
    return null;
  }

  var detected = browsers.map(function(browser) {
    var match = browser.rule.exec(userAgentString);
    var version = match && match[1].split(/[._]/).slice(0,3);

    if (version && version.length < 3) {
      version = version.concat(version.length == 1 ? [0, 0] : [0]);
    }

    return match && {
      name: browser.name,
      version: version.join('.')
    };
  }).filter(Boolean)[0] || null;

  if (detected) {
    detected.os = detectOS(userAgentString);
  }

  if (/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/i.test(userAgentString)) {
    detected = detected || {};
    detected.bot = true;
  }

  return detected;
}

function getBrowserRules() {
  return buildRules([
    [ 'aol', /AOLShield\/([0-9\._]+)/ ],
    [ 'edge', /Edge\/([0-9\._]+)/ ],
    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
    [ 'samsung', /SamsungBrowser\/([0-9\.]+)/ ],
    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
    [ 'ie', /MSIE\s(7\.0)/ ],
    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
    [ 'android', /Android\s([0-9\.]+)/ ],
    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
    [ 'safari', /Version\/([0-9\._]+).*Safari/ ],
    [ 'facebook', /FBAV\/([0-9\.]+)/],
    [ 'instagram', /Instagram\s([0-9\.]+)/],
    [ 'ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/]
  ]);
}

function getOperatingSystemRules() {
  return buildRules([
    [ 'iOS', /iP(hone|od|ad)/ ],
    [ 'Android OS', /Android/ ],
    [ 'BlackBerry OS', /BlackBerry|BB10/ ],
    [ 'Windows Mobile', /IEMobile/ ],
    [ 'Amazon OS', /Kindle/ ],
    [ 'Windows 3.11', /Win16/ ],
    [ 'Windows 95', /(Windows 95)|(Win95)|(Windows_95)/ ],
    [ 'Windows 98', /(Windows 98)|(Win98)/ ],
    [ 'Windows 2000', /(Windows NT 5.0)|(Windows 2000)/ ],
    [ 'Windows XP', /(Windows NT 5.1)|(Windows XP)/ ],
    [ 'Windows Server 2003', /(Windows NT 5.2)/ ],
    [ 'Windows Vista', /(Windows NT 6.0)/ ],
    [ 'Windows 7', /(Windows NT 6.1)/ ],
    [ 'Windows 8', /(Windows NT 6.2)/ ],
    [ 'Windows 8.1', /(Windows NT 6.3)/ ],
    [ 'Windows 10', /(Windows NT 10.0)/ ],
    [ 'Windows ME', /Windows ME/ ],
    [ 'Open BSD', /OpenBSD/ ],
    [ 'Sun OS', /SunOS/ ],
    [ 'Linux', /(Linux)|(X11)/ ],
    [ 'Mac OS', /(Mac_PowerPC)|(Macintosh)/ ],
    [ 'QNX', /QNX/ ],
    [ 'BeOS', /BeOS/ ],
    [ 'OS/2', /OS\/2/ ],
    [ 'Search Bot', /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/ ]
  ]);
}

function buildRules(ruleTuples) {
  return ruleTuples.map(function(tuple) {
    return {
      name: tuple[0],
      rule: tuple[1]
    };
  });
}

module.exports = {
  detect: detect,
  detectOS: detectOS,
  getNodeVersion: getNodeVersion,
  parseUserAgent: parseUserAgent
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/class/hasClass.js"));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "./node_modules/dunder-proto/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__("./node_modules/call-bind-apply-helpers/index.js");
var gOPD = __webpack_require__("./node_modules/gopd/index.js");

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ "./node_modules/es-define-property/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ "./node_modules/es-errors/eval.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ "./node_modules/es-errors/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ "./node_modules/es-errors/range.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ "./node_modules/es-errors/ref.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ "./node_modules/es-errors/syntax.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ "./node_modules/es-errors/type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ "./node_modules/es-errors/uri.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ "./node_modules/es-object-atoms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ "./node_modules/fbjs/lib/emptyFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "./node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "./node_modules/flux-standard-action/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashIsplainobject = __webpack_require__("./node_modules/lodash.isplainobject/index.js");

var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);

var validKeys = ['type', 'payload', 'error', 'meta'];

function isValidKey(key) {
  return validKeys.indexOf(key) > -1;
}

function isFSA(action) {
  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

/***/ }),

/***/ "./node_modules/focus-trap-react/dist/focus-trap-react.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");
var createFocusTrap = __webpack_require__("./node_modules/focus-trap/index.js");

var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setNode = function (el) {
      _this.node = el;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

        var returnFocus = returnFocusOnDeactivate || false;
        var config = { returnFocus: returnFocus };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var elementProps = {
        ref: this.setNode
      };

      // This will get id, className, style, etc. -- arbitrary element props
      for (var prop in this.props) {
        if (!this.props.hasOwnProperty(prop)) continue;
        if (checkedProps.indexOf(prop) !== -1) continue;
        elementProps[prop] = this.props[prop];
      }

      return React.createElement(this.props.tag, elementProps, this.props.children);
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  tag: 'div',
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),

/***/ "./node_modules/focus-trap/index.js":
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__("./node_modules/tabbable/index.js");
var xtend = __webpack_require__("./node_modules/xtend/immutable.js");

var listeningFocusTrap = null;

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active || listeningFocusTrap !== trap) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    listeningFocusTrap = null;

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),

/***/ "./node_modules/font-awesome/css/font-awesome.min.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/function-bind/implementation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "./node_modules/function-bind/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("./node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "./node_modules/get-intrinsic/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__("./node_modules/es-object-atoms/index.js");

var $Error = __webpack_require__("./node_modules/es-errors/index.js");
var $EvalError = __webpack_require__("./node_modules/es-errors/eval.js");
var $RangeError = __webpack_require__("./node_modules/es-errors/range.js");
var $ReferenceError = __webpack_require__("./node_modules/es-errors/ref.js");
var $SyntaxError = __webpack_require__("./node_modules/es-errors/syntax.js");
var $TypeError = __webpack_require__("./node_modules/es-errors/type.js");
var $URIError = __webpack_require__("./node_modules/es-errors/uri.js");

var abs = __webpack_require__("./node_modules/math-intrinsics/abs.js");
var floor = __webpack_require__("./node_modules/math-intrinsics/floor.js");
var max = __webpack_require__("./node_modules/math-intrinsics/max.js");
var min = __webpack_require__("./node_modules/math-intrinsics/min.js");
var pow = __webpack_require__("./node_modules/math-intrinsics/pow.js");
var round = __webpack_require__("./node_modules/math-intrinsics/round.js");
var sign = __webpack_require__("./node_modules/math-intrinsics/sign.js");

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__("./node_modules/gopd/index.js");
var $defineProperty = __webpack_require__("./node_modules/es-define-property/index.js");

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__("./node_modules/has-symbols/index.js")();

var getProto = __webpack_require__("./node_modules/get-proto/index.js");
var $ObjectGPO = __webpack_require__("./node_modules/get-proto/Object.getPrototypeOf.js");
var $ReflectGPO = __webpack_require__("./node_modules/get-proto/Reflect.getPrototypeOf.js");

var $apply = __webpack_require__("./node_modules/call-bind-apply-helpers/functionApply.js");
var $call = __webpack_require__("./node_modules/call-bind-apply-helpers/functionCall.js");

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("./node_modules/function-bind/index.js");
var hasOwn = __webpack_require__("./node_modules/hasown/index.js");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "./node_modules/get-proto/Object.getPrototypeOf.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__("./node_modules/es-object-atoms/index.js");

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ "./node_modules/get-proto/Reflect.getPrototypeOf.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ "./node_modules/get-proto/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__("./node_modules/get-proto/Reflect.getPrototypeOf.js");
var originalGetProto = __webpack_require__("./node_modules/get-proto/Object.getPrototypeOf.js");

var getDunderProto = __webpack_require__("./node_modules/dunder-proto/get.js");

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ "./node_modules/global/window.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/gopd/gOPD.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ "./node_modules/gopd/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__("./node_modules/gopd/gOPD.js");

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ "./node_modules/has-symbols/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("./node_modules/has-symbols/shams.js");

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "./node_modules/has-symbols/shams.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "./node_modules/hasown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__("./node_modules/function-bind/index.js");

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ "./node_modules/history/es/DOMUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),

/***/ "./node_modules/history/es/LocationUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__("./node_modules/resolve-pathname/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__("./node_modules/value-equal/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__("./node_modules/history/es/PathUtils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),

/***/ "./node_modules/history/es/PathUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),

/***/ "./node_modules/history/es/createBrowserHistory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__("./node_modules/history/es/LocationUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__("./node_modules/history/es/PathUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__("./node_modules/history/es/createTransitionManager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__("./node_modules/history/es/DOMUtils.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),

/***/ "./node_modules/history/es/createHashHistory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__("./node_modules/history/es/LocationUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__("./node_modules/history/es/PathUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__("./node_modules/history/es/createTransitionManager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__("./node_modules/history/es/DOMUtils.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),

/***/ "./node_modules/history/es/createMemoryHistory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__("./node_modules/history/es/PathUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__("./node_modules/history/es/LocationUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__("./node_modules/history/es/createTransitionManager.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),

/***/ "./node_modules/history/es/createTransitionManager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),

/***/ "./node_modules/history/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__("./node_modules/history/es/createBrowserHistory.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__("./node_modules/history/es/createHashHistory.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__("./node_modules/history/es/createMemoryHistory.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__("./node_modules/history/es/LocationUtils.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__("./node_modules/history/es/PathUtils.js");
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),

/***/ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__("./node_modules/react-is/index.js");

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "./node_modules/intl-format-cache/lib/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat-parser/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__("./node_modules/intl-messageformat-parser/lib/parser.js")['default'];
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-messageformat-parser/lib/parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__("./node_modules/intl-messageformat/lib/main.js")['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(2);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-messageformat/lib/compiler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/core.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__("./node_modules/intl-messageformat/lib/utils.js"), src$es5$$ = __webpack_require__("./node_modules/intl-messageformat/lib/es5.js"), src$compiler$$ = __webpack_require__("./node_modules/intl-messageformat/lib/compiler.js"), intl$messageformat$parser$$ = __webpack_require__("./node_modules/intl-messageformat-parser/index.js");
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/en.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__("./node_modules/intl-messageformat/lib/utils.js");

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__("./node_modules/intl-messageformat/lib/core.js"), src$en$$ = __webpack_require__("./node_modules/intl-messageformat/lib/en.js");

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__("./node_modules/intl-relativeformat/lib/main.js")['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(3);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/core.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__("./node_modules/intl-messageformat/index.js");
var diff_1 = __webpack_require__("./node_modules/intl-relativeformat/lib/diff.js");
var es5_1 = __webpack_require__("./node_modules/intl-relativeformat/lib/es5.js");
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/diff.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/en.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/intl-relativeformat/lib/core.js");
var en_1 = __webpack_require__("./node_modules/intl-relativeformat/lib/en.js");
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "./node_modules/invariant/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "./node_modules/is-ios/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var navigator = __webpack_require__("./node_modules/global/window.js").navigator

module.exports = typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) // iPad iOS 13


/***/ }),

/***/ "./node_modules/is-plain-obj/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = Object.prototype.toString;

module.exports = function (x) {
	var prototype;
	return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};


/***/ }),

/***/ "./node_modules/libphonenumber-js/core/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es6_PhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__es6_PhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_ParseError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/ParseError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__es6_ParseError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberWithError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberWithError_js__["a"]; });
/* unused harmony reexport parsePhoneNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es6_parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__es6_parsePhoneNumber_js__["a"]; });
/* unused harmony reexport parsePhoneNumberFromString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es6_isValidPhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isValidPhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_4__es6_isValidPhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es6_isPossiblePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isPossiblePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__es6_isPossiblePhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es6_validatePhoneNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/validatePhoneNumberLength.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__es6_validatePhoneNumberLength_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__es6_legacy_findNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/findNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__es6_legacy_findNumbers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__es6_legacy_searchNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/searchNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__es6_legacy_searchNumbers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbersInText_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findPhoneNumbersInText.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbersInText_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__es6_searchPhoneNumbersInText_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/searchPhoneNumbersInText.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__es6_searchPhoneNumbersInText_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__es6_PhoneNumberMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumberMatcher.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_PhoneNumberMatcher_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__es6_AsYouType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouType.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__es6_AsYouType_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__es6_AsYouTypeFormatter_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.js");
/* unused harmony reexport DIGIT_PLACEHOLDER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__es6_getCountries_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/getCountries.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__es6_getCountries_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__es6_metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__es6_metadata_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__es6_metadata_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_15__es6_metadata_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_15__es6_metadata_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__es6_getExampleNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/getExampleNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__es6_getExampleNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__es6_formatIncompletePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/formatIncompletePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_17__es6_formatIncompletePhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__es6_parseIncompletePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__es6_parseIncompletePhoneNumber_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_18__es6_parseIncompletePhoneNumber_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__es6_helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_19__es6_helpers_parseDigits_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__es6_helpers_RFC3966_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/RFC3966.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_20__es6_helpers_RFC3966_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_20__es6_helpers_RFC3966_js__["a"]; });


// `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`.


// `parsePhoneNumberFromString()` named export is now considered legacy:
// it has been promoted to a default export due to being too verbose.






// Deprecated.









// Deprecated:
// `DIGIT_PLACEHOLDER` is the character that `AsYouType` formatter uses in a phone number template.
// It's basically an "x" character. I guess, there's no point in exporting it as a constant
// because the established convention is that it's an "x" character so everyone just assumes "x".














/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouType.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_checkNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AsYouTypeState_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeState.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AsYouTypeFormatter_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AsYouTypeParser_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeParser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_getCountryByCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getCountryByNationalNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_isObject_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isObject.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var AsYouType = /*#__PURE__*/function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck(this, AsYouType);
    // Metadata instance is created once and stays constant.
    // This is required because other utility classes such as `AsYouTypeFormatter`
    // will use this metadata instance "reference" and will assume that it stays constant.
    this.metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadata);
    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
      _this$getCountryAndCa2 = _slicedToArray(_this$getCountryAndCa, 2),
      defaultCountry = _this$getCountryAndCa2[0],
      defaultCallingCode = _this$getCountryAndCa2[1];
    // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
    // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
    // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.
    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }
  return _createClass(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode;
      // Turns out `null` also has type "object". Weird.
      if (optionsOrDefaultCountry) {
        if (Object(__WEBPACK_IMPORTED_MODULE_8__helpers_isObject_js__["a" /* default */])(optionsOrDefaultCountry)) {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }
      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }
      if (defaultCallingCode) {
        /* istanbul ignore if */
        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            defaultCountry = '001';
          }
        }
      }
      return [defaultCountry, defaultCallingCode];
    }

    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
        digits = _this$parser$input.digits,
        justLeadingPlus = _this$parser$input.justLeadingPlus;
      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded();
        // Match the available formats by the currently available leading digits.
        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }
        var formattedNationalNumber;
        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }
        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded();
            // If it could, then re-try formatting the new national (significant) number.
            var nationalDigits = this.state.getNationalDigits();
            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }
        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;
      this.state = new __WEBPACK_IMPORTED_MODULE_3__AsYouTypeState_js__["a" /* default */]({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included a `.country` property on an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
          _this.metadata.selectNumberingPlan(country || callingCode);
          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new __WEBPACK_IMPORTED_MODULE_4__AsYouTypeFormatter_js__["b" /* default */]({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new __WEBPACK_IMPORTED_MODULE_5__AsYouTypeParser_js__["a" /* default */]({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();
          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      });
      this.formattedOutput = '';
      return this;
    }

    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }

    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      // If the number is being input in national format and some "default calling code"
      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
      // is equal to that "default calling code".
      //
      // If the number is being input in national format and no "default calling code"
      // has been passed to `AsYouType` constructor, then returns `undefined`,
      // even if a "default country" has been passed to `AsYouType` constructor.
      //
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    }

    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }

    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits;
      // Return `undefined` if no digits have been input yet.
      if (digits) {
        return this._getCountry();
      }
    }

    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        // `AsYouType.getCountry()` returns `undefined`
        // for "non-geographic" phone numbering plans.
        if (country === '001') {
          return;
        }
      }
      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    }

    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;
      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };
        var callingCode = this.state.callingCode;
        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }
        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }
        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }
      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state,
        nationalSignificantNumber = _this$state.nationalSignificantNumber,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = _this$state.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix,
        nationalPrefix = _this$state.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix || nationalPrefix;
      if (prefix) {
        number = prefix + number;
      }
      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberIsModified = this.state.nationalSignificantNumberIsModified;
      return this.getFullNumber(nationalSignificantNumberIsModified ? this.state.getNationalDigits() : this.getNonFormattedNationalNumberWithPrefix());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();
      if (number) {
        return number.replace(/[\+\d]/g, __WEBPACK_IMPORTED_MODULE_4__AsYouTypeFormatter_js__["a" /* DIGIT_PLACEHOLDER */]);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    }

    // Determines the exact country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      // Get a more precise country code for this national number.
      // It is possible that the precise country couldn't be determined
      // in cases when there're multiple countries sharing the same calling code.
      // In that case, `country` will be `undefined`.
      var country = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_getCountryByCallingCode_js__["a" /* default */])(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        metadata: this.metadata
      });
      // If the derived country is indeed more precise,
      // or if no country could be derived for the updated phone number.
      if (country !== this.state.country) {
        // Set (or reset) the more precise country.
        this.state.setCountry(country);
        // If a more precise country could be derived.
        if (country) {
          // Select a more precise telephone numbering plan.
          // For example, consider that `AsYouType` instance was created with `defaultCountry: "US"` argument.
          // In that case, the metadata instance will be using "US" metadata.
          // But then the user could input a Canadian phone number, in which case
          // the metadata instance should be switched to Canadian telephone numbering plan.
          // It is required to do that because later `canFormatCompleteNumber()` function will be called,
          // and that function relies on the precise country being pre-selected in the metadata instance.
          // Or, for example, `checkNumberLength()` function also relies on same thing.
          this.metadata.selectNumberingPlan(country);
        }
      }
    }

    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state,
        digits = _this$state2.digits,
        callingCode = _this$state2.callingCode,
        country = _this$state2.country,
        nationalSignificantNumber = _this$state2.nationalSignificantNumber;

      // Will return `undefined` if no digits have been input.
      if (!digits) {
        return;
      }
      if (this.isInternational()) {
        if (callingCode) {
          return '+' + callingCode + nationalSignificantNumber;
        } else {
          return '+' + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return '+' + callingCode_ + nationalSignificantNumber;
        }
      }
    }

    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
        nationalSignificantNumber = _this$state3.nationalSignificantNumber,
        carrierCode = _this$state3.carrierCode,
        callingCode = _this$state3.callingCode;
      if (!nationalSignificantNumber) {
        return;
      }

      // `this._getCountry()` is basically same as `this.state.country`
      // with the only change that it returns `undefined` in case of a
      // "non-geographic" numbering plan instead of `"001"` "internal use" value.
      var country = this._getCountry();

      // Sidenote:
      // `state.callingCode` and `state.country` are somewhat independent from one another
      // and there could be situations when one is defined but the other is not.
      // See the comment in `AsYouTypeState.js` for more info on when that is possible.

      if (!country && !callingCode) {
        return;
      }

      // By default, if `defaultCountry` parameter was passed when
      // creating `AsYouType` instance, `state.country` is gonna be
      // that `defaultCountry`, which doesn't entirely conform with
      // `parsePhoneNumber()`'s behavior where it attempts to determine
      // the country more precisely in cases when multiple countries
      // could correspond to the same `countryCallingCode`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
      //
      // Because `AsYouType.getNumber()` method is supposed to be a 1:1
      // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
      // it means that it should also behave accordingly in such cases of `country` ambiguity.
      // That's how users of this library would expect it to behave anyway.
      //
      // So here it checks if `state.country` is same as the `defaultCountry`,
      // and if it is, it attempts to get rid of any potential ambiguity.
      //
      if (country) {
        if (country === this.defaultCountry) {
          // // Create a `Metadata` instance just to get the calling code of the `country`.
          // const metadata = new Metadata(this.metadata.metadata)
          // // `state.callingCode` and `state.country` are somewhat independent from one another
          // // and there could be situations when one is defined but the other is not.
          // // See the comment in `AsYouTypeState.js` for more info on when that is possible.
          // // Here, it only passes `state.country` because there's no need to pass `state.callingCode`
          // // because `state.country` is known to be defined.
          // metadata.selectNumberingPlan(country)
          // const countryCallingCode = metadata.numberingPlan.callingCode()

          // Instead of getting `countryCallingCode` value above,
          // it could simply read it from the existing metadata instance.
          var countryCallingCode = this.metadata.numberingPlan.callingCode();

          // Attempt to rule out any potential country code ambiguity, if present.
          var exactCountry = getExactCountryForMultiCountryCallingCode(countryCallingCode, nationalSignificantNumber, this.metadata);
          if (exactCountry) {
            country = exactCountry;
          }
        }
      }
      var phoneNumber = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumber_js__["a" /* default */](country || callingCode, nationalSignificantNumber, this.metadata.metadata);
      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      }
      // Phone number extensions are not supported by "As You Type" formatter.
      return phoneNumber;
    }

    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();
      if (!phoneNumber) {
        return false;
      }
      return phoneNumber.isPossible();
    }

    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();
      if (!phoneNumber) {
        return false;
      }
      return phoneNumber.isValid();
    }

    /**
     * Checks if the phone number length is valid.
     * If it is, nothing is returned.
     * Otherwise, a rejection reason is returned.
     * @return {string?}
     */
  }, {
    key: "validateLength",
    value: function validateLength() {
      var _this$state4 = this.state,
        digits = _this$state4.digits,
        nationalSignificantNumber = _this$state4.nationalSignificantNumber;
      if (!digits) {
        return 'NOT_A_NUMBER';
      }
      if (!this.metadata.numberingPlan) {
        return 'INVALID_COUNTRY';
      }
      if (!nationalSignificantNumber) {
        return 'TOO_SHORT';
      }

      // `state.callingCode` and `state.country` are somewhat independent from one another
      // and there could be situations when one is defined but the other is not.
      // See the comment in `AsYouTypeState.js` for more info on when that is possible.
      // Here, it uses both: if `country` is defined then it will use that,
      // otherwise it will use `callingCode`.
      var result = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_checkNumberLength_js__["a" /* default */])(nationalSignificantNumber, undefined, this.metadata);
      if (result !== 'IS_POSSIBLE') {
        return result;
      }
    }

    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }

    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }

    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);
}(); // In situations when multiple countries use the same calling code,
// this function tells what exact country does a given national (significant) number belong to.

function getExactCountryForMultiCountryCallingCode(callingCode, nationalSignificantNumber, metadata) {
  var ambiguousCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (ambiguousCountries.length > 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_getCountryByNationalNumber_js__["a" /* default */])(nationalSignificantNumber, ambiguousCountries, metadata.metadata);
  }
}
//# sourceMappingURL=AsYouType.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternMatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PatternMatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_PatternParser_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternParser.js");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PatternMatcher = /*#__PURE__*/function () {
  function PatternMatcher(pattern) {
    _classCallCheck(this, PatternMatcher);
    this.matchTree = new __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_PatternParser_js__["a" /* default */]().parse(pattern);
  }
  return _createClass(PatternMatcher, [{
    key: "match",
    value: function match(string) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        allowOverflow = _ref.allowOverflow;
      if (!string) {
        throw new Error('String is required');
      }
      var result = _match(string.split(''), this.matchTree, true);
      if (result && result.match) {
        delete result.matchedChars;
      }
      if (result && result.overflow) {
        if (!allowOverflow) {
          return;
        }
      }
      return result;
    }
  }]);
}();
/**
 * Matches `characters` against a pattern compiled into a `tree`.
 * @param  {string[]} characters
 * @param  {Tree} tree — A pattern compiled into a `tree`. See the `*.d.ts` file for the description of the `tree` structure.
 * @param  {boolean} last — Whether it's the last (rightmost) subtree on its level of the match tree.
 * @return {object} See the `*.d.ts` file for the description of the result object.
 */

function _match(characters, tree, last) {
  // If `tree` is a string, then `tree` is a single character.
  // That's because when a pattern is parsed, multi-character-string parts
  // of a pattern are compiled into arrays of single characters.
  // I still wrote this piece of code for a "general" hypothetical case
  // when `tree` could be a string of several characters, even though
  // such case is not possible with the current implementation.
  if (typeof tree === 'string') {
    var characterString = characters.join('');
    if (tree.indexOf(characterString) === 0) {
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.
      /* istanbul ignore else */
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      }
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.
      /* istanbul ignore next */
      return {
        partialMatch: true
        // matchedChars: characters
      };
    }
    if (characterString.indexOf(tree) === 0) {
      if (last) {
        // The `else` path is not possible because `tree` is always a single character.
        // The `else` case for `characters.length > tree.length` would be
        // `characters.length <= tree.length` which means `characters.length <= 1`.
        // `characters` array can't be empty, so that means `characters === [tree]`,
        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
        // that the `if (tree.indexOf(characterString) === 0)` condition before this
        // `if` condition would be entered, and returned from there, not reaching this code.
        /* istanbul ignore else */
        if (characters.length > tree.length) {
          return {
            overflow: true
          };
        }
      }
      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }
    return;
  }
  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i = 0;
    while (i < tree.length) {
      var subtree = tree[i];
      var result = _match(restCharacters, subtree, last && i === tree.length - 1);
      if (!result) {
        return;
      } else if (result.overflow) {
        return result;
      } else if (result.match) {
        // Continue with the next subtree with the rest of the characters.
        restCharacters = restCharacters.slice(result.matchedChars.length);
        if (restCharacters.length === 0) {
          if (i === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true
              // matchedChars: characters
            };
          }
        }
      } else {
        /* istanbul ignore else */
        if (result.partialMatch) {
          return {
            partialMatch: true
            // matchedChars: characters
          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
        }
      }
      i++;
    }
    // If `last` then overflow has already been checked
    // by the last element of the `tree` array.
    /* istanbul ignore if */
    if (last) {
      return {
        overflow: true
      };
    }
    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }
  switch (tree.op) {
    case '|':
      var partialMatch;
      for (var _iterator = _createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;) {
        var branch = _step.value;
        var _result = _match(characters, branch, last);
        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            /* istanbul ignore else */
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }
      if (partialMatch) {
        return {
          partialMatch: true
          // matchedChars: ...
        };
      }
      // Not even a partial match.
      return;
    case '[]':
      for (var _iterator2 = _createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;) {
        var _char = _step2.value;
        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }
          if (last) {
            return {
              overflow: true
            };
          }
          return {
            match: true,
            matchedChars: [_char]
          };
        }
      }
      // No character matches.
      return;

    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}
//# sourceMappingURL=AsYouTypeFormatter.PatternMatcher.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternParser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PatternParser; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PatternParser = /*#__PURE__*/function () {
  function PatternParser() {
    _classCallCheck(this, PatternParser);
  }
  return _createClass(PatternParser, [{
    key: "parse",
    value: function parse(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);
      if (this.context.length !== 1) {
        throw new Error('Non-finalized contexts left when pattern parse ended');
      }
      var _this$context$ = this.context[0],
        branches = _this$context$.branches,
        instructions = _this$context$.instructions;
      if (branches) {
        return {
          op: '|',
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      }

      /* istanbul ignore if */
      if (instructions.length === 0) {
        throw new Error('Pattern is required');
      }
      if (instructions.length === 1) {
        return instructions[0];
      }
      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error('Pattern is required');
      }
      var match = pattern.match(OPERATOR);
      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }
        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
        return;
      }
      var operator = match[1];
      var before = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);
      switch (operator) {
        case '(?:':
          if (before) {
            this.parsePattern(before);
          }
          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;
        case ')':
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }
          if (before) {
            this.parsePattern(before);
          }
          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }
          var _this$getContext = this.getContext(),
            branches = _this$getContext.branches;
          branches.push(expandSingleElementArray(this.getContext().instructions));
          this.endContext();
          this.getContext().instructions.push({
            op: '|',
            args: branches
          });
          break;
        case '|':
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }
          if (before) {
            this.parsePattern(before);
          }
          // The top-level is an implicit "or" group, if required.
          if (!this.getContext().branches) {
            // `branches` are not defined only for the root implicit "or" operator.
            /* istanbul ignore else */
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }
          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
          this.getContext().instructions = [];
          break;
        case '[':
          if (before) {
            this.parsePattern(before);
          }
          this.startContext({
            oneOfSet: true
          });
          break;
        case ']':
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }
          this.endContext();
          this.getContext().instructions.push({
            op: '[]',
            args: parseOneOfSet(before)
          });
          break;

        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(operator));
      }
      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);
}();

function parseOneOfSet(pattern) {
  var values = [];
  var i = 0;
  while (i < pattern.length) {
    if (pattern[i] === '-') {
      if (i === 0 || i === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }
      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
      var value = prevValue;
      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i]);
    }
    i++;
  }
  return values;
}
var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var OPERATOR = new RegExp(
// any of:
'(' +
// or operator
'\\|' +
// or
'|' +
// or group start
'\\(\\?\\:' +
// or
'|' +
// or group end
'\\)' +
// or
'|' +
// one-of set start
'\\[' +
// or
'|' +
// one-of set end
'\\]' + ')');
function expandSingleElementArray(array) {
  if (array.length === 1) {
    return array[0];
  }
  return array;
}
//# sourceMappingURL=AsYouTypeFormatter.PatternParser.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.complete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatCompleteNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = canFormatCompleteNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_checkNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_formatNationalNumberUsingFormat_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js");



function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
    shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
    getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_checkNumberLength_js__["a" /* default */])(nationalSignificantNumber, undefined, metadata) === 'IS_POSSIBLE';
}
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
    shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
    getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.

  var nationalSignificantNumber = state.nationalSignificantNumber,
    international = state.international,
    nationalPrefix = state.nationalPrefix,
    carrierCode = state.carrierCode;

  // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //
  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });
    if (formattedNumber) {
      return formattedNumber;
    }
  }

  // Format the number without using `national_prefix_formatting_rule`.
  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}
function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
    useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
    getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_formatNationalNumberUsingFormat_js__["b" /* default */])(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });
  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix) {
      formattedNationalNumber = state.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix + ' ' + formattedNationalNumber;
    }
  }
  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
}

// Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_parseDigits_js__["b" /* default */])(formattedNationalNumber) === state.getNationalDigits();
}
//# sourceMappingURL=AsYouTypeFormatter.complete.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AsYouTypeFormatter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsYouTypeFormatter_complete_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.complete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsYouTypeFormatter_PatternMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.PatternMatcher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_formatNationalNumberUsingFormat_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_applyInternationalSeparatorStyle_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









// Used in phone number format template creation.
// Could be any digit, I guess.
var DUMMY_DIGIT = '9';
// I don't know why is it exactly `15`
var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
// Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var LONGEST_DUMMY_PHONE_NUMBER = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["d" /* repeat */])(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);

// A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/;

// Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var SUPPORT_LEGACY_FORMATTING_PATTERNS = true;

// A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\[([^\[\]])*\]/g;
};

// Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\d(?=[^,}][^,}])/g;
};

// A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + ']*' +
// Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + ']*' + '(\\$\\d[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + ']*)*' + '$');

// This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var MIN_LEADING_DIGITS_LENGTH = 3;
var AsYouTypeFormatter = /*#__PURE__*/function () {
  function AsYouTypeFormatter(_ref) {
    var state = _ref.state,
      metadata = _ref.metadata;
    _classCallCheck(this, AsYouTypeFormatter);
    this.metadata = metadata;
    this.resetFormat();
  }
  return _createClass(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();
      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();
        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }

    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this = this;
      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (Object(__WEBPACK_IMPORTED_MODULE_1__AsYouTypeFormatter_complete_js__["a" /* canFormatCompleteNumber */])(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = _createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;) {
          var _format = _step.value;
          var formattedCompleteNumber = Object(__WEBPACK_IMPORTED_MODULE_1__AsYouTypeFormatter_complete_js__["b" /* default */])(state, _format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
              return _this.getSeparatorAfterNationalPrefix(format);
            }
          });
          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = _format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */]), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber;
            // With a new formatting template, the matched position
            // using the old template needs to be reset.
            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */]);
            return formattedCompleteNumber;
          }
        }
      }
      // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).
      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    }

    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat;

      // Choose a format from the list of matching ones.
      var newlyChosenFormat = this.chooseFormat(state);
      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref2) {
      var _this2 = this;
      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
        nationalPrefix = _ref2.nationalPrefix,
        international = _ref2.international;
      var leadingDigits = nationalSignificantNumber;

      // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.

      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.
      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;
      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }
      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      });

      // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() &&
      // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      }
      // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }
      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length;

      // If this format is not restricted to a certain
      // leading digits pattern then it fits.
      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
      if (leadingDigitsPatternsCount === 0) {
        return true;
      }

      // Start narrowing down the list of possible formats based on the leading digits.
      // (only previously matched formats take part in the narrowing down process)

      // `leading_digits_patterns` start with 3 digits min
      // and then go up from there one digit at a time.
      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex];

      // Google imposes a requirement on the leading digits
      // to be minimum 3 digits long in order to be eligible
      // for checking those with a leading digits pattern.
      //
      // Since `leading_digits_patterns` start with 3 digits min,
      // Google's original `libphonenumber` library only starts
      // excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      //
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.
      //
      // Also, `leading_digits_patterns` doesn't always correspond to a single
      // digits count. For example, `60|8` pattern would already match `8`
      // but the `60` part would require having at least two leading digits,
      // so the whole pattern would require inputting two digits first in order to
      // decide on whether it matches the input, even when the input is "80".
      //
      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
      // even when there's only 1 or 2 digits of the national (significant) number.
      // To do that, it uses a non-strict pattern matcher written specifically for that.
      //
      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        // Before leading digits < 3 matching was implemented:
        // return true
        //
        // After leading digits < 3 matching was implemented:
        try {
          return new __WEBPACK_IMPORTED_MODULE_2__AsYouTypeFormatter_PatternMatcher_js__["a" /* default */](leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== undefined;
        } catch (error) /* istanbul ignore next */{
          // There's a slight possibility that there could be some undiscovered bug
          // in the pattern matcher code. Since the "leading digits < 3 matching"
          // feature is not "essential" for operation, it can fall back to the old way
          // in case of any issues rather than halting the application's execution.
          console.error(error);
          return true;
        }
      }

      // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
      // available then use the usual regular expression matching.
      //
      // The whole pattern is wrapped in round brackets (`()`) because
      // the pattern can use "or" operator (`|`) at the top level of the pattern.
      //
      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this3 = this;
      var _loop = function _loop() {
          var format = _step2.value;
          // If this format is currently being used
          // and is still suitable, then stick to it.
          if (_this3.chosenFormat === format) {
            return 0; // break
          }
          // Sometimes, a formatting rule inserts additional digits in a phone number,
          // and "as you type" formatter can't do that: it should only use the digits
          // that the user has input.
          //
          // For example, in Argentina, there's a format for mobile phone numbers:
          //
          // {
          //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
          //    "leading_digits_patterns": ["91"],
          //    "national_prefix_formatting_rule": "0$1",
          //    "format": "$2 15-$3-$4",
          //    "international_format": "$1 $2 $3-$4"
          // }
          //
          // In that format, `international_format` is used instead of `format`
          // because `format` inserts `15` in the formatted number,
          // and `AsYouType` formatter should only use the digits
          // the user has actually input, without adding any extra digits.
          // In this case, it wouldn't make a difference, because the `15`
          // is first stripped when applying `national_prefix_for_parsing`
          // and then re-added when using `format`, so in reality it doesn't
          // add any new digits to the number, but to detect that, the code
          // would have to be more complex: it would have to try formatting
          // the digits using the format and then see if any digits have
          // actually been added or removed, and then, every time a new digit
          // is input, it should re-check whether the chosen format doesn't
          // alter the digits.
          //
          // Google's code doesn't go that far, and so does this library:
          // it simply requires that a `format` doesn't add any additonal
          // digits to user's input.
          //
          // Also, people in general should move from inputting phone numbers
          // in national format (possibly with national prefixes)
          // and use international phone number format instead:
          // it's a logical thing in the modern age of mobile phones,
          // globalization and the internet.
          //
          /* istanbul ignore if */
          if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
            return 1; // continue
          }
          if (!_this3.createTemplateForFormat(format, state)) {
            // Remove the format if it can't generate a template.
            _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
              return _ !== format;
            });
            return 1; // continue
          }
          _this3.chosenFormat = format;
          return 0; // break
        },
        _ret;
      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      //
      // For some weird reason, `istanbul` says "else path not taken"
      // for the `for of` line below. Supposedly that means that
      // the loop doesn't ever go over the last element in the list.
      // That's true because there always is `this.chosenFormat`
      // when `this.matchingFormats` is non-empty.
      // And, for some weird reason, it doesn't think that the case
      // with empty `this.matchingFormats` qualifies for a valid "else" path.
      // So simply muting this `istanbul` warning.
      // It doesn't skip the contents of the `for of` loop,
      // it just skips the `for of` line.
      //
      /* istanbul ignore next */
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
        _ret = _loop();
        if (_ret === 0) break;
        if (_ret === 1) continue;
      }
      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }
      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)
      /* istanbul ignore if */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
        return;
      }
      // Get formatting template for this phone number format
      var template = this.getTemplateForFormat(format, state);
      // If the national number entered is too long
      // for any phone number format, then abort.
      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (this.isNANP) {
        return ' ';
      }
      // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.
      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      }
      // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.
      return '';
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix,
        missingPlus = _ref3.missingPlus;
      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }
      if (missingPlus) {
        return '';
      }
      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      }
      // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.
      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';
      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */], index + 1);
        i++;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["b" /* cutAndStripNonPairedParens */])(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template;
      // With a new formatting template, the matched position
      // using the old template needs to be reset.
      this.populatedNationalNumberTemplatePosition = -1;
      // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.
      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */]) + Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["d" /* repeat */])(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */], state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }

    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
        international = _ref4.international,
        nationalPrefix = _ref4.nationalPrefix,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = _ref4.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix;
      var pattern = format.pattern();

      /* istanbul ignore else */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
        pattern = pattern
        // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d')
        // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      }

      // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //
      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0];

      // If the national number entered is too long
      // for any phone number format, then abort.
      if (nationalSignificantNumber.length > digits.length) {
        return;
      }

      // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.

      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.

      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT);

      // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.
      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }
      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate;

      // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.
      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(__WEBPACK_IMPORTED_MODULE_4__helpers_formatNationalNumberUsingFormat_js__["a" /* FIRST_GROUP_PATTERN */], format.nationalPrefixFormattingRule());
        // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.
        /* istanbul ignore else */
        if (Object(__WEBPACK_IMPORTED_MODULE_3__helpers_parseDigits_js__["b" /* default */])(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + Object(__WEBPACK_IMPORTED_MODULE_3__helpers_parseDigits_js__["b" /* default */])('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true;
          // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.
          if (nationalPrefix) {
            var i = nationalPrefix.length;
            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */]);
              i--;
            }
          }
        }
      }

      // Generate formatting template for this phone number format.
      var template = digits
      // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat)
      // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */]);

      // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.
      if (!nationalPrefixIncludedInTemplate) {
        if (prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix) {
          // Prepend the prefix to the template manually.
          template = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["d" /* repeat */])(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */], prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["d" /* repeat */])(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["a" /* DIGIT_PLACEHOLDER */], nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }
      if (international) {
        template = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_applyInternationalSeparatorStyle_js__["a" /* default */])(template);
      }
      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["c" /* populateTemplateWithDigits */])(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }
      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1];

      // Return the formatted phone number so far.
      return Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util_js__["b" /* cutAndStripNonPairedParens */])(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);

      // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
      var international = _ref5.international,
        nationalPrefix = _ref5.nationalPrefix;
      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();
        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    }
  }]);
}();

//# sourceMappingURL=AsYouTypeFormatter.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIGIT_PLACEHOLDER; });
/* unused harmony export countOccurences */
/* harmony export (immutable) */ __webpack_exports__["d"] = repeat;
/* harmony export (immutable) */ __webpack_exports__["b"] = cutAndStripNonPairedParens;
/* unused harmony export closeNonPairedParens */
/* unused harmony export stripNonPairedParens */
/* harmony export (immutable) */ __webpack_exports__["c"] = populateTemplateWithDigits;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);

// Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).
function countOccurences(symbol, string) {
  var count = 0;
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for counting brackets it is safe.
  // for (const character of string)
  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    if (character === symbol) {
      count++;
    }
  }
  return count;
}

// Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript
function repeat(string, times) {
  if (times < 1) {
    return '';
  }
  var result = '';
  while (times > 1) {
    if (times & 1) {
      result += string;
    }
    times >>= 1;
    string += string;
  }
  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }
  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function closeNonPairedParens(template, cut_before) {
  var retained_template = template.slice(0, cut_before);
  var opening_braces = countOccurences('(', retained_template);
  var closing_braces = countOccurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;
  while (dangling_braces > 0 && cut_before < template.length) {
    if (template[cut_before] === ')') {
      dangling_braces--;
    }
    cut_before++;
  }
  return template.slice(0, cut_before);
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;
  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }
    i++;
  }
  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);
  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }
  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = _createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
    var digit = _step2.value;
    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }
    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }
  return [template, position];
}
//# sourceMappingURL=AsYouTypeFormatter.util.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeParser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouTypeParser; });
/* unused harmony export extractFormattedDigitsAndPlus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_extractCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_extractCountryCallingCodeFromInternationalNumberWithoutPlusSign_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_extractNationalNumberFromPossiblyIncompleteNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stripIddPrefix_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants_js__["e" /* VALID_DIGITS */] + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["d" /* PLUS_CHARS */] + ']' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants_js__["e" /* VALID_DIGITS */] + ']*' + '|' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants_js__["e" /* VALID_DIGITS */] + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants_js__["e" /* VALID_DIGITS */] + ']+' + '.*' + '$');

// Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var AsYouTypeParser = /*#__PURE__*/function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
      defaultCallingCode = _ref.defaultCallingCode,
      metadata = _ref.metadata,
      onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
    _classCallCheck(this, AsYouTypeParser);
    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }
  return _createClass(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
        _extractFormattedDigi2 = _slicedToArray(_extractFormattedDigi, 2),
        formattedDigits = _extractFormattedDigi2[0],
        hasPlus = _extractFormattedDigi2[1];
      var digits = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_parseDigits_js__["b" /* default */])(formattedDigits);
      // Checks for a special case: just a leading `+` has been entered.
      var justLeadingPlus;
      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber(undefined, undefined);
          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }
      if (digits) {
        this.inputDigits(digits, state);
      }
      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }

    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3;

      // Append phone number digits.
      state.appendDigits(nextDigits);

      // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.
      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }
      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      }

      // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)
      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
            return state.update(stateUpdate);
          });
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
        callingCode = _ref2.callingCode;
      return international && !callingCode;
    }

    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode(state) {
      var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_0__helpers_extractCountryCallingCode_js__["a" /* default */])('+' + state.getDigitsWithoutInternationalPrefix(), state.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
        countryCallingCode = _extractCountryCallin.countryCallingCode,
        number = _extractCountryCallin.number;
      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;
        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }

    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }
      var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_extractNationalNumberFromPossiblyIncompleteNumber_js__["a" /* default */])(nationalDigits, this.metadata),
        nationalPrefix = _extractNationalNumbe.nationalPrefix,
        nationalNumber = _extractNationalNumbe.nationalNumber,
        carrierCode = _extractNationalNumbe.carrierCode;
      if (nationalNumber === nationalDigits) {
        return;
      }
      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }

    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }
      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }
      var _extractNationalNumbe2 = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_extractNationalNumberFromPossiblyIncompleteNumber_js__["a" /* default */])(nationalDigits, this.metadata),
        nationalPrefix = _extractNationalNumbe2.nationalPrefix,
        nationalNumber = _extractNationalNumbe2.nationalNumber,
        carrierCode = _extractNationalNumbe2.carrierCode;
      // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.
      /* istanbul ignore if */
      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }
      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      // Tells if the parsed national (significant) number is present as-is in the input string.
      // For example, when inputting "0343515551212999" Argentinian mobile number,
      // the parsed national (significant) number is "93435551212999".
      // There, one can see how it stripped "0" national prefix and prepended a "9",
      // because that's how it is instructed to do in Argentina's metadata.
      // So in the described example, the parsed national (significant) number is not present
      // as-is in the input string. Instead, it's "modified" in the input string.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      var nationalSignificantNumberIsModified = false;

      // In some countries, a phone number could have a prefix that is not a "national prefix"
      // but rather some other type of "utility" prefix.
      // For example, when calling within Australia, one could prepend `1831` prefix to hide
      // caller's phone number.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      var prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix;

      // `nationalSignificantNumber` could be empty. In that case, `.lastIndexOf()` still works correctly.
      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber);

      // If the parsed national (significant) number is the last substring of the `nationalDigits`,
      // then it means that it's present as-is in the input string.
      // In any other case, the parsed national (significant) number is "modified" in the input string.
      if (nationalSignificantNumberIndex < 0 || nationalSignificantNumberIndex !== nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberIsModified = true;
      } else {
        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex);
        // When national (significant) number is equal to the `nationalDigits`,
        // this `onExtractedNationalNumber()` function simply doesn't get called.
        // This means that at this point, `prefixBeforeNationalNumber` is always non-empty.
        // Still, added this `if` check just to prevent potential silly bugs.
        // The `!prefixBeforeNationalNumber` case is not really testable
        // so this line is exluded from the code coverage.
        /* istanbul ignore if */
        if (prefixBeforeNationalNumber) {
          if (prefixBeforeNationalNumber !== nationalPrefix) {
            prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = prefixBeforeNationalNumber;
          }
        }
      }
      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberIsModified: nationalSignificantNumberIsModified,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix: prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix
      });
      // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.
      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
        return state.update(stateUpdate);
      })) {
        return true;
      }
      // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //
      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
      // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316
      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
        IDDPrefix = state.IDDPrefix,
        digits = state.digits,
        nationalSignificantNumber = state.nationalSignificantNumber;
      if (international || IDDPrefix) {
        return;
      }
      // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.
      var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_stripIddPrefix_js__["a" /* default */])(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state, {
          country: undefined,
          callingCode: undefined
        });
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_extractCountryCallingCodeFromInternationalNumberWithoutPlusSign_js__["a" /* default */])(state.digits, state.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          newCallingCode = _extractCountryCallin2.countryCallingCode;
        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          });
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state, _ref3) {
      var country = _ref3.country,
        callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode);
      // If a national (significant) number has been extracted before, reset it.
      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
          return state.update(stateUpdate);
        });
      }
    }
  }]);
}();
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (startsAt < 0) {
    return;
  }
  // Trim everything to the left of the phone number.
  text = text.slice(startsAt);
  // Trim the `+`.
  var hasPlus;
  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  }
  // Trim everything to the right of the phone number.
  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, '');
  // Re-add the previously trimmed `+`.
  if (hasPlus) {
    text = '+' + text;
  }
  return text;
}

/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */
function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || '';
  // Trim a `+`.
  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }
  return [extractedNumber];
}

/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */
function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
    _extractFormattedDigi4 = _slicedToArray(_extractFormattedDigi3, 2),
    formattedDigits = _extractFormattedDigi4[0],
    hasPlus = _extractFormattedDigi4[1];
  // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.
  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }
  return [formattedDigits, hasPlus];
}
//# sourceMappingURL=AsYouTypeParser.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/AsYouTypeState.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouTypeState; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// This "state" object simply holds the state of the "AsYouType" parser:
//
// Sidenote:
//   `state.callingCode` and `state.country` are somewhat independent from one another
//   and there could be situations when one is defined but the other is not.
//   * Situations when `state.country` would be defined but `state.callingCode` would be `undefined`:
// 		 * When `defaultCountry` is specified and inputting a phone number not in "international" format.
//     * When `defaultCountry` is specified and inputting a phone number in "international" format,
//       but before the `+` character has been input.
//   * Situations when `state.country` would be `undefined` but `state.callingCode` would be defined:
//     * When `defaultCountry` is not specified and inputting a phone number in "international" format,
//       and the "calling code" part is already complete, but multiple countries share this "calling code"
//       and there's not enough national (significant) number digits yet to determine the exact country.
//   * In any other sigutations, `state.country` and `state.callingCode` are either both defined or both `undefined`.
//     * When they're both defined, `state.callingCode` always corresponds to `state.country`.
//       So both are always consistent in this case.
//
// * `country?: string` — The exact country of the phone number, if it could be determined.
//                        When inputting a phone number in "international" format, it will derive the `country` from "country calling code" and the phone number digits.
//                        When inputting a phone number in "national" format, it will derive the `country` from `defaultCountry` that was specified when creating the `AsYouType` formatter.
//                        Sidenote: If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` flag was `true`, then for "non-geographic phone numbers" `state.country` would've been "001".
// * `callingCode?: string` — "Country calling code" that has been extracted from the input phone number.
//                        When inputting a phone number in "international" format, it will extract the "country calling code" from the digits that follow the "+" character.
//                        When inputting a phone number in "national" format, `callingCode` will be `undefined`.
// * `digits: string` — Phone number digits that have been input so far, including the "+" character, if present. In case of inputting non-arabic digits, those will be converted to arabic ones.
// * `international: boolean` — Whether the phone number is being input in "international" format, i.e. with a "+" character.
// * `missingPlus: boolean` — Whether it's a phone number in "international" format that is missing the leading "+" character for some reason — apparently, Google thinks that it's a common mistake when inputting a phone number.
// * `IDDPrefix?: string` — An "IDD prefix", when the phone number is being input in an "out-of-country dialing" format. https://wikitravel.org/en/International_dialling_prefix
// * `carrierCode?: string` — A "carrier code", if the phone number contains it. Normally, those can only be present in Colombia or Brazil, and only when calling from mobile phones to fixed-line numbers.
// * `nationalPrefix?: string` — "National prefix", if present in the phone number input.
// * `nationalSignificantNumber?: string` — National (significant) number digits that have been input so far.
// * `nationalSignificantNumberIsModified: boolean` — Tells if the parsed national (significant) number is present as-is in the input string. For example, when inputting "0343515551212999" Argentinian mobile number, the parsed national (significant) number is "93435551212999". There, one can see how it stripped "0" national prefix and prepended a "9", because that's how it is instructed to do in Argentina's metadata. So in the described example, the parsed national (significant) number is not present as-is in the input string. Instead, it's "modified" in the input string. https://gitlab.com/caamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
// * `prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix?: string` — In some countries, a phone number could have a prefix that is not a "national prefix" but rather some other type of "utility" prefix.
//                                                                             For example, when calling within Australia, one could prepend `1831` prefix to hide caller's phone number.
//                                                                             https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
//
var AsYouTypeState = /*#__PURE__*/function () {
  function AsYouTypeState(_ref) {
    var onCountryChange = _ref.onCountryChange,
      onCallingCodeChange = _ref.onCallingCodeChange;
    _classCallCheck(this, AsYouTypeState);
    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }
  return _createClass(AsYouTypeState, [{
    key: "reset",
    value: function reset(_ref2) {
      var country = _ref2.country,
        callingCode = _ref2.callingCode;
      this.international = false;
      this.missingPlus = false;
      this.IDDPrefix = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberIsModified = false;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = undefined;
    }
  }, {
    key: "update",
    value: function update(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(country, callingCode) {
      // Prepend the `+` to parsed input.
      this.international = true;
      // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.
      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }

    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }
      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }
      return this.digits;
    }
  }]);
}();

//# sourceMappingURL=AsYouTypeState.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/ParseError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParseError; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  function ParseError(code) {
    var _this;
    _classCallCheck(this, ParseError);
    _this = _callSuper(this, ParseError, [code]);
    // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.
    Object.setPrototypeOf(_this, ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  _inherits(ParseError, _Error);
  return _createClass(ParseError);
}(/*#__PURE__*/_wrapNativeSuper(Error));

//# sourceMappingURL=ParseError.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/PhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPossible_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isPossible.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isValid_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isValid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getNumberType.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_getCountryAndCallingCodeFromOneOfThem_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryAndCallingCodeFromOneOfThem.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_getPossibleCountriesForNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_extractCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_isObject_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__format_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/format.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck(this, PhoneNumber);
    // Validate `countryOrCountryCallingCode` argument.
    if (!countryOrCountryCallingCode) {
      throw new TypeError('First argument is required');
    }
    if (typeof countryOrCountryCallingCode !== 'string') {
      throw new TypeError('First argument must be a string');
    }

    // In case of public API use: `constructor(number, metadata)`.
    // Transform the arguments from `constructor(number, metadata)` to
    // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
    if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) {
      throw new TypeError('`metadata` argument not passed');
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_isObject_js__["a" /* default */])(nationalNumber) && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_isObject_js__["a" /* default */])(nationalNumber.countries)) {
      metadata = nationalNumber;
      var e164Number = countryOrCountryCallingCode;
      if (!E164_NUMBER_REGEXP.test(e164Number)) {
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      }
      var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_extractCountryCallingCode_js__["a" /* default */])(e164Number, undefined, undefined, undefined, metadata),
        _countryCallingCode = _extractCountryCallin.countryCallingCode,
        number = _extractCountryCallin.number;
      nationalNumber = number;
      countryOrCountryCallingCode = _countryCallingCode;
      if (!nationalNumber) {
        throw new Error('Invalid `number` argument passed: too short');
      }
    }

    // Validate `nationalNumber` argument.
    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` argument is required');
    }
    if (typeof nationalNumber !== 'string') {
      throw new TypeError('`nationalNumber` argument must be a string');
    }

    // Validate `metadata` argument.
    Object(__WEBPACK_IMPORTED_MODULE_0__metadata_js__["e" /* validateMetadata */])(metadata);

    // Initialize properties.
    var _getCountryAndCalling = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_getCountryAndCallingCodeFromOneOfThem_js__["a" /* default */])(countryOrCountryCallingCode, metadata),
      country = _getCountryAndCalling.country,
      countryCallingCode = _getCountryAndCalling.callingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.
    this.getMetadata = function () {
      return metadata;
    };
  }
  return _createClass(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_getPossibleCountriesForNumber_js__["a" /* default */])(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__isPossible_js__["a" /* default */])(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__isValid_js__["a" /* default */])(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }

    // `validateLength()` method was originally meant to be an equivalent for `validatePhoneNumberLength()`.
    //
    // Later, it became apparent that it's not really a true equivalent.
    // The reason is that a `PhoneNumber` instance is not created
    // when the phone number string is too short for it to be considered a valid phone number:
    // * When there must be at least 2 national (significant) number digits: `"1"`.
    // * When the country calling code part of an international number is incomplete: `"+12"`.
    //
    // So leaving this `validateLength()` method here would suggest a hidden anti-pattern
    // of using it instead of `validatePhoneNumberLength()` while ignoring
    // the "too short to be even possible" case from phone number length validation.
    // And ignoring that case wouldn't make any sense in a real-world application
    // because it would still be a valid case that should be handled.
    //
    // Because of that, this method was eventually commented out in order to not introduce
    // that kind of an anti-pattern.
    //
    // validateLength() {
    // 	const result = checkNumberLength(
    // 		this.nationalNumber,
    // 		undefined,
    // 		this.getMetadata()
    // 	)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getNumberType_js__["a" /* default */])(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__format_js__["b" /* default */])(this, _format, options ? _objectSpread(_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);
}();

var E164_NUMBER_REGEXP = /^\+\d+$/;
//# sourceMappingURL=PhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/PhoneNumberMatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberMatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_extension_createExtensionPattern_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findNumbers_RegExpCache_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/RegExpCache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/utf-8.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__findNumbers_Leniency_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/Leniency.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findNumbers_parsePreCandidate_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/parsePreCandidate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__findNumbers_isValidPreCandidate_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/isValidPreCandidate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidCandidate_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/isValidCandidate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumber.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * A port of Google's `PhoneNumberMatcher.java`.
 * https://github.com/googlei18n/libphonenumber/blob/master/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberMatcher.java
 * Date: 08.03.2018.
 */












var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var EXTN_PATTERNS_FOR_MATCHING = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_extension_createExtensionPattern_js__["a" /* default */])('matching');

/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */
var INNER_MATCHES = [
// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'/+(.*)',
// Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
"(?:".concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["g" /* pZ */], "-|-").concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["g" /* pZ */], ")").concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["g" /* pZ */], "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
"[\u2012-\u2015\uFF0D]".concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["g" /* pZ */], "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
"\\.+".concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["g" /* pZ */], "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
"".concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["g" /* pZ */], "+(").concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["a" /* PZ */], "+)")];

// Limit on the number of leading (plus) characters.
var leadLimit = Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__["b" /* limit */])(0, 2);

// Limit on the number of consecutive punctuation characters.
var punctuationLimit = Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__["b" /* limit */])(0, 4);

/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */
var digitBlockLimit = __WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* MAX_LENGTH_FOR_NSN */] + __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* MAX_LENGTH_COUNTRY_CODE */];

// Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.
var blockLimit = Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__["b" /* limit */])(0, digitBlockLimit);

/* A punctuation sequence allowing white space. */
var punctuation = "[".concat(__WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* VALID_PUNCTUATION */], "]") + punctuationLimit;

// A digits block without punctuation.
var digitSequence = __WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["f" /* pNd */] + Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__["b" /* limit */])(1, digitBlockLimit);

/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */
var PATTERN = '(?:' + __WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidCandidate_js__["a" /* LEAD_CLASS */] + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?';

// Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//
var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["c" /* _pN */]).concat(__WEBPACK_IMPORTED_MODULE_4__findNumbers_utf_8_js__["b" /* _pL */], "#]+$"));

// const NON_DIGITS_PATTERN = /(\D+)/

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */
var PhoneNumberMatcher = /*#__PURE__*/function () {
  /**
   * @param {string} text — the character sequence that we will search, null for no text.
   * @param {'POSSIBLE'|'VALID'|'STRICT_GROUPING'|'EXACT_GROUPING'} [options.leniency] — The leniency to use when evaluating candidate phone numbers. See `source/findNumbers/Leniency.js` for more details.
   * @param {number} [options.maxTries] — The maximum number of invalid numbers to try before giving up on the text. This is to cover degenerate cases where the text has a lot of false positives in it. Must be >= 0.
   */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, PhoneNumberMatcher);
    options = {
      v2: options.v2,
      defaultCallingCode: options.defaultCallingCode,
      defaultCountry: options.defaultCountry && Object(__WEBPACK_IMPORTED_MODULE_9__metadata_js__["d" /* isSupportedCountry */])(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
      // Here it should've assigned a default value only if `options.leniency === undefined`.
      leniency: options.leniency || (options.extended ? 'POSSIBLE' : 'VALID'),
      // Here it should've assigned a default value only if `options.maxTries === undefined`.
      maxTries: options.maxTries || MAX_SAFE_INTEGER
    };

    // Validate `leniency`.
    // if (!options.leniency) {
    // 	throw new TypeError('`leniency` is required')
    // }
    if (!__WEBPACK_IMPORTED_MODULE_5__findNumbers_Leniency_js__["a" /* default */][options.leniency]) {
      throw new TypeError("Unknown leniency: \"".concat(options.leniency, "\""));
    }
    if (options.leniency !== 'POSSIBLE' && options.leniency !== 'VALID') {
      throw new TypeError("Invalid `leniency`: \"".concat(options.leniency, "\". Supported values: \"POSSIBLE\", \"VALID\"."));
    }

    // Validate `maxTries`.
    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` must be `>= 0`');
    }
    this.text = text;
    this.options = options;
    this.metadata = metadata;

    // The degree of phone number validation.
    this.leniency = __WEBPACK_IMPORTED_MODULE_5__findNumbers_Leniency_js__["a" /* default */][options.leniency];

    /** The maximum number of retries after matching an invalid number. */
    this.maxTries = options.maxTries;

    // Compile regular expressions.
    this.PATTERN = new RegExp(PATTERN, 'ig');
    this.INNER_MATCHES = INNER_MATCHES.map(function (pattern) {
      return new RegExp(pattern, 'g');
    });

    /** The iteration tristate. */
    this.state = 'NOT_READY';

    /** The next index to start searching at. Undefined in {@link State#DONE}. */
    this.searchIndex = 0;

    // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
    // countries being used for the same doc with ~10 patterns for each country. Some pages will have
    // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
    // that use-case won't have a lot of benefit.
    this.regExpCache = new __WEBPACK_IMPORTED_MODULE_2__findNumbers_RegExpCache_js__["a" /* default */](32);
  }

  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */
  return _createClass(PhoneNumberMatcher, [{
    key: "find",
    value: function find(index) {
      // Reset the regular expression.
      this.PATTERN.lastIndex = index;
      var matches;
      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;
        candidate = Object(__WEBPACK_IMPORTED_MODULE_6__findNumbers_parsePreCandidate_js__["a" /* default */])(candidate);
        if (Object(__WEBPACK_IMPORTED_MODULE_7__findNumbers_isValidPreCandidate_js__["a" /* default */])(candidate, offset, this.text)) {
          var match =
          // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text)
          // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);
          if (match) {
            if (this.options.v2) {
              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: match.phoneNumber
              };
            } else {
              var phoneNumber = match.phoneNumber;
              var result = {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                phone: phoneNumber.nationalNumber
              };
              if (phoneNumber.country) {
                /* istanbul ignore if */
                if (USE_NON_GEOGRAPHIC_COUNTRY_CODE && country === '001') {
                  result.countryCallingCode = phoneNumber.countryCallingCode;
                } else {
                  result.country = phoneNumber.country;
                }
              } else {
                result.countryCallingCode = phoneNumber.countryCallingCode;
              }
              if (phoneNumber.ext) {
                result.ext = phoneNumber.ext;
              }
              return result;
            }
          }
        }
        this.maxTries--;
      }
    }

    /**
     * Attempts to extract a match from `substring`
     * if the substring itself does not qualify as a match.
     */
  }, {
    key: "extractInnerMatch",
    value: function extractInnerMatch(substring, offset, text) {
      for (var _iterator = _createForOfIteratorHelperLoose(this.INNER_MATCHES), _step; !(_step = _iterator()).done;) {
        var innerMatchRegExp = _step.value;
        // Reset regular expression.
        innerMatchRegExp.lastIndex = 0;
        var isFirstMatch = true;
        var candidateMatch = void 0;
        while (this.maxTries > 0 && (candidateMatch = innerMatchRegExp.exec(substring)) !== null) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _candidate = Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, substring.slice(0, candidateMatch.index));
            var _match = this.parseAndVerify(_candidate, offset, text);
            if (_match) {
              return _match;
            }
            this.maxTries--;
            isFirstMatch = false;
          }
          var candidate = Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_util_js__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, candidateMatch[1]);

          // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a `candidate` start index,
          // therefore resort to using this kind of an approximation.
          // (`groupMatcher` is called `candidateInSubstringMatch` in this javascript port)
          // https://stackoverflow.com/questions/15934353/get-index-of-each-capture-in-a-javascript-regex
          var candidateIndexGuess = substring.indexOf(candidate, candidateMatch.index);
          var match = this.parseAndVerify(candidate, offset + candidateIndexGuess, text);
          if (match) {
            return match;
          }
          this.maxTries--;
        }
      }
    }

    /**
     * Parses a phone number from the `candidate` using `parse` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */
  }, {
    key: "parseAndVerify",
    value: function parseAndVerify(candidate, offset, text) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidCandidate_js__["b" /* default */])(candidate, offset, text, this.options.leniency)) {
        return;
      }
      var phoneNumber = Object(__WEBPACK_IMPORTED_MODULE_10__parsePhoneNumber_js__["a" /* default */])(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry,
        defaultCallingCode: this.options.defaultCallingCode
      }, this.metadata);
      if (!phoneNumber) {
        return;
      }
      if (!phoneNumber.isPossible()) {
        return;
      }
      if (this.leniency(phoneNumber, {
        candidate: candidate,
        defaultCountry: this.options.defaultCountry,
        metadata: this.metadata,
        regExpCache: this.regExpCache
      })) {
        return {
          startsAt: offset,
          endsAt: offset + candidate.length,
          phoneNumber: phoneNumber
        };
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(this.searchIndex);
        if (this.lastMatch) {
          this.searchIndex = this.lastMatch.endsAt;
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }
      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      }

      // Don't retain that memory any longer than necessary.
      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);
}();

//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MIN_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_LENGTH_COUNTRY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VALID_DIGITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WHITESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALID_PUNCTUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLUS_CHARS; });
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2;

// The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.
var MAX_LENGTH_FOR_NSN = 17;

// The maximum length of the country calling code.
var MAX_LENGTH_COUNTRY_CODE = 3;

// Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";

// `DASHES` will be right after the opening square bracket of the "character class"
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
// export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var TILDES = "~\u2053\u223C\uFF5E";

// Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
// const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/LRUCache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LRUCache; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
var Node = /*#__PURE__*/_createClass(function Node(key, value) {
  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  _classCallCheck(this, Node);
  this.key = key;
  this.value = value;
  this.next = next;
  this.prev = prev;
});
var LRUCache = /*#__PURE__*/function () {
  //set default limit of 10 if limit is not passed.
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    _classCallCheck(this, LRUCache);
    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cache = {};
  }

  // Write Node to head of LinkedList
  // update cache with Node key and Node reference
  return _createClass(LRUCache, [{
    key: "put",
    value: function put(key, value) {
      this.ensureLimit();
      if (!this.head) {
        this.head = this.tail = new Node(key, value);
      } else {
        var node = new Node(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      }

      //Update the cache map
      this.cache[key] = this.head;
      this.size++;
    }

    // Read from cache map and make that node as new Head of LinkedList
  }, {
    key: "get",
    value: function get(key) {
      if (this.cache[key]) {
        var value = this.cache[key].value;

        // node removed from it's position and cache
        this.remove(key);
        // write node again to the head of LinkedList to make it most recently used
        this.put(key, value);
        return value;
      }
      console.log("Item not available in cache for key ".concat(key));
    }
  }, {
    key: "ensureLimit",
    value: function ensureLimit() {
      if (this.size === this.limit) {
        this.remove(this.tail.key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var node = this.cache[key];
      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }
      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }
      delete this.cache[key];
      this.size--;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cache = {};
    }

    // // Invokes the callback function with every node of the chain and the index of the node.
    // forEach(fn) {
    //   let node = this.head;
    //   let counter = 0;
    //   while (node) {
    //     fn(node, counter);
    //     node = node.next;
    //     counter++;
    //   }
    // }

    // // To iterate over LRU with a 'for...of' loop
    // *[Symbol.iterator]() {
    //   let node = this.head;
    //   while (node) {
    //     yield node;
    //     node = node.next;
    //   }
    // }
  }]);
}();

//# sourceMappingURL=LRUCache.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/Leniency.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export containsMoreThanOneSlashInNationalNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchPhoneNumberStringAgainstPhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/matchPhoneNumberStringAgainstPhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getCountryByCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/format.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/util.js");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }







/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(phoneNumber, _ref) {
    var candidate = _ref.candidate,
      metadata = _ref.metadata;
    return true;
  },
  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(phoneNumber, _ref2) {
    var candidate = _ref2.candidate,
      defaultCountry = _ref2.defaultCountry,
      metadata = _ref2.metadata;
    if (!phoneNumber.isValid() || !containsOnlyValidXChars(phoneNumber, candidate, metadata)) {
      return false;
    }

    // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(phoneNumber, { defaultCountry, metadata })
    return true;
  },
  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(phoneNumber, _ref3) {
    var candidate = _ref3.candidate,
      defaultCountry = _ref3.defaultCountry,
      metadata = _ref3.metadata,
      regExpCache = _ref3.regExpCache;
    if (!phoneNumber.isValid() || !containsOnlyValidXChars(phoneNumber, candidate, metadata) || containsMoreThanOneSlashInNationalNumber(phoneNumber, candidate) || !isNationalPrefixPresentIfRequired(phoneNumber, {
      defaultCountry: defaultCountry,
      metadata: metadata
    })) {
      return false;
    }
    return checkNumberGroupingIsValid(phoneNumber, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
  },
  /**
   * Phone numbers accepted are "valid" and are grouped in the same way
   * that we would have formatted it, or as a single block.
   * For example, a US number written as "650 2530000" is not accepted
   * at this leniency level, whereas "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(phoneNumber, _ref4) {
    var candidate = _ref4.candidate,
      defaultCountry = _ref4.defaultCountry,
      metadata = _ref4.metadata,
      regExpCache = _ref4.regExpCache;
    if (!phoneNumber.isValid() || !containsOnlyValidXChars(phoneNumber, candidate, metadata) || containsMoreThanOneSlashInNationalNumber(phoneNumber, candidate) || !isNationalPrefixPresentIfRequired(phoneNumber, {
      defaultCountry: defaultCountry,
      metadata: metadata
    })) {
      return false;
    }
    return checkNumberGroupingIsValid(phoneNumber, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
  }
});
function containsOnlyValidXChars(phoneNumber, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);
    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);
      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__matchPhoneNumberStringAgainstPhoneNumber_js__["a" /* default */])(candidate.substring(index), phoneNumber, metadata) !== 'NSN_MATCH') {
          return false;
        }
        // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.
      } else {
        var ext = Object(__WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits_js__["b" /* default */])(candidate.substring(index));
        if (ext) {
          if (phoneNumber.ext !== ext) {
            return false;
          }
        } else {
          if (phoneNumber.ext) {
            return false;
          }
        }
      }
    }
  }
  return true;
}
function isNationalPrefixPresentIfRequired(phoneNumber, _ref5) {
  var defaultCountry = _ref5.defaultCountry,
    _metadata = _ref5.metadata;
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (phoneNumber.__countryCallingCodeSource !== 'FROM_DEFAULT_COUNTRY') {
    return true;
  }
  var metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata_js__["a" /* default */](_metadata);
  metadata.selectNumberingPlan(phoneNumber.countryCallingCode);
  var phoneNumberRegion = phoneNumber.country || Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getCountryByCallingCode_js__["a" /* default */])(phoneNumber.countryCallingCode, {
    nationalNumber: phoneNumber.nationalNumber,
    metadata: metadata
  });

  // Check if a national prefix should be present when formatting this number.
  var nationalNumber = phoneNumber.nationalNumber;
  var format = Object(__WEBPACK_IMPORTED_MODULE_4__format_js__["a" /* chooseFormatForNumber */])(metadata.numberingPlan.formats(), nationalNumber);

  // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.
  if (format.nationalPrefixFormattingRule()) {
    if (metadata.numberingPlan.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was present.
      return true;
    }
    if (!format.usesNationalPrefix()) {
      // National Prefix not needed for this number.
      return true;
    }
    return Boolean(phoneNumber.nationalPrefix);
  }
  return true;
}
function containsMoreThanOneSlashInNationalNumber(phoneNumber, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');
  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  }

  // Now look for a second one.
  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);
  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  }

  // If the first slash is after the country calling code, this is permitted.
  var candidateHasCountryCode = phoneNumber.__countryCallingCodeSource === 'FROM_NUMBER_WITH_PLUS_SIGN' || phoneNumber.__countryCallingCodeSource === 'FROM_NUMBER_WITHOUT_PLUS_SIGN';
  if (candidateHasCountryCode && Object(__WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits_js__["b" /* default */])(candidate.substring(0, firstSlashInBodyIndex)) === phoneNumber.countryCallingCode) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }
  return true;
}
function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
  throw new Error('This part of code hasn\'t been ported');
  var normalizedCandidate = normalizeDigits(candidate, true /* keep non-digits */);
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);
  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  }

  // If this didn't pass, see if there are any alternate formats that match, and try them instead.
  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
  var nationalSignificantNumber = util.getNationalSignificantNumber(number);
  if (alternateFormats) {
    for (var _iterator = _createForOfIteratorHelperLoose(alternateFormats.numberFormats()), _step; !(_step = _iterator()).done;) {
      var alternateFormat = _step.value;
      if (alternateFormat.leadingDigitsPatterns().length > 0) {
        // There is only one leading digits pattern for alternate formats.
        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);
        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
          // Leading digits don't match; try another one.
          continue;
        }
      }
      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);
      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together following
 * standard formatting rules.
 */
function getNationalNumberGroups(metadata, number, formattingPattern) {
  throw new Error('This part of code hasn\'t been ported');
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  }

  // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.
  var rfc3966Format = formatNumber(number, 'RFC3966', metadata);

  // We remove the extension part from the formatted string before splitting it into different
  // groups.
  var endIndex = rfc3966Format.indexOf(';');
  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  }

  // The country-code will have a '-' following it.
  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}
function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  throw new Error('This part of code hasn\'t been ported');
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN);

  // Set this to the last group, skipping it if the number has an extension.
  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1;

  // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.
  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  }

  // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.
  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;
  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }
    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  }

  // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.
  return candidateNumberGroupIndex >= 0 && Object(__WEBPACK_IMPORTED_MODULE_5__util_js__["a" /* endsWith */])(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}
function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  throw new Error('This part of code hasn\'t been ported');
  var fromIndex = 0;
  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  }

  // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.
  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);
    if (fromIndex < 0) {
      return false;
    }
    // Moves {@code fromIndex} forward.
    fromIndex += formattedNumberGroups[i].length();
    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());
      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_js__["c" /* startsWith */])(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  }

  // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.
  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}
//# sourceMappingURL=Leniency.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/RegExpCache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegExpCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LRUCache_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/LRUCache.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


// A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
// countries being used for the same doc with ~10 patterns for each country. Some pages will have
// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
// that use-case won't have a lot of benefit.
var RegExpCache = /*#__PURE__*/function () {
  function RegExpCache(size) {
    _classCallCheck(this, RegExpCache);
    this.cache = new __WEBPACK_IMPORTED_MODULE_0__LRUCache_js__["a" /* default */](size);
  }
  return _createClass(RegExpCache, [{
    key: "getPatternForRegExp",
    value: function getPatternForRegExp(pattern) {
      var regExp = this.cache.get(pattern);
      if (!regExp) {
        regExp = new RegExp('^' + pattern);
        this.cache.put(pattern, regExp);
      }
      return regExp;
    }
  }]);
}();

//# sourceMappingURL=RegExpCache.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/isValidCandidate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEAD_CLASS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utf_8_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/utf-8.js");
// Copy-pasted from `PhoneNumberMatcher.js`.




var OPENING_PARENS = "(\\[\uFF08\uFF3B";
var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(__WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* PLUS_CHARS */], "]");

// Punctuation that may be at the start of a phone number - brackets and plus signs.
var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS);

// Limit on the number of pairs of brackets in a phone number.
var BRACKET_PAIR_LIMIT = Object(__WEBPACK_IMPORTED_MODULE_1__util_js__["b" /* limit */])(0, 3);

/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */
var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');

/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */
var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
function isValidCandidate(candidate, offset, text, leniency) {
  // Check the candidate doesn't contain any formatting
  // which would indicate that it really isn't a phone number.
  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
    return;
  }

  // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.
  if (leniency !== 'POSSIBLE') {
    // If the candidate is not at the start of the text,
    // and does not start with phone-number punctuation,
    // check the previous character.
    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
      var previousChar = text[offset - 1];
      // We return null if it is a latin letter or an invalid punctuation symbol.
      if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8_js__["d" /* isInvalidPunctuationSymbol */])(previousChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8_js__["e" /* isLatinLetter */])(previousChar)) {
        return false;
      }
    }
    var lastCharIndex = offset + candidate.length;
    if (lastCharIndex < text.length) {
      var nextChar = text[lastCharIndex];
      if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8_js__["d" /* isInvalidPunctuationSymbol */])(nextChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8_js__["e" /* isLatinLetter */])(nextChar)) {
        return false;
      }
    }
  }
  return true;
}
//# sourceMappingURL=isValidCandidate.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/isValidPreCandidate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidPreCandidate;
// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/;

// Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.
var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
function isValidPreCandidate(candidate, offset, text) {
  // Skip a match that is more likely to be a date.
  if (SLASH_SEPARATED_DATES.test(candidate)) {
    return false;
  }

  // Skip potential time-stamps.
  if (TIME_STAMPS.test(candidate)) {
    var followingText = text.slice(offset + candidate.length);
    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
      return false;
    }
  }
  return true;
}
//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/matchPhoneNumberStringAgainstPhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchPhoneNumberStringAgainstPhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumber.js");


/**
 * Matches a phone number object against a phone number string.
 * @param  {string} phoneNumberString
 * @param  {PhoneNumber} phoneNumber
 * @param  {object} metadata — Metadata JSON
 * @return {'INVALID_NUMBER'|'NO_MATCH'|'SHORT_NSN_MATCH'|'NSN_MATCH'|'EXACT_MATCH'}
 */
function matchPhoneNumberStringAgainstPhoneNumber(phoneNumberString, phoneNumber, metadata) {
  // Parse `phoneNumberString`.
  var phoneNumberStringContainsCallingCode = true;
  var parsedPhoneNumber = Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber_js__["a" /* default */])(phoneNumberString, metadata);
  if (!parsedPhoneNumber) {
    // If `phoneNumberString` didn't contain a country calling code
    // then substitute it with the `phoneNumber`'s country calling code.
    phoneNumberStringContainsCallingCode = false;
    parsedPhoneNumber = Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber_js__["a" /* default */])(phoneNumberString, {
      defaultCallingCode: phoneNumber.countryCallingCode
    }, metadata);
  }
  if (!parsedPhoneNumber) {
    return 'INVALID_NUMBER';
  }

  // Check that the extensions match.
  if (phoneNumber.ext) {
    if (parsedPhoneNumber.ext !== phoneNumber.ext) {
      return 'NO_MATCH';
    }
  } else {
    if (parsedPhoneNumber.ext) {
      return 'NO_MATCH';
    }
  }

  // Check that country calling codes match.
  if (phoneNumberStringContainsCallingCode) {
    if (phoneNumber.countryCallingCode !== parsedPhoneNumber.countryCallingCode) {
      return 'NO_MATCH';
    }
  }

  // Check if the whole numbers match.
  if (phoneNumber.number === parsedPhoneNumber.number) {
    if (phoneNumberStringContainsCallingCode) {
      return 'EXACT_MATCH';
    } else {
      return 'NSN_MATCH';
    }
  }

  // Check if one national number is a "suffix" of the other.
  if (phoneNumber.nationalNumber.indexOf(parsedPhoneNumber.nationalNumber) === 0 || parsedPhoneNumber.nationalNumber.indexOf(phoneNumber.nationalNumber) === 0) {
    // "A SHORT_NSN_MATCH occurs if there is a difference because of the
    //  presence or absence of an 'Italian leading zero', the presence or
    //  absence of an extension, or one NSN being a shorter variant of the
    //  other."
    return 'SHORT_NSN_MATCH';
  }
  return 'NO_MATCH';
}
//# sourceMappingURL=matchPhoneNumberStringAgainstPhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/parsePreCandidate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePreCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/util.js");


// Regular expression of characters typically used to start a second phone number for the purposes
// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//
var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
function parsePreCandidate(candidate) {
  // Check for extra numbers at the end.
  // TODO: This is the place to start when trying to support extraction of multiple phone number
  // from split notations (+41 79 123 45 67 / 68).
  return Object(__WEBPACK_IMPORTED_MODULE_0__util_js__["d" /* trimAfterFirstMatch */])(SECOND_NUMBER_START_PATTERN, candidate);
}
//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/utf-8.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _pN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pNd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _pL; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isLatinLetter;
/* harmony export (immutable) */ __webpack_exports__["d"] = isInvalidPunctuationSymbol;
// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.

// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */

var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
var pZ = "[".concat(_pZ, "]");
var PZ = "[^".concat(_pZ, "]");
var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
// const pN = `[${_pN}]`

var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
var pNd = "[".concat(_pNd, "]");
var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var pL = "[".concat(_pL, "]");
var pL_regexp = new RegExp(pL);
var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
var pSc = "[".concat(_pSc, "]");
var pSc_regexp = new RegExp(pSc);
var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
var pMn = "[".concat(_pMn, "]");
var pMn_regexp = new RegExp(pMn);
var _InBasic_Latin = "\0-\x7F";
var _InLatin_1_Supplement = "\x80-\xFF";
var _InLatin_Extended_A = "\u0100-\u017F";
var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
var _InLatin_Extended_B = "\u0180-\u024F";
var _InCombining_Diacritical_Marks = "\u0300-\u036F";
var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');

/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */
function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }
  return latinLetterRegexp.test(letter);
}
function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}
//# sourceMappingURL=utf-8.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findNumbers/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = limit;
/* harmony export (immutable) */ __webpack_exports__["d"] = trimAfterFirstMatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["a"] = endsWith;
/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
  if (lower < 0 || upper <= 0 || upper < lower) {
    throw new TypeError();
  }
  return "{".concat(lower, ",").concat(upper, "}");
}

/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */
function trimAfterFirstMatch(regexp, string) {
  var index = string.search(regexp);
  if (index >= 0) {
    return string.slice(0, index);
  }
  return string;
}
function startsWith(string, substring) {
  return string.indexOf(substring) === 0;
}
function endsWith(string, substring) {
  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/findPhoneNumbersInText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbersInText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumberMatcher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function findPhoneNumbersInText() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  var matcher = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher_js__["a" /* default */](text, _objectSpread(_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
  var results = [];
  while (matcher.hasNext()) {
    results.push(matcher.next());
  }
  return results;
}
//# sourceMappingURL=findPhoneNumbersInText.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/format.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = chooseFormatForNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_matchesEntirely_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_formatNationalNumberUsingFormat_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getIddPrefix_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_RFC3966_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/RFC3966.js");
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js






var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};

/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadataJson
 * @return {string}
 */
function formatNumber(input, format, options, metadataJson) {
  // Apply default options.
  if (options) {
    // Using ES6 "rest spread" syntax here didn't work with `babel`/`istanbul`
    // for some weird reason: this line of code would cause the code coverage
    // to show as not 100%. That's because `babel`/`istanbul`, for some weird reason,
    // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
    //
    // options = { ...DEFAULT_OPTIONS, ...options }
    //
    options = merge({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  var metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata_js__["a" /* default */](metadataJson);

  // Normally, the `input` object is supposed to be a `PhoneNumber` class instance.
  // Also, according to the `PhoneNumber` class source code, `country` can't be "001".
  // It means that normally `input.country` or `input.countryCallingCode` is supposed
  // to be present because either of the two is always required to exist in a `PhoneNumber` instance.
  // This means that realistically, it's gonna step into either the first `if`
  // or the following `else if`, and normally it won't even reach the legacy-compatibility
  // `else return input.phone || ''` part.
  // So normally, it won't ever return an empty string here.
  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata.selectNumberingPlan(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';
  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;

  // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".
  var number;
  switch (format) {
    case 'NATIONAL':
      // Normally, the `input` object is supposed to be a `PhoneNumber` class instance,
      // and a `PhoneNumber` class instance is always required to have a `nationalNumber`.
      // This means that the `if (!nationalNumber)` below is just for legacy-compatibility
      // and it normally can't really happen, so normally it won't ever return an empty string here.
      if (!nationalNumber) {
        return '';
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case 'RFC3966':
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_RFC3966_js__["a" /* formatRFC3966 */])({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });

    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case 'IDD':
      // If the required `fromCountry` parameter is not passed, it will return `undefined`.
      if (!options.fromCountry) {
        return;
        // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      // If the country of the phone number doesn't support IDD calling, it will return `undefined`.
      if (!formattedNumber) {
        return;
      }
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);
  if (!format) {
    return number;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_formatNationalNumberUsingFormat_js__["b" /* default */])(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}
function chooseFormatForNumber(availableFormats, nationalNumber) {
  // Using a `for ... of` loop here didn't work with `babel`/`istanbul`:
  // for some weird reason, it showed code coverage less than 100%.
  // That's because `babel`/`istanbul`, for some weird reason,
  // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
  //
  // for (const format of availableFormats) { ... }
  //
  return pickFirstMatchingElement(availableFormats, function (format) {
    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      // If leading digits don't match then move on to the next phone number format
      if (nationalNumber.search(lastLeadingDigitsPattern) !== 0) {
        return false;
      }
    }
    // Check that the national number matches the phone number format regular expression
    return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_matchesEntirely_js__["a" /* default */])(nationalNumber, format.pattern());
  });
}
function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = Object(__WEBPACK_IMPORTED_MODULE_2__metadata_js__["b" /* getCountryCallingCode */])(fromCountry, metadata.metadata);
  // When calling within the same country calling code.
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata);
    // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.
    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    }
    // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //
    return formattedNumber;
  }
  var iddPrefix = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getIddPrefix_js__["a" /* default */])(fromCountry, undefined, metadata.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
function merge() {
  var i = 1;
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  while (i < objects.length) {
    if (objects[i]) {
      for (var key in objects[i]) {
        objects[0][key] = objects[i][key];
      }
    }
    i++;
  }
  return objects[0];
}
function pickFirstMatchingElement(elements, testFunction) {
  var i = 0;
  while (i < elements.length) {
    if (testFunction(elements[i])) {
      return elements[i];
    }
    i++;
  }
}
//# sourceMappingURL=format.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/formatIncompletePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatIncompletePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouType.js");


/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string|object} [optionsOrDefaultCountry] - A two-letter ("ISO 3166-1 alpha-2") country code, or an object of shape `{ defaultCountry?: string, defaultCallingCode?: string }`.
 * @return {string} Formatted (possibly incomplete) phone number.
 */
function formatIncompletePhoneNumber(value, optionsOrDefaultCountry, metadata) {
  if (!metadata) {
    metadata = optionsOrDefaultCountry;
    optionsOrDefaultCountry = undefined;
  }
  return new __WEBPACK_IMPORTED_MODULE_0__AsYouType_js__["a" /* default */](optionsOrDefaultCountry, metadata).input(value);
}
//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/getCountries.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");

function getCountries(metadata) {
  return new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/getCountryCallingCode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_js__["b"]; });
// Deprecated. Import from 'metadata.js' directly instead.

//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/getExampleNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExampleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumber.js");

function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber_js__["a" /* default */](country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/RFC3966.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRFC3966;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRFC3966;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isViablePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


// https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */
function parseRFC3966(text) {
  var number;
  var ext;

  // Replace "tel:" with "tel=" for parsing convenience.
  text = text.replace(/^tel:/, 'tel=');
  for (var _iterator = _createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
    var part = _step.value;
    var _part$split = part.split('='),
      _part$split2 = _slicedToArray(_part$split, 2),
      name = _part$split2[0],
      value = _part$split2[1];
    switch (name) {
      case 'tel':
        number = value;
        break;
      case 'ext':
        ext = value;
        break;
      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }
        break;
    }
  }

  // If the phone number is not viable, then abort.
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isViablePhoneNumber_js__["b" /* default */])(number)) {
    return {};
  }
  var result = {
    number: number
  };
  if (ext) {
    result.ext = ext;
  }
  return result;
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */
function formatRFC3966(_ref) {
  var number = _ref.number,
    ext = _ref.ext;
  if (!number) {
    return '';
  }
  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }
  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyInternationalSeparatorStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");


// Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(__WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* VALID_PUNCTUATION */], "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkNumberLength;
/* unused harmony export checkNumberLengthForType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeArrays_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/mergeArrays.js");



/**
 * Checks phone number length against the phone numbering plan selected in metadata.
 * Optionally, it could be restrained by a specific country.
 * @param {string} nationalNumber
 * @param {string?} country — Specific country to use rather than the one that is pre-selected in the metadata instance.
 * @param {Metadata} metadata — Metadata instance with a selected numbering plan.
 * @returns {string}
 */
function checkNumberLength(nationalNumber, country, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, country, metadata);
}

/**
 * Checks phone number length against the phone numbering plan selected in metadata.
 * Optionally, it could be restrained by a specific phone number type or a specific country.
 * @param {string} nationalNumber
 * @param {string?} type — Specific phone number type.
 * @param {string?} country — Specific country to use instead of the one that is pre-selected in the metadata instance.
 * @param {Metadata} metadata — Metadata instance with a selected numbering plan.
 * @returns {string} See the README on `validatePhoneNumberLength()` function, with an addition of a special case: when phone numbers of type `type` aren't possible in the telephone numbering plan, it will return "INVALID_LENGTH".
 */
// Checks whether a number is possible for a certain `country` based on the number length.
//
// This function is not supported by metadata generated with ancient versions of
// `libphonenumber-js` (before version `1.0.18`) which didn't include "possible lengths".
//
// There was also a known issue with `checkNumberLength()` function:
// if a number is possible only in a certain `country` among several `countries`
// that share the same "country calling code", that function would check
// the possibility of the phone number only in the "main" `country` for the "country calling code"
// and would not check if it's actually be possible in the speciifc `country`.
//
// For example, "+1310xxxx" numbers are valid in Canada.
// However, they are not possible in the US due to being too short.
// Since Canada and the US share the same country calling code — "+1" —
// `checkNumberLength()` function used to return not "IS_POSSIBLE" for "+1310xxxx" numbers.
//
// In such cases, when using "/max" metadata, `isValid()` could output `true`
// but at the same time `isPossible()` could output `false`, which was contradictory.
//
// See https://issuetracker.google.com/issues/335892662 for the discusson in Google's issues.
//
// The solution suggested by Google was implemented: an optional `country` argument
// was added to `checkNumberLength()` function. If present, that `country` will be used
// to check phone number length for that specific `country` rather than the "main" country
// for the shared "country calling code".
//
function checkNumberLengthForType(nationalNumber, type, country, metadata) {
  if (country) {
    // If a specific `country` is specified, re-create a metadata instance with it.
    metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadata.metadata);
    metadata.selectNumberingPlan(country);
  }
  var type_info = metadata.type(type);

  // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.
  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
  // let local_lengths = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()

  // Metadata before version `1.0.18` didn't contain `possible_lengths`.
  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }
  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.
    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', country, metadata);
    }
    var mobile_type = metadata.type('MOBILE');
    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = Object(__WEBPACK_IMPORTED_MODULE_1__mergeArrays_js__["a" /* default */])(possible_lengths, mobile_type.possibleLengths());
      // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.

      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  }
  // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }
  var actual_length = nationalNumber.length;

  // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }
  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  }

  // We skip the first element since we've already checked it.
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createExtensionPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");


// The RFC 3966 format for extensions.
var RFC3966_EXTN_PREFIX = ';ext=';

/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */
var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(__WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */], "]{1,").concat(maxLength, "})");
};

/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */
function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.
  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */
  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */
  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */
  var extLimitWhenNotSure = '6';

  /** @type {string} */
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
  /** @type {string} */
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */
  var optionalExtnSuffix = "#?";

  // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".
  /** @type {string} */
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.
  /** @type {string} */
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  // When extension is not separated clearly.
  /** @type {string} */
  var ambiguousSeparator = "[- ]+";
  // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.
  /** @type {string} */
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.
  /** @type {string} */
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";

  /** @type {string} */
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";

  /** @type {string} */
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;

  // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractExtension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createExtensionPattern_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js");


// Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.
var EXTN_PATTERN = new RegExp('(?:' + Object(__WEBPACK_IMPORTED_MODULE_0__createExtensionPattern_js__["a" /* default */])() + ')$', 'i');

// Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractCountryCallingCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripIddPrefix_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractCountryCallingCodeFromInternationalNumberWithoutPlusSign_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");





/**
 * Attempts to extract a calling code from a phone number.
 * * If the phone number is found to be "international":
 *   * It will attempt to identify the calling code part of it and whether that part is complete and valid.
 *     * If the calling code part is complete and valid, it will return two properties:
 *       that calling code part (without `+`) and the rest of the digits.
 *     * Otherwise, i.e. if the calling code part is incomplete or invalid,
 *       it will return an empty object.
 * * Otherwise, i.e. if the phone number is national, there's no callind code to extract
 *   so it will just return the originally-passed `number` string as the only property.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Country.
 * @param  {string} [defaultCountry] — Default country.
 * @param  {string} [defaultCallingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadataJson
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`, where `countryCallingCodeSource` tells how the returned calling code was extracted (if it was extracted), `countryCallingCode` is the calling code that was extracted from the input `number` string, and `number` is the originally passed `number` without the extracted calling code (and without a `+`). If the calling code is present but incomplete or invalid, it will return an empty object.
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, null, metadata)
 * extractCountryCallingCode('2133734253', null, 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, null, metadata)
 * extractCountryCallingCode('+12133734253', null, 'RU', null, metadata)
 */
function extractCountryCallingCode(number, country, defaultCountry, defaultCallingCode, metadataJson) {
  if (!number) {
    return {};
  }
  var isNumberWithIddPrefix;

  // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376
  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_0__stripIddPrefix_js__["a" /* default */])(number, country || defaultCountry, defaultCallingCode, metadataJson);
    // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || defaultCountry || defaultCallingCode) {
        var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_1__extractCountryCallingCodeFromInternationalNumberWithoutPlusSign_js__["a" /* default */])(number, country, defaultCountry, defaultCallingCode, metadataJson),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  }

  // `number` can only be international at this point.

  // Fast abortion: country codes do not begin with a '0'
  if (number[1] === '0') {
    return {};
  }
  var metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata_js__["a" /* default */](metadataJson);

  // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //
  var i = 2;
  while (i - 1 <= __WEBPACK_IMPORTED_MODULE_3__constants_js__["a" /* MAX_LENGTH_COUNTRY_CODE */] && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}

// The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }
//# sourceMappingURL=extractCountryCallingCode.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extractNationalNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/getCountryCallingCode.js");






/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits (only digits, no `+`).
 * @param  {string} [country] — Exact country of the phone number.
 * @param  {string} [defaultCountry]
 * @param  {string} [defaultCallingCode]
 * @param  {object} metadataJson
 * @return {object} `{ countryCallingCode: string?, number: string }`, where `countryCallingCode` is the calling code that was extracted from the input `number` string, and `number` is the originally passed `number` without the extracted calling code.
 */
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadataJson) {
  // Validate arguments.
  // The `number` is known to be in a non-international form
  // because there's no leading "+" character.
  // Therefore, there must be either `country` or `defaultCountry` or `defaultCallingCode`.
  // Otherwise, there'd be no source for the calling code to search for in the `number`.
  if (!(country || defaultCountry || defaultCallingCode)) {
    // There's no source for the calling code to search for in the `number`.
    return {
      number: number
    };
  }
  var countryCallingCode = country || defaultCountry ? Object(__WEBPACK_IMPORTED_MODULE_4__getCountryCallingCode_js__["a" /* default */])(country || defaultCountry, metadataJson) : defaultCallingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
    metadata.selectNumberingPlan(country || defaultCountry || defaultCallingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_2__extractNationalNumber_js__["a" /* default */])(possibleShorterNumber, undefined, metadata),
      possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = Object(__WEBPACK_IMPORTED_MODULE_2__extractNationalNumber_js__["a" /* default */])(number, undefined, metadata),
      nationalNumber = _extractNationalNumbe2.nationalNumber;

    // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern()) && Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__["a" /* default */])(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || Object(__WEBPACK_IMPORTED_MODULE_3__checkNumberLength_js__["a" /* default */])(nationalNumber, undefined, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParseError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/ParseError.js");



/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = Object(__WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["e" /* default */])(numberToParse);
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["f" /* isPhoneContextValid */])(phoneContext)) {
    throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('NOT_A_NUMBER');
  }
  var phoneNumberString;
  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = '';

    // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.
    if (phoneContext.charAt(0) === __WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["a" /* PLUS_SIGN */]) {
      phoneNumberString += phoneContext;
    }

    // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.
    var indexOfRfc3966Prefix = numberToParse.indexOf(__WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["d" /* RFC3966_PREFIX_ */]);
    var indexOfNationalNumber;
    // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.
    /* istanbul ignore else */
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + __WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["d" /* RFC3966_PREFIX_ */].length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(__WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["c" /* RFC3966_PHONE_CONTEXT_ */]);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }

  // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.
  var indexOfIsdn = phoneNumberString.indexOf(__WEBPACK_IMPORTED_MODULE_0__extractPhoneContext_js__["b" /* RFC3966_ISDN_SUBADDRESS_ */]);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.

  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}
//# sourceMappingURL=extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractNationalNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractNationalNumberFromPossiblyIncompleteNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getCountryByCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js");





/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {string?} country — Specific country to use instead of the one that is pre-selected in the metadata instance.
 * @param  {Metadata} metadata — Metadata instance with a selected numbering plan.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */
function extractNationalNumber(number, country, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_0__extractNationalNumberFromPossiblyIncompleteNumber_js__["a" /* default */])(number, metadata),
    carrierCode = _extractNationalNumbe.carrierCode,
    nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    }
    // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature,
    // so this `if` will only be executed with newer metadata.
    if (metadata.numberingPlan.possibleLengths()) {
      // If an exact `country` is not specified, attempt to detect it from the assumed national number.
      if (!country) {
        country = Object(__WEBPACK_IMPORTED_MODULE_3__getCountryByCallingCode_js__["a" /* default */])(metadata.numberingPlan.callingCode(), {
          nationalNumber: nationalNumber,
          metadata: metadata
        });
      }

      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, country, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

// In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__["a" /* default */])(nationalNumberBefore, metadata.nationalNumberPattern()) && !Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__["a" /* default */])(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  }
  // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }
  return true;
}

/**
 * Tells if a given incomplete national number is possible or not.
 * @param {string} nationalNumber
 * @param {string?} country — Specific country rather than the one that is pre-selected in the metadata instance.
 * @param {Metadata} metadata — Metadata instance with a selected numbering plan.
 * @returns {boolean}
 */
function isPossibleIncompleteNationalNumber(nationalNumber, country, metadata) {
  switch (Object(__WEBPACK_IMPORTED_MODULE_2__checkNumberLength_js__["a" /* default */])(nationalNumber, country, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;
    default:
      return true;
  }
}
//# sourceMappingURL=extractNationalNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractNationalNumberFromPossiblyIncompleteNumber;
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
        // If there's more than one captured group,
        // then carrier code is the second one.
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      }
      // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        // If there's at least one captured group,
        // then carrier code is the first one.
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLUS_SIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RFC3966_PREFIX_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RFC3966_PHONE_CONTEXT_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RFC3966_ISDN_SUBADDRESS_; });
/* harmony export (immutable) */ __webpack_exports__["e"] = extractPhoneContext;
/* harmony export (immutable) */ __webpack_exports__["f"] = isPhoneContextValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.


var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';

/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g');

// In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var ALPHANUM_ = __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */];
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';

/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';

/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  // If no phone-context parameter is present
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  // If phone-context parameter is empty
  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart);
  // If phone-context is not the last parameter
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}

/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }

  // Does phone-context value match pattern of global-number-digits or domainname.
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
//# sourceMappingURL=extractPhoneContext.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIRST_GROUP_PATTERN; });
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNationalNumberUsingFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyInternationalSeparatorStyle_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js");


// This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
    withNationalPrefix = _ref.withNationalPrefix,
    carrierCode = _ref.carrierCode,
    metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() :
  // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
  if (useInternationalFormat) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__applyInternationalSeparatorStyle_js__["a" /* default */])(formattedNumber);
  }
  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/getCountryAndCallingCodeFromOneOfThem.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountryAndCallingCodeFromOneOfThem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isCountryCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isCountryCode.js");


var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryAndCallingCodeFromOneOfThem(countryOrCallingCode, metadataJson) {
  var country;
  var callingCode;
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
  // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isCountryCode_js__["a" /* default */])(countryOrCallingCode)) {
    country = countryOrCallingCode;
    metadata.selectNumberingPlan(country);
    callingCode = metadata.countryCallingCode();
  } else {
    callingCode = countryOrCallingCode;
    /* istanbul ignore if */
    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
      if (metadata.isNonGeographicCallingCode(callingCode)) {
        country = '001';
      }
    }
  }
  return {
    country: country,
    callingCode: callingCode
  };
}
//# sourceMappingURL=getCountryAndCallingCodeFromOneOfThem.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountryByCallingCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getCountryByNationalNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js");

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

/**
 * Returns the exact country that a given national (significant) number belongs to
 * in case of ambiguity, i.e. when multiple countries share the same "country calling code".
 * @param {string} [callingCode]
 * @param {string} [options.nationalNumber] — National (significant) number.
 * @param {Metadata} options.metadata — Metadata instance.
 * @returns {string?} Returns the most suitable country for this calling code and national (significant) number.
 */
function getCountryByCallingCode(callingCode, _ref) {
  var nationalNumber = _ref.nationalNumber,
    metadata = _ref.metadata;
  /* istanbul ignore if */
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }
  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__getCountryByNationalNumber_js__["a" /* default */])(nationalNumber, possibleCountries, metadata.metadata);
}
//# sourceMappingURL=getCountryByCallingCode.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountryByNationalNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getNumberType.js");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



/**
 * Returns the exact country that a given national (significant) number belongs to
 * in case of ambiguity, i.e. when multiple countries share the same "country calling code".
 * @param {string} [nationalNumber]
 * @param {string[]} countries — A list of countries that share the same calling code.
 * @param {object} metadata — Metadata JSON.
 * @returns {string?} Returns the exact country this number belongs to, or `undefined` if the exact country couldn't be determined.
 */
function getCountryByNationalNumber(nationalNumber, countries, metadataJson) {
  // Create a new `metadata` instance because it will be selecting a `country`.
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);

  // const matchingCountries = []

  for (var _iterator = _createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.selectNumberingPlan(country);
    // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.
    if (metadata.leadingDigits()) {
      if (nationalNumber && nationalNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    }
    // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__getNumberType_js__["a" /* default */])({
      phone: nationalNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // When multiple countries share the same "country calling code",
      // type patterns aren't guaranteed to be unique among them.
      // For example, both `US` and `CA` have the same pattern for `toll_free` numbers.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417147572
      //
      // That means that this `if` condition could be `true` for multiple countries from the list.
      // Currently, it just returns the first one, which is also the "main" country for the "country calling code".
      // In an example with `toll_free` numbers above, `"US"` would be returned even though
      // it could as well be `"CA"`.
      //
      // There was also a time when this attempted to be overly smart
      // and kept track of all such multiple matching countries
      // and then picked the one that matched the `defaultCountry`, if provided.
      // For example, with `toll_free` numbers above, and with `defaultCountry: "CA"`,
      // it would've returned `"CA"` instead of `"US"`.
      // Later it turned out that such "overly smart" behavior turned out to be just confusing,
      // so this "overly smart" country detection was reverted to returning the "main" country
      // for the "country calling code".
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
      //
      return country;
      //
      // The "overly smart" behavior code:
      //
      // if (defaultCountry) {
      // 	if (country === defaultCountry) {
      // 		return country
      // 	} else {
      // 		matchingCountries.push(country)
      // 	}
      // } else {
      // 	return country
      // }
    }
  }

  // // Return the first ("main") one of the `matchingCountries`.
  // if (matchingCountries.length > 0) {
  // 	return matchingCountries[0]
  // }
}
//# sourceMappingURL=getCountryByNationalNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIddPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");


/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;

// If the `country` supports IDD calling, it returns a preferred IDD prefix.
// If the `country` doesn't support IDD calling, it returns `undefined`.
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadata);
  countryMetadata.selectNumberingPlan(country || callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
//# sourceMappingURL=getIddPrefix.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/getNumberType.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNumberType;
/* unused harmony export isNumberTypeEqualTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL'];

// Finds out national phone number type (fixed line, mobile, etc)
function getNumberType(input, options, metadataJson) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};

  // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
  metadata.selectNumberingPlan(input.country || input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;

  // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835

  // Is this national number even valid for this country
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  }

  // Is it fixed line number
  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    }

    // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.
    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)
    /* istanbul ignore if */
    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }
    return 'FIXED_LINE';
  }
  for (var _iterator = _createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  var typeDefinition = metadata.type(type);
  if (!typeDefinition || !typeDefinition.pattern()) {
    return false;
  }

  // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.
  if (typeDefinition.possibleLengths() && typeDefinition.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely_js__["a" /* default */])(nationalNumber, typeDefinition.pattern());
}
//# sourceMappingURL=getNumberType.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPossibleCountriesForNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");


/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadata);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadataJson) {
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
  metadata.selectNumberingPlan(country);
  return metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0;
}
//# sourceMappingURL=getPossibleCountriesForNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/isCallingCode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCallingCode;
var CALLING_CODE_REG_EXP = /^\d+$/;
function isCallingCode(string) {
  return CALLING_CODE_REG_EXP.test(string);
}
//# sourceMappingURL=isCallingCode.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/isCountryCode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCountryCode;
var COUNTRY_CODE_REG_EXP = /^[A-Z]{2}$/;
function isCountryCode(string) {
  return COUNTRY_CODE_REG_EXP.test(string);
}
//# sourceMappingURL=isCountryCode.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/isObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}
//# sourceMappingURL=isObject.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VALID_PHONE_NUMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VALID_PHONE_NUMBER_WITH_EXTENSION; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isViablePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = isViablePhoneNumberStart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extension_createExtensionPattern_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js");



//  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']{' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* MIN_LENGTH_FOR_NSN */] + '}';
//
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//
var VALID_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* PLUS_CHARS */] + ']{0,1}' + '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* VALID_PUNCTUATION */] + ']*' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']' + '){3,}' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']*';

// This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* PLUS_CHARS */] + ']{0,1}' + '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* VALID_PUNCTUATION */] + ']*' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER +
// Phone number extensions
'(?:' + Object(__WEBPACK_IMPORTED_MODULE_1__extension_createExtensionPattern_js__["a" /* default */])() + ')?';

// The combined regular expression for valid phone numbers:
//
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
// Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
// Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i');

// Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//
function isViablePhoneNumber(number) {
  return number.length >= __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* MIN_LENGTH_FOR_NSN */] && VALID_PHONE_NUMBER_PATTERN.test(number);
}

// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchesEntirely;
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regularExpressionText) {
  // If the assigning of the `''` default value is moved to the arguments above,
  // the code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regularExpressionText + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/mergeArrays.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeArrays;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function (a, b) {
    return a - b;
  });

  // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/parseDigits.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIGITS; });
/* harmony export (immutable) */ __webpack_exports__["c"] = parseDigit;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseDigits;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}

/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */
function parseDigits(string) {
  var result = '';
  // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.
  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);
    if (digit) {
      result += digit;
    }
  }
  return result;
}
//# sourceMappingURL=parseDigits.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stripIddPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + __WEBPACK_IMPORTED_MODULE_1__constants_js__["e" /* VALID_DIGITS */] + '])');
function stripIddPrefix(number, country, callingCode, metadataJson) {
  if (!country) {
    return;
  }

  // Get the IDD prefix pattern.
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
  metadata.selectNumberingPlan(country || callingCode);
  var IDDPrefixPattern = new RegExp(metadata.IDDPrefix());

  // Check if the number is IDD-prefixed.
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }

  // Strip IDD prefix.
  number = number.slice(number.match(IDDPrefixPattern)[0].length);

  // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }
  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/isPossible.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossiblePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPossibleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_checkNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js");



/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadataJson
 * @return {string}
 */
function isPossiblePhoneNumber(input, options, metadataJson) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }
    metadata.selectNumberingPlan(input.country || input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata.selectNumberingPlan(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }
      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  // Old (legacy) metadata (< 1.0.18) had no "possible length" data.
  // So `isPossibleNumber()` function is supported only for non-legacy metadata.
  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  }

  // There was a bug in versions from `1.7.35` to `1.7.37` of `libphonenumber-js`
  // where "possible_lengths" property was missing from "non-geographical" numbering plans' metadata.
  // After that, the bug was noticed and fixed.
  // So for versions from `1.7.35` to `1.7.37`, just assume that all "non=geotraphical" numbers are possible.
  // The reason is that the bug was noticed relatively quickly (within a day or so)
  // and it's unlikely that anyone generated their custom metadata in that short time span.
  // And if they didn't generate any custom metadata then a follow-up package update would've silently fixed the bug.
  if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
    return true;
  }

  // `isPossibleNumber()` function is not supported.
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}

/**
 * Tells if a given national (significant) number is possible
 * @param {string} nationalNumber
 * @param {Metadata} metadata = Metadata instance with a pre-selected telephone numbering plan.
 * @returns {boolean}
 */
function isPossibleNumber(nationalNumber, metadata) {
  switch (Object(__WEBPACK_IMPORTED_MODULE_1__helpers_checkNumberLength_js__["a" /* default */])(nationalNumber, undefined, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return false;
  }
}
//# sourceMappingURL=isPossible.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/isPossiblePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossiblePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function isPossiblePhoneNumber() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber_js__["a" /* default */])(text, options, metadata);
  return phoneNumber && phoneNumber.isPossible() || false;
}
//# sourceMappingURL=isPossiblePhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/isValid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_matchesEntirely_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getNumberType.js");




/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isValidNumber(input, options, metadataJson) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata_js__["a" /* default */](metadataJson);
  metadata.selectNumberingPlan(input.country || input.countryCallingCode);

  // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.
  if (metadata.hasTypes()) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_getNumberType_js__["a" /* default */])(input, options, metadata.metadata) !== undefined;
  }

  // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_matchesEntirely_js__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern());
}
//# sourceMappingURL=isValid.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/isValidPhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidPhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function isValidPhoneNumber() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber_js__["a" /* default */])(text, options, metadata);
  return phoneNumber && phoneNumber.isValid() || false;
}
//# sourceMappingURL=isValidPhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/PhoneNumberSearch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_isViablePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findNumbers_parsePreCandidate_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/parsePreCandidate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findNumbers_isValidPreCandidate_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/isValidPreCandidate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findNumbers_isValidCandidate_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/findNumbers/isValidCandidate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["g" /* WHITESPACE */] + ']+');
var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* VALID_PUNCTUATION */] + ']+$');

/**
 * Extracts a parseable phone number including any opening brackets, etc.
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
 */
var PhoneNumberSearch = /*#__PURE__*/function () {
  function PhoneNumberSearch(text, options, metadata) {
    _classCallCheck(this, PhoneNumberSearch);
    this.text = text;
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    this.options = options || {};
    this.metadata = metadata;

    // Iteration tristate.
    this.state = 'NOT_READY';
    this.regexp = new RegExp(__WEBPACK_IMPORTED_MODULE_1__helpers_isViablePhoneNumber_js__["a" /* VALID_PHONE_NUMBER_WITH_EXTENSION */], 'ig');
  }
  return _createClass(PhoneNumberSearch, [{
    key: "find",
    value: function find() {
      var matches = this.regexp.exec(this.text);
      if (!matches) {
        return;
      }
      var number = matches[0];
      var startsAt = matches.index;
      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
      startsAt += matches[0].length - number.length;
      // Fixes not parsing numbers with whitespace in the end.
      // Also fixes not parsing numbers with opening parentheses in the end.
      // https://github.com/catamphetamine/libphonenumber-js/issues/252
      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
      number = Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_parsePreCandidate_js__["a" /* default */])(number);
      var result = this.parseCandidate(number, startsAt);
      if (result) {
        return result;
      }

      // Tail recursion.
      // Try the next one if this one is not a valid phone number.
      return this.find();
    }
  }, {
    key: "parseCandidate",
    value: function parseCandidate(number, startsAt) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_isValidPreCandidate_js__["a" /* default */])(number, startsAt, this.text)) {
        return;
      }

      // Don't parse phone numbers which are non-phone numbers
      // due to being part of something else (e.g. a UUID).
      // https://github.com/catamphetamine/libphonenumber-js/issues/213
      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).
      if (!Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_isValidCandidate_js__["b" /* default */])(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
        return;
      }

      // // Prepend any opening brackets left behind by the
      // // `PHONE_NUMBER_START_PATTERN` regexp.
      // const text_before_number = text.slice(this.searching_from, startsAt)
      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
      // if (full_number_starts_at >= 0) {
      // 	number = text_before_number.slice(full_number_starts_at) + number
      // 	startsAt = full_number_starts_at
      // }
      //
      // this.searching_from = matches.lastIndex

      var result = Object(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(number, this.options, this.metadata);
      if (!result.phone) {
        return;
      }
      result.startsAt = startsAt;
      result.endsAt = startsAt + number.length;
      return result;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.last_match = this.find();
        if (this.last_match) {
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }
      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      }
      // Don't retain that memory any longer than necessary.
      var result = this.last_match;
      this.last_match = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);
}();

//# sourceMappingURL=PhoneNumberSearch.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/findNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumberMatcher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");


function findNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  var matcher = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher_js__["a" /* default */](text, options, metadata);
  var results = [];
  while (matcher.hasNext()) {
    results.push(matcher.next());
  }
  return results;
}
//# sourceMappingURL=findNumbers.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/findPhoneNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbers;
/* harmony export (immutable) */ __webpack_exports__["b"] = searchPhoneNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findPhoneNumbersInitialImplementation_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/findPhoneNumbersInitialImplementation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
// This is a legacy function.
// Use `findNumbers()` instead.



function findPhoneNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return Object(__WEBPACK_IMPORTED_MODULE_0__findPhoneNumbersInitialImplementation_js__["a" /* default */])(text, options, metadata);
}

/**
 * @return ES6 `for ... of` iterator.
 */
function searchPhoneNumbers() {
  var _normalizeArguments2 = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments2.text,
    options = _normalizeArguments2.options,
    metadata = _normalizeArguments2.metadata;
  return Object(__WEBPACK_IMPORTED_MODULE_0__findPhoneNumbersInitialImplementation_js__["b" /* searchPhoneNumbers */])(text, options, metadata);
}
//# sourceMappingURL=findPhoneNumbers.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/findPhoneNumbersInitialImplementation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EXTN_PATTERNS_FOR_PARSING */
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbers;
/* harmony export (immutable) */ __webpack_exports__["b"] = searchPhoneNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_extension_createExtensionPattern_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumberSearch_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/PhoneNumberSearch.js");
// This is a legacy function.
// Use `findNumbers()` instead.




/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */
var EXTN_PATTERNS_FOR_PARSING = Object(__WEBPACK_IMPORTED_MODULE_0__helpers_extension_createExtensionPattern_js__["a" /* default */])('parsing');

// // Regular expression for getting opening brackets for a valid number
// // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
// const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')

// const VALID_PRECEDING_CHARACTER_PATTERN = /[^a-zA-Z0-9]/

function findPhoneNumbers(text, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }
  var search = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberSearch_js__["a" /* default */](text, options, metadata);
  var phones = [];
  while (search.hasNext()) {
    phones.push(search.next());
  }
  return phones;
}

/**
 * @return ES6 `for ... of` iterator.
 */
function searchPhoneNumbers(text, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }
  var search = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberSearch_js__["a" /* default */](text, options, metadata);
  var iterator = function iterator() {
    return {
      next: function next() {
        if (search.hasNext()) {
          return {
            done: false,
            value: search.next()
          };
        }
        return {
          done: true
        };
      }
    };
  };

  // This line of code didn't really work with `babel`/`istanbul`:
  // for some weird reason, it showed code coverage less than 100%.
  // That's because `babel`/`istanbul`, for some weird reason,
  // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
  //
  // const iterable = { [Symbol.iterator]: iterator }

  var iterable = {};
  iterable[Symbol.iterator] = iterator;
  return iterable;
}
//# sourceMappingURL=findPhoneNumbersInitialImplementation.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/format.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/format.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_isObject_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isObject.js");



function formatNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
    input = _normalizeArguments.input,
    format = _normalizeArguments.format,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["b" /* default */])(input, format, options, metadata);
}

// Sort out arguments
function normalizeArguments(args) {
  // This line of code appeared to not work correctly with `babel`/`istanbul`:
  // for some weird reason, it caused coverage less than 100%.
  // That's because `babel`/`istanbul`, for some weird reason,
  // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
  //
  // const [arg_1, arg_2, arg_3, arg_4, arg_5] = Array.prototype.slice.call(args)

  var arg_1 = args[0];
  var arg_2 = args[1];
  var arg_3 = args[2];
  var arg_4 = args[3];
  var arg_5 = args[4];
  var input;
  var format;
  var options;
  var metadata;

  // Sort out arguments.

  // If the phone number is passed as a string.
  // `format('8005553535', ...)`.
  if (typeof arg_1 === 'string') {
    // If country code is supplied.
    // `format('8005553535', 'RU', 'NATIONAL', [options], metadata)`.
    if (typeof arg_3 === 'string') {
      format = arg_3;
      if (arg_5) {
        options = arg_4;
        metadata = arg_5;
      } else {
        metadata = arg_4;
      }
      input = Object(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(arg_1, {
        defaultCountry: arg_2,
        extended: true
      }, metadata);
    }
    // Just an international phone number is supplied
    // `format('+78005553535', 'NATIONAL', [options], metadata)`.
    else {
      if (typeof arg_2 !== 'string') {
        throw new Error('`format` argument not passed to `formatNumber(number, format)`');
      }
      format = arg_2;
      if (arg_4) {
        options = arg_3;
        metadata = arg_4;
      } else {
        metadata = arg_3;
      }
      input = Object(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(arg_1, {
        extended: true
      }, metadata);
    }
  }
  // If the phone number is passed as a parsed number object.
  // `format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', [options], metadata)`.
  else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_isObject_js__["a" /* default */])(arg_1)) {
    input = arg_1;
    format = arg_2;
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      metadata = arg_3;
    }
  } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');

  // Legacy lowercase formats.
  if (format === 'International') {
    format = 'INTERNATIONAL';
  } else if (format === 'National') {
    format = 'NATIONAL';
  }
  return {
    input: input,
    format: format,
    options: options,
    metadata: metadata
  };
}
//# sourceMappingURL=format.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/getNumberType.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNumberType;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_isViablePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getNumberType.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_isObject_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parse.js");





// Finds out national phone number type (fixed line, mobile, etc)
function getNumberType() {
  var _normalizeArguments = normalizeArguments(arguments),
    input = _normalizeArguments.input,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  // `parseNumber()` would return `{}` when no phone number could be parsed from the input.
  if (!input.phone) {
    return;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_getNumberType_js__["a" /* default */])(input, options, metadata);
}

// Sort out arguments
function normalizeArguments(args) {
  // This line of code appeared to not work correctly with `babel`/`istanbul`:
  // for some weird reason, it caused coverage less than 100%.
  // That's because `babel`/`istanbul`, for some weird reason,
  // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
  //
  // const [arg_1, arg_2, arg_3, arg_4] = Array.prototype.slice.call(args)

  var arg_1 = args[0];
  var arg_2 = args[1];
  var arg_3 = args[2];
  var arg_4 = args[3];
  var input;
  var options = {};
  var metadata;

  // If the phone number is passed as a string.
  // `getNumberType('88005553535', ...)`.
  if (typeof arg_1 === 'string') {
    // If "default country" argument is being passed
    // then convert it to an `options` object.
    // `getNumberType('88005553535', 'RU', metadata)`.
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers_isObject_js__["a" /* default */])(arg_2)) {
      if (arg_4) {
        options = arg_3;
        metadata = arg_4;
      } else {
        metadata = arg_3;
      }

      // `parse` extracts phone numbers from raw text,
      // therefore it will cut off all "garbage" characters,
      // while this `validate` function needs to verify
      // that the phone number contains no "garbage"
      // therefore the explicit `isViablePhoneNumber` check.
      if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_isViablePhoneNumber_js__["b" /* default */])(arg_1)) {
        input = Object(__WEBPACK_IMPORTED_MODULE_3__parse_js__["a" /* default */])(arg_1, {
          defaultCountry: arg_2
        }, metadata);
      } else {
        input = {};
      }
    }
    // No "resrict country" argument is being passed.
    // International phone number is passed.
    // `getNumberType('+78005553535', metadata)`.
    else {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }

      // `parse` extracts phone numbers from raw text,
      // therefore it will cut off all "garbage" characters,
      // while this `validate` function needs to verify
      // that the phone number contains no "garbage"
      // therefore the explicit `isViablePhoneNumber` check.
      if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_isViablePhoneNumber_js__["b" /* default */])(arg_1)) {
        input = Object(__WEBPACK_IMPORTED_MODULE_3__parse_js__["a" /* default */])(arg_1, undefined, metadata);
      } else {
        input = {};
      }
    }
  }
  // If the phone number is passed as a parsed phone number.
  // `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
  else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_isObject_js__["a" /* default */])(arg_1)) {
    input = arg_1;
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');
  return {
    input: input,
    options: options,
    metadata: metadata
  };
}
//# sourceMappingURL=getNumberType.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/isPossibleNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossibleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/getNumberType.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPossible_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isPossible.js");



/**
 * Checks if a given phone number is possible.
 * Which means it only checks phone number length
 * and doesn't test any regular expressions.
 *
 * Examples:
 *
 * ```js
 * isPossibleNumber('+78005553535', metadata)
 * isPossibleNumber('8005553535', 'RU', metadata)
 * isPossibleNumber('88005553535', 'RU', metadata)
 * isPossibleNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isPossibleNumber() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__getNumberType_js__["b" /* normalizeArguments */])(arguments),
    input = _normalizeArguments.input,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  // `parseNumber()` would return `{}` when no phone number could be parsed from the input.
  if (!input.phone && !(options && options.v2)) {
    return false;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isPossible_js__["a" /* default */])(input, options, metadata);
}
//# sourceMappingURL=isPossibleNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/isValidNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isValid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/getNumberType.js");



// Finds out national phone number type (fixed line, mobile, etc)
function isValidNumber() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__getNumberType_js__["b" /* normalizeArguments */])(arguments),
    input = _normalizeArguments.input,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  // `parseNumber()` would return `{}` when no phone number could be parsed from the input.
  if (!input.phone) {
    return false;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__isValid_js__["a" /* default */])(input, options, metadata);
}
//# sourceMappingURL=isValidNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/isValidNumberForRegion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumberForRegion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_isViablePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isValidNumberForRegion_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/isValidNumberForRegion_.js");




// This function has been deprecated and is not exported as
// `isValidPhoneNumberForCountry()` or `isValidPhoneNumberForRegion()`.
//
// The rationale is:
//
// * We don't use the "region" word, so "country" would be better.
//
// * It could be substituted with:
//
// ```js
// export default function isValidPhoneNumberForCountry(phoneNumberString, country) {
// 	const phoneNumber = parsePhoneNumber(phoneNumberString, {
// 		defaultCountry: country,
// 		// Demand that the entire input string must be a phone number.
// 		// Otherwise, it would "extract" a phone number from an input string.
// 		extract: false
// 	})
// 	if (!phoneNumber) {
// 		return false
// 	}
// 	if (phoneNumber.country !== country) {
// 		return false
// 	}
// 	return phoneNumber.isValid()
// }
// ```
//
// * Same function could be used for `isPossiblePhoneNumberForCountry()`
//   by replacing `isValid()` with `isPossible()`.
//
// * The reason why this function is not exported is because its result is ambiguous.
//   Suppose `false` is returned. It could mean any of:
//   * Not a phone number.
//   * The phone number is valid but belongs to another country or another calling code.
//   * The phone number belongs to the correct country but is not valid digit-wise.
//   All those three cases should be handled separately from a "User Experience" standpoint.
//   Simply showing "Invalid phone number" error in all of those cases would be lazy UX.

function isValidNumberForRegion(number, country, metadata) {
  if (typeof number !== 'string') {
    throw new TypeError('number must be a string');
  }
  if (typeof country !== 'string') {
    throw new TypeError('country must be a string');
  }
  // `parse` extracts phone numbers from raw text,
  // therefore it will cut off all "garbage" characters,
  // while this `validate` function needs to verify
  // that the phone number contains no "garbage"
  // therefore the explicit `isViablePhoneNumber` check.
  var input;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_isViablePhoneNumber_js__["b" /* default */])(number)) {
    input = Object(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(number, {
      defaultCountry: country
    }, metadata);
  } else {
    input = {};
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__isValidNumberForRegion_js__["a" /* default */])(input, country, undefined, metadata);
}
//# sourceMappingURL=isValidNumberForRegion.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/isValidNumberForRegion_.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumberForRegion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isValid.js");


/**
 * Checks if a given phone number is valid within a given region.
 * Is just an alias for `phoneNumber.isValid() && phoneNumber.country === country`.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 */
function isValidNumberForRegion(input, country, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  return input.country === country && Object(__WEBPACK_IMPORTED_MODULE_0__isValid_js__["a" /* default */])(input, options, metadata);
}
//# sourceMappingURL=isValidNumberForRegion_.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/parse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");


function parseNumber() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return Object(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/legacy/searchNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumberMatcher.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



/**
 * @return ES6 `for ... of` iterator.
 */
function searchNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  var matcher = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher_js__["a" /* default */](text, options, metadata);
  return _defineProperty({}, Symbol.iterator, function () {
    return {
      next: function next() {
        if (matcher.hasNext()) {
          return {
            done: false,
            value: matcher.next()
          };
        }
        return {
          done: true
        };
      }
    };
  });
}
//# sourceMappingURL=searchNumbers.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/metadata.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metadata; });
/* harmony export (immutable) */ __webpack_exports__["e"] = validateMetadata;
/* harmony export (immutable) */ __webpack_exports__["c"] = getExtPrefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCountryCallingCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSupportedCountry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_semver_compare_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/tools/semver-compare.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_isObject_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_isCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isCallingCode.js");
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




// Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".
var V2 = '1.0.18';

// Added "idd_prefix" and "default_idd_prefix".
var V3 = '1.2.0';

// Moved `001` country code to "nonGeographic" section of metadata.
var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';

/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */
var Metadata = /*#__PURE__*/function () {
  /**
   * @param {object} metadata — Metadata JSON.
   */
  function Metadata(metadata) {
    _classCallCheck(this, Metadata);
    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }
  return _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return;
      // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }

    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }

    /**
     * Selects a telephone numbering plan based on either a country code or a calling code.
     * @param {string} argument — Country code or calling code.
     * @param {string} legacyArgumentCallingCode — Legacy argument: calling code, if the first argument is not passed.
     */
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(argument, legacyArgumentCallingCode) {
      var countryCode;
      var callingCode;
      if (argument) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_isCallingCode_js__["a" /* default */])(argument)) {
          callingCode = argument;
        } else {
          countryCode = argument;
        }
      }
      // Previously, the signature of this method was: `.selectNumberingPlan(country, callingCode)`.
      // And if `country` argument wasn't passed, it looked into the second argument `callingCode`.
      // Now it's preferred to only pass either `country` or `callingCode` as the first argument.
      if (legacyArgumentCallingCode) {
        callingCode = legacyArgumentCallingCode;
      }

      // Select a telephone numbering plan.
      if (countryCode && countryCode !== '001') {
        var countryMetadata = this.getCountryMetadata(countryCode);
        if (!countryMetadata) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(countryMetadata, this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      // If a calling code is specified, choose the telephone numbering plan
      // of the "default" country for this calling code.
      // For example, if calling code `1` is passed,
      // the telephone numbering plan of `US` will be selected.
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];
        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    }

    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }

    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }

    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }

    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }

    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }

    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }

    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }

    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }

    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }

    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }

    // Deprecated.
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }

    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }

    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);
}();

var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck(this, NumberingPlan);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  return _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }

    // When multiple countries share the same calling code,
    // all phone number formatting rules are included in the metadata
    // of the "default" country for that calling code.
    // Any other countries' metdata doesn't include any formatting rules.
    // Google developers said that such storage architecture was chosen for performance reasons.
    //
    // For example, for NANPA region ("North American Numbering Plan Administration",
    // which includes USA, Canada, Cayman Islands, Bahamas, etc) all formatting rules
    // are contained in the metadata of `US` country.
    //
    // This is not public API.
    //
  }, {
    key: "_getDefaultCountryMetadataForThisCallingCode",
    value: function _getDefaultCountryMetadataForThisCallingCode() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }

    // Deprecated.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this._getDefaultCountryMetadataForThisCallingCode();
    }

    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }

    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }

    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    }

    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats = this._getFormats(this.metadata) || this._getFormats(this._getDefaultCountryMetadataForThisCallingCode()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    }

    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this._getDefaultCountryMetadataForThisCallingCode());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }

    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this._getDefaultCountryMetadataForThisCallingCode());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.
      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      }
      // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
}();
var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck(this, Format);
    this._format = format;
    this.metadata = metadata;
  }
  return _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }

    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() &&
      // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule())
      // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck(this, Type);
    this.type = type;
    this.metadata = metadata;
  }
  return _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
}();
function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];
    case 'MOBILE':
      return types[1];
    case 'TOLL_FREE':
      return types[2];
    case 'PREMIUM_RATE':
      return types[3];
    case 'PERSONAL_NUMBER':
      return types[4];
    case 'VOICEMAIL':
      return types[5];
    case 'UAN':
      return types[6];
    case 'PAGER':
      return types[7];
    case 'VOIP':
      return types[8];
    case 'SHARED_COST':
      return types[9];
  }
}
function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  }

  // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
  // For that reason, it's not used in this detection algorithm.
  // Instead, it detects by `countries: {}` property existence.
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers_isObject_js__["a" /* default */])(metadata) || !Object(__WEBPACK_IMPORTED_MODULE_1__helpers_isObject_js__["a" /* default */])(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_isObject_js__["a" /* default */])(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
}

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var typeOf = function typeOf(_) {
  return _typeof(_);
};

/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */
function getExtPrefix(country, metadataJson) {
  var metadata = new Metadata(metadataJson);
  if (metadata.hasCountry(country)) {
    return metadata.selectNumberingPlan(country).ext();
  }
  return DEFAULT_EXT_PREFIX;
}

/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadataJson
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */
function getCountryCallingCode(country, metadataJson) {
  var metadata = new Metadata(metadataJson);
  if (metadata.hasCountry(country)) {
    return metadata.selectNumberingPlan(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}

/**
 * Tells if a country code is supported.
 * @param  {string} country
 * @param  {object} metadataJson
 * @return {boolean}
 * @example
 * // Returns `true`
 * isSupportedCountry("GB")
 */
function isSupportedCountry(country, metadataJson) {
  // const metadata = new Metadata(metadataJson)
  // return metadata.hasCountry(country)
  return metadataJson.countries.hasOwnProperty(country);
}

/**
 * Sets `v1`/`v2`/`v3`/`v4` properties on `this` object.
 * @param {object} metadata — Metadata JSON
 */
function setVersion(metadata) {
  var version = metadata.version;
  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__tools_semver_compare_js__["a" /* default */])(version, V3) === -1) {
      this.v2 = true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__tools_semver_compare_js__["a" /* default */])(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
//# sourceMappingURL=metadata.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/normalizeArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_isObject_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isObject.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


// Extracts the following properties from function arguments:
// * input `text`
// * `options` object
// * `metadata` JSON
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
    _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
    arg_1 = _Array$prototype$slic2[0],
    arg_2 = _Array$prototype$slic2[1],
    arg_3 = _Array$prototype$slic2[2],
    arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata;

  // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.
  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.');

  // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }
    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  }
  // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_isObject_js__["a" /* default */])(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text: text,
    options: options,
    metadata: metadata
  };
}
//# sourceMappingURL=normalizeArguments.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/parse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParseError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/ParseError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_isViablePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_extension_extractExtension_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parseIncompletePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/getCountryCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isPossible_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/isPossible.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_matchesEntirely_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_extractCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_extractNationalNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_getCountryByCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_extractFormattedPhoneNumberFromPossibleRfc3966NumberUri_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js");
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js









// import { parseRFC3966 } from './helpers/RFC3966.js'




// import stripIddPrefix from './helpers/stripIddPrefix.js'



// We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.
var MAX_INPUT_STRING_LENGTH = 250;

// This consists of the plus symbol, digits, and arabic-indic digits.
var PHONE_NUMBER_START_PATTERN = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* PLUS_CHARS */] + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + ']');

// Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* VALID_DIGITS */] + '#' + ']+$');
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

// Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadataJson
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */
function parse(text, options, metadataJson) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  var metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata_js__["a" /* default */](metadataJson);

  // Validate `defaultCountry`.
  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('INVALID_COUNTRY');
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }

  // Parse the phone number.
  var _parseInput = parseInput(text, options.v2, options.extract),
    formattedPhoneNumber = _parseInput.number,
    ext = _parseInput.ext,
    error = _parseInput.error;

  // If the phone number is not viable then return nothing.
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('TOO_SHORT');
      }
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('NOT_A_NUMBER');
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode,
    // If `country` is returned, its numbering plan will also be selected in `metadata`.
    // Otherwise, if `countryCallingCode` is returned, its numbering plan will also be selected in `metadata`.
    // Otherwise, if neither `country` nor `countryCallingCode` are returned, no numbering plan will be selected in `metadata`.
    metadata),
    country = _parsePhoneNumber.country,
    nationalNumber = _parsePhoneNumber.nationalNumber,
    countryCallingCode = _parsePhoneNumber.countryCallingCode,
    countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
    carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('INVALID_COUNTRY');
    }
    return {};
  }

  // Validate national (significant) number length.
  if (!nationalNumber || nationalNumber.length < __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* MIN_LENGTH_FOR_NSN */]) {
    // Won't throw here because the regexp already demands length > 1.
    /* istanbul ignore if */
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('TOO_SHORT');
    }
    // Google's demo just throws an error in this case.
    return {};
  }

  // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //
  if (nationalNumber.length > __WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* MAX_LENGTH_FOR_NSN */]) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('TOO_LONG');
    }
    // Google's demo just throws an error in this case.
    return {};
  }
  if (options.v2) {
    var phoneNumber = new __WEBPACK_IMPORTED_MODULE_8__PhoneNumber_js__["a" /* default */](countryCallingCode, nationalNumber, metadata.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }

  // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? Object(__WEBPACK_IMPORTED_MODULE_9__helpers_matchesEntirely_js__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }

  // isInternational: countryCallingCode !== undefined

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && Object(__WEBPACK_IMPORTED_MODULE_7__isPossible_js__["b" /* isPossibleNumber */])(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}

/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]('TOO_LONG');
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  // Attempt to extract a possible number from the string passed in
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text
  // Trim everything to the left of the phone number
  .slice(startsAt)
  // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}

/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */
function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = Object(__WEBPACK_IMPORTED_MODULE_13__helpers_extractFormattedPhoneNumberFromPossibleRfc3966NumberUri_js__["a" /* default */])(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  });
  // If the phone number is not viable, then abort.
  if (!number) {
    return {};
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_isViablePhoneNumber_js__["b" /* default */])(number)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_3__helpers_isViablePhoneNumber_js__["c" /* isViablePhoneNumberStart */])(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }
    return {};
  }
  // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.
  var withExtensionStripped = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_extension_extractExtension_js__["a" /* default */])(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number
  };
}

/**
 * Creates `parse()` result object.
 */
function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };
  if (ext) {
    result.ext = ext;
  }
  return result;
}

/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata — Metadata instance with no pre-selected numbering plan. If `country` is returned, its numbering plan will also be selected in `metadata`. Otherwise, if `countryCallingCode` is returned, its numbering plan will also be selected in `metadata`. Otherwise, if neither `country` nor `countryCallingCode` are returned, no numbering plan will be selected in `metadata`.
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */
function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Attempt to extract a calling code from a phone number.
  // * If the phone number is found to be "international":
  //   * It will attempt to identify the calling code part of it and whether that part is complete and valid.
  //     * If the calling code part is complete and valid, it will return two properties:
  //       that calling code part (without `+`) and the rest of the digits.
  //     * Otherwise, i.e. if the calling code part is incomplete or invalid,
  //       it will return an empty object.
  // * Otherwise, i.e. if the phone number is national, there's no callind code to extract
  //   so it will just return the originally-passed `number` string as the only property.
  var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_10__helpers_extractCountryCallingCode_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__parseIncompletePhoneNumber_js__["a" /* default */])(formattedPhoneNumber), undefined,
    // `defaultCountry` and `defaultCallingCode` are only used to detect
    // if it's an "international" phone number or not. They won't be used
    // to derive the resulting `countryCallingCode` from them, or anything like that.
    defaultCountry, defaultCallingCode, metadata.metadata),
    countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
    countryCallingCode = _extractCountryCallin.countryCallingCode,
    number = _extractCountryCallin.number;

  // The exact country of the phone number
  var country;

  // If `formattedPhoneNumber` is passed in "international" format,
  // choose a country by `countryCallingCode`.
  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  }
  // Else, if `formattedPhoneNumber` is passed in "national" format,
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    if (defaultCountry) {
      country = defaultCountry;
      metadata.selectNumberingPlan(defaultCountry);
      countryCallingCode = metadata.numberingPlan.callingCode();
    } else {
      metadata.selectNumberingPlan(defaultCallingCode);
      countryCallingCode = defaultCallingCode;
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
          country = '001';
        }
      }
    }
  } else return {};

  // At this point, `country` could be `undefined` but `countryCallingCode` is always defined.
  //
  // Also, if `country` is defined, its numbering plan is selected in `metadata`.
  // Otherwise, the numering plan for the `countryCallingCode` is selected in `metadata`.

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }
  var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_extractNationalNumber_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__parseIncompletePhoneNumber_js__["a" /* default */])(number), undefined, metadata),
    nationalNumber = _extractNationalNumbe.nationalNumber,
    carrierCode = _extractNationalNumbe.carrierCode;

  // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //
  var exactCountry = Object(__WEBPACK_IMPORTED_MODULE_12__helpers_getCountryByCallingCode_js__["a" /* default */])(countryCallingCode, {
    nationalNumber: nationalNumber,
    metadata: metadata
  });
  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */
    if (exactCountry === '001') {
      // Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.selectNumberingPlan(country);
    }
  }
  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseIncompletePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = parsePhoneNumberCharacter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */
function parseIncompletePhoneNumber(string) {
  var result = '';
  // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.
  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }
  return result;
}

/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} eventListener - An optional "on event" function.
 * @return {string?} The parsed character.
 */
function parsePhoneNumberCharacter(character, prevParsedCharacters, eventListener) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      // `eventListener` argument was added to this `export`ed function on Dec 26th, 2023.
      // Any 3rd-party code that used to `import` and call this function before that
      // won't be passing any `eventListener` argument.
      //
      // The addition of the `eventListener` argument was to fix the slightly-weird behavior
      // of parsing an input string when the user inputs something like `"2+7"
      // https://github.com/catamphetamine/react-phone-number-input/issues/437
      //
      // If the parser encounters an unexpected `+` in a string being parsed
      // then it simply discards that out-of-place `+` and any following characters.
      //
      if (typeof eventListener === 'function') {
        eventListener('end');
      }
      return;
    }
    return '+';
  }
  // Allow digits.
  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits_js__["c" /* parseDigit */])(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/parsePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js");


function parsePhoneNumber() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber_js__["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberWithError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumberWithError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");


function parsePhoneNumberWithError() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumberWithError_js__["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumberWithError.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberWithError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parse.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function parsePhoneNumberWithError(text, options, metadata) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__parse_js__["a" /* default */])(text, _objectSpread(_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumberWithError_.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumberWithError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParseError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/ParseError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



function parsePhoneNumber(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !Object(__WEBPACK_IMPORTED_MODULE_2__metadata_js__["d" /* isSupportedCountry */])(options.defaultCountry, metadata)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      defaultCountry: undefined
    });
  }
  // Parse phone number.
  try {
    return Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumberWithError_js__["a" /* default */])(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof __WEBPACK_IMPORTED_MODULE_1__ParseError_js__["a" /* default */]) {
      //
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumber_.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/searchPhoneNumbersInText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchPhoneNumbersInText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/PhoneNumberMatcher.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function searchPhoneNumbersInText() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  var matcher = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher_js__["a" /* default */](text, _objectSpread(_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
  return _defineProperty({}, Symbol.iterator, function () {
    return {
      next: function next() {
        if (matcher.hasNext()) {
          return {
            done: false,
            value: matcher.next()
          };
        }
        return {
          done: true
        };
      }
    };
  });
}
//# sourceMappingURL=searchPhoneNumbersInText.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/tools/semver-compare.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
});
//# sourceMappingURL=semver-compare.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/es6/validatePhoneNumberLength.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validatePhoneNumberLength;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/normalizeArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumberWithError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParseError_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/ParseError.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/metadata.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_checkNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





function validatePhoneNumberLength() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__normalizeArguments_js__["a" /* default */])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });

  // Parse phone number.
  try {
    var phoneNumber = Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumberWithError_js__["a" /* default */])(text, options, metadata);
    var metadataInstance = new __WEBPACK_IMPORTED_MODULE_3__metadata_js__["a" /* default */](metadata);
    metadataInstance.selectNumberingPlan(phoneNumber.country || phoneNumber.countryCallingCode);
    var result = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_checkNumberLength_js__["a" /* default */])(phoneNumber.nationalNumber, undefined, metadataInstance);
    if (result !== 'IS_POSSIBLE') {
      return result;
    }
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof __WEBPACK_IMPORTED_MODULE_2__ParseError_js__["a" /* default */]) {
      return error.message;
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=validatePhoneNumberLength.js.map

/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/PhoneNumberSearch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumberSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__ = __webpack_require__("./node_modules/libphonenumber-js/metadata.min.json.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_PhoneNumberSearch_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/PhoneNumberSearch.js");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.




function PhoneNumberSearch(text, options) {
	__WEBPACK_IMPORTED_MODULE_1__es6_legacy_PhoneNumberSearch_js__["a" /* default */].call(this, text, options, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__["a" /* default */])
}

// Deprecated.
PhoneNumberSearch.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_PhoneNumberSearch_js__["a" /* default */].prototype, {})
PhoneNumberSearch.prototype.constructor = PhoneNumberSearch


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/findPhoneNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_findPhoneNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/findPhoneNumbers.js");




function findPhoneNumbers() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_findPhoneNumbers_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/format.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_format_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/format.js");




function format() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_format_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/getNumberType.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNumberType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/getNumberType.js");




function getNumberType() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_getNumberType_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/isPossibleNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossibleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_isPossibleNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/isPossibleNumber.js");
// Deprecated.





function isPossibleNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_isPossibleNumber_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/isValidNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_isValidNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/isValidNumber.js");
// Deprecated.





function isValidNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_isValidNumber_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/isValidNumberForRegion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumberForRegion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_isValidNumberForRegion_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/isValidNumberForRegion.js");




function isValidNumberForRegion() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_isValidNumberForRegion_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/parse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/parse.js");




function parse() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_parse_js__["a" /* default */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.es6.exports/searchPhoneNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchPhoneNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_legacy_findPhoneNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/findPhoneNumbers.js");




function searchPhoneNumbers() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__min_exports_withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__es6_legacy_findPhoneNumbers_js__["b" /* searchPhoneNumbers */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min_exports_parsePhoneNumberWithError_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/parsePhoneNumberWithError.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumberWithError", function() { return __WEBPACK_IMPORTED_MODULE_0__min_exports_parsePhoneNumberWithError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_0__min_exports_parsePhoneNumberWithError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__min_exports_parsePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumberFromString", function() { return __WEBPACK_IMPORTED_MODULE_1__min_exports_parsePhoneNumber_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_1__min_exports_parsePhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__min_exports_isValidPhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/isValidPhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidPhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_2__min_exports_isValidPhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__min_exports_isPossiblePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/isPossiblePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isPossiblePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_3__min_exports_isPossiblePhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__min_exports_validatePhoneNumberLength_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/validatePhoneNumberLength.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "validatePhoneNumberLength", function() { return __WEBPACK_IMPORTED_MODULE_4__min_exports_validatePhoneNumberLength_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__min_exports_findNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/findNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findNumbers", function() { return __WEBPACK_IMPORTED_MODULE_5__min_exports_findNumbers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__min_exports_searchNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/searchNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchNumbers", function() { return __WEBPACK_IMPORTED_MODULE_6__min_exports_searchNumbers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__min_exports_findPhoneNumbersInText_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/findPhoneNumbersInText.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findPhoneNumbersInText", function() { return __WEBPACK_IMPORTED_MODULE_7__min_exports_findPhoneNumbersInText_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__min_exports_searchPhoneNumbersInText_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/searchPhoneNumbersInText.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchPhoneNumbersInText", function() { return __WEBPACK_IMPORTED_MODULE_8__min_exports_searchPhoneNumbersInText_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__min_exports_PhoneNumberMatcher_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/PhoneNumberMatcher.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneNumberMatcher", function() { return __WEBPACK_IMPORTED_MODULE_9__min_exports_PhoneNumberMatcher_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__min_exports_AsYouType_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/AsYouType.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AsYouType", function() { return __WEBPACK_IMPORTED_MODULE_10__min_exports_AsYouType_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__es6_AsYouTypeFormatter_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouTypeFormatter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DIGIT_PLACEHOLDER", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_AsYouTypeFormatter_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__min_exports_isSupportedCountry_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/isSupportedCountry.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSupportedCountry", function() { return __WEBPACK_IMPORTED_MODULE_12__min_exports_isSupportedCountry_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__min_exports_getCountries_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/getCountries.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCountries", function() { return __WEBPACK_IMPORTED_MODULE_13__min_exports_getCountries_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__min_exports_getCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/getCountryCallingCode.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCountryCallingCode", function() { return __WEBPACK_IMPORTED_MODULE_14__min_exports_getCountryCallingCode_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPhoneCode", function() { return __WEBPACK_IMPORTED_MODULE_14__min_exports_getCountryCallingCode_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min_exports_getExtPrefix_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/getExtPrefix.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getExtPrefix", function() { return __WEBPACK_IMPORTED_MODULE_15__min_exports_getExtPrefix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__min_exports_Metadata_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/Metadata.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Metadata", function() { return __WEBPACK_IMPORTED_MODULE_16__min_exports_Metadata_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__min_exports_getExampleNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/getExampleNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getExampleNumber", function() { return __WEBPACK_IMPORTED_MODULE_17__min_exports_getExampleNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__min_exports_formatIncompletePhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/formatIncompletePhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatIncompletePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_18__min_exports_formatIncompletePhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__min_exports_PhoneNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/PhoneNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_19__min_exports_PhoneNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParseError", function() { return __WEBPACK_IMPORTED_MODULE_20__core_index_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseIncompletePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_20__core_index_js__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumberCharacter", function() { return __WEBPACK_IMPORTED_MODULE_20__core_index_js__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseDigits", function() { return __WEBPACK_IMPORTED_MODULE_20__core_index_js__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseRFC3966", function() { return __WEBPACK_IMPORTED_MODULE_20__core_index_js__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatRFC3966", function() { return __WEBPACK_IMPORTED_MODULE_20__core_index_js__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_es6_exports_parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/parse.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseNumber", function() { return __WEBPACK_IMPORTED_MODULE_21__index_es6_exports_parse_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_21__index_es6_exports_parse_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__index_es6_exports_format_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/format.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatNumber", function() { return __WEBPACK_IMPORTED_MODULE_22__index_es6_exports_format_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_22__index_es6_exports_format_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__index_es6_exports_getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/getNumberType.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getNumberType", function() { return __WEBPACK_IMPORTED_MODULE_23__index_es6_exports_getNumberType_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__index_es6_exports_isPossibleNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/isPossibleNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isPossibleNumber", function() { return __WEBPACK_IMPORTED_MODULE_24__index_es6_exports_isPossibleNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__index_es6_exports_isValidNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/isValidNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidNumber", function() { return __WEBPACK_IMPORTED_MODULE_25__index_es6_exports_isValidNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_es6_exports_isValidNumberForRegion_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/isValidNumberForRegion.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidNumberForRegion", function() { return __WEBPACK_IMPORTED_MODULE_26__index_es6_exports_isValidNumberForRegion_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_es6_exports_findPhoneNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/findPhoneNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findPhoneNumbers", function() { return __WEBPACK_IMPORTED_MODULE_27__index_es6_exports_findPhoneNumbers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__index_es6_exports_searchPhoneNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/searchPhoneNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchPhoneNumbers", function() { return __WEBPACK_IMPORTED_MODULE_28__index_es6_exports_searchPhoneNumbers_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_es6_exports_PhoneNumberSearch_js__ = __webpack_require__("./node_modules/libphonenumber-js/index.es6.exports/PhoneNumberSearch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneNumberSearch", function() { return __WEBPACK_IMPORTED_MODULE_29__index_es6_exports_PhoneNumberSearch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__es6_helpers_parseDigits_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/helpers/parseDigits.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DIGITS", function() { return __WEBPACK_IMPORTED_MODULE_30__es6_helpers_parseDigits_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__es6_legacy_parse_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/parse.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseCustom", function() { return __WEBPACK_IMPORTED_MODULE_31__es6_legacy_parse_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__es6_legacy_format_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/format.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatCustom", function() { return __WEBPACK_IMPORTED_MODULE_32__es6_legacy_format_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__es6_legacy_isValidNumber_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/isValidNumber.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidNumberCustom", function() { return __WEBPACK_IMPORTED_MODULE_33__es6_legacy_isValidNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__es6_legacy_findPhoneNumbers_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/findPhoneNumbers.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findPhoneNumbersCustom", function() { return __WEBPACK_IMPORTED_MODULE_34__es6_legacy_findPhoneNumbers_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchPhoneNumbersCustom", function() { return __WEBPACK_IMPORTED_MODULE_34__es6_legacy_findPhoneNumbers_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__es6_legacy_PhoneNumberSearch_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/PhoneNumberSearch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneNumberSearchCustom", function() { return __WEBPACK_IMPORTED_MODULE_35__es6_legacy_PhoneNumberSearch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__es6_legacy_getNumberType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/legacy/getNumberType.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getNumberTypeCustom", function() { return __WEBPACK_IMPORTED_MODULE_36__es6_legacy_getNumberType_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__es6_getCountryCallingCode_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/getCountryCallingCode.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCountryCallingCodeCustom", function() { return __WEBPACK_IMPORTED_MODULE_37__es6_getCountryCallingCode_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPhoneCodeCustom", function() { return __WEBPACK_IMPORTED_MODULE_37__es6_getCountryCallingCode_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__es6_AsYouType_js__ = __webpack_require__("./node_modules/libphonenumber-js/es6/AsYouType.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AsYouTypeCustom", function() { return __WEBPACK_IMPORTED_MODULE_38__es6_AsYouType_js__["a"]; });
// `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`.

// `parsePhoneNumberFromString()` named export is now considered legacy:
// it has been promoted to a default export due to being too verbose.






// Deprecated.









// Deprecated:
// `DIGIT_PLACEHOLDER` is the character that `AsYouType` formatter uses in a phone number template.
// It's basically an "x" character. I guess, there's no point in exporting it as a constant
// because the established convention is that it's an "x" character so everyone just assumes "x".




// `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.











// Deprecated (old) exports.










// Deprecated DIGITS export.
// (it was used in `react-phone-number-input`)


// Deprecated "custom" exports.











/***/ }),

/***/ "./node_modules/libphonenumber-js/metadata.min.json.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ __webpack_exports__["a"] = ({"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[2-467])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]","(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}",[9]],["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|2[23]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[024-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[024-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:01\\d|8)\\d{7}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["0"]]]],"BL":["590","00","7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["(?:59(?:0(?:2[7-9]|3[3-7]|5[12]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],["8[129]\\d{7}"],0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-7]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]|50"]],["(\\d{8})","$1",["[5-7]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37|86)","300|4(?:0(?:0|20)|370|864)"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[178]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-6]|7[246]|8[2-4]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|[78]"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","[2-9]\\d{9}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|5[07]|[67]3)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|3[23]|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["5"],"0$1"]],"0"],"CF":["236","00","8776\\d{4}|(?:[27]\\d|61)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-8]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["60|809"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9(?:10|[2-9])"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]","(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["46"]],["(\\d{3})(\\d{7})","$1 $2",["6|90"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|9[14]"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9,10,11,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|3[13])"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,0,[["528[89]\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|3[01]|5[0-5]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","(?:400|[5-9]\\d\\d)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[4-9]"]]]],"ET":["251","00","(?:11|[2-57-9]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,"0|180020",0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:694\\d|7093)\\d{5}|(?:59|[89]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]|80[6-9]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0|180020","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","[235]\\d{8}|800\\d{5,6}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2358]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[48]\\d{8}|[2-9]\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|4(?:[0-35]|4[16-9])"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[48]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]|80[6-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["(?:59(?:0(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)|87\\d)|80[6-9]\\d\\d)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],["8[129]\\d{7}"],0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",[7,8,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-589]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13,14,15,16,17],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1(?:05|[2-9]))","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0|180020","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-6]|80[2-46]","11|2[02]|33|4[04]|79[1-6]|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31)|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:3171|5[15][2-6]|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|8(?:16|2[014]|3[126]|6[136]|7[78]|83)(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|3[129]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7(?:[23569]|8[0-57-9])|8[1-6])|7(?:1(?:[013-8]|9[6-9])|3(?:17|2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578])\\d|7(?:[23569]\\d|8[0-57-9])|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|3(?:2[0-49]|9[2-57])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["16|[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["18[06]","18[06]0"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11,12],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[03]"]]],0,0,0,0,0,0,[["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],["3[2-8]\\d{9,10}",[11,12]],0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0|180020","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[47]"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]","3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[25-9]"],"0$1"]],"0",0,"(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[36]0|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","8\\d{13}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["3"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(0-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"0 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(0-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(0-$1)",1]],"0",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["20"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|78|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2679]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{4})(\\d{5})","$1-$2",["892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8(?:0[0-7]|9)"],"0$1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[5-8]"],"0$1"]],"0",0,0,0,0,"[5-8]"],"MC":["377","00","(?:[3489]|[67]\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[67]"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","7090\\d{5}|(?:[56]9|[89]\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["(?:59(?:0(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)|87\\d)|80[6-9]\\d\\d)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],["8[129]\\d{7}"],0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|452|678|86","[12]|452|6788|86"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["11|2[16]"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","7091\\d{5}|(?:[56]9|[89]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]|8(?:0[6-9]|[36])"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-37-9]"],"0$1"]],"0"],"MX":["52","0[09]","[2-9]\\d{9}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],0,0,0,0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[0467]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:20|9\\d)\\d{8}|[78]\\d{9,13}",[10,11,12,13,14],[["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[24-9]"]]]],"NU":["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85[02-46-9]"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","30|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[78]\\d{8}|[2-9]\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","[36-8]\\d{5,8}|4\\d{6,8}|59\\d{6}|9\\d{5,10}|(?:2\\d|5[0-8])\\d{6,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["3[289]|4[246-8]|61|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[136]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","709\\d{6}|(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"],"0$1"]],"0",0,0,0,0,0,[["2631[0-6]\\d{4}|26(?:2\\d|30|88)\\d{5}"],["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"[3489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","(?:[15]\\d|800|92)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","[6-9]\\d{6}|[1-6]\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["6[89]|7|8[4-9]|9(?:[0-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","(?:[2489]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10,12],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[013]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|9[2-9]"]],["(\\d)(\\d{7})","$1 $2",["[267]|904"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[346-9]"]]],"0"],"SR":["597","00","(?:[2-5]|[6-9]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-9]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[25-7]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-359]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-4]|5[1-3]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[59]"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[3689]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[236-9]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:[0-57-9]\\d|66)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3(?:[1245]|3[12])"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["\\d"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["[67]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["826"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["83"],"0$1"],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["82"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[25]0|37|49|8[09]"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-478])|7[1-9]","[23568]|4(?:0[2-48]|[1-478])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024","20240"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["20[0-35-7]|4(?:6[45]|[7-9])|[7-9]","20(?:[0135-7]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[2-4]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["983[2-57-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[02589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|3[23]|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",[4,5,6,7,8,9,10,11,12,13],[["(\\d{4,5})","$1",["21"]],["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","00","(?:20|33|[5-9]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"]]]],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11,12],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{6,7}|7\\d{6}",[7,8,9,10],[["(\\d{4})(\\d{4,6})","$1 $2",["1(?:2[02]|[89])"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[26]|6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[47-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",[8,9,10,11,12],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2|39"],"0$1"],["(\\d{2})(\\d{7,10})","$1 $2",["3"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","(?:639\\d|7093)\\d{5}|(?:26|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["26(?:89\\d|9(?:0[0-467]|15|5[0-4]|6\\d|[78]0))\\d{4}"],["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|[579]\\d|63)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[579]"],"0$1"]],"0"],"ZW":["263","00","(?:13|8\\d{4})\\d{5}|[235-8]\\d{8}|[23568]\\d{6}",[7,9,10],[["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|29|58)|67[0-46-9]|(?:55|68)[0-69]"],"0$1"],["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|[27]|48)|37|675|(?:55|68)[78]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["548"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[256]|39|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["3"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[235-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"],0,0,0,0,0,0,["2\\d{8}",[9]]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|5[12]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|5(?:0\\d{3}|2[0-2]))\\d{7}",[7,8,9,10,12]],0,0,0,["348[57]\\d{7}",[11]],0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/AsYouType.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AsYouType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__ = __webpack_require__("./node_modules/libphonenumber-js/metadata.min.json.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.




function AsYouType(country) {
	return __WEBPACK_IMPORTED_MODULE_1__core_index_js__["a" /* AsYouType */].call(this, country, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__["a" /* default */])
}

AsYouType.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["a" /* AsYouType */].prototype, {})
AsYouType.prototype.constructor = AsYouType

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/Metadata.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Metadata;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__ = __webpack_require__("./node_modules/libphonenumber-js/metadata.min.json.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.




function Metadata() {
	return __WEBPACK_IMPORTED_MODULE_1__core_index_js__["b" /* Metadata */].call(this, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__["a" /* default */])
}

Metadata.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["b" /* Metadata */].prototype, {})
Metadata.prototype.constructor = Metadata

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/PhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__ = __webpack_require__("./node_modules/libphonenumber-js/metadata.min.json.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.




function PhoneNumber(number) {
	return __WEBPACK_IMPORTED_MODULE_1__core_index_js__["d" /* PhoneNumber */].call(this, number, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__["a" /* default */])
}
// Setting `PhoneNumber.prototype` via `Object.create()`
// didn't work with `instanceof` operator for some strange reason.
// https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/201
// Because of that issue, the `Object.create()` call had to be removed.
// It didn't result in any drawbacks because the `{}` argument of that call
// means that the `PhoneNumber` class created here adds 0 new properties
// to the existing `PhoneNumber` class it attempts to extend here.
// Hence, the `Object.create()` call can be omitted
// and the `prototype` can just be copied over as is.
// PhoneNumber.prototype = Object.create(_PhoneNumber.prototype, {})
PhoneNumber.prototype = __WEBPACK_IMPORTED_MODULE_1__core_index_js__["d" /* PhoneNumber */].prototype
PhoneNumber.prototype.constructor = PhoneNumber


/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/PhoneNumberMatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumberMatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__ = __webpack_require__("./node_modules/libphonenumber-js/metadata.min.json.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.




function PhoneNumberMatcher(text, options) {
	return __WEBPACK_IMPORTED_MODULE_1__core_index_js__["e" /* PhoneNumberMatcher */].call(this, text, options, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__["a" /* default */])
}
PhoneNumberMatcher.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["e" /* PhoneNumberMatcher */].prototype, {})
PhoneNumberMatcher.prototype.constructor = PhoneNumberMatcher


/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/findNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function findNumbers() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["g" /* findNumbers */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/findPhoneNumbersInText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbersInText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function findPhoneNumbersInText() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["h" /* findPhoneNumbersInText */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/formatIncompletePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatIncompletePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function formatIncompletePhoneNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["i" /* formatIncompletePhoneNumber */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/getCountries.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function getCountries() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["k" /* getCountries */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/getCountryCallingCode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountryCallingCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function getCountryCallingCode() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["l" /* getCountryCallingCode */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/getExampleNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExampleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function getExampleNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["m" /* getExampleNumber */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/getExtPrefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function getExtPrefix() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["n" /* getExtPrefix */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/isPossiblePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossiblePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function isPossiblePhoneNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["o" /* isPossiblePhoneNumber */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/isSupportedCountry.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSupportedCountry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function isSupportedCountry() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["p" /* isSupportedCountry */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/isValidPhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidPhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function isValidPhoneNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["q" /* isValidPhoneNumber */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function parsePhoneNumber() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["f" /* default */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/parsePhoneNumberWithError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberWithError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function parsePhoneNumberWithError() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["u" /* parsePhoneNumberWithError */], arguments)
}


/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/searchNumbers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function searchNumbers() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["w" /* searchNumbers */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/searchPhoneNumbersInText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchPhoneNumbersInText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function searchPhoneNumbersInText() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["x" /* searchPhoneNumbersInText */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/validatePhoneNumberLength.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validatePhoneNumberLength;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__ = __webpack_require__("./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index_js__ = __webpack_require__("./node_modules/libphonenumber-js/core/index.js");



function validatePhoneNumberLength() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__withMetadataArgument_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_index_js__["y" /* validatePhoneNumberLength */], arguments)
}

/***/ }),

/***/ "./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withMetadataArgument;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__ = __webpack_require__("./node_modules/libphonenumber-js/metadata.min.json.js");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.


function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json_js__["a" /* default */])
	return func.apply(this, args)
}

/***/ }),

/***/ "./node_modules/lodash-es/_Symbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),

/***/ "./node_modules/lodash-es/_baseGetTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__("./node_modules/lodash-es/_getRawTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__("./node_modules/lodash-es/_objectToString.js");




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),

/***/ "./node_modules/lodash-es/_freeGlobal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash-es/_getPrototype.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("./node_modules/lodash-es/_overArg.js");


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),

/***/ "./node_modules/lodash-es/_getRawTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),

/***/ "./node_modules/lodash-es/_objectToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),

/***/ "./node_modules/lodash-es/_overArg.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),

/***/ "./node_modules/lodash-es/_root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("./node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "./node_modules/lodash-es/isObjectLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),

/***/ "./node_modules/lodash-es/isPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__("./node_modules/lodash-es/_getPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),

/***/ "./node_modules/lodash._basefor/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * Creates a base function for methods like `_.forIn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash.isarguments/index.js":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash.isarray/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash.isfunction/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash.isobject/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash.isplainobject/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__("./node_modules/lodash._basefor/index.js"),
    isArguments = __webpack_require__("./node_modules/lodash.isarguments/index.js"),
    keysIn = __webpack_require__("./node_modules/lodash.keysin/index.js");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty.call(value, result);
}

module.exports = isPlainObject;


/***/ }),

/***/ "./node_modules/lodash.keysin/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__("./node_modules/lodash.isarguments/index.js"),
    isArray = __webpack_require__("./node_modules/lodash.isarray/index.js");

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),

/***/ "./node_modules/lodash.tonumber/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]';

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseTrim.js":
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__("./node_modules/lodash/_trimmedEndIndex.js");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_trimmedEndIndex.js":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "./node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    now = __webpack_require__("./node_modules/lodash/now.js"),
    toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__("./node_modules/lodash/_baseTrim.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "./node_modules/math-intrinsics/abs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ "./node_modules/math-intrinsics/floor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ "./node_modules/math-intrinsics/isNaN.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ "./node_modules/math-intrinsics/max.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ "./node_modules/math-intrinsics/min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ "./node_modules/math-intrinsics/pow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ "./node_modules/math-intrinsics/round.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ "./node_modules/math-intrinsics/sign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__("./node_modules/math-intrinsics/isNaN.js");

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ "./node_modules/moment/locale recursive ^\\.\\/.*$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./am-et": "./node_modules/moment/locale/am-et.js",
	"./am-et.js": "./node_modules/moment/locale/am-et.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ps": "./node_modules/moment/locale/ar-ps.js",
	"./ar-ps.js": "./node_modules/moment/locale/ar-ps.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn-bd": "./node_modules/moment/locale/bn-bd.js",
	"./bn-bd.js": "./node_modules/moment/locale/bn-bd.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-in": "./node_modules/moment/locale/en-in.js",
	"./en-in.js": "./node_modules/moment/locale/en-in.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./en-sg": "./node_modules/moment/locale/en-sg.js",
	"./en-sg.js": "./node_modules/moment/locale/en-sg.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-mx": "./node_modules/moment/locale/es-mx.js",
	"./es-mx.js": "./node_modules/moment/locale/es-mx.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fil": "./node_modules/moment/locale/fil.js",
	"./fil.js": "./node_modules/moment/locale/fil.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-deva": "./node_modules/moment/locale/gom-deva.js",
	"./gom-deva.js": "./node_modules/moment/locale/gom-deva.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku-kmr": "./node_modules/moment/locale/ku-kmr.js",
	"./ku-kmr.js": "./node_modules/moment/locale/ku-kmr.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./oc-lnc": "./node_modules/moment/locale/oc-lnc.js",
	"./oc-lnc.js": "./node_modules/moment/locale/oc-lnc.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./ps": "./node_modules/moment/locale/ps.js",
	"./ps.js": "./node_modules/moment/locale/ps.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tk": "./node_modules/moment/locale/tk.js",
	"./tk.js": "./node_modules/moment/locale/tk.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-mo": "./node_modules/moment/locale/zh-mo.js",
	"./zh-mo.js": "./node_modules/moment/locale/zh-mo.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/moment/locale/af.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ "./node_modules/moment/locale/am-et.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Amharic (Ethiopia) [am-et]
//! author : Tekle Ayele : https://github.com/tekleayele

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var amEt = moment.defineLocale('am-et', {
        months: 'ጃንዩወሪ_ፌብሩወሪ_ማርች_ኤፕሪል_ሜይ_ጁን_ጁላይ_ኦገስት_ሴፕቴምበር_ኦክቶበር_ኖቬምበር_ዲሴምበር'.split(
            '_'
        ),
        monthsShort: 'ጃን_ፌብ_ማር_ኤፕር_ሜይ_ጁን_ጁላይ_ኦገ_ሴፕ_ኦክቶ_ኖቬ_ዲሴ'.split('_'),
        weekdays: 'እሑድ_ሰኞ_ማክሰኞ_እሮብ_ሀሙስ_ዓርብ_ቅዳሜ'.split('_'),
        weekdaysShort: 'እሑ_ሰኞ_ማክ_እሮ_ሀሙ_ዓር_ቅዳ'.split('_'),
        weekdaysMin: 'እሁ_ሰ_ማ_እ_ሀ_ዓ_ቅ'.split('_'),
        meridiemParse: /ጥዋት|ከሰዓት/,
        isPM: function (input) {
            return input === 'ከሰዓት';
        },
        meridiem: function (hours) {
            return hours < 12 ? 'ጥዋት' : 'ከሰዓት';
        },
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[ዛሬ በ] LT',
            nextDay: '[ነገ በ] LT',
            nextWeek: 'dddd [በ] LT',
            lastDay: '[ትናንትና በ] LT',
            lastWeek: '[ያለፈው ሳምንት] dddd [በ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ውስጥ',
            past: '%s በፊት',
            s: 'ጥቂት ሰከንዶች',
            ss: '%d ሰከንዶች',
            m: 'አንድ ደቂቃ',
            mm: '%d ደቂቃዎች',
            h: 'አንድ ሰአት',
            hh: '%d ሰአታት',
            d: 'አንድ ቀን',
            dd: '%d ቀናት',
            M: 'አንድ ወር',
            MM: '%d ወራት',
            y: 'አንድ ዓመት',
            yy: '%d ዓመታት',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ኛ)/,
        ordinal: function (number) {
            return number + 'ኛ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return amEt;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-dz.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-kw.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-ly.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-ma.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-ps.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arPs;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-sa.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar-tn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ar.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ "./node_modules/moment/locale/az.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ "./node_modules/moment/locale/be.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ "./node_modules/moment/locale/bg.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ "./node_modules/moment/locale/bm.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration
    // Language contact person : Abdoufata Kane : https://github.com/abdoufata


    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ "./node_modules/moment/locale/bn-bd.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ "./node_modules/moment/locale/bn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/bo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/br.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ "./node_modules/moment/locale/bs.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ca.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: 'de gener_de febrer_de març_d’abril_de maig_de juny_de juliol_d’agost_de setembre_d’octubre_de novembre_de desembre'.split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ "./node_modules/moment/locale/cs.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ "./node_modules/moment/locale/cv.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ "./node_modules/moment/locale/cy.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ "./node_modules/moment/locale/da.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ "./node_modules/moment/locale/de-at.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsParse = [
            /^jän/i,
            /^feb/i,
            /^mär/i,
            /^apr/i,
            /^mai/i,
            /^jun/i,
            /^jul/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dez/i,
        ],
        monthsRegex =
            /^(Jänner|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|Jän\.?|Feb\.?|Mär\.?|Apr\.?|Jun\.?|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i;

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(Jänner|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember)/i,
        monthsShortStrictRegex:
            /^(Jän\.?|Feb\.?|März|Mär\.?|Apr\.?|Mai|Juni|Jun\.?|Juli|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ "./node_modules/moment/locale/de-ch.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsParse = [
            /^jan/i,
            /^feb/i,
            /^mär/i,
            /^apr/i,
            /^mai/i,
            /^jun/i,
            /^jul/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dez/i,
        ],
        monthsRegex =
            /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|Jan\.?|Feb\.?|Mär\.?|Apr\.?|Jun\.?|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i;

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember)/i,
        monthsShortStrictRegex:
            /^(Jan\.?|Feb\.?|März|Mär\.?|Apr\.?|Mai|Juni|Jun\.?|Juli|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ "./node_modules/moment/locale/de.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsParse = [
            /^jan/i,
            /^feb/i,
            /^mär/i,
            /^apr/i,
            /^mai/i,
            /^jun/i,
            /^jul/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dez/i,
        ],
        monthsRegex =
            /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember|Jan\.?|Feb\.?|Mär\.?|Apr\.?|Jun\.?|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i;

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember)/i,
        monthsShortStrictRegex:
            /^(Jan\.?|Feb\.?|März|Mär\.?|Apr\.?|Mai|Juni|Jun\.?|Juli|Jul\.?|Aug\.?|Sep\.?|Okt\.?|Nov\.?|Dez\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ "./node_modules/moment/locale/dv.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ "./node_modules/moment/locale/el.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-au.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-ca.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-gb.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-ie.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-il.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-in.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-nz.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ "./node_modules/moment/locale/en-sg.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ "./node_modules/moment/locale/eo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/es-do.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/es-mx.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ "./node_modules/moment/locale/es-us.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ "./node_modules/moment/locale/es.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ "./node_modules/moment/locale/et.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ "./node_modules/moment/locale/eu.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fa.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fi.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fil.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fr-ca.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fr-ch.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fr.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/fy.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ga.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ "./node_modules/moment/locale/gd.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ "./node_modules/moment/locale/gl.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/gom-deva.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ "./node_modules/moment/locale/gom-latn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/gu.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ "./node_modules/moment/locale/he.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ "./node_modules/moment/locale/hi.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ "./node_modules/moment/locale/hr.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/hu.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return (
                    num + (isFuture || withoutSuffix ? ' másodperc' : ' másodperce')
                );
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ "./node_modules/moment/locale/hy-am.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ "./node_modules/moment/locale/id.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsParse = [],
        longMonthsParse = [],
        shortMonthsParse = [];

    monthsParse[7] = /^agustus|^agu|^agt/i;
    longMonthsParse[7] = /^agustus$/i;
    shortMonthsParse[7] = /^agu$|^agt$/i;

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agu_Sep_Okt_Nov_Des'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: longMonthsParse,
        shortMonthsParse: shortMonthsParse,
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ "./node_modules/moment/locale/is.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ "./node_modules/moment/locale/it-ch.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ "./node_modules/moment/locale/it.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ja.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ "./node_modules/moment/locale/jv.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ka.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ "./node_modules/moment/locale/kk.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ "./node_modules/moment/locale/km.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ "./node_modules/moment/locale/kn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ko.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ku-kmr.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return kuKmr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ku.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ky.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ "./node_modules/moment/locale/lb.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ "./node_modules/moment/locale/lo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/lt.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ "./node_modules/moment/locale/lv.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ "./node_modules/moment/locale/me.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ "./node_modules/moment/locale/mi.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ "./node_modules/moment/locale/mk.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration
    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ml.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ "./node_modules/moment/locale/mn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/mr.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ms-my.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ms.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ "./node_modules/moment/locale/mt.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ "./node_modules/moment/locale/my.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ "./node_modules/moment/locale/nb.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ne.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ "./node_modules/moment/locale/nl-be.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ "./node_modules/moment/locale/nl.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/nn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/oc-lnc.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ "./node_modules/moment/locale/pa-in.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/pl.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D\.? MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ps.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pashto [ps]
//! author : Hanif Hefaz : https://github.com/hanifhefaz

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        },
        months = {
            format: 'جنوري_فبروري_مارچ_اپریل_مۍ_جون_جولای_اګست_سېپتمبر_اکتوبر_نومبر_دسمبر'.split(
                '_'
            ),
            standalone:
                'جنوري_فېبروري_مارچ_اپریل_مۍ_جون_جولای_اګست_سپتمبر_اکتوبر_نومبر_دسمبر'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s|,)+MMMM?/,
        },
        monthsShort = {
            format: 'جنوري_فبروري_مارچ_اپریل_مۍ_جون_جولای_اګست_سېپتمبر_اکتوبر_نومبر_دسمبر'.split(
                '_'
            ),
            standalone:
                'جنوري_فبروري_مارچ_اپریل_مۍ_جون_جولای_اګست_سپتمبر_اکتوبر_نومبر_دسمبر'.split(
                    '_'
                ),
        },
        monthsParse = [
            /^جنوري$/i,
            /^(فبروري|فېبروري)$/i,
            /^مارچ$/i,
            /^اپریل$/i,
            /^مۍ$/i,
            /^جون$/i,
            /^جولای$/i,
            /^اګست$/i,
            /^(سپتمبر|سېپتمبر)$/i,
            /^اکتوبر$/i,
            /^نومبر$/i,
            /^دسمبر$/i,
        ],
        monthsRegex =
            /^(جنوري|فبروري|فېبروري|مارچ|اپریل|مۍ|جون|جولای|اګست|سپتمبر|سېپتمبر|اکتوبر|نومبر|دسمبر)/i;

    function relativeTime(number, withoutSuffix, key, isFuture) {
        var format =
            isFuture && !withoutSuffix
                ? {
                      s: 'څو ثانيو',
                      ss: '%d ثانيو',
                      m: 'يوه دقيقه',
                      mm: '%d دقيقو',
                      h: 'يو ساعت',
                      hh: '%d ساعتو',
                      d: 'يوه ورځ',
                      dd: '%d ورځو',
                      M: 'يوه مياشت',
                      MM: '%d مياشتو',
                      y: 'يو کال',
                      yy: '%d کالونو',
                  }
                : {
                      s: 'څو ثانيې',
                      ss: '%d ثانيې',
                      m: 'يوه دقيقه',
                      mm: '%d دقيقې',
                      h: 'يو ساعت',
                      hh: '%d ساعتونه',
                      d: 'يوه ورځ',
                      dd: '%d ورځې',
                      M: 'يوه مياشت',
                      MM: '%d مياشتې',
                      y: 'يو کال',
                      yy: '%d کاله',
                  };

        return format[key].replace('%d', number);
    }

    var ps = moment.defineLocale('ps', {
        months: months,
        monthsShort: monthsShort,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsRegex,
        monthsShortStrictRegex: monthsRegex,
        weekdays: 'یکشنبه_دوشنبه_سه شنبه_چهارشنبه_پنج شنبه_جمعه_شنبه'.split('_'),
        weekdaysShort: 'یکشنبه_دوشنبه_سه شنبه_چهارشنبه_پنج شنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY/M/D',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd D, MMMM, YYYY [په] H:mm',
        },
        meridiemParse: /غ\.م|غ\.و\./,
        isPM: function (input) {
            return input === 'غ.و.';
        },
        meridiem: function (hour) {
            return hour < 12 ? 'غ.م' : 'غ.و.';
        },
        calendar: {
            sameDay: '[نن په] LT',
            nextDay: '[سبا په] LT',
            nextWeek: 'dddd [په] LT',
            lastDay: '[پرون په] LT',
            lastWeek: 'dddd [په] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'په %s کې',
            past: '%s مخکې',
            s: relativeTime,
            ss: relativeTime,
            m: relativeTime,
            mm: relativeTime,
            h: relativeTime,
            hh: relativeTime,
            d: relativeTime,
            dd: relativeTime,
            M: relativeTime,
            MM: relativeTime,
            y: relativeTime,
            yy: relativeTime,
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ps;

})));


/***/ }),

/***/ "./node_modules/moment/locale/pt-br.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: function () {
                return '[Hoje ' + (this.hours() >= 2 ? 'às' : 'à') + '] LT';
            },
            nextDay: function () {
                return '[Amanhã ' + (this.hours() >= 2 ? 'às' : 'à') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() >= 2 ? 'às' : 'à') + '] LT';
            },
            lastDay: function () {
                return '[Ontem ' + (this.hours() >= 2 ? 'às' : 'à') + '] LT';
            },
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [' + (this.hours() >= 2 ? 'às' : 'à') + '] LT' // Saturday + Sunday
                    : '[Última] dddd [' + (this.hours() >= 2 ? 'às' : 'à') + '] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/pt.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ro.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ru.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sd.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ "./node_modules/moment/locale/se.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),

/***/ "./node_modules/moment/locale/si.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sk.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sl.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sq.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sr-cyrl.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sr.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ss.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sv.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tors_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ "./node_modules/moment/locale/sw.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var relativeTime = {
        ss: 'sekunde %d',
        m: 'dakika moja',
        mm: 'dakika %d',
        h: 'saa moja',
        hh: 'saa %d',
        d: 'siku moja',
        dd: 'siku %d',
        M: 'mwezi mmoja',
        MM: 'miezi %d',
        y: 'mwaka mmoja',
        yy: 'miaka %d',
    };

    function relativeTimeWithSuffix(number, withoutSuffix, key, isFuture) {
        var output = relativeTime[key].replace(/%d/i, number);

        if (withoutSuffix || isFuture) {
            return output;
        }

        switch (key) {
            case 'ss':
            case 'mm':
            case 'hh':
            case 'dd':
                return output + (number === 1 ? ' iliyopita' : ' zilizopita');
            case 'm':
            case 'h':
            case 'd':
                return output + ' iliyopita';
            case 'M':
            case 'y':
                return output + ' uliopita';
            case 'MM':
            case 'yy':
                return output + ' iliyopita';
        }
    }

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: 'dddd [ijayo saa] LT',
            lastDay: '[jana] LT',
            lastWeek: 'dddd [iliyopita saa] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: function (output) {
                return output === 'hivi punde' ? 'tokea ' + output : output;
            },
            s: 'hivi punde',
            ss: relativeTimeWithSuffix,
            m: relativeTimeWithSuffix,
            mm: relativeTimeWithSuffix,
            h: relativeTimeWithSuffix,
            hh: relativeTimeWithSuffix,
            d: relativeTimeWithSuffix,
            dd: relativeTimeWithSuffix,
            M: relativeTimeWithSuffix,
            MM: relativeTimeWithSuffix,
            y: relativeTimeWithSuffix,
            yy: relativeTimeWithSuffix,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ta.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ "./node_modules/moment/locale/te.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tet.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tg.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ "./node_modules/moment/locale/th.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tk.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tl-ph.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tlh.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tr.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tzl.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tzm-latn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/tzm.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ug-cn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/uk.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire
//! Author : Oleksandr Trukhnii : https://github.com/JohnJunior

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_пʼятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_пʼятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_пʼятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ "./node_modules/moment/locale/ur.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ "./node_modules/moment/locale/uz-latn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: '%s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/uz.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: '%s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ "./node_modules/moment/locale/vi.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ "./node_modules/moment/locale/x-pseudo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/yo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/zh-cn.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ "./node_modules/moment/locale/zh-hk.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ "./node_modules/moment/locale/zh-mo.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ "./node_modules/moment/locale/zh-tw.js":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__("./node_modules/moment/moment.js")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ "./node_modules/moment/moment.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid$2(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidOffset &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) {
            formatFunctions[cacheKey] = makeFormatFunction(format);
        }

        return formatFunctions[cacheKey](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get$2(this, unit);
            }
        };
    }

    function get$2(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod$1(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord,
        monthsParseProperties = [
            'monthsParse',
            'longMonthsParse',
            'shortMonthsParse',
            'monthsRegex',
            'monthsShortRegex',
            'monthsStrictRegex',
            'monthsShortStrictRegex',
        ];

    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for (i = 0; i < monthsParseProperties.length; i++) {
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) {
                delete locale['_' + prop];
            }
        }
    }

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse$1(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse$1.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get$2(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function () {
        return (
            '' +
            this.weekday() +
            zeroFill(this.hours(), 2) +
            zeroFill(this.minutes(), 2)
        );
    });

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    addWeekParseToken('eHHmm', function (input, week, config) {
        var weekdayEnd = input.length - 4;

        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord,
        weekdaysParseProperties = [
            'weekdaysParse',
            'fullWeekdaysParse',
            'shortWeekdaysParse',
            'minWeekdaysParse',
            'weekdaysRegex',
            'weekdaysShortRegex',
            'weekdaysMinRegex',
            'weekdaysStrictRegex',
            'weekdaysShortStrictRegex',
            'weekdaysMinStrictRegex',
        ];

    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for (i = 0; i < weekdaysParseProperties.length; i++) {
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) {
                delete locale['_' + prop];
            }
        }
    }

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()],
            formatCache = this._longDateFormatCache;

        if (format || !formatUpper) {
            return format;
        }

        if (
            formatCache &&
            formatCache[key] &&
            formatCache[key].formatUpper === formatUpper
        ) {
            return formatCache[key].format;
        }

        format = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        if (!formatCache) {
            formatCache = this._longDateFormatCache = {};
        }
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format,
        };
        return format;
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTimeWithoutPostformat(
        number,
        withoutSuffix,
        string,
        isFuture
    ) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(
            relativeTimeWithoutPostformat.call(
                this,
                number,
                withoutSuffix,
                string,
                isFuture
            )
        );
    }

    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    function pastFuture(diff, output) {
        return this.postformat(
            pastFutureWithoutPostformat.call(this, diff, output)
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }

    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear =
            Math.round(
                (createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) /
                    864e5
            ) + 1;

        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire,
            normalizedName;

        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) {
            return locales[name];
        }

        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) {
            return locales[normalizedName];
        }

        // TODO: Find a better way to register and load all the locales in Node
        if (
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(normalizedName)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__("./node_modules/moment/locale recursive ^\\.\\/.*$")("./" + normalizedName);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[normalizedName] = null; // null means not found
            }
        }
        if (hasOwnProp(locales, normalizedName)) {
            return locales[normalizedName];
        }
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        var locale,
            tmpLocale = loadLocale(name),
            parentConfig = baseConfig;

        if (tmpLocale != null) {
            name = tmpLocale._abbr;
        }

        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(
                config,
                '_isDefaultDatePartsForWeek'
            ),
            weekContext = config._isDefaultDatePartsForWeek;

        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally {
            if (hadWeekContext) {
                config._isDefaultDatePartsForWeek = weekContext;
            } else {
                delete config._isDefaultDatePartsForWeek;
            }
        }
    }

    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;

        if (!now) {
            return hooks.now();
        }
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }

    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek,
            nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) {
            return [nowValue.year(), nowValue.month(), nowValue.date()];
        }
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    hooks._getDefaultDateParts = getDefaultDateParts;

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            now,
            currentDate,
            expectedWeekday,
            yearToUse,
            dateIsDefaulted;

        if (config._d) {
            return;
        }

        if (
            config._a[YEAR] == null ||
            config._a[MONTH] == null ||
            config._a[DATE] == null
        ) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse =
                config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        dateIsDefaulted =
            config._a[YEAR] == null ||
            config._a[MONTH] == null ||
            config._a[DATE] == null;

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            !dateIsDefaulted &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYearFromDate(
                    currentDate[YEAR],
                    currentDate[MONTH],
                    currentDate[DATE],
                    1,
                    4
                ).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYearFromDate(
                currentDate[YEAR],
                currentDate[MONTH],
                currentDate[DATE],
                dow,
                doy
            );

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            defaultDatePartsNow = {},
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid$2(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid$1({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid$2(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid$1();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid$1();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        for (i = 0; i < moments.length; ++i) {
            if (isMoment(moments[i])) {
                res = moments[i];
                break;
            }
        }
        if (!res) {
            return createInvalid$1();
        }
        for (++i; i < moments.length; ++i) {
            if (
                isMoment(moments[i]) &&
                (!moments[i].isValid() || moments[i][fn](res))
            ) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) {
            getParsingFlags(config).invalidOffset = input;
        }
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        if (
            toInt(parts[2]) > 59 ||
            (parts[0] === '+' ? minutes > 14 * 60 : minutes > 12 * 60)
        ) {
            return null;
        }

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract$1(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }

    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add$1 = createAdder(1, 'add'),
        subtract$1 = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone$1() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString$1(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid() {
        return isValid$2(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? 1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto$2 = Moment.prototype;

    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto$2[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto$2.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto$2.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto$2.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto$2.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs$1() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(
            (milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0)
        )) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf = asMilliseconds;

    function clone() {
        return createDuration(this);
    }

    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(
            locale,
            number || 1,
            !!withoutSuffix,
            string,
            isFuture
        );
    }

    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = pastFutureWithoutPostformat.call(locale, +this, output);
        }

        return locale.postformat(output);
    }

    var abs = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs(this._milliseconds) / 1000,
            days = abs(this._days),
            months = abs(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto = Duration.prototype;

    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;

    proto.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString
    );
    proto.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.31.0';

    setHookCallback(createLocal);

    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/no-scroll/index.js":
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module), __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/normalize-url/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var url = __webpack_require__("./node_modules/url/url.js");
var punycode = __webpack_require__("./node_modules/node-libs-browser/node_modules/punycode/punycode.js");
var queryString = __webpack_require__("./node_modules/query-string/index.js");
var prependHttp = __webpack_require__("./node_modules/prepend-http/index.js");
var sortKeys = __webpack_require__("./node_modules/sort-keys/index.js");
var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");

var DEFAULT_PORTS = {
	'http:': 80,
	'https:': 443,
	'ftp:': 21
};

// protocols that always contain a `//`` bit
var slashedProtocol = {
	'http': true,
	'https': true,
	'ftp': true,
	'gopher': true,
	'file': true,
	'http:': true,
	'https:': true,
	'ftp:': true,
	'gopher:': true,
	'file:': true
};

function testParameter(name, filters) {
	return filters.some(function (filter) {
		return filter instanceof RegExp ? filter.test(name) : filter === name;
	});
}

module.exports = function (str, opts) {
	opts = objectAssign({
		normalizeProtocol: true,
		normalizeHttps: false,
		stripFragment: true,
		stripWWW: true,
		removeQueryParameters: [/^utm_\w+/i],
		removeTrailingSlash: true,
		removeDirectoryIndex: false
	}, opts);

	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	var hasRelativeProtocol = str.indexOf('//') === 0;

	// prepend protocol
	str = prependHttp(str.trim()).replace(/^\/\//, 'http://');

	var urlObj = url.parse(str);

	if (opts.normalizeHttps && urlObj.protocol === 'https:') {
		urlObj.protocol = 'http:';
	}

	if (!urlObj.hostname && !urlObj.pathname) {
		throw new Error('Invalid URL');
	}

	// prevent these from being used by `url.format`
	delete urlObj.host;
	delete urlObj.query;

	// remove fragment
	if (opts.stripFragment) {
		delete urlObj.hash;
	}

	// remove default port
	var port = DEFAULT_PORTS[urlObj.protocol];
	if (Number(urlObj.port) === port) {
		delete urlObj.port;
	}

	// remove duplicate slashes
	if (urlObj.pathname) {
		urlObj.pathname = urlObj.pathname.replace(/\/{2,}/g, '/');
	}

	// decode URI octets
	if (urlObj.pathname) {
		urlObj.pathname = decodeURI(urlObj.pathname);
	}

	// remove directory index
	if (opts.removeDirectoryIndex === true) {
		opts.removeDirectoryIndex = [/^index\.[a-z]+$/];
	}

	if (Array.isArray(opts.removeDirectoryIndex) && opts.removeDirectoryIndex.length) {
		var pathComponents = urlObj.pathname.split('/');
		var lastComponent = pathComponents[pathComponents.length - 1];

		if (testParameter(lastComponent, opts.removeDirectoryIndex)) {
			pathComponents = pathComponents.slice(0, pathComponents.length - 1);
			urlObj.pathname = pathComponents.slice(1).join('/') + '/';
		}
	}

	// resolve relative paths, but only for slashed protocols
	if (slashedProtocol[urlObj.protocol]) {
		var domain = urlObj.protocol + '//' + urlObj.hostname;
		var relative = url.resolve(domain, urlObj.pathname);
		urlObj.pathname = relative.replace(domain, '');
	}

	if (urlObj.hostname) {
		// IDN to Unicode
		urlObj.hostname = punycode.toUnicode(urlObj.hostname).toLowerCase();

		// remove trailing dot
		urlObj.hostname = urlObj.hostname.replace(/\.$/, '');

		// remove `www.`
		if (opts.stripWWW) {
			urlObj.hostname = urlObj.hostname.replace(/^www\./, '');
		}
	}

	// remove URL with empty query string
	if (urlObj.search === '?') {
		delete urlObj.search;
	}

	var queryParameters = queryString.parse(urlObj.search);

	// remove query unwanted parameters
	if (Array.isArray(opts.removeQueryParameters)) {
		for (var key in queryParameters) {
			if (testParameter(key, opts.removeQueryParameters)) {
				delete queryParameters[key];
			}
		}
	}

	// sort query parameters
	urlObj.search = queryString.stringify(sortKeys(queryParameters));

	// decode query parameters
	urlObj.search = decodeURIComponent(urlObj.search);

	// take advantage of many of the Node `url` normalizations
	str = url.format(urlObj);

	// remove ending `/`
	if (opts.removeTrailingSlash || urlObj.pathname === '/') {
		str = str.replace(/\/$/, '');
	}

	// restore relative protocol, if applicable
	if (hasRelativeProtocol && !opts.normalizeProtocol) {
		str = str.replace(/^http:\/\//, '//');
	}

	return str;
};


/***/ }),

/***/ "./node_modules/object-assign/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "./node_modules/object-inspect/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(4);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/os-browserify/browser.js":
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),

/***/ "./node_modules/popper.js/dist/esm/popper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/prepend-http/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (url) {
	if (typeof url !== 'string') {
		throw new TypeError('Expected a string, got ' + typeof url);
	}

	url = url.trim();

	if (/^\.*\/|^(?!localhost)\w+:/.test(url)) {
		return url;
	}

	return url.replace(/^(?!(?:\w+:)?\/\/)/, 'http://');
};


/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/qs/lib/formats.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ "./node_modules/qs/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("./node_modules/qs/lib/stringify.js");
var parse = __webpack_require__("./node_modules/qs/lib/parse.js");
var formats = __webpack_require__("./node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "./node_modules/qs/lib/parse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__("./node_modules/side-channel/index.js");
var utils = __webpack_require__("./node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf;

var isPlainContainer = function isPlainContainer(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    if (isArray(value)) {
        return true;
    }
    var proto = getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};

var emptyCopyOf = function emptyCopyOf(value) {
    if (isArray(value)) {
        var arr = [];
        arr.length = value.length;
        return arr;
    }
    return getPrototypeOf(value) === null ? { __proto__: null } : {};
};

// `merge` and `compact` modify the containers they are given, so copy the caller's arrays and plain objects first
var copyInput = function copyInput(input) {
    var copies = getSideChannel();
    var result = {};
    var queue = [{ source: input, target: result }];

    for (var i = 0; i < queue.length; ++i) {
        var source = queue[i].source;
        var target = queue[i].target;
        var keys = Object.keys(source);
        for (var j = 0; j < keys.length; ++j) {
            var value = source[keys[j]];
            if (isPlainContainer(value)) {
                if (!copies.has(value)) {
                    var copy = emptyCopyOf(value);
                    copies.set(value, copy);
                    queue[queue.length] = { source: value, target: copy };
                }
                target[keys[j]] = copies.get(value);
            } else {
                target[keys[j]] = value;
            }
        }
    }

    return result;
};

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while (commaIndex > -1) {
                commaCount += 1;
                if (commaCount >= options.arrayLimit) {
                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                }
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        // `[]` belongs to the key, so look for it at the split point, not anywhere in the part
        var isEmptyBracketKey = pos > 1 && part.slice(pos - 2, pos) === '[]';

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (isEmptyBracketKey) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            val = utils.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || isEmptyBracketKey)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects,
                    options.throwOnLimitExceeded
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects,
                        options.throwOnLimitExceeded
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

// Behaves like `key.replace(/\.([^.[]+)/g, '[$1]')`, but only rewrites a dot
// that sits at bracket depth 0. A literal dot already inside a `[...]` segment
// is left untouched instead of corrupting the key (e.g. "outer[a.b]"). (#617)
var topLevelDotsToBrackets = function topLevelDotsToBrackets(key) {
    var result = '';
    var depth = 0;
    for (var i = 0; i < key.length; i += 1) {
        var cu = key.charCodeAt(i);
        if (cu === 0x5B) { // '['
            depth += 1;
            result += '[';
        } else if (cu === 0x5D) { // ']'
            if (depth > 0) {
                depth -= 1;
            }
            result += ']';
        } else if (
            cu === 0x2E // '.'
            && depth === 0
            && i + 1 < key.length
            && key.charCodeAt(i + 1) !== 0x2E // not another '.'
            && key.charCodeAt(i + 1) !== 0x5B // not '['
        ) {
            var start = i + 1;
            var j = start;
            while (j < key.length && key.charCodeAt(j) !== 0x2E && key.charCodeAt(j) !== 0x5B) {
                j += 1;
            }
            result += '[' + key.slice(start, j) + ']';
            i = j - 1;
        } else {
            result += key.charAt(i);
        }
    }
    return result;
};

// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? topLevelDotsToBrackets(originalKey) : originalKey;

    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var segments = [];

    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        segments[segments.length] = parent;
    }

    var n = key.length;
    var open = first;
    var collected = 0;

    while (open >= 0 && collected < options.depth) {
        var level = 1;
        var i = open + 1;
        var close = -1;

        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while (i < n && close < 0) {
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) { // '['
                level += 1;
            } else if (cu === 0x5D) { // ']'
                level -= 1;
                if (level === 0) {
                    close = i; // found matching close; loop will exit by condition
                }
            }
            i += 1;
        }

        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }

        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, content) && !options.allowPrototypes) {
            return;
        }

        segments[segments.length] = seg;
        collected += 1;

        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }

    if (open >= 0) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        segments[segments.length] = '[' + key.slice(open) + ']';
    }

    return segments;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : copyInput(str);
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "./node_modules/qs/lib/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__("./node_modules/side-channel/index.js");
var utils = __webpack_require__("./node_modules/qs/lib/utils.js");
var formats = __webpack_require__("./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel,
    depth,
    currentDepth
) {
    var obj = object;

    if (currentDepth > depth) {
        throw new RangeError('Input depth exceeded depth option of ' + depth);
    }

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;

    if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return formatter(encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix);
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, function (v) {
                return v == null ? v : encoder(v, defaults.encoder, charset, 'value', format);
            });
        }
        objKeys = [{ value: obj.length > 0 ? utils.toCoercible(obj).join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) {
        return formatter(encoder && !encodeValuesOnly ? encoder(adjustedPrefix, defaults.encoder, charset, 'key', format) : adjustedPrefix) + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel,
            depth,
            currentDepth + 1
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (has.call(arrayPrefixGenerators, opts.arrayFormat)) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (typeof key === 'undefined' || key === null) {
            continue;
        }

        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }

        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);

        pushToArray(keys, stringify(
            value,
            encodedKey,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel,
            options.depth,
            0
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93' + options.delimiter;
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "./node_modules/qs/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__("./node_modules/qs/lib/formats.js");
var getSideChannel = __webpack_require__("./node_modules/side-channel/index.js");
var defineProperty = __webpack_require__("./node_modules/es-define-property/index.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

// Track containers produced by a `strictMerge` conflict wrap, and their current max numeric index,
// so repeated conflicts on one path append instead of nesting a new wrapper each time
var conflictChannel = getSideChannel();

var markConflict = function markConflict(obj, maxIndex) {
    conflictChannel.set(obj, maxIndex);
    return obj;
};

var isConflict = function isConflict(obj) {
    return conflictChannel.has(obj);
};

var getConflictIndex = function getConflictIndex(obj) {
    return conflictChannel.get(obj);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && defineProperty) {
        defineProperty(obj, key, {
            configurable: true,
            enumerable: true,
            value: value,
            writable: true
        });
    } else {
        obj[key] = value;
    }
};

var maxNumericIndex = function maxNumericIndex(obj, min) {
    var max = min;
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; ++i) {
        var num = parseInt(keys[i], 10);
        if (String(num) === keys[i] && num > max) {
            max = num;
        }
    }

    return max;
};

var limitedPair = function limitedPair(first, second, options) {
    var pair = [first, second];
    if (options && typeof options.arrayLimit === 'number' && pair.length > options.arrayLimit) {
        if (options.throwOnLimitExceeded) {
            throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        }
        return markOverflow(arrayToObject(pair, options), 1);
    }
    return pair;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) {
                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                }
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge && isConflict(target)) {
                var nextConflict = getConflictIndex(target) + 1;
                if (
                    options.throwOnLimitExceeded
                    && typeof options.arrayLimit === 'number'
                    && nextConflict >= options.arrayLimit
                ) {
                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                }
                target[nextConflict] = source;
                markConflict(target, nextConflict);
            } else if (options && options.strictMerge) {
                var conflict = limitedPair(target, source, options);
                return isArray(conflict) ? markConflict(conflict, 1) : conflict;
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return limitedPair(target, source, options);
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
        if (isConflict(target)) {
            // the array may have grown past its last conflict, so continue after its last index
            markConflict(mergeTarget, target.length - 1);
        }
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            return markOverflow(arrayToObject(target, options), target.length - 1);
        }
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            setProperty(acc, key, merge(acc[key], value, options));
        } else {
            setProperty(acc, key, value);
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, maxNumericIndex(acc, getMaxIndex(source)));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }
        if (isConflict(acc)) {
            var conflictKey = parseInt(key, 10);
            if (String(conflictKey) === key && conflictKey > getConflictIndex(acc)) {
                markConflict(acc, conflictKey);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        setProperty(acc, key, source[key]);
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    // With no `%` there is no escape to expand, in either charset: `unescape` has
    // nothing to match, and `decodeURIComponent` is the identity on such a string
    // (and cannot throw). So only `+` -> ' ' remains, and often not even that.
    if (typeof str === 'string' && str.indexOf('%') === -1) {
        return str.indexOf('+') === -1 ? str : str.replace(/\+/g, ' ');
    }

    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var hasToPrimitive = typeof Symbol === 'function' && typeof Symbol.toPrimitive === 'symbol';
var arrayJoin = Array.prototype.join;
var arrayToString = Array.prototype.toString;
var objectToString = Object.prototype.toString;

// an object with no callable toString (eg, from JSON, or null-prototype) would make String() or join() throw,
// so it becomes its primitive valueOf or else Object.prototype.toString; arrays are walked like join walks them,
// copied only once an element changes, with an array already being joined becoming '' as engines do for cycles
var toCoercible = function toCoercible(value, joining) {
    if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
        return value;
    }
    if (hasToPrimitive && value[Symbol.toPrimitive] != null) {
        return value;
    }
    if (isArray(value) && value.toString === arrayToString && value.join === arrayJoin) {
        var ancestors = joining || getSideChannel();
        if (ancestors.has(value)) {
            return '';
        }
        ancestors.set(value, true);
        var copy;
        for (var i = 0; i < value.length; i += 1) {
            var item = value[i];
            var coerced = toCoercible(item, ancestors);
            if (!copy && coerced !== item) {
                copy = [];
                for (var j = 0; j < i; j += 1) {
                    copy[j] = value[j];
                }
            }
            if (copy) {
                copy[i] = coerced;
            }
        }
        ancestors['delete'](value);
        return copy || value;
    }
    if (typeof value.toString === 'function') {
        return value;
    }
    var valueOf = value.valueOf;
    if (typeof valueOf === 'function') {
        var primitive = valueOf.call(value);
        if (!primitive || (typeof primitive !== 'object' && typeof primitive !== 'function')) {
            return String(primitive);
        }
    }
    return objectToString.call(value);
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(toCoercible(str));
    }

    if (charset === 'iso-8859-1') {
        // `escape` leaves `+` untouched, but a literal `+` is decoded back to a space,
        // so it must be percent-encoded to round-trip (the utf-8 path already does this).
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        }).replace(/\+/g, '%2B');
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        if (j + limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = getSideChannel();

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = { obj: obj, prop: key };
                refs.set(val, true);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        if (throwOnLimitExceeded) {
            throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        }
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = isArray(b) ? b : [b];
        var newIndex = getMaxIndex(a);
        for (var i = 0; i < bValues.length; ++i) {
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) {
            throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        }
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge,
    toCoercible: toCoercible
};


/***/ }),

/***/ "./node_modules/query-string/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__("./node_modules/strict-uri-encode/index.js");
var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ "./node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "./node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "./node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("./node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("./node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "./node_modules/react-cookie-consent/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(11)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__("./node_modules/react/index.js");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cookies = exports.OPTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(7);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jsCookie = __webpack_require__(5);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OPTIONS = exports.OPTIONS = {
  TOP: "top",
  BOTTOM: "bottom",
  NONE: "none"
};

var CookieConsent = function (_Component) {
  _inherits(CookieConsent, _Component);

  function CookieConsent(props) {
    _classCallCheck(this, CookieConsent);

    var _this = _possibleConstructorReturn(this, (CookieConsent.__proto__ || Object.getPrototypeOf(CookieConsent)).call(this, props));

    _this.accept.bind(_this);

    _this.state = {
      visible: false,
      style: {
        alignItems: "baseline",
        background: "#353535",
        color: "white",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        left: "0",
        position: "fixed",
        width: "100%",
        zIndex: "999"
      },
      buttonStyle: {
        background: "#ffd42d",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "black",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
      },
      contentStyle: {
        flex: "1 0 300px",
        margin: "15px"
      }
    };

    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(CookieConsent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          cookieName = _props.cookieName,
          debug = _props.debug;

      // if cookie undefined or debug

      if (_jsCookie2.default.get(cookieName) === undefined || debug) {
        this.setState({ visible: true });
      }

      // if acceptOnScroll is set to true, add a listener
      if (this.props.acceptOnScroll) {
        window.addEventListener("scroll", this.handleScroll, { passive: true });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // remove listener if still set
      window.removeEventListener("scroll", this.handleScroll);
    }

    /**
     * checks whether scroll has exceeded set amount and fire accept if so.
     */

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      // (top / height) - height * 100
      var rootNode = document.documentElement,
          body = document.body,
          top = "scrollTop",
          height = "scrollHeight";

      var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;

      if (percentage > this.props.acceptOnScrollPercentage) {
        this.accept();
      }
    }

    /**
     * Set a persistent cookie
     */

  }, {
    key: "accept",
    value: function accept() {
      var _props2 = this.props,
          cookieName = _props2.cookieName,
          cookieValue = _props2.cookieValue,
          expires = _props2.expires,
          hideOnAccept = _props2.hideOnAccept,
          onAccept = _props2.onAccept,
          extraCookieOptions = _props2.extraCookieOptions;

      // fire onAccept

      onAccept();
      // remove listener if set
      window.removeEventListener("scroll", this.handleScroll);

      _jsCookie2.default.set(cookieName, cookieValue, _extends({ expires: expires }, extraCookieOptions));

      if (hideOnAccept) {
        this.setState({ visible: false });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // If the bar shouldn't be visible don't render anything.
      if (!this.state.visible) {
        return null;
      }

      var _props3 = this.props,
          location = _props3.location,
          style = _props3.style,
          buttonStyle = _props3.buttonStyle,
          contentStyle = _props3.contentStyle,
          disableStyles = _props3.disableStyles,
          buttonText = _props3.buttonText,
          containerClasses = _props3.containerClasses,
          contentClasses = _props3.contentClasses,
          buttonClasses = _props3.buttonClasses,
          buttonId = _props3.buttonId;


      var myStyle = {};
      var myButtonStyle = {};
      var myContentStyle = {};

      if (disableStyles) {
        // if styles are disabled use the provided styles (or non)
        myStyle = Object.assign({}, style);
        myButtonStyle = Object.assign({}, buttonStyle);
        myContentStyle = Object.assign({}, contentStyle);
      } else {
        // if styles aren't disabled merge them with the styles that are provided (or use default styles)
        myStyle = Object.assign({}, _extends({}, this.state.style, style));
        myButtonStyle = Object.assign({}, _extends({}, this.state.buttonStyle, buttonStyle));
        myContentStyle = Object.assign({}, _extends({}, this.state.contentStyle, contentStyle));
      }

      // syntactic sugar to enable user to easily select top / bottom
      switch (location) {
        case OPTIONS.TOP:
          myStyle.top = "0";
          myStyle.position = "fixed";
          break;

        case OPTIONS.BOTTOM:
          myStyle.bottom = "0";
          myStyle.position = "fixed";
          break;
      }

      return _react2.default.createElement(
        "div",
        { className: "cookieConsent " + containerClasses, style: myStyle },
        _react2.default.createElement(
          "div",
          { style: myContentStyle, className: contentClasses },
          this.props.children
        ),
        _react2.default.createElement(
          "button",
          {
            style: myButtonStyle,
            className: buttonClasses,
            id: buttonId,
            onClick: function onClick() {
              _this2.accept();
            }
          },
          buttonText
        )
      );
    }
  }]);

  return CookieConsent;
}(_react.Component);

CookieConsent.propTypes = {
  location: _propTypes2.default.oneOf(Object.keys(OPTIONS).map(function (key) {
    return OPTIONS[key];
  })),
  style: _propTypes2.default.object,
  buttonStyle: _propTypes2.default.object,
  contentStyle: _propTypes2.default.object,
  children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
  disableStyles: _propTypes2.default.bool,
  hideOnAccept: _propTypes2.default.bool,
  onAccept: _propTypes2.default.func,
  buttonText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
  cookieName: _propTypes2.default.string,
  cookieValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number]),
  debug: _propTypes2.default.bool,
  expires: _propTypes2.default.number,
  containerClasses: _propTypes2.default.string,
  contentClasses: _propTypes2.default.string,
  buttonClasses: _propTypes2.default.string,
  buttonId: _propTypes2.default.string,
  acceptOnScroll: _propTypes2.default.bool,
  acceptOnScrollPercentage: _propTypes2.default.number,
  extraCookieOptions: _propTypes2.default.object
};

CookieConsent.defaultProps = {
  disableStyles: false,
  hideOnAccept: true,
  acceptOnScroll: false,
  acceptOnScrollPercentage: 25,
  location: OPTIONS.BOTTOM,
  onAccept: function onAccept() {},
  cookieName: "CookieConsent",
  cookieValue: true,
  buttonText: "I understand",
  debug: false,
  expires: 365,
  containerClasses: "",
  contentClasses: "",
  buttonClasses: "",
  buttonId: "",
  extraCookieOptions: {}
};

exports.default = CookieConsent;
exports.Cookies = _jsCookie2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(4);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);
var assign = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(10);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
/******/ ]);

/***/ }),

/***/ "./node_modules/react-device-detect/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__("./node_modules/react/index.js");
var React__default = _interopDefault(React);

var UAParser = __webpack_require__("./node_modules/ua-parser-js/dist/ua-parser.min.js");

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: 'IE',
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DeviceTypes.Mobile;
};

var isTabletType = function isTabletType() {
  return device.type === DeviceTypes.Tablet;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DeviceTypes.SmartTv;
};

var isBrowserType = function isBrowserType() {
  return device.type === DeviceTypes.Browser;
};

var isWearableType = function isWearableType() {
  return device.type === DeviceTypes.Wearable;
};

var isConsoleType = function isConsoleType() {
  return device.type === DeviceTypes.Console;
};

var isAndroidType = function isAndroidType() {
  return os.name === OsTypes.Android;
};

var isWindowsType = function isWindowsType() {
  return os.name === OsTypes.Windows;
};

var isMacOsType = function isMacOsType() {
  return os.name === OsTypes.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OsTypes.WindowsPhone;
};

var isIOSType = function isIOSType() {
  return os.name === OsTypes.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BrowserTypes.Chrome;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BrowserTypes.Firefox;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BrowserTypes.Chromium;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BrowserTypes.Edge;
};

var isYandexType = function isYandexType() {
  return browser.name === BrowserTypes.Yandex;
};

var isSafariType = function isSafariType() {
  return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BrowserTypes.MobileSafari;
};

var isOperaType = function isOperaType() {
  return browser.name === BrowserTypes.Opera;
};

var isIEType = function isIEType() {
  return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BrowserTypes.MIUI;
};

var isSamsungBrowserType = function isSamsungBrowserType() {
  return browser.name === BrowserTypes.SamsungBrowser;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


/***/ }),

/***/ "./node_modules/react-dom/cjs/react-dom.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__("./node_modules/react/index.js"),n=__webpack_require__("./node_modules/object-assign/index.js"),r=__webpack_require__("./node_modules/scheduler/index.js");function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),

/***/ "./node_modules/react-dom/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__("./node_modules/react-dom/cjs/react-dom.production.min.js");
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),

/***/ "./node_modules/react-easy-swipe/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react-easy-swipe/lib/react-swipe.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./react-swipe'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reactSwipe);
    global.index = mod.exports;
  }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});

/***/ }),

/***/ "./node_modules/react-easy-swipe/lib/react-swipe.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/index.js"), __webpack_require__("./node_modules/prop-types/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.reactSwipe = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {} // eslint-disable-line no-empty

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }

  /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */
  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var ReactSwipe = function (_Component) {
    _inherits(ReactSwipe, _Component);

    function ReactSwipe() {
      var _ref;

      _classCallCheck(this, ReactSwipe);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

      _this._onMouseDown = _this._onMouseDown.bind(_this);
      _this._onMouseMove = _this._onMouseMove.bind(_this);
      _this._onMouseUp = _this._onMouseUp.bind(_this);

      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
      return _this;
    }

    _createClass(ReactSwipe, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.swiper) {
          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.swiper) {
          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }

        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);

        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        if (!this.moveStart) {
          return;
        }

        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // handling the responsability of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault && event.cancelable) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving && this.movePosition) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(1, event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(1, event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(1, event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(1, event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }, {
      key: '_setSwiperRef',
      value: function _setSwiperRef(node) {
        this.swiper = node;
        this.props.innerRef(node);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tagName = _props.tagName,
            className = _props.className,
            style = _props.style,
            children = _props.children,
            allowMouseEvents = _props.allowMouseEvents,
            onSwipeUp = _props.onSwipeUp,
            onSwipeDown = _props.onSwipeDown,
            onSwipeLeft = _props.onSwipeLeft,
            onSwipeRight = _props.onSwipeRight,
            onSwipeStart = _props.onSwipeStart,
            onSwipeMove = _props.onSwipeMove,
            onSwipeEnd = _props.onSwipeEnd,
            innerRef = _props.innerRef,
            tolerance = _props.tolerance,
            props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);

        return _react2.default.createElement(
          this.props.tagName,
          _extends({
            ref: this._setSwiperRef,
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: className,
            style: style
          }, props),
          children
        );
      }
    }]);

    return ReactSwipe;
  }(_react.Component);

  ReactSwipe.displayName = 'ReactSwipe';
  ReactSwipe.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.node,
    allowMouseEvents: _propTypes2.default.bool,
    onSwipeUp: _propTypes2.default.func,
    onSwipeDown: _propTypes2.default.func,
    onSwipeLeft: _propTypes2.default.func,
    onSwipeRight: _propTypes2.default.func,
    onSwipeStart: _propTypes2.default.func,
    onSwipeMove: _propTypes2.default.func,
    onSwipeEnd: _propTypes2.default.func,
    innerRef: _propTypes2.default.func,
    tolerance: _propTypes2.default.number.isRequired
  };
  ReactSwipe.defaultProps = {
    tagName: 'div',
    allowMouseEvents: false,
    onSwipeUp: function onSwipeUp() {},
    onSwipeDown: function onSwipeDown() {},
    onSwipeLeft: function onSwipeLeft() {},
    onSwipeRight: function onSwipeRight() {},
    onSwipeStart: function onSwipeStart() {},
    onSwipeMove: function onSwipeMove() {},
    onSwipeEnd: function onSwipeEnd() {},
    innerRef: function innerRef() {},

    tolerance: 0
  };
  exports.default = ReactSwipe;
});

/***/ }),

/***/ "./node_modules/react-html5video/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Overlay = exports.Fullscreen = exports.PlayPause = exports.Captions = exports.Volume = exports.Seek = exports.Time = exports.DefaultPlayer = exports.apiHelpers = exports.default = undefined;

	var _video = __webpack_require__(2);

	var _video2 = _interopRequireDefault(_video);

	var _api = __webpack_require__(96);

	var apiHelpers = _interopRequireWildcard(_api);

	var _DefaultPlayer = __webpack_require__(107);

	var _DefaultPlayer2 = _interopRequireDefault(_DefaultPlayer);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _video2.default;
	exports.apiHelpers = apiHelpers;
	exports.DefaultPlayer = _DefaultPlayer2.default;
	exports.Time = _DefaultPlayer.Time;
	exports.Seek = _DefaultPlayer.Seek;
	exports.Volume = _DefaultPlayer.Volume;
	exports.Captions = _DefaultPlayer.Captions;
	exports.PlayPause = _DefaultPlayer.PlayPause;
	exports.Fullscreen = _DefaultPlayer.Fullscreen;
	exports.Overlay = _DefaultPlayer.Overlay;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _assign = __webpack_require__(89);

	var _assign2 = _interopRequireDefault(_assign);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(94);

	var _constants = __webpack_require__(95);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaultMapStateToProps = function defaultMapStateToProps() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _assign2.default)({
	        video: (0, _extends3.default)({}, state)
	    });
	}; /**
	    * This is a HoC that finds a single
	    * <video> in a component and makes
	    * all its PROPERTIES available as props.
	    */


	var defaultMapVideoElToProps = function defaultMapVideoElToProps(videoEl) {
	    return {
	        videoEl: videoEl
	    };
	};

	var defaultMergeProps = function defaultMergeProps() {
	    var stateProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var videoElProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var ownProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return (0, _assign2.default)({}, stateProps, videoElProps, ownProps);
	};

	exports.default = function (BaseComponent) {
	    var mapStateToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMapStateToProps;
	    var mapVideoElToProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultMapVideoElToProps;
	    var mergeProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultMergeProps;
	    return function (_Component) {
	        (0, _inherits3.default)(Video, _Component);

	        function Video(props) {
	            (0, _classCallCheck3.default)(this, Video);

	            var _this = (0, _possibleConstructorReturn3.default)(this, (Video.__proto__ || (0, _getPrototypeOf2.default)(Video)).call(this, props));

	            _this.updateState = _this.updateState.bind(_this);
	            _this.state = {};
	            return _this;
	        }

	        (0, _createClass3.default)(Video, [{
	            key: 'updateState',
	            value: function updateState() {
	                var _this2 = this;

	                this.setState(_constants.PROPERTIES.reduce(function (p, c) {
	                    p[c] = _this2.videoEl && _this2.videoEl[c];
	                    return p;
	                }, {}));
	            }
	        }, {
	            key: 'bindEventsToUpdateState',
	            value: function bindEventsToUpdateState() {
	                var _this3 = this;

	                _constants.EVENTS.forEach(function (event) {
	                    _this3.videoEl.addEventListener(event.toLowerCase(), _this3.updateState);
	                });

	                _constants.TRACKEVENTS.forEach(function (event) {
	                    // TODO: JSDom does not have this method on
	                    // `textTracks`. Investigate so we can test this without this check.
	                    _this3.videoEl.textTracks.addEventListener && _this3.videoEl.textTracks.addEventListener(event.toLowerCase(), _this3.updateState);
	                });

	                // If <source> elements are used instead of a src attribute then
	                // errors for unsupported format do not bubble up to the <video>.
	                // Do this manually by listening to the last <source> error event
	                // to force an update.
	                // https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Using_HTML5_audio_and_video
	                var sources = this.videoEl.getElementsByTagName('source');
	                if (sources.length) {
	                    var lastSource = sources[sources.length - 1];
	                    lastSource.addEventListener('error', this.updateState);
	                }
	            }
	        }, {
	            key: 'unbindEvents',
	            value: function unbindEvents() {
	                var _this4 = this;

	                _constants.EVENTS.forEach(function (event) {
	                    _this4.videoEl.removeEventListener(event.toLowerCase(), _this4.updateState);
	                });

	                _constants.TRACKEVENTS.forEach(function (event) {
	                    // TODO: JSDom does not have this method on
	                    // `textTracks`. Investigate so we can test this without this check.
	                    _this4.videoEl.textTracks.removeEventListener && _this4.videoEl.textTracks.removeEventListener(event.toLowerCase(), _this4.updateState);
	                });

	                var sources = this.videoEl.getElementsByTagName('source');
	                if (sources.length) {
	                    var lastSource = sources[sources.length - 1];
	                    lastSource.removeEventListener('error', this.updateState);
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.unbindEvents();
	            }

	            // Stop `this.el` from being null briefly on every render,
	            // see: https://github.com/mderrick/react-html5video/pull/65

	        }, {
	            key: 'setRef',
	            value: function setRef(el) {
	                this.el = (0, _reactDom.findDOMNode)(el);
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                this.videoEl = this.el.getElementsByTagName('video')[0];
	                this.bindEventsToUpdateState();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var stateProps = mapStateToProps(this.state, this.props);
	                var videoElProps = mapVideoElToProps(this.videoEl, this.state, this.props);
	                return _react2.default.createElement(
	                    'div',
	                    { ref: this.setRef.bind(this) },
	                    _react2.default.createElement(BaseComponent, mergeProps(stateProps, videoElProps, this.props))
	                );
	            }
	        }]);
	        return Video;
	    }(_react.Component);
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	module.exports = __webpack_require__(16).Object.getPrototypeOf;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(6);
	var $getPrototypeOf = __webpack_require__(8);

	__webpack_require__(14)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(7);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(9);
	var toObject = __webpack_require__(6);
	var IE_PROTO = __webpack_require__(10)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(11)('keys');
	var uid = __webpack_require__(13);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(15);
	var core = __webpack_require__(16);
	var fails = __webpack_require__(25);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var core = __webpack_require__(16);
	var ctx = __webpack_require__(17);
	var hide = __webpack_require__(19);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(18);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var createDesc = __webpack_require__(28);
	module.exports = __webpack_require__(24) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(21);
	var IE8_DOM_DEFINE = __webpack_require__(23);
	var toPrimitive = __webpack_require__(27);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(24) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(24) && !__webpack_require__(25)(function () {
	  return Object.defineProperty(__webpack_require__(26)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(25)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	var document = __webpack_require__(12).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(22);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _defineProperty = __webpack_require__(31);

	var _defineProperty2 = _interopRequireDefault(_defineProperty);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(32), __esModule: true };

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(33);
	var $Object = __webpack_require__(16).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(15);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _typeof2 = __webpack_require__(35);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _iterator = __webpack_require__(36);

	var _iterator2 = _interopRequireDefault(_iterator);

	var _symbol = __webpack_require__(65);

	var _symbol2 = _interopRequireDefault(_symbol);

	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(38);
	__webpack_require__(60);
	module.exports = __webpack_require__(64).f('iterator');


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(39)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(41)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(40);
	var defined = __webpack_require__(7);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(42);
	var $export = __webpack_require__(15);
	var redefine = __webpack_require__(43);
	var hide = __webpack_require__(19);
	var has = __webpack_require__(9);
	var Iterators = __webpack_require__(44);
	var $iterCreate = __webpack_require__(45);
	var setToStringTag = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(8);
	var ITERATOR = __webpack_require__(59)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(19);


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(46);
	var descriptor = __webpack_require__(28);
	var setToStringTag = __webpack_require__(58);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(19)(IteratorPrototype, __webpack_require__(59)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(21);
	var dPs = __webpack_require__(47);
	var enumBugKeys = __webpack_require__(56);
	var IE_PROTO = __webpack_require__(10)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(26)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(57).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var anObject = __webpack_require__(21);
	var getKeys = __webpack_require__(48);

	module.exports = __webpack_require__(24) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(49);
	var enumBugKeys = __webpack_require__(56);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(9);
	var toIObject = __webpack_require__(50);
	var arrayIndexOf = __webpack_require__(53)(false);
	var IE_PROTO = __webpack_require__(10)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(51);
	var defined = __webpack_require__(7);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(52);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(50);
	var toLength = __webpack_require__(54);
	var toAbsoluteIndex = __webpack_require__(55);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(40);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(40);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(12).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(20).f;
	var has = __webpack_require__(9);
	var TAG = __webpack_require__(59)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(11)('wks');
	var uid = __webpack_require__(13);
	var Symbol = __webpack_require__(12).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(61);
	var global = __webpack_require__(12);
	var hide = __webpack_require__(19);
	var Iterators = __webpack_require__(44);
	var TO_STRING_TAG = __webpack_require__(59)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(62);
	var step = __webpack_require__(63);
	var Iterators = __webpack_require__(44);
	var toIObject = __webpack_require__(50);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(41)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(59);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(66), __esModule: true };

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67);
	__webpack_require__(77);
	__webpack_require__(78);
	__webpack_require__(79);
	module.exports = __webpack_require__(16).Symbol;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(12);
	var has = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(24);
	var $export = __webpack_require__(15);
	var redefine = __webpack_require__(43);
	var META = __webpack_require__(68).KEY;
	var $fails = __webpack_require__(25);
	var shared = __webpack_require__(11);
	var setToStringTag = __webpack_require__(58);
	var uid = __webpack_require__(13);
	var wks = __webpack_require__(59);
	var wksExt = __webpack_require__(64);
	var wksDefine = __webpack_require__(69);
	var enumKeys = __webpack_require__(70);
	var isArray = __webpack_require__(73);
	var anObject = __webpack_require__(21);
	var toIObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(27);
	var createDesc = __webpack_require__(28);
	var _create = __webpack_require__(46);
	var gOPNExt = __webpack_require__(74);
	var $GOPD = __webpack_require__(76);
	var $DP = __webpack_require__(20);
	var $keys = __webpack_require__(48);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(75).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(72).f = $propertyIsEnumerable;
	  __webpack_require__(71).f = $getOwnPropertySymbols;

	  if (DESCRIPTORS && !__webpack_require__(42)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(19)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(13)('meta');
	var isObject = __webpack_require__(22);
	var has = __webpack_require__(9);
	var setDesc = __webpack_require__(20).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(25)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var core = __webpack_require__(16);
	var LIBRARY = __webpack_require__(42);
	var wksExt = __webpack_require__(64);
	var defineProperty = __webpack_require__(20).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(48);
	var gOPS = __webpack_require__(71);
	var pIE = __webpack_require__(72);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(52);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(50);
	var gOPN = __webpack_require__(75).f;
	var toString = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(49);
	var hiddenKeys = __webpack_require__(56).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(72);
	var createDesc = __webpack_require__(28);
	var toIObject = __webpack_require__(50);
	var toPrimitive = __webpack_require__(27);
	var has = __webpack_require__(9);
	var IE8_DOM_DEFINE = __webpack_require__(23);
	var gOPD = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(24) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(69)('asyncIterator');


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(69)('observable');


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _setPrototypeOf = __webpack_require__(81);

	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

	var _create = __webpack_require__(85);

	var _create2 = _interopRequireDefault(_create);

	var _typeof2 = __webpack_require__(35);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }

	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(82), __esModule: true };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83);
	module.exports = __webpack_require__(16).Object.setPrototypeOf;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(15);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(84).set });


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(22);
	var anObject = __webpack_require__(21);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(17)(Function.call, __webpack_require__(76).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(87);
	var $Object = __webpack_require__(16).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(15);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(46) });


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _assign = __webpack_require__(89);

	var _assign2 = _interopRequireDefault(_assign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(91);
	module.exports = __webpack_require__(16).Object.assign;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(15);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(92) });


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(48);
	var gOPS = __webpack_require__(71);
	var pIE = __webpack_require__(72);
	var toObject = __webpack_require__(6);
	var IObject = __webpack_require__(51);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(25)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__("./node_modules/react/index.js");

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__("./node_modules/react-dom/index.js");

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var EVENTS = exports.EVENTS = ['abort', 'canPlay', 'canPlayThrough', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'loadedData', 'loadedMetadata', 'loadStart', 'pause', 'play', 'playing', 'progress', 'rateChange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeUpdate', 'volumeChange', 'waiting'];

	var TRACKEVENTS = exports.TRACKEVENTS = ['change', 'addTrack', 'removeTrack'];

	var METHODS = exports.METHODS = ['addTextTrack', 'canPlayType', 'load', 'play', 'pause'];

	var PROPERTIES = exports.PROPERTIES = ['audioTracks', 'autoPlay', 'buffered', 'controller', 'controls', 'currentSrc', 'currentTime', 'defaultMuted', 'defaultPlaybackRate', 'duration', 'ended', 'error', 'loop', 'mediaGroup', 'muted', 'networkState', 'paused', 'playbackRate', 'played', 'preload', 'readyState', 'seekable', 'seeking', 'src', 'startDate', 'textTracks', 'videoTracks', 'volume'];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPercentagePlayed = exports.getPercentageBuffered = exports.toggleTracks = exports.hideTracks = exports.showTrack = exports.toggleFullscreen = exports.toggleMute = exports.unmute = exports.mute = exports.setVolume = exports.setCurrentTime = exports.togglePause = undefined;

	var _toConsumableArray2 = __webpack_require__(97);

	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * These are custom helper methods that are not native
	 * to the HTMLMediaElement API. Pass in the native
	 * Video element, state and optional desired value to
	 * set. To be primarily used in `mapVideoElToProps`.
	 */
	var togglePause = exports.togglePause = function togglePause(videoEl, _ref) {
	    var paused = _ref.paused;

	    if (paused) {
	        videoEl.play();
	    } else {
	        videoEl.pause();
	    }
	};

	var setCurrentTime = exports.setCurrentTime = function setCurrentTime(videoEl, state, value) {
	    videoEl.currentTime = value;
	};

	var setVolume = exports.setVolume = function setVolume(videoEl, state, value) {
	    videoEl.muted = false;
	    videoEl.volume = value;
	};

	var mute = exports.mute = function mute(videoEl) {
	    videoEl.muted = true;
	};

	var unmute = exports.unmute = function unmute(videoEl) {
	    videoEl.muted = false;
	};

	var toggleMute = exports.toggleMute = function toggleMute(videoEl, _ref2) {
	    var volume = _ref2.volume,
	        muted = _ref2.muted;

	    if (muted || volume <= 0) {
	        if (volume <= 0) {
	            videoEl.volume = 1;
	        }
	        videoEl.muted = false;
	    } else {
	        videoEl.muted = true;
	    }
	};

	var toggleFullscreen = exports.toggleFullscreen = function toggleFullscreen(videoEl) {
	    videoEl.requestFullScreen = videoEl.requestFullscreen || videoEl.msRequestFullscreen || videoEl.mozRequestFullScreen || videoEl.webkitRequestFullscreen;
	    document.exitFullscreen = document.exitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen;
	    var fullscreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
	    if (fullscreenElement === videoEl) {
	        document.exitFullscreen();
	    } else {
	        videoEl.requestFullScreen();
	    }
	};

	var showTrack = exports.showTrack = function showTrack(_ref3, track) {
	    var textTracks = _ref3.textTracks;

	    hideTracks({ textTracks: textTracks });
	    track.mode = track.SHOWING || 'showing';
	};

	var hideTracks = exports.hideTracks = function hideTracks(_ref4) {
	    var textTracks = _ref4.textTracks;

	    for (var i = 0; i < textTracks.length; i++) {
	        textTracks[i].mode = textTracks[i].DISABLED || 'disabled';
	    }
	};

	var toggleTracks = exports.toggleTracks = function () {
	    var previousTrack = void 0;
	    return function (_ref5) {
	        var textTracks = _ref5.textTracks;

	        var currentTrack = [].concat((0, _toConsumableArray3.default)(textTracks)).filter(function (track) {
	            return track.mode === track.SHOWING || track.mode === 'showing';
	        })[0];
	        if (currentTrack) {
	            hideTracks({ textTracks: textTracks });
	            previousTrack = currentTrack;
	        } else {
	            showTrack({ textTracks: textTracks }, previousTrack || textTracks[0]);
	        }
	    };
	}();

	/**
	 * Custom getter methods that are commonly used
	 * across video layouts. To be primarily used in
	 * `mapStateToProps`
	 */
	var getPercentageBuffered = exports.getPercentageBuffered = function getPercentageBuffered(_ref6) {
	    var buffered = _ref6.buffered,
	        duration = _ref6.duration;
	    return buffered && buffered.length && buffered.end(buffered.length - 1) / duration * 100 || 0;
	};

	var getPercentagePlayed = exports.getPercentagePlayed = function getPercentagePlayed(_ref7) {
	    var currentTime = _ref7.currentTime,
	        duration = _ref7.duration;
	    return currentTime / duration * 100;
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _from = __webpack_require__(98);

	var _from2 = _interopRequireDefault(_from);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }

	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(38);
	__webpack_require__(100);
	module.exports = __webpack_require__(16).Array.from;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(17);
	var $export = __webpack_require__(15);
	var toObject = __webpack_require__(6);
	var call = __webpack_require__(101);
	var isArrayIter = __webpack_require__(102);
	var toLength = __webpack_require__(54);
	var createProperty = __webpack_require__(103);
	var getIterFn = __webpack_require__(104);

	$export($export.S + $export.F * !__webpack_require__(106)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(21);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(44);
	var ITERATOR = __webpack_require__(59)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(20);
	var createDesc = __webpack_require__(28);

	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(105);
	var ITERATOR = __webpack_require__(59)('iterator');
	var Iterators = __webpack_require__(44);
	module.exports = __webpack_require__(16).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(52);
	var TAG = __webpack_require__(59)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(59)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Overlay = exports.Fullscreen = exports.PlayPause = exports.Captions = exports.Volume = exports.Seek = exports.Time = exports.DefaultPlayer = exports.default = undefined;

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _objectWithoutProperties2 = __webpack_require__(108);

	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(109);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _video = __webpack_require__(2);

	var _video2 = _interopRequireDefault(_video);

	var _copy = __webpack_require__(110);

	var _copy2 = _interopRequireDefault(_copy);

	var _api = __webpack_require__(96);

	var _DefaultPlayer = __webpack_require__(111);

	var _DefaultPlayer2 = _interopRequireDefault(_DefaultPlayer);

	var _Time = __webpack_require__(115);

	var _Time2 = _interopRequireDefault(_Time);

	var _Seek = __webpack_require__(118);

	var _Seek2 = _interopRequireDefault(_Seek);

	var _Volume = __webpack_require__(121);

	var _Volume2 = _interopRequireDefault(_Volume);

	var _Captions = __webpack_require__(126);

	var _Captions2 = _interopRequireDefault(_Captions);

	var _PlayPause = __webpack_require__(130);

	var _PlayPause2 = _interopRequireDefault(_PlayPause);

	var _Fullscreen = __webpack_require__(135);

	var _Fullscreen2 = _interopRequireDefault(_Fullscreen);

	var _Overlay = __webpack_require__(139);

	var _Overlay2 = _interopRequireDefault(_Overlay);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var DefaultPlayer = function DefaultPlayer(_ref) {
	    var copy = _ref.copy,
	        video = _ref.video,
	        style = _ref.style,
	        controls = _ref.controls,
	        children = _ref.children,
	        className = _ref.className,
	        onSeekChange = _ref.onSeekChange,
	        onVolumeChange = _ref.onVolumeChange,
	        onVolumeClick = _ref.onVolumeClick,
	        onCaptionsClick = _ref.onCaptionsClick,
	        onPlayPauseClick = _ref.onPlayPauseClick,
	        onFullscreenClick = _ref.onFullscreenClick,
	        onCaptionsItemClick = _ref.onCaptionsItemClick,
	        restProps = (0, _objectWithoutProperties3.default)(_ref, ['copy', 'video', 'style', 'controls', 'children', 'className', 'onSeekChange', 'onVolumeChange', 'onVolumeClick', 'onCaptionsClick', 'onPlayPauseClick', 'onFullscreenClick', 'onCaptionsItemClick']);

	    return _react2.default.createElement(
	        'div',
	        { className: [_DefaultPlayer2.default.component, className].join(' '),
	            style: style },
	        _react2.default.createElement(
	            'video',
	            (0, _extends3.default)({
	                className: _DefaultPlayer2.default.video
	            }, restProps),
	            children
	        ),
	        _react2.default.createElement(_Overlay2.default, (0, _extends3.default)({
	            onClick: onPlayPauseClick
	        }, video)),
	        controls && controls.length && !video.error ? _react2.default.createElement(
	            'div',
	            { className: _DefaultPlayer2.default.controls },
	            controls.map(function (control, i) {
	                switch (control) {
	                    case 'Seek':
	                        return _react2.default.createElement(_Seek2.default, (0, _extends3.default)({
	                            key: i,
	                            ariaLabel: copy.seek,
	                            className: _DefaultPlayer2.default.seek,
	                            onChange: onSeekChange
	                        }, video));
	                    case 'PlayPause':
	                        return _react2.default.createElement(_PlayPause2.default, (0, _extends3.default)({
	                            key: i,
	                            ariaLabelPlay: copy.play,
	                            ariaLabelPause: copy.pause,
	                            onClick: onPlayPauseClick
	                        }, video));
	                    case 'Fullscreen':
	                        return _react2.default.createElement(_Fullscreen2.default, (0, _extends3.default)({
	                            key: i,
	                            ariaLabel: copy.fullscreen,
	                            onClick: onFullscreenClick
	                        }, video));
	                    case 'Time':
	                        return _react2.default.createElement(_Time2.default, (0, _extends3.default)({
	                            key: i
	                        }, video));
	                    case 'Volume':
	                        return _react2.default.createElement(_Volume2.default, (0, _extends3.default)({
	                            key: i,
	                            onClick: onVolumeClick,
	                            onChange: onVolumeChange,
	                            ariaLabelMute: copy.mute,
	                            ariaLabelUnmute: copy.unmute,
	                            ariaLabelVolume: copy.volume
	                        }, video));
	                    case 'Captions':
	                        return video.textTracks && video.textTracks.length ? _react2.default.createElement(_Captions2.default, (0, _extends3.default)({
	                            key: i,
	                            onClick: onCaptionsClick,
	                            ariaLabel: copy.captions,
	                            onItemClick: onCaptionsItemClick
	                        }, video)) : null;
	                    default:
	                        return null;
	                }
	            })
	        ) : null
	    );
	};

	var controls = ['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen', 'Captions'];

	DefaultPlayer.defaultProps = {
	    copy: _copy2.default,
	    controls: controls,
	    video: {}
	};

	DefaultPlayer.propTypes = {
	    copy: _propTypes2.default.object.isRequired,
	    controls: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(controls)),
	    video: _propTypes2.default.object.isRequired
	};

	var connectedPlayer = (0, _video2.default)(DefaultPlayer, function (_ref2) {
	    var networkState = _ref2.networkState,
	        readyState = _ref2.readyState,
	        error = _ref2.error,
	        restState = (0, _objectWithoutProperties3.default)(_ref2, ['networkState', 'readyState', 'error']);
	    return {
	        video: (0, _extends3.default)({
	            readyState: readyState,
	            networkState: networkState,
	            error: error || networkState === 3,
	            // TODO: This is not pretty. Doing device detection to remove
	            // spinner on iOS devices for a quick and dirty win. We should see if
	            // we can use the same readyState check safely across all browsers.
	            loading: readyState < (/iPad|iPhone|iPod/.test(navigator.userAgent) ? 1 : 4),
	            percentagePlayed: (0, _api.getPercentagePlayed)(restState),
	            percentageBuffered: (0, _api.getPercentageBuffered)(restState)
	        }, restState)
	    };
	}, function (videoEl, state) {
	    return {
	        onFullscreenClick: function onFullscreenClick() {
	            return (0, _api.toggleFullscreen)(videoEl.parentElement);
	        },
	        onVolumeClick: function onVolumeClick() {
	            return (0, _api.toggleMute)(videoEl, state);
	        },
	        onCaptionsClick: function onCaptionsClick() {
	            return (0, _api.toggleTracks)(state);
	        },
	        onPlayPauseClick: function onPlayPauseClick() {
	            return (0, _api.togglePause)(videoEl, state);
	        },
	        onCaptionsItemClick: function onCaptionsItemClick(track) {
	            return (0, _api.showTrack)(state, track);
	        },
	        onVolumeChange: function onVolumeChange(e) {
	            return (0, _api.setVolume)(videoEl, state, e.target.value);
	        },
	        onSeekChange: function onSeekChange(e) {
	            return (0, _api.setCurrentTime)(videoEl, state, e.target.value * state.duration / 100);
	        }
	    };
	});

	exports.default = connectedPlayer;
	exports.DefaultPlayer = DefaultPlayer;
	exports.Time = _Time2.default;
	exports.Seek = _Seek2.default;
	exports.Volume = _Volume2.default;
	exports.Captions = _Captions2.default;
	exports.PlayPause = _PlayPause2.default;
	exports.Fullscreen = _Fullscreen2.default;
	exports.Overlay = _Overlay2.default;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (obj, keys) {
	  var target = {};

	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }

	  return target;
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__("./node_modules/prop-types/index.js");

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var copy = {
	    play: 'Play video',
	    pause: 'Pause video',
	    mute: 'Mute video',
	    unmute: 'Unmute video',
	    volume: 'Change volume',
	    fullscreen: 'View video fullscreen',
	    seek: 'Seek video',
	    captions: 'Toggle captions'
	};

	exports.default = copy;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-DefaultPlayer_component","video":"rh5v-DefaultPlayer_video","controls":"rh5v-DefaultPlayer_controls","seek":"rh5v-DefaultPlayer_seek"};

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _Time = __webpack_require__(116);

	var _Time2 = _interopRequireDefault(_Time);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var formatTime = function formatTime(seconds) {
	    var date = new Date(Date.UTC(1970, 1, 1, 0, 0, 0, 0));
	    seconds = isNaN(seconds) || seconds > 86400 ? 0 : Math.floor(seconds);
	    date.setSeconds(seconds);
	    var duration = date.toISOString().substr(11, 8).replace(/^0{1,2}:?0{0,1}/, '');
	    return duration;
	};

	exports.default = function (_ref) {
	    var currentTime = _ref.currentTime,
	        duration = _ref.duration,
	        className = _ref.className;

	    return _react2.default.createElement(
	        'div',
	        { className: [_Time2.default.component, className].join(' ') },
	        _react2.default.createElement(
	            'span',
	            { className: _Time2.default.current },
	            formatTime(currentTime)
	        ),
	        '/',
	        _react2.default.createElement(
	            'span',
	            { className: _Time2.default.duration },
	            formatTime(duration)
	        )
	    );
	};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-Time_component","current":"rh5v-Time_current","duration":"rh5v-Time_duration"};

/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _Seek = __webpack_require__(119);

	var _Seek2 = _interopRequireDefault(_Seek);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (_ref) {
	    var onChange = _ref.onChange,
	        percentagePlayed = _ref.percentagePlayed,
	        percentageBuffered = _ref.percentageBuffered,
	        className = _ref.className,
	        ariaLabel = _ref.ariaLabel;

	    return _react2.default.createElement(
	        'div',
	        { className: [_Seek2.default.component, className].join(' ') },
	        _react2.default.createElement(
	            'div',
	            { className: _Seek2.default.track },
	            _react2.default.createElement('div', {
	                className: _Seek2.default.buffer,
	                style: {
	                    width: (percentageBuffered || 0) + '%'
	                } }),
	            _react2.default.createElement('div', {
	                className: _Seek2.default.fill,
	                style: {
	                    width: (percentagePlayed || 0) + '%'
	                } }),
	            _react2.default.createElement('input', {
	                min: '0',
	                step: 1,
	                max: '100',
	                type: 'range',
	                orient: 'horizontal',
	                onChange: onChange,
	                'aria-label': ariaLabel,
	                className: _Seek2.default.input,
	                value: percentagePlayed || 0 })
	        )
	    );
	};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-Seek_component","track":"rh5v-Seek_track","buffer":"rh5v-Seek_buffer","fill":"rh5v-Seek_fill","input":"rh5v-Seek_input"};

/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _Volume = __webpack_require__(122);

	var _Volume2 = _interopRequireDefault(_Volume);

	var _volume_off = __webpack_require__(124);

	var _volume_off2 = _interopRequireDefault(_volume_off);

	var _volume_up = __webpack_require__(125);

	var _volume_up2 = _interopRequireDefault(_volume_up);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (_ref) {
	    var onChange = _ref.onChange,
	        onClick = _ref.onClick,
	        volume = _ref.volume,
	        muted = _ref.muted,
	        className = _ref.className,
	        ariaLabelMute = _ref.ariaLabelMute,
	        ariaLabelUnmute = _ref.ariaLabelUnmute,
	        ariaLabelVolume = _ref.ariaLabelVolume;

	    var volumeValue = muted || !volume ? 0 : +volume;
	    var isSilent = muted || volume <= 0;
	    return _react2.default.createElement(
	        'div',
	        { className: [_Volume2.default.component, className].join(' ') },
	        _react2.default.createElement(
	            'button',
	            {
	                'aria-label': isSilent ? ariaLabelUnmute : ariaLabelMute,
	                className: _Volume2.default.button,
	                onClick: onClick,
	                type: 'button' },
	            isSilent ? _react2.default.createElement(_volume_off2.default, {
	                height: 20,
	                width: 20,
	                className: _Volume2.default.icon,
	                fill: '#fff' }) : _react2.default.createElement(_volume_up2.default, {
	                height: 20,
	                width: 20,
	                className: _Volume2.default.icon,
	                fill: '#fff' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _Volume2.default.slider },
	            _react2.default.createElement(
	                'div',
	                { className: _Volume2.default.track },
	                _react2.default.createElement('div', {
	                    className: _Volume2.default.fill,
	                    style: {
	                        height: volumeValue * 100 + '%'
	                    } }),
	                _react2.default.createElement('input', {
	                    min: '0',
	                    step: 0.1,
	                    max: '1',
	                    type: 'range',
	                    orient: 'vertical',
	                    onChange: onChange,
	                    'aria-label': ariaLabelVolume,
	                    className: _Volume2.default.input,
	                    value: volumeValue })
	            )
	        )
	    );
	};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-Volume_component","button":"rh5v-Volume_button","icon":"rh5v-Volume_icon","slider":"rh5v-Volume_slider","track":"rh5v-Volume_track","fill":"rh5v-Volume_fill","input":"rh5v-Volume_input"};

/***/ }),
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M12 3.984v4.219L9.891 6.094zM4.266 3L21 19.734 19.734 21l-2.063-2.063c-1.078.844-2.297 1.5-3.656 1.828v-2.063c.844-.234 1.594-.656 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016H2.999v-6h4.734L2.999 4.264zm14.718 9c0-3.188-2.063-5.859-4.969-6.703V3.234c4.031.891 6.984 4.5 6.984 8.766a8.87 8.87 0 0 1-1.031 4.172l-1.5-1.547A6.901 6.901 0 0 0 18.984 12zM16.5 12c0 .234 0 .422-.047.609l-2.438-2.438V7.968c1.5.75 2.484 2.25 2.484 4.031z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M14.016 3.234C18.047 4.125 21 7.734 21 12s-2.953 7.875-6.984 8.766v-2.063c2.906-.844 4.969-3.516 4.969-6.703s-2.063-5.859-4.969-6.703V3.234zM16.5 12a4.451 4.451 0 0 1-2.484 4.031V7.968c1.5.75 2.484 2.25 2.484 4.031zM3 9h3.984L12 3.984v16.031l-5.016-5.016H3v-6z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _toConsumableArray2 = __webpack_require__(97);

	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _Captions = __webpack_require__(127);

	var _Captions2 = _interopRequireDefault(_Captions);

	var _closed_caption = __webpack_require__(129);

	var _closed_caption2 = _interopRequireDefault(_closed_caption);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (_ref) {
	    var textTracks = _ref.textTracks,
	        onClick = _ref.onClick,
	        onItemClick = _ref.onItemClick,
	        className = _ref.className,
	        ariaLabel = _ref.ariaLabel;

	    return _react2.default.createElement(
	        'div',
	        { className: [_Captions2.default.component, className].join(' ') },
	        _react2.default.createElement(
	            'button',
	            {
	                type: 'button',
	                onClick: onClick,
	                'aria-label': ariaLabel,
	                className: _Captions2.default.button },
	            _react2.default.createElement(_closed_caption2.default, {
	                className: _Captions2.default.icon,
	                fill: '#fff' })
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: _Captions2.default.trackList },
	            textTracks && [].concat((0, _toConsumableArray3.default)(textTracks)).map(function (track) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: track.language,
	                        className: track.mode === track.SHOWING || track.mode == 'showing' ? _Captions2.default.activeTrackItem : _Captions2.default.trackItem,
	                        onClick: onItemClick.bind(undefined, track) },
	                    track.label
	                );
	            })
	        )
	    );
	};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-Captions_component","button":"rh5v-Captions_button","icon":"rh5v-Captions_icon","trackList":"rh5v-Captions_trackList","trackItem":"rh5v-Captions_trackItem","activeTrackItem":"rh5v-Captions_activeTrackItem rh5v-Captions_trackItem"};

/***/ }),
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M18 11.016V9.985a.96.96 0 0 0-.984-.984h-3c-.563 0-1.031.422-1.031.984v4.031c0 .563.469.984 1.031.984h3a.96.96 0 0 0 .984-.984v-1.031h-1.5v.516h-2.016v-3H16.5v.516H18zm-6.984 0V9.985c0-.563-.469-.984-1.031-.984h-3a.96.96 0 0 0-.984.984v4.031a.96.96 0 0 0 .984.984h3c.563 0 1.031-.422 1.031-.984v-1.031h-1.5v.516H7.5v-3h2.016v.516h1.5zm7.968-7.032C20.062 3.984 21 4.922 21 6v12c0 1.078-.938 2.016-2.016 2.016H5.015c-1.125 0-2.016-.938-2.016-2.016V6c0-1.078.891-2.016 2.016-2.016h13.969z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _PlayPause = __webpack_require__(131);

	var _PlayPause2 = _interopRequireDefault(_PlayPause);

	var _play_arrow = __webpack_require__(133);

	var _play_arrow2 = _interopRequireDefault(_play_arrow);

	var _pause = __webpack_require__(134);

	var _pause2 = _interopRequireDefault(_pause);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (_ref) {
	    var onClick = _ref.onClick,
	        paused = _ref.paused,
	        className = _ref.className,
	        ariaLabelPlay = _ref.ariaLabelPlay,
	        ariaLabelPause = _ref.ariaLabelPause;

	    return _react2.default.createElement(
	        'div',
	        { className: [_PlayPause2.default.component, className].join(' ') },
	        _react2.default.createElement(
	            'button',
	            {
	                className: _PlayPause2.default.button,
	                onClick: onClick,
	                'aria-label': paused ? ariaLabelPlay : ariaLabelPause,
	                type: 'button' },
	            paused ? _react2.default.createElement(_play_arrow2.default, {
	                className: _PlayPause2.default.icon,
	                fill: '#fff' }) : _react2.default.createElement(_pause2.default, {
	                className: _PlayPause2.default.icon,
	                fill: '#fff' })
	        )
	    );
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-PlayPause_component","button":"rh5v-PlayPause_button","icon":"rh5v-PlayPause_icon"};

/***/ }),
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M8.016 5.016L18.985 12 8.016 18.984V5.015z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _Fullscreen = __webpack_require__(136);

	var _Fullscreen2 = _interopRequireDefault(_Fullscreen);

	var _fullscreen = __webpack_require__(138);

	var _fullscreen2 = _interopRequireDefault(_fullscreen);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (_ref) {
	    var onClick = _ref.onClick,
	        className = _ref.className,
	        ariaLabel = _ref.ariaLabel;

	    return _react2.default.createElement(
	        'div',
	        { className: [_Fullscreen2.default.component, className].join(' ') },
	        _react2.default.createElement(
	            'button',
	            {
	                type: 'button',
	                onClick: onClick,
	                'aria-label': ariaLabel,
	                className: _Fullscreen2.default.button },
	            _react2.default.createElement(_fullscreen2.default, {
	                fill: '#fff',
	                className: _Fullscreen2.default.icon })
	        )
	    );
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-Fullscreen_component","button":"rh5v-Fullscreen_button","icon":"rh5v-Fullscreen_icon"};

/***/ }),
/* 137 */,
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M14.016 5.016h4.969v4.969h-1.969v-3h-3V5.016zm3 12v-3h1.969v4.969h-4.969v-1.969h3zm-12-7.032V5.015h4.969v1.969h-3v3H5.016zm1.968 4.032v3h3v1.969H5.015v-4.969h1.969z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	var _Overlay = __webpack_require__(140);

	var _Overlay2 = _interopRequireDefault(_Overlay);

	var _play_arrow = __webpack_require__(133);

	var _play_arrow2 = _interopRequireDefault(_play_arrow);

	var _spin = __webpack_require__(142);

	var _spin2 = _interopRequireDefault(_spin);

	var _report = __webpack_require__(143);

	var _report2 = _interopRequireDefault(_report);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Overlay = function (_Component) {
	    (0, _inherits3.default)(Overlay, _Component);

	    function Overlay() {
	        (0, _classCallCheck3.default)(this, Overlay);
	        return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	    }

	    (0, _createClass3.default)(Overlay, [{
	        key: 'renderContent',
	        value: function renderContent() {
	            var _props = this.props,
	                error = _props.error,
	                paused = _props.paused,
	                loading = _props.loading;

	            var iconProps = {
	                className: _Overlay2.default.icon,
	                height: 40,
	                width: 40,
	                fill: '#fff'
	            };
	            if (error) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _Overlay2.default.inner },
	                    _react2.default.createElement(_report2.default, iconProps)
	                );
	            } else if (loading) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _Overlay2.default.inner },
	                    _react2.default.createElement(_spin2.default, iconProps)
	                );
	            } else if (paused) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _Overlay2.default.inner },
	                    _react2.default.createElement(_play_arrow2.default, iconProps)
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                className = _props2.className,
	                onClick = _props2.onClick;

	            return _react2.default.createElement(
	                'div',
	                { className: [_Overlay2.default.component, className].join(' '),
	                    onClick: onClick },
	                this.renderContent()
	            );
	        }
	    }]);
	    return Overlay;
	}(_react.Component);

	exports.default = Overlay;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"rh5v-Overlay_component","inner":"rh5v-Overlay_inner","icon":"rh5v-Overlay_icon"};

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", className: "uil-ring-alt" }, this.props),
	        _react2.default.createElement("path", { fill: "none", className: "bk", d: "M0 0h100v100H0z" }),
	        _react2.default.createElement("circle", { cx: "50", cy: "50", r: "40", stroke: "#757575", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
	        _react2.default.createElement(
	          "circle",
	          { cx: "50", cy: "50", r: "40", stroke: "#fff", fill: "none", strokeWidth: "6", strokeLinecap: "round" },
	          _react2.default.createElement("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "0", to: "502" }),
	          _react2.default.createElement("animate", { attributeName: "stroke-dasharray", dur: "2s", repeatCount: "indefinite", values: "150.6 100.4;1 250;150.6 100.4" })
	        )
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends2 = __webpack_require__(88);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getPrototypeOf = __webpack_require__(3);

	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

	var _classCallCheck2 = __webpack_require__(29);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(30);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _possibleConstructorReturn2 = __webpack_require__(34);

	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

	var _inherits2 = __webpack_require__(80);

	var _inherits3 = _interopRequireDefault(_inherits2);

	var _react = __webpack_require__(93);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SVG = function (_React$Component) {
	  (0, _inherits3.default)(SVG, _React$Component);

	  function SVG() {
	    (0, _classCallCheck3.default)(this, SVG);
	    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
	  }

	  (0, _createClass3.default)(SVG, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, this.props),
	        _react2.default.createElement("path", { d: "M12.984 12.984v-6h-1.969v6h1.969zM12 17.297c.703 0 1.313-.609 1.313-1.313s-.609-1.266-1.313-1.266-1.313.563-1.313 1.266.609 1.313 1.313 1.313zM15.75 3L21 8.25v7.5L15.75 21h-7.5L3 15.75v-7.5L8.25 3h7.5z" })
	      );
	    }
	  }]);
	  return SVG;
	}(_react2.default.Component);

	exports.default = SVG;

/***/ })
/******/ ]);

/***/ }),

/***/ "./node_modules/react-html5video/dist/styles.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/react-id-swiper/lib/ReactIdSwiper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _swiper = __webpack_require__("./node_modules/swiper/dist/js/swiper.js");

var _swiper2 = _interopRequireDefault(_swiper);

var _objectAssign = __webpack_require__("./node_modules/object-assign/index.js");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _propTypes = __webpack_require__("./node_modules/react-id-swiper/node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactIdSwiper = function (_Component) {
  _inherits(ReactIdSwiper, _Component);

  // Default props
  function ReactIdSwiper(props) {
    _classCallCheck(this, ReactIdSwiper);

    var _this = _possibleConstructorReturn(this, (ReactIdSwiper.__proto__ || Object.getPrototypeOf(ReactIdSwiper)).call(this, props));

    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  // Proptypes


  _createClass(ReactIdSwiper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.swiper = new _swiper2.default(_reactDom2.default.findDOMNode(this), (0, _objectAssign2.default)({}, this.props));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.rebuildOnUpdate && typeof this.swiper !== 'undefined') {
        this.rebuildSwiper();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.children !== this.props.children;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.rebuildOnUpdate && typeof this.swiper !== 'undefined') {
        this.rebuildSwiper();
      } else if (this.props.shouldSwiperUpdate && typeof this.swiper !== 'undefined') {
        this.swiper.update();

        var numSlides = this.swiper.slides.length;
        if (numSlides <= this.swiper.activeIndex) {
          var index = Math.max(numSlides - 1, 0);
          this.swiper.slideTo(index);
        }
      }

      if (this.props.activeSlideKey) {
        var activeSlideId = null;
        var id = 0;
        _react2.default.Children.forEach(this.props.children, function (child) {
          if (child) {
            if (child.key === _this2.props.activeSlideKey) {
              activeSlideId = id;
            }
            id += 1;
          }
        });

        if (activeSlideId !== null) {
          this.swiper.slideTo(activeSlideId);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof this.swiper !== 'undefined') this.swiper.destroy(true, true);
      delete this.swiper;
    }
  }, {
    key: 'rebuildSwiper',
    value: function rebuildSwiper() {
      this.swiper.destroy(true, true);
      this.swiper = new _swiper2.default(_reactDom2.default.findDOMNode(this), (0, _objectAssign2.default)({}, this.props));
    }
  }, {
    key: 'validateClass',
    value: function validateClass(className) {
      if (typeof className !== 'string') return '';
      return className.replace(/\.|#/g, ' ').trim();
    }

    // Scrollbar

  }, {
    key: 'renderScrollBar',
    value: function renderScrollBar() {
      var _props = this.props,
          scrollbar = _props.scrollbar,
          renderCustomScrolbar = _props.renderCustomScrolbar,
          scrollbarCustomizedClass = _props.scrollbarCustomizedClass;

      // Return false if required param is not existed

      if (!scrollbar || !scrollbar.el) return false;

      // Return customized rendering for scrollbar if existed
      if (typeof renderCustomScrolbar === 'function') return renderCustomScrolbar();

      // Validate classnames
      var customizedClass = this.validateClass(scrollbarCustomizedClass);
      var scrollbarClass = this.validateClass(scrollbar.el);

      return _react2.default.createElement('div', { className: [scrollbarClass, customizedClass].join(' ').trim() });
    }

    // Pagination bullets

  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      var _props2 = this.props,
          pagination = _props2.pagination,
          renderCustomPagination = _props2.renderCustomPagination,
          paginationCustomizedClass = _props2.paginationCustomizedClass;

      // Return false if required param is not existed

      if (!pagination || !pagination.el) return false;

      // Return customized rendering for pagination if existed
      if (typeof renderCustomPagination === 'function') return renderCustomPagination();

      var customizedClass = this.validateClass(paginationCustomizedClass);
      var paginationClass = this.validateClass(pagination.el);

      return _react2.default.createElement('div', { className: [paginationClass, customizedClass].join(' ').trim() });
    }

    // Next button

  }, {
    key: 'renderNextButton',
    value: function renderNextButton() {
      var _props3 = this.props,
          navigation = _props3.navigation,
          nextButtonCustomizedClass = _props3.nextButtonCustomizedClass,
          renderCustomNextButton = _props3.renderCustomNextButton;

      // Return false if required param is not existed

      if (!navigation || !navigation.nextEl) return false;

      // Return customized rendering for next button if existed
      if (typeof renderCustomNextButton === 'function') return renderCustomNextButton();

      var customizedClass = this.validateClass(nextButtonCustomizedClass);
      var nextButtonClass = this.validateClass(navigation.nextEl);

      return _react2.default.createElement('div', { className: [nextButtonClass, customizedClass].join(' ').trim() });
    }

    // Prev button

  }, {
    key: 'renderPrevButton',
    value: function renderPrevButton() {
      var _props4 = this.props,
          navigation = _props4.navigation,
          prevButtonCustomizedClass = _props4.prevButtonCustomizedClass,
          renderCustomPrevButton = _props4.renderCustomPrevButton;

      // Return false if required param is not existed

      if (!navigation || !navigation.prevEl) return false;

      // Return customized rendering for next button if existed
      if (typeof renderCustomPrevButton === 'function') return renderCustomPrevButton();

      var customizedClass = this.validateClass(prevButtonCustomizedClass);
      var prevButtonClass = this.validateClass(navigation.prevEl);

      return _react2.default.createElement('div', { className: [prevButtonClass, customizedClass].join(' ').trim() });
    }

    // Parallax

  }, {
    key: 'renderParallax',
    value: function renderParallax() {
      var _props5 = this.props,
          parallax = _props5.parallax,
          renderCustomParallax = _props5.renderCustomParallax,
          parallaxEl = _props5.parallaxEl;

      // Return false if required param is not existed

      if (!parallax || !parallaxEl) return false;

      // Return customized rendering for next button if existed
      if (typeof renderCustomParallax === 'function') return renderCustomParallax();

      var parallaxBgClass = this.validateClass(this.props.parallaxEl.el);

      return _react2.default.createElement('div', { className: parallaxBgClass, 'data-swiper-parallax': this.props.parallaxEl.value });
    }
  }, {
    key: 'renderContent',
    value: function renderContent(e) {
      if (!e) return null;

      var _props6 = this.props,
          slideClass = _props6.slideClass,
          noSwiping = _props6.noSwiping;

      var noSwipingClass = noSwiping ? 'swiper-no-swiping' : '';
      var childProps = _extends({}, e.props, {
        className: [slideClass, e.props.className, noSwipingClass].join(' ').trim()
      });

      return _react2.default.cloneElement(e, _extends({}, childProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          ContainerEl = _props7.ContainerEl,
          WrapperEl = _props7.WrapperEl,
          containerClass = _props7.containerClass,
          wrapperClass = _props7.wrapperClass,
          children = _props7.children,
          rtl = _props7.rtl;

      var rtlProp = rtl ? { dir: 'rtl' } : {};

      return _react2.default.createElement(
        ContainerEl,
        _extends({ className: containerClass }, rtlProp),
        this.renderParallax(),
        _react2.default.createElement(
          WrapperEl,
          { className: wrapperClass },
          _react2.default.Children.map(children, this.renderContent)
        ),
        this.renderPagination(),
        this.renderScrollBar(),
        this.renderNextButton(),
        this.renderPrevButton()
      );
    }
  }]);

  return ReactIdSwiper;
}(_react.Component);

ReactIdSwiper.defaultProps = {
  containerClass: 'swiper-container',
  wrapperClass: 'swiper-wrapper',
  slideClass: 'swiper-slide',
  ContainerEl: 'div',
  WrapperEl: 'div'
};
ReactIdSwiper.propTypes = {
  // react-id-swiper original parameter
  ContainerEl: _propTypes2.default.string,
  WrapperEl: _propTypes2.default.string,
  containerClass: _propTypes2.default.string,
  wrapperClass: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element]),
  rebuildOnUpdate: _propTypes2.default.bool,
  shouldSwiperUpdate: _propTypes2.default.bool,
  prevButtonCustomizedClass: _propTypes2.default.string,
  nextButtonCustomizedClass: _propTypes2.default.string,
  paginationCustomizedClass: _propTypes2.default.string,
  scrollbarCustomizedClass: _propTypes2.default.string,
  activeSlideKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  renderCustomPrevButton: _propTypes2.default.func,
  renderCustomNextButton: _propTypes2.default.func,
  renderCustomScrolbar: _propTypes2.default.func,
  renderCustomPagination: _propTypes2.default.func,
  renderCustomParallax: _propTypes2.default.func,

  // parallax
  parallax: _propTypes2.default.bool,
  parallaxEl: _propTypes2.default.shape({
    el: _propTypes2.default.string,
    value: _propTypes2.default.string
  }),

  // swiper parameter
  init: _propTypes2.default.bool,
  initialSlide: _propTypes2.default.number,
  direction: _propTypes2.default.string,
  rtl: _propTypes2.default.bool,
  speed: _propTypes2.default.number,
  setWrapperSize: _propTypes2.default.bool,
  virtualTranslate: _propTypes2.default.bool,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  autoHeight: _propTypes2.default.bool,
  roundLengths: _propTypes2.default.bool,
  nested: _propTypes2.default.bool,
  uniqueNavElements: _propTypes2.default.bool,
  effect: _propTypes2.default.string,
  runCallbacksOnInit: _propTypes2.default.bool,

  // slides grid
  spaceBetween: _propTypes2.default.number,
  slidesPerView: _propTypes2.default.any,
  slidesPerColumn: _propTypes2.default.number,
  slidesPerColumnFill: _propTypes2.default.string,
  slidesPerGroup: _propTypes2.default.number,
  centeredSlides: _propTypes2.default.bool,
  slidesOffsetBefore: _propTypes2.default.number,
  slidesOffsetAfter: _propTypes2.default.number,
  normalizeSlideIndex: _propTypes2.default.bool,

  // grab cursor
  grabCursor: _propTypes2.default.bool,

  // touches
  touchEventsTarget: _propTypes2.default.string,
  touchRatio: _propTypes2.default.number,
  touchAngle: _propTypes2.default.number,
  simulateTouch: _propTypes2.default.bool,
  shortSwipes: _propTypes2.default.bool,
  longSwipes: _propTypes2.default.bool,
  longSwipesRatio: _propTypes2.default.number,
  longSwipesMs: _propTypes2.default.number,
  followFinger: _propTypes2.default.bool,
  allowTouchMove: _propTypes2.default.bool,
  threshold: _propTypes2.default.number,
  touchMoveStopPropagation: _propTypes2.default.bool,
  iOSEdgeSwipeDetection: _propTypes2.default.bool,
  iOSEdgeSwipeThreshold: _propTypes2.default.number,
  touchReleaseOnEdges: _propTypes2.default.bool,
  passiveListeners: _propTypes2.default.bool,

  // touch resistance
  resistance: _propTypes2.default.bool,
  resistanceRatio: _propTypes2.default.number,

  // swiping / no swiping
  allowSlidePrev: _propTypes2.default.bool,
  allowSlideNext: _propTypes2.default.bool,
  noSwiping: _propTypes2.default.bool,
  noSwipingClass: _propTypes2.default.string,
  swipeHandler: _propTypes2.default.any,

  // clicks
  preventClicks: _propTypes2.default.bool,
  preventClicksPropagation: _propTypes2.default.bool,
  slideToClickedSlide: _propTypes2.default.bool,

  // freemode
  freeMode: _propTypes2.default.bool,
  freeModeMomentum: _propTypes2.default.bool,
  freeModeMomentumRatio: _propTypes2.default.number,
  freeModeMomentumVelocityRatio: _propTypes2.default.number,
  freeModeMomentumBounce: _propTypes2.default.bool,
  freeModeMomentumBounceRatio: _propTypes2.default.number,
  freeModeMinimumVelocity: _propTypes2.default.number,
  freeModeSticky: _propTypes2.default.bool,

  // progress
  watchSlidesProgress: _propTypes2.default.bool,
  watchSlidesVisibility: _propTypes2.default.bool,

  // images
  preloadImages: _propTypes2.default.bool,
  updateOnImagesReady: _propTypes2.default.bool,

  // loop
  loop: _propTypes2.default.bool,
  loopAdditionalSlides: _propTypes2.default.number,
  loopedSlides: _propTypes2.default.number,
  loopFillGroupWithBlank: _propTypes2.default.bool,

  // breakpoints
  breakpoints: _propTypes2.default.object,

  // observer
  observer: _propTypes2.default.bool,
  observeParents: _propTypes2.default.bool,

  // namespace
  containerModifierClass: _propTypes2.default.string,
  slideClass: _propTypes2.default.string,
  slideActiveClass: _propTypes2.default.string,
  slideDuplicatedActiveClass: _propTypes2.default.string,
  slideVisibleClass: _propTypes2.default.string,
  slideDuplicateClass: _propTypes2.default.string,
  slideNextClass: _propTypes2.default.string,
  slideDuplicatedNextClass: _propTypes2.default.string,
  slidePrevClass: _propTypes2.default.string,
  slideDuplicatedPrevClass: _propTypes2.default.string,

  // autoplay
  autoplay: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    delay: _propTypes2.default.number,
    stopOnLast: _propTypes2.default.bool,
    disableOnInteraction: _propTypes2.default.bool
  })]),

  // pagination
  pagination: _propTypes2.default.shape({
    el: _propTypes2.default.string,
    type: _propTypes2.default.string,
    bulletElement: _propTypes2.default.string,
    dynamicBullets: _propTypes2.default.bool,
    hideOnClick: _propTypes2.default.bool,
    clickable: _propTypes2.default.bool,
    renderBullet: _propTypes2.default.func,
    renderFraction: _propTypes2.default.func,
    renderProgressbar: _propTypes2.default.func,
    renderCustom: _propTypes2.default.func,
    bulletClass: _propTypes2.default.string,
    bulletActiveClass: _propTypes2.default.string,
    modifierClass: _propTypes2.default.string,
    currentClass: _propTypes2.default.string,
    totalClass: _propTypes2.default.string,
    hiddenClass: _propTypes2.default.string,
    progressbarFillClass: _propTypes2.default.string,
    clickableClass: _propTypes2.default.string
  }),

  // scrollbar
  scrollbar: _propTypes2.default.shape({
    el: _propTypes2.default.any,
    hide: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    snapOnRelease: _propTypes2.default.bool,
    dragSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  }),

  // navigation
  navigation: _propTypes2.default.shape({
    nextEl: _propTypes2.default.string,
    prevEl: _propTypes2.default.string,
    hideOnClick: _propTypes2.default.bool,
    disabledClass: _propTypes2.default.string,
    hiddenClass: _propTypes2.default.string
  }),

  // a11y
  a11y: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    prevSlideMessage: _propTypes2.default.string,
    nextSlideMessage: _propTypes2.default.string,
    firstSlideMessage: _propTypes2.default.string,
    lastSlideMessage: _propTypes2.default.string,
    paginationBulletMessage: _propTypes2.default.string,
    notificationClass: _propTypes2.default.string
  })]),

  // zoom
  zoom: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    maxRatio: _propTypes2.default.number,
    minRatio: _propTypes2.default.number,
    toggle: _propTypes2.default.bool,
    containerClass: _propTypes2.default.string,
    zoomedSlideClass: _propTypes2.default.string
  })]),

  // keyboard
  keyboard: _propTypes2.default.bool,

  // mousewheel
  mousewheel: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    forceToAxis: _propTypes2.default.bool,
    releaseOnEdges: _propTypes2.default.bool,
    invert: _propTypes2.default.bool,
    sensitivity: _propTypes2.default.number,
    eventsTarged: _propTypes2.default.string
  })]),

  // hashNavigation
  hashNavigation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    watchState: _propTypes2.default.bool,
    replaceState: _propTypes2.default.bool
  })]),

  // history
  history: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    key: _propTypes2.default.string,
    replaceState: _propTypes2.default.bool
  })]),

  // lazy
  lazy: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    loadPrevNext: _propTypes2.default.bool,
    loadPrevNextAmount: _propTypes2.default.number,
    loadOnTransitionStart: _propTypes2.default.bool,
    elementClass: _propTypes2.default.string,
    loadingClass: _propTypes2.default.string,
    loadedClass: _propTypes2.default.string,
    preloaderClass: _propTypes2.default.string
  })]),

  // fadeEffect
  fadeEffect: _propTypes2.default.shape({
    crossFade: _propTypes2.default.bool
  }),

  // coverflowEffect
  coverflowEffect: _propTypes2.default.shape({
    slideShadows: _propTypes2.default.bool,
    rotate: _propTypes2.default.number,
    stretch: _propTypes2.default.number,
    depth: _propTypes2.default.number,
    modifier: _propTypes2.default.number
  }),

  // flipEffect
  flipEffect: _propTypes2.default.shape({
    slideShadows: _propTypes2.default.bool,
    limitRotation: _propTypes2.default.bool
  }),

  // cubeEffect
  cubeEffect: _propTypes2.default.shape({
    slideShadows: _propTypes2.default.bool,
    shadow: _propTypes2.default.bool,
    shadowOffset: _propTypes2.default.number,
    shadowScale: _propTypes2.default.number
  }),

  // controller
  controller: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    control: _propTypes2.default.any,
    inverse: _propTypes2.default.bool,
    by: _propTypes2.default.string
  })]),

  // events
  on: _propTypes2.default.shape({
    init: _propTypes2.default.func,
    beforeDestroy: _propTypes2.default.func,
    slideChange: _propTypes2.default.func,
    slideChangeTransitionStart: _propTypes2.default.func,
    slideChangeTransitionEnd: _propTypes2.default.func,
    slideNextTransitionStart: _propTypes2.default.func,
    slideNextTransitionEnd: _propTypes2.default.func,
    slidePrevTransitionStart: _propTypes2.default.func,
    slidePrevTransitionEnd: _propTypes2.default.func,
    transitionStart: _propTypes2.default.func,
    onTransitionEnd: _propTypes2.default.func,
    touchStart: _propTypes2.default.func,
    touchMove: _propTypes2.default.func,
    touchMoveOpposite: _propTypes2.default.func,
    sliderMove: _propTypes2.default.func,
    touchEnd: _propTypes2.default.func,
    click: _propTypes2.default.func,
    tap: _propTypes2.default.func,
    doubleTap: _propTypes2.default.func,
    imagesReady: _propTypes2.default.func,
    progress: _propTypes2.default.func,
    reachBeginning: _propTypes2.default.func,
    reachEnd: _propTypes2.default.func,
    fromEdge: _propTypes2.default.func,
    setTranslate: _propTypes2.default.func,
    setTransition: _propTypes2.default.func,
    resize: _propTypes2.default.func
  })
};
exports.default = ReactIdSwiper;

/***/ }),

/***/ "./node_modules/react-id-swiper/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("./node_modules/react-id-swiper/lib/ReactIdSwiper.js").default;

/***/ }),

/***/ "./node_modules/react-id-swiper/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var ReactPropTypesSecret = __webpack_require__("./node_modules/react-id-swiper/node_modules/prop-types/lib/ReactPropTypesSecret.js");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/react-id-swiper/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/react-id-swiper/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/react-id-swiper/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/react-id-swiper/src/styles/scss/swiper.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1793259545804
      var cssReload = __webpack_require__("./node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./node_modules/react-intl/lib/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__("./node_modules/intl-messageformat/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__("./node_modules/intl-relativeformat/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__("./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__("./node_modules/intl-format-cache/lib/index.js");
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),

/***/ "./node_modules/react-intl/locale-data/ar.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/be.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.be=t())}(this,function(){"use strict";return[{locale:"be",pluralRuleFunction:function(e,t){var a=String(e).split("."),r=Number(a[0])==e,o=r&&a[0].slice(-1),n=r&&a[0].slice(-2);return t?2!=o&&3!=o||12==n||13==n?"other":"few":1==o&&11!=n?"one":o>=2&&o<=4&&(n<12||n>14)?"few":r&&0==o||o>=5&&o<=9||n>=11&&n<=14?"many":"other"},fields:{year:{displayName:"год",relative:{0:"у гэтым годзе",1:"у наступным годзе","-1":"у мінулым годзе"},relativeTime:{future:{one:"праз {0} год",few:"праз {0} гады",many:"праз {0} гадоў",other:"праз {0} года"},past:{one:"{0} год таму",few:"{0} гады таму",many:"{0} гадоў таму",other:"{0} года таму"}}},"year-short":{displayName:"г.",relative:{0:"у гэтым годзе",1:"у наступным годзе","-1":"у мінулым годзе"},relativeTime:{future:{one:"праз {0} г.",few:"праз {0} г.",many:"праз {0} г.",other:"праз {0} г."},past:{one:"{0} г. таму",few:"{0} г. таму",many:"{0} г. таму",other:"{0} г. таму"}}},month:{displayName:"месяц",relative:{0:"у гэтым месяцы",1:"у наступным месяцы","-1":"у мінулым месяцы"},relativeTime:{future:{one:"праз {0} месяц",few:"праз {0} месяцы",many:"праз {0} месяцаў",other:"праз {0} месяца"},past:{one:"{0} месяц таму",few:"{0} месяцы таму",many:"{0} месяцаў таму",other:"{0} месяца таму"}}},"month-short":{displayName:"мес.",relative:{0:"у гэтым месяцы",1:"у наступным месяцы","-1":"у мінулым месяцы"},relativeTime:{future:{one:"праз {0} мес.",few:"праз {0} мес.",many:"праз {0} мес.",other:"праз {0} мес."},past:{one:"{0} мес. таму",few:"{0} мес. таму",many:"{0} мес. таму",other:"{0} мес. таму"}}},day:{displayName:"дзень",relative:{0:"сёння",1:"заўтра",2:"паслязаўтра","-2":"пазаўчора","-1":"учора"},relativeTime:{future:{one:"праз {0} дзень",few:"праз {0} дні",many:"праз {0} дзён",other:"праз {0} дня"},past:{one:"{0} дзень таму",few:"{0} дні таму",many:"{0} дзён таму",other:"{0} дня таму"}}},"day-short":{displayName:"дзень",relative:{0:"сёння",1:"заўтра",2:"паслязаўтра","-2":"пазаўчора","-1":"учора"},relativeTime:{future:{one:"праз {0} дзень",few:"праз {0} дні",many:"праз {0} дзён",other:"праз {0} дня"},past:{one:"{0} дзень таму",few:"{0} дні таму",many:"{0} дзён таму",other:"{0} дня таму"}}},hour:{displayName:"гадзіна",relative:{0:"у гэту гадзіну"},relativeTime:{future:{one:"праз {0} гадзіну",few:"праз {0} гадзіны",many:"праз {0} гадзін",other:"праз {0} гадзіны"},past:{one:"{0} гадзіну таму",few:"{0} гадзіны таму",many:"{0} гадзін таму",other:"{0} гадзіны таму"}}},"hour-short":{displayName:"гадз",relative:{0:"у гэту гадзіну"},relativeTime:{future:{one:"праз {0} гадз",few:"праз {0} гадз",many:"праз {0} гадз",other:"праз {0} гадз"},past:{one:"{0} гадз таму",few:"{0} гадз таму",many:"{0} гадз таму",other:"{0} гадз таму"}}},minute:{displayName:"хвіліна",relative:{0:"у гэту хвіліну"},relativeTime:{future:{one:"праз {0} хвіліну",few:"праз {0} хвіліны",many:"праз {0} хвілін",other:"праз {0} хвіліны"},past:{one:"{0} хвіліну таму",few:"{0} хвіліны таму",many:"{0} хвілін таму",other:"{0} хвіліны таму"}}},"minute-short":{displayName:"хв",relative:{0:"у гэту хвіліну"},relativeTime:{future:{one:"праз {0} хв",few:"праз {0} хв",many:"праз {0} хв",other:"праз {0} хв"},past:{one:"{0} хв таму",few:"{0} хв таму",many:"{0} хв таму",other:"{0} хв таму"}}},second:{displayName:"секунда",relative:{0:"цяпер"},relativeTime:{future:{one:"праз {0} секунду",few:"праз {0} секунды",many:"праз {0} секунд",other:"праз {0} секунды"},past:{one:"{0} секунду таму",few:"{0} секунды таму",many:"{0} секунд таму",other:"{0} секунды таму"}}},"second-short":{displayName:"с",relative:{0:"цяпер"},relativeTime:{future:{one:"праз {0} с",few:"праз {0} с",many:"праз {0} с",other:"праз {0} с"},past:{one:"{0} с таму",few:"{0} с таму",many:"{0} с таму",other:"{0} с таму"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/bg.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.bg=t())}(this,function(){"use strict";return[{locale:"bg",pluralRuleFunction:function(e,t){return t?"other":1==e?"one":"other"},fields:{year:{displayName:"година",relative:{0:"тази година",1:"следващата година","-1":"миналата година"},relativeTime:{future:{one:"след {0} година",other:"след {0} години"},past:{one:"преди {0} година",other:"преди {0} години"}}},"year-short":{displayName:"г.",relative:{0:"т. г.",1:"следв. г.","-1":"мин. г."},relativeTime:{future:{one:"след {0} г.",other:"след {0} г."},past:{one:"преди {0} г.",other:"преди {0} г."}}},month:{displayName:"месец",relative:{0:"този месец",1:"следващ месец","-1":"предходен месец"},relativeTime:{future:{one:"след {0} месец",other:"след {0} месеца"},past:{one:"преди {0} месец",other:"преди {0} месеца"}}},"month-short":{displayName:"мес.",relative:{0:"този мес.",1:"следв. мес.","-1":"мин. мес."},relativeTime:{future:{one:"след {0} м.",other:"след {0} м."},past:{one:"преди {0} м.",other:"преди {0} м."}}},day:{displayName:"ден",relative:{0:"днес",1:"утре",2:"вдругиден","-2":"онзи ден","-1":"вчера"},relativeTime:{future:{one:"след {0} ден",other:"след {0} дни"},past:{one:"преди {0} ден",other:"преди {0} дни"}}},"day-short":{displayName:"д",relative:{0:"днес",1:"утре",2:"вдругиден","-2":"онзи ден","-1":"вчера"},relativeTime:{future:{one:"след {0} ден",other:"след {0} дни"},past:{one:"преди {0} ден",other:"преди {0} дни"}}},hour:{displayName:"час",relative:{0:"в този час"},relativeTime:{future:{one:"след {0} час",other:"след {0} часа"},past:{one:"преди {0} час",other:"преди {0} часа"}}},"hour-short":{displayName:"ч",relative:{0:"в този час"},relativeTime:{future:{one:"след {0} ч",other:"след {0} ч"},past:{one:"преди {0} ч",other:"преди {0} ч"}}},minute:{displayName:"минута",relative:{0:"в тази минута"},relativeTime:{future:{one:"след {0} минута",other:"след {0} минути"},past:{one:"преди {0} минута",other:"преди {0} минути"}}},"minute-short":{displayName:"мин",relative:{0:"в тази минута"},relativeTime:{future:{one:"след {0} мин",other:"след {0} мин"},past:{one:"преди {0} мин",other:"преди {0} мин"}}},second:{displayName:"секунда",relative:{0:"сега"},relativeTime:{future:{one:"след {0} секунда",other:"след {0} секунди"},past:{one:"преди {0} секунда",other:"преди {0} секунди"}}},"second-short":{displayName:"сек",relative:{0:"сега"},relativeTime:{future:{one:"след {0} сек",other:"след {0} сек"},past:{one:"преди {0} сек",other:"преди {0} сек"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/cs.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.cs=a())}(this,function(){"use strict";return[{locale:"cs",pluralRuleFunction:function(e,a){var n=String(e).split("."),t=n[0],m=!n[1];return a?"other":1==e&&m?"one":t>=2&&t<=4&&m?"few":m?"other":"many"},fields:{year:{displayName:"rok",relative:{0:"tento rok",1:"příští rok","-1":"minulý rok"},relativeTime:{future:{one:"za {0} rok",few:"za {0} roky",many:"za {0} roku",other:"za {0} let"},past:{one:"před {0} rokem",few:"před {0} lety",many:"před {0} roku",other:"před {0} lety"}}},"year-short":{displayName:"r.",relative:{0:"tento rok",1:"příští rok","-1":"minulý rok"},relativeTime:{future:{one:"za {0} r.",few:"za {0} r.",many:"za {0} r.",other:"za {0} l."},past:{one:"před {0} r.",few:"před {0} r.",many:"před {0} r.",other:"před {0} l."}}},month:{displayName:"měsíc",relative:{0:"tento měsíc",1:"příští měsíc","-1":"minulý měsíc"},relativeTime:{future:{one:"za {0} měsíc",few:"za {0} měsíce",many:"za {0} měsíce",other:"za {0} měsíců"},past:{one:"před {0} měsícem",few:"před {0} měsíci",many:"před {0} měsíce",other:"před {0} měsíci"}}},"month-short":{displayName:"měs.",relative:{0:"tento měs.",1:"příští měs.","-1":"minulý měs."},relativeTime:{future:{one:"za {0} měs.",few:"za {0} měs.",many:"za {0} měs.",other:"za {0} měs."},past:{one:"před {0} měs.",few:"před {0} měs.",many:"před {0} měs.",other:"před {0} měs."}}},day:{displayName:"den",relative:{0:"dnes",1:"zítra",2:"pozítří","-2":"předevčírem","-1":"včera"},relativeTime:{future:{one:"za {0} den",few:"za {0} dny",many:"za {0} dne",other:"za {0} dní"},past:{one:"před {0} dnem",few:"před {0} dny",many:"před {0} dne",other:"před {0} dny"}}},"day-short":{displayName:"den",relative:{0:"dnes",1:"zítra",2:"pozítří","-2":"předevčírem","-1":"včera"},relativeTime:{future:{one:"za {0} den",few:"za {0} dny",many:"za {0} dne",other:"za {0} dní"},past:{one:"před {0} dnem",few:"před {0} dny",many:"před {0} dne",other:"před {0} dny"}}},hour:{displayName:"hodina",relative:{0:"tuto hodinu"},relativeTime:{future:{one:"za {0} hodinu",few:"za {0} hodiny",many:"za {0} hodiny",other:"za {0} hodin"},past:{one:"před {0} hodinou",few:"před {0} hodinami",many:"před {0} hodiny",other:"před {0} hodinami"}}},"hour-short":{displayName:"h",relative:{0:"tuto hodinu"},relativeTime:{future:{one:"za {0} h",few:"za {0} h",many:"za {0} h",other:"za {0} h"},past:{one:"před {0} h",few:"před {0} h",many:"před {0} h",other:"před {0} h"}}},minute:{displayName:"minuta",relative:{0:"tuto minutu"},relativeTime:{future:{one:"za {0} minutu",few:"za {0} minuty",many:"za {0} minuty",other:"za {0} minut"},past:{one:"před {0} minutou",few:"před {0} minutami",many:"před {0} minuty",other:"před {0} minutami"}}},"minute-short":{displayName:"min",relative:{0:"tuto minutu"},relativeTime:{future:{one:"za {0} min",few:"za {0} min",many:"za {0} min",other:"za {0} min"},past:{one:"před {0} min",few:"před {0} min",many:"před {0} min",other:"před {0} min"}}},second:{displayName:"sekunda",relative:{0:"nyní"},relativeTime:{future:{one:"za {0} sekundu",few:"za {0} sekundy",many:"za {0} sekundy",other:"za {0} sekund"},past:{one:"před {0} sekundou",few:"před {0} sekundami",many:"před {0} sekundy",other:"před {0} sekundami"}}},"second-short":{displayName:"s",relative:{0:"nyní"},relativeTime:{future:{one:"za {0} s",few:"za {0} s",many:"za {0} s",other:"za {0} s"},past:{one:"před {0} s",few:"před {0} s",many:"před {0} s",other:"před {0} s"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/cy.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.cy=n())}(this,function(){"use strict";return[{locale:"cy",pluralRuleFunction:function(e,n){return n?0==e||7==e||8==e||9==e?"zero":1==e?"one":2==e?"two":3==e||4==e?"few":5==e||6==e?"many":"other":0==e?"zero":1==e?"one":2==e?"two":3==e?"few":6==e?"many":"other"},fields:{year:{displayName:"blwyddyn",relative:{0:"eleni",1:"blwyddyn nesaf","-1":"llynedd"},relativeTime:{future:{zero:"ymhen {0} mlynedd",one:"ymhen blwyddyn",two:"ymhen {0} flynedd",few:"ymhen {0} blynedd",many:"ymhen {0} blynedd",other:"ymhen {0} mlynedd"},past:{zero:"{0} o flynyddoedd yn ôl",one:"blwyddyn yn ôl",two:"{0} flynedd yn ôl",few:"{0} blynedd yn ôl",many:"{0} blynedd yn ôl",other:"{0} o flynyddoedd yn ôl"}}},"year-short":{displayName:"bl.",relative:{0:"eleni",1:"blwyddyn nesaf","-1":"llynedd"},relativeTime:{future:{zero:"ymhen {0} mlynedd",one:"ymhen blwyddyn",two:"ymhen {0} flynedd",few:"ymhen {0} blynedd",many:"ymhen {0} blynedd",other:"ymhen {0} mlynedd"},past:{zero:"{0} o flynyddoedd yn ôl",one:"blwyddyn yn ôl",two:"{0} flynedd yn ôl",few:"{0} blynedd yn ôl",many:"{0} blynedd yn ôl",other:"{0} o flynyddoedd yn ôl"}}},month:{displayName:"mis",relative:{0:"y mis hwn",1:"mis nesaf","-1":"mis diwethaf"},relativeTime:{future:{zero:"ymhen {0} mis",one:"ymhen mis",two:"ymhen deufis",few:"ymhen {0} mis",many:"ymhen {0} mis",other:"ymhen {0} mis"},past:{zero:"{0} mis yn ôl",one:"{0} mis yn ôl",two:"{0} fis yn ôl",few:"{0} mis yn ôl",many:"{0} mis yn ôl",other:"{0} mis yn ôl"}}},"month-short":{displayName:"mis",relative:{0:"y mis hwn",1:"mis nesaf","-1":"mis diwethaf"},relativeTime:{future:{zero:"ymhen {0} mis",one:"ymhen mis",two:"ymhen deufis",few:"ymhen {0} mis",many:"ymhen {0} mis",other:"ymhen {0} mis"},past:{zero:"{0} mis yn ôl",one:"{0} mis yn ôl",two:"deufis yn ôl",few:"{0} mis yn ôl",many:"{0} mis yn ôl",other:"{0} mis yn ôl"}}},day:{displayName:"diwrnod",relative:{0:"heddiw",1:"yfory",2:"drennydd","-2":"echdoe","-1":"ddoe"},relativeTime:{future:{zero:"ymhen {0} diwrnod",one:"ymhen diwrnod",two:"ymhen deuddydd",few:"ymhen {0} diwrnod",many:"ymhen {0} diwrnod",other:"ymhen {0} diwrnod"},past:{zero:"{0} diwrnod yn ôl",one:"{0} diwrnod yn ôl",two:"{0} ddiwrnod yn ôl",few:"{0} diwrnod yn ôl",many:"{0} diwrnod yn ôl",other:"{0} diwrnod yn ôl"}}},"day-short":{displayName:"diwrnod",relative:{0:"heddiw",1:"yfory",2:"drennydd","-2":"echdoe","-1":"ddoe"},relativeTime:{future:{zero:"ymhen {0} diwrnod",one:"ymhen diwrnod",two:"ymhen deuddydd",few:"ymhen {0} diwrnod",many:"ymhen {0} diwrnod",other:"ymhen {0} diwrnod"},past:{zero:"{0} diwrnod yn ôl",one:"{0} diwrnod yn ôl",two:"{0} ddiwrnod yn ôl",few:"{0} diwrnod yn ôl",many:"{0} diwrnod yn ôl",other:"{0} diwrnod yn ôl"}}},hour:{displayName:"awr",relative:{0:"yr awr hon"},relativeTime:{future:{zero:"ymhen {0} awr",one:"ymhen awr",two:"ymhen {0} awr",few:"ymhen {0} awr",many:"ymhen {0} awr",other:"ymhen {0} awr"},past:{zero:"{0} awr yn ôl",one:"{0} awr yn ôl",two:"{0} awr yn ôl",few:"{0} awr yn ôl",many:"{0} awr yn ôl",other:"{0} awr yn ôl"}}},"hour-short":{displayName:"awr",relative:{0:"yr awr hon"},relativeTime:{future:{zero:"ymhen {0} awr",one:"ymhen awr",two:"ymhen {0} awr",few:"ymhen {0} awr",many:"ymhen {0} awr",other:"ymhen {0} awr"},past:{zero:"{0} awr yn ôl",one:"awr yn ôl",two:"{0} awr yn ôl",few:"{0} awr yn ôl",many:"{0} awr yn ôl",other:"{0} awr yn ôl"}}},minute:{displayName:"munud",relative:{0:"y funud hon"},relativeTime:{future:{zero:"ymhen {0} munud",one:"ymhen {0} munud",two:"ymhen {0} munud",few:"ymhen {0} munud",many:"ymhen {0} munud",other:"ymhen {0} munud"},past:{zero:"{0} munud yn ôl",one:"{0} munud yn ôl",two:"{0} munud yn ôl",few:"{0} munud yn ôl",many:"{0} munud yn ôl",other:"{0} munud yn ôl"}}},"minute-short":{displayName:"mun.",relative:{0:"y funud hon"},relativeTime:{future:{zero:"ymhen {0} munud",one:"ymhen {0} mun.",two:"ymhen {0} fun.",few:"ymhen {0} munud",many:"ymhen {0} munud",other:"ymhen {0} munud"},past:{zero:"{0} munud yn ôl",one:"{0} munud yn ôl",two:"{0} fun. yn ôl",few:"{0} munud yn ôl",many:"{0} munud yn ôl",other:"{0} munud yn ôl"}}},second:{displayName:"eiliad",relative:{0:"nawr"},relativeTime:{future:{zero:"ymhen {0} eiliad",one:"ymhen {0} eiliad",two:"ymhen {0} eiliad",few:"ymhen {0} eiliad",many:"ymhen {0} eiliad",other:"ymhen {0} eiliad"},past:{zero:"{0} eiliad yn ôl",one:"{0} eiliad yn ôl",two:"{0} eiliad yn ôl",few:"{0} eiliad yn ôl",many:"{0} eiliad yn ôl",other:"{0} eiliad yn ôl"}}},"second-short":{displayName:"eiliad",relative:{0:"nawr"},relativeTime:{future:{zero:"ymhen {0} eiliad",one:"ymhen {0} eiliad",two:"ymhen {0} eiliad",few:"ymhen {0} eiliad",many:"ymhen {0} eiliad",other:"ymhen {0} eiliad"},past:{zero:"{0} eiliad yn ôl",one:"{0} eiliad yn ôl",two:"{0} eiliad yn ôl",few:"{0} eiliad yn ôl",many:"{0} eiliad yn ôl",other:"{0} eiliad yn ôl"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/de.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},"year-short":{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},"month-short":{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},"day-short":{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},"hour-short":{displayName:"Std.",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Std.",other:"in {0} Std."},past:{one:"vor {0} Std.",other:"vor {0} Std."}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},"minute-short":{displayName:"Min.",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Min.",other:"in {0} Min."},past:{one:"vor {0} Min.",other:"vor {0} Min."}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}},"second-short":{displayName:"Sek.",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sek.",other:"in {0} Sek."},past:{one:"vor {0} Sek.",other:"vor {0} Sek."}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/el.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.el=t())}(this,function(){"use strict";return[{locale:"el",pluralRuleFunction:function(e,t){return t?"other":1==e?"one":"other"},fields:{year:{displayName:"έτος",relative:{0:"φέτος",1:"επόμενο έτος","-1":"πέρσι"},relativeTime:{future:{one:"σε {0} έτος",other:"σε {0} έτη"},past:{one:"πριν από {0} έτος",other:"πριν από {0} έτη"}}},"year-short":{displayName:"έτ.",relative:{0:"φέτος",1:"επόμενο έτος","-1":"πέρσι"},relativeTime:{future:{one:"σε {0} έτος",other:"σε {0} έτη"},past:{one:"πριν από {0} έτος",other:"πριν από {0} έτη"}}},month:{displayName:"μήνας",relative:{0:"τρέχων μήνας",1:"επόμενος μήνας","-1":"προηγούμενος μήνας"},relativeTime:{future:{one:"σε {0} μήνα",other:"σε {0} μήνες"},past:{one:"πριν από {0} μήνα",other:"πριν από {0} μήνες"}}},"month-short":{displayName:"μήν.",relative:{0:"τρέχων μήνας",1:"επόμενος μήνας","-1":"προηγούμενος μήνας"},relativeTime:{future:{one:"σε {0} μήνα",other:"σε {0} μήνες"},past:{one:"πριν από {0} μήνα",other:"πριν από {0} μήνες"}}},day:{displayName:"ημέρα",relative:{0:"σήμερα",1:"αύριο",2:"μεθαύριο","-2":"προχθές","-1":"χθες"},relativeTime:{future:{one:"σε {0} ημέρα",other:"σε {0} ημέρες"},past:{one:"πριν από {0} ημέρα",other:"πριν από {0} ημέρες"}}},"day-short":{displayName:"ημ.",relative:{0:"σήμερα",1:"αύριο",2:"μεθαύριο","-2":"προχθές","-1":"χθες"},relativeTime:{future:{one:"σε {0} ημ.",other:"σε {0} ημ."},past:{one:"πριν από {0} ημ.",other:"πριν από {0} ημ."}}},hour:{displayName:"ώρα",relative:{0:"τρέχουσα ώρα"},relativeTime:{future:{one:"σε {0} ώρα",other:"σε {0} ώρες"},past:{one:"πριν από {0} ώρα",other:"πριν από {0} ώρες"}}},"hour-short":{displayName:"ώ.",relative:{0:"τρέχουσα ώρα"},relativeTime:{future:{one:"σε {0} ώ.",other:"σε {0} ώ."},past:{one:"πριν από {0} ώ.",other:"πριν από {0} ώ."}}},minute:{displayName:"λεπτό",relative:{0:"τρέχον λεπτό"},relativeTime:{future:{one:"σε {0} λεπτό",other:"σε {0} λεπτά"},past:{one:"πριν από {0} λεπτό",other:"πριν από {0} λεπτά"}}},"minute-short":{displayName:"λεπ.",relative:{0:"τρέχον λεπτό"},relativeTime:{future:{one:"σε {0} λεπ.",other:"σε {0} λεπ."},past:{one:"πριν από {0} λεπ.",other:"πριν από {0} λεπ."}}},second:{displayName:"δευτερόλεπτο",relative:{0:"τώρα"},relativeTime:{future:{one:"σε {0} δευτερόλεπτο",other:"σε {0} δευτερόλεπτα"},past:{one:"πριν από {0} δευτερόλεπτο",other:"πριν από {0} δευτερόλεπτα"}}},"second-short":{displayName:"δευτ.",relative:{0:"τώρα"},relativeTime:{future:{one:"σε {0} δευτ.",other:"σε {0} δευτ."},past:{one:"πριν από {0} δευτ.",other:"πριν από {0} δευτ."}}}}},{locale:"el-CY",parentLocale:"el"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/en.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/es.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/fr.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/it.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/kk.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.kk=t())}(this,function(){"use strict";return[{locale:"kk",pluralRuleFunction:function(e,t){var r=String(e).split("."),a=Number(r[0])==e,o=a&&r[0].slice(-1);return t?6==o||9==o||a&&0==o&&0!=e?"many":"other":1==e?"one":"other"},fields:{year:{displayName:"жыл",relative:{0:"биылғы жыл",1:"келесі жыл","-1":"былтырғы жыл"},relativeTime:{future:{one:"{0} жылдан кейін",other:"{0} жылдан кейін"},past:{one:"{0} жыл бұрын",other:"{0} жыл бұрын"}}},"year-short":{displayName:"ж.",relative:{0:"биылғы жыл",1:"келесі жыл","-1":"былтырғы жыл"},relativeTime:{future:{one:"{0} ж. кейін",other:"{0} ж. кейін"},past:{one:"{0} ж. бұрын",other:"{0} ж. бұрын"}}},month:{displayName:"ай",relative:{0:"осы ай",1:"келесі ай","-1":"өткен ай"},relativeTime:{future:{one:"{0} айдан кейін",other:"{0} айдан кейін"},past:{one:"{0} ай бұрын",other:"{0} ай бұрын"}}},"month-short":{displayName:"ай",relative:{0:"осы ай",1:"келесі ай","-1":"өткен ай"},relativeTime:{future:{one:"{0} айдан кейін",other:"{0} айдан кейін"},past:{one:"{0} ай бұрын",other:"{0} ай бұрын"}}},day:{displayName:"күн",relative:{0:"бүгін",1:"ертең",2:"бүрсігүні","-2":"алдыңгүні","-1":"кеше"},relativeTime:{future:{one:"{0} күннен кейін",other:"{0} күннен кейін"},past:{one:"{0} күн бұрын",other:"{0} күн бұрын"}}},"day-short":{displayName:"күн",relative:{0:"бүгін",1:"ертең",2:"бүрсігүні","-2":"алдыңғы күні","-1":"кеше"},relativeTime:{future:{one:"{0} күннен кейін",other:"{0} күннен кейін"},past:{one:"{0} күн бұрын",other:"{0} күн бұрын"}}},hour:{displayName:"сағат",relative:{0:"осы сағат"},relativeTime:{future:{one:"{0} сағаттан кейін",other:"{0} сағаттан кейін"},past:{one:"{0} сағат бұрын",other:"{0} сағат бұрын"}}},"hour-short":{displayName:"сағ",relative:{0:"осы сағат"},relativeTime:{future:{one:"{0} сағ. кейін",other:"{0} сағ. кейін"},past:{one:"{0} сағ. бұрын",other:"{0} сағ. бұрын"}}},minute:{displayName:"минут",relative:{0:"осы минут"},relativeTime:{future:{one:"{0} минуттан кейін",other:"{0} минуттан кейін"},past:{one:"{0} минут бұрын",other:"{0} минут бұрын"}}},"minute-short":{displayName:"мин",relative:{0:"осы минут"},relativeTime:{future:{one:"{0} мин. кейін",other:"{0} мин. кейін"},past:{one:"{0} мин. бұрын",other:"{0} мин. бұрын"}}},second:{displayName:"секунд",relative:{0:"қазір"},relativeTime:{future:{one:"{0} секундтан кейін",other:"{0} секундтан кейін"},past:{one:"{0} секунд бұрын",other:"{0} секунд бұрын"}}},"second-short":{displayName:"с",relative:{0:"қазір"},relativeTime:{future:{one:"{0} сек. кейін",other:"{0} сек. кейін"},past:{one:"{0} сек. бұрын",other:"{0} сек. бұрын"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/lt.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,i){ true?module.exports=i():"function"==typeof define&&define.amd?define(i):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.lt=i())}(this,function(){"use strict";return[{locale:"lt",pluralRuleFunction:function(e,i){var a=String(e).split("."),n=a[1]||"",r=Number(a[0])==e,t=r&&a[0].slice(-1),o=r&&a[0].slice(-2);return i?"other":1==t&&(o<11||o>19)?"one":t>=2&&t<=9&&(o<11||o>19)?"few":0!=n?"many":"other"},fields:{year:{displayName:"metai",relative:{0:"šiais metais",1:"kitais metais","-1":"praėjusiais metais"},relativeTime:{future:{one:"po {0} metų",few:"po {0} metų",many:"po {0} metų",other:"po {0} metų"},past:{one:"prieš {0} metus",few:"prieš {0} metus",many:"prieš {0} metų",other:"prieš {0} metų"}}},"year-short":{displayName:"m.",relative:{0:"šiais metais",1:"kitais metais","-1":"praėjusiais metais"},relativeTime:{future:{one:"po {0} m.",few:"po {0} m.",many:"po {0} m.",other:"po {0} m."},past:{one:"prieš {0} m.",few:"prieš {0} m.",many:"prieš {0} m.",other:"prieš {0} m."}}},month:{displayName:"mėnuo",relative:{0:"šį mėnesį",1:"kitą mėnesį","-1":"praėjusį mėnesį"},relativeTime:{future:{one:"po {0} mėnesio",few:"po {0} mėnesių",many:"po {0} mėnesio",other:"po {0} mėnesių"},past:{one:"prieš {0} mėnesį",few:"prieš {0} mėnesius",many:"prieš {0} mėnesio",other:"prieš {0} mėnesių"}}},"month-short":{displayName:"mėn.",relative:{0:"šį mėnesį",1:"kitą mėnesį","-1":"praėjusį mėnesį"},relativeTime:{future:{one:"po {0} mėn.",few:"po {0} mėn.",many:"po {0} mėn.",other:"po {0} mėn."},past:{one:"prieš {0} mėn.",few:"prieš {0} mėn.",many:"prieš {0} mėn.",other:"prieš {0} mėn."}}},day:{displayName:"diena",relative:{0:"šiandien",1:"rytoj",2:"poryt","-2":"užvakar","-1":"vakar"},relativeTime:{future:{one:"po {0} dienos",few:"po {0} dienų",many:"po {0} dienos",other:"po {0} dienų"},past:{one:"prieš {0} dieną",few:"prieš {0} dienas",many:"prieš {0} dienos",other:"prieš {0} dienų"}}},"day-short":{displayName:"d.",relative:{0:"šiandien",1:"rytoj",2:"poryt","-2":"užvakar","-1":"vakar"},relativeTime:{future:{one:"po {0} d.",few:"po {0} d.",many:"po {0} d.",other:"po {0} d."},past:{one:"prieš {0} d.",few:"prieš {0} d.",many:"prieš {0} d.",other:"prieš {0} d."}}},hour:{displayName:"valanda",relative:{0:"šią valandą"},relativeTime:{future:{one:"po {0} valandos",few:"po {0} valandų",many:"po {0} valandos",other:"po {0} valandų"},past:{one:"prieš {0} valandą",few:"prieš {0} valandas",many:"prieš {0} valandos",other:"prieš {0} valandų"}}},"hour-short":{displayName:"val.",relative:{0:"šią valandą"},relativeTime:{future:{one:"po {0} val.",few:"po {0} val.",many:"po {0} val.",other:"po {0} val."},past:{one:"prieš {0} val.",few:"prieš {0} val.",many:"prieš {0} val.",other:"prieš {0} val."}}},minute:{displayName:"minutė",relative:{0:"šią minutę"},relativeTime:{future:{one:"po {0} minutės",few:"po {0} minučių",many:"po {0} minutės",other:"po {0} minučių"},past:{one:"prieš {0} minutę",few:"prieš {0} minutes",many:"prieš {0} minutės",other:"prieš {0} minučių"}}},"minute-short":{displayName:"min.",relative:{0:"šią minutę"},relativeTime:{future:{one:"po {0} min.",few:"po {0} min.",many:"po {0} min.",other:"po {0} min."},past:{one:"prieš {0} min.",few:"prieš {0} min.",many:"prieš {0} min.",other:"prieš {0} min."}}},second:{displayName:"sekundė",relative:{0:"dabar"},relativeTime:{future:{one:"po {0} sekundės",few:"po {0} sekundžių",many:"po {0} sekundės",other:"po {0} sekundžių"},past:{one:"prieš {0} sekundę",few:"prieš {0} sekundes",many:"prieš {0} sekundės",other:"prieš {0} sekundžių"}}},"second-short":{displayName:"sek.",relative:{0:"dabar"},relativeTime:{future:{one:"po {0} sek.",few:"po {0} sek.",many:"po {0} sek.",other:"po {0} sek."},past:{one:"prieš {0} sek.",few:"prieš {0} sek.",many:"prieš {0} sek.",other:"prieš {0} sek."}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/no.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.no=t())}(this,function(){"use strict";return[{locale:"no",pluralRuleFunction:function(e,t){return t?"other":1==e?"one":"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/pl.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pl=t())}(this,function(){"use strict";return[{locale:"pl",pluralRuleFunction:function(e,t){var a=String(e).split("."),m=a[0],i=!a[1],n=m.slice(-1),u=m.slice(-2);return t?"other":1==e&&i?"one":i&&n>=2&&n<=4&&(u<12||u>14)?"few":i&&1!=m&&(0==n||1==n)||i&&n>=5&&n<=9||i&&u>=12&&u<=14?"many":"other"},fields:{year:{displayName:"rok",relative:{0:"w tym roku",1:"w przyszłym roku","-1":"w zeszłym roku"},relativeTime:{future:{one:"za {0} rok",few:"za {0} lata",many:"za {0} lat",other:"za {0} roku"},past:{one:"{0} rok temu",few:"{0} lata temu",many:"{0} lat temu",other:"{0} roku temu"}}},"year-short":{displayName:"r.",relative:{0:"w tym roku",1:"w przyszłym roku","-1":"w zeszłym roku"},relativeTime:{future:{one:"za {0} rok",few:"za {0} lata",many:"za {0} lat",other:"za {0} roku"},past:{one:"{0} rok temu",few:"{0} lata temu",many:"{0} lat temu",other:"{0} roku temu"}}},month:{displayName:"miesiąc",relative:{0:"w tym miesiącu",1:"w przyszłym miesiącu","-1":"w zeszłym miesiącu"},relativeTime:{future:{one:"za {0} miesiąc",few:"za {0} miesiące",many:"za {0} miesięcy",other:"za {0} miesiąca"},past:{one:"{0} miesiąc temu",few:"{0} miesiące temu",many:"{0} miesięcy temu",other:"{0} miesiąca temu"}}},"month-short":{displayName:"mies.",relative:{0:"w tym miesiącu",1:"w przyszłym miesiącu","-1":"w zeszłym miesiącu"},relativeTime:{future:{one:"za {0} mies.",few:"za {0} mies.",many:"za {0} mies.",other:"za {0} mies."},past:{one:"{0} mies. temu",few:"{0} mies. temu",many:"{0} mies. temu",other:"{0} mies. temu"}}},day:{displayName:"dzień",relative:{0:"dzisiaj",1:"jutro",2:"pojutrze","-2":"przedwczoraj","-1":"wczoraj"},relativeTime:{future:{one:"za {0} dzień",few:"za {0} dni",many:"za {0} dni",other:"za {0} dnia"},past:{one:"{0} dzień temu",few:"{0} dni temu",many:"{0} dni temu",other:"{0} dnia temu"}}},"day-short":{displayName:"dzień",relative:{0:"dzisiaj",1:"jutro",2:"pojutrze","-2":"przedwczoraj","-1":"wczoraj"},relativeTime:{future:{one:"za {0} dzień",few:"za {0} dni",many:"za {0} dni",other:"za {0} dnia"},past:{one:"{0} dzień temu",few:"{0} dni temu",many:"{0} dni temu",other:"{0} dnia temu"}}},hour:{displayName:"godzina",relative:{0:"ta godzina"},relativeTime:{future:{one:"za {0} godzinę",few:"za {0} godziny",many:"za {0} godzin",other:"za {0} godziny"},past:{one:"{0} godzinę temu",few:"{0} godziny temu",many:"{0} godzin temu",other:"{0} godziny temu"}}},"hour-short":{displayName:"godz.",relative:{0:"ta godzina"},relativeTime:{future:{one:"za {0} godz.",few:"za {0} godz.",many:"za {0} godz.",other:"za {0} godz."},past:{one:"{0} godz. temu",few:"{0} godz. temu",many:"{0} godz. temu",other:"{0} godz. temu"}}},minute:{displayName:"minuta",relative:{0:"ta minuta"},relativeTime:{future:{one:"za {0} minutę",few:"za {0} minuty",many:"za {0} minut",other:"za {0} minuty"},past:{one:"{0} minutę temu",few:"{0} minuty temu",many:"{0} minut temu",other:"{0} minuty temu"}}},"minute-short":{displayName:"min",relative:{0:"ta minuta"},relativeTime:{future:{one:"za {0} min",few:"za {0} min",many:"za {0} min",other:"za {0} min"},past:{one:"{0} min temu",few:"{0} min temu",many:"{0} min temu",other:"{0} min temu"}}},second:{displayName:"sekunda",relative:{0:"teraz"},relativeTime:{future:{one:"za {0} sekundę",few:"za {0} sekundy",many:"za {0} sekund",other:"za {0} sekundy"},past:{one:"{0} sekundę temu",few:"{0} sekundy temu",many:"{0} sekund temu",other:"{0} sekundy temu"}}},"second-short":{displayName:"sek.",relative:{0:"teraz"},relativeTime:{future:{one:"za {0} sek.",few:"za {0} sek.",many:"za {0} sek.",other:"za {0} sek."},past:{one:"{0} sek. temu",few:"{0} sek. temu",many:"{0} sek. temu",other:"{0} sek. temu"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/pt.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pt=t())}(this,function(){"use strict";return[{locale:"pt",pluralRuleFunction:function(e,t){var o=String(e).split(".")[0];return t?"other":0==o||1==o?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"em {0} ano",other:"em {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},"year-short":{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"em {0} ano",other:"em {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"em {0} mês",other:"em {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},"month-short":{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"em {0} mês",other:"em {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"em {0} dia",other:"em {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},"day-short":{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"em {0} dia",other:"em {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"em {0} hora",other:"em {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"em {0} h",other:"em {0} h"},past:{one:"há {0} h",other:"há {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"em {0} minuto",other:"em {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},"minute-short":{displayName:"min.",relative:{0:"este minuto"},relativeTime:{future:{one:"em {0} min.",other:"em {0} min."},past:{one:"há {0} min.",other:"há {0} min."}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"em {0} segundo",other:"em {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"agora"},relativeTime:{future:{one:"em {0} seg.",other:"em {0} seg."},past:{one:"há {0} seg.",other:"há {0} seg."}}}}},{locale:"pt-AO",parentLocale:"pt-PT"},{locale:"pt-PT",parentLocale:"pt",pluralRuleFunction:function(e,t){var o=!String(e).split(".")[1];return t?"other":1==e&&o?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"dentro de {0} ano",other:"dentro de {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},"year-short":{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"dentro de {0} ano",other:"dentro de {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"dentro de {0} mês",other:"dentro de {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},"month-short":{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"dentro de {0} mês",other:"dentro de {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"dentro de {0} dia",other:"dentro de {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},"day-short":{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"dentro de {0} dia",other:"dentro de {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"há {0} h",other:"há {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"há {0} min",other:"há {0} min"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"agora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"há {0} s",other:"há {0} s"}}}}},{locale:"pt-CH",parentLocale:"pt-PT"},{locale:"pt-CV",parentLocale:"pt-PT"},{locale:"pt-GQ",parentLocale:"pt-PT"},{locale:"pt-GW",parentLocale:"pt-PT"},{locale:"pt-LU",parentLocale:"pt-PT"},{locale:"pt-MO",parentLocale:"pt-PT"},{locale:"pt-MZ",parentLocale:"pt-PT"},{locale:"pt-ST",parentLocale:"pt-PT"},{locale:"pt-TL",parentLocale:"pt-PT"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/ro.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ro=t())}(this,function(){"use strict";return[{locale:"ro",pluralRuleFunction:function(e,t){var a=String(e).split("."),i=!a[1],u=Number(a[0])==e&&a[0].slice(-2);return t?1==e?"one":"other":1==e&&i?"one":!i||0==e||1!=e&&u>=1&&u<=19?"few":"other"},fields:{year:{displayName:"an",relative:{0:"anul acesta",1:"anul viitor","-1":"anul trecut"},relativeTime:{future:{one:"peste {0} an",few:"peste {0} ani",other:"peste {0} de ani"},past:{one:"acum {0} an",few:"acum {0} ani",other:"acum {0} de ani"}}},"year-short":{displayName:"an",relative:{0:"anul acesta",1:"anul viitor","-1":"anul trecut"},relativeTime:{future:{one:"peste {0} an",few:"peste {0} ani",other:"peste {0} de ani"},past:{one:"acum {0} an",few:"acum {0} ani",other:"acum {0} de ani"}}},month:{displayName:"lună",relative:{0:"luna aceasta",1:"luna viitoare","-1":"luna trecută"},relativeTime:{future:{one:"peste {0} lună",few:"peste {0} luni",other:"peste {0} de luni"},past:{one:"acum {0} lună",few:"acum {0} luni",other:"acum {0} de luni"}}},"month-short":{displayName:"lună",relative:{0:"luna aceasta",1:"luna viitoare","-1":"luna trecută"},relativeTime:{future:{one:"peste {0} lună",few:"peste {0} luni",other:"peste {0} luni"},past:{one:"acum {0} lună",few:"acum {0} luni",other:"acum {0} luni"}}},day:{displayName:"zi",relative:{0:"azi",1:"mâine",2:"poimâine","-2":"alaltăieri","-1":"ieri"},relativeTime:{future:{one:"peste {0} zi",few:"peste {0} zile",other:"peste {0} de zile"},past:{one:"acum {0} zi",few:"acum {0} zile",other:"acum {0} de zile"}}},"day-short":{displayName:"zi",relative:{0:"azi",1:"mâine",2:"poimâine","-2":"alaltăieri","-1":"ieri"},relativeTime:{future:{one:"peste {0} zi",few:"peste {0} zile",other:"peste {0} de zile"},past:{one:"acum {0} zi",few:"acum {0} zile",other:"acum {0} de zile"}}},hour:{displayName:"oră",relative:{0:"ora aceasta"},relativeTime:{future:{one:"peste {0} oră",few:"peste {0} ore",other:"peste {0} de ore"},past:{one:"acum {0} oră",few:"acum {0} ore",other:"acum {0} de ore"}}},"hour-short":{displayName:"h",relative:{0:"ora aceasta"},relativeTime:{future:{one:"peste {0} h",few:"peste {0} h",other:"peste {0} h"},past:{one:"acum {0} h",few:"acum {0} h",other:"acum {0} h"}}},minute:{displayName:"minut",relative:{0:"minutul acesta"},relativeTime:{future:{one:"peste {0} minut",few:"peste {0} minute",other:"peste {0} de minute"},past:{one:"acum {0} minut",few:"acum {0} minute",other:"acum {0} de minute"}}},"minute-short":{displayName:"min.",relative:{0:"minutul acesta"},relativeTime:{future:{one:"peste {0} min.",few:"peste {0} min.",other:"peste {0} min."},past:{one:"acum {0} min.",few:"acum {0} min.",other:"acum {0} min."}}},second:{displayName:"secundă",relative:{0:"acum"},relativeTime:{future:{one:"peste {0} secundă",few:"peste {0} secunde",other:"peste {0} de secunde"},past:{one:"acum {0} secundă",few:"acum {0} secunde",other:"acum {0} de secunde"}}},"second-short":{displayName:"sec.",relative:{0:"acum"},relativeTime:{future:{one:"peste {0} sec.",few:"peste {0} sec.",other:"peste {0} sec."},past:{one:"acum {0} sec.",few:"acum {0} sec.",other:"acum {0} sec."}}}}},{locale:"ro-MD",parentLocale:"ro"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/si.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.si=t())}(this,function(){"use strict";return[{locale:"si",pluralRuleFunction:function(e,t){var r=String(e).split("."),a=r[0],o=r[1]||"";return t?"other":0==e||1==e||0==a&&1==o?"one":"other"},fields:{year:{displayName:"වර්ෂය",relative:{0:"මෙම වසර",1:"ඊළඟ වසර","-1":"පසුගිය වසර"},relativeTime:{future:{one:"වසර {0}කින්",other:"වසර {0}කින්"},past:{one:"වසර {0}කට පෙර",other:"වසර {0}කට පෙර"}}},"year-short":{displayName:"වර්.",relative:{0:"මෙම වසර",1:"ඊළඟ වසර","-1":"පසුගිය වසර"},relativeTime:{future:{one:"වසර {0}කින්",other:"වසර {0}කින්"},past:{one:"වසර {0}කට පෙර",other:"වසර {0}කට පෙර"}}},month:{displayName:"මාසය",relative:{0:"මෙම මාසය",1:"ඊළඟ මාසය","-1":"පසුගිය මාසය"},relativeTime:{future:{one:"මාස {0}කින්",other:"මාස {0}කින්"},past:{one:"මාස {0}කට පෙර",other:"මාස {0}කට පෙර"}}},"month-short":{displayName:"මාස.",relative:{0:"මෙම මාස.",1:"ඊළඟ මාස.","-1":"පසුගිය මාස."},relativeTime:{future:{one:"මාස {0}කින්",other:"මාස {0}කින්"},past:{one:"මාස {0}කට පෙර",other:"මාස {0}කට පෙර"}}},day:{displayName:"දිනය",relative:{0:"අද",1:"හෙට",2:"අනිද්දා","-2":"පෙරේදා","-1":"ඊයේ"},relativeTime:{future:{one:"දින {0}න්",other:"දින {0}න්"},past:{one:"දින {0}කට පෙර",other:"දින {0}කට පෙර"}}},"day-short":{displayName:"දිනය",relative:{0:"අද",1:"හෙට",2:"අනිද්දා","-2":"පෙරේදා","-1":"ඊයේ"},relativeTime:{future:{one:"දින {0}න්",other:"දින {0}න්"},past:{one:"දින {0}කට පෙර",other:"දින {0}කට පෙර"}}},hour:{displayName:"පැය",relative:{0:"මෙම පැය"},relativeTime:{future:{one:"පැය {0}කින්",other:"පැය {0}කින්"},past:{one:"පැය {0}කට පෙර",other:"පැය {0}කට පෙර"}}},"hour-short":{displayName:"පැය",relative:{0:"මෙම පැය"},relativeTime:{future:{one:"පැය {0}කින්",other:"පැය {0}කින්"},past:{one:"පැය {0}කට පෙර",other:"පැය {0}කට පෙර"}}},minute:{displayName:"මිනිත්තුව",relative:{0:"මෙම මිනිත්තුව"},relativeTime:{future:{one:"මිනිත්තු {0}කින්",other:"මිනිත්තු {0}කින්"},past:{one:"මිනිත්තු {0}කට පෙර",other:"මිනිත්තු {0}කට පෙර"}}},"minute-short":{displayName:"මිනි.",relative:{0:"මෙම මිනිත්තුව"},relativeTime:{future:{one:"මිනිත්තු {0}කින්",other:"මිනිත්තු {0}කින්"},past:{one:"මිනිත්තු {0}කට පෙර",other:"මිනිත්තු {0}කට පෙර"}}},second:{displayName:"තත්පරය",relative:{0:"දැන්"},relativeTime:{future:{one:"තත්පර {0}කින්",other:"තත්පර {0}කින්"},past:{one:"තත්පර {0}කට පෙර",other:"තත්පර {0}කට පෙර"}}},"second-short":{displayName:"තත්.",relative:{0:"දැන්"},relativeTime:{future:{one:"තත්පර {0}කින්",other:"තත්පර {0}කින්"},past:{one:"තත්පර {0}කට පෙර",other:"තත්පර {0}කට පෙර"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/sv.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){ true?module.exports=r():"function"==typeof define&&define.amd?define(r):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.sv=r())}(this,function(){"use strict";return[{locale:"sv",pluralRuleFunction:function(e,r){var t=String(e).split("."),a=!t[1],n=Number(t[0])==e,o=n&&t[0].slice(-1),m=n&&t[0].slice(-2);return r?1!=o&&2!=o||11==m||12==m?"other":"one":1==e&&a?"one":"other"},fields:{year:{displayName:"år",relative:{0:"i år",1:"nästa år","-1":"i fjol"},relativeTime:{future:{one:"om {0} år",other:"om {0} år"},past:{one:"för {0} år sedan",other:"för {0} år sedan"}}},"year-short":{displayName:"år",relative:{0:"i år",1:"nästa år","-1":"i fjol"},relativeTime:{future:{one:"om {0} år",other:"om {0} år"},past:{one:"för {0} år sen",other:"för {0} år sen"}}},month:{displayName:"månad",relative:{0:"denna månad",1:"nästa månad","-1":"förra månaden"},relativeTime:{future:{one:"om {0} månad",other:"om {0} månader"},past:{one:"för {0} månad sedan",other:"för {0} månader sedan"}}},"month-short":{displayName:"m",relative:{0:"denna mån.",1:"nästa mån.","-1":"förra mån."},relativeTime:{future:{one:"om {0} mån.",other:"om {0} mån."},past:{one:"för {0} mån. sen",other:"för {0} mån. sen"}}},day:{displayName:"dag",relative:{0:"i dag",1:"i morgon",2:"i övermorgon","-2":"i förrgår","-1":"i går"},relativeTime:{future:{one:"om {0} dag",other:"om {0} dagar"},past:{one:"för {0} dag sedan",other:"för {0} dagar sedan"}}},"day-short":{displayName:"dag",relative:{0:"i dag",1:"i morgon",2:"i övermorgon","-2":"i förrgår","-1":"i går"},relativeTime:{future:{one:"om {0} d",other:"om {0} d"},past:{one:"för {0} d sedan",other:"för {0} d sedan"}}},hour:{displayName:"timme",relative:{0:"denna timme"},relativeTime:{future:{one:"om {0} timme",other:"om {0} timmar"},past:{one:"för {0} timme sedan",other:"för {0} timmar sedan"}}},"hour-short":{displayName:"tim",relative:{0:"denna timme"},relativeTime:{future:{one:"om {0} tim",other:"om {0} tim"},past:{one:"för {0} tim sedan",other:"för {0} tim sedan"}}},minute:{displayName:"minut",relative:{0:"denna minut"},relativeTime:{future:{one:"om {0} minut",other:"om {0} minuter"},past:{one:"för {0} minut sedan",other:"för {0} minuter sedan"}}},"minute-short":{displayName:"min",relative:{0:"denna minut"},relativeTime:{future:{one:"om {0} min",other:"om {0} min"},past:{one:"för {0} min sen",other:"för {0} min sen"}}},second:{displayName:"sekund",relative:{0:"nu"},relativeTime:{future:{one:"om {0} sekund",other:"om {0} sekunder"},past:{one:"för {0} sekund sedan",other:"för {0} sekunder sedan"}}},"second-short":{displayName:"sek",relative:{0:"nu"},relativeTime:{future:{one:"om {0} sek",other:"om {0} sek"},past:{one:"för {0} s sen",other:"för {0} s sen"}}}}},{locale:"sv-AX",parentLocale:"sv"},{locale:"sv-FI",parentLocale:"sv"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/th.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.th=t())}(this,function(){"use strict";return[{locale:"th",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},"year-short":{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ใน {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},month:{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} เดือน"},past:{other:"{0} เดือนที่ผ่านมา"}}},"month-short":{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ใน {0} เดือน"},past:{other:"{0} เดือนที่แล้ว"}}},day:{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ในอีก {0} วัน"},past:{other:"{0} วันที่ผ่านมา"}}},"day-short":{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ใน {0} วัน"},past:{other:"{0} วันที่แล้ว"}}},hour:{displayName:"ชั่วโมง",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ในอีก {0} ชั่วโมง"},past:{other:"{0} ชั่วโมงที่ผ่านมา"}}},"hour-short":{displayName:"ชม.",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ใน {0} ชม."},past:{other:"{0} ชม. ที่แล้ว"}}},minute:{displayName:"นาที",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ในอีก {0} นาที"},past:{other:"{0} นาทีที่ผ่านมา"}}},"minute-short":{displayName:"น.",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ใน {0} นาที"},past:{other:"{0} นาทีที่แล้ว"}}},second:{displayName:"วินาที",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ในอีก {0} วินาที"},past:{other:"{0} วินาทีที่ผ่านมา"}}},"second-short":{displayName:"วิ",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ใน {0} วินาที"},past:{other:"{0} วินาทีที่แล้ว"}}}}}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/tr.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.tr=a())}(this,function(){"use strict";return[{locale:"tr",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},"year-short":{displayName:"yıl",relative:{0:"bu yıl",1:"gelecek yıl","-1":"geçen yıl"},relativeTime:{future:{one:"{0} yıl sonra",other:"{0} yıl sonra"},past:{one:"{0} yıl önce",other:"{0} yıl önce"}}},month:{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},"month-short":{displayName:"ay",relative:{0:"bu ay",1:"gelecek ay","-1":"geçen ay"},relativeTime:{future:{one:"{0} ay sonra",other:"{0} ay sonra"},past:{one:"{0} ay önce",other:"{0} ay önce"}}},day:{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},"day-short":{displayName:"gün",relative:{0:"bugün",1:"yarın",2:"öbür gün","-2":"evvelsi gün","-1":"dün"},relativeTime:{future:{one:"{0} gün sonra",other:"{0} gün sonra"},past:{one:"{0} gün önce",other:"{0} gün önce"}}},hour:{displayName:"saat",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} saat sonra",other:"{0} saat sonra"},past:{one:"{0} saat önce",other:"{0} saat önce"}}},"hour-short":{displayName:"sa.",relative:{0:"bu saat"},relativeTime:{future:{one:"{0} sa. sonra",other:"{0} sa. sonra"},past:{one:"{0} sa. önce",other:"{0} sa. önce"}}},minute:{displayName:"dakika",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dakika sonra",other:"{0} dakika sonra"},past:{one:"{0} dakika önce",other:"{0} dakika önce"}}},"minute-short":{displayName:"dk.",relative:{0:"bu dakika"},relativeTime:{future:{one:"{0} dk. sonra",other:"{0} dk. sonra"},past:{one:"{0} dk. önce",other:"{0} dk. önce"}}},second:{displayName:"saniye",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} saniye sonra",other:"{0} saniye sonra"},past:{one:"{0} saniye önce",other:"{0} saniye önce"}}},"second-short":{displayName:"sn.",relative:{0:"şimdi"},relativeTime:{future:{one:"{0} sn. sonra",other:"{0} sn. sonra"},past:{one:"{0} sn. önce",other:"{0} sn. önce"}}}}},{locale:"tr-CY",parentLocale:"tr"}]});


/***/ }),

/***/ "./node_modules/react-intl/locale-data/vi.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.vi=t())}(this,function(){"use strict";return[{locale:"vi",pluralRuleFunction:function(e,t){return t&&1==e?"one":"other"},fields:{year:{displayName:"Năm",relative:{0:"năm nay",1:"năm sau","-1":"năm ngoái"},relativeTime:{future:{other:"sau {0} năm nữa"},past:{other:"{0} năm trước"}}},"year-short":{displayName:"Năm",relative:{0:"năm nay",1:"năm sau","-1":"năm ngoái"},relativeTime:{future:{other:"sau {0} năm nữa"},past:{other:"{0} năm trước"}}},month:{displayName:"Tháng",relative:{0:"tháng này",1:"tháng sau","-1":"tháng trước"},relativeTime:{future:{other:"sau {0} tháng nữa"},past:{other:"{0} tháng trước"}}},"month-short":{displayName:"Tháng",relative:{0:"tháng này",1:"tháng sau","-1":"tháng trước"},relativeTime:{future:{other:"sau {0} tháng nữa"},past:{other:"{0} tháng trước"}}},day:{displayName:"Ngày",relative:{0:"Hôm nay",1:"Ngày mai",2:"Ngày kia","-2":"Hôm kia","-1":"Hôm qua"},relativeTime:{future:{other:"sau {0} ngày nữa"},past:{other:"{0} ngày trước"}}},"day-short":{displayName:"Ngày",relative:{0:"Hôm nay",1:"Ngày mai",2:"Ngày kia","-2":"Hôm kia","-1":"Hôm qua"},relativeTime:{future:{other:"sau {0} ngày nữa"},past:{other:"{0} ngày trước"}}},hour:{displayName:"Giờ",relative:{0:"giờ này"},relativeTime:{future:{other:"sau {0} giờ nữa"},past:{other:"{0} giờ trước"}}},"hour-short":{displayName:"Giờ",relative:{0:"giờ này"},relativeTime:{future:{other:"sau {0} giờ nữa"},past:{other:"{0} giờ trước"}}},minute:{displayName:"Phút",relative:{0:"phút này"},relativeTime:{future:{other:"sau {0} phút nữa"},past:{other:"{0} phút trước"}}},"minute-short":{displayName:"Phút",relative:{0:"phút này"},relativeTime:{future:{other:"sau {0} phút nữa"},past:{other:"{0} phút trước"}}},second:{displayName:"Giây",relative:{0:"bây giờ"},relativeTime:{future:{other:"sau {0} giây nữa"},past:{other:"{0} giây trước"}}},"second-short":{displayName:"Giây",relative:{0:"bây giờ"},relativeTime:{future:{other:"sau {0} giây nữa"},past:{other:"{0} giây trước"}}}}}]});


/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ "./node_modules/react-is/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("./node_modules/react-is/cjs/react-is.production.min.js");
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),

/***/ "./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ "./node_modules/react-minimalist-portal/lib/portal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
var isBrowser = typeof window !== 'undefined';

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isBrowser) {
        if (!this.props.container) {
          this.container = document.createElement('div');
          document.body.appendChild(this.container);
        } else {
          this.container = this.props.container;
        }
        this.renderLayer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom2.default.unmountComponentAtNode(this.container);
      }
      if (!this.props.container) {
        document.body.removeChild(this.container);
      }
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (useCreatePortal) {
        return _reactDom2.default.createPortal(this.props.children, this.container);
      }
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node, // eslint-disable-line
  container: _propTypes2.default.object // eslint-disable-line
};

exports.default = Portal;

/***/ }),

/***/ "./node_modules/react-owl-carousel/lib/OwlCarousel.js":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("./node_modules/react/index.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["react-owl-carousel"] = factory(require("react"));
	else
		root["react-owl-carousel"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

eval("// shim for using process in browser\nvar process = module.exports = {};\n\n// cached from whatever global is present so that test runners that stub it\n// don't break things.  But we need to wrap it in a try catch in case it is\n// wrapped in strict mode code which doesn't define any globals.  It's inside a\n// function because try/catches deoptimize in certain engines.\n\nvar cachedSetTimeout;\nvar cachedClearTimeout;\n\nfunction defaultSetTimout() {\n    throw new Error('setTimeout has not been defined');\n}\nfunction defaultClearTimeout () {\n    throw new Error('clearTimeout has not been defined');\n}\n(function () {\n    try {\n        if (typeof setTimeout === 'function') {\n            cachedSetTimeout = setTimeout;\n        } else {\n            cachedSetTimeout = defaultSetTimout;\n        }\n    } catch (e) {\n        cachedSetTimeout = defaultSetTimout;\n    }\n    try {\n        if (typeof clearTimeout === 'function') {\n            cachedClearTimeout = clearTimeout;\n        } else {\n            cachedClearTimeout = defaultClearTimeout;\n        }\n    } catch (e) {\n        cachedClearTimeout = defaultClearTimeout;\n    }\n} ())\nfunction runTimeout(fun) {\n    if (cachedSetTimeout === setTimeout) {\n        //normal enviroments in sane situations\n        return setTimeout(fun, 0);\n    }\n    // if setTimeout wasn't available but was latter defined\n    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {\n        cachedSetTimeout = setTimeout;\n        return setTimeout(fun, 0);\n    }\n    try {\n        // when when somebody has screwed with setTimeout but no I.E. maddness\n        return cachedSetTimeout(fun, 0);\n    } catch(e){\n        try {\n            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally\n            return cachedSetTimeout.call(null, fun, 0);\n        } catch(e){\n            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error\n            return cachedSetTimeout.call(this, fun, 0);\n        }\n    }\n\n\n}\nfunction runClearTimeout(marker) {\n    if (cachedClearTimeout === clearTimeout) {\n        //normal enviroments in sane situations\n        return clearTimeout(marker);\n    }\n    // if clearTimeout wasn't available but was latter defined\n    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {\n        cachedClearTimeout = clearTimeout;\n        return clearTimeout(marker);\n    }\n    try {\n        // when when somebody has screwed with setTimeout but no I.E. maddness\n        return cachedClearTimeout(marker);\n    } catch (e){\n        try {\n            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally\n            return cachedClearTimeout.call(null, marker);\n        } catch (e){\n            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.\n            // Some versions of I.E. have different rules for clearTimeout vs setTimeout\n            return cachedClearTimeout.call(this, marker);\n        }\n    }\n\n\n\n}\nvar queue = [];\nvar draining = false;\nvar currentQueue;\nvar queueIndex = -1;\n\nfunction cleanUpNextTick() {\n    if (!draining || !currentQueue) {\n        return;\n    }\n    draining = false;\n    if (currentQueue.length) {\n        queue = currentQueue.concat(queue);\n    } else {\n        queueIndex = -1;\n    }\n    if (queue.length) {\n        drainQueue();\n    }\n}\n\nfunction drainQueue() {\n    if (draining) {\n        return;\n    }\n    var timeout = runTimeout(cleanUpNextTick);\n    draining = true;\n\n    var len = queue.length;\n    while(len) {\n        currentQueue = queue;\n        queue = [];\n        while (++queueIndex < len) {\n            if (currentQueue) {\n                currentQueue[queueIndex].run();\n            }\n        }\n        queueIndex = -1;\n        len = queue.length;\n    }\n    currentQueue = null;\n    draining = false;\n    runClearTimeout(timeout);\n}\n\nprocess.nextTick = function (fun) {\n    var args = new Array(arguments.length - 1);\n    if (arguments.length > 1) {\n        for (var i = 1; i < arguments.length; i++) {\n            args[i - 1] = arguments[i];\n        }\n    }\n    queue.push(new Item(fun, args));\n    if (queue.length === 1 && !draining) {\n        runTimeout(drainQueue);\n    }\n};\n\n// v8 likes predictible objects\nfunction Item(fun, array) {\n    this.fun = fun;\n    this.array = array;\n}\nItem.prototype.run = function () {\n    this.fun.apply(null, this.array);\n};\nprocess.title = 'browser';\nprocess.browser = true;\nprocess.env = {};\nprocess.argv = [];\nprocess.version = ''; // empty string to avoid regexp issues\nprocess.versions = {};\n\nfunction noop() {}\n\nprocess.on = noop;\nprocess.addListener = noop;\nprocess.once = noop;\nprocess.off = noop;\nprocess.removeListener = noop;\nprocess.removeAllListeners = noop;\nprocess.emit = noop;\nprocess.prependListener = noop;\nprocess.prependOnceListener = noop;\n\nprocess.listeners = function (name) { return [] }\n\nprocess.binding = function (name) {\n    throw new Error('process.binding is not supported');\n};\n\nprocess.cwd = function () { return '/' };\nprocess.chdir = function (dir) {\n    throw new Error('process.chdir is not supported');\n};\nprocess.umask = function() { return 0; };\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/node-libs-browser/~/process/browser.js\n// module id = 0\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/node-libs-browser/~/process/browser.js?");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

eval("var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!\n * jQuery JavaScript Library v3.2.1\n * https://jquery.com/\n *\n * Includes Sizzle.js\n * https://sizzlejs.com/\n *\n * Copyright JS Foundation and other contributors\n * Released under the MIT license\n * https://jquery.org/license\n *\n * Date: 2017-03-20T18:59Z\n */\n( function( global, factory ) {\n\n\t\"use strict\";\n\n\tif ( typeof module === \"object\" && typeof module.exports === \"object\" ) {\n\n\t\t// For CommonJS and CommonJS-like environments where a proper `window`\n\t\t// is present, execute the factory and get jQuery.\n\t\t// For environments that do not have a `window` with a `document`\n\t\t// (such as Node.js), expose a factory as module.exports.\n\t\t// This accentuates the need for the creation of a real `window`.\n\t\t// e.g. var jQuery = require(\"jquery\")(window);\n\t\t// See ticket #14549 for more info.\n\t\tmodule.exports = global.document ?\n\t\t\tfactory( global, true ) :\n\t\t\tfunction( w ) {\n\t\t\t\tif ( !w.document ) {\n\t\t\t\t\tthrow new Error( \"jQuery requires a window with a document\" );\n\t\t\t\t}\n\t\t\t\treturn factory( w );\n\t\t\t};\n\t} else {\n\t\tfactory( global );\n\t}\n\n// Pass this if window is not defined yet\n} )( typeof window !== \"undefined\" ? window : this, function( window, noGlobal ) {\n\n// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1\n// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode\n// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common\n// enough that all such attempts are guarded in a try block.\n\"use strict\";\n\nvar arr = [];\n\nvar document = window.document;\n\nvar getProto = Object.getPrototypeOf;\n\nvar slice = arr.slice;\n\nvar concat = arr.concat;\n\nvar push = arr.push;\n\nvar indexOf = arr.indexOf;\n\nvar class2type = {};\n\nvar toString = class2type.toString;\n\nvar hasOwn = class2type.hasOwnProperty;\n\nvar fnToString = hasOwn.toString;\n\nvar ObjectFunctionString = fnToString.call( Object );\n\nvar support = {};\n\n\n\n\tfunction DOMEval( code, doc ) {\n\t\tdoc = doc || document;\n\n\t\tvar script = doc.createElement( \"script\" );\n\n\t\tscript.text = code;\n\t\tdoc.head.appendChild( script ).parentNode.removeChild( script );\n\t}\n/* global Symbol */\n// Defining this global in .eslintrc.json would create a danger of using the global\n// unguarded in another place, it seems safer to define global only for this module\n\n\n\nvar\n\tversion = \"3.2.1\",\n\n\t// Define a local copy of jQuery\n\tjQuery = function( selector, context ) {\n\n\t\t// The jQuery object is actually just the init constructor 'enhanced'\n\t\t// Need init if jQuery is called (just allow error to be thrown if not included)\n\t\treturn new jQuery.fn.init( selector, context );\n\t},\n\n\t// Support: Android <=4.0 only\n\t// Make sure we trim BOM and NBSP\n\trtrim = /^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g,\n\n\t// Matches dashed string for camelizing\n\trmsPrefix = /^-ms-/,\n\trdashAlpha = /-([a-z])/g,\n\n\t// Used by jQuery.camelCase as callback to replace()\n\tfcamelCase = function( all, letter ) {\n\t\treturn letter.toUpperCase();\n\t};\n\njQuery.fn = jQuery.prototype = {\n\n\t// The current version of jQuery being used\n\tjquery: version,\n\n\tconstructor: jQuery,\n\n\t// The default length of a jQuery object is 0\n\tlength: 0,\n\n\ttoArray: function() {\n\t\treturn slice.call( this );\n\t},\n\n\t// Get the Nth element in the matched element set OR\n\t// Get the whole matched element set as a clean array\n\tget: function( num ) {\n\n\t\t// Return all the elements in a clean array\n\t\tif ( num == null ) {\n\t\t\treturn slice.call( this );\n\t\t}\n\n\t\t// Return just the one element from the set\n\t\treturn num < 0 ? this[ num + this.length ] : this[ num ];\n\t},\n\n\t// Take an array of elements and push it onto the stack\n\t// (returning the new matched element set)\n\tpushStack: function( elems ) {\n\n\t\t// Build a new jQuery matched element set\n\t\tvar ret = jQuery.merge( this.constructor(), elems );\n\n\t\t// Add the old object onto the stack (as a reference)\n\t\tret.prevObject = this;\n\n\t\t// Return the newly-formed element set\n\t\treturn ret;\n\t},\n\n\t// Execute a callback for every element in the matched set.\n\teach: function( callback ) {\n\t\treturn jQuery.each( this, callback );\n\t},\n\n\tmap: function( callback ) {\n\t\treturn this.pushStack( jQuery.map( this, function( elem, i ) {\n\t\t\treturn callback.call( elem, i, elem );\n\t\t} ) );\n\t},\n\n\tslice: function() {\n\t\treturn this.pushStack( slice.apply( this, arguments ) );\n\t},\n\n\tfirst: function() {\n\t\treturn this.eq( 0 );\n\t},\n\n\tlast: function() {\n\t\treturn this.eq( -1 );\n\t},\n\n\teq: function( i ) {\n\t\tvar len = this.length,\n\t\t\tj = +i + ( i < 0 ? len : 0 );\n\t\treturn this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );\n\t},\n\n\tend: function() {\n\t\treturn this.prevObject || this.constructor();\n\t},\n\n\t// For internal use only.\n\t// Behaves like an Array's method, not like a jQuery method.\n\tpush: push,\n\tsort: arr.sort,\n\tsplice: arr.splice\n};\n\njQuery.extend = jQuery.fn.extend = function() {\n\tvar options, name, src, copy, copyIsArray, clone,\n\t\ttarget = arguments[ 0 ] || {},\n\t\ti = 1,\n\t\tlength = arguments.length,\n\t\tdeep = false;\n\n\t// Handle a deep copy situation\n\tif ( typeof target === \"boolean\" ) {\n\t\tdeep = target;\n\n\t\t// Skip the boolean and the target\n\t\ttarget = arguments[ i ] || {};\n\t\ti++;\n\t}\n\n\t// Handle case when target is a string or something (possible in deep copy)\n\tif ( typeof target !== \"object\" && !jQuery.isFunction( target ) ) {\n\t\ttarget = {};\n\t}\n\n\t// Extend jQuery itself if only one argument is passed\n\tif ( i === length ) {\n\t\ttarget = this;\n\t\ti--;\n\t}\n\n\tfor ( ; i < length; i++ ) {\n\n\t\t// Only deal with non-null/undefined values\n\t\tif ( ( options = arguments[ i ] ) != null ) {\n\n\t\t\t// Extend the base object\n\t\t\tfor ( name in options ) {\n\t\t\t\tsrc = target[ name ];\n\t\t\t\tcopy = options[ name ];\n\n\t\t\t\t// Prevent never-ending loop\n\t\t\t\tif ( target === copy ) {\n\t\t\t\t\tcontinue;\n\t\t\t\t}\n\n\t\t\t\t// Recurse if we're merging plain objects or arrays\n\t\t\t\tif ( deep && copy && ( jQuery.isPlainObject( copy ) ||\n\t\t\t\t\t( copyIsArray = Array.isArray( copy ) ) ) ) {\n\n\t\t\t\t\tif ( copyIsArray ) {\n\t\t\t\t\t\tcopyIsArray = false;\n\t\t\t\t\t\tclone = src && Array.isArray( src ) ? src : [];\n\n\t\t\t\t\t} else {\n\t\t\t\t\t\tclone = src && jQuery.isPlainObject( src ) ? src : {};\n\t\t\t\t\t}\n\n\t\t\t\t\t// Never move original objects, clone them\n\t\t\t\t\ttarget[ name ] = jQuery.extend( deep, clone, copy );\n\n\t\t\t\t// Don't bring in undefined values\n\t\t\t\t} else if ( copy !== undefined ) {\n\t\t\t\t\ttarget[ name ] = copy;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Return the modified object\n\treturn target;\n};\n\njQuery.extend( {\n\n\t// Unique for each copy of jQuery on the page\n\texpando: \"jQuery\" + ( version + Math.random() ).replace( /\\D/g, \"\" ),\n\n\t// Assume jQuery is ready without the ready module\n\tisReady: true,\n\n\terror: function( msg ) {\n\t\tthrow new Error( msg );\n\t},\n\n\tnoop: function() {},\n\n\tisFunction: function( obj ) {\n\t\treturn jQuery.type( obj ) === \"function\";\n\t},\n\n\tisWindow: function( obj ) {\n\t\treturn obj != null && obj === obj.window;\n\t},\n\n\tisNumeric: function( obj ) {\n\n\t\t// As of jQuery 3.0, isNumeric is limited to\n\t\t// strings and numbers (primitives or objects)\n\t\t// that can be coerced to finite numbers (gh-2662)\n\t\tvar type = jQuery.type( obj );\n\t\treturn ( type === \"number\" || type === \"string\" ) &&\n\n\t\t\t// parseFloat NaNs numeric-cast false positives (\"\")\n\t\t\t// ...but misinterprets leading-number strings, particularly hex literals (\"0x...\")\n\t\t\t// subtraction forces infinities to NaN\n\t\t\t!isNaN( obj - parseFloat( obj ) );\n\t},\n\n\tisPlainObject: function( obj ) {\n\t\tvar proto, Ctor;\n\n\t\t// Detect obvious negatives\n\t\t// Use toString instead of jQuery.type to catch host objects\n\t\tif ( !obj || toString.call( obj ) !== \"[object Object]\" ) {\n\t\t\treturn false;\n\t\t}\n\n\t\tproto = getProto( obj );\n\n\t\t// Objects with no prototype (e.g., `Object.create( null )`) are plain\n\t\tif ( !proto ) {\n\t\t\treturn true;\n\t\t}\n\n\t\t// Objects with prototype are plain iff they were constructed by a global Object function\n\t\tCtor = hasOwn.call( proto, \"constructor\" ) && proto.constructor;\n\t\treturn typeof Ctor === \"function\" && fnToString.call( Ctor ) === ObjectFunctionString;\n\t},\n\n\tisEmptyObject: function( obj ) {\n\n\t\t/* eslint-disable no-unused-vars */\n\t\t// See https://github.com/eslint/eslint/issues/6125\n\t\tvar name;\n\n\t\tfor ( name in obj ) {\n\t\t\treturn false;\n\t\t}\n\t\treturn true;\n\t},\n\n\ttype: function( obj ) {\n\t\tif ( obj == null ) {\n\t\t\treturn obj + \"\";\n\t\t}\n\n\t\t// Support: Android <=2.3 only (functionish RegExp)\n\t\treturn typeof obj === \"object\" || typeof obj === \"function\" ?\n\t\t\tclass2type[ toString.call( obj ) ] || \"object\" :\n\t\t\ttypeof obj;\n\t},\n\n\t// Evaluates a script in a global context\n\tglobalEval: function( code ) {\n\t\tDOMEval( code );\n\t},\n\n\t// Convert dashed to camelCase; used by the css and data modules\n\t// Support: IE <=9 - 11, Edge 12 - 13\n\t// Microsoft forgot to hump their vendor prefix (#9572)\n\tcamelCase: function( string ) {\n\t\treturn string.replace( rmsPrefix, \"ms-\" ).replace( rdashAlpha, fcamelCase );\n\t},\n\n\teach: function( obj, callback ) {\n\t\tvar length, i = 0;\n\n\t\tif ( isArrayLike( obj ) ) {\n\t\t\tlength = obj.length;\n\t\t\tfor ( ; i < length; i++ ) {\n\t\t\t\tif ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t} else {\n\t\t\tfor ( i in obj ) {\n\t\t\t\tif ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn obj;\n\t},\n\n\t// Support: Android <=4.0 only\n\ttrim: function( text ) {\n\t\treturn text == null ?\n\t\t\t\"\" :\n\t\t\t( text + \"\" ).replace( rtrim, \"\" );\n\t},\n\n\t// results is for internal usage only\n\tmakeArray: function( arr, results ) {\n\t\tvar ret = results || [];\n\n\t\tif ( arr != null ) {\n\t\t\tif ( isArrayLike( Object( arr ) ) ) {\n\t\t\t\tjQuery.merge( ret,\n\t\t\t\t\ttypeof arr === \"string\" ?\n\t\t\t\t\t[ arr ] : arr\n\t\t\t\t);\n\t\t\t} else {\n\t\t\t\tpush.call( ret, arr );\n\t\t\t}\n\t\t}\n\n\t\treturn ret;\n\t},\n\n\tinArray: function( elem, arr, i ) {\n\t\treturn arr == null ? -1 : indexOf.call( arr, elem, i );\n\t},\n\n\t// Support: Android <=4.0 only, PhantomJS 1 only\n\t// push.apply(_, arraylike) throws on ancient WebKit\n\tmerge: function( first, second ) {\n\t\tvar len = +second.length,\n\t\t\tj = 0,\n\t\t\ti = first.length;\n\n\t\tfor ( ; j < len; j++ ) {\n\t\t\tfirst[ i++ ] = second[ j ];\n\t\t}\n\n\t\tfirst.length = i;\n\n\t\treturn first;\n\t},\n\n\tgrep: function( elems, callback, invert ) {\n\t\tvar callbackInverse,\n\t\t\tmatches = [],\n\t\t\ti = 0,\n\t\t\tlength = elems.length,\n\t\t\tcallbackExpect = !invert;\n\n\t\t// Go through the array, only saving the items\n\t\t// that pass the validator function\n\t\tfor ( ; i < length; i++ ) {\n\t\t\tcallbackInverse = !callback( elems[ i ], i );\n\t\t\tif ( callbackInverse !== callbackExpect ) {\n\t\t\t\tmatches.push( elems[ i ] );\n\t\t\t}\n\t\t}\n\n\t\treturn matches;\n\t},\n\n\t// arg is for internal usage only\n\tmap: function( elems, callback, arg ) {\n\t\tvar length, value,\n\t\t\ti = 0,\n\t\t\tret = [];\n\n\t\t// Go through the array, translating each of the items to their new values\n\t\tif ( isArrayLike( elems ) ) {\n\t\t\tlength = elems.length;\n\t\t\tfor ( ; i < length; i++ ) {\n\t\t\t\tvalue = callback( elems[ i ], i, arg );\n\n\t\t\t\tif ( value != null ) {\n\t\t\t\t\tret.push( value );\n\t\t\t\t}\n\t\t\t}\n\n\t\t// Go through every key on the object,\n\t\t} else {\n\t\t\tfor ( i in elems ) {\n\t\t\t\tvalue = callback( elems[ i ], i, arg );\n\n\t\t\t\tif ( value != null ) {\n\t\t\t\t\tret.push( value );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t// Flatten any nested arrays\n\t\treturn concat.apply( [], ret );\n\t},\n\n\t// A global GUID counter for objects\n\tguid: 1,\n\n\t// Bind a function to a context, optionally partially applying any\n\t// arguments.\n\tproxy: function( fn, context ) {\n\t\tvar tmp, args, proxy;\n\n\t\tif ( typeof context === \"string\" ) {\n\t\t\ttmp = fn[ context ];\n\t\t\tcontext = fn;\n\t\t\tfn = tmp;\n\t\t}\n\n\t\t// Quick check to determine if target is callable, in the spec\n\t\t// this throws a TypeError, but we will just return undefined.\n\t\tif ( !jQuery.isFunction( fn ) ) {\n\t\t\treturn undefined;\n\t\t}\n\n\t\t// Simulated bind\n\t\targs = slice.call( arguments, 2 );\n\t\tproxy = function() {\n\t\t\treturn fn.apply( context || this, args.concat( slice.call( arguments ) ) );\n\t\t};\n\n\t\t// Set the guid of unique handler to the same of original handler, so it can be removed\n\t\tproxy.guid = fn.guid = fn.guid || jQuery.guid++;\n\n\t\treturn proxy;\n\t},\n\n\tnow: Date.now,\n\n\t// jQuery.support is not used in Core but other projects attach their\n\t// properties to it so it needs to exist.\n\tsupport: support\n} );\n\nif ( typeof Symbol === \"function\" ) {\n\tjQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];\n}\n\n// Populate the class2type map\njQuery.each( \"Boolean Number String Function Array Date RegExp Object Error Symbol\".split( \" \" ),\nfunction( i, name ) {\n\tclass2type[ \"[object \" + name + \"]\" ] = name.toLowerCase();\n} );\n\nfunction isArrayLike( obj ) {\n\n\t// Support: real iOS 8.2 only (not reproducible in simulator)\n\t// `in` check used to prevent JIT error (gh-2145)\n\t// hasOwn isn't used here due to false negatives\n\t// regarding Nodelist length in IE\n\tvar length = !!obj && \"length\" in obj && obj.length,\n\t\ttype = jQuery.type( obj );\n\n\tif ( type === \"function\" || jQuery.isWindow( obj ) ) {\n\t\treturn false;\n\t}\n\n\treturn type === \"array\" || length === 0 ||\n\t\ttypeof length === \"number\" && length > 0 && ( length - 1 ) in obj;\n}\nvar Sizzle =\n/*!\n * Sizzle CSS Selector Engine v2.3.3\n * https://sizzlejs.com/\n *\n * Copyright jQuery Foundation and other contributors\n * Released under the MIT license\n * http://jquery.org/license\n *\n * Date: 2016-08-08\n */\n(function( window ) {\n\nvar i,\n\tsupport,\n\tExpr,\n\tgetText,\n\tisXML,\n\ttokenize,\n\tcompile,\n\tselect,\n\toutermostContext,\n\tsortInput,\n\thasDuplicate,\n\n\t// Local document vars\n\tsetDocument,\n\tdocument,\n\tdocElem,\n\tdocumentIsHTML,\n\trbuggyQSA,\n\trbuggyMatches,\n\tmatches,\n\tcontains,\n\n\t// Instance-specific data\n\texpando = \"sizzle\" + 1 * new Date(),\n\tpreferredDoc = window.document,\n\tdirruns = 0,\n\tdone = 0,\n\tclassCache = createCache(),\n\ttokenCache = createCache(),\n\tcompilerCache = createCache(),\n\tsortOrder = function( a, b ) {\n\t\tif ( a === b ) {\n\t\t\thasDuplicate = true;\n\t\t}\n\t\treturn 0;\n\t},\n\n\t// Instance methods\n\thasOwn = ({}).hasOwnProperty,\n\tarr = [],\n\tpop = arr.pop,\n\tpush_native = arr.push,\n\tpush = arr.push,\n\tslice = arr.slice,\n\t// Use a stripped-down indexOf as it's faster than native\n\t// https://jsperf.com/thor-indexof-vs-for/5\n\tindexOf = function( list, elem ) {\n\t\tvar i = 0,\n\t\t\tlen = list.length;\n\t\tfor ( ; i < len; i++ ) {\n\t\t\tif ( list[i] === elem ) {\n\t\t\t\treturn i;\n\t\t\t}\n\t\t}\n\t\treturn -1;\n\t},\n\n\tbooleans = \"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",\n\n\t// Regular expressions\n\n\t// http://www.w3.org/TR/css3-selectors/#whitespace\n\twhitespace = \"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",\n\n\t// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier\n\tidentifier = \"(?:\\\\\\\\.|[\\\\w-]|[^\\0-\\\\xa0])+\",\n\n\t// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors\n\tattributes = \"\\\\[\" + whitespace + \"*(\" + identifier + \")(?:\" + whitespace +\n\t\t// Operator (capture 2)\n\t\t\"*([*^$|!~]?=)\" + whitespace +\n\t\t// \"Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]\"\n\t\t\"*(?:'((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\"|(\" + identifier + \"))|)\" + whitespace +\n\t\t\"*\\\\]\",\n\n\tpseudos = \":(\" + identifier + \")(?:\\\\((\" +\n\t\t// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:\n\t\t// 1. quoted (capture 3; capture 4 or capture 5)\n\t\t\"('((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\")|\" +\n\t\t// 2. simple (capture 6)\n\t\t\"((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\" + attributes + \")*)|\" +\n\t\t// 3. anything else (capture 2)\n\t\t\".*\" +\n\t\t\")\\\\)|)\",\n\n\t// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter\n\trwhitespace = new RegExp( whitespace + \"+\", \"g\" ),\n\trtrim = new RegExp( \"^\" + whitespace + \"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\" + whitespace + \"+$\", \"g\" ),\n\n\trcomma = new RegExp( \"^\" + whitespace + \"*,\" + whitespace + \"*\" ),\n\trcombinators = new RegExp( \"^\" + whitespace + \"*([>+~]|\" + whitespace + \")\" + whitespace + \"*\" ),\n\n\trattributeQuotes = new RegExp( \"=\" + whitespace + \"*([^\\\\]'\\\"]*?)\" + whitespace + \"*\\\\]\", \"g\" ),\n\n\trpseudo = new RegExp( pseudos ),\n\tridentifier = new RegExp( \"^\" + identifier + \"$\" ),\n\n\tmatchExpr = {\n\t\t\"ID\": new RegExp( \"^#(\" + identifier + \")\" ),\n\t\t\"CLASS\": new RegExp( \"^\\\\.(\" + identifier + \")\" ),\n\t\t\"TAG\": new RegExp( \"^(\" + identifier + \"|[*])\" ),\n\t\t\"ATTR\": new RegExp( \"^\" + attributes ),\n\t\t\"PSEUDO\": new RegExp( \"^\" + pseudos ),\n\t\t\"CHILD\": new RegExp( \"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\" + whitespace +\n\t\t\t\"*(even|odd|(([+-]|)(\\\\d*)n|)\" + whitespace + \"*(?:([+-]|)\" + whitespace +\n\t\t\t\"*(\\\\d+)|))\" + whitespace + \"*\\\\)|)\", \"i\" ),\n\t\t\"bool\": new RegExp( \"^(?:\" + booleans + \")$\", \"i\" ),\n\t\t// For use in libraries implementing .is()\n\t\t// We use this for POS matching in `select`\n\t\t\"needsContext\": new RegExp( \"^\" + whitespace + \"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\" +\n\t\t\twhitespace + \"*((?:-\\\\d)?\\\\d*)\" + whitespace + \"*\\\\)|)(?=[^-]|$)\", \"i\" )\n\t},\n\n\trinputs = /^(?:input|select|textarea|button)$/i,\n\trheader = /^h\\d$/i,\n\n\trnative = /^[^{]+\\{\\s*\\[native \\w/,\n\n\t// Easily-parseable/retrievable ID or TAG or CLASS selectors\n\trquickExpr = /^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,\n\n\trsibling = /[+~]/,\n\n\t// CSS escapes\n\t// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters\n\trunescape = new RegExp( \"\\\\\\\\([\\\\da-f]{1,6}\" + whitespace + \"?|(\" + whitespace + \")|.)\", \"ig\" ),\n\tfunescape = function( _, escaped, escapedWhitespace ) {\n\t\tvar high = \"0x\" + escaped - 0x10000;\n\t\t// NaN means non-codepoint\n\t\t// Support: Firefox<24\n\t\t// Workaround erroneous numeric interpretation of +\"0x\"\n\t\treturn high !== high || escapedWhitespace ?\n\t\t\tescaped :\n\t\t\thigh < 0 ?\n\t\t\t\t// BMP codepoint\n\t\t\t\tString.fromCharCode( high + 0x10000 ) :\n\t\t\t\t// Supplemental Plane codepoint (surrogate pair)\n\t\t\t\tString.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );\n\t},\n\n\t// CSS string/identifier serialization\n\t// https://drafts.csswg.org/cssom/#common-serializing-idioms\n\trcssescape = /([\\0-\\x1f\\x7f]|^-?\\d)|^-$|[^\\0-\\x1f\\x7f-\\uFFFF\\w-]/g,\n\tfcssescape = function( ch, asCodePoint ) {\n\t\tif ( asCodePoint ) {\n\n\t\t\t// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER\n\t\t\tif ( ch === \"\\0\" ) {\n\t\t\t\treturn \"\\uFFFD\";\n\t\t\t}\n\n\t\t\t// Control characters and (dependent upon position) numbers get escaped as code points\n\t\t\treturn ch.slice( 0, -1 ) + \"\\\\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + \" \";\n\t\t}\n\n\t\t// Other potentially-special ASCII characters get backslash-escaped\n\t\treturn \"\\\\\" + ch;\n\t},\n\n\t// Used for iframes\n\t// See setDocument()\n\t// Removing the function wrapper causes a \"Permission Denied\"\n\t// error in IE\n\tunloadHandler = function() {\n\t\tsetDocument();\n\t},\n\n\tdisabledAncestor = addCombinator(\n\t\tfunction( elem ) {\n\t\t\treturn elem.disabled === true && (\"form\" in elem || \"label\" in elem);\n\t\t},\n\t\t{ dir: \"parentNode\", next: \"legend\" }\n\t);\n\n// Optimize for push.apply( _, NodeList )\ntry {\n\tpush.apply(\n\t\t(arr = slice.call( preferredDoc.childNodes )),\n\t\tpreferredDoc.childNodes\n\t);\n\t// Support: Android<4.0\n\t// Detect silently failing push.apply\n\tarr[ preferredDoc.childNodes.length ].nodeType;\n} catch ( e ) {\n\tpush = { apply: arr.length ?\n\n\t\t// Leverage slice if possible\n\t\tfunction( target, els ) {\n\t\t\tpush_native.apply( target, slice.call(els) );\n\t\t} :\n\n\t\t// Support: IE<9\n\t\t// Otherwise append directly\n\t\tfunction( target, els ) {\n\t\t\tvar j = target.length,\n\t\t\t\ti = 0;\n\t\t\t// Can't trust NodeList.length\n\t\t\twhile ( (target[j++] = els[i++]) ) {}\n\t\t\ttarget.length = j - 1;\n\t\t}\n\t};\n}\n\nfunction Sizzle( selector, context, results, seed ) {\n\tvar m, i, elem, nid, match, groups, newSelector,\n\t\tnewContext = context && context.ownerDocument,\n\n\t\t// nodeType defaults to 9, since context defaults to document\n\t\tnodeType = context ? context.nodeType : 9;\n\n\tresults = results || [];\n\n\t// Return early from calls with invalid selector or context\n\tif ( typeof selector !== \"string\" || !selector ||\n\t\tnodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {\n\n\t\treturn results;\n\t}\n\n\t// Try to shortcut find operations (as opposed to filters) in HTML documents\n\tif ( !seed ) {\n\n\t\tif ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {\n\t\t\tsetDocument( context );\n\t\t}\n\t\tcontext = context || document;\n\n\t\tif ( documentIsHTML ) {\n\n\t\t\t// If the selector is sufficiently simple, try using a \"get*By*\" DOM method\n\t\t\t// (excepting DocumentFragment context, where the methods don't exist)\n\t\t\tif ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {\n\n\t\t\t\t// ID selector\n\t\t\t\tif ( (m = match[1]) ) {\n\n\t\t\t\t\t// Document context\n\t\t\t\t\tif ( nodeType === 9 ) {\n\t\t\t\t\t\tif ( (elem = context.getElementById( m )) ) {\n\n\t\t\t\t\t\t\t// Support: IE, Opera, Webkit\n\t\t\t\t\t\t\t// TODO: identify versions\n\t\t\t\t\t\t\t// getElementById can match elements by name instead of ID\n\t\t\t\t\t\t\tif ( elem.id === m ) {\n\t\t\t\t\t\t\t\tresults.push( elem );\n\t\t\t\t\t\t\t\treturn results;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\treturn results;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t// Element context\n\t\t\t\t\t} else {\n\n\t\t\t\t\t\t// Support: IE, Opera, Webkit\n\t\t\t\t\t\t// TODO: identify versions\n\t\t\t\t\t\t// getElementById can match elements by name instead of ID\n\t\t\t\t\t\tif ( newContext && (elem = newContext.getElementById( m )) &&\n\t\t\t\t\t\t\tcontains( context, elem ) &&\n\t\t\t\t\t\t\telem.id === m ) {\n\n\t\t\t\t\t\t\tresults.push( elem );\n\t\t\t\t\t\t\treturn results;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t// Type selector\n\t\t\t\t} else if ( match[2] ) {\n\t\t\t\t\tpush.apply( results, context.getElementsByTagName( selector ) );\n\t\t\t\t\treturn results;\n\n\t\t\t\t// Class selector\n\t\t\t\t} else if ( (m = match[3]) && support.getElementsByClassName &&\n\t\t\t\t\tcontext.getElementsByClassName ) {\n\n\t\t\t\t\tpush.apply( results, context.getElementsByClassName( m ) );\n\t\t\t\t\treturn results;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Take advantage of querySelectorAll\n\t\t\tif ( support.qsa &&\n\t\t\t\t!compilerCache[ selector + \" \" ] &&\n\t\t\t\t(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {\n\n\t\t\t\tif ( nodeType !== 1 ) {\n\t\t\t\t\tnewContext = context;\n\t\t\t\t\tnewSelector = selector;\n\n\t\t\t\t// qSA looks outside Element context, which is not what we want\n\t\t\t\t// Thanks to Andrew Dupont for this workaround technique\n\t\t\t\t// Support: IE <=8\n\t\t\t\t// Exclude object elements\n\t\t\t\t} else if ( context.nodeName.toLowerCase() !== \"object\" ) {\n\n\t\t\t\t\t// Capture the context ID, setting it first if necessary\n\t\t\t\t\tif ( (nid = context.getAttribute( \"id\" )) ) {\n\t\t\t\t\t\tnid = nid.replace( rcssescape, fcssescape );\n\t\t\t\t\t} else {\n\t\t\t\t\t\tcontext.setAttribute( \"id\", (nid = expando) );\n\t\t\t\t\t}\n\n\t\t\t\t\t// Prefix every selector in the list\n\t\t\t\t\tgroups = tokenize( selector );\n\t\t\t\t\ti = groups.length;\n\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\tgroups[i] = \"#\" + nid + \" \" + toSelector( groups[i] );\n\t\t\t\t\t}\n\t\t\t\t\tnewSelector = groups.join( \",\" );\n\n\t\t\t\t\t// Expand context for sibling selectors\n\t\t\t\t\tnewContext = rsibling.test( selector ) && testContext( context.parentNode ) ||\n\t\t\t\t\t\tcontext;\n\t\t\t\t}\n\n\t\t\t\tif ( newSelector ) {\n\t\t\t\t\ttry {\n\t\t\t\t\t\tpush.apply( results,\n\t\t\t\t\t\t\tnewContext.querySelectorAll( newSelector )\n\t\t\t\t\t\t);\n\t\t\t\t\t\treturn results;\n\t\t\t\t\t} catch ( qsaError ) {\n\t\t\t\t\t} finally {\n\t\t\t\t\t\tif ( nid === expando ) {\n\t\t\t\t\t\t\tcontext.removeAttribute( \"id\" );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// All others\n\treturn select( selector.replace( rtrim, \"$1\" ), context, results, seed );\n}\n\n/**\n * Create key-value caches of limited size\n * @returns {function(string, object)} Returns the Object data after storing it on itself with\n *\tproperty name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)\n *\tdeleting the oldest entry\n */\nfunction createCache() {\n\tvar keys = [];\n\n\tfunction cache( key, value ) {\n\t\t// Use (key + \" \") to avoid collision with native prototype properties (see Issue #157)\n\t\tif ( keys.push( key + \" \" ) > Expr.cacheLength ) {\n\t\t\t// Only keep the most recent entries\n\t\t\tdelete cache[ keys.shift() ];\n\t\t}\n\t\treturn (cache[ key + \" \" ] = value);\n\t}\n\treturn cache;\n}\n\n/**\n * Mark a function for special use by Sizzle\n * @param {Function} fn The function to mark\n */\nfunction markFunction( fn ) {\n\tfn[ expando ] = true;\n\treturn fn;\n}\n\n/**\n * Support testing using an element\n * @param {Function} fn Passed the created element and returns a boolean result\n */\nfunction assert( fn ) {\n\tvar el = document.createElement(\"fieldset\");\n\n\ttry {\n\t\treturn !!fn( el );\n\t} catch (e) {\n\t\treturn false;\n\t} finally {\n\t\t// Remove from its parent by default\n\t\tif ( el.parentNode ) {\n\t\t\tel.parentNode.removeChild( el );\n\t\t}\n\t\t// release memory in IE\n\t\tel = null;\n\t}\n}\n\n/**\n * Adds the same handler for all of the specified attrs\n * @param {String} attrs Pipe-separated list of attributes\n * @param {Function} handler The method that will be applied\n */\nfunction addHandle( attrs, handler ) {\n\tvar arr = attrs.split(\"|\"),\n\t\ti = arr.length;\n\n\twhile ( i-- ) {\n\t\tExpr.attrHandle[ arr[i] ] = handler;\n\t}\n}\n\n/**\n * Checks document order of two siblings\n * @param {Element} a\n * @param {Element} b\n * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b\n */\nfunction siblingCheck( a, b ) {\n\tvar cur = b && a,\n\t\tdiff = cur && a.nodeType === 1 && b.nodeType === 1 &&\n\t\t\ta.sourceIndex - b.sourceIndex;\n\n\t// Use IE sourceIndex if available on both nodes\n\tif ( diff ) {\n\t\treturn diff;\n\t}\n\n\t// Check if b follows a\n\tif ( cur ) {\n\t\twhile ( (cur = cur.nextSibling) ) {\n\t\t\tif ( cur === b ) {\n\t\t\t\treturn -1;\n\t\t\t}\n\t\t}\n\t}\n\n\treturn a ? 1 : -1;\n}\n\n/**\n * Returns a function to use in pseudos for input types\n * @param {String} type\n */\nfunction createInputPseudo( type ) {\n\treturn function( elem ) {\n\t\tvar name = elem.nodeName.toLowerCase();\n\t\treturn name === \"input\" && elem.type === type;\n\t};\n}\n\n/**\n * Returns a function to use in pseudos for buttons\n * @param {String} type\n */\nfunction createButtonPseudo( type ) {\n\treturn function( elem ) {\n\t\tvar name = elem.nodeName.toLowerCase();\n\t\treturn (name === \"input\" || name === \"button\") && elem.type === type;\n\t};\n}\n\n/**\n * Returns a function to use in pseudos for :enabled/:disabled\n * @param {Boolean} disabled true for :disabled; false for :enabled\n */\nfunction createDisabledPseudo( disabled ) {\n\n\t// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable\n\treturn function( elem ) {\n\n\t\t// Only certain elements can match :enabled or :disabled\n\t\t// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled\n\t\t// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled\n\t\tif ( \"form\" in elem ) {\n\n\t\t\t// Check for inherited disabledness on relevant non-disabled elements:\n\t\t\t// * listed form-associated elements in a disabled fieldset\n\t\t\t//   https://html.spec.whatwg.org/multipage/forms.html#category-listed\n\t\t\t//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled\n\t\t\t// * option elements in a disabled optgroup\n\t\t\t//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled\n\t\t\t// All such elements have a \"form\" property.\n\t\t\tif ( elem.parentNode && elem.disabled === false ) {\n\n\t\t\t\t// Option elements defer to a parent optgroup if present\n\t\t\t\tif ( \"label\" in elem ) {\n\t\t\t\t\tif ( \"label\" in elem.parentNode ) {\n\t\t\t\t\t\treturn elem.parentNode.disabled === disabled;\n\t\t\t\t\t} else {\n\t\t\t\t\t\treturn elem.disabled === disabled;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Support: IE 6 - 11\n\t\t\t\t// Use the isDisabled shortcut property to check for disabled fieldset ancestors\n\t\t\t\treturn elem.isDisabled === disabled ||\n\n\t\t\t\t\t// Where there is no isDisabled, check manually\n\t\t\t\t\t/* jshint -W018 */\n\t\t\t\t\telem.isDisabled !== !disabled &&\n\t\t\t\t\t\tdisabledAncestor( elem ) === disabled;\n\t\t\t}\n\n\t\t\treturn elem.disabled === disabled;\n\n\t\t// Try to winnow out elements that can't be disabled before trusting the disabled property.\n\t\t// Some victims get caught in our net (label, legend, menu, track), but it shouldn't\n\t\t// even exist on them, let alone have a boolean value.\n\t\t} else if ( \"label\" in elem ) {\n\t\t\treturn elem.disabled === disabled;\n\t\t}\n\n\t\t// Remaining elements are neither :enabled nor :disabled\n\t\treturn false;\n\t};\n}\n\n/**\n * Returns a function to use in pseudos for positionals\n * @param {Function} fn\n */\nfunction createPositionalPseudo( fn ) {\n\treturn markFunction(function( argument ) {\n\t\targument = +argument;\n\t\treturn markFunction(function( seed, matches ) {\n\t\t\tvar j,\n\t\t\t\tmatchIndexes = fn( [], seed.length, argument ),\n\t\t\t\ti = matchIndexes.length;\n\n\t\t\t// Match elements found at the specified indexes\n\t\t\twhile ( i-- ) {\n\t\t\t\tif ( seed[ (j = matchIndexes[i]) ] ) {\n\t\t\t\t\tseed[j] = !(matches[j] = seed[j]);\n\t\t\t\t}\n\t\t\t}\n\t\t});\n\t});\n}\n\n/**\n * Checks a node for validity as a Sizzle context\n * @param {Element|Object=} context\n * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value\n */\nfunction testContext( context ) {\n\treturn context && typeof context.getElementsByTagName !== \"undefined\" && context;\n}\n\n// Expose support vars for convenience\nsupport = Sizzle.support = {};\n\n/**\n * Detects XML nodes\n * @param {Element|Object} elem An element or a document\n * @returns {Boolean} True iff elem is a non-HTML XML node\n */\nisXML = Sizzle.isXML = function( elem ) {\n\t// documentElement is verified for cases where it doesn't yet exist\n\t// (such as loading iframes in IE - #4833)\n\tvar documentElement = elem && (elem.ownerDocument || elem).documentElement;\n\treturn documentElement ? documentElement.nodeName !== \"HTML\" : false;\n};\n\n/**\n * Sets document-related variables once based on the current document\n * @param {Element|Object} [doc] An element or document object to use to set the document\n * @returns {Object} Returns the current document\n */\nsetDocument = Sizzle.setDocument = function( node ) {\n\tvar hasCompare, subWindow,\n\t\tdoc = node ? node.ownerDocument || node : preferredDoc;\n\n\t// Return early if doc is invalid or already selected\n\tif ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {\n\t\treturn document;\n\t}\n\n\t// Update global variables\n\tdocument = doc;\n\tdocElem = document.documentElement;\n\tdocumentIsHTML = !isXML( document );\n\n\t// Support: IE 9-11, Edge\n\t// Accessing iframe documents after unload throws \"permission denied\" errors (jQuery #13936)\n\tif ( preferredDoc !== document &&\n\t\t(subWindow = document.defaultView) && subWindow.top !== subWindow ) {\n\n\t\t// Support: IE 11, Edge\n\t\tif ( subWindow.addEventListener ) {\n\t\t\tsubWindow.addEventListener( \"unload\", unloadHandler, false );\n\n\t\t// Support: IE 9 - 10 only\n\t\t} else if ( subWindow.attachEvent ) {\n\t\t\tsubWindow.attachEvent( \"onunload\", unloadHandler );\n\t\t}\n\t}\n\n\t/* Attributes\n\t---------------------------------------------------------------------- */\n\n\t// Support: IE<8\n\t// Verify that getAttribute really returns attributes and not properties\n\t// (excepting IE8 booleans)\n\tsupport.attributes = assert(function( el ) {\n\t\tel.className = \"i\";\n\t\treturn !el.getAttribute(\"className\");\n\t});\n\n\t/* getElement(s)By*\n\t---------------------------------------------------------------------- */\n\n\t// Check if getElementsByTagName(\"*\") returns only elements\n\tsupport.getElementsByTagName = assert(function( el ) {\n\t\tel.appendChild( document.createComment(\"\") );\n\t\treturn !el.getElementsByTagName(\"*\").length;\n\t});\n\n\t// Support: IE<9\n\tsupport.getElementsByClassName = rnative.test( document.getElementsByClassName );\n\n\t// Support: IE<10\n\t// Check if getElementById returns elements by name\n\t// The broken getElementById methods don't pick up programmatically-set names,\n\t// so use a roundabout getElementsByName test\n\tsupport.getById = assert(function( el ) {\n\t\tdocElem.appendChild( el ).id = expando;\n\t\treturn !document.getElementsByName || !document.getElementsByName( expando ).length;\n\t});\n\n\t// ID filter and find\n\tif ( support.getById ) {\n\t\tExpr.filter[\"ID\"] = function( id ) {\n\t\t\tvar attrId = id.replace( runescape, funescape );\n\t\t\treturn function( elem ) {\n\t\t\t\treturn elem.getAttribute(\"id\") === attrId;\n\t\t\t};\n\t\t};\n\t\tExpr.find[\"ID\"] = function( id, context ) {\n\t\t\tif ( typeof context.getElementById !== \"undefined\" && documentIsHTML ) {\n\t\t\t\tvar elem = context.getElementById( id );\n\t\t\t\treturn elem ? [ elem ] : [];\n\t\t\t}\n\t\t};\n\t} else {\n\t\tExpr.filter[\"ID\"] =  function( id ) {\n\t\t\tvar attrId = id.replace( runescape, funescape );\n\t\t\treturn function( elem ) {\n\t\t\t\tvar node = typeof elem.getAttributeNode !== \"undefined\" &&\n\t\t\t\t\telem.getAttributeNode(\"id\");\n\t\t\t\treturn node && node.value === attrId;\n\t\t\t};\n\t\t};\n\n\t\t// Support: IE 6 - 7 only\n\t\t// getElementById is not reliable as a find shortcut\n\t\tExpr.find[\"ID\"] = function( id, context ) {\n\t\t\tif ( typeof context.getElementById !== \"undefined\" && documentIsHTML ) {\n\t\t\t\tvar node, i, elems,\n\t\t\t\t\telem = context.getElementById( id );\n\n\t\t\t\tif ( elem ) {\n\n\t\t\t\t\t// Verify the id attribute\n\t\t\t\t\tnode = elem.getAttributeNode(\"id\");\n\t\t\t\t\tif ( node && node.value === id ) {\n\t\t\t\t\t\treturn [ elem ];\n\t\t\t\t\t}\n\n\t\t\t\t\t// Fall back on getElementsByName\n\t\t\t\t\telems = context.getElementsByName( id );\n\t\t\t\t\ti = 0;\n\t\t\t\t\twhile ( (elem = elems[i++]) ) {\n\t\t\t\t\t\tnode = elem.getAttributeNode(\"id\");\n\t\t\t\t\t\tif ( node && node.value === id ) {\n\t\t\t\t\t\t\treturn [ elem ];\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\treturn [];\n\t\t\t}\n\t\t};\n\t}\n\n\t// Tag\n\tExpr.find[\"TAG\"] = support.getElementsByTagName ?\n\t\tfunction( tag, context ) {\n\t\t\tif ( typeof context.getElementsByTagName !== \"undefined\" ) {\n\t\t\t\treturn context.getElementsByTagName( tag );\n\n\t\t\t// DocumentFragment nodes don't have gEBTN\n\t\t\t} else if ( support.qsa ) {\n\t\t\t\treturn context.querySelectorAll( tag );\n\t\t\t}\n\t\t} :\n\n\t\tfunction( tag, context ) {\n\t\t\tvar elem,\n\t\t\t\ttmp = [],\n\t\t\t\ti = 0,\n\t\t\t\t// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too\n\t\t\t\tresults = context.getElementsByTagName( tag );\n\n\t\t\t// Filter out possible comments\n\t\t\tif ( tag === \"*\" ) {\n\t\t\t\twhile ( (elem = results[i++]) ) {\n\t\t\t\t\tif ( elem.nodeType === 1 ) {\n\t\t\t\t\t\ttmp.push( elem );\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\treturn tmp;\n\t\t\t}\n\t\t\treturn results;\n\t\t};\n\n\t// Class\n\tExpr.find[\"CLASS\"] = support.getElementsByClassName && function( className, context ) {\n\t\tif ( typeof context.getElementsByClassName !== \"undefined\" && documentIsHTML ) {\n\t\t\treturn context.getElementsByClassName( className );\n\t\t}\n\t};\n\n\t/* QSA/matchesSelector\n\t---------------------------------------------------------------------- */\n\n\t// QSA and matchesSelector support\n\n\t// matchesSelector(:active) reports false when true (IE9/Opera 11.5)\n\trbuggyMatches = [];\n\n\t// qSa(:focus) reports false when true (Chrome 21)\n\t// We allow this because of a bug in IE8/9 that throws an error\n\t// whenever `document.activeElement` is accessed on an iframe\n\t// So, we allow :focus to pass through QSA all the time to avoid the IE error\n\t// See https://bugs.jquery.com/ticket/13378\n\trbuggyQSA = [];\n\n\tif ( (support.qsa = rnative.test( document.querySelectorAll )) ) {\n\t\t// Build QSA regex\n\t\t// Regex strategy adopted from Diego Perini\n\t\tassert(function( el ) {\n\t\t\t// Select is set to empty string on purpose\n\t\t\t// This is to test IE's treatment of not explicitly\n\t\t\t// setting a boolean content attribute,\n\t\t\t// since its presence should be enough\n\t\t\t// https://bugs.jquery.com/ticket/12359\n\t\t\tdocElem.appendChild( el ).innerHTML = \"<a id='\" + expando + \"'></a>\" +\n\t\t\t\t\"<select id='\" + expando + \"-\\r\\\\' msallowcapture=''>\" +\n\t\t\t\t\"<option selected=''></option></select>\";\n\n\t\t\t// Support: IE8, Opera 11-12.16\n\t\t\t// Nothing should be selected when empty strings follow ^= or $= or *=\n\t\t\t// The test attribute must be unknown in Opera but \"safe\" for WinRT\n\t\t\t// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section\n\t\t\tif ( el.querySelectorAll(\"[msallowcapture^='']\").length ) {\n\t\t\t\trbuggyQSA.push( \"[*^$]=\" + whitespace + \"*(?:''|\\\"\\\")\" );\n\t\t\t}\n\n\t\t\t// Support: IE8\n\t\t\t// Boolean attributes and \"value\" are not treated correctly\n\t\t\tif ( !el.querySelectorAll(\"[selected]\").length ) {\n\t\t\t\trbuggyQSA.push( \"\\\\[\" + whitespace + \"*(?:value|\" + booleans + \")\" );\n\t\t\t}\n\n\t\t\t// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+\n\t\t\tif ( !el.querySelectorAll( \"[id~=\" + expando + \"-]\" ).length ) {\n\t\t\t\trbuggyQSA.push(\"~=\");\n\t\t\t}\n\n\t\t\t// Webkit/Opera - :checked should return selected option elements\n\t\t\t// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked\n\t\t\t// IE8 throws error here and will not see later tests\n\t\t\tif ( !el.querySelectorAll(\":checked\").length ) {\n\t\t\t\trbuggyQSA.push(\":checked\");\n\t\t\t}\n\n\t\t\t// Support: Safari 8+, iOS 8+\n\t\t\t// https://bugs.webkit.org/show_bug.cgi?id=136851\n\t\t\t// In-page `selector#id sibling-combinator selector` fails\n\t\t\tif ( !el.querySelectorAll( \"a#\" + expando + \"+*\" ).length ) {\n\t\t\t\trbuggyQSA.push(\".#.+[+~]\");\n\t\t\t}\n\t\t});\n\n\t\tassert(function( el ) {\n\t\t\tel.innerHTML = \"<a href='' disabled='disabled'></a>\" +\n\t\t\t\t\"<select disabled='disabled'><option/></select>\";\n\n\t\t\t// Support: Windows 8 Native Apps\n\t\t\t// The type and name attributes are restricted during .innerHTML assignment\n\t\t\tvar input = document.createElement(\"input\");\n\t\t\tinput.setAttribute( \"type\", \"hidden\" );\n\t\t\tel.appendChild( input ).setAttribute( \"name\", \"D\" );\n\n\t\t\t// Support: IE8\n\t\t\t// Enforce case-sensitivity of name attribute\n\t\t\tif ( el.querySelectorAll(\"[name=d]\").length ) {\n\t\t\t\trbuggyQSA.push( \"name\" + whitespace + \"*[*^$|!~]?=\" );\n\t\t\t}\n\n\t\t\t// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)\n\t\t\t// IE8 throws error here and will not see later tests\n\t\t\tif ( el.querySelectorAll(\":enabled\").length !== 2 ) {\n\t\t\t\trbuggyQSA.push( \":enabled\", \":disabled\" );\n\t\t\t}\n\n\t\t\t// Support: IE9-11+\n\t\t\t// IE's :disabled selector does not pick up the children of disabled fieldsets\n\t\t\tdocElem.appendChild( el ).disabled = true;\n\t\t\tif ( el.querySelectorAll(\":disabled\").length !== 2 ) {\n\t\t\t\trbuggyQSA.push( \":enabled\", \":disabled\" );\n\t\t\t}\n\n\t\t\t// Opera 10-11 does not throw on post-comma invalid pseudos\n\t\t\tel.querySelectorAll(\"*,:x\");\n\t\t\trbuggyQSA.push(\",.*:\");\n\t\t});\n\t}\n\n\tif ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||\n\t\tdocElem.webkitMatchesSelector ||\n\t\tdocElem.mozMatchesSelector ||\n\t\tdocElem.oMatchesSelector ||\n\t\tdocElem.msMatchesSelector) )) ) {\n\n\t\tassert(function( el ) {\n\t\t\t// Check to see if it's possible to do matchesSelector\n\t\t\t// on a disconnected node (IE 9)\n\t\t\tsupport.disconnectedMatch = matches.call( el, \"*\" );\n\n\t\t\t// This should fail with an exception\n\t\t\t// Gecko does not error, returns false instead\n\t\t\tmatches.call( el, \"[s!='']:x\" );\n\t\t\trbuggyMatches.push( \"!=\", pseudos );\n\t\t});\n\t}\n\n\trbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join(\"|\") );\n\trbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join(\"|\") );\n\n\t/* Contains\n\t---------------------------------------------------------------------- */\n\thasCompare = rnative.test( docElem.compareDocumentPosition );\n\n\t// Element contains another\n\t// Purposefully self-exclusive\n\t// As in, an element does not contain itself\n\tcontains = hasCompare || rnative.test( docElem.contains ) ?\n\t\tfunction( a, b ) {\n\t\t\tvar adown = a.nodeType === 9 ? a.documentElement : a,\n\t\t\t\tbup = b && b.parentNode;\n\t\t\treturn a === bup || !!( bup && bup.nodeType === 1 && (\n\t\t\t\tadown.contains ?\n\t\t\t\t\tadown.contains( bup ) :\n\t\t\t\t\ta.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16\n\t\t\t));\n\t\t} :\n\t\tfunction( a, b ) {\n\t\t\tif ( b ) {\n\t\t\t\twhile ( (b = b.parentNode) ) {\n\t\t\t\t\tif ( b === a ) {\n\t\t\t\t\t\treturn true;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn false;\n\t\t};\n\n\t/* Sorting\n\t---------------------------------------------------------------------- */\n\n\t// Document order sorting\n\tsortOrder = hasCompare ?\n\tfunction( a, b ) {\n\n\t\t// Flag for duplicate removal\n\t\tif ( a === b ) {\n\t\t\thasDuplicate = true;\n\t\t\treturn 0;\n\t\t}\n\n\t\t// Sort on method existence if only one input has compareDocumentPosition\n\t\tvar compare = !a.compareDocumentPosition - !b.compareDocumentPosition;\n\t\tif ( compare ) {\n\t\t\treturn compare;\n\t\t}\n\n\t\t// Calculate position if both inputs belong to the same document\n\t\tcompare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?\n\t\t\ta.compareDocumentPosition( b ) :\n\n\t\t\t// Otherwise we know they are disconnected\n\t\t\t1;\n\n\t\t// Disconnected nodes\n\t\tif ( compare & 1 ||\n\t\t\t(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {\n\n\t\t\t// Choose the first element that is related to our preferred document\n\t\t\tif ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {\n\t\t\t\treturn -1;\n\t\t\t}\n\t\t\tif ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {\n\t\t\t\treturn 1;\n\t\t\t}\n\n\t\t\t// Maintain original order\n\t\t\treturn sortInput ?\n\t\t\t\t( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :\n\t\t\t\t0;\n\t\t}\n\n\t\treturn compare & 4 ? -1 : 1;\n\t} :\n\tfunction( a, b ) {\n\t\t// Exit early if the nodes are identical\n\t\tif ( a === b ) {\n\t\t\thasDuplicate = true;\n\t\t\treturn 0;\n\t\t}\n\n\t\tvar cur,\n\t\t\ti = 0,\n\t\t\taup = a.parentNode,\n\t\t\tbup = b.parentNode,\n\t\t\tap = [ a ],\n\t\t\tbp = [ b ];\n\n\t\t// Parentless nodes are either documents or disconnected\n\t\tif ( !aup || !bup ) {\n\t\t\treturn a === document ? -1 :\n\t\t\t\tb === document ? 1 :\n\t\t\t\taup ? -1 :\n\t\t\t\tbup ? 1 :\n\t\t\t\tsortInput ?\n\t\t\t\t( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :\n\t\t\t\t0;\n\n\t\t// If the nodes are siblings, we can do a quick check\n\t\t} else if ( aup === bup ) {\n\t\t\treturn siblingCheck( a, b );\n\t\t}\n\n\t\t// Otherwise we need full lists of their ancestors for comparison\n\t\tcur = a;\n\t\twhile ( (cur = cur.parentNode) ) {\n\t\t\tap.unshift( cur );\n\t\t}\n\t\tcur = b;\n\t\twhile ( (cur = cur.parentNode) ) {\n\t\t\tbp.unshift( cur );\n\t\t}\n\n\t\t// Walk down the tree looking for a discrepancy\n\t\twhile ( ap[i] === bp[i] ) {\n\t\t\ti++;\n\t\t}\n\n\t\treturn i ?\n\t\t\t// Do a sibling check if the nodes have a common ancestor\n\t\t\tsiblingCheck( ap[i], bp[i] ) :\n\n\t\t\t// Otherwise nodes in our document sort first\n\t\t\tap[i] === preferredDoc ? -1 :\n\t\t\tbp[i] === preferredDoc ? 1 :\n\t\t\t0;\n\t};\n\n\treturn document;\n};\n\nSizzle.matches = function( expr, elements ) {\n\treturn Sizzle( expr, null, null, elements );\n};\n\nSizzle.matchesSelector = function( elem, expr ) {\n\t// Set document vars if needed\n\tif ( ( elem.ownerDocument || elem ) !== document ) {\n\t\tsetDocument( elem );\n\t}\n\n\t// Make sure that attribute selectors are quoted\n\texpr = expr.replace( rattributeQuotes, \"='$1']\" );\n\n\tif ( support.matchesSelector && documentIsHTML &&\n\t\t!compilerCache[ expr + \" \" ] &&\n\t\t( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&\n\t\t( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {\n\n\t\ttry {\n\t\t\tvar ret = matches.call( elem, expr );\n\n\t\t\t// IE 9's matchesSelector returns false on disconnected nodes\n\t\t\tif ( ret || support.disconnectedMatch ||\n\t\t\t\t\t// As well, disconnected nodes are said to be in a document\n\t\t\t\t\t// fragment in IE 9\n\t\t\t\t\telem.document && elem.document.nodeType !== 11 ) {\n\t\t\t\treturn ret;\n\t\t\t}\n\t\t} catch (e) {}\n\t}\n\n\treturn Sizzle( expr, document, null, [ elem ] ).length > 0;\n};\n\nSizzle.contains = function( context, elem ) {\n\t// Set document vars if needed\n\tif ( ( context.ownerDocument || context ) !== document ) {\n\t\tsetDocument( context );\n\t}\n\treturn contains( context, elem );\n};\n\nSizzle.attr = function( elem, name ) {\n\t// Set document vars if needed\n\tif ( ( elem.ownerDocument || elem ) !== document ) {\n\t\tsetDocument( elem );\n\t}\n\n\tvar fn = Expr.attrHandle[ name.toLowerCase() ],\n\t\t// Don't get fooled by Object.prototype properties (jQuery #13807)\n\t\tval = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?\n\t\t\tfn( elem, name, !documentIsHTML ) :\n\t\t\tundefined;\n\n\treturn val !== undefined ?\n\t\tval :\n\t\tsupport.attributes || !documentIsHTML ?\n\t\t\telem.getAttribute( name ) :\n\t\t\t(val = elem.getAttributeNode(name)) && val.specified ?\n\t\t\t\tval.value :\n\t\t\t\tnull;\n};\n\nSizzle.escape = function( sel ) {\n\treturn (sel + \"\").replace( rcssescape, fcssescape );\n};\n\nSizzle.error = function( msg ) {\n\tthrow new Error( \"Syntax error, unrecognized expression: \" + msg );\n};\n\n/**\n * Document sorting and removing duplicates\n * @param {ArrayLike} results\n */\nSizzle.uniqueSort = function( results ) {\n\tvar elem,\n\t\tduplicates = [],\n\t\tj = 0,\n\t\ti = 0;\n\n\t// Unless we *know* we can detect duplicates, assume their presence\n\thasDuplicate = !support.detectDuplicates;\n\tsortInput = !support.sortStable && results.slice( 0 );\n\tresults.sort( sortOrder );\n\n\tif ( hasDuplicate ) {\n\t\twhile ( (elem = results[i++]) ) {\n\t\t\tif ( elem === results[ i ] ) {\n\t\t\t\tj = duplicates.push( i );\n\t\t\t}\n\t\t}\n\t\twhile ( j-- ) {\n\t\t\tresults.splice( duplicates[ j ], 1 );\n\t\t}\n\t}\n\n\t// Clear input after sorting to release objects\n\t// See https://github.com/jquery/sizzle/pull/225\n\tsortInput = null;\n\n\treturn results;\n};\n\n/**\n * Utility function for retrieving the text value of an array of DOM nodes\n * @param {Array|Element} elem\n */\ngetText = Sizzle.getText = function( elem ) {\n\tvar node,\n\t\tret = \"\",\n\t\ti = 0,\n\t\tnodeType = elem.nodeType;\n\n\tif ( !nodeType ) {\n\t\t// If no nodeType, this is expected to be an array\n\t\twhile ( (node = elem[i++]) ) {\n\t\t\t// Do not traverse comment nodes\n\t\t\tret += getText( node );\n\t\t}\n\t} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {\n\t\t// Use textContent for elements\n\t\t// innerText usage removed for consistency of new lines (jQuery #11153)\n\t\tif ( typeof elem.textContent === \"string\" ) {\n\t\t\treturn elem.textContent;\n\t\t} else {\n\t\t\t// Traverse its children\n\t\t\tfor ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {\n\t\t\t\tret += getText( elem );\n\t\t\t}\n\t\t}\n\t} else if ( nodeType === 3 || nodeType === 4 ) {\n\t\treturn elem.nodeValue;\n\t}\n\t// Do not include comment or processing instruction nodes\n\n\treturn ret;\n};\n\nExpr = Sizzle.selectors = {\n\n\t// Can be adjusted by the user\n\tcacheLength: 50,\n\n\tcreatePseudo: markFunction,\n\n\tmatch: matchExpr,\n\n\tattrHandle: {},\n\n\tfind: {},\n\n\trelative: {\n\t\t\">\": { dir: \"parentNode\", first: true },\n\t\t\" \": { dir: \"parentNode\" },\n\t\t\"+\": { dir: \"previousSibling\", first: true },\n\t\t\"~\": { dir: \"previousSibling\" }\n\t},\n\n\tpreFilter: {\n\t\t\"ATTR\": function( match ) {\n\t\t\tmatch[1] = match[1].replace( runescape, funescape );\n\n\t\t\t// Move the given value to match[3] whether quoted or unquoted\n\t\t\tmatch[3] = ( match[3] || match[4] || match[5] || \"\" ).replace( runescape, funescape );\n\n\t\t\tif ( match[2] === \"~=\" ) {\n\t\t\t\tmatch[3] = \" \" + match[3] + \" \";\n\t\t\t}\n\n\t\t\treturn match.slice( 0, 4 );\n\t\t},\n\n\t\t\"CHILD\": function( match ) {\n\t\t\t/* matches from matchExpr[\"CHILD\"]\n\t\t\t\t1 type (only|nth|...)\n\t\t\t\t2 what (child|of-type)\n\t\t\t\t3 argument (even|odd|\\d*|\\d*n([+-]\\d+)?|...)\n\t\t\t\t4 xn-component of xn+y argument ([+-]?\\d*n|)\n\t\t\t\t5 sign of xn-component\n\t\t\t\t6 x of xn-component\n\t\t\t\t7 sign of y-component\n\t\t\t\t8 y of y-component\n\t\t\t*/\n\t\t\tmatch[1] = match[1].toLowerCase();\n\n\t\t\tif ( match[1].slice( 0, 3 ) === \"nth\" ) {\n\t\t\t\t// nth-* requires argument\n\t\t\t\tif ( !match[3] ) {\n\t\t\t\t\tSizzle.error( match[0] );\n\t\t\t\t}\n\n\t\t\t\t// numeric x and y parameters for Expr.filter.CHILD\n\t\t\t\t// remember that false/true cast respectively to 0/1\n\t\t\t\tmatch[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === \"even\" || match[3] === \"odd\" ) );\n\t\t\t\tmatch[5] = +( ( match[7] + match[8] ) || match[3] === \"odd\" );\n\n\t\t\t// other types prohibit arguments\n\t\t\t} else if ( match[3] ) {\n\t\t\t\tSizzle.error( match[0] );\n\t\t\t}\n\n\t\t\treturn match;\n\t\t},\n\n\t\t\"PSEUDO\": function( match ) {\n\t\t\tvar excess,\n\t\t\t\tunquoted = !match[6] && match[2];\n\n\t\t\tif ( matchExpr[\"CHILD\"].test( match[0] ) ) {\n\t\t\t\treturn null;\n\t\t\t}\n\n\t\t\t// Accept quoted arguments as-is\n\t\t\tif ( match[3] ) {\n\t\t\t\tmatch[2] = match[4] || match[5] || \"\";\n\n\t\t\t// Strip excess characters from unquoted arguments\n\t\t\t} else if ( unquoted && rpseudo.test( unquoted ) &&\n\t\t\t\t// Get excess from tokenize (recursively)\n\t\t\t\t(excess = tokenize( unquoted, true )) &&\n\t\t\t\t// advance to the next closing parenthesis\n\t\t\t\t(excess = unquoted.indexOf( \")\", unquoted.length - excess ) - unquoted.length) ) {\n\n\t\t\t\t// excess is a negative index\n\t\t\t\tmatch[0] = match[0].slice( 0, excess );\n\t\t\t\tmatch[2] = unquoted.slice( 0, excess );\n\t\t\t}\n\n\t\t\t// Return only captures needed by the pseudo filter method (type and argument)\n\t\t\treturn match.slice( 0, 3 );\n\t\t}\n\t},\n\n\tfilter: {\n\n\t\t\"TAG\": function( nodeNameSelector ) {\n\t\t\tvar nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();\n\t\t\treturn nodeNameSelector === \"*\" ?\n\t\t\t\tfunction() { return true; } :\n\t\t\t\tfunction( elem ) {\n\t\t\t\t\treturn elem.nodeName && elem.nodeName.toLowerCase() === nodeName;\n\t\t\t\t};\n\t\t},\n\n\t\t\"CLASS\": function( className ) {\n\t\t\tvar pattern = classCache[ className + \" \" ];\n\n\t\t\treturn pattern ||\n\t\t\t\t(pattern = new RegExp( \"(^|\" + whitespace + \")\" + className + \"(\" + whitespace + \"|$)\" )) &&\n\t\t\t\tclassCache( className, function( elem ) {\n\t\t\t\t\treturn pattern.test( typeof elem.className === \"string\" && elem.className || typeof elem.getAttribute !== \"undefined\" && elem.getAttribute(\"class\") || \"\" );\n\t\t\t\t});\n\t\t},\n\n\t\t\"ATTR\": function( name, operator, check ) {\n\t\t\treturn function( elem ) {\n\t\t\t\tvar result = Sizzle.attr( elem, name );\n\n\t\t\t\tif ( result == null ) {\n\t\t\t\t\treturn operator === \"!=\";\n\t\t\t\t}\n\t\t\t\tif ( !operator ) {\n\t\t\t\t\treturn true;\n\t\t\t\t}\n\n\t\t\t\tresult += \"\";\n\n\t\t\t\treturn operator === \"=\" ? result === check :\n\t\t\t\t\toperator === \"!=\" ? result !== check :\n\t\t\t\t\toperator === \"^=\" ? check && result.indexOf( check ) === 0 :\n\t\t\t\t\toperator === \"*=\" ? check && result.indexOf( check ) > -1 :\n\t\t\t\t\toperator === \"$=\" ? check && result.slice( -check.length ) === check :\n\t\t\t\t\toperator === \"~=\" ? ( \" \" + result.replace( rwhitespace, \" \" ) + \" \" ).indexOf( check ) > -1 :\n\t\t\t\t\toperator === \"|=\" ? result === check || result.slice( 0, check.length + 1 ) === check + \"-\" :\n\t\t\t\t\tfalse;\n\t\t\t};\n\t\t},\n\n\t\t\"CHILD\": function( type, what, argument, first, last ) {\n\t\t\tvar simple = type.slice( 0, 3 ) !== \"nth\",\n\t\t\t\tforward = type.slice( -4 ) !== \"last\",\n\t\t\t\tofType = what === \"of-type\";\n\n\t\t\treturn first === 1 && last === 0 ?\n\n\t\t\t\t// Shortcut for :nth-*(n)\n\t\t\t\tfunction( elem ) {\n\t\t\t\t\treturn !!elem.parentNode;\n\t\t\t\t} :\n\n\t\t\t\tfunction( elem, context, xml ) {\n\t\t\t\t\tvar cache, uniqueCache, outerCache, node, nodeIndex, start,\n\t\t\t\t\t\tdir = simple !== forward ? \"nextSibling\" : \"previousSibling\",\n\t\t\t\t\t\tparent = elem.parentNode,\n\t\t\t\t\t\tname = ofType && elem.nodeName.toLowerCase(),\n\t\t\t\t\t\tuseCache = !xml && !ofType,\n\t\t\t\t\t\tdiff = false;\n\n\t\t\t\t\tif ( parent ) {\n\n\t\t\t\t\t\t// :(first|last|only)-(child|of-type)\n\t\t\t\t\t\tif ( simple ) {\n\t\t\t\t\t\t\twhile ( dir ) {\n\t\t\t\t\t\t\t\tnode = elem;\n\t\t\t\t\t\t\t\twhile ( (node = node[ dir ]) ) {\n\t\t\t\t\t\t\t\t\tif ( ofType ?\n\t\t\t\t\t\t\t\t\t\tnode.nodeName.toLowerCase() === name :\n\t\t\t\t\t\t\t\t\t\tnode.nodeType === 1 ) {\n\n\t\t\t\t\t\t\t\t\t\treturn false;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t// Reverse direction for :only-* (if we haven't yet done so)\n\t\t\t\t\t\t\t\tstart = dir = type === \"only\" && !start && \"nextSibling\";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\tstart = [ forward ? parent.firstChild : parent.lastChild ];\n\n\t\t\t\t\t\t// non-xml :nth-child(...) stores cache data on `parent`\n\t\t\t\t\t\tif ( forward && useCache ) {\n\n\t\t\t\t\t\t\t// Seek `elem` from a previously-cached index\n\n\t\t\t\t\t\t\t// ...in a gzip-friendly way\n\t\t\t\t\t\t\tnode = parent;\n\t\t\t\t\t\t\touterCache = node[ expando ] || (node[ expando ] = {});\n\n\t\t\t\t\t\t\t// Support: IE <9 only\n\t\t\t\t\t\t\t// Defend against cloned attroperties (jQuery gh-1709)\n\t\t\t\t\t\t\tuniqueCache = outerCache[ node.uniqueID ] ||\n\t\t\t\t\t\t\t\t(outerCache[ node.uniqueID ] = {});\n\n\t\t\t\t\t\t\tcache = uniqueCache[ type ] || [];\n\t\t\t\t\t\t\tnodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];\n\t\t\t\t\t\t\tdiff = nodeIndex && cache[ 2 ];\n\t\t\t\t\t\t\tnode = nodeIndex && parent.childNodes[ nodeIndex ];\n\n\t\t\t\t\t\t\twhile ( (node = ++nodeIndex && node && node[ dir ] ||\n\n\t\t\t\t\t\t\t\t// Fallback to seeking `elem` from the start\n\t\t\t\t\t\t\t\t(diff = nodeIndex = 0) || start.pop()) ) {\n\n\t\t\t\t\t\t\t\t// When found, cache indexes on `parent` and break\n\t\t\t\t\t\t\t\tif ( node.nodeType === 1 && ++diff && node === elem ) {\n\t\t\t\t\t\t\t\t\tuniqueCache[ type ] = [ dirruns, nodeIndex, diff ];\n\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t// Use previously-cached element index if available\n\t\t\t\t\t\t\tif ( useCache ) {\n\t\t\t\t\t\t\t\t// ...in a gzip-friendly way\n\t\t\t\t\t\t\t\tnode = elem;\n\t\t\t\t\t\t\t\touterCache = node[ expando ] || (node[ expando ] = {});\n\n\t\t\t\t\t\t\t\t// Support: IE <9 only\n\t\t\t\t\t\t\t\t// Defend against cloned attroperties (jQuery gh-1709)\n\t\t\t\t\t\t\t\tuniqueCache = outerCache[ node.uniqueID ] ||\n\t\t\t\t\t\t\t\t\t(outerCache[ node.uniqueID ] = {});\n\n\t\t\t\t\t\t\t\tcache = uniqueCache[ type ] || [];\n\t\t\t\t\t\t\t\tnodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];\n\t\t\t\t\t\t\t\tdiff = nodeIndex;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t// xml :nth-child(...)\n\t\t\t\t\t\t\t// or :nth-last-child(...) or :nth(-last)?-of-type(...)\n\t\t\t\t\t\t\tif ( diff === false ) {\n\t\t\t\t\t\t\t\t// Use the same loop as above to seek `elem` from the start\n\t\t\t\t\t\t\t\twhile ( (node = ++nodeIndex && node && node[ dir ] ||\n\t\t\t\t\t\t\t\t\t(diff = nodeIndex = 0) || start.pop()) ) {\n\n\t\t\t\t\t\t\t\t\tif ( ( ofType ?\n\t\t\t\t\t\t\t\t\t\tnode.nodeName.toLowerCase() === name :\n\t\t\t\t\t\t\t\t\t\tnode.nodeType === 1 ) &&\n\t\t\t\t\t\t\t\t\t\t++diff ) {\n\n\t\t\t\t\t\t\t\t\t\t// Cache the index of each encountered element\n\t\t\t\t\t\t\t\t\t\tif ( useCache ) {\n\t\t\t\t\t\t\t\t\t\t\touterCache = node[ expando ] || (node[ expando ] = {});\n\n\t\t\t\t\t\t\t\t\t\t\t// Support: IE <9 only\n\t\t\t\t\t\t\t\t\t\t\t// Defend against cloned attroperties (jQuery gh-1709)\n\t\t\t\t\t\t\t\t\t\t\tuniqueCache = outerCache[ node.uniqueID ] ||\n\t\t\t\t\t\t\t\t\t\t\t\t(outerCache[ node.uniqueID ] = {});\n\n\t\t\t\t\t\t\t\t\t\t\tuniqueCache[ type ] = [ dirruns, diff ];\n\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\tif ( node === elem ) {\n\t\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// Incorporate the offset, then check against cycle size\n\t\t\t\t\t\tdiff -= last;\n\t\t\t\t\t\treturn diff === first || ( diff % first === 0 && diff / first >= 0 );\n\t\t\t\t\t}\n\t\t\t\t};\n\t\t},\n\n\t\t\"PSEUDO\": function( pseudo, argument ) {\n\t\t\t// pseudo-class names are case-insensitive\n\t\t\t// http://www.w3.org/TR/selectors/#pseudo-classes\n\t\t\t// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters\n\t\t\t// Remember that setFilters inherits from pseudos\n\t\t\tvar args,\n\t\t\t\tfn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||\n\t\t\t\t\tSizzle.error( \"unsupported pseudo: \" + pseudo );\n\n\t\t\t// The user may use createPseudo to indicate that\n\t\t\t// arguments are needed to create the filter function\n\t\t\t// just as Sizzle does\n\t\t\tif ( fn[ expando ] ) {\n\t\t\t\treturn fn( argument );\n\t\t\t}\n\n\t\t\t// But maintain support for old signatures\n\t\t\tif ( fn.length > 1 ) {\n\t\t\t\targs = [ pseudo, pseudo, \"\", argument ];\n\t\t\t\treturn Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?\n\t\t\t\t\tmarkFunction(function( seed, matches ) {\n\t\t\t\t\t\tvar idx,\n\t\t\t\t\t\t\tmatched = fn( seed, argument ),\n\t\t\t\t\t\t\ti = matched.length;\n\t\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\t\tidx = indexOf( seed, matched[i] );\n\t\t\t\t\t\t\tseed[ idx ] = !( matches[ idx ] = matched[i] );\n\t\t\t\t\t\t}\n\t\t\t\t\t}) :\n\t\t\t\t\tfunction( elem ) {\n\t\t\t\t\t\treturn fn( elem, 0, args );\n\t\t\t\t\t};\n\t\t\t}\n\n\t\t\treturn fn;\n\t\t}\n\t},\n\n\tpseudos: {\n\t\t// Potentially complex pseudos\n\t\t\"not\": markFunction(function( selector ) {\n\t\t\t// Trim the selector passed to compile\n\t\t\t// to avoid treating leading and trailing\n\t\t\t// spaces as combinators\n\t\t\tvar input = [],\n\t\t\t\tresults = [],\n\t\t\t\tmatcher = compile( selector.replace( rtrim, \"$1\" ) );\n\n\t\t\treturn matcher[ expando ] ?\n\t\t\t\tmarkFunction(function( seed, matches, context, xml ) {\n\t\t\t\t\tvar elem,\n\t\t\t\t\t\tunmatched = matcher( seed, null, xml, [] ),\n\t\t\t\t\t\ti = seed.length;\n\n\t\t\t\t\t// Match elements unmatched by `matcher`\n\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\tif ( (elem = unmatched[i]) ) {\n\t\t\t\t\t\t\tseed[i] = !(matches[i] = elem);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}) :\n\t\t\t\tfunction( elem, context, xml ) {\n\t\t\t\t\tinput[0] = elem;\n\t\t\t\t\tmatcher( input, null, xml, results );\n\t\t\t\t\t// Don't keep the element (issue #299)\n\t\t\t\t\tinput[0] = null;\n\t\t\t\t\treturn !results.pop();\n\t\t\t\t};\n\t\t}),\n\n\t\t\"has\": markFunction(function( selector ) {\n\t\t\treturn function( elem ) {\n\t\t\t\treturn Sizzle( selector, elem ).length > 0;\n\t\t\t};\n\t\t}),\n\n\t\t\"contains\": markFunction(function( text ) {\n\t\t\ttext = text.replace( runescape, funescape );\n\t\t\treturn function( elem ) {\n\t\t\t\treturn ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;\n\t\t\t};\n\t\t}),\n\n\t\t// \"Whether an element is represented by a :lang() selector\n\t\t// is based solely on the element's language value\n\t\t// being equal to the identifier C,\n\t\t// or beginning with the identifier C immediately followed by \"-\".\n\t\t// The matching of C against the element's language value is performed case-insensitively.\n\t\t// The identifier C does not have to be a valid language name.\"\n\t\t// http://www.w3.org/TR/selectors/#lang-pseudo\n\t\t\"lang\": markFunction( function( lang ) {\n\t\t\t// lang value must be a valid identifier\n\t\t\tif ( !ridentifier.test(lang || \"\") ) {\n\t\t\t\tSizzle.error( \"unsupported lang: \" + lang );\n\t\t\t}\n\t\t\tlang = lang.replace( runescape, funescape ).toLowerCase();\n\t\t\treturn function( elem ) {\n\t\t\t\tvar elemLang;\n\t\t\t\tdo {\n\t\t\t\t\tif ( (elemLang = documentIsHTML ?\n\t\t\t\t\t\telem.lang :\n\t\t\t\t\t\telem.getAttribute(\"xml:lang\") || elem.getAttribute(\"lang\")) ) {\n\n\t\t\t\t\t\telemLang = elemLang.toLowerCase();\n\t\t\t\t\t\treturn elemLang === lang || elemLang.indexOf( lang + \"-\" ) === 0;\n\t\t\t\t\t}\n\t\t\t\t} while ( (elem = elem.parentNode) && elem.nodeType === 1 );\n\t\t\t\treturn false;\n\t\t\t};\n\t\t}),\n\n\t\t// Miscellaneous\n\t\t\"target\": function( elem ) {\n\t\t\tvar hash = window.location && window.location.hash;\n\t\t\treturn hash && hash.slice( 1 ) === elem.id;\n\t\t},\n\n\t\t\"root\": function( elem ) {\n\t\t\treturn elem === docElem;\n\t\t},\n\n\t\t\"focus\": function( elem ) {\n\t\t\treturn elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);\n\t\t},\n\n\t\t// Boolean properties\n\t\t\"enabled\": createDisabledPseudo( false ),\n\t\t\"disabled\": createDisabledPseudo( true ),\n\n\t\t\"checked\": function( elem ) {\n\t\t\t// In CSS3, :checked should return both checked and selected elements\n\t\t\t// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked\n\t\t\tvar nodeName = elem.nodeName.toLowerCase();\n\t\t\treturn (nodeName === \"input\" && !!elem.checked) || (nodeName === \"option\" && !!elem.selected);\n\t\t},\n\n\t\t\"selected\": function( elem ) {\n\t\t\t// Accessing this property makes selected-by-default\n\t\t\t// options in Safari work properly\n\t\t\tif ( elem.parentNode ) {\n\t\t\t\telem.parentNode.selectedIndex;\n\t\t\t}\n\n\t\t\treturn elem.selected === true;\n\t\t},\n\n\t\t// Contents\n\t\t\"empty\": function( elem ) {\n\t\t\t// http://www.w3.org/TR/selectors/#empty-pseudo\n\t\t\t// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),\n\t\t\t//   but not by others (comment: 8; processing instruction: 7; etc.)\n\t\t\t// nodeType < 6 works because attributes (2) do not appear as children\n\t\t\tfor ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {\n\t\t\t\tif ( elem.nodeType < 6 ) {\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn true;\n\t\t},\n\n\t\t\"parent\": function( elem ) {\n\t\t\treturn !Expr.pseudos[\"empty\"]( elem );\n\t\t},\n\n\t\t// Element/input types\n\t\t\"header\": function( elem ) {\n\t\t\treturn rheader.test( elem.nodeName );\n\t\t},\n\n\t\t\"input\": function( elem ) {\n\t\t\treturn rinputs.test( elem.nodeName );\n\t\t},\n\n\t\t\"button\": function( elem ) {\n\t\t\tvar name = elem.nodeName.toLowerCase();\n\t\t\treturn name === \"input\" && elem.type === \"button\" || name === \"button\";\n\t\t},\n\n\t\t\"text\": function( elem ) {\n\t\t\tvar attr;\n\t\t\treturn elem.nodeName.toLowerCase() === \"input\" &&\n\t\t\t\telem.type === \"text\" &&\n\n\t\t\t\t// Support: IE<8\n\t\t\t\t// New HTML5 attribute values (e.g., \"search\") appear with elem.type === \"text\"\n\t\t\t\t( (attr = elem.getAttribute(\"type\")) == null || attr.toLowerCase() === \"text\" );\n\t\t},\n\n\t\t// Position-in-collection\n\t\t\"first\": createPositionalPseudo(function() {\n\t\t\treturn [ 0 ];\n\t\t}),\n\n\t\t\"last\": createPositionalPseudo(function( matchIndexes, length ) {\n\t\t\treturn [ length - 1 ];\n\t\t}),\n\n\t\t\"eq\": createPositionalPseudo(function( matchIndexes, length, argument ) {\n\t\t\treturn [ argument < 0 ? argument + length : argument ];\n\t\t}),\n\n\t\t\"even\": createPositionalPseudo(function( matchIndexes, length ) {\n\t\t\tvar i = 0;\n\t\t\tfor ( ; i < length; i += 2 ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t}),\n\n\t\t\"odd\": createPositionalPseudo(function( matchIndexes, length ) {\n\t\t\tvar i = 1;\n\t\t\tfor ( ; i < length; i += 2 ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t}),\n\n\t\t\"lt\": createPositionalPseudo(function( matchIndexes, length, argument ) {\n\t\t\tvar i = argument < 0 ? argument + length : argument;\n\t\t\tfor ( ; --i >= 0; ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t}),\n\n\t\t\"gt\": createPositionalPseudo(function( matchIndexes, length, argument ) {\n\t\t\tvar i = argument < 0 ? argument + length : argument;\n\t\t\tfor ( ; ++i < length; ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t})\n\t}\n};\n\nExpr.pseudos[\"nth\"] = Expr.pseudos[\"eq\"];\n\n// Add button/input type pseudos\nfor ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {\n\tExpr.pseudos[ i ] = createInputPseudo( i );\n}\nfor ( i in { submit: true, reset: true } ) {\n\tExpr.pseudos[ i ] = createButtonPseudo( i );\n}\n\n// Easy API for creating new setFilters\nfunction setFilters() {}\nsetFilters.prototype = Expr.filters = Expr.pseudos;\nExpr.setFilters = new setFilters();\n\ntokenize = Sizzle.tokenize = function( selector, parseOnly ) {\n\tvar matched, match, tokens, type,\n\t\tsoFar, groups, preFilters,\n\t\tcached = tokenCache[ selector + \" \" ];\n\n\tif ( cached ) {\n\t\treturn parseOnly ? 0 : cached.slice( 0 );\n\t}\n\n\tsoFar = selector;\n\tgroups = [];\n\tpreFilters = Expr.preFilter;\n\n\twhile ( soFar ) {\n\n\t\t// Comma and first run\n\t\tif ( !matched || (match = rcomma.exec( soFar )) ) {\n\t\t\tif ( match ) {\n\t\t\t\t// Don't consume trailing commas as valid\n\t\t\t\tsoFar = soFar.slice( match[0].length ) || soFar;\n\t\t\t}\n\t\t\tgroups.push( (tokens = []) );\n\t\t}\n\n\t\tmatched = false;\n\n\t\t// Combinators\n\t\tif ( (match = rcombinators.exec( soFar )) ) {\n\t\t\tmatched = match.shift();\n\t\t\ttokens.push({\n\t\t\t\tvalue: matched,\n\t\t\t\t// Cast descendant combinators to space\n\t\t\t\ttype: match[0].replace( rtrim, \" \" )\n\t\t\t});\n\t\t\tsoFar = soFar.slice( matched.length );\n\t\t}\n\n\t\t// Filters\n\t\tfor ( type in Expr.filter ) {\n\t\t\tif ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||\n\t\t\t\t(match = preFilters[ type ]( match ))) ) {\n\t\t\t\tmatched = match.shift();\n\t\t\t\ttokens.push({\n\t\t\t\t\tvalue: matched,\n\t\t\t\t\ttype: type,\n\t\t\t\t\tmatches: match\n\t\t\t\t});\n\t\t\t\tsoFar = soFar.slice( matched.length );\n\t\t\t}\n\t\t}\n\n\t\tif ( !matched ) {\n\t\t\tbreak;\n\t\t}\n\t}\n\n\t// Return the length of the invalid excess\n\t// if we're just parsing\n\t// Otherwise, throw an error or return tokens\n\treturn parseOnly ?\n\t\tsoFar.length :\n\t\tsoFar ?\n\t\t\tSizzle.error( selector ) :\n\t\t\t// Cache the tokens\n\t\t\ttokenCache( selector, groups ).slice( 0 );\n};\n\nfunction toSelector( tokens ) {\n\tvar i = 0,\n\t\tlen = tokens.length,\n\t\tselector = \"\";\n\tfor ( ; i < len; i++ ) {\n\t\tselector += tokens[i].value;\n\t}\n\treturn selector;\n}\n\nfunction addCombinator( matcher, combinator, base ) {\n\tvar dir = combinator.dir,\n\t\tskip = combinator.next,\n\t\tkey = skip || dir,\n\t\tcheckNonElements = base && key === \"parentNode\",\n\t\tdoneName = done++;\n\n\treturn combinator.first ?\n\t\t// Check against closest ancestor/preceding element\n\t\tfunction( elem, context, xml ) {\n\t\t\twhile ( (elem = elem[ dir ]) ) {\n\t\t\t\tif ( elem.nodeType === 1 || checkNonElements ) {\n\t\t\t\t\treturn matcher( elem, context, xml );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn false;\n\t\t} :\n\n\t\t// Check against all ancestor/preceding elements\n\t\tfunction( elem, context, xml ) {\n\t\t\tvar oldCache, uniqueCache, outerCache,\n\t\t\t\tnewCache = [ dirruns, doneName ];\n\n\t\t\t// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching\n\t\t\tif ( xml ) {\n\t\t\t\twhile ( (elem = elem[ dir ]) ) {\n\t\t\t\t\tif ( elem.nodeType === 1 || checkNonElements ) {\n\t\t\t\t\t\tif ( matcher( elem, context, xml ) ) {\n\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\twhile ( (elem = elem[ dir ]) ) {\n\t\t\t\t\tif ( elem.nodeType === 1 || checkNonElements ) {\n\t\t\t\t\t\touterCache = elem[ expando ] || (elem[ expando ] = {});\n\n\t\t\t\t\t\t// Support: IE <9 only\n\t\t\t\t\t\t// Defend against cloned attroperties (jQuery gh-1709)\n\t\t\t\t\t\tuniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});\n\n\t\t\t\t\t\tif ( skip && skip === elem.nodeName.toLowerCase() ) {\n\t\t\t\t\t\t\telem = elem[ dir ] || elem;\n\t\t\t\t\t\t} else if ( (oldCache = uniqueCache[ key ]) &&\n\t\t\t\t\t\t\toldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {\n\n\t\t\t\t\t\t\t// Assign to newCache so results back-propagate to previous elements\n\t\t\t\t\t\t\treturn (newCache[ 2 ] = oldCache[ 2 ]);\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t// Reuse newcache so results back-propagate to previous elements\n\t\t\t\t\t\t\tuniqueCache[ key ] = newCache;\n\n\t\t\t\t\t\t\t// A match means we're done; a fail means we have to keep checking\n\t\t\t\t\t\t\tif ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {\n\t\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn false;\n\t\t};\n}\n\nfunction elementMatcher( matchers ) {\n\treturn matchers.length > 1 ?\n\t\tfunction( elem, context, xml ) {\n\t\t\tvar i = matchers.length;\n\t\t\twhile ( i-- ) {\n\t\t\t\tif ( !matchers[i]( elem, context, xml ) ) {\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn true;\n\t\t} :\n\t\tmatchers[0];\n}\n\nfunction multipleContexts( selector, contexts, results ) {\n\tvar i = 0,\n\t\tlen = contexts.length;\n\tfor ( ; i < len; i++ ) {\n\t\tSizzle( selector, contexts[i], results );\n\t}\n\treturn results;\n}\n\nfunction condense( unmatched, map, filter, context, xml ) {\n\tvar elem,\n\t\tnewUnmatched = [],\n\t\ti = 0,\n\t\tlen = unmatched.length,\n\t\tmapped = map != null;\n\n\tfor ( ; i < len; i++ ) {\n\t\tif ( (elem = unmatched[i]) ) {\n\t\t\tif ( !filter || filter( elem, context, xml ) ) {\n\t\t\t\tnewUnmatched.push( elem );\n\t\t\t\tif ( mapped ) {\n\t\t\t\t\tmap.push( i );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\treturn newUnmatched;\n}\n\nfunction setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {\n\tif ( postFilter && !postFilter[ expando ] ) {\n\t\tpostFilter = setMatcher( postFilter );\n\t}\n\tif ( postFinder && !postFinder[ expando ] ) {\n\t\tpostFinder = setMatcher( postFinder, postSelector );\n\t}\n\treturn markFunction(function( seed, results, context, xml ) {\n\t\tvar temp, i, elem,\n\t\t\tpreMap = [],\n\t\t\tpostMap = [],\n\t\t\tpreexisting = results.length,\n\n\t\t\t// Get initial elements from seed or context\n\t\t\telems = seed || multipleContexts( selector || \"*\", context.nodeType ? [ context ] : context, [] ),\n\n\t\t\t// Prefilter to get matcher input, preserving a map for seed-results synchronization\n\t\t\tmatcherIn = preFilter && ( seed || !selector ) ?\n\t\t\t\tcondense( elems, preMap, preFilter, context, xml ) :\n\t\t\t\telems,\n\n\t\t\tmatcherOut = matcher ?\n\t\t\t\t// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,\n\t\t\t\tpostFinder || ( seed ? preFilter : preexisting || postFilter ) ?\n\n\t\t\t\t\t// ...intermediate processing is necessary\n\t\t\t\t\t[] :\n\n\t\t\t\t\t// ...otherwise use results directly\n\t\t\t\t\tresults :\n\t\t\t\tmatcherIn;\n\n\t\t// Find primary matches\n\t\tif ( matcher ) {\n\t\t\tmatcher( matcherIn, matcherOut, context, xml );\n\t\t}\n\n\t\t// Apply postFilter\n\t\tif ( postFilter ) {\n\t\t\ttemp = condense( matcherOut, postMap );\n\t\t\tpostFilter( temp, [], context, xml );\n\n\t\t\t// Un-match failing elements by moving them back to matcherIn\n\t\t\ti = temp.length;\n\t\t\twhile ( i-- ) {\n\t\t\t\tif ( (elem = temp[i]) ) {\n\t\t\t\t\tmatcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tif ( seed ) {\n\t\t\tif ( postFinder || preFilter ) {\n\t\t\t\tif ( postFinder ) {\n\t\t\t\t\t// Get the final matcherOut by condensing this intermediate into postFinder contexts\n\t\t\t\t\ttemp = [];\n\t\t\t\t\ti = matcherOut.length;\n\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\tif ( (elem = matcherOut[i]) ) {\n\t\t\t\t\t\t\t// Restore matcherIn since elem is not yet a final match\n\t\t\t\t\t\t\ttemp.push( (matcherIn[i] = elem) );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tpostFinder( null, (matcherOut = []), temp, xml );\n\t\t\t\t}\n\n\t\t\t\t// Move matched elements from seed to results to keep them synchronized\n\t\t\t\ti = matcherOut.length;\n\t\t\t\twhile ( i-- ) {\n\t\t\t\t\tif ( (elem = matcherOut[i]) &&\n\t\t\t\t\t\t(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {\n\n\t\t\t\t\t\tseed[temp] = !(results[temp] = elem);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t// Add elements to results, through postFinder if defined\n\t\t} else {\n\t\t\tmatcherOut = condense(\n\t\t\t\tmatcherOut === results ?\n\t\t\t\t\tmatcherOut.splice( preexisting, matcherOut.length ) :\n\t\t\t\t\tmatcherOut\n\t\t\t);\n\t\t\tif ( postFinder ) {\n\t\t\t\tpostFinder( null, results, matcherOut, xml );\n\t\t\t} else {\n\t\t\t\tpush.apply( results, matcherOut );\n\t\t\t}\n\t\t}\n\t});\n}\n\nfunction matcherFromTokens( tokens ) {\n\tvar checkContext, matcher, j,\n\t\tlen = tokens.length,\n\t\tleadingRelative = Expr.relative[ tokens[0].type ],\n\t\timplicitRelative = leadingRelative || Expr.relative[\" \"],\n\t\ti = leadingRelative ? 1 : 0,\n\n\t\t// The foundational matcher ensures that elements are reachable from top-level context(s)\n\t\tmatchContext = addCombinator( function( elem ) {\n\t\t\treturn elem === checkContext;\n\t\t}, implicitRelative, true ),\n\t\tmatchAnyContext = addCombinator( function( elem ) {\n\t\t\treturn indexOf( checkContext, elem ) > -1;\n\t\t}, implicitRelative, true ),\n\t\tmatchers = [ function( elem, context, xml ) {\n\t\t\tvar ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (\n\t\t\t\t(checkContext = context).nodeType ?\n\t\t\t\t\tmatchContext( elem, context, xml ) :\n\t\t\t\t\tmatchAnyContext( elem, context, xml ) );\n\t\t\t// Avoid hanging onto element (issue #299)\n\t\t\tcheckContext = null;\n\t\t\treturn ret;\n\t\t} ];\n\n\tfor ( ; i < len; i++ ) {\n\t\tif ( (matcher = Expr.relative[ tokens[i].type ]) ) {\n\t\t\tmatchers = [ addCombinator(elementMatcher( matchers ), matcher) ];\n\t\t} else {\n\t\t\tmatcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );\n\n\t\t\t// Return special upon seeing a positional matcher\n\t\t\tif ( matcher[ expando ] ) {\n\t\t\t\t// Find the next relative operator (if any) for proper handling\n\t\t\t\tj = ++i;\n\t\t\t\tfor ( ; j < len; j++ ) {\n\t\t\t\t\tif ( Expr.relative[ tokens[j].type ] ) {\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\treturn setMatcher(\n\t\t\t\t\ti > 1 && elementMatcher( matchers ),\n\t\t\t\t\ti > 1 && toSelector(\n\t\t\t\t\t\t// If the preceding token was a descendant combinator, insert an implicit any-element `*`\n\t\t\t\t\t\ttokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === \" \" ? \"*\" : \"\" })\n\t\t\t\t\t).replace( rtrim, \"$1\" ),\n\t\t\t\t\tmatcher,\n\t\t\t\t\ti < j && matcherFromTokens( tokens.slice( i, j ) ),\n\t\t\t\t\tj < len && matcherFromTokens( (tokens = tokens.slice( j )) ),\n\t\t\t\t\tj < len && toSelector( tokens )\n\t\t\t\t);\n\t\t\t}\n\t\t\tmatchers.push( matcher );\n\t\t}\n\t}\n\n\treturn elementMatcher( matchers );\n}\n\nfunction matcherFromGroupMatchers( elementMatchers, setMatchers ) {\n\tvar bySet = setMatchers.length > 0,\n\t\tbyElement = elementMatchers.length > 0,\n\t\tsuperMatcher = function( seed, context, xml, results, outermost ) {\n\t\t\tvar elem, j, matcher,\n\t\t\t\tmatchedCount = 0,\n\t\t\t\ti = \"0\",\n\t\t\t\tunmatched = seed && [],\n\t\t\t\tsetMatched = [],\n\t\t\t\tcontextBackup = outermostContext,\n\t\t\t\t// We must always have either seed elements or outermost context\n\t\t\t\telems = seed || byElement && Expr.find[\"TAG\"]( \"*\", outermost ),\n\t\t\t\t// Use integer dirruns iff this is the outermost matcher\n\t\t\t\tdirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),\n\t\t\t\tlen = elems.length;\n\n\t\t\tif ( outermost ) {\n\t\t\t\toutermostContext = context === document || context || outermost;\n\t\t\t}\n\n\t\t\t// Add elements passing elementMatchers directly to results\n\t\t\t// Support: IE<9, Safari\n\t\t\t// Tolerate NodeList properties (IE: \"length\"; Safari: <number>) matching elements by id\n\t\t\tfor ( ; i !== len && (elem = elems[i]) != null; i++ ) {\n\t\t\t\tif ( byElement && elem ) {\n\t\t\t\t\tj = 0;\n\t\t\t\t\tif ( !context && elem.ownerDocument !== document ) {\n\t\t\t\t\t\tsetDocument( elem );\n\t\t\t\t\t\txml = !documentIsHTML;\n\t\t\t\t\t}\n\t\t\t\t\twhile ( (matcher = elementMatchers[j++]) ) {\n\t\t\t\t\t\tif ( matcher( elem, context || document, xml) ) {\n\t\t\t\t\t\t\tresults.push( elem );\n\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tif ( outermost ) {\n\t\t\t\t\t\tdirruns = dirrunsUnique;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Track unmatched elements for set filters\n\t\t\t\tif ( bySet ) {\n\t\t\t\t\t// They will have gone through all possible matchers\n\t\t\t\t\tif ( (elem = !matcher && elem) ) {\n\t\t\t\t\t\tmatchedCount--;\n\t\t\t\t\t}\n\n\t\t\t\t\t// Lengthen the array for every element, matched or not\n\t\t\t\t\tif ( seed ) {\n\t\t\t\t\t\tunmatched.push( elem );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// `i` is now the count of elements visited above, and adding it to `matchedCount`\n\t\t\t// makes the latter nonnegative.\n\t\t\tmatchedCount += i;\n\n\t\t\t// Apply set filters to unmatched elements\n\t\t\t// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`\n\t\t\t// equals `i`), unless we didn't visit _any_ elements in the above loop because we have\n\t\t\t// no element matchers and no seed.\n\t\t\t// Incrementing an initially-string \"0\" `i` allows `i` to remain a string only in that\n\t\t\t// case, which will result in a \"00\" `matchedCount` that differs from `i` but is also\n\t\t\t// numerically zero.\n\t\t\tif ( bySet && i !== matchedCount ) {\n\t\t\t\tj = 0;\n\t\t\t\twhile ( (matcher = setMatchers[j++]) ) {\n\t\t\t\t\tmatcher( unmatched, setMatched, context, xml );\n\t\t\t\t}\n\n\t\t\t\tif ( seed ) {\n\t\t\t\t\t// Reintegrate element matches to eliminate the need for sorting\n\t\t\t\t\tif ( matchedCount > 0 ) {\n\t\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\t\tif ( !(unmatched[i] || setMatched[i]) ) {\n\t\t\t\t\t\t\t\tsetMatched[i] = pop.call( results );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t// Discard index placeholder values to get only actual matches\n\t\t\t\t\tsetMatched = condense( setMatched );\n\t\t\t\t}\n\n\t\t\t\t// Add matches to results\n\t\t\t\tpush.apply( results, setMatched );\n\n\t\t\t\t// Seedless set matches succeeding multiple successful matchers stipulate sorting\n\t\t\t\tif ( outermost && !seed && setMatched.length > 0 &&\n\t\t\t\t\t( matchedCount + setMatchers.length ) > 1 ) {\n\n\t\t\t\t\tSizzle.uniqueSort( results );\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Override manipulation of globals by nested matchers\n\t\t\tif ( outermost ) {\n\t\t\t\tdirruns = dirrunsUnique;\n\t\t\t\toutermostContext = contextBackup;\n\t\t\t}\n\n\t\t\treturn unmatched;\n\t\t};\n\n\treturn bySet ?\n\t\tmarkFunction( superMatcher ) :\n\t\tsuperMatcher;\n}\n\ncompile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {\n\tvar i,\n\t\tsetMatchers = [],\n\t\telementMatchers = [],\n\t\tcached = compilerCache[ selector + \" \" ];\n\n\tif ( !cached ) {\n\t\t// Generate a function of recursive functions that can be used to check each element\n\t\tif ( !match ) {\n\t\t\tmatch = tokenize( selector );\n\t\t}\n\t\ti = match.length;\n\t\twhile ( i-- ) {\n\t\t\tcached = matcherFromTokens( match[i] );\n\t\t\tif ( cached[ expando ] ) {\n\t\t\t\tsetMatchers.push( cached );\n\t\t\t} else {\n\t\t\t\telementMatchers.push( cached );\n\t\t\t}\n\t\t}\n\n\t\t// Cache the compiled function\n\t\tcached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );\n\n\t\t// Save selector and tokenization\n\t\tcached.selector = selector;\n\t}\n\treturn cached;\n};\n\n/**\n * A low-level selection function that works with Sizzle's compiled\n *  selector functions\n * @param {String|Function} selector A selector or a pre-compiled\n *  selector function built with Sizzle.compile\n * @param {Element} context\n * @param {Array} [results]\n * @param {Array} [seed] A set of elements to match against\n */\nselect = Sizzle.select = function( selector, context, results, seed ) {\n\tvar i, tokens, token, type, find,\n\t\tcompiled = typeof selector === \"function\" && selector,\n\t\tmatch = !seed && tokenize( (selector = compiled.selector || selector) );\n\n\tresults = results || [];\n\n\t// Try to minimize operations if there is only one selector in the list and no seed\n\t// (the latter of which guarantees us context)\n\tif ( match.length === 1 ) {\n\n\t\t// Reduce context if the leading compound selector is an ID\n\t\ttokens = match[0] = match[0].slice( 0 );\n\t\tif ( tokens.length > 2 && (token = tokens[0]).type === \"ID\" &&\n\t\t\t\tcontext.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {\n\n\t\t\tcontext = ( Expr.find[\"ID\"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];\n\t\t\tif ( !context ) {\n\t\t\t\treturn results;\n\n\t\t\t// Precompiled matchers will still verify ancestry, so step up a level\n\t\t\t} else if ( compiled ) {\n\t\t\t\tcontext = context.parentNode;\n\t\t\t}\n\n\t\t\tselector = selector.slice( tokens.shift().value.length );\n\t\t}\n\n\t\t// Fetch a seed set for right-to-left matching\n\t\ti = matchExpr[\"needsContext\"].test( selector ) ? 0 : tokens.length;\n\t\twhile ( i-- ) {\n\t\t\ttoken = tokens[i];\n\n\t\t\t// Abort if we hit a combinator\n\t\t\tif ( Expr.relative[ (type = token.type) ] ) {\n\t\t\t\tbreak;\n\t\t\t}\n\t\t\tif ( (find = Expr.find[ type ]) ) {\n\t\t\t\t// Search, expanding context for leading sibling combinators\n\t\t\t\tif ( (seed = find(\n\t\t\t\t\ttoken.matches[0].replace( runescape, funescape ),\n\t\t\t\t\trsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context\n\t\t\t\t)) ) {\n\n\t\t\t\t\t// If seed is empty or no tokens remain, we can return early\n\t\t\t\t\ttokens.splice( i, 1 );\n\t\t\t\t\tselector = seed.length && toSelector( tokens );\n\t\t\t\t\tif ( !selector ) {\n\t\t\t\t\t\tpush.apply( results, seed );\n\t\t\t\t\t\treturn results;\n\t\t\t\t\t}\n\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Compile and execute a filtering function if one is not provided\n\t// Provide `match` to avoid retokenization if we modified the selector above\n\t( compiled || compile( selector, match ) )(\n\t\tseed,\n\t\tcontext,\n\t\t!documentIsHTML,\n\t\tresults,\n\t\t!context || rsibling.test( selector ) && testContext( context.parentNode ) || context\n\t);\n\treturn results;\n};\n\n// One-time assignments\n\n// Sort stability\nsupport.sortStable = expando.split(\"\").sort( sortOrder ).join(\"\") === expando;\n\n// Support: Chrome 14-35+\n// Always assume duplicates if they aren't passed to the comparison function\nsupport.detectDuplicates = !!hasDuplicate;\n\n// Initialize against the default document\nsetDocument();\n\n// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)\n// Detached nodes confoundingly follow *each other*\nsupport.sortDetached = assert(function( el ) {\n\t// Should return 1, but returns 4 (following)\n\treturn el.compareDocumentPosition( document.createElement(\"fieldset\") ) & 1;\n});\n\n// Support: IE<8\n// Prevent attribute/property \"interpolation\"\n// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx\nif ( !assert(function( el ) {\n\tel.innerHTML = \"<a href='#'></a>\";\n\treturn el.firstChild.getAttribute(\"href\") === \"#\" ;\n}) ) {\n\taddHandle( \"type|href|height|width\", function( elem, name, isXML ) {\n\t\tif ( !isXML ) {\n\t\t\treturn elem.getAttribute( name, name.toLowerCase() === \"type\" ? 1 : 2 );\n\t\t}\n\t});\n}\n\n// Support: IE<9\n// Use defaultValue in place of getAttribute(\"value\")\nif ( !support.attributes || !assert(function( el ) {\n\tel.innerHTML = \"<input/>\";\n\tel.firstChild.setAttribute( \"value\", \"\" );\n\treturn el.firstChild.getAttribute( \"value\" ) === \"\";\n}) ) {\n\taddHandle( \"value\", function( elem, name, isXML ) {\n\t\tif ( !isXML && elem.nodeName.toLowerCase() === \"input\" ) {\n\t\t\treturn elem.defaultValue;\n\t\t}\n\t});\n}\n\n// Support: IE<9\n// Use getAttributeNode to fetch booleans when getAttribute lies\nif ( !assert(function( el ) {\n\treturn el.getAttribute(\"disabled\") == null;\n}) ) {\n\taddHandle( booleans, function( elem, name, isXML ) {\n\t\tvar val;\n\t\tif ( !isXML ) {\n\t\t\treturn elem[ name ] === true ? name.toLowerCase() :\n\t\t\t\t\t(val = elem.getAttributeNode( name )) && val.specified ?\n\t\t\t\t\tval.value :\n\t\t\t\tnull;\n\t\t}\n\t});\n}\n\nreturn Sizzle;\n\n})( window );\n\n\n\njQuery.find = Sizzle;\njQuery.expr = Sizzle.selectors;\n\n// Deprecated\njQuery.expr[ \":\" ] = jQuery.expr.pseudos;\njQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;\njQuery.text = Sizzle.getText;\njQuery.isXMLDoc = Sizzle.isXML;\njQuery.contains = Sizzle.contains;\njQuery.escapeSelector = Sizzle.escape;\n\n\n\n\nvar dir = function( elem, dir, until ) {\n\tvar matched = [],\n\t\ttruncate = until !== undefined;\n\n\twhile ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {\n\t\tif ( elem.nodeType === 1 ) {\n\t\t\tif ( truncate && jQuery( elem ).is( until ) ) {\n\t\t\t\tbreak;\n\t\t\t}\n\t\t\tmatched.push( elem );\n\t\t}\n\t}\n\treturn matched;\n};\n\n\nvar siblings = function( n, elem ) {\n\tvar matched = [];\n\n\tfor ( ; n; n = n.nextSibling ) {\n\t\tif ( n.nodeType === 1 && n !== elem ) {\n\t\t\tmatched.push( n );\n\t\t}\n\t}\n\n\treturn matched;\n};\n\n\nvar rneedsContext = jQuery.expr.match.needsContext;\n\n\n\nfunction nodeName( elem, name ) {\n\n  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();\n\n};\nvar rsingleTag = ( /^<([a-z][^\\/\\0>:\\x20\\t\\r\\n\\f]*)[\\x20\\t\\r\\n\\f]*\\/?>(?:<\\/\\1>|)$/i );\n\n\n\nvar risSimple = /^.[^:#\\[\\.,]*$/;\n\n// Implement the identical functionality for filter and not\nfunction winnow( elements, qualifier, not ) {\n\tif ( jQuery.isFunction( qualifier ) ) {\n\t\treturn jQuery.grep( elements, function( elem, i ) {\n\t\t\treturn !!qualifier.call( elem, i, elem ) !== not;\n\t\t} );\n\t}\n\n\t// Single element\n\tif ( qualifier.nodeType ) {\n\t\treturn jQuery.grep( elements, function( elem ) {\n\t\t\treturn ( elem === qualifier ) !== not;\n\t\t} );\n\t}\n\n\t// Arraylike of elements (jQuery, arguments, Array)\n\tif ( typeof qualifier !== \"string\" ) {\n\t\treturn jQuery.grep( elements, function( elem ) {\n\t\t\treturn ( indexOf.call( qualifier, elem ) > -1 ) !== not;\n\t\t} );\n\t}\n\n\t// Simple selector that can be filtered directly, removing non-Elements\n\tif ( risSimple.test( qualifier ) ) {\n\t\treturn jQuery.filter( qualifier, elements, not );\n\t}\n\n\t// Complex selector, compare the two sets, removing non-Elements\n\tqualifier = jQuery.filter( qualifier, elements );\n\treturn jQuery.grep( elements, function( elem ) {\n\t\treturn ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;\n\t} );\n}\n\njQuery.filter = function( expr, elems, not ) {\n\tvar elem = elems[ 0 ];\n\n\tif ( not ) {\n\t\texpr = \":not(\" + expr + \")\";\n\t}\n\n\tif ( elems.length === 1 && elem.nodeType === 1 ) {\n\t\treturn jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];\n\t}\n\n\treturn jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {\n\t\treturn elem.nodeType === 1;\n\t} ) );\n};\n\njQuery.fn.extend( {\n\tfind: function( selector ) {\n\t\tvar i, ret,\n\t\t\tlen = this.length,\n\t\t\tself = this;\n\n\t\tif ( typeof selector !== \"string\" ) {\n\t\t\treturn this.pushStack( jQuery( selector ).filter( function() {\n\t\t\t\tfor ( i = 0; i < len; i++ ) {\n\t\t\t\t\tif ( jQuery.contains( self[ i ], this ) ) {\n\t\t\t\t\t\treturn true;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} ) );\n\t\t}\n\n\t\tret = this.pushStack( [] );\n\n\t\tfor ( i = 0; i < len; i++ ) {\n\t\t\tjQuery.find( selector, self[ i ], ret );\n\t\t}\n\n\t\treturn len > 1 ? jQuery.uniqueSort( ret ) : ret;\n\t},\n\tfilter: function( selector ) {\n\t\treturn this.pushStack( winnow( this, selector || [], false ) );\n\t},\n\tnot: function( selector ) {\n\t\treturn this.pushStack( winnow( this, selector || [], true ) );\n\t},\n\tis: function( selector ) {\n\t\treturn !!winnow(\n\t\t\tthis,\n\n\t\t\t// If this is a positional/relative selector, check membership in the returned set\n\t\t\t// so $(\"p:first\").is(\"p:last\") won't return true for a doc with two \"p\".\n\t\t\ttypeof selector === \"string\" && rneedsContext.test( selector ) ?\n\t\t\t\tjQuery( selector ) :\n\t\t\t\tselector || [],\n\t\t\tfalse\n\t\t).length;\n\t}\n} );\n\n\n// Initialize a jQuery object\n\n\n// A central reference to the root jQuery(document)\nvar rootjQuery,\n\n\t// A simple way to check for HTML strings\n\t// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)\n\t// Strict HTML recognition (#11290: must start with <)\n\t// Shortcut simple #id case for speed\n\trquickExpr = /^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]+))$/,\n\n\tinit = jQuery.fn.init = function( selector, context, root ) {\n\t\tvar match, elem;\n\n\t\t// HANDLE: $(\"\"), $(null), $(undefined), $(false)\n\t\tif ( !selector ) {\n\t\t\treturn this;\n\t\t}\n\n\t\t// Method init() accepts an alternate rootjQuery\n\t\t// so migrate can support jQuery.sub (gh-2101)\n\t\troot = root || rootjQuery;\n\n\t\t// Handle HTML strings\n\t\tif ( typeof selector === \"string\" ) {\n\t\t\tif ( selector[ 0 ] === \"<\" &&\n\t\t\t\tselector[ selector.length - 1 ] === \">\" &&\n\t\t\t\tselector.length >= 3 ) {\n\n\t\t\t\t// Assume that strings that start and end with <> are HTML and skip the regex check\n\t\t\t\tmatch = [ null, selector, null ];\n\n\t\t\t} else {\n\t\t\t\tmatch = rquickExpr.exec( selector );\n\t\t\t}\n\n\t\t\t// Match html or make sure no context is specified for #id\n\t\t\tif ( match && ( match[ 1 ] || !context ) ) {\n\n\t\t\t\t// HANDLE: $(html) -> $(array)\n\t\t\t\tif ( match[ 1 ] ) {\n\t\t\t\t\tcontext = context instanceof jQuery ? context[ 0 ] : context;\n\n\t\t\t\t\t// Option to run scripts is true for back-compat\n\t\t\t\t\t// Intentionally let the error be thrown if parseHTML is not present\n\t\t\t\t\tjQuery.merge( this, jQuery.parseHTML(\n\t\t\t\t\t\tmatch[ 1 ],\n\t\t\t\t\t\tcontext && context.nodeType ? context.ownerDocument || context : document,\n\t\t\t\t\t\ttrue\n\t\t\t\t\t) );\n\n\t\t\t\t\t// HANDLE: $(html, props)\n\t\t\t\t\tif ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {\n\t\t\t\t\t\tfor ( match in context ) {\n\n\t\t\t\t\t\t\t// Properties of context are called as methods if possible\n\t\t\t\t\t\t\tif ( jQuery.isFunction( this[ match ] ) ) {\n\t\t\t\t\t\t\t\tthis[ match ]( context[ match ] );\n\n\t\t\t\t\t\t\t// ...and otherwise set as attributes\n\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\tthis.attr( match, context[ match ] );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\treturn this;\n\n\t\t\t\t// HANDLE: $(#id)\n\t\t\t\t} else {\n\t\t\t\t\telem = document.getElementById( match[ 2 ] );\n\n\t\t\t\t\tif ( elem ) {\n\n\t\t\t\t\t\t// Inject the element directly into the jQuery object\n\t\t\t\t\t\tthis[ 0 ] = elem;\n\t\t\t\t\t\tthis.length = 1;\n\t\t\t\t\t}\n\t\t\t\t\treturn this;\n\t\t\t\t}\n\n\t\t\t// HANDLE: $(expr, $(...))\n\t\t\t} else if ( !context || context.jquery ) {\n\t\t\t\treturn ( context || root ).find( selector );\n\n\t\t\t// HANDLE: $(expr, context)\n\t\t\t// (which is just equivalent to: $(context).find(expr)\n\t\t\t} else {\n\t\t\t\treturn this.constructor( context ).find( selector );\n\t\t\t}\n\n\t\t// HANDLE: $(DOMElement)\n\t\t} else if ( selector.nodeType ) {\n\t\t\tthis[ 0 ] = selector;\n\t\t\tthis.length = 1;\n\t\t\treturn this;\n\n\t\t// HANDLE: $(function)\n\t\t// Shortcut for document ready\n\t\t} else if ( jQuery.isFunction( selector ) ) {\n\t\t\treturn root.ready !== undefined ?\n\t\t\t\troot.ready( selector ) :\n\n\t\t\t\t// Execute immediately if ready is not present\n\t\t\t\tselector( jQuery );\n\t\t}\n\n\t\treturn jQuery.makeArray( selector, this );\n\t};\n\n// Give the init function the jQuery prototype for later instantiation\ninit.prototype = jQuery.fn;\n\n// Initialize central reference\nrootjQuery = jQuery( document );\n\n\nvar rparentsprev = /^(?:parents|prev(?:Until|All))/,\n\n\t// Methods guaranteed to produce a unique set when starting from a unique set\n\tguaranteedUnique = {\n\t\tchildren: true,\n\t\tcontents: true,\n\t\tnext: true,\n\t\tprev: true\n\t};\n\njQuery.fn.extend( {\n\thas: function( target ) {\n\t\tvar targets = jQuery( target, this ),\n\t\t\tl = targets.length;\n\n\t\treturn this.filter( function() {\n\t\t\tvar i = 0;\n\t\t\tfor ( ; i < l; i++ ) {\n\t\t\t\tif ( jQuery.contains( this, targets[ i ] ) ) {\n\t\t\t\t\treturn true;\n\t\t\t\t}\n\t\t\t}\n\t\t} );\n\t},\n\n\tclosest: function( selectors, context ) {\n\t\tvar cur,\n\t\t\ti = 0,\n\t\t\tl = this.length,\n\t\t\tmatched = [],\n\t\t\ttargets = typeof selectors !== \"string\" && jQuery( selectors );\n\n\t\t// Positional selectors never match, since there's no _selection_ context\n\t\tif ( !rneedsContext.test( selectors ) ) {\n\t\t\tfor ( ; i < l; i++ ) {\n\t\t\t\tfor ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {\n\n\t\t\t\t\t// Always skip document fragments\n\t\t\t\t\tif ( cur.nodeType < 11 && ( targets ?\n\t\t\t\t\t\ttargets.index( cur ) > -1 :\n\n\t\t\t\t\t\t// Don't pass non-elements to Sizzle\n\t\t\t\t\t\tcur.nodeType === 1 &&\n\t\t\t\t\t\t\tjQuery.find.matchesSelector( cur, selectors ) ) ) {\n\n\t\t\t\t\t\tmatched.push( cur );\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );\n\t},\n\n\t// Determine the position of an element within the set\n\tindex: function( elem ) {\n\n\t\t// No argument, return index in parent\n\t\tif ( !elem ) {\n\t\t\treturn ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;\n\t\t}\n\n\t\t// Index in selector\n\t\tif ( typeof elem === \"string\" ) {\n\t\t\treturn indexOf.call( jQuery( elem ), this[ 0 ] );\n\t\t}\n\n\t\t// Locate the position of the desired element\n\t\treturn indexOf.call( this,\n\n\t\t\t// If it receives a jQuery object, the first element is used\n\t\t\telem.jquery ? elem[ 0 ] : elem\n\t\t);\n\t},\n\n\tadd: function( selector, context ) {\n\t\treturn this.pushStack(\n\t\t\tjQuery.uniqueSort(\n\t\t\t\tjQuery.merge( this.get(), jQuery( selector, context ) )\n\t\t\t)\n\t\t);\n\t},\n\n\taddBack: function( selector ) {\n\t\treturn this.add( selector == null ?\n\t\t\tthis.prevObject : this.prevObject.filter( selector )\n\t\t);\n\t}\n} );\n\nfunction sibling( cur, dir ) {\n\twhile ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}\n\treturn cur;\n}\n\njQuery.each( {\n\tparent: function( elem ) {\n\t\tvar parent = elem.parentNode;\n\t\treturn parent && parent.nodeType !== 11 ? parent : null;\n\t},\n\tparents: function( elem ) {\n\t\treturn dir( elem, \"parentNode\" );\n\t},\n\tparentsUntil: function( elem, i, until ) {\n\t\treturn dir( elem, \"parentNode\", until );\n\t},\n\tnext: function( elem ) {\n\t\treturn sibling( elem, \"nextSibling\" );\n\t},\n\tprev: function( elem ) {\n\t\treturn sibling( elem, \"previousSibling\" );\n\t},\n\tnextAll: function( elem ) {\n\t\treturn dir( elem, \"nextSibling\" );\n\t},\n\tprevAll: function( elem ) {\n\t\treturn dir( elem, \"previousSibling\" );\n\t},\n\tnextUntil: function( elem, i, until ) {\n\t\treturn dir( elem, \"nextSibling\", until );\n\t},\n\tprevUntil: function( elem, i, until ) {\n\t\treturn dir( elem, \"previousSibling\", until );\n\t},\n\tsiblings: function( elem ) {\n\t\treturn siblings( ( elem.parentNode || {} ).firstChild, elem );\n\t},\n\tchildren: function( elem ) {\n\t\treturn siblings( elem.firstChild );\n\t},\n\tcontents: function( elem ) {\n        if ( nodeName( elem, \"iframe\" ) ) {\n            return elem.contentDocument;\n        }\n\n        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only\n        // Treat the template element as a regular one in browsers that\n        // don't support it.\n        if ( nodeName( elem, \"template\" ) ) {\n            elem = elem.content || elem;\n        }\n\n        return jQuery.merge( [], elem.childNodes );\n\t}\n}, function( name, fn ) {\n\tjQuery.fn[ name ] = function( until, selector ) {\n\t\tvar matched = jQuery.map( this, fn, until );\n\n\t\tif ( name.slice( -5 ) !== \"Until\" ) {\n\t\t\tselector = until;\n\t\t}\n\n\t\tif ( selector && typeof selector === \"string\" ) {\n\t\t\tmatched = jQuery.filter( selector, matched );\n\t\t}\n\n\t\tif ( this.length > 1 ) {\n\n\t\t\t// Remove duplicates\n\t\t\tif ( !guaranteedUnique[ name ] ) {\n\t\t\t\tjQuery.uniqueSort( matched );\n\t\t\t}\n\n\t\t\t// Reverse order for parents* and prev-derivatives\n\t\t\tif ( rparentsprev.test( name ) ) {\n\t\t\t\tmatched.reverse();\n\t\t\t}\n\t\t}\n\n\t\treturn this.pushStack( matched );\n\t};\n} );\nvar rnothtmlwhite = ( /[^\\x20\\t\\r\\n\\f]+/g );\n\n\n\n// Convert String-formatted options into Object-formatted ones\nfunction createOptions( options ) {\n\tvar object = {};\n\tjQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {\n\t\tobject[ flag ] = true;\n\t} );\n\treturn object;\n}\n\n/*\n * Create a callback list using the following parameters:\n *\n *\toptions: an optional list of space-separated options that will change how\n *\t\t\tthe callback list behaves or a more traditional option object\n *\n * By default a callback list will act like an event callback list and can be\n * \"fired\" multiple times.\n *\n * Possible options:\n *\n *\tonce:\t\t\twill ensure the callback list can only be fired once (like a Deferred)\n *\n *\tmemory:\t\t\twill keep track of previous values and will call any callback added\n *\t\t\t\t\tafter the list has been fired right away with the latest \"memorized\"\n *\t\t\t\t\tvalues (like a Deferred)\n *\n *\tunique:\t\t\twill ensure a callback can only be added once (no duplicate in the list)\n *\n *\tstopOnFalse:\tinterrupt callings when a callback returns false\n *\n */\njQuery.Callbacks = function( options ) {\n\n\t// Convert options from String-formatted to Object-formatted if needed\n\t// (we check in cache first)\n\toptions = typeof options === \"string\" ?\n\t\tcreateOptions( options ) :\n\t\tjQuery.extend( {}, options );\n\n\tvar // Flag to know if list is currently firing\n\t\tfiring,\n\n\t\t// Last fire value for non-forgettable lists\n\t\tmemory,\n\n\t\t// Flag to know if list was already fired\n\t\tfired,\n\n\t\t// Flag to prevent firing\n\t\tlocked,\n\n\t\t// Actual callback list\n\t\tlist = [],\n\n\t\t// Queue of execution data for repeatable lists\n\t\tqueue = [],\n\n\t\t// Index of currently firing callback (modified by add/remove as needed)\n\t\tfiringIndex = -1,\n\n\t\t// Fire callbacks\n\t\tfire = function() {\n\n\t\t\t// Enforce single-firing\n\t\t\tlocked = locked || options.once;\n\n\t\t\t// Execute callbacks for all pending executions,\n\t\t\t// respecting firingIndex overrides and runtime changes\n\t\t\tfired = firing = true;\n\t\t\tfor ( ; queue.length; firingIndex = -1 ) {\n\t\t\t\tmemory = queue.shift();\n\t\t\t\twhile ( ++firingIndex < list.length ) {\n\n\t\t\t\t\t// Run callback and check for early termination\n\t\t\t\t\tif ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&\n\t\t\t\t\t\toptions.stopOnFalse ) {\n\n\t\t\t\t\t\t// Jump to end and forget the data so .add doesn't re-fire\n\t\t\t\t\t\tfiringIndex = list.length;\n\t\t\t\t\t\tmemory = false;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Forget the data if we're done with it\n\t\t\tif ( !options.memory ) {\n\t\t\t\tmemory = false;\n\t\t\t}\n\n\t\t\tfiring = false;\n\n\t\t\t// Clean up if we're done firing for good\n\t\t\tif ( locked ) {\n\n\t\t\t\t// Keep an empty list if we have data for future add calls\n\t\t\t\tif ( memory ) {\n\t\t\t\t\tlist = [];\n\n\t\t\t\t// Otherwise, this object is spent\n\t\t\t\t} else {\n\t\t\t\t\tlist = \"\";\n\t\t\t\t}\n\t\t\t}\n\t\t},\n\n\t\t// Actual Callbacks object\n\t\tself = {\n\n\t\t\t// Add a callback or a collection of callbacks to the list\n\t\t\tadd: function() {\n\t\t\t\tif ( list ) {\n\n\t\t\t\t\t// If we have memory from a past run, we should fire after adding\n\t\t\t\t\tif ( memory && !firing ) {\n\t\t\t\t\t\tfiringIndex = list.length - 1;\n\t\t\t\t\t\tqueue.push( memory );\n\t\t\t\t\t}\n\n\t\t\t\t\t( function add( args ) {\n\t\t\t\t\t\tjQuery.each( args, function( _, arg ) {\n\t\t\t\t\t\t\tif ( jQuery.isFunction( arg ) ) {\n\t\t\t\t\t\t\t\tif ( !options.unique || !self.has( arg ) ) {\n\t\t\t\t\t\t\t\t\tlist.push( arg );\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} else if ( arg && arg.length && jQuery.type( arg ) !== \"string\" ) {\n\n\t\t\t\t\t\t\t\t// Inspect recursively\n\t\t\t\t\t\t\t\tadd( arg );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} );\n\t\t\t\t\t} )( arguments );\n\n\t\t\t\t\tif ( memory && !firing ) {\n\t\t\t\t\t\tfire();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\treturn this;\n\t\t\t},\n\n\t\t\t// Remove a callback from the list\n\t\t\tremove: function() {\n\t\t\t\tjQuery.each( arguments, function( _, arg ) {\n\t\t\t\t\tvar index;\n\t\t\t\t\twhile ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {\n\t\t\t\t\t\tlist.splice( index, 1 );\n\n\t\t\t\t\t\t// Handle firing indexes\n\t\t\t\t\t\tif ( index <= firingIndex ) {\n\t\t\t\t\t\t\tfiringIndex--;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t} );\n\t\t\t\treturn this;\n\t\t\t},\n\n\t\t\t// Check if a given callback is in the list.\n\t\t\t// If no argument is given, return whether or not list has callbacks attached.\n\t\t\thas: function( fn ) {\n\t\t\t\treturn fn ?\n\t\t\t\t\tjQuery.inArray( fn, list ) > -1 :\n\t\t\t\t\tlist.length > 0;\n\t\t\t},\n\n\t\t\t// Remove all callbacks from the list\n\t\t\tempty: function() {\n\t\t\t\tif ( list ) {\n\t\t\t\t\tlist = [];\n\t\t\t\t}\n\t\t\t\treturn this;\n\t\t\t},\n\n\t\t\t// Disable .fire and .add\n\t\t\t// Abort any current/pending executions\n\t\t\t// Clear all callbacks and values\n\t\t\tdisable: function() {\n\t\t\t\tlocked = queue = [];\n\t\t\t\tlist = memory = \"\";\n\t\t\t\treturn this;\n\t\t\t},\n\t\t\tdisabled: function() {\n\t\t\t\treturn !list;\n\t\t\t},\n\n\t\t\t// Disable .fire\n\t\t\t// Also disable .add unless we have memory (since it would have no effect)\n\t\t\t// Abort any pending executions\n\t\t\tlock: function() {\n\t\t\t\tlocked = queue = [];\n\t\t\t\tif ( !memory && !firing ) {\n\t\t\t\t\tlist = memory = \"\";\n\t\t\t\t}\n\t\t\t\treturn this;\n\t\t\t},\n\t\t\tlocked: function() {\n\t\t\t\treturn !!locked;\n\t\t\t},\n\n\t\t\t// Call all callbacks with the given context and arguments\n\t\t\tfireWith: function( context, args ) {\n\t\t\t\tif ( !locked ) {\n\t\t\t\t\targs = args || [];\n\t\t\t\t\targs = [ context, args.slice ? args.slice() : args ];\n\t\t\t\t\tqueue.push( args );\n\t\t\t\t\tif ( !firing ) {\n\t\t\t\t\t\tfire();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\treturn this;\n\t\t\t},\n\n\t\t\t// Call all the callbacks with the given arguments\n\t\t\tfire: function() {\n\t\t\t\tself.fireWith( this, arguments );\n\t\t\t\treturn this;\n\t\t\t},\n\n\t\t\t// To know if the callbacks have already been called at least once\n\t\t\tfired: function() {\n\t\t\t\treturn !!fired;\n\t\t\t}\n\t\t};\n\n\treturn self;\n};\n\n\nfunction Identity( v ) {\n\treturn v;\n}\nfunction Thrower( ex ) {\n\tthrow ex;\n}\n\nfunction adoptValue( value, resolve, reject, noValue ) {\n\tvar method;\n\n\ttry {\n\n\t\t// Check for promise aspect first to privilege synchronous behavior\n\t\tif ( value && jQuery.isFunction( ( method = value.promise ) ) ) {\n\t\t\tmethod.call( value ).done( resolve ).fail( reject );\n\n\t\t// Other thenables\n\t\t} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {\n\t\t\tmethod.call( value, resolve, reject );\n\n\t\t// Other non-thenables\n\t\t} else {\n\n\t\t\t// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:\n\t\t\t// * false: [ value ].slice( 0 ) => resolve( value )\n\t\t\t// * true: [ value ].slice( 1 ) => resolve()\n\t\t\tresolve.apply( undefined, [ value ].slice( noValue ) );\n\t\t}\n\n\t// For Promises/A+, convert exceptions into rejections\n\t// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in\n\t// Deferred#then to conditionally suppress rejection.\n\t} catch ( value ) {\n\n\t\t// Support: Android 4.0 only\n\t\t// Strict mode functions invoked without .call/.apply get global-object context\n\t\treject.apply( undefined, [ value ] );\n\t}\n}\n\njQuery.extend( {\n\n\tDeferred: function( func ) {\n\t\tvar tuples = [\n\n\t\t\t\t// action, add listener, callbacks,\n\t\t\t\t// ... .then handlers, argument index, [final state]\n\t\t\t\t[ \"notify\", \"progress\", jQuery.Callbacks( \"memory\" ),\n\t\t\t\t\tjQuery.Callbacks( \"memory\" ), 2 ],\n\t\t\t\t[ \"resolve\", \"done\", jQuery.Callbacks( \"once memory\" ),\n\t\t\t\t\tjQuery.Callbacks( \"once memory\" ), 0, \"resolved\" ],\n\t\t\t\t[ \"reject\", \"fail\", jQuery.Callbacks( \"once memory\" ),\n\t\t\t\t\tjQuery.Callbacks( \"once memory\" ), 1, \"rejected\" ]\n\t\t\t],\n\t\t\tstate = \"pending\",\n\t\t\tpromise = {\n\t\t\t\tstate: function() {\n\t\t\t\t\treturn state;\n\t\t\t\t},\n\t\t\t\talways: function() {\n\t\t\t\t\tdeferred.done( arguments ).fail( arguments );\n\t\t\t\t\treturn this;\n\t\t\t\t},\n\t\t\t\t\"catch\": function( fn ) {\n\t\t\t\t\treturn promise.then( null, fn );\n\t\t\t\t},\n\n\t\t\t\t// Keep pipe for back-compat\n\t\t\t\tpipe: function( /* fnDone, fnFail, fnProgress */ ) {\n\t\t\t\t\tvar fns = arguments;\n\n\t\t\t\t\treturn jQuery.Deferred( function( newDefer ) {\n\t\t\t\t\t\tjQuery.each( tuples, function( i, tuple ) {\n\n\t\t\t\t\t\t\t// Map tuples (progress, done, fail) to arguments (done, fail, progress)\n\t\t\t\t\t\t\tvar fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];\n\n\t\t\t\t\t\t\t// deferred.progress(function() { bind to newDefer or newDefer.notify })\n\t\t\t\t\t\t\t// deferred.done(function() { bind to newDefer or newDefer.resolve })\n\t\t\t\t\t\t\t// deferred.fail(function() { bind to newDefer or newDefer.reject })\n\t\t\t\t\t\t\tdeferred[ tuple[ 1 ] ]( function() {\n\t\t\t\t\t\t\t\tvar returned = fn && fn.apply( this, arguments );\n\t\t\t\t\t\t\t\tif ( returned && jQuery.isFunction( returned.promise ) ) {\n\t\t\t\t\t\t\t\t\treturned.promise()\n\t\t\t\t\t\t\t\t\t\t.progress( newDefer.notify )\n\t\t\t\t\t\t\t\t\t\t.done( newDefer.resolve )\n\t\t\t\t\t\t\t\t\t\t.fail( newDefer.reject );\n\t\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\t\tnewDefer[ tuple[ 0 ] + \"With\" ](\n\t\t\t\t\t\t\t\t\t\tthis,\n\t\t\t\t\t\t\t\t\t\tfn ? [ returned ] : arguments\n\t\t\t\t\t\t\t\t\t);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t} );\n\t\t\t\t\t\tfns = null;\n\t\t\t\t\t} ).promise();\n\t\t\t\t},\n\t\t\t\tthen: function( onFulfilled, onRejected, onProgress ) {\n\t\t\t\t\tvar maxDepth = 0;\n\t\t\t\t\tfunction resolve( depth, deferred, handler, special ) {\n\t\t\t\t\t\treturn function() {\n\t\t\t\t\t\t\tvar that = this,\n\t\t\t\t\t\t\t\targs = arguments,\n\t\t\t\t\t\t\t\tmightThrow = function() {\n\t\t\t\t\t\t\t\t\tvar returned, then;\n\n\t\t\t\t\t\t\t\t\t// Support: Promises/A+ section 2.3.3.3.3\n\t\t\t\t\t\t\t\t\t// https://promisesaplus.com/#point-59\n\t\t\t\t\t\t\t\t\t// Ignore double-resolution attempts\n\t\t\t\t\t\t\t\t\tif ( depth < maxDepth ) {\n\t\t\t\t\t\t\t\t\t\treturn;\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\treturned = handler.apply( that, args );\n\n\t\t\t\t\t\t\t\t\t// Support: Promises/A+ section 2.3.1\n\t\t\t\t\t\t\t\t\t// https://promisesaplus.com/#point-48\n\t\t\t\t\t\t\t\t\tif ( returned === deferred.promise() ) {\n\t\t\t\t\t\t\t\t\t\tthrow new TypeError( \"Thenable self-resolution\" );\n\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Support: Promises/A+ sections 2.3.3.1, 3.5\n\t\t\t\t\t\t\t\t\t// https://promisesaplus.com/#point-54\n\t\t\t\t\t\t\t\t\t// https://promisesaplus.com/#point-75\n\t\t\t\t\t\t\t\t\t// Retrieve `then` only once\n\t\t\t\t\t\t\t\t\tthen = returned &&\n\n\t\t\t\t\t\t\t\t\t\t// Support: Promises/A+ section 2.3.4\n\t\t\t\t\t\t\t\t\t\t// https://promisesaplus.com/#point-64\n\t\t\t\t\t\t\t\t\t\t// Only check objects and functions for thenability\n\t\t\t\t\t\t\t\t\t\t( typeof returned === \"object\" ||\n\t\t\t\t\t\t\t\t\t\t\ttypeof returned === \"function\" ) &&\n\t\t\t\t\t\t\t\t\t\treturned.then;\n\n\t\t\t\t\t\t\t\t\t// Handle a returned thenable\n\t\t\t\t\t\t\t\t\tif ( jQuery.isFunction( then ) ) {\n\n\t\t\t\t\t\t\t\t\t\t// Special processors (notify) just wait for resolution\n\t\t\t\t\t\t\t\t\t\tif ( special ) {\n\t\t\t\t\t\t\t\t\t\t\tthen.call(\n\t\t\t\t\t\t\t\t\t\t\t\treturned,\n\t\t\t\t\t\t\t\t\t\t\t\tresolve( maxDepth, deferred, Identity, special ),\n\t\t\t\t\t\t\t\t\t\t\t\tresolve( maxDepth, deferred, Thrower, special )\n\t\t\t\t\t\t\t\t\t\t\t);\n\n\t\t\t\t\t\t\t\t\t\t// Normal processors (resolve) also hook into progress\n\t\t\t\t\t\t\t\t\t\t} else {\n\n\t\t\t\t\t\t\t\t\t\t\t// ...and disregard older resolution values\n\t\t\t\t\t\t\t\t\t\t\tmaxDepth++;\n\n\t\t\t\t\t\t\t\t\t\t\tthen.call(\n\t\t\t\t\t\t\t\t\t\t\t\treturned,\n\t\t\t\t\t\t\t\t\t\t\t\tresolve( maxDepth, deferred, Identity, special ),\n\t\t\t\t\t\t\t\t\t\t\t\tresolve( maxDepth, deferred, Thrower, special ),\n\t\t\t\t\t\t\t\t\t\t\t\tresolve( maxDepth, deferred, Identity,\n\t\t\t\t\t\t\t\t\t\t\t\t\tdeferred.notifyWith )\n\t\t\t\t\t\t\t\t\t\t\t);\n\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t// Handle all other returned values\n\t\t\t\t\t\t\t\t\t} else {\n\n\t\t\t\t\t\t\t\t\t\t// Only substitute handlers pass on context\n\t\t\t\t\t\t\t\t\t\t// and multiple values (non-spec behavior)\n\t\t\t\t\t\t\t\t\t\tif ( handler !== Identity ) {\n\t\t\t\t\t\t\t\t\t\t\tthat = undefined;\n\t\t\t\t\t\t\t\t\t\t\targs = [ returned ];\n\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t// Process the value(s)\n\t\t\t\t\t\t\t\t\t\t// Default process is resolve\n\t\t\t\t\t\t\t\t\t\t( special || deferred.resolveWith )( that, args );\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t},\n\n\t\t\t\t\t\t\t\t// Only normal processors (resolve) catch and reject exceptions\n\t\t\t\t\t\t\t\tprocess = special ?\n\t\t\t\t\t\t\t\t\tmightThrow :\n\t\t\t\t\t\t\t\t\tfunction() {\n\t\t\t\t\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\t\t\t\t\tmightThrow();\n\t\t\t\t\t\t\t\t\t\t} catch ( e ) {\n\n\t\t\t\t\t\t\t\t\t\t\tif ( jQuery.Deferred.exceptionHook ) {\n\t\t\t\t\t\t\t\t\t\t\t\tjQuery.Deferred.exceptionHook( e,\n\t\t\t\t\t\t\t\t\t\t\t\t\tprocess.stackTrace );\n\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t// Support: Promises/A+ section 2.3.3.3.4.1\n\t\t\t\t\t\t\t\t\t\t\t// https://promisesaplus.com/#point-61\n\t\t\t\t\t\t\t\t\t\t\t// Ignore post-resolution exceptions\n\t\t\t\t\t\t\t\t\t\t\tif ( depth + 1 >= maxDepth ) {\n\n\t\t\t\t\t\t\t\t\t\t\t\t// Only substitute handlers pass on context\n\t\t\t\t\t\t\t\t\t\t\t\t// and multiple values (non-spec behavior)\n\t\t\t\t\t\t\t\t\t\t\t\tif ( handler !== Thrower ) {\n\t\t\t\t\t\t\t\t\t\t\t\t\tthat = undefined;\n\t\t\t\t\t\t\t\t\t\t\t\t\targs = [ e ];\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\tdeferred.rejectWith( that, args );\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t};\n\n\t\t\t\t\t\t\t// Support: Promises/A+ section 2.3.3.3.1\n\t\t\t\t\t\t\t// https://promisesaplus.com/#point-57\n\t\t\t\t\t\t\t// Re-resolve promises immediately to dodge false rejection from\n\t\t\t\t\t\t\t// subsequent errors\n\t\t\t\t\t\t\tif ( depth ) {\n\t\t\t\t\t\t\t\tprocess();\n\t\t\t\t\t\t\t} else {\n\n\t\t\t\t\t\t\t\t// Call an optional hook to record the stack, in case of exception\n\t\t\t\t\t\t\t\t// since it's otherwise lost when execution goes async\n\t\t\t\t\t\t\t\tif ( jQuery.Deferred.getStackHook ) {\n\t\t\t\t\t\t\t\t\tprocess.stackTrace = jQuery.Deferred.getStackHook();\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\twindow.setTimeout( process );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t};\n\t\t\t\t\t}\n\n\t\t\t\t\treturn jQuery.Deferred( function( newDefer ) {\n\n\t\t\t\t\t\t// progress_handlers.add( ... )\n\t\t\t\t\t\ttuples[ 0 ][ 3 ].add(\n\t\t\t\t\t\t\tresolve(\n\t\t\t\t\t\t\t\t0,\n\t\t\t\t\t\t\t\tnewDefer,\n\t\t\t\t\t\t\t\tjQuery.isFunction( onProgress ) ?\n\t\t\t\t\t\t\t\t\tonProgress :\n\t\t\t\t\t\t\t\t\tIdentity,\n\t\t\t\t\t\t\t\tnewDefer.notifyWith\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t);\n\n\t\t\t\t\t\t// fulfilled_handlers.add( ... )\n\t\t\t\t\t\ttuples[ 1 ][ 3 ].add(\n\t\t\t\t\t\t\tresolve(\n\t\t\t\t\t\t\t\t0,\n\t\t\t\t\t\t\t\tnewDefer,\n\t\t\t\t\t\t\t\tjQuery.isFunction( onFulfilled ) ?\n\t\t\t\t\t\t\t\t\tonFulfilled :\n\t\t\t\t\t\t\t\t\tIdentity\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t);\n\n\t\t\t\t\t\t// rejected_handlers.add( ... )\n\t\t\t\t\t\ttuples[ 2 ][ 3 ].add(\n\t\t\t\t\t\t\tresolve(\n\t\t\t\t\t\t\t\t0,\n\t\t\t\t\t\t\t\tnewDefer,\n\t\t\t\t\t\t\t\tjQuery.isFunction( onRejected ) ?\n\t\t\t\t\t\t\t\t\tonRejected :\n\t\t\t\t\t\t\t\t\tThrower\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t);\n\t\t\t\t\t} ).promise();\n\t\t\t\t},\n\n\t\t\t\t// Get a promise for this deferred\n\t\t\t\t// If obj is provided, the promise aspect is added to the object\n\t\t\t\tpromise: function( obj ) {\n\t\t\t\t\treturn obj != null ? jQuery.extend( obj, promise ) : promise;\n\t\t\t\t}\n\t\t\t},\n\t\t\tdeferred = {};\n\n\t\t// Add list-specific methods\n\t\tjQuery.each( tuples, function( i, tuple ) {\n\t\t\tvar list = tuple[ 2 ],\n\t\t\t\tstateString = tuple[ 5 ];\n\n\t\t\t// promise.progress = list.add\n\t\t\t// promise.done = list.add\n\t\t\t// promise.fail = list.add\n\t\t\tpromise[ tuple[ 1 ] ] = list.add;\n\n\t\t\t// Handle state\n\t\t\tif ( stateString ) {\n\t\t\t\tlist.add(\n\t\t\t\t\tfunction() {\n\n\t\t\t\t\t\t// state = \"resolved\" (i.e., fulfilled)\n\t\t\t\t\t\t// state = \"rejected\"\n\t\t\t\t\t\tstate = stateString;\n\t\t\t\t\t},\n\n\t\t\t\t\t// rejected_callbacks.disable\n\t\t\t\t\t// fulfilled_callbacks.disable\n\t\t\t\t\ttuples[ 3 - i ][ 2 ].disable,\n\n\t\t\t\t\t// progress_callbacks.lock\n\t\t\t\t\ttuples[ 0 ][ 2 ].lock\n\t\t\t\t);\n\t\t\t}\n\n\t\t\t// progress_handlers.fire\n\t\t\t// fulfilled_handlers.fire\n\t\t\t// rejected_handlers.fire\n\t\t\tlist.add( tuple[ 3 ].fire );\n\n\t\t\t// deferred.notify = function() { deferred.notifyWith(...) }\n\t\t\t// deferred.resolve = function() { deferred.resolveWith(...) }\n\t\t\t// deferred.reject = function() { deferred.rejectWith(...) }\n\t\t\tdeferred[ tuple[ 0 ] ] = function() {\n\t\t\t\tdeferred[ tuple[ 0 ] + \"With\" ]( this === deferred ? undefined : this, arguments );\n\t\t\t\treturn this;\n\t\t\t};\n\n\t\t\t// deferred.notifyWith = list.fireWith\n\t\t\t// deferred.resolveWith = list.fireWith\n\t\t\t// deferred.rejectWith = list.fireWith\n\t\t\tdeferred[ tuple[ 0 ] + \"With\" ] = list.fireWith;\n\t\t} );\n\n\t\t// Make the deferred a promise\n\t\tpromise.promise( deferred );\n\n\t\t// Call given func if any\n\t\tif ( func ) {\n\t\t\tfunc.call( deferred, deferred );\n\t\t}\n\n\t\t// All done!\n\t\treturn deferred;\n\t},\n\n\t// Deferred helper\n\twhen: function( singleValue ) {\n\t\tvar\n\n\t\t\t// count of uncompleted subordinates\n\t\t\tremaining = arguments.length,\n\n\t\t\t// count of unprocessed arguments\n\t\t\ti = remaining,\n\n\t\t\t// subordinate fulfillment data\n\t\t\tresolveContexts = Array( i ),\n\t\t\tresolveValues = slice.call( arguments ),\n\n\t\t\t// the master Deferred\n\t\t\tmaster = jQuery.Deferred(),\n\n\t\t\t// subordinate callback factory\n\t\t\tupdateFunc = function( i ) {\n\t\t\t\treturn function( value ) {\n\t\t\t\t\tresolveContexts[ i ] = this;\n\t\t\t\t\tresolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;\n\t\t\t\t\tif ( !( --remaining ) ) {\n\t\t\t\t\t\tmaster.resolveWith( resolveContexts, resolveValues );\n\t\t\t\t\t}\n\t\t\t\t};\n\t\t\t};\n\n\t\t// Single- and empty arguments are adopted like Promise.resolve\n\t\tif ( remaining <= 1 ) {\n\t\t\tadoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,\n\t\t\t\t!remaining );\n\n\t\t\t// Use .then() to unwrap secondary thenables (cf. gh-3000)\n\t\t\tif ( master.state() === \"pending\" ||\n\t\t\t\tjQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {\n\n\t\t\t\treturn master.then();\n\t\t\t}\n\t\t}\n\n\t\t// Multiple arguments are aggregated like Promise.all array elements\n\t\twhile ( i-- ) {\n\t\t\tadoptValue( resolveValues[ i ], updateFunc( i ), master.reject );\n\t\t}\n\n\t\treturn master.promise();\n\t}\n} );\n\n\n// These usually indicate a programmer mistake during development,\n// warn about them ASAP rather than swallowing them by default.\nvar rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;\n\njQuery.Deferred.exceptionHook = function( error, stack ) {\n\n\t// Support: IE 8 - 9 only\n\t// Console exists when dev tools are open, which can happen at any time\n\tif ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {\n\t\twindow.console.warn( \"jQuery.Deferred exception: \" + error.message, error.stack, stack );\n\t}\n};\n\n\n\n\njQuery.readyException = function( error ) {\n\twindow.setTimeout( function() {\n\t\tthrow error;\n\t} );\n};\n\n\n\n\n// The deferred used on DOM ready\nvar readyList = jQuery.Deferred();\n\njQuery.fn.ready = function( fn ) {\n\n\treadyList\n\t\t.then( fn )\n\n\t\t// Wrap jQuery.readyException in a function so that the lookup\n\t\t// happens at the time of error handling instead of callback\n\t\t// registration.\n\t\t.catch( function( error ) {\n\t\t\tjQuery.readyException( error );\n\t\t} );\n\n\treturn this;\n};\n\njQuery.extend( {\n\n\t// Is the DOM ready to be used? Set to true once it occurs.\n\tisReady: false,\n\n\t// A counter to track how many items to wait for before\n\t// the ready event fires. See #6781\n\treadyWait: 1,\n\n\t// Handle when the DOM is ready\n\tready: function( wait ) {\n\n\t\t// Abort if there are pending holds or we're already ready\n\t\tif ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Remember that the DOM is ready\n\t\tjQuery.isReady = true;\n\n\t\t// If a normal DOM Ready event fired, decrement, and wait if need be\n\t\tif ( wait !== true && --jQuery.readyWait > 0 ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// If there are functions bound, to execute\n\t\treadyList.resolveWith( document, [ jQuery ] );\n\t}\n} );\n\njQuery.ready.then = readyList.then;\n\n// The ready event handler and self cleanup method\nfunction completed() {\n\tdocument.removeEventListener( \"DOMContentLoaded\", completed );\n\twindow.removeEventListener( \"load\", completed );\n\tjQuery.ready();\n}\n\n// Catch cases where $(document).ready() is called\n// after the browser event has already occurred.\n// Support: IE <=9 - 10 only\n// Older IE sometimes signals \"interactive\" too soon\nif ( document.readyState === \"complete\" ||\n\t( document.readyState !== \"loading\" && !document.documentElement.doScroll ) ) {\n\n\t// Handle it asynchronously to allow scripts the opportunity to delay ready\n\twindow.setTimeout( jQuery.ready );\n\n} else {\n\n\t// Use the handy event callback\n\tdocument.addEventListener( \"DOMContentLoaded\", completed );\n\n\t// A fallback to window.onload, that will always work\n\twindow.addEventListener( \"load\", completed );\n}\n\n\n\n\n// Multifunctional method to get and set values of a collection\n// The value/s can optionally be executed if it's a function\nvar access = function( elems, fn, key, value, chainable, emptyGet, raw ) {\n\tvar i = 0,\n\t\tlen = elems.length,\n\t\tbulk = key == null;\n\n\t// Sets many values\n\tif ( jQuery.type( key ) === \"object\" ) {\n\t\tchainable = true;\n\t\tfor ( i in key ) {\n\t\t\taccess( elems, fn, i, key[ i ], true, emptyGet, raw );\n\t\t}\n\n\t// Sets one value\n\t} else if ( value !== undefined ) {\n\t\tchainable = true;\n\n\t\tif ( !jQuery.isFunction( value ) ) {\n\t\t\traw = true;\n\t\t}\n\n\t\tif ( bulk ) {\n\n\t\t\t// Bulk operations run against the entire set\n\t\t\tif ( raw ) {\n\t\t\t\tfn.call( elems, value );\n\t\t\t\tfn = null;\n\n\t\t\t// ...except when executing function values\n\t\t\t} else {\n\t\t\t\tbulk = fn;\n\t\t\t\tfn = function( elem, key, value ) {\n\t\t\t\t\treturn bulk.call( jQuery( elem ), value );\n\t\t\t\t};\n\t\t\t}\n\t\t}\n\n\t\tif ( fn ) {\n\t\t\tfor ( ; i < len; i++ ) {\n\t\t\t\tfn(\n\t\t\t\t\telems[ i ], key, raw ?\n\t\t\t\t\tvalue :\n\t\t\t\t\tvalue.call( elems[ i ], i, fn( elems[ i ], key ) )\n\t\t\t\t);\n\t\t\t}\n\t\t}\n\t}\n\n\tif ( chainable ) {\n\t\treturn elems;\n\t}\n\n\t// Gets\n\tif ( bulk ) {\n\t\treturn fn.call( elems );\n\t}\n\n\treturn len ? fn( elems[ 0 ], key ) : emptyGet;\n};\nvar acceptData = function( owner ) {\n\n\t// Accepts only:\n\t//  - Node\n\t//    - Node.ELEMENT_NODE\n\t//    - Node.DOCUMENT_NODE\n\t//  - Object\n\t//    - Any\n\treturn owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );\n};\n\n\n\n\nfunction Data() {\n\tthis.expando = jQuery.expando + Data.uid++;\n}\n\nData.uid = 1;\n\nData.prototype = {\n\n\tcache: function( owner ) {\n\n\t\t// Check if the owner object already has a cache\n\t\tvar value = owner[ this.expando ];\n\n\t\t// If not, create one\n\t\tif ( !value ) {\n\t\t\tvalue = {};\n\n\t\t\t// We can accept data for non-element nodes in modern browsers,\n\t\t\t// but we should not, see #8335.\n\t\t\t// Always return an empty object.\n\t\t\tif ( acceptData( owner ) ) {\n\n\t\t\t\t// If it is a node unlikely to be stringify-ed or looped over\n\t\t\t\t// use plain assignment\n\t\t\t\tif ( owner.nodeType ) {\n\t\t\t\t\towner[ this.expando ] = value;\n\n\t\t\t\t// Otherwise secure it in a non-enumerable property\n\t\t\t\t// configurable must be true to allow the property to be\n\t\t\t\t// deleted when data is removed\n\t\t\t\t} else {\n\t\t\t\t\tObject.defineProperty( owner, this.expando, {\n\t\t\t\t\t\tvalue: value,\n\t\t\t\t\t\tconfigurable: true\n\t\t\t\t\t} );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn value;\n\t},\n\tset: function( owner, data, value ) {\n\t\tvar prop,\n\t\t\tcache = this.cache( owner );\n\n\t\t// Handle: [ owner, key, value ] args\n\t\t// Always use camelCase key (gh-2257)\n\t\tif ( typeof data === \"string\" ) {\n\t\t\tcache[ jQuery.camelCase( data ) ] = value;\n\n\t\t// Handle: [ owner, { properties } ] args\n\t\t} else {\n\n\t\t\t// Copy the properties one-by-one to the cache object\n\t\t\tfor ( prop in data ) {\n\t\t\t\tcache[ jQuery.camelCase( prop ) ] = data[ prop ];\n\t\t\t}\n\t\t}\n\t\treturn cache;\n\t},\n\tget: function( owner, key ) {\n\t\treturn key === undefined ?\n\t\t\tthis.cache( owner ) :\n\n\t\t\t// Always use camelCase key (gh-2257)\n\t\t\towner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];\n\t},\n\taccess: function( owner, key, value ) {\n\n\t\t// In cases where either:\n\t\t//\n\t\t//   1. No key was specified\n\t\t//   2. A string key was specified, but no value provided\n\t\t//\n\t\t// Take the \"read\" path and allow the get method to determine\n\t\t// which value to return, respectively either:\n\t\t//\n\t\t//   1. The entire cache object\n\t\t//   2. The data stored at the key\n\t\t//\n\t\tif ( key === undefined ||\n\t\t\t\t( ( key && typeof key === \"string\" ) && value === undefined ) ) {\n\n\t\t\treturn this.get( owner, key );\n\t\t}\n\n\t\t// When the key is not a string, or both a key and value\n\t\t// are specified, set or extend (existing objects) with either:\n\t\t//\n\t\t//   1. An object of properties\n\t\t//   2. A key and value\n\t\t//\n\t\tthis.set( owner, key, value );\n\n\t\t// Since the \"set\" path can have two possible entry points\n\t\t// return the expected data based on which path was taken[*]\n\t\treturn value !== undefined ? value : key;\n\t},\n\tremove: function( owner, key ) {\n\t\tvar i,\n\t\t\tcache = owner[ this.expando ];\n\n\t\tif ( cache === undefined ) {\n\t\t\treturn;\n\t\t}\n\n\t\tif ( key !== undefined ) {\n\n\t\t\t// Support array or space separated string of keys\n\t\t\tif ( Array.isArray( key ) ) {\n\n\t\t\t\t// If key is an array of keys...\n\t\t\t\t// We always set camelCase keys, so remove that.\n\t\t\t\tkey = key.map( jQuery.camelCase );\n\t\t\t} else {\n\t\t\t\tkey = jQuery.camelCase( key );\n\n\t\t\t\t// If a key with the spaces exists, use it.\n\t\t\t\t// Otherwise, create an array by matching non-whitespace\n\t\t\t\tkey = key in cache ?\n\t\t\t\t\t[ key ] :\n\t\t\t\t\t( key.match( rnothtmlwhite ) || [] );\n\t\t\t}\n\n\t\t\ti = key.length;\n\n\t\t\twhile ( i-- ) {\n\t\t\t\tdelete cache[ key[ i ] ];\n\t\t\t}\n\t\t}\n\n\t\t// Remove the expando if there's no more data\n\t\tif ( key === undefined || jQuery.isEmptyObject( cache ) ) {\n\n\t\t\t// Support: Chrome <=35 - 45\n\t\t\t// Webkit & Blink performance suffers when deleting properties\n\t\t\t// from DOM nodes, so set to undefined instead\n\t\t\t// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)\n\t\t\tif ( owner.nodeType ) {\n\t\t\t\towner[ this.expando ] = undefined;\n\t\t\t} else {\n\t\t\t\tdelete owner[ this.expando ];\n\t\t\t}\n\t\t}\n\t},\n\thasData: function( owner ) {\n\t\tvar cache = owner[ this.expando ];\n\t\treturn cache !== undefined && !jQuery.isEmptyObject( cache );\n\t}\n};\nvar dataPriv = new Data();\n\nvar dataUser = new Data();\n\n\n\n//\tImplementation Summary\n//\n//\t1. Enforce API surface and semantic compatibility with 1.9.x branch\n//\t2. Improve the module's maintainability by reducing the storage\n//\t\tpaths to a single mechanism.\n//\t3. Use the same single mechanism to support \"private\" and \"user\" data.\n//\t4. _Never_ expose \"private\" data to user code (TODO: Drop _data, _removeData)\n//\t5. Avoid exposing implementation details on user objects (eg. expando properties)\n//\t6. Provide a clear path for implementation upgrade to WeakMap in 2014\n\nvar rbrace = /^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,\n\trmultiDash = /[A-Z]/g;\n\nfunction getData( data ) {\n\tif ( data === \"true\" ) {\n\t\treturn true;\n\t}\n\n\tif ( data === \"false\" ) {\n\t\treturn false;\n\t}\n\n\tif ( data === \"null\" ) {\n\t\treturn null;\n\t}\n\n\t// Only convert to a number if it doesn't change the string\n\tif ( data === +data + \"\" ) {\n\t\treturn +data;\n\t}\n\n\tif ( rbrace.test( data ) ) {\n\t\treturn JSON.parse( data );\n\t}\n\n\treturn data;\n}\n\nfunction dataAttr( elem, key, data ) {\n\tvar name;\n\n\t// If nothing was found internally, try to fetch any\n\t// data from the HTML5 data-* attribute\n\tif ( data === undefined && elem.nodeType === 1 ) {\n\t\tname = \"data-\" + key.replace( rmultiDash, \"-$&\" ).toLowerCase();\n\t\tdata = elem.getAttribute( name );\n\n\t\tif ( typeof data === \"string\" ) {\n\t\t\ttry {\n\t\t\t\tdata = getData( data );\n\t\t\t} catch ( e ) {}\n\n\t\t\t// Make sure we set the data so it isn't changed later\n\t\t\tdataUser.set( elem, key, data );\n\t\t} else {\n\t\t\tdata = undefined;\n\t\t}\n\t}\n\treturn data;\n}\n\njQuery.extend( {\n\thasData: function( elem ) {\n\t\treturn dataUser.hasData( elem ) || dataPriv.hasData( elem );\n\t},\n\n\tdata: function( elem, name, data ) {\n\t\treturn dataUser.access( elem, name, data );\n\t},\n\n\tremoveData: function( elem, name ) {\n\t\tdataUser.remove( elem, name );\n\t},\n\n\t// TODO: Now that all calls to _data and _removeData have been replaced\n\t// with direct calls to dataPriv methods, these can be deprecated.\n\t_data: function( elem, name, data ) {\n\t\treturn dataPriv.access( elem, name, data );\n\t},\n\n\t_removeData: function( elem, name ) {\n\t\tdataPriv.remove( elem, name );\n\t}\n} );\n\njQuery.fn.extend( {\n\tdata: function( key, value ) {\n\t\tvar i, name, data,\n\t\t\telem = this[ 0 ],\n\t\t\tattrs = elem && elem.attributes;\n\n\t\t// Gets all values\n\t\tif ( key === undefined ) {\n\t\t\tif ( this.length ) {\n\t\t\t\tdata = dataUser.get( elem );\n\n\t\t\t\tif ( elem.nodeType === 1 && !dataPriv.get( elem, \"hasDataAttrs\" ) ) {\n\t\t\t\t\ti = attrs.length;\n\t\t\t\t\twhile ( i-- ) {\n\n\t\t\t\t\t\t// Support: IE 11 only\n\t\t\t\t\t\t// The attrs elements can be null (#14894)\n\t\t\t\t\t\tif ( attrs[ i ] ) {\n\t\t\t\t\t\t\tname = attrs[ i ].name;\n\t\t\t\t\t\t\tif ( name.indexOf( \"data-\" ) === 0 ) {\n\t\t\t\t\t\t\t\tname = jQuery.camelCase( name.slice( 5 ) );\n\t\t\t\t\t\t\t\tdataAttr( elem, name, data[ name ] );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tdataPriv.set( elem, \"hasDataAttrs\", true );\n\t\t\t\t}\n\t\t\t}\n\n\t\t\treturn data;\n\t\t}\n\n\t\t// Sets multiple values\n\t\tif ( typeof key === \"object\" ) {\n\t\t\treturn this.each( function() {\n\t\t\t\tdataUser.set( this, key );\n\t\t\t} );\n\t\t}\n\n\t\treturn access( this, function( value ) {\n\t\t\tvar data;\n\n\t\t\t// The calling jQuery object (element matches) is not empty\n\t\t\t// (and therefore has an element appears at this[ 0 ]) and the\n\t\t\t// `value` parameter was not undefined. An empty jQuery object\n\t\t\t// will result in `undefined` for elem = this[ 0 ] which will\n\t\t\t// throw an exception if an attempt to read a data cache is made.\n\t\t\tif ( elem && value === undefined ) {\n\n\t\t\t\t// Attempt to get data from the cache\n\t\t\t\t// The key will always be camelCased in Data\n\t\t\t\tdata = dataUser.get( elem, key );\n\t\t\t\tif ( data !== undefined ) {\n\t\t\t\t\treturn data;\n\t\t\t\t}\n\n\t\t\t\t// Attempt to \"discover\" the data in\n\t\t\t\t// HTML5 custom data-* attrs\n\t\t\t\tdata = dataAttr( elem, key );\n\t\t\t\tif ( data !== undefined ) {\n\t\t\t\t\treturn data;\n\t\t\t\t}\n\n\t\t\t\t// We tried really hard, but the data doesn't exist.\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\t// Set the data...\n\t\t\tthis.each( function() {\n\n\t\t\t\t// We always store the camelCased key\n\t\t\t\tdataUser.set( this, key, value );\n\t\t\t} );\n\t\t}, null, value, arguments.length > 1, null, true );\n\t},\n\n\tremoveData: function( key ) {\n\t\treturn this.each( function() {\n\t\t\tdataUser.remove( this, key );\n\t\t} );\n\t}\n} );\n\n\njQuery.extend( {\n\tqueue: function( elem, type, data ) {\n\t\tvar queue;\n\n\t\tif ( elem ) {\n\t\t\ttype = ( type || \"fx\" ) + \"queue\";\n\t\t\tqueue = dataPriv.get( elem, type );\n\n\t\t\t// Speed up dequeue by getting out quickly if this is just a lookup\n\t\t\tif ( data ) {\n\t\t\t\tif ( !queue || Array.isArray( data ) ) {\n\t\t\t\t\tqueue = dataPriv.access( elem, type, jQuery.makeArray( data ) );\n\t\t\t\t} else {\n\t\t\t\t\tqueue.push( data );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn queue || [];\n\t\t}\n\t},\n\n\tdequeue: function( elem, type ) {\n\t\ttype = type || \"fx\";\n\n\t\tvar queue = jQuery.queue( elem, type ),\n\t\t\tstartLength = queue.length,\n\t\t\tfn = queue.shift(),\n\t\t\thooks = jQuery._queueHooks( elem, type ),\n\t\t\tnext = function() {\n\t\t\t\tjQuery.dequeue( elem, type );\n\t\t\t};\n\n\t\t// If the fx queue is dequeued, always remove the progress sentinel\n\t\tif ( fn === \"inprogress\" ) {\n\t\t\tfn = queue.shift();\n\t\t\tstartLength--;\n\t\t}\n\n\t\tif ( fn ) {\n\n\t\t\t// Add a progress sentinel to prevent the fx queue from being\n\t\t\t// automatically dequeued\n\t\t\tif ( type === \"fx\" ) {\n\t\t\t\tqueue.unshift( \"inprogress\" );\n\t\t\t}\n\n\t\t\t// Clear up the last queue stop function\n\t\t\tdelete hooks.stop;\n\t\t\tfn.call( elem, next, hooks );\n\t\t}\n\n\t\tif ( !startLength && hooks ) {\n\t\t\thooks.empty.fire();\n\t\t}\n\t},\n\n\t// Not public - generate a queueHooks object, or return the current one\n\t_queueHooks: function( elem, type ) {\n\t\tvar key = type + \"queueHooks\";\n\t\treturn dataPriv.get( elem, key ) || dataPriv.access( elem, key, {\n\t\t\tempty: jQuery.Callbacks( \"once memory\" ).add( function() {\n\t\t\t\tdataPriv.remove( elem, [ type + \"queue\", key ] );\n\t\t\t} )\n\t\t} );\n\t}\n} );\n\njQuery.fn.extend( {\n\tqueue: function( type, data ) {\n\t\tvar setter = 2;\n\n\t\tif ( typeof type !== \"string\" ) {\n\t\t\tdata = type;\n\t\t\ttype = \"fx\";\n\t\t\tsetter--;\n\t\t}\n\n\t\tif ( arguments.length < setter ) {\n\t\t\treturn jQuery.queue( this[ 0 ], type );\n\t\t}\n\n\t\treturn data === undefined ?\n\t\t\tthis :\n\t\t\tthis.each( function() {\n\t\t\t\tvar queue = jQuery.queue( this, type, data );\n\n\t\t\t\t// Ensure a hooks for this queue\n\t\t\t\tjQuery._queueHooks( this, type );\n\n\t\t\t\tif ( type === \"fx\" && queue[ 0 ] !== \"inprogress\" ) {\n\t\t\t\t\tjQuery.dequeue( this, type );\n\t\t\t\t}\n\t\t\t} );\n\t},\n\tdequeue: function( type ) {\n\t\treturn this.each( function() {\n\t\t\tjQuery.dequeue( this, type );\n\t\t} );\n\t},\n\tclearQueue: function( type ) {\n\t\treturn this.queue( type || \"fx\", [] );\n\t},\n\n\t// Get a promise resolved when queues of a certain type\n\t// are emptied (fx is the type by default)\n\tpromise: function( type, obj ) {\n\t\tvar tmp,\n\t\t\tcount = 1,\n\t\t\tdefer = jQuery.Deferred(),\n\t\t\telements = this,\n\t\t\ti = this.length,\n\t\t\tresolve = function() {\n\t\t\t\tif ( !( --count ) ) {\n\t\t\t\t\tdefer.resolveWith( elements, [ elements ] );\n\t\t\t\t}\n\t\t\t};\n\n\t\tif ( typeof type !== \"string\" ) {\n\t\t\tobj = type;\n\t\t\ttype = undefined;\n\t\t}\n\t\ttype = type || \"fx\";\n\n\t\twhile ( i-- ) {\n\t\t\ttmp = dataPriv.get( elements[ i ], type + \"queueHooks\" );\n\t\t\tif ( tmp && tmp.empty ) {\n\t\t\t\tcount++;\n\t\t\t\ttmp.empty.add( resolve );\n\t\t\t}\n\t\t}\n\t\tresolve();\n\t\treturn defer.promise( obj );\n\t}\n} );\nvar pnum = ( /[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/ ).source;\n\nvar rcssNum = new RegExp( \"^(?:([+-])=|)(\" + pnum + \")([a-z%]*)$\", \"i\" );\n\n\nvar cssExpand = [ \"Top\", \"Right\", \"Bottom\", \"Left\" ];\n\nvar isHiddenWithinTree = function( elem, el ) {\n\n\t\t// isHiddenWithinTree might be called from jQuery#filter function;\n\t\t// in that case, element will be second argument\n\t\telem = el || elem;\n\n\t\t// Inline style trumps all\n\t\treturn elem.style.display === \"none\" ||\n\t\t\telem.style.display === \"\" &&\n\n\t\t\t// Otherwise, check computed style\n\t\t\t// Support: Firefox <=43 - 45\n\t\t\t// Disconnected elements can have computed display: none, so first confirm that elem is\n\t\t\t// in the document.\n\t\t\tjQuery.contains( elem.ownerDocument, elem ) &&\n\n\t\t\tjQuery.css( elem, \"display\" ) === \"none\";\n\t};\n\nvar swap = function( elem, options, callback, args ) {\n\tvar ret, name,\n\t\told = {};\n\n\t// Remember the old values, and insert the new ones\n\tfor ( name in options ) {\n\t\told[ name ] = elem.style[ name ];\n\t\telem.style[ name ] = options[ name ];\n\t}\n\n\tret = callback.apply( elem, args || [] );\n\n\t// Revert the old values\n\tfor ( name in options ) {\n\t\telem.style[ name ] = old[ name ];\n\t}\n\n\treturn ret;\n};\n\n\n\n\nfunction adjustCSS( elem, prop, valueParts, tween ) {\n\tvar adjusted,\n\t\tscale = 1,\n\t\tmaxIterations = 20,\n\t\tcurrentValue = tween ?\n\t\t\tfunction() {\n\t\t\t\treturn tween.cur();\n\t\t\t} :\n\t\t\tfunction() {\n\t\t\t\treturn jQuery.css( elem, prop, \"\" );\n\t\t\t},\n\t\tinitial = currentValue(),\n\t\tunit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? \"\" : \"px\" ),\n\n\t\t// Starting value computation is required for potential unit mismatches\n\t\tinitialInUnit = ( jQuery.cssNumber[ prop ] || unit !== \"px\" && +initial ) &&\n\t\t\trcssNum.exec( jQuery.css( elem, prop ) );\n\n\tif ( initialInUnit && initialInUnit[ 3 ] !== unit ) {\n\n\t\t// Trust units reported by jQuery.css\n\t\tunit = unit || initialInUnit[ 3 ];\n\n\t\t// Make sure we update the tween properties later on\n\t\tvalueParts = valueParts || [];\n\n\t\t// Iteratively approximate from a nonzero starting point\n\t\tinitialInUnit = +initial || 1;\n\n\t\tdo {\n\n\t\t\t// If previous iteration zeroed out, double until we get *something*.\n\t\t\t// Use string for doubling so we don't accidentally see scale as unchanged below\n\t\t\tscale = scale || \".5\";\n\n\t\t\t// Adjust and apply\n\t\t\tinitialInUnit = initialInUnit / scale;\n\t\t\tjQuery.style( elem, prop, initialInUnit + unit );\n\n\t\t// Update scale, tolerating zero or NaN from tween.cur()\n\t\t// Break the loop if scale is unchanged or perfect, or if we've just had enough.\n\t\t} while (\n\t\t\tscale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations\n\t\t);\n\t}\n\n\tif ( valueParts ) {\n\t\tinitialInUnit = +initialInUnit || +initial || 0;\n\n\t\t// Apply relative offset (+=/-=) if specified\n\t\tadjusted = valueParts[ 1 ] ?\n\t\t\tinitialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :\n\t\t\t+valueParts[ 2 ];\n\t\tif ( tween ) {\n\t\t\ttween.unit = unit;\n\t\t\ttween.start = initialInUnit;\n\t\t\ttween.end = adjusted;\n\t\t}\n\t}\n\treturn adjusted;\n}\n\n\nvar defaultDisplayMap = {};\n\nfunction getDefaultDisplay( elem ) {\n\tvar temp,\n\t\tdoc = elem.ownerDocument,\n\t\tnodeName = elem.nodeName,\n\t\tdisplay = defaultDisplayMap[ nodeName ];\n\n\tif ( display ) {\n\t\treturn display;\n\t}\n\n\ttemp = doc.body.appendChild( doc.createElement( nodeName ) );\n\tdisplay = jQuery.css( temp, \"display\" );\n\n\ttemp.parentNode.removeChild( temp );\n\n\tif ( display === \"none\" ) {\n\t\tdisplay = \"block\";\n\t}\n\tdefaultDisplayMap[ nodeName ] = display;\n\n\treturn display;\n}\n\nfunction showHide( elements, show ) {\n\tvar display, elem,\n\t\tvalues = [],\n\t\tindex = 0,\n\t\tlength = elements.length;\n\n\t// Determine new display value for elements that need to change\n\tfor ( ; index < length; index++ ) {\n\t\telem = elements[ index ];\n\t\tif ( !elem.style ) {\n\t\t\tcontinue;\n\t\t}\n\n\t\tdisplay = elem.style.display;\n\t\tif ( show ) {\n\n\t\t\t// Since we force visibility upon cascade-hidden elements, an immediate (and slow)\n\t\t\t// check is required in this first loop unless we have a nonempty display value (either\n\t\t\t// inline or about-to-be-restored)\n\t\t\tif ( display === \"none\" ) {\n\t\t\t\tvalues[ index ] = dataPriv.get( elem, \"display\" ) || null;\n\t\t\t\tif ( !values[ index ] ) {\n\t\t\t\t\telem.style.display = \"\";\n\t\t\t\t}\n\t\t\t}\n\t\t\tif ( elem.style.display === \"\" && isHiddenWithinTree( elem ) ) {\n\t\t\t\tvalues[ index ] = getDefaultDisplay( elem );\n\t\t\t}\n\t\t} else {\n\t\t\tif ( display !== \"none\" ) {\n\t\t\t\tvalues[ index ] = \"none\";\n\n\t\t\t\t// Remember what we're overwriting\n\t\t\t\tdataPriv.set( elem, \"display\", display );\n\t\t\t}\n\t\t}\n\t}\n\n\t// Set the display of the elements in a second loop to avoid constant reflow\n\tfor ( index = 0; index < length; index++ ) {\n\t\tif ( values[ index ] != null ) {\n\t\t\telements[ index ].style.display = values[ index ];\n\t\t}\n\t}\n\n\treturn elements;\n}\n\njQuery.fn.extend( {\n\tshow: function() {\n\t\treturn showHide( this, true );\n\t},\n\thide: function() {\n\t\treturn showHide( this );\n\t},\n\ttoggle: function( state ) {\n\t\tif ( typeof state === \"boolean\" ) {\n\t\t\treturn state ? this.show() : this.hide();\n\t\t}\n\n\t\treturn this.each( function() {\n\t\t\tif ( isHiddenWithinTree( this ) ) {\n\t\t\t\tjQuery( this ).show();\n\t\t\t} else {\n\t\t\t\tjQuery( this ).hide();\n\t\t\t}\n\t\t} );\n\t}\n} );\nvar rcheckableType = ( /^(?:checkbox|radio)$/i );\n\nvar rtagName = ( /<([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]+)/i );\n\nvar rscriptType = ( /^$|\\/(?:java|ecma)script/i );\n\n\n\n// We have to close these tags to support XHTML (#13200)\nvar wrapMap = {\n\n\t// Support: IE <=9 only\n\toption: [ 1, \"<select multiple='multiple'>\", \"</select>\" ],\n\n\t// XHTML parsers do not magically insert elements in the\n\t// same way that tag soup parsers do. So we cannot shorten\n\t// this by omitting <tbody> or other required elements.\n\tthead: [ 1, \"<table>\", \"</table>\" ],\n\tcol: [ 2, \"<table><colgroup>\", \"</colgroup></table>\" ],\n\ttr: [ 2, \"<table><tbody>\", \"</tbody></table>\" ],\n\ttd: [ 3, \"<table><tbody><tr>\", \"</tr></tbody></table>\" ],\n\n\t_default: [ 0, \"\", \"\" ]\n};\n\n// Support: IE <=9 only\nwrapMap.optgroup = wrapMap.option;\n\nwrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;\nwrapMap.th = wrapMap.td;\n\n\nfunction getAll( context, tag ) {\n\n\t// Support: IE <=9 - 11 only\n\t// Use typeof to avoid zero-argument method invocation on host objects (#15151)\n\tvar ret;\n\n\tif ( typeof context.getElementsByTagName !== \"undefined\" ) {\n\t\tret = context.getElementsByTagName( tag || \"*\" );\n\n\t} else if ( typeof context.querySelectorAll !== \"undefined\" ) {\n\t\tret = context.querySelectorAll( tag || \"*\" );\n\n\t} else {\n\t\tret = [];\n\t}\n\n\tif ( tag === undefined || tag && nodeName( context, tag ) ) {\n\t\treturn jQuery.merge( [ context ], ret );\n\t}\n\n\treturn ret;\n}\n\n\n// Mark scripts as having already been evaluated\nfunction setGlobalEval( elems, refElements ) {\n\tvar i = 0,\n\t\tl = elems.length;\n\n\tfor ( ; i < l; i++ ) {\n\t\tdataPriv.set(\n\t\t\telems[ i ],\n\t\t\t\"globalEval\",\n\t\t\t!refElements || dataPriv.get( refElements[ i ], \"globalEval\" )\n\t\t);\n\t}\n}\n\n\nvar rhtml = /<|&#?\\w+;/;\n\nfunction buildFragment( elems, context, scripts, selection, ignored ) {\n\tvar elem, tmp, tag, wrap, contains, j,\n\t\tfragment = context.createDocumentFragment(),\n\t\tnodes = [],\n\t\ti = 0,\n\t\tl = elems.length;\n\n\tfor ( ; i < l; i++ ) {\n\t\telem = elems[ i ];\n\n\t\tif ( elem || elem === 0 ) {\n\n\t\t\t// Add nodes directly\n\t\t\tif ( jQuery.type( elem ) === \"object\" ) {\n\n\t\t\t\t// Support: Android <=4.0 only, PhantomJS 1 only\n\t\t\t\t// push.apply(_, arraylike) throws on ancient WebKit\n\t\t\t\tjQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );\n\n\t\t\t// Convert non-html into a text node\n\t\t\t} else if ( !rhtml.test( elem ) ) {\n\t\t\t\tnodes.push( context.createTextNode( elem ) );\n\n\t\t\t// Convert html into DOM nodes\n\t\t\t} else {\n\t\t\t\ttmp = tmp || fragment.appendChild( context.createElement( \"div\" ) );\n\n\t\t\t\t// Deserialize a standard representation\n\t\t\t\ttag = ( rtagName.exec( elem ) || [ \"\", \"\" ] )[ 1 ].toLowerCase();\n\t\t\t\twrap = wrapMap[ tag ] || wrapMap._default;\n\t\t\t\ttmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];\n\n\t\t\t\t// Descend through wrappers to the right content\n\t\t\t\tj = wrap[ 0 ];\n\t\t\t\twhile ( j-- ) {\n\t\t\t\t\ttmp = tmp.lastChild;\n\t\t\t\t}\n\n\t\t\t\t// Support: Android <=4.0 only, PhantomJS 1 only\n\t\t\t\t// push.apply(_, arraylike) throws on ancient WebKit\n\t\t\t\tjQuery.merge( nodes, tmp.childNodes );\n\n\t\t\t\t// Remember the top-level container\n\t\t\t\ttmp = fragment.firstChild;\n\n\t\t\t\t// Ensure the created nodes are orphaned (#12392)\n\t\t\t\ttmp.textContent = \"\";\n\t\t\t}\n\t\t}\n\t}\n\n\t// Remove wrapper from fragment\n\tfragment.textContent = \"\";\n\n\ti = 0;\n\twhile ( ( elem = nodes[ i++ ] ) ) {\n\n\t\t// Skip elements already in the context collection (trac-4087)\n\t\tif ( selection && jQuery.inArray( elem, selection ) > -1 ) {\n\t\t\tif ( ignored ) {\n\t\t\t\tignored.push( elem );\n\t\t\t}\n\t\t\tcontinue;\n\t\t}\n\n\t\tcontains = jQuery.contains( elem.ownerDocument, elem );\n\n\t\t// Append to fragment\n\t\ttmp = getAll( fragment.appendChild( elem ), \"script\" );\n\n\t\t// Preserve script evaluation history\n\t\tif ( contains ) {\n\t\t\tsetGlobalEval( tmp );\n\t\t}\n\n\t\t// Capture executables\n\t\tif ( scripts ) {\n\t\t\tj = 0;\n\t\t\twhile ( ( elem = tmp[ j++ ] ) ) {\n\t\t\t\tif ( rscriptType.test( elem.type || \"\" ) ) {\n\t\t\t\t\tscripts.push( elem );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\treturn fragment;\n}\n\n\n( function() {\n\tvar fragment = document.createDocumentFragment(),\n\t\tdiv = fragment.appendChild( document.createElement( \"div\" ) ),\n\t\tinput = document.createElement( \"input\" );\n\n\t// Support: Android 4.0 - 4.3 only\n\t// Check state lost if the name is set (#11217)\n\t// Support: Windows Web Apps (WWA)\n\t// `name` and `type` must use .setAttribute for WWA (#14901)\n\tinput.setAttribute( \"type\", \"radio\" );\n\tinput.setAttribute( \"checked\", \"checked\" );\n\tinput.setAttribute( \"name\", \"t\" );\n\n\tdiv.appendChild( input );\n\n\t// Support: Android <=4.1 only\n\t// Older WebKit doesn't clone checked state correctly in fragments\n\tsupport.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;\n\n\t// Support: IE <=11 only\n\t// Make sure textarea (and checkbox) defaultValue is properly cloned\n\tdiv.innerHTML = \"<textarea>x</textarea>\";\n\tsupport.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;\n} )();\nvar documentElement = document.documentElement;\n\n\n\nvar\n\trkeyEvent = /^key/,\n\trmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,\n\trtypenamespace = /^([^.]*)(?:\\.(.+)|)/;\n\nfunction returnTrue() {\n\treturn true;\n}\n\nfunction returnFalse() {\n\treturn false;\n}\n\n// Support: IE <=9 only\n// See #13393 for more info\nfunction safeActiveElement() {\n\ttry {\n\t\treturn document.activeElement;\n\t} catch ( err ) { }\n}\n\nfunction on( elem, types, selector, data, fn, one ) {\n\tvar origFn, type;\n\n\t// Types can be a map of types/handlers\n\tif ( typeof types === \"object\" ) {\n\n\t\t// ( types-Object, selector, data )\n\t\tif ( typeof selector !== \"string\" ) {\n\n\t\t\t// ( types-Object, data )\n\t\t\tdata = data || selector;\n\t\t\tselector = undefined;\n\t\t}\n\t\tfor ( type in types ) {\n\t\t\ton( elem, type, selector, data, types[ type ], one );\n\t\t}\n\t\treturn elem;\n\t}\n\n\tif ( data == null && fn == null ) {\n\n\t\t// ( types, fn )\n\t\tfn = selector;\n\t\tdata = selector = undefined;\n\t} else if ( fn == null ) {\n\t\tif ( typeof selector === \"string\" ) {\n\n\t\t\t// ( types, selector, fn )\n\t\t\tfn = data;\n\t\t\tdata = undefined;\n\t\t} else {\n\n\t\t\t// ( types, data, fn )\n\t\t\tfn = data;\n\t\t\tdata = selector;\n\t\t\tselector = undefined;\n\t\t}\n\t}\n\tif ( fn === false ) {\n\t\tfn = returnFalse;\n\t} else if ( !fn ) {\n\t\treturn elem;\n\t}\n\n\tif ( one === 1 ) {\n\t\torigFn = fn;\n\t\tfn = function( event ) {\n\n\t\t\t// Can use an empty set, since event contains the info\n\t\t\tjQuery().off( event );\n\t\t\treturn origFn.apply( this, arguments );\n\t\t};\n\n\t\t// Use same guid so caller can remove using origFn\n\t\tfn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );\n\t}\n\treturn elem.each( function() {\n\t\tjQuery.event.add( this, types, fn, data, selector );\n\t} );\n}\n\n/*\n * Helper functions for managing events -- not part of the public interface.\n * Props to Dean Edwards' addEvent library for many of the ideas.\n */\njQuery.event = {\n\n\tglobal: {},\n\n\tadd: function( elem, types, handler, data, selector ) {\n\n\t\tvar handleObjIn, eventHandle, tmp,\n\t\t\tevents, t, handleObj,\n\t\t\tspecial, handlers, type, namespaces, origType,\n\t\t\telemData = dataPriv.get( elem );\n\n\t\t// Don't attach events to noData or text/comment nodes (but allow plain objects)\n\t\tif ( !elemData ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Caller can pass in an object of custom data in lieu of the handler\n\t\tif ( handler.handler ) {\n\t\t\thandleObjIn = handler;\n\t\t\thandler = handleObjIn.handler;\n\t\t\tselector = handleObjIn.selector;\n\t\t}\n\n\t\t// Ensure that invalid selectors throw exceptions at attach time\n\t\t// Evaluate against documentElement in case elem is a non-element node (e.g., document)\n\t\tif ( selector ) {\n\t\t\tjQuery.find.matchesSelector( documentElement, selector );\n\t\t}\n\n\t\t// Make sure that the handler has a unique ID, used to find/remove it later\n\t\tif ( !handler.guid ) {\n\t\t\thandler.guid = jQuery.guid++;\n\t\t}\n\n\t\t// Init the element's event structure and main handler, if this is the first\n\t\tif ( !( events = elemData.events ) ) {\n\t\t\tevents = elemData.events = {};\n\t\t}\n\t\tif ( !( eventHandle = elemData.handle ) ) {\n\t\t\teventHandle = elemData.handle = function( e ) {\n\n\t\t\t\t// Discard the second event of a jQuery.event.trigger() and\n\t\t\t\t// when an event is called after a page has unloaded\n\t\t\t\treturn typeof jQuery !== \"undefined\" && jQuery.event.triggered !== e.type ?\n\t\t\t\t\tjQuery.event.dispatch.apply( elem, arguments ) : undefined;\n\t\t\t};\n\t\t}\n\n\t\t// Handle multiple events separated by a space\n\t\ttypes = ( types || \"\" ).match( rnothtmlwhite ) || [ \"\" ];\n\t\tt = types.length;\n\t\twhile ( t-- ) {\n\t\t\ttmp = rtypenamespace.exec( types[ t ] ) || [];\n\t\t\ttype = origType = tmp[ 1 ];\n\t\t\tnamespaces = ( tmp[ 2 ] || \"\" ).split( \".\" ).sort();\n\n\t\t\t// There *must* be a type, no attaching namespace-only handlers\n\t\t\tif ( !type ) {\n\t\t\t\tcontinue;\n\t\t\t}\n\n\t\t\t// If event changes its type, use the special event handlers for the changed type\n\t\t\tspecial = jQuery.event.special[ type ] || {};\n\n\t\t\t// If selector defined, determine special event api type, otherwise given type\n\t\t\ttype = ( selector ? special.delegateType : special.bindType ) || type;\n\n\t\t\t// Update special based on newly reset type\n\t\t\tspecial = jQuery.event.special[ type ] || {};\n\n\t\t\t// handleObj is passed to all event handlers\n\t\t\thandleObj = jQuery.extend( {\n\t\t\t\ttype: type,\n\t\t\t\torigType: origType,\n\t\t\t\tdata: data,\n\t\t\t\thandler: handler,\n\t\t\t\tguid: handler.guid,\n\t\t\t\tselector: selector,\n\t\t\t\tneedsContext: selector && jQuery.expr.match.needsContext.test( selector ),\n\t\t\t\tnamespace: namespaces.join( \".\" )\n\t\t\t}, handleObjIn );\n\n\t\t\t// Init the event handler queue if we're the first\n\t\t\tif ( !( handlers = events[ type ] ) ) {\n\t\t\t\thandlers = events[ type ] = [];\n\t\t\t\thandlers.delegateCount = 0;\n\n\t\t\t\t// Only use addEventListener if the special events handler returns false\n\t\t\t\tif ( !special.setup ||\n\t\t\t\t\tspecial.setup.call( elem, data, namespaces, eventHandle ) === false ) {\n\n\t\t\t\t\tif ( elem.addEventListener ) {\n\t\t\t\t\t\telem.addEventListener( type, eventHandle );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tif ( special.add ) {\n\t\t\t\tspecial.add.call( elem, handleObj );\n\n\t\t\t\tif ( !handleObj.handler.guid ) {\n\t\t\t\t\thandleObj.handler.guid = handler.guid;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Add to the element's handler list, delegates in front\n\t\t\tif ( selector ) {\n\t\t\t\thandlers.splice( handlers.delegateCount++, 0, handleObj );\n\t\t\t} else {\n\t\t\t\thandlers.push( handleObj );\n\t\t\t}\n\n\t\t\t// Keep track of which events have ever been used, for event optimization\n\t\t\tjQuery.event.global[ type ] = true;\n\t\t}\n\n\t},\n\n\t// Detach an event or set of events from an element\n\tremove: function( elem, types, handler, selector, mappedTypes ) {\n\n\t\tvar j, origCount, tmp,\n\t\t\tevents, t, handleObj,\n\t\t\tspecial, handlers, type, namespaces, origType,\n\t\t\telemData = dataPriv.hasData( elem ) && dataPriv.get( elem );\n\n\t\tif ( !elemData || !( events = elemData.events ) ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Once for each type.namespace in types; type may be omitted\n\t\ttypes = ( types || \"\" ).match( rnothtmlwhite ) || [ \"\" ];\n\t\tt = types.length;\n\t\twhile ( t-- ) {\n\t\t\ttmp = rtypenamespace.exec( types[ t ] ) || [];\n\t\t\ttype = origType = tmp[ 1 ];\n\t\t\tnamespaces = ( tmp[ 2 ] || \"\" ).split( \".\" ).sort();\n\n\t\t\t// Unbind all events (on this namespace, if provided) for the element\n\t\t\tif ( !type ) {\n\t\t\t\tfor ( type in events ) {\n\t\t\t\t\tjQuery.event.remove( elem, type + types[ t ], handler, selector, true );\n\t\t\t\t}\n\t\t\t\tcontinue;\n\t\t\t}\n\n\t\t\tspecial = jQuery.event.special[ type ] || {};\n\t\t\ttype = ( selector ? special.delegateType : special.bindType ) || type;\n\t\t\thandlers = events[ type ] || [];\n\t\t\ttmp = tmp[ 2 ] &&\n\t\t\t\tnew RegExp( \"(^|\\\\.)\" + namespaces.join( \"\\\\.(?:.*\\\\.|)\" ) + \"(\\\\.|$)\" );\n\n\t\t\t// Remove matching events\n\t\t\torigCount = j = handlers.length;\n\t\t\twhile ( j-- ) {\n\t\t\t\thandleObj = handlers[ j ];\n\n\t\t\t\tif ( ( mappedTypes || origType === handleObj.origType ) &&\n\t\t\t\t\t( !handler || handler.guid === handleObj.guid ) &&\n\t\t\t\t\t( !tmp || tmp.test( handleObj.namespace ) ) &&\n\t\t\t\t\t( !selector || selector === handleObj.selector ||\n\t\t\t\t\t\tselector === \"**\" && handleObj.selector ) ) {\n\t\t\t\t\thandlers.splice( j, 1 );\n\n\t\t\t\t\tif ( handleObj.selector ) {\n\t\t\t\t\t\thandlers.delegateCount--;\n\t\t\t\t\t}\n\t\t\t\t\tif ( special.remove ) {\n\t\t\t\t\t\tspecial.remove.call( elem, handleObj );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Remove generic event handler if we removed something and no more handlers exist\n\t\t\t// (avoids potential for endless recursion during removal of special event handlers)\n\t\t\tif ( origCount && !handlers.length ) {\n\t\t\t\tif ( !special.teardown ||\n\t\t\t\t\tspecial.teardown.call( elem, namespaces, elemData.handle ) === false ) {\n\n\t\t\t\t\tjQuery.removeEvent( elem, type, elemData.handle );\n\t\t\t\t}\n\n\t\t\t\tdelete events[ type ];\n\t\t\t}\n\t\t}\n\n\t\t// Remove data and the expando if it's no longer used\n\t\tif ( jQuery.isEmptyObject( events ) ) {\n\t\t\tdataPriv.remove( elem, \"handle events\" );\n\t\t}\n\t},\n\n\tdispatch: function( nativeEvent ) {\n\n\t\t// Make a writable jQuery.Event from the native event object\n\t\tvar event = jQuery.event.fix( nativeEvent );\n\n\t\tvar i, j, ret, matched, handleObj, handlerQueue,\n\t\t\targs = new Array( arguments.length ),\n\t\t\thandlers = ( dataPriv.get( this, \"events\" ) || {} )[ event.type ] || [],\n\t\t\tspecial = jQuery.event.special[ event.type ] || {};\n\n\t\t// Use the fix-ed jQuery.Event rather than the (read-only) native event\n\t\targs[ 0 ] = event;\n\n\t\tfor ( i = 1; i < arguments.length; i++ ) {\n\t\t\targs[ i ] = arguments[ i ];\n\t\t}\n\n\t\tevent.delegateTarget = this;\n\n\t\t// Call the preDispatch hook for the mapped type, and let it bail if desired\n\t\tif ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Determine handlers\n\t\thandlerQueue = jQuery.event.handlers.call( this, event, handlers );\n\n\t\t// Run delegates first; they may want to stop propagation beneath us\n\t\ti = 0;\n\t\twhile ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {\n\t\t\tevent.currentTarget = matched.elem;\n\n\t\t\tj = 0;\n\t\t\twhile ( ( handleObj = matched.handlers[ j++ ] ) &&\n\t\t\t\t!event.isImmediatePropagationStopped() ) {\n\n\t\t\t\t// Triggered event must either 1) have no namespace, or 2) have namespace(s)\n\t\t\t\t// a subset or equal to those in the bound event (both can have no namespace).\n\t\t\t\tif ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {\n\n\t\t\t\t\tevent.handleObj = handleObj;\n\t\t\t\t\tevent.data = handleObj.data;\n\n\t\t\t\t\tret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||\n\t\t\t\t\t\thandleObj.handler ).apply( matched.elem, args );\n\n\t\t\t\t\tif ( ret !== undefined ) {\n\t\t\t\t\t\tif ( ( event.result = ret ) === false ) {\n\t\t\t\t\t\t\tevent.preventDefault();\n\t\t\t\t\t\t\tevent.stopPropagation();\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t// Call the postDispatch hook for the mapped type\n\t\tif ( special.postDispatch ) {\n\t\t\tspecial.postDispatch.call( this, event );\n\t\t}\n\n\t\treturn event.result;\n\t},\n\n\thandlers: function( event, handlers ) {\n\t\tvar i, handleObj, sel, matchedHandlers, matchedSelectors,\n\t\t\thandlerQueue = [],\n\t\t\tdelegateCount = handlers.delegateCount,\n\t\t\tcur = event.target;\n\n\t\t// Find delegate handlers\n\t\tif ( delegateCount &&\n\n\t\t\t// Support: IE <=9\n\t\t\t// Black-hole SVG <use> instance trees (trac-13180)\n\t\t\tcur.nodeType &&\n\n\t\t\t// Support: Firefox <=42\n\t\t\t// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)\n\t\t\t// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click\n\t\t\t// Support: IE 11 only\n\t\t\t// ...but not arrow key \"clicks\" of radio inputs, which can have `button` -1 (gh-2343)\n\t\t\t!( event.type === \"click\" && event.button >= 1 ) ) {\n\n\t\t\tfor ( ; cur !== this; cur = cur.parentNode || this ) {\n\n\t\t\t\t// Don't check non-elements (#13208)\n\t\t\t\t// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)\n\t\t\t\tif ( cur.nodeType === 1 && !( event.type === \"click\" && cur.disabled === true ) ) {\n\t\t\t\t\tmatchedHandlers = [];\n\t\t\t\t\tmatchedSelectors = {};\n\t\t\t\t\tfor ( i = 0; i < delegateCount; i++ ) {\n\t\t\t\t\t\thandleObj = handlers[ i ];\n\n\t\t\t\t\t\t// Don't conflict with Object.prototype properties (#13203)\n\t\t\t\t\t\tsel = handleObj.selector + \" \";\n\n\t\t\t\t\t\tif ( matchedSelectors[ sel ] === undefined ) {\n\t\t\t\t\t\t\tmatchedSelectors[ sel ] = handleObj.needsContext ?\n\t\t\t\t\t\t\t\tjQuery( sel, this ).index( cur ) > -1 :\n\t\t\t\t\t\t\t\tjQuery.find( sel, this, null, [ cur ] ).length;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tif ( matchedSelectors[ sel ] ) {\n\t\t\t\t\t\t\tmatchedHandlers.push( handleObj );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tif ( matchedHandlers.length ) {\n\t\t\t\t\t\thandlerQueue.push( { elem: cur, handlers: matchedHandlers } );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t// Add the remaining (directly-bound) handlers\n\t\tcur = this;\n\t\tif ( delegateCount < handlers.length ) {\n\t\t\thandlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );\n\t\t}\n\n\t\treturn handlerQueue;\n\t},\n\n\taddProp: function( name, hook ) {\n\t\tObject.defineProperty( jQuery.Event.prototype, name, {\n\t\t\tenumerable: true,\n\t\t\tconfigurable: true,\n\n\t\t\tget: jQuery.isFunction( hook ) ?\n\t\t\t\tfunction() {\n\t\t\t\t\tif ( this.originalEvent ) {\n\t\t\t\t\t\t\treturn hook( this.originalEvent );\n\t\t\t\t\t}\n\t\t\t\t} :\n\t\t\t\tfunction() {\n\t\t\t\t\tif ( this.originalEvent ) {\n\t\t\t\t\t\t\treturn this.originalEvent[ name ];\n\t\t\t\t\t}\n\t\t\t\t},\n\n\t\t\tset: function( value ) {\n\t\t\t\tObject.defineProperty( this, name, {\n\t\t\t\t\tenumerable: true,\n\t\t\t\t\tconfigurable: true,\n\t\t\t\t\twritable: true,\n\t\t\t\t\tvalue: value\n\t\t\t\t} );\n\t\t\t}\n\t\t} );\n\t},\n\n\tfix: function( originalEvent ) {\n\t\treturn originalEvent[ jQuery.expando ] ?\n\t\t\toriginalEvent :\n\t\t\tnew jQuery.Event( originalEvent );\n\t},\n\n\tspecial: {\n\t\tload: {\n\n\t\t\t// Prevent triggered image.load events from bubbling to window.load\n\t\t\tnoBubble: true\n\t\t},\n\t\tfocus: {\n\n\t\t\t// Fire native event if possible so blur/focus sequence is correct\n\t\t\ttrigger: function() {\n\t\t\t\tif ( this !== safeActiveElement() && this.focus ) {\n\t\t\t\t\tthis.focus();\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t},\n\t\t\tdelegateType: \"focusin\"\n\t\t},\n\t\tblur: {\n\t\t\ttrigger: function() {\n\t\t\t\tif ( this === safeActiveElement() && this.blur ) {\n\t\t\t\t\tthis.blur();\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t},\n\t\t\tdelegateType: \"focusout\"\n\t\t},\n\t\tclick: {\n\n\t\t\t// For checkbox, fire native event so checked state will be right\n\t\t\ttrigger: function() {\n\t\t\t\tif ( this.type === \"checkbox\" && this.click && nodeName( this, \"input\" ) ) {\n\t\t\t\t\tthis.click();\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t},\n\n\t\t\t// For cross-browser consistency, don't fire native .click() on links\n\t\t\t_default: function( event ) {\n\t\t\t\treturn nodeName( event.target, \"a\" );\n\t\t\t}\n\t\t},\n\n\t\tbeforeunload: {\n\t\t\tpostDispatch: function( event ) {\n\n\t\t\t\t// Support: Firefox 20+\n\t\t\t\t// Firefox doesn't alert if the returnValue field is not set.\n\t\t\t\tif ( event.result !== undefined && event.originalEvent ) {\n\t\t\t\t\tevent.originalEvent.returnValue = event.result;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n};\n\njQuery.removeEvent = function( elem, type, handle ) {\n\n\t// This \"if\" is needed for plain objects\n\tif ( elem.removeEventListener ) {\n\t\telem.removeEventListener( type, handle );\n\t}\n};\n\njQuery.Event = function( src, props ) {\n\n\t// Allow instantiation without the 'new' keyword\n\tif ( !( this instanceof jQuery.Event ) ) {\n\t\treturn new jQuery.Event( src, props );\n\t}\n\n\t// Event object\n\tif ( src && src.type ) {\n\t\tthis.originalEvent = src;\n\t\tthis.type = src.type;\n\n\t\t// Events bubbling up the document may have been marked as prevented\n\t\t// by a handler lower down the tree; reflect the correct value.\n\t\tthis.isDefaultPrevented = src.defaultPrevented ||\n\t\t\t\tsrc.defaultPrevented === undefined &&\n\n\t\t\t\t// Support: Android <=2.3 only\n\t\t\t\tsrc.returnValue === false ?\n\t\t\treturnTrue :\n\t\t\treturnFalse;\n\n\t\t// Create target properties\n\t\t// Support: Safari <=6 - 7 only\n\t\t// Target should not be a text node (#504, #13143)\n\t\tthis.target = ( src.target && src.target.nodeType === 3 ) ?\n\t\t\tsrc.target.parentNode :\n\t\t\tsrc.target;\n\n\t\tthis.currentTarget = src.currentTarget;\n\t\tthis.relatedTarget = src.relatedTarget;\n\n\t// Event type\n\t} else {\n\t\tthis.type = src;\n\t}\n\n\t// Put explicitly provided properties onto the event object\n\tif ( props ) {\n\t\tjQuery.extend( this, props );\n\t}\n\n\t// Create a timestamp if incoming event doesn't have one\n\tthis.timeStamp = src && src.timeStamp || jQuery.now();\n\n\t// Mark it as fixed\n\tthis[ jQuery.expando ] = true;\n};\n\n// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding\n// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html\njQuery.Event.prototype = {\n\tconstructor: jQuery.Event,\n\tisDefaultPrevented: returnFalse,\n\tisPropagationStopped: returnFalse,\n\tisImmediatePropagationStopped: returnFalse,\n\tisSimulated: false,\n\n\tpreventDefault: function() {\n\t\tvar e = this.originalEvent;\n\n\t\tthis.isDefaultPrevented = returnTrue;\n\n\t\tif ( e && !this.isSimulated ) {\n\t\t\te.preventDefault();\n\t\t}\n\t},\n\tstopPropagation: function() {\n\t\tvar e = this.originalEvent;\n\n\t\tthis.isPropagationStopped = returnTrue;\n\n\t\tif ( e && !this.isSimulated ) {\n\t\t\te.stopPropagation();\n\t\t}\n\t},\n\tstopImmediatePropagation: function() {\n\t\tvar e = this.originalEvent;\n\n\t\tthis.isImmediatePropagationStopped = returnTrue;\n\n\t\tif ( e && !this.isSimulated ) {\n\t\t\te.stopImmediatePropagation();\n\t\t}\n\n\t\tthis.stopPropagation();\n\t}\n};\n\n// Includes all common event props including KeyEvent and MouseEvent specific props\njQuery.each( {\n\taltKey: true,\n\tbubbles: true,\n\tcancelable: true,\n\tchangedTouches: true,\n\tctrlKey: true,\n\tdetail: true,\n\teventPhase: true,\n\tmetaKey: true,\n\tpageX: true,\n\tpageY: true,\n\tshiftKey: true,\n\tview: true,\n\t\"char\": true,\n\tcharCode: true,\n\tkey: true,\n\tkeyCode: true,\n\tbutton: true,\n\tbuttons: true,\n\tclientX: true,\n\tclientY: true,\n\toffsetX: true,\n\toffsetY: true,\n\tpointerId: true,\n\tpointerType: true,\n\tscreenX: true,\n\tscreenY: true,\n\ttargetTouches: true,\n\ttoElement: true,\n\ttouches: true,\n\n\twhich: function( event ) {\n\t\tvar button = event.button;\n\n\t\t// Add which for key events\n\t\tif ( event.which == null && rkeyEvent.test( event.type ) ) {\n\t\t\treturn event.charCode != null ? event.charCode : event.keyCode;\n\t\t}\n\n\t\t// Add which for click: 1 === left; 2 === middle; 3 === right\n\t\tif ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {\n\t\t\tif ( button & 1 ) {\n\t\t\t\treturn 1;\n\t\t\t}\n\n\t\t\tif ( button & 2 ) {\n\t\t\t\treturn 3;\n\t\t\t}\n\n\t\t\tif ( button & 4 ) {\n\t\t\t\treturn 2;\n\t\t\t}\n\n\t\t\treturn 0;\n\t\t}\n\n\t\treturn event.which;\n\t}\n}, jQuery.event.addProp );\n\n// Create mouseenter/leave events using mouseover/out and event-time checks\n// so that event delegation works in jQuery.\n// Do the same for pointerenter/pointerleave and pointerover/pointerout\n//\n// Support: Safari 7 only\n// Safari sends mouseenter too often; see:\n// https://bugs.chromium.org/p/chromium/issues/detail?id=470258\n// for the description of the bug (it existed in older Chrome versions as well).\njQuery.each( {\n\tmouseenter: \"mouseover\",\n\tmouseleave: \"mouseout\",\n\tpointerenter: \"pointerover\",\n\tpointerleave: \"pointerout\"\n}, function( orig, fix ) {\n\tjQuery.event.special[ orig ] = {\n\t\tdelegateType: fix,\n\t\tbindType: fix,\n\n\t\thandle: function( event ) {\n\t\t\tvar ret,\n\t\t\t\ttarget = this,\n\t\t\t\trelated = event.relatedTarget,\n\t\t\t\thandleObj = event.handleObj;\n\n\t\t\t// For mouseenter/leave call the handler if related is outside the target.\n\t\t\t// NB: No relatedTarget if the mouse left/entered the browser window\n\t\t\tif ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {\n\t\t\t\tevent.type = handleObj.origType;\n\t\t\t\tret = handleObj.handler.apply( this, arguments );\n\t\t\t\tevent.type = fix;\n\t\t\t}\n\t\t\treturn ret;\n\t\t}\n\t};\n} );\n\njQuery.fn.extend( {\n\n\ton: function( types, selector, data, fn ) {\n\t\treturn on( this, types, selector, data, fn );\n\t},\n\tone: function( types, selector, data, fn ) {\n\t\treturn on( this, types, selector, data, fn, 1 );\n\t},\n\toff: function( types, selector, fn ) {\n\t\tvar handleObj, type;\n\t\tif ( types && types.preventDefault && types.handleObj ) {\n\n\t\t\t// ( event )  dispatched jQuery.Event\n\t\t\thandleObj = types.handleObj;\n\t\t\tjQuery( types.delegateTarget ).off(\n\t\t\t\thandleObj.namespace ?\n\t\t\t\t\thandleObj.origType + \".\" + handleObj.namespace :\n\t\t\t\t\thandleObj.origType,\n\t\t\t\thandleObj.selector,\n\t\t\t\thandleObj.handler\n\t\t\t);\n\t\t\treturn this;\n\t\t}\n\t\tif ( typeof types === \"object\" ) {\n\n\t\t\t// ( types-object [, selector] )\n\t\t\tfor ( type in types ) {\n\t\t\t\tthis.off( type, selector, types[ type ] );\n\t\t\t}\n\t\t\treturn this;\n\t\t}\n\t\tif ( selector === false || typeof selector === \"function\" ) {\n\n\t\t\t// ( types [, fn] )\n\t\t\tfn = selector;\n\t\t\tselector = undefined;\n\t\t}\n\t\tif ( fn === false ) {\n\t\t\tfn = returnFalse;\n\t\t}\n\t\treturn this.each( function() {\n\t\t\tjQuery.event.remove( this, types, fn, selector );\n\t\t} );\n\t}\n} );\n\n\nvar\n\n\t/* eslint-disable max-len */\n\n\t// See https://github.com/eslint/eslint/issues/3229\n\trxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]*)[^>]*)\\/>/gi,\n\n\t/* eslint-enable */\n\n\t// Support: IE <=10 - 11, Edge 12 - 13\n\t// In IE/Edge using regex groups here causes severe slowdowns.\n\t// See https://connect.microsoft.com/IE/feedback/details/1736512/\n\trnoInnerhtml = /<script|<style|<link/i,\n\n\t// checked=\"checked\" or checked\n\trchecked = /checked\\s*(?:[^=]|=\\s*.checked.)/i,\n\trscriptTypeMasked = /^true\\/(.*)/,\n\trcleanScript = /^\\s*<!(?:\\[CDATA\\[|--)|(?:\\]\\]|--)>\\s*$/g;\n\n// Prefer a tbody over its parent table for containing new rows\nfunction manipulationTarget( elem, content ) {\n\tif ( nodeName( elem, \"table\" ) &&\n\t\tnodeName( content.nodeType !== 11 ? content : content.firstChild, \"tr\" ) ) {\n\n\t\treturn jQuery( \">tbody\", elem )[ 0 ] || elem;\n\t}\n\n\treturn elem;\n}\n\n// Replace/restore the type attribute of script elements for safe DOM manipulation\nfunction disableScript( elem ) {\n\telem.type = ( elem.getAttribute( \"type\" ) !== null ) + \"/\" + elem.type;\n\treturn elem;\n}\nfunction restoreScript( elem ) {\n\tvar match = rscriptTypeMasked.exec( elem.type );\n\n\tif ( match ) {\n\t\telem.type = match[ 1 ];\n\t} else {\n\t\telem.removeAttribute( \"type\" );\n\t}\n\n\treturn elem;\n}\n\nfunction cloneCopyEvent( src, dest ) {\n\tvar i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;\n\n\tif ( dest.nodeType !== 1 ) {\n\t\treturn;\n\t}\n\n\t// 1. Copy private data: events, handlers, etc.\n\tif ( dataPriv.hasData( src ) ) {\n\t\tpdataOld = dataPriv.access( src );\n\t\tpdataCur = dataPriv.set( dest, pdataOld );\n\t\tevents = pdataOld.events;\n\n\t\tif ( events ) {\n\t\t\tdelete pdataCur.handle;\n\t\t\tpdataCur.events = {};\n\n\t\t\tfor ( type in events ) {\n\t\t\t\tfor ( i = 0, l = events[ type ].length; i < l; i++ ) {\n\t\t\t\t\tjQuery.event.add( dest, type, events[ type ][ i ] );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// 2. Copy user data\n\tif ( dataUser.hasData( src ) ) {\n\t\tudataOld = dataUser.access( src );\n\t\tudataCur = jQuery.extend( {}, udataOld );\n\n\t\tdataUser.set( dest, udataCur );\n\t}\n}\n\n// Fix IE bugs, see support tests\nfunction fixInput( src, dest ) {\n\tvar nodeName = dest.nodeName.toLowerCase();\n\n\t// Fails to persist the checked state of a cloned checkbox or radio button.\n\tif ( nodeName === \"input\" && rcheckableType.test( src.type ) ) {\n\t\tdest.checked = src.checked;\n\n\t// Fails to return the selected option to the default selected state when cloning options\n\t} else if ( nodeName === \"input\" || nodeName === \"textarea\" ) {\n\t\tdest.defaultValue = src.defaultValue;\n\t}\n}\n\nfunction domManip( collection, args, callback, ignored ) {\n\n\t// Flatten any nested arrays\n\targs = concat.apply( [], args );\n\n\tvar fragment, first, scripts, hasScripts, node, doc,\n\t\ti = 0,\n\t\tl = collection.length,\n\t\tiNoClone = l - 1,\n\t\tvalue = args[ 0 ],\n\t\tisFunction = jQuery.isFunction( value );\n\n\t// We can't cloneNode fragments that contain checked, in WebKit\n\tif ( isFunction ||\n\t\t\t( l > 1 && typeof value === \"string\" &&\n\t\t\t\t!support.checkClone && rchecked.test( value ) ) ) {\n\t\treturn collection.each( function( index ) {\n\t\t\tvar self = collection.eq( index );\n\t\t\tif ( isFunction ) {\n\t\t\t\targs[ 0 ] = value.call( this, index, self.html() );\n\t\t\t}\n\t\t\tdomManip( self, args, callback, ignored );\n\t\t} );\n\t}\n\n\tif ( l ) {\n\t\tfragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );\n\t\tfirst = fragment.firstChild;\n\n\t\tif ( fragment.childNodes.length === 1 ) {\n\t\t\tfragment = first;\n\t\t}\n\n\t\t// Require either new content or an interest in ignored elements to invoke the callback\n\t\tif ( first || ignored ) {\n\t\t\tscripts = jQuery.map( getAll( fragment, \"script\" ), disableScript );\n\t\t\thasScripts = scripts.length;\n\n\t\t\t// Use the original fragment for the last item\n\t\t\t// instead of the first because it can end up\n\t\t\t// being emptied incorrectly in certain situations (#8070).\n\t\t\tfor ( ; i < l; i++ ) {\n\t\t\t\tnode = fragment;\n\n\t\t\t\tif ( i !== iNoClone ) {\n\t\t\t\t\tnode = jQuery.clone( node, true, true );\n\n\t\t\t\t\t// Keep references to cloned scripts for later restoration\n\t\t\t\t\tif ( hasScripts ) {\n\n\t\t\t\t\t\t// Support: Android <=4.0 only, PhantomJS 1 only\n\t\t\t\t\t\t// push.apply(_, arraylike) throws on ancient WebKit\n\t\t\t\t\t\tjQuery.merge( scripts, getAll( node, \"script\" ) );\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tcallback.call( collection[ i ], node, i );\n\t\t\t}\n\n\t\t\tif ( hasScripts ) {\n\t\t\t\tdoc = scripts[ scripts.length - 1 ].ownerDocument;\n\n\t\t\t\t// Reenable scripts\n\t\t\t\tjQuery.map( scripts, restoreScript );\n\n\t\t\t\t// Evaluate executable scripts on first document insertion\n\t\t\t\tfor ( i = 0; i < hasScripts; i++ ) {\n\t\t\t\t\tnode = scripts[ i ];\n\t\t\t\t\tif ( rscriptType.test( node.type || \"\" ) &&\n\t\t\t\t\t\t!dataPriv.access( node, \"globalEval\" ) &&\n\t\t\t\t\t\tjQuery.contains( doc, node ) ) {\n\n\t\t\t\t\t\tif ( node.src ) {\n\n\t\t\t\t\t\t\t// Optional AJAX dependency, but won't run scripts if not present\n\t\t\t\t\t\t\tif ( jQuery._evalUrl ) {\n\t\t\t\t\t\t\t\tjQuery._evalUrl( node.src );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tDOMEval( node.textContent.replace( rcleanScript, \"\" ), doc );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\treturn collection;\n}\n\nfunction remove( elem, selector, keepData ) {\n\tvar node,\n\t\tnodes = selector ? jQuery.filter( selector, elem ) : elem,\n\t\ti = 0;\n\n\tfor ( ; ( node = nodes[ i ] ) != null; i++ ) {\n\t\tif ( !keepData && node.nodeType === 1 ) {\n\t\t\tjQuery.cleanData( getAll( node ) );\n\t\t}\n\n\t\tif ( node.parentNode ) {\n\t\t\tif ( keepData && jQuery.contains( node.ownerDocument, node ) ) {\n\t\t\t\tsetGlobalEval( getAll( node, \"script\" ) );\n\t\t\t}\n\t\t\tnode.parentNode.removeChild( node );\n\t\t}\n\t}\n\n\treturn elem;\n}\n\njQuery.extend( {\n\thtmlPrefilter: function( html ) {\n\t\treturn html.replace( rxhtmlTag, \"<$1></$2>\" );\n\t},\n\n\tclone: function( elem, dataAndEvents, deepDataAndEvents ) {\n\t\tvar i, l, srcElements, destElements,\n\t\t\tclone = elem.cloneNode( true ),\n\t\t\tinPage = jQuery.contains( elem.ownerDocument, elem );\n\n\t\t// Fix IE cloning issues\n\t\tif ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&\n\t\t\t\t!jQuery.isXMLDoc( elem ) ) {\n\n\t\t\t// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2\n\t\t\tdestElements = getAll( clone );\n\t\t\tsrcElements = getAll( elem );\n\n\t\t\tfor ( i = 0, l = srcElements.length; i < l; i++ ) {\n\t\t\t\tfixInput( srcElements[ i ], destElements[ i ] );\n\t\t\t}\n\t\t}\n\n\t\t// Copy the events from the original to the clone\n\t\tif ( dataAndEvents ) {\n\t\t\tif ( deepDataAndEvents ) {\n\t\t\t\tsrcElements = srcElements || getAll( elem );\n\t\t\t\tdestElements = destElements || getAll( clone );\n\n\t\t\t\tfor ( i = 0, l = srcElements.length; i < l; i++ ) {\n\t\t\t\t\tcloneCopyEvent( srcElements[ i ], destElements[ i ] );\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\tcloneCopyEvent( elem, clone );\n\t\t\t}\n\t\t}\n\n\t\t// Preserve script evaluation history\n\t\tdestElements = getAll( clone, \"script\" );\n\t\tif ( destElements.length > 0 ) {\n\t\t\tsetGlobalEval( destElements, !inPage && getAll( elem, \"script\" ) );\n\t\t}\n\n\t\t// Return the cloned set\n\t\treturn clone;\n\t},\n\n\tcleanData: function( elems ) {\n\t\tvar data, elem, type,\n\t\t\tspecial = jQuery.event.special,\n\t\t\ti = 0;\n\n\t\tfor ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {\n\t\t\tif ( acceptData( elem ) ) {\n\t\t\t\tif ( ( data = elem[ dataPriv.expando ] ) ) {\n\t\t\t\t\tif ( data.events ) {\n\t\t\t\t\t\tfor ( type in data.events ) {\n\t\t\t\t\t\t\tif ( special[ type ] ) {\n\t\t\t\t\t\t\t\tjQuery.event.remove( elem, type );\n\n\t\t\t\t\t\t\t// This is a shortcut to avoid jQuery.event.remove's overhead\n\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\tjQuery.removeEvent( elem, type, data.handle );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t// Support: Chrome <=35 - 45+\n\t\t\t\t\t// Assign undefined instead of using delete, see Data#remove\n\t\t\t\t\telem[ dataPriv.expando ] = undefined;\n\t\t\t\t}\n\t\t\t\tif ( elem[ dataUser.expando ] ) {\n\n\t\t\t\t\t// Support: Chrome <=35 - 45+\n\t\t\t\t\t// Assign undefined instead of using delete, see Data#remove\n\t\t\t\t\telem[ dataUser.expando ] = undefined;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n} );\n\njQuery.fn.extend( {\n\tdetach: function( selector ) {\n\t\treturn remove( this, selector, true );\n\t},\n\n\tremove: function( selector ) {\n\t\treturn remove( this, selector );\n\t},\n\n\ttext: function( value ) {\n\t\treturn access( this, function( value ) {\n\t\t\treturn value === undefined ?\n\t\t\t\tjQuery.text( this ) :\n\t\t\t\tthis.empty().each( function() {\n\t\t\t\t\tif ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {\n\t\t\t\t\t\tthis.textContent = value;\n\t\t\t\t\t}\n\t\t\t\t} );\n\t\t}, null, value, arguments.length );\n\t},\n\n\tappend: function() {\n\t\treturn domManip( this, arguments, function( elem ) {\n\t\t\tif ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {\n\t\t\t\tvar target = manipulationTarget( this, elem );\n\t\t\t\ttarget.appendChild( elem );\n\t\t\t}\n\t\t} );\n\t},\n\n\tprepend: function() {\n\t\treturn domManip( this, arguments, function( elem ) {\n\t\t\tif ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {\n\t\t\t\tvar target = manipulationTarget( this, elem );\n\t\t\t\ttarget.insertBefore( elem, target.firstChild );\n\t\t\t}\n\t\t} );\n\t},\n\n\tbefore: function() {\n\t\treturn domManip( this, arguments, function( elem ) {\n\t\t\tif ( this.parentNode ) {\n\t\t\t\tthis.parentNode.insertBefore( elem, this );\n\t\t\t}\n\t\t} );\n\t},\n\n\tafter: function() {\n\t\treturn domManip( this, arguments, function( elem ) {\n\t\t\tif ( this.parentNode ) {\n\t\t\t\tthis.parentNode.insertBefore( elem, this.nextSibling );\n\t\t\t}\n\t\t} );\n\t},\n\n\tempty: function() {\n\t\tvar elem,\n\t\t\ti = 0;\n\n\t\tfor ( ; ( elem = this[ i ] ) != null; i++ ) {\n\t\t\tif ( elem.nodeType === 1 ) {\n\n\t\t\t\t// Prevent memory leaks\n\t\t\t\tjQuery.cleanData( getAll( elem, false ) );\n\n\t\t\t\t// Remove any remaining nodes\n\t\t\t\telem.textContent = \"\";\n\t\t\t}\n\t\t}\n\n\t\treturn this;\n\t},\n\n\tclone: function( dataAndEvents, deepDataAndEvents ) {\n\t\tdataAndEvents = dataAndEvents == null ? false : dataAndEvents;\n\t\tdeepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;\n\n\t\treturn this.map( function() {\n\t\t\treturn jQuery.clone( this, dataAndEvents, deepDataAndEvents );\n\t\t} );\n\t},\n\n\thtml: function( value ) {\n\t\treturn access( this, function( value ) {\n\t\t\tvar elem = this[ 0 ] || {},\n\t\t\t\ti = 0,\n\t\t\t\tl = this.length;\n\n\t\t\tif ( value === undefined && elem.nodeType === 1 ) {\n\t\t\t\treturn elem.innerHTML;\n\t\t\t}\n\n\t\t\t// See if we can take a shortcut and just use innerHTML\n\t\t\tif ( typeof value === \"string\" && !rnoInnerhtml.test( value ) &&\n\t\t\t\t!wrapMap[ ( rtagName.exec( value ) || [ \"\", \"\" ] )[ 1 ].toLowerCase() ] ) {\n\n\t\t\t\tvalue = jQuery.htmlPrefilter( value );\n\n\t\t\t\ttry {\n\t\t\t\t\tfor ( ; i < l; i++ ) {\n\t\t\t\t\t\telem = this[ i ] || {};\n\n\t\t\t\t\t\t// Remove element nodes and prevent memory leaks\n\t\t\t\t\t\tif ( elem.nodeType === 1 ) {\n\t\t\t\t\t\t\tjQuery.cleanData( getAll( elem, false ) );\n\t\t\t\t\t\t\telem.innerHTML = value;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\telem = 0;\n\n\t\t\t\t// If using innerHTML throws an exception, use the fallback method\n\t\t\t\t} catch ( e ) {}\n\t\t\t}\n\n\t\t\tif ( elem ) {\n\t\t\t\tthis.empty().append( value );\n\t\t\t}\n\t\t}, null, value, arguments.length );\n\t},\n\n\treplaceWith: function() {\n\t\tvar ignored = [];\n\n\t\t// Make the changes, replacing each non-ignored context element with the new content\n\t\treturn domManip( this, arguments, function( elem ) {\n\t\t\tvar parent = this.parentNode;\n\n\t\t\tif ( jQuery.inArray( this, ignored ) < 0 ) {\n\t\t\t\tjQuery.cleanData( getAll( this ) );\n\t\t\t\tif ( parent ) {\n\t\t\t\t\tparent.replaceChild( elem, this );\n\t\t\t\t}\n\t\t\t}\n\n\t\t// Force callback invocation\n\t\t}, ignored );\n\t}\n} );\n\njQuery.each( {\n\tappendTo: \"append\",\n\tprependTo: \"prepend\",\n\tinsertBefore: \"before\",\n\tinsertAfter: \"after\",\n\treplaceAll: \"replaceWith\"\n}, function( name, original ) {\n\tjQuery.fn[ name ] = function( selector ) {\n\t\tvar elems,\n\t\t\tret = [],\n\t\t\tinsert = jQuery( selector ),\n\t\t\tlast = insert.length - 1,\n\t\t\ti = 0;\n\n\t\tfor ( ; i <= last; i++ ) {\n\t\t\telems = i === last ? this : this.clone( true );\n\t\t\tjQuery( insert[ i ] )[ original ]( elems );\n\n\t\t\t// Support: Android <=4.0 only, PhantomJS 1 only\n\t\t\t// .get() because push.apply(_, arraylike) throws on ancient WebKit\n\t\t\tpush.apply( ret, elems.get() );\n\t\t}\n\n\t\treturn this.pushStack( ret );\n\t};\n} );\nvar rmargin = ( /^margin/ );\n\nvar rnumnonpx = new RegExp( \"^(\" + pnum + \")(?!px)[a-z%]+$\", \"i\" );\n\nvar getStyles = function( elem ) {\n\n\t\t// Support: IE <=11 only, Firefox <=30 (#15098, #14150)\n\t\t// IE throws on elements created in popups\n\t\t// FF meanwhile throws on frame elements through \"defaultView.getComputedStyle\"\n\t\tvar view = elem.ownerDocument.defaultView;\n\n\t\tif ( !view || !view.opener ) {\n\t\t\tview = window;\n\t\t}\n\n\t\treturn view.getComputedStyle( elem );\n\t};\n\n\n\n( function() {\n\n\t// Executing both pixelPosition & boxSizingReliable tests require only one layout\n\t// so they're executed at the same time to save the second computation.\n\tfunction computeStyleTests() {\n\n\t\t// This is a singleton, we need to execute it only once\n\t\tif ( !div ) {\n\t\t\treturn;\n\t\t}\n\n\t\tdiv.style.cssText =\n\t\t\t\"box-sizing:border-box;\" +\n\t\t\t\"position:relative;display:block;\" +\n\t\t\t\"margin:auto;border:1px;padding:1px;\" +\n\t\t\t\"top:1%;width:50%\";\n\t\tdiv.innerHTML = \"\";\n\t\tdocumentElement.appendChild( container );\n\n\t\tvar divStyle = window.getComputedStyle( div );\n\t\tpixelPositionVal = divStyle.top !== \"1%\";\n\n\t\t// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44\n\t\treliableMarginLeftVal = divStyle.marginLeft === \"2px\";\n\t\tboxSizingReliableVal = divStyle.width === \"4px\";\n\n\t\t// Support: Android 4.0 - 4.3 only\n\t\t// Some styles come back with percentage values, even though they shouldn't\n\t\tdiv.style.marginRight = \"50%\";\n\t\tpixelMarginRightVal = divStyle.marginRight === \"4px\";\n\n\t\tdocumentElement.removeChild( container );\n\n\t\t// Nullify the div so it wouldn't be stored in the memory and\n\t\t// it will also be a sign that checks already performed\n\t\tdiv = null;\n\t}\n\n\tvar pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,\n\t\tcontainer = document.createElement( \"div\" ),\n\t\tdiv = document.createElement( \"div\" );\n\n\t// Finish early in limited (non-browser) environments\n\tif ( !div.style ) {\n\t\treturn;\n\t}\n\n\t// Support: IE <=9 - 11 only\n\t// Style of cloned element affects source element cloned (#8908)\n\tdiv.style.backgroundClip = \"content-box\";\n\tdiv.cloneNode( true ).style.backgroundClip = \"\";\n\tsupport.clearCloneStyle = div.style.backgroundClip === \"content-box\";\n\n\tcontainer.style.cssText = \"border:0;width:8px;height:0;top:0;left:-9999px;\" +\n\t\t\"padding:0;margin-top:1px;position:absolute\";\n\tcontainer.appendChild( div );\n\n\tjQuery.extend( support, {\n\t\tpixelPosition: function() {\n\t\t\tcomputeStyleTests();\n\t\t\treturn pixelPositionVal;\n\t\t},\n\t\tboxSizingReliable: function() {\n\t\t\tcomputeStyleTests();\n\t\t\treturn boxSizingReliableVal;\n\t\t},\n\t\tpixelMarginRight: function() {\n\t\t\tcomputeStyleTests();\n\t\t\treturn pixelMarginRightVal;\n\t\t},\n\t\treliableMarginLeft: function() {\n\t\t\tcomputeStyleTests();\n\t\t\treturn reliableMarginLeftVal;\n\t\t}\n\t} );\n} )();\n\n\nfunction curCSS( elem, name, computed ) {\n\tvar width, minWidth, maxWidth, ret,\n\n\t\t// Support: Firefox 51+\n\t\t// Retrieving style before computed somehow\n\t\t// fixes an issue with getting wrong values\n\t\t// on detached elements\n\t\tstyle = elem.style;\n\n\tcomputed = computed || getStyles( elem );\n\n\t// getPropertyValue is needed for:\n\t//   .css('filter') (IE 9 only, #12537)\n\t//   .css('--customProperty) (#3144)\n\tif ( computed ) {\n\t\tret = computed.getPropertyValue( name ) || computed[ name ];\n\n\t\tif ( ret === \"\" && !jQuery.contains( elem.ownerDocument, elem ) ) {\n\t\t\tret = jQuery.style( elem, name );\n\t\t}\n\n\t\t// A tribute to the \"awesome hack by Dean Edwards\"\n\t\t// Android Browser returns percentage for some values,\n\t\t// but width seems to be reliably pixels.\n\t\t// This is against the CSSOM draft spec:\n\t\t// https://drafts.csswg.org/cssom/#resolved-values\n\t\tif ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {\n\n\t\t\t// Remember the original values\n\t\t\twidth = style.width;\n\t\t\tminWidth = style.minWidth;\n\t\t\tmaxWidth = style.maxWidth;\n\n\t\t\t// Put in the new values to get a computed value out\n\t\t\tstyle.minWidth = style.maxWidth = style.width = ret;\n\t\t\tret = computed.width;\n\n\t\t\t// Revert the changed values\n\t\t\tstyle.width = width;\n\t\t\tstyle.minWidth = minWidth;\n\t\t\tstyle.maxWidth = maxWidth;\n\t\t}\n\t}\n\n\treturn ret !== undefined ?\n\n\t\t// Support: IE <=9 - 11 only\n\t\t// IE returns zIndex value as an integer.\n\t\tret + \"\" :\n\t\tret;\n}\n\n\nfunction addGetHookIf( conditionFn, hookFn ) {\n\n\t// Define the hook, we'll check on the first run if it's really needed.\n\treturn {\n\t\tget: function() {\n\t\t\tif ( conditionFn() ) {\n\n\t\t\t\t// Hook not needed (or it's not possible to use it due\n\t\t\t\t// to missing dependency), remove it.\n\t\t\t\tdelete this.get;\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\t// Hook needed; redefine it so that the support test is not executed again.\n\t\t\treturn ( this.get = hookFn ).apply( this, arguments );\n\t\t}\n\t};\n}\n\n\nvar\n\n\t// Swappable if display is none or starts with table\n\t// except \"table\", \"table-cell\", or \"table-caption\"\n\t// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display\n\trdisplayswap = /^(none|table(?!-c[ea]).+)/,\n\trcustomProp = /^--/,\n\tcssShow = { position: \"absolute\", visibility: \"hidden\", display: \"block\" },\n\tcssNormalTransform = {\n\t\tletterSpacing: \"0\",\n\t\tfontWeight: \"400\"\n\t},\n\n\tcssPrefixes = [ \"Webkit\", \"Moz\", \"ms\" ],\n\temptyStyle = document.createElement( \"div\" ).style;\n\n// Return a css property mapped to a potentially vendor prefixed property\nfunction vendorPropName( name ) {\n\n\t// Shortcut for names that are not vendor prefixed\n\tif ( name in emptyStyle ) {\n\t\treturn name;\n\t}\n\n\t// Check for vendor prefixed names\n\tvar capName = name[ 0 ].toUpperCase() + name.slice( 1 ),\n\t\ti = cssPrefixes.length;\n\n\twhile ( i-- ) {\n\t\tname = cssPrefixes[ i ] + capName;\n\t\tif ( name in emptyStyle ) {\n\t\t\treturn name;\n\t\t}\n\t}\n}\n\n// Return a property mapped along what jQuery.cssProps suggests or to\n// a vendor prefixed property.\nfunction finalPropName( name ) {\n\tvar ret = jQuery.cssProps[ name ];\n\tif ( !ret ) {\n\t\tret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;\n\t}\n\treturn ret;\n}\n\nfunction setPositiveNumber( elem, value, subtract ) {\n\n\t// Any relative (+/-) values have already been\n\t// normalized at this point\n\tvar matches = rcssNum.exec( value );\n\treturn matches ?\n\n\t\t// Guard against undefined \"subtract\", e.g., when used as in cssHooks\n\t\tMath.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || \"px\" ) :\n\t\tvalue;\n}\n\nfunction augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {\n\tvar i,\n\t\tval = 0;\n\n\t// If we already have the right measurement, avoid augmentation\n\tif ( extra === ( isBorderBox ? \"border\" : \"content\" ) ) {\n\t\ti = 4;\n\n\t// Otherwise initialize for horizontal or vertical properties\n\t} else {\n\t\ti = name === \"width\" ? 1 : 0;\n\t}\n\n\tfor ( ; i < 4; i += 2 ) {\n\n\t\t// Both box models exclude margin, so add it if we want it\n\t\tif ( extra === \"margin\" ) {\n\t\t\tval += jQuery.css( elem, extra + cssExpand[ i ], true, styles );\n\t\t}\n\n\t\tif ( isBorderBox ) {\n\n\t\t\t// border-box includes padding, so remove it if we want content\n\t\t\tif ( extra === \"content\" ) {\n\t\t\t\tval -= jQuery.css( elem, \"padding\" + cssExpand[ i ], true, styles );\n\t\t\t}\n\n\t\t\t// At this point, extra isn't border nor margin, so remove border\n\t\t\tif ( extra !== \"margin\" ) {\n\t\t\t\tval -= jQuery.css( elem, \"border\" + cssExpand[ i ] + \"Width\", true, styles );\n\t\t\t}\n\t\t} else {\n\n\t\t\t// At this point, extra isn't content, so add padding\n\t\t\tval += jQuery.css( elem, \"padding\" + cssExpand[ i ], true, styles );\n\n\t\t\t// At this point, extra isn't content nor padding, so add border\n\t\t\tif ( extra !== \"padding\" ) {\n\t\t\t\tval += jQuery.css( elem, \"border\" + cssExpand[ i ] + \"Width\", true, styles );\n\t\t\t}\n\t\t}\n\t}\n\n\treturn val;\n}\n\nfunction getWidthOrHeight( elem, name, extra ) {\n\n\t// Start with computed style\n\tvar valueIsBorderBox,\n\t\tstyles = getStyles( elem ),\n\t\tval = curCSS( elem, name, styles ),\n\t\tisBorderBox = jQuery.css( elem, \"boxSizing\", false, styles ) === \"border-box\";\n\n\t// Computed unit is not pixels. Stop here and return.\n\tif ( rnumnonpx.test( val ) ) {\n\t\treturn val;\n\t}\n\n\t// Check for style in case a browser which returns unreliable values\n\t// for getComputedStyle silently falls back to the reliable elem.style\n\tvalueIsBorderBox = isBorderBox &&\n\t\t( support.boxSizingReliable() || val === elem.style[ name ] );\n\n\t// Fall back to offsetWidth/Height when value is \"auto\"\n\t// This happens for inline elements with no explicit setting (gh-3571)\n\tif ( val === \"auto\" ) {\n\t\tval = elem[ \"offset\" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];\n\t}\n\n\t// Normalize \"\", auto, and prepare for extra\n\tval = parseFloat( val ) || 0;\n\n\t// Use the active box-sizing model to add/subtract irrelevant styles\n\treturn ( val +\n\t\taugmentWidthOrHeight(\n\t\t\telem,\n\t\t\tname,\n\t\t\textra || ( isBorderBox ? \"border\" : \"content\" ),\n\t\t\tvalueIsBorderBox,\n\t\t\tstyles\n\t\t)\n\t) + \"px\";\n}\n\njQuery.extend( {\n\n\t// Add in style property hooks for overriding the default\n\t// behavior of getting and setting a style property\n\tcssHooks: {\n\t\topacity: {\n\t\t\tget: function( elem, computed ) {\n\t\t\t\tif ( computed ) {\n\n\t\t\t\t\t// We should always get a number back from opacity\n\t\t\t\t\tvar ret = curCSS( elem, \"opacity\" );\n\t\t\t\t\treturn ret === \"\" ? \"1\" : ret;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t},\n\n\t// Don't automatically add \"px\" to these possibly-unitless properties\n\tcssNumber: {\n\t\t\"animationIterationCount\": true,\n\t\t\"columnCount\": true,\n\t\t\"fillOpacity\": true,\n\t\t\"flexGrow\": true,\n\t\t\"flexShrink\": true,\n\t\t\"fontWeight\": true,\n\t\t\"lineHeight\": true,\n\t\t\"opacity\": true,\n\t\t\"order\": true,\n\t\t\"orphans\": true,\n\t\t\"widows\": true,\n\t\t\"zIndex\": true,\n\t\t\"zoom\": true\n\t},\n\n\t// Add in properties whose names you wish to fix before\n\t// setting or getting the value\n\tcssProps: {\n\t\t\"float\": \"cssFloat\"\n\t},\n\n\t// Get and set the style property on a DOM Node\n\tstyle: function( elem, name, value, extra ) {\n\n\t\t// Don't set styles on text and comment nodes\n\t\tif ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Make sure that we're working with the right name\n\t\tvar ret, type, hooks,\n\t\t\torigName = jQuery.camelCase( name ),\n\t\t\tisCustomProp = rcustomProp.test( name ),\n\t\t\tstyle = elem.style;\n\n\t\t// Make sure that we're working with the right name. We don't\n\t\t// want to query the value if it is a CSS custom property\n\t\t// since they are user-defined.\n\t\tif ( !isCustomProp ) {\n\t\t\tname = finalPropName( origName );\n\t\t}\n\n\t\t// Gets hook for the prefixed version, then unprefixed version\n\t\thooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];\n\n\t\t// Check if we're setting a value\n\t\tif ( value !== undefined ) {\n\t\t\ttype = typeof value;\n\n\t\t\t// Convert \"+=\" or \"-=\" to relative numbers (#7345)\n\t\t\tif ( type === \"string\" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {\n\t\t\t\tvalue = adjustCSS( elem, name, ret );\n\n\t\t\t\t// Fixes bug #9237\n\t\t\t\ttype = \"number\";\n\t\t\t}\n\n\t\t\t// Make sure that null and NaN values aren't set (#7116)\n\t\t\tif ( value == null || value !== value ) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\t// If a number was passed in, add the unit (except for certain CSS properties)\n\t\t\tif ( type === \"number\" ) {\n\t\t\t\tvalue += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? \"\" : \"px\" );\n\t\t\t}\n\n\t\t\t// background-* props affect original clone's values\n\t\t\tif ( !support.clearCloneStyle && value === \"\" && name.indexOf( \"background\" ) === 0 ) {\n\t\t\t\tstyle[ name ] = \"inherit\";\n\t\t\t}\n\n\t\t\t// If a hook was provided, use that value, otherwise just set the specified value\n\t\t\tif ( !hooks || !( \"set\" in hooks ) ||\n\t\t\t\t( value = hooks.set( elem, value, extra ) ) !== undefined ) {\n\n\t\t\t\tif ( isCustomProp ) {\n\t\t\t\t\tstyle.setProperty( name, value );\n\t\t\t\t} else {\n\t\t\t\t\tstyle[ name ] = value;\n\t\t\t\t}\n\t\t\t}\n\n\t\t} else {\n\n\t\t\t// If a hook was provided get the non-computed value from there\n\t\t\tif ( hooks && \"get\" in hooks &&\n\t\t\t\t( ret = hooks.get( elem, false, extra ) ) !== undefined ) {\n\n\t\t\t\treturn ret;\n\t\t\t}\n\n\t\t\t// Otherwise just get the value from the style object\n\t\t\treturn style[ name ];\n\t\t}\n\t},\n\n\tcss: function( elem, name, extra, styles ) {\n\t\tvar val, num, hooks,\n\t\t\torigName = jQuery.camelCase( name ),\n\t\t\tisCustomProp = rcustomProp.test( name );\n\n\t\t// Make sure that we're working with the right name. We don't\n\t\t// want to modify the value if it is a CSS custom property\n\t\t// since they are user-defined.\n\t\tif ( !isCustomProp ) {\n\t\t\tname = finalPropName( origName );\n\t\t}\n\n\t\t// Try prefixed name followed by the unprefixed name\n\t\thooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];\n\n\t\t// If a hook was provided get the computed value from there\n\t\tif ( hooks && \"get\" in hooks ) {\n\t\t\tval = hooks.get( elem, true, extra );\n\t\t}\n\n\t\t// Otherwise, if a way to get the computed value exists, use that\n\t\tif ( val === undefined ) {\n\t\t\tval = curCSS( elem, name, styles );\n\t\t}\n\n\t\t// Convert \"normal\" to computed value\n\t\tif ( val === \"normal\" && name in cssNormalTransform ) {\n\t\t\tval = cssNormalTransform[ name ];\n\t\t}\n\n\t\t// Make numeric if forced or a qualifier was provided and val looks numeric\n\t\tif ( extra === \"\" || extra ) {\n\t\t\tnum = parseFloat( val );\n\t\t\treturn extra === true || isFinite( num ) ? num || 0 : val;\n\t\t}\n\n\t\treturn val;\n\t}\n} );\n\njQuery.each( [ \"height\", \"width\" ], function( i, name ) {\n\tjQuery.cssHooks[ name ] = {\n\t\tget: function( elem, computed, extra ) {\n\t\t\tif ( computed ) {\n\n\t\t\t\t// Certain elements can have dimension info if we invisibly show them\n\t\t\t\t// but it must have a current display style that would benefit\n\t\t\t\treturn rdisplayswap.test( jQuery.css( elem, \"display\" ) ) &&\n\n\t\t\t\t\t// Support: Safari 8+\n\t\t\t\t\t// Table columns in Safari have non-zero offsetWidth & zero\n\t\t\t\t\t// getBoundingClientRect().width unless display is changed.\n\t\t\t\t\t// Support: IE <=11 only\n\t\t\t\t\t// Running getBoundingClientRect on a disconnected node\n\t\t\t\t\t// in IE throws an error.\n\t\t\t\t\t( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?\n\t\t\t\t\t\tswap( elem, cssShow, function() {\n\t\t\t\t\t\t\treturn getWidthOrHeight( elem, name, extra );\n\t\t\t\t\t\t} ) :\n\t\t\t\t\t\tgetWidthOrHeight( elem, name, extra );\n\t\t\t}\n\t\t},\n\n\t\tset: function( elem, value, extra ) {\n\t\t\tvar matches,\n\t\t\t\tstyles = extra && getStyles( elem ),\n\t\t\t\tsubtract = extra && augmentWidthOrHeight(\n\t\t\t\t\telem,\n\t\t\t\t\tname,\n\t\t\t\t\textra,\n\t\t\t\t\tjQuery.css( elem, \"boxSizing\", false, styles ) === \"border-box\",\n\t\t\t\t\tstyles\n\t\t\t\t);\n\n\t\t\t// Convert to pixels if value adjustment is needed\n\t\t\tif ( subtract && ( matches = rcssNum.exec( value ) ) &&\n\t\t\t\t( matches[ 3 ] || \"px\" ) !== \"px\" ) {\n\n\t\t\t\telem.style[ name ] = value;\n\t\t\t\tvalue = jQuery.css( elem, name );\n\t\t\t}\n\n\t\t\treturn setPositiveNumber( elem, value, subtract );\n\t\t}\n\t};\n} );\n\njQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,\n\tfunction( elem, computed ) {\n\t\tif ( computed ) {\n\t\t\treturn ( parseFloat( curCSS( elem, \"marginLeft\" ) ) ||\n\t\t\t\telem.getBoundingClientRect().left -\n\t\t\t\t\tswap( elem, { marginLeft: 0 }, function() {\n\t\t\t\t\t\treturn elem.getBoundingClientRect().left;\n\t\t\t\t\t} )\n\t\t\t\t) + \"px\";\n\t\t}\n\t}\n);\n\n// These hooks are used by animate to expand properties\njQuery.each( {\n\tmargin: \"\",\n\tpadding: \"\",\n\tborder: \"Width\"\n}, function( prefix, suffix ) {\n\tjQuery.cssHooks[ prefix + suffix ] = {\n\t\texpand: function( value ) {\n\t\t\tvar i = 0,\n\t\t\t\texpanded = {},\n\n\t\t\t\t// Assumes a single number if not a string\n\t\t\t\tparts = typeof value === \"string\" ? value.split( \" \" ) : [ value ];\n\n\t\t\tfor ( ; i < 4; i++ ) {\n\t\t\t\texpanded[ prefix + cssExpand[ i ] + suffix ] =\n\t\t\t\t\tparts[ i ] || parts[ i - 2 ] || parts[ 0 ];\n\t\t\t}\n\n\t\t\treturn expanded;\n\t\t}\n\t};\n\n\tif ( !rmargin.test( prefix ) ) {\n\t\tjQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;\n\t}\n} );\n\njQuery.fn.extend( {\n\tcss: function( name, value ) {\n\t\treturn access( this, function( elem, name, value ) {\n\t\t\tvar styles, len,\n\t\t\t\tmap = {},\n\t\t\t\ti = 0;\n\n\t\t\tif ( Array.isArray( name ) ) {\n\t\t\t\tstyles = getStyles( elem );\n\t\t\t\tlen = name.length;\n\n\t\t\t\tfor ( ; i < len; i++ ) {\n\t\t\t\t\tmap[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );\n\t\t\t\t}\n\n\t\t\t\treturn map;\n\t\t\t}\n\n\t\t\treturn value !== undefined ?\n\t\t\t\tjQuery.style( elem, name, value ) :\n\t\t\t\tjQuery.css( elem, name );\n\t\t}, name, value, arguments.length > 1 );\n\t}\n} );\n\n\nfunction Tween( elem, options, prop, end, easing ) {\n\treturn new Tween.prototype.init( elem, options, prop, end, easing );\n}\njQuery.Tween = Tween;\n\nTween.prototype = {\n\tconstructor: Tween,\n\tinit: function( elem, options, prop, end, easing, unit ) {\n\t\tthis.elem = elem;\n\t\tthis.prop = prop;\n\t\tthis.easing = easing || jQuery.easing._default;\n\t\tthis.options = options;\n\t\tthis.start = this.now = this.cur();\n\t\tthis.end = end;\n\t\tthis.unit = unit || ( jQuery.cssNumber[ prop ] ? \"\" : \"px\" );\n\t},\n\tcur: function() {\n\t\tvar hooks = Tween.propHooks[ this.prop ];\n\n\t\treturn hooks && hooks.get ?\n\t\t\thooks.get( this ) :\n\t\t\tTween.propHooks._default.get( this );\n\t},\n\trun: function( percent ) {\n\t\tvar eased,\n\t\t\thooks = Tween.propHooks[ this.prop ];\n\n\t\tif ( this.options.duration ) {\n\t\t\tthis.pos = eased = jQuery.easing[ this.easing ](\n\t\t\t\tpercent, this.options.duration * percent, 0, 1, this.options.duration\n\t\t\t);\n\t\t} else {\n\t\t\tthis.pos = eased = percent;\n\t\t}\n\t\tthis.now = ( this.end - this.start ) * eased + this.start;\n\n\t\tif ( this.options.step ) {\n\t\t\tthis.options.step.call( this.elem, this.now, this );\n\t\t}\n\n\t\tif ( hooks && hooks.set ) {\n\t\t\thooks.set( this );\n\t\t} else {\n\t\t\tTween.propHooks._default.set( this );\n\t\t}\n\t\treturn this;\n\t}\n};\n\nTween.prototype.init.prototype = Tween.prototype;\n\nTween.propHooks = {\n\t_default: {\n\t\tget: function( tween ) {\n\t\t\tvar result;\n\n\t\t\t// Use a property on the element directly when it is not a DOM element,\n\t\t\t// or when there is no matching style property that exists.\n\t\t\tif ( tween.elem.nodeType !== 1 ||\n\t\t\t\ttween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {\n\t\t\t\treturn tween.elem[ tween.prop ];\n\t\t\t}\n\n\t\t\t// Passing an empty string as a 3rd parameter to .css will automatically\n\t\t\t// attempt a parseFloat and fallback to a string if the parse fails.\n\t\t\t// Simple values such as \"10px\" are parsed to Float;\n\t\t\t// complex values such as \"rotate(1rad)\" are returned as-is.\n\t\t\tresult = jQuery.css( tween.elem, tween.prop, \"\" );\n\n\t\t\t// Empty strings, null, undefined and \"auto\" are converted to 0.\n\t\t\treturn !result || result === \"auto\" ? 0 : result;\n\t\t},\n\t\tset: function( tween ) {\n\n\t\t\t// Use step hook for back compat.\n\t\t\t// Use cssHook if its there.\n\t\t\t// Use .style if available and use plain properties where available.\n\t\t\tif ( jQuery.fx.step[ tween.prop ] ) {\n\t\t\t\tjQuery.fx.step[ tween.prop ]( tween );\n\t\t\t} else if ( tween.elem.nodeType === 1 &&\n\t\t\t\t( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||\n\t\t\t\t\tjQuery.cssHooks[ tween.prop ] ) ) {\n\t\t\t\tjQuery.style( tween.elem, tween.prop, tween.now + tween.unit );\n\t\t\t} else {\n\t\t\t\ttween.elem[ tween.prop ] = tween.now;\n\t\t\t}\n\t\t}\n\t}\n};\n\n// Support: IE <=9 only\n// Panic based approach to setting things on disconnected nodes\nTween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {\n\tset: function( tween ) {\n\t\tif ( tween.elem.nodeType && tween.elem.parentNode ) {\n\t\t\ttween.elem[ tween.prop ] = tween.now;\n\t\t}\n\t}\n};\n\njQuery.easing = {\n\tlinear: function( p ) {\n\t\treturn p;\n\t},\n\tswing: function( p ) {\n\t\treturn 0.5 - Math.cos( p * Math.PI ) / 2;\n\t},\n\t_default: \"swing\"\n};\n\njQuery.fx = Tween.prototype.init;\n\n// Back compat <1.8 extension point\njQuery.fx.step = {};\n\n\n\n\nvar\n\tfxNow, inProgress,\n\trfxtypes = /^(?:toggle|show|hide)$/,\n\trrun = /queueHooks$/;\n\nfunction schedule() {\n\tif ( inProgress ) {\n\t\tif ( document.hidden === false && window.requestAnimationFrame ) {\n\t\t\twindow.requestAnimationFrame( schedule );\n\t\t} else {\n\t\t\twindow.setTimeout( schedule, jQuery.fx.interval );\n\t\t}\n\n\t\tjQuery.fx.tick();\n\t}\n}\n\n// Animations created synchronously will run synchronously\nfunction createFxNow() {\n\twindow.setTimeout( function() {\n\t\tfxNow = undefined;\n\t} );\n\treturn ( fxNow = jQuery.now() );\n}\n\n// Generate parameters to create a standard animation\nfunction genFx( type, includeWidth ) {\n\tvar which,\n\t\ti = 0,\n\t\tattrs = { height: type };\n\n\t// If we include width, step value is 1 to do all cssExpand values,\n\t// otherwise step value is 2 to skip over Left and Right\n\tincludeWidth = includeWidth ? 1 : 0;\n\tfor ( ; i < 4; i += 2 - includeWidth ) {\n\t\twhich = cssExpand[ i ];\n\t\tattrs[ \"margin\" + which ] = attrs[ \"padding\" + which ] = type;\n\t}\n\n\tif ( includeWidth ) {\n\t\tattrs.opacity = attrs.width = type;\n\t}\n\n\treturn attrs;\n}\n\nfunction createTween( value, prop, animation ) {\n\tvar tween,\n\t\tcollection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ \"*\" ] ),\n\t\tindex = 0,\n\t\tlength = collection.length;\n\tfor ( ; index < length; index++ ) {\n\t\tif ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {\n\n\t\t\t// We're done with this property\n\t\t\treturn tween;\n\t\t}\n\t}\n}\n\nfunction defaultPrefilter( elem, props, opts ) {\n\tvar prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,\n\t\tisBox = \"width\" in props || \"height\" in props,\n\t\tanim = this,\n\t\torig = {},\n\t\tstyle = elem.style,\n\t\thidden = elem.nodeType && isHiddenWithinTree( elem ),\n\t\tdataShow = dataPriv.get( elem, \"fxshow\" );\n\n\t// Queue-skipping animations hijack the fx hooks\n\tif ( !opts.queue ) {\n\t\thooks = jQuery._queueHooks( elem, \"fx\" );\n\t\tif ( hooks.unqueued == null ) {\n\t\t\thooks.unqueued = 0;\n\t\t\toldfire = hooks.empty.fire;\n\t\t\thooks.empty.fire = function() {\n\t\t\t\tif ( !hooks.unqueued ) {\n\t\t\t\t\toldfire();\n\t\t\t\t}\n\t\t\t};\n\t\t}\n\t\thooks.unqueued++;\n\n\t\tanim.always( function() {\n\n\t\t\t// Ensure the complete handler is called before this completes\n\t\t\tanim.always( function() {\n\t\t\t\thooks.unqueued--;\n\t\t\t\tif ( !jQuery.queue( elem, \"fx\" ).length ) {\n\t\t\t\t\thooks.empty.fire();\n\t\t\t\t}\n\t\t\t} );\n\t\t} );\n\t}\n\n\t// Detect show/hide animations\n\tfor ( prop in props ) {\n\t\tvalue = props[ prop ];\n\t\tif ( rfxtypes.test( value ) ) {\n\t\t\tdelete props[ prop ];\n\t\t\ttoggle = toggle || value === \"toggle\";\n\t\t\tif ( value === ( hidden ? \"hide\" : \"show\" ) ) {\n\n\t\t\t\t// Pretend to be hidden if this is a \"show\" and\n\t\t\t\t// there is still data from a stopped show/hide\n\t\t\t\tif ( value === \"show\" && dataShow && dataShow[ prop ] !== undefined ) {\n\t\t\t\t\thidden = true;\n\n\t\t\t\t// Ignore all other no-op show/hide data\n\t\t\t\t} else {\n\t\t\t\t\tcontinue;\n\t\t\t\t}\n\t\t\t}\n\t\t\torig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );\n\t\t}\n\t}\n\n\t// Bail out if this is a no-op like .hide().hide()\n\tpropTween = !jQuery.isEmptyObject( props );\n\tif ( !propTween && jQuery.isEmptyObject( orig ) ) {\n\t\treturn;\n\t}\n\n\t// Restrict \"overflow\" and \"display\" styles during box animations\n\tif ( isBox && elem.nodeType === 1 ) {\n\n\t\t// Support: IE <=9 - 11, Edge 12 - 13\n\t\t// Record all 3 overflow attributes because IE does not infer the shorthand\n\t\t// from identically-valued overflowX and overflowY\n\t\topts.overflow = [ style.overflow, style.overflowX, style.overflowY ];\n\n\t\t// Identify a display type, preferring old show/hide data over the CSS cascade\n\t\trestoreDisplay = dataShow && dataShow.display;\n\t\tif ( restoreDisplay == null ) {\n\t\t\trestoreDisplay = dataPriv.get( elem, \"display\" );\n\t\t}\n\t\tdisplay = jQuery.css( elem, \"display\" );\n\t\tif ( display === \"none\" ) {\n\t\t\tif ( restoreDisplay ) {\n\t\t\t\tdisplay = restoreDisplay;\n\t\t\t} else {\n\n\t\t\t\t// Get nonempty value(s) by temporarily forcing visibility\n\t\t\t\tshowHide( [ elem ], true );\n\t\t\t\trestoreDisplay = elem.style.display || restoreDisplay;\n\t\t\t\tdisplay = jQuery.css( elem, \"display\" );\n\t\t\t\tshowHide( [ elem ] );\n\t\t\t}\n\t\t}\n\n\t\t// Animate inline elements as inline-block\n\t\tif ( display === \"inline\" || display === \"inline-block\" && restoreDisplay != null ) {\n\t\t\tif ( jQuery.css( elem, \"float\" ) === \"none\" ) {\n\n\t\t\t\t// Restore the original display value at the end of pure show/hide animations\n\t\t\t\tif ( !propTween ) {\n\t\t\t\t\tanim.done( function() {\n\t\t\t\t\t\tstyle.display = restoreDisplay;\n\t\t\t\t\t} );\n\t\t\t\t\tif ( restoreDisplay == null ) {\n\t\t\t\t\t\tdisplay = style.display;\n\t\t\t\t\t\trestoreDisplay = display === \"none\" ? \"\" : display;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tstyle.display = \"inline-block\";\n\t\t\t}\n\t\t}\n\t}\n\n\tif ( opts.overflow ) {\n\t\tstyle.overflow = \"hidden\";\n\t\tanim.always( function() {\n\t\t\tstyle.overflow = opts.overflow[ 0 ];\n\t\t\tstyle.overflowX = opts.overflow[ 1 ];\n\t\t\tstyle.overflowY = opts.overflow[ 2 ];\n\t\t} );\n\t}\n\n\t// Implement show/hide animations\n\tpropTween = false;\n\tfor ( prop in orig ) {\n\n\t\t// General show/hide setup for this element animation\n\t\tif ( !propTween ) {\n\t\t\tif ( dataShow ) {\n\t\t\t\tif ( \"hidden\" in dataShow ) {\n\t\t\t\t\thidden = dataShow.hidden;\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\tdataShow = dataPriv.access( elem, \"fxshow\", { display: restoreDisplay } );\n\t\t\t}\n\n\t\t\t// Store hidden/visible for toggle so `.stop().toggle()` \"reverses\"\n\t\t\tif ( toggle ) {\n\t\t\t\tdataShow.hidden = !hidden;\n\t\t\t}\n\n\t\t\t// Show elements before animating them\n\t\t\tif ( hidden ) {\n\t\t\t\tshowHide( [ elem ], true );\n\t\t\t}\n\n\t\t\t/* eslint-disable no-loop-func */\n\n\t\t\tanim.done( function() {\n\n\t\t\t/* eslint-enable no-loop-func */\n\n\t\t\t\t// The final step of a \"hide\" animation is actually hiding the element\n\t\t\t\tif ( !hidden ) {\n\t\t\t\t\tshowHide( [ elem ] );\n\t\t\t\t}\n\t\t\t\tdataPriv.remove( elem, \"fxshow\" );\n\t\t\t\tfor ( prop in orig ) {\n\t\t\t\t\tjQuery.style( elem, prop, orig[ prop ] );\n\t\t\t\t}\n\t\t\t} );\n\t\t}\n\n\t\t// Per-property setup\n\t\tpropTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );\n\t\tif ( !( prop in dataShow ) ) {\n\t\t\tdataShow[ prop ] = propTween.start;\n\t\t\tif ( hidden ) {\n\t\t\t\tpropTween.end = propTween.start;\n\t\t\t\tpropTween.start = 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\nfunction propFilter( props, specialEasing ) {\n\tvar index, name, easing, value, hooks;\n\n\t// camelCase, specialEasing and expand cssHook pass\n\tfor ( index in props ) {\n\t\tname = jQuery.camelCase( index );\n\t\teasing = specialEasing[ name ];\n\t\tvalue = props[ index ];\n\t\tif ( Array.isArray( value ) ) {\n\t\t\teasing = value[ 1 ];\n\t\t\tvalue = props[ index ] = value[ 0 ];\n\t\t}\n\n\t\tif ( index !== name ) {\n\t\t\tprops[ name ] = value;\n\t\t\tdelete props[ index ];\n\t\t}\n\n\t\thooks = jQuery.cssHooks[ name ];\n\t\tif ( hooks && \"expand\" in hooks ) {\n\t\t\tvalue = hooks.expand( value );\n\t\t\tdelete props[ name ];\n\n\t\t\t// Not quite $.extend, this won't overwrite existing keys.\n\t\t\t// Reusing 'index' because we have the correct \"name\"\n\t\t\tfor ( index in value ) {\n\t\t\t\tif ( !( index in props ) ) {\n\t\t\t\t\tprops[ index ] = value[ index ];\n\t\t\t\t\tspecialEasing[ index ] = easing;\n\t\t\t\t}\n\t\t\t}\n\t\t} else {\n\t\t\tspecialEasing[ name ] = easing;\n\t\t}\n\t}\n}\n\nfunction Animation( elem, properties, options ) {\n\tvar result,\n\t\tstopped,\n\t\tindex = 0,\n\t\tlength = Animation.prefilters.length,\n\t\tdeferred = jQuery.Deferred().always( function() {\n\n\t\t\t// Don't match elem in the :animated selector\n\t\t\tdelete tick.elem;\n\t\t} ),\n\t\ttick = function() {\n\t\t\tif ( stopped ) {\n\t\t\t\treturn false;\n\t\t\t}\n\t\t\tvar currentTime = fxNow || createFxNow(),\n\t\t\t\tremaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),\n\n\t\t\t\t// Support: Android 2.3 only\n\t\t\t\t// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)\n\t\t\t\ttemp = remaining / animation.duration || 0,\n\t\t\t\tpercent = 1 - temp,\n\t\t\t\tindex = 0,\n\t\t\t\tlength = animation.tweens.length;\n\n\t\t\tfor ( ; index < length; index++ ) {\n\t\t\t\tanimation.tweens[ index ].run( percent );\n\t\t\t}\n\n\t\t\tdeferred.notifyWith( elem, [ animation, percent, remaining ] );\n\n\t\t\t// If there's more to do, yield\n\t\t\tif ( percent < 1 && length ) {\n\t\t\t\treturn remaining;\n\t\t\t}\n\n\t\t\t// If this was an empty animation, synthesize a final progress notification\n\t\t\tif ( !length ) {\n\t\t\t\tdeferred.notifyWith( elem, [ animation, 1, 0 ] );\n\t\t\t}\n\n\t\t\t// Resolve the animation and report its conclusion\n\t\t\tdeferred.resolveWith( elem, [ animation ] );\n\t\t\treturn false;\n\t\t},\n\t\tanimation = deferred.promise( {\n\t\t\telem: elem,\n\t\t\tprops: jQuery.extend( {}, properties ),\n\t\t\topts: jQuery.extend( true, {\n\t\t\t\tspecialEasing: {},\n\t\t\t\teasing: jQuery.easing._default\n\t\t\t}, options ),\n\t\t\toriginalProperties: properties,\n\t\t\toriginalOptions: options,\n\t\t\tstartTime: fxNow || createFxNow(),\n\t\t\tduration: options.duration,\n\t\t\ttweens: [],\n\t\t\tcreateTween: function( prop, end ) {\n\t\t\t\tvar tween = jQuery.Tween( elem, animation.opts, prop, end,\n\t\t\t\t\t\tanimation.opts.specialEasing[ prop ] || animation.opts.easing );\n\t\t\t\tanimation.tweens.push( tween );\n\t\t\t\treturn tween;\n\t\t\t},\n\t\t\tstop: function( gotoEnd ) {\n\t\t\t\tvar index = 0,\n\n\t\t\t\t\t// If we are going to the end, we want to run all the tweens\n\t\t\t\t\t// otherwise we skip this part\n\t\t\t\t\tlength = gotoEnd ? animation.tweens.length : 0;\n\t\t\t\tif ( stopped ) {\n\t\t\t\t\treturn this;\n\t\t\t\t}\n\t\t\t\tstopped = true;\n\t\t\t\tfor ( ; index < length; index++ ) {\n\t\t\t\t\tanimation.tweens[ index ].run( 1 );\n\t\t\t\t}\n\n\t\t\t\t// Resolve when we played the last frame; otherwise, reject\n\t\t\t\tif ( gotoEnd ) {\n\t\t\t\t\tdeferred.notifyWith( elem, [ animation, 1, 0 ] );\n\t\t\t\t\tdeferred.resolveWith( elem, [ animation, gotoEnd ] );\n\t\t\t\t} else {\n\t\t\t\t\tdeferred.rejectWith( elem, [ animation, gotoEnd ] );\n\t\t\t\t}\n\t\t\t\treturn this;\n\t\t\t}\n\t\t} ),\n\t\tprops = animation.props;\n\n\tpropFilter( props, animation.opts.specialEasing );\n\n\tfor ( ; index < length; index++ ) {\n\t\tresult = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );\n\t\tif ( result ) {\n\t\t\tif ( jQuery.isFunction( result.stop ) ) {\n\t\t\t\tjQuery._queueHooks( animation.elem, animation.opts.queue ).stop =\n\t\t\t\t\tjQuery.proxy( result.stop, result );\n\t\t\t}\n\t\t\treturn result;\n\t\t}\n\t}\n\n\tjQuery.map( props, createTween, animation );\n\n\tif ( jQuery.isFunction( animation.opts.start ) ) {\n\t\tanimation.opts.start.call( elem, animation );\n\t}\n\n\t// Attach callbacks from options\n\tanimation\n\t\t.progress( animation.opts.progress )\n\t\t.done( animation.opts.done, animation.opts.complete )\n\t\t.fail( animation.opts.fail )\n\t\t.always( animation.opts.always );\n\n\tjQuery.fx.timer(\n\t\tjQuery.extend( tick, {\n\t\t\telem: elem,\n\t\t\tanim: animation,\n\t\t\tqueue: animation.opts.queue\n\t\t} )\n\t);\n\n\treturn animation;\n}\n\njQuery.Animation = jQuery.extend( Animation, {\n\n\ttweeners: {\n\t\t\"*\": [ function( prop, value ) {\n\t\t\tvar tween = this.createTween( prop, value );\n\t\t\tadjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );\n\t\t\treturn tween;\n\t\t} ]\n\t},\n\n\ttweener: function( props, callback ) {\n\t\tif ( jQuery.isFunction( props ) ) {\n\t\t\tcallback = props;\n\t\t\tprops = [ \"*\" ];\n\t\t} else {\n\t\t\tprops = props.match( rnothtmlwhite );\n\t\t}\n\n\t\tvar prop,\n\t\t\tindex = 0,\n\t\t\tlength = props.length;\n\n\t\tfor ( ; index < length; index++ ) {\n\t\t\tprop = props[ index ];\n\t\t\tAnimation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];\n\t\t\tAnimation.tweeners[ prop ].unshift( callback );\n\t\t}\n\t},\n\n\tprefilters: [ defaultPrefilter ],\n\n\tprefilter: function( callback, prepend ) {\n\t\tif ( prepend ) {\n\t\t\tAnimation.prefilters.unshift( callback );\n\t\t} else {\n\t\t\tAnimation.prefilters.push( callback );\n\t\t}\n\t}\n} );\n\njQuery.speed = function( speed, easing, fn ) {\n\tvar opt = speed && typeof speed === \"object\" ? jQuery.extend( {}, speed ) : {\n\t\tcomplete: fn || !fn && easing ||\n\t\t\tjQuery.isFunction( speed ) && speed,\n\t\tduration: speed,\n\t\teasing: fn && easing || easing && !jQuery.isFunction( easing ) && easing\n\t};\n\n\t// Go to the end state if fx are off\n\tif ( jQuery.fx.off ) {\n\t\topt.duration = 0;\n\n\t} else {\n\t\tif ( typeof opt.duration !== \"number\" ) {\n\t\t\tif ( opt.duration in jQuery.fx.speeds ) {\n\t\t\t\topt.duration = jQuery.fx.speeds[ opt.duration ];\n\n\t\t\t} else {\n\t\t\t\topt.duration = jQuery.fx.speeds._default;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Normalize opt.queue - true/undefined/null -> \"fx\"\n\tif ( opt.queue == null || opt.queue === true ) {\n\t\topt.queue = \"fx\";\n\t}\n\n\t// Queueing\n\topt.old = opt.complete;\n\n\topt.complete = function() {\n\t\tif ( jQuery.isFunction( opt.old ) ) {\n\t\t\topt.old.call( this );\n\t\t}\n\n\t\tif ( opt.queue ) {\n\t\t\tjQuery.dequeue( this, opt.queue );\n\t\t}\n\t};\n\n\treturn opt;\n};\n\njQuery.fn.extend( {\n\tfadeTo: function( speed, to, easing, callback ) {\n\n\t\t// Show any hidden elements after setting opacity to 0\n\t\treturn this.filter( isHiddenWithinTree ).css( \"opacity\", 0 ).show()\n\n\t\t\t// Animate to the value specified\n\t\t\t.end().animate( { opacity: to }, speed, easing, callback );\n\t},\n\tanimate: function( prop, speed, easing, callback ) {\n\t\tvar empty = jQuery.isEmptyObject( prop ),\n\t\t\toptall = jQuery.speed( speed, easing, callback ),\n\t\t\tdoAnimation = function() {\n\n\t\t\t\t// Operate on a copy of prop so per-property easing won't be lost\n\t\t\t\tvar anim = Animation( this, jQuery.extend( {}, prop ), optall );\n\n\t\t\t\t// Empty animations, or finishing resolves immediately\n\t\t\t\tif ( empty || dataPriv.get( this, \"finish\" ) ) {\n\t\t\t\t\tanim.stop( true );\n\t\t\t\t}\n\t\t\t};\n\t\t\tdoAnimation.finish = doAnimation;\n\n\t\treturn empty || optall.queue === false ?\n\t\t\tthis.each( doAnimation ) :\n\t\t\tthis.queue( optall.queue, doAnimation );\n\t},\n\tstop: function( type, clearQueue, gotoEnd ) {\n\t\tvar stopQueue = function( hooks ) {\n\t\t\tvar stop = hooks.stop;\n\t\t\tdelete hooks.stop;\n\t\t\tstop( gotoEnd );\n\t\t};\n\n\t\tif ( typeof type !== \"string\" ) {\n\t\t\tgotoEnd = clearQueue;\n\t\t\tclearQueue = type;\n\t\t\ttype = undefined;\n\t\t}\n\t\tif ( clearQueue && type !== false ) {\n\t\t\tthis.queue( type || \"fx\", [] );\n\t\t}\n\n\t\treturn this.each( function() {\n\t\t\tvar dequeue = true,\n\t\t\t\tindex = type != null && type + \"queueHooks\",\n\t\t\t\ttimers = jQuery.timers,\n\t\t\t\tdata = dataPriv.get( this );\n\n\t\t\tif ( index ) {\n\t\t\t\tif ( data[ index ] && data[ index ].stop ) {\n\t\t\t\t\tstopQueue( data[ index ] );\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\tfor ( index in data ) {\n\t\t\t\t\tif ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {\n\t\t\t\t\t\tstopQueue( data[ index ] );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tfor ( index = timers.length; index--; ) {\n\t\t\t\tif ( timers[ index ].elem === this &&\n\t\t\t\t\t( type == null || timers[ index ].queue === type ) ) {\n\n\t\t\t\t\ttimers[ index ].anim.stop( gotoEnd );\n\t\t\t\t\tdequeue = false;\n\t\t\t\t\ttimers.splice( index, 1 );\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Start the next in the queue if the last step wasn't forced.\n\t\t\t// Timers currently will call their complete callbacks, which\n\t\t\t// will dequeue but only if they were gotoEnd.\n\t\t\tif ( dequeue || !gotoEnd ) {\n\t\t\t\tjQuery.dequeue( this, type );\n\t\t\t}\n\t\t} );\n\t},\n\tfinish: function( type ) {\n\t\tif ( type !== false ) {\n\t\t\ttype = type || \"fx\";\n\t\t}\n\t\treturn this.each( function() {\n\t\t\tvar index,\n\t\t\t\tdata = dataPriv.get( this ),\n\t\t\t\tqueue = data[ type + \"queue\" ],\n\t\t\t\thooks = data[ type + \"queueHooks\" ],\n\t\t\t\ttimers = jQuery.timers,\n\t\t\t\tlength = queue ? queue.length : 0;\n\n\t\t\t// Enable finishing flag on private data\n\t\t\tdata.finish = true;\n\n\t\t\t// Empty the queue first\n\t\t\tjQuery.queue( this, type, [] );\n\n\t\t\tif ( hooks && hooks.stop ) {\n\t\t\t\thooks.stop.call( this, true );\n\t\t\t}\n\n\t\t\t// Look for any active animations, and finish them\n\t\t\tfor ( index = timers.length; index--; ) {\n\t\t\t\tif ( timers[ index ].elem === this && timers[ index ].queue === type ) {\n\t\t\t\t\ttimers[ index ].anim.stop( true );\n\t\t\t\t\ttimers.splice( index, 1 );\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Look for any animations in the old queue and finish them\n\t\t\tfor ( index = 0; index < length; index++ ) {\n\t\t\t\tif ( queue[ index ] && queue[ index ].finish ) {\n\t\t\t\t\tqueue[ index ].finish.call( this );\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Turn off finishing flag\n\t\t\tdelete data.finish;\n\t\t} );\n\t}\n} );\n\njQuery.each( [ \"toggle\", \"show\", \"hide\" ], function( i, name ) {\n\tvar cssFn = jQuery.fn[ name ];\n\tjQuery.fn[ name ] = function( speed, easing, callback ) {\n\t\treturn speed == null || typeof speed === \"boolean\" ?\n\t\t\tcssFn.apply( this, arguments ) :\n\t\t\tthis.animate( genFx( name, true ), speed, easing, callback );\n\t};\n} );\n\n// Generate shortcuts for custom animations\njQuery.each( {\n\tslideDown: genFx( \"show\" ),\n\tslideUp: genFx( \"hide\" ),\n\tslideToggle: genFx( \"toggle\" ),\n\tfadeIn: { opacity: \"show\" },\n\tfadeOut: { opacity: \"hide\" },\n\tfadeToggle: { opacity: \"toggle\" }\n}, function( name, props ) {\n\tjQuery.fn[ name ] = function( speed, easing, callback ) {\n\t\treturn this.animate( props, speed, easing, callback );\n\t};\n} );\n\njQuery.timers = [];\njQuery.fx.tick = function() {\n\tvar timer,\n\t\ti = 0,\n\t\ttimers = jQuery.timers;\n\n\tfxNow = jQuery.now();\n\n\tfor ( ; i < timers.length; i++ ) {\n\t\ttimer = timers[ i ];\n\n\t\t// Run the timer and safely remove it when done (allowing for external removal)\n\t\tif ( !timer() && timers[ i ] === timer ) {\n\t\t\ttimers.splice( i--, 1 );\n\t\t}\n\t}\n\n\tif ( !timers.length ) {\n\t\tjQuery.fx.stop();\n\t}\n\tfxNow = undefined;\n};\n\njQuery.fx.timer = function( timer ) {\n\tjQuery.timers.push( timer );\n\tjQuery.fx.start();\n};\n\njQuery.fx.interval = 13;\njQuery.fx.start = function() {\n\tif ( inProgress ) {\n\t\treturn;\n\t}\n\n\tinProgress = true;\n\tschedule();\n};\n\njQuery.fx.stop = function() {\n\tinProgress = null;\n};\n\njQuery.fx.speeds = {\n\tslow: 600,\n\tfast: 200,\n\n\t// Default speed\n\t_default: 400\n};\n\n\n// Based off of the plugin by Clint Helfers, with permission.\n// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/\njQuery.fn.delay = function( time, type ) {\n\ttime = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;\n\ttype = type || \"fx\";\n\n\treturn this.queue( type, function( next, hooks ) {\n\t\tvar timeout = window.setTimeout( next, time );\n\t\thooks.stop = function() {\n\t\t\twindow.clearTimeout( timeout );\n\t\t};\n\t} );\n};\n\n\n( function() {\n\tvar input = document.createElement( \"input\" ),\n\t\tselect = document.createElement( \"select\" ),\n\t\topt = select.appendChild( document.createElement( \"option\" ) );\n\n\tinput.type = \"checkbox\";\n\n\t// Support: Android <=4.3 only\n\t// Default value for a checkbox should be \"on\"\n\tsupport.checkOn = input.value !== \"\";\n\n\t// Support: IE <=11 only\n\t// Must access selectedIndex to make default options select\n\tsupport.optSelected = opt.selected;\n\n\t// Support: IE <=11 only\n\t// An input loses its value after becoming a radio\n\tinput = document.createElement( \"input\" );\n\tinput.value = \"t\";\n\tinput.type = \"radio\";\n\tsupport.radioValue = input.value === \"t\";\n} )();\n\n\nvar boolHook,\n\tattrHandle = jQuery.expr.attrHandle;\n\njQuery.fn.extend( {\n\tattr: function( name, value ) {\n\t\treturn access( this, jQuery.attr, name, value, arguments.length > 1 );\n\t},\n\n\tremoveAttr: function( name ) {\n\t\treturn this.each( function() {\n\t\t\tjQuery.removeAttr( this, name );\n\t\t} );\n\t}\n} );\n\njQuery.extend( {\n\tattr: function( elem, name, value ) {\n\t\tvar ret, hooks,\n\t\t\tnType = elem.nodeType;\n\n\t\t// Don't get/set attributes on text, comment and attribute nodes\n\t\tif ( nType === 3 || nType === 8 || nType === 2 ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Fallback to prop when attributes are not supported\n\t\tif ( typeof elem.getAttribute === \"undefined\" ) {\n\t\t\treturn jQuery.prop( elem, name, value );\n\t\t}\n\n\t\t// Attribute hooks are determined by the lowercase version\n\t\t// Grab necessary hook if one is defined\n\t\tif ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {\n\t\t\thooks = jQuery.attrHooks[ name.toLowerCase() ] ||\n\t\t\t\t( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );\n\t\t}\n\n\t\tif ( value !== undefined ) {\n\t\t\tif ( value === null ) {\n\t\t\t\tjQuery.removeAttr( elem, name );\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tif ( hooks && \"set\" in hooks &&\n\t\t\t\t( ret = hooks.set( elem, value, name ) ) !== undefined ) {\n\t\t\t\treturn ret;\n\t\t\t}\n\n\t\t\telem.setAttribute( name, value + \"\" );\n\t\t\treturn value;\n\t\t}\n\n\t\tif ( hooks && \"get\" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {\n\t\t\treturn ret;\n\t\t}\n\n\t\tret = jQuery.find.attr( elem, name );\n\n\t\t// Non-existent attributes return null, we normalize to undefined\n\t\treturn ret == null ? undefined : ret;\n\t},\n\n\tattrHooks: {\n\t\ttype: {\n\t\t\tset: function( elem, value ) {\n\t\t\t\tif ( !support.radioValue && value === \"radio\" &&\n\t\t\t\t\tnodeName( elem, \"input\" ) ) {\n\t\t\t\t\tvar val = elem.value;\n\t\t\t\t\telem.setAttribute( \"type\", value );\n\t\t\t\t\tif ( val ) {\n\t\t\t\t\t\telem.value = val;\n\t\t\t\t\t}\n\t\t\t\t\treturn value;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t},\n\n\tremoveAttr: function( elem, value ) {\n\t\tvar name,\n\t\t\ti = 0,\n\n\t\t\t// Attribute names can contain non-HTML whitespace characters\n\t\t\t// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2\n\t\t\tattrNames = value && value.match( rnothtmlwhite );\n\n\t\tif ( attrNames && elem.nodeType === 1 ) {\n\t\t\twhile ( ( name = attrNames[ i++ ] ) ) {\n\t\t\t\telem.removeAttribute( name );\n\t\t\t}\n\t\t}\n\t}\n} );\n\n// Hooks for boolean attributes\nboolHook = {\n\tset: function( elem, value, name ) {\n\t\tif ( value === false ) {\n\n\t\t\t// Remove boolean attributes when set to false\n\t\t\tjQuery.removeAttr( elem, name );\n\t\t} else {\n\t\t\telem.setAttribute( name, name );\n\t\t}\n\t\treturn name;\n\t}\n};\n\njQuery.each( jQuery.expr.match.bool.source.match( /\\w+/g ), function( i, name ) {\n\tvar getter = attrHandle[ name ] || jQuery.find.attr;\n\n\tattrHandle[ name ] = function( elem, name, isXML ) {\n\t\tvar ret, handle,\n\t\t\tlowercaseName = name.toLowerCase();\n\n\t\tif ( !isXML ) {\n\n\t\t\t// Avoid an infinite loop by temporarily removing this function from the getter\n\t\t\thandle = attrHandle[ lowercaseName ];\n\t\t\tattrHandle[ lowercaseName ] = ret;\n\t\t\tret = getter( elem, name, isXML ) != null ?\n\t\t\t\tlowercaseName :\n\t\t\t\tnull;\n\t\t\tattrHandle[ lowercaseName ] = handle;\n\t\t}\n\t\treturn ret;\n\t};\n} );\n\n\n\n\nvar rfocusable = /^(?:input|select|textarea|button)$/i,\n\trclickable = /^(?:a|area)$/i;\n\njQuery.fn.extend( {\n\tprop: function( name, value ) {\n\t\treturn access( this, jQuery.prop, name, value, arguments.length > 1 );\n\t},\n\n\tremoveProp: function( name ) {\n\t\treturn this.each( function() {\n\t\t\tdelete this[ jQuery.propFix[ name ] || name ];\n\t\t} );\n\t}\n} );\n\njQuery.extend( {\n\tprop: function( elem, name, value ) {\n\t\tvar ret, hooks,\n\t\t\tnType = elem.nodeType;\n\n\t\t// Don't get/set properties on text, comment and attribute nodes\n\t\tif ( nType === 3 || nType === 8 || nType === 2 ) {\n\t\t\treturn;\n\t\t}\n\n\t\tif ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {\n\n\t\t\t// Fix name and attach hooks\n\t\t\tname = jQuery.propFix[ name ] || name;\n\t\t\thooks = jQuery.propHooks[ name ];\n\t\t}\n\n\t\tif ( value !== undefined ) {\n\t\t\tif ( hooks && \"set\" in hooks &&\n\t\t\t\t( ret = hooks.set( elem, value, name ) ) !== undefined ) {\n\t\t\t\treturn ret;\n\t\t\t}\n\n\t\t\treturn ( elem[ name ] = value );\n\t\t}\n\n\t\tif ( hooks && \"get\" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {\n\t\t\treturn ret;\n\t\t}\n\n\t\treturn elem[ name ];\n\t},\n\n\tpropHooks: {\n\t\ttabIndex: {\n\t\t\tget: function( elem ) {\n\n\t\t\t\t// Support: IE <=9 - 11 only\n\t\t\t\t// elem.tabIndex doesn't always return the\n\t\t\t\t// correct value when it hasn't been explicitly set\n\t\t\t\t// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/\n\t\t\t\t// Use proper attribute retrieval(#12072)\n\t\t\t\tvar tabindex = jQuery.find.attr( elem, \"tabindex\" );\n\n\t\t\t\tif ( tabindex ) {\n\t\t\t\t\treturn parseInt( tabindex, 10 );\n\t\t\t\t}\n\n\t\t\t\tif (\n\t\t\t\t\trfocusable.test( elem.nodeName ) ||\n\t\t\t\t\trclickable.test( elem.nodeName ) &&\n\t\t\t\t\telem.href\n\t\t\t\t) {\n\t\t\t\t\treturn 0;\n\t\t\t\t}\n\n\t\t\t\treturn -1;\n\t\t\t}\n\t\t}\n\t},\n\n\tpropFix: {\n\t\t\"for\": \"htmlFor\",\n\t\t\"class\": \"className\"\n\t}\n} );\n\n// Support: IE <=11 only\n// Accessing the selectedIndex property\n// forces the browser to respect setting selected\n// on the option\n// The getter ensures a default option is selected\n// when in an optgroup\n// eslint rule \"no-unused-expressions\" is disabled for this code\n// since it considers such accessions noop\nif ( !support.optSelected ) {\n\tjQuery.propHooks.selected = {\n\t\tget: function( elem ) {\n\n\t\t\t/* eslint no-unused-expressions: \"off\" */\n\n\t\t\tvar parent = elem.parentNode;\n\t\t\tif ( parent && parent.parentNode ) {\n\t\t\t\tparent.parentNode.selectedIndex;\n\t\t\t}\n\t\t\treturn null;\n\t\t},\n\t\tset: function( elem ) {\n\n\t\t\t/* eslint no-unused-expressions: \"off\" */\n\n\t\t\tvar parent = elem.parentNode;\n\t\t\tif ( parent ) {\n\t\t\t\tparent.selectedIndex;\n\n\t\t\t\tif ( parent.parentNode ) {\n\t\t\t\t\tparent.parentNode.selectedIndex;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t};\n}\n\njQuery.each( [\n\t\"tabIndex\",\n\t\"readOnly\",\n\t\"maxLength\",\n\t\"cellSpacing\",\n\t\"cellPadding\",\n\t\"rowSpan\",\n\t\"colSpan\",\n\t\"useMap\",\n\t\"frameBorder\",\n\t\"contentEditable\"\n], function() {\n\tjQuery.propFix[ this.toLowerCase() ] = this;\n} );\n\n\n\n\n\t// Strip and collapse whitespace according to HTML spec\n\t// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace\n\tfunction stripAndCollapse( value ) {\n\t\tvar tokens = value.match( rnothtmlwhite ) || [];\n\t\treturn tokens.join( \" \" );\n\t}\n\n\nfunction getClass( elem ) {\n\treturn elem.getAttribute && elem.getAttribute( \"class\" ) || \"\";\n}\n\njQuery.fn.extend( {\n\taddClass: function( value ) {\n\t\tvar classes, elem, cur, curValue, clazz, j, finalValue,\n\t\t\ti = 0;\n\n\t\tif ( jQuery.isFunction( value ) ) {\n\t\t\treturn this.each( function( j ) {\n\t\t\t\tjQuery( this ).addClass( value.call( this, j, getClass( this ) ) );\n\t\t\t} );\n\t\t}\n\n\t\tif ( typeof value === \"string\" && value ) {\n\t\t\tclasses = value.match( rnothtmlwhite ) || [];\n\n\t\t\twhile ( ( elem = this[ i++ ] ) ) {\n\t\t\t\tcurValue = getClass( elem );\n\t\t\t\tcur = elem.nodeType === 1 && ( \" \" + stripAndCollapse( curValue ) + \" \" );\n\n\t\t\t\tif ( cur ) {\n\t\t\t\t\tj = 0;\n\t\t\t\t\twhile ( ( clazz = classes[ j++ ] ) ) {\n\t\t\t\t\t\tif ( cur.indexOf( \" \" + clazz + \" \" ) < 0 ) {\n\t\t\t\t\t\t\tcur += clazz + \" \";\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t// Only assign if different to avoid unneeded rendering.\n\t\t\t\t\tfinalValue = stripAndCollapse( cur );\n\t\t\t\t\tif ( curValue !== finalValue ) {\n\t\t\t\t\t\telem.setAttribute( \"class\", finalValue );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn this;\n\t},\n\n\tremoveClass: function( value ) {\n\t\tvar classes, elem, cur, curValue, clazz, j, finalValue,\n\t\t\ti = 0;\n\n\t\tif ( jQuery.isFunction( value ) ) {\n\t\t\treturn this.each( function( j ) {\n\t\t\t\tjQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );\n\t\t\t} );\n\t\t}\n\n\t\tif ( !arguments.length ) {\n\t\t\treturn this.attr( \"class\", \"\" );\n\t\t}\n\n\t\tif ( typeof value === \"string\" && value ) {\n\t\t\tclasses = value.match( rnothtmlwhite ) || [];\n\n\t\t\twhile ( ( elem = this[ i++ ] ) ) {\n\t\t\t\tcurValue = getClass( elem );\n\n\t\t\t\t// This expression is here for better compressibility (see addClass)\n\t\t\t\tcur = elem.nodeType === 1 && ( \" \" + stripAndCollapse( curValue ) + \" \" );\n\n\t\t\t\tif ( cur ) {\n\t\t\t\t\tj = 0;\n\t\t\t\t\twhile ( ( clazz = classes[ j++ ] ) ) {\n\n\t\t\t\t\t\t// Remove *all* instances\n\t\t\t\t\t\twhile ( cur.indexOf( \" \" + clazz + \" \" ) > -1 ) {\n\t\t\t\t\t\t\tcur = cur.replace( \" \" + clazz + \" \", \" \" );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t// Only assign if different to avoid unneeded rendering.\n\t\t\t\t\tfinalValue = stripAndCollapse( cur );\n\t\t\t\t\tif ( curValue !== finalValue ) {\n\t\t\t\t\t\telem.setAttribute( \"class\", finalValue );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn this;\n\t},\n\n\ttoggleClass: function( value, stateVal ) {\n\t\tvar type = typeof value;\n\n\t\tif ( typeof stateVal === \"boolean\" && type === \"string\" ) {\n\t\t\treturn stateVal ? this.addClass( value ) : this.removeClass( value );\n\t\t}\n\n\t\tif ( jQuery.isFunction( value ) ) {\n\t\t\treturn this.each( function( i ) {\n\t\t\t\tjQuery( this ).toggleClass(\n\t\t\t\t\tvalue.call( this, i, getClass( this ), stateVal ),\n\t\t\t\t\tstateVal\n\t\t\t\t);\n\t\t\t} );\n\t\t}\n\n\t\treturn this.each( function() {\n\t\t\tvar className, i, self, classNames;\n\n\t\t\tif ( type === \"string\" ) {\n\n\t\t\t\t// Toggle individual class names\n\t\t\t\ti = 0;\n\t\t\t\tself = jQuery( this );\n\t\t\t\tclassNames = value.match( rnothtmlwhite ) || [];\n\n\t\t\t\twhile ( ( className = classNames[ i++ ] ) ) {\n\n\t\t\t\t\t// Check each className given, space separated list\n\t\t\t\t\tif ( self.hasClass( className ) ) {\n\t\t\t\t\t\tself.removeClass( className );\n\t\t\t\t\t} else {\n\t\t\t\t\t\tself.addClass( className );\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t// Toggle whole class name\n\t\t\t} else if ( value === undefined || type === \"boolean\" ) {\n\t\t\t\tclassName = getClass( this );\n\t\t\t\tif ( className ) {\n\n\t\t\t\t\t// Store className if set\n\t\t\t\t\tdataPriv.set( this, \"__className__\", className );\n\t\t\t\t}\n\n\t\t\t\t// If the element has a class name or if we're passed `false`,\n\t\t\t\t// then remove the whole classname (if there was one, the above saved it).\n\t\t\t\t// Otherwise bring back whatever was previously saved (if anything),\n\t\t\t\t// falling back to the empty string if nothing was stored.\n\t\t\t\tif ( this.setAttribute ) {\n\t\t\t\t\tthis.setAttribute( \"class\",\n\t\t\t\t\t\tclassName || value === false ?\n\t\t\t\t\t\t\"\" :\n\t\t\t\t\t\tdataPriv.get( this, \"__className__\" ) || \"\"\n\t\t\t\t\t);\n\t\t\t\t}\n\t\t\t}\n\t\t} );\n\t},\n\n\thasClass: function( selector ) {\n\t\tvar className, elem,\n\t\t\ti = 0;\n\n\t\tclassName = \" \" + selector + \" \";\n\t\twhile ( ( elem = this[ i++ ] ) ) {\n\t\t\tif ( elem.nodeType === 1 &&\n\t\t\t\t( \" \" + stripAndCollapse( getClass( elem ) ) + \" \" ).indexOf( className ) > -1 ) {\n\t\t\t\t\treturn true;\n\t\t\t}\n\t\t}\n\n\t\treturn false;\n\t}\n} );\n\n\n\n\nvar rreturn = /\\r/g;\n\njQuery.fn.extend( {\n\tval: function( value ) {\n\t\tvar hooks, ret, isFunction,\n\t\t\telem = this[ 0 ];\n\n\t\tif ( !arguments.length ) {\n\t\t\tif ( elem ) {\n\t\t\t\thooks = jQuery.valHooks[ elem.type ] ||\n\t\t\t\t\tjQuery.valHooks[ elem.nodeName.toLowerCase() ];\n\n\t\t\t\tif ( hooks &&\n\t\t\t\t\t\"get\" in hooks &&\n\t\t\t\t\t( ret = hooks.get( elem, \"value\" ) ) !== undefined\n\t\t\t\t) {\n\t\t\t\t\treturn ret;\n\t\t\t\t}\n\n\t\t\t\tret = elem.value;\n\n\t\t\t\t// Handle most common string cases\n\t\t\t\tif ( typeof ret === \"string\" ) {\n\t\t\t\t\treturn ret.replace( rreturn, \"\" );\n\t\t\t\t}\n\n\t\t\t\t// Handle cases where value is null/undef or number\n\t\t\t\treturn ret == null ? \"\" : ret;\n\t\t\t}\n\n\t\t\treturn;\n\t\t}\n\n\t\tisFunction = jQuery.isFunction( value );\n\n\t\treturn this.each( function( i ) {\n\t\t\tvar val;\n\n\t\t\tif ( this.nodeType !== 1 ) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tif ( isFunction ) {\n\t\t\t\tval = value.call( this, i, jQuery( this ).val() );\n\t\t\t} else {\n\t\t\t\tval = value;\n\t\t\t}\n\n\t\t\t// Treat null/undefined as \"\"; convert numbers to string\n\t\t\tif ( val == null ) {\n\t\t\t\tval = \"\";\n\n\t\t\t} else if ( typeof val === \"number\" ) {\n\t\t\t\tval += \"\";\n\n\t\t\t} else if ( Array.isArray( val ) ) {\n\t\t\t\tval = jQuery.map( val, function( value ) {\n\t\t\t\t\treturn value == null ? \"\" : value + \"\";\n\t\t\t\t} );\n\t\t\t}\n\n\t\t\thooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];\n\n\t\t\t// If set returns undefined, fall back to normal setting\n\t\t\tif ( !hooks || !( \"set\" in hooks ) || hooks.set( this, val, \"value\" ) === undefined ) {\n\t\t\t\tthis.value = val;\n\t\t\t}\n\t\t} );\n\t}\n} );\n\njQuery.extend( {\n\tvalHooks: {\n\t\toption: {\n\t\t\tget: function( elem ) {\n\n\t\t\t\tvar val = jQuery.find.attr( elem, \"value\" );\n\t\t\t\treturn val != null ?\n\t\t\t\t\tval :\n\n\t\t\t\t\t// Support: IE <=10 - 11 only\n\t\t\t\t\t// option.text throws exceptions (#14686, #14858)\n\t\t\t\t\t// Strip and collapse whitespace\n\t\t\t\t\t// https://html.spec.whatwg.org/#strip-and-collapse-whitespace\n\t\t\t\t\tstripAndCollapse( jQuery.text( elem ) );\n\t\t\t}\n\t\t},\n\t\tselect: {\n\t\t\tget: function( elem ) {\n\t\t\t\tvar value, option, i,\n\t\t\t\t\toptions = elem.options,\n\t\t\t\t\tindex = elem.selectedIndex,\n\t\t\t\t\tone = elem.type === \"select-one\",\n\t\t\t\t\tvalues = one ? null : [],\n\t\t\t\t\tmax = one ? index + 1 : options.length;\n\n\t\t\t\tif ( index < 0 ) {\n\t\t\t\t\ti = max;\n\n\t\t\t\t} else {\n\t\t\t\t\ti = one ? index : 0;\n\t\t\t\t}\n\n\t\t\t\t// Loop through all the selected options\n\t\t\t\tfor ( ; i < max; i++ ) {\n\t\t\t\t\toption = options[ i ];\n\n\t\t\t\t\t// Support: IE <=9 only\n\t\t\t\t\t// IE8-9 doesn't update selected after form reset (#2551)\n\t\t\t\t\tif ( ( option.selected || i === index ) &&\n\n\t\t\t\t\t\t\t// Don't return options that are disabled or in a disabled optgroup\n\t\t\t\t\t\t\t!option.disabled &&\n\t\t\t\t\t\t\t( !option.parentNode.disabled ||\n\t\t\t\t\t\t\t\t!nodeName( option.parentNode, \"optgroup\" ) ) ) {\n\n\t\t\t\t\t\t// Get the specific value for the option\n\t\t\t\t\t\tvalue = jQuery( option ).val();\n\n\t\t\t\t\t\t// We don't need an array for one selects\n\t\t\t\t\t\tif ( one ) {\n\t\t\t\t\t\t\treturn value;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// Multi-Selects return an array\n\t\t\t\t\t\tvalues.push( value );\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\treturn values;\n\t\t\t},\n\n\t\t\tset: function( elem, value ) {\n\t\t\t\tvar optionSet, option,\n\t\t\t\t\toptions = elem.options,\n\t\t\t\t\tvalues = jQuery.makeArray( value ),\n\t\t\t\t\ti = options.length;\n\n\t\t\t\twhile ( i-- ) {\n\t\t\t\t\toption = options[ i ];\n\n\t\t\t\t\t/* eslint-disable no-cond-assign */\n\n\t\t\t\t\tif ( option.selected =\n\t\t\t\t\t\tjQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1\n\t\t\t\t\t) {\n\t\t\t\t\t\toptionSet = true;\n\t\t\t\t\t}\n\n\t\t\t\t\t/* eslint-enable no-cond-assign */\n\t\t\t\t}\n\n\t\t\t\t// Force browsers to behave consistently when non-matching value is set\n\t\t\t\tif ( !optionSet ) {\n\t\t\t\t\telem.selectedIndex = -1;\n\t\t\t\t}\n\t\t\t\treturn values;\n\t\t\t}\n\t\t}\n\t}\n} );\n\n// Radios and checkboxes getter/setter\njQuery.each( [ \"radio\", \"checkbox\" ], function() {\n\tjQuery.valHooks[ this ] = {\n\t\tset: function( elem, value ) {\n\t\t\tif ( Array.isArray( value ) ) {\n\t\t\t\treturn ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );\n\t\t\t}\n\t\t}\n\t};\n\tif ( !support.checkOn ) {\n\t\tjQuery.valHooks[ this ].get = function( elem ) {\n\t\t\treturn elem.getAttribute( \"value\" ) === null ? \"on\" : elem.value;\n\t\t};\n\t}\n} );\n\n\n\n\n// Return jQuery for attributes-only inclusion\n\n\nvar rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;\n\njQuery.extend( jQuery.event, {\n\n\ttrigger: function( event, data, elem, onlyHandlers ) {\n\n\t\tvar i, cur, tmp, bubbleType, ontype, handle, special,\n\t\t\teventPath = [ elem || document ],\n\t\t\ttype = hasOwn.call( event, \"type\" ) ? event.type : event,\n\t\t\tnamespaces = hasOwn.call( event, \"namespace\" ) ? event.namespace.split( \".\" ) : [];\n\n\t\tcur = tmp = elem = elem || document;\n\n\t\t// Don't do events on text and comment nodes\n\t\tif ( elem.nodeType === 3 || elem.nodeType === 8 ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// focus/blur morphs to focusin/out; ensure we're not firing them right now\n\t\tif ( rfocusMorph.test( type + jQuery.event.triggered ) ) {\n\t\t\treturn;\n\t\t}\n\n\t\tif ( type.indexOf( \".\" ) > -1 ) {\n\n\t\t\t// Namespaced trigger; create a regexp to match event type in handle()\n\t\t\tnamespaces = type.split( \".\" );\n\t\t\ttype = namespaces.shift();\n\t\t\tnamespaces.sort();\n\t\t}\n\t\tontype = type.indexOf( \":\" ) < 0 && \"on\" + type;\n\n\t\t// Caller can pass in a jQuery.Event object, Object, or just an event type string\n\t\tevent = event[ jQuery.expando ] ?\n\t\t\tevent :\n\t\t\tnew jQuery.Event( type, typeof event === \"object\" && event );\n\n\t\t// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)\n\t\tevent.isTrigger = onlyHandlers ? 2 : 3;\n\t\tevent.namespace = namespaces.join( \".\" );\n\t\tevent.rnamespace = event.namespace ?\n\t\t\tnew RegExp( \"(^|\\\\.)\" + namespaces.join( \"\\\\.(?:.*\\\\.|)\" ) + \"(\\\\.|$)\" ) :\n\t\t\tnull;\n\n\t\t// Clean up the event in case it is being reused\n\t\tevent.result = undefined;\n\t\tif ( !event.target ) {\n\t\t\tevent.target = elem;\n\t\t}\n\n\t\t// Clone any incoming data and prepend the event, creating the handler arg list\n\t\tdata = data == null ?\n\t\t\t[ event ] :\n\t\t\tjQuery.makeArray( data, [ event ] );\n\n\t\t// Allow special events to draw outside the lines\n\t\tspecial = jQuery.event.special[ type ] || {};\n\t\tif ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Determine event propagation path in advance, per W3C events spec (#9951)\n\t\t// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)\n\t\tif ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {\n\n\t\t\tbubbleType = special.delegateType || type;\n\t\t\tif ( !rfocusMorph.test( bubbleType + type ) ) {\n\t\t\t\tcur = cur.parentNode;\n\t\t\t}\n\t\t\tfor ( ; cur; cur = cur.parentNode ) {\n\t\t\t\teventPath.push( cur );\n\t\t\t\ttmp = cur;\n\t\t\t}\n\n\t\t\t// Only add window if we got to document (e.g., not plain obj or detached DOM)\n\t\t\tif ( tmp === ( elem.ownerDocument || document ) ) {\n\t\t\t\teventPath.push( tmp.defaultView || tmp.parentWindow || window );\n\t\t\t}\n\t\t}\n\n\t\t// Fire handlers on the event path\n\t\ti = 0;\n\t\twhile ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {\n\n\t\t\tevent.type = i > 1 ?\n\t\t\t\tbubbleType :\n\t\t\t\tspecial.bindType || type;\n\n\t\t\t// jQuery handler\n\t\t\thandle = ( dataPriv.get( cur, \"events\" ) || {} )[ event.type ] &&\n\t\t\t\tdataPriv.get( cur, \"handle\" );\n\t\t\tif ( handle ) {\n\t\t\t\thandle.apply( cur, data );\n\t\t\t}\n\n\t\t\t// Native handler\n\t\t\thandle = ontype && cur[ ontype ];\n\t\t\tif ( handle && handle.apply && acceptData( cur ) ) {\n\t\t\t\tevent.result = handle.apply( cur, data );\n\t\t\t\tif ( event.result === false ) {\n\t\t\t\t\tevent.preventDefault();\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tevent.type = type;\n\n\t\t// If nobody prevented the default action, do it now\n\t\tif ( !onlyHandlers && !event.isDefaultPrevented() ) {\n\n\t\t\tif ( ( !special._default ||\n\t\t\t\tspecial._default.apply( eventPath.pop(), data ) === false ) &&\n\t\t\t\tacceptData( elem ) ) {\n\n\t\t\t\t// Call a native DOM method on the target with the same name as the event.\n\t\t\t\t// Don't do default actions on window, that's where global variables be (#6170)\n\t\t\t\tif ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {\n\n\t\t\t\t\t// Don't re-trigger an onFOO event when we call its FOO() method\n\t\t\t\t\ttmp = elem[ ontype ];\n\n\t\t\t\t\tif ( tmp ) {\n\t\t\t\t\t\telem[ ontype ] = null;\n\t\t\t\t\t}\n\n\t\t\t\t\t// Prevent re-triggering of the same event, since we already bubbled it above\n\t\t\t\t\tjQuery.event.triggered = type;\n\t\t\t\t\telem[ type ]();\n\t\t\t\t\tjQuery.event.triggered = undefined;\n\n\t\t\t\t\tif ( tmp ) {\n\t\t\t\t\t\telem[ ontype ] = tmp;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn event.result;\n\t},\n\n\t// Piggyback on a donor event to simulate a different one\n\t// Used only for `focus(in | out)` events\n\tsimulate: function( type, elem, event ) {\n\t\tvar e = jQuery.extend(\n\t\t\tnew jQuery.Event(),\n\t\t\tevent,\n\t\t\t{\n\t\t\t\ttype: type,\n\t\t\t\tisSimulated: true\n\t\t\t}\n\t\t);\n\n\t\tjQuery.event.trigger( e, null, elem );\n\t}\n\n} );\n\njQuery.fn.extend( {\n\n\ttrigger: function( type, data ) {\n\t\treturn this.each( function() {\n\t\t\tjQuery.event.trigger( type, data, this );\n\t\t} );\n\t},\n\ttriggerHandler: function( type, data ) {\n\t\tvar elem = this[ 0 ];\n\t\tif ( elem ) {\n\t\t\treturn jQuery.event.trigger( type, data, elem, true );\n\t\t}\n\t}\n} );\n\n\njQuery.each( ( \"blur focus focusin focusout resize scroll click dblclick \" +\n\t\"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave \" +\n\t\"change select submit keydown keypress keyup contextmenu\" ).split( \" \" ),\n\tfunction( i, name ) {\n\n\t// Handle event binding\n\tjQuery.fn[ name ] = function( data, fn ) {\n\t\treturn arguments.length > 0 ?\n\t\t\tthis.on( name, null, data, fn ) :\n\t\t\tthis.trigger( name );\n\t};\n} );\n\njQuery.fn.extend( {\n\thover: function( fnOver, fnOut ) {\n\t\treturn this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );\n\t}\n} );\n\n\n\n\nsupport.focusin = \"onfocusin\" in window;\n\n\n// Support: Firefox <=44\n// Firefox doesn't have focus(in | out) events\n// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787\n//\n// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1\n// focus(in | out) events fire after focus & blur events,\n// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order\n// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857\nif ( !support.focusin ) {\n\tjQuery.each( { focus: \"focusin\", blur: \"focusout\" }, function( orig, fix ) {\n\n\t\t// Attach a single capturing handler on the document while someone wants focusin/focusout\n\t\tvar handler = function( event ) {\n\t\t\tjQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );\n\t\t};\n\n\t\tjQuery.event.special[ fix ] = {\n\t\t\tsetup: function() {\n\t\t\t\tvar doc = this.ownerDocument || this,\n\t\t\t\t\tattaches = dataPriv.access( doc, fix );\n\n\t\t\t\tif ( !attaches ) {\n\t\t\t\t\tdoc.addEventListener( orig, handler, true );\n\t\t\t\t}\n\t\t\t\tdataPriv.access( doc, fix, ( attaches || 0 ) + 1 );\n\t\t\t},\n\t\t\tteardown: function() {\n\t\t\t\tvar doc = this.ownerDocument || this,\n\t\t\t\t\tattaches = dataPriv.access( doc, fix ) - 1;\n\n\t\t\t\tif ( !attaches ) {\n\t\t\t\t\tdoc.removeEventListener( orig, handler, true );\n\t\t\t\t\tdataPriv.remove( doc, fix );\n\n\t\t\t\t} else {\n\t\t\t\t\tdataPriv.access( doc, fix, attaches );\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\t} );\n}\nvar location = window.location;\n\nvar nonce = jQuery.now();\n\nvar rquery = ( /\\?/ );\n\n\n\n// Cross-browser xml parsing\njQuery.parseXML = function( data ) {\n\tvar xml;\n\tif ( !data || typeof data !== \"string\" ) {\n\t\treturn null;\n\t}\n\n\t// Support: IE 9 - 11 only\n\t// IE throws on parseFromString with invalid input.\n\ttry {\n\t\txml = ( new window.DOMParser() ).parseFromString( data, \"text/xml\" );\n\t} catch ( e ) {\n\t\txml = undefined;\n\t}\n\n\tif ( !xml || xml.getElementsByTagName( \"parsererror\" ).length ) {\n\t\tjQuery.error( \"Invalid XML: \" + data );\n\t}\n\treturn xml;\n};\n\n\nvar\n\trbracket = /\\[\\]$/,\n\trCRLF = /\\r?\\n/g,\n\trsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,\n\trsubmittable = /^(?:input|select|textarea|keygen)/i;\n\nfunction buildParams( prefix, obj, traditional, add ) {\n\tvar name;\n\n\tif ( Array.isArray( obj ) ) {\n\n\t\t// Serialize array item.\n\t\tjQuery.each( obj, function( i, v ) {\n\t\t\tif ( traditional || rbracket.test( prefix ) ) {\n\n\t\t\t\t// Treat each array item as a scalar.\n\t\t\t\tadd( prefix, v );\n\n\t\t\t} else {\n\n\t\t\t\t// Item is non-scalar (array or object), encode its numeric index.\n\t\t\t\tbuildParams(\n\t\t\t\t\tprefix + \"[\" + ( typeof v === \"object\" && v != null ? i : \"\" ) + \"]\",\n\t\t\t\t\tv,\n\t\t\t\t\ttraditional,\n\t\t\t\t\tadd\n\t\t\t\t);\n\t\t\t}\n\t\t} );\n\n\t} else if ( !traditional && jQuery.type( obj ) === \"object\" ) {\n\n\t\t// Serialize object item.\n\t\tfor ( name in obj ) {\n\t\t\tbuildParams( prefix + \"[\" + name + \"]\", obj[ name ], traditional, add );\n\t\t}\n\n\t} else {\n\n\t\t// Serialize scalar item.\n\t\tadd( prefix, obj );\n\t}\n}\n\n// Serialize an array of form elements or a set of\n// key/values into a query string\njQuery.param = function( a, traditional ) {\n\tvar prefix,\n\t\ts = [],\n\t\tadd = function( key, valueOrFunction ) {\n\n\t\t\t// If value is a function, invoke it and use its return value\n\t\t\tvar value = jQuery.isFunction( valueOrFunction ) ?\n\t\t\t\tvalueOrFunction() :\n\t\t\t\tvalueOrFunction;\n\n\t\t\ts[ s.length ] = encodeURIComponent( key ) + \"=\" +\n\t\t\t\tencodeURIComponent( value == null ? \"\" : value );\n\t\t};\n\n\t// If an array was passed in, assume that it is an array of form elements.\n\tif ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {\n\n\t\t// Serialize the form elements\n\t\tjQuery.each( a, function() {\n\t\t\tadd( this.name, this.value );\n\t\t} );\n\n\t} else {\n\n\t\t// If traditional, encode the \"old\" way (the way 1.3.2 or older\n\t\t// did it), otherwise encode params recursively.\n\t\tfor ( prefix in a ) {\n\t\t\tbuildParams( prefix, a[ prefix ], traditional, add );\n\t\t}\n\t}\n\n\t// Return the resulting serialization\n\treturn s.join( \"&\" );\n};\n\njQuery.fn.extend( {\n\tserialize: function() {\n\t\treturn jQuery.param( this.serializeArray() );\n\t},\n\tserializeArray: function() {\n\t\treturn this.map( function() {\n\n\t\t\t// Can add propHook for \"elements\" to filter or add form elements\n\t\t\tvar elements = jQuery.prop( this, \"elements\" );\n\t\t\treturn elements ? jQuery.makeArray( elements ) : this;\n\t\t} )\n\t\t.filter( function() {\n\t\t\tvar type = this.type;\n\n\t\t\t// Use .is( \":disabled\" ) so that fieldset[disabled] works\n\t\t\treturn this.name && !jQuery( this ).is( \":disabled\" ) &&\n\t\t\t\trsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&\n\t\t\t\t( this.checked || !rcheckableType.test( type ) );\n\t\t} )\n\t\t.map( function( i, elem ) {\n\t\t\tvar val = jQuery( this ).val();\n\n\t\t\tif ( val == null ) {\n\t\t\t\treturn null;\n\t\t\t}\n\n\t\t\tif ( Array.isArray( val ) ) {\n\t\t\t\treturn jQuery.map( val, function( val ) {\n\t\t\t\t\treturn { name: elem.name, value: val.replace( rCRLF, \"\\r\\n\" ) };\n\t\t\t\t} );\n\t\t\t}\n\n\t\t\treturn { name: elem.name, value: val.replace( rCRLF, \"\\r\\n\" ) };\n\t\t} ).get();\n\t}\n} );\n\n\nvar\n\tr20 = /%20/g,\n\trhash = /#.*$/,\n\trantiCache = /([?&])_=[^&]*/,\n\trheaders = /^(.*?):[ \\t]*([^\\r\\n]*)$/mg,\n\n\t// #7653, #8125, #8152: local protocol detection\n\trlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,\n\trnoContent = /^(?:GET|HEAD)$/,\n\trprotocol = /^\\/\\//,\n\n\t/* Prefilters\n\t * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)\n\t * 2) These are called:\n\t *    - BEFORE asking for a transport\n\t *    - AFTER param serialization (s.data is a string if s.processData is true)\n\t * 3) key is the dataType\n\t * 4) the catchall symbol \"*\" can be used\n\t * 5) execution will start with transport dataType and THEN continue down to \"*\" if needed\n\t */\n\tprefilters = {},\n\n\t/* Transports bindings\n\t * 1) key is the dataType\n\t * 2) the catchall symbol \"*\" can be used\n\t * 3) selection will start with transport dataType and THEN go to \"*\" if needed\n\t */\n\ttransports = {},\n\n\t// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression\n\tallTypes = \"*/\".concat( \"*\" ),\n\n\t// Anchor tag for parsing the document origin\n\toriginAnchor = document.createElement( \"a\" );\n\toriginAnchor.href = location.href;\n\n// Base \"constructor\" for jQuery.ajaxPrefilter and jQuery.ajaxTransport\nfunction addToPrefiltersOrTransports( structure ) {\n\n\t// dataTypeExpression is optional and defaults to \"*\"\n\treturn function( dataTypeExpression, func ) {\n\n\t\tif ( typeof dataTypeExpression !== \"string\" ) {\n\t\t\tfunc = dataTypeExpression;\n\t\t\tdataTypeExpression = \"*\";\n\t\t}\n\n\t\tvar dataType,\n\t\t\ti = 0,\n\t\t\tdataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];\n\n\t\tif ( jQuery.isFunction( func ) ) {\n\n\t\t\t// For each dataType in the dataTypeExpression\n\t\t\twhile ( ( dataType = dataTypes[ i++ ] ) ) {\n\n\t\t\t\t// Prepend if requested\n\t\t\t\tif ( dataType[ 0 ] === \"+\" ) {\n\t\t\t\t\tdataType = dataType.slice( 1 ) || \"*\";\n\t\t\t\t\t( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );\n\n\t\t\t\t// Otherwise append\n\t\t\t\t} else {\n\t\t\t\t\t( structure[ dataType ] = structure[ dataType ] || [] ).push( func );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t};\n}\n\n// Base inspection function for prefilters and transports\nfunction inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {\n\n\tvar inspected = {},\n\t\tseekingTransport = ( structure === transports );\n\n\tfunction inspect( dataType ) {\n\t\tvar selected;\n\t\tinspected[ dataType ] = true;\n\t\tjQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {\n\t\t\tvar dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );\n\t\t\tif ( typeof dataTypeOrTransport === \"string\" &&\n\t\t\t\t!seekingTransport && !inspected[ dataTypeOrTransport ] ) {\n\n\t\t\t\toptions.dataTypes.unshift( dataTypeOrTransport );\n\t\t\t\tinspect( dataTypeOrTransport );\n\t\t\t\treturn false;\n\t\t\t} else if ( seekingTransport ) {\n\t\t\t\treturn !( selected = dataTypeOrTransport );\n\t\t\t}\n\t\t} );\n\t\treturn selected;\n\t}\n\n\treturn inspect( options.dataTypes[ 0 ] ) || !inspected[ \"*\" ] && inspect( \"*\" );\n}\n\n// A special extend for ajax options\n// that takes \"flat\" options (not to be deep extended)\n// Fixes #9887\nfunction ajaxExtend( target, src ) {\n\tvar key, deep,\n\t\tflatOptions = jQuery.ajaxSettings.flatOptions || {};\n\n\tfor ( key in src ) {\n\t\tif ( src[ key ] !== undefined ) {\n\t\t\t( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];\n\t\t}\n\t}\n\tif ( deep ) {\n\t\tjQuery.extend( true, target, deep );\n\t}\n\n\treturn target;\n}\n\n/* Handles responses to an ajax request:\n * - finds the right dataType (mediates between content-type and expected dataType)\n * - returns the corresponding response\n */\nfunction ajaxHandleResponses( s, jqXHR, responses ) {\n\n\tvar ct, type, finalDataType, firstDataType,\n\t\tcontents = s.contents,\n\t\tdataTypes = s.dataTypes;\n\n\t// Remove auto dataType and get content-type in the process\n\twhile ( dataTypes[ 0 ] === \"*\" ) {\n\t\tdataTypes.shift();\n\t\tif ( ct === undefined ) {\n\t\t\tct = s.mimeType || jqXHR.getResponseHeader( \"Content-Type\" );\n\t\t}\n\t}\n\n\t// Check if we're dealing with a known content-type\n\tif ( ct ) {\n\t\tfor ( type in contents ) {\n\t\t\tif ( contents[ type ] && contents[ type ].test( ct ) ) {\n\t\t\t\tdataTypes.unshift( type );\n\t\t\t\tbreak;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Check to see if we have a response for the expected dataType\n\tif ( dataTypes[ 0 ] in responses ) {\n\t\tfinalDataType = dataTypes[ 0 ];\n\t} else {\n\n\t\t// Try convertible dataTypes\n\t\tfor ( type in responses ) {\n\t\t\tif ( !dataTypes[ 0 ] || s.converters[ type + \" \" + dataTypes[ 0 ] ] ) {\n\t\t\t\tfinalDataType = type;\n\t\t\t\tbreak;\n\t\t\t}\n\t\t\tif ( !firstDataType ) {\n\t\t\t\tfirstDataType = type;\n\t\t\t}\n\t\t}\n\n\t\t// Or just use first one\n\t\tfinalDataType = finalDataType || firstDataType;\n\t}\n\n\t// If we found a dataType\n\t// We add the dataType to the list if needed\n\t// and return the corresponding response\n\tif ( finalDataType ) {\n\t\tif ( finalDataType !== dataTypes[ 0 ] ) {\n\t\t\tdataTypes.unshift( finalDataType );\n\t\t}\n\t\treturn responses[ finalDataType ];\n\t}\n}\n\n/* Chain conversions given the request and the original response\n * Also sets the responseXXX fields on the jqXHR instance\n */\nfunction ajaxConvert( s, response, jqXHR, isSuccess ) {\n\tvar conv2, current, conv, tmp, prev,\n\t\tconverters = {},\n\n\t\t// Work with a copy of dataTypes in case we need to modify it for conversion\n\t\tdataTypes = s.dataTypes.slice();\n\n\t// Create converters map with lowercased keys\n\tif ( dataTypes[ 1 ] ) {\n\t\tfor ( conv in s.converters ) {\n\t\t\tconverters[ conv.toLowerCase() ] = s.converters[ conv ];\n\t\t}\n\t}\n\n\tcurrent = dataTypes.shift();\n\n\t// Convert to each sequential dataType\n\twhile ( current ) {\n\n\t\tif ( s.responseFields[ current ] ) {\n\t\t\tjqXHR[ s.responseFields[ current ] ] = response;\n\t\t}\n\n\t\t// Apply the dataFilter if provided\n\t\tif ( !prev && isSuccess && s.dataFilter ) {\n\t\t\tresponse = s.dataFilter( response, s.dataType );\n\t\t}\n\n\t\tprev = current;\n\t\tcurrent = dataTypes.shift();\n\n\t\tif ( current ) {\n\n\t\t\t// There's only work to do if current dataType is non-auto\n\t\t\tif ( current === \"*\" ) {\n\n\t\t\t\tcurrent = prev;\n\n\t\t\t// Convert response if prev dataType is non-auto and differs from current\n\t\t\t} else if ( prev !== \"*\" && prev !== current ) {\n\n\t\t\t\t// Seek a direct converter\n\t\t\t\tconv = converters[ prev + \" \" + current ] || converters[ \"* \" + current ];\n\n\t\t\t\t// If none found, seek a pair\n\t\t\t\tif ( !conv ) {\n\t\t\t\t\tfor ( conv2 in converters ) {\n\n\t\t\t\t\t\t// If conv2 outputs current\n\t\t\t\t\t\ttmp = conv2.split( \" \" );\n\t\t\t\t\t\tif ( tmp[ 1 ] === current ) {\n\n\t\t\t\t\t\t\t// If prev can be converted to accepted input\n\t\t\t\t\t\t\tconv = converters[ prev + \" \" + tmp[ 0 ] ] ||\n\t\t\t\t\t\t\t\tconverters[ \"* \" + tmp[ 0 ] ];\n\t\t\t\t\t\t\tif ( conv ) {\n\n\t\t\t\t\t\t\t\t// Condense equivalence converters\n\t\t\t\t\t\t\t\tif ( conv === true ) {\n\t\t\t\t\t\t\t\t\tconv = converters[ conv2 ];\n\n\t\t\t\t\t\t\t\t// Otherwise, insert the intermediate dataType\n\t\t\t\t\t\t\t\t} else if ( converters[ conv2 ] !== true ) {\n\t\t\t\t\t\t\t\t\tcurrent = tmp[ 0 ];\n\t\t\t\t\t\t\t\t\tdataTypes.unshift( tmp[ 1 ] );\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Apply converter (if not an equivalence)\n\t\t\t\tif ( conv !== true ) {\n\n\t\t\t\t\t// Unless errors are allowed to bubble, catch and return them\n\t\t\t\t\tif ( conv && s.throws ) {\n\t\t\t\t\t\tresponse = conv( response );\n\t\t\t\t\t} else {\n\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\tresponse = conv( response );\n\t\t\t\t\t\t} catch ( e ) {\n\t\t\t\t\t\t\treturn {\n\t\t\t\t\t\t\t\tstate: \"parsererror\",\n\t\t\t\t\t\t\t\terror: conv ? e : \"No conversion from \" + prev + \" to \" + current\n\t\t\t\t\t\t\t};\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\treturn { state: \"success\", data: response };\n}\n\njQuery.extend( {\n\n\t// Counter for holding the number of active queries\n\tactive: 0,\n\n\t// Last-Modified header cache for next request\n\tlastModified: {},\n\tetag: {},\n\n\tajaxSettings: {\n\t\turl: location.href,\n\t\ttype: \"GET\",\n\t\tisLocal: rlocalProtocol.test( location.protocol ),\n\t\tglobal: true,\n\t\tprocessData: true,\n\t\tasync: true,\n\t\tcontentType: \"application/x-www-form-urlencoded; charset=UTF-8\",\n\n\t\t/*\n\t\ttimeout: 0,\n\t\tdata: null,\n\t\tdataType: null,\n\t\tusername: null,\n\t\tpassword: null,\n\t\tcache: null,\n\t\tthrows: false,\n\t\ttraditional: false,\n\t\theaders: {},\n\t\t*/\n\n\t\taccepts: {\n\t\t\t\"*\": allTypes,\n\t\t\ttext: \"text/plain\",\n\t\t\thtml: \"text/html\",\n\t\t\txml: \"application/xml, text/xml\",\n\t\t\tjson: \"application/json, text/javascript\"\n\t\t},\n\n\t\tcontents: {\n\t\t\txml: /\\bxml\\b/,\n\t\t\thtml: /\\bhtml/,\n\t\t\tjson: /\\bjson\\b/\n\t\t},\n\n\t\tresponseFields: {\n\t\t\txml: \"responseXML\",\n\t\t\ttext: \"responseText\",\n\t\t\tjson: \"responseJSON\"\n\t\t},\n\n\t\t// Data converters\n\t\t// Keys separate source (or catchall \"*\") and destination types with a single space\n\t\tconverters: {\n\n\t\t\t// Convert anything to text\n\t\t\t\"* text\": String,\n\n\t\t\t// Text to html (true = no transformation)\n\t\t\t\"text html\": true,\n\n\t\t\t// Evaluate text as a json expression\n\t\t\t\"text json\": JSON.parse,\n\n\t\t\t// Parse text as xml\n\t\t\t\"text xml\": jQuery.parseXML\n\t\t},\n\n\t\t// For options that shouldn't be deep extended:\n\t\t// you can add your own custom options here if\n\t\t// and when you create one that shouldn't be\n\t\t// deep extended (see ajaxExtend)\n\t\tflatOptions: {\n\t\t\turl: true,\n\t\t\tcontext: true\n\t\t}\n\t},\n\n\t// Creates a full fledged settings object into target\n\t// with both ajaxSettings and settings fields.\n\t// If target is omitted, writes into ajaxSettings.\n\tajaxSetup: function( target, settings ) {\n\t\treturn settings ?\n\n\t\t\t// Building a settings object\n\t\t\tajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :\n\n\t\t\t// Extending ajaxSettings\n\t\t\tajaxExtend( jQuery.ajaxSettings, target );\n\t},\n\n\tajaxPrefilter: addToPrefiltersOrTransports( prefilters ),\n\tajaxTransport: addToPrefiltersOrTransports( transports ),\n\n\t// Main method\n\tajax: function( url, options ) {\n\n\t\t// If url is an object, simulate pre-1.5 signature\n\t\tif ( typeof url === \"object\" ) {\n\t\t\toptions = url;\n\t\t\turl = undefined;\n\t\t}\n\n\t\t// Force options to be an object\n\t\toptions = options || {};\n\n\t\tvar transport,\n\n\t\t\t// URL without anti-cache param\n\t\t\tcacheURL,\n\n\t\t\t// Response headers\n\t\t\tresponseHeadersString,\n\t\t\tresponseHeaders,\n\n\t\t\t// timeout handle\n\t\t\ttimeoutTimer,\n\n\t\t\t// Url cleanup var\n\t\t\turlAnchor,\n\n\t\t\t// Request state (becomes false upon send and true upon completion)\n\t\t\tcompleted,\n\n\t\t\t// To know if global events are to be dispatched\n\t\t\tfireGlobals,\n\n\t\t\t// Loop variable\n\t\t\ti,\n\n\t\t\t// uncached part of the url\n\t\t\tuncached,\n\n\t\t\t// Create the final options object\n\t\t\ts = jQuery.ajaxSetup( {}, options ),\n\n\t\t\t// Callbacks context\n\t\t\tcallbackContext = s.context || s,\n\n\t\t\t// Context for global events is callbackContext if it is a DOM node or jQuery collection\n\t\t\tglobalEventContext = s.context &&\n\t\t\t\t( callbackContext.nodeType || callbackContext.jquery ) ?\n\t\t\t\t\tjQuery( callbackContext ) :\n\t\t\t\t\tjQuery.event,\n\n\t\t\t// Deferreds\n\t\t\tdeferred = jQuery.Deferred(),\n\t\t\tcompleteDeferred = jQuery.Callbacks( \"once memory\" ),\n\n\t\t\t// Status-dependent callbacks\n\t\t\tstatusCode = s.statusCode || {},\n\n\t\t\t// Headers (they are sent all at once)\n\t\t\trequestHeaders = {},\n\t\t\trequestHeadersNames = {},\n\n\t\t\t// Default abort message\n\t\t\tstrAbort = \"canceled\",\n\n\t\t\t// Fake xhr\n\t\t\tjqXHR = {\n\t\t\t\treadyState: 0,\n\n\t\t\t\t// Builds headers hashtable if needed\n\t\t\t\tgetResponseHeader: function( key ) {\n\t\t\t\t\tvar match;\n\t\t\t\t\tif ( completed ) {\n\t\t\t\t\t\tif ( !responseHeaders ) {\n\t\t\t\t\t\t\tresponseHeaders = {};\n\t\t\t\t\t\t\twhile ( ( match = rheaders.exec( responseHeadersString ) ) ) {\n\t\t\t\t\t\t\t\tresponseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tmatch = responseHeaders[ key.toLowerCase() ];\n\t\t\t\t\t}\n\t\t\t\t\treturn match == null ? null : match;\n\t\t\t\t},\n\n\t\t\t\t// Raw string\n\t\t\t\tgetAllResponseHeaders: function() {\n\t\t\t\t\treturn completed ? responseHeadersString : null;\n\t\t\t\t},\n\n\t\t\t\t// Caches the header\n\t\t\t\tsetRequestHeader: function( name, value ) {\n\t\t\t\t\tif ( completed == null ) {\n\t\t\t\t\t\tname = requestHeadersNames[ name.toLowerCase() ] =\n\t\t\t\t\t\t\trequestHeadersNames[ name.toLowerCase() ] || name;\n\t\t\t\t\t\trequestHeaders[ name ] = value;\n\t\t\t\t\t}\n\t\t\t\t\treturn this;\n\t\t\t\t},\n\n\t\t\t\t// Overrides response content-type header\n\t\t\t\toverrideMimeType: function( type ) {\n\t\t\t\t\tif ( completed == null ) {\n\t\t\t\t\t\ts.mimeType = type;\n\t\t\t\t\t}\n\t\t\t\t\treturn this;\n\t\t\t\t},\n\n\t\t\t\t// Status-dependent callbacks\n\t\t\t\tstatusCode: function( map ) {\n\t\t\t\t\tvar code;\n\t\t\t\t\tif ( map ) {\n\t\t\t\t\t\tif ( completed ) {\n\n\t\t\t\t\t\t\t// Execute the appropriate callbacks\n\t\t\t\t\t\t\tjqXHR.always( map[ jqXHR.status ] );\n\t\t\t\t\t\t} else {\n\n\t\t\t\t\t\t\t// Lazy-add the new callbacks in a way that preserves old ones\n\t\t\t\t\t\t\tfor ( code in map ) {\n\t\t\t\t\t\t\t\tstatusCode[ code ] = [ statusCode[ code ], map[ code ] ];\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\treturn this;\n\t\t\t\t},\n\n\t\t\t\t// Cancel the request\n\t\t\t\tabort: function( statusText ) {\n\t\t\t\t\tvar finalText = statusText || strAbort;\n\t\t\t\t\tif ( transport ) {\n\t\t\t\t\t\ttransport.abort( finalText );\n\t\t\t\t\t}\n\t\t\t\t\tdone( 0, finalText );\n\t\t\t\t\treturn this;\n\t\t\t\t}\n\t\t\t};\n\n\t\t// Attach deferreds\n\t\tdeferred.promise( jqXHR );\n\n\t\t// Add protocol if not provided (prefilters might expect it)\n\t\t// Handle falsy url in the settings object (#10093: consistency with old signature)\n\t\t// We also use the url parameter if available\n\t\ts.url = ( ( url || s.url || location.href ) + \"\" )\n\t\t\t.replace( rprotocol, location.protocol + \"//\" );\n\n\t\t// Alias method option to type as per ticket #12004\n\t\ts.type = options.method || options.type || s.method || s.type;\n\n\t\t// Extract dataTypes list\n\t\ts.dataTypes = ( s.dataType || \"*\" ).toLowerCase().match( rnothtmlwhite ) || [ \"\" ];\n\n\t\t// A cross-domain request is in order when the origin doesn't match the current origin.\n\t\tif ( s.crossDomain == null ) {\n\t\t\turlAnchor = document.createElement( \"a\" );\n\n\t\t\t// Support: IE <=8 - 11, Edge 12 - 13\n\t\t\t// IE throws exception on accessing the href property if url is malformed,\n\t\t\t// e.g. http://example.com:80x/\n\t\t\ttry {\n\t\t\t\turlAnchor.href = s.url;\n\n\t\t\t\t// Support: IE <=8 - 11 only\n\t\t\t\t// Anchor's host property isn't correctly set when s.url is relative\n\t\t\t\turlAnchor.href = urlAnchor.href;\n\t\t\t\ts.crossDomain = originAnchor.protocol + \"//\" + originAnchor.host !==\n\t\t\t\t\turlAnchor.protocol + \"//\" + urlAnchor.host;\n\t\t\t} catch ( e ) {\n\n\t\t\t\t// If there is an error parsing the URL, assume it is crossDomain,\n\t\t\t\t// it can be rejected by the transport if it is invalid\n\t\t\t\ts.crossDomain = true;\n\t\t\t}\n\t\t}\n\n\t\t// Convert data if not already a string\n\t\tif ( s.data && s.processData && typeof s.data !== \"string\" ) {\n\t\t\ts.data = jQuery.param( s.data, s.traditional );\n\t\t}\n\n\t\t// Apply prefilters\n\t\tinspectPrefiltersOrTransports( prefilters, s, options, jqXHR );\n\n\t\t// If request was aborted inside a prefilter, stop there\n\t\tif ( completed ) {\n\t\t\treturn jqXHR;\n\t\t}\n\n\t\t// We can fire global events as of now if asked to\n\t\t// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)\n\t\tfireGlobals = jQuery.event && s.global;\n\n\t\t// Watch for a new set of requests\n\t\tif ( fireGlobals && jQuery.active++ === 0 ) {\n\t\t\tjQuery.event.trigger( \"ajaxStart\" );\n\t\t}\n\n\t\t// Uppercase the type\n\t\ts.type = s.type.toUpperCase();\n\n\t\t// Determine if request has content\n\t\ts.hasContent = !rnoContent.test( s.type );\n\n\t\t// Save the URL in case we're toying with the If-Modified-Since\n\t\t// and/or If-None-Match header later on\n\t\t// Remove hash to simplify url manipulation\n\t\tcacheURL = s.url.replace( rhash, \"\" );\n\n\t\t// More options handling for requests with no content\n\t\tif ( !s.hasContent ) {\n\n\t\t\t// Remember the hash so we can put it back\n\t\t\tuncached = s.url.slice( cacheURL.length );\n\n\t\t\t// If data is available, append data to url\n\t\t\tif ( s.data ) {\n\t\t\t\tcacheURL += ( rquery.test( cacheURL ) ? \"&\" : \"?\" ) + s.data;\n\n\t\t\t\t// #9682: remove data so that it's not used in an eventual retry\n\t\t\t\tdelete s.data;\n\t\t\t}\n\n\t\t\t// Add or update anti-cache param if needed\n\t\t\tif ( s.cache === false ) {\n\t\t\t\tcacheURL = cacheURL.replace( rantiCache, \"$1\" );\n\t\t\t\tuncached = ( rquery.test( cacheURL ) ? \"&\" : \"?\" ) + \"_=\" + ( nonce++ ) + uncached;\n\t\t\t}\n\n\t\t\t// Put hash and anti-cache on the URL that will be requested (gh-1732)\n\t\t\ts.url = cacheURL + uncached;\n\n\t\t// Change '%20' to '+' if this is encoded form body content (gh-2658)\n\t\t} else if ( s.data && s.processData &&\n\t\t\t( s.contentType || \"\" ).indexOf( \"application/x-www-form-urlencoded\" ) === 0 ) {\n\t\t\ts.data = s.data.replace( r20, \"+\" );\n\t\t}\n\n\t\t// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.\n\t\tif ( s.ifModified ) {\n\t\t\tif ( jQuery.lastModified[ cacheURL ] ) {\n\t\t\t\tjqXHR.setRequestHeader( \"If-Modified-Since\", jQuery.lastModified[ cacheURL ] );\n\t\t\t}\n\t\t\tif ( jQuery.etag[ cacheURL ] ) {\n\t\t\t\tjqXHR.setRequestHeader( \"If-None-Match\", jQuery.etag[ cacheURL ] );\n\t\t\t}\n\t\t}\n\n\t\t// Set the correct header, if data is being sent\n\t\tif ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {\n\t\t\tjqXHR.setRequestHeader( \"Content-Type\", s.contentType );\n\t\t}\n\n\t\t// Set the Accepts header for the server, depending on the dataType\n\t\tjqXHR.setRequestHeader(\n\t\t\t\"Accept\",\n\t\t\ts.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?\n\t\t\t\ts.accepts[ s.dataTypes[ 0 ] ] +\n\t\t\t\t\t( s.dataTypes[ 0 ] !== \"*\" ? \", \" + allTypes + \"; q=0.01\" : \"\" ) :\n\t\t\t\ts.accepts[ \"*\" ]\n\t\t);\n\n\t\t// Check for headers option\n\t\tfor ( i in s.headers ) {\n\t\t\tjqXHR.setRequestHeader( i, s.headers[ i ] );\n\t\t}\n\n\t\t// Allow custom headers/mimetypes and early abort\n\t\tif ( s.beforeSend &&\n\t\t\t( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {\n\n\t\t\t// Abort if not done already and return\n\t\t\treturn jqXHR.abort();\n\t\t}\n\n\t\t// Aborting is no longer a cancellation\n\t\tstrAbort = \"abort\";\n\n\t\t// Install callbacks on deferreds\n\t\tcompleteDeferred.add( s.complete );\n\t\tjqXHR.done( s.success );\n\t\tjqXHR.fail( s.error );\n\n\t\t// Get transport\n\t\ttransport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );\n\n\t\t// If no transport, we auto-abort\n\t\tif ( !transport ) {\n\t\t\tdone( -1, \"No Transport\" );\n\t\t} else {\n\t\t\tjqXHR.readyState = 1;\n\n\t\t\t// Send global event\n\t\t\tif ( fireGlobals ) {\n\t\t\t\tglobalEventContext.trigger( \"ajaxSend\", [ jqXHR, s ] );\n\t\t\t}\n\n\t\t\t// If request was aborted inside ajaxSend, stop there\n\t\t\tif ( completed ) {\n\t\t\t\treturn jqXHR;\n\t\t\t}\n\n\t\t\t// Timeout\n\t\t\tif ( s.async && s.timeout > 0 ) {\n\t\t\t\ttimeoutTimer = window.setTimeout( function() {\n\t\t\t\t\tjqXHR.abort( \"timeout\" );\n\t\t\t\t}, s.timeout );\n\t\t\t}\n\n\t\t\ttry {\n\t\t\t\tcompleted = false;\n\t\t\t\ttransport.send( requestHeaders, done );\n\t\t\t} catch ( e ) {\n\n\t\t\t\t// Rethrow post-completion exceptions\n\t\t\t\tif ( completed ) {\n\t\t\t\t\tthrow e;\n\t\t\t\t}\n\n\t\t\t\t// Propagate others as results\n\t\t\t\tdone( -1, e );\n\t\t\t}\n\t\t}\n\n\t\t// Callback for when everything is done\n\t\tfunction done( status, nativeStatusText, responses, headers ) {\n\t\t\tvar isSuccess, success, error, response, modified,\n\t\t\t\tstatusText = nativeStatusText;\n\n\t\t\t// Ignore repeat invocations\n\t\t\tif ( completed ) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tcompleted = true;\n\n\t\t\t// Clear timeout if it exists\n\t\t\tif ( timeoutTimer ) {\n\t\t\t\twindow.clearTimeout( timeoutTimer );\n\t\t\t}\n\n\t\t\t// Dereference transport for early garbage collection\n\t\t\t// (no matter how long the jqXHR object will be used)\n\t\t\ttransport = undefined;\n\n\t\t\t// Cache response headers\n\t\t\tresponseHeadersString = headers || \"\";\n\n\t\t\t// Set readyState\n\t\t\tjqXHR.readyState = status > 0 ? 4 : 0;\n\n\t\t\t// Determine if successful\n\t\t\tisSuccess = status >= 200 && status < 300 || status === 304;\n\n\t\t\t// Get response data\n\t\t\tif ( responses ) {\n\t\t\t\tresponse = ajaxHandleResponses( s, jqXHR, responses );\n\t\t\t}\n\n\t\t\t// Convert no matter what (that way responseXXX fields are always set)\n\t\t\tresponse = ajaxConvert( s, response, jqXHR, isSuccess );\n\n\t\t\t// If successful, handle type chaining\n\t\t\tif ( isSuccess ) {\n\n\t\t\t\t// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.\n\t\t\t\tif ( s.ifModified ) {\n\t\t\t\t\tmodified = jqXHR.getResponseHeader( \"Last-Modified\" );\n\t\t\t\t\tif ( modified ) {\n\t\t\t\t\t\tjQuery.lastModified[ cacheURL ] = modified;\n\t\t\t\t\t}\n\t\t\t\t\tmodified = jqXHR.getResponseHeader( \"etag\" );\n\t\t\t\t\tif ( modified ) {\n\t\t\t\t\t\tjQuery.etag[ cacheURL ] = modified;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// if no content\n\t\t\t\tif ( status === 204 || s.type === \"HEAD\" ) {\n\t\t\t\t\tstatusText = \"nocontent\";\n\n\t\t\t\t// if not modified\n\t\t\t\t} else if ( status === 304 ) {\n\t\t\t\t\tstatusText = \"notmodified\";\n\n\t\t\t\t// If we have data, let's convert it\n\t\t\t\t} else {\n\t\t\t\t\tstatusText = response.state;\n\t\t\t\t\tsuccess = response.data;\n\t\t\t\t\terror = response.error;\n\t\t\t\t\tisSuccess = !error;\n\t\t\t\t}\n\t\t\t} else {\n\n\t\t\t\t// Extract error from statusText and normalize for non-aborts\n\t\t\t\terror = statusText;\n\t\t\t\tif ( status || !statusText ) {\n\t\t\t\t\tstatusText = \"error\";\n\t\t\t\t\tif ( status < 0 ) {\n\t\t\t\t\t\tstatus = 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Set data for the fake xhr object\n\t\t\tjqXHR.status = status;\n\t\t\tjqXHR.statusText = ( nativeStatusText || statusText ) + \"\";\n\n\t\t\t// Success/Error\n\t\t\tif ( isSuccess ) {\n\t\t\t\tdeferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );\n\t\t\t} else {\n\t\t\t\tdeferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );\n\t\t\t}\n\n\t\t\t// Status-dependent callbacks\n\t\t\tjqXHR.statusCode( statusCode );\n\t\t\tstatusCode = undefined;\n\n\t\t\tif ( fireGlobals ) {\n\t\t\t\tglobalEventContext.trigger( isSuccess ? \"ajaxSuccess\" : \"ajaxError\",\n\t\t\t\t\t[ jqXHR, s, isSuccess ? success : error ] );\n\t\t\t}\n\n\t\t\t// Complete\n\t\t\tcompleteDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );\n\n\t\t\tif ( fireGlobals ) {\n\t\t\t\tglobalEventContext.trigger( \"ajaxComplete\", [ jqXHR, s ] );\n\n\t\t\t\t// Handle the global AJAX counter\n\t\t\t\tif ( !( --jQuery.active ) ) {\n\t\t\t\t\tjQuery.event.trigger( \"ajaxStop\" );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\treturn jqXHR;\n\t},\n\n\tgetJSON: function( url, data, callback ) {\n\t\treturn jQuery.get( url, data, callback, \"json\" );\n\t},\n\n\tgetScript: function( url, callback ) {\n\t\treturn jQuery.get( url, undefined, callback, \"script\" );\n\t}\n} );\n\njQuery.each( [ \"get\", \"post\" ], function( i, method ) {\n\tjQuery[ method ] = function( url, data, callback, type ) {\n\n\t\t// Shift arguments if data argument was omitted\n\t\tif ( jQuery.isFunction( data ) ) {\n\t\t\ttype = type || callback;\n\t\t\tcallback = data;\n\t\t\tdata = undefined;\n\t\t}\n\n\t\t// The url can be an options object (which then must have .url)\n\t\treturn jQuery.ajax( jQuery.extend( {\n\t\t\turl: url,\n\t\t\ttype: method,\n\t\t\tdataType: type,\n\t\t\tdata: data,\n\t\t\tsuccess: callback\n\t\t}, jQuery.isPlainObject( url ) && url ) );\n\t};\n} );\n\n\njQuery._evalUrl = function( url ) {\n\treturn jQuery.ajax( {\n\t\turl: url,\n\n\t\t// Make this explicit, since user can override this through ajaxSetup (#11264)\n\t\ttype: \"GET\",\n\t\tdataType: \"script\",\n\t\tcache: true,\n\t\tasync: false,\n\t\tglobal: false,\n\t\t\"throws\": true\n\t} );\n};\n\n\njQuery.fn.extend( {\n\twrapAll: function( html ) {\n\t\tvar wrap;\n\n\t\tif ( this[ 0 ] ) {\n\t\t\tif ( jQuery.isFunction( html ) ) {\n\t\t\t\thtml = html.call( this[ 0 ] );\n\t\t\t}\n\n\t\t\t// The elements to wrap the target around\n\t\t\twrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );\n\n\t\t\tif ( this[ 0 ].parentNode ) {\n\t\t\t\twrap.insertBefore( this[ 0 ] );\n\t\t\t}\n\n\t\t\twrap.map( function() {\n\t\t\t\tvar elem = this;\n\n\t\t\t\twhile ( elem.firstElementChild ) {\n\t\t\t\t\telem = elem.firstElementChild;\n\t\t\t\t}\n\n\t\t\t\treturn elem;\n\t\t\t} ).append( this );\n\t\t}\n\n\t\treturn this;\n\t},\n\n\twrapInner: function( html ) {\n\t\tif ( jQuery.isFunction( html ) ) {\n\t\t\treturn this.each( function( i ) {\n\t\t\t\tjQuery( this ).wrapInner( html.call( this, i ) );\n\t\t\t} );\n\t\t}\n\n\t\treturn this.each( function() {\n\t\t\tvar self = jQuery( this ),\n\t\t\t\tcontents = self.contents();\n\n\t\t\tif ( contents.length ) {\n\t\t\t\tcontents.wrapAll( html );\n\n\t\t\t} else {\n\t\t\t\tself.append( html );\n\t\t\t}\n\t\t} );\n\t},\n\n\twrap: function( html ) {\n\t\tvar isFunction = jQuery.isFunction( html );\n\n\t\treturn this.each( function( i ) {\n\t\t\tjQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );\n\t\t} );\n\t},\n\n\tunwrap: function( selector ) {\n\t\tthis.parent( selector ).not( \"body\" ).each( function() {\n\t\t\tjQuery( this ).replaceWith( this.childNodes );\n\t\t} );\n\t\treturn this;\n\t}\n} );\n\n\njQuery.expr.pseudos.hidden = function( elem ) {\n\treturn !jQuery.expr.pseudos.visible( elem );\n};\njQuery.expr.pseudos.visible = function( elem ) {\n\treturn !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );\n};\n\n\n\n\njQuery.ajaxSettings.xhr = function() {\n\ttry {\n\t\treturn new window.XMLHttpRequest();\n\t} catch ( e ) {}\n};\n\nvar xhrSuccessStatus = {\n\n\t\t// File protocol always yields status code 0, assume 200\n\t\t0: 200,\n\n\t\t// Support: IE <=9 only\n\t\t// #1450: sometimes IE returns 1223 when it should be 204\n\t\t1223: 204\n\t},\n\txhrSupported = jQuery.ajaxSettings.xhr();\n\nsupport.cors = !!xhrSupported && ( \"withCredentials\" in xhrSupported );\nsupport.ajax = xhrSupported = !!xhrSupported;\n\njQuery.ajaxTransport( function( options ) {\n\tvar callback, errorCallback;\n\n\t// Cross domain only allowed if supported through XMLHttpRequest\n\tif ( support.cors || xhrSupported && !options.crossDomain ) {\n\t\treturn {\n\t\t\tsend: function( headers, complete ) {\n\t\t\t\tvar i,\n\t\t\t\t\txhr = options.xhr();\n\n\t\t\t\txhr.open(\n\t\t\t\t\toptions.type,\n\t\t\t\t\toptions.url,\n\t\t\t\t\toptions.async,\n\t\t\t\t\toptions.username,\n\t\t\t\t\toptions.password\n\t\t\t\t);\n\n\t\t\t\t// Apply custom fields if provided\n\t\t\t\tif ( options.xhrFields ) {\n\t\t\t\t\tfor ( i in options.xhrFields ) {\n\t\t\t\t\t\txhr[ i ] = options.xhrFields[ i ];\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Override mime type if needed\n\t\t\t\tif ( options.mimeType && xhr.overrideMimeType ) {\n\t\t\t\t\txhr.overrideMimeType( options.mimeType );\n\t\t\t\t}\n\n\t\t\t\t// X-Requested-With header\n\t\t\t\t// For cross-domain requests, seeing as conditions for a preflight are\n\t\t\t\t// akin to a jigsaw puzzle, we simply never set it to be sure.\n\t\t\t\t// (it can always be set on a per-request basis or even using ajaxSetup)\n\t\t\t\t// For same-domain requests, won't change header if already provided.\n\t\t\t\tif ( !options.crossDomain && !headers[ \"X-Requested-With\" ] ) {\n\t\t\t\t\theaders[ \"X-Requested-With\" ] = \"XMLHttpRequest\";\n\t\t\t\t}\n\n\t\t\t\t// Set headers\n\t\t\t\tfor ( i in headers ) {\n\t\t\t\t\txhr.setRequestHeader( i, headers[ i ] );\n\t\t\t\t}\n\n\t\t\t\t// Callback\n\t\t\t\tcallback = function( type ) {\n\t\t\t\t\treturn function() {\n\t\t\t\t\t\tif ( callback ) {\n\t\t\t\t\t\t\tcallback = errorCallback = xhr.onload =\n\t\t\t\t\t\t\t\txhr.onerror = xhr.onabort = xhr.onreadystatechange = null;\n\n\t\t\t\t\t\t\tif ( type === \"abort\" ) {\n\t\t\t\t\t\t\t\txhr.abort();\n\t\t\t\t\t\t\t} else if ( type === \"error\" ) {\n\n\t\t\t\t\t\t\t\t// Support: IE <=9 only\n\t\t\t\t\t\t\t\t// On a manual native abort, IE9 throws\n\t\t\t\t\t\t\t\t// errors on any property access that is not readyState\n\t\t\t\t\t\t\t\tif ( typeof xhr.status !== \"number\" ) {\n\t\t\t\t\t\t\t\t\tcomplete( 0, \"error\" );\n\t\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\t\tcomplete(\n\n\t\t\t\t\t\t\t\t\t\t// File: protocol always yields status 0; see #8605, #14207\n\t\t\t\t\t\t\t\t\t\txhr.status,\n\t\t\t\t\t\t\t\t\t\txhr.statusText\n\t\t\t\t\t\t\t\t\t);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t\tcomplete(\n\t\t\t\t\t\t\t\t\txhrSuccessStatus[ xhr.status ] || xhr.status,\n\t\t\t\t\t\t\t\t\txhr.statusText,\n\n\t\t\t\t\t\t\t\t\t// Support: IE <=9 only\n\t\t\t\t\t\t\t\t\t// IE9 has no XHR2 but throws on binary (trac-11426)\n\t\t\t\t\t\t\t\t\t// For XHR2 non-text, let the caller handle it (gh-2498)\n\t\t\t\t\t\t\t\t\t( xhr.responseType || \"text\" ) !== \"text\"  ||\n\t\t\t\t\t\t\t\t\ttypeof xhr.responseText !== \"string\" ?\n\t\t\t\t\t\t\t\t\t\t{ binary: xhr.response } :\n\t\t\t\t\t\t\t\t\t\t{ text: xhr.responseText },\n\t\t\t\t\t\t\t\t\txhr.getAllResponseHeaders()\n\t\t\t\t\t\t\t\t);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t};\n\t\t\t\t};\n\n\t\t\t\t// Listen to events\n\t\t\t\txhr.onload = callback();\n\t\t\t\terrorCallback = xhr.onerror = callback( \"error\" );\n\n\t\t\t\t// Support: IE 9 only\n\t\t\t\t// Use onreadystatechange to replace onabort\n\t\t\t\t// to handle uncaught aborts\n\t\t\t\tif ( xhr.onabort !== undefined ) {\n\t\t\t\t\txhr.onabort = errorCallback;\n\t\t\t\t} else {\n\t\t\t\t\txhr.onreadystatechange = function() {\n\n\t\t\t\t\t\t// Check readyState before timeout as it changes\n\t\t\t\t\t\tif ( xhr.readyState === 4 ) {\n\n\t\t\t\t\t\t\t// Allow onerror to be called first,\n\t\t\t\t\t\t\t// but that will not handle a native abort\n\t\t\t\t\t\t\t// Also, save errorCallback to a variable\n\t\t\t\t\t\t\t// as xhr.onerror cannot be accessed\n\t\t\t\t\t\t\twindow.setTimeout( function() {\n\t\t\t\t\t\t\t\tif ( callback ) {\n\t\t\t\t\t\t\t\t\terrorCallback();\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} );\n\t\t\t\t\t\t}\n\t\t\t\t\t};\n\t\t\t\t}\n\n\t\t\t\t// Create the abort callback\n\t\t\t\tcallback = callback( \"abort\" );\n\n\t\t\t\ttry {\n\n\t\t\t\t\t// Do send the request (this may raise an exception)\n\t\t\t\t\txhr.send( options.hasContent && options.data || null );\n\t\t\t\t} catch ( e ) {\n\n\t\t\t\t\t// #14683: Only rethrow if this hasn't been notified as an error yet\n\t\t\t\t\tif ( callback ) {\n\t\t\t\t\t\tthrow e;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t},\n\n\t\t\tabort: function() {\n\t\t\t\tif ( callback ) {\n\t\t\t\t\tcallback();\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\t}\n} );\n\n\n\n\n// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)\njQuery.ajaxPrefilter( function( s ) {\n\tif ( s.crossDomain ) {\n\t\ts.contents.script = false;\n\t}\n} );\n\n// Install script dataType\njQuery.ajaxSetup( {\n\taccepts: {\n\t\tscript: \"text/javascript, application/javascript, \" +\n\t\t\t\"application/ecmascript, application/x-ecmascript\"\n\t},\n\tcontents: {\n\t\tscript: /\\b(?:java|ecma)script\\b/\n\t},\n\tconverters: {\n\t\t\"text script\": function( text ) {\n\t\t\tjQuery.globalEval( text );\n\t\t\treturn text;\n\t\t}\n\t}\n} );\n\n// Handle cache's special case and crossDomain\njQuery.ajaxPrefilter( \"script\", function( s ) {\n\tif ( s.cache === undefined ) {\n\t\ts.cache = false;\n\t}\n\tif ( s.crossDomain ) {\n\t\ts.type = \"GET\";\n\t}\n} );\n\n// Bind script tag hack transport\njQuery.ajaxTransport( \"script\", function( s ) {\n\n\t// This transport only deals with cross domain requests\n\tif ( s.crossDomain ) {\n\t\tvar script, callback;\n\t\treturn {\n\t\t\tsend: function( _, complete ) {\n\t\t\t\tscript = jQuery( \"<script>\" ).prop( {\n\t\t\t\t\tcharset: s.scriptCharset,\n\t\t\t\t\tsrc: s.url\n\t\t\t\t} ).on(\n\t\t\t\t\t\"load error\",\n\t\t\t\t\tcallback = function( evt ) {\n\t\t\t\t\t\tscript.remove();\n\t\t\t\t\t\tcallback = null;\n\t\t\t\t\t\tif ( evt ) {\n\t\t\t\t\t\t\tcomplete( evt.type === \"error\" ? 404 : 200, evt.type );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t);\n\n\t\t\t\t// Use native DOM manipulation to avoid our domManip AJAX trickery\n\t\t\t\tdocument.head.appendChild( script[ 0 ] );\n\t\t\t},\n\t\t\tabort: function() {\n\t\t\t\tif ( callback ) {\n\t\t\t\t\tcallback();\n\t\t\t\t}\n\t\t\t}\n\t\t};\n\t}\n} );\n\n\n\n\nvar oldCallbacks = [],\n\trjsonp = /(=)\\?(?=&|$)|\\?\\?/;\n\n// Default jsonp settings\njQuery.ajaxSetup( {\n\tjsonp: \"callback\",\n\tjsonpCallback: function() {\n\t\tvar callback = oldCallbacks.pop() || ( jQuery.expando + \"_\" + ( nonce++ ) );\n\t\tthis[ callback ] = true;\n\t\treturn callback;\n\t}\n} );\n\n// Detect, normalize options and install callbacks for jsonp requests\njQuery.ajaxPrefilter( \"json jsonp\", function( s, originalSettings, jqXHR ) {\n\n\tvar callbackName, overwritten, responseContainer,\n\t\tjsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?\n\t\t\t\"url\" :\n\t\t\ttypeof s.data === \"string\" &&\n\t\t\t\t( s.contentType || \"\" )\n\t\t\t\t\t.indexOf( \"application/x-www-form-urlencoded\" ) === 0 &&\n\t\t\t\trjsonp.test( s.data ) && \"data\"\n\t\t);\n\n\t// Handle iff the expected data type is \"jsonp\" or we have a parameter to set\n\tif ( jsonProp || s.dataTypes[ 0 ] === \"jsonp\" ) {\n\n\t\t// Get callback name, remembering preexisting value associated with it\n\t\tcallbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?\n\t\t\ts.jsonpCallback() :\n\t\t\ts.jsonpCallback;\n\n\t\t// Insert callback into url or form data\n\t\tif ( jsonProp ) {\n\t\t\ts[ jsonProp ] = s[ jsonProp ].replace( rjsonp, \"$1\" + callbackName );\n\t\t} else if ( s.jsonp !== false ) {\n\t\t\ts.url += ( rquery.test( s.url ) ? \"&\" : \"?\" ) + s.jsonp + \"=\" + callbackName;\n\t\t}\n\n\t\t// Use data converter to retrieve json after script execution\n\t\ts.converters[ \"script json\" ] = function() {\n\t\t\tif ( !responseContainer ) {\n\t\t\t\tjQuery.error( callbackName + \" was not called\" );\n\t\t\t}\n\t\t\treturn responseContainer[ 0 ];\n\t\t};\n\n\t\t// Force json dataType\n\t\ts.dataTypes[ 0 ] = \"json\";\n\n\t\t// Install callback\n\t\toverwritten = window[ callbackName ];\n\t\twindow[ callbackName ] = function() {\n\t\t\tresponseContainer = arguments;\n\t\t};\n\n\t\t// Clean-up function (fires after converters)\n\t\tjqXHR.always( function() {\n\n\t\t\t// If previous value didn't exist - remove it\n\t\t\tif ( overwritten === undefined ) {\n\t\t\t\tjQuery( window ).removeProp( callbackName );\n\n\t\t\t// Otherwise restore preexisting value\n\t\t\t} else {\n\t\t\t\twindow[ callbackName ] = overwritten;\n\t\t\t}\n\n\t\t\t// Save back as free\n\t\t\tif ( s[ callbackName ] ) {\n\n\t\t\t\t// Make sure that re-using the options doesn't screw things around\n\t\t\t\ts.jsonpCallback = originalSettings.jsonpCallback;\n\n\t\t\t\t// Save the callback name for future use\n\t\t\t\toldCallbacks.push( callbackName );\n\t\t\t}\n\n\t\t\t// Call if it was a function and we have a response\n\t\t\tif ( responseContainer && jQuery.isFunction( overwritten ) ) {\n\t\t\t\toverwritten( responseContainer[ 0 ] );\n\t\t\t}\n\n\t\t\tresponseContainer = overwritten = undefined;\n\t\t} );\n\n\t\t// Delegate to script\n\t\treturn \"script\";\n\t}\n} );\n\n\n\n\n// Support: Safari 8 only\n// In Safari 8 documents created via document.implementation.createHTMLDocument\n// collapse sibling forms: the second one becomes a child of the first one.\n// Because of that, this security measure has to be disabled in Safari 8.\n// https://bugs.webkit.org/show_bug.cgi?id=137337\nsupport.createHTMLDocument = ( function() {\n\tvar body = document.implementation.createHTMLDocument( \"\" ).body;\n\tbody.innerHTML = \"<form></form><form></form>\";\n\treturn body.childNodes.length === 2;\n} )();\n\n\n// Argument \"data\" should be string of html\n// context (optional): If specified, the fragment will be created in this context,\n// defaults to document\n// keepScripts (optional): If true, will include scripts passed in the html string\njQuery.parseHTML = function( data, context, keepScripts ) {\n\tif ( typeof data !== \"string\" ) {\n\t\treturn [];\n\t}\n\tif ( typeof context === \"boolean\" ) {\n\t\tkeepScripts = context;\n\t\tcontext = false;\n\t}\n\n\tvar base, parsed, scripts;\n\n\tif ( !context ) {\n\n\t\t// Stop scripts or inline event handlers from being executed immediately\n\t\t// by using document.implementation\n\t\tif ( support.createHTMLDocument ) {\n\t\t\tcontext = document.implementation.createHTMLDocument( \"\" );\n\n\t\t\t// Set the base href for the created document\n\t\t\t// so any parsed elements with URLs\n\t\t\t// are based on the document's URL (gh-2965)\n\t\t\tbase = context.createElement( \"base\" );\n\t\t\tbase.href = document.location.href;\n\t\t\tcontext.head.appendChild( base );\n\t\t} else {\n\t\t\tcontext = document;\n\t\t}\n\t}\n\n\tparsed = rsingleTag.exec( data );\n\tscripts = !keepScripts && [];\n\n\t// Single tag\n\tif ( parsed ) {\n\t\treturn [ context.createElement( parsed[ 1 ] ) ];\n\t}\n\n\tparsed = buildFragment( [ data ], context, scripts );\n\n\tif ( scripts && scripts.length ) {\n\t\tjQuery( scripts ).remove();\n\t}\n\n\treturn jQuery.merge( [], parsed.childNodes );\n};\n\n\n/**\n * Load a url into a page\n */\njQuery.fn.load = function( url, params, callback ) {\n\tvar selector, type, response,\n\t\tself = this,\n\t\toff = url.indexOf( \" \" );\n\n\tif ( off > -1 ) {\n\t\tselector = stripAndCollapse( url.slice( off ) );\n\t\turl = url.slice( 0, off );\n\t}\n\n\t// If it's a function\n\tif ( jQuery.isFunction( params ) ) {\n\n\t\t// We assume that it's the callback\n\t\tcallback = params;\n\t\tparams = undefined;\n\n\t// Otherwise, build a param string\n\t} else if ( params && typeof params === \"object\" ) {\n\t\ttype = \"POST\";\n\t}\n\n\t// If we have elements to modify, make the request\n\tif ( self.length > 0 ) {\n\t\tjQuery.ajax( {\n\t\t\turl: url,\n\n\t\t\t// If \"type\" variable is undefined, then \"GET\" method will be used.\n\t\t\t// Make value of this field explicit since\n\t\t\t// user can override it through ajaxSetup method\n\t\t\ttype: type || \"GET\",\n\t\t\tdataType: \"html\",\n\t\t\tdata: params\n\t\t} ).done( function( responseText ) {\n\n\t\t\t// Save response for use in complete callback\n\t\t\tresponse = arguments;\n\n\t\t\tself.html( selector ?\n\n\t\t\t\t// If a selector was specified, locate the right elements in a dummy div\n\t\t\t\t// Exclude scripts to avoid IE 'Permission Denied' errors\n\t\t\t\tjQuery( \"<div>\" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :\n\n\t\t\t\t// Otherwise use the full result\n\t\t\t\tresponseText );\n\n\t\t// If the request succeeds, this function gets \"data\", \"status\", \"jqXHR\"\n\t\t// but they are ignored because response was set above.\n\t\t// If it fails, this function gets \"jqXHR\", \"status\", \"error\"\n\t\t} ).always( callback && function( jqXHR, status ) {\n\t\t\tself.each( function() {\n\t\t\t\tcallback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );\n\t\t\t} );\n\t\t} );\n\t}\n\n\treturn this;\n};\n\n\n\n\n// Attach a bunch of functions for handling common AJAX events\njQuery.each( [\n\t\"ajaxStart\",\n\t\"ajaxStop\",\n\t\"ajaxComplete\",\n\t\"ajaxError\",\n\t\"ajaxSuccess\",\n\t\"ajaxSend\"\n], function( i, type ) {\n\tjQuery.fn[ type ] = function( fn ) {\n\t\treturn this.on( type, fn );\n\t};\n} );\n\n\n\n\njQuery.expr.pseudos.animated = function( elem ) {\n\treturn jQuery.grep( jQuery.timers, function( fn ) {\n\t\treturn elem === fn.elem;\n\t} ).length;\n};\n\n\n\n\njQuery.offset = {\n\tsetOffset: function( elem, options, i ) {\n\t\tvar curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,\n\t\t\tposition = jQuery.css( elem, \"position\" ),\n\t\t\tcurElem = jQuery( elem ),\n\t\t\tprops = {};\n\n\t\t// Set position first, in-case top/left are set even on static elem\n\t\tif ( position === \"static\" ) {\n\t\t\telem.style.position = \"relative\";\n\t\t}\n\n\t\tcurOffset = curElem.offset();\n\t\tcurCSSTop = jQuery.css( elem, \"top\" );\n\t\tcurCSSLeft = jQuery.css( elem, \"left\" );\n\t\tcalculatePosition = ( position === \"absolute\" || position === \"fixed\" ) &&\n\t\t\t( curCSSTop + curCSSLeft ).indexOf( \"auto\" ) > -1;\n\n\t\t// Need to be able to calculate position if either\n\t\t// top or left is auto and position is either absolute or fixed\n\t\tif ( calculatePosition ) {\n\t\t\tcurPosition = curElem.position();\n\t\t\tcurTop = curPosition.top;\n\t\t\tcurLeft = curPosition.left;\n\n\t\t} else {\n\t\t\tcurTop = parseFloat( curCSSTop ) || 0;\n\t\t\tcurLeft = parseFloat( curCSSLeft ) || 0;\n\t\t}\n\n\t\tif ( jQuery.isFunction( options ) ) {\n\n\t\t\t// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)\n\t\t\toptions = options.call( elem, i, jQuery.extend( {}, curOffset ) );\n\t\t}\n\n\t\tif ( options.top != null ) {\n\t\t\tprops.top = ( options.top - curOffset.top ) + curTop;\n\t\t}\n\t\tif ( options.left != null ) {\n\t\t\tprops.left = ( options.left - curOffset.left ) + curLeft;\n\t\t}\n\n\t\tif ( \"using\" in options ) {\n\t\t\toptions.using.call( elem, props );\n\n\t\t} else {\n\t\t\tcurElem.css( props );\n\t\t}\n\t}\n};\n\njQuery.fn.extend( {\n\toffset: function( options ) {\n\n\t\t// Preserve chaining for setter\n\t\tif ( arguments.length ) {\n\t\t\treturn options === undefined ?\n\t\t\t\tthis :\n\t\t\t\tthis.each( function( i ) {\n\t\t\t\t\tjQuery.offset.setOffset( this, options, i );\n\t\t\t\t} );\n\t\t}\n\n\t\tvar doc, docElem, rect, win,\n\t\t\telem = this[ 0 ];\n\n\t\tif ( !elem ) {\n\t\t\treturn;\n\t\t}\n\n\t\t// Return zeros for disconnected and hidden (display: none) elements (gh-2310)\n\t\t// Support: IE <=11 only\n\t\t// Running getBoundingClientRect on a\n\t\t// disconnected node in IE throws an error\n\t\tif ( !elem.getClientRects().length ) {\n\t\t\treturn { top: 0, left: 0 };\n\t\t}\n\n\t\trect = elem.getBoundingClientRect();\n\n\t\tdoc = elem.ownerDocument;\n\t\tdocElem = doc.documentElement;\n\t\twin = doc.defaultView;\n\n\t\treturn {\n\t\t\ttop: rect.top + win.pageYOffset - docElem.clientTop,\n\t\t\tleft: rect.left + win.pageXOffset - docElem.clientLeft\n\t\t};\n\t},\n\n\tposition: function() {\n\t\tif ( !this[ 0 ] ) {\n\t\t\treturn;\n\t\t}\n\n\t\tvar offsetParent, offset,\n\t\t\telem = this[ 0 ],\n\t\t\tparentOffset = { top: 0, left: 0 };\n\n\t\t// Fixed elements are offset from window (parentOffset = {top:0, left: 0},\n\t\t// because it is its only offset parent\n\t\tif ( jQuery.css( elem, \"position\" ) === \"fixed\" ) {\n\n\t\t\t// Assume getBoundingClientRect is there when computed position is fixed\n\t\t\toffset = elem.getBoundingClientRect();\n\n\t\t} else {\n\n\t\t\t// Get *real* offsetParent\n\t\t\toffsetParent = this.offsetParent();\n\n\t\t\t// Get correct offsets\n\t\t\toffset = this.offset();\n\t\t\tif ( !nodeName( offsetParent[ 0 ], \"html\" ) ) {\n\t\t\t\tparentOffset = offsetParent.offset();\n\t\t\t}\n\n\t\t\t// Add offsetParent borders\n\t\t\tparentOffset = {\n\t\t\t\ttop: parentOffset.top + jQuery.css( offsetParent[ 0 ], \"borderTopWidth\", true ),\n\t\t\t\tleft: parentOffset.left + jQuery.css( offsetParent[ 0 ], \"borderLeftWidth\", true )\n\t\t\t};\n\t\t}\n\n\t\t// Subtract parent offsets and element margins\n\t\treturn {\n\t\t\ttop: offset.top - parentOffset.top - jQuery.css( elem, \"marginTop\", true ),\n\t\t\tleft: offset.left - parentOffset.left - jQuery.css( elem, \"marginLeft\", true )\n\t\t};\n\t},\n\n\t// This method will return documentElement in the following cases:\n\t// 1) For the element inside the iframe without offsetParent, this method will return\n\t//    documentElement of the parent window\n\t// 2) For the hidden or detached element\n\t// 3) For body or html element, i.e. in case of the html node - it will return itself\n\t//\n\t// but those exceptions were never presented as a real life use-cases\n\t// and might be considered as more preferable results.\n\t//\n\t// This logic, however, is not guaranteed and can change at any point in the future\n\toffsetParent: function() {\n\t\treturn this.map( function() {\n\t\t\tvar offsetParent = this.offsetParent;\n\n\t\t\twhile ( offsetParent && jQuery.css( offsetParent, \"position\" ) === \"static\" ) {\n\t\t\t\toffsetParent = offsetParent.offsetParent;\n\t\t\t}\n\n\t\t\treturn offsetParent || documentElement;\n\t\t} );\n\t}\n} );\n\n// Create scrollLeft and scrollTop methods\njQuery.each( { scrollLeft: \"pageXOffset\", scrollTop: \"pageYOffset\" }, function( method, prop ) {\n\tvar top = \"pageYOffset\" === prop;\n\n\tjQuery.fn[ method ] = function( val ) {\n\t\treturn access( this, function( elem, method, val ) {\n\n\t\t\t// Coalesce documents and windows\n\t\t\tvar win;\n\t\t\tif ( jQuery.isWindow( elem ) ) {\n\t\t\t\twin = elem;\n\t\t\t} else if ( elem.nodeType === 9 ) {\n\t\t\t\twin = elem.defaultView;\n\t\t\t}\n\n\t\t\tif ( val === undefined ) {\n\t\t\t\treturn win ? win[ prop ] : elem[ method ];\n\t\t\t}\n\n\t\t\tif ( win ) {\n\t\t\t\twin.scrollTo(\n\t\t\t\t\t!top ? val : win.pageXOffset,\n\t\t\t\t\ttop ? val : win.pageYOffset\n\t\t\t\t);\n\n\t\t\t} else {\n\t\t\t\telem[ method ] = val;\n\t\t\t}\n\t\t}, method, val, arguments.length );\n\t};\n} );\n\n// Support: Safari <=7 - 9.1, Chrome <=37 - 49\n// Add the top/left cssHooks using jQuery.fn.position\n// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084\n// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347\n// getComputedStyle returns percent when specified for top/left/bottom/right;\n// rather than make the css module depend on the offset module, just check for it here\njQuery.each( [ \"top\", \"left\" ], function( i, prop ) {\n\tjQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,\n\t\tfunction( elem, computed ) {\n\t\t\tif ( computed ) {\n\t\t\t\tcomputed = curCSS( elem, prop );\n\n\t\t\t\t// If curCSS returns percentage, fallback to offset\n\t\t\t\treturn rnumnonpx.test( computed ) ?\n\t\t\t\t\tjQuery( elem ).position()[ prop ] + \"px\" :\n\t\t\t\t\tcomputed;\n\t\t\t}\n\t\t}\n\t);\n} );\n\n\n// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods\njQuery.each( { Height: \"height\", Width: \"width\" }, function( name, type ) {\n\tjQuery.each( { padding: \"inner\" + name, content: type, \"\": \"outer\" + name },\n\t\tfunction( defaultExtra, funcName ) {\n\n\t\t// Margin is only for outerHeight, outerWidth\n\t\tjQuery.fn[ funcName ] = function( margin, value ) {\n\t\t\tvar chainable = arguments.length && ( defaultExtra || typeof margin !== \"boolean\" ),\n\t\t\t\textra = defaultExtra || ( margin === true || value === true ? \"margin\" : \"border\" );\n\n\t\t\treturn access( this, function( elem, type, value ) {\n\t\t\t\tvar doc;\n\n\t\t\t\tif ( jQuery.isWindow( elem ) ) {\n\n\t\t\t\t\t// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)\n\t\t\t\t\treturn funcName.indexOf( \"outer\" ) === 0 ?\n\t\t\t\t\t\telem[ \"inner\" + name ] :\n\t\t\t\t\t\telem.document.documentElement[ \"client\" + name ];\n\t\t\t\t}\n\n\t\t\t\t// Get document width or height\n\t\t\t\tif ( elem.nodeType === 9 ) {\n\t\t\t\t\tdoc = elem.documentElement;\n\n\t\t\t\t\t// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],\n\t\t\t\t\t// whichever is greatest\n\t\t\t\t\treturn Math.max(\n\t\t\t\t\t\telem.body[ \"scroll\" + name ], doc[ \"scroll\" + name ],\n\t\t\t\t\t\telem.body[ \"offset\" + name ], doc[ \"offset\" + name ],\n\t\t\t\t\t\tdoc[ \"client\" + name ]\n\t\t\t\t\t);\n\t\t\t\t}\n\n\t\t\t\treturn value === undefined ?\n\n\t\t\t\t\t// Get width or height on the element, requesting but not forcing parseFloat\n\t\t\t\t\tjQuery.css( elem, type, extra ) :\n\n\t\t\t\t\t// Set width or height on the element\n\t\t\t\t\tjQuery.style( elem, type, value, extra );\n\t\t\t}, type, chainable ? margin : undefined, chainable );\n\t\t};\n\t} );\n} );\n\n\njQuery.fn.extend( {\n\n\tbind: function( types, data, fn ) {\n\t\treturn this.on( types, null, data, fn );\n\t},\n\tunbind: function( types, fn ) {\n\t\treturn this.off( types, null, fn );\n\t},\n\n\tdelegate: function( selector, types, data, fn ) {\n\t\treturn this.on( types, selector, data, fn );\n\t},\n\tundelegate: function( selector, types, fn ) {\n\n\t\t// ( namespace ) or ( selector, types [, fn] )\n\t\treturn arguments.length === 1 ?\n\t\t\tthis.off( selector, \"**\" ) :\n\t\t\tthis.off( types, selector || \"**\", fn );\n\t}\n} );\n\njQuery.holdReady = function( hold ) {\n\tif ( hold ) {\n\t\tjQuery.readyWait++;\n\t} else {\n\t\tjQuery.ready( true );\n\t}\n};\njQuery.isArray = Array.isArray;\njQuery.parseJSON = JSON.parse;\njQuery.nodeName = nodeName;\n\n\n\n\n// Register as a named AMD module, since jQuery can be concatenated with other\n// files that may use define, but not via a proper concatenation script that\n// understands anonymous AMD modules. A named AMD is safest and most robust\n// way to register. Lowercase jquery is used because AMD module names are\n// derived from file names, and jQuery is normally delivered in a lowercase\n// file name. Do this after creating the global so that if an AMD module wants\n// to call noConflict to hide this version of jQuery, it will work.\n\n// Note that for maximum portability, libraries that are not jQuery should\n// declare themselves as anonymous modules, and avoid setting a global if an\n// AMD loader is present. jQuery is a special case. For more information, see\n// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon\n\nif ( true ) {\n\t!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {\n\t\treturn jQuery;\n\t}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),\n\t\t\t\t__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));\n}\n\n\n\n\nvar\n\n\t// Map over jQuery in case of overwrite\n\t_jQuery = window.jQuery,\n\n\t// Map over the $ in case of overwrite\n\t_$ = window.$;\n\njQuery.noConflict = function( deep ) {\n\tif ( window.$ === jQuery ) {\n\t\twindow.$ = _$;\n\t}\n\n\tif ( deep && window.jQuery === jQuery ) {\n\t\twindow.jQuery = _jQuery;\n\t}\n\n\treturn jQuery;\n};\n\n// Expose jQuery and $ identifiers, even in AMD\n// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)\n// and CommonJS for browser emulators (#13566)\nif ( !noGlobal ) {\n\twindow.jQuery = window.$ = jQuery;\n}\n\n\n\n\nreturn jQuery;\n} );\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/jquery/dist/jquery.js\n// module id = 1\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/jquery/dist/jquery.js?");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\n/**\n * Copyright (c) 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * \n */\n\nfunction makeEmptyFunction(arg) {\n  return function () {\n    return arg;\n  };\n}\n\n/**\n * This function accepts and discards inputs; it has no side effects. This is\n * primarily useful idiomatically for overridable function endpoints which\n * always need to be callable, since JS lacks a null-call idiom ala Cocoa.\n */\nvar emptyFunction = function emptyFunction() {};\n\nemptyFunction.thatReturns = makeEmptyFunction;\nemptyFunction.thatReturnsFalse = makeEmptyFunction(false);\nemptyFunction.thatReturnsTrue = makeEmptyFunction(true);\nemptyFunction.thatReturnsNull = makeEmptyFunction(null);\nemptyFunction.thatReturnsThis = function () {\n  return this;\n};\nemptyFunction.thatReturnsArgument = function (arg) {\n  return arg;\n};\n\nmodule.exports = emptyFunction;\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/fbjs/lib/emptyFunction.js\n// module id = 2\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/fbjs/lib/emptyFunction.js?");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("/* WEBPACK VAR INJECTION */(function(process) {/**\n * Copyright (c) 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n */\n\n\n\n/**\n * Use invariant() to assert state which your program assumes to be true.\n *\n * Provide sprintf-style format (only %s is supported) and arguments\n * to provide information about what broke and what you were\n * expecting.\n *\n * The invariant message will be stripped in production, but the invariant\n * will remain to ensure logic does not differ in production.\n */\n\nvar validateFormat = function validateFormat(format) {};\n\nif (process.env.NODE_ENV !== 'production') {\n  validateFormat = function validateFormat(format) {\n    if (format === undefined) {\n      throw new Error('invariant requires an error message argument');\n    }\n  };\n}\n\nfunction invariant(condition, format, a, b, c, d, e, f) {\n  validateFormat(format);\n\n  if (!condition) {\n    var error;\n    if (format === undefined) {\n      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');\n    } else {\n      var args = [a, b, c, d, e, f];\n      var argIndex = 0;\n      error = new Error(format.replace(/%s/g, function () {\n        return args[argIndex++];\n      }));\n      error.name = 'Invariant Violation';\n    }\n\n    error.framesToPop = 1; // we don't care about invariant's own frame\n    throw error;\n  }\n}\n\nmodule.exports = invariant;\n/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/fbjs/lib/invariant.js\n// module id = 3\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/fbjs/lib/invariant.js?");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

eval("/*\n\tMIT License http://www.opensource.org/licenses/mit-license.php\n\tAuthor Tobias Koppers @sokra\n*/\n// css base code, injected by the css-loader\nmodule.exports = function(useSourceMap) {\n\tvar list = [];\n\n\t// return the list of modules as css string\n\tlist.toString = function toString() {\n\t\treturn this.map(function (item) {\n\t\t\tvar content = cssWithMappingToString(item, useSourceMap);\n\t\t\tif(item[2]) {\n\t\t\t\treturn \"@media \" + item[2] + \"{\" + content + \"}\";\n\t\t\t} else {\n\t\t\t\treturn content;\n\t\t\t}\n\t\t}).join(\"\");\n\t};\n\n\t// import a list of modules into the list\n\tlist.i = function(modules, mediaQuery) {\n\t\tif(typeof modules === \"string\")\n\t\t\tmodules = [[null, modules, \"\"]];\n\t\tvar alreadyImportedModules = {};\n\t\tfor(var i = 0; i < this.length; i++) {\n\t\t\tvar id = this[i][0];\n\t\t\tif(typeof id === \"number\")\n\t\t\t\talreadyImportedModules[id] = true;\n\t\t}\n\t\tfor(i = 0; i < modules.length; i++) {\n\t\t\tvar item = modules[i];\n\t\t\t// skip already imported module\n\t\t\t// this implementation is not 100% perfect for weird media query combinations\n\t\t\t//  when a module is imported multiple times with different media queries.\n\t\t\t//  I hope this will never occur (Hey this way we have smaller bundles)\n\t\t\tif(typeof item[0] !== \"number\" || !alreadyImportedModules[item[0]]) {\n\t\t\t\tif(mediaQuery && !item[2]) {\n\t\t\t\t\titem[2] = mediaQuery;\n\t\t\t\t} else if(mediaQuery) {\n\t\t\t\t\titem[2] = \"(\" + item[2] + \") and (\" + mediaQuery + \")\";\n\t\t\t\t}\n\t\t\t\tlist.push(item);\n\t\t\t}\n\t\t}\n\t};\n\treturn list;\n};\n\nfunction cssWithMappingToString(item, useSourceMap) {\n\tvar content = item[1] || '';\n\tvar cssMapping = item[3];\n\tif (!cssMapping) {\n\t\treturn content;\n\t}\n\n\tif (useSourceMap && typeof btoa === 'function') {\n\t\tvar sourceMapping = toComment(cssMapping);\n\t\tvar sourceURLs = cssMapping.sources.map(function (source) {\n\t\t\treturn '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'\n\t\t});\n\n\t\treturn [content].concat(sourceURLs).concat([sourceMapping]).join('\\n');\n\t}\n\n\treturn [content].join('\\n');\n}\n\n// Adapted from convert-source-map (MIT)\nfunction toComment(sourceMap) {\n\t// eslint-disable-next-line no-undef\n\tvar base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));\n\tvar data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;\n\n\treturn '/*# ' + data + ' */';\n}\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/css-loader/lib/css-base.js\n// module id = 4\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/css-loader/lib/css-base.js?");

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("/* WEBPACK VAR INJECTION */(function(process) {/**\n * Copyright 2014-2015, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n */\n\n\n\nvar emptyFunction = __webpack_require__(2);\n\n/**\n * Similar to invariant but only logs a warning if the condition is not met.\n * This can be used to log issues in development environments in critical\n * paths. Removing the logging code for production environments will keep the\n * same logic and follow the same code paths.\n */\n\nvar warning = emptyFunction;\n\nif (process.env.NODE_ENV !== 'production') {\n  (function () {\n    var printWarning = function printWarning(format) {\n      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n        args[_key - 1] = arguments[_key];\n      }\n\n      var argIndex = 0;\n      var message = 'Warning: ' + format.replace(/%s/g, function () {\n        return args[argIndex++];\n      });\n      if (typeof console !== 'undefined') {\n        console.error(message);\n      }\n      try {\n        // --- Welcome to debugging React ---\n        // This error was thrown as a convenience so that you can use this stack\n        // to find the callsite that caused this warning to fire.\n        throw new Error(message);\n      } catch (x) {}\n    };\n\n    warning = function warning(condition, format) {\n      if (format === undefined) {\n        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');\n      }\n\n      if (format.indexOf('Failed Composite propType: ') === 0) {\n        return; // Ignore CompositeComponent proptype check.\n      }\n\n      if (!condition) {\n        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {\n          args[_key2 - 2] = arguments[_key2];\n        }\n\n        printWarning.apply(undefined, [format].concat(args));\n      }\n    };\n  })();\n}\n\nmodule.exports = warning;\n/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/fbjs/lib/warning.js\n// module id = 5\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/fbjs/lib/warning.js?");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("/**\n * Copyright 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n\n\n\nvar ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';\n\nmodule.exports = ReactPropTypesSecret;\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/prop-types/lib/ReactPropTypesSecret.js\n// module id = 6\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/prop-types/lib/ReactPropTypesSecret.js?");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

eval("/*\n\tMIT License http://www.opensource.org/licenses/mit-license.php\n\tAuthor Tobias Koppers @sokra\n*/\nvar stylesInDom = {},\n\tmemoize = function(fn) {\n\t\tvar memo;\n\t\treturn function () {\n\t\t\tif (typeof memo === \"undefined\") memo = fn.apply(this, arguments);\n\t\t\treturn memo;\n\t\t};\n\t},\n\tisOldIE = memoize(function() {\n\t\t// Test for IE <= 9 as proposed by Browserhacks\n\t\t// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805\n\t\t// Tests for existence of standard globals is to allow style-loader \n\t\t// to operate correctly into non-standard environments\n\t\t// @see https://github.com/webpack-contrib/style-loader/issues/177\n\t\treturn window && document && document.all && !window.atob;\n\t}),\n\tgetElement = (function(fn) {\n\t\tvar memo = {};\n\t\treturn function(selector) {\n\t\t\tif (typeof memo[selector] === \"undefined\") {\n\t\t\t\tmemo[selector] = fn.call(this, selector);\n\t\t\t}\n\t\t\treturn memo[selector]\n\t\t};\n\t})(function (styleTarget) {\n\t\treturn document.querySelector(styleTarget)\n\t}),\n\tsingletonElement = null,\n\tsingletonCounter = 0,\n\tstyleElementsInsertedAtTop = [],\n\tfixUrls = __webpack_require__(20);\n\nmodule.exports = function(list, options) {\n\tif(typeof DEBUG !== \"undefined\" && DEBUG) {\n\t\tif(typeof document !== \"object\") throw new Error(\"The style-loader cannot be used in a non-browser environment\");\n\t}\n\n\toptions = options || {};\n\toptions.attrs = typeof options.attrs === \"object\" ? options.attrs : {};\n\n\t// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>\n\t// tags it will allow on a page\n\tif (typeof options.singleton === \"undefined\") options.singleton = isOldIE();\n\n\t// By default, add <style> tags to the <head> element\n\tif (typeof options.insertInto === \"undefined\") options.insertInto = \"head\";\n\n\t// By default, add <style> tags to the bottom of the target\n\tif (typeof options.insertAt === \"undefined\") options.insertAt = \"bottom\";\n\n\tvar styles = listToStyles(list, options);\n\taddStylesToDom(styles, options);\n\n\treturn function update(newList) {\n\t\tvar mayRemove = [];\n\t\tfor(var i = 0; i < styles.length; i++) {\n\t\t\tvar item = styles[i];\n\t\t\tvar domStyle = stylesInDom[item.id];\n\t\t\tdomStyle.refs--;\n\t\t\tmayRemove.push(domStyle);\n\t\t}\n\t\tif(newList) {\n\t\t\tvar newStyles = listToStyles(newList, options);\n\t\t\taddStylesToDom(newStyles, options);\n\t\t}\n\t\tfor(var i = 0; i < mayRemove.length; i++) {\n\t\t\tvar domStyle = mayRemove[i];\n\t\t\tif(domStyle.refs === 0) {\n\t\t\t\tfor(var j = 0; j < domStyle.parts.length; j++)\n\t\t\t\t\tdomStyle.parts[j]();\n\t\t\t\tdelete stylesInDom[domStyle.id];\n\t\t\t}\n\t\t}\n\t};\n};\n\nfunction addStylesToDom(styles, options) {\n\tfor(var i = 0; i < styles.length; i++) {\n\t\tvar item = styles[i];\n\t\tvar domStyle = stylesInDom[item.id];\n\t\tif(domStyle) {\n\t\t\tdomStyle.refs++;\n\t\t\tfor(var j = 0; j < domStyle.parts.length; j++) {\n\t\t\t\tdomStyle.parts[j](item.parts[j]);\n\t\t\t}\n\t\t\tfor(; j < item.parts.length; j++) {\n\t\t\t\tdomStyle.parts.push(addStyle(item.parts[j], options));\n\t\t\t}\n\t\t} else {\n\t\t\tvar parts = [];\n\t\t\tfor(var j = 0; j < item.parts.length; j++) {\n\t\t\t\tparts.push(addStyle(item.parts[j], options));\n\t\t\t}\n\t\t\tstylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};\n\t\t}\n\t}\n}\n\nfunction listToStyles(list, options) {\n\tvar styles = [];\n\tvar newStyles = {};\n\tfor(var i = 0; i < list.length; i++) {\n\t\tvar item = list[i];\n\t\tvar id = options.base ? item[0] + options.base : item[0];\n\t\tvar css = item[1];\n\t\tvar media = item[2];\n\t\tvar sourceMap = item[3];\n\t\tvar part = {css: css, media: media, sourceMap: sourceMap};\n\t\tif(!newStyles[id])\n\t\t\tstyles.push(newStyles[id] = {id: id, parts: [part]});\n\t\telse\n\t\t\tnewStyles[id].parts.push(part);\n\t}\n\treturn styles;\n}\n\nfunction insertStyleElement(options, styleElement) {\n\tvar styleTarget = getElement(options.insertInto)\n\tif (!styleTarget) {\n\t\tthrow new Error(\"Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.\");\n\t}\n\tvar lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];\n\tif (options.insertAt === \"top\") {\n\t\tif(!lastStyleElementInsertedAtTop) {\n\t\t\tstyleTarget.insertBefore(styleElement, styleTarget.firstChild);\n\t\t} else if(lastStyleElementInsertedAtTop.nextSibling) {\n\t\t\tstyleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);\n\t\t} else {\n\t\t\tstyleTarget.appendChild(styleElement);\n\t\t}\n\t\tstyleElementsInsertedAtTop.push(styleElement);\n\t} else if (options.insertAt === \"bottom\") {\n\t\tstyleTarget.appendChild(styleElement);\n\t} else {\n\t\tthrow new Error(\"Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.\");\n\t}\n}\n\nfunction removeStyleElement(styleElement) {\n\tstyleElement.parentNode.removeChild(styleElement);\n\tvar idx = styleElementsInsertedAtTop.indexOf(styleElement);\n\tif(idx >= 0) {\n\t\tstyleElementsInsertedAtTop.splice(idx, 1);\n\t}\n}\n\nfunction createStyleElement(options) {\n\tvar styleElement = document.createElement(\"style\");\n\toptions.attrs.type = \"text/css\";\n\n\tattachTagAttrs(styleElement, options.attrs);\n\tinsertStyleElement(options, styleElement);\n\treturn styleElement;\n}\n\nfunction createLinkElement(options) {\n\tvar linkElement = document.createElement(\"link\");\n\toptions.attrs.type = \"text/css\";\n\toptions.attrs.rel = \"stylesheet\";\n\n\tattachTagAttrs(linkElement, options.attrs);\n\tinsertStyleElement(options, linkElement);\n\treturn linkElement;\n}\n\nfunction attachTagAttrs(element, attrs) {\n\tObject.keys(attrs).forEach(function (key) {\n\t\telement.setAttribute(key, attrs[key]);\n\t});\n}\n\nfunction addStyle(obj, options) {\n\tvar styleElement, update, remove, transformResult;\n\n\t// If a transform function was defined, run it on the css\n\tif (options.transform && obj.css) {\n\t    transformResult = options.transform(obj.css);\n\t    \n\t    if (transformResult) {\n\t    \t// If transform returns a value, use that instead of the original css.\n\t    \t// This allows running runtime transformations on the css.\n\t    \tobj.css = transformResult;\n\t    } else {\n\t    \t// If the transform function returns a falsy value, don't add this css. \n\t    \t// This allows conditional loading of css\n\t    \treturn function() {\n\t    \t\t// noop\n\t    \t};\n\t    }\n\t}\n\n\tif (options.singleton) {\n\t\tvar styleIndex = singletonCounter++;\n\t\tstyleElement = singletonElement || (singletonElement = createStyleElement(options));\n\t\tupdate = applyToSingletonTag.bind(null, styleElement, styleIndex, false);\n\t\tremove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);\n\t} else if(obj.sourceMap &&\n\t\ttypeof URL === \"function\" &&\n\t\ttypeof URL.createObjectURL === \"function\" &&\n\t\ttypeof URL.revokeObjectURL === \"function\" &&\n\t\ttypeof Blob === \"function\" &&\n\t\ttypeof btoa === \"function\") {\n\t\tstyleElement = createLinkElement(options);\n\t\tupdate = updateLink.bind(null, styleElement, options);\n\t\tremove = function() {\n\t\t\tremoveStyleElement(styleElement);\n\t\t\tif(styleElement.href)\n\t\t\t\tURL.revokeObjectURL(styleElement.href);\n\t\t};\n\t} else {\n\t\tstyleElement = createStyleElement(options);\n\t\tupdate = applyToTag.bind(null, styleElement);\n\t\tremove = function() {\n\t\t\tremoveStyleElement(styleElement);\n\t\t};\n\t}\n\n\tupdate(obj);\n\n\treturn function updateStyle(newObj) {\n\t\tif(newObj) {\n\t\t\tif(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)\n\t\t\t\treturn;\n\t\t\tupdate(obj = newObj);\n\t\t} else {\n\t\t\tremove();\n\t\t}\n\t};\n}\n\nvar replaceText = (function () {\n\tvar textStore = [];\n\n\treturn function (index, replacement) {\n\t\ttextStore[index] = replacement;\n\t\treturn textStore.filter(Boolean).join('\\n');\n\t};\n})();\n\nfunction applyToSingletonTag(styleElement, index, remove, obj) {\n\tvar css = remove ? \"\" : obj.css;\n\n\tif (styleElement.styleSheet) {\n\t\tstyleElement.styleSheet.cssText = replaceText(index, css);\n\t} else {\n\t\tvar cssNode = document.createTextNode(css);\n\t\tvar childNodes = styleElement.childNodes;\n\t\tif (childNodes[index]) styleElement.removeChild(childNodes[index]);\n\t\tif (childNodes.length) {\n\t\t\tstyleElement.insertBefore(cssNode, childNodes[index]);\n\t\t} else {\n\t\t\tstyleElement.appendChild(cssNode);\n\t\t}\n\t}\n}\n\nfunction applyToTag(styleElement, obj) {\n\tvar css = obj.css;\n\tvar media = obj.media;\n\n\tif(media) {\n\t\tstyleElement.setAttribute(\"media\", media)\n\t}\n\n\tif(styleElement.styleSheet) {\n\t\tstyleElement.styleSheet.cssText = css;\n\t} else {\n\t\twhile(styleElement.firstChild) {\n\t\t\tstyleElement.removeChild(styleElement.firstChild);\n\t\t}\n\t\tstyleElement.appendChild(document.createTextNode(css));\n\t}\n}\n\nfunction updateLink(linkElement, options, obj) {\n\tvar css = obj.css;\n\tvar sourceMap = obj.sourceMap;\n\n\t/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled\n\tand there is no publicPath defined then lets turn convertToAbsoluteUrls\n\ton by default.  Otherwise default to the convertToAbsoluteUrls option\n\tdirectly\n\t*/\n\tvar autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;\n\n\tif (options.convertToAbsoluteUrls || autoFixUrls){\n\t\tcss = fixUrls(css);\n\t}\n\n\tif(sourceMap) {\n\t\t// http://stackoverflow.com/a/26603875\n\t\tcss += \"\\n/*# sourceMappingURL=data:application/json;base64,\" + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + \" */\";\n\t}\n\n\tvar blob = new Blob([css], { type: \"text/css\" });\n\n\tvar oldSrc = linkElement.href;\n\n\tlinkElement.href = URL.createObjectURL(blob);\n\n\tif(oldSrc)\n\t\tURL.revokeObjectURL(oldSrc);\n}\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/style-loader/addStyles.js\n// module id = 7\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/style-loader/addStyles.js?");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

eval("/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/**\n * Owl Carousel v2.2.0\n * Copyright 2013-2016 David Deutsch\n * Licensed under MIT (https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE)\n */\n/**\n * Owl carousel\n * @version 2.1.6\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n * @todo Lazy Load Icon\n * @todo prevent animationend bubling\n * @todo itemsScaleUp\n * @todo Test Zepto\n * @todo stagePadding calculate wrong active classes\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates a carousel.\n\t * @class The Owl Carousel.\n\t * @public\n\t * @param {HTMLElement|jQuery} element - The element to create the carousel for.\n\t * @param {Object} [options] - The options\n\t */\n\tfunction Owl(element, options) {\n\n\t\t/**\n\t\t * Current settings for the carousel.\n\t\t * @public\n\t\t */\n\t\tthis.settings = null;\n\n\t\t/**\n\t\t * Current options set by the caller including defaults.\n\t\t * @public\n\t\t */\n\t\tthis.options = $.extend({}, Owl.Defaults, options);\n\n\t\t/**\n\t\t * Plugin element.\n\t\t * @public\n\t\t */\n\t\tthis.$element = $(element);\n\n\t\t/**\n\t\t * Proxied event handlers.\n\t\t * @protected\n\t\t */\n\t\tthis._handlers = {};\n\n\t\t/**\n\t\t * References to the running plugins of this carousel.\n\t\t * @protected\n\t\t */\n\t\tthis._plugins = {};\n\n\t\t/**\n\t\t * Currently suppressed events to prevent them from beeing retriggered.\n\t\t * @protected\n\t\t */\n\t\tthis._supress = {};\n\n\t\t/**\n\t\t * Absolute current position.\n\t\t * @protected\n\t\t */\n\t\tthis._current = null;\n\n\t\t/**\n\t\t * Animation speed in milliseconds.\n\t\t * @protected\n\t\t */\n\t\tthis._speed = null;\n\n\t\t/**\n\t\t * Coordinates of all items in pixel.\n\t\t * @todo The name of this member is missleading.\n\t\t * @protected\n\t\t */\n\t\tthis._coordinates = [];\n\n\t\t/**\n\t\t * Current breakpoint.\n\t\t * @todo Real media queries would be nice.\n\t\t * @protected\n\t\t */\n\t\tthis._breakpoint = null;\n\n\t\t/**\n\t\t * Current width of the plugin element.\n\t\t */\n\t\tthis._width = null;\n\n\t\t/**\n\t\t * All real items.\n\t\t * @protected\n\t\t */\n\t\tthis._items = [];\n\n\t\t/**\n\t\t * All cloned items.\n\t\t * @protected\n\t\t */\n\t\tthis._clones = [];\n\n\t\t/**\n\t\t * Merge values of all items.\n\t\t * @todo Maybe this could be part of a plugin.\n\t\t * @protected\n\t\t */\n\t\tthis._mergers = [];\n\n\t\t/**\n\t\t * Widths of all items.\n\t\t */\n\t\tthis._widths = [];\n\n\t\t/**\n\t\t * Invalidated parts within the update process.\n\t\t * @protected\n\t\t */\n\t\tthis._invalidated = {};\n\n\t\t/**\n\t\t * Ordered list of workers for the update process.\n\t\t * @protected\n\t\t */\n\t\tthis._pipe = [];\n\n\t\t/**\n\t\t * Current state information for the drag operation.\n\t\t * @todo #261\n\t\t * @protected\n\t\t */\n\t\tthis._drag = {\n\t\t\ttime: null,\n\t\t\ttarget: null,\n\t\t\tpointer: null,\n\t\t\tstage: {\n\t\t\t\tstart: null,\n\t\t\t\tcurrent: null\n\t\t\t},\n\t\t\tdirection: null\n\t\t};\n\n\t\t/**\n\t\t * Current state information and their tags.\n\t\t * @type {Object}\n\t\t * @protected\n\t\t */\n\t\tthis._states = {\n\t\t\tcurrent: {},\n\t\t\ttags: {\n\t\t\t\t'initializing': [ 'busy' ],\n\t\t\t\t'animating': [ 'busy' ],\n\t\t\t\t'dragging': [ 'interacting' ]\n\t\t\t}\n\t\t};\n\n\t\t$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {\n\t\t\tthis._handlers[handler] = $.proxy(this[handler], this);\n\t\t}, this));\n\n\t\t$.each(Owl.Plugins, $.proxy(function(key, plugin) {\n\t\t\tthis._plugins[key.charAt(0).toLowerCase() + key.slice(1)]\n\t\t\t\t= new plugin(this);\n\t\t}, this));\n\n\t\t$.each(Owl.Workers, $.proxy(function(priority, worker) {\n\t\t\tthis._pipe.push({\n\t\t\t\t'filter': worker.filter,\n\t\t\t\t'run': $.proxy(worker.run, this)\n\t\t\t});\n\t\t}, this));\n\n\t\tthis.setup();\n\t\tthis.initialize();\n\t}\n\n\t/**\n\t * Default options for the carousel.\n\t * @public\n\t */\n\tOwl.Defaults = {\n\t\titems: 3,\n\t\tloop: false,\n\t\tcenter: false,\n\t\trewind: false,\n\n\t\tmouseDrag: true,\n\t\ttouchDrag: true,\n\t\tpullDrag: true,\n\t\tfreeDrag: false,\n\n\t\tmargin: 0,\n\t\tstagePadding: 0,\n\n\t\tmerge: false,\n\t\tmergeFit: true,\n\t\tautoWidth: false,\n\n\t\tstartPosition: 0,\n\t\trtl: false,\n\n\t\tsmartSpeed: 250,\n\t\tfluidSpeed: false,\n\t\tdragEndSpeed: false,\n\n\t\tresponsive: {},\n\t\tresponsiveRefreshRate: 200,\n\t\tresponsiveBaseElement: window,\n\n\t\tfallbackEasing: 'swing',\n\n\t\tinfo: false,\n\n\t\tnestedItemSelector: false,\n\t\titemElement: 'div',\n\t\tstageElement: 'div',\n\n\t\trefreshClass: 'owl-refresh',\n\t\tloadedClass: 'owl-loaded',\n\t\tloadingClass: 'owl-loading',\n\t\trtlClass: 'owl-rtl',\n\t\tresponsiveClass: 'owl-responsive',\n\t\tdragClass: 'owl-drag',\n\t\titemClass: 'owl-item',\n\t\tstageClass: 'owl-stage',\n\t\tstageOuterClass: 'owl-stage-outer',\n\t\tgrabClass: 'owl-grab'\n\t};\n\n\t/**\n\t * Enumeration for width.\n\t * @public\n\t * @readonly\n\t * @enum {String}\n\t */\n\tOwl.Width = {\n\t\tDefault: 'default',\n\t\tInner: 'inner',\n\t\tOuter: 'outer'\n\t};\n\n\t/**\n\t * Enumeration for types.\n\t * @public\n\t * @readonly\n\t * @enum {String}\n\t */\n\tOwl.Type = {\n\t\tEvent: 'event',\n\t\tState: 'state'\n\t};\n\n\t/**\n\t * Contains all registered plugins.\n\t * @public\n\t */\n\tOwl.Plugins = {};\n\n\t/**\n\t * List of workers involved in the update process.\n\t */\n\tOwl.Workers = [ {\n\t\tfilter: [ 'width', 'settings' ],\n\t\trun: function() {\n\t\t\tthis._width = this.$element.width();\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function(cache) {\n\t\t\tcache.current = this._items && this._items[this.relative(this._current)];\n\t\t}\n\t}, {\n\t\tfilter: [ 'items', 'settings' ],\n\t\trun: function() {\n\t\t\tthis.$stage.children('.cloned').remove();\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function(cache) {\n\t\t\tvar margin = this.settings.margin || '',\n\t\t\t\tgrid = !this.settings.autoWidth,\n\t\t\t\trtl = this.settings.rtl,\n\t\t\t\tcss = {\n\t\t\t\t\t'width': 'auto',\n\t\t\t\t\t'margin-left': rtl ? margin : '',\n\t\t\t\t\t'margin-right': rtl ? '' : margin\n\t\t\t\t};\n\n\t\t\t!grid && this.$stage.children().css(css);\n\n\t\t\tcache.css = css;\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function(cache) {\n\t\t\tvar width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,\n\t\t\t\tmerge = null,\n\t\t\t\titerator = this._items.length,\n\t\t\t\tgrid = !this.settings.autoWidth,\n\t\t\t\twidths = [];\n\n\t\t\tcache.items = {\n\t\t\t\tmerge: false,\n\t\t\t\twidth: width\n\t\t\t};\n\n\t\t\twhile (iterator--) {\n\t\t\t\tmerge = this._mergers[iterator];\n\t\t\t\tmerge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;\n\n\t\t\t\tcache.items.merge = merge > 1 || cache.items.merge;\n\n\t\t\t\twidths[iterator] = !grid ? this._items[iterator].width() : width * merge;\n\t\t\t}\n\n\t\t\tthis._widths = widths;\n\t\t}\n\t}, {\n\t\tfilter: [ 'items', 'settings' ],\n\t\trun: function() {\n\t\t\tvar clones = [],\n\t\t\t\titems = this._items,\n\t\t\t\tsettings = this.settings,\n\t\t\t\tview = Math.max(settings.items * 2, 4),\n\t\t\t\tsize = Math.ceil(items.length / 2) * 2,\n\t\t\t\trepeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,\n\t\t\t\tappend = '',\n\t\t\t\tprepend = '';\n\n\t\t\trepeat /= 2;\n\n\t\t\twhile (repeat--) {\n\t\t\t\tclones.push(this.normalize(clones.length / 2, true));\n\t\t\t\tappend = append + items[clones[clones.length - 1]][0].outerHTML;\n\t\t\t\tclones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));\n\t\t\t\tprepend = items[clones[clones.length - 1]][0].outerHTML + prepend;\n\t\t\t}\n\n\t\t\tthis._clones = clones;\n\n\t\t\t$(append).addClass('cloned').appendTo(this.$stage);\n\t\t\t$(prepend).addClass('cloned').prependTo(this.$stage);\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function() {\n\t\t\tvar rtl = this.settings.rtl ? 1 : -1,\n\t\t\t\tsize = this._clones.length + this._items.length,\n\t\t\t\titerator = -1,\n\t\t\t\tprevious = 0,\n\t\t\t\tcurrent = 0,\n\t\t\t\tcoordinates = [];\n\n\t\t\twhile (++iterator < size) {\n\t\t\t\tprevious = coordinates[iterator - 1] || 0;\n\t\t\t\tcurrent = this._widths[this.relative(iterator)] + this.settings.margin;\n\t\t\t\tcoordinates.push(previous + current * rtl);\n\t\t\t}\n\n\t\t\tthis._coordinates = coordinates;\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function() {\n\t\t\tvar padding = this.settings.stagePadding,\n\t\t\t\tcoordinates = this._coordinates,\n\t\t\t\tcss = {\n\t\t\t\t\t'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,\n\t\t\t\t\t'padding-left': padding || '',\n\t\t\t\t\t'padding-right': padding || ''\n\t\t\t\t};\n\n\t\t\tthis.$stage.css(css);\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function(cache) {\n\t\t\tvar iterator = this._coordinates.length,\n\t\t\t\tgrid = !this.settings.autoWidth,\n\t\t\t\titems = this.$stage.children();\n\n\t\t\tif (grid && cache.items.merge) {\n\t\t\t\twhile (iterator--) {\n\t\t\t\t\tcache.css.width = this._widths[this.relative(iterator)];\n\t\t\t\t\titems.eq(iterator).css(cache.css);\n\t\t\t\t}\n\t\t\t} else if (grid) {\n\t\t\t\tcache.css.width = cache.items.width;\n\t\t\t\titems.css(cache.css);\n\t\t\t}\n\t\t}\n\t}, {\n\t\tfilter: [ 'items' ],\n\t\trun: function() {\n\t\t\tthis._coordinates.length < 1 && this.$stage.removeAttr('style');\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'items', 'settings' ],\n\t\trun: function(cache) {\n\t\t\tcache.current = cache.current ? this.$stage.children().index(cache.current) : 0;\n\t\t\tcache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));\n\t\t\tthis.reset(cache.current);\n\t\t}\n\t}, {\n\t\tfilter: [ 'position' ],\n\t\trun: function() {\n\t\t\tthis.animate(this.coordinates(this._current));\n\t\t}\n\t}, {\n\t\tfilter: [ 'width', 'position', 'items', 'settings' ],\n\t\trun: function() {\n\t\t\tvar rtl = this.settings.rtl ? 1 : -1,\n\t\t\t\tpadding = this.settings.stagePadding * 2,\n\t\t\t\tbegin = this.coordinates(this.current()) + padding,\n\t\t\t\tend = begin + this.width() * rtl,\n\t\t\t\tinner, outer, matches = [], i, n;\n\n\t\t\tfor (i = 0, n = this._coordinates.length; i < n; i++) {\n\t\t\t\tinner = this._coordinates[i - 1] || 0;\n\t\t\t\touter = Math.abs(this._coordinates[i]) + padding * rtl;\n\n\t\t\t\tif ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))\n\t\t\t\t\t|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {\n\t\t\t\t\tmatches.push(i);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tthis.$stage.children('.active').removeClass('active');\n\t\t\tthis.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');\n\n\t\t\tif (this.settings.center) {\n\t\t\t\tthis.$stage.children('.center').removeClass('center');\n\t\t\t\tthis.$stage.children().eq(this.current()).addClass('center');\n\t\t\t}\n\t\t}\n\t} ];\n\n\t/**\n\t * Initializes the carousel.\n\t * @protected\n\t */\n\tOwl.prototype.initialize = function() {\n\t\tthis.enter('initializing');\n\t\tthis.trigger('initialize');\n\n\t\tthis.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);\n\n\t\tif (this.settings.autoWidth && !this.is('pre-loading')) {\n\t\t\tvar imgs, nestedSelector, width;\n\t\t\timgs = this.$element.find('img');\n\t\t\tnestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;\n\t\t\twidth = this.$element.children(nestedSelector).width();\n\n\t\t\tif (imgs.length && width <= 0) {\n\t\t\t\tthis.preloadAutoWidthImages(imgs);\n\t\t\t}\n\t\t}\n\n\t\tthis.$element.addClass(this.options.loadingClass);\n\n\t\t// create stage\n\t\tthis.$stage = $('<' + this.settings.stageElement + ' class=\"' + this.settings.stageClass + '\"/>')\n\t\t\t.wrap('<div class=\"' + this.settings.stageOuterClass + '\"/>');\n\n\t\t// append stage\n\t\tthis.$element.append(this.$stage.parent());\n\n\t\t// append content\n\t\tthis.replace(this.$element.children().not(this.$stage.parent()));\n\n\t\t// check visibility\n\t\tif (this.$element.is(':visible')) {\n\t\t\t// update view\n\t\t\tthis.refresh();\n\t\t} else {\n\t\t\t// invalidate width\n\t\t\tthis.invalidate('width');\n\t\t}\n\n\t\tthis.$element\n\t\t\t.removeClass(this.options.loadingClass)\n\t\t\t.addClass(this.options.loadedClass);\n\n\t\t// register event handlers\n\t\tthis.registerEventHandlers();\n\n\t\tthis.leave('initializing');\n\t\tthis.trigger('initialized');\n\t};\n\n\t/**\n\t * Setups the current settings.\n\t * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?\n\t * @todo Support for media queries by using `matchMedia` would be nice.\n\t * @public\n\t */\n\tOwl.prototype.setup = function() {\n\t\tvar viewport = this.viewport(),\n\t\t\toverwrites = this.options.responsive,\n\t\t\tmatch = -1,\n\t\t\tsettings = null;\n\n\t\tif (!overwrites) {\n\t\t\tsettings = $.extend({}, this.options);\n\t\t} else {\n\t\t\t$.each(overwrites, function(breakpoint) {\n\t\t\t\tif (breakpoint <= viewport && breakpoint > match) {\n\t\t\t\t\tmatch = Number(breakpoint);\n\t\t\t\t}\n\t\t\t});\n\n\t\t\tsettings = $.extend({}, this.options, overwrites[match]);\n\t\t\tif (typeof settings.stagePadding === 'function') {\n\t\t\t\tsettings.stagePadding = settings.stagePadding();\n\t\t\t}\n\t\t\tdelete settings.responsive;\n\n\t\t\t// responsive class\n\t\t\tif (settings.responsiveClass) {\n\t\t\t\tthis.$element.attr('class',\n\t\t\t\t\tthis.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\\\S+\\\\s', 'g'), '$1' + match)\n\t\t\t\t);\n\t\t\t}\n\t\t}\n\n\t\tthis.trigger('change', { property: { name: 'settings', value: settings } });\n\t\tthis._breakpoint = match;\n\t\tthis.settings = settings;\n\t\tthis.invalidate('settings');\n\t\tthis.trigger('changed', { property: { name: 'settings', value: this.settings } });\n\t};\n\n\t/**\n\t * Updates option logic if necessery.\n\t * @protected\n\t */\n\tOwl.prototype.optionsLogic = function() {\n\t\tif (this.settings.autoWidth) {\n\t\t\tthis.settings.stagePadding = false;\n\t\t\tthis.settings.merge = false;\n\t\t}\n\t};\n\n\t/**\n\t * Prepares an item before add.\n\t * @todo Rename event parameter `content` to `item`.\n\t * @protected\n\t * @returns {jQuery|HTMLElement} - The item container.\n\t */\n\tOwl.prototype.prepare = function(item) {\n\t\tvar event = this.trigger('prepare', { content: item });\n\n\t\tif (!event.data) {\n\t\t\tevent.data = $('<' + this.settings.itemElement + '/>')\n\t\t\t\t.addClass(this.options.itemClass).append(item)\n\t\t}\n\n\t\tthis.trigger('prepared', { content: event.data });\n\n\t\treturn event.data;\n\t};\n\n\t/**\n\t * Updates the view.\n\t * @public\n\t */\n\tOwl.prototype.update = function() {\n\t\tvar i = 0,\n\t\t\tn = this._pipe.length,\n\t\t\tfilter = $.proxy(function(p) { return this[p] }, this._invalidated),\n\t\t\tcache = {};\n\n\t\twhile (i < n) {\n\t\t\tif (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {\n\t\t\t\tthis._pipe[i].run(cache);\n\t\t\t}\n\t\t\ti++;\n\t\t}\n\n\t\tthis._invalidated = {};\n\n\t\t!this.is('valid') && this.enter('valid');\n\t};\n\n\t/**\n\t * Gets the width of the view.\n\t * @public\n\t * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.\n\t * @returns {Number} - The width of the view in pixel.\n\t */\n\tOwl.prototype.width = function(dimension) {\n\t\tdimension = dimension || Owl.Width.Default;\n\t\tswitch (dimension) {\n\t\t\tcase Owl.Width.Inner:\n\t\t\tcase Owl.Width.Outer:\n\t\t\t\treturn this._width;\n\t\t\tdefault:\n\t\t\t\treturn this._width - this.settings.stagePadding * 2 + this.settings.margin;\n\t\t}\n\t};\n\n\t/**\n\t * Refreshes the carousel primarily for adaptive purposes.\n\t * @public\n\t */\n\tOwl.prototype.refresh = function() {\n\t\tthis.enter('refreshing');\n\t\tthis.trigger('refresh');\n\n\t\tthis.setup();\n\n\t\tthis.optionsLogic();\n\n\t\tthis.$element.addClass(this.options.refreshClass);\n\n\t\tthis.update();\n\n\t\tthis.$element.removeClass(this.options.refreshClass);\n\n\t\tthis.leave('refreshing');\n\t\tthis.trigger('refreshed');\n\t};\n\n\t/**\n\t * Checks window `resize` event.\n\t * @protected\n\t */\n\tOwl.prototype.onThrottledResize = function() {\n\t\twindow.clearTimeout(this.resizeTimer);\n\t\tthis.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);\n\t};\n\n\t/**\n\t * Checks window `resize` event.\n\t * @protected\n\t */\n\tOwl.prototype.onResize = function() {\n\t\tif (!this._items.length) {\n\t\t\treturn false;\n\t\t}\n\n\t\tif (this._width === this.$element.width()) {\n\t\t\treturn false;\n\t\t}\n\n\t\tif (!this.$element.is(':visible')) {\n\t\t\treturn false;\n\t\t}\n\n\t\tthis.enter('resizing');\n\n\t\tif (this.trigger('resize').isDefaultPrevented()) {\n\t\t\tthis.leave('resizing');\n\t\t\treturn false;\n\t\t}\n\n\t\tthis.invalidate('width');\n\n\t\tthis.refresh();\n\n\t\tthis.leave('resizing');\n\t\tthis.trigger('resized');\n\t};\n\n\t/**\n\t * Registers event handlers.\n\t * @todo Check `msPointerEnabled`\n\t * @todo #261\n\t * @protected\n\t */\n\tOwl.prototype.registerEventHandlers = function() {\n\t\tif ($.support.transition) {\n\t\t\tthis.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));\n\t\t}\n\n\t\tif (this.settings.responsive !== false) {\n\t\t\tthis.on(window, 'resize', this._handlers.onThrottledResize);\n\t\t}\n\n\t\tif (this.settings.mouseDrag) {\n\t\t\tthis.$element.addClass(this.options.dragClass);\n\t\t\tthis.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));\n\t\t\tthis.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });\n\t\t}\n\n\t\tif (this.settings.touchDrag){\n\t\t\tthis.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));\n\t\t\tthis.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));\n\t\t}\n\t};\n\n\t/**\n\t * Handles `touchstart` and `mousedown` events.\n\t * @todo Horizontal swipe threshold as option\n\t * @todo #261\n\t * @protected\n\t * @param {Event} event - The event arguments.\n\t */\n\tOwl.prototype.onDragStart = function(event) {\n\t\tvar stage = null;\n\n\t\tif (event.which === 3) {\n\t\t\treturn;\n\t\t}\n\n\t\tif ($.support.transform) {\n\t\t\tstage = this.$stage.css('transform').replace(/.*\\(|\\)| /g, '').split(',');\n\t\t\tstage = {\n\t\t\t\tx: stage[stage.length === 16 ? 12 : 4],\n\t\t\t\ty: stage[stage.length === 16 ? 13 : 5]\n\t\t\t};\n\t\t} else {\n\t\t\tstage = this.$stage.position();\n\t\t\tstage = {\n\t\t\t\tx: this.settings.rtl ?\n\t\t\t\t\tstage.left + this.$stage.width() - this.width() + this.settings.margin :\n\t\t\t\t\tstage.left,\n\t\t\t\ty: stage.top\n\t\t\t};\n\t\t}\n\n\t\tif (this.is('animating')) {\n\t\t\t$.support.transform ? this.animate(stage.x) : this.$stage.stop()\n\t\t\tthis.invalidate('position');\n\t\t}\n\n\t\tthis.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');\n\n\t\tthis.speed(0);\n\n\t\tthis._drag.time = new Date().getTime();\n\t\tthis._drag.target = $(event.target);\n\t\tthis._drag.stage.start = stage;\n\t\tthis._drag.stage.current = stage;\n\t\tthis._drag.pointer = this.pointer(event);\n\n\t\t$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));\n\n\t\t$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {\n\t\t\tvar delta = this.difference(this._drag.pointer, this.pointer(event));\n\n\t\t\t$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));\n\n\t\t\tif (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tevent.preventDefault();\n\n\t\t\tthis.enter('dragging');\n\t\t\tthis.trigger('drag');\n\t\t}, this));\n\t};\n\n\t/**\n\t * Handles the `touchmove` and `mousemove` events.\n\t * @todo #261\n\t * @protected\n\t * @param {Event} event - The event arguments.\n\t */\n\tOwl.prototype.onDragMove = function(event) {\n\t\tvar minimum = null,\n\t\t\tmaximum = null,\n\t\t\tpull = null,\n\t\t\tdelta = this.difference(this._drag.pointer, this.pointer(event)),\n\t\t\tstage = this.difference(this._drag.stage.start, delta);\n\n\t\tif (!this.is('dragging')) {\n\t\t\treturn;\n\t\t}\n\n\t\tevent.preventDefault();\n\n\t\tif (this.settings.loop) {\n\t\t\tminimum = this.coordinates(this.minimum());\n\t\t\tmaximum = this.coordinates(this.maximum() + 1) - minimum;\n\t\t\tstage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;\n\t\t} else {\n\t\t\tminimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());\n\t\t\tmaximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());\n\t\t\tpull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;\n\t\t\tstage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);\n\t\t}\n\n\t\tthis._drag.stage.current = stage;\n\n\t\tthis.animate(stage.x);\n\t};\n\n\t/**\n\t * Handles the `touchend` and `mouseup` events.\n\t * @todo #261\n\t * @todo Threshold for click event\n\t * @protected\n\t * @param {Event} event - The event arguments.\n\t */\n\tOwl.prototype.onDragEnd = function(event) {\n\t\tvar delta = this.difference(this._drag.pointer, this.pointer(event)),\n\t\t\tstage = this._drag.stage.current,\n\t\t\tdirection = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';\n\n\t\t$(document).off('.owl.core');\n\n\t\tthis.$element.removeClass(this.options.grabClass);\n\n\t\tif (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {\n\t\t\tthis.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);\n\t\t\tthis.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));\n\t\t\tthis.invalidate('position');\n\t\t\tthis.update();\n\n\t\t\tthis._drag.direction = direction;\n\n\t\t\tif (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {\n\t\t\t\tthis._drag.target.one('click.owl.core', function() { return false; });\n\t\t\t}\n\t\t}\n\n\t\tif (!this.is('dragging')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.leave('dragging');\n\t\tthis.trigger('dragged');\n\t};\n\n\t/**\n\t * Gets absolute position of the closest item for a coordinate.\n\t * @todo Setting `freeDrag` makes `closest` not reusable. See #165.\n\t * @protected\n\t * @param {Number} coordinate - The coordinate in pixel.\n\t * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.\n\t * @return {Number} - The absolute position of the closest item.\n\t */\n\tOwl.prototype.closest = function(coordinate, direction) {\n\t\tvar position = -1,\n\t\t\tpull = 30,\n\t\t\twidth = this.width(),\n\t\t\tcoordinates = this.coordinates();\n\n\t\tif (!this.settings.freeDrag) {\n\t\t\t// check closest item\n\t\t\t$.each(coordinates, $.proxy(function(index, value) {\n\t\t\t\t// on a left pull, check on current index\n\t\t\t\tif (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {\n\t\t\t\t\tposition = index;\n\t\t\t\t// on a right pull, check on previous index\n\t\t\t\t// to do so, subtract width from value and set position = index + 1\n\t\t\t\t} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {\n\t\t\t\t\tposition = index + 1;\n\t\t\t\t} else if (this.op(coordinate, '<', value)\n\t\t\t\t\t&& this.op(coordinate, '>', coordinates[index + 1] || value - width)) {\n\t\t\t\t\tposition = direction === 'left' ? index + 1 : index;\n\t\t\t\t}\n\t\t\t\treturn position === -1;\n\t\t\t}, this));\n\t\t}\n\n\t\tif (!this.settings.loop) {\n\t\t\t// non loop boundries\n\t\t\tif (this.op(coordinate, '>', coordinates[this.minimum()])) {\n\t\t\t\tposition = coordinate = this.minimum();\n\t\t\t} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {\n\t\t\t\tposition = coordinate = this.maximum();\n\t\t\t}\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n\t * Animates the stage.\n\t * @todo #270\n\t * @public\n\t * @param {Number} coordinate - The coordinate in pixels.\n\t */\n\tOwl.prototype.animate = function(coordinate) {\n\t\tvar animate = this.speed() > 0;\n\n\t\tthis.is('animating') && this.onTransitionEnd();\n\n\t\tif (animate) {\n\t\t\tthis.enter('animating');\n\t\t\tthis.trigger('translate');\n\t\t}\n\n\t\tif ($.support.transform3d && $.support.transition) {\n\t\t\tthis.$stage.css({\n\t\t\t\ttransform: 'translate3d(' + coordinate + 'px,0px,0px)',\n\t\t\t\ttransition: (this.speed() / 1000) + 's'\n\t\t\t});\n\t\t} else if (animate) {\n\t\t\tthis.$stage.animate({\n\t\t\t\tleft: coordinate + 'px'\n\t\t\t}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));\n\t\t} else {\n\t\t\tthis.$stage.css({\n\t\t\t\tleft: coordinate + 'px'\n\t\t\t});\n\t\t}\n\t};\n\n\t/**\n\t * Checks whether the carousel is in a specific state or not.\n\t * @param {String} state - The state to check.\n\t * @returns {Boolean} - The flag which indicates if the carousel is busy.\n\t */\n\tOwl.prototype.is = function(state) {\n\t\treturn this._states.current[state] && this._states.current[state] > 0;\n\t};\n\n\t/**\n\t * Sets the absolute position of the current item.\n\t * @public\n\t * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.\n\t * @returns {Number} - The absolute position of the current item.\n\t */\n\tOwl.prototype.current = function(position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._current;\n\t\t}\n\n\t\tif (this._items.length === 0) {\n\t\t\treturn undefined;\n\t\t}\n\n\t\tposition = this.normalize(position);\n\n\t\tif (this._current !== position) {\n\t\t\tvar event = this.trigger('change', { property: { name: 'position', value: position } });\n\n\t\t\tif (event.data !== undefined) {\n\t\t\t\tposition = this.normalize(event.data);\n\t\t\t}\n\n\t\t\tthis._current = position;\n\n\t\t\tthis.invalidate('position');\n\n\t\t\tthis.trigger('changed', { property: { name: 'position', value: this._current } });\n\t\t}\n\n\t\treturn this._current;\n\t};\n\n\t/**\n\t * Invalidates the given part of the update routine.\n\t * @param {String} [part] - The part to invalidate.\n\t * @returns {Array.<String>} - The invalidated parts.\n\t */\n\tOwl.prototype.invalidate = function(part) {\n\t\tif ($.type(part) === 'string') {\n\t\t\tthis._invalidated[part] = true;\n\t\t\tthis.is('valid') && this.leave('valid');\n\t\t}\n\t\treturn $.map(this._invalidated, function(v, i) { return i });\n\t};\n\n\t/**\n\t * Resets the absolute position of the current item.\n\t * @public\n\t * @param {Number} position - The absolute position of the new item.\n\t */\n\tOwl.prototype.reset = function(position) {\n\t\tposition = this.normalize(position);\n\n\t\tif (position === undefined) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._speed = 0;\n\t\tthis._current = position;\n\n\t\tthis.suppress([ 'translate', 'translated' ]);\n\n\t\tthis.animate(this.coordinates(position));\n\n\t\tthis.release([ 'translate', 'translated' ]);\n\t};\n\n\t/**\n\t * Normalizes an absolute or a relative position of an item.\n\t * @public\n\t * @param {Number} position - The absolute or relative position to normalize.\n\t * @param {Boolean} [relative=false] - Whether the given position is relative or not.\n\t * @returns {Number} - The normalized position.\n\t */\n\tOwl.prototype.normalize = function(position, relative) {\n\t\tvar n = this._items.length,\n\t\t\tm = relative ? 0 : this._clones.length;\n\n\t\tif (!this.isNumeric(position) || n < 1) {\n\t\t\tposition = undefined;\n\t\t} else if (position < 0 || position >= n + m) {\n\t\t\tposition = ((position - m / 2) % n + n) % n + m / 2;\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n\t * Converts an absolute position of an item into a relative one.\n\t * @public\n\t * @param {Number} position - The absolute position to convert.\n\t * @returns {Number} - The converted position.\n\t */\n\tOwl.prototype.relative = function(position) {\n\t\tposition -= this._clones.length / 2;\n\t\treturn this.normalize(position, true);\n\t};\n\n\t/**\n\t * Gets the maximum position for the current item.\n\t * @public\n\t * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.\n\t * @returns {Number}\n\t */\n\tOwl.prototype.maximum = function(relative) {\n\t\tvar settings = this.settings,\n\t\t\tmaximum = this._coordinates.length,\n\t\t\titerator,\n\t\t\treciprocalItemsWidth,\n\t\t\telementWidth;\n\n\t\tif (settings.loop) {\n\t\t\tmaximum = this._clones.length / 2 + this._items.length - 1;\n\t\t} else if (settings.autoWidth || settings.merge) {\n\t\t\titerator = this._items.length;\n\t\t\treciprocalItemsWidth = this._items[--iterator].width();\n\t\t\telementWidth = this.$element.width();\n\t\t\twhile (iterator--) {\n\t\t\t\treciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;\n\t\t\t\tif (reciprocalItemsWidth > elementWidth) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t\tmaximum = iterator + 1;\n\t\t} else if (settings.center) {\n\t\t\tmaximum = this._items.length - 1;\n\t\t} else {\n\t\t\tmaximum = this._items.length - settings.items;\n\t\t}\n\n\t\tif (relative) {\n\t\t\tmaximum -= this._clones.length / 2;\n\t\t}\n\n\t\treturn Math.max(maximum, 0);\n\t};\n\n\t/**\n\t * Gets the minimum position for the current item.\n\t * @public\n\t * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.\n\t * @returns {Number}\n\t */\n\tOwl.prototype.minimum = function(relative) {\n\t\treturn relative ? 0 : this._clones.length / 2;\n\t};\n\n\t/**\n\t * Gets an item at the specified relative position.\n\t * @public\n\t * @param {Number} [position] - The relative position of the item.\n\t * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.\n\t */\n\tOwl.prototype.items = function(position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._items.slice();\n\t\t}\n\n\t\tposition = this.normalize(position, true);\n\t\treturn this._items[position];\n\t};\n\n\t/**\n\t * Gets an item at the specified relative position.\n\t * @public\n\t * @param {Number} [position] - The relative position of the item.\n\t * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.\n\t */\n\tOwl.prototype.mergers = function(position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._mergers.slice();\n\t\t}\n\n\t\tposition = this.normalize(position, true);\n\t\treturn this._mergers[position];\n\t};\n\n\t/**\n\t * Gets the absolute positions of clones for an item.\n\t * @public\n\t * @param {Number} [position] - The relative position of the item.\n\t * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.\n\t */\n\tOwl.prototype.clones = function(position) {\n\t\tvar odd = this._clones.length / 2,\n\t\t\teven = odd + this._items.length,\n\t\t\tmap = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };\n\n\t\tif (position === undefined) {\n\t\t\treturn $.map(this._clones, function(v, i) { return map(i) });\n\t\t}\n\n\t\treturn $.map(this._clones, function(v, i) { return v === position ? map(i) : null });\n\t};\n\n\t/**\n\t * Sets the current animation speed.\n\t * @public\n\t * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.\n\t * @returns {Number} - The current animation speed in milliseconds.\n\t */\n\tOwl.prototype.speed = function(speed) {\n\t\tif (speed !== undefined) {\n\t\t\tthis._speed = speed;\n\t\t}\n\n\t\treturn this._speed;\n\t};\n\n\t/**\n\t * Gets the coordinate of an item.\n\t * @todo The name of this method is missleanding.\n\t * @public\n\t * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.\n\t * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.\n\t */\n\tOwl.prototype.coordinates = function(position) {\n\t\tvar multiplier = 1,\n\t\t\tnewPosition = position - 1,\n\t\t\tcoordinate;\n\n\t\tif (position === undefined) {\n\t\t\treturn $.map(this._coordinates, $.proxy(function(coordinate, index) {\n\t\t\t\treturn this.coordinates(index);\n\t\t\t}, this));\n\t\t}\n\n\t\tif (this.settings.center) {\n\t\t\tif (this.settings.rtl) {\n\t\t\t\tmultiplier = -1;\n\t\t\t\tnewPosition = position + 1;\n\t\t\t}\n\n\t\t\tcoordinate = this._coordinates[position];\n\t\t\tcoordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;\n\t\t} else {\n\t\t\tcoordinate = this._coordinates[newPosition] || 0;\n\t\t}\n\n\t\tcoordinate = Math.ceil(coordinate);\n\n\t\treturn coordinate;\n\t};\n\n\t/**\n\t * Calculates the speed for a translation.\n\t * @protected\n\t * @param {Number} from - The absolute position of the start item.\n\t * @param {Number} to - The absolute position of the target item.\n\t * @param {Number} [factor=undefined] - The time factor in milliseconds.\n\t * @returns {Number} - The time in milliseconds for the translation.\n\t */\n\tOwl.prototype.duration = function(from, to, factor) {\n\t\tif (factor === 0) {\n\t\t\treturn 0;\n\t\t}\n\n\t\treturn Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));\n\t};\n\n\t/**\n\t * Slides to the specified item.\n\t * @public\n\t * @param {Number} position - The position of the item.\n\t * @param {Number} [speed] - The time in milliseconds for the transition.\n\t */\n\tOwl.prototype.to = function(position, speed) {\n\t\tvar current = this.current(),\n\t\t\trevert = null,\n\t\t\tdistance = position - this.relative(current),\n\t\t\tdirection = (distance > 0) - (distance < 0),\n\t\t\titems = this._items.length,\n\t\t\tminimum = this.minimum(),\n\t\t\tmaximum = this.maximum();\n\n\t\tif (this.settings.loop) {\n\t\t\tif (!this.settings.rewind && Math.abs(distance) > items / 2) {\n\t\t\t\tdistance += direction * -1 * items;\n\t\t\t}\n\n\t\t\tposition = current + distance;\n\t\t\trevert = ((position - minimum) % items + items) % items + minimum;\n\n\t\t\tif (revert !== position && revert - distance <= maximum && revert - distance > 0) {\n\t\t\t\tcurrent = revert - distance;\n\t\t\t\tposition = revert;\n\t\t\t\tthis.reset(current);\n\t\t\t}\n\t\t} else if (this.settings.rewind) {\n\t\t\tmaximum += 1;\n\t\t\tposition = (position % maximum + maximum) % maximum;\n\t\t} else {\n\t\t\tposition = Math.max(minimum, Math.min(maximum, position));\n\t\t}\n\n\t\tthis.speed(this.duration(current, position, speed));\n\t\tthis.current(position);\n\n\t\tif (this.$element.is(':visible')) {\n\t\t\tthis.update();\n\t\t}\n\t};\n\n\t/**\n\t * Slides to the next item.\n\t * @public\n\t * @param {Number} [speed] - The time in milliseconds for the transition.\n\t */\n\tOwl.prototype.next = function(speed) {\n\t\tspeed = speed || false;\n\t\tthis.to(this.relative(this.current()) + 1, speed);\n\t};\n\n\t/**\n\t * Slides to the previous item.\n\t * @public\n\t * @param {Number} [speed] - The time in milliseconds for the transition.\n\t */\n\tOwl.prototype.prev = function(speed) {\n\t\tspeed = speed || false;\n\t\tthis.to(this.relative(this.current()) - 1, speed);\n\t};\n\n\t/**\n\t * Handles the end of an animation.\n\t * @protected\n\t * @param {Event} event - The event arguments.\n\t */\n\tOwl.prototype.onTransitionEnd = function(event) {\n\n\t\t// if css2 animation then event object is undefined\n\t\tif (event !== undefined) {\n\t\t\tevent.stopPropagation();\n\n\t\t\t// Catch only owl-stage transitionEnd event\n\t\t\tif ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {\n\t\t\t\treturn false;\n\t\t\t}\n\t\t}\n\n\t\tthis.leave('animating');\n\t\tthis.trigger('translated');\n\t};\n\n\t/**\n\t * Gets viewport width.\n\t * @protected\n\t * @return {Number} - The width in pixel.\n\t */\n\tOwl.prototype.viewport = function() {\n\t\tvar width;\n\t\tif (this.options.responsiveBaseElement !== window) {\n\t\t\twidth = $(this.options.responsiveBaseElement).width();\n\t\t} else if (window.innerWidth) {\n\t\t\twidth = window.innerWidth;\n\t\t} else if (document.documentElement && document.documentElement.clientWidth) {\n\t\t\twidth = document.documentElement.clientWidth;\n\t\t} else {\n\t\t\tthrow 'Can not detect viewport width.';\n\t\t}\n\t\treturn width;\n\t};\n\n\t/**\n\t * Replaces the current content.\n\t * @public\n\t * @param {HTMLElement|jQuery|String} content - The new content.\n\t */\n\tOwl.prototype.replace = function(content) {\n\t\tthis.$stage.empty();\n\t\tthis._items = [];\n\n\t\tif (content) {\n\t\t\tcontent = (content instanceof jQuery) ? content : $(content);\n\t\t}\n\n\t\tif (this.settings.nestedItemSelector) {\n\t\t\tcontent = content.find('.' + this.settings.nestedItemSelector);\n\t\t}\n\n\t\tcontent.filter(function() {\n\t\t\treturn this.nodeType === 1;\n\t\t}).each($.proxy(function(index, item) {\n\t\t\titem = this.prepare(item);\n\t\t\tthis.$stage.append(item);\n\t\t\tthis._items.push(item);\n\t\t\tthis._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t}, this));\n\n\t\tthis.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);\n\n\t\tthis.invalidate('items');\n\t};\n\n\t/**\n\t * Adds an item.\n\t * @todo Use `item` instead of `content` for the event arguments.\n\t * @public\n\t * @param {HTMLElement|jQuery|String} content - The item content to add.\n\t * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.\n\t */\n\tOwl.prototype.add = function(content, position) {\n\t\tvar current = this.relative(this._current);\n\n\t\tposition = position === undefined ? this._items.length : this.normalize(position, true);\n\t\tcontent = content instanceof jQuery ? content : $(content);\n\n\t\tthis.trigger('add', { content: content, position: position });\n\n\t\tcontent = this.prepare(content);\n\n\t\tif (this._items.length === 0 || position === this._items.length) {\n\t\t\tthis._items.length === 0 && this.$stage.append(content);\n\t\t\tthis._items.length !== 0 && this._items[position - 1].after(content);\n\t\t\tthis._items.push(content);\n\t\t\tthis._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t} else {\n\t\t\tthis._items[position].before(content);\n\t\t\tthis._items.splice(position, 0, content);\n\t\t\tthis._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t}\n\n\t\tthis._items[current] && this.reset(this._items[current].index());\n\n\t\tthis.invalidate('items');\n\n\t\tthis.trigger('added', { content: content, position: position });\n\t};\n\n\t/**\n\t * Removes an item by its position.\n\t * @todo Use `item` instead of `content` for the event arguments.\n\t * @public\n\t * @param {Number} position - The relative position of the item to remove.\n\t */\n\tOwl.prototype.remove = function(position) {\n\t\tposition = this.normalize(position, true);\n\n\t\tif (position === undefined) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.trigger('remove', { content: this._items[position], position: position });\n\n\t\tthis._items[position].remove();\n\t\tthis._items.splice(position, 1);\n\t\tthis._mergers.splice(position, 1);\n\n\t\tthis.invalidate('items');\n\n\t\tthis.trigger('removed', { content: null, position: position });\n\t};\n\n\t/**\n\t * Preloads images with auto width.\n\t * @todo Replace by a more generic approach\n\t * @protected\n\t */\n\tOwl.prototype.preloadAutoWidthImages = function(images) {\n\t\timages.each($.proxy(function(i, element) {\n\t\t\tthis.enter('pre-loading');\n\t\t\telement = $(element);\n\t\t\t$(new Image()).one('load', $.proxy(function(e) {\n\t\t\t\telement.attr('src', e.target.src);\n\t\t\t\telement.css('opacity', 1);\n\t\t\t\tthis.leave('pre-loading');\n\t\t\t\t!this.is('pre-loading') && !this.is('initializing') && this.refresh();\n\t\t\t}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));\n\t\t}, this));\n\t};\n\n\t/**\n\t * Destroys the carousel.\n\t * @public\n\t */\n\tOwl.prototype.destroy = function() {\n\n\t\tthis.$element.off('.owl.core');\n\t\tthis.$stage.off('.owl.core');\n\t\t$(document).off('.owl.core');\n\n\t\tif (this.settings.responsive !== false) {\n\t\t\twindow.clearTimeout(this.resizeTimer);\n\t\t\tthis.off(window, 'resize', this._handlers.onThrottledResize);\n\t\t}\n\n\t\tfor (var i in this._plugins) {\n\t\t\tthis._plugins[i].destroy();\n\t\t}\n\n\t\tthis.$stage.children('.cloned').remove();\n\n\t\tthis.$stage.unwrap();\n\t\tthis.$stage.children().contents().unwrap();\n\t\tthis.$stage.children().unwrap();\n\n\t\tthis.$element\n\t\t\t.removeClass(this.options.refreshClass)\n\t\t\t.removeClass(this.options.loadingClass)\n\t\t\t.removeClass(this.options.loadedClass)\n\t\t\t.removeClass(this.options.rtlClass)\n\t\t\t.removeClass(this.options.dragClass)\n\t\t\t.removeClass(this.options.grabClass)\n\t\t\t.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\\\S+\\\\s', 'g'), ''))\n\t\t\t.removeData('owl.carousel');\n\t};\n\n\t/**\n\t * Operators to calculate right-to-left and left-to-right.\n\t * @protected\n\t * @param {Number} [a] - The left side operand.\n\t * @param {String} [o] - The operator.\n\t * @param {Number} [b] - The right side operand.\n\t */\n\tOwl.prototype.op = function(a, o, b) {\n\t\tvar rtl = this.settings.rtl;\n\t\tswitch (o) {\n\t\t\tcase '<':\n\t\t\t\treturn rtl ? a > b : a < b;\n\t\t\tcase '>':\n\t\t\t\treturn rtl ? a < b : a > b;\n\t\t\tcase '>=':\n\t\t\t\treturn rtl ? a <= b : a >= b;\n\t\t\tcase '<=':\n\t\t\t\treturn rtl ? a >= b : a <= b;\n\t\t\tdefault:\n\t\t\t\tbreak;\n\t\t}\n\t};\n\n\t/**\n\t * Attaches to an internal event.\n\t * @protected\n\t * @param {HTMLElement} element - The event source.\n\t * @param {String} event - The event name.\n\t * @param {Function} listener - The event handler to attach.\n\t * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.\n\t */\n\tOwl.prototype.on = function(element, event, listener, capture) {\n\t\tif (element.addEventListener) {\n\t\t\telement.addEventListener(event, listener, capture);\n\t\t} else if (element.attachEvent) {\n\t\t\telement.attachEvent('on' + event, listener);\n\t\t}\n\t};\n\n\t/**\n\t * Detaches from an internal event.\n\t * @protected\n\t * @param {HTMLElement} element - The event source.\n\t * @param {String} event - The event name.\n\t * @param {Function} listener - The attached event handler to detach.\n\t * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.\n\t */\n\tOwl.prototype.off = function(element, event, listener, capture) {\n\t\tif (element.removeEventListener) {\n\t\t\telement.removeEventListener(event, listener, capture);\n\t\t} else if (element.detachEvent) {\n\t\t\telement.detachEvent('on' + event, listener);\n\t\t}\n\t};\n\n\t/**\n\t * Triggers a public event.\n\t * @todo Remove `status`, `relatedTarget` should be used instead.\n\t * @protected\n\t * @param {String} name - The event name.\n\t * @param {*} [data=null] - The event data.\n\t * @param {String} [namespace=carousel] - The event namespace.\n\t * @param {String} [state] - The state which is associated with the event.\n\t * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.\n\t * @returns {Event} - The event arguments.\n\t */\n\tOwl.prototype.trigger = function(name, data, namespace, state, enter) {\n\t\tvar status = {\n\t\t\titem: { count: this._items.length, index: this.current() }\n\t\t}, handler = $.camelCase(\n\t\t\t$.grep([ 'on', name, namespace ], function(v) { return v })\n\t\t\t\t.join('-').toLowerCase()\n\t\t), event = $.Event(\n\t\t\t[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),\n\t\t\t$.extend({ relatedTarget: this }, status, data)\n\t\t);\n\n\t\tif (!this._supress[name]) {\n\t\t\t$.each(this._plugins, function(name, plugin) {\n\t\t\t\tif (plugin.onTrigger) {\n\t\t\t\t\tplugin.onTrigger(event);\n\t\t\t\t}\n\t\t\t});\n\n\t\t\tthis.register({ type: Owl.Type.Event, name: name });\n\t\t\tthis.$element.trigger(event);\n\n\t\t\tif (this.settings && typeof this.settings[handler] === 'function') {\n\t\t\t\tthis.settings[handler].call(this, event);\n\t\t\t}\n\t\t}\n\n\t\treturn event;\n\t};\n\n\t/**\n\t * Enters a state.\n\t * @param name - The state name.\n\t */\n\tOwl.prototype.enter = function(name) {\n\t\t$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {\n\t\t\tif (this._states.current[name] === undefined) {\n\t\t\t\tthis._states.current[name] = 0;\n\t\t\t}\n\n\t\t\tthis._states.current[name]++;\n\t\t}, this));\n\t};\n\n\t/**\n\t * Leaves a state.\n\t * @param name - The state name.\n\t */\n\tOwl.prototype.leave = function(name) {\n\t\t$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {\n\t\t\tthis._states.current[name]--;\n\t\t}, this));\n\t};\n\n\t/**\n\t * Registers an event or state.\n\t * @public\n\t * @param {Object} object - The event or state to register.\n\t */\n\tOwl.prototype.register = function(object) {\n\t\tif (object.type === Owl.Type.Event) {\n\t\t\tif (!$.event.special[object.name]) {\n\t\t\t\t$.event.special[object.name] = {};\n\t\t\t}\n\n\t\t\tif (!$.event.special[object.name].owl) {\n\t\t\t\tvar _default = $.event.special[object.name]._default;\n\t\t\t\t$.event.special[object.name]._default = function(e) {\n\t\t\t\t\tif (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {\n\t\t\t\t\t\treturn _default.apply(this, arguments);\n\t\t\t\t\t}\n\t\t\t\t\treturn e.namespace && e.namespace.indexOf('owl') > -1;\n\t\t\t\t};\n\t\t\t\t$.event.special[object.name].owl = true;\n\t\t\t}\n\t\t} else if (object.type === Owl.Type.State) {\n\t\t\tif (!this._states.tags[object.name]) {\n\t\t\t\tthis._states.tags[object.name] = object.tags;\n\t\t\t} else {\n\t\t\t\tthis._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);\n\t\t\t}\n\n\t\t\tthis._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {\n\t\t\t\treturn $.inArray(tag, this._states.tags[object.name]) === i;\n\t\t\t}, this));\n\t\t}\n\t};\n\n\t/**\n\t * Suppresses events.\n\t * @protected\n\t * @param {Array.<String>} events - The events to suppress.\n\t */\n\tOwl.prototype.suppress = function(events) {\n\t\t$.each(events, $.proxy(function(index, event) {\n\t\t\tthis._supress[event] = true;\n\t\t}, this));\n\t};\n\n\t/**\n\t * Releases suppressed events.\n\t * @protected\n\t * @param {Array.<String>} events - The events to release.\n\t */\n\tOwl.prototype.release = function(events) {\n\t\t$.each(events, $.proxy(function(index, event) {\n\t\t\tdelete this._supress[event];\n\t\t}, this));\n\t};\n\n\t/**\n\t * Gets unified pointer coordinates from event.\n\t * @todo #261\n\t * @protected\n\t * @param {Event} - The `mousedown` or `touchstart` event.\n\t * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.\n\t */\n\tOwl.prototype.pointer = function(event) {\n\t\tvar result = { x: null, y: null };\n\n\t\tevent = event.originalEvent || event || window.event;\n\n\t\tevent = event.touches && event.touches.length ?\n\t\t\tevent.touches[0] : event.changedTouches && event.changedTouches.length ?\n\t\t\t\tevent.changedTouches[0] : event;\n\n\t\tif (event.pageX) {\n\t\t\tresult.x = event.pageX;\n\t\t\tresult.y = event.pageY;\n\t\t} else {\n\t\t\tresult.x = event.clientX;\n\t\t\tresult.y = event.clientY;\n\t\t}\n\n\t\treturn result;\n\t};\n\n\t/**\n\t * Determines if the input is a Number or something that can be coerced to a Number\n\t * @protected\n\t * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested\n\t * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number\n\t */\n\tOwl.prototype.isNumeric = function(number) {\n\t\treturn !isNaN(parseFloat(number));\n\t};\n\n\t/**\n\t * Gets the difference of two vectors.\n\t * @todo #261\n\t * @protected\n\t * @param {Object} - The first vector.\n\t * @param {Object} - The second vector.\n\t * @returns {Object} - The difference.\n\t */\n\tOwl.prototype.difference = function(first, second) {\n\t\treturn {\n\t\t\tx: first.x - second.x,\n\t\t\ty: first.y - second.y\n\t\t};\n\t};\n\n\t/**\n\t * The jQuery Plugin for the Owl Carousel\n\t * @todo Navigation plugin `next` and `prev`\n\t * @public\n\t */\n\t$.fn.owlCarousel = function(option) {\n\t\tvar args = Array.prototype.slice.call(arguments, 1);\n\n\t\treturn this.each(function() {\n\t\t\tvar $this = $(this),\n\t\t\t\tdata = $this.data('owl.carousel');\n\n\t\t\tif (!data) {\n\t\t\t\tdata = new Owl(this, typeof option == 'object' && option);\n\t\t\t\t$this.data('owl.carousel', data);\n\n\t\t\t\t$.each([\n\t\t\t\t\t'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'\n\t\t\t\t], function(i, event) {\n\t\t\t\t\tdata.register({ type: Owl.Type.Event, name: event });\n\t\t\t\t\tdata.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {\n\t\t\t\t\t\tif (e.namespace && e.relatedTarget !== this) {\n\t\t\t\t\t\t\tthis.suppress([ event ]);\n\t\t\t\t\t\t\tdata[event].apply(this, [].slice.call(arguments, 1));\n\t\t\t\t\t\t\tthis.release([ event ]);\n\t\t\t\t\t\t}\n\t\t\t\t\t}, data));\n\t\t\t\t});\n\t\t\t}\n\n\t\t\tif (typeof option == 'string' && option.charAt(0) !== '_') {\n\t\t\t\tdata[option].apply(data, args);\n\t\t\t}\n\t\t});\n\t};\n\n\t/**\n\t * The constructor for the jQuery Plugin\n\t * @public\n\t */\n\t$.fn.owlCarousel.Constructor = Owl;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * AutoRefresh Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates the auto refresh plugin.\n\t * @class The Auto Refresh Plugin\n\t * @param {Owl} carousel - The Owl Carousel\n\t */\n\tvar AutoRefresh = function(carousel) {\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * Refresh interval.\n\t\t * @protected\n\t\t * @type {number}\n\t\t */\n\t\tthis._interval = null;\n\n\t\t/**\n\t\t * Whether the element is currently visible or not.\n\t\t * @protected\n\t\t * @type {Boolean}\n\t\t */\n\t\tthis._visible = null;\n\n\t\t/**\n\t\t * All event handlers.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoRefresh) {\n\t\t\t\t\tthis.watch();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tAutoRefresh.Defaults = {\n\t\tautoRefresh: true,\n\t\tautoRefreshInterval: 500\n\t};\n\n\t/**\n\t * Watches the element.\n\t */\n\tAutoRefresh.prototype.watch = function() {\n\t\tif (this._interval) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._visible = this._core.$element.is(':visible');\n\t\tthis._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);\n\t};\n\n\t/**\n\t * Refreshes the element.\n\t */\n\tAutoRefresh.prototype.refresh = function() {\n\t\tif (this._core.$element.is(':visible') === this._visible) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._visible = !this._visible;\n\n\t\tthis._core.$element.toggleClass('owl-hidden', !this._visible);\n\n\t\tthis._visible && (this._core.invalidate('width') && this._core.refresh());\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t */\n\tAutoRefresh.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\twindow.clearInterval(this._interval);\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Lazy Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates the lazy plugin.\n\t * @class The Lazy Plugin\n\t * @param {Owl} carousel - The Owl Carousel\n\t */\n\tvar Lazy = function(carousel) {\n\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * Already loaded items.\n\t\t * @protected\n\t\t * @type {Array.<jQuery>}\n\t\t */\n\t\tthis._loaded = [];\n\n\t\t/**\n\t\t * Event handlers.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (!e.namespace) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tif (!this._core.settings || !this._core.settings.lazyLoad) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tif ((e.property && e.property.name == 'position') || e.type == 'initialized') {\n\t\t\t\t\tvar settings = this._core.settings,\n\t\t\t\t\t\tn = (settings.center && Math.ceil(settings.items / 2) || settings.items),\n\t\t\t\t\t\ti = ((settings.center && n * -1) || 0),\n\t\t\t\t\t\tposition = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,\n\t\t\t\t\t\tclones = this._core.clones().length,\n\t\t\t\t\t\tload = $.proxy(function(i, v) { this.load(v) }, this);\n\n\t\t\t\t\twhile (i++ < n) {\n\t\t\t\t\t\tthis.load(clones / 2 + this._core.relative(position));\n\t\t\t\t\t\tclones && $.each(this._core.clones(this._core.relative(position)), load);\n\t\t\t\t\t\tposition++;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set the default options\n\t\tthis._core.options = $.extend({}, Lazy.Defaults, this._core.options);\n\n\t\t// register event handler\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tLazy.Defaults = {\n\t\tlazyLoad: false\n\t};\n\n\t/**\n\t * Loads all resources of an item at the specified position.\n\t * @param {Number} position - The absolute position of the item.\n\t * @protected\n\t */\n\tLazy.prototype.load = function(position) {\n\t\tvar $item = this._core.$stage.children().eq(position),\n\t\t\t$elements = $item && $item.find('.owl-lazy');\n\n\t\tif (!$elements || $.inArray($item.get(0), this._loaded) > -1) {\n\t\t\treturn;\n\t\t}\n\n\t\t$elements.each($.proxy(function(index, element) {\n\t\t\tvar $element = $(element), image,\n\t\t\t\turl = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src');\n\n\t\t\tthis._core.trigger('load', { element: $element, url: url }, 'lazy');\n\n\t\t\tif ($element.is('img')) {\n\t\t\t\t$element.one('load.owl.lazy', $.proxy(function() {\n\t\t\t\t\t$element.css('opacity', 1);\n\t\t\t\t\tthis._core.trigger('loaded', { element: $element, url: url }, 'lazy');\n\t\t\t\t}, this)).attr('src', url);\n\t\t\t} else {\n\t\t\t\timage = new Image();\n\t\t\t\timage.onload = $.proxy(function() {\n\t\t\t\t\t$element.css({\n\t\t\t\t\t\t'background-image': 'url(' + url + ')',\n\t\t\t\t\t\t'opacity': '1'\n\t\t\t\t\t});\n\t\t\t\t\tthis._core.trigger('loaded', { element: $element, url: url }, 'lazy');\n\t\t\t\t}, this);\n\t\t\t\timage.src = url;\n\t\t\t}\n\t\t}, this));\n\n\t\tthis._loaded.push($item.get(0));\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t * @public\n\t */\n\tLazy.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\tfor (handler in this.handlers) {\n\t\t\tthis._core.$element.off(handler, this.handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * AutoHeight Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates the auto height plugin.\n\t * @class The Auto Height Plugin\n\t * @param {Owl} carousel - The Owl Carousel\n\t */\n\tvar AutoHeight = function(carousel) {\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * All event handlers.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight) {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight && e.property.name == 'position'){\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'loaded.owl.lazy': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight\n\t\t\t\t\t&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tAutoHeight.Defaults = {\n\t\tautoHeight: false,\n\t\tautoHeightClass: 'owl-height'\n\t};\n\n\t/**\n\t * Updates the view.\n\t */\n\tAutoHeight.prototype.update = function() {\n\t\tvar start = this._core._current,\n\t\t\tend = start + this._core.settings.items,\n\t\t\tvisible = this._core.$stage.children().toArray().slice(start, end),\n\t\t\theights = [],\n\t\t\tmaxheight = 0;\n\n\t\t$.each(visible, function(index, item) {\n\t\t\theights.push($(item).height());\n\t\t});\n\n\t\tmaxheight = Math.max.apply(null, heights);\n\n\t\tthis._core.$stage.parent()\n\t\t\t.height(maxheight)\n\t\t\t.addClass(this._core.settings.autoHeightClass);\n\t};\n\n\tAutoHeight.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Video Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates the video plugin.\n\t * @class The Video Plugin\n\t * @param {Owl} carousel - The Owl Carousel\n\t */\n\tvar Video = function(carousel) {\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * Cache all video URLs.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._videos = {};\n\n\t\t/**\n\t\t * Current playing item.\n\t\t * @protected\n\t\t * @type {jQuery}\n\t\t */\n\t\tthis._playing = null;\n\n\t\t/**\n\t\t * All event handlers.\n\t\t * @todo The cloned content removale is too late\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'resize.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.video && this.isInFullScreen()) {\n\t\t\t\t\te.preventDefault();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'refreshed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.is('resizing')) {\n\t\t\t\t\tthis._core.$stage.find('.cloned .owl-video-frame').remove();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && e.property.name === 'position' && this._playing) {\n\t\t\t\t\tthis.stop();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'prepared.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (!e.namespace) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tvar $element = $(e.content).find('.owl-video');\n\n\t\t\t\tif ($element.length) {\n\t\t\t\t\t$element.css('display', 'none');\n\t\t\t\t\tthis.fetch($element, $(e.content));\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Video.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\n\t\tthis._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {\n\t\t\tthis.play(e);\n\t\t}, this));\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tVideo.Defaults = {\n\t\tvideo: false,\n\t\tvideoHeight: false,\n\t\tvideoWidth: false\n\t};\n\n\t/**\n\t * Gets the video ID and the type (YouTube/Vimeo/vzaar only).\n\t * @protected\n\t * @param {jQuery} target - The target containing the video data.\n\t * @param {jQuery} item - The item containing the video.\n\t */\n\tVideo.prototype.fetch = function(target, item) {\n\t\t\tvar type = (function() {\n\t\t\t\t\tif (target.attr('data-vimeo-id')) {\n\t\t\t\t\t\treturn 'vimeo';\n\t\t\t\t\t} else if (target.attr('data-vzaar-id')) {\n\t\t\t\t\t\treturn 'vzaar'\n\t\t\t\t\t} else {\n\t\t\t\t\t\treturn 'youtube';\n\t\t\t\t\t}\n\t\t\t\t})(),\n\t\t\t\tid = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),\n\t\t\t\twidth = target.attr('data-width') || this._core.settings.videoWidth,\n\t\t\t\theight = target.attr('data-height') || this._core.settings.videoHeight,\n\t\t\t\turl = target.attr('href');\n\n\t\tif (url) {\n\n\t\t\t/*\n\t\t\t\t\tParses the id's out of the following urls (and probably more):\n\t\t\t\t\thttps://www.youtube.com/watch?v=:id\n\t\t\t\t\thttps://youtu.be/:id\n\t\t\t\t\thttps://vimeo.com/:id\n\t\t\t\t\thttps://vimeo.com/channels/:channel/:id\n\t\t\t\t\thttps://vimeo.com/groups/:group/videos/:id\n\t\t\t\t\thttps://app.vzaar.com/videos/:id\n\n\t\t\t\t\tVisual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F\n\t\t\t*/\n\n\t\t\tid = url.match(/(http:|https:|)\\/\\/(player.|www.|app.)?(vimeo\\.com|youtu(be\\.com|\\.be|be\\.googleapis\\.com)|vzaar\\.com)\\/(video\\/|videos\\/|embed\\/|channels\\/.+\\/|groups\\/.+\\/|watch\\?v=|v\\/)?([A-Za-z0-9._%-]*)(\\&\\S+)?/);\n\n\t\t\tif (id[3].indexOf('youtu') > -1) {\n\t\t\t\ttype = 'youtube';\n\t\t\t} else if (id[3].indexOf('vimeo') > -1) {\n\t\t\t\ttype = 'vimeo';\n\t\t\t} else if (id[3].indexOf('vzaar') > -1) {\n\t\t\t\ttype = 'vzaar';\n\t\t\t} else {\n\t\t\t\tthrow new Error('Video URL not supported.');\n\t\t\t}\n\t\t\tid = id[6];\n\t\t} else {\n\t\t\tthrow new Error('Missing video URL.');\n\t\t}\n\n\t\tthis._videos[url] = {\n\t\t\ttype: type,\n\t\t\tid: id,\n\t\t\twidth: width,\n\t\t\theight: height\n\t\t};\n\n\t\titem.attr('data-video', url);\n\n\t\tthis.thumbnail(target, this._videos[url]);\n\t};\n\n\t/**\n\t * Creates video thumbnail.\n\t * @protected\n\t * @param {jQuery} target - The target containing the video data.\n\t * @param {Object} info - The video info object.\n\t * @see `fetch`\n\t */\n\tVideo.prototype.thumbnail = function(target, video) {\n\t\tvar tnLink,\n\t\t\ticon,\n\t\t\tpath,\n\t\t\tdimensions = video.width && video.height ? 'style=\"width:' + video.width + 'px;height:' + video.height + 'px;\"' : '',\n\t\t\tcustomTn = target.find('img'),\n\t\t\tsrcType = 'src',\n\t\t\tlazyClass = '',\n\t\t\tsettings = this._core.settings,\n\t\t\tcreate = function(path) {\n\t\t\t\ticon = '<div class=\"owl-video-play-icon\"></div>';\n\n\t\t\t\tif (settings.lazyLoad) {\n\t\t\t\t\ttnLink = '<div class=\"owl-video-tn ' + lazyClass + '\" ' + srcType + '=\"' + path + '\"></div>';\n\t\t\t\t} else {\n\t\t\t\t\ttnLink = '<div class=\"owl-video-tn\" style=\"opacity:1;background-image:url(' + path + ')\"></div>';\n\t\t\t\t}\n\t\t\t\ttarget.after(tnLink);\n\t\t\t\ttarget.after(icon);\n\t\t\t};\n\n\t\t// wrap video content into owl-video-wrapper div\n\t\ttarget.wrap('<div class=\"owl-video-wrapper\"' + dimensions + '></div>');\n\n\t\tif (this._core.settings.lazyLoad) {\n\t\t\tsrcType = 'data-src';\n\t\t\tlazyClass = 'owl-lazy';\n\t\t}\n\n\t\t// custom thumbnail\n\t\tif (customTn.length) {\n\t\t\tcreate(customTn.attr(srcType));\n\t\t\tcustomTn.remove();\n\t\t\treturn false;\n\t\t}\n\n\t\tif (video.type === 'youtube') {\n\t\t\tpath = \"//img.youtube.com/vi/\" + video.id + \"/hqdefault.jpg\";\n\t\t\tcreate(path);\n\t\t} else if (video.type === 'vimeo') {\n\t\t\t$.ajax({\n\t\t\t\ttype: 'GET',\n\t\t\t\turl: '//vimeo.com/api/v2/video/' + video.id + '.json',\n\t\t\t\tjsonp: 'callback',\n\t\t\t\tdataType: 'jsonp',\n\t\t\t\tsuccess: function(data) {\n\t\t\t\t\tpath = data[0].thumbnail_large;\n\t\t\t\t\tcreate(path);\n\t\t\t\t}\n\t\t\t});\n\t\t} else if (video.type === 'vzaar') {\n\t\t\t$.ajax({\n\t\t\t\ttype: 'GET',\n\t\t\t\turl: '//vzaar.com/api/videos/' + video.id + '.json',\n\t\t\t\tjsonp: 'callback',\n\t\t\t\tdataType: 'jsonp',\n\t\t\t\tsuccess: function(data) {\n\t\t\t\t\tpath = data.framegrab_url;\n\t\t\t\t\tcreate(path);\n\t\t\t\t}\n\t\t\t});\n\t\t}\n\t};\n\n\t/**\n\t * Stops the current video.\n\t * @public\n\t */\n\tVideo.prototype.stop = function() {\n\t\tthis._core.trigger('stop', null, 'video');\n\t\tthis._playing.find('.owl-video-frame').remove();\n\t\tthis._playing.removeClass('owl-video-playing');\n\t\tthis._playing = null;\n\t\tthis._core.leave('playing');\n\t\tthis._core.trigger('stopped', null, 'video');\n\t};\n\n\t/**\n\t * Starts the current video.\n\t * @public\n\t * @param {Event} event - The event arguments.\n\t */\n\tVideo.prototype.play = function(event) {\n\t\tvar target = $(event.target),\n\t\t\titem = target.closest('.' + this._core.settings.itemClass),\n\t\t\tvideo = this._videos[item.attr('data-video')],\n\t\t\twidth = video.width || '100%',\n\t\t\theight = video.height || this._core.$stage.height(),\n\t\t\thtml;\n\n\t\tif (this._playing) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._core.enter('playing');\n\t\tthis._core.trigger('play', null, 'video');\n\n\t\titem = this._core.items(this._core.relative(item.index()));\n\n\t\tthis._core.reset(item.index());\n\n\t\tif (video.type === 'youtube') {\n\t\t\thtml = '<iframe width=\"' + width + '\" height=\"' + height + '\" src=\"//www.youtube.com/embed/' +\n\t\t\t\tvideo.id + '?autoplay=1&v=' + video.id + '\" frameborder=\"0\" allowfullscreen></iframe>';\n\t\t} else if (video.type === 'vimeo') {\n\t\t\thtml = '<iframe src=\"//player.vimeo.com/video/' + video.id +\n\t\t\t\t'?autoplay=1\" width=\"' + width + '\" height=\"' + height +\n\t\t\t\t'\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';\n\t\t} else if (video.type === 'vzaar') {\n\t\t\thtml = '<iframe frameborder=\"0\"' + 'height=\"' + height + '\"' + 'width=\"' + width +\n\t\t\t\t'\" allowfullscreen mozallowfullscreen webkitAllowFullScreen ' +\n\t\t\t\t'src=\"//view.vzaar.com/' + video.id + '/player?autoplay=true\"></iframe>';\n\t\t}\n\n\t\t$('<div class=\"owl-video-frame\">' + html + '</div>').insertAfter(item.find('.owl-video'));\n\n\t\tthis._playing = item.addClass('owl-video-playing');\n\t};\n\n\t/**\n\t * Checks whether an video is currently in full screen mode or not.\n\t * @todo Bad style because looks like a readonly method but changes members.\n\t * @protected\n\t * @returns {Boolean}\n\t */\n\tVideo.prototype.isInFullScreen = function() {\n\t\tvar element = document.fullscreenElement || document.mozFullScreenElement ||\n\t\t\t\tdocument.webkitFullscreenElement;\n\n\t\treturn element && $(element).parent().hasClass('owl-video-frame');\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t */\n\tVideo.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\tthis._core.$element.off('click.owl.video');\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Video = Video;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Animate Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates the animate plugin.\n\t * @class The Navigation Plugin\n\t * @param {Owl} scope - The Owl Carousel\n\t */\n\tvar Animate = function(scope) {\n\t\tthis.core = scope;\n\t\tthis.core.options = $.extend({}, Animate.Defaults, this.core.options);\n\t\tthis.swapping = true;\n\t\tthis.previous = undefined;\n\t\tthis.next = undefined;\n\n\t\tthis.handlers = {\n\t\t\t'change.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && e.property.name == 'position') {\n\t\t\t\t\tthis.previous = this.core.current();\n\t\t\t\t\tthis.next = e.property.value;\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.swapping = e.type == 'translated';\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'translate.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {\n\t\t\t\t\tthis.swap();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\tthis.core.$element.on(this.handlers);\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tAnimate.Defaults = {\n\t\tanimateOut: false,\n\t\tanimateIn: false\n\t};\n\n\t/**\n\t * Toggles the animation classes whenever an translations starts.\n\t * @protected\n\t * @returns {Boolean|undefined}\n\t */\n\tAnimate.prototype.swap = function() {\n\n\t\tif (this.core.settings.items !== 1) {\n\t\t\treturn;\n\t\t}\n\n\t\tif (!$.support.animation || !$.support.transition) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.core.speed(0);\n\n\t\tvar left,\n\t\t\tclear = $.proxy(this.clear, this),\n\t\t\tprevious = this.core.$stage.children().eq(this.previous),\n\t\t\tnext = this.core.$stage.children().eq(this.next),\n\t\t\tincoming = this.core.settings.animateIn,\n\t\t\toutgoing = this.core.settings.animateOut;\n\n\t\tif (this.core.current() === this.previous) {\n\t\t\treturn;\n\t\t}\n\n\t\tif (outgoing) {\n\t\t\tleft = this.core.coordinates(this.previous) - this.core.coordinates(this.next);\n\t\t\tprevious.one($.support.animation.end, clear)\n\t\t\t\t.css( { 'left': left + 'px' } )\n\t\t\t\t.addClass('animated owl-animated-out')\n\t\t\t\t.addClass(outgoing);\n\t\t}\n\n\t\tif (incoming) {\n\t\t\tnext.one($.support.animation.end, clear)\n\t\t\t\t.addClass('animated owl-animated-in')\n\t\t\t\t.addClass(incoming);\n\t\t}\n\t};\n\n\tAnimate.prototype.clear = function(e) {\n\t\t$(e.target).css( { 'left': '' } )\n\t\t\t.removeClass('animated owl-animated-out owl-animated-in')\n\t\t\t.removeClass(this.core.settings.animateIn)\n\t\t\t.removeClass(this.core.settings.animateOut);\n\t\tthis.core.onTransitionEnd();\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t * @public\n\t */\n\tAnimate.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\tfor (handler in this.handlers) {\n\t\t\tthis.core.$element.off(handler, this.handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Autoplay Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\t/**\n\t * Creates the autoplay plugin.\n\t * @class The Autoplay Plugin\n\t * @param {Owl} scope - The Owl Carousel\n\t */\n\tvar Autoplay = function(carousel) {\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * The autoplay timeout.\n\t\t * @type {Timeout}\n\t\t */\n\t\tthis._timeout = null;\n\n\t\t/**\n\t\t * Indicates whenever the autoplay is paused.\n\t\t * @type {Boolean}\n\t\t */\n\t\tthis._paused = false;\n\n\t\t/**\n\t\t * All event handlers.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'changed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && e.property.name === 'settings') {\n\t\t\t\t\tif (this._core.settings.autoplay) {\n\t\t\t\t\t\tthis.play();\n\t\t\t\t\t} else {\n\t\t\t\t\t\tthis.stop();\n\t\t\t\t\t}\n\t\t\t\t} else if (e.namespace && e.property.name === 'position') {\n\t\t\t\t\t//console.log('play?', e);\n\t\t\t\t\tif (this._core.settings.autoplay) {\n\t\t\t\t\t\tthis._setAutoPlayInterval();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'initialized.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoplay) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'play.owl.autoplay': $.proxy(function(e, t, s) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.play(t, s);\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'stop.owl.autoplay': $.proxy(function(e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.stop();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'mouseover.owl.autoplay': $.proxy(function() {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.pause();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'mouseleave.owl.autoplay': $.proxy(function() {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'touchstart.owl.core': $.proxy(function() {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.pause();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'touchend.owl.core': $.proxy(function() {\n\t\t\t\tif (this._core.settings.autoplayHoverPause) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Autoplay.Defaults, this._core.options);\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tAutoplay.Defaults = {\n\t\tautoplay: false,\n\t\tautoplayTimeout: 5000,\n\t\tautoplayHoverPause: false,\n\t\tautoplaySpeed: false\n\t};\n\n\t/**\n\t * Starts the autoplay.\n\t * @public\n\t * @param {Number} [timeout] - The interval before the next animation starts.\n\t * @param {Number} [speed] - The animation speed for the animations.\n\t */\n\tAutoplay.prototype.play = function(timeout, speed) {\n\t\tthis._paused = false;\n\n\t\tif (this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._core.enter('rotating');\n\n\t\tthis._setAutoPlayInterval();\n\t};\n\n\t/**\n\t * Gets a new timeout\n\t * @private\n\t * @param {Number} [timeout] - The interval before the next animation starts.\n\t * @param {Number} [speed] - The animation speed for the animations.\n\t * @return {Timeout}\n\t */\n\tAutoplay.prototype._getNextTimeout = function(timeout, speed) {\n\t\tif ( this._timeout ) {\n\t\t\twindow.clearTimeout(this._timeout);\n\t\t}\n\t\treturn window.setTimeout($.proxy(function() {\n\t\t\tif (this._paused || this._core.is('busy') || this._core.is('interacting') || document.hidden) {\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tthis._core.next(speed || this._core.settings.autoplaySpeed);\n\t\t}, this), timeout || this._core.settings.autoplayTimeout);\n\t};\n\n\t/**\n\t * Sets autoplay in motion.\n\t * @private\n\t */\n\tAutoplay.prototype._setAutoPlayInterval = function() {\n\t\tthis._timeout = this._getNextTimeout();\n\t};\n\n\t/**\n\t * Stops the autoplay.\n\t * @public\n\t */\n\tAutoplay.prototype.stop = function() {\n\t\tif (!this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\twindow.clearTimeout(this._timeout);\n\t\tthis._core.leave('rotating');\n\t};\n\n\t/**\n\t * Stops the autoplay.\n\t * @public\n\t */\n\tAutoplay.prototype.pause = function() {\n\t\tif (!this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._paused = true;\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t */\n\tAutoplay.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\tthis.stop();\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Navigation Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\t'use strict';\n\n\t/**\n\t * Creates the navigation plugin.\n\t * @class The Navigation Plugin\n\t * @param {Owl} carousel - The Owl Carousel.\n\t */\n\tvar Navigation = function(carousel) {\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * Indicates whether the plugin is initialized or not.\n\t\t * @protected\n\t\t * @type {Boolean}\n\t\t */\n\t\tthis._initialized = false;\n\n\t\t/**\n\t\t * The current paging indexes.\n\t\t * @protected\n\t\t * @type {Array}\n\t\t */\n\t\tthis._pages = [];\n\n\t\t/**\n\t\t * All DOM elements of the user interface.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._controls = {};\n\n\t\t/**\n\t\t * Markup for an indicator.\n\t\t * @protected\n\t\t * @type {Array.<String>}\n\t\t */\n\t\tthis._templates = [];\n\n\t\t/**\n\t\t * The carousel element.\n\t\t * @type {jQuery}\n\t\t */\n\t\tthis.$element = this._core.$element;\n\n\t\t/**\n\t\t * Overridden methods of the carousel.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._overrides = {\n\t\t\tnext: this._core.next,\n\t\t\tprev: this._core.prev,\n\t\t\tto: this._core.to\n\t\t};\n\n\t\t/**\n\t\t * All event handlers.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'prepared.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.push('<div class=\"' + this._core.settings.dotClass + '\">' +\n\t\t\t\t\t\t$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'added.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.splice(e.position, 0, this._templates.pop());\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'remove.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.splice(e.position, 1);\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && e.property.name == 'position') {\n\t\t\t\t\tthis.draw();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'initialized.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && !this._initialized) {\n\t\t\t\t\tthis._core.trigger('initialize', null, 'navigation');\n\t\t\t\t\tthis.initialize();\n\t\t\t\t\tthis.update();\n\t\t\t\t\tthis.draw();\n\t\t\t\t\tthis._initialized = true;\n\t\t\t\t\tthis._core.trigger('initialized', null, 'navigation');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'refreshed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._initialized) {\n\t\t\t\t\tthis._core.trigger('refresh', null, 'navigation');\n\t\t\t\t\tthis.update();\n\t\t\t\t\tthis.draw();\n\t\t\t\t\tthis._core.trigger('refreshed', null, 'navigation');\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Navigation.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis.$element.on(this._handlers);\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t * @todo Rename `slideBy` to `navBy`\n\t */\n\tNavigation.Defaults = {\n\t\tnav: false,\n\t\tnavText: [ 'prev', 'next' ],\n\t\tnavSpeed: false,\n\t\tnavElement: 'div',\n\t\tnavContainer: false,\n\t\tnavContainerClass: 'owl-nav',\n\t\tnavClass: [ 'owl-prev', 'owl-next' ],\n\t\tslideBy: 1,\n\t\tdotClass: 'owl-dot',\n\t\tdotsClass: 'owl-dots',\n\t\tdots: true,\n\t\tdotsEach: false,\n\t\tdotsData: false,\n\t\tdotsSpeed: false,\n\t\tdotsContainer: false\n\t};\n\n\t/**\n\t * Initializes the layout of the plugin and extends the carousel.\n\t * @protected\n\t */\n\tNavigation.prototype.initialize = function() {\n\t\tvar override,\n\t\t\tsettings = this._core.settings;\n\n\t\t// create DOM structure for relative navigation\n\t\tthis._controls.$relative = (settings.navContainer ? $(settings.navContainer)\n\t\t\t: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');\n\n\t\tthis._controls.$previous = $('<' + settings.navElement + '>')\n\t\t\t.addClass(settings.navClass[0])\n\t\t\t.html(settings.navText[0])\n\t\t\t.prependTo(this._controls.$relative)\n\t\t\t.on('click', $.proxy(function(e) {\n\t\t\t\tthis.prev(settings.navSpeed);\n\t\t\t}, this));\n\t\tthis._controls.$next = $('<' + settings.navElement + '>')\n\t\t\t.addClass(settings.navClass[1])\n\t\t\t.html(settings.navText[1])\n\t\t\t.appendTo(this._controls.$relative)\n\t\t\t.on('click', $.proxy(function(e) {\n\t\t\t\tthis.next(settings.navSpeed);\n\t\t\t}, this));\n\n\t\t// create DOM structure for absolute navigation\n\t\tif (!settings.dotsData) {\n\t\t\tthis._templates = [ $('<div>')\n\t\t\t\t.addClass(settings.dotClass)\n\t\t\t\t.append($('<span>'))\n\t\t\t\t.prop('outerHTML') ];\n\t\t}\n\n\t\tthis._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)\n\t\t\t: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');\n\n\t\tthis._controls.$absolute.on('click', 'div', $.proxy(function(e) {\n\t\t\tvar index = $(e.target).parent().is(this._controls.$absolute)\n\t\t\t\t? $(e.target).index() : $(e.target).parent().index();\n\n\t\t\te.preventDefault();\n\n\t\t\tthis.to(index, settings.dotsSpeed);\n\t\t}, this));\n\n\t\t// override public methods of the carousel\n\t\tfor (override in this._overrides) {\n\t\t\tthis._core[override] = $.proxy(this[override], this);\n\t\t}\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t * @protected\n\t */\n\tNavigation.prototype.destroy = function() {\n\t\tvar handler, control, property, override;\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (control in this._controls) {\n\t\t\tthis._controls[control].remove();\n\t\t}\n\t\tfor (override in this.overides) {\n\t\t\tthis._core[override] = this._overrides[override];\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t/**\n\t * Updates the internal state.\n\t * @protected\n\t */\n\tNavigation.prototype.update = function() {\n\t\tvar i, j, k,\n\t\t\tlower = this._core.clones().length / 2,\n\t\t\tupper = lower + this._core.items().length,\n\t\t\tmaximum = this._core.maximum(true),\n\t\t\tsettings = this._core.settings,\n\t\t\tsize = settings.center || settings.autoWidth || settings.dotsData\n\t\t\t\t? 1 : settings.dotsEach || settings.items;\n\n\t\tif (settings.slideBy !== 'page') {\n\t\t\tsettings.slideBy = Math.min(settings.slideBy, settings.items);\n\t\t}\n\n\t\tif (settings.dots || settings.slideBy == 'page') {\n\t\t\tthis._pages = [];\n\n\t\t\tfor (i = lower, j = 0, k = 0; i < upper; i++) {\n\t\t\t\tif (j >= size || j === 0) {\n\t\t\t\t\tthis._pages.push({\n\t\t\t\t\t\tstart: Math.min(maximum, i - lower),\n\t\t\t\t\t\tend: i - lower + size - 1\n\t\t\t\t\t});\n\t\t\t\t\tif (Math.min(maximum, i - lower) === maximum) {\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t\tj = 0, ++k;\n\t\t\t\t}\n\t\t\t\tj += this._core.mergers(this._core.relative(i));\n\t\t\t}\n\t\t}\n\t};\n\n\t/**\n\t * Draws the user interface.\n\t * @todo The option `dotsData` wont work.\n\t * @protected\n\t */\n\tNavigation.prototype.draw = function() {\n\t\tvar difference,\n\t\t\tsettings = this._core.settings,\n\t\t\tdisabled = this._core.items().length <= settings.items,\n\t\t\tindex = this._core.relative(this._core.current()),\n\t\t\tloop = settings.loop || settings.rewind;\n\n\t\tthis._controls.$relative.toggleClass('disabled', !settings.nav || disabled);\n\n\t\tif (settings.nav) {\n\t\t\tthis._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));\n\t\t\tthis._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));\n\t\t}\n\n\t\tthis._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);\n\n\t\tif (settings.dots) {\n\t\t\tdifference = this._pages.length - this._controls.$absolute.children().length;\n\n\t\t\tif (settings.dotsData && difference !== 0) {\n\t\t\t\tthis._controls.$absolute.html(this._templates.join(''));\n\t\t\t} else if (difference > 0) {\n\t\t\t\tthis._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));\n\t\t\t} else if (difference < 0) {\n\t\t\t\tthis._controls.$absolute.children().slice(difference).remove();\n\t\t\t}\n\n\t\t\tthis._controls.$absolute.find('.active').removeClass('active');\n\t\t\tthis._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');\n\t\t}\n\t};\n\n\t/**\n\t * Extends event data.\n\t * @protected\n\t * @param {Event} event - The event object which gets thrown.\n\t */\n\tNavigation.prototype.onTrigger = function(event) {\n\t\tvar settings = this._core.settings;\n\n\t\tevent.page = {\n\t\t\tindex: $.inArray(this.current(), this._pages),\n\t\t\tcount: this._pages.length,\n\t\t\tsize: settings && (settings.center || settings.autoWidth || settings.dotsData\n\t\t\t\t? 1 : settings.dotsEach || settings.items)\n\t\t};\n\t};\n\n\t/**\n\t * Gets the current page position of the carousel.\n\t * @protected\n\t * @returns {Number}\n\t */\n\tNavigation.prototype.current = function() {\n\t\tvar current = this._core.relative(this._core.current());\n\t\treturn $.grep(this._pages, $.proxy(function(page, index) {\n\t\t\treturn page.start <= current && page.end >= current;\n\t\t}, this)).pop();\n\t};\n\n\t/**\n\t * Gets the current succesor/predecessor position.\n\t * @protected\n\t * @returns {Number}\n\t */\n\tNavigation.prototype.getPosition = function(successor) {\n\t\tvar position, length,\n\t\t\tsettings = this._core.settings;\n\n\t\tif (settings.slideBy == 'page') {\n\t\t\tposition = $.inArray(this.current(), this._pages);\n\t\t\tlength = this._pages.length;\n\t\t\tsuccessor ? ++position : --position;\n\t\t\tposition = this._pages[((position % length) + length) % length].start;\n\t\t} else {\n\t\t\tposition = this._core.relative(this._core.current());\n\t\t\tlength = this._core.items().length;\n\t\t\tsuccessor ? position += settings.slideBy : position -= settings.slideBy;\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n\t * Slides to the next item or page.\n\t * @public\n\t * @param {Number} [speed=false] - The time in milliseconds for the transition.\n\t */\n\tNavigation.prototype.next = function(speed) {\n\t\t$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);\n\t};\n\n\t/**\n\t * Slides to the previous item or page.\n\t * @public\n\t * @param {Number} [speed=false] - The time in milliseconds for the transition.\n\t */\n\tNavigation.prototype.prev = function(speed) {\n\t\t$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);\n\t};\n\n\t/**\n\t * Slides to the specified item or page.\n\t * @public\n\t * @param {Number} position - The position of the item or page.\n\t * @param {Number} [speed] - The time in milliseconds for the transition.\n\t * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.\n\t */\n\tNavigation.prototype.to = function(position, speed, standard) {\n\t\tvar length;\n\n\t\tif (!standard && this._pages.length) {\n\t\t\tlength = this._pages.length;\n\t\t\t$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);\n\t\t} else {\n\t\t\t$.proxy(this._overrides.to, this._core)(position, speed);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Hash Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\t'use strict';\n\n\t/**\n\t * Creates the hash plugin.\n\t * @class The Hash Plugin\n\t * @param {Owl} carousel - The Owl Carousel\n\t */\n\tvar Hash = function(carousel) {\n\t\t/**\n\t\t * Reference to the core.\n\t\t * @protected\n\t\t * @type {Owl}\n\t\t */\n\t\tthis._core = carousel;\n\n\t\t/**\n\t\t * Hash index for the items.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._hashes = {};\n\n\t\t/**\n\t\t * The carousel element.\n\t\t * @type {jQuery}\n\t\t */\n\t\tthis.$element = this._core.$element;\n\n\t\t/**\n\t\t * All event handlers.\n\t\t * @protected\n\t\t * @type {Object}\n\t\t */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && this._core.settings.startPosition === 'URLHash') {\n\t\t\t\t\t$(window).trigger('hashchange.owl.navigation');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'prepared.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tvar hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');\n\n\t\t\t\t\tif (!hash) {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\tthis._hashes[hash] = e.content;\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function(e) {\n\t\t\t\tif (e.namespace && e.property.name === 'position') {\n\t\t\t\t\tvar current = this._core.items(this._core.relative(this._core.current())),\n\t\t\t\t\t\thash = $.map(this._hashes, function(item, hash) {\n\t\t\t\t\t\t\treturn item === current ? hash : null;\n\t\t\t\t\t\t}).join();\n\n\t\t\t\t\tif (!hash || window.location.hash.slice(1) === hash) {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\twindow.location.hash = hash;\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Hash.Defaults, this._core.options);\n\n\t\t// register the event handlers\n\t\tthis.$element.on(this._handlers);\n\n\t\t// register event listener for hash navigation\n\t\t$(window).on('hashchange.owl.navigation', $.proxy(function(e) {\n\t\t\tvar hash = window.location.hash.substring(1),\n\t\t\t\titems = this._core.$stage.children(),\n\t\t\t\tposition = this._hashes[hash] && items.index(this._hashes[hash]);\n\n\t\t\tif (position === undefined || position === this._core.current()) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tthis._core.to(this._core.relative(position), false, true);\n\t\t}, this));\n\t};\n\n\t/**\n\t * Default options.\n\t * @public\n\t */\n\tHash.Defaults = {\n\t\tURLhashListener: false\n\t};\n\n\t/**\n\t * Destroys the plugin.\n\t * @public\n\t */\n\tHash.prototype.destroy = function() {\n\t\tvar handler, property;\n\n\t\t$(window).off('hashchange.owl.navigation');\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/**\n * Support Plugin\n *\n * @version 2.1.0\n * @author Vivid Planet Software GmbH\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function($, window, document, undefined) {\n\n\tvar style = $('<support>').get(0).style,\n\t\tprefixes = 'Webkit Moz O ms'.split(' '),\n\t\tevents = {\n\t\t\ttransition: {\n\t\t\t\tend: {\n\t\t\t\t\tWebkitTransition: 'webkitTransitionEnd',\n\t\t\t\t\tMozTransition: 'transitionend',\n\t\t\t\t\tOTransition: 'oTransitionEnd',\n\t\t\t\t\ttransition: 'transitionend'\n\t\t\t\t}\n\t\t\t},\n\t\t\tanimation: {\n\t\t\t\tend: {\n\t\t\t\t\tWebkitAnimation: 'webkitAnimationEnd',\n\t\t\t\t\tMozAnimation: 'animationend',\n\t\t\t\t\tOAnimation: 'oAnimationEnd',\n\t\t\t\t\tanimation: 'animationend'\n\t\t\t\t}\n\t\t\t}\n\t\t},\n\t\ttests = {\n\t\t\tcsstransforms: function() {\n\t\t\t\treturn !!test('transform');\n\t\t\t},\n\t\t\tcsstransforms3d: function() {\n\t\t\t\treturn !!test('perspective');\n\t\t\t},\n\t\t\tcsstransitions: function() {\n\t\t\t\treturn !!test('transition');\n\t\t\t},\n\t\t\tcssanimations: function() {\n\t\t\t\treturn !!test('animation');\n\t\t\t}\n\t\t};\n\n\tfunction test(property, prefixed) {\n\t\tvar result = false,\n\t\t\tupper = property.charAt(0).toUpperCase() + property.slice(1);\n\n\t\t$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {\n\t\t\tif (style[property] !== undefined) {\n\t\t\t\tresult = prefixed ? property : true;\n\t\t\t\treturn false;\n\t\t\t}\n\t\t});\n\n\t\treturn result;\n\t}\n\n\tfunction prefixed(property) {\n\t\treturn test(property, true);\n\t}\n\n\tif (tests.csstransitions()) {\n\t\t/* jshint -W053 */\n\t\t$.support.transition = new String(prefixed('transition'))\n\t\t$.support.transition.end = events.transition.end[ $.support.transition ];\n\t}\n\n\tif (tests.cssanimations()) {\n\t\t/* jshint -W053 */\n\t\t$.support.animation = new String(prefixed('animation'))\n\t\t$.support.animation.end = events.animation.end[ $.support.animation ];\n\t}\n\n\tif (tests.csstransforms()) {\n\t\t/* jshint -W053 */\n\t\t$.support.transform = new String(prefixed('transform'));\n\t\t$.support.transform3d = tests.csstransforms3d();\n\t}\n\n})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);\n\n/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/owl.carousel/dist/owl.carousel.js\n// module id = 8\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/owl.carousel/dist/owl.carousel.js?");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

eval("/* WEBPACK VAR INJECTION */(function(process) {/**\n * Copyright 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n\nif (process.env.NODE_ENV !== 'production') {\n  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&\n    Symbol.for &&\n    Symbol.for('react.element')) ||\n    0xeac7;\n\n  var isValidElement = function(object) {\n    return typeof object === 'object' &&\n      object !== null &&\n      object.$$typeof === REACT_ELEMENT_TYPE;\n  };\n\n  // By explicitly using `prop-types` you are opting into new development behavior.\n  // http://fb.me/prop-types-in-prod\n  var throwOnDirectAccess = true;\n  module.exports = __webpack_require__(19)(isValidElement, throwOnDirectAccess);\n} else {\n  // By explicitly using `prop-types` you are opting into new production behavior.\n  // http://fb.me/prop-types-in-prod\n  module.exports = __webpack_require__(18)();\n}\n\n/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/prop-types/index.js\n// module id = 9\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/prop-types/index.js?");

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

eval("// style-loader: Adds some css to the DOM by adding a <style> tag\n\n// load the styles\nvar content = __webpack_require__(14);\nif(typeof content === 'string') content = [[module.i, content, '']];\n// Prepare cssTransformation\nvar transform;\n\nvar options = {}\noptions.transform = transform\n// add the styles to the DOM\nvar update = __webpack_require__(7)(content, options);\nif(content.locals) module.exports = content.locals;\n// Hot Module Replacement\nif(false) {\n\t// When the styles change, update the <style> tags\n\tif(!content.locals) {\n\t\tmodule.hot.accept(\"!!../../../css-loader/index.js!./owl.carousel.min.css\", function() {\n\t\t\tvar newContent = require(\"!!../../../css-loader/index.js!./owl.carousel.min.css\");\n\t\t\tif(typeof newContent === 'string') newContent = [[module.id, newContent, '']];\n\t\t\tupdate(newContent);\n\t\t});\n\t}\n\t// When the module is disposed, remove the <style> tags\n\tmodule.hot.dispose(function() { update(); });\n}\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/owl.carousel/dist/assets/owl.carousel.min.css\n// module id = 10\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/owl.carousel/dist/assets/owl.carousel.min.css?");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

eval("// style-loader: Adds some css to the DOM by adding a <style> tag\n\n// load the styles\nvar content = __webpack_require__(15);\nif(typeof content === 'string') content = [[module.i, content, '']];\n// Prepare cssTransformation\nvar transform;\n\nvar options = {}\noptions.transform = transform\n// add the styles to the DOM\nvar update = __webpack_require__(7)(content, options);\nif(content.locals) module.exports = content.locals;\n// Hot Module Replacement\nif(false) {\n\t// When the styles change, update the <style> tags\n\tif(!content.locals) {\n\t\tmodule.hot.accept(\"!!../../../css-loader/index.js!./owl.theme.default.min.css\", function() {\n\t\t\tvar newContent = require(\"!!../../../css-loader/index.js!./owl.theme.default.min.css\");\n\t\t\tif(typeof newContent === 'string') newContent = [[module.id, newContent, '']];\n\t\t\tupdate(newContent);\n\t\t});\n\t}\n\t// When the module is disposed, remove the <style> tags\n\tmodule.hot.dispose(function() { update(); });\n}\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/owl.carousel/dist/assets/owl.theme.default.min.css\n// module id = 11\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/owl.carousel/dist/assets/owl.theme.default.min.css?");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

eval("module.exports = __WEBPACK_EXTERNAL_MODULE_12__;\n\n//////////////////\n// WEBPACK FOOTER\n// external {\"root\":\"React\",\"commonjs2\":\"react\",\"commonjs\":\"react\",\"amd\":\"react\"}\n// module id = 12\n// module chunks = 0\n\n//# sourceURL=webpack:///external_%7B%22root%22:%22React%22,%22commonjs2%22:%22react%22,%22commonjs%22:%22react%22,%22amd%22:%22react%22%7D?");

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
eval("Object.defineProperty(__webpack_exports__, \"__esModule\", { value: true });\n/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(12);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_min_css__ = __webpack_require__(10);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_owl_carousel_dist_assets_owl_carousel_min_css__);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_owl_carousel_dist_assets_owl_theme_default_min_css__ = __webpack_require__(11);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_owl_carousel_dist_assets_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_owl_carousel_dist_assets_owl_theme_default_min_css__);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_owl_carousel__ = __webpack_require__(8);\n/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_owl_carousel__);\n\n\nvar _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nfunction _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return call && (typeof call === \"object\" || typeof call === \"function\") ? call : self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function, not \" + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }\n\n\n\n\n\n\n\nvar Owl_Carousel_Options = {\n\n    // options\n    items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,\n    margin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,\n    loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    mouseDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    touchDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    pullDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    freeDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    stagePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,\n    merge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    mergeFit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    autoWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    startPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),\n    URLhashListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    rewind: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    navText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),\n    navElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    slideBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),\n    dots: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    dotsEach: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    dotData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    lazyLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    lazyContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    autoplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    autoplayTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,\n    autoplayHoverPause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    smartSpeed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,\n    fluidSpeed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    autoplaySpeed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    navSpeed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    dotsSpeed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    dragEndSpeed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    callbacks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,\n    responsiveRefreshRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,\n    responsiveBaseElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,\n    video: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,\n    videoHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    videoWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    animateOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    animateIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    fallbackEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    nestedItemSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    itemElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    stageElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    navContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n    dotsContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n\n    // dom class\n    refreshClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    loadingClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    loadedClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    rtlClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    dragClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    grabClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    stageClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    stageOuterClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    navContainerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    navClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    controlsClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    dotClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    dotsClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    autoHeightClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,\n    responsiveClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),\n\n    // event\n    onInitialize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onInitialized: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onResize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onResized: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onRefreshed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onDragged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onTranslate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onTranslated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onLoadLazy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onLoadedLazy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onStopVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,\n    onPlayVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func\n};\n\nvar OwlCarousel = function (_Component) {\n    _inherits(OwlCarousel, _Component);\n\n    function OwlCarousel(props, context) {\n        _classCallCheck(this, OwlCarousel);\n\n        var _this = _possibleConstructorReturn(this, (OwlCarousel.__proto__ || Object.getPrototypeOf(OwlCarousel)).call(this, props, context));\n\n        _this.next = _this.next.bind(_this);\n        _this.prev = _this.prev.bind(_this);\n        _this.to = _this.to.bind(_this);\n        _this.create = _this.create.bind(_this);\n        _this.destory = _this.destory.bind(_this);\n        _this.play = _this.play.bind(_this);\n        _this.stop = _this.stop.bind(_this);\n        return _this;\n    }\n\n    _createClass(OwlCarousel, [{\n        key: 'componentWillMount',\n        value: function componentWillMount() {\n            this._filterProps(this.props);\n        }\n    }, {\n        key: 'componentDidMount',\n        value: function componentDidMount() {\n            this.owlCarousel = $(this.inst);\n            this.owlCarousel.owlCarousel(this.options);\n        }\n    }, {\n        key: 'componentWillReceiveProps',\n        value: function componentWillReceiveProps(nextProps) {\n            this._filterProps(nextProps);\n            this.destory();\n        }\n    }, {\n        key: 'componentDidUpdate',\n        value: function componentDidUpdate() {\n            console.log(this.options);\n            this.owlCarousel = $(this.inst);\n            this.owlCarousel.owlCarousel(this.options);\n        }\n    }, {\n        key: 'componentWillUnmount',\n        value: function componentWillUnmount() {\n            this.destory();\n        }\n    }, {\n        key: 'next',\n        value: function next(speed) {\n            if (typeof speed == 'number') {\n                this.owlCarousel.trigger('next.owl.carousel', [speed]);\n            } else {\n                this.owlCarousel.trigger('next.owl.carousel');\n            }\n        }\n    }, {\n        key: 'prev',\n        value: function prev(speed) {\n            if (typeof speed == 'number') {\n                this.owlCarousel.trigger('prev.owl.carousel', [speed]);\n            } else {\n                this.owlCarousel.trigger('prev.owl.carousel');\n            }\n        }\n\n        // refresh(event, speed) {\n        // }\n\n    }, {\n        key: 'to',\n        value: function to(position, speed) {\n            if (typeof position == 'number' && typeof speed == 'number') {\n                this.owlCarousel.trigger('to.owl.carousel', [position, speed]);\n            } else {\n                this.owlCarousel.trigger('to.owl.carousel');\n            }\n        }\n    }, {\n        key: 'create',\n        value: function create() {\n            this.owlCarousel.owlCarousel(this.options);\n        }\n    }, {\n        key: 'destory',\n        value: function destory() {\n            this.owlCarousel.trigger('destroy.owl.carousel');\n        }\n\n        // replace(data) {\n\n        // }\n\n        // add(data, position) {\n\n        // }\n\n        // remove(position) {\n\n        // }\n\n    }, {\n        key: 'play',\n        value: function play(timeout, speed) {\n            if (typeof timeout == 'number' && typeof speed == 'number') {\n                this.owlCarousel.trigger('play.owl.autoplay', [timeout, speed]);\n            } else {\n                this.owlCarousel.trigger('play.owl.autoplay');\n            }\n        }\n    }, {\n        key: 'stop',\n        value: function stop() {\n            this.owlCarousel.trigger('stop.owl.autoplay');\n        }\n    }, {\n        key: '_filterProps',\n        value: function _filterProps(props) {\n            var _this2 = this;\n\n            this.options = {};\n            this.propsWithoutOptions = {};\n            Object.keys(props).forEach(function (key) {\n                if (Owl_Carousel_Options.hasOwnProperty(key)) {\n                    _this2.options[key] = props[key];\n                } else {\n                    _this2.propsWithoutOptions[key] = props[key];\n                }\n            });\n        }\n    }, {\n        key: 'render',\n        value: function render() {\n            var _this3 = this;\n\n            var _propsWithoutOptions = this.propsWithoutOptions,\n                className = _propsWithoutOptions.className,\n                children = _propsWithoutOptions.children,\n                props = _objectWithoutProperties(_propsWithoutOptions, ['className', 'children']);\n\n            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(\n                'div',\n                _extends({\n                    className: 'owl-carousel ' + className,\n                    ref: function ref(inst) {\n                        return _this3.inst = inst;\n                    }\n                }, props),\n                children\n            );\n        }\n    }]);\n\n    return OwlCarousel;\n}(__WEBPACK_IMPORTED_MODULE_0_react__[\"Component\"]);\n\nOwlCarousel.propTypes = Owl_Carousel_Options;\n\nOwlCarousel.defaultProps = {\n    className: ''\n};\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (OwlCarousel);\n/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./components/OwlCarousel.jsx\n// module id = 13\n// module chunks = 0\n\n//# sourceURL=webpack:///./components/OwlCarousel.jsx?");

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

eval("exports = module.exports = __webpack_require__(4)(undefined);\n// imports\n\n\n// module\nexports.push([module.i, \"/**\\n * Owl Carousel v2.2.0\\n * Copyright 2013-2016 David Deutsch\\n * Licensed under MIT (https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE)\\n */\\n.owl-carousel,.owl-carousel .owl-item{-webkit-tap-highlight-color:transparent;position:relative}.owl-carousel{display:none;width:100%;z-index:1}.owl-carousel .owl-stage{position:relative;-ms-touch-action:pan-Y}.owl-carousel .owl-stage:after{content:\\\".\\\";display:block;clear:both;visibility:hidden;line-height:0;height:0}.owl-carousel .owl-stage-outer{position:relative;overflow:hidden;-webkit-transform:translate3d(0,0,0)}.owl-carousel .owl-item{min-height:1px;float:left;-webkit-backface-visibility:hidden;-webkit-touch-callout:none}.owl-carousel .owl-item img{display:block;width:100%;-webkit-transform-style:preserve-3d}.owl-carousel .owl-dots.disabled,.owl-carousel .owl-nav.disabled{display:none}.no-js .owl-carousel,.owl-carousel.owl-loaded{display:block}.owl-carousel .owl-dot,.owl-carousel .owl-nav .owl-next,.owl-carousel .owl-nav .owl-prev{cursor:pointer;cursor:hand;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-loading{opacity:0;display:block}.owl-carousel.owl-hidden{opacity:0}.owl-carousel.owl-refresh .owl-item{visibility:hidden}.owl-carousel.owl-drag .owl-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-grab{cursor:move;cursor:grab}.owl-carousel.owl-rtl{direction:rtl}.owl-carousel.owl-rtl .owl-item{float:right}.owl-carousel .animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.owl-carousel .owl-animated-in{z-index:0}.owl-carousel .owl-animated-out{z-index:1}.owl-carousel .fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@keyframes fadeOut{0%{opacity:1}100%{opacity:0}}.owl-height{transition:height .5s ease-in-out}.owl-carousel .owl-item .owl-lazy{opacity:0;transition:opacity .4s ease}.owl-carousel .owl-item img.owl-lazy{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.owl-carousel .owl-video-wrapper{position:relative;height:100%;background:#000}.owl-carousel .owl-video-play-icon{position:absolute;height:80px;width:80px;left:50%;top:50%;margin-left:-40px;margin-top:-40px;background:url(\" + __webpack_require__(16) + \") no-repeat;cursor:pointer;z-index:1;-webkit-backface-visibility:hidden;transition:-webkit-transform .1s ease;transition:transform .1s ease}.owl-carousel .owl-video-play-icon:hover{-webkit-transform:scale(1.3,1.3);-ms-transform:scale(1.3,1.3);transform:scale(1.3,1.3)}.owl-carousel .owl-video-playing .owl-video-play-icon,.owl-carousel .owl-video-playing .owl-video-tn{display:none}.owl-carousel .owl-video-tn{opacity:0;height:100%;background-position:center center;background-repeat:no-repeat;background-size:contain;transition:opacity .4s ease}.owl-carousel .owl-video-frame{position:relative;z-index:1;height:100%;width:100%}\", \"\"]);\n\n// exports\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/css-loader!./~/owl.carousel/dist/assets/owl.carousel.min.css\n// module id = 14\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/owl.carousel/dist/assets/owl.carousel.min.css?./~/css-loader");

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

eval("exports = module.exports = __webpack_require__(4)(undefined);\n// imports\n\n\n// module\nexports.push([module.i, \"/**\\n * Owl Carousel v2.2.0\\n * Copyright 2013-2016 David Deutsch\\n * Licensed under MIT (https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE)\\n */\\n.owl-theme .owl-dots,.owl-theme .owl-nav{text-align:center;-webkit-tap-highlight-color:transparent}.owl-theme .owl-nav{margin-top:10px}.owl-theme .owl-nav [class*=owl-]{color:#FFF;font-size:14px;margin:5px;padding:4px 7px;background:#D6D6D6;display:inline-block;cursor:pointer;border-radius:3px}.owl-theme .owl-nav [class*=owl-]:hover{background:#869791;color:#FFF;text-decoration:none}.owl-theme .owl-nav .disabled{opacity:.5;cursor:default}.owl-theme .owl-nav.disabled+.owl-dots{margin-top:10px}.owl-theme .owl-dots .owl-dot{display:inline-block;zoom:1}.owl-theme .owl-dots .owl-dot span{width:10px;height:10px;margin:5px 7px;background:#D6D6D6;display:block;-webkit-backface-visibility:visible;transition:opacity .2s ease;border-radius:30px}.owl-theme .owl-dots .owl-dot.active span,.owl-theme .owl-dots .owl-dot:hover span{background:#869791}\", \"\"]);\n\n// exports\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/css-loader!./~/owl.carousel/dist/assets/owl.theme.default.min.css\n// module id = 15\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/owl.carousel/dist/assets/owl.theme.default.min.css?./~/css-loader");

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

eval("module.exports = __webpack_require__.p + \"4a37f8008959c75f619bf0a3a4e2d7a2.png\";\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/owl.carousel/dist/assets/owl.video.play.png\n// module id = 16\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/owl.carousel/dist/assets/owl.video.play.png?");

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("/* WEBPACK VAR INJECTION */(function(process) {/**\n * Copyright 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n\n\n\nif (process.env.NODE_ENV !== 'production') {\n  var invariant = __webpack_require__(3);\n  var warning = __webpack_require__(5);\n  var ReactPropTypesSecret = __webpack_require__(6);\n  var loggedTypeFailures = {};\n}\n\n/**\n * Assert that the values match with the type specs.\n * Error messages are memorized and will only be shown once.\n *\n * @param {object} typeSpecs Map of name to a ReactPropType\n * @param {object} values Runtime values that need to be type-checked\n * @param {string} location e.g. \"prop\", \"context\", \"child context\"\n * @param {string} componentName Name of the component for error messages.\n * @param {?Function} getStack Returns the component stack.\n * @private\n */\nfunction checkPropTypes(typeSpecs, values, location, componentName, getStack) {\n  if (process.env.NODE_ENV !== 'production') {\n    for (var typeSpecName in typeSpecs) {\n      if (typeSpecs.hasOwnProperty(typeSpecName)) {\n        var error;\n        // Prop type validation may throw. In case they do, we don't want to\n        // fail the render phase where it didn't fail before. So we log it.\n        // After these have been cleaned up, we'll let them throw.\n        try {\n          // This is intentionally an invariant that gets caught. It's the same\n          // behavior as without this statement except with a better message.\n          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);\n          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);\n        } catch (ex) {\n          error = ex;\n        }\n        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);\n        if (error instanceof Error && !(error.message in loggedTypeFailures)) {\n          // Only monitor this failure once because there tends to be a lot of the\n          // same error.\n          loggedTypeFailures[error.message] = true;\n\n          var stack = getStack ? getStack() : '';\n\n          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');\n        }\n      }\n    }\n  }\n}\n\nmodule.exports = checkPropTypes;\n\n/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/prop-types/checkPropTypes.js\n// module id = 17\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/prop-types/checkPropTypes.js?");

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("/**\n * Copyright 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n\n\n\nvar emptyFunction = __webpack_require__(2);\nvar invariant = __webpack_require__(3);\n\nmodule.exports = function() {\n  // Important!\n  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.\n  function shim() {\n    invariant(\n      false,\n      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +\n      'Use PropTypes.checkPropTypes() to call them. ' +\n      'Read more at http://fb.me/use-check-prop-types'\n    );\n  };\n  shim.isRequired = shim;\n  function getShim() {\n    return shim;\n  };\n  var ReactPropTypes = {\n    array: shim,\n    bool: shim,\n    func: shim,\n    number: shim,\n    object: shim,\n    string: shim,\n    symbol: shim,\n\n    any: shim,\n    arrayOf: getShim,\n    element: shim,\n    instanceOf: getShim,\n    node: shim,\n    objectOf: getShim,\n    oneOf: getShim,\n    oneOfType: getShim,\n    shape: getShim\n  };\n\n  ReactPropTypes.checkPropTypes = emptyFunction;\n  ReactPropTypes.PropTypes = ReactPropTypes;\n\n  return ReactPropTypes;\n};\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/prop-types/factoryWithThrowingShims.js\n// module id = 18\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/prop-types/factoryWithThrowingShims.js?");

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("/* WEBPACK VAR INJECTION */(function(process) {/**\n * Copyright 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n\n\n\nvar emptyFunction = __webpack_require__(2);\nvar invariant = __webpack_require__(3);\nvar warning = __webpack_require__(5);\n\nvar ReactPropTypesSecret = __webpack_require__(6);\nvar checkPropTypes = __webpack_require__(17);\n\nmodule.exports = function(isValidElement, throwOnDirectAccess) {\n  /* global Symbol */\n  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;\n  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.\n\n  /**\n   * Returns the iterator method function contained on the iterable object.\n   *\n   * Be sure to invoke the function with the iterable as context:\n   *\n   *     var iteratorFn = getIteratorFn(myIterable);\n   *     if (iteratorFn) {\n   *       var iterator = iteratorFn.call(myIterable);\n   *       ...\n   *     }\n   *\n   * @param {?object} maybeIterable\n   * @return {?function}\n   */\n  function getIteratorFn(maybeIterable) {\n    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);\n    if (typeof iteratorFn === 'function') {\n      return iteratorFn;\n    }\n  }\n\n  /**\n   * Collection of methods that allow declaration and validation of props that are\n   * supplied to React components. Example usage:\n   *\n   *   var Props = require('ReactPropTypes');\n   *   var MyArticle = React.createClass({\n   *     propTypes: {\n   *       // An optional string prop named \"description\".\n   *       description: Props.string,\n   *\n   *       // A required enum prop named \"category\".\n   *       category: Props.oneOf(['News','Photos']).isRequired,\n   *\n   *       // A prop named \"dialog\" that requires an instance of Dialog.\n   *       dialog: Props.instanceOf(Dialog).isRequired\n   *     },\n   *     render: function() { ... }\n   *   });\n   *\n   * A more formal specification of how these methods are used:\n   *\n   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)\n   *   decl := ReactPropTypes.{type}(.isRequired)?\n   *\n   * Each and every declaration produces a function with the same signature. This\n   * allows the creation of custom validation functions. For example:\n   *\n   *  var MyLink = React.createClass({\n   *    propTypes: {\n   *      // An optional string or URI prop named \"href\".\n   *      href: function(props, propName, componentName) {\n   *        var propValue = props[propName];\n   *        if (propValue != null && typeof propValue !== 'string' &&\n   *            !(propValue instanceof URI)) {\n   *          return new Error(\n   *            'Expected a string or an URI for ' + propName + ' in ' +\n   *            componentName\n   *          );\n   *        }\n   *      }\n   *    },\n   *    render: function() {...}\n   *  });\n   *\n   * @internal\n   */\n\n  var ANONYMOUS = '<<anonymous>>';\n\n  // Important!\n  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.\n  var ReactPropTypes = {\n    array: createPrimitiveTypeChecker('array'),\n    bool: createPrimitiveTypeChecker('boolean'),\n    func: createPrimitiveTypeChecker('function'),\n    number: createPrimitiveTypeChecker('number'),\n    object: createPrimitiveTypeChecker('object'),\n    string: createPrimitiveTypeChecker('string'),\n    symbol: createPrimitiveTypeChecker('symbol'),\n\n    any: createAnyTypeChecker(),\n    arrayOf: createArrayOfTypeChecker,\n    element: createElementTypeChecker(),\n    instanceOf: createInstanceTypeChecker,\n    node: createNodeChecker(),\n    objectOf: createObjectOfTypeChecker,\n    oneOf: createEnumTypeChecker,\n    oneOfType: createUnionTypeChecker,\n    shape: createShapeTypeChecker\n  };\n\n  /**\n   * inlined Object.is polyfill to avoid requiring consumers ship their own\n   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is\n   */\n  /*eslint-disable no-self-compare*/\n  function is(x, y) {\n    // SameValue algorithm\n    if (x === y) {\n      // Steps 1-5, 7-10\n      // Steps 6.b-6.e: +0 != -0\n      return x !== 0 || 1 / x === 1 / y;\n    } else {\n      // Step 6.a: NaN == NaN\n      return x !== x && y !== y;\n    }\n  }\n  /*eslint-enable no-self-compare*/\n\n  /**\n   * We use an Error-like object for backward compatibility as people may call\n   * PropTypes directly and inspect their output. However, we don't use real\n   * Errors anymore. We don't inspect their stack anyway, and creating them\n   * is prohibitively expensive if they are created too often, such as what\n   * happens in oneOfType() for any type before the one that matched.\n   */\n  function PropTypeError(message) {\n    this.message = message;\n    this.stack = '';\n  }\n  // Make `instanceof Error` still work for returned errors.\n  PropTypeError.prototype = Error.prototype;\n\n  function createChainableTypeChecker(validate) {\n    if (process.env.NODE_ENV !== 'production') {\n      var manualPropTypeCallCache = {};\n      var manualPropTypeWarningCount = 0;\n    }\n    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {\n      componentName = componentName || ANONYMOUS;\n      propFullName = propFullName || propName;\n\n      if (secret !== ReactPropTypesSecret) {\n        if (throwOnDirectAccess) {\n          // New behavior only for users of `prop-types` package\n          invariant(\n            false,\n            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +\n            'Use `PropTypes.checkPropTypes()` to call them. ' +\n            'Read more at http://fb.me/use-check-prop-types'\n          );\n        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {\n          // Old behavior for people using React.PropTypes\n          var cacheKey = componentName + ':' + propName;\n          if (\n            !manualPropTypeCallCache[cacheKey] &&\n            // Avoid spamming the console because they are often not actionable except for lib authors\n            manualPropTypeWarningCount < 3\n          ) {\n            warning(\n              false,\n              'You are manually calling a React.PropTypes validation ' +\n              'function for the `%s` prop on `%s`. This is deprecated ' +\n              'and will throw in the standalone `prop-types` package. ' +\n              'You may be seeing this warning due to a third-party PropTypes ' +\n              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',\n              propFullName,\n              componentName\n            );\n            manualPropTypeCallCache[cacheKey] = true;\n            manualPropTypeWarningCount++;\n          }\n        }\n      }\n      if (props[propName] == null) {\n        if (isRequired) {\n          if (props[propName] === null) {\n            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));\n          }\n          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));\n        }\n        return null;\n      } else {\n        return validate(props, propName, componentName, location, propFullName);\n      }\n    }\n\n    var chainedCheckType = checkType.bind(null, false);\n    chainedCheckType.isRequired = checkType.bind(null, true);\n\n    return chainedCheckType;\n  }\n\n  function createPrimitiveTypeChecker(expectedType) {\n    function validate(props, propName, componentName, location, propFullName, secret) {\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== expectedType) {\n        // `propValue` being instance of, say, date/regexp, pass the 'object'\n        // check, but we can offer a more precise error message here rather than\n        // 'of type `object`'.\n        var preciseType = getPreciseType(propValue);\n\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createAnyTypeChecker() {\n    return createChainableTypeChecker(emptyFunction.thatReturnsNull);\n  }\n\n  function createArrayOfTypeChecker(typeChecker) {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (typeof typeChecker !== 'function') {\n        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');\n      }\n      var propValue = props[propName];\n      if (!Array.isArray(propValue)) {\n        var propType = getPropType(propValue);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));\n      }\n      for (var i = 0; i < propValue.length; i++) {\n        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);\n        if (error instanceof Error) {\n          return error;\n        }\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createElementTypeChecker() {\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      if (!isValidElement(propValue)) {\n        var propType = getPropType(propValue);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createInstanceTypeChecker(expectedClass) {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (!(props[propName] instanceof expectedClass)) {\n        var expectedClassName = expectedClass.name || ANONYMOUS;\n        var actualClassName = getClassName(props[propName]);\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createEnumTypeChecker(expectedValues) {\n    if (!Array.isArray(expectedValues)) {\n      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;\n      return emptyFunction.thatReturnsNull;\n    }\n\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      for (var i = 0; i < expectedValues.length; i++) {\n        if (is(propValue, expectedValues[i])) {\n          return null;\n        }\n      }\n\n      var valuesString = JSON.stringify(expectedValues);\n      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createObjectOfTypeChecker(typeChecker) {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (typeof typeChecker !== 'function') {\n        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');\n      }\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== 'object') {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));\n      }\n      for (var key in propValue) {\n        if (propValue.hasOwnProperty(key)) {\n          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);\n          if (error instanceof Error) {\n            return error;\n          }\n        }\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createUnionTypeChecker(arrayOfTypeCheckers) {\n    if (!Array.isArray(arrayOfTypeCheckers)) {\n      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;\n      return emptyFunction.thatReturnsNull;\n    }\n\n    function validate(props, propName, componentName, location, propFullName) {\n      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {\n        var checker = arrayOfTypeCheckers[i];\n        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {\n          return null;\n        }\n      }\n\n      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createNodeChecker() {\n    function validate(props, propName, componentName, location, propFullName) {\n      if (!isNode(props[propName])) {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function createShapeTypeChecker(shapeTypes) {\n    function validate(props, propName, componentName, location, propFullName) {\n      var propValue = props[propName];\n      var propType = getPropType(propValue);\n      if (propType !== 'object') {\n        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));\n      }\n      for (var key in shapeTypes) {\n        var checker = shapeTypes[key];\n        if (!checker) {\n          continue;\n        }\n        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);\n        if (error) {\n          return error;\n        }\n      }\n      return null;\n    }\n    return createChainableTypeChecker(validate);\n  }\n\n  function isNode(propValue) {\n    switch (typeof propValue) {\n      case 'number':\n      case 'string':\n      case 'undefined':\n        return true;\n      case 'boolean':\n        return !propValue;\n      case 'object':\n        if (Array.isArray(propValue)) {\n          return propValue.every(isNode);\n        }\n        if (propValue === null || isValidElement(propValue)) {\n          return true;\n        }\n\n        var iteratorFn = getIteratorFn(propValue);\n        if (iteratorFn) {\n          var iterator = iteratorFn.call(propValue);\n          var step;\n          if (iteratorFn !== propValue.entries) {\n            while (!(step = iterator.next()).done) {\n              if (!isNode(step.value)) {\n                return false;\n              }\n            }\n          } else {\n            // Iterator will provide entry [k,v] tuples rather than values.\n            while (!(step = iterator.next()).done) {\n              var entry = step.value;\n              if (entry) {\n                if (!isNode(entry[1])) {\n                  return false;\n                }\n              }\n            }\n          }\n        } else {\n          return false;\n        }\n\n        return true;\n      default:\n        return false;\n    }\n  }\n\n  function isSymbol(propType, propValue) {\n    // Native Symbol.\n    if (propType === 'symbol') {\n      return true;\n    }\n\n    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'\n    if (propValue['@@toStringTag'] === 'Symbol') {\n      return true;\n    }\n\n    // Fallback for non-spec compliant Symbols which are polyfilled.\n    if (typeof Symbol === 'function' && propValue instanceof Symbol) {\n      return true;\n    }\n\n    return false;\n  }\n\n  // Equivalent of `typeof` but with special handling for array and regexp.\n  function getPropType(propValue) {\n    var propType = typeof propValue;\n    if (Array.isArray(propValue)) {\n      return 'array';\n    }\n    if (propValue instanceof RegExp) {\n      // Old webkits (at least until Android 4.0) return 'function' rather than\n      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/\n      // passes PropTypes.object.\n      return 'object';\n    }\n    if (isSymbol(propType, propValue)) {\n      return 'symbol';\n    }\n    return propType;\n  }\n\n  // This handles more types than `getPropType`. Only used for error messages.\n  // See `createPrimitiveTypeChecker`.\n  function getPreciseType(propValue) {\n    var propType = getPropType(propValue);\n    if (propType === 'object') {\n      if (propValue instanceof Date) {\n        return 'date';\n      } else if (propValue instanceof RegExp) {\n        return 'regexp';\n      }\n    }\n    return propType;\n  }\n\n  // Returns class name of the object, if any.\n  function getClassName(propValue) {\n    if (!propValue.constructor || !propValue.constructor.name) {\n      return ANONYMOUS;\n    }\n    return propValue.constructor.name;\n  }\n\n  ReactPropTypes.checkPropTypes = checkPropTypes;\n  ReactPropTypes.PropTypes = ReactPropTypes;\n\n  return ReactPropTypes;\n};\n\n/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/prop-types/factoryWithTypeCheckers.js\n// module id = 19\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/prop-types/factoryWithTypeCheckers.js?");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

eval("\n/**\n * When source maps are enabled, `style-loader` uses a link element with a data-uri to\n * embed the css on the page. This breaks all relative urls because now they are relative to a\n * bundle instead of the current page.\n *\n * One solution is to only use full urls, but that may be impossible.\n *\n * Instead, this function \"fixes\" the relative urls to be absolute according to the current page location.\n *\n * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.\n *\n */\n\nmodule.exports = function (css) {\n  // get current location\n  var location = typeof window !== \"undefined\" && window.location;\n\n  if (!location) {\n    throw new Error(\"fixUrls requires window.location\");\n  }\n\n\t// blank or null?\n\tif (!css || typeof css !== \"string\") {\n\t  return css;\n  }\n\n  var baseUrl = location.protocol + \"//\" + location.host;\n  var currentDir = baseUrl + location.pathname.replace(/\\/[^\\/]*$/, \"/\");\n\n\t// convert each url(...)\n\t/*\n\tThis regular expression is just a way to recursively match brackets within\n\ta string.\n\n\t /url\\s*\\(  = Match on the word \"url\" with any whitespace after it and then a parens\n\t   (  = Start a capturing group\n\t     (?:  = Start a non-capturing group\n\t         [^)(]  = Match anything that isn't a parentheses\n\t         |  = OR\n\t         \\(  = Match a start parentheses\n\t             (?:  = Start another non-capturing groups\n\t                 [^)(]+  = Match anything that isn't a parentheses\n\t                 |  = OR\n\t                 \\(  = Match a start parentheses\n\t                     [^)(]*  = Match anything that isn't a parentheses\n\t                 \\)  = Match a end parentheses\n\t             )  = End Group\n              *\\) = Match anything and then a close parens\n          )  = Close non-capturing group\n          *  = Match anything\n       )  = Close capturing group\n\t \\)  = Match a close parens\n\n\t /gi  = Get all matches, not the first.  Be case insensitive.\n\t */\n\tvar fixedCss = css.replace(/url\\s*\\(((?:[^)(]|\\((?:[^)(]+|\\([^)(]*\\))*\\))*)\\)/gi, function(fullMatch, origUrl) {\n\t\t// strip quotes (if they exist)\n\t\tvar unquotedOrigUrl = origUrl\n\t\t\t.trim()\n\t\t\t.replace(/^\"(.*)\"$/, function(o, $1){ return $1; })\n\t\t\t.replace(/^'(.*)'$/, function(o, $1){ return $1; });\n\n\t\t// already a full url? no change\n\t\tif (/^(#|data:|http:\\/\\/|https:\\/\\/|file:\\/\\/\\/)/i.test(unquotedOrigUrl)) {\n\t\t  return fullMatch;\n\t\t}\n\n\t\t// convert the url to a full url\n\t\tvar newUrl;\n\n\t\tif (unquotedOrigUrl.indexOf(\"//\") === 0) {\n\t\t  \t//TODO: should we add protocol?\n\t\t\tnewUrl = unquotedOrigUrl;\n\t\t} else if (unquotedOrigUrl.indexOf(\"/\") === 0) {\n\t\t\t// path should be relative to the base url\n\t\t\tnewUrl = baseUrl + unquotedOrigUrl; // already starts with '/'\n\t\t} else {\n\t\t\t// path should be relative to current directory\n\t\t\tnewUrl = currentDir + unquotedOrigUrl.replace(/^\\.\\//, \"\"); // Strip leading './'\n\t\t}\n\n\t\t// send back the fixed url(...)\n\t\treturn \"url(\" + JSON.stringify(newUrl) + \")\";\n\t});\n\n\t// send back the fixed css\n\treturn fixedCss;\n};\n\n\n//////////////////\n// WEBPACK FOOTER\n// ./~/style-loader/fixUrls.js\n// module id = 20\n// module chunks = 0\n\n//# sourceURL=webpack:///./~/style-loader/fixUrls.js?");

/***/ })
/******/ ]);
});

/***/ }),

/***/ "./node_modules/react-popper/lib/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),

/***/ "./node_modules/react-popper/lib/Manager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),

/***/ "./node_modules/react-popper/lib/Popper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__("./node_modules/popper.js/dist/esm/popper.js");

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }
      this._popper = new _popper2.default(this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),

/***/ "./node_modules/react-popper/lib/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),

/***/ "./node_modules/react-popper/lib/react-popper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__("./node_modules/react-popper/lib/Manager.js");

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__("./node_modules/react-popper/lib/Target.js");

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__("./node_modules/react-popper/lib/Popper.js");

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__("./node_modules/react-popper/lib/Arrow.js");

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),

/***/ "./node_modules/react-redux/es/components/Provider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__("./node_modules/react-redux/es/utils/PropTypes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__("./node_modules/react-redux/es/utils/warning.js");





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),

/***/ "./node_modules/react-redux/es/components/connectAdvanced.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__("./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__("./node_modules/react-is/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__("./node_modules/react-redux/es/utils/Subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__("./node_modules/react-redux/es/utils/PropTypes.js");










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),

/***/ "./node_modules/react-redux/es/connect/connect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__("./node_modules/react-redux/es/components/connectAdvanced.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__("./node_modules/react-redux/es/utils/shallowEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__("./node_modules/react-redux/es/connect/mapDispatchToProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__("./node_modules/react-redux/es/connect/mapStateToProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__("./node_modules/react-redux/es/connect/mergeProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__("./node_modules/react-redux/es/connect/selectorFactory.js");








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),

/***/ "./node_modules/react-redux/es/connect/mapDispatchToProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__("./node_modules/react-redux/es/connect/wrapMapToProps.js");


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),

/***/ "./node_modules/react-redux/es/connect/mapStateToProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__("./node_modules/react-redux/es/connect/wrapMapToProps.js");

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),

/***/ "./node_modules/react-redux/es/connect/mergeProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__("./node_modules/react-redux/es/utils/verifyPlainObject.js");


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),

/***/ "./node_modules/react-redux/es/connect/selectorFactory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__("./node_modules/react-redux/es/connect/verifySubselectors.js");


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),

/***/ "./node_modules/react-redux/es/connect/verifySubselectors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__("./node_modules/react-redux/es/utils/warning.js");


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),

/***/ "./node_modules/react-redux/es/connect/wrapMapToProps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__("./node_modules/react-redux/es/utils/verifyPlainObject.js");

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),

/***/ "./node_modules/react-redux/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__("./node_modules/react-redux/es/components/Provider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__("./node_modules/react-redux/es/components/connectAdvanced.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__("./node_modules/react-redux/es/connect/connect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),

/***/ "./node_modules/react-redux/es/utils/PropTypes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),

/***/ "./node_modules/react-redux/es/utils/Subscription.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),

/***/ "./node_modules/react-redux/es/utils/isPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),

/***/ "./node_modules/react-redux/es/utils/shallowEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),

/***/ "./node_modules/react-redux/es/utils/verifyPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__("./node_modules/react-redux/es/utils/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__("./node_modules/react-redux/es/utils/warning.js");


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),

/***/ "./node_modules/react-redux/es/utils/warning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/CSSTranslate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(position, metric, axis) {
  var positionPercent = position === 0 ? position : position + metric;
  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
  var transitionProp = 'translate3d';
  var translatedPosition = '(' + positionCss.join(',') + ')';
  return transitionProp + translatedPosition;
};

exports.default = _default;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/components/Carousel/animations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fadeAnimationHandler = exports.slideStopSwipingHandler = exports.slideSwipeAnimationHandler = exports.slideAnimationHandler = void 0;

var _react = __webpack_require__("./node_modules/react/index.js");

var _CSSTranslate = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/CSSTranslate.js"));

var _utils = __webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Carousel/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */
var slideAnimationHandler = function slideAnimationHandler(props, state) {
  var returnStyles = {};
  var selectedItem = state.selectedItem;
  var previousItem = selectedItem;
  var lastPosition = _react.Children.count(props.children) - 1;
  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

  if (needClonedSlide) {
    if (previousItem < 0) {
      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
      } else {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
      }
    } else if (previousItem > lastPosition) {
      returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
    }

    return returnStyles;
  }

  var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
  var transitionTime = props.transitionTime + 'ms';
  returnStyles.itemListStyle = {
    WebkitTransform: transformProp,
    msTransform: transformProp,
    OTransform: transformProp,
    transform: transformProp
  };

  if (!state.swiping) {
    returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */


exports.slideAnimationHandler = slideAnimationHandler;

var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
  var returnStyles = {};
  var isHorizontal = props.axis === 'horizontal';

  var childrenLength = _react.Children.count(props.children);

  var initialBoundry = 0;
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
  var axisDelta = isHorizontal ? delta.x : delta.y;
  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

  if (currentPosition === initialBoundry && axisDelta > 0) {
    handledDelta = 0;
  } // prevent user from swiping right out of boundaries


  if (currentPosition === finalBoundry && axisDelta < 0) {
    handledDelta = 0;
  }

  var position = currentPosition + 100 / (state.itemSize / handledDelta);
  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

  if (props.infiniteLoop && hasMoved) {
    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
    if (state.selectedItem === 0 && position > -100) {
      position -= childrenLength * 100;
    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
      position += childrenLength * 100;
    }
  }

  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
    if (!state.swipeMovementStarted) {
      setState({
        swipeMovementStarted: true
      });
    }

    returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
  } //allows scroll if the swipe was within the tolerance


  if (hasMoved && !state.cancelClick) {
    setState({
      cancelClick: true
    });
  }

  return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */


exports.slideSwipeAnimationHandler = slideSwipeAnimationHandler;

var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
  return {
    itemListStyle: itemListStyle
  };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */


exports.slideStopSwipingHandler = slideStopSwipingHandler;

var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
  var transitionTime = props.transitionTime + 'ms';
  var transitionTimingFunction = 'ease-in-out';
  var slideStyle = {
    position: 'absolute',
    display: 'block',
    zIndex: -2,
    minHeight: '100%',
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: transitionTimingFunction,
    msTransitionTimingFunction: transitionTimingFunction,
    MozTransitionTimingFunction: transitionTimingFunction,
    WebkitTransitionTimingFunction: transitionTimingFunction,
    OTransitionTimingFunction: transitionTimingFunction
  };

  if (!state.swiping) {
    slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return {
    slideStyle: slideStyle,
    selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
      opacity: 1,
      position: 'relative'
    }),
    prevStyle: _objectSpread({}, slideStyle)
  };
};

exports.fadeAnimationHandler = fadeAnimationHandler;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/components/Carousel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("./node_modules/react/index.js"));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__("./node_modules/react-easy-swipe/lib/index.js"));

var _cssClasses = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/cssClasses.js"));

var _Thumbs = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Thumbs.js"));

var _document = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/shims/document.js"));

var _window = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/shims/window.js"));

var _utils = __webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Carousel/utils.js");

var _animations = __webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Carousel/animations.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  // @ts-ignore
  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
      _this.thumbsRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
      _this.carouselWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
      _this.listRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
      if (!_this.itemsRef) {
        _this.itemsRef = [];
      }

      _this.itemsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.clearAutoPlay();

      if (!_this.props.autoPlay) {
        return;
      }

      _this.timer = setTimeout(function () {
        _this.increment();
      }, _this.props.interval);
    });

    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
      if (_this.timer) clearTimeout(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
      _this.clearAutoPlay();

      _this.autoPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
      _this.setState({
        isMouseEntered: true
      }, _this.clearAutoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
      _this.setState({
        isMouseEntered: false
      }, _this.autoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
      if (!_this.carouselWrapperRef) {
        return false;
      }

      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
      if (!_this.isFocusWithinTheCarousel()) {
        return;
      }

      var axis = _this.props.axis;
      var isHorizontal = axis === 'horizontal';
      var keyNames = {
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        ArrowLeft: 37
      };
      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;

      if (nextKey === e.keyCode) {
        _this.increment();
      } else if (prevKey === e.keyCode) {
        _this.decrement();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
        return;
      }

      var isHorizontal = _this.props.axis === 'horizontal';
      var firstItem = _this.itemsRef[0];

      if (!firstItem) {
        return;
      }

      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

      _this.setState({
        itemSize: itemSize
      });

      if (_this.thumbsRef) {
        _this.thumbsRef.updateSizes();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
      _this.setState({
        hasMount: true
      });

      _this.updateSizes();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
      if (_react.Children.count(_this.props.children) === 0) {
        return;
      }

      if (_this.state.cancelClick) {
        _this.setState({
          cancelClick: false
        });

        return;
      }

      _this.props.onClickItem(index, item);

      if (index !== _this.state.selectedItem) {
        _this.setState({
          selectedItem: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.props.onChange(index, item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
      _this.props.onClickThumb(index, item);

      _this.moveTo(index);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
      _this.setState({
        swiping: true
      });

      _this.props.onSwipeStart(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
      _this.setState({
        swiping: false,
        cancelClick: false,
        swipeMovementStarted: false
      });

      _this.props.onSwipeEnd(event);

      _this.clearAutoPlay();

      if (_this.state.autoPlay) {
        _this.autoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
      _this.props.onSwipeMove(event);

      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));

      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
      // Return false to allow scrolling when not swiping


      return !!Object.keys(animationHandlerResponse).length;
    });

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      if (typeof position !== 'number') {
        return;
      }

      var lastPosition = _react.Children.count(_this.props.children) - 1;

      if (position < 0) {
        position = _this.props.infiniteLoop ? lastPosition : 0;
      }

      if (position > lastPosition) {
        position = _this.props.infiniteLoop ? 0 : lastPosition;
      }

      _this.selectItem({
        // if it's not a slider, we don't need to set position here
        selectedItem: position
      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
      // and will result in the interval function not being cleared correctly.


      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
        _this.resetAutoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
      _this.increment(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
      _this.decrement(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
      _this.increment(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
      _this.decrement(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
      return function (e) {
        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
          _this.moveTo(newIndex);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state) {
      // Merge in the new state while updating updating previous item
      _this.setState(_objectSpread({
        previousItem: _this.state.selectedItem
      }, state), function () {
        // Run animation handler and update styles based on it
        _this.setState(_this.animationHandler(_this.props, _this.state));
      });

      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
      var selectedItem = _this.props.selectedItem;
      var item = _this.itemsRef && _this.itemsRef[selectedItem];
      var images = item && item.getElementsByTagName('img') || [];
      return images[0];
    });

    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
      var item = _this.itemsRef && _this.itemsRef[position];

      if (_this.state.hasMount && item && item.children.length) {
        var slideImages = item.children[0].getElementsByTagName('img') || [];

        if (slideImages.length > 0) {
          var image = slideImages[0];

          if (!image.complete) {
            // if the image is still loading, the size won't be available so we trigger a new render after it's done
            var onImageLoad = function onImageLoad() {
              _this.forceUpdate();

              image.removeEventListener('load', onImageLoad);
            };

            image.addEventListener('load', onImageLoad);
          }
        } // try to get img first, if img not there find first display tag


        var displayItem = slideImages[0] || item.children[0];
        var height = displayItem.clientHeight;
        return height > 0 ? height : null;
      }

      return null;
    });

    var initState = {
      initialized: false,
      previousItem: props.selectedItem,
      selectedItem: props.selectedItem,
      hasMount: false,
      isMouseEntered: false,
      autoPlay: props.autoPlay,
      swiping: false,
      swipeMovementStarted: false,
      cancelClick: false,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.children) {
        return;
      }

      this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.children && this.props.children && !this.state.initialized) {
        this.setupCarousel();
      }

      if (!prevProps.autoFocus && this.props.autoFocus) {
        this.forceFocus();
      }

      if (prevState.swiping && !this.state.swiping) {
        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
      }

      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
        this.updateSizes();
        this.moveTo(this.props.selectedItem);
      }

      if (prevProps.autoPlay !== this.props.autoPlay) {
        if (this.props.autoPlay) {
          this.setupAutoPlay();
        } else {
          this.destroyAutoPlay();
        }

        this.setState({
          autoPlay: this.props.autoPlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function setupCarousel() {
      var _this2 = this;

      this.bindEvents();

      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
        this.setupAutoPlay();
      }

      if (this.props.autoFocus) {
        this.forceFocus();
      }

      this.setState({
        initialized: true
      }, function () {
        var initialImage = _this2.getInitialImage();

        if (initialImage && !initialImage.complete) {
          // if it's a carousel of images, we set the mount state after the first image is loaded
          initialImage.addEventListener('load', _this2.setMountState);
        } else {
          _this2.setMountState();
        }
      });
    }
  }, {
    key: "destroyCarousel",
    value: function destroyCarousel() {
      if (this.state.initialized) {
        this.unbindEvents();
        this.destroyAutoPlay();
      }
    }
  }, {
    key: "setupAutoPlay",
    value: function setupAutoPlay() {
      this.autoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "destroyAutoPlay",
    value: function destroyAutoPlay() {
      this.clearAutoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
      var initialImage = this.getInitialImage();

      if (initialImage) {
        initialImage.removeEventListener('load', this.setMountState);
      }

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "forceFocus",
    value: function forceFocus() {
      var _this$carouselWrapper;

      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
    }
  }, {
    key: "renderItems",
    value: function renderItems(isClone) {
      var _this3 = this;

      if (!this.props.children) {
        return [];
      }

      return _react.Children.map(this.props.children, function (item, index) {
        var isSelected = index === _this3.state.selectedItem;
        var isPrevious = index === _this3.state.previousItem;
        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};

        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
          style = _objectSpread(_objectSpread({}, style), {}, {
            minWidth: _this3.props.centerSlidePercentage + '%'
          });
        }

        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
          style = _objectSpread(_objectSpread({}, style), {}, {
            pointerEvents: 'none'
          });
        }

        var slideProps = {
          ref: function ref(e) {
            return _this3.setItemsRef(e, index);
          },
          key: 'itemKey' + index + (isClone ? 'clone' : ''),
          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
          onClick: _this3.handleClickItem.bind(_this3, index, item),
          style: style
        };
        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
          isSelected: index === _this3.state.selectedItem,
          isPrevious: index === _this3.state.previousItem
        }));
      });
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this4 = this;

      var _this$props = this.props,
          showIndicators = _this$props.showIndicators,
          labels = _this$props.labels,
          renderIndicator = _this$props.renderIndicator,
          children = _this$props.children;

      if (!showIndicators) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "control-dots"
      }, _react.Children.map(children, function (_, index) {
        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
      }));
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      if (!this.props.showStatus) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
    }
  }, {
    key: "renderThumbs",
    value: function renderThumbs() {
      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
      var isHorizontal = this.props.axis === 'horizontal';
      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
      var itemsClone = this.renderItems(true);
      var firstClone = itemsClone.shift();
      var lastClone = itemsClone.pop();
      var swiperProps = {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      };
      var containerStyles = {};

      if (isHorizontal) {
        swiperProps.onSwipeLeft = this.onSwipeForward;
        swiperProps.onSwipeRight = this.onSwipeBackwards;

        if (this.props.dynamicHeight) {
          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

          containerStyles.height = itemHeight || 'auto';
        }
      } else {
        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
          height: this.state.itemSize
        });
        containerStyles.height = this.state.itemSize;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: _cssClasses.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(true),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(true, this.props.axis),
        style: containerStyles
      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
        tagName: "ul",
        innerRef: this.setListRef
      }, swiperProps, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        ref: function ref(node) {
          return _this5.setListRef(node);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]);

  return Carousel;
}(_react.default.Component);

exports.default = Carousel;

_defineProperty(Carousel, "displayName", 'Carousel');

_defineProperty(Carousel, "defaultProps", {
  ariaLabel: undefined,
  axis: 'horizontal',
  centerSlidePercentage: 80,
  interval: 3000,
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  onClickItem: _utils.noop,
  onClickThumb: _utils.noop,
  onChange: _utils.noop,
  onSwipeStart: function onSwipeStart() {},
  onSwipeEnd: function onSwipeEnd() {},
  onSwipeMove: function onSwipeMove() {
    return false;
  },
  preventMovementUntilSwipeScrollTolerance: false,
  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_PREV(!hasPrev),
      onClick: onClickHandler
    });
  },
  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_NEXT(!hasNext),
      onClick: onClickHandler
    });
  },
  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _cssClasses.default.DOT(isSelected),
      onClick: onClickHandler,
      onKeyDown: onClickHandler,
      value: index,
      key: index,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(label, " ").concat(index + 1)
    });
  },
  renderItem: function renderItem(item) {
    return item;
  },
  renderThumbs: function renderThumbs(children) {
    var images = _react.Children.map(children, function (item) {
      var img = item; // if the item is not an image, try to find the first image in the item's children.

      if (item.type !== 'img') {
        img = _react.Children.toArray(item.props.children).find(function (children) {
          return children.type === 'img';
        });
      }

      if (!img) {
        return undefined;
      }

      return img;
    });

    if (images.filter(function (image) {
      return image;
    }).length === 0) {
      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
      return [];
    }

    return images;
  },
  statusFormatter: _utils.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: true,
  showIndicators: true,
  showStatus: true,
  showThumbs: true,
  stopOnHover: true,
  swipeScrollTolerance: 5,
  swipeable: true,
  transitionTime: 350,
  verticalSwipe: 'standard',
  width: '100%',
  animationHandler: 'slide',
  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
  stopSwipingHandler: _animations.slideStopSwipingHandler
});

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/components/Carousel/types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/components/Carousel/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPosition = exports.getPosition = exports.isKeyboardEvent = exports.defaultStatusFormatter = exports.noop = void 0;

var _react = __webpack_require__("./node_modules/react/index.js");

var _CSSTranslate = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/CSSTranslate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

exports.noop = noop;

var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
  return "".concat(current, " of ").concat(total);
};

exports.defaultStatusFormatter = defaultStatusFormatter;

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e ? e.hasOwnProperty('key') : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */


exports.isKeyboardEvent = isKeyboardEvent;

var getPosition = function getPosition(index, props) {
  if (props.infiniteLoop) {
    // index has to be added by 1 because of the first cloned slide
    ++index;
  }

  if (index === 0) {
    return 0;
  }

  var childrenLength = _react.Children.count(props.children);

  if (props.centerMode && props.axis === 'horizontal') {
    var currentPosition = -index * props.centerSlidePercentage;
    var lastPosition = childrenLength - 1;

    if (index && (index !== lastPosition || props.infiniteLoop)) {
      currentPosition += (100 - props.centerSlidePercentage) / 2;
    } else if (index === lastPosition) {
      currentPosition += 100 - props.centerSlidePercentage;
    }

    return currentPosition;
  }

  return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */


exports.getPosition = getPosition;

var setPosition = function setPosition(position, axis) {
  var style = {};
  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
    // @ts-ignore
    style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
  });
  return style;
};

exports.setPosition = setPosition;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/components/Thumbs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("./node_modules/react/index.js"));

var _cssClasses = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/cssClasses.js"));

var _dimensions = __webpack_require__("./node_modules/react-responsive-carousel/lib/js/dimensions.js");

var _CSSTranslate = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/CSSTranslate.js"));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__("./node_modules/react-easy-swipe/lib/index.js"));

var _window = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/shims/window.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e.hasOwnProperty('key');
};

var Thumbs = /*#__PURE__*/function (_Component) {
  _inherits(Thumbs, _Component);

  var _super = _createSuper(Thumbs);

  function Thumbs(_props) {
    var _this;

    _classCallCheck(this, Thumbs);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
      _this.itemsWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
      _this.itemsListRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
      if (!_this.thumbsRef) {
        _this.thumbsRef = [];
      }

      _this.thumbsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
        return;
      }

      var total = _react.Children.count(_this.props.children);

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
      var visibleItems = Math.floor(wrapperSize / itemSize);
      var showArrows = visibleItems < total;
      var lastPosition = showArrows ? total - visibleItems : 0;

      _this.setState(function (_state, props) {
        return {
          itemSize: itemSize,
          visibleItems: visibleItems,
          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
          lastPosition: lastPosition,
          showArrows: showArrows
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
      if (!isKeyboardEvent(e) || e.key === 'Enter') {
        var handler = _this.props.onSelectItem;

        if (typeof handler === 'function') {
          handler(index, item);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
      _this.setState({
        swiping: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
      _this.setState({
        swiping: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
      var deltaX = delta.x;

      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
        return false;
      }

      var leftBoundary = 0;

      var childrenLength = _react.Children.count(_this.props.children);

      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

      if (currentPosition === leftBoundary && deltaX > 0) {
        deltaX = 0;
      } // prevent user from swiping right out of boundaries


      if (currentPosition === lastLeftBoundary && deltaX < 0) {
        deltaX = 0;
      }

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

      if (_this.itemsListRef) {
        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
        });
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      // position can't be lower than 0
      position = position < 0 ? 0 : position; // position can't be higher than last postion

      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;

      _this.setState({
        firstItem: position
      });
    });

    _this.state = {
      selectedItem: _props.selectedItem,
      swiping: false,
      showArrows: false,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    };
    return _this;
  }

  _createClass(Thumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedItem !== this.state.selectedItem) {
        this.setState({
          selectedItem: this.props.selectedItem,
          firstItem: this.getFirstItem(this.props.selectedItem)
        });
      }

      if (this.props.children === prevProps.children) {
        return;
      } // This will capture any size changes for arrow adjustments etc.
      // usually in the same render cycle so we don't see any flickers


      this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function setupThumbs() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
      // the container size to adjust the responsive behaviour

      this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function destroyThumbs() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function getFirstItem(selectedItem) {
      var firstItem = selectedItem;

      if (selectedItem >= this.state.lastPosition) {
        firstItem = this.state.lastPosition;
      }

      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
        firstItem = this.state.firstItem;
      }

      if (selectedItem < this.state.firstItem) {
        firstItem = selectedItem;
      }

      return firstItem;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      return this.props.children.map(function (img, index) {
        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);

        var thumbProps = {
          key: index,
          ref: function ref(e) {
            return _this2.setThumbsRef(e, index);
          },
          className: itemClass,
          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
          style: {
            width: _this2.props.thumbWidth
          }
        };
        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
          role: "button",
          tabIndex: 0
        }), img);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.props.children) {
        return null;
      }

      var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

      var itemListStyles = {};
      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
      var transitionTime = this.props.transitionTime + 'ms';
      itemListStyles = {
        WebkitTransform: transformProp,
        MozTransform: transformProp,
        MsTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp,
        msTransform: transformProp,
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        MsTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(false)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(false),
        ref: this.setItemsWrapperRef
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_PREV(!hasPrev),
        onClick: function onClick() {
          return _this3.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
        tagName: "ul",
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: itemListStyles,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        ref: function ref(node) {
          return _this3.setItemsListRef(node);
        },
        style: itemListStyles
      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_NEXT(!hasNext),
        onClick: function onClick() {
          return _this3.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]);

  return Thumbs;
}(_react.Component);

exports.default = Thumbs;

_defineProperty(Thumbs, "displayName", 'Thumbs');

_defineProperty(Thumbs, "defaultProps", {
  axis: 'horizontal',
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/cssClasses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(__webpack_require__("./node_modules/classnames/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  ROOT: function ROOT(customClassName) {
    return (0, _classnames.default)(_defineProperty({
      'carousel-root': true
    }, customClassName || '', !!customClassName));
  },
  CAROUSEL: function CAROUSEL(isSlider) {
    return (0, _classnames.default)({
      carousel: true,
      'carousel-slider': isSlider
    });
  },
  WRAPPER: function WRAPPER(isSlider, axis) {
    return (0, _classnames.default)({
      'thumbs-wrapper': !isSlider,
      'slider-wrapper': isSlider,
      'axis-horizontal': axis === 'horizontal',
      'axis-vertical': axis !== 'horizontal'
    });
  },
  SLIDER: function SLIDER(isSlider, isSwiping) {
    return (0, _classnames.default)({
      thumbs: !isSlider,
      slider: isSlider,
      animated: !isSwiping
    });
  },
  ITEM: function ITEM(isSlider, selected, previous) {
    return (0, _classnames.default)({
      thumb: !isSlider,
      slide: isSlider,
      selected: selected,
      previous: previous
    });
  },
  ARROW_PREV: function ARROW_PREV(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-prev': true,
      'control-disabled': disabled
    });
  },
  ARROW_NEXT: function ARROW_NEXT(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-next': true,
      'control-disabled': disabled
    });
  },
  DOT: function DOT(selected) {
    return (0, _classnames.default)({
      dot: true,
      selected: selected
    });
  }
};
exports.default = _default;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/dimensions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outerWidth = void 0;

var outerWidth = function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};

exports.outerWidth = outerWidth;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Carousel", {
  enumerable: true,
  get: function get() {
    return _Carousel.default;
  }
});
Object.defineProperty(exports, "CarouselProps", {
  enumerable: true,
  get: function get() {
    return _types.CarouselProps;
  }
});
Object.defineProperty(exports, "Thumbs", {
  enumerable: true,
  get: function get() {
    return _Thumbs.default;
  }
});

var _Carousel = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Carousel/index.js"));

var _types = __webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Carousel/types.js");

var _Thumbs = _interopRequireDefault(__webpack_require__("./node_modules/react-responsive-carousel/lib/js/components/Thumbs.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/shims/document.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  return document;
};

exports.default = _default;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/js/shims/window.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  return window;
};

exports.default = _default;

/***/ }),

/***/ "./node_modules/react-responsive-carousel/lib/styles/carousel.min.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/react-responsive-modal/lib/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__ = __webpack_require__("./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal__ = __webpack_require__("./node_modules/react-minimalist-portal/lib/portal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition__ = __webpack_require__("./node_modules/react-transition-group/CSSTransition.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_no_scroll__ = __webpack_require__("./node_modules/no-scroll/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_no_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_no_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react__ = __webpack_require__("./node_modules/focus-trap-react/dist/focus-trap-react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__);









function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var CloseIcon = function CloseIcon(_ref) {
  var classes = _ref.classes,
      classNames = _ref.classNames,
      styles = _ref.styles,
      closeIconSize = _ref.closeIconSize,
      closeIconSvgPath = _ref.closeIconSvgPath,
      onClickCloseIcon = _ref.onClickCloseIcon,
      id = _ref.id;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.closeButton, classNames.closeButton),
    style: styles.closeButton,
    onClick: onClickCloseIcon,
    id: id
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.closeIcon, classNames.closeIcon),
    style: styles.closeIcon,
    xmlns: "http://www.w3.org/2000/svg",
    width: closeIconSize,
    height: closeIconSize,
    viewBox: "0 0 36 36"
  }, closeIconSvgPath));
};

CloseIcon.propTypes = {
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  closeIconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onClickCloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
CloseIcon.defaultProps = {
  id: null
};

var _modals = [];
/**
 * Handle the order of the modals.
 * Inspired by the material-ui implementation.
 */

var modalManager = {
  /**
   * Return the modals array
   */
  modals: function modals() {
    return _modals;
  },

  /**
   * Register a new modal
   */
  add: function add(modal) {
    if (_modals.indexOf(modal) === -1) {
      _modals.push(modal);
    }
  },

  /**
   * Remove a modal
   */
  remove: function remove(modal) {
    var index = _modals.indexOf(modal);

    if (index !== -1) {
      _modals.splice(index, 1);
    }
  },

  /**
   * Check if the modal is the first one on the screen
   */
  isTopModal: function isTopModal(modal) {
    return !!_modals.length && _modals[_modals.length - 1] === modal;
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_overlay__CLSq- {\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  padding: 1.2rem;\n}\n.styles_overlayCenter__YHoO7 {\n  align-items: center;\n}\n.styles_modal__gNwvD {\n  max-width: 800px;\n  position: relative;\n  padding: 1.2rem;\n  background: #ffffff;\n  background-clip: padding-box;\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);\n  margin: auto;\n}\n.styles_closeButton__20ID4 {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  display: flex;\n}\n.styles_closeIcon__1QwbI {\n}\n.styles_transitionEnter__3j_-a {\n  opacity: 0.01;\n}\n.styles_transitionEnterActive___eQs7 {\n  opacity: 1;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.styles_transitionExit__1KmEf {\n  opacity: 1;\n}\n.styles_transitionExitActive__1nQXw {\n  opacity: 0.01;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n";
var cssClasses = {"overlay":"styles_overlay__CLSq-","overlayCenter":"styles_overlayCenter__YHoO7","modal":"styles_modal__gNwvD","closeButton":"styles_closeButton__20ID4","closeIcon":"styles_closeIcon__1QwbI","transitionEnter":"styles_transitionEnter__3j_-a","transitionEnterActive":"styles_transitionEnterActive___eQs7","transitionExit":"styles_transitionExit__1KmEf","transitionExitActive":"styles_transitionExitActive__1nQXw"};
styleInject(css,{"insertAt":"top"});

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldClose", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showPortal: _this.props.open
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOpen", function () {
      modalManager.add(_assertThisInitialized(_assertThisInitialized(_this)));

      if (_this.props.blockScroll) {
        Modal.blockScroll();
      }

      document.addEventListener('keydown', _this.handleKeydown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function () {
      modalManager.remove(_assertThisInitialized(_assertThisInitialized(_this)));

      if (_this.props.blockScroll) {
        _this.unblockScroll();
      }

      document.removeEventListener('keydown', _this.handleKeydown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOverlay", function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (!_this.shouldClose) {
        _this.shouldClose = null;
        return;
      }

      if (_this.props.onOverlayClick) {
        _this.props.onOverlayClick(event);
      }

      if (_this.props.closeOnOverlayClick) {
        _this.props.onClose(event);
      }

      _this.shouldClose = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickCloseIcon", function (event) {
      _this.props.onClose(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeydown", function (event) {
      // Only the last modal need to be escaped when pressing the esc key
      if (event.keyCode !== 27 || !modalManager.isTopModal(_assertThisInitialized(_assertThisInitialized(_this)))) {
        return;
      }

      if (_this.props.onEscKeyDown) {
        _this.props.onEscKeyDown(event);
      }

      if (_this.props.closeOnEsc) {
        _this.props.onClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleModalEvent", function () {
      _this.shouldClose = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEntered", function () {
      if (_this.props.onEntered) {
        _this.props.onEntered();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleExited", function () {
      if (_this.props.onExited) {
        _this.props.onExited();
      }

      _this.setState({
        showPortal: false
      });

      if (_this.props.blockScroll) {
        _this.unblockScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unblockScroll", function () {
      // Restore the scroll only if there is no modal on the screen
      if (modalManager.modals().length === 0) {
        __WEBPACK_IMPORTED_MODULE_6_no_scroll___default.a.off();
      }
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Block scroll when initial prop is open
      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.showPortal && !this.state.showPortal) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.open) {
        this.handleClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          center = _this$props.center,
          classes = _this$props.classes,
          classNames = _this$props.classNames,
          styles = _this$props.styles,
          showCloseIcon = _this$props.showCloseIcon,
          closeIconSize = _this$props.closeIconSize,
          closeIconSvgPath = _this$props.closeIconSvgPath,
          animationDuration = _this$props.animationDuration,
          container = _this$props.container,
          focusTrapped = _this$props.focusTrapped,
          focusTrapOptions = _this$props.focusTrapOptions,
          overlayId = _this$props.overlayId,
          modalId = _this$props.modalId,
          closeIconId = _this$props.closeIconId;
      var showPortal = this.state.showPortal;

      if (!showPortal) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal___default.a, {
        container: container
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition___default.a, {
        in: open,
        appear: true,
        classNames: {
          appear: classNames.transitionEnter || classes.transitionEnter,
          appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
          enter: classNames.transitionEnter || classes.transitionEnter,
          enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
          exit: classNames.transitionExit || classes.transitionExit,
          exitActive: classNames.transitionExitActive || classes.transitionExitActive
        },
        timeout: animationDuration,
        onEntered: this.handleEntered,
        onExited: this.handleExited
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.overlay, center ? classes.overlayCenter : null, classNames.overlay),
        onClick: this.handleClickOverlay,
        style: styles.overlay,
        id: overlayId
      }, focusTrapped ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.modal, classNames.modal),
        style: styles.modal,
        onMouseDown: this.handleModalEvent,
        onMouseUp: this.handleModalEvent,
        onClick: this.handleModalEvent,
        id: modalId
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default.a, {
        focusTrapOptions: _objectSpread({}, {
          clickOutsideDeactivates: true
        }, focusTrapOptions)
      }, this.props.children, showCloseIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, {
        classes: classes,
        classNames: classNames,
        styles: styles,
        closeIconSize: closeIconSize,
        closeIconSvgPath: closeIconSvgPath,
        onClickCloseIcon: this.handleClickCloseIcon,
        id: closeIconId
      }))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.modal, classNames.modal),
        style: styles.modal,
        onMouseDown: this.handleModalEvent,
        onMouseUp: this.handleModalEvent,
        onClick: this.handleModalEvent,
        id: modalId
      }, this.props.children, showCloseIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, {
        classes: classes,
        classNames: classNames,
        styles: styles,
        closeIconSize: closeIconSize,
        closeIconSvgPath: closeIconSvgPath,
        onClickCloseIcon: this.handleClickCloseIcon,
        id: closeIconId
      })))));
    }
  }], [{
    key: "blockScroll",
    value: function blockScroll() {
      __WEBPACK_IMPORTED_MODULE_6_no_scroll___default.a.on();
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.showPortal && nextProps.open) {
        return {
          showPortal: true
        };
      }

      return null;
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Modal.propTypes = {
  /**
   * Is the modal closable when user press esc key.
   */
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Is the modal closable when user click on overlay.
   */
  closeOnOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Callback fired when the Modal is open and the animation is finished.
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the Modal has exited and the animation is finished.
   */
  onExited: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the Modal is requested to be closed by a click on the overlay or when user press esc key.
   */
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Callback fired when the escape key is pressed.
   */
  onEscKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the overlay is clicked.
   */
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Control if the modal is open or not.
   */
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * An object containing classNames to style the modal, can have properties 'overlay' (classname for overlay div), 'modal' (classname for modal content div), 'closeButton' (classname for the button that contain the close icon), 'closeIcon' (classname for close icon svg). You can customize the transition with 'transitionEnter', 'transitionEnterActive', 'transitionExit', 'transitionExitActive'
   */
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * An object containing the styles objects to style the modal, can have properties 'overlay', 'modal', 'closeButton', 'closeIcon'.
   */
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * The content of the modal.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * @internal
   */
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Should the dialog be centered.
   */
  center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Show the close icon.
   */
  showCloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Close icon size.
   */
  closeIconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * A valid svg path to show as icon.
   */
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Animation duration in milliseconds.
   */
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * You can specify a container prop which should be of type `Element`. The portal will be rendered inside that element. The default behavior will create a div node and render it at the at the end of document.body.
   */
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  // eslint-disable-line

  /**
   * Whether to block scrolling when dialog is open
   */
  blockScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * When the modal is open, trap focus within it
   */
  focusTrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Options to be passed to the focus trap, details available at https://github.com/davidtheclark/focus-trap#focustrap--createfocustrapelement-createoptions
   */
  focusTrapOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * id attribute for overlay
   */
  overlayId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * id attribute for modal
   */
  modalId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * id attribute for close icon
   */
  closeIconId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Modal.defaultProps = {
  classes: cssClasses,
  closeOnEsc: true,
  closeOnOverlayClick: true,
  onEntered: null,
  onExited: null,
  onEscKeyDown: null,
  onOverlayClick: null,
  showCloseIcon: true,
  closeIconSize: 28,
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
  }),
  classNames: {},
  styles: {},
  children: null,
  center: false,
  animationDuration: 500,
  blockScroll: true,
  focusTrapped: false,
  focusTrapOptions: {},
  overlayId: null,
  modalId: null,
  closeIconId: null
};
Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__["polyfill"])(Modal);

/* harmony default export */ __webpack_exports__["default"] = (Modal);
//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ "./node_modules/react-router-dom/es/BrowserRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/react-router-dom/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router-dom/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),

/***/ "./node_modules/react-router-dom/es/HashRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/react-router-dom/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router-dom/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Link.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/es/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ "./node_modules/react-router-dom/es/MemoryRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__("./node_modules/react-router/es/MemoryRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/NavLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__("./node_modules/react-router-dom/es/Route.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__("./node_modules/react-router-dom/es/Link.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Prompt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__("./node_modules/react-router/es/Prompt.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__("./node_modules/react-router/es/Redirect.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Route.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__("./node_modules/react-router/es/Route.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Router.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/StaticRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__("./node_modules/react-router/es/StaticRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Switch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__("./node_modules/react-router/es/Switch.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/generatePath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__("./node_modules/react-router/es/generatePath.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__("./node_modules/react-router-dom/es/BrowserRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__("./node_modules/react-router-dom/es/HashRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__("./node_modules/react-router-dom/es/Link.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__("./node_modules/react-router-dom/es/MemoryRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__("./node_modules/react-router-dom/es/NavLink.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__("./node_modules/react-router-dom/es/Prompt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__("./node_modules/react-router-dom/es/Redirect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__("./node_modules/react-router-dom/es/Route.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__("./node_modules/react-router-dom/es/Router.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__("./node_modules/react-router-dom/es/StaticRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__("./node_modules/react-router-dom/es/Switch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__("./node_modules/react-router-dom/es/generatePath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__("./node_modules/react-router-dom/es/matchPath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__("./node_modules/react-router-dom/es/withRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),

/***/ "./node_modules/react-router-dom/es/matchPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/withRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__("./node_modules/react-router/es/withRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/node_modules/warning/warning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "./node_modules/react-router/es/MemoryRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/react-router/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),

/***/ "./node_modules/react-router/es/Prompt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),

/***/ "./node_modules/react-router/es/Redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__("./node_modules/react-router/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__("./node_modules/history/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__("./node_modules/react-router/es/generatePath.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),

/***/ "./node_modules/react-router/es/Route.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/react-router/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),

/***/ "./node_modules/react-router/es/Router.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/react-router/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),

/***/ "./node_modules/react-router/es/StaticRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/react-router/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__("./node_modules/history/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),

/***/ "./node_modules/react-router/es/Switch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__("./node_modules/react-router/node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),

/***/ "./node_modules/react-router/es/generatePath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__("./node_modules/react-router/node_modules/path-to-regexp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),

/***/ "./node_modules/react-router/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__("./node_modules/react-router/es/MemoryRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__("./node_modules/react-router/es/Prompt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__("./node_modules/react-router/es/Redirect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__("./node_modules/react-router/es/Route.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__("./node_modules/react-router/es/StaticRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__("./node_modules/react-router/es/Switch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__("./node_modules/react-router/es/generatePath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_7__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__("./node_modules/react-router/es/withRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),

/***/ "./node_modules/react-router/es/matchPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__("./node_modules/react-router/node_modules/path-to-regexp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),

/***/ "./node_modules/react-router/es/withRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__("./node_modules/react-router/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__("./node_modules/react-router/es/Route.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),

/***/ "./node_modules/react-router/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "./node_modules/react-router/node_modules/isarray/index.js":
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/react-router/node_modules/path-to-regexp/index.js":
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__("./node_modules/react-router/node_modules/isarray/index.js")

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),

/***/ "./node_modules/react-router/node_modules/warning/warning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "./node_modules/react-star-rating-component/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StarRatingComponent = function (_Component) {
  _inherits(StarRatingComponent, _Component);

  function StarRatingComponent(props) {
    _classCallCheck(this, StarRatingComponent);

    var _this = _possibleConstructorReturn(this, (StarRatingComponent.__proto__ || Object.getPrototypeOf(StarRatingComponent)).call(this));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(StarRatingComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;


      if (value != null && value !== this.state.value) {
        this.setState({ value: value });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(inputValue) {
      var _props = this.props,
          editing = _props.editing,
          value = _props.value;


      if (!editing) {
        return;
      }

      // do not update internal state based on input value if prop passed
      if (value != null) {
        return;
      }

      this.setState({ value: inputValue });
    }
  }, {
    key: 'onStarClick',
    value: function onStarClick(index, value, name, e) {
      e.stopPropagation();

      var _props2 = this.props,
          onStarClick = _props2.onStarClick,
          editing = _props2.editing;


      if (!editing) {
        return;
      }

      onStarClick && onStarClick(index, value, name, e);
    }
  }, {
    key: 'onStarHover',
    value: function onStarHover(index, value, name, e) {
      e.stopPropagation();

      var _props3 = this.props,
          onStarHover = _props3.onStarHover,
          editing = _props3.editing;


      if (!editing) {
        return;
      }

      onStarHover && onStarHover(index, value, name, e);
    }
  }, {
    key: 'onStarHoverOut',
    value: function onStarHoverOut(index, value, name, e) {
      e.stopPropagation();

      var _props4 = this.props,
          onStarHoverOut = _props4.onStarHoverOut,
          editing = _props4.editing;


      if (!editing) {
        return;
      }

      onStarHoverOut && onStarHoverOut(index, value, name, e);
    }
  }, {
    key: 'renderStars',
    value: function renderStars() {
      var _this2 = this;

      var _props5 = this.props,
          name = _props5.name,
          starCount = _props5.starCount,
          starColor = _props5.starColor,
          emptyStarColor = _props5.emptyStarColor,
          editing = _props5.editing;
      var value = this.state.value;


      var starStyles = function starStyles(i, value) {
        return {
          float: 'right',
          cursor: editing ? 'pointer' : 'default',
          color: value >= i ? starColor : emptyStarColor
        };
      };
      var radioStyles = {
        display: 'none',
        position: 'absolute',
        marginLeft: -9999
      };

      // populate stars
      var starNodes = [];

      var _loop = function _loop(i) {
        var id = name + '_' + i;
        var starNodeInput = _react2.default.createElement('input', {
          key: 'input_' + id,
          style: radioStyles,
          className: 'dv-star-rating-input',
          type: 'radio',
          name: name,
          id: id,
          value: i,
          checked: value === i,
          onChange: _this2.onChange.bind(_this2, i, name)
        });
        var starNodeLabel = _react2.default.createElement(
          'label',
          {
            key: 'label_' + id,
            style: starStyles(i, value),
            className: 'dv-star-rating-star ' + (value >= i ? 'dv-star-rating-full-star' : 'dv-star-rating-empty-star'),
            htmlFor: id,
            onClick: function onClick(e) {
              return _this2.onStarClick(i, value, name, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2.onStarHover(i, value, name, e);
            },
            onMouseLeave: function onMouseLeave(e) {
              return _this2.onStarHoverOut(i, value, name, e);
            }
          },
          _this2.renderIcon(i, value, name, id)
        );

        starNodes.push(starNodeInput);
        starNodes.push(starNodeLabel);
      };

      for (var i = starCount; i > 0; i--) {
        _loop(i);
      }

      return starNodes.length ? starNodes : null;
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(index, value, name, id) {
      var _props6 = this.props,
          renderStarIcon = _props6.renderStarIcon,
          renderStarIconHalf = _props6.renderStarIconHalf;


      if (typeof renderStarIconHalf === 'function' && Math.ceil(value) === index && value % 1 !== 0) {
        return renderStarIconHalf(index, value, name, id);
      }

      if (typeof renderStarIcon === 'function') {
        return renderStarIcon(index, value, name, id);
      }

      return _react2.default.createElement(
        'i',
        { key: 'icon_' + id, style: { fontStyle: 'normal' } },
        '\u2605'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          editing = _props7.editing,
          className = _props7.className;

      var classes = (0, _classnames2.default)('dv-star-rating', {
        'dv-star-rating-non-editable': !editing
      }, className);

      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', position: 'relative' }, className: classes },
        this.renderStars()
      );
    }
  }]);

  return StarRatingComponent;
}(_react.Component);

StarRatingComponent.propTypes = {
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.number,
  editing: _propTypes2.default.bool,
  starCount: _propTypes2.default.number,
  starColor: _propTypes2.default.string,
  onStarClick: _propTypes2.default.func,
  onStarHover: _propTypes2.default.func,
  onStarHoverOut: _propTypes2.default.func,
  renderStarIcon: _propTypes2.default.func,
  renderStarIconHalf: _propTypes2.default.func
};
StarRatingComponent.defaultProps = {
  starCount: 5,
  editing: true,
  starColor: '#ffb400',
  emptyStarColor: '#333'
};
exports.default = StarRatingComponent;
module.exports = exports['default'];


/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("./node_modules/prop-types/index.js"));

var _addClass = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/class/addClass.js"));

var _removeClass = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/class/removeClass.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _Transition = _interopRequireDefault(__webpack_require__("./node_modules/react-transition-group/Transition.js"));

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-transition-group/Transition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__("./node_modules/prop-types/index.js"));

var _react = _interopRequireDefault(__webpack_require__("./node_modules/react/index.js"));

var _reactDom = _interopRequireDefault(__webpack_require__("./node_modules/react-dom/index.js"));

var _reactLifecyclesCompat = __webpack_require__("./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js");

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__("./node_modules/prop-types/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ "./node_modules/react/cjs/react.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__("./node_modules/object-assign/index.js"),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),

/***/ "./node_modules/react/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("./node_modules/react/cjs/react.production.min.js");
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),

/***/ "./node_modules/reactstrap/dist/reactstrap.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return Alert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return Col; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return Navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return NavbarBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarToggler", function() { return NavbarToggler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return Nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavItem", function() { return NavItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return NavDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return Breadcrumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return BreadcrumbItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonDropdown", function() { return ButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return ButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return ButtonToolbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return Dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return DropdownItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return DropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownToggle", function() { return DropdownToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return Fade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return Badge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return Card; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardLink", function() { return CardLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardGroup", function() { return CardGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardDeck", function() { return CardDeck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardColumns", function() { return CardColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardBody", function() { return CardBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardBlock", function() { return CardBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return CardFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return CardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardImg", function() { return CardImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardImgOverlay", function() { return CardImgOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return Carousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCarousel", function() { return UncontrolledCarousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselControl", function() { return CarouselControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return CarouselItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselIndicators", function() { return CarouselIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselCaption", function() { return CarouselCaption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardSubtitle", function() { return CardSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardText", function() { return CardText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardTitle", function() { return CardTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return Popover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverContent", function() { return PopoverContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverBody", function() { return PopoverBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverTitle", function() { return PopoverTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverHeader", function() { return PopoverHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return Progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return ModalFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperContent", function() { return PopperContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperTargetHelper", function() { return PopperTargetHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return ListGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormFeedback", function() { return FormFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormText", function() { return FormText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return InputGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupAddon", function() { return InputGroupAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButton", function() { return InputGroupButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButtonDropdown", function() { return InputGroupButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupText", function() { return InputGroupText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return Media; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationItem", function() { return PaginationItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationLink", function() { return PaginationLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return TabContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return TabPane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return Jumbotron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return ListGroupItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemText", function() { return ListGroupItemText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemHeading", function() { return ListGroupItemHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledAlert", function() { return UncontrolledAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledButtonDropdown", function() { return UncontrolledButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledDropdown", function() { return UncontrolledDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledNavDropdown", function() { return UncontrolledNavDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledTooltip", function() { return UncontrolledTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Util", function() { return utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__("./node_modules/lodash.isfunction/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__("./node_modules/lodash.isobject/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__("./node_modules/react-popper/lib/react-popper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__("./node_modules/lodash.tonumber/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);









// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);

  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule = void 0;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

function getTarget(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && document) {
    var selection = document.querySelector(target);
    if (selection === null) {
      selection = document.querySelector('#' + target);
    }
    if (selection === null) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }

  return target;
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var utils = Object.freeze({
	getScrollbarWidth: getScrollbarWidth,
	setScrollbarWidth: setScrollbarWidth,
	isBodyOverflowing: isBodyOverflowing,
	getOriginalBodyPadding: getOriginalBodyPadding,
	conditionallyUpdateScrollbar: conditionallyUpdateScrollbar,
	setGlobalCssModule: setGlobalCssModule,
	mapToCssModules: mapToCssModules,
	omit: omit,
	pick: pick,
	warnOnce: warnOnce,
	deprecated: deprecated,
	DOMElement: DOMElement,
	getTarget: getTarget,
	TransitionTimeouts: TransitionTimeouts,
	TransitionPropTypeKeys: TransitionPropTypeKeys,
	TransitionStatuses: TransitionStatuses,
	keyCodes: keyCodes,
	PopperPlacements: PopperPlacements,
	canUseDOM: canUseDOM
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$8 = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
        inNavbar: this.props.inNavbar
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if ([keyCodes.esc, keyCodes.up, keyCodes.down, keyCodes.space].indexOf(e.which) === -1 || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');

      if (!items.length) return;

      var index = -1;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          active = _omit.active,
          addonType = _omit.addonType,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav', 'active', 'addonType']);

      var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, direction !== 'down' && 'drop' + direction, nav && active ? 'active' : false, (_classNames = {}, defineProperty(_classNames, 'input-group-' + addonType, addonType), defineProperty(_classNames, 'btn-group', group), defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group && !addonType), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Manager"], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$10 = {
  tag: 'ol'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'breadcrumb'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"];

    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? noFlipModifier : undefined;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      if (this.context.inNavbar) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: this.onClick,
          'aria-expanded': this.context.isOpen,
          children: children
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Target"], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm A fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `ENTERING`
   *  - `ENTERED`
   *  - `EXITING`
   *  - `EXITED`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state= { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEventListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['in', 'children', 'cssModule', 'slide', 'tag', 'className']);


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            { className: itemClasses },
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'left' : 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'right' : 'left' });
      }
      this.setState({ indicatorClicked: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          children = _props3.children,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var wrappedOnClick = function wrappedOnClick(e) {
        if (typeof indicators.props.onClickHandler === 'function') {
          _this3.setState({ indicatorClicked: true }, function () {
            return indicators.props.onClickHandler(e);
          });
        }
      };
      var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(indicators, { onClickHandler: wrappedOnClick });
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        wrappedIndicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.src, alt: item.altText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h5'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$33 = {
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          hideArrow = _props.hideArrow,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          modifiers = _props.modifiers,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'hideArrow', 'className', 'tag', 'container', 'modifiers']);

      var arrowClassName = mapToCssModules('arrow', cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var extendedModifiers = _extends({
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      }, modifiers);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"],
        _extends({ modifiers: extendedModifiers }, attrs, { component: tag, className: popperClassName }),
        children,
        !hideArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Arrow"], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$35;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$36 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  hideArrow: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle(e);
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$36));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$36;
Popover.defaultProps = defaultProps$34;

var propTypes$37 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$37;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$38;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$39 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$39;
Progress.defaultProps = defaultProps$37;

var propTypes$41 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var Portal = function (_React$Component) {
  inherits(Portal, _React$Component);

  function Portal() {
    classCallCheck(this, Portal);
    return possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = propTypes$41;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$40 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes
};

var propsToOmit = Object.keys(propTypes$40);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this._element = null;
    _this._originalBodyPadding = null;
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);

    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      }

      if (this.state.isOpen && this.props.autoFocus) {
        this.setFocus();
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen && !this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen && !this.state.isOpen) {
        this.init();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
        this.setFocus();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onExit) {
        this.props.onExit();
      }

      if (this.state.isOpen) {
        this.destroy();
      }

      this._isMounted = false;
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      // so all methods get called before it is unmounted
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
      this.destroy();

      if (this._isMounted) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
        this._dialog.parentNode.focus();
      }
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      e.stopPropagation();
      if (!this.props.isOpen || this.props.backdrop !== true) return;

      var container = this._dialog;

      if (e.target && !container.contains(e.target) && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      if (!this.bodyClassAdded) {
        document.body.className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
        this.bodyClassAdded = true;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        document.body.removeChild(this._element);
        this._element = null;
      }

      if (this.bodyClassAdded) {
        var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule);
        // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
        var modalOpenClassNameRegex = new RegExp('(^| )' + modalOpenClassName + '( |$)');
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
        this.bodyClassAdded = false;
      }

      setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _classNames,
          _this2 = this;

      var attributes = omit(this.props, propsToOmit);
      var dialogBaseClass = 'modal-dialog';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, {
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, defineProperty(_classNames, 'modal-' + this.props.size, this.props.size), defineProperty(_classNames, dialogBaseClass + '-centered', this.props.centered), _classNames)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this2._dialog = c;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isOpen) {
        var _props = this.props,
            wrapClassName = _props.wrapClassName,
            modalClassName = _props.modalClassName,
            backdropClassName = _props.backdropClassName,
            cssModule = _props.cssModule,
            isOpen = _props.isOpen,
            backdrop = _props.backdrop,
            role = _props.role,
            labelledBy = _props.labelledBy,
            external = _props.external;


        var modalAttributes = {
          onClick: this.handleBackdropClick,
          onKeyUp: this.handleEscape,
          style: { display: 'block' },
          'aria-labelledby': labelledBy,
          role: role,
          tabIndex: '-1'
        };

        var hasTransition = this.props.fade;
        var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        });
        var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Portal,
          { node: this._element },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: mapToCssModules(wrapClassName) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              _extends({}, modalAttributes, modalTransition, {
                'in': isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule)
              }),
              external,
              this.renderModalDialog()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
              'in': isOpen && !!backdrop,
              cssModule: cssModule,
              className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
            }))
          )
        );
      }

      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$40;
Modal.defaultProps = defaultProps$38;

var propTypes$42 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$39 = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$42;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$43;
ModalBody.defaultProps = defaultProps$40;

var propTypes$44 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$44;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$45 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  hideArrow: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip() {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show, this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip() {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$45));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          className: classes,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$45;
Tooltip.defaultProps = defaultProps$42;

var propTypes$46 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'striped', 'inverse', 'dark', 'hover', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : 'table-responsive-' + responsive;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: responsiveClassName },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$46;
Table.defaultProps = defaultProps$43;

var propTypes$47 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$47;
ListGroup.defaultProps = defaultProps$44;

var propTypes$48 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

Form.propTypes = propTypes$48;
Form.defaultProps = defaultProps$45;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$46 = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'valid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid ? 'valid-feedback' : 'invalid-feedback'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$49;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$50;
FormGroup.defaultProps = defaultProps$47;

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$51;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$52 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input() {
    classCallCheck(this, Input);
    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          invalid = _props.invalid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'invalid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag || 'p';
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
        if (state === 'danger') {
          invalid = true;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input' || typeof tag !== 'string') {
        attributes.type = type;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$52;
Input.defaultProps = defaultProps$49;

var propTypes$53 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$53;
InputGroup.defaultProps = defaultProps$50;

var propTypes$55 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupText.propTypes = propTypes$55;
InputGroupText.defaultProps = defaultProps$52;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'addonType', 'children']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-' + addonType), cssModule);

  // Convenience to assist with transition
  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupText, { children: children })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupAddon.propTypes = propTypes$54;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$56 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = objectWithoutProperties(props, ['children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = objectWithoutProperties(propsWithoutGroup, ['cssModule', 'tag', 'addonType']);


    var allGroupAttributes = _extends({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InputGroupAddon,
      _extends({}, allGroupAttributes, { className: groupClassName }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { children: children }))
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupAddon, _extends({}, props, { children: children }));
};

InputGroupButton.propTypes = propTypes$56;

var propTypes$57 = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = propTypes$57;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$58 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$58;
Label.defaultProps = defaultProps$53;

var propTypes$59 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$59;

var propTypes$60 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$54 = {
  tag: 'ul'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = propTypes$60;
Pagination.defaultProps = defaultProps$54;

var propTypes$61 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$61;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$62 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$62;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$63 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$63));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TabContent.propTypes = propTypes$63;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$64 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$64;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$65;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$66 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes)
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, transition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert' }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$66;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$67 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$67;
Collapse.defaultProps = defaultProps$61;

var propTypes$68 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item'), cssModule);

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$68;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$69 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$69;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$70 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$70;
ListGroupItemText.defaultProps = defaultProps$64;

var UncontrolledAlert = function (_Component) {
  inherits(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    classCallCheck(this, UncontrolledAlert);

    var _this = possibleConstructorReturn(this, (UncontrolledAlert.__proto__ || Object.getPrototypeOf(UncontrolledAlert)).call(this, props));

    _this.state = { isOpen: true };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledAlert, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledButtonDropdown = function (_Component) {
  inherits(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    classCallCheck(this, UncontrolledButtonDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledButtonDropdown.__proto__ || Object.getPrototypeOf(UncontrolledButtonDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledButtonDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledDropdown = function (_Component) {
  inherits(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    classCallCheck(this, UncontrolledDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledDropdown.__proto__ || Object.getPrototypeOf(UncontrolledDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UncontrolledDropdown, _extends({ nav: true }, props));
};

var UncontrolledTooltip = function (_Component) {
  inherits(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    classCallCheck(this, UncontrolledTooltip);

    var _this = possibleConstructorReturn(this, (UncontrolledTooltip.__proto__ || Object.getPrototypeOf(UncontrolledTooltip)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledTooltip, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),

/***/ "./node_modules/redux-promise/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = promiseMiddleware;

var _fluxStandardAction = __webpack_require__("./node_modules/flux-standard-action/lib/index.js");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function promiseMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      if (!_fluxStandardAction.isFSA(action)) {
        return isPromise(action) ? action.then(dispatch) : next(action);
      }

      return isPromise(action.payload) ? action.payload.then(function (result) {
        return dispatch(_extends({}, action, { payload: result }));
      }, function (error) {
        return dispatch(_extends({}, action, { payload: error, error: true }));
      }) : next(action);
    };
  };
}

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/redux/es/applyMiddleware.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__("./node_modules/redux/es/compose.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),

/***/ "./node_modules/redux/es/bindActionCreators.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),

/***/ "./node_modules/redux/es/combineReducers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__("./node_modules/redux/es/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__("./node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__("./node_modules/redux/es/utils/warning.js");




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),

/***/ "./node_modules/redux/es/compose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),

/***/ "./node_modules/redux/es/createStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__("./node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__("./node_modules/symbol-observable/es/index.js");



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),

/***/ "./node_modules/redux/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__("./node_modules/redux/es/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__("./node_modules/redux/es/combineReducers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__("./node_modules/redux/es/bindActionCreators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__("./node_modules/redux/es/applyMiddleware.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__("./node_modules/redux/es/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__("./node_modules/redux/es/utils/warning.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "./node_modules/redux/es/utils/warning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/resolve-pathname/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),

/***/ "./node_modules/scheduler/cjs/scheduler.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),

/***/ "./node_modules/scheduler/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("./node_modules/scheduler/cjs/scheduler.production.min.js");
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),

/***/ "./node_modules/seedrandom/index.js":
/***/ (function(module, exports, __webpack_require__) {

// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.

// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.
var alea = __webpack_require__("./node_modules/seedrandom/lib/alea.js");

// xor128, a pure xor-shift generator by George Marsaglia.
// Period: 2^128-1.
// Reported to fail: MatrixRank and LinearComp.
var xor128 = __webpack_require__("./node_modules/seedrandom/lib/xor128.js");

// xorwow, George Marsaglia's 160-bit xor-shift combined plus weyl.
// Period: 2^192-2^32
// Reported to fail: CollisionOver, SimpPoker, and LinearComp.
var xorwow = __webpack_require__("./node_modules/seedrandom/lib/xorwow.js");

// xorshift7, by François Panneton and Pierre L'ecuyer, takes
// a different approach: it adds robustness by allowing more shifts
// than Marsaglia's original three.  It is a 7-shift generator
// with 256 bits, that passes BigCrush with no systmatic failures.
// Period 2^256-1.
// No systematic BigCrush failures reported.
var xorshift7 = __webpack_require__("./node_modules/seedrandom/lib/xorshift7.js");

// xor4096, by Richard Brent, is a 4096-bit xor-shift with a
// very long period that also adds a Weyl generator. It also passes
// BigCrush with no systematic failures.  Its long period may
// be useful if you have many generators and need to avoid
// collisions.
// Period: 2^4128-2^32.
// No systematic BigCrush failures reported.
var xor4096 = __webpack_require__("./node_modules/seedrandom/lib/xor4096.js");

// Tyche-i, by Samuel Neves and Filipe Araujo, is a bit-shifting random
// number generator derived from ChaCha, a modern stream cipher.
// https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
// Period: ~2^127
// No systematic BigCrush failures reported.
var tychei = __webpack_require__("./node_modules/seedrandom/lib/tychei.js");

// The original ARC4-based prng included in this library.
// Period: ~2^1600
var sr = __webpack_require__("./node_modules/seedrandom/seedrandom.js");

sr.alea = alea;
sr.xor128 = xor128;
sr.xorwow = xorwow;
sr.xorshift7 = xorshift7;
sr.xor4096 = xor4096;
sr.tychei = tychei;

module.exports = sr;


/***/ }),

/***/ "./node_modules/seedrandom/lib/alea.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -

// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// 
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



(function(global, module, define) {

function Alea(seed) {
  var me = this, mash = Mash();

  me.next = function() {
    var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
    me.s0 = me.s1;
    me.s1 = me.s2;
    return me.s2 = t - (me.c = t | 0);
  };

  // Apply the seeding algorithm from Baagoe.
  me.c = 1;
  me.s0 = mash(' ');
  me.s1 = mash(' ');
  me.s2 = mash(' ');
  me.s0 -= mash(seed);
  if (me.s0 < 0) { me.s0 += 1; }
  me.s1 -= mash(seed);
  if (me.s1 < 0) { me.s1 += 1; }
  me.s2 -= mash(seed);
  if (me.s2 < 0) { me.s2 += 1; }
  mash = null;
}

function copy(f, t) {
  t.c = f.c;
  t.s0 = f.s0;
  t.s1 = f.s1;
  t.s2 = f.s2;
  return t;
}

function impl(seed, opts) {
  var xg = new Alea(seed),
      state = opts && opts.state,
      prng = xg.next;
  prng.int32 = function() { return (xg.next() * 0x100000000) | 0; }
  prng.double = function() {
    return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
  };
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

function Mash() {
  var n = 0xefc8249d;

  var mash = function(data) {
    data = data.toString();
    for (var i = 0; i < data.length; i++) {
      n += data.charCodeAt(i);
      var h = 0.02519603282416938 * n;
      n = h >>> 0;
      h -= n;
      h *= n;
      n = h >>> 0;
      h -= n;
      n += h * 0x100000000; // 2^32
    }
    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
  };

  return mash;
}


if (module && module.exports) {
  module.exports = impl;
} else if (__webpack_require__("./node_modules/webpack/buildin/amd-define.js") && __webpack_require__("./node_modules/webpack/buildin/amd-options.js")) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return impl; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  this.alea = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  __webpack_require__("./node_modules/webpack/buildin/amd-define.js")   // present with an AMD loader
);



/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/seedrandom/lib/tychei.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var b = me.b, c = me.c, d = me.d, a = me.a;
    b = (b << 25) ^ (b >>> 7) ^ c;
    c = (c - d) | 0;
    d = (d << 24) ^ (d >>> 8) ^ a;
    a = (a - b) | 0;
    me.b = b = (b << 20) ^ (b >>> 12) ^ c;
    me.c = c = (c - d) | 0;
    me.d = (d << 16) ^ (c >>> 16) ^ a;
    return me.a = (a - b) | 0;
  };

  /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */

  me.a = 0;
  me.b = 0;
  me.c = 2654435769 | 0;
  me.d = 1367130551;

  if (seed === Math.floor(seed)) {
    // Integer seed.
    me.a = (seed / 0x100000000) | 0;
    me.b = seed | 0;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 20; k++) {
    me.b ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.a = f.a;
  t.b = f.b;
  t.c = f.c;
  t.d = f.d;
  return t;
};

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (__webpack_require__("./node_modules/webpack/buildin/amd-define.js") && __webpack_require__("./node_modules/webpack/buildin/amd-options.js")) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return impl; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  this.tychei = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  __webpack_require__("./node_modules/webpack/buildin/amd-define.js")   // present with an AMD loader
);



/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/seedrandom/lib/xor128.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;

  // Set up generator function.
  me.next = function() {
    var t = me.x ^ (me.x << 11);
    me.x = me.y;
    me.y = me.z;
    me.z = me.w;
    return me.w ^= (me.w >>> 19) ^ t ^ (t >>> 8);
  };

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (__webpack_require__("./node_modules/webpack/buildin/amd-define.js") && __webpack_require__("./node_modules/webpack/buildin/amd-options.js")) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return impl; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  this.xor128 = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  __webpack_require__("./node_modules/webpack/buildin/amd-define.js")   // present with an AMD loader
);



/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/seedrandom/lib/xor4096.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    var w = me.w,
        X = me.X, i = me.i, t, v;
    // Update Weyl generator.
    me.w = w = (w + 0x61c88647) | 0;
    // Update xor generator.
    v = X[(i + 34) & 127];
    t = X[i = ((i + 1) & 127)];
    v ^= v << 13;
    t ^= t << 17;
    v ^= v >>> 15;
    t ^= t >>> 12;
    // Update Xor generator array state.
    v = X[i] = v ^ t;
    me.i = i;
    // Result is the combination.
    return (v + (w ^ (w >>> 16))) | 0;
  };

  function init(me, seed) {
    var t, v, i, j, w, X = [], limit = 128;
    if (seed === (seed | 0)) {
      // Numeric seeds initialize v, which is used to generates X.
      v = seed;
      seed = null;
    } else {
      // String seeds are mixed into v and X one character at a time.
      seed = seed + '\0';
      v = 0;
      limit = Math.max(limit, seed.length);
    }
    // Initialize circular array and weyl value.
    for (i = 0, j = -32; j < limit; ++j) {
      // Put the unicode characters into the array, and shuffle them.
      if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
      // After 32 shuffles, take v as the starting w value.
      if (j === 0) w = v;
      v ^= v << 10;
      v ^= v >>> 15;
      v ^= v << 4;
      v ^= v >>> 13;
      if (j >= 0) {
        w = (w + 0x61c88647) | 0;     // Weyl.
        t = (X[j & 127] ^= (v + w));  // Combine xor and weyl to init array.
        i = (0 == t) ? i + 1 : 0;     // Count zeroes.
      }
    }
    // We have detected all zeroes; make the key nonzero.
    if (i >= 128) {
      X[(seed && seed.length || 0) & 127] = -1;
    }
    // Run the generator 512 times to further mix the state before using it.
    // Factoring this as a function slows the main generator, so it is just
    // unrolled here.  The weyl generator is not advanced while warming up.
    i = 127;
    for (j = 4 * 128; j > 0; --j) {
      v = X[(i + 34) & 127];
      t = X[i = ((i + 1) & 127)];
      v ^= v << 13;
      t ^= t << 17;
      v ^= v >>> 15;
      t ^= t >>> 12;
      X[i] = v ^ t;
    }
    // Storing state as object members is faster than using closure variables.
    me.w = w;
    me.X = X;
    me.i = i;
  }

  init(me, seed);
}

function copy(f, t) {
  t.i = f.i;
  t.w = f.w;
  t.X = f.X.slice();
  return t;
};

function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.X) copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (__webpack_require__("./node_modules/webpack/buildin/amd-define.js") && __webpack_require__("./node_modules/webpack/buildin/amd-options.js")) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return impl; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  this.xor4096 = impl;
}

})(
  this,                                     // window object or global
  (typeof module) == 'object' && module,    // present in node.js
  __webpack_require__("./node_modules/webpack/buildin/amd-define.js")   // present with an AMD loader
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/seedrandom/lib/xorshift7.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    // Update xor generator.
    var X = me.x, i = me.i, t, v, w;
    t = X[i]; t ^= (t >>> 7); v = t ^ (t << 24);
    t = X[(i + 1) & 7]; v ^= t ^ (t >>> 10);
    t = X[(i + 3) & 7]; v ^= t ^ (t >>> 3);
    t = X[(i + 4) & 7]; v ^= t ^ (t << 7);
    t = X[(i + 7) & 7]; t = t ^ (t << 13); v ^= t ^ (t << 9);
    X[i] = v;
    me.i = (i + 1) & 7;
    return v;
  };

  function init(me, seed) {
    var j, w, X = [];

    if (seed === (seed | 0)) {
      // Seed state array using a 32-bit integer.
      w = X[0] = seed;
    } else {
      // Seed state using a string.
      seed = '' + seed;
      for (j = 0; j < seed.length; ++j) {
        X[j & 7] = (X[j & 7] << 15) ^
            (seed.charCodeAt(j) + X[(j + 1) & 7] << 13);
      }
    }
    // Enforce an array length of 8, not all zeroes.
    while (X.length < 8) X.push(0);
    for (j = 0; j < 8 && X[j] === 0; ++j);
    if (j == 8) w = X[7] = -1; else w = X[j];

    me.x = X;
    me.i = 0;

    // Discard an initial 256 values.
    for (j = 256; j > 0; --j) {
      me.next();
    }
  }

  init(me, seed);
}

function copy(f, t) {
  t.x = f.x.slice();
  t.i = f.i;
  return t;
}

function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.x) copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (__webpack_require__("./node_modules/webpack/buildin/amd-define.js") && __webpack_require__("./node_modules/webpack/buildin/amd-options.js")) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return impl; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  this.xorshift7 = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  __webpack_require__("./node_modules/webpack/buildin/amd-define.js")   // present with an AMD loader
);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/seedrandom/lib/xorwow.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var t = (me.x ^ (me.x >>> 2));
    me.x = me.y; me.y = me.z; me.z = me.w; me.w = me.v;
    return (me.d = (me.d + 362437 | 0)) +
       (me.v = (me.v ^ (me.v << 4)) ^ (t ^ (t << 1))) | 0;
  };

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;
  me.v = 0;

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    if (k == strseed.length) {
      me.d = me.x << 10 ^ me.x >>> 4;
    }
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  t.v = f.v;
  t.d = f.d;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (__webpack_require__("./node_modules/webpack/buildin/amd-define.js") && __webpack_require__("./node_modules/webpack/buildin/amd-options.js")) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return impl; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  this.xorwow = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  __webpack_require__("./node_modules/webpack/buildin/amd-define.js")   // present with an AMD loader
);



/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/seedrandom/seedrandom.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
Copyright 2014 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//

// Detect the global object, even if operating in strict mode.
// http://stackoverflow.com/a/14387057/265298
var global = (0, eval)('this'),
    width = 256,        // each RC4 output is 0 <= x < 256
    chunks = 6,         // at least six RC4 outputs for each double
    digits = 52,        // there are 52 significant digits in a double
    rngname = 'random', // rngname: name for Math.random and Math.seedrandom
    startdenom = math.pow(width, chunks),
    significance = math.pow(2, digits),
    overflow = significance * 2,
    mask = width - 1,
    nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
function seedrandom(seed, options, callback) {
  var key = [];
  options = (options == true) ? { entropy: true } : (options || {});

  // Flatten the seed string or build one from local entropy if needed.
  var shortseed = mixkey(flatten(
    options.entropy ? [seed, tostring(pool)] :
    (seed == null) ? autoseed() : seed, 3), key);

  // Use the seed to initialize an ARC4 generator.
  var arc4 = new ARC4(key);

  // This function returns a random double in [0, 1) that contains
  // randomness in every bit of the mantissa of the IEEE 754 value.
  var prng = function() {
    var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
        d = startdenom,                 //   and denominator d = 2 ^ 48.
        x = 0;                          //   and no 'extra last byte'.
    while (n < significance) {          // Fill up all significant digits by
      n = (n + x) * width;              //   shifting numerator and
      d *= width;                       //   denominator and generating a
      x = arc4.g(1);                    //   new least-significant-byte.
    }
    while (n >= overflow) {             // To avoid rounding up, before adding
      n /= 2;                           //   last byte, shift everything
      d /= 2;                           //   right using integer math until
      x >>>= 1;                         //   we have exactly the desired bits.
    }
    return (n + x) / d;                 // Form the number within [0, 1).
  };

  prng.int32 = function() { return arc4.g(4) | 0; }
  prng.quick = function() { return arc4.g(4) / 0x100000000; }
  prng.double = prng;

  // Mix the randomness into accumulated entropy.
  mixkey(tostring(arc4.S), pool);

  // Calling convention: what to return as a function of prng, seed, is_math.
  return (options.pass || callback ||
      function(prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) { copy(state, arc4); }
          // Only provide the .state method if requested via options.state.
          prng.state = function() { return copy(arc4, {}); }
        }

        // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.
        if (is_math_call) { math[rngname] = prng; return seed; }

        // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(
  prng,
  shortseed,
  'global' in options ? options.global : (this == math),
  options.state);
}
math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
function ARC4(key) {
  var t, keylen = key.length,
      me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

  // The empty key [] is treated as [0].
  if (!keylen) { key = [keylen++]; }

  // Set up S using the standard key scheduling algorithm.
  while (i < width) {
    s[i] = i++;
  }
  for (i = 0; i < width; i++) {
    s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
    s[j] = t;
  }

  // The "g" method returns the next (count) outputs as one number.
  (me.g = function(count) {
    // Using instance members instead of closure state nearly doubles speed.
    var t, r = 0,
        i = me.i, j = me.j, s = me.S;
    while (count--) {
      t = s[i = mask & (i + 1)];
      r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
    }
    me.i = i; me.j = j;
    return r;
    // For robust unpredictability, the function call below automatically
    // discards an initial batch of values.  This is called RC4-drop[256].
    // See http://google.com/search?q=rsa+fluhrer+response&btnI
  })(width);
}

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
function copy(f, t) {
  t.i = f.i;
  t.j = f.j;
  t.S = f.S.slice();
  return t;
};

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function flatten(obj, depth) {
  var result = [], typ = (typeof obj), prop;
  if (depth && typ == 'object') {
    for (prop in obj) {
      try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
    }
  }
  return (result.length ? result : typ == 'string' ? obj : obj + '\0');
}

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function mixkey(seed, key) {
  var stringseed = seed + '', smear, j = 0;
  while (j < stringseed.length) {
    key[mask & j] =
      mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
  }
  return tostring(key);
}

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
function autoseed() {
  try {
    var out;
    if (nodecrypto && (out = nodecrypto.randomBytes)) {
      // The use of 'out' to remember randomBytes makes tight minified code.
      out = out(width);
    } else {
      out = new Uint8Array(width);
      (global.crypto || global.msCrypto).getRandomValues(out);
    }
    return tostring(out);
  } catch (e) {
    var browser = global.navigator,
        plugins = browser && browser.plugins;
    return [+new Date, global, plugins, global.screen, tostring(pool)];
  }
}

//
// tostring()
// Converts an array of charcodes to a string
//
function tostring(a) {
  return String.fromCharCode.apply(0, a);
}

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//
if ((typeof module) == 'object' && module.exports) {
  module.exports = seedrandom;
  // When in node.js, try using crypto package for autoseeding.
  try {
    nodecrypto = __webpack_require__(5);
  } catch (ex) {}
} else if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return seedrandom; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

// End anonymous scope, and pass initial values.
})(
  [],     // pool: entropy pool starts empty
  Math    // math: package containing random, pow, and seedrandom
);


/***/ }),

/***/ "./node_modules/shuffle-seed/index.js":
/***/ (function(module, exports, __webpack_require__) {

var seedrandom = __webpack_require__("./node_modules/seedrandom/index.js");
var self = __webpack_require__("./node_modules/shuffle-seed/shuffle-seed.js");

module.exports = self;



/***/ }),

/***/ "./node_modules/shuffle-seed/shuffle-seed.js":
/***/ (function(module, exports, __webpack_require__) {

;(function() {
	var self = {};

	if(Math.seedrandom) seedrandom = Math.seedrandom;

	var isArray = function($){
		return Object.prototype.toString.call( $ ) === '[object Array]'
	}

	var extend = function(obj) {
		for (var i = 1; i < arguments.length; i++) for (var key in arguments[i]) obj[key] = arguments[i][key];
		return obj;
	}

	var seedify = function(seed){
		if (/(number|string)/i.test(Object.prototype.toString.call(seed).match(/^\[object (.*)\]$/)[1])) return seed;
		if (isNaN(seed)) return Number(String((this.strSeed = seed)).split('').map(function(x){return x.charCodeAt(0)}).join(''));
		return seed;
	}

	var seedRand = function(func,min,max){
		return Math.floor(func() * (max - min + 1)) + min;
	}

	self.shuffle = function(arr,seed){
		if (!isArray(arr)) return null;
		seed = seedify(seed) || 'none';

		var size = arr.length;
		var rng = seedrandom(seed);
		var resp = [];
		var keys = [];

		for(var i=0;i<size;i++) keys.push(i);
		for(var i=0;i<size;i++){
			var r = seedRand(rng,0,keys.length-1);
			var g = keys[r];
			keys.splice(r,1);
			resp.push(arr[g]);
		}
		return resp;
	}

	self.unshuffle = function(arr,seed){
		if (!isArray(arr)) return null;
		seed = seedify(seed) || 'none';

		var size = arr.length;
		var rng = seedrandom(seed);
		var resp = [];
		var map = [];
		var keys = [];

		for(var i=0;i<size;i++) {
			resp.push(null);
			keys.push(i);
		}

		for(var i=0;i<size;i++){
			var r = seedRand(rng,0,keys.length-1);
			var g = keys[r];
			keys.splice(r,1);
			resp[g]=arr[i];
		}

		return resp;
	}

	if(true){
		module.exports=self;
	} else {
		this['shuffleSeed']=self;
	}
}.call(this));


/***/ }),

/***/ "./node_modules/side-channel-list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__("./node_modules/object-inspect/index.js");

var $TypeError = __webpack_require__("./node_modules/es-errors/type.js");

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var deletedNode = listDelete($o, key);
			if (deletedNode && $o && !$o.next) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	return channel;
};


/***/ }),

/***/ "./node_modules/side-channel-map/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("./node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__("./node_modules/call-bound/index.js");
var inspect = __webpack_require__("./node_modules/object-inspect/index.js");

var $TypeError = __webpack_require__("./node_modules/es-errors/type.js");
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ "./node_modules/side-channel-weakmap/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("./node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__("./node_modules/call-bound/index.js");
var inspect = __webpack_require__("./node_modules/object-inspect/index.js");
var getSideChannelMap = __webpack_require__("./node_modules/side-channel-map/index.js");

var $TypeError = __webpack_require__("./node_modules/es-errors/type.js");
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ "./node_modules/side-channel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__("./node_modules/es-errors/type.js");
var inspect = __webpack_require__("./node_modules/object-inspect/index.js");
var getSideChannelList = __webpack_require__("./node_modules/side-channel-list/index.js");
var getSideChannelMap = __webpack_require__("./node_modules/side-channel-map/index.js");
var getSideChannelWeakMap = __webpack_require__("./node_modules/side-channel-weakmap/index.js");

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				var keyDesc = key && Object(key) === key
					? 'the given object key'
					: inspect(key);
				throw new $TypeError('Side channel does not contain ' + keyDesc);
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};

	return channel;
};


/***/ }),

/***/ "./node_modules/simple-line-icons/css/simple-line-icons.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/sort-keys/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPlainObj = __webpack_require__("./node_modules/is-plain-obj/index.js");

module.exports = function (obj, opts) {
	if (!isPlainObj(obj)) {
		throw new TypeError('Expected a plain object');
	}

	opts = opts || {};

	// DEPRECATED
	if (typeof opts === 'function') {
		opts = {compare: opts};
	}

	var deep = opts.deep;
	var seenInput = [];
	var seenOutput = [];

	var sortKeys = function (x) {
		var seenIndex = seenInput.indexOf(x);

		if (seenIndex !== -1) {
			return seenOutput[seenIndex];
		}

		var ret = {};
		var keys = Object.keys(x).sort(opts.compare);

		seenInput.push(x);
		seenOutput.push(ret);

		for (var i = 0; i < keys.length; i++) {
			var key = keys[i];
			var val = x[key];

			ret[key] = deep && isPlainObj(val) ? sortKeys(val) : val;
		}

		return ret;
	};

	return sortKeys(obj);
};


/***/ }),

/***/ "./node_modules/strict-uri-encode/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ "./node_modules/swiper/dist/css/swiper.min.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/swiper/dist/js/swiper.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: (function checkTransition() {
        var style = testDiv.style;
        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
      }()),
      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
        var style = testDiv.style;
        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
      }()),

      flexbox: (function checkFlexbox() {
        var style = testDiv.style;
        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) { return true; }
        }
        return false;
      }()),

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      handler.apply(self, args);
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (
          (params.slidesPerColumnFill === 'column')
          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
        ) {
          if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - (column * slidesPerColumn);
            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            var groupIndex = Math.floor(i / params.slidesPerGroup);
            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
          }
          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide
          .css(
            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
          )
          .attr('data-swiper-column', column)
          .attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();


    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap,
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView
        && (ipod || iphone)
        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== e.target
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) { return; }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push(("wp8-" + (params.direction)));
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index')
            .removeAttr('data-swiper-column')
            .removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: (function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }()),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) { return true; }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        }
        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + (delta * params.sensitivity);
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now(),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            $firstDisplayedBullet
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev"))
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev-prev"));
            $lastDisplayedBullet
              .next()
              .addClass(((params.bulletActiveClass) + "-next"))
              .next()
              .addClass(((params.bulletActiveClass) + "-next-next"));
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        } else {
          $dragEl.transform(("translateX(" + newPos + "px)"));
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        } else {
          $dragEl.transform(("translateY(" + newPos + "px)"));
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));


/***/ }),

/***/ "./node_modules/symbol-observable/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__("./node_modules/symbol-observable/es/ponyfill.js");
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./node_modules/symbol-observable/es/ponyfill.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),

/***/ "./node_modules/tabbable/index.js":
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (
    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (
    node.disabled
    || isHiddenInput(node)
    || untouchabilityChecker.isUntouchable(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function(item) {
      return item === node;
    });
    if (cached) return cached[1];

    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }

    this.cache.push([node, result]);

    return result;
}

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),

/***/ "./node_modules/ua-parser-js/dist/ua-parser.min.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v0.7.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="0.7.41",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HONOR="Honor",HUAWEI="Huawei",LENOVO="Lenovo",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",NVIDIA="Nvidia",ONEPLUS="OnePlus",OPERA="Opera",OPPO="OPPO",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/(daum)apps[\/ ]([\w\.]+)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/\b(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i,/\b((i[346]|x)86)(pc)?\b/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],[[ARCHITECTURE,"arm"]],[/((ppc|powerpc)(64)?)( mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/ sun4\w[;\)]/i],[[ARCHITECTURE,"sparc"]],[/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],[MODEL,[VENDOR,HONOR],[TYPE,TABLET]],[/honor([-\w ]+)[;\)]/i],[MODEL,[VENDOR,HONOR],[TYPE,MOBILE]],[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,/\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,/ ([\w ]+) miui\/v?\d/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,OPPO],[TYPE,MOBILE]],[/\b(opd2(\d{3}a?))(?: bui|\))/i],[MODEL,[VENDOR,strMapper,{OnePlus:["304","403","203"],"*":OPPO}],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,/lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],[MODEL,[VENDOR,LENOVO],[TYPE,TABLET]],[/(nokia) (t[12][01])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,/nokia[-_ ]?(([-\w\. ]*))/i],[[MODEL,/_/g," "],[TYPE,MOBILE],[VENDOR,"Nokia"]],[/(pixel (c|tablet))\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,/archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,TABLET]],[/archos ([\w ]+)( b|\))/i,/; (ac[3-6]\d\w{2,8})( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(infinix) (x1101b?)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (hmd|imo) ([\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/(shield \w+ tv)/i],[MODEL,[VENDOR,NVIDIA],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mi(tv|box)-?\w+) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],[MODEL,[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield)( bui|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,CONSOLE]],[/(playstation \w+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i,/(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(ow(?:19|20)?we?[1-3]{1,3})/i],[MODEL,[VENDOR,OPPO],[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/(opwwe\d{3})/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,WEARABLE]],[/(moto 360)/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,WEARABLE]],[/(smartwatch 3)/i],[MODEL,[VENDOR,SONY],[TYPE,WEARABLE]],[/(g watch r)/i],[MODEL,[VENDOR,LG],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/(homepod).+mac os/i],[MODEL,[VENDOR,APPLE],[TYPE,EMBEDDED]],[/windows iot/i],[[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/droid .+?; ([\w\. -]+)( bui|\))/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/ladybird\//i],[[NAME,"LibWeb"]],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(ubuntu) ([\w\.]+) like android/i],[[NAME,/(.+)/,"$1 Touch"],VERSION],[/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__("./node_modules/webpack/buildin/amd-options.js")){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ "./node_modules/universal-cookie/es6/Cookies.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__("./node_modules/universal-cookie/node_modules/cookie/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("./node_modules/universal-cookie/es6/utils.js");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* parseCookies */])(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* hasDocumentCookie */])();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cookies);


/***/ }),

/***/ "./node_modules/universal-cookie/es6/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cookies__ = __webpack_require__("./node_modules/universal-cookie/es6/Cookies.js");

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Cookies__["a" /* default */]);


/***/ }),

/***/ "./node_modules/universal-cookie/es6/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasDocumentCookie;
/* unused harmony export cleanCookies */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseCookies;
/* unused harmony export isParsingCookie */
/* harmony export (immutable) */ __webpack_exports__["c"] = readCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__("./node_modules/universal-cookie/node_modules/cookie/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}


/***/ }),

/***/ "./node_modules/universal-cookie/node_modules/cookie/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ "./node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__("./node_modules/node-libs-browser/node_modules/punycode/punycode.js");

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__("./node_modules/qs/lib/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;


/***/ }),

/***/ "./node_modules/uuid/lib/bytesToUuid.js":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ "./node_modules/uuid/lib/rng-browser.js":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ "./node_modules/uuid/v1.js":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("./node_modules/uuid/lib/rng-browser.js");
var bytesToUuid = __webpack_require__("./node_modules/uuid/lib/bytesToUuid.js");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ "./node_modules/value-equal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),

/***/ "./node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "./node_modules/webpack/buildin/amd-define.js":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "./node_modules/webpack/buildin/amd-options.js":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/harmony-module.js":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./node_modules/xtend/immutable.js":
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ "./scss/core/_dropdown-menu-right.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1793259545715
      var cssReload = __webpack_require__("./node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./scss/style.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1793259547946
      var cssReload = __webpack_require__("./node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ "./src/PrivateRoute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PrivateRoute = function PrivateRoute(_ref) {
    var Component = _ref.component,
        rest = _objectWithoutProperties(_ref, ['component']);

    var isLoggedIn = false;

    if (sessionStorage.getItem('authorized')) {
        var loginData = JSON.parse(sessionStorage.getItem('authorized'));
        if (loginData.success) {
            isLoggedIn = true;
        }
    }
    return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
        render: function render(props) {
            return isLoggedIn === true ? _react2.default.createElement(Component, props) : _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/login' } });
        }
    }));
};
exports.default = PrivateRoute;

/***/ }),

/***/ "./src/actions/AccountActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setProfilePic = exports.getInterests = exports.setDetails = exports.getDetails = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getDetails = exports.getDetails = function getDetails(data) {
    return {
        type: action_types.GET_DETAILS,
        data: {
            user: data
        }
    };
};

var setDetails = exports.setDetails = function setDetails(data) {
    return {
        type: action_types.SET_DETAILS,
        data: {
            user: data
        }
    };
};

var getInterests = exports.getInterests = function getInterests(data) {
    return {
        type: action_types.GET_INTERESTS,
        data: {
            interests: data
        }
    };
};

var setProfilePic = exports.setProfilePic = function setProfilePic(profilePic) {
    return {
        type: action_types.SET_PROFILE_PIC,
        data: {
            profilePic: profilePic
        }
    };
};

/***/ }),

/***/ "./src/actions/ActivityIndicatorActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hide = exports.show = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var show = exports.show = function show() {
    return {
        type: action_types.IS_LOADING,
        data: {
            isLoading: true
        }
    };
};

var hide = exports.hide = function hide() {
    return {
        type: action_types.IS_LOADING,
        data: {
            isLoading: false
        }
    };
};

/***/ }),

/***/ "./src/actions/AuthenticationActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logout = exports.authenticate = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var authenticate = exports.authenticate = function authenticate(data) {
    return {
        type: action_types.LOGIN,
        data: data
    };
};

var logout = exports.logout = function logout(data) {
    return {
        type: action_types.LOGOUT,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/CategoryActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryDetail = exports.getCategories = exports.getGameTypes = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getGameTypes = exports.getGameTypes = function getGameTypes(data) {
    return {
        type: action_types.GET_GAME_TYPES,
        data: data
    };
};

var getCategories = exports.getCategories = function getCategories(data) {
    return {
        type: action_types.GET_CATEGORIES,
        data: data
    };
};

var getCategoryDetail = exports.getCategoryDetail = function getCategoryDetail(data) {
    return {
        type: action_types.GET_CATEGORY_DETAIL,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/CountryActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openCountryDetail = exports.getCountryDomainAndSubDomain = exports.getLanguages = exports.getCountries = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getCountries = exports.getCountries = function getCountries(data) {
    return {
        type: action_types.GET_COUNTRIES,
        data: data
    };
};

var getLanguages = exports.getLanguages = function getLanguages(data) {
    return {
        type: action_types.GET_LANGUAGES,
        data: data
    };
};

var getCountryDomainAndSubDomain = exports.getCountryDomainAndSubDomain = function getCountryDomainAndSubDomain(data) {
    return {
        type: action_types.GET_COUNTRIES_LANGUAGES_SUBDOMAIN,
        data: data
    };
};

var openCountryDetail = exports.openCountryDetail = function openCountryDetail(data) {
    return {
        type: action_types.OPEN_COUNTRY_DETAILS,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/DomainActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDomains = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getDomains = exports.getDomains = function getDomains(data) {
    return {
        type: action_types.GET_DOMAIN,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/FlashMessageActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideMessage = exports.showMessage = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var showMessage = exports.showMessage = function showMessage(data) {
    return {
        type: action_types.SHOW_MESSAGE,
        data: {
            isShowing: true,
            message: data.message,
            type: data.type
        }
    };
};

var hideMessage = exports.hideMessage = function hideMessage() {
    return {
        type: action_types.HIDE_MESSAGE,
        data: {
            isShowing: false
        }
    };
};

/***/ }),

/***/ "./src/actions/GamesActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategorygame = exports.setFavouriteGames = exports.getFavouriteGames = exports.getSearchGames = exports.getSimilarGames = exports.getGameDetail = exports.getGames = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getGames = exports.getGames = function getGames(data) {
    return {
        type: action_types.GET_GAMES,
        data: data
    };
};

var getGameDetail = exports.getGameDetail = function getGameDetail(data) {
    return {
        type: action_types.GET_GAME_DETAIL,
        data: data
    };
};

var getSimilarGames = exports.getSimilarGames = function getSimilarGames(data) {
    return {
        type: action_types.GET_SIMILAR_GAMES,
        data: data
    };
};

var getSearchGames = exports.getSearchGames = function getSearchGames(data) {
    return {
        type: action_types.GET_SEARCHED_GAMES,
        data: data
    };
};

var getFavouriteGames = exports.getFavouriteGames = function getFavouriteGames(data) {
    return {
        type: action_types.GET_FAVOURITE_GAMES,
        data: data
    };
};

var setFavouriteGames = exports.setFavouriteGames = function setFavouriteGames(data) {
    return {
        type: action_types.SET_FAVOURITE_GAME,
        data: data
    };
};

var getCategorygame = exports.getCategorygame = function getCategorygame(data) {
    return {
        type: action_types.CATEGORY_GAMES,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/HeaderActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showbar = exports.setHeaderTitle = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setHeaderTitle = exports.setHeaderTitle = function setHeaderTitle(title) {
    return {
        type: action_types.SET_HEADER_TITLE,
        data: {
            title: title
        }
    };
};

// export const showSearchBar = (bool) => {
//     return {
//         type: action_types.SHOW_SEARCH,
//         data: bool
//     }
// };

var showbar = exports.showbar = function showbar(bool) {
    return {
        type: action_types.SHOW_SEARCH,
        data: bool
    };
};

// export const onBackAction = () => {
//     return {
//         type: action_types.ON_BACK_CLICK,
//         data: true
//     }
// };
//
// export const resetBack = () => {
//     return {
//         type: action_types.RESET_BACK_CLICK,
//         data: false
//     }
// };

/***/ }),

/***/ "./src/actions/SearchActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchText = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var searchText = exports.searchText = function searchText(_searchText) {
    return {
        type: action_types.SEARCH_TEXT,
        data: {
            text: _searchText
        }
    };
};

/***/ }),

/***/ "./src/actions/SplashScreenActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showSplash = exports.hideSplash = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hideSplash = exports.hideSplash = function hideSplash() {
    return {
        type: action_types.HIDE_SPLASH,
        data: {
            hideSplash: true
        }
    };
};

var showSplash = exports.showSplash = function showSplash() {
    return {
        type: action_types.SHOW_SPLASH,
        data: {
            hideSplash: false
        }
    };
};

/***/ }),

/***/ "./src/actions/UsersActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUsers = exports.getRoles = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getRoles = exports.getRoles = function getRoles(data) {
    return {
        type: action_types.GET_ROLES,
        data: data
    };
};

var getUsers = exports.getUsers = function getUsers(data) {
    return {
        type: action_types.GET_USERS,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/WelcomeActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeLangAction = exports.addUid = exports.checkAccess = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var checkAccess = exports.checkAccess = function checkAccess(data) {
    return {
        type: action_types.HAS_ACCESS,
        data: data
    };
};

var addUid = exports.addUid = function addUid(data) {
    return {
        type: action_types.ADD_UID,
        data: data
    };
};

var changeLangAction = exports.changeLangAction = function changeLangAction(data) {
    return {
        type: action_types.CHANGE_LANGUAGE,
        data: data
    };
};

/***/ }),

/***/ "./src/actions/action_types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HAS_ACCESS = exports.HAS_ACCESS = 'HAS_ACCESS';
var LOGIN = exports.LOGIN = 'LOGIN';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var IS_LOADING = exports.IS_LOADING = 'IS_LOADING';
var GET_DOMAIN = exports.GET_DOMAIN = 'GET_DOMAIN';
var GET_COUNTRIES = exports.GET_COUNTRIES = 'GET_COUNTRIES';
var GET_ROLES = exports.GET_ROLES = 'GET_ROLES';
var GET_USERS = exports.GET_USERS = 'GET_USERS';
var GET_GAME_TYPES = exports.GET_GAME_TYPES = 'GET_GAME_TYPES';
var GET_CATEGORIES = exports.GET_CATEGORIES = 'GET_CATEGORIES';
var GET_LANGUAGES = exports.GET_LANGUAGES = 'GET_LANGUAGES';
var GET_COUNTRIES_LANGUAGES_SUBDOMAIN = exports.GET_COUNTRIES_LANGUAGES_SUBDOMAIN = 'GET_COUNTRIES_LANGUAGES_SUBDOMAIN';
var OPEN_COUNTRY_DETAILS = exports.OPEN_COUNTRY_DETAILS = 'OPEN_COUNTRY_DETAILS';
var GET_GAMES = exports.GET_GAMES = 'GET_GAMES';
var GET_CATEGORY_DETAIL = exports.GET_CATEGORY_DETAIL = 'GET_CATEGORY_DETAIL';
var GET_GAME_DETAIL = exports.GET_GAME_DETAIL = 'GET_GAME_DETAIL';
var GET_SIMILAR_GAMES = exports.GET_SIMILAR_GAMES = 'GET_SIMILAR_GAMES';
var GET_SEARCHED_GAMES = exports.GET_SEARCHED_GAMES = 'GET_SEARCHED_GAMES';
var GET_FAVOURITE_GAMES = exports.GET_FAVOURITE_GAMES = 'GET_FAVOURITE_GAMES';
var SET_FAVOURITE_GAME = exports.SET_FAVOURITE_GAME = 'SET_FAVOURITE_GAME';
var HIDE_SPLASH = exports.HIDE_SPLASH = 'HIDE_SPLASH';
var SHOW_SPLASH = exports.SHOW_SPLASH = 'SHOW_SPLASH';
var ADD_UID = exports.ADD_UID = 'ADD_UID';
var SET_HEADER_TITLE = exports.SET_HEADER_TITLE = 'SET_HEADER_TITLE';
var SHOW_SEARCH = exports.SHOW_SEARCH = 'SHOW_SEARCH';
var GET_DETAILS = exports.GET_DETAILS = 'GET_DETAILS';
var SET_DETAILS = exports.SET_DETAILS = 'SET_DETAILS';
var GET_INTERESTS = exports.GET_INTERESTS = 'GET_INTERESTS';
var SET_PROFILE_PIC = exports.SET_PROFILE_PIC = 'SET_PROFILE_PIC';
var SHOW_MESSAGE = exports.SHOW_MESSAGE = 'SHOW_MESSAGE';
var HIDE_MESSAGE = exports.HIDE_MESSAGE = 'HIDE_MESSAGE';
var SEARCH_TEXT = exports.SEARCH_TEXT = 'SEARCH_TEXT';
var CATEGORY_GAMES = exports.CATEGORY_GAMES = 'CATEGORY_GAMES';
var CHANGE_LANGUAGE = exports.CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

/***/ }),

/***/ "./src/analytics/sendData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _session = __webpack_require__("./src/analytics/session.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var sendData = exports.sendData = function sendData(cName, cCategory, cType, uType, additionalParams) {
    var sessionId = (0, _session.getSessionCookie)();
    var subDomain = _domainConfig.config.subDomain;
    var args = {
        url: window.location.href,
        lang: _domainConfig.config.lang,
        userAgent: navigator.userAgent
    };
    var authorizationData = JSON.parse(sessionStorage.getItem('authorized'));
    var rockmanId = authorizationData ? authorizationData.subscriptionData ? authorizationData.subscriptionData.rockmanId || authorizationData.subscriptionData.rockman_id : '' : '';
    var rid = new URL(window.location.href).searchParams.get('rid');
    if (rockmanId && rockmanId.length > 0 || rid && rid.length > 0) {
        var data = {
            r: rockmanId && rockmanId.length > 0 ? rockmanId : rid,
            portal_session_id: sessionId,
            d: [{
                t: "content_usage",
                a: {
                    content_name: cName,
                    content_category: cCategory,
                    content_type: cType,
                    usage_type: uType,
                    args: _extends({}, args, additionalParams),
                    product_name: window.location.hostname.includes("gamiclub") ? "gamiclub" : window.location.hostname.includes("beemobi") ? "beemobi" : window.location.hostname.includes("appspool") ? "appspool" : window.location.hostname.includes("vplay") ? "vplay" : window.location.hostname.includes('gamezclan') ? 'gamezclan' : window.location.hostname.includes('thegamingclubs') ? 'thegamingclubs' : "gamelords",
                    subdomain: subDomain
                }
            }]
        };
        if (window.location.host.includes('localhost')) {
            console.log(data);
            return;
        }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', _variables.ANALYTICS_API_URL, true);
        // xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(data));
    }
    return;
};

/***/ }),

/***/ "./src/analytics/session.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSessionCookie = undefined;

var _v = __webpack_require__("./node_modules/uuid/v1.js");

var _v2 = _interopRequireDefault(_v);

var _universalCookie = __webpack_require__("./node_modules/universal-cookie/es6/index.js");

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookies = new _universalCookie2.default();

var sessionCookieAlive = function sessionCookieAlive() {
    if (cookies.get("sessionId")) return true;else return false;
};

var generateSessionCookie = function generateSessionCookie() {
    var d = new Date();
    d.setTime(d.getTime() + 30 * 60 * 1000);
    var sessionId = (0, _v2.default)().replace(/-/g, '');
    cookies.set("sessionId", sessionId, { path: "/", expires: d });
    return true;
};

var getCurrentCookie = function getCurrentCookie() {
    return cookies.get('sessionId');
};

var getSessionCookie = exports.getSessionCookie = function getSessionCookie() {
    if (!sessionCookieAlive()) generateSessionCookie();
    return getCurrentCookie();
};

/***/ }),

/***/ "./src/components/Account/Account.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _HeaderActions = __webpack_require__("./src/actions/HeaderActions.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _messages = __webpack_require__("./src/constants/messages.js");

var _messages_ar = __webpack_require__("./src/constants/messages_ar.js");

var _messages_kk = __webpack_require__("./src/constants/messages_kk.js");

var _messages_fr = __webpack_require__("./src/constants/messages_fr.js");

var _messages_sv = __webpack_require__("./src/constants/messages_sv.js");

var _messages_no = __webpack_require__("./src/constants/messages_no.js");

var _messages_vi = __webpack_require__("./src/constants/messages_vi.js");

var _messages_tr = __webpack_require__("./src/constants/messages_tr.js");

var _messages_it = __webpack_require__("./src/constants/messages_it.js");

var _messages_es = __webpack_require__("./src/constants/messages_es.js");

var _messages_cy = __webpack_require__("./src/constants/messages_cy.js");

var _messages_el = __webpack_require__("./src/constants/messages_el.js");

var _messages_ro = __webpack_require__("./src/constants/messages_ro.js");

var _messages_cz = __webpack_require__("./src/constants/messages_cz.js");

var _messages_pt = __webpack_require__("./src/constants/messages_pt.js");

var _messages_lt = __webpack_require__("./src/constants/messages_lt.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _messages_de = __webpack_require__("./src/constants/messages_de.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _enableWithdraw = __webpack_require__("./src/constants/enableWithdraw.js");

var _domainTheme = __webpack_require__("./src/utils/domainTheme.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain, kazakhDomain, orangeDomain, ciDomain, cdDomain, tnDomain, frenchDomain, snDomain, swedishDomain, cmDomain, kwDomain, belgiumDomain, zaDomain, norwayDomain, vietnamDomain, dzDomain, egDomain, turkeyDomain, spanishDomain, ghDomain, italianDomain, rsDomain, deDomain, roDomain, bfDomain, czDomain;
var msg = void 0;

var Account = function (_Component) {
  _inherits(Account, _Component);

  function Account(props) {
    _classCallCheck(this, Account);

    var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));

    _this.unsubscribeText = function () {
      var unsubscribeText = void 0;
      if (zaDomain) {
        unsubscribeText = _react2.default.createElement(
          "div",
          { className: "unsub_text" },
          _react2.default.createElement(
            "p",
            null,
            "To unsubscribe dial *135*997# or Dial 082 135 for Vodacom Customer Support."
          ),
          _react2.default.createElement(
            "p",
            null,
            "Go to ",
            _react2.default.createElement(
              "a",
              { href: "https://bit.ly/3if1lzJ" },
              "https://bit.ly/3if1lzJ"
            ),
            " to manage your content services."
          )
        );
      }
      return unsubscribeText;
    };

    _this.state = {
      name: "",
      emailAddress: "",
      location: "",
      interests: [],
      accountType: "standard",
      photo: "",
      photoFile: null,
      errorUnsub: ""
    };

    _this.editForm = _this.editForm.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onCategoryChange = _this.onCategoryChange.bind(_this);
    _this.onFileChange = _this.onFileChange.bind(_this);
    _this.submitForm = _this.submitForm.bind(_this);
    _this.validateForm = _this.validateForm.bind(_this);
    _this.translateInterests = _this.translateInterests.bind(_this);
    _this.unsubscribe = _this.unsubscribe.bind(_this);
    _this.unsubscribePE = _this.unsubscribePE.bind(_this);
    _this.changeDomain = _this.changeDomain.bind(_this);
    return _this;
  }

  _createClass(Account, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.access.token != "") {
        _axios2.default.defaults.headers.common["authorization"] = this.props.access.token;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _sendData.sendData)("", "", "", "viewed", { page: "account" });
      var user = this.props.account.user;
      this.setState({
        name: user.name,
        emailAddress: user.email,
        location: user.address,
        interests: user.userInterests ? user.userInterests.map(function (i) {
          return i.interestId;
        }) : [],
        accountType: user.accountType
      });

      window.scrollTo(0, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove("<account-page></account-page>");
    }
  }, {
    key: "changeDomain",
    value: function changeDomain() {
      arabicDomain = _domainConfig.config.lang == "ar" ? true : false;
      kazakhDomain = _domainConfig.config.lang == "kk" ? true : false;
      orangeDomain = _domainConfig.config.country == "ci" ? true : false;
      ciDomain = _domainConfig.config.country == "ci" ? true : false;
      cdDomain = _domainConfig.config.country == "cd" ? true : false;
      tnDomain = _domainConfig.config.country == "tn" ? true : false;
      frenchDomain = _domainConfig.config.lang == "fr" ? true : false;
      snDomain = _domainConfig.config.country == "sn" ? true : false;
      swedishDomain = _domainConfig.config.country == "se" ? true : false;
      cmDomain = _domainConfig.config.country == "cm" ? true : false;
      kwDomain = _domainConfig.config.country == "kw" ? true : false;
      belgiumDomain = _domainConfig.config.country == "be" ? true : false;
      zaDomain = _domainConfig.config.country == "za" ? true : false;
      norwayDomain = _domainConfig.config.country == "no" ? true : false;
      vietnamDomain = _domainConfig.config.country == "vn" ? true : false;
      dzDomain = _domainConfig.config.country == "dz" ? true : false;
      egDomain = _domainConfig.config.country == "eg" ? true : false;
      ghDomain = _domainConfig.config.country == "gh" ? true : false;
      turkeyDomain = _domainConfig.config.country == "tr" ? true : false;
      spanishDomain = _domainConfig.config.subDomain == "es" ? true : false;
      italianDomain = _domainConfig.config.subDomain == "it" ? true : false;
      rsDomain = _domainConfig.config.subDomain == "cy" ? true : false;
      deDomain = _domainConfig.config.subDomain == "ch" ? true : false;
      roDomain = _domainConfig.config.subDomain == "ro" ? true : false;
      bfDomain = _domainConfig.config.country == "bf" ? true : false;
      czDomain = _domainConfig.config.country == "cz" ? true : false;
      switch (_domainConfig.config.lang) {
        case "ar":
          msg = _messages_ar.messages_ar;
          break;
        case "kk":
          msg = _messages_kk.messages_kk;
          break;
        case "fr":
          msg = _messages_fr.messages_fr;
          break;
        case "sv":
          msg = _messages_sv.messages_sv;
          break;
        case "no":
          msg = _messages_no.messages_no;
          break;
        case "vi":
          msg = _messages_vi.messages_vi;
          break;
        case "tr":
          msg = _messages_tr.messages_tr;
          break;
        case "cy":
          msg = _messages_cy.messages_cy;
          break;
        case "es":
          msg = _messages_es.messages_es;
          break;
        case "it":
          msg = _messages_it.messages_it;
          break;
        case "de":
          msg = _messages_de.messages_de;
          break;
        case "el":
          msg = _messages_el.messages_el;
          break;
        case "ro":
          msg = _messages_ro.messages_ro;
          break;
        case "cs":
          msg = _messages_cz.messages_cz;
          break;
        case "pt":
          msg = _messages_pt.messages_pt;
          break;
        case "lt":
          msg = _messages_lt.messages_lt;
          break;
        default:
          msg = _messages.messages;
          break;
      }
    }
  }, {
    key: "translateInterests",
    value: function translateInterests(interests, lang) {
      var translatedInterests = interests.map(function (interest) {
        var inE = ["Sports", "Action", "Adventure", "Fitness", "Entertainment"];
        var inK = ["Спорт", "Экшн", "Приключения", "Фитнес", "Развлечения"];
        var inFrench = ["Sports", "Action", "Aventure", "Entraînement physique", "Divertissement"];
        var inSwedish = ["Sporter", "Action", "Äventyr", "Träning", "Underhållning"];
        var inArabic = ["رياضة", " اكشن", "مغامرة", "اللياقه البدنيه", "وسائل الترفيه"];
        var inBelgium = ["Sport", "Actie", "Avontuur", "Geschiktheid", "Vermaak"];
        var inNo = ["Sport", "Action", "Eventyr", "Fitness", "Underholdning"];
        var inVietnam = ["Thể thao", "Hành động", "Phiêu lưu", "Gym", "Giải trí"];
        var inTurkey = ["Spor", "Aksiyon", "Macera", "Fitness", "Eğlence"];
        var inSpanish = ["Deporte", "Acción", "Aventura", "Fitness", "Entretenimiento"];
        var inItalian = ["Sport", "Azione", "Avventura", "Fitness", "Intrattenimento"];
        var inSerbian = ["Спортови", "Акција", "Авантура", "Фитнес", "Забава"];
        var inGerman = ["Sports", "Aktion", "Abenteuer", "Fitness", "Unterhaltung"];
        var inGreek = ["Σπορ", "Δράση", "Περιπέτεια", "Fitness", "Διασκέδασης"];
        var inRo = ["Sport", "Acțiune", "Aventură", "Fitness", "Divertisment"];
        var inPt = ["Desportos", "Ação", "Aventura", "Fitness", "Entretenimento"];
        var inLt = ["Sportas", "Veiksmas", "Nuotykiai", "Fitnesas", "Pramogos"];
        var index = inE.indexOf(interest);
        if (index != -1) {
          if (lang == "kk") interest = inK[index];else if (lang == "fr") interest = inFrench[index];else if (lang == "sv") interest = inSwedish[index];else if (lang == "ar") interest = inArabic[index];else if (lang == "be") interest = inBelgium[index];else if (lang == "no") interest = inNo[index];else if (lang == "vi") interest = inVietnam[index];else if (lang == "tr") interest = inTurkey[index];else if (lang == "es") interest = inSpanish[index];else if (lang == "it") interest = inItalian[index];else if (lang == "cy") interest = inSerbian[index];else if (lang == "de") interest = inGerman[index];else if (lang == "gr") interest = inGreek[index];else if (lang == "ro") interest = inRo[index];else if (lang == "pt") interest = inPt[index];else if (lang == "lt") interest = inLt[index];else interest = inE[index];
        }
        return interest;
      });
      return translatedInterests;
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: "editForm",
    value: function editForm(e) {
      if (this.validateForm()) {
        this.submitForm();
      }
    }
  }, {
    key: "unsubscribePE",
    value: function unsubscribePE() {
      var _this2 = this;

      var rockmanId = this.props.access.subscriptionData.rockmanId || this.props.access.subscriptionData.rockman_id || "fdf098fcc6";
      if (!rockmanId) {
        this.props.showMessage({
          message: "Disculpe, se produjo un error al darle de baja",
          type: false
        });
        return;
      }
      _axios2.default.get(vars.BASE_URL + "/unsubscribe?rockmanId=" + rockmanId + "&country=pe").then(function (response) {
        if (response.data && response.data.success) {
          // sessionStorage.clear();
          _this2.props.showMessage({
            message: "Su suscripción ha sido correctamente cancelada",
            type: true
          });
          // setTimeout(() => {
          //     this.props.history.push("/login");
          // }, 1500)
        } else {
          _this2.props.showMessage({
            message: "Disculpe, se produjo un error al darle de baja",
            type: false
          });
          return;
        }
      }).catch(function (err) {
        _this2.props.showMessage({
          message: "Disculpe, se produjo un error al darle de baja",
          type: false
        });
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.state.emailAddress != "" && !regExp.test(this.state.emailAddress)) {
        this.props.showMessage({
          message: msg.emailNotValid,
          type: false
        });
        return false;
      }
      return true;
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this3 = this;

      var user = this.props.account.user;
      user.name = this.state.name;
      user.email = this.state.emailAddress;
      user.address = this.state.location;
      user.interests = this.state.interests;
      user.accountType = this.state.accountType;

      _axios2.default.put(vars.BASE_URL + "/editProfile", user).then(function (response) {
        _this3.props.showMessage({
          message: msg.profileSaved,
          type: true
        });
        (0, _helper.console_log)(response);
      }).catch(function (error) {
        (0, _helper.console_log)(error);
      });

      this.props.setDetails(user);
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      var interest = this.state.interests,
          indexOf = interest.indexOf(parseInt(e.target.name));
      if (indexOf == -1) {
        interest.push(parseInt(e.target.name));
      } else {
        interest = interest.filter(function (c) {
          return c !== parseInt(e.target.name);
        });
      }

      this.setState({
        interests: interest
      });
    }
  }, {
    key: "onFileChange",
    value: function onFileChange(e) {
      var reader = new FileReader(),
          file = e.target.files[0];
      var base64Data = void 0;
      reader.readAsDataURL(file);
      var currentThis = this;
      reader.onloadend = function () {
        base64Data = reader.result;
        currentThis.props.show();
        _axios2.default.post(vars.BASE_URL + "/profile/upload", { profilePic: base64Data }).then(function (response) {
          currentThis.props.showMessage({
            message: msg.profilePic,
            type: true
          });
          currentThis.props.setProfilePic(response.data.data.profilePic);
          currentThis.props.hide();
        }).catch(function (error) {
          currentThis.props.hide();
          (0, _helper.console_log)(error);
        });
        currentThis.setState({
          photo: [reader.result],
          photoFile: file
        });
      };
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      var uid = this.props.access.uid;
      var lang = this.props.access.currentLang;
      var url = window.location.origin;
      (0, _sendData.sendData)("", "", "", "unsubscribe clicked");
      var country = _domainConfig.config.country;
      if (this.props.access.uid && (cdDomain || tnDomain || snDomain || cmDomain || vietnamDomain || ciDomain || orangeDomain)) {
        if ((cmDomain || ciDomain) && _isGamiclub.isGamiclub) {
          window.location = "http://n.gamiclub.com/unsubscribe/" + country + "?lang=fr&token=" + uid;
        } else if (ciDomain || orangeDomain) {
          window.location = "http://n.game-lords.com/unsubscribe/dz/?domain=dz.game-lords.com&token=" + uid;
        } else if (snDomain && _isGamiclub.isGamiclub) {
          window.location = "http://n.gamiclub.com/unsubscribe/sn?lang=fr&token=" + uid;
        } else {
          window.location = "http://n.lordgames.info/unsubscribe/" + country + "?lang=" + lang + "&token=" + uid;
        }
      } else if (this.props.access.uid && belgiumDomain && _isGamiclub.isGamiclub) {
        window.location = "http://n.gamiclub.com/unsubscribe/be/?lang=" + (_domainConfig.config.lang === "be" ? "nl" : _domainConfig.config.lang) + "&token=" + uid;
      } else if (this.props.access.uid && belgiumDomain) {
        window.location = "http://n.game-lords.com/unsubscribe/be/?domain=be.game-lords.com&token=" + uid;
      } else if (this.props.access.uid && kwDomain) {
        window.location = "http://n.lordgames.info/unsubscribe/kw?domain=" + (_isGamiclub.isGamiclub ? "kw.gamiclub.com" : "kw.game-lords.com") + "&platform=mcb&msisdn[]=" + this.props.access.subscriptionData.msisdn_full.slice(3) + "&skip_identify=1";
      } else if (this.props.access.uid && _domainConfig.config.subDomain === "maxis") {
        window.location = "https://m.game-lords.com/unsubscribe/my?lang=en&domain=" + _domainConfig.config.subDomain + ".game-lords.com&platform=mcb&skip_identify=true&token=" + uid;
      } else if (this.props.access.uid && _domainConfig.config.subDomain === "my") {
        window.location = "https://checksubscription.com/?c=my";
      } else if (this.props.access.uid && _domainConfig.config.subDomain === "pl" && window.location.hostname.includes("funzarena")) {
        window.location = "https://checksubscription.com/?c=pl";
      } else if (this.props.access.uid && zaDomain && _isGamiclub.isGamiclub) {
        window.location = "http://n.gamiclub.com/unsubscribe/za?lang=en&token=" + uid;
      } else if (this.props.access.uid && czDomain && _isGamiclub.isGamiclub) {
        window.location = "http://n.gamiclub.com/unsubscribe/cz?lang=cz&token=" + uid;
      } else if (this.props.access.uid && zaDomain) {
        if (sessionStorage.getItem("staging")) {
          window.location = "http://ads-za-yola.sam-media.com/unsubscribe/za1?country=vn&lang=en&token=" + uid;
        } else {
          window.location = "http://n.game-lords.com/unsubscribe/za/?domain=za.game-lords.com&country=za&lang=en&token=" + uid;
        }
      } else if (this.props.access.uid && dzDomain) {
        if (_domainConfig.config.lang === "ar") {
          window.location = "http://n.game-lords.com/unsubscribe/dz/?domain=dz.game-lords.com&lang=ar&token=" + uid;
        } else if (_domainConfig.config.lang === "fr") {
          window.location = "http://n.game-lords.com/unsubscribe/dz/?domain=dz.game-lords.com&token=" + uid;
        }
      } else if (this.props.access.uid && egDomain) {
        if (_domainConfig.config.lang === "ar") {
          window.location = " http://n.game-lords.com/unsubscribe/eg/?country=eg&lang=ar&domain=eg.game-lords.com&token=" + uid;
        } else {
          window.location = " http://n.game-lords.com/unsubscribe/eg/?country=eg&lang=en&domain=eg.game-lords.com&token=" + uid;
        }
      } else if (this.props.access.uid && turkeyDomain) {
        window.location = "http://n.game-lords.com/unsubscribe/tr/?domain=tr.game-lords.com&token=" + uid;
      } else if (this.props.access.uid && norwayDomain) {
        window.location = "http://n.game-lords.com/unsubscribe/no?lang=no&token=" + uid;
      } else if (this.props.access.uid && spanishDomain) {
        window.location = "http://n.game-lords.com/unsubscribe/es?domain=es.game-lords.com&token=" + uid;
      } else if (this.props.access.uid && ghDomain) {
        window.location = "http://n.game-lords.com/unsubscribe/gh/?token=" + uid;
      } else if (this.props.access.uid && swedishDomain) {
        window.location = "http://n.lordgames.info/unsubscribe/se?lang=sv&token=" + uid;
      } else if (this.props.access.uid && italianDomain) {
        window.location = "http://n.game-lords.com/unsubscribe/it/?domain=it.game-lords.com&token=" + uid;
      } else if (this.props.access.uid && _domainConfig.config.subDomain === "bh" && _isGamiclub.isGamiclub) {
        window.location = "http://n.gamiclub.com/unsubscribe/bh/?domain=bh.gamiclub.com&token=" + uid;
      } else if (this.props.access.uid && (_domainConfig.config.subDomain === "id" || _domainConfig.config.subDomain === "idsale" || _domainConfig.config.subDomain === "gmn") && !_isGamiclub.isGamiclub) {
        window.location = "https://m.game-lords.com/unsubscribe/id?lang=id&token=" + uid;
      }
      // else if (this.props.access.uid && roDomain) {
      //     window.location = `http://n.gamiclub.com/unsubscribe/ro/?domain=ro.gamiclub.com&token==${uid}`;
      // }
      else if (this.props.access.uid && _domainConfig.config.subDomain === "es2") {
          window.location = "http://n.beemobi.me/unsubscribe/es/?country=es&domain=es2.beemobi.me&token=" + uid;
        } else if (this.props.access.uid && bfDomain && _isGamiclub.isGamiclub) {
          window.location = "http://n.gamiclub.com/unsubscribe/bf?lang=fr&token=" + uid;
        } else if (this.props.access.uid && _domainConfig.config.subDomain === "ch" && !_isGamiclub.isGamiclub && !_isAppspool.isAppspool) {
          window.location = "http://n.game-lords.com/unsubscribe/ch?lang=" + _domainConfig.config.lang + "&token=" + uid;
        } else if (!this.props.access.uid) {
          this.setState({
            errorUnsub: "No uid found. Try again after logging in with a valid uid."
          });
        }
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      this.changeDomain();
      var PP_url = void 0,
          TC_url = void 0,
          unsubscribe_url = void 0,
          contactus_url = void 0;
      if (_domainConfig.config.lang == "ar") {
        this.props.setHeaderTitle("حسابي");
      } else if (_domainConfig.config.subDomain === "bg") {
        this.props.setHeaderTitle("Моят акаунт");
      } else if (kazakhDomain) {
        this.props.setHeaderTitle("Личный кабинет");
      } else if (_domainConfig.config.lang == "fr") {
        this.props.setHeaderTitle("Mon compte");
      } else if (_domainConfig.config.lang == "cy") {
        this.props.setHeaderTitle("Мој профил");
      } else if (_domainConfig.config.lang == "de") {
        this.props.setHeaderTitle("Mein Konto");
      } else if (_domainConfig.config.lang == "el") {
        this.props.setHeaderTitle("Ο λογαριασμός μου");
      } else if (_domainConfig.config.lang == "ro") {
        this.props.setHeaderTitle("Contul meu");
      } else if (_domainConfig.config.lang == "it") {
        this.props.setHeaderTitle("Il mio account");
      } else if (_domainConfig.config.lang == "pt") {
        this.props.setHeaderTitle("Minha Conta");
      } else if (_domainConfig.config.lang == "lt") {
        this.props.setHeaderTitle("Mano Paskyra");
      } else if (swedishDomain) {
        this.props.setHeaderTitle("Mitt konto");
        PP_url = "http://n.game-lords.com/se/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html&_extracted=b46947911ad34990bc9776146fc173b9&";
        TC_url = "http://n.game-lords.com/se/tnc-game-lords?device=pc&offer=1";
        unsubscribe_url = "http://n.lordgames.info/unsubscribe/se?lang=sv&token=" + this.props.account.user.uid;
      } else if (norwayDomain) {
        this.props.setHeaderTitle("Min konto");
      } else if (vietnamDomain) {
        this.props.setHeaderTitle("Tài khoản của tôi");
      } else if (turkeyDomain) {
        this.props.setHeaderTitle("Hesabım");
      } else if (italianDomain) {
        this.props.setHeaderTitle("Il mio account");
      } else if (spanishDomain) {
        this.props.setHeaderTitle("Mi cuenta");
        contactus_url = "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=contact.html";
        TC_url = "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=general_conditions.html";
        unsubscribe_url = "http://n.game-lords.com/unsubscribe/es?domain=es.game-lords.com&token=" + this.props.account.user.uid;
      } else if (_domainConfig.config.subDomain === "es2") {
        this.props.setHeaderTitle("Mi cuenta");
      } else if (_domainConfig.config.subDomain === "pe") {
        this.props.setHeaderTitle("Mi cuenta");
      } else if (ghDomain) {
        this.props.setHeaderTitle("My Account");
        TC_url = "http://n.lordgames.info/gh/tnc-gamelords?device=pc&offer=1";
      } else if (egDomain) {
        this.props.setHeaderTitle("My Account");
        TC_url = "http://n.gamiclub.com/eg/eg-mm-gamiclub?offer=1&msisdn=" + this.props.access.subscriptionData.msisdn;
      } else if (czDomain) {
        this.props.setHeaderTitle("Můj účet");
      } else this.props.setHeaderTitle("My Account");
      var editBtnClass = "edit-button";
      editBtnClass = _domainConfig.config.lang == "ar" ? editBtnClass + " ar" : editBtnClass;
      var Unsubscribe = void 0;
      if (orangeDomain || ciDomain || cdDomain || tnDomain || snDomain || cmDomain) Unsubscribe = "Se désabonner";else if (swedishDomain) Unsubscribe = "Avsluta prenumerationen";else if (belgiumDomain) Unsubscribe = "Uitschrijven";else if (norwayDomain) Unsubscribe = "Meld av";else if (vietnamDomain) Unsubscribe = "Hủy đăng ký";else if (_domainConfig.config.lang == "ar") Unsubscribe = "الغاء الاشتراك";else if (turkeyDomain) Unsubscribe = "Üyelikten ayrıl";else if (spanishDomain || _domainConfig.config.subDomain === "es2") Unsubscribe = "Cancelación";else if (_domainConfig.config.lang == "fr") Unsubscribe = "Se désabonner";else if (_domainConfig.config.lang == "it") Unsubscribe = "Annulla l'iscrizione";else if (_domainConfig.config.lang === "de") Unsubscribe = "Abmelden";else if (_domainConfig.config.subDomain === "pe") Unsubscribe = "Cancelar la suscripción";else if (czDomain) Unsubscribe = "ODHLÁSIT ODBĚR";else if (roDomain) Unsubscribe = " Anulare";else if (_domainConfig.config.subDomain === "pt") Unsubscribe = "CANCELAR INSCRIÇÃO";else if (_domainConfig.config.subDomain === "lt") Unsubscribe = "ATŠAUKTI PRENUMERATĄ";else if (_domainConfig.config.subDomain === "pl") Unsubscribe = "Anuluj subskrypcję";else Unsubscribe = "Unsubscribe";
      var inE = ["Sports", "Action", "Adventure", "Fitness", "Entertainment"];
      inE = this.translateInterests(inE, _domainConfig.config.lang);
      var _props$access$subscri = this.props.access.subscriptionData,
          msisdn_full = _props$access$subscri.msisdn_full,
          rockmanId = _props$access$subscri.rockmanId;
      var lang = _domainConfig.config.lang,
          country = _domainConfig.config.country,
          subDomain = _domainConfig.config.subDomain;

      var productName = window.location.hostname;
      return _react2.default.createElement(
        "section",
        { className: "account" },
        _react2.default.createElement(
          "button",
          { className: editBtnClass, onClick: this.editForm },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "save", defaultMessage: "Save" })
        ),
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Form,
            {
              className: _domainConfig.config.lang == "ar" ? "account-form account-form--editable ar" : "account-form account-form--editable",
              action: "",
              method: "post"
            },
            _react2.default.createElement(
              _reactstrap.Row,
              null,
              _react2.default.createElement(
                _reactstrap.Col,
                { sm: "8", xs: "7" },
                _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "accountDetails",
                      defaultMessage: "Account Details"
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "account__input" },
                    _react2.default.createElement(
                      "label",
                      { className: "account__input__label", htmlFor: "name" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "accountName",
                        defaultMessage: "Name"
                      })
                    ),
                    _react2.default.createElement("input", {
                      className: "account__input__field",
                      type: "text",
                      name: "name",
                      id: "name",
                      value: this.state.name,
                      onChange: this.onChange
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "account__input" },
                    _react2.default.createElement(
                      "label",
                      {
                        className: "account__input__label",
                        htmlFor: "emailAddress"
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "accountEmail",
                        defaultMessage: "Email Address"
                      })
                    ),
                    _react2.default.createElement("input", {
                      className: "account__input__field",
                      type: "text",
                      name: "emailAddress",
                      id: "emailAddress",
                      value: this.state.emailAddress,
                      onChange: this.onChange
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "account__input" },
                    _react2.default.createElement(
                      "label",
                      { className: "account__input__label", htmlFor: "location" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "accountLocation",
                        defaultMessage: "Location"
                      })
                    ),
                    _react2.default.createElement("input", {
                      className: "account__input__field",
                      type: "text",
                      name: "location",
                      id: "location",
                      value: this.state.location,
                      onChange: this.onChange
                    })
                  )
                ),
                this.props.account.interests ? _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "accountInterests",
                      defaultMessage: "Interests"
                    })
                  ),
                  _react2.default.createElement(
                    "span",
                    { className: "hint-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "accountChooseCategory",
                      defaultMessage: "Choose 3 categories"
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "account__checkbox-wrap" },
                    this.props.account.interests.map(function (interest, k) {
                      return _react2.default.createElement(
                        "div",
                        { key: k, className: "account__input" },
                        _react2.default.createElement("input", {
                          type: "checkbox",
                          className: _isGamiclub.isGamiclub ? "common-checkbox-gamiclub" : _productCondition.isGameflares ? "common-checkbox gameflares-checkbox" : _productCondition.isGamiway ? "common-checkbox gamiway-checkbox" : "common-checkbox",
                          name: interest.interestId,
                          id: interest.interestId,
                          checked: _this4.state.interests.indexOf(interest.interestId) !== -1 ? true : false,
                          onChange: _this4.onCategoryChange
                        }),
                        _react2.default.createElement(
                          "label",
                          {
                            className: "account__default__label",
                            htmlFor: interest.interestId
                          },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: inE[k],
                            defaultMessage: inE[k]
                          })
                        )
                      );
                    })
                  )
                ) : "",
                _domainConfig.config.subDomain === "pe" && !_isGamiclub.isGamiclub ? _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _productCondition.isGameflares ? { color: "#FF394B" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(
                      _reactstrap.Button,
                      {
                        color: "warning",
                        style: _productCondition.isGameflares ? {
                          borderColor: "#FF394B",
                          backgroundColor: "#FF394B",
                          color: "#ffffff"
                        } : null,
                        onClick: this.unsubscribePE
                      },
                      Unsubscribe
                    ),
                    this.state.errorUnsub ? _react2.default.createElement(
                      "h5",
                      { style: { color: "white", marginTop: "5px" } },
                      this.state.errorUnsub
                    ) : null
                  )
                ) : null,
                (_domainConfig.config.subDomain === "es2" || spanishDomain || orangeDomain || ciDomain || cdDomain || tnDomain || snDomain || swedishDomain || cmDomain || belgiumDomain || kwDomain || norwayDomain || vietnamDomain || dzDomain || turkeyDomain || italianDomain || ghDomain || _domainConfig.config.subDomain === "bh" && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "my" && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "pl" && window.location.hostname.includes("funzarena") || bfDomain && _isGamiclub.isGamiclub || czDomain && _isGamiclub.isGamiclub || (_domainConfig.config.subDomain === "id" || _domainConfig.config.subDomain === "idsale" || _domainConfig.config.subDomain === "gmn" || _domainConfig.config.subDomain === "my" || _domainConfig.config.subDomain === "maxis" || egDomain || _domainConfig.config.subDomain === "ch") && !_isGamiclub.isGamiclub && !_isAppspool.isAppspool && !_productCondition.isGamiway) && this.props.access.uid ? _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : _productCondition.isGameflares ? { color: "#FF394B" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(
                      _reactstrap.Button,
                      {
                        color: "warning",
                        style: _isGamiclub.isGamiclub ? {
                          backgroundColor: "green",
                          borderColor: "green",
                          color: "white"
                        } : _productCondition.isGameflares ? {
                          borderColor: "#FF394B",
                          backgroundColor: "#FF394B",
                          color: "#ffffff"
                        } : null,
                        onClick: this.unsubscribe
                      },
                      Unsubscribe
                    ),
                    this.state.errorUnsub ? _react2.default.createElement(
                      "h5",
                      { style: { color: "white", marginTop: "5px" } },
                      this.state.errorUnsub
                    ) : null
                  )
                ) : null,
                spanishDomain || swedishDomain || ghDomain ? _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(
                      _reactstrap.Button,
                      {
                        style: _isGamiclub.isGamiclub ? {
                          backgroundColor: "green",
                          borderColor: "green",
                          color: "white"
                        } : null,
                        color: "warning",
                        onClick: function onClick() {
                          window.open(TC_url, "_blank");
                        }
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "tnc",
                        defaultMessage: "Terms & Conditions"
                      })
                    )
                  )
                ) : null,
                swedishDomain ? _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(
                      _reactstrap.Button,
                      {
                        style: _isGamiclub.isGamiclub ? {
                          backgroundColor: "green",
                          borderColor: "green",
                          color: "white"
                        } : null,
                        color: "warning",
                        onClick: function onClick() {
                          window.open(PP_url, "_blank");
                        }
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "privacyPolicy",
                        defaultMessage: "Privacy policy"
                      })
                    )
                  )
                ) : null,
                kwDomain || norwayDomain && !_isGamiclub.isGamiclub || deDomain && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "bh" && _isGamiclub.isGamiclub ? _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "h3",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : null,
                      className: "account__title"
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "subscription_details",
                      defaultMessage: "Subscription Details"
                    }),
                    ":"
                  ),
                  _react2.default.createElement(
                    "span",
                    { className: "hint-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "mobile_number",
                      defaultMessage: "Mobile Number"
                    }),
                    ":",
                    " ",
                    _domainConfig.config.subDomain === "bh" ? this.props.access.subscriptionData["msisdn"] : this.props.access.subscriptionData.msisdn_full
                  ),
                  " ",
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { className: "hint-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "subscription_date",
                      defaultMessage: "Subscription Date"
                    }),
                    ":",
                    " ",
                    _domainConfig.config.subDomain === "bh" && _isGamiclub.isGamiclub ? (0, _helper.formatDate)(this.props.access.subscriptionData["subscribed_at"]) : this.props.access.subscriptionData.startDate
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { className: "hint-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "renewal_date",
                      defaultMessage: "Renewal Date"
                    }),
                    ":",
                    " ",
                    _domainConfig.config.subDomain === "bh" && _isGamiclub.isGamiclub ? (0, _helper.formatDate)(this.props.access.subscriptionData["next_renewal_date"]) : this.props.access.subscriptionData.renewalDate
                  ),
                  _react2.default.createElement("br", null),
                  kazakhDomain ? _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                      "span",
                      { className: "hint-text" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "expiry_date",
                        defaultMessage: "Expiry date"
                      }),
                      ": ",
                      this.props.access.subscriptionData.expiryDate
                    ),
                    _react2.default.createElement("br", null)
                  ) : null,
                  _domainConfig.config.subDomain !== "bh" ? _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                      "span",
                      { className: "hint-text" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "applied_plan",
                        defaultMessage: "Applied Plan"
                      }),
                      ":",
                      " ",
                      this.props.access.subscriptionData.billingPlan == 7 || norwayDomain ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "weekly",
                        defaultMessage: "Weekly"
                      }) : this.props.access.subscriptionData.billingPlan == 1 ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "daily",
                        defaultMessage: "Daily"
                      }) : this.props.access.subscriptionData.billingPlan == 30 ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "monthly",
                        defaultMessage: "Monthly"
                      }) : ""
                    ),
                    _react2.default.createElement("br", null)
                  ) : null,
                  _domainConfig.config.subDomain === "bh" && _isGamiclub.isGamiclub ? _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                      "span",
                      { className: "hint-text" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "billing_interval",
                        defaultMessage: "Billing Interval"
                      }),
                      ":",
                      " ",
                      this.props.access.subscriptionData["Billing Interval"]
                    ),
                    _react2.default.createElement("br", null),
                    _react2.default.createElement(
                      "span",
                      { className: "hint-text" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, { id: "price", defaultMessage: "Price" }),
                      ":",
                      " ",
                      isNaN(this.props.access.subscriptionData["Price"]) ? "0" : (this.props.access.subscriptionData["Price"] / 100).toFixed(1)
                    ),
                    _react2.default.createElement("br", null),
                    _react2.default.createElement(
                      "span",
                      { className: "hint-text" },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "service_description",
                        defaultMessage: "Service Description"
                      }),
                      ": ",
                      this.props.access.subscriptionData["Description"]
                    ),
                    _react2.default.createElement("br", null)
                  ) : null,
                  _react2.default.createElement(
                    "span",
                    { className: "hint-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "service_name",
                      defaultMessage: "Service Name"
                    }),
                    ": ",
                    _isGamiclub.isGamiclub ? "Gamiclub" : "Gamelords"
                  )
                ) : null,
                zaDomain && _react2.default.createElement(
                  "div",
                  { className: "unsubscribe_text_section" },
                  this.unsubscribeText()
                ),
                (0, _enableWithdraw.isWithdrawEnabled)(subDomain) && _react2.default.createElement(
                  "div",
                  { className: "account__fields" },
                  _react2.default.createElement(
                    "a",
                    {
                      href: "https://checksubscription.com/withdraw?c=" + country + "&product=" + productName + "&country=" + country + "&language=" + lang + "&portalSource=" + productName + "&rockmanId=" + rockmanId + "&msisdn=" + (msisdn_full || ""),
                      target: "_blank",
                      rel: "noopener noreferrer",
                      style: _isGamiclub.isGamiclub ? { color: "#57A67C" } : { color: "#f6a50e" }
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "withdraw_from_contract",
                      defaultMessage: "Withdraw from Contract"
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { sm: "4", xs: "5" },
                _react2.default.createElement(
                  "div",
                  { className: "account__image" },
                  _react2.default.createElement(
                    "div",
                    { className: "account__input" },
                    _react2.default.createElement(
                      "label",
                      {
                        className: "account__input__label account__input__label--image",
                        htmlFor: "photo"
                      },
                      _react2.default.createElement("img", {
                        className: "avatar-image",
                        src: this.state.photo ? this.state.photo : this.props.account.user.profilePic ? this.props.account.user.profilePic : "img/avatar-with-camera.png",
                        alt: "Edit Photo"
                      }),
                      _react2.default.createElement(
                        "span",
                        { className: "avatar-text" },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                          id: "accountEditPhoto",
                          defaultMessage: "Edit Photo"
                        })
                      )
                    ),
                    _react2.default.createElement("input", {
                      type: "file",
                      className: "account__input__field",
                      name: "photo",
                      id: "photo",
                      accept: "image/gif, image/jpeg, image/png image/jpg",
                      onChange: this.onFileChange
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Account;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    account: state.AccountReducer,
    access: state.WelcomeReducer,
    flashmessage: state.FlashMessageReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    setHeaderTitle: _HeaderActions.setHeaderTitle,
    setDetails: _AccountActions.setDetails,
    showMessage: _FlashMessageActions.showMessage,
    setProfilePic: _AccountActions.setProfilePic,
    changeLangAction: _WelcomeActions.changeLangAction
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Account);

/***/ }),

/***/ "./src/components/ActivityIndicator/ActivityIndicator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _helper = __webpack_require__("./src/utils/helper.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivityIndicator = function (_Component) {
    _inherits(ActivityIndicator, _Component);

    function ActivityIndicator() {
        _classCallCheck(this, ActivityIndicator);

        return _possibleConstructorReturn(this, (ActivityIndicator.__proto__ || Object.getPrototypeOf(ActivityIndicator)).apply(this, arguments));
    }

    _createClass(ActivityIndicator, [{
        key: 'render',
        value: function render() {
            var isLoading = this.props.isLoading;
            if (isLoading) {
                document.body.classList.add("scroll-hide");
            } else {
                document.body.classList.remove("scroll-hide");
            }
            return isLoading ? _react2.default.createElement(
                'div',
                { className: 'activity-indicator' },
                _react2.default.createElement('img', { className: 'icon-loader', src: './img/g-icon.svg', alt: 'Loading...' })
            ) : null;
        }
    }]);

    return ActivityIndicator;
}(_react.Component);

exports.default = ActivityIndicator;

/***/ }),

/***/ "./src/components/Banner/Banner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactResponsiveCarousel = __webpack_require__("./node_modules/react-responsive-carousel/lib/js/index.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Banner = function (_Component) {
    _inherits(Banner, _Component);

    function Banner(props) {
        _classCallCheck(this, Banner);

        return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).call(this, props));
    }

    _createClass(Banner, [{
        key: 'onclick',
        value: function onclick(id) {
            if (id != undefined) {
                //if (config.subDomain === "my") {
                window.location.href = '#/category/' + id + '?uid=' + this.props.access.uid;
                /*}
                else {
                    window.location.href = '#/detail/' + id + '?uid=' + this.props.access.uid;
                } */
            }
        }
    }, {
        key: 'getItem',
        value: function getItem(data, i) {
            var _this2 = this;

            var url = window.location.hash;
            return _react2.default.createElement(
                'div',
                { key: i, onClick: function onClick() {
                        return _this2.onclick(data.id);
                    }, className: url == '#/home/html' || url == '#/home/android' || url == '#/home/video' || _domainConfig.config.subDomain == 'tr' ? "banner-item" : "banner-item striped-lines-bg" },
                _react2.default.createElement('img', { src: data.imgUrl, alt: data.game_name.toUpperCase() }),
                data.offer ? _react2.default.createElement(
                    'div',
                    { className: 'ribbon' },
                    _react2.default.createElement(
                        'span',
                        { className: 'ribbon-content' },
                        data.offer.toUpperCase()
                    )
                ) : '',
                _react2.default.createElement(
                    'div',
                    { className: 'banner-text' },
                    _react2.default.createElement(
                        'span',
                        { style: _isGamiclub.isGamiclub ? { color: 'green' } : null, className: 'game-name' },
                        data.game_name.toUpperCase()
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'category-name' },
                        data.category_name.toUpperCase()
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var data = this.props.bannerData;
            return _react2.default.createElement(
                'section',
                { className: 'banner' },
                _react2.default.createElement(
                    _reactResponsiveCarousel.Carousel,
                    { swipeable: true, autoPlay: true, interval: 3000, showArrows: false, showThumbs: false, infiniteLoop: true, transitionTime: 350, emulateTouch: true, showIndicators: data.length > 1 },
                    data.map(function (image, i) {
                        return _this3.getItem(image, i);
                    })
                )
            );
        }
    }]);

    return Banner;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer
    };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Banner);

/***/ }),

/***/ "./src/components/Category/ManageCategories.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain = _domainConfig.config.lang == 'ar' ? true : false;

var data = new FormData();

var ManageCategories = function (_Component) {
    _inherits(ManageCategories, _Component);

    function ManageCategories(props) {
        _classCallCheck(this, ManageCategories);

        var _this = _possibleConstructorReturn(this, (ManageCategories.__proto__ || Object.getPrototypeOf(ManageCategories)).call(this, props));

        _this.state = {
            categoryName: '',
            categoryImage: false,
            categoryType: 0,
            isValid: false,
            errorMessage: ''
        };

        _this.isValid = _this.isValid.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onDelete = _this.onDelete.bind(_this);
        return _this;
    }

    _createClass(ManageCategories, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getGameTypes();
            this.getCategories();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.user.isAuthenticated) {
                this.props.history.push('/login');
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();

            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.addCategory({
                    categoryName: this.state.categoryName,
                    categoryImage: this.state.categoryImage,
                    categoryTypeId: this.state.categoryType
                });
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.state.categoryName == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Category Name field is required."
                });
                return false;
            }
            if (!this.state.categoryImage) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select the category image file."
                });
                return false;
            }
            if (this.state.categoryType == 0) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select the category type."
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            switch (e.target.name) {
                case 'categoryImage':
                    {
                        data.append('categoryImage', e.target.files[0]);
                        this.setState({
                            categoryImage: _typeof(e.target.files[0]) == 'object' ? true : false
                        });
                        break;
                    }
                default:
                    {
                        this.setState(_defineProperty({}, e.target.name, e.target.value));
                    }
            }
        }
    }, {
        key: 'addCategory',
        value: function addCategory(cat) {
            var _this2 = this;

            data.append('categoryName', cat.categoryName);
            data.append('categoryTypeId', cat.categoryTypeId);

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/addCategory', data).then(function (response) {
                _this2.props.hide();
                if (response.data.success) {
                    _this2.getCategories();
                }
                _this2.setState({
                    categoryName: '',
                    categoryType: 0,
                    categoryImage: false,
                    isValid: false,
                    errorMessage: ''
                });
            }).catch(function (error) {
                _this2.props.hide();
                (0, _helper.console_log)(error);
                _this2.setState({ isValid: false, errorMessage: 'Sorry, cannot add category right now, please try again later.' });
            });
        }
    }, {
        key: 'getGameTypes',
        value: function getGameTypes() {
            var _this3 = this;

            _axios2.default.get(vars.BASE_URL + '/getCategoryTypes').then(function (response) {
                if (response.data.success) {
                    _this3.props.getGameTypes(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
                _this3.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'getCategories',
        value: function getCategories() {
            var _this4 = this;

            this.props.show();
            _axios2.default.get(vars.BASE_URL + '/getCategories').then(function (response) {
                _this4.props.hide();
                if (response.data.success) {
                    var dataFinal = response.data;
                    var categoriesArr = dataFinal.data;
                    dataFinal = _extends({}, dataFinal, { data: categoriesArr });
                    if (!(_domainConfig.config.subDomain === 'cz' && isGamiclub)) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'E-knihy';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'fr' && isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Heróis Verdes';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    }
                    if (_domainConfig.config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    } else {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Videos Virales';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'rs') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Е-књиге';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'tr' && _domainConfig.config.subDomain !== 'qa' && _domainConfig.config.subDomain !== 'kw') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Facebook';
                        });
                    }
                    _this4.props.getCategories(dataFinal);
                }
            }).catch(function (error) {
                _this4.props.hide();
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'onDelete',
        value: function onDelete(categoryId) {
            var _this5 = this;

            this.props.show();
            _axios2.default.delete(vars.BASE_URL + '/deleteCategories', {
                data: {
                    categoryIds: [categoryId]
                }
            }).then(function (response) {
                _this5.props.hide();
                if (response.data.success) {
                    _this5.getCategories();
                }
            }).catch(function (error) {
                _this5.props.hide();
                (0, _helper.console_log)(error);
                _this5.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            return _react2.default.createElement(
                'div',
                { className: 'manage-categories animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Add Category'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'categoryName' },
                                                'Category Name'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'categoryName', name: 'categoryName', placeholder: 'Category Name', value: this.state.categoryName, onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'categoryImage' },
                                                'Category Image'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'file', id: 'categoryImage', name: 'categoryImage', placeholder: 'Category Image', onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'categoryType' },
                                                'Games Type'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9', size: 'lg' },
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'categoryType', id: 'categoryType', value: this.state.categoryType, onChange: this.onChange },
                                                _react2.default.createElement(
                                                    'option',
                                                    { key: 0, value: '0' },
                                                    'Type'
                                                ),
                                                this.props.categories.gameType.length > 0 ? this.props.categories.gameType.map(function (type) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: type.categoryTypeId, value: type.categoryTypeId },
                                                        type.categoryTypeName
                                                    );
                                                }) : ''
                                            )
                                        )
                                    ),
                                    !this.state.isValid && this.state.errorMessage != '' ? _react2.default.createElement(
                                        _reactstrap.Alert,
                                        { color: 'danger' },
                                        this.state.errorMessage
                                    ) : ''
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'primary', onClick: this.onSubmit },
                                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                                    ' Add'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Table,
                                    { hover: true, responsive: true, size: 'lg', className: 'category-custom-table' },
                                    _react2.default.createElement(
                                        'thead',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox', size: 'lg', id: 'select-all', name: 'select-all', value: 'select-all', className: 'form-control-lg' })
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Category Name'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Total Content'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Category Type'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Actions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.props.categories.categories.length > 0 ? this.props.categories.categories.map(function (data, i) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: i },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement('input', { type: 'checkbox', id: 'category-' + data.categoryId, name: 'category-' + data.categoryId, value: 'category-' + data.categoryId, className: 'form-control-lg' })
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'strong',
                                                        null,
                                                        data.categoryName || ''
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    data.count || 0
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    data.categoryTypeName || ''
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', color: 'success' },
                                                        _react2.default.createElement('i', { className: 'fa fa-edit' })
                                                    ),
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', color: 'danger', onClick: _this6.onDelete.bind(_this6, data.categoryId) },
                                                        _react2.default.createElement('i', { className: 'fa fa-trash' })
                                                    )
                                                )
                                            );
                                        }) : _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: 5 },
                                                'No categories found.'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { color: 'danger' },
                                    _react2.default.createElement('i', { className: 'fa fa-trash' }),
                                    ' Delete All'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ManageCategories;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer,
        categories: state.CategoryReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getGameTypes: _CategoryActions.getGameTypes,
        getCategories: _CategoryActions.getCategories
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageCategories);

/***/ }),

/***/ "./src/components/CategoryGames/CategoryGames.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var kazakhDomain = _domainConfig.config.lang == 'kk' ? true : false;

var CategoryGames = function (_Component) {
    _inherits(CategoryGames, _Component);

    function CategoryGames(props) {
        _classCallCheck(this, CategoryGames);

        var _this = _possibleConstructorReturn(this, (CategoryGames.__proto__ || Object.getPrototypeOf(CategoryGames)).call(this, props));

        _this.shuffle = _this.shuffle.bind(_this);
        _this.applyHuaRule = _this.applyHuaRule.bind(_this);
        _this.applyTRRule = _this.applyTRRule.bind(_this);
        _this.arrayMove = _this.arrayMove.bind(_this);
        return _this;
    }

    _createClass(CategoryGames, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'shuffle',
        value: function shuffle(gameArray) {
            if ((_domainConfig.config.subDomain == 'hua' || _domainConfig.config.subDomain == 'gmn') && gameArray[0].categoryId == 18) {
                return this.applyHuaRule(gameArray);
            }
            if (_domainConfig.config.subDomain == 'tr' && (gameArray[0].categoryId == 18 || gameArray[0].categoryId == 23)) {
                return this.applyTRRule(gameArray, gameArray[0].categoryId);
            }
            var shuffledArray = gameArray.sort(function () {
                return Math.random() - 0.5;
            });
            return shuffledArray;
        }
    }, {
        key: 'applyHuaRule',
        value: function applyHuaRule(gameArray) {
            var gameIdsToBeFirst = [124, 434, 435];
            var result = [];
            for (var i = 0; i < gameArray.length; i++) {
                if (gameArray[i].gameId == gameIdsToBeFirst[0] || gameArray[i].gameId == gameIdsToBeFirst[1] || gameArray[i].gameId == gameIdsToBeFirst[2]) {
                    result = this.arrayMove(gameArray, i, 0);
                }
            }
            return result;
        }
    }, {
        key: 'applyTRRule',
        value: function applyTRRule(gameArray, categoryId) {
            var gameIdsToBeFirst = [];
            if (categoryId == 18) gameIdsToBeFirst = [436];else if (categoryId == 23) gameIdsToBeFirst = [455];
            // const gameIdsToBeFirst = [436];
            var result = [];
            for (var i = 0; i < gameArray.length; i++) {
                if (gameArray[i].gameId == gameIdsToBeFirst[0]) {
                    result = this.arrayMove(gameArray, i, 0);
                }
            }
            return result;
        }
    }, {
        key: 'arrayMove',
        value: function arrayMove(arr, oldIndex, newIndex) {
            if (newIndex >= arr.length) {
                var k = newIndex - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
            return arr;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var category = this.props.category;

            var englishCat = ["Premium Games", "Action", "Adventure", "RPG", "Virtual Reality", "Arcade", "Racing", "Sports"];
            var gamesParams = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500
            };

            var gameRelatedMoreClass = "game-related-more";
            var gameCategoryTitleClass = "game-category-title";
            if (kazakhDomain) {
                gameRelatedMoreClass += ' kz-related-more';
                gameCategoryTitleClass += ' kz-text';
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', className: 'game-related-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'game-related-top' },
                            _react2.default.createElement(
                                'div',
                                { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : _productCondition.isGameflares ? { borderBottom: '1px solid #FF394B' } : _productCondition.isGamiway ? { borderBottom: '1px solid #b347a0' } : null },
                                _react2.default.createElement(
                                    'h2',
                                    { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : _productCondition.isGameflares ? { color: 'white', backgroundColor: '#FF394B' } : _productCondition.isGamiway ? { color: 'white', backgroundColor: '#b347a0' } : null, className: gameCategoryTitleClass },
                                    _react2.default.createElement('i', { className: this.props.category.categoryIcon, 'aria-hidden': 'true' }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + category.categoryName,
                                        defaultMessage: category.categoryName
                                    })
                                ),
                                _react2.default.createElement(
                                    'a',
                                    { className: gameRelatedMoreClass, style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, href: "/#/category/" + this.props.category.categoryId + "?uid=" + this.props.access.uid },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'viewAll',
                                        defaultMessage: 'View All'
                                    })
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Row,
                    { className: 'game-list-row' },
                    this.props.games.length > 0 ? _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12' },
                        _react2.default.createElement(
                            _reactIdSwiper2.default,
                            _extends({}, gamesParams, { shouldSwiperUpdate: true }),
                            this.shuffle(this.props.games).map(function (game) {
                                console.log(game.gameTitle.toUpperCase());
                                return _react2.default.createElement(
                                    'div',
                                    { className: 'swiper-game-card', key: game.gameId },
                                    _react2.default.createElement(
                                        _reactstrap.Card,
                                        { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? "game-card gameflares-card-hover" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card", onClick: _this2.props.onFavoriteClick.bind(_this2, game) },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'game-card-inner' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-thumb-wrap' },
                                                _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-card-details' },
                                                _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                    _reactstrap.CardTitle,
                                                    { className: 'game-title text-shadow' },
                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                        defaultMessage: game.gameTitle })
                                                ),
                                                window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                                                    'div',
                                                    { className: 'custom-rating isFavorite' },
                                                    _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: '', type: 'checkbox', checked: game.isFavorite }),
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                        _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star-o custom-star isFavorite' })
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-left' },
                                                    _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                            return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star' });
                                                        } })
                                                ),
                                                !window.location.hostname.includes('vplay') && _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                    game.gameType.toLowerCase() === "html5" ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : game.gameType.toLowerCase() === "android" ? _react2.default.createElement('i', { className: 'fa fa-android', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' })
                                                )
                                            )
                                        )
                                    )
                                );
                            })
                        )
                    ) : _react2.default.createElement(
                        _reactstrap.Col,
                        { xl: '12', lg: '12', md: '12', sm: '12', xs: '12' },
                        ' ',
                        _react2.default.createElement(
                            'p',
                            { className: 'white-text-color' },
                            window.location.hash.includes('home/video') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noVideosFound', defaultMessage: 'No videos found under this category.' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noGamesFound', defaultMessage: 'No games found under this category.' })
                        )
                    )
                )
            );
        }
    }]);

    return CategoryGames;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CategoryGames);

/***/ }),

/***/ "./src/components/CategoryGames/CategoryGamesDemo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryGamesDemo = function (_Component) {
  _inherits(CategoryGamesDemo, _Component);

  function CategoryGamesDemo(props) {
    _classCallCheck(this, CategoryGamesDemo);

    var _this = _possibleConstructorReturn(this, (CategoryGamesDemo.__proto__ || Object.getPrototypeOf(CategoryGamesDemo)).call(this, props));

    _this.shuffle = _this.shuffle.bind(_this);
    _this.arrayMove = _this.arrayMove.bind(_this);
    _this.doAction = _this.doAction.bind(_this);
    return _this;
  }

  _createClass(CategoryGamesDemo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.scrollTo(0, 0);
    }
  }, {
    key: "shuffle",
    value: function shuffle(gameArray) {
      var shuffledArray = gameArray.sort(function () {
        return Math.random() - 0.5;
      });
      return shuffledArray;
    }
  }, {
    key: "arrayMove",
    value: function arrayMove(arr, oldIndex, newIndex) {
      if (newIndex >= arr.length) {
        var k = newIndex - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
      return arr;
    }
  }, {
    key: "doAction",
    value: function doAction(game, gameIndex) {
      if ((gameIndex === 0 || gameIndex === 1) && (game.categoryName === "New Arrivals" || game.categoryName === "Inspiration")) window.location.href = "#/play-maxis/" + game.gameId;else window.location.href = "#/subscription-maxis/";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var category = this.props.category;


      var gamesParams = {
        direction: "horizontal",
        slidesPerView: "auto",
        speed: 500
      };

      var gameRelatedMoreClass = "game-related-more";
      var gameCategoryTitleClass = "game-category-title";

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _reactstrap.Row,
          null,
          _react2.default.createElement(
            _reactstrap.Col,
            { xs: "12", className: "game-related-container" },
            _react2.default.createElement(
              "div",
              { className: "game-related-top" },
              _react2.default.createElement(
                "div",
                {
                  className: "game-category",
                  style: _isGamiclub.isGamiclub ? { borderBottom: "1px solid green" } : _productCondition.isGameflares ? { borderBottom: "1px solid #FF394B" } : _productCondition.isGamiway ? { borderBottom: "1px solid #b347a0" } : null
                },
                _react2.default.createElement(
                  "h2",
                  {
                    style: _isGamiclub.isGamiclub ? { color: "white", backgroundColor: "green" } : _productCondition.isGameflares ? { color: "white", backgroundColor: "#FF394B" } : _productCondition.isGamiway ? { color: "white", backgroundColor: "#b347a0" } : null,
                    className: gameCategoryTitleClass
                  },
                  _react2.default.createElement("i", {
                    className: this.props.category.categoryIcon,
                    "aria-hidden": "true"
                  }),
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "" + category.categoryName,
                    defaultMessage: category.categoryName
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactstrap.Row,
          { className: "game-list-row" },
          this.props.games.length > 0 ? _react2.default.createElement(
            _reactstrap.Col,
            { xs: "12" },
            _react2.default.createElement(
              _reactIdSwiper2.default,
              _extends({}, gamesParams, { shouldSwiperUpdate: true }),
              this.shuffle(this.props.games).map(function (game, gameIndex) {
                return _react2.default.createElement(
                  "div",
                  { className: "swiper-game-card", key: game.gameId },
                  _react2.default.createElement(
                    _reactstrap.Card,
                    {
                      className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? "game-card gameflares-card-hover" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card",
                      onClick: _this2.doAction.bind(_this2, game, gameIndex)
                    },
                    _react2.default.createElement(
                      "div",
                      { className: "game-card-inner" },
                      _react2.default.createElement(
                        "div",
                        { className: "game-thumb-wrap" },
                        _react2.default.createElement(_reactstrap.CardImg, {
                          className: "game-thumb",
                          top: true,
                          width: "100%",
                          src: game.gameImage.includes("https://cdn.game-lords.com/games/http") ? game.gameImage.split("https://cdn.game-lords.com/games/")[1] : game.gameImage,
                          alt: game.gameTitle
                        })
                      ),
                      _react2.default.createElement(
                        "div",
                        { className: "game-card-details" },
                        _react2.default.createElement(
                          _reactstrap.CardTitle,
                          { className: "game-title text-shadow" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "" + game.gameTitle.toUpperCase(),
                            defaultMessage: game.gameTitle
                          })
                        ),
                        _react2.default.createElement(
                          "div",
                          { className: "game-card-left" },
                          _react2.default.createElement(_reactStarRatingComponent2.default, {
                            name: "rate1",
                            starCount: 5,
                            value: game.userRating,
                            editing: false,
                            renderStarIcon: function renderStarIcon() {
                              return _react2.default.createElement("i", {
                                style: _isGamiclub.isGamiclub ? { color: "green" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                                className: "fa fa-star custom-star"
                              });
                            }
                          })
                        ),
                        _react2.default.createElement(
                          "div",
                          { className: "game-card-right text-uppercase text-shadow text-right" },
                          _react2.default.createElement("i", {
                            className: (gameIndex === 0 || gameIndex === 1) && (game.categoryName === "New Arrivals" || game.categoryName === "Inspiration") ? "fa fa-unlock" : "fa fa-lock",
                            "aria-hidden": "true"
                          })
                        )
                      )
                    )
                  )
                );
              })
            )
          ) : _react2.default.createElement(
            _reactstrap.Col,
            { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" },
            _react2.default.createElement(
              "p",
              { className: "white-text-color" },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "noGamesFound",
                defaultMessage: "No games found under this category."
              })
            )
          )
        )
      );
    }
  }]);

  return CategoryGamesDemo;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    access: state.WelcomeReducer
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CategoryGamesDemo);

/***/ }),

/***/ "./src/components/CategoryList/CategoryList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactOwlCarousel = __webpack_require__("./node_modules/react-owl-carousel/lib/OwlCarousel.js");

var _reactOwlCarousel2 = _interopRequireDefault(_reactOwlCarousel);

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryList = function (_Component) {
    _inherits(CategoryList, _Component);

    function CategoryList(props) {
        _classCallCheck(this, CategoryList);

        return _possibleConstructorReturn(this, (CategoryList.__proto__ || Object.getPrototypeOf(CategoryList)).call(this, props));
    }

    _createClass(CategoryList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
        }

        // shouldComponentUpdate(nextProps, nextState) {
        //     return false;
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var gametype = this.props.gametype;

            var currentLanguage = this.props.access.currentLang;
            var categories = void 0;
            var loopvalue = false;
            if (window.location.hash.indexOf('html') >= 0) {
                categories = this.props.categories.categories.filter(function (item) {
                    //console.log(item);
                    if (item.categoryTypeName == 'HTML5') {
                        if (item.categoryName == "New Arrivals") {
                            item.categoryImage = "https://cdn.game-lords.com/new+games/new-arrivals.png";
                        } else if (item.categoryName == "Action") {
                            item.categoryImage = "https://cdn.game-lords.com/new+games/action.png";
                        } else if (item.categoryName == "Adventure") {
                            item.categoryImage = "https://cdn.game-lords.com/new+games/adventure.png";
                        } else if (item.categoryName == "Arcade") {
                            item.categoryImage = "https://cdn.game-lords.com/new+games/arcade.png";
                        }
                        return item;
                    }
                });
            } else if (window.location.hash.indexOf('video') >= 0) {
                categories = this.props.categories.categories.filter(function (item) {
                    if (item.categoryTypeName == 'VIDEO') {
                        return item;
                    }
                });
            } else {
                categories = this.props.categories.categories.filter(function (item) {
                    if (item.categoryTypeName == 'ANDROID') {
                        if (_isGamiclub.isGamiclub && _domainConfig.config.subDomain === 'fr' && item.categoryId === 4) {
                            item.categoryName = "Action (18+)";
                        }
                        return item;
                    }
                });
            }
            if (categories.length > 3) {
                loopvalue = true;
            }
            if (categories && categories.length > 0) {
                return _react2.default.createElement(
                    _reactOwlCarousel2.default,
                    { loop: loopvalue, margin: 30, items: 50, dots: false, nav: false, center: false, autoWidth: true },
                    categories.map(function (c, k) {
                        return c.categoryTypeName.toLowerCase() == gametype ? _react2.default.createElement(
                            'div',
                            { key: k, className: 'item' },
                            _react2.default.createElement(
                                'div',
                                { className: _isGamiclub.isGamiclub ? "category-box-gamiclub" : _productCondition.isGameflares ? "category-box gameflares-category-box" : _productCondition.isGamiway ? "category-box gamiway-category-box" : "category-box" },
                                _react2.default.createElement('img', { src: c.categoryImage, alt: c.categoryNameTranslated }),
                                _react2.default.createElement('div', { className: _isGamiclub.isGamiclub ? "category-box-inner-gamiclub" : _productCondition.isGameflares ? "category-box-inner gameflares-category-box-inner" : _productCondition.isGamiway ? "category-box-inner gamiway-category-box-inner" : "category-box-inner" }),
                                _react2.default.createElement(
                                    'a',
                                    { className: 'category-box-btn', href: '/#/category/' + c.categoryId + "?uid=" + _this2.props.access.uid },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'category-box-type text-uppercase' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + c.categoryName,
                                            defaultMessage: c.categoryName
                                        })
                                    )
                                )
                            )
                        ) : null;
                    })
                );
            } else return null;
        }
    }]);

    return CategoryList;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        domains: state.DomainReducer,
        country: state.CountryReducer,
        categories: state.CategoryReducer,
        games: state.GamesReducer,
        access: state.WelcomeReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getGames: _GamesActions.getGames,
        getCategories: _CategoryActions.getCategories,
        getFavouriteGames: _GamesActions.getFavouriteGames,
        setFavouriteGames: _GamesActions.setFavouriteGames,
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CategoryList);

/***/ }),

/***/ "./src/components/Country/AddCountryLanguage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CountryActions = __webpack_require__("./src/actions/CountryActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddCountryLanguage = function (_Component) {
    _inherits(AddCountryLanguage, _Component);

    function AddCountryLanguage(props) {
        _classCallCheck(this, AddCountryLanguage);

        var _this = _possibleConstructorReturn(this, (AddCountryLanguage.__proto__ || Object.getPrototypeOf(AddCountryLanguage)).call(this, props));

        _this.state = {
            country: 0,
            languages: [],
            subDomain: '',
            domainIds: [],
            domainId: 0,
            domain: '',
            url: '',
            isValid: false,
            errorMessage: ''
        };

        _this.onChange = _this.onChange.bind(_this);
        _this.cancel = _this.cancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        return _this;
    }

    _createClass(AddCountryLanguage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getCountries();
            this.getLanguages();

            this.setState({
                country: this.props.country.countryManagement.countryId,
                languages: this.props.country.countryManagement.language.map(function (l) {
                    return l.languageId;
                }),
                domainIds: this.props.country.countryManagement.domain.map(function (d) {
                    return d.domainId;
                })
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.user.isAuthenticated) {
                this.props.history.push('/login');
            }
        }
    }, {
        key: 'getCountries',
        value: function getCountries() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getCountries').then(function (response) {
                if (response.data.success) {
                    _this2.props.getCountries(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
            });
        }
    }, {
        key: 'getLanguages',
        value: function getLanguages() {
            var _this3 = this;

            _axios2.default.get(vars.BASE_URL + '/getLanguages').then(function (response) {
                if (response.data.success) {
                    _this3.props.getLanguages(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            if (e.target.name == 'subdomainname') {
                var url = this.state.domain != '' ? this.state.domain.split('_')[1] : '';
                this.setState({
                    subDomain: e.target.value,
                    url: e.target.value + '.' + url
                });
            } else {
                if (e.target.value != 0) {
                    this.setState({
                        domain: e.target.value,
                        domainId: e.target.value.split('_')[0],
                        url: this.state.subDomain + '.' + e.target.value.split('_')[1]
                    });
                }
            }
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.props.history.goBack();
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.state.subDomain === '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Subdomain cannot be blank"
                });
                return false;
            }

            if (this.state.domainId === 0) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select a domain to map subdomain."
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();

            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.addSubdomain({
                    domainId: this.state.domainId,
                    subDomainName: this.state.subDomain
                });
            }
        }
    }, {
        key: 'addSubdomain',
        value: function addSubdomain(data) {
            var _this4 = this;

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/addSubDomain', data).then(function (response) {
                _this4.props.hide();
                if (response.data.success) {
                    _this4.props.history.goBack();
                    _this4.setState({
                        domainId: 0,
                        isValid: false,
                        errorMessage: ''
                    });
                }
            }).catch(function (error) {
                _this4.props.hide();
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Unable to post data.' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            (0, _helper.console_log)("Props", this.props);
            return _react2.default.createElement(
                'div',
                { className: 'addcountrylanguage animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Edit Country'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '4' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'countryname' },
                                                'Country Name'
                                            ),
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', id: 'countryname', name: 'countryname', value: this.state.country, placeholder: 'Country Name', disabled: true },
                                                this.props.country.countries.length > 0 ? this.props.country.countries.map(function (c, k) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: c.countryId, value: c.countryId },
                                                        c.name
                                                    );
                                                }) : ''
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '4' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'language' },
                                                'Language'
                                            ),
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'language', id: 'language', value: this.state.languages, multiple: true, disabled: true },
                                                this.props.country.languages.length > 0 ? this.props.country.languages.map(function (l, k) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: l.languageId, value: l.languageId },
                                                        l.englishName
                                                    );
                                                }) : ''
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Add Sub Domain and Details'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '4' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'subdomainname' },
                                                'Sub Domain Name'
                                            ),
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'subdomainname', name: 'subdomainname', value: this.state.subDomain, onChange: this.onChange, placeholder: 'Sub Domain Name' })
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '4' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'selectdomain' },
                                                'Domain URL'
                                            ),
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'selectdomain', id: 'selectdomain', value: this.state.domain, onChange: this.onChange },
                                                _react2.default.createElement(
                                                    'option',
                                                    { key: 0, value: 0 },
                                                    'Select Domain'
                                                ),
                                                this.props.country.countryManagement.domain.length > 0 ? this.props.country.countryManagement.domain.map(function (d) {
                                                    var url = d.domainUrl.split('//')[1];
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: d.domainId, value: d.domainId + '_' + url },
                                                        d.domainUrl
                                                    );
                                                }) : ''
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '4' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'url' },
                                                'URL'
                                            ),
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'url', name: 'url', value: this.state.url, disabled: true })
                                        )
                                    ),
                                    !this.state.isValid && this.state.errorMessage != '' ? _react2.default.createElement(
                                        _reactstrap.Alert,
                                        { color: 'danger' },
                                        this.state.errorMessage
                                    ) : ''
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'primary', onClick: this.cancel },
                                    _react2.default.createElement('i', { className: 'fa fa-times' }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel',
                                        defaultMessage: ' Cancel'
                                    })
                                ),
                                ' ',
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'success', onClick: this.onSubmit },
                                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save',
                                        defaultMessage: ' Save'
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AddCountryLanguage;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getCountries: _CountryActions.getCountries,
        getLanguages: _CountryActions.getLanguages
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddCountryLanguage);

/***/ }),

/***/ "./src/components/Country/Country.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CountryActions = __webpack_require__("./src/actions/CountryActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Country = function (_Component) {
    _inherits(Country, _Component);

    function Country(props) {
        _classCallCheck(this, Country);

        var _this = _possibleConstructorReturn(this, (Country.__proto__ || Object.getPrototypeOf(Country)).call(this, props));

        _this.state = {
            country: 0,
            languages: [],
            isValid: false,
            errorMessage: ''
        };

        _this.isValid = _this.isValid.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onMultiSelectChange = _this.onMultiSelectChange.bind(_this);
        return _this;
    }

    _createClass(Country, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getCountries();
            this.getLanguages();
            this.getCountryDomainAndSubDomain();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.user.isAuthenticated) {
                this.props.history.push('/login');
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            this.setState(_defineProperty({}, e.target.name, e.target.value));
        }
    }, {
        key: 'onMultiSelectChange',
        value: function onMultiSelectChange(e) {
            var languages = Array.prototype.slice.call(e.target.selectedOptions).map(function (o) {
                return o.value;
            });

            this.setState({
                languages: languages
            });
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.state.country === 0) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select a country."
                });
                return false;
            }
            if (this.state.languages.length <= 0) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select a language."
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();

            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.addCountryLanguage({
                    countryId: this.state.country,
                    languageIds: this.state.languages
                });
            }
        }
    }, {
        key: 'getCountries',
        value: function getCountries() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getCountries').then(function (response) {
                if (response.data.success) {
                    _this2.props.getCountries(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
            });
        }
    }, {
        key: 'getLanguages',
        value: function getLanguages() {
            var _this3 = this;

            _axios2.default.get(vars.BASE_URL + '/getLanguages').then(function (response) {
                if (response.data.success) {
                    _this3.props.getLanguages(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
            });
        }
    }, {
        key: 'addCountryLanguage',
        value: function addCountryLanguage(data) {
            var _this4 = this;

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/addCountryLanguage', data).then(function (response) {
                _this4.props.hide();
                if (response.data.success) {
                    _this4.getCountryDomainAndSubDomain();
                    _this4.setState({
                        country: 0,
                        isValid: false,
                        errorMessage: ''
                    });
                }
            }).catch(function (error) {
                _this4.props.hide();
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Unable to post data.' });
            });
        }
    }, {
        key: 'getCountryDomainAndSubDomain',
        value: function getCountryDomainAndSubDomain() {
            var _this5 = this;

            this.props.show();
            _axios2.default.get(vars.BASE_URL + '/getCountryDomainAndSubDomain').then(function (response) {
                _this5.props.hide();
                if (response.data.success) {
                    _this5.props.getCountryDomainAndSubDomain(response.data);
                }
            }).catch(function (error) {
                _this5.props.hide();
                (0, _helper.console_log)(error);
            });
        }
    }, {
        key: 'countryDetails',
        value: function countryDetails(data) {
            this.props.openCountryDetail(data);
            this.props.history.push('/manage-country');
        }
    }, {
        key: 'countryDelete',
        value: function countryDelete(data) {
            var _this6 = this;

            this.props.show();
            _axios2.default.delete(vars.BASE_URL + '/deleteCountryLanguage', { data: {
                    countryId: data.countryId
                } }).then(function (response) {
                _this6.props.hide();
                if (response.data.success) {
                    _this6.getCountryDomainAndSubDomain();
                }
            }).catch(function (error) {
                _this6.props.hide();
                (0, _helper.console_log)(error);
                _this6.setState({ isValid: false, errorMessage: 'Sorry, cannot delete country right now, please try again later.' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            return _react2.default.createElement(
                'div',
                { className: 'country animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Add Country'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'country' },
                                                'Country Name'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9', size: 'lg' },
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'country', id: 'country', value: this.state.country, onChange: this.onChange },
                                                _react2.default.createElement(
                                                    'option',
                                                    { key: 0, value: 0 },
                                                    'Country Name'
                                                ),
                                                this.props.country.countries.length > 0 ? this.props.country.countries.map(function (country, k) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: country.countryId, value: country.countryId },
                                                        country.name
                                                    );
                                                }) : ''
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'languages' },
                                                'Multiple select'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '9' },
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'languages', id: 'languages', defaultValue: [], onChange: this.onMultiSelectChange, multiple: true },
                                                this.props.country.languages.length > 0 ? this.props.country.languages.map(function (language, k) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: language.languageId, value: language.languageId },
                                                        language.englishName
                                                    );
                                                }) : ''
                                            )
                                        )
                                    ),
                                    !this.state.isValid && this.state.errorMessage != '' ? _react2.default.createElement(
                                        _reactstrap.Alert,
                                        { color: 'danger' },
                                        this.state.errorMessage
                                    ) : ''
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'primary', onClick: this.onSubmit },
                                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                                    ' Add'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Table,
                                    { hover: true, responsive: true, size: 'lg', className: 'country-custom-table' },
                                    _react2.default.createElement(
                                        'thead',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Country'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Language'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Domain'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Sub-Domain'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Actions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.props.country.countryDomain.length > 0 ? this.props.country.countryDomain.map(function (v, k) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: k },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'strong',
                                                        null,
                                                        v.country
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    v.language.map(function (l) {
                                                        return _react2.default.createElement(
                                                            'span',
                                                            { key: l.languageId, className: 'gray-highlight' },
                                                            l.languageCode
                                                        );
                                                    })
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    v.domain.map(function (d) {
                                                        return _react2.default.createElement(
                                                            'span',
                                                            { key: d.domainId, className: 'mr-2' },
                                                            d.domainUrl
                                                        );
                                                    })
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    v.subDomain.map(function (s) {
                                                        return _react2.default.createElement(
                                                            'span',
                                                            { key: s.subDomainId, className: 'green-highlight' },
                                                            s.subDomainName
                                                        );
                                                    })
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', color: 'success', onClick: _this7.countryDetails.bind(_this7, v) },
                                                        _react2.default.createElement('i', { className: 'fa fa-edit' })
                                                    ),
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', color: 'danger', onClick: _this7.countryDelete.bind(_this7, v) },
                                                        _react2.default.createElement('i', { className: 'fa fa-trash' })
                                                    )
                                                )
                                            );
                                        }) : _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                'No Countries added yet.'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Country;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getCountries: _CountryActions.getCountries,
        getLanguages: _CountryActions.getLanguages,
        getCountryDomainAndSubDomain: _CountryActions.getCountryDomainAndSubDomain,
        openCountryDetail: _CountryActions.openCountryDetail
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Country);

/***/ }),

/***/ "./src/components/CountryModal/CountryModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _CountryActions = __webpack_require__("./src/actions/CountryActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountryModal = function (_Component) {
    _inherits(CountryModal, _Component);

    function CountryModal(props) {
        _classCallCheck(this, CountryModal);

        var _this = _possibleConstructorReturn(this, (CountryModal.__proto__ || Object.getPrototypeOf(CountryModal)).call(this, props));

        _this.state = {
            countriesArray: {},
            all: false
        };
        _this.selectAllCountries = _this.selectAllCountries.bind(_this);
        _this.selectCountries = _this.selectCountries.bind(_this);
        _this.mapCountryDomain = _this.mapCountryDomain.bind(_this);
        _this.modalToggle = _this.modalToggle.bind(_this);
        return _this;
    }

    _createClass(CountryModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getCountries();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var countriesArray = [];
            if (this.props.country.countries.length > 0) {
                this.props.country.countries.map(function (v) {
                    countriesArray[v.countryId] = false;
                });
            }

            this.setState({
                countriesArray: countriesArray
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var countriesArray = this.state.countriesArray,
                all = false;
            if (countriesArray.length > 0) {
                countriesArray.map(function (v, k) {
                    if (nextProps.countries.indexOf(k) !== -1) {
                        countriesArray[k] = true;
                    } else {
                        countriesArray[k] = false;
                    }
                });
            }

            if (this.state.countriesArray.length - 1 === countriesArray.filter(function (v) {
                return v === true;
            }).length) {
                all = true;
            }

            this.setState({
                countriesArray: countriesArray,
                all: all
            });
        }
    }, {
        key: 'getCountries',
        value: function getCountries() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getCountries').then(function (response) {
                if (response.data.success) {
                    _this2.props.getCountries(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
            });
        }
    }, {
        key: 'selectAllCountries',
        value: function selectAllCountries(e) {
            var _this3 = this;

            var countriesArray = this.state.countriesArray;
            if (countriesArray.length > 0) {
                countriesArray.forEach(function (v, k) {
                    countriesArray[k] = !_this3.state.all;
                });
            }

            this.setState({
                countriesArray: countriesArray,
                all: !this.state.all
            });
        }
    }, {
        key: 'selectCountries',
        value: function selectCountries(countryId, e) {
            var countriesArray = this.state.countriesArray,
                all = false;
            countriesArray[countryId] = e.target.checked;

            if (this.state.countriesArray.length - 1 === countriesArray.filter(function (v) {
                return v === true;
            }).length) {
                all = true;
            }
            this.setState({
                countriesArray: countriesArray,
                all: all
            });
        }
    }, {
        key: 'mapCountryDomain',
        value: function mapCountryDomain() {
            var _this4 = this;

            var countriesArray = this.state.countriesArray,
                data = [];

            countriesArray.forEach(function (v, k) {
                if (v) {
                    data.push({
                        domainId: _this4.props.domainId,
                        countryId: k
                    });
                }
            });

            this.props.mapCountryDomain(data);
            this.modalToggle();
        }
    }, {
        key: 'modalToggle',
        value: function modalToggle() {
            this.props.modalToggle({
                domainId: 0,
                countries: []
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            // console_log(this.props.countries);
            return _react2.default.createElement(
                _reactstrap.Modal,
                { isOpen: this.props.show, toggle: this.modalToggle, className: 'modal-lg' },
                _react2.default.createElement(
                    _reactstrap.ModalHeader,
                    { toggle: this.modalToggle },
                    'Edit Domain'
                ),
                _react2.default.createElement(
                    _reactstrap.ModalBody,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: 3, md: 3 },
                            _react2.default.createElement(
                                _reactstrap.Label,
                                { check: true, htmlFor: 'country-all' },
                                _react2.default.createElement(_reactstrap.Input, { type: 'checkbox', id: 'country-all', checked: this.state.all, name: 'country-all', value: 'all', onChange: this.selectAllCountries }),
                                ' All'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        this.props.country.countries ? this.props.country.countries.map(function (country, key) {
                            return _react2.default.createElement(
                                _reactstrap.Col,
                                { key: country.countryId, xs: 3, md: 3 },
                                _react2.default.createElement(
                                    _reactstrap.Label,
                                    { check: true, htmlFor: country.countryId },
                                    _react2.default.createElement(_reactstrap.Input, { className: 'country', type: 'checkbox',
                                        id: country.countryId,
                                        name: country.countryId,
                                        value: country.countryId,
                                        checked: _this5.state.countriesArray[country.countryId],
                                        onChange: _this5.selectCountries.bind(_this5, country.countryId) }),
                                    ' ',
                                    country.name,
                                    ' (',
                                    country.code,
                                    ')'
                                )
                            );
                        }) : ''
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.ModalFooter,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Button,
                        { color: 'danger', onClick: this.modalToggle },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    ' ',
                    _react2.default.createElement(
                        _reactstrap.Button,
                        { color: 'success', onClick: this.mapCountryDomain },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save',
                            defaultMessage: ' Save'
                        })
                    )
                )
            );
        }
    }]);

    return CountryModal;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getCountries: _CountryActions.getCountries
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CountryModal);

/***/ }),

/***/ "./src/components/DemoPage/DemoMaxisWelcome.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _Banner = __webpack_require__("./src/components/Banner/Banner.js");

var _Banner2 = _interopRequireDefault(_Banner);

var _HeaderActions = __webpack_require__("./src/actions/HeaderActions.js");

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DemoMaxisWelcome = function (_Component) {
  _inherits(DemoMaxisWelcome, _Component);

  function DemoMaxisWelcome(props) {
    _classCallCheck(this, DemoMaxisWelcome);

    var _this = _possibleConstructorReturn(this, (DemoMaxisWelcome.__proto__ || Object.getPrototypeOf(DemoMaxisWelcome)).call(this, props));

    _this.state = {
      dataSent: false
    };
    return _this;
  }

  _createClass(DemoMaxisWelcome, [{
    key: "componentWillMount",
    value: function componentWillMount() {}
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add("welcome-page-body", "maxis-welcome-page-body");
      this.props.setHeaderTitle("!Más de 300 juegos html5 online!");
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _sendData.sendData)("", "", "", "viewed", { page: "homepage" });
      document.body.classList.remove("welcome-page-body");
    }
  }, {
    key: "render",
    value: function render() {
      var androidBtnStyle = {};

      var banner = [{
        imgUrl: "./img/Welcome-Page.png",
        offer: "",
        game_name: "",
        category_name: ""
      }];
      console.log("welcome here");

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "welcome-page" },
          _react2.default.createElement(_Banner2.default, { bannerData: banner }),
          _react2.default.createElement(
            "div",
            { className: "category-options-wrap" },
            _react2.default.createElement(
              "div",
              { className: "category-options-inner" },
              _react2.default.createElement(
                _reactstrap.Row,
                { className: "justify-content-center" },
                _react2.default.createElement(
                  _reactstrap.Col,
                  { xs: "12" },
                  _react2.default.createElement(
                    "h6",
                    { className: "explore-text white-text-color" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "welcome.text.gamiclub",
                      defaultMessage: "EXPLORE THE BEST CONTENT ONLINE TODAY!"
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _reactstrap.Row,
                { className: "justify-content-center" },
                _react2.default.createElement(
                  _reactstrap.Col,
                  null,
                  _react2.default.createElement(
                    "div",
                    { className: "buttons-wrap" },
                    _react2.default.createElement(
                      "div",
                      { className: "games-btn" },
                      _react2.default.createElement(
                        "a",
                        { href: "#/demo-maxis/html" },
                        _react2.default.createElement("i", { className: "fa fa-html5 fa-gradient-gamiclub", "aria-hidden": "true" }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "html5", defaultMessage: "HTML5" }),
                          _react2.default.createElement(
                            "span",
                            { style: { color: "lightgreen" }, className: "games-text" },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "games",
                              defaultMessage: "games"
                            })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      "div",
                      { className: "games-btn", style: androidBtnStyle },
                      _react2.default.createElement(
                        "a",
                        { href: "#/demo-maxis/android" },
                        _react2.default.createElement("i", { className: "fa fa-html5 fa-gradient-gamiclub", "aria-hidden": "true" }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "android-upper", defaultMessage: "ANDROID" }),
                          _react2.default.createElement(
                            "span",
                            { style: { color: "lightgreen" }, className: "games-text" },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "games",
                              defaultMessage: "games"
                            })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      "div",
                      { className: "games-btn" },
                      _react2.default.createElement(
                        "a",
                        { href: "#/demo-maxis/video" },
                        _react2.default.createElement("i", {
                          className: "fa fa-video-camera fa-gradient-gamiclub",
                          "aria-hidden": "true"
                        }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "videos",
                            defaultMessage: "VIDEOS"
                          }),
                          _react2.default.createElement(
                            "span",
                            {
                              style: { color: "lightgreen" },
                              className: "games-text"
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "vid-player",
                              defaultMessage: "player"
                            })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactstrap.Row,
                { className: "justify-content-center" },
                _react2.default.createElement(
                  _reactstrap.Col,
                  { xs: "12" },
                  _react2.default.createElement(
                    "h6",
                    { className: "white-text-color kazakh-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "kazakhOnly", defaultMessage: " " })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DemoMaxisWelcome;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    access: state.WelcomeReducer,
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    checkAccess: _WelcomeActions.checkAccess,
    getDetails: _AccountActions.getDetails,
    getInterests: _AccountActions.getInterests,
    setHeaderTitle: _HeaderActions.setHeaderTitle
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DemoMaxisWelcome);

/***/ }),

/***/ "./src/components/DemoPage/DemoPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _SearchActions = __webpack_require__("./src/actions/SearchActions.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _Banner = __webpack_require__("./src/components/Banner/Banner.js");

var _Banner2 = _interopRequireDefault(_Banner);

var _CategoryGames = __webpack_require__("./src/components/CategoryGames/CategoryGames.js");

var _CategoryGames2 = _interopRequireDefault(_CategoryGames);

var _messages = __webpack_require__("./src/constants/messages.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CategoryList = __webpack_require__("./src/components/CategoryList/CategoryList.js");

var _CategoryList2 = _interopRequireDefault(_CategoryList);

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _CategoryGamesDemo = __webpack_require__("./src/components/CategoryGames/CategoryGamesDemo.js");

var _CategoryGamesDemo2 = _interopRequireDefault(_CategoryGamesDemo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var msg = _messages.messages;

var DemoPage = function (_Component) {
  _inherits(DemoPage, _Component);

  function DemoPage(props) {
    _classCallCheck(this, DemoPage);

    var _this = _possibleConstructorReturn(this, (DemoPage.__proto__ || Object.getPrototypeOf(DemoPage)).call(this, props));

    _this.state = {
      gameType: "",
      switcherState: false,
      loading: true
    };
    _this.openGame = _this.openGame.bind(_this);
    return _this;
  }

  _createClass(DemoPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.games.games.length <= 0) {}
      if (this.props.history.location.pathname.split('/')[2] == 'html') {
        this.setState({
          gameType: 'html5'
        });
      } else if (this.props.history.location.pathname.split('/')[2] == 'android') {
        this.setState({
          gameType: 'android'
        });
      } else if (this.props.history.location.pathname.split('/')[2] == 'video' && (_isGamiclub.isGamiclub || _domainConfig.config.subDomain === 'za' || _domainConfig.config.subDomain === 'kw' || _domainConfig.config.subDomain === 'pt')) {
        this.setState({
          gameType: 'video'
        });
      } else {
        this.props.history.push("/maxis-welcome");
      }
      this.props.searchText("");
      if (this.props.categories.categories) this.setState({ categoriesTranslated: true });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.categories.categories) this.setState({ categoriesTranslated: true });
      window.scrollTo(0, 0);
    }
  }, {
    key: "openGame",
    value: function openGame(game, e) {
      e.preventDefault();
      if (e.target.tagName != "INPUT") {
        this.props.history.push((0, _helper.appendUid)("/play-maxis/" + game.gameId, this.props.access.uid));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var bannerData = void 0;
      var htmlBannerDataMobile = void 0;
      var htmlBannerData = void 0;
      console.log("gametype - ", this.state.gameType);
      if (this.state.gameType == "html5") {
        htmlBannerData = [{
          //imgUrl: './img/html5-banner.jpg',
          imgUrl: "./img/my-html5-banner-new.png",
          offer: null,
          game_name: "",
          category_name: "",
          //id: 34
          id: 26
        }];
        htmlBannerDataMobile = [{
          //imgUrl: './img/mobile-html5-banner.jpg',
          imgUrl: "./img/my-html5-banner-new.png",
          offer: null,
          game_name: "",
          category_name: "",
          //id: 34
          id: 26
        }];

        if (_domainConfig.config.subDomain == "my") {
          htmlBannerData[0].imgUrl = "./img/my-html5-banner-new.png";
          htmlBannerDataMobile[0].imgUrl = "./img/my-html5-banner-new.png";
          htmlBannerData[0].id = 26;
          htmlBannerDataMobile[0].id = 26;
        }

        if (window.innerWidth <= 575) {
          bannerData = htmlBannerDataMobile;
        } else {
          bannerData = htmlBannerData;
        }
      } else if (this.state.gameType == 'video') {
        bannerData = [{
          imgUrl: './img/gamiclub-banner.png',
          offer: null,
          game_name: '',
          category_name: '',
          id: undefined
        }];
      } else {
        var androidBannerData = void 0,
            androidBannerDataMobile = void 0;
        androidBannerData = [{
          imgUrl: "./img/android-banner.jpg",
          offer: null,
          game_name: "",
          category_name: "",
          id: 122
        }];
        androidBannerDataMobile = [{
          imgUrl: "./img/mobile-android-banner.jpg",
          offer: null,
          game_name: "",
          category_name: "",
          id: 122
        }];

        if (window.innerWidth <= 575) {
          bannerData = androidBannerDataMobile;
        } else {
          bannerData = androidBannerData;
        }
      }

      return _react2.default.createElement(
        "div",
        { className: "home-page" },
        _react2.default.createElement(_Banner2.default, { bannerData: bannerData }),
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            "div",
            null,
            this.props.categories.categories.length > 0 ? this.props.categories.categories.map(function (category, index) {
              if (category.categoryTypeName.toLowerCase() == _this2.state.gameType) {
                return _react2.default.createElement(_CategoryGamesDemo2.default, {
                  key: index,
                  index: index,
                  category: category,
                  games: _this2.props.games.games.length > 0 && _this2.props.games.games.filter(function (g) {
                    return g.categoryId == category.categoryId;
                  }).length > 0 ? _this2.props.games.games.filter(function (g) {
                    return g.categoryId == category.categoryId;
                  }) : [],
                  onFavoriteClick: _this2.openGame
                });
              }
            }) : ""
          )
        )
      );
    }
  }]);

  return DemoPage;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    access: state.WelcomeReducer,
    domains: state.DomainReducer,
    country: state.CountryReducer,
    categories: state.CategoryReducer,
    games: state.GamesReducer,
    flashmessage: state.FlashMessageReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getGames: _GamesActions.getGames,
    getFavouriteGames: _GamesActions.getFavouriteGames,
    setFavouriteGames: _GamesActions.setFavouriteGames,
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    showMessage: _FlashMessageActions.showMessage,
    searchText: _SearchActions.searchText
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DemoPage);

/***/ }),

/***/ "./src/components/Domain/Domain.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _DomainActions = __webpack_require__("./src/actions/DomainActions.js");

var _CountryModal = __webpack_require__("./src/components/CountryModal/CountryModal.js");

var _CountryModal2 = _interopRequireDefault(_CountryModal);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Domain = function (_Component) {
    _inherits(Domain, _Component);

    function Domain(props) {
        _classCallCheck(this, Domain);

        var _this = _possibleConstructorReturn(this, (Domain.__proto__ || Object.getPrototypeOf(Domain)).call(this, props));

        _this.state = {
            domainName: '',
            domainUrl: '',
            isValid: false,
            errorMessage: '',
            countryModal: false,
            domainId: 0,
            countries: []
        };
        _this.isValid = _this.isValid.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.deleteDomain = _this.deleteDomain.bind(_this);
        _this.onChangeEnabled = _this.onChangeEnabled.bind(_this);
        _this._getCountryModalToggle = _this._getCountryModalToggle.bind(_this);
        _this.mapCountryDomain = _this.mapCountryDomain.bind(_this);
        return _this;
    }

    _createClass(Domain, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDomains();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.user.isAuthenticated) {
                this.props.history.push((0, _helper.appendUid)('/login', this.props.access.uid));
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            var url = new RegExp('^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$');

            if (this.state.domainName == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Domain Name field is required."
                });
                return false;
            }
            if (this.state.domainUrl == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Domain URL field is required."
                });
                return false;
            }
            if (!url.test(this.state.domainUrl)) {
                this.setState({
                    isValid: false,
                    errorMessage: "Domain URL is not valid."
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();

            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.addDomain({
                    domainName: this.state.domainName,
                    url: this.state.domainUrl
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            this.setState(_defineProperty({}, e.target.name, e.target.value));
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode == 13) {
                if (this.isValid()) {
                    this.setState({ isValid: true, errorMessage: '' });
                    this.addDomain({
                        domainName: this.state.domainName,
                        url: this.state.domainUrl
                    });
                }
            }
        }
    }, {
        key: 'addDomain',
        value: function addDomain(data) {
            var _this2 = this;

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/addDomain', data).then(function (response) {
                _this2.props.hide();
                if (response.data.success) {
                    _this2.getDomains();
                }
                _this2.setState({
                    domainName: '',
                    domainUrl: '',
                    isValid: false,
                    errorMessage: '',
                    domainId: 0,
                    countries: []
                });
            }).catch(function (error) {
                _this2.props.hide();
                (0, _helper.console_log)(error);
                _this2.setState({ isValid: false, errorMessage: 'Sorry, cannot add domain right now, please try again later.' });
            });
        }
    }, {
        key: 'getDomains',
        value: function getDomains() {
            var _this3 = this;

            this.props.show();
            _axios2.default.get(vars.BASE_URL + '/getDomain').then(function (response) {
                _this3.props.hide();
                if (response.data.success) {
                    _this3.props.getDomains(response.data);
                }
            }).catch(function (error) {
                _this3.props.hide();
                (0, _helper.console_log)(error);
                _this3.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'deleteDomain',
        value: function deleteDomain(domainId) {
            var _this4 = this;

            this.props.show();
            _axios2.default.delete(vars.BASE_URL + '/deleteDomain', { data: { 'domainId': domainId } }).then(function (response) {
                _this4.props.hide();
                if (response.data.success) {
                    _this4.getDomains();
                }
            }).catch(function (error) {
                _this4.props.hide();
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Sorry, cannot delete domain right now, please try again later.' });
            });
        }
    }, {
        key: 'onChangeEnabled',
        value: function onChangeEnabled(domain) {
            var _this5 = this;

            domain.isEnabled = !domain.isEnabled;
            this.props.show();
            _axios2.default.put(vars.BASE_URL + '/setDomain', domain).then(function (response) {
                _this5.props.hide();
                if (response.data.success) {
                    _this5.getDomains();
                }
            }).catch(function (error) {
                _this5.props.hide();
                (0, _helper.console_log)(error);
                _this5.setState({ isValid: false, errorMessage: 'Sorry, cannot update domain right now, please try again later.' });
            });
        }
    }, {
        key: '_getCountryModalToggle',
        value: function _getCountryModalToggle(domain) {
            this.setState({
                countryModal: !this.state.countryModal,
                domainId: domain.domainId,
                countries: domain.countries
            });
        }
    }, {
        key: 'mapCountryDomain',
        value: function mapCountryDomain(data) {
            var _this6 = this;

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/mapCountriesToDomain', data).then(function (response) {
                _this6.props.hide();
                if (response.data.success) {
                    _this6.getDomains();
                }
            }).catch(function (error) {
                _this6.props.hide();
                (0, _helper.console_log)(error);
                _this6.setState({ isValid: false, errorMessage: 'Sorry, cannot map country to domain right now, please try again later.' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            return _react2.default.createElement(
                'div',
                { className: 'domain animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Add Domain'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'domainName' },
                                                'Domain Name'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'domainName', name: 'domainName', placeholder: 'Domain Name', value: this.state.domainName, onChange: this.onChange, onKeyUp: this.onKeyUp })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'domainUrl' },
                                                'URL'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'domainUrl', name: 'domainUrl', placeholder: 'URL (Ex. http://game-lords.com)', value: this.state.domainUrl, onChange: this.onChange, onKeyUp: this.onKeyUp })
                                        )
                                    ),
                                    !this.state.isValid && this.state.errorMessage != '' ? _react2.default.createElement(
                                        _reactstrap.Alert,
                                        { color: 'danger' },
                                        this.state.errorMessage
                                    ) : ''
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'primary', onClick: this.onSubmit },
                                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                                    ' Add'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Table,
                                    { hover: true, responsive: true, size: 'lg', className: 'domain-custom-table' },
                                    _react2.default.createElement(
                                        'thead',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Domain'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'URL'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Country'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Enabled'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Actions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.props.domains.domains.length > 0 ? this.props.domains.domains.map(function (v, k) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: k },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'strong',
                                                        null,
                                                        v.domainName
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    v.url
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    v.countryData.length > 0 ? v.countryData.map(function (country, i) {
                                                        return _react2.default.createElement(
                                                            'span',
                                                            { key: i, className: 'gray-highlight' },
                                                            ' ',
                                                            country.countryCode,
                                                            ' '
                                                        );
                                                    }) : ''
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        _reactstrap.Label,
                                                        { className: 'switch switch-text switch-pill switch-success' },
                                                        _react2.default.createElement(_reactstrap.Input, { type: 'checkbox', className: 'switch-input', checked: v.isEnabled ? true : false, onChange: _this7.onChangeEnabled.bind(_this7, { 'domainId': v.domainId, 'isEnabled': v.isEnabled }) }),
                                                        _react2.default.createElement('span', { className: 'switch-label', 'data-on': 'On', 'data-off': 'Off' }),
                                                        _react2.default.createElement('span', { className: 'switch-handle' })
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', color: 'success', onClick: _this7._getCountryModalToggle.bind(_this7, { 'domainId': v.domainId, 'countries': v.countryData.map(function (v) {
                                                                    return v.countryId;
                                                                }) }) },
                                                        _react2.default.createElement('i', { className: 'fa fa-edit' })
                                                    ),
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', color: 'danger', onClick: _this7.deleteDomain.bind(_this7, v.domainId) },
                                                        _react2.default.createElement('i', { className: 'fa fa-trash' })
                                                    )
                                                )
                                            );
                                        }) : _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { rowSpan: 5 },
                                                'No Domains Added Yet.'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_CountryModal2.default, { show: this.state.countryModal, countries: this.state.countries, domainId: this.state.domainId, modalToggle: this._getCountryModalToggle, mapCountryDomain: this.mapCountryDomain })
            );
        }
    }]);

    return Domain;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getDomains: _DomainActions.getDomains
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Domain);

/***/ }),

/***/ "./src/components/Faq/ContactUs/ContactUs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactUs = function (_Component) {
  _inherits(ContactUs, _Component);

  function ContactUs() {
    _classCallCheck(this, ContactUs);

    return _possibleConstructorReturn(this, (ContactUs.__proto__ || Object.getPrototypeOf(ContactUs)).apply(this, arguments));
  }

  _createClass(ContactUs, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "section",
        { className: "terms" },
        _react2.default.createElement(
          _reactstrap.Row,
          null,
          _react2.default.createElement(
            _reactstrap.Col,
            { xs: "12" },
            _react2.default.createElement(
              "div",
              { className: "terms-title-wrap" },
              _react2.default.createElement(
                "h2",
                { className: "terms-section-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "sidebar.contact",
                  defaultMessage: "Contact Us"
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Row,
            { className: "no-gutters" },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0397 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1 GAMELORDS, \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u0395\u03BB\u03BB\u03AC\u03B4\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 Sam Media BV, \u03BC\u03B5 \u03AD\u03B4\u03C1\u03B1 \u03C3\u03C4\u03B7\u03BD \u039F\u03BB\u03BB\u03B1\u03BD\u03B4\u03AF\u03B1 (Van Diemenstraat 356 1013 CR Amsterdam) \u03BC\u03B5 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC VAT NL8187 94 859 B01 \u03B7 \u03BF\u03C0\u03BF\u03AF\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03B7\u03BC\u03AD\u03BD\u03B7 \u03C3\u03C4\u03BF \u03BF\u03B9\u03BA\u03B5\u03AF\u03BF \u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03CC \u0395\u03C0\u03B9\u03BC\u03B5\u03BB\u03B7\u03C4\u03AE\u03C1\u03B9\u03BF \u03BC\u03B5 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u03A3\u03C5\u03BD\u03B5\u03C0\u03CE\u03C2, \u03B3\u03B9\u03B1 \u03BF\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03B8\u03AD\u03BC\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF \u03A4\u03BC\u03AE\u03BC\u03B1 \u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2 \u03A0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03C4\u03B7\u03C2 \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 Sam Media BV \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03B9\u03BA\u03AC \u03C3\u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC 2112348373 (\u03B1\u03C0\u03BB\u03AE \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03B1\u03C0\u03CC \u03BF\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03CC \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF). \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BC\u03AD\u03C3\u03C9 email \u03C3\u03C4\u03BF sam-media.gr@cchelp.co"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u03A3\u03B5 \u03C0\u03B5\u03C1\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C0\u03BF\u03C5 \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2 \u03B1\u03C0\u03CC \u03BA\u03AC\u03C0\u03BF\u03B9\u03B1 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1 \u03C0\u03BF\u03C5 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03B9 \u03B7 \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 Sam Media BV \u03C3\u03C4\u03B7\u03BD \u0395\u03BB\u03BB\u03AC\u03B4\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B5\u03C2:"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "1. \u039D\u03B1 \u03B1\u03C0\u03BF\u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03B3\u03C1\u03B1\u03C0\u03C4\u03CC \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03C4\u03B7\u03BD \u03BB\u03AD\u03BE\u03B7\xA0 STOP GL \u03C3\u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC 54066 \u03AE 54070 \u03BC\u03B5 \u03BA\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B1\u03C0\u03BB\u03BF\u03CD \u03C4\u03C5\u03C0\u03B9\u03BA\u03BF\u03CD \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2, \u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03B5\u03BD\u03B4\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03BD\u03AC\u03BB\u03BF\u03B3\u03B1 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C0\u03AC\u03C1\u03BF\u03C7\u03BF \u03BA\u03B9\u03BD\u03B7\u03C4\u03AE\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03AF\u03B1\u03C2, \u03C0\u03BF\u03C5 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03B9."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u039C\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C4\u03BF\u03C5 \u03B1\u03BD\u03C9\u03C4\u03AD\u03C1\u03C9 \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2, \u03B8\u03B1 \u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03AC\u03BC\u03B5\u03C3\u03B1\xA0\u03B4\u03C9\u03C1\u03B5\u03AC\u03BD\xA0\u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B1\u03C0\u03CC \u03C4\u03BF 54005 \u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03B8\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03BD\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1/\u03B5\u03C2."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "2. \u039D\u03B1 \u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03B9\u03BA\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC 2112348373 \u03C4\u03BF\u03C5 \u03A4\u03BC\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2 \u03A0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03C4\u03B7\u03C2 \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 Sam Media BV:"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "- \u0395\u03C0\u03B9\u03BB\u03AD\u03B3\u03BF\u03BD\u03C4\u03B1\u03C2 (1) \u03BA\u03B1\u03B9 \u03B1\u03C6\u03BF\u03CD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B7\u03C7\u03BF\u03B3\u03C1\u03B1\u03C6\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B5\u03C3\u03C4\u03B5 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1. (24\u03C9\u03C1\u03B7 \u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7)"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "- \u0395\u03C0\u03B9\u03BB\u03AD\u03B3\u03BF\u03BD\u03C4\u03B1\u03C2 (2) \u03B8\u03B1 \u03B5\u03BE\u03C5\u03C0\u03B7\u03C1\u03B5\u03C4\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1\u03BD \u03B1\u03BD\u03C4\u03B9\u03C0\u03C1\u03CC\u03C3\u03C9\u03C0\u03CC \u03BC\u03B1\u03C2, \u03C0\u03C1\u03BF\u03BA\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5 \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2 (\u038F\u03C1\u03B5\u03C2 \u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2: 10\u03C0.\u03BC. \u03C9\u03C2 6\u03BC.\u03BC)"
              )
            )
          )
        )
      );
    }
  }]);

  return ContactUs;
}(_react.Component);

exports.default = ContactUs;

/***/ }),

/***/ "./src/components/Faq/Faq.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Faq = function (_Component) {
  _inherits(Faq, _Component);

  function Faq() {
    _classCallCheck(this, Faq);

    return _possibleConstructorReturn(this, (Faq.__proto__ || Object.getPrototypeOf(Faq)).apply(this, arguments));
  }

  _createClass(Faq, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "section",
        { className: "terms" },
        _react2.default.createElement(
          _reactstrap.Row,
          null,
          _react2.default.createElement(
            _reactstrap.Col,
            { xs: "12" },
            _react2.default.createElement(
              "div",
              { className: "terms-title-wrap" },
              _react2.default.createElement(
                "h2",
                { className: "terms-section-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: "sidebar.faq", defaultMessage: "Faq" })
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Row,
            { className: "no-gutters" },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "\u03A0\u039B\u0397\u03A1\u039F\u03A6\u039F\u03A1\u0399\u0395\u03A3 \u0393\u0399\u0391 \u03A4\u0397\u039D \u03A3\u03A5\u039D\u0394\u03A1\u039F\u039C\u0397 \u03A3\u0391\u03A3 "
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0397 GAMELORDS \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03B9 \u03C8\u03C5\u03C7\u03B1\u03B3\u03C9\u03B3\u03B9\u03BA\u03AD\u03C2 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C3\u03C5\u03BD\u03AF\u03C3\u03C4\u03B1\u03BD\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03BB\u03AE\u03C8\u03B7 \u03C0\u03B5\u03C1\u03B9\u03B5\u03C7\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5 \u03B3\u03B9\u03B1 \u03BA\u03B9\u03BD\u03B7\u03C4\u03AC \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03B1, \u03CC\u03C0\u03C9\u03C2 \u03AE\u03C7o\u03B9 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2, \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B5\u03C2, \u03C0\u03B1\u03B9\u03C7\u03BD\u03AF\u03B4\u03B9\u03B1, \u03B5\u03B9\u03B4\u03B7\u03C3\u03B5\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C5\u03BB\u03B9\u03BA\u03CC, \u03B1\u03C3\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AD\u03C2 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AD\u03C8\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03AC\u03BB\u03BB\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03B1."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0391\u03C6\u03BF\u03CD \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03BA\u03B1\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B1 \u03B1\u03C1\u03C7\u03B5\u03AF\u03B1 \u03C3\u03B5 \u03C3\u03C5\u03BC\u03B2\u03B1\u03C4\u03AC \u03BA\u03B9\u03BD\u03B7\u03C4\u03AC \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03B1 \u03BA\u03B1\u03B9 \u03C3\u03C5\u03BC\u03B2\u03B1\u03C4\u03AD\u03C2 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AD\u03C2 \u03BC\u03AD\u03C3\u03C9 \u03C4\u03B7\u03C2 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "GAMELORDS"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u03A4\u03B1 \u03BC\u03AD\u03BB\u03B7 \u03C4\u03B7\u03C2 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "GAMELORDS"
                ),
                " \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03BF\u03C5\u03BD \u03C4\u03BF\u03BD \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C4\u03BF\u03C5\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03BA\u03AC\u03B8\u03B5 \u03BC\u03AE\u03BD\u03B1, \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BF\u03C0\u03BF\u03AF\u03BF \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03BA\u03AC\u03BD\u03BF\u03C5\u03BD \u03BB\u03AE\u03C8\u03B7 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03BF\u03CD \u03C0\u03B5\u03C1\u03B9\u03B5\u03C7\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5 \u03BA\u03AC\u03B8\u03B5 \u03C6\u03BF\u03C1\u03AC."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0397 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "GAMELORDS"
                ),
                " \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BC\u03B5 \u03BC\u03B7\u03BD\u03B9\u03B1\u03AF\u03B1 \u03C3\u03C5\u03BD\u03B4\u03C1\u03BF\u03BC\u03AE \u03BA\u03B1\u03B9 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B1 \u03B8\u03B1 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B5 \u03B4\u03CE\u03B4\u03B5\u03BA\u03B1 (12) \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03BB\u03AE\u03C8\u03B7 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B9\u03BC\u03B1 \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03B1, \u03B1\u03BE\u03AF\u03B1\u03C2 2,29\u20AC \u03AD\u03BA\u03B1\u03C3\u03C4\u03BF, \u03AE \u03AD\u03C9\u03C2 (48) \u03C3\u03B1\u03C1\u03AC\u03BD\u03C4\u03B1 \u03BF\u03C7\u03C4\u03CE \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03BB\u03AE\u03C8\u03B7 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B9\u03BC\u03B1 \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03B1 0,57\u20AC \u03B5\u03BA\u03B1\u03C3\u03C4\u03BF \u03BC\u03B7\u03BD\u03B9\u03B1\u03AF\u03C9\u03C2, \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7: 27,48\u20AC \u03B1\u03BD\u03AC \u03BC\u03AE\u03BD\u03B1 (\u03C3\u03C5\u03BC\u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03A6\u03A0\u0391 \u03BA\u03B1\u03B9 \u03C4\u03B5\u03BB\u03CE\u03BD \u03BA\u03B9\u03BD\u03B7\u03C4\u03AE\u03C2). \u03A4\u03B5\u03BB\u03B9\u03BA\u03AE \u03A4\u03B9\u03BC\u03AE \u039C\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0397 \u03BC\u03B7\u03BD\u03B9\u03B1\u03AF\u03B1 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03B8\u03B1 \u03C4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03BC\u03AD\u03C3\u03C9 \u03C4\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03BA\u03B9\u03BD\u03B7\u03C4\u03AE\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03AF\u03B1\u03C2 \u03C4\u03BF\u03C5 \u03A0\u03B1\u03C1\u03CC\u03C7\u03BF\u03C5 \u03C3\u03B1\u03C2"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0391\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03B7 \u03C0\u03C1\u03BF\u03CB\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1\u03C2",
                " ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "GAMELORDS"
                ),
                " \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03C3\u03C4\u03B5 \u03AC\u03BD\u03C9 \u03C4\u03C9\u03BD 18 \u03B5\u03C4\u03CE\u03BD, \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B4\u03BF\u03B8\u03B5\u03AF \u03B7 \u03AC\u03B4\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C5 \u03B1\u03C4\u03CC\u03BC\u03BF\u03C5 \u03C0\u03BF\u03C5 \u03C0\u03BB\u03B7\u03C1\u03CE\u03BD\u03B5\u03B9 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BA\u03B9\u03BD\u03B7\u03C4\u03AE\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03AF\u03B1\u03C2."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0397 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "GAMELORDS"
                ),
                ", \u03C3\u03C4\u03B7\u03BD \u0395\u03BB\u03BB\u03AC\u03B4\u03B1 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 Sam Media BV., \u03BC\u03B5 \u03AD\u03B4\u03C1\u03B1 \u03C4\u03B7\u03BD O\u03BB\u03BB\u03B1\u03BD\u03B4\u03AF\u03B1 (Van Diemenstraat 356 1013 CR Amsterdam )\u03BC\u03AD\u03C3\u03C9 \u03C4\u03C9\u03BD 5\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CE\u03BD \u03C4\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B7\u03C2 \u03C4\u03B5\u03C7\u03BD\u03B9\u03BA\u03AE\u03C2 \u03C5\u03C0\u03BF\u03B4\u03BF\u03BC\u03AE\u03C2 \u03C4\u03B7\u03C2."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0393\u03B9\u03B1 \u03BF\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03B8\u03AD\u03BC\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF \u03A4\u03BC\u03AE\u03BC\u03B1 \u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2 \u03A0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03B9\u03BA\u03AC \u03C3\u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC 2112348373\xA0(\u03B1\u03C0\u03BB\u03AE \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03B1\u03C0\u03CC \u03BF\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03CC \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF). \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BC\u03AD\u03C3\u03C9 email \u03C3\u03C4\u03BF: sam-media.gr@cchelp.co"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0395\u03AC\u03BD \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03BA\u03CC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03C5\u03BD\u03B4\u03C1\u03BF\u03BC\u03AE \u03C3\u03B1\u03C2 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1, \u03C3\u03C4\u03B5\u03AF\u03BB\u03C4\u03B5 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B1\u03C0\u03CC \u03C4\u03BF \u03BA\u03B9\u03BD\u03B7\u03C4\u03CC \u03C3\u03B1\u03C2 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03BB\u03AD\u03BE\u03B7",
                " ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "STOP GL"
                ),
                "\u03C3\u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03B5\u03BD\u03C4\u03B1\u03C8\u03AE\u03C6\u03B9\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "54066/54070"
                ),
                " \u03CC\u03C0\u03BF\u03C5 \u03B5\u03AF\u03C7\u03B1\u03C4\u03B5 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03B5\u03AF"
              ),
              _react2.default.createElement(
                "p",
                null,
                "\u03A4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03BF\u03C3\u03C4\u03AD\u03BB\u03BB\u03B5\u03B9 \u03BF \u03C3\u03C5\u03BD\u03B4\u03C1\u03BF\u03BC\u03B7\u03C4\u03AE\u03C2 \u03C3\u03C4\u03BF\u03BD \u03C0\u03B5\u03BD\u03C4\u03B1\u03C8\u03AE\u03C6\u03B9\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "54066"
                ),
                " \u03AD\u03C7\u03B5\u03B9 \u03BA\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B1\u03C0\u03BB\u03BF\u03CD \u03C4\u03C5\u03C0\u03B9\u03BA\u03BF\u03CD \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2, \u03C0\u03BF\u03C5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03BD\u03AC \u03C0\u03AC\u03C1\u03BF\u03C7\u03BF \u03BA\u03B9\u03BD\u03B7\u03C4\u03AE\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03AF\u03B1\u03C2. \u0397 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03AD\u03BB\u03BB\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF\u03BD \u03C3\u03C5\u03BD\u03B4\u03C1\u03BF\u03BC\u03B7\u03C4\u03AE \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "54066"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Faq;
}(_react.Component);

exports.default = Faq;

/***/ }),

/***/ "./src/components/Favorites/Favorites.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _isIos = __webpack_require__("./node_modules/is-ios/index.js");

var _isIos2 = _interopRequireDefault(_isIos);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _messages_ar = __webpack_require__("./src/constants/messages_ar.js");

var _messages_kk = __webpack_require__("./src/constants/messages_kk.js");

var _messages_fr = __webpack_require__("./src/constants/messages_fr.js");

var _messages_sv = __webpack_require__("./src/constants/messages_sv.js");

var _messages_no = __webpack_require__("./src/constants/messages_no.js");

var _messages_vi = __webpack_require__("./src/constants/messages_vi.js");

var _messages_tr = __webpack_require__("./src/constants/messages_tr.js");

var _messages_it = __webpack_require__("./src/constants/messages_it.js");

var _messages_cy = __webpack_require__("./src/constants/messages_cy.js");

var _messages_de = __webpack_require__("./src/constants/messages_de.js");

var _messages_el = __webpack_require__("./src/constants/messages_el.js");

var _messages_ro = __webpack_require__("./src/constants/messages_ro.js");

var _messages_cz = __webpack_require__("./src/constants/messages_cz.js");

var _messages_pt = __webpack_require__("./src/constants/messages_pt.js");

var _messages = __webpack_require__("./src/constants/messages.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var msg = void 0;

var Favorites = function (_Component) {
    _inherits(Favorites, _Component);

    function Favorites(props) {
        _classCallCheck(this, Favorites);

        var _this = _possibleConstructorReturn(this, (Favorites.__proto__ || Object.getPrototypeOf(Favorites)).call(this, props));

        _this.toggle = _this.toggle.bind(_this);
        _this.openGame = _this.openGame.bind(_this);
        _this.changeDomain = _this.changeDomain.bind(_this);
        _this.state = {
            activeTab: _domainConfig.config.subDomain == 'pk' ? '2' : '1'
        };
        return _this;
    }

    _createClass(Favorites, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
            (0, _sendData.sendData)('', '', '', 'viewed', { page: 'favorites' });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getFavouriteGames();
        }
    }, {
        key: 'getFavouriteGames',
        value: function getFavouriteGames() {
            var _this2 = this;

            var uid = this.props.access.uid;

            _axios2.default.get(vars.BASE_URL + '/getFavorites?uid=' + uid).then(function (response) {
                if (response.data.success) {
                    _this2.props.getFavouriteGames(response.data);
                }
            }).catch(function (error) {
                _this2.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'toggle',
        value: function toggle(tab) {
            if (this.state.activeTab !== tab) {
                this.setState({
                    activeTab: tab
                });
            }
        }
    }, {
        key: 'changeDomain',
        value: function changeDomain() {
            switch (_domainConfig.config.lang) {
                case 'ar':
                    msg = _messages_ar.messages_ar;
                    break;
                case 'kk':
                    msg = _messages_kk.messages_kk;
                    break;
                case 'fr':
                    msg = _messages_fr.messages_fr;
                    break;
                case 'sv':
                    msg = _messages_sv.messages_sv;
                    break;
                case 'no':
                    msg = _messages_no.messages_no;
                    break;
                case 'vi':
                    msg = _messages_vi.messages_vi;
                    break;
                case 'tr':
                    msg = _messages_tr.messages_tr;
                    break;
                case 'it':
                    msg = _messages_it.messages_it;
                    break;
                case 'cy':
                    msg = _messages_cy.messages_cy;
                    break;
                case 'de':
                    msg = _messages_de.messages_de;
                    break;
                case 'el':
                    msg = _messages_el.messages_el;
                    break;
                case 'ro':
                    msg = _messages_ro.messages_ro;
                    break;
                case 'cs':
                    msg = _messages_cz.messages_cz;
                    break;
                case 'fr':
                    msg = _messages_pt.messages_pt;
                    break;
                default:
                    msg = _messages.messages;
                    break;
            }
        }
    }, {
        key: 'openGame',
        value: function openGame(game, e) {
            var _this3 = this;

            if (e.target.classList.contains('isFavorite')) {
                var data = {
                    uid: this.props.access.uid,
                    gameId: game.gameId,
                    isFavorite: !game.isFavorite
                };
                (0, _sendData.sendData)(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
                _axios2.default.post(vars.BASE_URL + '/favorite', data).then(function (response) {
                    if (response.status) {
                        _this3.props.showMessage({
                            message: msg.removeFromFavorites,
                            type: false
                        });
                        _this3.getFavouriteGames();
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            } else if (e.target.tagName != 'INPUT') {
                this.props.history.push((0, _helper.appendUid)('/detail/' + game.gameId, this.props.access.uid));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var html5Games = this.props.games.favoriteGames.filter(function (game) {
                return game.gameType.toLowerCase() == "html5";
            });
            var androidGames = this.props.games.favoriteGames.filter(function (game) {
                return game.gameType.toLowerCase() == "android";
            });
            var finalVideos = this.props.games.favoriteGames.filter(function (game) {
                return game.gameType.toLowerCase() == "video";
            });
            var excludedCategories = ['Motivation', 'Tour', 'Fun Gaming', 'Athletics', 'E-Learning', 'Heroes', 'Squid Games', 'Astrology', 'Cuisine', 'Musique', 'Apprends le français', 'Courts métrages', 'Visites', 'Heróis Verdes', 'Meu Emprego dos Sonhos', 'Political & Activism'];
            var excludedCategorieses2 = ['Motivation', 'Tour', 'Fun Gaming', 'Athletics', 'E-Learning', 'Squid Games', 'Astrology', 'Cuisine', 'Musique', 'Apprends le français', 'Courts métrages', 'Visites', 'Heróis Verdes', 'Meu Emprego dos Sonhos'];
            var videos = finalVideos;
            if (_domainConfig.config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                videos = finalVideos.filter(function (item) {
                    if (excludedCategories.indexOf(item.categoryName) === -1) {
                        return item;
                    }
                });
            }
            if (_domainConfig.config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                videos = finalVideos.filter(function (item) {
                    if (excludedCategorieses2.indexOf(item.categoryName) === -1) {
                        return item;
                    }
                });
            }
            this.changeDomain();
            return _react2.default.createElement(
                'section',
                { className: 'favorites' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12' },
                        _react2.default.createElement(
                            _reactstrap.Nav,
                            { pills: true, className: 'nav-justified favorites-tabs' },
                            _domainConfig.config.subDomain !== 'pk' && _react2.default.createElement(
                                _reactstrap.NavItem,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.NavLink,
                                    {
                                        className: (0, _classnames2.default)({ active: this.state.activeTab === '1' }),
                                        onClick: function onClick() {
                                            _this4.toggle('1');
                                        }
                                    },
                                    _isGamiclub.isGamiclub ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'html5', defaultMessage: 'HTML5' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'html5games', defaultMessage: 'HTML5 Games' })
                                )
                            ),
                            _domainConfig.config.subDomain === 'pk' || _domainConfig.config.subDomain === 'rsma' || _domainConfig.config.subDomain === 'maae' || _domainConfig.config.subDomain === 'za' && _isIos2.default || _domainConfig.config.subDomain === 'my' && window.location.hostname.includes('gamiclub.online') || _domainConfig.config.subDomain === 'ae' && window.location.hostname.includes('game-lords.com') ? null : _react2.default.createElement(
                                _reactstrap.NavItem,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.NavLink,
                                    {
                                        className: (0, _classnames2.default)({ active: this.state.activeTab === '2' }),
                                        onClick: function onClick() {
                                            _this4.toggle('2');
                                        }
                                    },
                                    _isGamiclub.isGamiclub ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'android', defaultMessage: 'ANDROID' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'androidGames', defaultMessage: 'ANDROID Games' })
                                )
                            ),
                            (_isGamiclub.isGamiclub && _domainConfig.config.subDomain !== 'rsma' && !(_isOnlyMobbfun.isOnlyMobbfun && _domainConfig.config.subDomain === 'id') && !(window.location.hostname.includes('game-lords.com') && _domainConfig.config.subDomain === 'ae') || _domainConfig.config.subDomain === 'kw' || _domainConfig.config.subDomain === 'pt') && _react2.default.createElement(
                                _reactstrap.NavItem,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.NavLink,
                                    {
                                        className: (0, _classnames2.default)({ active: this.state.activeTab === '3' }),
                                        onClick: function onClick() {
                                            _this4.toggle('3');
                                        }
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'videos', defaultMessage: 'VIDEOS' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.TabContent,
                            { activeTab: this.state.activeTab },
                            _react2.default.createElement(
                                _reactstrap.TabPane,
                                { tabId: '1' },
                                _react2.default.createElement(
                                    _reactstrap.Row,
                                    { className: 'game-list-row' },
                                    html5Games.length > 0 ? html5Games.map(function (game) {
                                        return _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xl: '2', md: '3', sm: '4', xs: '6', key: game.gameId },
                                            _react2.default.createElement(
                                                _reactstrap.Card,
                                                { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? "game-card gameflares-game-card" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card", onClick: _this4.openGame.bind(_this4, game) },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-inner' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-thumb-wrap' },
                                                        _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-card-details' },
                                                        _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                            _reactstrap.CardTitle,
                                                            { className: 'game-title text-shadow' },
                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                                defaultMessage: game.gameTitle })
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'custom-rating isFavorite' },
                                                            _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                            _react2.default.createElement(
                                                                'label',
                                                                { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                                _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star isFavorite' })
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-left' },
                                                            _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                                    return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star' });
                                                                } })
                                                        ),
                                                        _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                            game.gameType.toLowerCase() === "html5" ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-android', 'aria-hidden': 'true' })
                                                        )
                                                    )
                                                )
                                            )
                                        );
                                    }) : _react2.default.createElement(
                                        _reactstrap.Col,
                                        { xs: '12' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'favorites-tabs-inner text-center' },
                                            _isGamiclub.isGamiclub || _productCondition.isGameflares ? _react2.default.createElement('i', { className: 'fa fa-html5 ' + (_productCondition.isGameflares ? 'fa-gradient-gameflares' : 'fa-gradient-gamiclub') }) : _react2.default.createElement('i', { className: 'fa fa-html5 fa-gradient' }),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'favorites-text' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noFavGames',
                                                    defaultMessage: 'No Favorite Games Yet'
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'favorites-sub-text' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addFavGames',
                                                    defaultMessage: 'Add your favorite games to access and play easily without any hassels'
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { className: _isGamiclub.isGamiclub ? "btn discover-btn gradient-gamiclub" : _productCondition.isGameflares ? "btn discover-btn gradient-gameflares" : "btn discover-btn gradient", href: (0, _helper.appendUid)("/#/home/html", this.props.access.uid) },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'discover',
                                                    defaultMessage: 'Discover'
                                                })
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.TabPane,
                                { tabId: '2' },
                                _react2.default.createElement(
                                    _reactstrap.Row,
                                    { className: 'game-list-row' },
                                    androidGames.length > 0 ? androidGames.map(function (game) {
                                        return (0, _helper.filterGames)(game) ? _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xl: '2', md: '3', sm: '4', xs: '6', className: 'fav-android-tab', key: game.gameId },
                                            _react2.default.createElement(
                                                _reactstrap.Card,
                                                { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? "game-card gameflares-game-card" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card", onClick: _this4.openGame.bind(_this4, game) },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-inner' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-thumb-wrap' },
                                                        _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-card-details' },
                                                        _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                            _reactstrap.CardTitle,
                                                            { className: 'game-title text-shadow' },
                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                                defaultMessage: game.gameTitle })
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'custom-rating isFavorite' },
                                                            _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                            _react2.default.createElement(
                                                                'label',
                                                                { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                                _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star isFavorite' })
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-left' },
                                                            _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate2', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                                    return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star' });
                                                                } })
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                            game.gameType.toLowerCase() == "html5" ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-android', 'aria-hidden': 'true' })
                                                        )
                                                    )
                                                )
                                            )
                                        ) : null;
                                    }) : _react2.default.createElement(
                                        _reactstrap.Col,
                                        { xs: '12' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'favorites-tabs-inner text-center' },
                                            _isGamiclub.isGamiclub || _productCondition.isGameflares ? _react2.default.createElement('i', { className: 'fa fa-android ' + (_productCondition.isGameflares ? 'fa-gradient-gameflares' : 'fa-gradient-gamiclub') }) : _react2.default.createElement('i', { className: 'fa fa-android fa-gradient' }),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'favorites-text' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noFavGames',
                                                    defaultMessage: 'No Favorite Games Yet'
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'favorites-sub-text' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addFavGames',
                                                    defaultMessage: 'Add your favorite games to access and play easily without any hassels'
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { className: _isGamiclub.isGamiclub ? "btn discover-btn gradient-gamiclub" : _productCondition.isGameflares ? "btn discover-btn gradient-gameflares" : "btn discover-btn gradient", href: (0, _helper.appendUid)("#/home/android", this.props.access.uid) },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'discover',
                                                    defaultMessage: 'Discover'
                                                })
                                            )
                                        )
                                    )
                                )
                            ),
                            _isGamiclub.isGamiclub ? _react2.default.createElement(
                                _reactstrap.TabPane,
                                { tabId: '3' },
                                _react2.default.createElement(
                                    _reactstrap.Row,
                                    { className: 'game-list-row' },
                                    videos.length > 0 ? videos.map(function (game) {
                                        return _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xl: '2', md: '3', sm: '4', xs: '6', key: game.gameId },
                                            _react2.default.createElement(
                                                _reactstrap.Card,
                                                { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : "game-card", onClick: _this4.openGame.bind(_this4, game) },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-inner' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-thumb-wrap' },
                                                        _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-card-details' },
                                                        _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                            _reactstrap.CardTitle,
                                                            { className: 'game-title text-shadow' },
                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                                defaultMessage: game.gameTitle })
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'custom-rating isFavorite' },
                                                            _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                            _react2.default.createElement(
                                                                'label',
                                                                { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                                _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : null, className: 'fa fa-star custom-star isFavorite' })
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-left' },
                                                            _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                                    return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : null, className: 'fa fa-star custom-star' });
                                                                } })
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                            game.gameType.toLowerCase() == "html5" ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : game.gameType.toLowerCase() == 'video' ? _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' })
                                                        )
                                                    )
                                                )
                                            )
                                        );
                                    }) : _react2.default.createElement(
                                        _reactstrap.Col,
                                        { xs: '12' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'favorites-tabs-inner text-center' },
                                            _react2.default.createElement('i', { className: 'fa fa-video-camera fa-gradient-gamiclub' }),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'favorites-text' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noFavVideos',
                                                    defaultMessage: 'No Favorite Videos Yet'
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'favorites-sub-text' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addFavVideos',
                                                    defaultMessage: 'Add your favorite videos to access and play easily without any hassels'
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'btn discover-btn gradient-gamiclub', href: (0, _helper.appendUid)("/#/home/video", this.props.access.uid) },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'discover',
                                                    defaultMessage: 'Discover'
                                                })
                                            )
                                        )
                                    )
                                )
                            ) : null
                        )
                    )
                )
            );
        }
    }]);

    return Favorites;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        games: state.GamesReducer,
        access: state.WelcomeReducer,
        flashmessage: state.FlashMessageReducer

    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getFavouriteGames: _GamesActions.getFavouriteGames,
        showMessage: _FlashMessageActions.showMessage
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Favorites);

/***/ }),

/***/ "./src/components/FlashMessage/FlashMessage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlashMessage = function (_Component) {
    _inherits(FlashMessage, _Component);

    function FlashMessage(props) {
        _classCallCheck(this, FlashMessage);

        var _this = _possibleConstructorReturn(this, (FlashMessage.__proto__ || Object.getPrototypeOf(FlashMessage)).call(this, props));

        _this.setTimeout = null;
        _this.element = null;
        return _this;
    }

    _createClass(FlashMessage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.element = document.querySelector('.flash-message');
            if (this.props.flashmessage.isShowing) {
                this.setTimeout = setTimeout(function () {
                    return _this2.props.hideMessage();
                }, 2000);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this3 = this;

            this.element.classList.remove("notification-positive");
            this.element.classList.remove("notification-negative");
            if (this.props.flashmessage.isShowing) {
                if (this.setTimeout != null) {
                    clearTimeout(this.setTimeout);
                }
                if (this.props.flashmessage.type) {
                    this.element.classList.add("notification-positive");
                } else {
                    this.element.classList.add("notification-negative");
                }
                this.setTimeout = setTimeout(function () {
                    return _this3.props.hideMessage();
                }, 2000);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.path != this.props.path) {
                this.props.hideMessage();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.hideMessage();
            clearTimeout(this.setTimeout);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: "flash-message" },
                _react2.default.createElement(
                    'a',
                    { href: (0, _helper.appendUid)("/#/", this.props.access.uid) },
                    this.props.flashmessage.message
                )
            );
        }
    }]);

    return FlashMessage;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        hideMessage: _FlashMessageActions.hideMessage
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FlashMessage);

/***/ }),

/***/ "./src/components/Footer/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _os = __webpack_require__("./node_modules/os-browserify/browser.js");

var _isOnlyBeemobi = __webpack_require__("./src/constants/isOnlyBeemobi.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

var _isGamezClan = __webpack_require__("./src/constants/isGamezClan.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _domainTheme = __webpack_require__("./src/utils/domainTheme.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var spanishDomain = _domainConfig.config.lang == "es" ? true : false;

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.onUnsubClick = function (unsubscribe_url, e) {
      e.preventDefault();
      (0, _sendData.sendData)("", "", "", "unsubscribe clicked");
      window.open(unsubscribe_url);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var currentLang = this.props.currentLang;
      var subDomain = _domainConfig.config.subDomain;
      var contactus_url = void 0,
          TC_url = void 0,
          unsubscribe_url = void 0,
          PP_url = void 0;
      var compatibility_terms = void 0,
          service_mgmt = void 0;
      if (subDomain == "es") {
        contactus_url = "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=contact.html";
        TC_url = "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=general_conditions.html";
        unsubscribe_url = "http://n.game-lords.com/unsubscribe/es?domain=es.game-lords.com&token=" + this.props.access.uid;
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              unsubscribe_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  {
                    href: "",
                    onClick: this.onUnsubClick.bind(this, unsubscribe_url),
                    target: "_blank"
                  },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "unsubscribe",
                    defaultMessage: "Unsubscribe"
                  })
                )
              ) : null,
              TC_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Condition"
                  })
                )
              ) : null,
              PP_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: PP_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "privacyPolicy",
                    defaultMessage: "Privacy Policy"
                  })
                )
              ) : null
            )
          )
        );
      }

      if (subDomain == "pe") {
        TC_url = "https://c1.mouisys.com/content/es/T&C%20Gamelords/?country=pe&service=game-lords";
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              TC_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Condition"
                  })
                )
              ) : null
            )
          )
        );
      }

      if (subDomain == "it") {
        TC_url = "http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=index.html&token=" + this.props.access.uid;
        PP_url = "http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=privacy_policy.html&token=" + this.props.access.uid;
        compatibility_terms = "http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=compatibility.html&token=" + this.props.access.uid;
        contactus_url = "http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=cancellation.html&token=" + this.props.access.uid;
        service_mgmt = "http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=cancellation.html&token=" + this.props.access.uid;
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              TC_url && _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms and Conditions"
                  })
                )
              ),
              PP_url && _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: PP_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "infoPrivacy",
                    defaultMessage: "Info Privacy"
                  })
                )
              ),
              compatibility_terms && _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: compatibility_terms, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "compatibilityTerms",
                    defaultMessage: "Compatibility Terms"
                  })
                )
              ),
              contactus_url && _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: contactus_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "contact_us",
                    defaultMessage: "Contattaci"
                  })
                )
              ),
              service_mgmt && _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: service_mgmt, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "serviceMgmt",
                    defaultMessage: "Gestione servizio"
                  })
                )
              )
            )
          )
        );
      }
      if (subDomain == "gr" && _isGamiclub.isGamiclub) {
        TC_url = "http://n.gamiclub.com/gr/tnc-gamiclub?device=pc&offer=1";
        unsubscribe_url = "http://n.game-lords.com/unsubscribe/gr?lang=el&token=" + this.props.access.uid;
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              unsubscribe_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  {
                    href: "",
                    onClick: this.onUnsubClick.bind(this, unsubscribe_url),
                    target: "_blank"
                  },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "unsubscribe",
                    defaultMessage: "Unsubscribe"
                  })
                )
              ) : null,
              TC_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Condition"
                  })
                )
              ) : null
            )
          )
        );
      }

      if (subDomain == "ro") {
        TC_url = "http://n.gamiclub.com/ro/tnc-gamiclub?offer=1";
        unsubscribe_url = "http://n.gamiclub.com/unsubscribe/ro/?domain=ro.gamiclub.com&token=" + this.props.access.uid;
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              unsubscribe_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  {
                    href: "",
                    onClick: this.onUnsubClick.bind(this, unsubscribe_url),
                    target: "_blank"
                  },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "unsubscribe",
                    defaultMessage: "Unsubscribe"
                  })
                )
              ) : null,
              TC_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Condition"
                  })
                )
              ) : null
            )
          )
        );
      }

      if (subDomain === "no" && !_isGamiclub.isGamiclub) {
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer no_app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "copyright-block" },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "a",
                { href: "mailto:no@content-clubs.com" },
                "Kontakt: no@content-clubs.com"
              )
            ),
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "a",
                { href: "#/?uid=" + this.props.account.user.uid },
                _isGamiclub.isGamiclub ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "footer.copyright.gamiclub",
                  defaultMessage: "\xA9 2020 Gamiclub. All Rights Reserved"
                }) : window.location.hostname.includes("gameverse-lt") ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "footer.copyright.gameverse-lt",
                  defaultMessage: "\xA9 2026 Gameverse. All Rights Reserved"
                }) : _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "footer.copyright",
                  defaultMessage: "\xA9 2020 Gamelords. All Rights Reserved"
                })
              )
            )
          )
        );
      }

      if (_isOnlyBeemobi.isOnlyBeemobi && subDomain === "es2") {
        var msisdn = this.props.access.subscriptionData ? this.props.access.subscriptionData["msisdn_full"] : "";
        if (!msisdn) return null;
        return _react2.default.createElement(
          "footer",
          {
            style: { borderTop: "1px solid green", padding: "5px 0px" },
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "copyright-block" },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "a",
                {
                  href: "https://checksubscription.com/?c=es&utm_source=es2.beemobi.me&msisdn=" + msisdn
                },
                "Checksubscription"
              )
            ),
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "a",
                {
                  href: "http://n.beemobi.me/unsubscribe/es/?country=es&domain=es2.beemobi.me&token=" + this.props.access.uid
                },
                "Darse de baja"
              )
            )
          )
        );
      }

      if (subDomain === "se") {
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer se_app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: "javascript:void(0)" },
                  "N\xE5gra fr\xE5gor? L\xE5t prata 020 0753411 eller \xA0"
                ),
                _react2.default.createElement(
                  "a",
                  { href: "mailto:info-se@mobileinfo.biz" },
                  "info-se@mobileinfo.biz"
                )
              )
            )
          )
        );
      }
      if (subDomain == "eg" && _isGamiclub.isGamiclub) {
        var _msisdn = this.props.access.subscriptionData ? this.props.access.subscriptionData["msisdn_full"] : "";
        if (!_msisdn) return null;
        TC_url = "http://n.gamiclub.com/eg/eg-mm-gamiclub?offer=1&msisdn=" + _msisdn;
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              TC_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Condition"
                  })
                )
              ) : null
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "copyright-block" },
            _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement(
                "a",
                { href: "#/?uid=" + this.props.account.user.uid },
                window.location.hostname.includes("gameverse-lt") ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "footer.copyright.gameverse-lt",
                  defaultMessage: "\xA9 2026 Gameverse. All Rights Reserved"
                }) : _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "footer.copyright.gamiclub",
                  defaultMessage: "\xA9 2020 Gamiclub. All Rights Reserved"
                })
              )
            )
          )
        );
      }
      if (subDomain == "za" && !_isGamiclub.isGamiclub) {
        TC_url = "http://n.lordgames.info/za/tnc-gamelords?device=pc&offer=1";
        return _react2.default.createElement(
          "footer",
          {
            style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : null,
            className: "app-footer"
          },
          _react2.default.createElement(
            "div",
            { className: "footer-menu" },
            _react2.default.createElement(
              "div",
              { className: "footer-link" },
              TC_url ? _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "a",
                  { href: TC_url, target: "_blank" },
                  _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Condition"
                  })
                )
              ) : null
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "copyright-block" },
            _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement(
                "a",
                { href: "#/?uid=" + this.props.account.user.uid },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "footer.copyright",
                  defaultMessage: "\xA9 2020 Gamelords. All Rights Reserved"
                })
              )
            )
          )
        );
      }
      var theme = (0, _domainTheme.getDomainTheme)();
      return _react2.default.createElement(
        "footer",
        {
          style: _isGamiclub.isGamiclub ? { borderTop: "1px solid green" } : _productCondition.isGameflares ? { borderTop: "1px solid #FF394B" } : _productCondition.isGamiway ? { borderTop: "1px solid #b347a0" } : null,
          className: "app-footer " + (_productCondition.isGameflares ? "app-footer-gameflares" : "")
        },
        _react2.default.createElement(
          "div",
          { className: "copyright-block" },
          _react2.default.createElement(
            "span",
            null,
            _react2.default.createElement(
              "a",
              { href: "#/?uid=" + this.props.account.user.uid },
              _isGamiclub.isGamiclub ? _isOnlyBeemobi.isOnlyBeemobi ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.beemobi",
                defaultMessage: "\xA9 2020 Beemobi. All Rights Reserved"
              }) : _isOnlyMobbfun.isOnlyMobbfun ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.mobbfun",
                defaultMessage: "\xA9 2022 Mobbfun. All Rights Reserved"
              }) : window.location.hostname.includes("gameverse-lt") ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.gameverse-lt",
                defaultMessage: "\xA9 2026 Gameverse. All Rights Reserved"
              }) : _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.gamiclub",
                defaultMessage: "\xA9 2020 Gamiclub. All Rights Reserved"
              }) : _isAppspool.isAppspool ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.appspool",
                defaultMessage: "\xA9 2020 Appspool. All Rights Reserved"
              }) : _isGamezClan.isGamezClan ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.gamezclan",
                defaultMessage: "\xA9 2020 Gamezclan. All Rights Reserved"
              }) : _productCondition.isGameflares ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.gameflares",
                defaultMessage: "\xA9 2024 Gameflares. All Rights Reserved"
              }) : _productCondition.isGamiway ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.gamiway",
                defaultMessage: "\xA9 2020 Gamiway. All Rights Reserved"
              }) : _isTheGamingClubs.isTheGamingClubs ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright.gamiway",
                defaultMessage: "\xA9 2024 GamingClubs. All Rights Reserved"
              }) : _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: "footer.copyright." + theme.productName,
                defaultMessage: "&copy; 2020 " + theme.productName + ". All Rights Reserved"
              })
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    account: state.AccountReducer,
    access: state.WelcomeReducer
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Footer);

/***/ }),

/***/ "./src/components/GameDetail/GameDetail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactResponsiveModal = __webpack_require__("./node_modules/react-responsive-modal/lib/index.es.js");

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _messages = __webpack_require__("./src/constants/messages.js");

var _messages_ar = __webpack_require__("./src/constants/messages_ar.js");

var _messages_kk = __webpack_require__("./src/constants/messages_kk.js");

var _messages_fr = __webpack_require__("./src/constants/messages_fr.js");

var _messages_sv = __webpack_require__("./src/constants/messages_sv.js");

var _messages_no = __webpack_require__("./src/constants/messages_no.js");

var _messages_vi = __webpack_require__("./src/constants/messages_vi.js");

var _messages_tr = __webpack_require__("./src/constants/messages_tr.js");

var _messages_it = __webpack_require__("./src/constants/messages_it.js");

var _messages_cy = __webpack_require__("./src/constants/messages_cy.js");

var _messages_de = __webpack_require__("./src/constants/messages_de.js");

var _messages_el = __webpack_require__("./src/constants/messages_el.js");

var _messages_cz = __webpack_require__("./src/constants/messages_cz.js");

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _messages_pt = __webpack_require__("./src/constants/messages_pt.js");

var _messages_lt = __webpack_require__("./src/constants/messages_lt.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _reactDeviceDetect = __webpack_require__("./node_modules/react-device-detect/main.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _reactHtml5video = __webpack_require__("./node_modules/react-html5video/dist/index.js");

__webpack_require__("./node_modules/react-html5video/dist/styles.css");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var kazakhDomain = void 0;
var lang = void 0;
var msg = void 0;

var GameDetail = function (_Component) {
    _inherits(GameDetail, _Component);

    function GameDetail(props) {
        _classCallCheck(this, GameDetail);

        var _this = _possibleConstructorReturn(this, (GameDetail.__proto__ || Object.getPrototypeOf(GameDetail)).call(this, props));

        _this.state = {
            activeTab: '1',
            rating: 0,
            liked: 0,
            isFavorite: 0,
            categoryId: 0,
            gameId: 0,
            openGame: false,
            game: '',
            open: false
        };
        _this.toggle = _this.toggle.bind(_this);
        _this._openGame = _this._openGame.bind(_this);
        _this.loadGame = _this.loadGame.bind(_this);
        _this.markFavourite = _this.markFavourite.bind(_this);
        _this.downloadGameApk = _this.downloadGameApk.bind(_this);
        _this.changeDomain = _this.changeDomain.bind(_this);
        _this.applyUpsellingFlow = _this.applyUpsellingFlow.bind(_this);
        _this.translatePlatform = _this.translatePlatform.bind(_this);
        _this.translateCategory = _this.translateCategory.bind(_this);
        return _this;
    }

    _createClass(GameDetail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
            (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'viewed', { page: 'game page' });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.openGame && prevState.gameId != this.state.gameId) {
                (0, _sendData.sendData)(prevState.game.gameTitle, prevState.game.categoryName, prevState.game.gameType, 'finished');
                (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'played');
            } else if (!this.state.openGame && prevState.gameId != this.state.gameId) {
                (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'viewed');
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var gameId = this.props.match.params.gameId;
            var uid = this.props.access.uid;
            this.getGameDetail(gameId, uid);
            var searchContainer = document.querySelector("#search-container");

            if (searchContainer != null) {
                if (searchContainer.classList.contains('search-toggle')) {
                    searchContainer.classList.toggle("search-toggle");
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.state.openGame) {
                (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'finished');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.match.params.gameId != nextProps.match.params.gameId) {
                this.getGameDetail(nextProps.match.params.gameId, this.props.access.uid);
            }
        }
    }, {
        key: 'rateGame',
        value: function rateGame() {
            var _this2 = this;

            var data = {
                uid: this.props.access.uid,
                gameId: this.state.gameId,
                liked: this.state.liked == 0 ? true : false
            };
            (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, data.liked ? 'liked' : 'unliked');
            _axios2.default.post(vars.BASE_URL + '/userLike', data).then(function (response) {
                if (response.status) {
                    _this2.setState({
                        liked: _this2.state.liked == 0 ? 1 : 0
                    });
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'downloadGameApk',
        value: function downloadGameApk(e, href) {
            e.preventDefault();
            if (this.shouldUpsell(this.state.game.gameId)) this.applyUpsellingFlow();else {
                if (_reactDeviceDetect.isIOS) {
                    this.onOpenModal();
                } else {
                    this.downloadApk(href);
                }
                return false;
            }
        }
    }, {
        key: 'changeDomain',
        value: function changeDomain() {
            kazakhDomain = _domainConfig.config.lang == 'kk' ? true : false;
            lang = _domainConfig.config.lang;
            switch (_domainConfig.config.lang) {
                case 'ar':
                    msg = _messages_ar.messages_ar;
                    break;
                case 'kk':
                    msg = _messages_kk.messages_kk;
                    break;
                case 'fr':
                    msg = _messages_fr.messages_fr;
                    break;
                case 'sv':
                    msg = _messages_sv.messages_sv;
                    break;
                case 'no':
                    msg = _messages_no.messages_no;
                    break;
                case 'vi':
                    msg = _messages_vi.messages_vi;
                    break;
                case 'tr':
                    msg = _messages_tr.messages_tr;
                    break;
                case 'it':
                    msg = _messages_it.messages_it;
                    break;
                case 'cy':
                    msg = _messages_cy.messages_cy;
                    break;
                case 'de':
                    msg = _messages_de.messages_de;
                    break;
                case 'el':
                    msg = _messages_el.messages_el;
                    break;
                case 'cs':
                    msg = _messages_cz.messages_cz;
                    break;
                case 'pt':
                    msg = _messages_pt.messages_pt;
                    break;
                case 'lt':
                    msg = _messages_lt.messages_lt;
                    break;
                default:
                    msg = _messages.messages;
                    break;
            }
        }
    }, {
        key: 'downloadApk',
        value: function downloadApk(href) {
            if ((0, _helper.validURL)(href)) {
                window.location.href = href;
            } else {
                window.location.href = vars.cdnUrl + href;
            }
            (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'downloaded');
            if ((_domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') && this.props.access.subscriptionData.allowedApps.indexOf(this.state.game.gameId) >= 0) {
                this.props.history.push('/welcome?uid=' + this.props.access.uid);
            }
        }
    }, {
        key: 'onOpenModal',
        value: function onOpenModal() {
            this.setState({ open: true });
        }
    }, {
        key: 'onCloseModal',
        value: function onCloseModal() {
            this.setState({ open: false });
        }
    }, {
        key: 'markFavourite',
        value: function markFavourite(gameData) {
            var _this3 = this;

            var data = {
                uid: this.props.access.uid,
                gameId: gameData.game.gameId,
                isFavorite: gameData.isFavorite
            };
            if (data.isFavorite) {
                this.props.showMessage({
                    message: msg.addToFavorites,
                    type: true
                });
            } else {
                this.props.showMessage({
                    message: msg.removeFromFavorites,
                    type: false
                });
            }
            (0, _sendData.sendData)(gameData.game.gameTitle, gameData.game.categoryName, gameData.game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
            _axios2.default.post(vars.BASE_URL + '/favorite', data).then(function (response) {
                if (response.status) {
                    _this3.setState({
                        isFavorite: _this3.state.isFavorite ? 0 : 1
                    });
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    }, {
        key: 'translatePlatform',
        value: function translatePlatform(plt) {
            var platforms = ["PC, Tablet & Mobile", "Mobile & Tablet", "PC, Mobile & Tablets"];
            if (plt === 'Mobile and Tablet') plt = 'Mobile & Tablet';
            var index = platforms.indexOf(plt);
            if (_domainConfig.config.lang == 'cy') {
                platforms = ["Десктоп,таблет & мобилни телефон", "мобилни телефон & таблет", "Десктоп,таблет & мобилни телефон"];
            }
            if (_domainConfig.config.lang == 'de') {
                platforms = ["PC, Tablet & Mobilgeräte", "Mobilgeräte & Tablets", "PC, Tablet & Mobilgeräte"];
            }
            if (_domainConfig.config.lang == 'fr') {
                platforms = ["PC, tablette et mobile", "Mobile et Tablette", "PC, tablette et mobile"];
            }
            if (_domainConfig.config.lang == 'ro') {
                platforms = ["PC, tabletă și mobil", " mobil și tabletă", "PC, mobil și tabletă"];
            }
            if (_domainConfig.config.lang == 'it') {
                platforms = ["PC, tablet e dispositivi mobili", "Cellulare e tablet", "PC, cellulari e tablet"];
            }
            return platforms[index];
        }
    }, {
        key: 'translateCategory',
        value: function translateCategory(cat) {
            var cats = ["HTML5", "ANDROID", "VIDEO"];
            var index = cats.indexOf(cat);
            if (_domainConfig.config.lang == 'cy') {
                cats = ["ХТМЛ5", "АНДРОИД", "ВИДЕОС"];
            }
            return cats[index];
        }
    }, {
        key: 'toggle',
        value: function toggle(tab) {
            if (this.state.activeTab !== tab) {
                this.setState({
                    activeTab: tab
                });
            }
        }
    }, {
        key: 'getGameDetail',
        value: function getGameDetail(gameId, uid) {
            var allGames = this.props.game.games;
            var foundGame = allGames.find(function (game) {
                return game.gameId == gameId;
            });
            this.props.getGameDetail(foundGame);
            this.setState({
                game: foundGame,
                gameId: gameId,
                categoryId: foundGame ? foundGame.categoryId : 0,
                isFavorite: foundGame ? foundGame.isFavorite ? 1 : 0 : 0,
                liked: foundGame ? foundGame.liked ? 1 : 0 : 0
            });
            this.getSimilarGames(foundGame ? foundGame.categoryId : 0, uid);
        }
    }, {
        key: 'getSimilarGames',
        value: function getSimilarGames(categoryId, uid) {
            var allGames = this.props.game.games;
            var similarGames = allGames.filter(function (game) {
                return game.categoryId == categoryId;
            });
            this.props.getSimilarGames(similarGames);
        }
    }, {
        key: '_openGame',
        value: function _openGame(game, e) {
            e.preventDefault();
            var searchContainer = document.querySelector("#search-container");
            if (searchContainer != null) {
                if (searchContainer.classList.contains('search-toggle')) {
                    searchContainer.classList.toggle("search-toggle");
                }
            }

            if (e.target.classList.contains('isFavorite')) {

                var pEl = _reactDom2.default.findDOMNode(this.refs['star' + game.gameId]);
                var _check = !pEl.checked;

                var data = {
                    uid: this.props.access.uid,
                    gameId: game.gameId,
                    isFavorite: _check
                };
                if (data.isFavorite) {
                    this.props.showMessage({
                        message: msg.addToFavorites,
                        type: true
                    });
                } else {
                    this.props.showMessage({
                        message: msg.removeFromFavorites,
                        type: false
                    });
                }
                (0, _sendData.sendData)(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
                _axios2.default.post(vars.BASE_URL + '/favorite', data).then(function (response) {
                    if (response.status) {
                        pEl.checked = _check;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            } else {
                window.scrollTo(0, 0);
                this.props.history.push((0, _helper.appendUid)('/detail/' + game.gameId, this.props.access.uid));
            }
        }
    }, {
        key: 'loadGame',
        value: function loadGame() {
            var _this4 = this;

            if (this.shouldUpsell(this.state.game.gameId)) this.applyUpsellingFlow();else {
                (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, 'played');
                this.props.show();
                this.setState({
                    openGame: !this.state.openGame
                });
                setTimeout(function () {
                    _this4.props.hide();
                }, 1000);
            }
        }
    }, {
        key: 'shouldUpsell',
        value: function shouldUpsell(gameId) {
            if (_domainConfig.config.subDomain == 'hua') return true;
            if (_domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') {
                if (gameId == 4 || gameId == 159) return false; //swing robber
                // if (gameId == 31) return false;
                else return true;
            } else return false;
        }
    }, {
        key: 'isAppAllowed',
        value: function isAppAllowed(gameId) {
            if (this.props.access.subscriptionData.allowedApps.indexOf(gameId) == -1) return false;else return true;
        }
    }, {
        key: 'applyUpsellingFlow',
        value: function applyUpsellingFlow() {
            var paymentPageUrl = '';
            if (_domainConfig.config.subDomain == 'hua' || _domainConfig.config.subDomain == 'gmn') paymentPageUrl = 'http://m.game-lords.com/my/best-games-hua?device=smart&offer=1&game_id=' + this.state.game.gameId + '&game_name=' + this.state.game.gameTitle + '&game_image=' + this.state.game.gameImage + '&msisdn=' + this.props.access.subscriptionData.msisdn;else paymentPageUrl = 'http://m.game-lords.com/id/seasonal-sale-hua?device=smart&offer=1&game_id=' + this.state.game.gameId + '&game_name=' + this.state.game.gameTitle + '&game_image=' + this.state.game.gameImage + '&msisdn=' + this.props.access.subscriptionData.msisdn;
            window.open(paymentPageUrl);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            this.changeDomain();
            var gameDetail = this.state.game;
            var gameType = gameDetail.gameType;
            if (_isGamiclub.isGamiclub && _domainConfig.config.subDomain === 'fr' && gameDetail.categoryId === 4) {
                gameDetail.categoryName = "Action (18+)";
            }
            var bgImages = ["", "rpg", "augmented-reality", "virtual-reality", "action", "adventure", "arcade", "racing", "sports", "utilities", "action", "adventure", "arcade", "racing", "sports", "rts", "", "premium", "premium", "", "premium", "premium"];
            var gamesParams = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500
            };
            var open = this.state.open;


            var starWrapClass = 'game-detail-star-wrap';
            var gameCategoryTitleClass = "game-category-title";
            var gameRelatedMoreClass = "game-related-more";
            if (kazakhDomain) {
                starWrapClass += ' kz-star-wrap';
                gameCategoryTitleClass += ' kz-text';
                gameRelatedMoreClass += ' kz-related-more';
            }
            return _react2.default.createElement(
                'section',
                { className: 'game-detail' },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    !this.state.openGame ? _react2.default.createElement(
                        _reactstrap.Row,
                        { className: 'clearfix' },
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'mb-4 px-0' },
                            _react2.default.createElement(
                                _reactstrap.TabContent,
                                { activeTab: this.state.activeTab },
                                gameDetail != null ? _react2.default.createElement(
                                    _reactstrap.TabPane,
                                    { tabId: '1' },
                                    _react2.default.createElement(
                                        _reactstrap.Row,
                                        { className: "game-bg-image " + bgImages[gameDetail.categoryId] },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { lg: '3', xs: '12', className: 'text-right top-z-index game-thumb-wrap' },
                                            _react2.default.createElement('img', { className: 'img-fluid game-thumb', src: gameDetail.gameImage.includes('https://cdn.game-lords.com/games/http') ? gameDetail.gameImage.split('https://cdn.game-lords.com/games/')[1] : gameDetail.gameImage, alt: gameDetail.gameTitle })
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { lg: '9', xs: '12', className: 'top-z-index game-top-wrap' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-detail-top' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-title-rating' },
                                                    _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                        'h3',
                                                        { className: 'game-detail-title' },
                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + gameDetail.gameTitle.toUpperCase(),
                                                            defaultMessage: gameDetail.gameTitle })
                                                    ),
                                                    _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: gameDetail.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                            return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star' });
                                                        } }),
                                                    lang !== 'ar' && lang != 'kk' && lang != 'sv' && lang != 'tr' ? _react2.default.createElement(
                                                        'span',
                                                        { className: 'game-user-rating' },
                                                        gameDetail.userRating,
                                                        '/5',
                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'averageRatingBasedOn',
                                                            defaultMessage: ' average user rating based on '
                                                        }),
                                                        gameDetail.totalUserReview,
                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'averageRatingReview',
                                                            defaultMessage: ' review'
                                                        })
                                                    ) : null
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { id: 'contentMob' },
                                                gameDetail.gameType.toLowerCase() === 'html5' || gameDetail.gameType.toLowerCase() === 'video' ? _react2.default.createElement(
                                                    'a',
                                                    { className: 'game-btn text-shadow-small', onClick: this.loadGame },
                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'playNow',
                                                        defaultMessage: 'Play Now'
                                                    })
                                                ) : _react2.default.createElement(
                                                    'a',
                                                    { className: 'game-btn text-shadow-small', href: '#', onClick: function onClick(e) {
                                                            return _this5.downloadGameApk(e, (0, _helper.appendUid)(gameDetail.gameFile, _this5.props.access.uid));
                                                        } },
                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'downloadNow',
                                                        defaultMessage: 'Download Now'
                                                    })
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-description' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-desc-list' },
                                                    lang !== 'ar' && lang != 'kk' && lang != 'sv' && lang != 'tr' ? _react2.default.createElement(
                                                        'ul',
                                                        { className: 'list-unstyled' },
                                                        _react2.default.createElement(
                                                            'li',
                                                            null,
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'game-desc-left' },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'category',
                                                                    defaultMessage: 'Category'
                                                                })
                                                            ),
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'game-desc-right', style: { paddingLeft: '40px' } },
                                                                ':\u2003',
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + gameDetail.categoryName, defaultMessage: gameDetail.categoryName })
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'li',
                                                            null,
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'game-desc-left' },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'platform',
                                                                    defaultMessage: 'Platform'
                                                                })
                                                            ),
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'game-desc-right', style: { paddingLeft: '40px' } },
                                                                ':\u2003',
                                                                this.translatePlatform(gameDetail.platforms)
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'li',
                                                            null,
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'game-desc-left' },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'type',
                                                                    defaultMessage: 'Type'
                                                                })
                                                            ),
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'game-desc-right', style: { paddingLeft: '40px' } },
                                                                ':\u2003',
                                                                this.translateCategory(gameDetail.gameType)
                                                            )
                                                        )
                                                    ) : null
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-detail-links' },
                                                    window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-detail-star' },
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-detail-star-wrap' },
                                                            _react2.default.createElement(
                                                                'div',
                                                                { className: 'custom-rating' },
                                                                _react2.default.createElement('input', { id: 'fav' + this.state.gameId, ref: 'star' + this.state.gameId, type: 'checkbox', checked: this.state.isFavorite, onChange: this.markFavourite.bind(this, { game: this.state.game, isFavorite: !this.state.isFavorite }) }),
                                                                _react2.default.createElement(
                                                                    'label',
                                                                    { htmlFor: 'fav' + this.state.gameId },
                                                                    _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star-o custom-star isFavorite' })
                                                                )
                                                            ),
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'star-name' },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'favorite',
                                                                    defaultMessage: 'Favorite'
                                                                })
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: starWrapClass },
                                                            _react2.default.createElement(
                                                                'div',
                                                                { className: 'custom-rating' },
                                                                _react2.default.createElement('input', { id: 'game-two', type: 'checkbox', checked: this.state.liked, onChange: this.rateGame.bind(this) }),
                                                                _react2.default.createElement(
                                                                    'label',
                                                                    { htmlFor: 'game-two' },
                                                                    _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-thumbs-o-up custom-thumb' })
                                                                )
                                                            ),
                                                            _react2.default.createElement(
                                                                'span',
                                                                { className: 'star-name' },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'rate',
                                                                    defaultMessage: 'Rate'
                                                                })
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { id: 'contentDes' },
                                                        gameDetail.gameType.toLowerCase() === 'html5' || gameDetail.gameType.toLowerCase() === 'video' ? _react2.default.createElement(
                                                            'a',
                                                            { className: 'game-btn text-shadow-small', onClick: this.loadGame },
                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'playNow',
                                                                defaultMessage: 'Play Now'
                                                            })
                                                        ) : _react2.default.createElement(
                                                            'a',
                                                            { className: 'game-btn text-shadow-small', href: '#', onClick: function onClick(e) {
                                                                    return _this5.downloadGameApk(e, (0, _helper.appendUid)(gameDetail.gameFile, _this5.props.access.uid));
                                                                } },
                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'downloadNow',
                                                                defaultMessage: 'Download Now'
                                                            })
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ) : _react2.default.createElement(
                                    _reactstrap.TabPane,
                                    { tabId: '1' },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'no-game-text' },
                                        'Game not found!'
                                    )
                                )
                            )
                        )
                    ) : _react2.default.createElement(
                        'div',
                        { style: { objectFit: 'cover' } },
                        gameDetail.gameType.toLowerCase() === 'video' ? _react2.default.createElement(_reactHtml5video.DefaultPlayer, { autoPlay: true, style: { height: window.innerWidth < 576 ? '100%' : '65vh' }, src: gameDetail.gameFile,
                            controls: ['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen'] }) : _react2.default.createElement('object', { data: gameDetail.gameFile, className: 'openGame' }),
                        _react2.default.createElement(
                            'h3',
                            { style: { padding: '20px 0px' } },
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + gameDetail.gameTitle.toUpperCase(),
                                defaultMessage: gameDetail.gameTitle })
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', className: 'game-related-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'game-related-top' },
                            _react2.default.createElement(
                                'div',
                                { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : _productCondition.isGameflares ? { borderBottom: '1px solid #FF394B' } : _productCondition.isGamiway ? { borderBottom: '1px solid #b347a0' } : null },
                                gameType == 'VIDEO' ? _react2.default.createElement(
                                    'h2',
                                    { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : _productCondition.isGameflares ? { color: 'white', backgroundColor: '#FF394B' } : _productCondition.isGamiway ? { color: 'white', backgroundColor: '#b347a0' } : null, className: gameCategoryTitleClass },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'relatedVideo',
                                        defaultMessage: 'Related Videos'
                                    })
                                ) : _react2.default.createElement(
                                    'h2',
                                    { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : _productCondition.isGameflares ? { color: 'white', backgroundColor: '#FF394B' } : _productCondition.isGamiway ? { color: 'white', backgroundColor: '#b347a0' } : null, className: gameCategoryTitleClass },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'relatedGames',
                                        defaultMessage: 'Related Games'
                                    })
                                ),
                                _react2.default.createElement(
                                    'a',
                                    { className: gameRelatedMoreClass, style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, href: "/#/category/" + this.state.categoryId + "?uid=" + this.props.access.uid },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'viewAll',
                                        defaultMessage: 'View All'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'medium-desktop-tabs similar-tabs' },
                            this.props.game.similarGames.length > 1 ? _react2.default.createElement(
                                _reactIdSwiper2.default,
                                _extends({}, gamesParams, { shouldSwiperUpdate: true }),
                                this.props.game.similarGames.map(function (game) {
                                    if (game.gameId != _this5.state.gameId) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'swiper-game-card', key: game.gameId },
                                            _react2.default.createElement(
                                                _reactstrap.Card,
                                                { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? "game-card gameflares-game-card" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card", onClick: _this5._openGame.bind(_this5, game) },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-inner' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-thumb-wrap' },
                                                        _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-card-details' },
                                                        _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                            _reactstrap.CardTitle,
                                                            { className: 'game-title text-shadow' },
                                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                                defaultMessage: game.gameTitle })
                                                        ),
                                                        window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                                                            'div',
                                                            { className: 'custom-rating isFavorite' },
                                                            _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                            _react2.default.createElement(
                                                                'label',
                                                                { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                                _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star-o custom-star isFavorite' })
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'game-card-left large-width' },
                                                            gameDetail.gameType.toLowerCase() === 'html5' || gameDetail.gameType.toLowerCase() === 'video' ? _react2.default.createElement(
                                                                'a',
                                                                { className: 'game-btn text-shadow-small small-font', onClick: _this5._openGame.bind(_this5, game) },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'playNow',
                                                                    defaultMessage: 'Play Now'
                                                                })
                                                            ) : _react2.default.createElement(
                                                                'a',
                                                                { className: 'game-btn text-shadow-small small-font', href: '#', onClick: _this5._openGame.bind(_this5, game) },
                                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'downloadNow',
                                                                    defaultMessage: 'Download Now'
                                                                })
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        );
                                    }
                                })
                            ) : _react2.default.createElement(
                                'p',
                                { className: 'white-text-color no-game-text' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'no related games found', defaultMessage: 'No related games found.' })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactResponsiveModal2.default,
                    { open: open, onClose: this.onCloseModal.bind(this), center: true },
                    _react2.default.createElement(
                        'h5',
                        { className: 'modelHeading' },
                        'Incompatible Device'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Device is not compatible with the file'
                    ),
                    _react2.default.createElement(
                        'a',
                        { className: 'modelAnchor', href: (0, _helper.appendUid)("/#/home/html", this.props.access.uid) },
                        _react2.default.createElement(
                            'button',
                            { className: 'modelButton' },
                            'Okay'
                        )
                    )
                )
            );
        }
    }]);

    return GameDetail;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        game: state.GamesReducer,
        access: state.WelcomeReducer,
        header: state.HeaderReducer,
        search: state.SearchReducer

    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getGameDetail: _GamesActions.getGameDetail,
        getSimilarGames: _GamesActions.getSimilarGames,
        showMessage: _FlashMessageActions.showMessage
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameDetail);

/***/ }),

/***/ "./src/components/GameDetail/GameDetailDemo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactResponsiveModal = __webpack_require__("./node_modules/react-responsive-modal/lib/index.es.js");

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _messages = __webpack_require__("./src/constants/messages.js");

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var msg = _messages.messages;

var GameDetailDemo = function (_Component) {
  _inherits(GameDetailDemo, _Component);

  function GameDetailDemo(props) {
    _classCallCheck(this, GameDetailDemo);

    var _this = _possibleConstructorReturn(this, (GameDetailDemo.__proto__ || Object.getPrototypeOf(GameDetailDemo)).call(this, props));

    _this.state = {
      activeTab: "1",
      rating: 0,
      liked: 0,
      isFavorite: 0,
      categoryId: 0,
      gameId: 0,
      openGame: false,
      game: "",
      open: false
    };
    _this.toggle = _this.toggle.bind(_this);
    _this._openGame = _this._openGame.bind(_this);
    _this.loadGame = _this.loadGame.bind(_this);
    return _this;
  }

  _createClass(GameDetailDemo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.scrollTo(0, 0);
      (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, "viewed", { page: "game page" });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.openGame && prevState.gameId != this.state.gameId) {
        (0, _sendData.sendData)(prevState.game.gameTitle, prevState.game.categoryName, prevState.game.gameType, "finished");
        (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, "played");
      } else if (!this.state.openGame && prevState.gameId != this.state.gameId) {
        (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, "viewed");
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var gameId = this.props.match.params.gameId;
      var uid = this.props.access.uid;
      this.getGameDetail(gameId, uid);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.openGame) {
        (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, "finished");
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.match.params.gameId != nextProps.match.params.gameId) {
        this.getGameDetail(nextProps.match.params.gameId, this.props.access.uid);
      }
    }
  }, {
    key: "onOpenModal",
    value: function onOpenModal() {
      this.setState({ open: true });
    }
  }, {
    key: "onCloseModal",
    value: function onCloseModal() {
      this.setState({ open: false });
    }
  }, {
    key: "toggle",
    value: function toggle(tab) {
      if (this.state.activeTab !== tab) {
        this.setState({
          activeTab: tab
        });
      }
    }
  }, {
    key: "getGameDetail",
    value: function getGameDetail(gameId, uid) {
      var allGames = this.props.game.games;
      var foundGame = allGames.find(function (game) {
        return game.gameId == gameId;
      });
      this.props.getGameDetail(foundGame);
      this.setState({
        game: foundGame,
        gameId: gameId,
        categoryId: foundGame ? foundGame.categoryId : 0,
        isFavorite: foundGame ? foundGame.isFavorite ? 1 : 0 : 0,
        liked: foundGame ? foundGame.liked ? 1 : 0 : 0
      });
    }
  }, {
    key: "_openGame",
    value: function _openGame(game, e) {
      e.preventDefault();
      this.props.history.push((0, _helper.appendUid)("/play-maxis/" + game.gameId, this.props.access.uid));
    }
  }, {
    key: "loadGame",
    value: function loadGame() {
      var _this2 = this;

      (0, _sendData.sendData)(this.state.game.gameTitle, this.state.game.categoryName, this.state.game.gameType, "played");
      this.props.show();
      this.setState({
        openGame: !this.state.openGame
      });
      setTimeout(function () {
        _this2.props.hide();
      }, 1000);
    }
  }, {
    key: "render",
    value: function render() {
      var gameDetail = this.state.game;

      var bgImages = ["", "rpg", "augmented-reality", "virtual-reality", "action", "adventure", "arcade", "racing", "sports", "utilities", "action", "adventure", "arcade", "racing", "sports", "rts", "", "premium", "premium", "", "premium", "premium"];

      var open = this.state.open;


      return _react2.default.createElement(
        "section",
        { className: "game-detail" },
        _react2.default.createElement(
          "div",
          { className: "container-fluid" },
          !this.state.openGame ? _react2.default.createElement(
            _reactstrap.Row,
            { className: "clearfix" },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "mb-4 px-0" },
              _react2.default.createElement(
                _reactstrap.TabContent,
                { activeTab: this.state.activeTab },
                gameDetail != null ? _react2.default.createElement(
                  _reactstrap.TabPane,
                  { tabId: "1" },
                  _react2.default.createElement(
                    _reactstrap.Row,
                    {
                      className: "game-bg-image " + bgImages[gameDetail.categoryId]
                    },
                    _react2.default.createElement(
                      _reactstrap.Col,
                      {
                        lg: "3",
                        xs: "12",
                        className: "text-right top-z-index game-thumb-wrap"
                      },
                      _react2.default.createElement("img", {
                        className: "img-fluid game-thumb",
                        src: gameDetail.gameImage.includes("https://cdn.game-lords.com/games/http") ? gameDetail.gameImage.split("https://cdn.game-lords.com/games/")[1] : gameDetail.gameImage,
                        alt: gameDetail.gameTitle
                      })
                    ),
                    _react2.default.createElement(
                      _reactstrap.Col,
                      {
                        lg: "9",
                        xs: "12",
                        className: "top-z-index game-top-wrap"
                      },
                      _react2.default.createElement(
                        "div",
                        { className: "game-detail-top" },
                        _react2.default.createElement(
                          "div",
                          { className: "game-title-rating" },
                          _react2.default.createElement(
                            "h3",
                            { className: "game-detail-title" },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "" + gameDetail.gameTitle.toUpperCase(),
                              defaultMessage: gameDetail.gameTitle
                            })
                          ),
                          _react2.default.createElement(_reactStarRatingComponent2.default, {
                            name: "rate1",
                            starCount: 5,
                            value: gameDetail.userRating,
                            editing: false,
                            renderStarIcon: function renderStarIcon() {
                              return _react2.default.createElement("i", {
                                style: _isGamiclub.isGamiclub ? { color: "green" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                                className: "fa fa-star custom-star"
                              });
                            }
                          })
                        )
                      ),
                      _react2.default.createElement(
                        "div",
                        { id: "contentMob" },
                        _react2.default.createElement(
                          "a",
                          {
                            className: "game-btn text-shadow-small",
                            onClick: this.loadGame
                          },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "playNow",
                            defaultMessage: "Play Now"
                          })
                        )
                      ),
                      _react2.default.createElement(
                        "div",
                        { id: "contentDes" },
                        _react2.default.createElement(
                          "a",
                          {
                            className: "game-btn text-shadow-small",
                            onClick: this.loadGame
                          },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "playNow",
                            defaultMessage: "Play Now"
                          })
                        )
                      ),
                      _react2.default.createElement(
                        "div",
                        { className: "game-description" },
                        _react2.default.createElement("div", { className: "game-desc-list" })
                      )
                    )
                  )
                ) : _react2.default.createElement(
                  _reactstrap.TabPane,
                  { tabId: "1" },
                  _react2.default.createElement(
                    "p",
                    { className: "no-game-text" },
                    "Game not found!"
                  )
                )
              )
            )
          ) : _react2.default.createElement(
            "div",
            { style: { objectFit: "cover" } },
            _react2.default.createElement("object", { data: gameDetail.gameFile, className: "openGame" }),
            _react2.default.createElement(
              "h3",
              { style: { padding: "20px 0px" } },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "" + gameDetail.gameTitle.toUpperCase(),
                defaultMessage: gameDetail.gameTitle
              })
            )
          )
        ),
        _react2.default.createElement(
          _reactResponsiveModal2.default,
          { open: open, onClose: this.onCloseModal.bind(this), center: true },
          _react2.default.createElement(
            "h5",
            { className: "modelHeading" },
            "Incompatible Device"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Device is not compatible with the file"
          ),
          _react2.default.createElement(
            "a",
            {
              className: "modelAnchor",
              href: (0, _helper.appendUid)("/#/home/html", this.props.access.uid)
            },
            _react2.default.createElement(
              "button",
              { className: "modelButton" },
              "Okay"
            )
          )
        )
      );
    }
  }]);

  return GameDetailDemo;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    game: state.GamesReducer,
    access: state.WelcomeReducer,
    header: state.HeaderReducer,
    search: state.SearchReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    getGameDetail: _GamesActions.getGameDetail,
    getSimilarGames: _GamesActions.getSimilarGames,
    showMessage: _FlashMessageActions.showMessage
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameDetailDemo);

/***/ }),

/***/ "./src/components/GameDetail/GameList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _messages = __webpack_require__("./src/constants/messages.js");

var _messages_ar = __webpack_require__("./src/constants/messages_ar.js");

var _messages_kk = __webpack_require__("./src/constants/messages_kk.js");

var _messages_fr = __webpack_require__("./src/constants/messages_fr.js");

var _messages_sv = __webpack_require__("./src/constants/messages_sv.js");

var _messages_no = __webpack_require__("./src/constants/messages_no.js");

var _messages_vi = __webpack_require__("./src/constants/messages_vi.js");

var _messages_tr = __webpack_require__("./src/constants/messages_tr.js");

var _messages_it = __webpack_require__("./src/constants/messages_it.js");

var _messages_es = __webpack_require__("./src/constants/messages_es.js");

var _messages_cy = __webpack_require__("./src/constants/messages_cy.js");

var _messages_de = __webpack_require__("./src/constants/messages_de.js");

var _messages_el = __webpack_require__("./src/constants/messages_el.js");

var _messages_cz = __webpack_require__("./src/constants/messages_cz.js");

var _messages_pt = __webpack_require__("./src/constants/messages_pt.js");

var _messages_lt = __webpack_require__("./src/constants/messages_lt.js");

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _restrictedCategories = __webpack_require__("./src/constants/restrictedCategories.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _helper2 = __webpack_require__("./src/utils/helper.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var msg = void 0;

var GameList = function (_Component) {
    _inherits(GameList, _Component);

    function GameList(props) {
        _classCallCheck(this, GameList);

        var _this = _possibleConstructorReturn(this, (GameList.__proto__ || Object.getPrototypeOf(GameList)).call(this, props));

        _this.state = {
            activeTab: '1',
            rating: 0,
            isValid: false,
            errorMessage: '',
            category: {},
            loading: true
        };

        _this.openGame = _this.openGame.bind(_this);
        _this.changeLanguage = _this.changeLanguage.bind(_this);
        return _this;
    }

    _createClass(GameList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
            (0, _sendData.sendData)('', this.state.category.categoryName, this.state.category.categoryTypeName, 'viewed', { page: 'game list' });
        }
    }, {
        key: 'onStarClick',
        value: function onStarClick(nextValue, prevValue, name) {
            this.setState({ rating: nextValue });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var categoryId = this.props.match.params.categoryId;
            if (this.props.games.categoryGames.length != 0) {
                if (this.props.games.categoryGames[0].categoryId != this.props.match.params.categoryId) {
                    this.props.show();
                    var uid = this.props.access.uid;
                    this.getGames(categoryId, uid);
                }
            } else {
                this.props.show();
                var _uid = this.props.access.uid;
                this.getGames(categoryId, _uid);
            }
            this.getCategoryDetail(categoryId);
            var searchContainer = document.querySelector("#search-container");

            if (searchContainer != null) {
                if (searchContainer.classList.contains('search-toggle')) {
                    searchContainer.classList.toggle("search-toggle");
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.match.params.categoryId != nextProps.match.params.categoryId) {
                this.getGames(nextProps.match.params.categoryId, this.props.access.uid);
                this.getCategoryDetail(nextProps.match.params.categoryId);
            }
        }
    }, {
        key: 'getGames',
        value: function getGames(categoryId, uid) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _axios2.default.get(vars.BASE_URL + '/getGames?categoryId=' + categoryId + '&uid=' + uid).then(function (response) {
                    if (response.data.success) {
                        response.data.data = response.data.data.filter(function (game) {
                            return (0, _restrictedCategories.isCategoryAllowed)(game.categoryName);
                        });
                        if (!(_domainConfig.config.subDomain == 'tr' || _domainConfig.config.subDomain == 'no')) {
                            response.data.data = response.data.data.filter(function (game) {
                                return game.gameTitle != "Trusted Tarot" && game.gameTitle != "Coffee Reading";
                            });
                        }
                        if (_domainConfig.config.subDomain == 'no') response.data.data = response.data.data.map(function (game) {
                            return game.gameId == 455 ? _extends({}, game, { gameTitle: 'Coffee Reading' }) : game;
                        });
                        if (_domainConfig.config.subDomain != 'tr') {
                            response.data.data = response.data.data.filter(function (game) {
                                return game.gameTitle != 'Okey';
                            });
                        }
                        if (_domainConfig.config.subDomain === 'eg') {
                            var excluded_games = ['Santa Claus The Pervert Part 1', 'Place your bets! GTA is getting a real virtual casino', 'Dargavs Welcome to the City of the Dead', 'King Bacon Vs Vegans', 'Jackpot', 'Christmas Night Of Horror', 'High Fly Valentine', 'Horoscope', 'Sacra Terra Kiss Of Death', 'Haunted Legends Undertaker', 'Stereotypo'];
                            response.data.data = response.data.data.filter(function (game) {
                                return excluded_games.indexOf(game.gameTitle) < 0;
                            });
                        }
                        if (!(_domainConfig.config.subDomain === 'gh' || _domainConfig.config.subDomain === 'ci')) {
                            response.data.data = response.data.data.filter(function (game) {
                                return game.gameTitle != 'Fidget Pop It';
                            });
                        }
                        if (_domainConfig.config.subDomain !== 'demo') {
                            var excluded = ['Balancer Ball 3D', 'Bottle Knock Down', 'Brain For Monster Truck', 'Bull Fight', 'Dogs Quiz', 'Forsake The Rake', 'Fruit Slice', 'Horse Quiz', 'Knock Down', 'Physics Line', 'Pixel Art', 'Sheep Fight', 'Slenderman Must Die Abandoned Graveyard', 'Tough Muscle Man', 'Unicorn Dash'];
                            response.data.data = response.data.data.filter(function (game) {
                                return excluded.indexOf(game.gameTitle) < 0;
                            });
                        }
                        if (_domainConfig.config.subDomain === 'demo') {
                            var _excluded = ['Box Race', 'Pacman', "Don't Miss", 'Earth Attack', 'Memory Game', 'Mathematic', 'Office Horror Story', 'Rise Up', 'Shadow Ninja', 'Square Adventure', 'Super Color Lines', 'NINJA CLAN', 'Fidget Spinner', 'Snake Attack', 'King Bacon Vs Vegans', 'CATS VS DOGS', 'Legend Of The Samurai', 'Zombo', 'CANDY GIRL', 'Flappy Bird Multiplayer', 'RUN, VOVAN, RUN', ' BOX TOWER', 'Connect 4', 'Four Colors', 'Math Game', 'Slice Fruit', 'Goose Game'];
                            response.data.data = response.data.data.filter(function (game) {
                                return _excluded.indexOf(game.gameTitle) < 0;
                            });
                        }
                        if (_domainConfig.config.subDomain !== 'pe') {
                            var _excluded2 = ['Caller ID'];
                            response.data.data = response.data.data.filter(function (game) {
                                return _excluded2.indexOf(game.gameTitle) < 0;
                            });
                        }
                        if (_domainConfig.config.subDomain !== 'pe' && _domainConfig.config.subDomain !== 'tr') {
                            var _excluded3 = ['Photo Text Editor', 'Photo Editor Application', 'Pic Shop', 'Retro Cam Pro', 'Facial Twin Editor', 'Valentine Love Mesh', 'Love Photo', 'Wild Side App'];
                            response.data.data = response.data.data.filter(function (game) {
                                return _excluded3.indexOf(game.gameTitle) < 0;
                            });
                        }
                        if (_domainConfig.config.subDomain !== 'gr' && _domainConfig.config.subDomain !== 'cz' && _domainConfig.config.subDomain !== 'ch' && _domainConfig.config.subDomain !== 'fr') {
                            var _excluded4 = ['PDF Merger', 'QR Scanner'];
                            response.data.data = response.data.data.filter(function (game) {
                                return _excluded4.indexOf(game.gameTitle) < 0;
                            });
                        }
                        if (_domainConfig.config.subDomain === 'pe') {
                            var _excluded5 = ['Brain it on the truck', 'Pacman', 'Earth Attack', 'Brain For Monster Truck'];
                            response.data.data = response.data.data.filter(function (game) {
                                if (game.categoryName === 'Adventure' && game.gameTitle === 'Rise Up') {
                                    return false;
                                }
                                return _excluded5.indexOf(game.gameTitle) < 0;
                            });
                        }
                    }
                    _this2.props.getCategorygame(response.data);
                    _this2.setState({ loading: false });
                    resolve();
                }).catch(function (error) {
                    _this2.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
                    _this2.setState({ loading: false });
                    reject(error);
                });
            });
        }
    }, {
        key: 'translateCat',
        value: function translateCat(categoriesArr, lang) {
            var translatedCatArr = categoriesArr.map(function (cat) {
                var englishCat = ["Premium Games", "Action", "Adventure", "RPG", "Virtual Reality", "Arcade", "Racing", "Sports"];
                var arabicCat = ["العاب مميزه", "الاكشن", "المغامرات", "العاب ار بي جي", "الواقع الافتراضي", "مغامرات", "سباق", "الرياضه"];
                var kazakhCat = ["Премиум игры", "Экшн", "Приключения", "RPG", "Виртуальная реальность", "Аркады", "Гонки", "Спорт"];
                var frenchCat = ["Jeux Premium", "Action", "Aventure", "RPG", "Réalité virtuelle", "Arcade", "Course", "Sports"];
                var swedishCat = ["Premium-spel", 'Action', 'Äventyr', 'RPG', 'Virtual Reality', 'Arkad', 'Racing', 'Sporter'];
                var belgiumCat = ["Premium spelletjes", "Actie", "Avontuur", "RPG", "Virtuele realiteit", "Arcade", "Racen", "Sport"];
                var norwayCat = ["Premium-spill", "Action", "Eventyr", "RPG", "Virtuell virkelighet", "Arkade", "Racing", "Sport"];
                var vietnamCat = ["Games độc quyền", "Hành động", "Phiêu lưu", "RPG", "Thực tế ảo", "Nhập vai", "Đua xe", "Thể thao"];
                var turkeyCat = ["Premium Oyunlar   ", "Aksiyon", "Macera", "RPG", "Sanal Gerçeklik", "Arcade oyun", "Yarış ", "Spor"];
                var spanishCat = ["Juegos prémium", "Acción", "Aventura", "RPG", "Realidad Virtual", "Arcade", "Correr", "Deporte"];

                var index = englishCat.indexOf(cat.categoryName);
                if (index != -1) {
                    if (lang == 'ar') {
                        cat = _extends({}, cat, { categoryName: arabicCat[index] });
                    } else if (lang == 'kk') {
                        cat = _extends({}, cat, { categoryName: kazakhCat[index] });
                    } else if (lang == 'fr') {
                        cat = _extends({}, cat, { categoryName: frenchCat[index] });
                    } else if (lang == 'sv') {
                        cat = _extends({}, cat, { categoryName: swedishCat[index] });
                    } else if (lang == 'be') {
                        cat = _extends({}, cat, { categoryName: belgiumCat[index] });
                    } else if (lang == 'no') {
                        cat = _extends({}, cat, { categoryName: norwayCat[index] });
                    } else if (lang == 'vi') {
                        cat = _extends({}, cat, { categoryName: vietnamCat[index] });
                    } else if (lang == 'tr') {
                        cat = _extends({}, cat, { categoryName: turkeyCat[index] });
                    } else if (lang == 'es') {
                        cat = _extends({}, cat, { categoryName: spanishCat[index] });
                    }
                }
                return cat;
            });
            return translatedCatArr;
        }
    }, {
        key: 'getCategoryDetail',
        value: function getCategoryDetail(categoryId) {
            var allCategories = this.props.categories.categories;
            var foundCategory = allCategories.find(function (cat) {
                return cat.categoryId == categoryId;
            });
            // let translatedCategory = this.translateCat(foundCategory);
            this.props.getCategoryDetail(foundCategory);
            this.setState({
                category: foundCategory
            });
            this.props.hide();
        }
    }, {
        key: 'openGame',
        value: function openGame(game, e) {
            var _this3 = this;

            if (e.target.classList.contains('isFavorite')) {
                var data = {
                    uid: this.props.access.uid,
                    gameId: game.gameId,
                    isFavorite: !game.isFavorite
                };
                if (data.isFavorite) {
                    this.props.showMessage({
                        message: msg.addToFavorites,
                        type: true
                    });
                } else {
                    this.props.showMessage({
                        message: msg.removeFromFavorites,
                        type: false
                    });
                }
                (0, _sendData.sendData)(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
                _axios2.default.post(vars.BASE_URL + '/favorite', data).then(function (response) {
                    if (response.status) {
                        _this3.getGames(_this3.props.match.params.categoryId, _this3.props.access.uid).then(function () {}).catch(function (err) {
                            console.log(err);
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            } else if (e.target.tagName.toLowerCase() != 'input') {
                this.props.history.push((0, _helper.appendUid)('/detail/' + game.gameId, this.props.access.uid));
            }
        }
    }, {
        key: 'changeLanguage',
        value: function changeLanguage() {
            switch (_domainConfig.config.lang) {
                case 'ar':
                    msg = _messages_ar.messages_ar;
                    break;
                case 'kk':
                    msg = _messages_kk.messages_kk;
                    break;
                case 'fr':
                    msg = _messages_fr.messages_fr;
                    break;
                case 'sv':
                    msg = _messages_sv.messages_sv;
                    break;
                case 'no':
                    msg = _messages_no.messages_no;
                    break;
                case 'vi':
                    msg = _messages_vi.messages_vi;
                    break;
                case 'tr':
                    msg = _messages_tr.messages_tr;
                    break;
                case 'it':
                    msg = _messages_it.messages_it;
                    break;
                case 'es':
                    msg = _messages_es.messages_es;
                    break;
                case 'cy':
                    msg = _messages_cy.messages_cy;
                    break;
                case 'de':
                    msg = _messages_de.messages_de;
                    break;
                case 'el':
                    msg = _messages_el.messages_el;
                    break;
                case 'cs':
                    msg = _messages_cz.messages_cz;
                    break;
                case 'pt':
                    msg = _messages_pt.messages_pt;
                    break;
                case 'lt':
                    msg = _messages_lt.messages_lt;
                    break;
                default:
                    msg = _messages.messages;
                    break;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var starIcon = '<svg class="isFavorite" width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.3328" y1="14" x2="25.6672" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.2078" y1="14" x2="25.7922" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="isFavorite" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg>',
                thumbsUpIcon = '<svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="0.5" y1="14" x2="24.5" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="0.375" y1="14" x2="24.625" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="st0" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M320 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zm160-512v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zm1184 0q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-129q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 .5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"/></svg>';
            this.changeLanguage();
            var categoryName = this.state.category.categoryName;
            if (_isGamiclub.isGamiclub && _domainConfig.config.subDomain === 'fr' && this.state.category.categoryId === 4) {
                categoryName = "Action (18+)";
            }
            /*if(this.state.loading){ 
                return <div className='activity-indicator'> <img className={isGamiclub ? 'icon-loader-gamiclub' : 'icon-loader'} src={isGamiclub ? './img/ball-triangle.svg' : './img/g-icon.svg'} alt="Loading..."/></div>;
            }
            else {*/
            return _react2.default.createElement(
                'section',
                { className: 'categoryListPage' },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : _productCondition.isGameflares ? { borderBottom: '1px solid #FF394B' } : _productCondition.isGamiway ? { borderBottom: '1px solid #b347a0' } : null },
                                _react2.default.createElement(
                                    'h2',
                                    { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : _productCondition.isGameflares ? { color: 'white', backgroundColor: '#FF394B' } : _productCondition.isGamiway ? { color: 'white', backgroundColor: '#b347a0' } : null, className: 'game-category-title' },
                                    _react2.default.createElement('i', { className: this.state.category ? this.state.category.categoryIcon : "fa fa-rocket", 'aria-hidden': 'true' }),
                                    this.state.category ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + categoryName,
                                        defaultMessage: categoryName
                                    }) : ""
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.Row,
                        { className: 'game-list-row' },
                        this.props.games.categoryGames.length > 0 ? this.props.games.categoryGames.map(function (game) {
                            return (0, _helper2.filterGames)(game) ? _react2.default.createElement(
                                _reactstrap.Col,
                                { xl: '2', md: '3', sm: '4', xs: '6', key: game.gameId },
                                _react2.default.createElement(
                                    _reactstrap.Card,
                                    { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? " game-card gameflares-game-card" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card", onClick: _this4.openGame.bind(_this4, game) },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'game-card-inner' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'game-thumb-wrap' },
                                            _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'game-card-details' },
                                            _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                _reactstrap.CardTitle,
                                                { className: 'game-title text-shadow' },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                    defaultMessage: game.gameTitle })
                                            ),
                                            window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                                                'div',
                                                { className: 'custom-rating isFavorite' },
                                                _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                _react2.default.createElement(
                                                    'label',
                                                    { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                    _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star-o custom-star isFavorite' })
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-card-left' },
                                                _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                        return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star' });
                                                    } })
                                            ),
                                            !window.location.hostname.includes('vplay') && _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                'div',
                                                { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                game.gameType.toLowerCase() == 'html5' ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : game.gameType.toLowerCase() === "android" ? _react2.default.createElement('i', { className: 'fa fa-android', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' })
                                            )
                                        )
                                    )
                                )
                            ) : null;
                        }) : _react2.default.createElement(
                            _reactstrap.Col,
                            { xl: '12', lg: '12', md: '12', sm: '12', xs: '12' },
                            ' ',
                            _react2.default.createElement(
                                'p',
                                { className: 'white-text-color no-game-text' },
                                window.location.hash.includes('home/video') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noVideosFound', defaultMessage: 'No videos found under this category.' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noGamesFound', defaultMessage: 'No games found under this category.' })
                            )
                        )
                    )
                )
            );
            //}
        }
    }]);

    return GameList;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        games: state.GamesReducer,
        categories: state.CategoryReducer,
        access: state.WelcomeReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getCategorygame: _GamesActions.getCategorygame,
        getCategoryDetail: _CategoryActions.getCategoryDetail,
        showMessage: _FlashMessageActions.showMessage
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GameList);

/***/ }),

/***/ "./src/components/Header/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _HeaderDropdown = __webpack_require__("./src/components/Header/HeaderDropdown.js");

var _HeaderDropdown2 = _interopRequireDefault(_HeaderDropdown);

var _AuthenticationActions = __webpack_require__("./src/actions/AuthenticationActions.js");

var _HeaderActions = __webpack_require__("./src/actions/HeaderActions.js");

var _SearchActions = __webpack_require__("./src/actions/SearchActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isOnlyBeemobi = __webpack_require__("./src/constants/isOnlyBeemobi.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

var _isGamezClan = __webpack_require__("./src/constants/isGamezClan.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _domainTheme = __webpack_require__("./src/utils/domainTheme.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain = _domainConfig.config.lang == "ar" ? true : false;
var frenchDomain = _domainConfig.config.lang == "fr" ? true : false;
var kazakhDomain = _domainConfig.config.lang == "kk" ? true : false;
var norwayDomain = _domainConfig.config.lang == "no" ? true : false;
var swedishDomain = _domainConfig.config.lang == "sv" ? true : false;
var turkeyDomain = _domainConfig.config.lang == "tr" ? true : false;
var spanishDomain = _domainConfig.config.lang == "es" ? true : false;

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.searchOpen = _this.searchOpen.bind(_this);

    _this.onSearchTextChange = _this.onSearchTextChange.bind(_this);
    _this.clearText = _this.clearText.bind(_this);
    return _this;
  }

  _createClass(Header, [{
    key: "sidebarToggle",
    value: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
    }
  }, {
    key: "mobileSidebarToggle",
    value: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
    }
  }, {
    key: "redirectToWelcome",
    value: function redirectToWelcome(e) {
      if (!document.body.classList.contains("sidebar-hidden")) {
        document.body.classList.toggle("sidebar-hidden");
      }
      if (document.body.classList.contains("sidebar-mobile-show")) {
        document.body.classList.toggle("sidebar-mobile-show");
      }
    }
    // searchOpen() {
    //     debugger
    //     this.props.showbar(!this.props.header.showSearchBar);
    //     let searchInput = document.querySelector("#search-input");
    //     if (!this.props.header.showSearchBar) {
    //         searchInput.focus();
    //     } else {
    //         searchInput.blur();
    //     }
    //     this.clearText();
    // }

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.hideSearchBar();
    }
  }, {
    key: "clearText",
    value: function clearText() {
      this.props.searchText("");
    }
  }, {
    key: "onSearchTextChange",
    value: function onSearchTextChange(text) {
      this.props.searchText(text);
    }
  }, {
    key: "hideSearchBar",
    value: function hideSearchBar() {
      var currentThis = this;
      document.querySelector(".app-body").addEventListener("click", function (e) {
        if (e.target.classList.contains("custom-star")) {} else {
          var searchContainer = document.querySelector("#search-container");
          var searchInput = document.querySelector("#search-input");
          searchContainer.classList.remove("search-toggle");
          if (searchContainer.classList.contains("search-toggle")) {
            searchInput.focus();
          } else {
            searchInput.blur();
          }
        }
      });
    }
  }, {
    key: "searchOpen",
    value: function searchOpen() {
      this.clearText();
      this.props.showbar(!this.props.header.showSearchBar);
      var searchContainer = document.querySelector("#search-container");
      var searchInput = document.querySelector("#search-input");
      var navbar = document.querySelector("#navbar");
      var navbarLeft = document.querySelector("#navbar-left");
      searchContainer.classList.toggle("search-toggle");
      navbar.classList.toggle("search-toggle");
      navbarLeft.classList.toggle("search-toggle");
      document.body.classList.toggle("hamburger-menu-hidden");
      if (searchContainer.classList.contains("search-toggle")) {
        searchInput.focus();
      } else {
        searchInput.blur();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.props.changeLang(event.target.value);
      this.setState({});
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.props.currentLang == "ar" ? document.body.classList.add("ar") : document.body.classList.add("other");
      var isAdmin = this.props.user.isAdmin;
      var showSearch = true;
      var maxis_email = void 0;

      if (this.props.pathName.indexOf("/welcome") != -1 || this.props.pathName.indexOf("/search") != -1 || this.props.pathName.indexOf("/account") != -1 || this.props.pathName.indexOf("/restricted") != -1) {
        showSearch = false;
      }

      if (sessionStorage.getItem("maxis_email")) {
        maxis_email = sessionStorage.getItem("maxis_email");
      }
      var theme = (0, _domainTheme.getDomainTheme)();

      return _react2.default.createElement(
        "header",
        {
          id: "navbar",
          className: this.props.currentLang == "ar" ? "app-header navbar ar" : _productCondition.isGameflares ? "app-header navbar gameflares_bg" : "app-header navbar other"
        },
        _react2.default.createElement(
          "div",
          { className: "container-fluid" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col-xs-12" },
              this.props.pathName.indexOf("/restricted") != -1 ? "" : _react2.default.createElement(
                "div",
                {
                  id: "navbar-left",
                  className: "navbar-left " + (_productCondition.isGameflares ? "gameflares_bg" : "")
                },
                window.location.hostname.includes("vplay") ? null : !this.props.pathName.includes("maxis") && _react2.default.createElement(
                  _reactstrap.NavbarToggler,
                  {
                    className: "d-lg-none " + (_productCondition.isGameflares ? "gameflares_bg" : ""),
                    onClick: this.mobileSidebarToggle
                  },
                  _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement("i", {
                      style: { color: theme.color },
                      className: "icon-menu menu-icon"
                    })
                  )
                ),
                window.location.hostname.includes("vplay") ? null : !this.props.pathName.includes("maxis") && _react2.default.createElement(
                  _reactstrap.NavbarToggler,
                  {
                    className: "d-md-down-none desktop-menuicon " + (_productCondition.isGameflares ? "gameflares_bg" : ""),
                    onClick: this.sidebarToggle
                  },
                  _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement("i", {
                      style: { color: theme.color },
                      className: "icon-menu menu-icon"
                    })
                  )
                ),
                this.props.pathName.indexOf("/account") != -1 ? "" : _react2.default.createElement(_reactstrap.NavbarBrand, {
                  className: _isOnlyMobbfun.isOnlyMobbfun ? "navbar-brand-mobbfun" : _productCondition.isGameflares ? "navbar-brand-gameflares" : undefined,
                  style: { backgroundImage: "url(" + theme.logo + ")" },
                  href: swedishDomain || _domainConfig.config.subDomain == "th" || _domainConfig.config.subDomain == "rsma" || window.location.hostname.includes("game-lords.com") && _domainConfig.config.subDomain === "ae" || window.location.hostname.includes("vplay") ? (0, _helper.appendUid)("#/home/html", this.props.access.uid) : _domainConfig.config.subDomain == "pk" ? (0, _helper.appendUid)("#/home/android", this.props.access.uid) : window.location.href.includes("maxis") ? "/#/demo-maxis" : (0, _helper.appendUid)("#/welcome", this.props.access.uid),
                  onClick: this.redirectToWelcome
                })
              ),
              this.props.pathName.indexOf("/account") != -1 || _domainConfig.config.subDomain === "es" && this.props.pathName.indexOf("/welcome") >= 0 && screen.width > 768 ? _react2.default.createElement(
                "h2",
                { className: "page-title white-text-color" },
                this.props.header.title
              ) : _react2.default.createElement("span", null),
              window.location.href.includes("maxis") ? _react2.default.createElement(
                "h2",
                { className: "page-title white-text-color maxis-login" },
                sessionStorage.getItem("maxis_email") ? "Hello " + sessionStorage.getItem("maxis_email") : _react2.default.createElement(
                  "a",
                  {
                    href: "#",
                    onClick: function onClick(e) {
                      e.preventDefault();
                      if (_this2.props.onLoginClick) _this2.props.onLoginClick();
                    }
                  },
                  "Signup/Login"
                )
              ) : _react2.default.createElement("span", null),
              window.location.hostname.includes("vplay") ? null : !this.props.pathName.includes("maxis") && _react2.default.createElement(
                _reactstrap.Nav,
                { className: "navbar search-wrap" },
                isAdmin ? _react2.default.createElement(_HeaderDropdown2.default, { logout: this.props.logout }) : showSearch ? _react2.default.createElement(
                  _reactstrap.NavItem,
                  {
                    id: "search-container",
                    className: "d-md-down-none search-container search"
                  },
                  _react2.default.createElement(
                    _reactstrap.NavLink,
                    {
                      className: arabicDomain ? "search-button ar" : "search-button",
                      id: "search-button",
                      onClick: this.searchOpen
                    },
                    _isGamiclub.isGamiclub ? _react2.default.createElement("img", {
                      className: "icon-magnifier menu-icon search-icon",
                      src: "./img/gamiclub/search.png"
                    }) : _productCondition.isGameflares ? _react2.default.createElement("img", {
                      className: "icon-magnifier menu-icon search-icon",
                      src: "./img/gameflares/magnifying-glass.png"
                    }) : _productCondition.isGamiway ? _react2.default.createElement("img", {
                      className: "icon-magnifier menu-icon search-icon",
                      src: "./img/gamiway/search.png"
                    }) : _react2.default.createElement("img", {
                      className: "icon-magnifier menu-icon search-icon",
                      src: "./img/icons/search-icon.png"
                    })
                  ),
                  _react2.default.createElement(
                    _reactIntl.FormattedMessage,
                    {
                      defaultMessage: "Search...",
                      id: "search.input.placeholder"
                    },
                    function (placeholder) {
                      return _react2.default.createElement(_reactstrap.Input, {
                        style: _isGamiclub.isGamiclub ? { borderColor: "green" } : _productCondition.isGameflares ? { borderColor: "#FF394B" } : _productCondition.isGamiway ? { borderColor: "#b347a0" } : null,
                        onChange: function onChange(e) {
                          return _this2.onSearchTextChange(e.target.value);
                        },
                        placeholder: placeholder,
                        id: "search-input",
                        className: "search-input",
                        type: "search",
                        value: _this2.props.search.searchText
                      });
                    }
                  ),
                  _react2.default.createElement(
                    "button",
                    {
                      className: "search-clear",
                      onClick: this.clearText
                    },
                    _isGamiclub.isGamiclub || _productCondition.isGameflares || _productCondition.isGamiway ? _react2.default.createElement("i", {
                      className: "fa fa-times " + (_productCondition.isGameflares ? "fa-gradient-gameflares" : _productCondition.isGamiway ? "fa-gradient-gamiway" : "fa-gradient-gamiclub"),
                      style: { fontSize: "18px" },
                      "aria-hidden": "true"
                    }) : _react2.default.createElement("img", { src: "./img/icons/clear.svg" })
                  ),
                  _react2.default.createElement(
                    "button",
                    {
                      style: _isGamiclub.isGamiclub ? { color: "green" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                      className: "search-cancel",
                      onClick: this.searchOpen
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "search.cancel.button",
                      defaultMessage: "Cancel"
                    })
                  )
                ) : ""
              )
            )
          )
        )
      );
    }
  }]);

  return Header;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.AuthenticationReducer,
    header: state.HeaderReducer,
    search: state.SearchReducer,
    access: state.WelcomeReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    logout: _AuthenticationActions.logout,
    searchText: _SearchActions.searchText,
    showbar: _HeaderActions.showbar
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

/***/ }),

/***/ "./src/components/Header/HeaderDropdown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderDropdown = function (_React$Component) {
    _inherits(HeaderDropdown, _React$Component);

    function HeaderDropdown(props) {
        _classCallCheck(this, HeaderDropdown);

        var _this = _possibleConstructorReturn(this, (HeaderDropdown.__proto__ || Object.getPrototypeOf(HeaderDropdown)).call(this, props));

        _this.toggle = _this.toggle.bind(_this);
        _this.state = {
            dropdownOpen: false
        };

        _this.logout = _this.logout.bind(_this);
        return _this;
    }

    _createClass(HeaderDropdown, [{
        key: 'toggle',
        value: function toggle() {
            this.setState({
                dropdownOpen: !this.state.dropdownOpen
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.props.logout();
        }
    }, {
        key: 'dropAccnt',
        value: function dropAccnt() {
            return _react2.default.createElement(
                _reactstrap.Dropdown,
                { nav: true, isOpen: this.state.dropdownOpen, toggle: this.toggle },
                _react2.default.createElement(
                    _reactstrap.DropdownToggle,
                    { nav: true },
                    _react2.default.createElement(
                        'div',
                        { className: 'header-dropdown img-avatar' },
                        _react2.default.createElement('i', { className: 'fa fa-user' })
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.DropdownMenu,
                    { right: true },
                    _react2.default.createElement(
                        _reactstrap.DropdownItem,
                        { onClick: this.logout },
                        _react2.default.createElement('i', { className: 'fa fa-lock' }),
                        ' Logout'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var attributes = _objectWithoutProperties(this.props, []);

            return this.dropAccnt();
        }
    }]);

    return HeaderDropdown;
}(_react2.default.Component);

exports.default = HeaderDropdown;

/***/ }),

/***/ "./src/components/HomePage/HomePage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _SearchActions = __webpack_require__("./src/actions/SearchActions.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _Banner = __webpack_require__("./src/components/Banner/Banner.js");

var _Banner2 = _interopRequireDefault(_Banner);

var _CategoryGames = __webpack_require__("./src/components/CategoryGames/CategoryGames.js");

var _CategoryGames2 = _interopRequireDefault(_CategoryGames);

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _messages = __webpack_require__("./src/constants/messages.js");

var _messages_ar = __webpack_require__("./src/constants/messages_ar.js");

var _messages_kk = __webpack_require__("./src/constants/messages_kk.js");

var _messages_fr = __webpack_require__("./src/constants/messages_fr.js");

var _messages_sv = __webpack_require__("./src/constants/messages_sv.js");

var _messages_no = __webpack_require__("./src/constants/messages_no.js");

var _messages_vi = __webpack_require__("./src/constants/messages_vi.js");

var _messages_tr = __webpack_require__("./src/constants/messages_tr.js");

var _messages_it = __webpack_require__("./src/constants/messages_it.js");

var _messages_es = __webpack_require__("./src/constants/messages_es.js");

var _messages_cy = __webpack_require__("./src/constants/messages_cy.js");

var _messages_de = __webpack_require__("./src/constants/messages_de.js");

var _messages_el = __webpack_require__("./src/constants/messages_el.js");

var _messages_ro = __webpack_require__("./src/constants/messages_ro.js");

var _messages_cz = __webpack_require__("./src/constants/messages_cz.js");

var _messages_pt = __webpack_require__("./src/constants/messages_pt.js");

var _messages_lt = __webpack_require__("./src/constants/messages_lt.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CategoryList = __webpack_require__("./src/components/CategoryList/CategoryList.js");

var _CategoryList2 = _interopRequireDefault(_CategoryList);

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _wallpaper = __webpack_require__("./src/components/wallpapers/wallpaper.js");

var _wallpaper2 = _interopRequireDefault(_wallpaper);

var _video = __webpack_require__("./src/components/UploadVideos/video.js");

var _video2 = _interopRequireDefault(_video);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _texts = __webpack_require__("./src/constants/texts.js");

var _videos = __webpack_require__("./src/constants/videos.js");

var _textModal = __webpack_require__("./src/components/TextModal/textModal.js");

var _textModal2 = _interopRequireDefault(_textModal);

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain, malasiyaDomain, kazakhDomain, swedishDomain, frenchDomain, belgiumDomain, norwayDomain, vietnamDomain, turkeyDomain, italianDomain, spanishDomain;
var msg = {};

var HomePage = function (_Component) {
    _inherits(HomePage, _Component);

    function HomePage(props) {
        _classCallCheck(this, HomePage);

        var _this = _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).call(this, props));

        _this.state = {
            gameType: '',
            switcherState: false,
            loading: true
        };
        _this.openGame = _this.openGame.bind(_this);
        _this.toggleSwitcher = _this.toggleSwitcher.bind(_this);
        _this.changeDomain = _this.changeDomain.bind(_this);
        return _this;
    }

    _createClass(HomePage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.games.games.length <= 0) {}
            if (this.props.history.location.pathname.split('/')[2] == 'html') {
                this.setState({
                    gameType: 'html5'
                });
                (0, _sendData.sendData)('', '', 'html5', 'viewed', { page: 'html5 home' });
            } else if (this.props.history.location.pathname.split('/')[2] == 'android') {
                this.setState({
                    gameType: 'android'
                });
                (0, _sendData.sendData)('', '', 'android', 'viewed', { page: 'android home' });
            } else if (this.props.history.location.pathname.split('/')[2] == 'video' && (_isGamiclub.isGamiclub || _domainConfig.config.subDomain === 'za' || _domainConfig.config.subDomain === 'kw' || _domainConfig.config.subDomain === 'pt')) {
                this.setState({
                    gameType: 'video'
                });
                (0, _sendData.sendData)('', '', 'video', 'viewed', { page: 'video home' });
            } else {
                this.props.history.push("/login");
            }
            this.props.searchText('');
            if (this.props.categories.categories) {
                this.setState({ categoriesTranslated: true });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.categories.categories) {
                this.setState({ categoriesTranslated: true });
            }
            window.scrollTo(0, 0);
        }
    }, {
        key: 'changeDomain',
        value: function changeDomain() {
            arabicDomain = _domainConfig.config.lang == 'ar' ? true : false;
            kazakhDomain = _domainConfig.config.lang == 'kk' ? true : false;
            swedishDomain = _domainConfig.config.lang == 'sv' ? true : false;
            frenchDomain = _domainConfig.config.lang == 'fr' ? true : false;
            belgiumDomain = _domainConfig.config.lang == 'be' ? true : false;
            norwayDomain = _domainConfig.config.lang == 'no' ? true : false;
            vietnamDomain = _domainConfig.config.lang == 'vi' ? true : false;
            turkeyDomain = _domainConfig.config.lang == 'tr' ? true : false;
            spanishDomain = _domainConfig.config.lang == 'es' ? true : false;
            italianDomain = _domainConfig.config.lang == 'it' ? true : false;
            malasiyaDomain = _domainConfig.config.country == 'my' ? true : false;

            switch (_domainConfig.config.lang) {
                case 'ar':
                    msg = _messages_ar.messages_ar;
                    break;
                case 'kk':
                    msg = _messages_kk.messages_kk;
                    break;
                case 'fr':
                    msg = _messages_fr.messages_fr;
                    break;
                case 'sv':
                    msg = _messages_sv.messages_sv;
                    break;
                case 'no':
                    msg = _messages_no.messages_no;
                    break;
                case 'vi':
                    msg = _messages_vi.messages_vi;
                    break;
                case 'tr':
                    msg = _messages_tr.messages_tr;
                    break;
                case 'es':
                    msg = _messages_es.messages_es;
                    break;
                case 'it':
                    msg = _messages_it.messages_it;
                    break;
                case 'cy':
                    msg = _messages_cy.messages_cy;
                    break;
                case 'de':
                    msg = _messages_de.messages_de;
                    break;
                case 'el':
                    msg = _messages_el.messages_el;
                    break;
                case 'ro':
                    msg = _messages_ro.messages_ro;
                    break;
                case 'cs':
                    msg = _messages_cz.messages_cz;
                    break;
                case 'pt':
                    msg = _messages_pt.messages_pt;
                    break;
                case 'lt':
                    msg = _messages_lt.messages_lt;
                    break;
                default:
                    msg = _messages.messages;
                    break;
            }
        }
    }, {
        key: 'toggleSwitcher',
        value: function toggleSwitcher(e) {
            this.setState({
                switcherState: e.target.checked
            });
            this.getFavouriteGames();
        }
    }, {
        key: 'getFavouriteGames',
        value: function getFavouriteGames() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getFavorites?uid=' + this.props.access.uid).then(function (response) {
                if (response.data.success) {
                    _this2.props.getFavouriteGames(response.data);
                }
            }).catch(function (error) {
                _this2.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.history.location.pathname.split('/')[2] == 'html') {
                this.setState({
                    gameType: 'html5'
                });
            } else if (nextProps.history.location.pathname.split('/')[2] == 'android') {
                this.setState({
                    gameType: 'android'
                });
            } else if (nextProps.history.location.pathname.split('/')[2] == 'video') {
                this.setState({
                    gameType: 'video'
                });
            }
        }
    }, {
        key: 'openGame',
        value: function openGame(game, e) {
            var _this3 = this;

            e.preventDefault();
            if (e.target.classList.contains('isFavorite')) {
                var pEl = void 0;
                if (this.state.switcherState == true) {
                    pEl = _reactDom2.default.findDOMNode(this.refs['star' + game.gameId]);
                } else {
                    pEl = document.getElementById('fav' + game.gameId);
                }
                var _check = !pEl.checked;
                var data = {
                    uid: this.props.access.uid,
                    gameId: game.gameId,
                    isFavorite: _check //!game.isFavorite
                };

                var allGames = this.props.games.games,
                    gameIndex = this.props.games.games.findIndex(function (g) {
                    return g.gameId == game.gameId;
                }),
                    favGameIndex = this.props.games.favoriteGames.findIndex(function (g) {
                    return g.gameId == game.gameId;
                }),
                    favoriteGame = this.props.games.favoriteGames;

                allGames[gameIndex].isFavorite = !game.isFavorite;

                if (!game.isFavorite) {
                    if (favGameIndex > -1) {
                        favoriteGame.push(game);
                    }
                } else {
                    favoriteGame.splice(favGameIndex, 1);
                }

                this.props.setFavouriteGames({
                    games: allGames,
                    favoriteGames: favoriteGame
                });

                if (_check) {
                    this.props.showMessage({
                        message: msg.addToFavorites,
                        type: true
                    });
                } else {
                    this.props.showMessage({
                        message: msg.removeFromFavorites,
                        type: false
                    });
                }
                (0, _sendData.sendData)(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
                _axios2.default.post(vars.BASE_URL + '/favorite', data).then(function (response) {
                    if (response.status) {

                        if (_this3.state.switcherState == true) {
                            _this3.getFavouriteGames();
                        } else {
                            pEl.checked = _check;
                        }
                    }
                }).catch(function (error) {
                    (0, _helper.console_log)(error);
                });
            } else if (e.target.tagName != 'INPUT') {
                this.props.history.push((0, _helper.appendUid)('/detail/' + game.gameId, this.props.access.uid));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            console.log('isGamiway===>', _domainConfig.config.subDomain);
            this.changeDomain();

            var bannerData = void 0;
            var htmlBannerDataMobile = void 0;
            var htmlBannerData = void 0;
            if (this.state.gameType == 'html5') {
                htmlBannerData = [{
                    //imgUrl: './img/html5-banner.jpg',
                    imgUrl: './img/my-html5-banner-new.png',
                    offer: null,
                    game_name: '',
                    category_name: '',
                    //id: 34
                    id: 26
                }];
                htmlBannerDataMobile = [{
                    //imgUrl: './img/mobile-html5-banner.jpg',
                    imgUrl: './img/my-html5-banner-new.png',
                    offer: null,
                    game_name: '',
                    category_name: '',
                    //id: 34
                    id: 26

                }];

                if (arabicDomain) {
                    htmlBannerData[0].imgUrl = './img/asiacell-html5-pc.png';
                    htmlBannerDataMobile[0].imgUrl = './img/asiacell-html5-mobile.png';
                } else if (kazakhDomain) {
                    htmlBannerData[0].imgUrl = './img/kazakh-html5-pc.jpg';
                    htmlBannerDataMobile[0].imgUrl = './img/kazakh-html5-mobile.jpg';
                } else if (swedishDomain) {
                    htmlBannerData[0].imgUrl = './img/se-html5-pc.png';
                    htmlBannerDataMobile[0].imgUrl = './img/se-html5-mobile.png';
                } else if (malasiyaDomain) {
                    htmlBannerData[0].imgUrl = './img/my-html5-banner-new.png';
                    htmlBannerDataMobile[0].imgUrl = './img/my-html5-banner-new.png';
                    htmlBannerData[0].id = 26;
                    htmlBannerDataMobile[0].id = 26;
                }

                if (window.innerWidth <= 575) {
                    bannerData = htmlBannerDataMobile;
                } else {
                    bannerData = htmlBannerData;
                }
            } else if (this.state.gameType == 'video') {
                bannerData = [{
                    imgUrl: './img/gamiclub-banner.png',
                    offer: null,
                    game_name: '',
                    category_name: '',
                    id: undefined
                }];
            } else {
                var androidBannerData = void 0,
                    androidBannerDataMobile = void 0;
                androidBannerData = [{
                    imgUrl: './img/android-banner.jpg',
                    offer: null,
                    game_name: '',
                    category_name: '',
                    id: 122
                }];
                androidBannerDataMobile = [{
                    imgUrl: './img/mobile-android-banner.jpg',
                    offer: null,
                    game_name: '',
                    category_name: '',
                    id: 122
                }];

                if (arabicDomain) {
                    androidBannerData[0].imgUrl = './img/asiacell-android-pc-large.png';
                    androidBannerDataMobile[0].imgUrl = './img/asiacell-android-mobile.png';
                } else if (kazakhDomain) {
                    androidBannerData[0].imgUrl = './img/kazakh-android-pc.jpg';
                    androidBannerDataMobile[0].imgUrl = './img/kazakh-android-mobile.jpg';
                } else if (swedishDomain) {
                    androidBannerData[0].imgUrl = './img/se-android-pc.png';
                    androidBannerDataMobile[0].imgUrl = './img/se-android-mobile.png';
                }
                if (_domainConfig.config.subDomain == 'tr') {
                    androidBannerData[0].imgUrl = './img/coffeebannerNew.jpg';
                    androidBannerDataMobile[0].imgUrl = './img/coffeeBannerMobileNew.jpg';
                    androidBannerData[0].id = 455;
                    androidBannerDataMobile[0].id = 455;
                }

                if (window.innerWidth <= 575) {
                    bannerData = androidBannerDataMobile;
                } else {
                    bannerData = androidBannerData;
                }
            }

            var gamesParams = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500
            };
            var starIcon = '<svg class="isFavorite" width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.3328" y1="14" x2="25.6672" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.2078" y1="14" x2="25.7922" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="isFavorite" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg>',
                thumbsUpIcon = '<svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a1" gradientUnits="userSpaceOnUse" x1="0.5" y1="14" x2="24.5" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b1" gradientUnits="userSpaceOnUse" x1="0.375" y1="14" x2="24.625" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="st0" fill="url(#a1)" stroke="url(#b1)" stroke-width="100" d="M320 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zm160-512v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zm1184 0q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-129q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 .5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"/></svg>';
            return _react2.default.createElement(
                'div',
                { className: 'home-page' },
                _react2.default.createElement(_Banner2.default, { bannerData: bannerData }),
                !_isGamiclub.isGamiclub && _domainConfig.config.subDomain == 'no' || _isGamiclub.isGamiclub && _domainConfig.config.subDomain == 'ch' ? _react2.default.createElement(
                    'button',
                    { onClick: function onClick(e) {
                            (0, _sendData.sendData)('', '', '', 'WA chat clicked');
                            window.open('https://wa.me/12028528006?text=Hello');
                        }, className: 'whatsapp-button' },
                    ' ',
                    _react2.default.createElement('img', { className: 'whatsapp-img', src: './img/whatsapp.png' }),
                    ' '
                ) : null,
                _react2.default.createElement(
                    _reactstrap.Container,
                    { fluid: true },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'category-options' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'category-title-wrap text-uppercase' },
                                    _isGamiclub.isGamiclub || _productCondition.isGameflares || _productCondition.isGamiway ? this.state.gameType == 'android' ? _react2.default.createElement('i', { className: 'fa fa-android ' + (_productCondition.isGameflares ? 'fa-gradient-gameflares' : _productCondition.isGamiway ? 'fa-gradient-gamiway' : 'fa-gradient-gamiclub'), 'aria-hidden': 'true' }) : this.state.gameType == 'html5' ? _react2.default.createElement('i', { className: 'fa fa-html5 ' + (_productCondition.isGameflares ? 'fa-gradient-gameflares' : _productCondition.isGamiway ? 'fa-gradient-gamiway' : 'fa-gradient-gamiclub'), 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-video-camera fa-gradient-gamiclub ' + (_productCondition.isGamiway ? 'fa-gradient-gamiway' : null), 'aria-hidden': 'true' }) : this.state.gameType == 'android' ? _react2.default.createElement('img', { className: 'category-title-icon', src: './img/icons/android.svg', alt: this.state.gameType }) : _react2.default.createElement('img', { className: 'category-title-icon', src: './img/icons/html5.svg', alt: this.state.gameType }),
                                    !this.state.switcherState ? _react2.default.createElement(
                                        'span',
                                        { style: _isGamiclub.isGamiclub ? { color: 'lightgreen' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'category-type' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'topCategories',
                                            defaultMessage: 'Top Categories'
                                        })
                                    ) : _react2.default.createElement(
                                        'span',
                                        { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'category-type' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'favGames',
                                            defaultMessage: 'Favourite Games'
                                        })
                                    )
                                ),
                                window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                                    'div',
                                    { className: 'fav-checkbox' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'switcher' },
                                        _react2.default.createElement('input', { type: 'checkbox', value: this.state.switcherState, onChange: this.toggleSwitcher }),
                                        _react2.default.createElement('div', { className: _isGamiclub.isGamiclub ? "switcher__indicator__gamiclub" : _productCondition.isGameflares ? 'switcher__indicator__gameflares' : _productCondition.isGamiway ? " switcher__indicator switcher__indicator__gamiway" : "switcher__indicator" }),
                                        _react2.default.createElement(
                                            'span',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'favorites',
                                                defaultMessage: 'Favorites'
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    !this.state.switcherState ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _reactstrap.Row,
                            null,
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: _isGamiclub.isGamiclub ? "category-box-wrap-gamiclub" : "category-box-wrap" },
                                    _react2.default.createElement(_CategoryList2.default, { gametype: this.state.gameType, currentLanguage: _domainConfig.config.lang })
                                )
                            )
                        ),
                        this.props.categories.categories.length > 0 ? this.props.categories.categories.map(function (category, index) {
                            if (category.categoryName.toLowerCase().indexOf('arcade') >= 0 && category.categoryTypeId === 2 && (_domainConfig.config.subDomain == 'iq' || _domainConfig.config.subDomain == 'asiacell')) {
                                return null;
                            } else if (category.categoryTypeName.toLowerCase() == _this4.state.gameType) {
                                return _react2.default.createElement(_CategoryGames2.default, { key: index, index: index, category: category, games: _this4.props.games.games.length > 0 && _this4.props.games.games.filter(function (g) {
                                        return g.categoryId == category.categoryId;
                                    }).length > 0 ? _this4.props.games.games.filter(function (g) {
                                        return g.categoryId == category.categoryId;
                                    }) : [], onFavoriteClick: _this4.openGame });
                            }
                        }) : ''
                    ) : _react2.default.createElement(
                        _reactstrap.Row,
                        { className: 'game-list-row favorite-toggle-wrap' },
                        this.props.games.favoriteGames.length > 0 && this.props.games.favoriteGames.filter(function (g) {
                            return g.gameType.toLowerCase() == _this4.state.gameType;
                        }).length > 0 ? _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                _reactIdSwiper2.default,
                                _extends({}, gamesParams, { shouldSwiperUpdate: true }),
                                this.props.games.favoriteGames.filter(function (g) {
                                    return g.gameType.toLowerCase() == _this4.state.gameType;
                                }).map(function (game) {
                                    return _react2.default.createElement(
                                        'div',
                                        { className: 'swiper-game-card' },
                                        _react2.default.createElement(
                                            _reactstrap.Card,
                                            { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : _productCondition.isGameflares ? "game-card gameflares-card-hover" : _productCondition.isGamiway ? "game-card gamiway-card" : "game-card", onClick: _this4.openGame.bind(_this4, game) },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-card-inner' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-thumb-wrap' },
                                                    _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-details' },
                                                    _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                        _reactstrap.CardTitle,
                                                        { className: 'game-title text-shadow' },
                                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(), defaultMessage: game.gameTitle })
                                                    ),
                                                    window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                                                        'div',
                                                        { className: 'custom-rating isFavorite' },
                                                        _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                        _react2.default.createElement(
                                                            'label',
                                                            { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                            _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star-o custom-star isFavorite' })
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-card-left' },
                                                        _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                                return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : _productCondition.isGameflares ? { color: '#FF394B' } : _productCondition.isGamiway ? { color: '#b347a0' } : null, className: 'fa fa-star custom-star' });
                                                            } })
                                                    ),
                                                    !window.location.hostname.includes('vplay') && _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                        'div',
                                                        { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                        game.gameType.toLowerCase() === "html5" ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : game.gameType.toLowerCase() === "video" ? _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-android', 'aria-hidden': 'true' })
                                                    )
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        ) : _react2.default.createElement(
                            _reactstrap.Col,
                            { xl: '12', lg: '12', md: '12', sm: '12', xs: '12' },
                            ' ',
                            _react2.default.createElement(
                                'p',
                                { className: 'white-text-color no-game-text' },
                                window.location.hash.includes('home/video') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noFavVideosFound', defaultMessage: 'No favorite videos found.' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noFavGamesFound', defaultMessage: 'No favorite games found.' })
                            )
                        )
                    ),
                    (_domainConfig.config.subDomain == 'id' || _domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && !_isGamiclub.isGamiclub && !_productCondition.isGamiway ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _reactstrap.Row,
                            null,
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12', className: 'game-related-container' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'game-related-top' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : _productCondition.isGameflares ? { borderBottom: '1px solid #FF394B' } : null },
                                        _react2.default.createElement(
                                            'h2',
                                            { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : _productCondition.isGameflares ? { color: 'white', backgroundColor: '#FF394B' } : null, className: 'game-category-title' },
                                            _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' }),
                                            'Financial Tips & Tricks'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Row,
                            { className: 'game-list-row' },
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'swiper-wallpaper-card' },
                                    _react2.default.createElement(
                                        _reactstrap.Card,
                                        { className: _isGamiclub.isGamiclub ? "wallpaper-card-gamiclub" : _productCondition.isGameflares ? "wallpaper-card wallpaper-card-gameflares" : "wallpaper-card", onClick: function onClick() {
                                                window.open('http://id.trendme.co/id/financial-tips-tricks/financial-tips-tricks/?uid=' + _this4.props.access.uid);
                                            } },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'wallpaper-card-inner' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'wallpaper-thumb-wrap' },
                                                _react2.default.createElement(_reactstrap.CardImg, { className: 'wallpaper-thumb', style: { objectFit: 'cover', height: '150px', cursor: "pointer" }, alt: 'Financial Tips and Tricks', src: './img/idfinance.jpeg' })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ) : null,
                    _domainConfig.config.subDomain == 'za' && !this.state.switcherState && window.location.hash.includes('home/html') ? _react2.default.createElement(_wallpaper2.default, null) : null,
                    (_domainConfig.config.subDomain == 'es' || _domainConfig.config.subDomain == 'es2') && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_es }) : null,
                    _domainConfig.config.subDomain == 'no' && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_no }) : null,
                    _domainConfig.config.subDomain == 'kw' && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_kw }) : null,
                    _domainConfig.config.subDomain == 'qa' && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_qa }) : null,
                    _domainConfig.config.subDomain == 'ae' && !this.state.switcherState && window.location.hash.includes('home/html') && _isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_ae }) : null,
                    _domainConfig.config.subDomain == 'eg' && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_eg }) : null,
                    _domainConfig.config.subDomain == 'rs' && !this.state.switcherState && window.location.hash.includes('home/html') && _isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_rs }) : null,
                    _domainConfig.config.subDomain == 'cz' && !this.state.switcherState && window.location.hash.includes('home/video') && _isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_cz }) : null,
                    _domainConfig.config.subDomain == 'gmn' && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_gmn }) : null,
                    _domainConfig.config.subDomain == 'ci' && !this.state.switcherState && window.location.hash.includes('home/html') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_za_ci }) : null,
                    _domainConfig.config.subDomain == 'za' && !this.state.switcherState && window.location.hash.includes('home/video') && !_isGamiclub.isGamiclub ? _react2.default.createElement(_video2.default, { video: _videos.videos_za }) : null,
                    (_domainConfig.config.subDomain == 'id' || _domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && !_isGamiclub.isGamiclub && !_productCondition.isGamiway ? _react2.default.createElement(_textModal2.default, { text: _texts.textContentShopee }) : null,
                    (_domainConfig.config.subDomain == 'id' || _domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && !_isGamiclub.isGamiclub && !_productCondition.isGamiway ? _react2.default.createElement(_textModal2.default, { text: _texts.textContentIDRoblox }) : null,
                    (_domainConfig.config.subDomain == 'id' || _domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') && !this.state.switcherState && window.location.hash.includes('home/android') && !_isGamiclub.isGamiclub && !_productCondition.isGamiway ? _react2.default.createElement(_textModal2.default, { text: _texts.textContentIDSquidGames }) : null
                )
            );
        }
    }]);

    return HomePage;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        categories: state.CategoryReducer,
        games: state.GamesReducer,
        flashmessage: state.FlashMessageReducer

    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getGames: _GamesActions.getGames,
        getFavouriteGames: _GamesActions.getFavouriteGames,
        setFavouriteGames: _GamesActions.setFavouriteGames,
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        showMessage: _FlashMessageActions.showMessage,
        searchText: _SearchActions.searchText
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HomePage);

/***/ }),

/***/ "./src/components/Login/Login.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _isIos = __webpack_require__("./node_modules/is-ios/index.js");

var _isIos2 = _interopRequireDefault(_isIos);

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _restrictedCategories = __webpack_require__("./src/constants/restrictedCategories.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isOnlyBeemobi = __webpack_require__("./src/constants/isOnlyBeemobi.js");

var _login = __webpack_require__("./src/utils/login.utils.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

var _isGamezClan = __webpack_require__("./src/constants/isGamezClan.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _heURL = __webpack_require__("./src/constants/heURL.js");

var _domainTheme = __webpack_require__("./src/utils/domainTheme.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getErrorMessages = function getErrorMessages() {
  switch (_domainConfig.config.subDomain) {
    case "pt":
      return {
        phoneNumberRequired: "Número de telefone necessário",
        invalidNumber: "Número inválido",
        subNotFound: "Assinatura não encontrada"
      };
    default:
      return {
        phoneNumberRequired: "Phone number required",
        invalidNumber: "Invalid Number",
        subNotFound: "Subscription not found"
      };
  }
};

var Login = function (_Component) {
  _inherits(Login, _Component);

  function Login(props) {
    _classCallCheck(this, Login);

    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

    _this.state = {
      msisdn: "",
      isValid: false,
      errorMessage: "",
      domain: window.location.host,
      notFound: false,
      reason: ""
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onChangeMsisdn = _this.onChangeMsisdn.bind(_this);
    _this.onKeyUp = _this.onKeyUp.bind(_this);
    _this.callAuthenticate = _this.callAuthenticate.bind(_this);
    _this.callUserApis = _this.callUserApis.bind(_this);
    _this.getCategories = _this.getCategories.bind(_this);
    _this.getGames = _this.getGames.bind(_this);
    return _this;
  }

  _createClass(Login, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "onChangeMsisdn",
    value: function onChangeMsisdn(e) {
      this.setState({ msisdn: e.target.value });
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      if (e.keyCode == 13) {
        this.onSubmit(e);
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault();
      if ((0, _login.isvalid)(this.state.msisdn, _domainConfig.config.country)) {
        var msisdn = (0, _login.parse)(this.state.msisdn, _domainConfig.config.country);
        this.setState({ isValid: true, errorMessage: "" });
        this.callAuthenticate({
          msisdn: msisdn
        });
      } else {
        if (!this.state.msisdn) {
          this.setState(function (prev) {
            return _extends({}, prev, {
              isvalid: false,
              notFound: false,
              errorMessage: getErrorMessages().phoneNumberRequired
            });
          });
        } else {
          this.setState(function (prev) {
            return _extends({}, prev, {
              isValid: false,
              notFound: false,
              errorMessage: getErrorMessages().invalidNumber
            });
          });
        }
      }
    }
  }, {
    key: "callAuthenticate",
    value: function callAuthenticate(data) {
      var _this2 = this;

      this.props.show();
      var domain = window.location.host;
      if (window.location.host.indexOf("local") >= 0) domain = _domainConfig.config.subDomain + ".gamiclub.com";
      _axios2.default.get(vars.BASE_URL + ("/checkAccessWithMsisdn?msisdn=" + data.msisdn + "&domain=" + domain)).then(function (response) {
        if (response.data.success) {
          var _data = {
            success: response.data.success,
            uid: response.data.data.payload.token,
            token: response.data.data.token,
            subscriptionData: response.data.data.payload
          };
          sessionStorage.setItem("authorized", JSON.stringify(_data));
          (0, _sendData.sendData)("", "", "", "Accessed", {
            method: "msisdn",
            status: "success",
            url: window.location.href,
            rid: _data.subscriptionData.rockmanId
          });
          _this2.props.checkAccess(_data);
          _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
          _this2.getCategories();
          _this2.getGames(_data.uid).then(function () {
            _this2.callUserApis(_data.uid);
          }).then(function () {
            console.log("call apis was successful");
            _this2.props.hide();
            _this2.props.history.push((0, _helper.appendUid)("/welcome", _data.uid));
          }).catch(function (err) {
            console.log(err);
            _this2.props.hide();
            _this2.props.history.push("/login");
          });
        } else {
          _this2.setState({
            notFound: true,
            reason: getErrorMessages().subNotFound
          });
          _this2.props.hide();
        }
      }).catch(function (error) {
        _this2.props.hide();
        console.log(error);
        _this2.props.history.push("/restricted");
      });
    }
  }, {
    key: "callUserApis",
    value: function callUserApis(uid) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.props.account.interests.length <= 0) {
          _axios2.default.all([_axios2.default.get(vars.BASE_URL + "/interests?uid=" + uid)]).then(_axios2.default.spread(function (interests) {
            if (interests.data.data) {
              _this3.props.getInterests(interests.data.data);
            }
            resolve();
          })).then(function () {
            _axios2.default.get(vars.BASE_URL + "/getUserProfile?uid=" + uid).then(function (resp) {
              if (resp.data.data) {
                _this3.props.getDetails(resp.data.data);
              }
            }).catch(function (err) {
              console.log("error in getting user profile twosteplogin1111-------- ", err);
            });
          }).catch(function (err) {
            (0, _helper.console_log)(err);
            reject(err);
          });
        } else {
          _this3.props.getDetails(_this3.props.account.user);
          _this3.props.getInterests(_this3.props.account.interests);
          resolve();
        }
      });
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      var _this4 = this;

      _axios2.default.get(vars.BASE_URL + "/getCategories").then(function (response) {
        if (response.data.success) {
          var dataFinal = response.data;
          var categoriesArr = dataFinal.data;
          dataFinal = _extends({}, dataFinal, { data: categoriesArr });
          dataFinal.data = dataFinal.data.filter(function (category) {
            return (0, _restrictedCategories.isCategoryAllowed)(category.categoryName);
          });
          if (!(_domainConfig.config.subDomain === "cz" && _isGamiclub.isGamiclub)) {
            dataFinal.data = dataFinal.data.filter(function (category) {
              return category.categoryName != "E-knihy";
            });
          }
          if (_domainConfig.config.subDomain === "fr" && _isGamiclub.isGamiclub) {
            dataFinal.data = dataFinal.data.filter(function (category) {
              return category.categoryName != "Heróis Verdes";
            });
          }
          if (_domainConfig.config.subDomain === "my" && window.location.hostname.includes("gamiclub")) {
            dataFinal.data = dataFinal.data.filter(function (category) {
              var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
              return excludes.indexOf(category.categoryName) == -1;
            });
          }
          if (_domainConfig.config.subDomain === "es2" && window.location.hostname.includes("beemobi")) {
            dataFinal.data = dataFinal.data.filter(function (category) {
              var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"];
              return excludes.indexOf(category.categoryName) == -1;
            });
          } else {
            dataFinal.data = dataFinal.data.filter(function (category) {
              return category.categoryName != "Videos Virales";
            });
          }
          if (_domainConfig.config.subDomain !== "rs") {
            dataFinal.data = dataFinal.data.filter(function (category) {
              return category.categoryName != "Е-књиге";
            });
          }
          if (_domainConfig.config.subDomain !== "tr" && _domainConfig.config.subDomain !== "qa" && _domainConfig.config.subDomain !== "kw") {
            dataFinal.data = dataFinal.data.filter(function (category) {
              return category.categoryName != "Facebook";
            });
          }
          _this4.props.getCategories(dataFinal);
          return;
        }
      }).catch(function (error) {
        (0, _helper.console_log)(error);
        _this4.setState({
          isValid: false,
          errorMessage: "Unable to fetch the data."
        });
        return;
      });
    }
  }, {
    key: "getGames",
    value: function getGames(uid) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _axios2.default.get(vars.BASE_URL + "/getGames?uid=" + uid).then(function (response) {
          if (response.data.success) {
            response.data.data = response.data.data.filter(function (game) {
              return (0, _restrictedCategories.isCategoryAllowed)(game.categoryName);
            });
            if (!(_domainConfig.config.subDomain == "tr" || _domainConfig.config.subDomain == "no")) {
              response.data.data = response.data.data.filter(function (game) {
                return game.gameTitle != "Trusted Tarot" && game.gameTitle != "Coffee Reading";
              });
            }
            _this5.props.getGames(response.data);
          }
          resolve();
        }).catch(function (error) {
          (0, _helper.console_log)(error);
          _this5.setState({
            isValid: false,
            errorMessage: "Unable to fetch the data."
          });
          reject(error);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!_isGamiclub.isGamiclub && _domainConfig.config.subDomain === "pe" && window.location.href.includes("login")) {
        if (window.location.search.includes("show-login=true")) window.location.href = "https://loginprime.com/GOaAZO";else window.location.href = _heURL.peHEURL;
        return null;
      } else if (!_isGamiclub.isGamiclub && _domainConfig.config.subDomain === "pe-staging" && window.location.href.includes("login")) {
        window.location.href = "https://loginprime.com/0Pj1KO";
        return null;
      }
      var flag_url = (0, _login.getFlag)(_domainConfig.config.country);
      var theme = (0, _domainTheme.getDomainTheme)();
      var uid = this.props.access.uid;
      console.log("theme", theme);

      return _react2.default.createElement(
        "div",
        { className: "login animated fadeIn" },
        _react2.default.createElement(
          _reactstrap.Row,
          { className: "justify-content-center" },
          _react2.default.createElement(
            _reactstrap.Col,
            null,
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "login-page-header" },
              _react2.default.createElement("img", {
                className: _isOnlyMobbfun.isOnlyMobbfun ? "login-page-logo-mobbfun login-page-logo" : "login-page-logo",
                src: theme.logo,
                alt: "GameLord"
              })
            ),
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "login-page-content" },
              _react2.default.createElement(
                "h1",
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "areYouAlready",
                  defaultMessage: "Are you already a member of "
                }),
                theme.productName ? theme.productName : "Gamelords",
                "?"
              ),
              _react2.default.createElement(
                "p",
                null,
                _domainConfig.config.subDomain === "za" && _isIos2.default ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "thenConfirmAlt",
                  defaultMessage: "Then confirm your mobile number and get unlimited access to all our <strong> HTML5 </strong> games and <strong> videos </strong>"
                }) : _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: "thenConfirm",
                  defaultMessage: "Then confirm your mobile number and get unlimited access to all our <strong> HTML5 </strong> and <strong> Android </strong> games"
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "login-page-mobile_num" },
                flag_url ? _react2.default.createElement(
                  "div",
                  { className: "flag_img" },
                  _react2.default.createElement("img", { src: flag_url, className: "flag_url" })
                ) : null,
                _react2.default.createElement("input", {
                  autoFocus: true,
                  type: "number",
                  name: "msisdn",
                  value: this.state.msisdn,
                  onChange: this.onChangeMsisdn,
                  onKeyUp: this.onKeyUp,
                  className: "LoginRoute-number",
                  placeholder: (0, _login.getPlaceHolder)(_domainConfig.config.country),
                  style: flag_url ? { textIndent: "41px" } : {}
                }),
                _react2.default.createElement(
                  "button",
                  {
                    type: "submit",
                    onClick: this.onSubmit,
                    style: _isGamiclub.isGamiclub ? { backgroundColor: "green" } : _productCondition.isGameflares ? { backgroundColor: "#FF394B" } : _productCondition.isGamiway ? { backgroundColor: "#b347a0" } : null,
                    className: "LoginRoute-button"
                  },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "login", defaultMessage: "Login" }),
                  _react2.default.createElement("i", { className: "icon-back" })
                ),
                this.state.notFound ? _react2.default.createElement(
                  "span",
                  { className: "error-message" },
                  this.state.reason
                ) : !this.state.isValid ? _react2.default.createElement(
                  "span",
                  { className: "error-message" },
                  this.state.errorMessage
                ) : null
              ),
              _productCondition.isFunzarena && _react2.default.createElement(
                "a",
                { className: "navigate-link", href: "#/terms-conditions" },
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Conditions"
                  })
                )
              )
            )
          )
        )
      );
      //}
      //else return (<MsisdnNotFound reason={this.state.reason} />)
    }
  }]);

  return Login;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer,
    access: state.WelcomeReducer,
    account: state.AccountReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    // authenticate,
    checkAccess: _WelcomeActions.checkAccess,
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    getDetails: _AccountActions.getDetails,
    getInterests: _AccountActions.getInterests,
    getGames: _GamesActions.getGames,
    getCategories: _CategoryActions.getCategories
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);

/***/ }),

/***/ "./src/components/Login/TwoStepLogin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _restrictedCategories = __webpack_require__("./src/constants/restrictedCategories.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwoStepLogin = function (_Component) {
    _inherits(TwoStepLogin, _Component);

    function TwoStepLogin(props) {
        _classCallCheck(this, TwoStepLogin);

        var _this = _possibleConstructorReturn(this, (TwoStepLogin.__proto__ || Object.getPrototypeOf(TwoStepLogin)).call(this, props));

        _this.state = {
            username: '',
            password: '',
            isValid: false,
            errorMessage: '',
            usernamePwdInvalidated: false,
            reason: '',
            error: {}

        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.callAuthenticate = _this.callAuthenticate.bind(_this);
        _this.callUserApis = _this.callUserApis.bind(_this);
        _this.getCategories = _this.getCategories.bind(_this);
        _this.getGames = _this.getGames.bind(_this);
        return _this;
    }

    _createClass(TwoStepLogin, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.state.username == '') {
                this.setState({
                    isValid: false,
                    error: {
                        username: true
                    }
                });
                return false;
            }
            if (this.state.password == '') {
                this.setState({
                    isValid: false,
                    error: {
                        password: true
                    }
                });
                return false;
            }
            return true;
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _e$target = e.target,
                name = _e$target.name,
                value = _e$target.value;

            this.setState(_defineProperty({}, name, value));
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode == 13) {
                if (this.isValid()) {
                    this.setState({ isValid: true, errorMessage: '' });
                    this.callAuthenticate({
                        username: this.state.username,
                        password: this.state.password
                    });
                }
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.callAuthenticate({
                    username: this.state.username,
                    password: this.state.password

                });
            }
        }
    }, {
        key: 'callAuthenticate',
        value: function callAuthenticate(data) {
            var _this2 = this;

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/checkAccessWithUsername', {
                username: data.username,
                password: data.password
            }).then(function (response) {
                var data = {
                    success: response.data.success,
                    uid: response.data.data.payload.token,
                    token: response.data.data.token,
                    subscriptionData: response.data.data.payload
                };
                sessionStorage.setItem("authorized", JSON.stringify(data));
                (0, _sendData.sendData)('', '', '', 'Accessed', { method: 'username', status: 'success', url: window.location.href, rid: data.subscriptionData.rockmanId });
                _this2.props.checkAccess(data);
                if (response.data.success) {
                    _axios2.default.defaults.headers.common['authorization'] = _this2.props.access.token;
                    _this2.getCategories();
                    _this2.getGames(_this2.props.access.uid).then(function () {
                        _this2.callUserApis(_this2.props.access.uid);
                    }).then(function () {
                        console.log('call apis was successful');
                        _this2.props.hide();
                        _this2.props.history.push((0, _helper.appendUid)('/welcome', _this2.props.access.uid));
                    }).catch(function (err) {
                        console.log(err);
                        _this2.props.hide();
                        _this2.props.history.push('/twoStepLogin');
                    });
                } else {
                    _this2.setState({
                        error: {
                            api: true
                        },
                        reason: response.data.data.payload.reason
                    });
                    _this2.props.hide();
                }
            }).catch(function (error) {
                _this2.props.hide();
                console.log(error);
                _this2.props.history.push("/twoStepLogin");
            });
        }
    }, {
        key: 'callUserApis',
        value: function callUserApis(uid) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                if (_this3.props.account.interests.length <= 0) {
                    _axios2.default.all([_axios2.default.get(vars.BASE_URL + '/interests?uid=' + uid)]).then(_axios2.default.spread(function (interests) {
                        if (interests.data.data) {
                            _this3.props.getInterests(interests.data.data);
                        }
                        resolve();
                    })).then(function () {
                        _axios2.default.get(vars.BASE_URL + '/getUserProfile?uid=' + uid).then(function (resp) {
                            if (resp.data.data) {
                                _this3.props.getDetails(resp.data.data);
                            }
                        }).catch(function (err) {
                            console.log("error in getting user profile twosteplogin1111-------- ", err);
                        });
                    }).catch(function (err) {
                        (0, _helper.console_log)(err);
                        reject(err);
                    });
                } else {
                    _this3.props.getDetails(_this3.props.account.user);
                    _this3.props.getInterests(_this3.props.account.interests);
                    resolve();
                }
            });
        }
    }, {
        key: 'getCategories',
        value: function getCategories() {
            var _this4 = this;

            _axios2.default.get(vars.BASE_URL + '/getCategories').then(function (response) {
                if (response.data.success) {
                    var dataFinal = response.data;
                    var categoriesArr = dataFinal.data;
                    dataFinal = _extends({}, dataFinal, { data: categoriesArr });
                    dataFinal.data = dataFinal.data.filter(function (category) {
                        return (0, _restrictedCategories.isCategoryAllowed)(category.categoryName);
                    });
                    if (_domainConfig.config.subDomain == 'sa' || _domainConfig.config.subDomain == 'iq' || _domainConfig.config.subDomain == 'asiacell' || _domainConfig.config.subDomain == 'qa') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'New Arrivals';
                        });
                    }
                    if (!(_domainConfig.config.subDomain === 'ch' && _isGamiclub.isGamiclub)) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Astrology';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'fr' && _isGamiclub.isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Heróis Verdes';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    }
                    if (_domainConfig.config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    } else {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Videos Virales';
                        });
                    }
                    if (!(_domainConfig.config.subDomain === 'cz' && _isGamiclub.isGamiclub)) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'E-knihy';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'rs') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Е-књиге';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'ae') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'IQ Games';
                        });
                    }
                    if (_domainConfig.config.subDomain != 'maxis' && _domainConfig.config.subDomain != 'my' && _domainConfig.config.subDomain != 'sa' && !_isGamiclub.isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Utilities';
                        });
                    }
                    if (_domainConfig.config.subDomain != 'idsale' || _domainConfig.config.subDomain != 'gmn') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'On Sale';
                        });
                    }
                    if (_domainConfig.config.subDomain == 'idsale' || _domainConfig.config.subDomain === 'gmn') {
                        dataFinal.data = dataFinal.data.sort(function (category) {
                            if (category.categoryName == 'On Sale') return -1;else return 1;
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'tr' && _domainConfig.config.subDomain !== 'qa' && _domainConfig.config.subDomain !== 'kw') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Facebook';
                        });
                    }
                    _this4.props.getCategories(dataFinal);
                    return;
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
                return;
            });
        }
    }, {
        key: 'getGames',
        value: function getGames(uid) {
            var _this5 = this;

            return new Promise(function (resolve, reject) {
                _axios2.default.get(vars.BASE_URL + '/getGames?uid=' + uid).then(function (response) {
                    if (response.data.success) {
                        response.data.data = response.data.data.filter(function (game) {
                            return (0, _restrictedCategories.isCategoryAllowed)(game.categoryName);
                        });
                        if (!(_domainConfig.config.subDomain == 'tr' || _domainConfig.config.subDomain == 'no')) {
                            response.data.data = response.data.data.filter(function (game) {
                                return game.gameTitle != "Trusted Tarot" && game.gameTitle != "Coffee Reading";
                            });
                        }
                        if (_domainConfig.config.subDomain != 'tr') {
                            response.data.data = response.data.data.filter(function (game) {
                                return game.gameTitle != 'Okey';
                            });
                        }
                        if (_domainConfig.config.subDomain === 'eg') {
                            var excluded_games = ['Santa Claus The Pervert Part 1', 'Place your bets! GTA is getting a real virtual casino', 'Dargavs Welcome to the City of the Dead', 'King Bacon Vs Vegans', 'Jackpot', 'Christmas Night Of Horror', 'High Fly Valentine', 'Horoscope', 'Sacra Terra Kiss Of Death', 'Haunted Legends Undertaker', 'Stereotypo'];
                            response.data.data = response.data.data.filter(function (game) {
                                return excluded_games.indexOf(game.gameTitle) < 0;
                            });
                        }
                        _this5.props.getGames(response.data);
                    }
                    resolve();
                }).catch(function (error) {
                    (0, _helper.console_log)(error);
                    _this5.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
                    reject(error);
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            // if (!this.state.error.usernamePwdInvalidated) {
            return _react2.default.createElement(
                'div',
                { className: 'login animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    { className: 'justify-content-center' },
                    _react2.default.createElement(
                        _reactstrap.Col,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Row,
                            { className: 'login-page-header' },
                            _react2.default.createElement(
                                'div',
                                { className: 'login-page-header-child' },
                                _react2.default.createElement('img', { className: 'login-page-logo', src: _isGamiclub.isGamiclub ? "./img/logo_gamiclub.png" : "./img/logo.png", alt: 'GameLord', width: '125px' })
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Row,
                            { className: 'login-page-content' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pleaseLogin',
                                    defaultMessage: 'Please login to continue'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'loginUsing',
                                    defaultMessage: 'Login using the username and password you got in the welcome message'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'login-page-mobile_num' },
                                this.state.error.username && _react2.default.createElement(
                                    'span',
                                    { className: 'error-message' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'usernameRequired',
                                        defaultMessage: 'Username is required.'
                                    })
                                ),
                                _react2.default.createElement('input', { autoFocus: true, type: 'text', name: 'username', value: this.state.username, onChange: this.onChange, onKeyUp: this.onKeyUp, className: 'LoginRoute-number',
                                    placeholder: 'Kullan\u0131c\u0131 ad\u0131' }),
                                this.state.error.password && _react2.default.createElement(
                                    'span',
                                    { className: 'error-message' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'passwordRequired',
                                        defaultMessage: 'Password is required.'
                                    })
                                ),
                                _react2.default.createElement('input', { type: 'password', name: 'password', value: this.state.password, onChange: this.onChange, onKeyUp: this.onKeyUp, className: 'LoginRoute-number',
                                    placeholder: '\u015Eifre' }),
                                _react2.default.createElement(
                                    'button',
                                    { type: 'submit', onClick: this.onSubmit, className: 'LoginRoute-button' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login',
                                        defaultMessage: 'Login'
                                    }),
                                    _react2.default.createElement('i', { className: 'icon-back' })
                                ),
                                this.state.error.api && _react2.default.createElement(
                                    'span',
                                    { className: 'error-message' },
                                    this.state.reason
                                )
                            )
                        )
                    )
                )
            );
            // }
            // else{
            //     return (<TwoStepLoginFailed reason={this.state.reason} />)
            // } 
        }
    }]);

    return TwoStepLogin;
}(_react.Component);

var TwoStepLoginFailed = function TwoStepLoginFailed(props) {
    return _react2.default.createElement(
        _reactstrap.Container,
        { className: 'restricted' },
        _react2.default.createElement(
            _reactstrap.Row,
            { className: 'justify-content-center' },
            _react2.default.createElement(
                _reactstrap.Col,
                { md: '6' },
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'float-left display-3 mr-4 red-text-color' },
                        _react2.default.createElement('i', { className: 'fa fa-warning' })
                    ),
                    _react2.default.createElement(
                        'h4',
                        { className: 'pt-3 golden-text-color', style: { fontWeight: 800 } },
                        props.reason
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'red-text-color float-left' },
                        'Subscribe now to GameLords for unlimited access to all our HTML5 and Android Games!'
                    )
                )
            )
        )
    );
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer,
        account: state.AccountReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        checkAccess: _WelcomeActions.checkAccess,
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getDetails: _AccountActions.getDetails,
        getInterests: _AccountActions.getInterests,
        getGames: _GamesActions.getGames,
        getCategories: _CategoryActions.getCategories
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TwoStepLogin);

/***/ }),

/***/ "./src/components/NewPrivacyPolicy/NewPrivacyPolicy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewPrivacyPolicy = function (_Component) {
    _inherits(NewPrivacyPolicy, _Component);

    function NewPrivacyPolicy() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, NewPrivacyPolicy);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewPrivacyPolicy.__proto__ || Object.getPrototypeOf(NewPrivacyPolicy)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showCookiePolicy: false
        }, _this.toggleCookiePolicy = function () {
            _this.setState(function (prevState) {
                return {
                    showCookiePolicy: !prevState.showCookiePolicy
                };
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(NewPrivacyPolicy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _sendData.sendData)('', '', '', 'viewed', { page: 'privacy-policy' });
            window.scrollTo(0, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'terms privacy-policy' },
                _react2.default.createElement(
                    _reactstrap.Container,
                    { fluid: true },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'terms-title-wrap' },
                                _react2.default.createElement(
                                    'h2',
                                    { className: 'terms-section-title' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyTitle',
                                        defaultMessage: 'Privacy Policy'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyHead',
                                    defaultMessage: 'This Application collects some Personal Data from its Users. This document can be printed for reference by using the print command in the settings of any browser.'
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.Row,
                        { className: 'no-gutters' },
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyOwner',
                                    defaultMessage: 'Owner and Data Controller'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyOwner1',
                                            defaultMessage: 'Mobimilia BV'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyOwner2',
                                            defaultMessage: 'Van Diemenstraat 140'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyOwner3',
                                            defaultMessage: '1013 CN Amsterdam'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyOwner4',
                                            defaultMessage: 'Owner contact email: info@mobimilia.com'
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected',
                                    defaultMessage: 'Types of Data collected'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected1',
                                            defaultMessage: 'Among the types of Personal Data that this Application collects, by itself or through third parties, there are: Cookies; Usage Data; unique device identifiers for advertising (Google Advertiser ID or IDFA, for example).'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected2',
                                            defaultMessage: 'Complete details on each type of Personal Data collected are provided in the dedicated sections of this privacy policy or by specific explanation texts displayed prior to the Data collection.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected3',
                                            defaultMessage: 'Personal Data may be freely provided by the User, or, in case of Usage Data, collected automatically when using this Application.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected4',
                                            defaultMessage: 'Unless specified otherwise, all Data requested by this Application is mandatory and failure to provide this Data may make it impossible for this Application to provide its services. In cases where this Application specifically states that some Data is not mandatory, Users are free not to communicate this Data without consequences to the availability or the functioning of the Service.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected5',
                                            defaultMessage: 'Users who are uncertain about which Personal Data is mandatory are welcome to contact the Owner.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected6',
                                            defaultMessage: 'Any use of Cookies \u2013 or of other tracking tools \u2013 by this Application or by the owners of third-party services used by this Application serves the purpose of providing the Service required by the User, in addition to any other purposes described in the present document and in the Cookie Policy, if available.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDataCollected7',
                                            defaultMessage: 'Users are responsible for any third-party Personal Data obtained, published or shared through this Application and confirm that they have the third party\'s consent to provide the Data to the Owner.'
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurpose',
                                    defaultMessage: 'The purposes of processing'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeHead1',
                                    defaultMessage: 'The Data concerning the User is collected to allow the Owner to provide its Service, comply with its legal obligations, respond to enforcement requests, protect its rights and interests (or those of its Users or third parties), detect any malicious or fraudulent activity, as well as the following: Analytics, Remarketing and behavioral targeting, Advertising, Content performance and features testing (A/B testing) and Tag Management.'
                                }),
                                " ",
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeHead2',
                                    defaultMessage: 'For specific information about the Personal Data used for each purpose, the User may refer to the section \u201CDetailed information on the processing of Personal Data\u201D.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfo',
                                    defaultMessage: 'Detailed information on the processing of Personal Data'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoHead',
                                    defaultMessage: 'Personal Data is collected for the following purposes and using the following services:'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAdvertising',
                                    defaultMessage: 'Advertising'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAdvertising1',
                                            defaultMessage: 'This type of service allows User Data to be utilized for advertising communication purposes. These communications are displayed in the form of banners and other advertisements on this Application, possibly based on User interests.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAdvertising2',
                                            defaultMessage: 'This does not mean that all Personal Data are used for this purpose. Information and conditions of use are shown below.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAdvertising3',
                                            defaultMessage: 'Some of the services listed below may use Cookies or other Identifiers to identify Users or they may use the behavioral retargeting technique, i.e. displaying ads tailored to the User\u2019s interests and behavior, including those detected outside this Application. For more information, please check the privacy policies of the relevant services.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAdvertising4',
                                            defaultMessage: 'In addition to any opt-out feature offered by any of the services below, Users may opt out by visiting the Network Advertising Initiative opt-out page.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAdvertising5',
                                            defaultMessage: 'Users may also opt-out of certain advertising features through applicable device settings, such as the device advertising settings for mobile phones or ads settings in general.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleIreland',
                                    defaultMessage: 'Google Ads Similar audiences (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleIreland1',
                                            defaultMessage: 'Similar audiences is an advertising and behavioral targeting service provided by Google Ireland Limited that uses Data from Google Ads Remarketing in order to display ads to Users with similar behavior to Users who are already on the remarketing list due to their past use of this Application.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleIreland2',
                                            defaultMessage: 'On the basis of this Data, personalized ads will be shown to Users suggested by Google Ads Similar audiences. Users who don\'t want to be included in Similar audiences can opt out and disable the use of advertising cookies by going to: Google Ad Settings.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleIreland3',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedGoogleIreland4',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalytics',
                                    defaultMessage: 'Analytics'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalytics1',
                                            defaultMessage: 'The services contained in this section enable the Owner to monitor and analyze web traffic and can be used to keep track of User behavior.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland',
                                    defaultMessage: 'Google Analytics (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland1',
                                            defaultMessage: 'Google Analytics is a web analysis service provided by Google Ireland Limited (\u201CGoogle\u201D). Google utilizes the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland2',
                                            defaultMessage: 'Google may use the Data collected to contextualize and personalize the ads of its own advertising network.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland3',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland4',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect',
                                    defaultMessage: 'Analytics collected directly (this Application)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect1',
                                            defaultMessage: 'This Application uses an internal analytics system that does not involve third parties.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous',
                                    defaultMessage: 'Google Analytics with anonymized IP (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous1',
                                            defaultMessage: 'Google Analytics is a web analysis service provided by Google Ireland Limited (\u201CGoogle\u201D). Google utilizes the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous2',
                                            defaultMessage: 'Google may use the Data collected to contextualize and personalize the ads of its own advertising network.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous3',
                                            defaultMessage: 'This integration of Google Analytics anonymizes your IP address. It works by shortening Users\' IP addresses within member states of the European Union or in other contracting states to the Agreement on the European Economic Area. Only in exceptional cases will the complete IP address be sent to a Google server and shortened within the US.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous4',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous5',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAds',
                                    defaultMessage: 'Google Ads conversion tracking (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAds1',
                                            defaultMessage: 'Google Ads conversion tracking is an analytics service provided by Google Ireland Limited that connects data from the Google Ads advertising network with actions performed on this Application.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAds2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAds3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting',
                                    defaultMessage: 'Google Analytics Advertising Reporting Features (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting1',
                                            defaultMessage: 'Google Analytics on this Application has Advertising Reporting Features activated, which collects additional information from the DoubleClick cookie (web activity) and from device advertising IDs (app activity). It allows the Owner to analyze specific behavior and interests Data (traffic Data and Users\' ads interaction Data) and, if enabled, demographic Data (information about the age and gender). Users can opt out of Google\'s use of cookies by visiting Google\'s Ads Settings.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting2',
                                            defaultMessage: 'Personal Data processed: Cookies; unique device identifiers for advertising (Google Advertiser ID or IDFA, for example); various types of Data as specified in the privacy policy of the service.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleDemographics',
                                    defaultMessage: 'Google Analytics Demographics and Interests reports (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleDemographics1',
                                            defaultMessage: 'Google Analytics Demographics and Interests reports is a Google Advertising Reporting feature that makes available demographic and interests Data inside Google Analytics for this Application (demographics means age and gender Data). Users can opt out of Google\'s use of cookies by visiting Google\'s Ads Settings.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleDemographics2',
                                            defaultMessage: 'Personal Data processed: Cookies; unique device identifiers for advertising (Google Advertiser ID or IDFA, for example).'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleDemographics3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoABTesting',
                                    defaultMessage: 'Content performance and features testing (A/B testing)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoABTesting1',
                                    defaultMessage: 'The services contained in this section allow the Owner to track and analyze the User response concerning web traffic or behavior regarding changes to the structure, text or any other component of this Application.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleOptimize',
                                    defaultMessage: 'Google Optimize (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleOptimize1',
                                            defaultMessage: 'Google Optimize is an A/B testing service provided by Google Ireland Limited (Google). Google may use Personal Data to contextualize and personalize the ads of its own advertising network.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleOptimize2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleOptimize3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoRemarketing',
                                    defaultMessage: 'Remarketing and behavioral targeting'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoRemarketing1',
                                            defaultMessage: 'This type of service allows this Application and its partners to inform, optimize and serve advertising based on past use of this Application by the User.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoRemarketing2',
                                            defaultMessage: 'This activity is facilitated by tracking Usage Data and by using Cookies and other Identifiers to collect information which is then transferred to the partners that manage the remarketing and behavioral targeting activity.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoRemarketing3',
                                            defaultMessage: 'Some services offer a remarketing option based on email address lists.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoRemarketing4',
                                            defaultMessage: 'In addition to any opt-out feature provided by any of the services below, Users may opt out by visiting the Network Advertising Initiative opt-out page.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoRemarketing5',
                                            defaultMessage: 'Users may also opt-out of certain advertising features through applicable device settings, such as the device advertising settings for mobile phones or ads settings in general.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion',
                                    defaultMessage: 'Google Ad Manager Audience Extension (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion1',
                                            defaultMessage: 'Google Ad Manager Audience Extension is a remarketing and behavioral targeting service provided by Google Ireland Limited that tracks the visitors of this Application and allows selected advertising partners to display targeted ads across the web to them.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing',
                                    defaultMessage: 'Google Ads Remarketing (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing1',
                                            defaultMessage: 'Google Ads Remarketing is a remarketing and behavioral targeting service provided by Google Ireland Limited that connects the activity of this Application with the Google Ads advertising network and the DoubleClick Cookie. Users can opt out of Google\'s use of cookies for ads personalization by visiting Google\'s Ads Settings.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics',
                                    defaultMessage: 'Remarketing with Google Analytics (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics1',
                                            defaultMessage: 'Remarketing with Google Analytics is a remarketing and behavioral targeting service provided by Google Ireland Limited that connects the tracking activity performed by Google Analytics and its Cookies with the Google Ads advertising network and the Doubleclick Cookie.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFacebookRemembering',
                                    defaultMessage: 'Facebook Remarketing (Facebook, Inc.)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFacebookRemembering1',
                                            defaultMessage: 'Facebook Remarketing is a remarketing and behavioral targeting service provided by Facebook, Inc. that connects the activity of this Application with the Facebook advertising network.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFacebookRemembering2',
                                            defaultMessage: 'Personal Data processed: Cookies; Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFacebookRemembering3',
                                            defaultMessage: 'Place of processing: United States \u2013 Privacy Policy \u2013 Opt Out. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoTagManagement',
                                    defaultMessage: 'Tag Management'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoTagManagement1',
                                            defaultMessage: 'This type of service helps the Owner to manage the tags or scripts needed on this Application in a centralized fashion.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoTagManagement2',
                                            defaultMessage: 'This results in the Users\' Data flowing through these services, potentially resulting in the retention of this Data.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '10px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleTagManager',
                                    defaultMessage: 'Google Tag Manager (Google Ireland Limited)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleTagManager1',
                                            defaultMessage: 'Google Tag Manager is a tag management service provided by Google Ireland Limited.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleTagManager2',
                                            defaultMessage: 'Personal Data processed: Usage Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoGoogleTagManager3',
                                            defaultMessage: 'Place of processing: Ireland \u2013 Privacy Policy. Privacy Shield participant.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData',
                                    defaultMessage: 'Further information about Personal Data'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData1',
                                            defaultMessage: 'Analysis and predictions based on the User\u2019s Data (\u201Cprofiling\u201D)'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData2',
                                            defaultMessage: 'The Owner may use the Personal and Usage Data collected through this Application to create or update User profiles. This type of Data processing allows the Owner to evaluate User choices, preferences and behaviour for the purposes outlined in the respective section of this document.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData3',
                                            defaultMessage: 'User profiles can also be created through the use of automated tools like algorithms, which can also be provided by third parties. To find out more about the profiling activities performed, Users can check the relevant sections of this document.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData4',
                                            defaultMessage: 'The User always has a right to object to this kind of profiling activity. To find out more about the User\'s rights and how to exercise them, the User is invited to consult the section of this document outlining the rights of the User.'
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRights',
                                    defaultMessage: 'The rights of Users'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsPara1',
                                    defaultMessage: 'Users may exercise certain rights regarding their Data processed by the Owner.'
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsPara2',
                                    defaultMessage: 'In particular, Users have the right to do the following:'
                                }),
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList1',
                                            defaultMessage: 'Withdraw their consent at any time. Users have the right to withdraw consent where they have previously given their consent to the processing of their Personal Data.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList2',
                                            defaultMessage: 'Object to processing of their Data. Users have the right to object to the processing of their Data if the processing is carried out on a legal basis other than consent. Further details are provided in the dedicated section below.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList3',
                                            defaultMessage: 'Access their Data. Users have the right to learn if Data is being processed by the Owner, obtain disclosure regarding certain aspects of the processing and obtain a copy of the Data undergoing processing.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList4',
                                            defaultMessage: 'Verify and seek rectification. Users have the right to verify the accuracy of their Data and ask for it to be updated or corrected.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList5',
                                            defaultMessage: 'Restrict the processing of their Data. Users have the right, under certain circumstances, to restrict the processing of their Data. In this case, the Owner will not process their Data for any purpose other than storing it.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList6',
                                            defaultMessage: 'Have their Personal Data deleted or otherwise removed. Users have the right, under certain circumstances, to obtain the erasure of their Data from the Owner.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList7',
                                            defaultMessage: 'Receive their Data and have it transferred to another controller. Users have the right to receive their Data in a structured, commonly used and machine readable format and, if technically feasible, to have it transmitted to another controller without any hindrance. This provision is applicable provided that the Data is processed by automated means and that the processing is based on the User\'s consent, on a contract which the User is part of or on pre-contractual obligations thereof.'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsParaList8',
                                            defaultMessage: 'Lodge a complaint. Users have the right to bring a claim before their competent data protection authority.'
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsDetails',
                                    defaultMessage: 'Details about the right to object to processing'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsDetails1',
                                    defaultMessage: 'Where Personal Data is processed for a public interest, in the exercise of an official authority vested in the Owner or for the purposes of the legitimate interests pursued by the Owner, Users may object to such processing by providing a ground related to their particular situation to justify the objection.'
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsDetails2',
                                    defaultMessage: 'Users must know that, however, should their Personal Data be processed for direct marketing purposes, they can object to that processing at any time without providing any justification. To learn, whether the Owner is processing Personal Data for direct marketing purposes, Users may refer to the relevant sections of this document.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsExercise',
                                    defaultMessage: 'How to exercise these rights'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyRightsExercise1',
                                    defaultMessage: 'Any requests to exercise User rights can be directed to the Owner through the contact details provided in this document. These requests can be exercised free of charge and will be addressed by the Owner as early as possible and always within one month.'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookie',
                                    defaultMessage: 'Cookie Policy'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookie1',
                                    defaultMessage: 'This Application uses Cookies and other Identifiers. To learn more, the User may consult the '
                                }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'privacy-policy-lists-anchors', onClick: this.toggleCookiePolicy, style: { cursor: 'pointer' } },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookie2',
                                        defaultMessage: 'Cookie Policy.'
                                    })
                                )
                            )
                        ),
                        this.state.showCookiePolicy ? _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieGamelord',
                                    defaultMessage: 'Cookie Policy of Game Lords'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieGamelord1',
                                    defaultMessage: 'Cookies and other Identifiers consist of portions of code placed on the User\u2019s device that assist the Owner in providing the Service according to the purposes described.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieGamelord2',
                                    defaultMessage: 'Some of the purposes for which Identifiers are used may also require the User\'s consent. Whenever consent is given, it can be freely withdrawn at any time following the instructions provided in this document.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieActivities',
                                    defaultMessage: 'Activities strictly necessary for the operation of this Application and delivery of the Service'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieActivities1',
                                    defaultMessage: 'This Application uses Cookies or other Identifiers to carry out activities that are strictly necessary for the operation or delivery of the Service and, therefore, do not require Users to consent. Users can disable such Identifiers by modifying their browser or device settings as described in more detail within this document, but this may affect core operational functions or result in the unavailability of the Service.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivities',
                                    defaultMessage: 'Other activities'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'privacy-policy-lists' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesMeasurement',
                                            defaultMessage: 'Measurement'
                                        }),
                                        ':',
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'terms-para' },
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesMeasurement1',
                                                defaultMessage: 'This Application uses Cookies or other Identifiers to measure traffic and analyze User behavior with the goal of improving the Service.'
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'privacy-policy-lists' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesMeasurementList1',
                                                defaultMessage: 'Analytics'
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesMeasurementList2',
                                                defaultMessage: 'Analytics services managed directly by this Application'
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesMeasurementList3',
                                                defaultMessage: 'Anonymized analytics services'
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesMeasurementList4',
                                                defaultMessage: 'Content performance and features testing (A/B testing)'
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesTargeting',
                                            defaultMessage: 'Targeting & Advertising'
                                        }),
                                        ':',
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'terms-para' },
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesTargeting1',
                                                defaultMessage: 'This Application uses Cookies or other Identifiers to deliver personalized marketing content based on User behavior and to operate, serve and track ads.'
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'privacy-policy-lists' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesTargetingList1',
                                                defaultMessage: 'Analytics'
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieOtherActivitiesTargetingList2',
                                                defaultMessage: 'Analytics services managed directly by this Application'
                                            })
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieWithdrawConstent',
                                    defaultMessage: 'How to provide or withdraw consent'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieWithdrawConstent1',
                                    defaultMessage: 'Users can provide or withdraw consent to the use of Cookies and other Identifiers by setting their preferences within the cookie notice or by updating such preferences via the relevant consent-preferences widget accordingly, if available.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieWithdrawConstent2',
                                    defaultMessage: 'Additionally, Users can manage preferences regarding Identifiers directly from within their own device settings and prevent \u2013 for example \u2013 the storing of third-party Identifiers. It is also possible, via relevant browser or device features, to delete previously stored Identifiers, including those used to remember the User\u2019s initial consent. Users can, for example, find information about how to manage Identifiers in the most commonly used browsers at the following addresses: Google Chrome, Mozilla Firefox, Apple Safari and Microsoft Internet Explorer.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieWithdrawConstent3',
                                    defaultMessage: 'With regard to any Identifiers stored by third parties, Users can manage their preferences and withdraw their consent by clicking the related opt-out link (where provided), by using the means indicated in the third party\'s privacy policy, or by contacting the third party.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieWithdrawConstent4',
                                    defaultMessage: 'Notwithstanding the above, Users are hereby informed that they may follow the instructions provided by YourOnlineChoices (EU), the Network Advertising Initiative (US) and the Digital Advertising Alliance (US), DAAC (Canada), DDAI (Japan) or other similar services. Such initiatives allow Users to select their tracking preferences for most of the advertising tools. The Owner thus recommends that Users make use of these resources in addition to the information provided in this document.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController',
                                    defaultMessage: 'Owner and Data Controller'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController1',
                                    defaultMessage: 'Mobimilia BV'
                                }),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController2',
                                    defaultMessage: 'Van Diemenstraat 140'
                                }),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController3',
                                    defaultMessage: '1013 CN Amsterdam'
                                }),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController4',
                                    defaultMessage: 'Owner contact email: info@mobimilia.com'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController5',
                                    defaultMessage: 'Since the storing of third-party Cookies and other Identifiers through the services used within this Application cannot be technically controlled by the Owner, any specific references to Identifiers stored by third parties are to be considered indicative. In order to obtain complete information, the User is kindly requested to consult the privacy policies of the respective third-party services listed in this document.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyCookieController6',
                                    defaultMessage: 'Given the objective complexity surrounding technologies related to Cookies and other Identifiers, Users are encouraged to contact the Owner should they wish to receive any further information on the use of such Identifiers by this Application.'
                                })
                            )
                        ) : null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfo',
                                    defaultMessage: 'Additional information about Data collection and processing'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoLegalAction',
                                    defaultMessage: 'Legal action'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoLegalAction1',
                                    defaultMessage: 'The User\'s Personal Data may be used for legal purposes by the Owner in Court or in the stages leading to possible legal action arising from improper use of this Application or the related Services.'
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoLegalAction2',
                                    defaultMessage: 'The User declares to be aware that the Owner may be required to reveal personal data upon request of public authorities.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoPersonalData',
                                    defaultMessage: 'Additional information about User\'s Personal Data'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoPersonalData1',
                                    defaultMessage: 'In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular Services or the collection and processing of Personal Data upon request.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoMaintenance',
                                    defaultMessage: 'System logs and maintenance'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoMaintenance1',
                                    defaultMessage: 'For operation and maintenance purposes, this Application and any third-party services may collect files that record interaction with this Application (System logs) use other Personal Data (such as the IP Address) for this purpose.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoNotContained',
                                    defaultMessage: 'Information not contained in this policy'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoNotContained1',
                                    defaultMessage: 'More details concerning the collection or processing of Personal Data may be requested from the Owner at any time. Please see the contact information at the beginning of this document.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoDoNotTrack',
                                    defaultMessage: 'How \u201CDo Not Track\u201D requests are handled'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoDoNotTrack1',
                                    defaultMessage: 'This Application does not support \u201CDo Not Track\u201D requests. To determine whether any of the third-party services it uses honor the \u201CDo Not Track\u201D requests, please read their privacy policies.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoChanges',
                                    defaultMessage: 'Changes to this privacy policy'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoChanges1',
                                    defaultMessage: 'The Owner reserves the right to make changes to this privacy policy at any time by notifying its Users on this page and possibly within this Application and/or - as far as technically and legally feasible - sending a notice to Users via any contact information available to the Owner. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom.'
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyAddInfoChanges2',
                                    defaultMessage: 'Should the changes affect processing activities performed on the basis of the User\u2019s consent, the Owner shall collect new consent from the User, where required.'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefiner',
                                    defaultMessage: 'Definitions and legal references'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerPersonalData',
                                    defaultMessage: 'Personal Data (or Data)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerPersonalData1',
                                    defaultMessage: 'Any information that directly, indirectly, or in connection with other information \u2014 including a personal identification number \u2014 allows for the identification or identifiability of a natural person.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerUsageData',
                                    defaultMessage: 'Usage Data'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerUsageData1',
                                    defaultMessage: 'Information collected automatically through this Application (or third-party services employed in this Application), which can include: the IP addresses or domain names of the computers utilized by the Users who use this Application, the URI addresses (Uniform Resource Identifier), the time of the request, the method utilized to submit the request to the server, the size of the file received in response, the numerical code indicating the status of the server\'s answer (successful outcome, error, etc.), the country of origin, the features of the browser and the operating system utilized by the User, the various time details per visit (e.g., the time spent on each page within the Application) and the details about the path followed within the Application with special reference to the sequence of pages visited, and other parameters about the device operating system and/or the User\'s IT environment.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerUser',
                                    defaultMessage: 'User'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerUser1',
                                    defaultMessage: 'The individual using this Application who, unless otherwise specified, coincides with the Data Subject.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerSubject',
                                    defaultMessage: 'Data Subject'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerSubject1',
                                    defaultMessage: 'The natural person to whom the Personal Data refers.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerProcessor',
                                    defaultMessage: 'Data Processor (or Data Supervisor)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerProcessor1',
                                    defaultMessage: 'The natural or legal person, public authority, agency or other body which processes Personal Data on behalf of the Controller, as described in this privacy policy.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerController',
                                    defaultMessage: 'Data Controller (or Owner)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerController1',
                                    defaultMessage: 'The natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of Personal Data, including the security measures concerning the operation and use of this Application. The Data Controller, unless otherwise specified, is the Owner of this Application.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerApplication',
                                    defaultMessage: 'This Application'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerApplication1',
                                    defaultMessage: 'The means by which the Personal Data of the User is collected and processed.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerService',
                                    defaultMessage: 'Service'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerService1',
                                    defaultMessage: 'The service provided by this Application as described in the relative terms (if available) and on this site/application.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerEU',
                                    defaultMessage: 'European Union (or EU)'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerEU1',
                                    defaultMessage: 'Unless otherwise specified, all references made within this document to the European Union include all current member states to the European Union and the European Economic Area.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerCookies',
                                    defaultMessage: 'Cookies'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerCookies1',
                                    defaultMessage: 'Small sets of data stored in the User\'s device.'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para-head' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerLegalInfo',
                                    defaultMessage: 'Legal information'
                                }),
                                ':'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerLegalInfo1',
                                    defaultMessage: 'This privacy statement has been prepared based on provisions of multiple legislations, including Art. 13/14 of Regulation (EU) 2016/679 (General Data Protection Regulation).'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para', style: { marginLeft: '30px' } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyDefinerLegalInfo2',
                                    defaultMessage: 'This privacy policy relates solely to this Application, if not stated otherwise within this document.'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            null,
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPrivacyPolicyLatestUpdate',
                                    defaultMessage: 'Latest update: May 08, 2020'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return NewPrivacyPolicy;
}(_react.Component);

exports.default = NewPrivacyPolicy;

/***/ }),

/***/ "./src/components/PrivacyPolicy/PrivacyPolicy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _isOnlyBeemobi = __webpack_require__("./src/constants/isOnlyBeemobi.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyPolicy = function (_Component) {
  _inherits(PrivacyPolicy, _Component);

  function PrivacyPolicy() {
    _classCallCheck(this, PrivacyPolicy);

    return _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).apply(this, arguments));
  }

  _createClass(PrivacyPolicy, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _sendData.sendData)("", "", "", "viewed", { page: "privacy-policy" });
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      if (_domainConfig.config.subDomain === "rs" && _isGamiclub.isGamiclub) {
        return _react2.default.createElement(
          "section",
          { className: "terms privacy-policy" },
          _react2.default.createElement(
            _reactstrap.Container,
            { fluid: true },
            _react2.default.createElement(
              _reactstrap.Row,
              null,
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12" },
                _react2.default.createElement(
                  "div",
                  { className: "terms-title-wrap" },
                  _react2.default.createElement(
                    "h2",
                    { className: "terms-section-title" },
                    "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438\u041E \u043D\u0430\u043C\u0430 - GamiClub"
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "no-gutters" },
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u0432\u0430 \u0441\u043C\u0435\u0440\u043D\u0438\u0446\u0430 \u0440\u0435\u0433\u0443\u043B\u0438\u0448\u0435 \u0432\u0430\u0448\u0435 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 \u043C\u043E\u0431\u0438\u043B\u043D\u0435 \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0435 GamiClub \u0438 \u0431\u0438\u043B\u043E \u043A\u043E\u0433 \u0441\u0430\u0434\u0440\u0436\u0430\u0458\u0430, \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0430 \u0438 \u0443\u0441\u043B\u0443\u0433\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u0441\u0430 \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u043E \u043E\u0432\u0435 \u0432\u0435\u0431 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041C\u043E\u0431\u0438\u043B\u043D\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u0432\u0435\u0431 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u0430\u0458\u0435 \u043D\u0430 \u0440\u0430\u0441\u043F\u043E\u043B\u0430\u0433\u0430\u045A\u0443 GamiClub, \u0430 \u043F\u0440\u0443\u0436\u0430 \u0438\u0445 VAN DIEMENSTRAAT 140, 1031 CN AMSTERDAM, \u0430 \u045A\u0435\u043D\u0430 \u043F\u0440\u0438\u0434\u0440\u0443\u0436\u0435\u043D\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 Sam Media BV. \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0443 Amsterdam, \u043A\u043E\u0458\u0430 \u0441\u0435 \u0443 \u0434\u0430\u0459\u0435\u043C \u0442\u0435\u043A\u0441\u0442\u0443 \u0437\u0430\u0458\u0435\u0434\u043D\u043E \u043D\u0430\u0437\u0438\u0432\u0430 \u201E\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430, \u043C\u0438, \u043C\u0438, \u043D\u0430\u0448\u0438, \u0441\u0430\u043C\u0438\u201C . Sam Media BV. \u0458\u0435 \u0434\u043E\u0431\u0430\u0432\u0459\u0430\u0447 \u0441\u0430\u0434\u0440\u0436\u0430\u0458\u0430 \u0438 \u0440\u0430\u0434\u0438 GamiClub. \u0412\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0443 \u043C\u043E\u0431\u0438\u043B\u043D\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0458\u0435 GamiClub \u0445\u043E\u0441\u0442\u0438\u0440\u0430 Sam Media BV. \u0443 Amsterdam. \u041A\u043E\u043B\u0435\u043A\u0442\u0438\u0432\u043D\u043E \u043D\u0443\u0434\u0438\u043C\u043E \u043F\u043E\u0433\u043E\u0434\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0443 \u043D\u0430 GamiClub \u0438 \u043F\u0440\u0443\u0436\u0430\u043C\u043E \u0432\u0430\u043C \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u0438\u0433\u0440\u0430\u043C\u0430, \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u0437\u0430\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u043C \u043D\u0430 \u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0447\u0443 \u0438 \u0441\u043B."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0421\u0432\u0440\u0445\u0430 \u043E\u0432\u0435 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041C\u0438 \u0441\u043C\u043E \u043F\u043E\u0441\u0432\u0435\u045B\u0435\u043D\u0438 \u0437\u0430\u0448\u0442\u0438\u0442\u0438 \u0438 \u043E\u0447\u0443\u0432\u0430\u045A\u0443 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u0432\u0430\u0448\u0438\u0445 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043F\u0440\u0438\u0434\u0440\u0436\u0430\u0432\u0430\u0458\u0443\u045B\u0438 \u0441\u0435 \u0441\u0432\u0438\u0445 \u0432\u0430\u0436\u0435\u045B\u0438\u0445 \u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u0438\u0445 \u0441\u043C\u0435\u0440\u043D\u0438\u0446\u0430 \u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438 \u0421\u0440\u0431\u0438\u0458\u0438 \u0437\u0430\u043A\u043E\u043D \u043E \u0437\u0430\u0448\u0442\u0438\u0442\u0438 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u0432\u0430 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u0458\u0430 \u0441\u0435 \u043D\u0430\u0437\u0438\u0432\u0430 \u201E\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430\u201C \u0458\u0435 \u0458\u0430\u0432\u043D\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043A\u043E\u0458\u0438 \u0443\u0442\u0432\u0440\u0452\u0443\u0458\u0435 \u043D\u0430\u0448 \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u043D\u0430\u0448\u0438\u043C \u043F\u043E\u0441\u0442\u0443\u043F\u0430\u045A\u0435\u043C \u0438 \u0440\u0443\u043A\u043E\u0432\u0430\u045A\u0435\u043C \u043B\u0438\u0447\u043D\u0438\u043C \u043F\u043E\u0434\u0430\u0446\u0438\u043C\u0430 \u043A\u043E\u0458\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u043F\u0440\u0438\u043A\u0443\u043F\u0438\u0442\u0438 \u043E\u0434 \u0432\u0430\u0441 \u0438\u043B\u0438 \u043E \u0432\u0430\u043C\u0430. \u0418\u0437\u0434\u0432\u0430\u0458\u0430 \u043D\u0430\u0448\u0435 \u043F\u0440\u0430\u043A\u0441\u0435 \u043E\u043A\u043E \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u045A\u0430, \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430, \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u045A\u0430, \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u0442\u0438, \u0441\u043A\u043B\u0430\u0434\u0438\u0448\u0442\u0435\u045A\u0430, \u0447\u0443\u0432\u0430\u045A\u0430 \u0435\u0432\u0438\u0434\u0435\u043D\u0446\u0438\u0458\u0430, \u043E\u0434\u0440\u0436\u0430\u0432\u0430\u045A\u0430 \u0438 \u043F\u0440\u0435\u043A\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u043D\u0435 \u0440\u0430\u0437\u043C\u0435\u043D\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430 (\u043F\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u0438) \u0432\u0430\u0448\u0438\u0445 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u0432\u0430 \u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0441\u0443 \u0438\u043D\u043A\u043E\u0440\u043F\u043E\u0440\u0438\u0440\u0430\u043D\u0430 \u0443 \u0423\u0432\u0458\u0435\u0442\u0435 \u0438 \u043E\u0434\u0440\u0435\u0434\u0431\u0435 GamiClub \u0438 \u043C\u043E\u0431\u0438\u043B\u043D\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 GamiClub. \u041F\u0440\u0438\u0445\u0432\u0430\u0442\u0430\u045A\u0435\u043C GamiClub \u0423\u0441\u043B\u043E\u0432\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0430 \u043F\u0440\u0438\u0445\u0432\u0430\u0442\u0430\u0442\u0435 \u043E\u0432\u0443 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0443. \u041A\u043E\u043F\u0438\u0458\u0430 \u043E\u0432\u0435 \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0435 \u043C\u043E\u0436\u0435 \u0432\u0430\u043C \u0441\u0435 \u043F\u043E\u0441\u043B\u0430\u0442\u0438 / \u043F\u043E\u0441\u043B\u0430\u0442\u0438 \u0435-\u043F\u043E\u0448\u0442\u043E\u043C \u043D\u0430 \u0432\u0430\u0448 \u0437\u0430\u0445\u0442\u0435\u0432."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0420\u0430\u0437\u043C\u0430\u0442\u0440\u0430\u045A\u0435 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0414\u0430 \u0431\u0438\u0441\u043C\u043E \u0432\u0430\u043C \u043F\u0440\u0443\u0436\u0438\u043B\u0438 \u0443\u0441\u043B\u0443\u0433\u0443 \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0435 \u043D\u0430 GamiClub, \u043C\u043E\u0440\u0430\u043C\u043E \u043F\u0440\u0438\u043A\u0443\u043F\u0438\u0442\u0438 \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u0432\u0430\u043C\u0430. \u041B\u0438\u0447\u043D\u0438 \u043F\u043E\u0434\u0430\u0446\u0438 \u043A\u043E\u0458\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u043F\u0440\u0438\u043A\u0443\u043F\u0438\u0442\u0438 \u043E \u0432\u0430\u043C\u0430 \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443, \u0430\u043B\u0438 \u043D\u0438\u0441\u0443 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438 \u043D\u0430 \u0432\u0430\u0448 \u043C\u043E\u0431\u0438\u043B\u043D\u0438 \u0431\u0440\u043E\u0458 \u0438 \u0432\u0430\u0448\u0435 \u0438\u043C\u0435. \u0423 \u0441\u043B\u0443\u0447\u0430\u0458\u0443 \u0434\u0430 \u0441\u0435 \u043E\u0434 \u043D\u0430\u0441 \u043C\u043E\u0436\u0435 \u0437\u0430\u0442\u0440\u0430\u0436\u0438\u0442\u0438 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u045A\u0435 \u0434\u043E\u0434\u0430\u0442\u043D\u0438\u0445 \u0438\u043B\u0438 \u0434\u043E\u0434\u0430\u0442\u043D\u0438\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430 \u043E \u0432\u0430\u043C\u0430 \u043A\u0430\u043A\u043E \u0431\u0438\u0441\u043C\u043E \u0432\u0430\u043C \u043F\u0440\u0443\u0436\u0438\u043B\u0438 \u043D\u0430\u0448\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0435, \u0443\u0441\u043B\u0443\u0433\u0435, \u043C\u0438 \u045B\u0435\u043C\u043E \u0441\u0435 \u043F\u043E\u0431\u0440\u0438\u043D\u0443\u0442\u0438 \u0434\u0430 \u0434\u043E\u0431\u0438\u0458\u0435\u043C\u043E \u0432\u0430\u0448\u0443 \u0441\u0430\u0433\u043B\u0430\u0441\u043D\u043E\u0441\u0442 \u0438 \u043E \u0442\u043E\u043C\u0435 \u0432\u0430\u0441 \u043E\u0431\u0430\u0432\u0435\u0441\u0442\u0438\u043C\u043E."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u045A\u0435 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E \u043F\u0443\u0442\u0435\u043C \u0431\u0440\u043E\u0458\u043D\u0438\u0445 \u043A\u0430\u043D\u0430\u043B\u0430, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438:"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0414\u0438\u0440\u0435\u043A\u0442\u043D\u043E \u043E\u0434 \u0432\u0430\u0441, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438, \u0430\u043B\u0438 \u043D\u0438\u0458\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E \u043D\u0430: \u041A\u0430\u0434\u0430 \u043D\u0430 \u043D\u0430\u0448\u0438\u043C \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u043C \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u0443\u043D\u0435\u0441\u0435\u0442\u0435 \u0442\u0440\u0430\u0436\u0435\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043E \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0438. \u041A\u0430\u0434\u0430 \u0443\u0447\u0435\u0441\u0442\u0432\u0443\u0458\u0435\u0442\u0435 \u0443 \u043D\u0430\u0448\u0438\u043C \u0440\u0430\u0437\u043B\u0438\u0447\u0438\u0442\u0438\u043C \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u0458\u0430\u043C\u0430 \u0438 \u0430\u043D\u043A\u0435\u0442\u0430\u043C\u0430 \u041E\u0434 \u0442\u0440\u0435\u045B\u0438\u0445 \u0441\u0442\u0440\u0430\u043D\u0430, \u043F\u043E\u043F\u0443\u0442 \u043D\u0430\u0448\u0438\u0445 \u043F\u043E\u0432\u0435\u0437\u0430\u043D\u0438\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430, \u0432\u0430\u0448\u0435\u0433 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0412\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E \u0443\u0433\u043B\u0430\u0432\u043D\u043E\u043C \u0434\u0430 \u0431\u0438\u0441\u043C\u043E \u0432\u0430\u043C \u0438\u0441\u043F\u043E\u0440\u0443\u0447\u0438\u043B\u0438 \u043D\u0430\u0448\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0435 \u0438 \u0443\u0441\u043B\u0443\u0433\u0435, \u043D\u0430 \u043F\u0440\u0438\u043C\u0435\u0440 \u0443\u0441\u043B\u0443\u0433\u0443 \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0435 GamiClub, \u0430 \u043F\u043E\u0442\u043E\u043C \u0438 \u0437\u0430:"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041D\u0430\u043F\u043B\u0430\u0442\u0430 \u0438 \u0443\u043F\u0440\u0430\u0432\u0459\u0430\u045A\u0435 \u0440\u0430\u0447\u0443\u043D\u0438\u043C\u0430; \u0421\u043B\u0443\u0436\u0431\u0430 \u0437\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0435 \u0438 \u043F\u043E\u043C\u043E\u045B; \u041F\u0440\u0443\u0436\u0438\u043C\u043E \u0432\u0430\u043C \u0434\u0430\u0459\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u043D\u0430\u0448\u0438\u043C \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u0458\u0430\u043C\u0430, \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u043C\u0430, \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0430 \u043A\u043E\u0458\u0435 \u043D\u0443\u0434\u0438\u043C\u043E \u043C\u0438 \u0438 \u043D\u0430\u0448\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438; \u0418\u043B\u0438 \u0430\u043A\u043E \u0438 \u043A\u0430\u0434\u0430 \u0442\u043E \u0437\u0430\u0445\u0442\u0435\u0432\u0430 \u0437\u0430\u043A\u043E\u043D."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041E\u0441\u0435\u0442\u0459\u0438\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u0441\u0435\u0442\u0459\u0438\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u0441\u0443 \u0434\u0435\u0444\u0438\u043D\u0438\u0441\u0430\u043D\u0435 \u043A\u0430\u043E \u0434\u0435\u0442\u0430\u0459\u0438 \u043E \u0432\u0430\u0448\u043E\u0458 \u0440\u0430\u0441\u0438, \u0435\u0442\u043D\u0438\u0447\u043A\u043E\u0458 \u043F\u0440\u0438\u043F\u0430\u0434\u043D\u043E\u0441\u0442\u0438, \u0432\u0435\u0440\u0441\u043A\u0438\u043C \u0432\u0435\u0440\u043E\u0432\u0430\u045A\u0438\u043C\u0430, \u0440\u043E\u0434\u0443 \u0438\u0442\u0434. \u0413\u0435\u043D\u0435\u0440\u0430\u043B\u043D\u043E \u0433\u043B\u0435\u0434\u0430\u043D\u043E, \u043D\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E \u043D\u0438\u0442\u0438 \u0441\u0443 \u043D\u0430\u043C \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u0435 \u043E\u0441\u0435\u0442\u0459\u0438\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u0432\u0430\u043C\u0430 \u0443 \u0441\u0432\u0440\u0445\u0443 \u043F\u0440\u0443\u0436\u0430\u045A\u0430 \u043D\u0430\u0448\u0438\u0445 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0430 \u0438 \u0443\u0441\u043B\u0443\u0433\u0430. \u0423 \u0441\u043B\u0443\u0447\u0430\u0458\u0443 \u0434\u0430 \u0458\u0435 \u0442\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E, \u043C\u0438 \u045B\u0435\u043C\u043E \u0442\u043E \u0443\u0447\u0438\u043D\u0438\u0442\u0438 \u0442\u0430\u043A\u043E \u0448\u0442\u043E \u045B\u0435\u043C\u043E \u043E\u0431\u0435\u0437\u0431\u0435\u0434\u0438\u0442\u0438 \u0434\u0430 \u0434\u043E\u0431\u0438\u0458\u0435\u043C\u043E \u0432\u0430\u0448\u0443 \u0441\u0430\u0433\u043B\u0430\u0441\u043D\u043E\u0441\u0442 \u0438 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0435\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u045B\u0435\u043C\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0441\u0430\u043C\u043E \u0443 \u0441\u0432\u0440\u0445\u0443 \u0443 \u043A\u043E\u0458\u0443 \u0441\u0442\u0435 \u043F\u0440\u0443\u0436\u0438\u043B\u0438 \u043E\u0441\u0435\u0442\u0459\u0438\u0432\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0423\u043F\u043E\u0442\u0440\u0435\u0431\u0430 / \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u045A\u0435 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430"
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041E\u0441\u043D\u043E\u0432\u043D\u0430 \u0441\u0432\u0440\u0445\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u043C\u043E\u0433\u0443\u045B\u0430\u0432\u0430\u0458\u0443\u045B\u0438 \u0432\u0430\u043C GamiClub \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434 \u0438 \u0443\u0441\u043B\u0443\u0433\u0435 \u043A\u043E\u0458\u0435 \u0441\u0442\u0435 \u0437\u0430\u0442\u0440\u0430\u0436\u0438\u043B\u0438 / \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0438\u043B\u0438, \u043C\u0438 \u045B\u0435\u043C\u043E \u043E\u0442\u043A\u0440\u0438\u0442\u0438 \u0432\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0442\u0440\u0435\u045B\u0438\u043C \u043B\u0438\u0446\u0438\u043C\u0430 \u0432\u0430\u043D \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435, \u043A\u0430\u043E \u0448\u0442\u043E \u0458\u0435 \u0432\u0430\u0448 \u043C\u043E\u0431\u0438\u043B\u043D\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u0434\u0430 \u043E\u0441\u0438\u0433\u0443\u0440\u0430\u043C\u043E \u043D\u0430\u043F\u043B\u0430\u0442\u0443 \u043D\u0430\u043A\u043D\u0430\u0434\u0430. \u0412\u0430\u0448\u0438 \u043B\u0438\u0447\u043D\u0438 \u043F\u043E\u0434\u0430\u0446\u0438 \u0441\u0435 \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u0458\u0443 \u043E\u0432\u0438\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u0441\u0430\u043C\u043E \u0443 \u043E\u0434\u043D\u043E\u0441\u0443 \u043D\u0430 \u043D\u0430\u0441 \u043A\u043E\u0458\u0438 \u043F\u0440\u0443\u0436\u0430\u043C\u043E / \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430\u043C\u043E \u0442\u0440\u0430\u0436\u0435\u043D\u0435 / \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u045B\u0435\u043D\u0435 \u0443\u0441\u043B\u0443\u0433\u0435 \u043F\u043E \u0432\u0430\u0448\u0435\u043C \u0437\u0430\u0445\u0442\u0435\u0432\u0443."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0442\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0458\u0438 \u043A\u043E\u0458\u0435 \u0441\u0443 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0435\u043D\u0435 \u0434\u0430 \u0431\u0438 (1) \u043F\u0440\u0430\u0442\u0438\u043B\u0438 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0443 \u043E\u0441\u043E\u0431\u0435 GamiClub, (2) \u0434\u0430 \u0431\u0438 \u043E\u0434\u0440\u0435\u0434\u0438\u043B\u0438 \u043A\u043E\u0458\u0430 \u043F\u043E\u0434\u0440\u0443\u0447\u0458\u0430 \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u0445 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435 \u0441\u0435 \u043D\u0430\u0458\u0447\u0435\u0448\u045B\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0435. \u041E\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043D\u0430\u043C \u043F\u043E\u043C\u0430\u0436\u0443 \u0434\u0430 \u0431\u043E\u0459\u0435 \u0440\u0430\u0437\u0443\u043C\u0435\u043C\u043E \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043A\u043E \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u043E \u0438\u0441\u043A\u0443\u0441\u0442\u0432\u043E \u043F\u043E\u0458\u0435\u0434\u0438\u043D\u0430\u0446\u0430 \u0440\u0430\u0434\u0438 \u0434\u0430\u0459\u0435\u0433 \u043F\u043E\u0431\u043E\u0459\u0448\u0430\u045A\u0430 / \u0443\u043D\u0430\u043F\u0440\u0435\u0452\u0435\u045A\u0430 \u043D\u0430\u0448\u0438\u0445 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0430 \u0438 \u0443\u0441\u043B\u0443\u0433\u0430 \u0438 \u0446\u0438\u0459\u0430\u043D\u043E\u0433 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0430 \u0438 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u0458\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041C\u0438 \u0442\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u043E\u0442\u043A\u0440\u0438\u0442\u0438 \u0432\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435:"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0414\u0440\u0436\u0430\u0432\u043D\u0430 \u0438 \u0440\u0435\u0433\u0443\u043B\u0430\u0442\u043E\u0440\u043D\u0430 \u0442\u0435\u043B\u0430 \u043F\u0440\u0435\u043C\u0430 \u0437\u0430\u043A\u043E\u043D\u0443 \u0438\u043B\u0438 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u0438\u043C\u0430, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438, \u0430\u043B\u0438 \u043D\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0430\u0432\u0430\u0458\u0443\u045B\u0438 \u0441\u0435 \u043D\u0430 \u043E\u0434\u0433\u043E\u0432\u043E\u0440 \u043D\u0430 \u043F\u043E\u0437\u0438\u0432\u0435, \u0441\u0443\u0434\u0441\u043A\u0435 \u043D\u0430\u043B\u043E\u0433\u0435, \u043D\u0430\u043B\u043E\u0433\u0435 \u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u043D\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u0430\u043A, \u0438\u043B\u0438 \u0434\u0430 \u043D\u0430 \u0434\u0440\u0443\u0433\u0438 \u043D\u0430\u0447\u0438\u043D \u0443\u0441\u043F\u043E\u0441\u0442\u0430\u0432\u0435 \u0438\u043B\u0438 \u0438\u0437\u0432\u0440\u0448\u0435 \u043D\u0430\u0448\u0430 \u0437\u0430\u043A\u043E\u043D\u0441\u043A\u0430 \u043F\u0440\u0430\u0432\u0430 \u0438\u043B\u0438 \u0431\u0440\u0430\u043D\u0435 \u043F\u0440\u043E\u0442\u0438\u0432 \u043F\u0440\u0430\u0432\u043D\u0438\u0445 \u0437\u0430\u0445\u0442\u0435\u0432\u0430 \u0438\u043B\u0438 \u0443 \u0441\u043B\u0443\u0447\u0430\u0458\u0443 \u0434\u0430 \u043F\u0440\u0435\u043A\u0440\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u0440\u0448\u0438\u0442\u0435 \u0443\u0433\u043E\u0432\u043E\u0440 \u0441 \u043D\u0430\u043C\u0430. \u041C\u0438 \u045B\u0435\u043C\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0438 \u043E\u0442\u043A\u0440\u0438\u0442\u0438 \u0432\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0430\u043A\u043E \u0432\u0435\u0440\u0443\u0458\u0435\u043C\u043E \u0434\u0430 \u045B\u0435\u0442\u0435 \u043D\u0430\u0448\u0442\u0435\u0442\u0438\u0442\u0438 \u0438\u043C\u043E\u0432\u0438\u043D\u0438 \u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u0438\u043C\u0430 \u043D\u0430\u0448\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435, \u045A\u0435\u043D\u0438\u0445 \u0432\u043B\u0430\u0441\u043D\u0438\u043A\u0430 \u0438\u043B\u0438 \u043E\u0441\u043E\u0431\u0430\u043C\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043B\u0438\u0458\u0435\u043D\u0430\u0442\u0430 \u043D\u0430\u0448\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435. \u041A\u043E\u043D\u0430\u0447\u043D\u043E \u045B\u0435\u043C\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0438\u043B\u0438 \u043E\u0431\u0435\u043B\u043E\u0434\u0430\u043D\u0438\u0442\u0438 \u0432\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0430\u043A\u043E \u0441\u043C\u0430\u0442\u0440\u0430\u043C\u043E \u0434\u0430 \u0458\u0435 \u043D\u0435\u043E\u043F\u0445\u043E\u0434\u043D\u043E \u0434\u0430 \u0440\u0430\u0437\u043C\u0435\u043D\u0438\u043C\u043E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u0443 \u0446\u0438\u0459\u0443 \u0438\u0441\u0442\u0440\u0430\u0433\u0435, \u0441\u043F\u0440\u0435\u0447\u0430\u0432\u0430\u045A\u0430 \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u0443\u0437\u0438\u043C\u0430\u045A\u0430 \u0440\u0430\u0434\u045A\u0438 \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u043D\u0435\u0437\u0430\u043A\u043E\u043D\u0438\u0442\u0438\u043C \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438\u043C\u0430, \u0441\u0443\u043C\u045A\u0430\u043C\u0430 \u0443 \u043F\u0440\u0435\u0432\u0430\u0440\u0443, \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u043A\u043E\u0458\u0435 \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0458\u0430\u043B\u043D\u0435 \u043F\u0440\u0435\u0442\u045A\u0435 \u0444\u0438\u0437\u0438\u0447\u043A\u043E\u0458 \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u0442\u0438 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0435 \u043E\u0441\u043E\u0431\u0435, \u043A\u0440\u0448\u0435\u045A\u0430 \u043D\u0430\u0448\u0438\u0445 \u043F\u0440\u0438\u0445\u0432\u0430\u0442\u0459\u0438\u0432\u0430 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435, \u0412\u0430\u0448\u0438 \u043F\u0440\u0430\u0432\u043D\u0438 \u0441\u0430\u0432\u0435\u0442\u043D\u0438\u0446\u0438, \u043D\u0430 \u0432\u0430\u0448 \u0437\u0430\u0445\u0442\u0435\u0432; \u041D\u0430\u0448\u0438 \u043F\u0440\u043E\u0444\u0435\u0441\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0441\u0430\u0432\u0435\u0442\u043D\u0438\u0446\u0438, \u0440\u0435\u0432\u0438\u0437\u043E\u0440\u0438 \u0438 \u043F\u0440\u0430\u0432\u043D\u0438\u0446\u0438."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041F\u0440\u0435\u043A\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u043D\u043E \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u045A\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u0434 \u043D\u0430\u0441 \u045B\u0435 \u0441\u0435 \u043C\u043E\u0436\u0434\u0430 \u0442\u0440\u0430\u0436\u0438\u0442\u0438 \u0434\u0430 \u043F\u0440\u0435\u043D\u0435\u0441\u0435\u043C\u043E \u0432\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043D\u0430\u0448\u0438\u043C \u043F\u0440\u0443\u0436\u0430\u043E\u0446\u0438\u043C\u0430 \u0443\u0441\u043B\u0443\u0433\u0430 \u0442\u0440\u0435\u045B\u0435 \u0441\u0442\u0440\u0430\u043D\u0435 \u0443 \u0458\u0443\u0440\u0438\u0441\u0434\u0438\u043A\u0446\u0438\u0458\u0430\u043C\u0430 \u0432\u0430\u043D \u0421\u0440\u0431\u0438\u0458\u0438. \u041D\u0430\u0448\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438 / \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0438 \u0443\u0441\u043B\u0443\u0433\u0430 \u043F\u0440\u0443\u0436\u0430\u0458\u0443 \u043D\u0430\u043C \u0445\u043E\u0441\u0442 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0443 \u043F\u043E\u0434\u0440\u0448\u043A\u0443. \u041E\u0432\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438 / \u043F\u0440\u0443\u0436\u0430\u043E\u0446\u0438 \u0443\u0441\u043B\u0443\u0433\u0430 \u043F\u043E\u0434\u043B\u0438\u0458\u0435\u0436\u0443 \u0441\u0442\u0440\u043E\u0433\u043E\u0458 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438 \u043A\u043E\u0458\u0430 \u0448\u0442\u0438\u0442\u0438 \u0432\u0430\u0448\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043E\u0434 \u043D\u0435\u043E\u0432\u043B\u0430\u0448\u0442\u0435\u043D\u0435 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0438\u043B\u0438 \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u045A\u0430 \u0438 \u045A\u0438\u0445\u043E\u0432 \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u0432\u0430\u0448\u0438\u043C \u043B\u0438\u0447\u043D\u0438\u043C \u043F\u043E\u0434\u0430\u0446\u0438\u043C\u0430 \u0458\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0443 \u043C\u0458\u0435\u0440\u0438 \u0443 \u043A\u043E\u0458\u043E\u0458 \u0458\u0435 \u0442\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E \u0437\u0430 \u043E\u0431\u0430\u0432\u0459\u0430\u045A\u0435 \u045A\u0438\u0445\u043E\u0432\u043E\u0433 \u043F\u043E\u0441\u043B\u0430. \u041F\u043E\u0434\u0443\u0437\u0438\u043C\u0430\u043C\u043E \u0441\u0432\u0435 \u0440\u0430\u0437\u0443\u043C\u043D\u0435 \u043A\u043E\u0440\u0430\u043A\u0435 \u0434\u0430 \u043E\u0441\u0438\u0433\u0443\u0440\u0430\u043C\u043E \u0434\u0430 \u0441\u0435 \u043F\u0440\u0443\u0436\u0430\u043E\u0446\u0438 \u0443\u0441\u043B\u0443\u0433\u0430 \u0442\u0440\u0435\u045B\u0435 \u0441\u0442\u0440\u0430\u043D\u0435 \u0441 \u043A\u043E\u0458\u0438\u043C\u0430 \u0441\u0435 \u0431\u0430\u0432\u0438\u043C\u043E \u043E\u0431\u0430\u0432\u0435\u0437\u0443\u0458\u0443 \u043D\u0430 \u0432\u0438\u0441\u043E\u043A\u0435 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0434\u0435 \u0437\u0430\u0448\u0442\u0438\u0442\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0438 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0434\u0440\u0436\u0430\u0432\u0430\u0458\u0443 \u0432\u0430\u0436\u0435\u045B\u0438\u0445 \u043F\u0440\u043E\u043F\u0438\u0441\u0430 \u043E \u0437\u0430\u0448\u0442\u0438\u0442\u0438 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0443 \u045A\u0438\u0445\u043E\u0432\u0438\u043C \u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0438\u043C\u0430. \u0422\u0430\u043A\u0432\u0435 \u043C\u0435\u0440\u0435 \u0441\u0443 \u0458\u0430\u0441\u043D\u043E \u043F\u0440\u043E\u043F\u0438\u0441\u0430\u043D\u0435 \u0443 \u0443\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u043C \u0441\u043F\u043E\u0440\u0430\u0437\u0443\u043C\u0443 \u0438\u0437\u043C\u0435\u0452\u0443 \u043D\u0430\u0441 \u0438 \u043D\u0430\u0448\u0435\u0433 \u043F\u0440\u0443\u0436\u0430\u043E\u0446\u0430 \u0443\u0441\u043B\u0443\u0433\u0430 \u0442\u0440\u0435\u045B\u0435 \u0441\u0442\u0440\u0430\u043D\u0435. \u0423\u0433\u043E\u0432\u043E\u0440\u0438 \u0437\u0430\u0445\u0442\u0435\u0432\u0430\u0458\u0443 \u0434\u0430 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443\u045B\u0438 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440 \u0443\u0441\u043B\u0443\u0433\u0430 \u0438\u0441\u043F\u0443\u045A\u0430\u0432\u0430 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0434\u0435 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u0458\u0435 \u0441\u043C\u043E \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u043B\u0438 \u0437\u0430 \u0441\u0435\u0431\u0435 \u0443 \u0437\u0430\u0448\u0442\u0438\u0442\u0438 \u0432\u0430\u0448\u0438\u0445 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0438 \u0434\u0430 \u043F\u043E\u0448\u0442\u0443\u0458\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443\u045B\u0435 \u043F\u0440\u043E\u043F\u0438\u0441\u0435 \u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u0438 \u0437\u0430\u0448\u0442\u0438\u0442\u0438 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430. \u041B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u045B\u0435\u043C\u043E \u043E\u0442\u043A\u0440\u0438\u0442\u0438 \u043D\u0430\u0448\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438\u043C\u0430 \u0442\u0440\u0435\u045B\u0438\u0445 \u0441\u0442\u0440\u0430\u043D\u0430 \u0441\u0430\u043C\u043E \u0433\u043E\u0440\u0435 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u043C \u0430\u043A\u043E \u0441\u0442\u0435 \u043D\u0430\u043C \u0434\u0430\u043B\u0438 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u0438\u043B\u0438 \u0430\u043A\u043E \u0441\u0435 \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u045A\u0435 \u043E\u0434\u043D\u043E\u0441\u0438 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0438 \u0440\u0430\u0437\u043B\u043E\u0433 \u0437\u0431\u043E\u0433 \u043A\u043E\u0458\u0435\u0433 \u0441\u043C\u043E \u043F\u0440\u0438\u043A\u0443\u043F\u0438\u043B\u0438 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0438 \u0430\u043A\u043E \u043E\u043F\u0440\u0430\u0432\u0434\u0430\u043D\u043E \u043E\u0447\u0435\u043A\u0443\u0458\u0435\u0442\u0435 \u0434\u0430 \u0442\u043E \u0443\u0447\u0438\u043D\u0438\u043C\u043E."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0421\u0443\u043E\u0447\u0430\u0432\u0430\u045A\u0435 \u0441\u0430 \u043D\u0435\u0436\u0435\u0459\u0435\u043D\u0438\u043C \u043B\u0438\u0447\u043D\u0438\u043C \u043F\u043E\u0434\u0430\u0446\u0438\u043C\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0423 \u0441\u043B\u0443\u0447\u0430\u0458\u0443 \u0434\u0430 \u0441\u043C\u043E \u043F\u0440\u0438\u043C\u0438\u043B\u0438 \u0438\u043B\u0438 \u043D\u0430\u0438\u0448\u043B\u0438 \u043D\u0430 \u043D\u0435\u0436\u0435\u0459\u0435\u043D\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043E \u0432\u0430\u043C\u0430, \u043F\u0440\u0435\u0434\u0443\u0437\u0435\u045B\u0435\u043C\u043E \u0441\u0432\u0435 \u0440\u0430\u0437\u0443\u043C\u043D\u0435 \u043A\u043E\u0440\u0430\u043A\u0435 \u0434\u0430 \u0443\u0442\u0432\u0440\u0434\u0438\u043C\u043E \u0434\u0430 \u043B\u0438 \u0441\u0443 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043D\u0435\u043E\u043F\u0445\u043E\u0434\u043D\u0435 \u0437\u0430 \u043D\u0430\u0448\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u0438 \u043F\u043E\u0441\u043B\u043E\u0432\u0430\u045A\u0435 \u0438 \u0434\u0430 \u0441\u0442\u0435 \u0434\u0430\u043B\u0438 \u0441\u0430\u0433\u043B\u0430\u0441\u043D\u043E\u0441\u0442 \u0437\u0430 \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u045A\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430. \u0410\u043A\u043E \u0441\u0435 \u0441\u043C\u0430\u0442\u0440\u0430 \u0434\u0430 \u043D\u0438\u0458\u0435 \u043F\u0440\u0438\u043C\u0435\u0440\u0435\u043D\u043E \u0438 \u0443 \u0441\u043A\u043B\u0430\u0434\u0443 \u0441 \u0432\u0430\u0448\u043E\u043C \u0441\u0430\u0433\u043B\u0430\u0441\u043D\u043E\u0448\u045B\u0443, \u0443\u0442\u0432\u0440\u0434\u0438\u045B\u0435\u043C\u043E \u0434\u0430 \u043B\u0438 \u0441\u0435 \u0434\u043E\u0431\u0438\u0458\u0435\u043D\u0438 \u043F\u043E\u0434\u0430\u0446\u0438 \u043C\u043E\u0440\u0430\u0458\u0443 \u0434\u0435-\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u043E\u0432\u0430\u0442\u0438 / \u0443\u043D\u0438\u0448\u0442\u0438\u0442\u0438 \u0438 \u043F\u0440\u0435\u0434\u0443\u0437\u0435\u0442\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u0435 \u043C\u0435\u0440\u0435 \u0437\u0430 \u0441\u0438\u0433\u0443\u0440\u043D\u043E \u0443\u043D\u0438\u0448\u0442\u0430\u0432\u0430\u045A\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u0430 \u0441\u0438\u0433\u0443\u0440\u043D\u043E\u0441\u0442"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0435\u043D\u0435 \u0443 \u0431\u0430\u0437\u0438 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0447\u0443\u0432\u0430\u043C\u043E \u043D\u0430 \u043D\u0430\u0448\u0438\u043C \u0441\u0435\u0440\u0432\u0435\u0440\u0438\u043C\u0430. \u041F\u0440\u0435\u0434\u0443\u0437\u0438\u043C\u0430\u043C\u043E \u0441\u0432\u0435 \u043C\u0435\u0440\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0440\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043A\u0430\u043A\u043E \u0431\u0438\u0441\u043C\u043E \u043E\u0431\u0435\u0437\u0431\u0435\u0434\u0438\u043B\u0438 \u0434\u0430 \u043D\u0430\u0448\u0438 \u0440\u0430\u0447\u0443\u043D\u0430\u0440\u0438 \u0438\u043C\u0430\u0458\u0443 \u0430\u0434\u0435\u043A\u0432\u0430\u0442\u043D\u0435 \u043C\u0435\u0440\u0435 \u0437\u0430\u0448\u0442\u0438\u0442\u0435 (\u043A\u0430\u043E \u0448\u0442\u043E \u0441\u0443 \u0437\u0430\u0448\u0442\u0438\u0442\u043D\u0438 \u0437\u0438\u0434, \u0441\u0438\u0433\u0443\u0440\u043D\u043E \u0440\u0430\u0434\u043D\u043E \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0435 \u0438 \u0440\u0430\u0434\u043D\u0438 \u0442\u043E\u043A\u043E\u0432\u0438, \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u0441\u0435\u0440\u0432\u0435\u0440\u0438, \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u043D\u0435 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0458\u0435 \u0438\u0442\u0434.) \u0414\u0430 \u0431\u0438 \u0441\u0435 \u0437\u0430\u0448\u0442\u0438\u0442\u0438\u043B\u0438 \u043E\u0434 \u0433\u0443\u0431\u0438\u0442\u043A\u0430, \u0437\u043B\u043E\u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0443 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435. \u0411\u0435\u0437 \u043E\u0431\u0437\u0438\u0440\u0430 \u043D\u0430 \u0442\u0430\u043A\u0432\u0435 \u043C\u0435\u0440\u0435, \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0433\u0430\u0440\u0430\u043D\u0442\u043E\u0432\u0430\u0442\u0438 \u0434\u0430 \u045B\u0435 \u043C\u0435\u0440\u0435 \u0437\u0430\u0448\u0442\u0438\u0442\u0435 \u0441\u043F\u0440\u0435\u0447\u0438\u0442\u0438 \u0438\u043B\u0435\u0433\u0430\u043B\u043D\u0438 \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u043D\u0430\u0448\u0438\u043C \u0440\u0430\u0447\u0443\u043D\u0430\u0440\u0438\u043C\u0430 \u0438 \u043F\u043E\u0458\u0435\u0434\u0438\u043D\u0430\u0447\u043D\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u045A\u0438\u043C\u0430 \u0443\u043A\u0440\u0430\u0434\u0435\u043D\u0435 \u0438\u043B\u0438 \u0438\u0437\u043C\u0435\u045A\u0435\u043D\u0435."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0411\u0435\u0436\u0438\u0447\u043D\u0435 \u0430\u0434\u0440\u0435\u0441\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0410\u043A\u043E \u0458\u0435 \u0430\u0434\u0440\u0435\u0441\u0430 \u0435-\u043F\u043E\u0448\u0442\u0435 \u043A\u043E\u0458\u0443 \u043D\u0430\u043C \u043D\u0430\u043C \u0434\u0430\u0442\u0435 \u0431\u0435\u0436\u0438\u0447\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0435-\u043F\u043E\u0448\u0442\u0435, \u043F\u0440\u0438\u0441\u0442\u0430\u0458\u0435\u0442\u0435 \u0434\u0430 \u043F\u0440\u0438\u043C\u0430\u0442\u0435 \u043F\u043E\u0440\u0443\u043A\u0435 \u043D\u0430 \u0442\u0430\u043A\u0432\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u043E\u0434 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435 \u0438\u043B\u0438 \u045A\u0435\u043D\u0438\u0445 \u043F\u043E\u0441\u043B\u043E\u0432\u043D\u0438\u0445 \u0441\u0430\u0440\u0430\u0434\u043D\u0438\u043A\u0430 (\u043E\u0441\u0438\u043C \u0438 \u0441\u0432\u0435 \u0434\u043E\u043A \u043D\u0438\u0441\u0442\u0435 \u043E\u0434\u043B\u0443\u0447\u0438\u043B\u0438 \u0434\u0430 \u0442\u0430\u043A\u0432\u0435 \u043F\u043E\u0440\u0443\u043A\u0435 \u043D\u0435 \u043F\u0440\u0438\u043C\u0430\u0442\u0435 \u0441\u043B\u0435\u0434\u0435\u045B\u0438 \u0443\u043F\u0443\u0442\u0441\u0442\u0432\u0430 \u0443 \u043E\u0434\u0458\u0430\u0432\u0438\u0442\u0435 \u0434\u0435\u043E \u043E\u0432\u0435 \u0441\u043C\u0435\u0440\u043D\u0438\u0446\u0435). \u0421\u0445\u0432\u0430\u045B\u0430\u0442\u0435 \u0434\u0430 \u0441\u0435 \u043D\u0430 \u043E\u0432\u0435 \u043F\u043E\u0440\u0443\u043A\u0435 \u043E\u0434\u043D\u043E\u0441\u0435 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0434\u043D\u0435 \u0446\u0435\u043D\u0435 \u0432\u0430\u0448\u0435\u0433 \u0431\u0435\u0436\u0438\u0447\u043D\u043E\u0433 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0430. \u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0459\u0430\u0442\u0435 \u0434\u0430 \u0441\u0442\u0435 \u0432\u043B\u0430\u0441\u043D\u0438\u043A \u0438\u043B\u0438 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0431\u0435\u0436\u0438\u0447\u043D\u043E\u0433 \u0443\u0440\u0435\u0452\u0430\u0458\u0430 \u043D\u0430 \u043A\u043E\u0458\u0435\u043C \u045B\u0435 \u0441\u0435 \u043F\u043E\u0440\u0443\u043A\u0435 \u043F\u0440\u0438\u043C\u0430\u0442\u0438 \u0438 \u0434\u0430 \u0441\u0442\u0435 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438 \u0434\u0430 \u043E\u0434\u043E\u0431\u0440\u0430\u0432\u0430\u0442\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443\u045B\u0435 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0410\u043A\u043E \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0432\u0438\u0448\u0435 \u043D\u0435 \u043F\u0440\u0438\u043C\u0430\u0442\u0435 \u043D\u0430\u0448\u0435 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u0435, \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0448\u043A\u0435 \u0438 \u043F\u0440\u043E\u043C\u043E\u0442\u0438\u0432\u043D\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0458\u0430\u043B\u0435, \u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0441\u0442 '\u0438\u0441\u043A\u0459\u0443\u0447\u0438\u0432\u0430\u045A\u0430' \u0432\u0430\u043C \u0458\u0435 \u043D\u0430 \u0440\u0430\u0441\u043F\u043E\u043B\u0430\u0433\u0430\u045A\u0443 \u0443 \u0441\u0432\u0430\u043A\u043E\u043C \u0442\u0440\u0435\u043D\u0443\u0442\u043A\u0443."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0421\u0435\u0440\u0432\u0438\u0441 \u043A\u0440\u0430\u0442\u043A\u0438\u0445 \u043F\u043E\u0440\u0443\u043A\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041C\u043E\u0436\u0435\u043C\u043E \u0443\u0447\u0438\u043D\u0438\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u043C \u0443\u0441\u043B\u0443\u0433\u0443 \u043F\u0443\u0442\u0435\u043C \u043A\u043E\u0458\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u0438\u043C\u0430\u0442\u0438 \u043F\u043E\u0440\u0443\u043A\u0435 \u043D\u0430 \u0441\u0432\u043E\u043C \u0431\u0435\u0436\u0438\u0447\u043D\u043E\u043C \u0443\u0440\u0435\u0452\u0430\u0458\u0443 \u043F\u0443\u0442\u0435\u043C \u0443\u0441\u043B\u0443\u0433\u0435 \u043A\u0440\u0430\u0442\u043A\u0438\u0445 \u043F\u043E\u0440\u0443\u043A\u0430 (\u201E\u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u0430\u201C). \u041F\u043E\u0434\u0430\u0446\u0438 \u0434\u043E\u0431\u0438\u0458\u0435\u043D\u0438 \u043E\u0434 \u0432\u0430\u0441 \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u043E\u0432\u043E\u043C \u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u043E\u043C \u043C\u043E\u0433\u0443 \u0434\u0430 \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443 \u0432\u0430\u0448\u0435 \u0438\u043C\u0435, \u0430\u0434\u0440\u0435\u0441\u0443, \u0431\u0440\u043E\u0458 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u0438\u043C\u0435 \u0432\u0430\u0448\u0435\u0433 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0430 \u0438 \u0434\u0430\u0442\u0443\u043C, \u0432\u0440\u0435\u043C\u0435 \u0438 \u0441\u0430\u0434\u0440\u0436\u0430\u0458 \u0432\u0430\u0448\u0438\u0445 \u043F\u043E\u0440\u0443\u043A\u0430. \u0418\u0437\u0458\u0430\u0432\u0459\u0443\u0458\u0435\u0442\u0435 \u0434\u0430 \u0438\u043C\u0430\u0442\u0435 18 \u0433\u043E\u0434\u0438\u043D\u0430 \u0438 \u0434\u0430 \u0441\u0442\u0435 \u0432\u043B\u0430\u0441\u043D\u0438\u043A \u0438\u043B\u0438 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0431\u0435\u0436\u0438\u0447\u043D\u043E\u0433 \u0443\u0440\u0435\u0452\u0430\u0458\u0430 \u043D\u0430 \u043A\u043E\u0458\u0435\u043C \u045B\u0435 \u0441\u0435 \u043F\u0440\u0438\u043C\u0438\u0442\u0438 \u043F\u043E\u0440\u0443\u043A\u0435 \u0438 \u0434\u0430 \u0441\u0442\u0435 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438 \u0434\u0430 \u043E\u0434\u043E\u0431\u0440\u0430\u0432\u0430\u0442\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443\u045B\u0435 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435. \u0423\u0437 \u0431\u0438\u043B\u043E \u043A\u0430\u043A\u0432\u0443 \u043D\u0430\u043A\u043D\u0430\u0434\u0443 \u043E \u043A\u043E\u0458\u043E\u0458 \u0441\u0442\u0435 \u043E\u0431\u0430\u0432\u0435\u0448\u0442\u0435\u043D\u0438, \u043D\u0430 \u043D\u0430\u0448\u0443 \u043F\u043E\u0442\u0432\u0440\u0434\u0443 \u0438 \u0441\u0432\u0443 \u043D\u0430\u0440\u0435\u0434\u043D\u0443 \u0421\u041C\u0421 \u043F\u0440\u0435\u043F\u0438\u0441\u043A\u0443 \u0432\u0430\u0436\u0435 \u0438 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0434\u043D\u0435 \u0446\u0435\u043D\u0435 \u0441\u043B\u0430\u045A\u0430 \u043F\u043E\u0440\u0443\u043A\u0430 \u0432\u0430\u0448\u0435\u0433 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0430. \u0421\u0432\u0435 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435 \u043D\u0430\u043F\u043B\u0430\u045B\u0443\u0458\u0435 \u0438 \u043D\u0430\u043F\u043B\u0430\u045B\u0443\u0458\u0435 \u0432\u0430\u0448 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043D\u0435\u045B\u0435 \u0431\u0438\u0442\u0438 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u0430 \u0437\u0430 \u043A\u0430\u0448\u045A\u0435\u045A\u0435 \u0443 \u043F\u0440\u0438\u0458\u0435\u043C\u0443 \u0431\u0438\u043B\u043E \u043A\u0430\u043A\u0432\u0438\u0445 \u0421\u041C\u0421 \u043F\u043E\u0440\u0443\u043A\u0430, \u0458\u0435\u0440 \u0438\u0441\u043F\u043E\u0440\u0443\u043A\u0430 \u043F\u043E\u0434\u043B\u0435\u0436\u0435 \u0435\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u043C \u043F\u0440\u0435\u043D\u043E\u0441\u0443 \u043E\u0434 \u0432\u0430\u0448\u0435\u0433 \u043C\u0440\u0435\u0436\u043D\u043E\u0433 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0430. \u0423\u0441\u043B\u0443\u0433\u0435 \u0421\u041C\u0421 \u043F\u043E\u0440\u0443\u043A\u0430 \u043F\u0440\u0443\u0436\u0430\u0458\u0443 \u0441\u0435 \u043D\u0430 \u0410\u0421 \u0410\u0421 \u0418\u0421 \u043E\u0441\u043D\u043E\u0432\u0438. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0442\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0436\u0435 \u0434\u043E\u0431\u0438\u0442\u0438 \u0434\u0430\u0442\u0443\u043C, \u0432\u0440\u0435\u043C\u0435 \u0438 \u0441\u0430\u0434\u0440\u0436\u0430\u0458 \u0432\u0430\u0448\u0438\u0445 \u043F\u043E\u0440\u0443\u043A\u0430 \u0442\u043E\u043A\u043E\u043C \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430 \u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u0435. \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u0434\u043E\u0431\u0438\u0458\u0435\u043C\u043E \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u043D\u0430\u0448\u043E\u043C \u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u043E\u043C \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u045B\u0435\u043C\u043E \u0443 \u0441\u043A\u043B\u0430\u0434\u0443 \u0441\u0430 \u043E\u0432\u043E\u043C \u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u043C \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438. \u0410\u043A\u043E \u0432\u0430\u043C \u0441\u0435 \u043D\u0430 \u0444\u0430\u043A\u0442\u0443\u0440\u0438 \u0437\u0430 \u0431\u0435\u0436\u0438\u0447\u043D\u0438 \u0440\u0430\u0447\u0443\u043D \u043D\u0430\u043F\u043B\u0430\u0442\u0438 \u043D\u0430\u043A\u043D\u0430\u0434\u0430, \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0430\u0448\u0435\u043C \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0443 \u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443\u045B\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u0443 \u0432\u0435\u0437\u0438 \u0441 \u0442\u0438\u043C. \u0412\u0430\u0448 \u0431\u0435\u0436\u0438\u0447\u043D\u0438 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440 \u0438 \u0434\u0440\u0443\u0433\u0438 \u043F\u0440\u0443\u0436\u0430\u043E\u0446\u0438 \u0443\u0441\u043B\u0443\u0433\u0430 \u0442\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0433\u0443 \u0434\u0430 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u0458\u0443 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043E \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0443 \u0432\u0430\u0448\u0435\u0433 \u0431\u0435\u0436\u0438\u0447\u043D\u043E\u0433 \u0443\u0440\u0435\u0452\u0430\u0458\u0430, \u0430 \u045A\u0438\u0445\u043E\u0432\u0443 \u043F\u0440\u0430\u043A\u0441\u0443 \u0440\u0435\u0433\u0443\u043B\u0438\u0448\u0435 \u045A\u0438\u0445\u043E\u0432\u0430 \u0441\u043E\u043F\u0441\u0442\u0432\u0435\u043D\u0430 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430. \u041F\u0440\u0438\u0437\u043D\u0430\u0458\u0435\u0442\u0435 \u0438 \u0441\u043B\u0430\u0436\u0435\u0442\u0435 \u0441\u0435 \u0434\u0430 \u0441\u0435 \u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u0430 \u043F\u0440\u0443\u0436\u0430 \u043F\u0443\u0442\u0435\u043C \u0431\u0435\u0436\u0438\u0447\u043D\u0438\u0445 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043A\u043E\u0458\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0435 \u0440\u0430\u0434\u0438\u043E (\u0438 \u0434\u0440\u0443\u0433\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430) \u0437\u0430 \u043F\u0440\u0435\u043D\u043E\u0448\u0435\u045A\u0435 \u043A\u043E\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u0458\u0430 \u043F\u0440\u0435\u043A\u043E \u0441\u043B\u043E\u0436\u0435\u043D\u0438\u0445 \u043C\u0440\u0435\u0436\u0430. \u041D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0443\u0458\u0435\u043C\u043E \u0434\u0430 \u045B\u0435 \u0432\u0430\u0448\u0430 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u0435 \u0431\u0438\u0442\u0438 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0430 \u0438\u043B\u0438 \u0441\u0438\u0433\u0443\u0440\u043D\u0430, \u0438 \u043D\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u043C\u043E \u0432\u0430\u043C \u0437\u0430 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u0430\u043A \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u0441\u0438\u0433\u0443\u0440\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u0458\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u0436\u0438\u0432\u0435\u0442\u0438. \u041F\u043E\u0442\u043F\u0443\u043D\u043E \u0441\u0442\u0435 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u0438 \u0437\u0430 \u043F\u0440\u0435\u0434\u0443\u0437\u0438\u043C\u0430\u045A\u0435 \u043C\u0435\u0440\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0440\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438 \u043E\u0431\u0435\u0437\u0431\u0435\u0452\u0438\u0432\u0430\u045A\u0435 \u043C\u0435\u0440\u0430 \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u0458\u0435 \u043D\u0430\u0458\u0431\u043E\u0459\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u0458\u0438 \u0438 \u043D\u0430\u043C\u0435\u043D\u0441\u043A\u043E\u0458 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0438 \u0421\u041C\u0421 \u0443\u0441\u043B\u0443\u0433\u0435. \u0422\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u0438\u0442\u0438 \u0441\u0430\u0434\u0440\u0436\u0430\u0458\u0443 \u0432\u0430\u0448\u0435\u0433 \u043D\u0430\u043B\u043E\u0433\u0430 \u0438 \u0431\u0435\u0436\u0438\u0447\u043D\u043E\u0433 \u043D\u0430\u043B\u043E\u0433\u0430 \u043A\u043E\u0434 \u0432\u0430\u0448\u0435\u0433 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0430 \u0443 \u0441\u0432\u0440\u0445\u0443 \u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u045A\u0430 \u0438 \u0440\u0435\u0448\u0430\u0432\u0430\u045A\u0430 \u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0438\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0438 \u0436\u0430\u043B\u0431\u0438 \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0430. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043C\u043E\u0436\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0437\u0430 \u043F\u0440\u0443\u0436\u0430\u045A\u0435 \u0443\u0441\u043B\u0443\u0433\u0430 \u043A\u043E\u0458\u0435 \u0441\u0442 \u0435 \u0442\u0440\u0430\u0436\u0438\u043B\u0438, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438 \u0443\u0441\u043B\u0443\u0433\u0435 \u043A\u043E\u0458\u0435 \u043F\u0440\u0438\u043A\u0430\u0437\u0443\u0458\u0443 \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438 \u0441\u0430\u0434\u0440\u0436\u0430\u0458 \u0438 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0435. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0442\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0437\u0430 \u0440\u0435\u0432\u0438\u0437\u0438\u0458\u0443, \u0438\u0441\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u045A\u0435 \u0438 \u0430\u043D\u0430\u043B\u0438\u0437\u0443 \u0434\u0430 \u0431\u0438 \u0440\u0430\u0434\u0438\u043B\u0430 \u0438 \u043F\u043E\u0431\u043E\u0459\u0448\u0430\u043B\u0430 \u043D\u0430\u0448\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0458\u0435 \u0438 \u0443\u0441\u043B\u0443\u0433\u0435. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043C\u043E\u0436\u0435 \u0434\u0435\u043B\u0438\u0442\u0438 \u0437\u0431\u0438\u0440\u043D\u0435 \u0438 \u043D\u0435\u043E\u0441\u043E\u0431\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0441\u0430 \u043F\u043E\u0441\u043B\u043E\u0432\u043D\u0438\u043C \u0441\u0430\u0440\u0430\u0434\u043D\u0438\u0446\u0438\u043C\u0430 \u0442\u0440\u0435\u045B\u0438\u0445 \u043B\u0438\u0446\u0430. \u041A\u0430\u0434\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u043F\u043E\u0441\u043B\u043E\u0432\u043D\u0435 \u0441\u0430\u0440\u0430\u0434\u043D\u0438\u043A\u0435 \u0434\u0430 \u0431\u0438 \u043F\u043E\u043C\u043E\u0433\u043B\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0438 \u0443 \u043E\u0431\u0440\u0430\u0434\u0438 \u0432\u0430\u0448\u0438\u0445 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430, \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0437\u0430\u0445\u0442\u0435\u0432\u0430 \u0434\u0430 \u0441\u0435 \u043E\u043D\u0438 \u043F\u0440\u0438\u0434\u0440\u0436\u0430\u0432\u0430\u0458\u0443 \u043D\u0430\u0448\u0438\u0445 \u0441\u043C\u0435\u0440\u043D\u0438\u0446\u0430 \u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u0438 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0435 \u0434\u0440\u0443\u0433\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430\u0458\u0443\u045B\u0435 \u043C\u0435\u0440\u0435 \u043F\u043E\u0432\u0435\u0440\u0459\u0438\u0432\u043E\u0441\u0442\u0438 \u0438 \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u0442\u0438. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043C\u043E\u0436\u0435 \u0442\u0430\u043A\u043E\u0452\u0435 \u0434\u0435\u043B\u0438\u0442\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u0441\u0430 \u0442\u0440\u0435\u045B\u0438\u043C \u043B\u0438\u0446\u0438\u043C\u0430, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438, \u0430\u043B\u0438 \u043D\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0430\u0432\u0430\u0458\u0443\u045B\u0438 \u0441\u0435 \u043D\u0430 \u045A\u0438\u0445, \u043D\u0430 \u043F\u043E\u0448\u0442\u043E\u0432\u0430\u045A\u0435 \u0437\u0430\u043A\u043E\u043D\u0441\u043A\u043E\u0433 \u043F\u043E\u0441\u0442\u0443\u043F\u043A\u0430, \u0441\u043F\u0440\u0435\u0447\u0430\u0432\u0430\u045A\u0435 \u043F\u0440\u0435\u0432\u0430\u0440\u0435 \u0438\u043B\u0438 \u043D\u0435\u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0435 \u0448\u0442\u0435\u0442\u0435 \u0438 \u043E\u0441\u0438\u0433\u0443\u0440\u0430\u045A\u0435 \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u0442\u0438 \u043D\u0430\u0448\u0435 \u043C\u0440\u0435\u0436\u0435 \u0438 \u0443\u0441\u043B\u0443\u0433\u0430. \u041C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0443\u043A\u043B\u043E\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0438\u0437 \u0431\u0430\u0437\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435. \u0410\u043A\u043E \u0443\u043A\u043B\u043E\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0438\u0437 \u0431\u0430\u0437\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435, \u043F\u0440\u0435\u0434\u0443\u0437\u0435\u045B\u0435 \u0438\u0445 \u0432\u0438\u0448\u0435 \u043D\u0435\u045B\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0443 \u0441\u0435\u043A\u0443\u043D\u0434\u0430\u0440\u043D\u0435 \u0441\u0432\u0440\u0445\u0435, \u043E\u0442\u043A\u0440\u0438\u045B\u0435 \u0438\u0445 \u0442\u0440\u0435\u045B\u0438\u043C \u043B\u0438\u0446\u0438\u043C\u0430 \u0438\u043B\u0438 \u0438\u0445 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0438\u043B\u0438 \u0442\u0440\u0435\u045B\u0435 \u0441\u0442\u0440\u0430\u043D\u0435 \u043A\u0430\u043A\u043E \u0431\u0438 \u0432\u0430\u043C \u043F\u043E\u0441\u043B\u0430\u043B\u0438 \u043F\u0440\u043E\u043C\u043E\u0442\u0438\u0432\u043D\u0443 \u043A\u043E\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0446\u0438\u0458\u0443. \u041C\u043E\u0436\u0435\u0442\u0435 \u0443\u043A\u043B\u043E\u043D\u0438\u0442\u0438 \u0441\u0432\u043E\u0458\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0441\u043B\u0430\u045A\u0435\u043C \u043F\u0438\u0441\u043C\u0435\u043D\u043E\u0433 \u0437\u0430\u0445\u0442\u0435\u0432\u0430 \u043F\u0443\u0442\u0435\u043C \u0435-\u043C\u0430\u0438\u043B\u0430 \u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0443: sammedia.rs@silverlines.info"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u0440\u0438\u0441\u0442\u0443\u043F \u0438 \u0438\u0441\u043F\u0440\u0430\u0432\u043A\u0430 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430"
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041F\u0440\u0438\u0441\u0442\u0443\u043F"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0418\u043C\u0430\u0442\u0435 \u043F\u0440\u0430\u0432\u043E \u0434\u0430 \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u0438\u0442\u0435 \u043B\u0438\u0447\u043D\u0438\u043C \u043F\u043E\u0434\u0430\u0446\u0438\u043C\u0430 \u043A\u043E\u0458\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0438\u043C\u0430\u0442\u0438 \u043E \u0432\u0430\u043C\u0430 \u0431\u0438\u043B\u043E \u043A\u0430\u0434\u0430:"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438\u0440\u0430\u0458\u0442\u0435 \u043D\u0430\u0441 \u043F\u0443\u0442\u0435\u043C \u0435-\u043C\u0430\u0438\u043B\u0430 \u0437\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0443 \u043F\u043E\u0434\u0440\u0448\u043A\u0443 \u043D\u0430 sammedia.rs@silverlines.info \u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438\u0440\u0430\u045A\u0435 \u0441\u043B\u0443\u0436\u0431\u0435\u043D\u0438\u043A\u0430 \u0437\u0430 \u0437\u0430\u0448\u0442\u0438\u0442\u0443 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u043F\u0443\u0442\u0435\u043C \u0435-\u043F\u043E\u0448\u0442\u0435 \u0438\u043B\u0438 \u043F\u043E\u0448\u0442\u0435;"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u043E\u0441\u0442\u043E\u0458\u0435 \u043E\u043A\u043E\u043B\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u043C\u0430 \u0432\u0430\u0436\u0435\u045B\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u0438\u043C\u0430 \u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438 \u0443 \u043A\u043E\u0458\u0438\u043C\u0430 \u0432\u0430\u043C \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0434\u0430\u0442\u0438 \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u043B\u0438\u0447\u043D\u0438\u043C \u043F\u043E\u0434\u0430\u0446\u0438\u043C\u0430 \u043A\u043E\u0458\u0435 \u0438\u043C\u0430\u043C\u043E \u043E \u0432\u0430\u043C\u0430. \u041D\u0430 \u043F\u0440\u0438\u043C\u0435\u0440, \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0430\u043C \u0434\u0430\u0442\u0438 \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u0430\u043A\u043E \u0431\u0438 \u043D\u0435\u0440\u0430\u0437\u0443\u043C\u043D\u043E \u0443\u0442\u0438\u0446\u0430\u043E \u043D\u0430 \u0442\u0443\u0452\u0443 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442 \u0438\u043B\u0438 \u0430\u043A\u043E \u0431\u0438 \u0432\u0430\u043C \u043F\u0440\u0443\u0436\u0438\u043E \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u043E\u0437\u0431\u0438\u0459\u043D\u043E \u0443\u0433\u0440\u043E\u0436\u0430\u0432\u0430\u043E \u043D\u0435\u0447\u0438\u0458\u0438 \u0436\u0438\u0432\u043E\u0442, \u0437\u0434\u0440\u0430\u0432\u0459\u0435 \u0438 \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u0442."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u0440\u0438\u0441\u0442\u0443\u043F \u043B\u0438\u0447\u043D\u0438\u043C \u043F\u043E\u0434\u0430\u0446\u0438\u043C\u0430 \u043A\u043E\u0458\u0435 \u0438\u043C\u0430\u043C\u043E \u043E \u0432\u0430\u043C\u0430 \u0443\u0433\u043B\u0430\u0432\u043D\u043E\u043C \u043D\u0435\u043C\u0430 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0430, \u043E\u0441\u0438\u043C \u0430\u043A\u043E \u0437\u0430\u0445\u0442\u0435\u0432 \u043D\u0438\u0458\u0435 \u0441\u043B\u043E\u0436\u0435\u043D \u0438\u043B\u0438 \u043D\u0435 \u0437\u0430\u0445\u0442\u0438\u0458\u0435\u0432\u0430 \u043C\u043D\u043E\u0433\u043E \u0440\u0435\u0441\u0443\u0440\u0441\u0430. \u0410\u043A\u043E \u0441\u0435 \u043D\u0430\u043F\u043B\u0430\u0442\u0438, \u0431\u0438\u045B\u0435 \u0440\u0430\u0437\u0443\u043C\u043D\u043E \u0438 \u043E\u0431\u0430\u0432\u0435\u0441\u0442\u0438\u045B\u0435\u043C\u043E \u0432\u0430\u0441 \u0448\u0442\u0430 \u045B\u0435 \u0431\u0438\u0442\u0438 \u0442\u0430\u043A\u043E \u0434\u0430 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u043D\u0430 \u0442\u043E \u043F\u0440\u0435 \u043D\u0435\u0433\u043E \u0448\u0442\u043E \u043D\u0430\u0441\u0442\u0430\u0432\u0438\u043C\u043E"
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0418\u0441\u043F\u0440\u0430\u0432\u043A\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u0440\u0435\u0434\u0443\u0437\u0435\u045B\u0435\u043C\u043E \u0441\u0432\u0435 \u0440\u0430\u0437\u0443\u043C\u043D\u0435 \u043A\u043E\u0440\u0430\u043A\u0435 \u0434\u0430 \u043E\u0441\u0438\u0433\u0443\u0440\u0430\u043C\u043E \u0434\u0430 \u0441\u0443 \u043B\u0438\u0447\u043D\u0438 \u043F\u043E\u0434\u0430\u0446\u0438 \u043A\u043E\u0458\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E, \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u043C\u043E \u0438 \u043E\u0442\u043A\u0440\u0438\u0432\u0430\u043C\u043E \u0442\u0430\u0447\u043D\u0438, \u0442\u0430\u0447\u043D\u0438 \u0438 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u043D\u0438. \u0414\u0430 \u0431\u0438\u0441\u043C\u043E \u043E\u0441\u0438\u0433\u0443\u0440\u0430\u043B\u0438 \u045A\u0435\u0433\u043E\u0432\u0443 \u0442\u0430\u0447\u043D\u043E\u0441\u0442, \u043E\u0445\u0440\u0430\u0431\u0440\u0443\u0458\u0435\u043C\u043E \u0432\u0430\u0441 \u0434\u0430 \u043D\u0430\u0441 \u043E\u0431\u0430\u0432\u0435\u0441\u0442\u0438\u0442\u0435 \u043E \u0441\u0432\u0438\u043C \u043F\u0440\u043E\u043C\u0435\u043D\u0430\u043C\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430 \u043A\u043E\u0458\u0435 \u0431\u0438\u0441\u043C\u043E \u043C\u043E\u0433\u043B\u0438 \u0434\u0430 \u0438\u043C\u0430\u043C\u043E. \u041E\u0431\u0430\u0432\u0435\u0441\u0442\u0438\u0442\u0435 \u043D\u0430\u0441:"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0410\u043A\u043E \u043F\u043E\u0441\u0442\u043E\u0458\u0435 \u0433\u0440\u0435\u0448\u043A\u0435 \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u043A\u043E\u0458\u0435 \u0438\u043C\u0430\u043C\u043E; \u041E\u0431\u0430\u0432\u0435\u0448\u0442\u0430\u0432\u0430\u0458\u0442\u0435 \u043D\u0430\u0441 \u043E \u0438\u0437\u043C\u0435\u043D\u0430\u043C\u0430 \u0443 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u043A\u043E\u0458\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0438\u043C\u0430\u0442\u0438 \u043E \u0432\u0430\u043C\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u0440\u0435\u0434\u0443\u0437\u0435\u045B\u0435\u043C\u043E \u0441\u0432\u0435 \u0440\u0430\u0437\u0443\u043C\u043D\u0435 \u043A\u043E\u0440\u0430\u043A\u0435 \u0434\u0430 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u043C\u043E \u0432\u0430\u0448\u0435 \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0443 \u0440\u043E\u043A\u0443 \u043E\u0434 30 \u0434\u0430\u043D\u0430 \u043E\u0434 \u043F\u043E\u0434\u043D\u043E\u0448\u0435\u045A\u0430 \u0437\u0430\u0445\u0442\u0435\u0432\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "Cookies"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043C\u043E\u0436\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435 \u0438 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0458\u0443 \u0432\u0435\u0431\u043C\u0430\u0441\u0442\u0435\u0440\u0430 \u0434\u0430 \u043F\u043E\u0432\u0435\u0436\u0435 \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043F\u043E\u0432\u0435\u0437\u0430\u043D\u0435 \u0441\u0430 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043E\u043C \u043E \u0432\u0430\u043C\u0430. \u041F\u043E\u0440\u0435\u0434 \u0442\u043E\u0433\u0430, \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043C\u043E\u0436\u0435 \u0443 \u0431\u0443\u0434\u0443\u045B\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0434\u0440\u0443\u0433\u0435 \u043D\u043E\u0432\u0435 \u0438 \u0435\u0432\u043E\u043B\u0443\u0438\u0440\u0430\u0458\u0443\u045B\u0435 \u0438\u0437\u0432\u043E\u0440\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430. (\u0430) Cookies. \u201ECookies\u201C \u0441\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u0458\u0430 \u0441\u043E\u0444\u0442\u0432\u0435\u0440\u0430 \u0432\u0430\u0448\u0435\u0433 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0447\u0430. \u0410\u043A\u043E \u0458\u0435 \u043E\u043C\u043E\u0433\u0443\u045B\u0435\u043D\u043E, \u043D\u0430 \u0432\u0430\u0448 \u0440\u0430\u0447\u0443\u043D\u0430\u0440 \u043C\u043E\u0436\u0435\u043C\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435 \u043A\u043E\u0458\u0438 \u043C\u043E\u0433\u0443 \u043F\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0438 \u043C\u0430\u043B\u0435 \u043A\u043E\u043B\u0438\u0447\u0438\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043E \u0432\u0430\u0448\u043E\u0458 \u043F\u043E\u0441\u0435\u0442\u0438 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u043E\u0458 \u043E\u0434 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0430 \u043D\u0430\u0448\u0438\u043C \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u0437\u0430 \u043C\u043E\u0431\u0438\u043B\u043D\u0435 \u0443\u0440\u0435\u0452\u0430\u0458\u0435. Cookies \u043D\u0430\u043C \u043F\u043E\u043C\u0430\u0436\u0443 \u0443 \u043F\u0440\u0430\u045B\u0435\u045A\u0443 \u043A\u043E\u0458\u0430 \u0441\u0435 \u043E\u0434 \u043D\u0430\u0448\u0438\u0445 \u0444\u0443\u043D\u043A\u0446\u0438\u0458\u0430 \u043D\u0430\u0458\u0432\u0438\u0448\u0435 \u043E\u0431\u0440\u0430\u045B\u0430 \u0432\u0430\u043C\u0430 \u0438 \u043A\u043E\u0458\u0438 \u0441\u0430\u0434\u0440\u0436\u0430\u0458 \u0441\u0442\u0435 \u043C\u043E\u0436\u0434\u0430 \u0432\u0438\u0434\u0435\u043B\u0438 \u0443 \u043F\u0440\u043E\u0448\u043B\u0438\u043C \u043F\u043E\u0441\u0435\u0442\u0430\u043C\u0430. \u041A\u0430\u0434\u0430 \u043F\u043E\u043D\u043E\u0432\u043E \u043F\u043E\u0441\u0435\u0442\u0438\u0442\u0435 \u043E\u0432\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, cookies \u043D\u0430\u043C \u043C\u043E\u0433\u0443 \u043E\u043C\u043E\u0433\u0443\u045B\u0438\u0442\u0438 \u0434\u0430 \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0434\u0438\u043C\u043E \u043D\u0430\u0448 \u0441\u0430\u0434\u0440\u0436\u0430\u0458 \u0443 \u0441\u043A\u043B\u0430\u0434\u0443 \u0441\u0430 \u0432\u0430\u0448\u0438\u043C \u0436\u0435\u0459\u0430\u043C\u0430. \u041C\u0438 \u043C\u043E\u0436\u0435\u043C\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435 \u0437\u0430: \u043F\u0440\u0430\u045B\u0435\u045A\u0435 \u0431\u0440\u043E\u0458\u0430 \u043F\u043E\u0432\u0440\u0430\u0442\u043D\u0438\u0445 \u043F\u043E\u0441\u0435\u0442\u0430 \u043E\u0432\u043E\u0458 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438; \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u045A\u0435 \u0438 \u0438\u0437\u0432\u0435\u0448\u0442\u0430\u0432\u0430\u045A\u0435 \u0437\u0431\u0438\u0440\u043D\u0438\u0445, \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u0447\u043A\u0438\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430 \u043E \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0443 \u0432\u0435\u0431 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430; \u0438\u0441\u043F\u043E\u0440\u0443\u0447\u0443\u0458\u0443 \u0432\u0430\u043C \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0438 \u0441\u0430\u0434\u0440\u0436\u0430\u0458 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0443 \u0432\u0430\u0448\u0438\u0445 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u045A\u0430 \u0438\u043B\u0438 \u043F\u0440\u043E\u0448\u043B\u0435 \u0438\u0441\u0442\u043E\u0440\u0438\u0458\u0435 \u0433\u043B\u0435\u0434\u0430\u045A\u0430; \u0441\u0430\u0447\u0443\u0432\u0430\u0458\u0442\u0435 \u043B\u043E\u0437\u0438\u043D\u043A\u0443 \u0440\u0430\u0434\u0438 \u043B\u0430\u043A\u0448\u0435\u0433 \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u0430 \u043D\u0430\u0448\u043E\u0458 \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0438. \u041C\u043E\u0436\u0435\u0442\u0435 \u043E\u043D\u0435\u043C\u043E\u0433\u0443\u045B\u0438\u0442\u0438 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435, \u0438\u0430\u043A\u043E \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430 \u043C\u043E\u0436\u0434\u0430 \u043D\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0448\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u043D\u043E \u0437\u0430 \u0432\u0430\u0441. \u041F\u043E\u0441\u0442\u0430\u0432\u043A\u0435 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0447\u0430 \u043C\u043E\u0433\u0443 \u0441\u0435 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u043E\u0432\u0430\u0442\u0438 \u0434\u0430 \u043F\u0440\u0438\u0445\u0432\u0430\u0442\u0435 \u0438\u043B\u0438 \u043E\u0434\u0431\u0438\u0458\u0443 \u0441\u0432\u0435 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435 \u0438\u043B\u0438 \u0437\u0430\u0442\u0440\u0430\u0436\u0435 \u043E\u0431\u0430\u0432\u0435\u0448\u0442\u0435\u045A\u0435 \u043A\u0430\u0434\u0430 \u0458\u0435 \u043A\u043E\u043B\u0430\u0447\u0438\u045B \u043F\u043E\u0434\u0435\u0448\u0435\u043D. \u0412\u0438\u0448\u0435 \u043E cookies \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u0438 \u043D\u0430 \u0445\u0442\u0442\u043F://\u0446\u043E\u043E\u043A\u0438\u0435\u0446\u0435\u043D\u0442\u0440\u0430\u043B.\u0446\u043E\u043C. \u0412\u0430\u0436\u043D\u043E \u0458\u0435 \u0437\u043D\u0430\u0442\u0438 \u0434\u0430 \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435 \u0438\u043B\u0438 \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u0435 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u0435 \u0441\u0430 \u0441\u0432\u043E\u0433 \u0443\u0440\u0435\u0452\u0430\u0458\u0430, \u0430 \u0442\u0430\u043A\u043E\u0452\u0435 \u043E\u043D\u0435\u043C\u043E\u0433\u0443\u045B\u0438\u0442\u0438 \u0431\u0443\u0434\u0443\u045B\u0443 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0443 \u0438\u0441\u0442\u0438\u0445 \u043F\u0440\u043E\u043C\u0435\u043D\u043E\u043C \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E\u0441\u043D\u0438\u0445 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0432\u0435\u0431 \u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0447\u0443. \u0414\u0430 \u0431\u0438\u0441\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u043B\u0438 \u0441\u0432\u0435 \u043A\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0435 \u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u043E\u0441\u0442\u0438 \u0441\u0430\u0458\u0442\u043E\u0432\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435 \u041C\u043E\u0431\u0438\u043B\u0435, \u043C\u043E\u0440\u0430\u0442\u0435 \u0434\u0430 \u043F\u0440\u0438\u0445\u0432\u0430\u0442\u0438\u0442\u0435 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435. (\u0431) \u0412\u0435\u0431 \u0441\u0432\u0435\u0442\u0438\u043B\u0438\u0446\u0435. \u0412\u0435\u0431 \u0431\u0435\u0430\u0446\u043E\u043D \u0458\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0441\u043A\u0438 \u043A\u043E\u0434 \u043A\u043E\u0458\u0438 \u0441\u0435 \u043C\u043E\u0436\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0437\u0430 \u043F\u0440\u0438\u043A\u0430\u0437\u0438\u0432\u0430\u045A\u0435 \u0441\u043B\u0438\u043A\u0435 \u043D\u0430 \u0432\u0435\u0431 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438, \u0430\u043B\u0438 \u0441\u0435 \u0442\u0430\u043A\u043E\u0452\u0435 \u043C\u043E\u0436\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0437\u0430 \u043F\u0440\u0435\u043D\u043E\u0448\u0435\u045A\u0435 \u0432\u0430\u0448\u0435 \u0458\u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u0435 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0443 \u0431\u0430\u0437\u0443 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0438 \u043F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435 \u0441\u0430 \u043F\u0440\u0435\u0442\u0445\u043E\u0434\u043D\u043E \u0441\u0442\u0435\u0447\u0435\u043D\u0438\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430\u043C\u0430 \u043E \u043F\u043E\u0458\u0435\u0434\u0438\u043D\u0446\u0443 \u0443 \u0431\u0430\u0437\u0438 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430. \u041E\u0432\u043E \u043E\u043C\u043E\u0433\u0443\u045B\u0430\u0432\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0438 \u0434\u0430 \u043F\u0440\u0430\u0442\u0438 \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0435 \u043C\u043E\u0431\u0438\u043B\u043D\u0435 \u0441\u0430\u0458\u0442\u043E\u0432\u0435 \u043A\u043E\u0458\u0435 \u043F\u043E\u0441\u0435\u045B\u0443\u0458\u0435\u0442\u0435. \u0412\u0435\u0431 \u0431\u0435\u0430\u0446\u043E\u043D\u0441 \u043A\u043E\u0440\u0438\u0441\u0442\u0435 \u0441\u0435 \u0437\u0430 \u043F\u0440\u0430\u045B\u0435\u045A\u0435 \u043D\u0430\u0432\u0438\u043A\u0430 \u0443 \u043F\u043E\u043D\u0430\u0448\u0430\u045A\u0443 \u043D\u0430 \u043C\u0440\u0435\u0436\u0438 \u0443 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0448\u043A\u0435 \u0441\u0432\u0440\u0445\u0435 \u043A\u0430\u043A\u043E \u0431\u0438 \u0441\u0435 \u043E\u0434\u0440\u0435\u0434\u0438\u043B\u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438 \u0438\u043B\u0438 \u0443\u0441\u043B\u0443\u0433\u0435 \u043A\u043E\u0458\u0438 \u0431\u0438 \u0432\u0430\u0441 \u043C\u043E\u0433\u043B\u0438 \u0437\u0430\u043D\u0438\u043C\u0430\u0442\u0438. \u041F\u043E\u0440\u0435\u0434 \u0442\u043E\u0433\u0430 \u0448\u0442\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u0432\u0435\u0431 \u0431\u0435\u0430\u0446\u043E\u043D\u0441 \u043D\u0430 \u0432\u0435\u0431 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0430, \u0426\u043E\u043C\u043F\u0430\u043D\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u0438 \u0432\u0435\u0431 \u0431\u0435\u0430\u0446\u043E\u043D\u0441 \u0443 \u0435-\u043F\u043E\u0440\u0443\u043A\u0430\u043C\u0430 \u043A\u043E\u0458\u0435 \u0441\u0435 \u0448\u0430\u0459\u0443 \u043F\u043E\u0458\u0435\u0434\u0438\u043D\u0446\u0438\u043C\u0430 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u043C \u0443 \u0431\u0430\u0437\u0438 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435. (\u0446) \u0418\u041F \u0430\u0434\u0440\u0435\u0441\u0435. \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0430\u0443\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u0438 \u043F\u0440\u0430\u0442\u0438 \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0443 \u0432\u0430\u0448\u0435\u0433 \u043F\u043E\u043D\u0430\u0448\u0430\u045A\u0430 \u043D\u0430 \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0438. \u041E\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0437\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u043E \u0438\u0441\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u045A\u0435 \u0434\u0435\u043C\u043E\u0433\u0440\u0430\u0444\u0438\u0458\u0435, \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430 \u0438 \u043F\u043E\u043D\u0430\u0448\u0430\u045A\u0430 \u043D\u0430\u0448\u0438\u0445 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0434\u0430 \u0431\u043E\u0459\u0435 \u0440\u0430\u0437\u0443\u043C\u0435\u043C\u043E, \u0437\u0430\u0448\u0442\u0438\u0442\u0438\u043C\u043E \u0438 \u0441\u043B\u0443\u0436\u0438\u043C\u043E \u0432\u0430\u043C\u0430 \u0438 \u043D\u0430\u0448\u043E\u0458 \u0437\u0430\u0458\u0435\u0434\u043D\u0438"
                )
              )
            )
          )
        );
      } else if (_domainConfig.config.subDomain === "portal" && _isGamiclub.isGameverse) {
        return _react2.default.createElement(
          "section",
          { className: "terms privacy-policy" },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12" },
              _react2.default.createElement(
                "div",
                { className: "terms-title-wrap" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-section-title" },
                  "Privatumo politika"
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactstrap.Container,
            { fluid: true },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0160i Privatumo politika paai\u0161kina m\u016Bs\u0173 \u012Fsipareigojimus ir j\u016Bs\u0173 teises, susijusias su j\u016Bs\u0173 informacija. Atid\u017Eiai perskaitykite Privatumo politik\u0105. Jei nesutinkate su \u0161ia Privatumo politika, pra\u0161ome nesinaudoti m\u016Bs\u0173 Svetain\u0117mis ar Paslaugomis."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Privatumo politika yra tinkamai integruota ir taikoma toms pa\u010Dioms Paslaugoms ir Svetain\u0117ms, kaip nustatyta Naudojimo s\u0105lygose. Bet kokie terminai, kuriuos naudojame Privatumo politikoje be apibr\u0117\u017Eim\u0173, turi toki\u0105 pa\u010Di\u0105 reik\u0161m\u0119 kaip ir Naudojimo s\u0105lygose."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Informacij\u0105 renkame \u0161iais b\u016Bdais"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Kai j\u016Bs mums j\u0105 pateikiate arba suteikiate leidim\u0105 j\u0105 gauti. Jei nuspr\u0119site u\u017Esisakyti paslaug\u0105 i\u0161 m\u016Bs\u0173, mes arba j\u016Bs\u0173 mobiliojo ry\u0161io operatorius rinksime j\u016Bs\u0173 mok\u0117jimo duomenis d\u0117l m\u016Bs\u0173 paslaug\u0173. J\u016Bs\u0173 mobiliojo ry\u0161io operatoriaus surinktiems paskyros ir atsiskaitymo duomenims taikoma jo privatumo politika."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Technin\u0119 informacij\u0105 gauname, kai lankot\u0117s m\u016Bs\u0173 Svetain\u0117se ir (arba) naudojat\u0117s Paslaugomis. Kiekvien\u0105 kart\u0105, kai naudojat\u0117s m\u016Bs\u0173 Paslaugomis, galime rinkti technin\u0119 informacij\u0105 apie jus. Kiekvien\u0105 kart\u0105, kai prisijungiate prie m\u016Bs\u0173 Paslaug\u0173 arba atsijungiate nuo j\u0173, renkame prisijungimo informacij\u0105."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Kaip naudojame surinkt\u0105 informacij\u0105"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "J\u016Bs\u0173 informacij\u0105 galime naudoti \u0161iais tikslais:"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u2022 Teikti u\u017Esakytas paslaugas;"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u2022 Apskai\u010Diuoti ir surinkti mokes\u010Dius u\u017E jums suteiktas paslaugas."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Kiek laiko saugome j\u016Bs\u0173 informacij\u0105"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "J\u016Bs\u0173 informacij\u0105 saugosime tiek laiko, kiek b\u016Btina, kad gal\u0117tume teikti jums savo paslaugas. Taip pat saugosime j\u016Bs\u0173 informacij\u0105 tiek laiko, kiek b\u016Btina, kad \u012Fvykdytume savo teisinius \u012Fsipareigojimus, i\u0161spr\u0119stume gin\u010Dus ir u\u017Etikrintume savo sutar\u010Di\u0173 vykdym\u0105."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Kai mums nebereik\u0117s naudoti j\u016Bs\u0173 informacijos ir jos nebereik\u0117s saugoti, kad \u012Fvykdytume teisinius ar reguliavimo \u012Fsipareigojimus, j\u0105 i\u0161trinsime i\u0161 savo sistem\u0173 arba nuasmeninsime taip, kad j\u016Bs\u0173 neb\u016Bt\u0173 galima identifikuoti."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Kaip saugome j\u016Bs\u0173 informacij\u0105, taip pat u\u017E ES rib\u0173"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Mums r\u016Bpi j\u016Bs\u0173 privatumas ir duomenys, ta\u010Diau negalime u\u017Etikrinti ar garantuoti bet kokios mums siun\u010Diamos informacijos saugumo arba garantuoti, kad j\u016Bs\u0173 informacija nebus pasiekta, atskleista, pakeista ar sunaikinta pa\u017Eeidus m\u016Bs\u0173 fizines, technines ar valdymo pramon\u0117s standart\u0173 saugumo priemones."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Naudojame tinkam\u0105 duomen\u0173 rinkimo, saugojimo ir tvarkymo praktik\u0105 bei saugumo priemones, kad apsaugotume j\u016Bs\u0173 informacij\u0105, sandori\u0173 informacij\u0105 ir m\u016Bs\u0173 Paslaugose saugomus duomenis nuo neteis\u0117tos ar atsitiktin\u0117s prieigos, pakeitimo, atskleidimo ar sunaikinimo."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Ta\u010Diau n\u0117 vienas duomen\u0173 perdavimo internetu ar elektroninio saugojimo metodas n\u0117ra 100% saugus. Tod\u0117l negalime garantuoti visi\u0161ko saugumo. Ir toliau tobulinsime savo saugumo proced\u016Bras, kai atsiras nauj\u0173 technologij\u0173."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Kadangi veikiame tarptautiniu mastu, j\u016Bs\u0173 informacija, \u012Fskaitant asmens duomenis, gali b\u016Bti perduota ir pasiekiama Jungtin\u0117se Amerikos Valstijose / Singap\u016Bre ir (arba) bet kurioje kitoje \u0161alyje, nei j\u016Bs\u0173 gyvenamosios vietos \u0161alis. Imam\u0117s vis\u0173 pagr\u012Fst\u0173 priemoni\u0173, kad apsaugotume j\u016Bs\u0173 asmens duomenis \u0161iose \u0161alyse."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Privatumo politikos pri\u0117mimas"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Naudodamiesi bet kuriomis m\u016Bs\u0173 Paslaugomis, j\u016Bs sutinkate, kad mes rinktume ir naudotume j\u016Bs\u0173 informacij\u0105 pagal \u0161i\u0105 Privatumo politik\u0105."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Pasiliekame teis\u0119 bet kada keisti \u0161i\u0105 Privatumo politik\u0105, paskelbdami pakeitimus \u0161iame puslapyje. Patikrinkite \u0161io puslapio per\u017Ei\u016Bros dat\u0105, kad nustatytum\u0117te, ar politika pasikeit\u0117 nuo paskutinio j\u016Bs\u0173 apsilankymo."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Jei toliau naudosit\u0117s bet kuria m\u016Bs\u0173 Svetain\u0117s ar Paslaug\u0173 dalimi po atnaujintos Privatumo politikos paskelbimo, tai reik\u0161, kad sutinkate su pakeitimais."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "\u0160ios Privatumo politikos pakeitimai"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Retkar\u010Diais galime keisti savo Privatumo politik\u0105. Jei nuspr\u0119sime pakeisti savo Privatumo politik\u0105, paskelbsime \u0161iuos pakeitimus \u0161iame puslapyje, kad visada gal\u0117tum\u0117te susipa\u017Einti su naujausia Privatumo politikos versija."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Kontaktai"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Jei turite klausim\u0173 d\u0117l \u0161ios Privatumo politikos, Svetaini\u0173 praktikos ar j\u016Bs\u0173 santyki\u0173 su Svetain\u0117mis, susisiekite su mumis el. pa\u0161tu lt@gameverse-lt.com."
              )
            )
          )
        );
      } else return _react2.default.createElement(
        "section",
        { className: "terms privacy-policy" },
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12" },
              _react2.default.createElement(
                "div",
                { className: "terms-title-wrap" },
                _react2.default.createElement(
                  "h2",
                  { className: "terms-section-title" },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "privacy-policy-title",
                    defaultMessage: "Privacy Policy"
                  })
                )
              )
            )
          ),
          _domainConfig.config.subDomain === "gr" && _productCondition.isGamelords ? _react2.default.createElement(
            _reactstrap.Row,
            { className: "no-gutters" },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head1",
                  defaultMessage: "1. Privacy Policy: Purposes and field of application"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-Purposes-desc1",
                  defaultMessage: "The hereby Praivacy Policy is referred to the Services\u2019 provision by the company under corporate name Sam Media BV based at Van Diemenstraat 356 1013 CR Amsterdam The Netherlands with VAT NL8187 94 859 B01 which is registered with number 164831301000in relevant Chamber of Commerce (referred to as \u201Cthe Company\u201D).\r "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-Purposes-desc2",
                  defaultMessage: "The purpose of this Privacy Policy constitutes the description of all the the means which are used for the collection and processing of the personal data that the Company receives, via the internet or other ways, as also the Company\u2019s privacy practices."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-Purposes-desc3",
                  defaultMessage: "The Company commits to take all necessary measurements for the protection and process of the personal data in a lawful manner, in full compliance to the General Data Protection Regulation (EU) 2016/679 (GDPR) and other related laws of its implementation. "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-Purposes-desc4",
                  defaultMessage: "The provided Services by the Company are addressed to adults; personal data for any person, known by the Company to be aged under 18 years, are not collected, without the prior verifiable consent of the holder of parental responsibility over the child. In any case, the holder or the parental responsibility has the right, upon his/her request, to be informed regarding the information provided by the minor and/or to request its erasure. If the Company becomes aware that the person who is submitting his/her personal data is under 18 years old, the Company shall immediately erase said data."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-Purposes-desc5",
                  defaultMessage: "The present Privacy Policy is incorporated to the General Terms and Conditions, which are posted at the Company\u2019s website, constituting a single text. The Company\u2019s business activities are conducted via its website https://sam-media.com/."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "2. privacy-policy-gr-head2",
                  defaultMessage: "2. \u039F\u03C1\u03B9\u03C3\u03BC\u03BF\u03AF"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc6",
                  defaultMessage: "Personal data: any information relating to an identified or identifiable individual \u2013 natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc69",
                  defaultMessage: "Personal Data Subject: every natural person that his/her personal data are submitted to a process by or on behalf of the Company."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc7",
                  defaultMessage: "Data processing: any activity involving personal data, irrespective of the means and the procedure applied, e.g, collection, recording, use, revision, disclosure, organisation, projection and destruction of personal data"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc8",
                  defaultMessage: "Processing restriction: the signaling of stored personal data in a purpose of their process in the future."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc9",
                  defaultMessage: "Profiling: any form of automated processing of personal data that is consisting of the personal\u2019s data use for the evaluation of certain personal aspects of a natural person."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc10",
                  defaultMessage: "Filing System: any structured personal data set, which is accessible in accordance to specific criteria, whether this personal data set is centralized, or decentralized or distributed over an functional or geographical basis."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc11",
                  defaultMessage: "Transmission: the access to personal data, for example by allowing access, broadcast or publication."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc12",
                  defaultMessage: "Data Controller: the natural person or the legal entity that determines the purpose, the way, the content and the procedure of the processing of personal data."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc13",
                  defaultMessage: "Data Processor: the natural person or the legal entity, which processes personal data following the controller\u2019s instructions."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc14",
                  defaultMessage: "Personal Data Subject\u2019s Consent: any indication of will, which is free, specific, explicit and in full aware of the personal data subject; with that way the personal subject data declares that agree with the fact of his/her personal data processing, via his/her statement or his/her clear positive act."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head3",
                  defaultMessage: "3. Processing Purpose of the Data"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc15",
                  defaultMessage: "The processing of personal data is exclusively realized by the Company, in accordance to the purpose that is indicated upon the collection of personal data, in the context of Services\u2019 provision by the Company, as also every legitimate purpose."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc16",
                  defaultMessage: "The collected personal data by the Company aim to facilitate the creation or improvement, as also the personalization of the relationship between the Company and recipients of its Services."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc17",
                  defaultMessage: "The processing of the personal data is always conducted within the legal framework and the principles of good faith. For that reason, the personal data that are collected or are stored, are only the necessary, in order to fulfil the processing purpose. Moreover, the Company takes all the necessary measures for ensuring the legality of the said process which it should be, in any case, compliant with the purpose of data\u2019s collection."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc18",
                  defaultMessage: "The personal data processing for that purpose is lawful only if it is founded on the End User\u2019s consent, as it is predicted to Article 6 paragraph 1a and Article 9 paragraph 2a General Data Protection Regulation (GDPR), as also the said processing is realized in the context of the contract\u2019s performance where the End User is a contracting party, as a personal data subject. (Article 6 paragraph 1b GDPR)"
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head4",
                  defaultMessage: "4. Kind of the Personal Data that are collected"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc19",
                  defaultMessage: "The kind of the personal data that are collected include the full name, email address, billing information or mobile telephone number and related data, as may be requested for time to time. In any case, the said collection and processing of your personal data needs necessarily your explicit consent to the Company."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head5",
                  defaultMessage: "5. Means of Collection of the Personal Data"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc20",
                  defaultMessage: "The personal data collection is conducted either because you provides them to the Company on your own or via automated means. More specifically:"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para terms-para-xs" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc211",
                  defaultMessage: "Provision of the Personal Data voluntarily by the Data\u2019s Subjects"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc21",
                  defaultMessage: "The Company collect personal data, when you submit personal information to the latter, on your own initiative. The said collection happens to the following cases:"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc22",
                  defaultMessage: "- by your subscription to the Company\u2019s website, in order to receive recreational content Services for mobile phones, for example notification sounds, games, pictures, news and others.,"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc23",
                  defaultMessage: "- by using the download links, without your subscription, to the Company\u2019s website https://sam-media.com/, such as in cases of individual downloads or subscription via SMS by using your  mobile phone, "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc24",
                  defaultMessage: "-by submitting your opinions, suggestions, comments or complaints to the Company or through any communication between you and the Company."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc25",
                  defaultMessage: "- by your participation in the Company\u2019s activities, such as competitions, games, surveys, fora,"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc26",
                  defaultMessage: "- by transferring your personal data by third parties which have a cooperation relationship with the Company and they are reliable. This data\u2019s transfer is always conducted in the context of the fulfilment of the purpose for which you submit your personal data, giving your relevant consent,"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc27",
                  defaultMessage: "-by transferring your personal data to the Company through public databases."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para terms-para-xs" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc28",
                  defaultMessage: "Personal Information Collection via Automated Means (Cookies)-the Company\u2019s Policy"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc29",
                  defaultMessage: "Cookies are small text files, which are used for the storage of data that are related to you and your preferences. Every time that you visit specific websites, the cookies are placed automatically in a predetermined file in your computer by the server. The purpose of the cookies is to uniquely identify your computer to the server. In this way, it is allowed to the Company to collect information relating to the server, in order to facilitate your browse in the internet, as also to evaluate and test the function of the Company\u2019s website."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc30",
                  defaultMessage: "By using the cookies, the Company is able to identify your web browser, as also to determine whether you have downloaded the activation software, which is required in order to access specific material in the Company\u2019s websites. Moreover, the Company may, through the cookies, determine the total number of visitors of its website and identify you when you visit again its website. Information pertaining to your activities in the Company\u2019s website and other non-personal data may also be used, in order to be appeared only the online advertisements that the Company believes that correspond to your preferences.. "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc31",
                  defaultMessage: "Cookies have the ability of storing your access code in a website that you have previously used, in order to provide easy access to this, as also storing related data to your preferences, in order to redirect you to a website adjusted to said preferences."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc32",
                  defaultMessage: "Information that can be used for your identification, it is not possible to be collected through the cookies of other related identifying means. The said collection can only happen in the case that you submit on your own such information, so the automated means are going to be used to deliver additional information regarding your use of the websites and/or the interactive emails, having as an exclusive purpose of increasing their usefulness for you. Such cases are indicatively and without limitation, your subscription request for the Company\u2019s Services or the sending of an email."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc33",
                  defaultMessage: "In the majority of the browsers, they are programmed to accept cookies. Although, there is the ability for you to adjust your browser\u2019s settings so that the latter reject downloading the cookies or to notify you each time your browser receives a cookie. It is indicated that in this case, it is possible for some pages of the Company\u2019s website may not function properly, and you may not have access to specific applications."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc34",
                  defaultMessage: "It is possible that the Company may use cookies and other similar means to associate your use of the Company\u2019s website with personal data received by the Company or by a third party, reliable partner of the Company."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc35",
                  defaultMessage: "The above mentioned case could indicatively happen if you have requested information regarding future products or promotional activities of the Company, cookies and/or your browsing history regarding your activities in the Company\u2019s website, may allow the Company to limit the provided material to what the latter believe that you may find interesting, based on your previous online activities and preferences. In the above mentioned case that the Company intends to combine your personal data and cookies or information regarding your browsing history, the Company will necessarily request your previous express consent."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc36",
                  defaultMessage: "At the Company\u2019s website may appear third parties\u2019 advertisements, which may also contain cookies. The said cookies are determined each time by the advertiser or the advertised entity and the Company has not the ability of controlling them. Therefore, you should refer to the advertiser\u2019s or the advertised entity\u2019s privacy policy, in order to ascertain if they use cookies and how."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc37",
                  defaultMessage: "Finally, the technical department or other departments of the Company or its associates may automatically collect information regarding the visitors of the Company\u2019s website for purposes of maintenance, improvement, security and other legitimately acceptable reasons. Such information may include the IP address of visitors, the browser type, the date, time and duration of the visit and specific pages that the you have visited."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head6",
                  defaultMessage: "6. The Company\u2019s Practices relating to the Personal Data collection and your notification"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc38",
                  defaultMessage: "By providing your personal data each time, the Company ensures that you have been informed about who collects your personal information, the means of their collection, the kind of their use by the Company, as also about the purpose of thei collection."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc39",
                  defaultMessage: "For that reason, each time that you provide your personal data, the Company will take care of notifying you about your options regarding your personal data\u2019s use, as also in any  case of a potential joint use of your data by the Company and third parties."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc40",
                  defaultMessage: "In the event that your personal data are collected manually or by means not related to the internet (such as subscription form), the Company takes care of sending you a brief notice, whereby it describes how you may receive the Company\u2019s entire Privacy Policy and other related information from it. In that way, your detailed notification, regarding to all related aspects of your personal data and their use by the Company, is ensured, so that you are able to give your express consent to the Company."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc41",
                  defaultMessage: "At the Company\u2019s website, it is possible to appear links that redirect you to other companies\u2019 websites. In some of the above cases, the third parties\u2019 websites may contain the Company\u2019s logo, even though the fact that the Company has not their operation or the responsibility about these websites\u2019 content. "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc42",
                  defaultMessage: "At the Company\u2019s website may also appeared advertisements from other companies, which may redirect you via a link to third parties\u2019 websites. In that case the Company has no liability for the practices of third parties or for the privacy policies of third parties or local advertising companies on the internet. So, if you are redirected from the Company\u2019s website via such link or by clicking on an advertisement, you should refer to the applicable privacy policy of the third party or the advertiser\u2019s website, so that you have information about how they will handle any personal data collected from you. "
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head7",
                  defaultMessage: "7. Data Subject\u2019s Rights"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43",
                  defaultMessage: "All data subjects have the following rights, pursuant to GDPR, which the Company respects and protects:"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-a",
                  defaultMessage: "(a) the right to be informed, means that the subject has the right, upon his/her request, of receiving information about his/her personal data that are maintained by the Company and more particularly, the kind of the data under process, who natural persons or legal entities have the right of process, as also the reasons of that"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-b",
                  defaultMessage: "(b) the right of access, means that the subject is entitled to submit request to the Company with content of having free access to his/her personal data that are maintained by the Company"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-c",
                  defaultMessage: "(c) right to rectification and completion, means that the subject is entitled, upon his/her notice to the Company, to request the correction of any accuracies to his/her personal data, as also the completion of any incomplete data, under the condition that these data are necessary for the purposes of the process"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-d",
                  defaultMessage: "(d) right to erasure, means that the subject is entitled to request from the Company the erasure of his/her personal data that are collected by the Company. Although, some of the collected personal data will be erased after a specified period of retention, especially in cases that the Company is obligated by the Law to maintain the personal data or the collected data are necessary for the performance of Company\u2019s contractual obligations towards the subject "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-e",
                  defaultMessage: "(e) right to restriction of processing, means that the subject has the right to request the restriction of processing his/her personal data and especially: 1) if there is doubt for their accuracy, 2) if the processing is illegal, 3) if the collected data are not necessary for the data controller, 4) if he/she has objections to automated process"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-f",
                  defaultMessage: "(f) right to data portability, means that the subject has the right to request the transfer of his/her data to another data controller"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-g",
                  defaultMessage: "(g) right to object, means that the subject may object, at any time in the future, to his/her personal data\u2019s process by the Company, if the Company processes his/her data on the basis of the reasons that are provided in article 6 (1e or 1f) GDPR (EU) 2016/679. If the subject objects, the Company shall stop processing his/her data, under the condition that there are no legal reasons that justify their further process. The personal data\u2019s process for advertising purposes is not a legal reason."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-h",
                  defaultMessage: "(h) rights relating to the automated decision-making and profiling means that the personal data subject has the right of not being subjected to decision that has been taken exclusively on the basis of an automated processing, including profiling, which produces legal effects that concern the subject or significantly affect him/her with a similar way. The above mentioned do not apply in the following cases: 1)if the decision is necessary for the conclusion or the performance of the contract between the Company and the subject, 2) if it is allowed by the Law of European Union or the Law of the member state in which is subject the data controller or 3) if there is the express consent of the personal data subject."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-i",
                  defaultMessage: "(i) right to withdraw consent means that the subject has the right to withdraw his/her consent for his/her personal data\u2019s process, at any time in the future.  The legitimacy of the personal data\u2019s process is not affected by the said act, until the time of the withdrawal of his/her consent."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc43-j",
                  defaultMessage: "(j) right to freeze the personal data means that in some cases that are provided by the Law, the Company will freeze the personal data of the subject, upon his/her request. Furthermore, the process of personal data is only realized to a limited extent."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc44",
                  defaultMessage: "If the subject request to the Company for the discontinuance of his/her personal data\u2019s use, the Company shall satisfy this request and shall maintain only the information necessary to comply with the national legislation. "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc45",
                  defaultMessage: "The subject may contact with the Company, in order to exercise his/her rights, and the Company shall respond in a timely manner, not exceeding 30 days."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head8",
                  defaultMessage: "8. The Use and The Process of Personal Data"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc46",
                  defaultMessage: "The Company is bound that will use the provided personal data, according to this Privacy Policy and exclusively for the purposes that the End User\u2019s provided them for."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc47",
                  defaultMessage: "The Company maintains the ability of using the personal data that provided to the Company upon your registration to the Company\u2019s Services, in order to send you important information and notices regarding to your account and the services that you have requested."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc48",
                  defaultMessage: "In a case of personal data collection by the Company that concerns the data\u2019s provision directly by the himself/herself End User, when the latter requested to receive files or services from the Company, the Company will proceed to procession of the request for assistance or service, including processing the completion of the order and the payment, if any. So, the Company will not share the data with third parties, except for those that the Company uses to conduct its business (for example, the completion of the order and the payment processing), required to conclude purchases that are made by the subject and subscriptions that it has requested via https://sam-media.com/."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head9",
                  defaultMessage: "9. Personal Data\u2019s Transfer to third parties"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc49",
                  defaultMessage: "The Company undertakes the commitment of not transferring the personal data that are collected to third parties that are not related or associated with it, unless you have provided your express consent about that. If the Company receives personal data from a third party-business partner, the use of these information by the Company will be governed by the hereby Privacy Policy."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc50",
                  defaultMessage: "This Privacy Policy describes the types of other companies that may wish to send you notifications about their products and services and, therefore, wish to share your personal data, under the condition that you have explicitly consented to the above. "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc51",
                  defaultMessage: "The Company\u2019s website may also be linked to websites operated by the Company\u2019s affiliates, for example companies that are members of the Company\u2019s Group. Although members of the Company Group abide by the rules of the Group, the subjects of the personal data should refer to the separate privacy policies and practices, which may differ in certain aspects from this Privacy Policy."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc52",
                  defaultMessage: "Any third party that undertakes the processing on behalf of the Company, as indicatively and without limitation a service provider, is required to contractually agree to the processing of the personal data in accordance with this Privacy Policy; for that reason, the terms of this Policy are included in the pertinent agreements."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc53",
                  defaultMessage: "It is possible the revelation of personal data to third parties only if it is necessary or if the subject expressly consents to it. The personal data should be provided anonymously, if deemed appropriate."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc54",
                  defaultMessage: "Moreover, the Company may use all the personal data, in an anonymously, for research purposes."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc55",
                  defaultMessage: "Third companies that are associates of the Company may offer the subjects downloads of data and files, by collecting personal data on behalf of the Company, when the subjects register or log in for individual downloads of files and services via their mobile phone. Then, the Company\u2019s associates can share with the Company the personal data required, in order to offer the requested information, file downloads and other services. The Company\u2019s associates also provide to subject\u2019s mobile phone operator the required information, in order to charge him/her for the information and file downloads and other services that have been purchased."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc56",
                  defaultMessage: "The Company maintains the ability of sharing subject\u2019s personal data with its associates companies or with companies that belong to its Group of Companies, always in order to fulfil the processing purpose."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc57",
                  defaultMessage: "For the achievement of all the above mentioned purposes, all of the Company\u2019s employees receive the necessary training in personal data and data security issues. As also, for the legitimacy of employees\u2019, officers\u2019 and associates\u2019 access to personal data, this access should be justified by a legitimate reason, as it is predicted by the Law."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc58",
                  defaultMessage: "The Company has the right of sharing subject\u2019s personal data with outsource associates or agents, who provide their assistance to the Company for managing its informational activities (for example completion of orders, statistical analyses). Although, in that case the above mentioned persons can only use the provided personal data, in order to provide to the Company a specific service and not for any other purpose."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc59",
                  defaultMessage: "Personal data: any information relating to an identified or identifiable individual \u2013 natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc60",
                  defaultMessage: "The Company may enter into agreements with third companies that own the technology, which allows the Company to adjust the advertising and marketing messages that the personal data\u2019s subjects receive on the Company\u2019s websites. Non-personal data and browsing history data about subjects\u2019 activities on these websites may be shared with these companies, in order to achieve this adjustment. These companies will not share the said information with any third party nor use it for any other purpose. It is, nonetheless, possible for the browsing history and other demographic information to be used, anonymously, exclusively for advertising-statistical purposes by the Company or its business associates."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head10",
                  defaultMessage: "10. Data Storage, Time of Retention and Security"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc61",
                  defaultMessage: "The time of personal data storage is determined by the time that is needed for the fulfilment of the purpose of its collection as also by the Law. The information relating to the storage of the personal data and the period of their retention are determined in the Data Retention Policy of the Company."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para terms-para-xs" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc62",
                  defaultMessage: "The Company takes all measures indicated by technology, organisational or no, for the purpose of safeguarding the personal data that the Company possesses against loss, theft and unauthorised use, disclosure or modification, so as ensuring their integrity, confidentiality and availability. The Company uses also reasonable methods to ensure that the personal data are accurate, updated and properly completed."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head11",
                  defaultMessage: "11. Cases of the Personal Data Disclosure"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc63",
                  defaultMessage: "The Company is entitled to disclose your personal data without needing your consent, in the following cases: a) in order to protect its legitimate rights or the rights of other companies that belong to its Group of Companies or the rights of its employees, officers or associates, b) to safeguard the security of its website visitors, c) to be protected against fraud or committed criminal acts or any case of a suspicion for such act, d) for reasons relating to danger management, e) public order and security, public interest, f) in order to comply with the law or the legal procedures."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head12",
                  defaultMessage: "2. \u039F\u03C1\u03B9\u03C3\u03BC\u03BF\u03AF"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc64",
                  defaultMessage: "Personal data: any information relating to an identified or identifiable individual \u2013 natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc65",
                  defaultMessage: "Personal data: any information relating to an identified or identifiable individual \u2013 natural person. The identifiable natural person means the person that his/her identity can be verified, directly or indirectly, mainly through the reference to an identifier, such as name, ID number, location data, one or more factors that characterize his/her physical, natural, psychological, financial, cultural or social identity."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head13",
                  defaultMessage: "12. Conditions of cross-border disclosure of the Personal Data"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc66",
                  defaultMessage: "The subjects\u2019 personal data disclosure to a third country is possible, only if the legislation of said country provides a sufficient level of data\u2019s protection. In a different case, the personal data may only be transferred to this country, if the subject has expressly consented to their transfer or if the data protection is provided for by a relevant agreement for data\u2019s transfer, which provides all the necessary warranties about their protection"
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head14",
                  defaultMessage: "13. Transfer of the Company"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc67",
                  defaultMessage: "If the Company transfers, in whole or in part, its business or sells or transfers assets or, in general, engages in a merger or transfer of its business, it is allowed to transfer subjects\u2019 personal data to a third party as part of this transaction."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-head15",
                  defaultMessage: "15. Solving Personal Data\u2019s Issues-Communication"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-gr-desc68",
                  defaultMessage: "For the reason of exercising subject\u2019s rights, for example resolving a privacy issue, for issues relating to the collection and processing of subject\u2019s  personal data by the Company, in order to revise, rectify or erase subject\u2019s personal data or to discontinue any future communication with the subject, the latter may contact the Company via the email address  HYPERLINK \"mailto:customer.support@lilymobile.gr\"sam-media.gr@cchelp.co by calling the customer service at 2112348373  or by sending a letter to the Company\u2019s head offices at Van Diemenstraat 356 1013 CR Amsterdam The Netherlands"
                })
              )
            )
          ) : _react2.default.createElement(
            _reactstrap.Row,
            { className: "no-gutters" },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-desc",
                  defaultMessage: "This Privacy Policy explains our commitments and your rights concerning your information.\r You should read the Privacy Policy carefully. If you do not agree with this Privacy Policy, \r please do not use our Sites or Services. The Privacy Policy is duly incorporated and subject\r to the Terms of Service and governs the same Services and Sites as the ones mentioned in the \r Terms of Service. Any terms we use in the Privacy Policy without defining them have the same \r definition as in the Terms of Service."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-collect-info-head",
                  defaultMessage: "WE COLLECT INFORMATION THE FOLLOWING WAYS:"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-collect-info-desc1",
                  defaultMessage: "1. When you give it to us or give us permission to obtain it If you choose to subscribe to a Service\r from us, we or the mobile operator of your network will collect your information related to the\r payment for the subscription of our Services. Account and billing information collected by the\r mobile operator are subject to their respective privacy policies.   "
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-collect-info-desc2",
                  defaultMessage: "2. We get technical information when you visit our Sites and/or Services We may collect technical information\r about you whenever you use our Services. We collect log data every time you log in or log out of our Services."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-collect-info-head",
                  defaultMessage: "HOW WE USE COLLECTED INFORMATION"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-collect-info-subhead",
                  defaultMessage: "We may use your information for the following purposes:"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\xB7",
                " ",
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-collect-info-desc1",
                  defaultMessage: "Provide the Service(s) you request;"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                ".",
                " ",
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-collect-info-desc2",
                  defaultMessage: "Bill and collect for the Service(s) provided to you;"
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-long-head",
                  defaultMessage: "HOW LONG WE KEEP YOUR INFORMATION"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-long-desc",
                  defaultMessage: "We will retain your information for as long as needed to provide our Services to you. We will retain your information as necessary to comply with our legal obligations, resolve disputes and enforce our agreements.\r When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we will either remove it from our systems or depersonalize it so that we can no longer identify you."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-long-protect-head",
                  defaultMessage: "HOW WE PROTECT YOUR INFORMATION ALSO OUTSIDE THE EU"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-long-protect-desc1",
                  defaultMessage: "We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-long-protect-desc2",
                  defaultMessage: "We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-how-long-protect-desc3",
                  defaultMessage: "Because we operate internationally, your information, including personal information, may be transferred to and made available in the USA/Singapore and/or any other country than your country of residence. Also in these countries, we take all reasonable care to protect your personal information."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-acceptance-head",
                  defaultMessage: "ACCEPTANCE OF PRIVACY POLICY"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-acceptance-desc",
                  defaultMessage: "By using any of our Services, you consent to our collection and use of your information in accordance with this Privacy Policy. We reserve the right to modify this Privacy Policy at any time by posting the changes on this page. Please check the revision date at the bottom of this page to determine if the policy has been modified since you last reviewed it. Your continued use of any portion of our Site or Services following the posting of the updated Privacy Policy will constitute your acceptance of the changes."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-changes-head",
                  defaultMessage: "CHANGES TO THIS PRIVACY POLICY"
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-changes-desc",
                  defaultMessage: "We may make changes in our Privacy Policy from time to time. If we decide to change our Privacy Policy, we will post those changes on this page so that you can always access the latest Privacy Policy."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "privacy-policy-contact-us",
                  defaultMessage: "CONTACTING US"
                })
              ),
              _domainConfig.config.subDomain === "my" ? _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "You may contact our Customer Care Team at 03-2775 2064 /+6018-780 0852 or through email at cs@sam-media.com. Our dedicated Customer Care Team will be more than happy to answer your questions or solve any issues. Please note that the operating hours for our Customer Care Team is only from Monday to Friday, 9.30AM to 6.00PM."
              ) : _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: _isTheGamingClubs.isTheGamingClubs && _domainConfig.config.subDomain === "lt" ? "privacy-policy-contact-us-desc-the-gamingclubs" : _isOnlyBeemobi.isOnlyBeemobi && _domainConfig.config.subDomain === "es2" ? "privacy-policy-contact-us-desc-the-beemobi" : "privacy-policy-contact-us-desc",
                  defaultMessage: "If you have a question about this Privacy Policy, the practices of the Sites, or your dealings with the Sites, please contact us by sending an e-mail to support@content-clubs.com."
                })
              )
            )
          )
        )
      );
    }
  }]);

  return PrivacyPolicy;
}(_react.Component);

exports.default = PrivacyPolicy;

/***/ }),

/***/ "./src/components/PrivacyPolicy/PrivacyPolicyNo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyPolicyNo = function (_Component) {
  _inherits(PrivacyPolicyNo, _Component);

  function PrivacyPolicyNo() {
    _classCallCheck(this, PrivacyPolicyNo);

    return _possibleConstructorReturn(this, (PrivacyPolicyNo.__proto__ || Object.getPrototypeOf(PrivacyPolicyNo)).apply(this, arguments));
  }

  _createClass(PrivacyPolicyNo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _sendData.sendData)('', '', '', 'viewed', { page: 'privacy-policy' });
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'section',
        { className: 'terms privacy-policy' },
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12' },
              _react2.default.createElement(
                'div',
                { className: 'terms-title-wrap' },
                _react2.default.createElement(
                  'h2',
                  { className: 'terms-section-title' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'privacy-policy-title',
                    defaultMessage: 'Privacy Policy'
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactstrap.Row,
            { className: 'no-gutters' },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Retningslinjer for personvern'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Disse retningslinjene for personvern forklarer v\xE5re forpliktelser og dine rettigheter ang\xE5ende dine opplysninger. Du b\xF8r lese retningslinjene for personvern n\xF8ye. Hvis du ikke er enig i disse retningslinjene for personvern, m\xE5 du ikke bruke v\xE5re nettsider eller tjenester. Retningslinjene for personvern er beh\xF8rig innlemmet og underlagt vilk\xE5rene for bruk, og regulerer de samme tjenestene og nettstedene som er nevnt i vilk\xE5rene for bruk. Alle uttrykk som vi bruker i retningslinjene for personvern uten \xE5 definere dem, har samme definisjon som i vilk\xE5rene for bruk.'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'VI SAMLER INFORMASJON P\xC5 F\xD8LGENDE M\xC5TER:'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                '1. N\xE5r du gir oss den eller gir oss tillatelse til \xE5 innhente den. Hvis du velger \xE5 abonnere p\xE5 en tjeneste fra oss, samler vi eller mobiloperat\xF8ren av nettverket dine opplysninger knyttet til betalingen for abonnementet p\xE5 tjenestene v\xE5re. Konto- og faktureringsinformasjon som er innsamlet av mobiloperat\xF8ren, er underlagt deres respektive personvernregler.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                '2. Vi f\xE5r teknisk informasjon n\xE5r du bes\xF8ker v\xE5re nettsteder og/eller tjenester. Vi kan samle inn teknisk informasjon om deg n\xE5r du bruker tjenestene v\xE5re. Vi samler loggdata hver gang du logger inn p\xE5 eller logger ut av tjenestene v\xE5re.'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'HVORDAN VI BRUKER INNSAMLET INFORMASJON'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Vi kan bruke informasjon om deg til f\xF8lgende form\xE5l:'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Tilby tjenesten(e) du foresp\xF8r:'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Fakturering og innsamling for tjenesten(e) som tilbys deg'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'HVOR LENGE VI LAGRER INFORMASJONEN OM DEG'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Vi beholder informasjonen om deg s\xE5 lenge det er n\xF8dvendig for \xE5 kunne tilby v\xE5re tjenester til deg. Vi vil beholde informasjonen om deg etter behov for \xE5 overholde v\xE5re juridiske forpliktelser, l\xF8se tvister og h\xE5ndheve avtalene v\xE5re. N\xE5r vi ikke lenger trenger \xE5 bruke informasjonen om deg, og det ikke er n\xF8dvendig for oss \xE5 beholde den for \xE5 overholde v\xE5re lovbestemte eller regulatoriske forpliktelser, sletter vi den fra v\xE5re systemer eller depersonaliserer den slik at vi ikke lenger kan identifisere deg.'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'HVORDAN VI BESKYTTER INFORMASJON OM DEG OGS\xC5 UTENFOR EU'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Vi er opptatt av \xE5 beskytte dine personlige opplysninger og data, men vi kan ikke garantere for sikkerheten til all informasjon du overf\xF8rer til oss, eller garantere at informasjonen din ikke blir tilgjengelig, avsl\xF8rt, endret eller \xF8delagt ved brudd p\xE5 noen av v\xE5re fysiske, tekniske eller ledelsesmessige sikringstiltak av bransjestandard. Vi benytter passende praksis for datainnsamling, lagring og behandling og sikkerhetsforanstaltninger for \xE5 beskytte mot uautorisert eller utilsiktet tilgang, endring, avsl\xF8ring eller \xF8deleggelse av dine opplysninger, transaksjonsinformasjon og data lagret i v\xE5re tjenester. Imidlertid er ingen metode for overf\xF8ring p\xE5 internett eller elektronisk lagring 100% sikker. Derfor kan vi ikke garantere absolutt sikkerhet for personlig informasjon. Vi vil fortsette \xE5 forbedre v\xE5re sikkerhetsprosedyrer etter hvert som ny teknologi blir tilgjengelig. Siden vi opererer internasjonalt, kan informasjonen om deg, inkludert personlig informasjon, overf\xF8res til og gj\xF8res tilgjengelig i USA/Singapore og/eller et annet land enn ditt hjemland. Ogs\xE5 i disse landene bruker vi all rimelig forsiktighet for \xE5 beskytte dine personlige opplysninger.'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'GODKJENNELSE AV RETNINGSLINJER FOR PERSONVERN'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Ved \xE5 bruke v\xE5re tjenester, samtykker du til v\xE5r innsamling og bruk av informasjonen om deg i samsvar med disse retningslinjene for personvern. Vi forbeholder oss retten til \xE5 endre disse retningslinjene for personvern n\xE5r som helst ved \xE5 legge inn endringene p\xE5 denne siden. Vennligst sjekk revisjonsdatoen nederst p\xE5 denne siden for \xE5 finne ut om retningslinjene er endret siden du sist sjekket dem. Om du fortsetter \xE5 bruke hvilken som helst del av nettstedet eller tjenestene v\xE5re etter at en oppdatering retningslinjene for personvern er lagt ut, aksepterer du endringene'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'ENDRINGER AV DISSE RETNINGSLINJENE FOR PERSONVERN'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Vi kan gj\xF8re endringer i v\xE5re retningslinjer for personvern fra tid til annen. Hvis vi bestemmer oss for \xE5 endre v\xE5re retningslinjer for personvern, vil vi legge inn disse endringene p\xE5 denne siden, slik at du alltid kan f\xE5 tilgang til de nyeste retningslinjene for personvern.'
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'h6',
                { className: 'terms-title' },
                'KONTAKTE OSS'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Dersom du har et sp\xF8rsm\xE5l om disse retningslinjene for personvern, praksisen p\xE5 nettsidene, eller din opplevelse med nettsidene, kan du kontakte oss ved \xE5 sende en e-post til info@sam-media.com.'
              )
            )
          )
        )
      );
    }
  }]);

  return PrivacyPolicyNo;
}(_react.Component);

exports.default = PrivacyPolicyNo;

/***/ }),

/***/ "./src/components/SearchPage/SearchPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _messages = __webpack_require__("./src/constants/messages.js");

var _messages_ar = __webpack_require__("./src/constants/messages_ar.js");

var _messages_kk = __webpack_require__("./src/constants/messages_kk.js");

var _messages_fr = __webpack_require__("./src/constants/messages_fr.js");

var _messages_sv = __webpack_require__("./src/constants/messages_sv.js");

var _messages_no = __webpack_require__("./src/constants/messages_no.js");

var _messages_vi = __webpack_require__("./src/constants/messages_vi.js");

var _messages_tr = __webpack_require__("./src/constants/messages_tr.js");

var _messages_cy = __webpack_require__("./src/constants/messages_cy.js");

var _messages_de = __webpack_require__("./src/constants/messages_de.js");

var _messages_it = __webpack_require__("./src/constants/messages_it.js");

var _messages_pt = __webpack_require__("./src/constants/messages_pt.js");

var _messages_lt = __webpack_require__("./src/constants/messages_lt.js");

var _FlashMessageActions = __webpack_require__("./src/actions/FlashMessageActions.js");

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactStarRatingComponent = __webpack_require__("./node_modules/react-star-rating-component/index.js");

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _SearchActions = __webpack_require__("./src/actions/SearchActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _FlashMessage = __webpack_require__("./src/components/FlashMessage/FlashMessage.js");

var _FlashMessage2 = _interopRequireDefault(_FlashMessage);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _restrictedCategories = __webpack_require__("./src/constants/restrictedCategories.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain = _domainConfig.config.lang == 'ar' ? true : false;
var kazakhDomain = _domainConfig.config.lang == 'kk' ? true : false;
var msg = void 0;

switch (_domainConfig.config.lang) {
    case 'ar':
        msg = _messages_ar.messages_ar;
        break;
    case 'kk':
        msg = _messages_kk.messages_kk;
        break;
    case 'fr':
        msg = _messages_fr.messages_fr;
        break;
    case 'sv':
        msg = _messages_sv.messages_sv;
        break;
    case 'no':
        msg = _messages_no.messages_no;
        break;
    case 'vi':
        msg = _messages_vi.messages_vi;
        break;
    case 'tr':
        msg = _messages_tr.messages_tr;
        break;
    case 'it':
        msg = _messages_it.messages_it;
        break;
    case 'cy':
        msg = _messages_cy.messages_cy;
        break;
    case 'de':
        msg = _messages_de.messages_de;
        break;
    case 'pt':
        msg = _messages_pt.messages_pt;
        break;
    case 'lt':
        msg = _messages_lt.messages_lt;
        break;
    default:
        msg = _messages.messages;
        break;
}

var SearchPage = function (_Component) {
    _inherits(SearchPage, _Component);

    function SearchPage(props) {
        _classCallCheck(this, SearchPage);

        var _this = _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).call(this, props));

        _this.state = {
            text: props.search.searchText,
            categoryId: '',
            categoryTypeId: '',
            sortBy: '',
            isValid: false,
            errorMessage: '',
            games: { searchedGames: [] }
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.openGame = _this.openGame.bind(_this);
        _this.searchGames = _this.searchGames.bind(_this);
        return _this;
    }

    _createClass(SearchPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var regEx = this.props.search.searchText;
            this.getGameTypes();
            this.getCategories();
            this.searchGames();
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            this.setState(_defineProperty({}, e.target.name, e.target.value));

            this.searchGames(_defineProperty({}, e.target.name, e.target.value));

            this.setState({ text: e.target.value });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _sendData.sendData)('', '', '', '', { page: 'search page', search_term: this.props.search.searchText });
            this.props.searchText('');
        }
    }, {
        key: 'getCategories',
        value: function getCategories() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getCategories').then(function (response) {
                if (response.data.success) {
                    var dataFinal = response.data;
                    var categoriesArr = dataFinal.data;
                    dataFinal = _extends({}, dataFinal, { data: categoriesArr });
                    dataFinal.data = dataFinal.data.filter(function (category) {
                        return (0, _restrictedCategories.isCategoryAllowed)(category.categoryName);
                    });
                    if (!(_domainConfig.config.subDomain === 'cz' && _isGamiclub.isGamiclub)) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'E-knihy';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'fr' && _isGamiclub.isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Heróis Verdes';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    }
                    if (_domainConfig.config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    } else {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Videos Virales';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'rs') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Е-књиге';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'tr' && _domainConfig.config.subDomain !== 'qa' && _domainConfig.config.subDomain !== 'kw') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Facebook';
                        });
                    }
                    _this2.props.getCategories(dataFinal);
                }
            }).catch(function (error) {
                _this2.props.hide();
                (0, _helper.console_log)(error);
                _this2.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'getGameTypes',
        value: function getGameTypes() {
            var _this3 = this;

            _axios2.default.get(vars.BASE_URL + '/getCategoryTypes').then(function (response) {
                if (response.data.success) {
                    _this3.props.getGameTypes(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
                _this3.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'searchGames',
        value: function searchGames(regEx) {
            var _this4 = this;

            var data = Object.assign({}, {
                text: regEx
            }),
                urlParams = '';
            Object.keys(data).map(function (k) {
                if (data[k] != '' && data[k] != 0) {
                    urlParams += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
                }
            });

            _axios2.default.get(vars.BASE_URL + '/getGames?' + urlParams + '&uid=' + this.props.access.uid).then(function (response) {
                if (response.data.success) {
                    response.data.data = response.data.data.filter(function (game) {
                        return (0, _restrictedCategories.isCategoryAllowed)(game.categoryName);
                    });
                    _this4.setState({ games: { searchedGames: response.data } });
                }
            }).catch(function (error) {
                _this4.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.searchGames(nextProps.search.searchText);
        }
    }, {
        key: 'openGame',
        value: function openGame(game, e) {
            e.preventDefault();
            if (e.target.classList.contains('isFavorite')) {
                var pEl = void 0;
                pEl = _reactDom2.default.findDOMNode(this.refs['star' + game.gameId]);
                var _check = !pEl.checked;
                var data = {
                    uid: this.props.access.uid,
                    gameId: game.gameId,
                    isFavorite: _check
                };
                if (_check) {
                    this.props.showMessage({
                        message: msg.addToFavorites,
                        type: true
                    });
                } else {
                    this.props.showMessage({
                        message: msg.removeFromFavorites,
                        type: false
                    });
                }
                (0, _sendData.sendData)(game.gameTitle, game.categoryName, game.gameType, data.isFavorite ? 'favorite-added' : 'favorite-removed');
                _axios2.default.post(vars.BASE_URL + '/favorite', data).then(function (response) {
                    if (response.status) {
                        pEl.checked = _check;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            } else if (e.target.tagName != 'INPUT') {
                this.props.searchText('');
                var searchContainer = document.querySelector("#search-container");
                var searchInput = document.querySelector("#search-input");
                var searchButton = document.querySelector("#search-button");
                var searchClear = document.querySelector(".search-clear");
                var searchCancel = document.querySelector(".search-cancel");
                searchContainer.classList.toggle("search-toggle");
                this.props.goToPage((0, _helper.appendUid)('/detail/' + game.gameId, this.props.access.id));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var regEx = this.props.search.searchText;

            var starIcon = '<svg class="isFavorite" width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.3328" y1="14" x2="25.6672" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientTransform="rotate(-180)" gradientUnits="userSpaceOnUse" x1="0.2078" y1="14" x2="25.7922" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="isFavorite" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg>',
                thumbsUpIcon = '<svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="0.5" y1="14" x2="24.5" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="0.375" y1="14" x2="24.625" y2="14"><stop  offset="0" style="stop-color:#F2A11B"/><stop  offset="1" style="stop-color:#E97609"/></linearGradient><path class="st0" fill="url(#a)" stroke="url(#b)" stroke-width="100" d="M320 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zm160-512v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zm1184 0q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-129q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 .5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"/></svg>';

            var gameCategoryTitleClass = "game-category-title";
            if (kazakhDomain) {
                gameCategoryTitleClass += ' kz-text';
            }
            return _react2.default.createElement(
                'section',
                { className: 'search-page' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_FlashMessage2.default, null),
                    _react2.default.createElement(
                        _reactstrap.Container,
                        { fluid: true },
                        _react2.default.createElement(
                            _reactstrap.Row,
                            null,
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : null },
                                    _react2.default.createElement(
                                        'h2',
                                        { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : null, className: gameCategoryTitleClass },
                                        _react2.default.createElement('i', { className: 'fa fa-rocket', 'aria-hidden': 'true' }),
                                        _isGamiclub.isGamiclub ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'directories',
                                            defaultMessage: 'Directories'
                                        }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'gameDirectories',
                                            defaultMessage: 'Game Directories'
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Row,
                            { className: 'game-list-row' },
                            this.state.games.searchedGames.data && this.state.games.searchedGames.data.length > 0 ? this.state.games.searchedGames.data.map(function (game) {
                                return (0, _helper.filterGames)(game) ? _react2.default.createElement(
                                    _reactstrap.Col,
                                    { xl: '2', md: '3', sm: '4', xs: '6', key: game.gameId },
                                    _react2.default.createElement(
                                        _reactstrap.Card,
                                        { className: _isGamiclub.isGamiclub ? "game-card-gamiclub" : "game-card", onClick: _this5.openGame.bind(_this5, game) },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'game-card-inner' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-thumb-wrap' },
                                                _react2.default.createElement(_reactstrap.CardImg, { className: 'game-thumb', top: true, width: '100%', src: game.gameImage.includes('https://cdn.game-lords.com/games/http') ? game.gameImage.split('https://cdn.game-lords.com/games/')[1] : game.gameImage, alt: game.gameTitle })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'game-card-details' },
                                                _react2.default.createElement(
                                                    _reactstrap.CardTitle,
                                                    { className: 'game-title text-shadow' },
                                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + game.gameTitle.toUpperCase(),
                                                        defaultMessage: game.gameTitle })
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'custom-rating isFavorite' },
                                                    _react2.default.createElement('input', { id: 'fav' + game.gameId, ref: 'star' + game.gameId, className: 'isFavorite', type: 'checkbox', checked: game.isFavorite }),
                                                    _react2.default.createElement(
                                                        'label',
                                                        { htmlFor: 'fav' + game.gameId, className: 'isFavorite' },
                                                        _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : null, className: 'fa fa-star-o custom-star isFavorite' })
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-left' },
                                                    _react2.default.createElement(_reactStarRatingComponent2.default, { name: 'rate1', starCount: 5, value: game.userRating, editing: false, renderStarIcon: function renderStarIcon() {
                                                            return _react2.default.createElement('i', { style: _isGamiclub.isGamiclub ? { color: 'green' } : null, className: 'fa fa-star custom-star' });
                                                        } })
                                                ),
                                                _domainConfig.config.subDomain != 'es' && _react2.default.createElement(
                                                    'div',
                                                    { className: 'game-card-right text-uppercase text-shadow text-right' },
                                                    game.gameType == 'HTML5' ? _react2.default.createElement('i', { className: 'fa fa-html5', 'aria-hidden': 'true' }) : game.gameType == 'ANDROID' ? _react2.default.createElement('i', { className: 'fa fa-android', 'aria-hidden': 'true' }) : _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' })
                                                )
                                            )
                                        )
                                    )
                                ) : null;
                            }) : _react2.default.createElement(
                                _reactstrap.Col,
                                { xl: '12', lg: '12', md: '12', sm: '12', xs: '12' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'white-text-color no-game-text' },
                                    window.location.hash.includes('home/video') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noVideosFound', defaultMessage: 'No videos found.' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'noGamesFound', defaultMessage: 'No games found.' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SearchPage;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer,
        games: state.GamesReducer,
        categories: state.CategoryReducer,
        search: state.SearchReducer,
        flashmessage: state.FlashMessageReducer

    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getCategories: _CategoryActions.getCategories,
        getGameTypes: _CategoryActions.getGameTypes,
        getSearchGames: _GamesActions.getSearchGames,
        searchText: _SearchActions.searchText,
        showMessage: _FlashMessageActions.showMessage
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPage);

/***/ }),

/***/ "./src/components/Sidebar/Overlay.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Overlay = function (_Component) {
    _inherits(Overlay, _Component);

    function Overlay() {
        _classCallCheck(this, Overlay);

        return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
    }

    _createClass(Overlay, [{
        key: 'sidebarToggle',
        value: function sidebarToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-hidden');
            document.body.classList.toggle('sidebar-mobile-show');
        }
    }, {
        key: 'render',
        value: function render() {
            var isAdmin = this.props.isAdmin;

            return isAdmin ? null : _react2.default.createElement('div', { className: 'overlay-background', onClick: this.sidebarToggle.bind(this) });
        }
    }]);

    return Overlay;
}(_react.Component);

exports.default = Overlay;

/***/ }),

/***/ "./src/components/Sidebar/Sidebar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isIos = __webpack_require__("./node_modules/is-ios/index.js");

var _isIos2 = _interopRequireDefault(_isIos);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isGamezClan = __webpack_require__("./src/constants/isGamezClan.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _isOnlyBeemobi = __webpack_require__("./src/constants/isOnlyBeemobi.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain, kazakhDomain, frenchDomain, swedishDomain, belgiumDomain, norwayDomain, asiacellDomain, vietnamDomain, myDomain, turkeyDomain, maseDomain, spanishDomain, italianDomain, rsDomain, deDomain, roDomain;

var getContactPageURL = function getContactPageURL() {
  var onlyGamelords = !_isGamiclub.isGamiclub && !_isGamezClan.isGamezClan;
  var onlyGamiclub = _isGamiclub.isGamiclub && !_isOnlyMobbfun.isOnlyMobbfun && !_isOnlyBeemobi.isOnlyBeemobi;
  var cucaURL = "https://game-lords.com";
  if (onlyGamiclub) cucaURL = "https://gamiclub.com";
  var subdomains = ["sa", "ae", "kw", "rs"];
  if (subdomains.indexOf(_domainConfig.config.subDomain) >= 0) return cucaURL + "/customer-care/?subdomain=" + _domainConfig.config.subDomain;else return undefined;
};

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.state = {
      openAndroid: false,
      openHtml: false,
      openNotification: false,
      openLanguage: false
    };

    _this.hideSideBar = _this.hideSideBar.bind(_this);
    _this.changeDomain = _this.changeDomain.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: "handleClick",
    value: function handleClick(name, e) {
      e.preventDefault();
      switch (name) {
        case "html5":
          {
            this.setState({
              openHtml: !this.state.openHtml,
              openAndroid: false,
              openNotification: false,
              openLanguage: false
            });
            break;
          }
        case "android":
          {
            this.setState({
              openAndroid: !this.state.openAndroid,
              openHtml: false,
              openNotification: false,
              openLanguage: false
            });
            break;
          }
        case "notification":
          {
            this.setState({
              openNotification: !this.state.openNotification,
              openHtml: false,
              openAndroid: false,
              openLanguage: false
            });
            break;
          }
        case "language":
          {
            this.setState({
              openLanguage: !this.state.openLanguage,
              openHtml: false,
              openAndroid: false,
              openNotification: false
            });
            break;
          }
      }
    }
  }, {
    key: "translateCat",
    value: function translateCat(categoriesArr, lang) {
      var translatedCatArr = categoriesArr.map(function (cat) {
        var englishCat = ["Premium Games", "Action", "Adventure", "RPG", "Virtual Reality", "Arcade", "Racing", "Sports"];
        var arabicCat = ["العاب مميزه", "الاكشن", "المغامرات", "العاب ار بي جي", "الواقع الافتراضي", "مغامرات", "سباق", "الرياضه"];
        var kazakhCat = ["Премиум игры", "Экшн", "Приключения", "RPG", "Виртуальная реальность", "Аркады", "Гонки", "Спорт"];
        var frenchCat = ["Jeux Premium", "Action", "Aventure", "RPG", "Réalité virtuelle", "Arcade", "Course", "Sports"];
        var swedishCat = ["Premium-spel", "Action", "Äventyr", "RPG", "Virtual Reality", "Arkad", "Racing", "Sporter"];
        var belgiumCat = ["Premium spelletjes", "Actie", "Avontuur", "RPG", "Virtuele realiteit", "Arcade", "Racen", "Sport"];
        var norwayCat = ["Premium-spill", "Action", "Eventyr", "RPG", "Virtuell virkelighet", "Arkade", "Racing", "Sport"];
        var vietnamCat = ["Games độc quyền", "Hành động", "Phiêu lưu", "RPG", "Thực tế ảo", "Nhập vai", "Đua xe", "Thể thao"];
        var turkeyCat = ["Premium Oyunlar   ", "Aksiyon", "Macera", "RPG", "Sanal Gerçeklik", "Arcade oyun", "Yarış ", "Spor"];
        var spanishCat = ["Juegos prémium", "Acción", "Aventura", "RPG", "Realidad Virtual", "Arcade", "Correr", "Deporte"];
        var italianCat = ["Giochi premium", "Azione", "Avventura", "RPG", "Realtà virtuale", "Arcade", "Corsa", "Sport"];
        var greekCat = ["Premium παιχνίδια", "Δράση", "Περιπέτεια", "Παιχνίδια RPG", "Εικονική πραγματικότητα", "Ηλεκτρονικά παιχνίδια", "Αγώνες αυτοκινήτου", "Σπορ"];

        var index = englishCat.indexOf(cat.categoryName);
        if (index != -1) {
          if (lang == "ar") {
            cat = _extends({}, cat, { categoryNameTranslated: arabicCat[index] });
          } else if (lang == "kk") {
            cat = _extends({}, cat, { categoryNameTranslated: kazakhCat[index] });
          } else if (lang == "fr") {
            cat = _extends({}, cat, { categoryNameTranslated: frenchCat[index] });
          } else if (lang == "sv") {
            cat = _extends({}, cat, { categoryNameTranslated: swedishCat[index] });
          } else if (lang == "be") {
            cat = _extends({}, cat, { categoryNameTranslated: belgiumCat[index] });
          } else if (lang == "no") {
            cat = _extends({}, cat, { categoryNameTranslated: norwayCat[index] });
          } else if (lang == "vi") {
            cat = _extends({}, cat, { categoryNameTranslated: vietnamCat[index] });
          } else if (lang == "tr") {
            cat = _extends({}, cat, { categoryNameTranslated: turkeyCat[index] });
          } else if (lang == "es") {
            cat = _extends({}, cat, { categoryNameTranslated: spanishCat[index] });
          } else if (lang == "it") {
            cat = _extends({}, cat, { categoryNameTranslated: italianCat[index] });
          } else if (lang == "el") {
            cat = _extends({}, cat, { categoryNameTranslated: greekCat[index] });
          }
        }
        return cat;
      });
      return translatedCatArr;
    }
  }, {
    key: "hideSideBar",
    value: function hideSideBar() {
      document.body.classList.toggle("sidebar-hidden");
      document.body.classList.toggle("sidebar-mobile-show");
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.props.changeLang(event);
      this.props.changeLangAction({
        currentLang: event
      });

      this.setState({});
    }
  }, {
    key: "changeDomain",
    value: function changeDomain() {
      arabicDomain = _domainConfig.config.lang == "ar" ? true : false;
      kazakhDomain = _domainConfig.config.lang == "kk" ? true : false;
      frenchDomain = _domainConfig.config.subDomain == "ci" ? true : false;
      swedishDomain = _domainConfig.config.lang == "sv" ? true : false;
      belgiumDomain = _domainConfig.config.lang == "be" ? true : false;
      norwayDomain = _domainConfig.config.lang == "no" ? true : false;
      asiacellDomain = _domainConfig.config.subDomain == "iq" || _domainConfig.config.subDomain == "asiacell" ? true : false;
      vietnamDomain = _domainConfig.config.lang == "vi" ? true : false;
      myDomain = _domainConfig.config.subDomain == "my" ? true : false;
      turkeyDomain = _domainConfig.config.subDomain == "tr" ? true : false;
      maseDomain = _domainConfig.config.subDomain == "mase" ? true : false;
      spanishDomain = _domainConfig.config.subDomain == "es" ? true : false;
      italianDomain = _domainConfig.config.subDomain == "it" ? true : false;
      rsDomain = _domainConfig.config.subDomain == "rs" ? true : false;
      deDomain = _domainConfig.config.subDomain == "ch" ? true : false;
      roDomain = _domainConfig.config.subDomain == "ro" ? true : false;
    }
  }, {
    key: "getUnsubLink",
    value: function getUnsubLink() {
      var uid = this.props.access.uid;
      if (!uid) return "";
      if (_domainConfig.config.subDomain === "za" && _isGamiclub.isGamiclub) return "http://n.gamiclub.com/unsubscribe/za?lang=en&token=" + uid;else return "";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var url = window.location.origin;
      this.changeDomain();
      var handleClick = this.handleClick;
      var isAdmin = this.props.isAdmin;
      var navigateItem = _isGamiclub.isGamiclub ? "navigate-item-gamiclub" : _productCondition.isGameflares ? "navigate-item-gameflares" : _productCondition.isGamiway ? "navigate-item navigate-item-gamiway" : "navigate-item";

      var classNameNotif = this.state.openNotification ? navigateItem + " navigate-dropdown open" : navigateItem + " navigate-dropdown";
      classNameNotif = this.props.currentLang == "ar" ? classNameNotif + " ar" : classNameNotif;

      var classNameLang = this.state.openLanguage ? navigateItem + " navigate-dropdown open" : navigateItem + " navigate-dropdown";
      classNameLang = this.props.currentLang == "ar" ? classNameLang + " ar" : classNameLang;

      var classNameli = navigateItem;
      classNameli = this.props.currentLang == "ar" ? classNameli + " ar" : classNameli;
      var classNameSidebar = "sidebar " + (_productCondition.isGameflares ? "gameflares-sidebar-bg" : "");
      classNameSidebar = this.props.currentLang == "ar" ? classNameSidebar + " ar" : classNameSidebar;
      var uid = this.props.access.uid;
      var ppLink = void 0,
          tncLink = void 0;
      if (frenchDomain) {
        ppLink = "http://n.game-lords.com/ci/tnc-game-lords?offer=1&operator=CI_ORANGE&operatorSubmitted=Y&_next=general_conditions.html&_extracted=ef1f53a7bcfc44e2a65beaf6459f8419&_next=privacy_policy.html&_extracted=ef1f53a7bcfc44e2a65beaf6459f8419&";
        tncLink = "http://n.game-lords.com/ci/tnc-game-lords?offer=1&operator=CI_ORANGE&operatorSubmitted=Y&_next=general_conditions.html&_extracted=ef1f53a7bcfc44e2a65beaf6459f8419&";
      } else if (swedishDomain) {
        ppLink = "http://google.com"; //temporary
        tncLink = "http://google.com";
      } else if (_domainConfig.config.subDomain === "gr" && !_isGamiclub.isGamiclub && !_isAppspool.isAppspool) {
        ppLink = "https://c1.ouisys.com/static/privacy-gamelords-gr";
        tncLink = "https://c1.ouisys.com/static/terms-gamelords-gr";
      } else if (belgiumDomain) {
        ppLink = "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html", tncLink = "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=general_conditions.html";
      } else if (spanishDomain) {
        ppLink = "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html", tncLink = "http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=general_conditions.html";
      } else if (roDomain) {
        tncLink = "http://n.gamiclub.com/ro/tnc-gamiclub?offer=1";
      } else if (_domainConfig.config.subDomain === "pt" && _isGamiclub.isGamiclub) {
        tncLink = "https://c1.mouisys.com/static/terms-gamiclub-pt";
      }

      return _react2.default.createElement(
        "div",
        { className: classNameSidebar },
        _react2.default.createElement(
          "nav",
          { className: "sidebar-navigate" },
          _react2.default.createElement(
            "a",
            {
              href: _domainConfig.config.subDomain === "za" && _isGamiclub.isGamiclub ? undefined : (0, _helper.appendUid)("/#/account", uid),
              onClick: this.hideSideBar
            },
            _react2.default.createElement(
              "div",
              { className: "profile" },
              _react2.default.createElement("img", {
                className: "profile__image",
                src: this.props.account.user.profilePic ? this.props.account.user.profilePic : "./img/avatar.png",
                alt: this.props.account.user.name
              }),
              _domainConfig.config.subDomain === "za" && _isGamiclub.isGamiclub ? null : _react2.default.createElement(
                "p",
                { className: "profile__name" },
                this.props.account.user.name
              )
            )
          ),
          isAdmin ? _react2.default.createElement(
            "ul",
            { className: "navigate" },
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/welcome", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-home" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "sidebar.home",
                    defaultMessage: "Home",
                    description: "Sidebar text"
                  })
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/domain", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-cogs" }),
                _react2.default.createElement(
                  "span",
                  null,
                  "Domain"
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/country", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-globe" }),
                _react2.default.createElement(
                  "span",
                  null,
                  "Country"
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/manage-categories", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-filter" }),
                _react2.default.createElement(
                  "span",
                  null,
                  "Manage Categories"
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/uploads", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-upload" }),
                _react2.default.createElement(
                  "span",
                  null,
                  "Upload"
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/manage-user", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-users" }),
                _react2.default.createElement(
                  "span",
                  null,
                  "Manage Users"
                )
              )
            )
          ) : _react2.default.createElement(
            "ul",
            { className: "navigate" },
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: swedishDomain || maseDomain || myDomain || _domainConfig.config.subDomain == "th" || _domainConfig.config.subDomain === "rsma" || window.location.hostname.includes('game-lords.com') && _domainConfig.config.subDomain === 'ae' ? (0, _helper.appendUid)("/#/home/html", uid) : _domainConfig.config.subDomain == "pk" ? (0, _helper.appendUid)("/#/home/android", uid) : (0, _helper.appendUid)("/#/welcome", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-home" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "sidebar.home",
                    defaultMessage: "Home",
                    description: "Sidebar text"
                  })
                )
              )
            ),
            _domainConfig.config.subDomain === "za" && _isGamiclub.isGamiclub ? null : _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/account", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-user-circle-o" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "sidebar.myaccount",
                    defaultMessage: "My Account",
                    description: "Sidebar text"
                  })
                )
              )
            ),
            _react2.default.createElement(
              "li",
              { className: classNameNotif },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  onClick: handleClick.bind(this, "notification")
                },
                _react2.default.createElement("i", { className: "fa fa-bell" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(
                    "div",
                    { className: "notif" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "sidebar.notif",
                      defaultMessage: "Notification"
                    }),
                    _react2.default.createElement("i", { className: "expand" })
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "navigate-dropdown-items" },
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    { className: "navigate-link" },
                    _react2.default.createElement(
                      "span",
                      null,
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.nonotif",
                        defaultMessage: "You have no notifications yet"
                      })
                    )
                  )
                )
              )
            ),
            _domainConfig.config.subDomain !== "pk" && _react2.default.createElement(
              "li",
              {
                className: this.props.currentLang == "ar" ? navigateItem + " navigate-dropdown ar" : navigateItem + " navigate-dropdown"
              },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  href: (0, _helper.appendUid)("/#/home/html", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-html5" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "html5games",
                    defaultMessage: "HTML5 Games"
                  })
                )
              )
            ),
            maseDomain || myDomain || _domainConfig.config.subDomain == "th" || _domainConfig.config.subDomain === "rsma" || _domainConfig.config.subDomain === "maae" || window.location.hostname.includes('game-lords.com') && _domainConfig.config.subDomain === 'ae' || _domainConfig.config.subDomain === "za" && _isIos2.default ? "" : _react2.default.createElement(
              "li",
              {
                className: this.props.currentLang == "ar" ? navigateItem + " navigate-dropdown ar" : navigateItem + " navigate-dropdown"
              },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  href: (0, _helper.appendUid)("/#/home/android", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-android" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "androidGames",
                    defaultMessage: "ANDROID Games"
                  })
                )
              )
            ),
            (_isGamiclub.isGamiclub || _productCondition.isGamiway) && !(_isOnlyMobbfun.isOnlyMobbfun && _domainConfig.config.subDomain === "id") && !(window.location.hostname.includes('game-lords.com') && _domainConfig.config.subDomain === 'ae') && _domainConfig.config.subDomain !== "rsma" || _domainConfig.config.subDomain === "kw" || _domainConfig.config.subDomain === "pt" ? _react2.default.createElement(
              "li",
              {
                className: this.props.currentLang == "ar" ? navigateItem + " navigate-dropdown ar" : navigateItem + " navigate-dropdown"
              },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  href: (0, _helper.appendUid)("/#/home/video", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-video-camera" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "videos", defaultMessage: "VIDEOS" })
                )
              )
            ) : null,
            _domainConfig.config.subDomain == "sa" && !_isGamezClan.isGamezClan && _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: "http://sa.vidzclubs.com/?uid=fdf098fcc6",
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-play" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "vod",
                    defaultMessage: "Video-on-Demand"
                  })
                )
              )
            ),
            getContactPageURL() ? _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: getContactPageURL(),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-question" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "help", defaultMessage: "Contact Us" })
                )
              )
            ) : null,
            _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/favorites", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-star" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "favorite", defaultMessage: "Favorite" })
                )
              )
            ),
            _domainConfig.config.subDomain === "dz" ? _react2.default.createElement(
              "li",
              { className: classNameLang },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  onClick: handleClick.bind(this, "language")
                },
                _react2.default.createElement("i", { className: "fa fa-language" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(
                    "div",
                    { className: "langdropdown" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "sidebar.lang",
                      defaultMessage: "Languages"
                    }),
                    _react2.default.createElement("i", { className: "expand" })
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "navigate-dropdown-items" },
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("ar");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "ar" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.ar",
                        defaultMessage: "ar"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("fr");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "fr" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.fr",
                        defaultMessage: "fr"
                      })
                    )
                  )
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "be" ? _react2.default.createElement(
              "li",
              { className: classNameLang },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  onClick: handleClick.bind(this, "language")
                },
                _react2.default.createElement("i", { className: "fa fa-language" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(
                    "div",
                    { className: "langdropdown" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "sidebar.lang",
                      defaultMessage: "Languages"
                    }),
                    _react2.default.createElement("i", { className: "expand" })
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "navigate-dropdown-items" },
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("be");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "be" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.be",
                        defaultMessage: "Dutch"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("fr");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "fr" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.fr",
                        defaultMessage: "French"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("de");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "de" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.de",
                        defaultMessage: "German"
                      })
                    )
                  )
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "eg" ? _react2.default.createElement(
              "li",
              { className: classNameLang },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  onClick: handleClick.bind(this, "language")
                },
                _react2.default.createElement("i", { className: "fa fa-language" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(
                    "div",
                    { className: "langdropdown" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "sidebar.lang",
                      defaultMessage: "Languages"
                    }),
                    _react2.default.createElement("i", { className: "expand" })
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "navigate-dropdown-items" },
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("ar");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "ar" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.ar",
                        defaultMessage: "Arabic"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("en");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "en" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.en",
                        defaultMessage: "English"
                      })
                    )
                  )
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "ch" ? _react2.default.createElement(
              "li",
              { className: classNameLang },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  onClick: handleClick.bind(this, "language")
                },
                _react2.default.createElement("i", { className: "fa fa-language" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(
                    "div",
                    { className: "langdropdown" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "sidebar.lang",
                      defaultMessage: "Languages"
                    }),
                    _react2.default.createElement("i", { className: "expand" })
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "navigate-dropdown-items" },
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("fr");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "fr" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.fr",
                        defaultMessage: "French"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("de");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "de" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.de",
                        defaultMessage: "German"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("it");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "it" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.it",
                        defaultMessage: "Italian"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("en");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "en" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.en",
                        defaultMessage: "English"
                      })
                    )
                  )
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "pl" ? _react2.default.createElement(
              "li",
              { className: classNameLang },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link navigate-dropdown-toggle",
                  onClick: handleClick.bind(this, "language")
                },
                _react2.default.createElement("i", { className: "fa fa-language" }),
                _react2.default.createElement(
                  "span",
                  { className: "children" },
                  _react2.default.createElement(
                    "div",
                    { className: "langdropdown" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "sidebar.lang",
                      defaultMessage: "Languages"
                    }),
                    _react2.default.createElement("i", { className: "expand" })
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "navigate-dropdown-items" },
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("pl");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "pl" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.pl",
                        defaultMessage: "Polish"
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: classNameli },
                  _react2.default.createElement(
                    "a",
                    {
                      className: "navigate-link",
                      onClick: function onClick() {
                        return _this2.handleChange("en");
                      }
                    },
                    _react2.default.createElement(
                      "span",
                      {
                        className: this.props.currentLang == "en" ? "activeLang" : ""
                      },
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "sidebar.lang.en",
                        defaultMessage: "English"
                      })
                    )
                  )
                )
              )
            ) : null,
            _react2.default.createElement("li", {
              style: _isGamiclub.isGamiclub ? { backgroundColor: "green" } : _productCondition.isGameflares ? { backgroundColor: "#FF394B" } : null,
              className: arabicDomain || kazakhDomain || norwayDomain || vietnamDomain || turkeyDomain || spanishDomain || rsDomain || url.indexOf("dz") >= 0 || italianDomain ? "" : "divider"
            }),
            _domainConfig.config.subDomain === "za" && !(_isAppspool.isAppspool || _productCondition.isGameflares || _isGamezClan.isGamezClan || _productCondition.isGamiway || _isTheGamingClubs.isTheGamingClubs) && _react2.default.createElement(
              "li",
              { className: classNameli, style: { padding: "0.5rem 0" } },
              _react2.default.createElement(
                "span",
                {
                  style: {
                    marginLeft: "9%"
                  }
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "unsubscribe-ZA",
                  defaultMessage: "To unsubscribe, dial 135*997#"
                })
              )
            )
            //   <li className={classNameli}>
            //                 <a className='navigate-link' onClick={(e) => {
            //                     e.preventDefault();
            //                     const unsublink = this.getUnsubLink()
            //                     if(unsublink) window.location = unsublink
            //                 }}>
            //                     <i className='fa fa-ban'></i>
            //                     <span>
            //                         <FormattedMessage id="unsubscribe" defaultMessage="Unsubscribe" />
            //                     </span>
            //                 </a>
            //         </li>
            ,
            _react2.default.createElement(
              "li",
              { className: classNameli },
              arabicDomain || kazakhDomain || norwayDomain || vietnamDomain || turkeyDomain || spanishDomain || url.indexOf("dz") >= 0 || italianDomain || _domainConfig.config.subDomain === "eg" || _domainConfig.config.subDomain === "be" && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "pe" ? _react2.default.createElement("span", null) : frenchDomain || swedishDomain || belgiumDomain && !_isGamiclub.isGamiclub ? _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  onClick: function onClick(e) {
                    window.location = ppLink;
                  }
                },
                _react2.default.createElement("i", { className: "fa fa-lock" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "privacyPolicy",
                    defaultMessage: "Policy Privacy"
                  })
                )
              ) : _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/privacy-policy", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-lock" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "privacyPolicy",
                    defaultMessage: "Policy Privacy"
                  })
                )
              )
            ),
            _domainConfig.config.subDomain === "ch" && _domainConfig.config.lang === "de" ? _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/agb", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-lock" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "agb", defaultMessage: "AGB" })
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "ch" && _domainConfig.config.lang === "de" ? _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/hilfe", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-lock" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "hilfe", defaultMessage: "Hilfe" })
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "ch" && _domainConfig.config.lang === "de" ? _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/impressum", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-lock" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "impressum",
                    defaultMessage: "Impressum"
                  })
                )
              )
            ) : null,
            _domainConfig.config.subDomain === "ch" && _domainConfig.config.lang === "de" ? _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/abo-verwaltung", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-lock" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "aboVerwaltung",
                    defaultMessage: "Abo Verwaltung"
                  })
                )
              )
            ) : null,
            _react2.default.createElement(
              "li",
              { className: classNameli },
              arabicDomain || kazakhDomain || norwayDomain || vietnamDomain || turkeyDomain || spanishDomain || _domainConfig.config.subDomain === "dz" || italianDomain || deDomain || _domainConfig.config.subDomain === "eg" || _domainConfig.config.subDomain === "gr" && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "cz" || _domainConfig.config.subDomain === "be" && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "pe" || _domainConfig.config.subDomain === "nl" && _isGamiclub.isGamiclub || _domainConfig.config.subDomain === "sn" && _isGamiclub.isGamiclub ? _react2.default.createElement("span", null) : frenchDomain || swedishDomain || belgiumDomain && !_isGamiclub.isGamiclub || _domainConfig.config.subDomain === "gr" && !_isGamiclub.isGamiclub && !_isAppspool.isAppspool || _domainConfig.config.subDomain === "pt" && _isGamiclub.isGamiclub ? _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  onClick: function onClick(e) {
                    window.location = tncLink;
                  }
                },
                _react2.default.createElement("i", { className: "fa fa-file-text-o" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Conditions"
                  })
                )
              ) : _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("#/terms-conditions", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-file-text-o" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "tnc",
                    defaultMessage: "Terms & Conditions"
                  })
                )
              )
            ),
            _domainConfig.config.subDomain === "gr" && _productCondition.isGamelords && _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/contact-us", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-file-text-o" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "sidebar.contact",
                    defaultMessage: "Contact Us",
                    description: "Sidebar text"
                  })
                )
              )
            ),
            _domainConfig.config.subDomain === "gr" && _productCondition.isGamelords && _react2.default.createElement(
              "li",
              { className: classNameli },
              _react2.default.createElement(
                "a",
                {
                  className: "navigate-link",
                  href: (0, _helper.appendUid)("/#/faq", uid),
                  onClick: this.hideSideBar
                },
                _react2.default.createElement("i", { className: "fa fa-file-text-o" }),
                _react2.default.createElement(
                  "span",
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "sidebar.faq",
                    defaultMessage: "Faq",
                    description: "Sidebar text"
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    categories: state.CategoryReducer,
    account: state.AccountReducer,
    access: state.WelcomeReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    changeLangAction: _WelcomeActions.changeLangAction
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Sidebar);

/***/ }),

/***/ "./src/components/SplashScreen/SplashScreen.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _SplashScreenActions = __webpack_require__("./src/actions/SplashScreenActions.js");

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _domainTheme = __webpack_require__("./src/utils/domainTheme.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SplashScreen = function (_Component) {
    _inherits(SplashScreen, _Component);

    function SplashScreen(props) {
        _classCallCheck(this, SplashScreen);

        return _possibleConstructorReturn(this, (SplashScreen.__proto__ || Object.getPrototypeOf(SplashScreen)).call(this, props));
    }

    _createClass(SplashScreen, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var uid = (0, _helper.getParameters)("uid");
            var msisdn = (0, _helper.getParameters)("msisdn");
            var rid = (0, _helper.getParameters)("rid");
            var id = (0, _helper.getParameters)("id");
            var is_staging = (0, _helper.getParameters)("is_staging");
            var search = {};
            if (uid.exist) {
                this.props.addUid({ uid: uid.value });
            }
            if (is_staging.exist) search = _extends({}, search, { is_staging: is_staging.value });
            if (this.props.location.pathname === '/') {
                if (_domainConfig.config.subDomain === "kw" && _isGamiclub.isGamiclub && id.exist) {
                    search = _extends({}, search, { id: id.value });
                    this.props.history.push({
                        pathname: "/welcome",
                        search: _querystring2.default.stringify(search)
                    });
                } else if (_domainConfig.config.subDomain === "za" && uid.exist && rid.exist) {
                    search = _extends({}, search, { uid: uid.value, rid: rid.value });
                    this.props.history.push({
                        pathname: "/welcome",
                        search: _querystring2.default.stringify(search)
                    });
                } else if (_domainConfig.config.subDomain === "sa" && !_isGamiclub.isGamiclub && id.exist) {
                    search = _extends({}, search, { id: id.value });
                    this.props.history.push({
                        pathname: "/welcome",
                        search: _querystring2.default.stringify(search)
                    });
                } else if (_domainConfig.config.subDomain == 'mase' || _domainConfig.config.subDomain == 'th' || _domainConfig.config.subDomain === "rsma" || window.location.hostname.includes('game-lords.com') && _domainConfig.config.subDomain === 'ae' || window.location.hostname.includes('vplay')) {
                    search = _extends({}, search, { uid: uid.value });
                    this.props.history.push({
                        pathname: "/home/html",
                        search: _querystring2.default.stringify(search)
                    });
                } else if (_domainConfig.config.subDomain == 'pk') {
                    search = _extends({}, search, { uid: uid.value });
                    this.props.history.push({
                        pathname: "/home/android",
                        search: _querystring2.default.stringify(search)
                    });
                } else if (msisdn.exist) {
                    search = _extends({}, search, { msisdn: msisdn.value });
                    this.props.history.push({
                        pathname: "/welcome",
                        search: _querystring2.default.stringify(search)
                    });
                } else if (rid.exist) {
                    search = _extends({}, search, { rid: rid.value });
                    this.props.history.push({
                        pathname: "/welcome",
                        search: _querystring2.default.stringify(search)
                    });
                } else {
                    search = _extends({}, search, { uid: uid.value });
                    this.props.history.push({
                        pathname: "/welcome",
                        search: _querystring2.default.stringify(search)
                    });
                }
            } else {
                this.props.history.push(this.props.location.pathname + this.props.location.search);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var theme = (0, _domainTheme.getDomainTheme)();
            var className = "splash-screen";
            if (this.props.splash.hideSplash) {
                className += " hidden";
            }
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: 'splash-screen__image-wrap' },
                    _react2.default.createElement('img', { className: 'splash-screen__image img-fluid', src: theme.logo, alt: theme.productName })
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'splash-screen__text' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'splashscreen.text',
                        defaultMessage: 'Play Way Beyond',
                        description: 'Splashscreen text'
                    })
                )
            );
        }
    }]);

    return SplashScreen;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer,
        splash: state.SplashScreenReducer,
        account: state.AccountReducer

    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getCategories: _CategoryActions.getCategories,
        getGames: _GamesActions.getGames,
        hideSplash: _SplashScreenActions.hideSplash,
        checkAccess: _WelcomeActions.checkAccess,
        addUid: _WelcomeActions.addUid,
        getDetails: _AccountActions.getDetails,
        getInterests: _AccountActions.getInterests
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SplashScreen);

/***/ }),

/***/ "./src/components/StaticPages/AGB.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AGB = function (_Component) {
    _inherits(AGB, _Component);

    function AGB() {
        _classCallCheck(this, AGB);

        return _possibleConstructorReturn(this, (AGB.__proto__ || Object.getPrototypeOf(AGB)).apply(this, arguments));
    }

    _createClass(AGB, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _sendData.sendData)('', '', '', 'viewed', { page: 'agb' });
            window.scrollTo(0, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'terms privacy-policy' },
                _react2.default.createElement(
                    _reactstrap.Container,
                    { fluid: true },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'terms-title-wrap' },
                                _react2.default.createElement(
                                    'h2',
                                    { className: 'terms-section-title' },
                                    'Gesch\xE4ftsbedingungen'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.Row,
                        { className: 'no-gutters' },
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'AGB'
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                '1. Geltungbereich'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Die nachstehenden Allgemeinen Gesch\xE4ftsbedingungen sind Bestandteil eines jeden Vertrags zwischen der, Sam Media (im Folgenden: Anbieter) und dem Nutzer der Leistungen des Anbieters. An diese Allgemeinen Gesch\xE4ftsbedingungen sind auch die Rechtsnachfolger des Anbieters sowie die des Nutzers gebunden.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Anbieter stellt dem Nutzer gegen Entgelt die M\xF6glichkeit zur Verf\xFCgung, die auf der Webseite angebotenen Inhalte \xFCber sein mobiles Endger\xE4t (Mobiltelefon) abzurufen und zu nutzen. Gegenstand dieser Allgemeinen Gesch\xE4ftsbedingungen sind s\xE4mtliche diesbez\xFCglich zwischen den Vertragsparteien zu treffende Regelungen.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Diese Allgemeinen Gesch\xE4ftsbedingungen gelten ausschliesslich f\xFCr Nutzer aus der Schweiz.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Anbieter erbringt seine Leistungen ausschliesslich auf der Grundlage dieser Allgemeinen Gesch\xE4ftsbedingungen.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Die G\xFCltigkeit dieser Allgemeinen Gesch\xE4ftsbedingungen erstreckt sich auf alle auf der Webseite angebotenen Leistungen des Anbieters. Der Nutzer erkennt mit der Inanspruchnahme der Leistungen des Anbieters diese Allgemeinen Gesch\xE4ftsbedingungen als f\xFCr ihn verbindlich an.'
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                '2. Vertragsschluss'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Die Pr\xE4sentation der Leistungen des Anbieters auf der Webseite von stellt noch kein bindendes Angebot des Anbieters, sondern lediglich eine Aufforderung zur Abgabe eines Angebots durch den Nutzer dar.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Vertrag kommt durch die Aktivierung des auf dem mobilen Endger\xE4t des Nutzers nach Aufruf einer Leistung des Anbieters angezeigten Best\xE4tigungs- bzw. Abspielbuttons durch den Nutzer und die darauf folgende Einrichtung der Gesch\xE4ftsbedingungen der Leistungen durch den Anbieter zustande.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Nutzer kann unmittelbar nach der Einrichtung der Nutzungsm\xF6glichkeit s\xE4mtliche auf der Webseite angebotenen Leistungen \xFCber sein mobiles Endger\xE4t abrufen und nutzen.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Es gelten die dem Nutzer mitgeteilten Preise. Diese beinhalten die gesetzliche Mehrwertsteuer, gelten f\xFCr den jeweils angegebenen Zeitraum und beziehen sich lediglich auf die Einr\xE4umung der Nutzungsm\xF6glichkeit der Leistungen des Anbieters. Nicht von den Preisen umfasst sind im Rahmen des Abrufs der Leistungen des Anbieters entstehende Verbindungsgeb\xFChren, die dem Nutzer von seinem Mobilfunkanbieter berechnet werden.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Das seitens des Nutzers f\xFCr die Inanspruchnahme der Leistungen des Anbieters zu entrichtende Entgelt wird sofort mit Vertragsschluss und ohne Abzug f\xE4llig. Dieses Entgelt wird im Auftrag des Anbieters seitens des Mobilfunkanbieters des Nutzers im Rahmen der turnusm\xE4ssigen Abrechnung eingezogen.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Nutzer erh\xE4lt an den von dem Anbieter zur Verf\xFCgung gestellten Leistungen ein einfaches, nicht \xFCbertragbares, zeitlich auf die Dauer dieses Vertrags begrenztes, \xF6rtlich unbeschr\xE4nktes Nutzungsrecht.'
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                '3. Zahlungsbedingungen'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Es gelten die dem Nutzer mitgeteilten Preise. Diese beinhalten die gesetzliche Mehrwertsteuer, gelten f\xFCr den jeweils angegebenen Zeitraum und beziehen sich lediglich auf die Einr\xE4umung der Nutzungsm\xF6glichkeit der Leistungen des Anbieters. Nicht von den Preisen umfasst sind im Rahmen des Abrufs der Leistungen des Anbieters entstehende Verbindungsgeb\xFChren, die dem Nutzer von seinem Mobilfunkanbieter berechnet werden.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Das seitens des Nutzers f\xFCr die Inanspruchnahme der Leistungen des Anbieters zu entrichtende Entgelt wird sofort mit Vertragsschluss und ohne Abzug f\xE4llig. Dieses Entgelt wird im Auftrag des Anbieters seitens des Mobilfunkanbieters des Nutzers im Rahmen der turnusm\xE4ssigen Abrechnung eingezogen.'
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                '4. Nutzungsrechte'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Nutzer erh\xE4lt an den von dem Anbieter zur Verf\xFCgung gestellten Leistungen ein einfaches, nicht \xFCbertragbares, zeitlich auf die Dauer dieses Vertrags begrenztes, \xF6rtlich unbeschr\xE4nktes Nutzungsrecht.'
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                '5. Erreichbarkeit'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Anbieter gew\xE4hrleistet eine Erreichbarkeit der von ihm zur Verf\xFCgung gestellten Leistungen von 99,5 % im Jahresdurchschnitt. Sollte eine solche Erreichbarkeit nicht gegeben sein, kann der Nutzer gegen\xFCber dem Anbieter ein Minderungsrecht geltend machen. Dieses ist der H\xF6he nach auf den Betrag begrenzt, den der Nutzer w\xE4hrend des Zeitraums, in dem die gew\xE4hrleistete Erreichbarkeit nicht vorlag, aufgrund dieses Vertrags zu entrichten hatte.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'Der Anbieter gestaltet sein Angebot unter Einhaltung der am Markt vorhandenen technischen Standards und versucht hierdurch sicher zu stellen, dass der Nutzer die Leistungen des Anbieters in Anspruch nehmen kann. Der Anbieter kann jedoch nicht garantieren, dass die von ihm angebotenen Leistungen mittels s\xE4mtlicher am Markt befindlicher mobiler Endger\xE4te abrufbar sind.'
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'terms-list' },
                            _react2.default.createElement(
                                'h6',
                                { className: 'terms-title' },
                                '6. Haftungsbeschr\xE4nkung / Haftungsfreistellung'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'terms-para' },
                                'F\xFCr andere als durch Verletzung von Leben, K\xF6rper und Gesundheit entstehende Sch\xE4den haftet der Anbieter lediglich, soweit diese auf vors\xE4tzlichem oder grob fahrl\xE4ssigem Verhalten des Anbieters, seiner Mitarbeiter oder seiner Erf\xFCllungsgehilfen beruhen. Dies gilt auch f\xFCr Sch\xE4den aus der Verletzung von Pflichten bei Vertragsverhandlungen sowie aus der Vornahme von unerlaubten Handlungen. Eine dar\xFCber'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AGB;
}(_react.Component);

exports.default = AGB;

/***/ }),

/***/ "./src/components/StaticPages/AboVerwaltung.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AboVerwaltung = function (_Component) {
	_inherits(AboVerwaltung, _Component);

	function AboVerwaltung() {
		_classCallCheck(this, AboVerwaltung);

		return _possibleConstructorReturn(this, (AboVerwaltung.__proto__ || Object.getPrototypeOf(AboVerwaltung)).apply(this, arguments));
	}

	_createClass(AboVerwaltung, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			(0, _sendData.sendData)('', '', '', 'viewed', { page: 'abo-verwaltung' });
			window.scrollTo(0, 0);
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'section',
				{ className: 'terms privacy-policy' },
				_react2.default.createElement(
					_reactstrap.Container,
					{ fluid: true },
					_react2.default.createElement(
						_reactstrap.Row,
						null,
						_react2.default.createElement(
							_reactstrap.Col,
							{ xs: '12' },
							_react2.default.createElement(
								'div',
								{ className: 'terms-title-wrap' },
								_react2.default.createElement(
									'h2',
									{ className: 'terms-section-title' },
									'Abonnement verwalten'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactstrap.Row,
						{ className: 'no-gutters' },
						_react2.default.createElement(
							_reactstrap.Col,
							{ xs: '12', className: 'terms-list' },
							_react2.default.createElement(
								'p',
								{ className: 'terms-para' },
								'Abo Verwaltung'
							),
							_react2.default.createElement(
								'p',
								{ className: 'terms-para' },
								'Sie k\xF6nnen das Abonnement jederzeit unter der telefonischen Hotline: 044 5816 275 oder beim E-Mail-Support ',
								_react2.default.createElement(
									'a',
									{ href: 'mailto:gamelords.ch@silverlines.info' },
									'gamelords.ch@silverlines.info'
								)
							)
						)
					)
				)
			);
		}
	}]);

	return AboVerwaltung;
}(_react.Component);

exports.default = AboVerwaltung;

/***/ }),

/***/ "./src/components/StaticPages/Hilfe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hilfe = function (_Component) {
	_inherits(Hilfe, _Component);

	function Hilfe() {
		_classCallCheck(this, Hilfe);

		return _possibleConstructorReturn(this, (Hilfe.__proto__ || Object.getPrototypeOf(Hilfe)).apply(this, arguments));
	}

	_createClass(Hilfe, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			(0, _sendData.sendData)('', '', '', 'viewed', { page: 'hilfe' });
			window.scrollTo(0, 0);
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'section',
				{ className: 'terms privacy-policy' },
				_react2.default.createElement(
					_reactstrap.Container,
					{ fluid: true },
					_react2.default.createElement(
						_reactstrap.Row,
						null,
						_react2.default.createElement(
							_reactstrap.Col,
							{ xs: '12' },
							_react2.default.createElement(
								'div',
								{ className: 'terms-title-wrap' },
								_react2.default.createElement(
									'h2',
									{ className: 'terms-section-title' },
									'Hilfe'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactstrap.Row,
						{ className: 'no-gutters' },
						_react2.default.createElement(
							_reactstrap.Col,
							{ xs: '12', className: 'terms-list' },
							_react2.default.createElement(
								'p',
								{ className: 'terms-para' },
								'Sollten Sie noch Fragen haben, dann k\xF6nnen Sie Kontakt mit uns unter ',
								_react2.default.createElement(
									'a',
									{ href: 'mailto: gamelords.ch@silverlines.info' },
									'gamelords.ch@silverlines.info'
								),
								' Aufnehmen. Bitte vergessen Sie nicht, Ihre Handynummer anzugeben. Wir setzen uns so schnell wie m\xF6glich mit Ihnen in Verbindung! Telefonnummer Helpdesk: 044 5816 275'
							)
						)
					)
				)
			);
		}
	}]);

	return Hilfe;
}(_react.Component);

exports.default = Hilfe;

/***/ }),

/***/ "./src/components/StaticPages/Impressum.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Impressum = function (_Component) {
  _inherits(Impressum, _Component);

  function Impressum() {
    _classCallCheck(this, Impressum);

    return _possibleConstructorReturn(this, (Impressum.__proto__ || Object.getPrototypeOf(Impressum)).apply(this, arguments));
  }

  _createClass(Impressum, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _sendData.sendData)('', '', '', 'viewed', { page: 'impressum' });
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'section',
        { className: 'terms privacy-policy' },
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12' },
              _react2.default.createElement(
                'div',
                { className: 'terms-title-wrap' },
                _react2.default.createElement(
                  'h2',
                  { className: 'terms-section-title' },
                  'Impressum'
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactstrap.Row,
            { className: 'no-gutters' },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: '12', className: 'terms-list' },
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Silver Lines'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Van Diemenstraat 356'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                '1013CR Amsterdam'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Niederlande'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'Phone: 044 5816 275'
              ),
              _react2.default.createElement(
                'p',
                { className: 'terms-para' },
                'E-mail: ',
                _react2.default.createElement(
                  'a',
                  { href: 'mailto:gamelords.ch@silverlines.info' },
                  'ggamelords.ch@silverlines.info'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Impressum;
}(_react.Component);

exports.default = Impressum;

/***/ }),

/***/ "./src/components/StaticPages/SubscriptionPageMaxis.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriptionPlan = function (_Component) {
    _inherits(SubscriptionPlan, _Component);

    function SubscriptionPlan() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SubscriptionPlan);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscriptionPlan.__proto__ || Object.getPrototypeOf(SubscriptionPlan)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubscribe = function () {
            window.location.href = "http://m.gamiclub.com/my/my-test-gmc?offer=1";
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SubscriptionPlan, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _sendData.sendData)('', '', '', 'viewed', { page: 'subscription-plan' });
            window.scrollTo(0, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'subscription-plan' },
                _react2.default.createElement(
                    _reactstrap.Container,
                    { fluid: true },
                    _react2.default.createElement(
                        _reactstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'subscription-title-wrap' },
                                _react2.default.createElement(
                                    'h2',
                                    { className: 'subscription-section-title' },
                                    'Subscribe to continue'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.Row,
                        { className: 'no-gutters' },
                        _react2.default.createElement(
                            _reactstrap.Col,
                            { xs: '12', className: 'subscription-details' },
                            _react2.default.createElement(
                                'p',
                                { className: 'subscription-para' },
                                'Subscribe now and enjoy unlimited access to Gamiclub.'
                            ),
                            _react2.default.createElement(
                                _reactstrap.Button,
                                { color: 'primary', className: 'subscription-button', onClick: this.handleSubscribe },
                                'Subscribe - RM 8.00 per week'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SubscriptionPlan;
}(_react.Component);

exports.default = SubscriptionPlan;

/***/ }),

/***/ "./src/components/Terms/Terms.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Terms = function (_Component) {
  _inherits(Terms, _Component);

  function Terms() {
    _classCallCheck(this, Terms);

    return _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).apply(this, arguments));
  }

  _createClass(Terms, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _sendData.sendData)("", "", "", "viewed", { page: "terms-&-conditions" });
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      if (_domainConfig.config.subDomain === "rs") {
        return _react2.default.createElement(
          "section",
          { className: "terms" },
          _react2.default.createElement(
            _reactstrap.Container,
            { fluid: true },
            _react2.default.createElement(
              _reactstrap.Row,
              null,
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12" },
                _react2.default.createElement(
                  "div",
                  { className: "terms-title-wrap" },
                  _react2.default.createElement(
                    "h2",
                    { className: "terms-section-title" },
                    "\u0423\u0441\u043B\u043E\u0432\u0438 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430"
                  ),
                  _react2.default.createElement(
                    "p",
                    {
                      className: "terms-para",
                      style: { textAlign: "center", fontSize: "14px" }
                    },
                    "\u041F\u043E\u0441\u0435\u0442\u0438\u043B\u0430\u0446 - \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0459\u0430 \u043E\u0441\u043E\u0431\u0443 \u043A\u043E\u0458\u0430 \u043F\u043E\u0441\u0435\u045B\u0443\u0458\u0435 \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0443 \u043A\u043E\u0458\u0430 \u0440\u0435\u043A\u043B\u0430\u043C\u0438\u0440\u0430 \u0443\u0441\u043B\u0443\u0433\u0443 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0437\u0430 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0435 (\u0448\u0442\u0430\u043C\u043F\u0430, \u0422\u0412 \u0438 \u0440\u0430\u0434\u0438\u043E)."
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "no-gutters" },
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "\u0422\u043E\u043A \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0435:"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-list" },
                  "- \u043A\u0440\u0430\u0458\u045A\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0442\u0440\u0435\u0431\u0430 \u0434\u0430 \u0443\u043D\u0435\u0441\u0435 \u0441\u0432\u043E\u0458 \u0431\u0440\u043E\u0458 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043D\u0430 \u043E\u0434\u0440\u0435\u0434\u0438\u0448\u043D\u043E\u0458 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-list" },
                  "- \u043A\u0440\u0430\u0458\u045A\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u045B\u0435 \u0437\u0430\u0442\u0438\u043C \u0434\u043E\u0431\u0438\u0442\u0438 \u0458\u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u0438 \u0458\u0435\u0434\u043D\u043E\u043A\u0440\u0430\u0442\u043D\u0438 \u043F\u0438\u043D"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-list" },
                  "- \u043D\u0430\u043A\u043E\u043D \u0448\u0442\u043E \u0443\u043D\u0435\u0441\u0435 \u0458\u0435\u0434\u043D\u043E\u043A\u0440\u0430\u0442\u043D\u0438 \u043F\u0438\u043D \u043D\u0430 \u043E\u0434\u0440\u0435\u0434\u0438\u0448\u043D\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0441\u0435 \u043F\u0440\u0438\u0458\u0430\u0432\u0459\u0443\u0458\u0435 \u043D\u0430 \u043D\u0430\u0448\u0443 \u0443\u0441\u043B\u0443\u0433\u0443"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-list" },
                  "- \u043A\u0440\u0430\u0458\u045A\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u045B\u0435 \u0434\u043E\u0431\u0438\u0442\u0438 \u043F\u043E\u0440\u0443\u043A\u0443 \u0434\u043E\u0431\u0440\u043E\u0434\u043E\u0448\u043B\u0438\u0446\u0435 \u0438 \u043E\u0434\u043C\u0430\u0445 \u0437\u0430\u0442\u0438\u043C \u043F\u043E\u0440\u0443\u043A\u0443 \u043A\u0430 \u0441\u0430\u0434\u0440\u0436\u0430\u0458\u0443, \u043A\u0430\u043A\u043E \u0431\u0438 \u043C\u043E\u0433\u0430\u043E \u0434\u0430 \u0443\u0436\u0438\u0432\u0430 \u0443 \u043D\u0430\u0448\u0435\u043C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0443"
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "1. \u0418\u0417\u0408\u0410\u0412\u0410 \u041E \u041F\u0420\u0418\u0412\u0410\u0422\u041D\u041E\u0421\u0422\u0418"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0417\u0430\u0448\u0442\u0438\u0442\u0430 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0437\u0430 \u043D\u0430\u0441 \u0458\u0435 \u0432\u0430\u0436\u043D\u0430. \u0417\u0430 \u043F\u043E\u043D\u0443\u0452\u0435\u043D\u0435 \u0443\u0441\u043B\u0443\u0433\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E, \u043E\u0431\u0440\u0430\u0452\u0443\u0458\u0435\u043C\u043E \u0438\u043B\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u043C\u043E \u043B\u0438\u0447\u043D\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430, \u043A\u0430\u043E \u0448\u0442\u043E \u0458\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u043E \u0443 \u043D\u0430\u0440\u0435\u0434\u043D\u0438\u043C \u0447\u043B\u0430\u043D\u0446\u0438\u043C\u0430. \u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u0441\u043A\u0438 \u043F\u043E\u0434\u0430\u0446\u0438 \u0441\u0443 \u043F\u043E\u0434\u0430\u0446\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u043A\u043E\u0458\u0438 \u0443\u0441\u043B\u0443\u0433\u0443 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u0458\u0443 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0435\u043C \u043D\u0430 \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443 \u0438\u043B\u0438 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u045A\u0435\u043C \u043F\u0443\u0442\u0435\u043C \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0430, \u0430 \u0442\u043E \u0441\u0443 \u0418\u041F \u0430\u0434\u0440\u0435\u0441\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0435-\u043F\u043E\u0448\u0442\u0435, \u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0438 \u0441\u0438\u0441\u0442\u0435\u043C, \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u043D\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0443 \u043E\u043A\u0432\u0438\u0440\u0443 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0430 \u0443\u0441\u043B\u0443\u0433\u0435."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "2. \u041A\u041E\u0420\u0418\u0421\u041D\u0418 \u041F\u041E\u0421\u0408\u0415\u0422\u041D\u0418\u0426\u0418"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u043E\u0434\u0430\u0446\u0438 \u043A\u043E\u0458\u0435 \u043F\u043E\u0441\u0435\u0442\u0438\u043B\u0430\u0446 (\u043E\u0441\u043E\u0431\u0430 \u043A\u043E\u0458\u0430 \u043D\u0438\u0458\u0435 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043B\u0430 \u0443\u0441\u043B\u0443\u0433\u0443) \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0459\u043D\u043E \u043E\u0441\u0442\u0430\u0432\u0459\u0430 \u043D\u0430 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u0438\u043C \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430\u043C\u0430, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0441\u043A\u0438 \u0431\u0440\u043E\u0458, \u0430\u0434\u0440\u0435\u0441\u0443 \u0435-\u043F\u043E\u0448\u0442\u0435 \u0438 \u0434\u0440\u0443\u0433\u0435 \u043B\u0438\u0447\u043D\u0435 \u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u0441\u043A\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435, \u043F\u043E\u0434\u0430\u0446\u0438 \u0441\u0443 \u0437\u0430 \u043A\u043E\u0458\u0435 \u043F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0435 \u0438\u043C\u0430 \u043F\u0440\u0430\u0432\u043E \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u0443 \u043E\u043A\u0432\u0438\u0440\u0443 \u0441\u0432\u043E\u0458\u0438\u0445 \u043F\u0440\u043E\u0458\u0435\u043A\u0430\u0442\u0430. \u041F\u043E\u0441\u0435\u0442\u0438\u043B\u0430\u0446 \u0441\u0435 \u0442\u0430\u043A\u043E\u0452\u0435 \u0441\u043B\u0430\u0436\u0435 \u0434\u0430 \u043F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0430 \u043C\u043E\u0436\u0435 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0441\u0432\u043E\u0458\u0435 \u0431\u0440\u043E\u0458\u0435\u0432\u0435 \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u0445 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0443 \u0441\u0432\u043E\u0458\u0438\u043C \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0448\u043A\u0438\u043C \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438\u043C\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "3. \u041F\u0440\u0438\u0441\u0442\u0443\u043F \u0443\u0441\u043B\u0443\u0437\u0438"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "3.1 "
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0443\u0441\u043B\u0443\u0433\u0435 \u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440 \u0438 \u0434\u043E\u0431\u0430\u0432\u0459\u0430\u0447 \u0443\u0441\u043B\u0443\u0433\u0430 \u0458\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u0418\u043D\u0442\u0435\u0440 Sam Media BV. \u041A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435\u043C \u043E\u0432\u0435 \u0443\u0441\u043B\u0443\u0433\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043F\u043E\u0442\u0432\u0440\u0452\u0443\u0458\u0435 \u0434\u0430 \u0458\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043E \u0438 \u0440\u0430\u0437\u0443\u043C\u0435\u043E \u0443\u0441\u043B\u043E\u0432\u0435 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430 \u0443\u0441\u043B\u0443\u0433\u0435 \u0438 \u0443 \u043F\u043E\u0442\u043F\u0443\u043D\u043E\u0441\u0442\u0438 \u0441\u0435 \u0441\u0430 \u045A\u0438\u043C\u0430 \u0441\u043B\u0430\u0436\u0435."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "3.2. \u041E\u043F\u0438\u0441 \u0443\u0441\u043B\u0443\u0433\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0421\u0435\u0440\u0432\u0438\u0441 \u043C\u043E\u0433\u0443 \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0446\u0438 \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u0445 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0430 \u041C\u0422\u0421, Y\u0435\u0442\u0442\u0435\u043B, A1 \u043A\u043E\u0458\u0438 \u0438\u043C\u0430\u0458\u0443 18 \u0438\u043B\u0438 \u0432\u0438\u0448\u0435 \u0433\u043E\u0434\u0438\u043D\u0430. \u0441\u043B\u0443\u0433\u0430 \u0458\u0435 \u0437\u0430\u0431\u0430\u0432\u043D\u0430 \u0438 \u043F\u0440\u0443\u0436\u0430 \u043F\u043E\u0440\u0442\u0430\u043B \u0441\u0430 \u043D\u0430\u0458\u0431\u043E\u0459\u0438\u043C \u0445\u0442\u043C\u043B5 \u0438\u0433\u0440\u0430\u043C\u0430, \u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0448\u045B\u0443 \u0441\u043A\u0438\u0434\u0430\u045A\u0430 \u043D\u0430 \u0430\u043D\u0434\u0440\u043E\u0438\u0434 \u0443\u0440\u0435\u0452\u0430\u0458\u0438\u043C\u0430 \u0442\u0435 \u0437\u0430\u0431\u0430\u0432\u043D\u0438 \u0432\u0438\u0434\u0435\u043E \u0441\u0430\u0434\u0440\u0436\u0430\u0458, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u043C \u0443\u0440\u0435\u0452\u0430\u0458\u0443, \u0441\u0430 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u043C \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u043E\u043C \u0443 \u0442\u043E\u043A\u0443 \u0432\u0430\u0448\u0435 \u043E\u043D\u043B\u0430\u0458\u043D \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0435.."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "3.3. \u041E\u043F\u0438\u0441 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0441\u0430\u045A\u0430 \u0443\u0441\u043B\u0443\u0433\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0414\u0430 \u0431\u0438 \u0443\u0447\u0435\u0441\u0442\u0432\u043E\u0432\u0430\u043E \u0443 \u0443\u0441\u043B\u0443\u0437\u0438, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043F\u0440\u0438\u0445\u0432\u0430\u0442\u0430 \u0443\u0441\u043B\u043E\u0432\u0435 \u0443\u0441\u043B\u0443\u0433\u0435 \u0438 \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u045B\u0443\u0458\u0435 \u0441\u0435 \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0443."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "3.4. \u041F\u043B\u0430\u045B\u0430\u045A\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0443\u0441\u043B\u0443\u0433\u0430 \u0423\u0441\u043B\u0443\u0433\u0430 \u0441\u0435 \u043F\u043B\u0430\u045B\u0430. \u041F\u043B\u0430\u045B\u0430\u045A\u0435 \u0441\u0435 \u0432\u0440\u0448\u0438 \u043F\u0440\u0435\u043A\u043E \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0430. \u041A\u043E\u0440\u0438\u0441\u043D\u0438\u0446\u0438\u043C\u0430 \u0441\u0432\u0438\u0445 \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u0445 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0430 \u043D\u0430\u043F\u043B\u0430\u045B\u0443\u0458\u0435 \u0441\u0435 \u0441\u0432\u0430\u043A\u0430 \u043F\u043E\u0441\u043B\u0430\u0442\u0430 \u043F\u043E\u0440\u0443\u043A\u0430 \u043E\u0441\u0438\u043C \u0441\u0438\u0441\u0442\u0435\u043C\u0441\u043A\u0435 \u043F\u043E\u0440\u0443\u043A\u0435. \u041F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0430 \u0438\u043C\u0430 \u043F\u0440\u0430\u0432\u043E \u043F\u0440\u043E\u043C\u0435\u043D\u0435 \u0446\u0435\u043D\u0430 \u0441\u0432\u043E\u0458\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430, \u0430\u043B\u0438 \u0458\u0435 \u0434\u0443\u0436\u0430\u043D \u0434\u0430 \u043E \u0442\u043E\u043C\u0435 \u043E\u0431\u0430\u0432\u0435\u0441\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0435 \u043D\u0430 \u0441\u0432\u0438\u043C \u043C\u0435\u0441\u0442\u0438\u043C\u0430 \u0433\u0434\u0435 \u0441\u0443 \u043F\u043E\u0441\u0442\u0430\u0432\u0459\u0435\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0438 \u0438 \u0443\u043F\u0443\u0442\u0441\u0442\u0432\u0430 \u0437\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 \u0443\u0441\u043B\u0443\u0433\u0430. \u0410\u043A\u043E \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440 \u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438 \u0446\u0435\u043D\u0443 \u0443\u0441\u043B\u0443\u0433\u0435 \u0442\u043E\u043A\u043E\u043C \u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0443\u0441\u043B\u0443\u0433\u0435, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043E\u0441\u0442\u0430\u0458\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0443\u0441\u043B\u0443\u0433\u0435 \u0434\u043E\u043A \u0441\u0435 \u043D\u0435 \u043E\u0434\u0458\u0430\u0432\u0438 \u0438\u0437 \u0443\u0441\u043B\u0443\u0433\u0435."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "4. \u041E\u041F\u0428\u0422\u0410 \u041F\u0420\u0410\u0412\u0418\u041B\u0410"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "4.1. \u041E\u043F\u0438\u0441 \u0438 \u0441\u0432\u0440\u0445\u0430 \u0443\u0441\u043B\u0443\u0433\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442, \u0448\u0442\u0430\u043C\u043F\u0430, \u0422\u0412 \u0438 \u0440\u0430\u0434\u0438\u043E \u043C\u0435\u0434\u0438\u0458\u0438 \u043C\u0435\u0441\u0442\u043E \u0441\u0443 \u0437\u0430 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0435 \u0437\u0430\u0431\u0430\u0432\u043D\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430 \u043F\u0443\u0442\u0435\u043C \u043C\u043E\u0431\u0438\u043B\u043D\u0438\u0445 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043F\u0443\u0442\u0435\u043C \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430 \u0421\u041C\u0421 \u043F\u043E\u0440\u0443\u043A\u0430. \u0421\u0432\u0440\u0445\u0430 \u0443\u0441\u043B\u0443\u0433\u0435 \u0458\u0435 \u0438\u0441\u043A\u0459\u0443\u0447\u0438\u0432\u043E \u0443 \u0437\u0430\u0431\u0430\u0432\u0443. \u041F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0430 \u043D\u0435 \u0443\u0442\u0438\u0447\u0435 \u043D\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0435 \u0438 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0435, \u0430 \u043D\u0430\u0440\u043E\u0447\u0438\u0442\u043E \u043D\u0430 \u0421\u041C\u0421 \u043A\u043E\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u0458\u0443 \u0442\u0430\u043C\u043E \u0433\u0434\u0435 \u0441\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0438 \u0434\u0430 \u0441\u0443 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u0440\u0430\u0437\u043C\u0435\u045A\u0443\u0458\u0443 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0446\u0438 \u0438 \u043E\u043F\u0435\u0440\u0430\u0442\u0435\u0440\u0438 \u0442\u0430\u0447\u043D\u0435."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "4.2. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442 \u0443\u0441\u043B\u0443\u0433\u0435 \u0414\u043E\u0431\u0430\u0432\u0459\u0430\u0447 \u0443\u0441\u043B\u0443\u0433\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u043F\u043E\u043A\u0443\u0448\u0430\u0432\u0430 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u043D\u043E \u043F\u043E\u0432\u0435\u045B\u0430\u0442\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0438\u0432\u043E\u0441\u0442 \u0443\u0441\u043B\u0443\u0433\u0435. \u0417\u0431\u043E\u0433 \u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0438\u0445 \u043A\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043A\u0435 \u0432\u0435\u0437\u0435 \u0438 \u043C\u043E\u0431\u0438\u043B\u043D\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0458\u0435, \u043D\u0430 \u043A\u043E\u0458\u0435 \u0434\u043E\u0431\u0430\u0432\u0459\u0430\u0447 \u0443\u0441\u043B\u0443\u0433\u0430 \u043D\u0435 \u0443\u0442\u0458\u0435\u0447\u0435, \u043C\u043E\u0436\u0435 \u0434\u043E\u045B\u0438 \u0434\u043E \u043F\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u0445 \u043F\u0440\u0435\u043A\u0438\u0434\u0430 \u0443 \u043F\u0440\u0435\u043D\u043E\u0441\u0443 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 - \u0440\u0430\u0434\u0443 \u0443\u0441\u043B\u0443\u0433\u0435. \u041F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440 \u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u043E\u0432\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442 \u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442 \u0443\u0441\u043B\u0443\u0433\u0435."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "4.3. \u0422\u0435\u0445\u043D\u0438\u0447\u043A\u0438 \u0443\u0441\u043B\u043E\u0432\u0438 \u0437\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 \u0443\u0441\u043B\u0443\u0433\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043C\u043E\u0440\u0430 \u0434\u0430 \u043E\u0441\u0438\u0433\u0443\u0440\u0430 \u043E\u0434\u0440\u0436\u0430\u0432\u0430\u045A\u0435 \u0438 \u043F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0430 \u0441\u0432\u043E\u0433 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430. \u0423 \u043E\u0432\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0458\u0443, \u043F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0430 \u043D\u0438\u0458\u0435 \u0434\u0443\u0436\u0430\u043D \u0434\u0430 \u043F\u0440\u0443\u0436\u0430 \u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0443 \u043F\u043E\u0434\u0440\u0448\u043A\u0443. \u0414\u0430 \u0431\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u043E \u0443\u0441\u043B\u0443\u0433\u0443, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043C\u043E\u0440\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u043C\u043E\u0431\u0438\u043B\u043D\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0438 \u0438\u043C\u0430\u0442\u0438 \u0432\u0430\u0459\u0430\u043D\u0443 \u0432\u0435\u0437\u0443 (\u0441\u0438\u0433\u043D\u0430\u043B) \u043D\u0430 \u0441\u0432\u043E\u043C \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443. \u0411\u0435\u0437 \u043E\u0432\u0438\u0445 \u0443\u0441\u043B\u043E\u0432\u0430 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u0443\u0441\u043B\u0443\u0433\u0435 \u043D\u0438\u0458\u0435 \u043C\u043E\u0433\u0443\u045B\u0430. \u041A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0458\u0435 \u0438\u0441\u043A\u0459\u0443\u0447\u0438\u0432\u043E \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u0430\u043D \u0437\u0430 \u043F\u0440\u0443\u0436\u0430\u045A\u0435 \u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0438\u0445 \u0443\u0441\u043B\u043E\u0432\u0430. \u041F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0435 \u043D\u0438\u0458\u0435 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u0430\u043D \u0430\u043A\u043E \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u0443\u0441\u043B\u0443\u0433\u0443 \u0437\u0431\u043E\u0433 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0430 \u0441\u0432\u043E\u0433 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "4.4. \u0422\u0440\u043E\u0448\u043A\u043E\u0432\u0438 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430 \u0443\u0441\u043B\u0443\u0433\u0435 \u041A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435\u043C"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0443\u0441\u043B\u0443\u0433\u0435, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043F\u0440\u0438\u0441\u0442\u0430\u0458\u0435 \u043D\u0430 \u043D\u0430\u0441\u0442\u0430\u043B\u0435 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435 \u0458\u0435\u0440 \u0458\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0438\u0441\u0430\u043D \u043E \u0446\u0435\u043D\u0438 \u0443\u0441\u043B\u0443\u0433\u0435 \u0443 \u0441\u043A\u043B\u0430\u0434\u0443 \u0441\u0430 \u043F\u0440\u0430\u0432\u0438\u043B\u0438\u043C\u0430 \u043A\u043E\u0458\u0435 \u043F\u0440\u043E\u043F\u0438\u0441\u0443\u0458\u0443 \u0437\u0430\u043A\u043E\u043D \u0438 \u043C\u043E\u0431\u0438\u043B\u043D\u0438 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0438. \u0421 \u043E\u0431\u0437\u0438\u0440\u043E\u043C \u043D\u0430 \u0442\u043E \u0434\u0430 \u0441\u0443 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0438 \u0438\u0441\u043A\u0430\u0437\u0430\u043D\u0438 \u043D\u0430 \u0441\u0430\u0458\u0442\u043E\u0432\u0438\u043C\u0430 \u0437\u0430 \u043E\u0433\u043B\u0430\u0448\u0430\u0432\u0430\u045A\u0435, \u043A\u0430\u043E \u0438 \u0443 \u0443\u0441\u043B\u043E\u0432\u0438\u043C\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u043C\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430, \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043F\u0440\u0438\u0445\u0432\u0430\u0442\u0430 \u043E\u0431\u0430\u0432\u0435\u0437\u0443 \u0434\u0430 \u043D\u0435\u043C\u0430 \u043F\u0440\u0430\u0432\u043E \u0434\u0430 \u0437\u0430\u0445\u0442\u0435\u0432\u0430 \u043D\u0430\u0441\u0442\u0430\u043B\u0435 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435, \u043A\u0430\u043E \u0438 \u0434\u0430 \u043D\u0430\u0434\u043E\u043A\u043D\u0430\u0434\u0438 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435 \u0430\u043A\u043E \u043D\u0438\u0458\u0435 \u0434\u043E\u0431\u0438\u043E \u043E\u0434\u0433\u043E\u0432\u043E\u0440 \u043D\u0430 \u043F\u043E\u0440\u0443\u043A\u0443."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "4.5. \u041F\u0440\u043E\u043C\u0435\u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0435 \u0437\u0430\u0434\u0440\u0436\u0430\u0432\u0430 \u043F\u0440\u0430\u0432\u043E \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0435 \u0443\u0433\u043E\u0432\u043E\u0440\u0430 \u0443 \u0431\u0438\u043B\u043E \u043A\u043E\u043C \u0442\u0440\u0435\u043D\u0443\u0442\u043A\u0443 \u0443 \u0431\u0443\u0434\u0443\u045B\u043D\u043E\u0441\u0442\u0438. \u041D\u0430\u043A\u043E\u043D \u043F\u0440\u043E\u043C\u0435\u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430 \u0443\u0441\u043B\u0443\u0433\u0435, \u0430\u043A\u043E \u0458\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u043F\u0440\u0435\u0442\u0445\u043E\u0434\u043D\u043E \u043F\u0440\u0438\u0441\u0442\u0430\u043E \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0435, \u0430 \u043D\u0430\u043A\u043E\u043D \u0448\u0442\u043E \u043F\u0440\u043E\u043C\u0435\u043D\u0430 \u043D\u0438\u0458\u0435, \u043E\u043D \u0441\u0435 \u043C\u043E\u0436\u0435 \u043E\u0434\u0458\u0430\u0432\u0438\u0442\u0438 \u0443 \u0441\u043A\u043B\u0430\u0434\u0443 \u0441\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0441\u0430\u045A\u0435\u043C \u0443\u0441\u043B\u0443\u0433\u0435. \u041F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0430 \u043D\u0438\u0458\u0435 \u0434\u0443\u0436\u0430\u043D \u0434\u0430 \u043E\u0431\u0430\u0432\u0435\u0448\u0442\u0430\u0432\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0435 \u043E \u043F\u0440\u043E\u043C\u0435\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "4.6. \u041E\u0441\u0438\u0433\u0443\u0440\u0430\u045A\u0435 / \u043D\u0430\u043A\u043D\u0430\u0434\u0430 \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0458\u0435"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430, \u045A\u0435\u043D\u0438 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438, \u0441\u043B\u0443\u0436\u0431\u0435\u043D\u0438\u0446\u0438, \u0437\u0430\u043F\u043E\u0441\u043B\u0435\u043D\u0438, \u0434\u043E\u0431\u0430\u0432\u0459\u0430\u0447\u0438 \u0438 \u0430\u0433\u0435\u043D\u0442\u0438 \u0441\u0435 \u043E\u0434\u0440\u0438\u0447\u0443 \u0441\u0432\u0430\u043A\u0435 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0431\u0438\u043B\u043E \u043A\u0430\u043A\u0432\u0443 \u0448\u0442\u0435\u0442\u0443 \u043D\u0430\u0441\u0442\u0430\u043B\u0443 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u043E\u043C \u0423\u0441\u043B\u0443\u0433\u0430. \u0418\u0437\u0440\u0438\u0447\u0438\u0442\u043E \u0440\u0430\u0437\u0443\u043C\u0435\u0442\u0435 \u0438 \u043F\u0440\u0438\u0441\u0442\u0430\u0458\u0435\u0442\u0435 \u0434\u0430 \u0423\u0441\u043B\u0443\u0433\u0435 \u043F\u0440\u0443\u0436\u0430\u0442\u0435 \u043D\u0430 \u043D\u0430\u0447\u0438\u043D \"\u043A\u0430\u043A\u0430\u0432 \u0458\u0435\u0441\u0442\u0435\" \u0438 \"\u043A\u0430\u043A\u043E \u0458\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u043D\" \u0431\u0435\u0437 \u0438\u043A\u0430\u043A\u0432\u0438\u0445 \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0458\u0430. \u0421\u0442\u0440\u0430\u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u0459\u0430\u0447\u0430 \u0438\u0437\u0440\u0438\u0447\u0438\u0442\u043E \u0441\u0435 \u043E\u0434\u0440\u0438\u0447\u0443 \u0443 \u043D\u0430\u0458\u0432\u0435\u045B\u043E\u0458 \u043C\u0435\u0440\u0438 \u0434\u043E\u043F\u0443\u0448\u0442\u0435\u043D\u043E\u0458 \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u0441\u0432\u0438\u043C \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0458\u0430\u043C\u0430, \u0431\u0438\u043B\u043E \u0438\u0437\u0440\u0438\u0447\u0438\u0442\u0438\u043C \u0438\u043B\u0438 \u0438\u043C\u043F\u043B\u0438\u0446\u0438\u0440\u0430\u043D\u0438\u043C, \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u0438\u043B\u0438 \u043D\u0430 \u043D\u0435\u043A\u0438 \u0434\u0440\u0443\u0433\u0438 \u043D\u0430\u0447\u0438\u043D, \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0430, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438, \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0430, \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u043D\u0435 \u0443\u0441\u043B\u043E\u0432\u0435 \u043F\u0440\u043E\u0434\u0430\u0458\u0435, \u0432\u043B\u0430\u0441\u043D\u0438\u0448\u0442\u0432\u0430 \u0438 \u043F\u0440\u043E\u0434\u0430\u0458\u0435 \u0440\u043E\u0431\u0435 \u0438 \u0438\u043C\u043E\u0432\u0438\u043D\u0435, \u043A\u0430\u043E \u0438 \u043D\u0430\u043C\u0435\u043D\u0441\u043A\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u0458\u0443 \u0438 \u043A\u0440\u0448\u0435\u045A\u0435 \u0430\u0443\u0442\u043E\u0440\u0441\u043A\u0438\u0445 \u043F\u0440\u0430\u0432\u0430. \u0421\u0442\u0440\u0430\u043D\u0435 \u0443 \u0443\u0433\u043E\u0432\u043E\u0440\u0443 \u0441\u0435 \u043E\u0434\u0440\u0438\u0447\u0443 \u0441\u0432\u0430\u043A\u0435 \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0458\u0435 \u0443 \u043F\u043E\u0433\u043B\u0435\u0434\u0443 \u0441\u0438\u0433\u0443\u0440\u043D\u043E\u0441\u0442\u0438, \u043F\u043E\u0443\u0437\u0434\u0430\u043D\u043E\u0441\u0442\u0438, \u0431\u043B\u0430\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043E\u0441\u0442\u0438 \u0438 \u043F\u0435\u0440\u0444\u043E\u0440\u043C\u0430\u043D\u0441\u0438 \u0443\u0441\u043B\u0443\u0433\u0430. \u0423\u0433\u043E\u0432\u043E\u0440\u043D\u0435 \u0441\u0442\u0440\u0430\u043D\u0435 \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0443\u0458\u0443 \u0434\u0430 \u045B\u0435 \u0423\u0441\u043B\u0443\u0433\u0435 \u0438\u0441\u043F\u0443\u043D\u0438\u0442\u0438 \u0432\u0430\u0448\u0435 \u0437\u0430\u0445\u0442\u0435\u0432\u0435 \u0438\u043B\u0438 \u0434\u0430 \u045B\u0435 \u0443\u0441\u043B\u0443 \u0432\u0435\u0442\u0430 \u0438\u043B\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430, \u0431\u0438\u043B\u043E \u0434\u0430 \u0441\u0443 \u0443\u0441\u043C\u0435\u043D\u0435 \u0438\u043B\u0438 \u043F\u0438\u0441\u043C\u0435\u043D\u0435, \u0434\u043E\u0431\u0438\u0458\u0435\u043D\u0435 \u043E\u0434 \u043D\u0430\u0441 \u0438\u043B\u0438 \u043F\u0443\u0442\u0435\u043C \u043D\u0430\u0448\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430, \u043D\u0435\u045B\u0435 \u0441\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0458\u0430 \u043A\u043E\u0458\u0430 \u043D\u0438\u0458\u0435 \u043E\u0432\u0434\u0435 \u0438\u0437\u0440\u0438\u0447\u0438\u0442\u043E \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u0430. \u041D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0435 \u043E\u0441\u043B\u043E\u043D\u0438\u0442\u0438 \u043D\u0430 \u0442\u0430\u043A\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u0438\u043B\u0438 \u0441\u0430\u0432\u0435\u0442\u0435. \u0420\u0430\u0437\u0443\u043C\u0435\u0442\u0435 \u0438 \u043F\u0440\u0438\u0441\u0442\u0430\u0458\u0435\u0442\u0435 \u043D\u0430 \u043F\u0440\u0435\u0443\u0437\u0438\u043C\u0430\u045A\u0435 \u0438 / \u0438\u043B\u0438 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 \u0423\u0441\u043B\u0443\u0433\u0430, \u0441\u0430\u0434\u0440\u0436\u0430\u0458\u0430, \u0441\u043E\u0444\u0442\u0432\u0435\u0440\u0430 \u0438 \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430 \u043D\u0430 \u0441\u043E\u043F\u0441\u0442\u0432\u0435\u043D\u0438 \u0440\u0438\u0437\u0438\u043A \u0438 \u0440\u0438\u0437\u0438\u043A \u0438 \u0434\u0430 \u045B\u0435\u0442\u0435 \u0431\u0438\u0442\u0438 \u0458\u0435\u0434\u0438\u043D\u0438 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u0438 \u0437\u0430 \u0431\u0438\u043B\u043E \u043A\u0430\u043A\u0432\u043E \u043E\u0448\u0442\u0435\u045B\u0435\u045A\u0435 \u0440\u0430\u0447\u0443\u043D\u0430\u0440\u0441\u043A\u043E\u0433 \u0441\u0438\u0441\u0442\u0435\u043C\u0430, \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0438\u043B\u0438 \u0433\u0443\u0431\u0438\u0442\u0430\u043A \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043A\u043E\u0458\u0438 \u0441\u0443 \u043F\u043E\u0441\u043B\u0435\u0434\u0438\u0446\u0430. \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 \u0443\u0441\u043B\u0443\u0433\u0430. \u041E\u0441\u0438\u043C \u0443 \u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0438\u043C\u0430 \u0443 \u043A\u043E\u0458\u0438\u043C\u0430 \u0441\u0443 \u043E\u0432\u0435 \u043E\u0434\u0440\u0435\u0434\u0431\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0435, \u0441\u043B\u0430\u0436\u0435\u0442\u0435 \u0441\u0435 \u0434\u0430 \u0458\u0435 \u0446\u0435\u043B\u043E\u043A\u0443\u043F\u043D\u0430 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435 \u043F\u0440\u0435\u043C\u0430 \u0432\u0430\u043C\u0430 \u0438\u043B\u0438 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u043E\u0458 \u0442\u0440\u0435\u045B\u043E\u0458 \u0441\u0442\u0440\u0430\u043D\u0438, \u043A\u0430\u043E \u0438 \u0437\u0430 \u0432\u0430\u0448 \u0438\u043B\u0438 \u0435\u043A\u0441\u043A\u043B\u0443\u0437\u0438\u0432\u043D\u0438 \u043B\u0435\u043A \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0435 \u0442\u0440\u0435\u045B\u0435 \u0441\u0442\u0440\u0430\u043D\u0435, \u0437\u0430\u043A\u043E\u043D\u0441\u043A\u0438, \u0443 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u0443 \u0438\u043B\u0438 \u043D\u0430 \u0434\u0440\u0443\u0433\u0438 \u043D\u0430\u0447\u0438\u043D \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0430 \u043F\u0440\u0443\u0436\u0435\u043D\u0438\u043C \u043E\u0432\u0438\u043C \u0441\u043F\u043E\u0440\u0430\u0437\u0443\u043C\u043E\u043C \u0438 / \u0438\u043B\u0438 \u0431\u0438\u043B\u043E \u043A\u0430\u043A\u0432\u0438\u043C \u043A\u0440\u0448\u0435\u045A\u0435\u043C \u043E\u0432\u043E\u0433 \u0441\u043F\u043E\u0440\u0430\u0437\u0443\u043C\u0430, \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u0458\u0435 \u0438\u0441\u043A\u0459\u0443\u0447\u0438\u0432\u043E \u043D\u0430 \u0438\u0437\u043D\u043E\u0441 \u043A\u043E\u0458\u0438 \u0441\u0442\u0435 \u043F\u043B\u0430\u0442\u0438\u043B\u0438 \u0437\u0430 \u0442\u0430\u043A\u0432\u0435 \u0443\u0441\u043B\u0443\u0433\u0435 \u0442\u043E\u043A\u043E\u043C \u0442\u0440\u0430\u0458\u0430\u045A\u0430 \u043E\u0432\u043E\u0433 \u0443\u0433\u043E\u0432\u043E\u0440\u0430. \u041E\u0441\u0438\u043C \u0443 \u0458\u0443\u0440\u0438\u0441\u0434\u0438\u043A\u0446\u0438\u0458\u0430\u043C\u0430 \u0443 \u043A\u043E\u0458\u0438\u043C\u0430 \u0441\u0443 \u0442\u0430\u043A\u0432\u0435 \u043E\u0434\u0440\u0435\u0434\u0431\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0435, \u0441\u0442\u0440\u0430\u043D\u0435 \u0443\u0433\u043E\u0432\u043E\u0440\u043D\u0438\u0446\u0435 \u043A\u043E\u0458\u0435 \u0441\u0443 \u0441\u0442\u0438\u0446\u0430\u043B\u0435 \u043D\u0435\u045B\u0435 \u0431\u0438\u0442\u0438 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u0435 \u0437\u0430 \u0431\u0438\u043B\u043E \u043A\u0430\u043A\u0432\u0443 \u0434\u0438\u0440\u0435\u043A\u0442\u043D\u0443, \u0438\u043D\u0434\u0438\u0440\u0435\u043A\u0442\u043D\u0443, \u0441\u043B\u0443\u0447\u0430\u0458\u043D\u0443, \u043F\u043E\u0441\u0435\u0431\u043D\u0443, \u0443\u0437\u043E\u0440\u043D\u0443, \u043A\u0440\u0438\u0432\u0438\u0447\u043D\u0443, \u0442\u0440\u0435\u045B\u0443 \u0438\u043B\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u0438\u0447\u043D\u0443 \u0448\u0442\u0435\u0442\u0443 (\u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438 \u0448\u0442\u0435\u0442\u0443 \u0437\u0431\u043E\u0433 \u0433\u0443\u0431\u0438\u0442\u043A\u0430 \u043F\u043E\u0441\u043B\u043E\u0432\u043D\u0435 \u0434\u043E\u0431\u0438\u0442\u0438, \u043F\u0440\u0435\u043A\u0438\u0434\u0430 \u043F\u043E\u0441\u043B\u043E\u0432\u0430\u045A\u0430, \u0433\u0443\u0431\u0438\u0442\u043A\u0430 \u043F\u043E\u0441\u043B\u043E\u0432\u043D\u0438\u0445 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430 \u0438 \u0441\u043B\u0438\u0447\u043D\u043E) \u043F\u0440\u043E\u0438\u0441\u0442\u0435\u043A\u043B\u0435 \u0438\u0437 \u0432\u0430\u0448\u0435 \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0435, \u0437\u043B\u043E\u0443\u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0438\u043B\u0438 \u043D\u0435\u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0430 \u0423\u0441\u043B\u0443\u0433\u0430, \u0421\u0430\u0434\u0440\u0436\u0430\u0458\u0430, \u0421\u043E\u0444\u0442\u0432\u0435\u0440\u0430 \u0438 \u0412\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0435, \u0447\u0430\u043A \u0438 \u0430\u043A\u043E \u0458\u0435 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043E\u0431\u0430\u0432\u0435\u0448\u0442\u0435\u043D\u0430 \u043E \u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0441\u0442\u0438 \u0442\u0430\u043A\u0432\u0435 \u0448\u0442\u0435\u0442\u0435, \u0443 \u043C\u0435\u0440\u0438 \u0443 \u043A\u043E\u0458\u043E\u0458 \u0434\u0440\u0436\u0430\u0432\u0430 \u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u0459\u0430\u0432\u0430 \u0438\u0441\u043A\u0459\u0443\u0447\u0435\u045A\u0435 \u0438\u043B\u0438 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0435 \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442\u0438 \u043A\u0430\u043A\u043E \u0458\u0435 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u043E \u0443 \u043E\u0432\u043E\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0443. , \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0435 \u0458\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0430 \u043D\u0430 \u043D\u0438\u0432\u043E \u0434\u043E\u0437\u0432\u043E\u0459\u0435\u043D \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u0443 \u0442\u043E\u0458 \u0437\u0435\u043C\u0459\u0438. \u0421\u0430\u0433\u043B\u0430\u0441\u043D\u0438 \u0441\u0442\u0435 \u0434\u0430 \u0437\u0430\u0448\u0442\u0438\u0442\u0438\u0442\u0435 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0443 \u0438 \u045A\u0435\u043D\u0435 \u0440\u043E\u0434\u0438\u0442\u0435\u0459\u0435, \u0447\u043B\u0430\u043D\u043E\u0432\u0435, \u043F\u043E\u0434\u0440\u0443\u0436\u043D\u0438\u0446\u0435, \u043F\u043E\u0434\u0440\u0443\u0436\u043D\u0438\u0446\u0435, \u043F\u0440\u0443\u0436\u0430\u043E\u0446\u0435 \u0443\u0441\u043B\u0443\u0433\u0430, \u043F\u0440\u0435\u0434\u0443\u0437\u0435\u0442\u043D\u0438\u043A\u0435, \u0430\u0433\u0435\u043D\u0442\u0435, \u0434\u0430\u0432\u0430\u043E\u0446\u0435 \u043B\u0438\u0446\u0435\u043D\u0446\u0435, \u0441\u043B\u0443\u0436\u0431\u0435\u043D\u0438\u043A\u0435, \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0435, \u0430\u043A\u0446\u0438\u043E\u043D\u0430\u0440\u0435 \u0438 \u0437\u0430\u043F\u043E\u0441\u043B\u0435\u043D\u0435 \u043E\u0434 \u0433\u0443\u0431\u0438\u0442\u043A\u0430, \u043E\u0434\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442\u0438, \u0437\u0430\u0445\u0442\u0435\u0432\u0430, \u0442\u0443\u0436\u0431\u0435 \u0438\u043B\u0438 \u0437\u0430\u0445\u0442\u0435\u0432\u0430, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438 \u0440\u0430\u0437\u0443\u043C\u043D\u0435 \u0430\u0434\u0432\u043E\u043A\u0430\u0442\u0441\u043A\u0435 \u043D\u0430\u043A\u043D\u0430\u0434\u0435, \u043D\u0430\u043F\u0440\u0430\u0432\u0459\u0435\u043D\u0435 \u043E\u0434 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0435 \u0442\u0440\u0435\u045B\u0435 \u0441\u0442\u0440\u0430\u043D\u0435 \u043A\u043E\u0458\u0430 \u043F\u0440\u043E\u0438\u0437\u0438\u043B\u0430\u0437\u0438 \u0438\u0437 \u0438\u043B\u0438 \u0443 \u0432\u0435\u0437\u0438 \u0441\u0430 (\u0430) \u0432\u0430\u0448\u043E\u043C \u0443\u043F\u043E\u0442\u0440\u0435\u0431\u043E\u043C \u0423\u0441\u043B\u0443\u0433\u0430 \u0438 (\u0431) \u043A\u0440\u0448\u0435\u045A\u0435\u043C \u043E\u0434 \u0432\u0430\u0441 \u0438\u043B\u0438 \u0432\u0430\u0448\u0438\u0445 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A\u0430 \u0438 \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0458\u0430\u043C\u0430 \u0443\u0442\u0432\u0440\u0452\u0435\u043D\u0438\u043C \u0443 \u043E\u0432\u0438\u043C \u0423\u0441\u043B\u043E\u0432\u0438\u043C\u0430. \u041F\u043B\u0430\u0442\u0438\u0442 \u045B\u0435\u0442\u0435 \u0438 \u0441\u0432\u0435 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435, \u043E\u0434\u0448\u0442\u0435\u0442\u0443 \u0438 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435 \u043E\u0434\u0448\u0442\u0435\u0442\u0435, \u0443\u043A\u0459\u0443\u0447\u0443\u0458\u0443\u045B\u0438 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0430, \u0440\u0430\u0437\u0443\u043C\u043D\u0435 \u043E\u0434\u0432\u0435\u0442\u043D\u0438\u0447\u043A\u0435 \u043D\u0430\u043A\u043D\u0430\u0434\u0435 \u0438 \u0442\u0440\u043E\u0448\u043A\u043E\u0432\u0435 \u0434\u043E\u0434\u0438\u0458\u0435\u0459\u0435\u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u045B\u0430\u045A\u0435 \u0438\u043B\u0438 \u043D\u0430 \u043A\u043E\u0458\u0435 \u0458\u0435 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0458\u0430 \u043D\u0430\u043A\u043D\u0430\u0452\u0435\u043D\u0430 \u0443 \u0432\u0435\u0437\u0438 \u0441 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u043E\u043C \u0442\u0430\u043A\u0432\u043E\u043C \u0442\u0443\u0436\u0431\u043E\u043C, \u043F\u0430\u0440\u043D\u0438\u0446\u043E\u043C, \u043F\u043E\u0441\u0442\u0443\u043F\u043A\u043E\u043C, \u043F\u043E\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u045A\u0435\u043C \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u0430\u043A."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "5. \u041F\u0420\u0418\u0412\u0410\u0422\u041D\u041E\u0421\u0422"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "5.1. \u0418\u0437\u0458\u0430\u0432\u0430 \u043E \u0437\u0430\u0448\u0442\u0438\u0442\u0438 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0441\u0442\u0438"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0417\u0430\u0448\u0442\u0438\u0442\u0430 \u043B\u0438\u0447\u043D\u0438\u0445 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0437\u0430 \u043D\u0430\u0441 \u0458\u0435 \u0432\u0430\u0436\u043D\u0430. \u0421\u0432\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u043F\u0440\u0438\u043A\u0443\u043F\u0459\u0430\u043C\u043E \u043E\u0441\u0442\u0430\u0432\u0459\u0430\u0458\u0443 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0443 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0459\u043D\u043E \u0438 \u043D\u0435 \u043C\u043E\u0440\u0430\u0458\u0443 \u0438\u0445 \u043E\u0441\u0442\u0430\u0432\u0459\u0430\u0442\u0438."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "5.2."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0430 ",
                  "<бр>",
                  " \u0417\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0438\u0441\u0430\u045A\u0430 \u0443\u0441\u043B\u0443\u0433\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0430\u043D \u043D\u0430\u043C \u0458\u0435 \u0431\u0440\u043E\u0458 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0434\u0430 \u0431\u0438\u0441\u043C\u043E \u043E\u043C\u043E\u0433\u0443\u045B\u0438\u043B\u0438 \u0421\u041C\u0421 \u043F\u043E\u0440\u0443\u043A\u0435. \u041F\u043E\u0434\u0430\u0446\u0438 \u043A\u043E\u0458\u0438 \u0441\u0435 \u0440\u0430\u0437\u043C\u0435\u045A\u0443\u0458\u0443 \u0443 \u043E\u043A\u0432\u0438\u0440\u0443 \u0443\u0441\u043B\u0443\u0433\u0435 \u0441\u0432\u0435 \u0441\u0443 \u043B\u0438\u0447\u043D\u0435 \u0438 \u043E\u043F\u0448\u0442\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A \u0440\u0430\u0437\u043C\u0435\u045A\u0443\u0458\u0435 \u0443 \u0441\u0435\u0440\u0432\u0438\u0441\u0443 \u0441\u043B\u0430\u045A\u0435\u043C \u0441\u043C\u0441 \u043F\u043E\u0440\u0443\u043A\u0430. \u0423 \u043E\u043A\u0432\u0438\u0440\u0443 \u0432\u0430\u0436\u0435\u045B\u0435\u0433 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0430, \u043C\u043E\u0436\u0435\u043C\u043E \u0438\u0441\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0435 \u043F\u043E\u0434\u0430\u0442\u043A\u0435 \u0443 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u0435 \u0441\u0432\u0440\u0445\u0435, \u0438\u0441\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u045A\u0435 \u0442\u0440\u0436\u0438\u0448\u0442\u0430, \u0437\u0430 \u043F\u043E\u0431\u043E\u0459\u0448\u0430\u045A\u0435 \u043D\u0430\u0448\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430 \u0438 \u0437\u0430 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u0458\u0443 \u0434\u0440\u0443\u0433\u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430 \u043A\u043E\u0458\u0435 \u043F\u0440\u0443\u0436\u0430 \u043F\u0440\u0443\u0436\u0430\u043B\u0430\u0446 \u0443\u0441\u043B\u0443\u0433\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para-head" },
                  "5.3."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u041F\u0440\u0435\u043D\u043E\u0441 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u043F\u043E\u0441\u0435\u0442\u0438\u043B\u0430\u0446\u0430 \u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0438 \u0441\u043D\u0438\u043C\u0430\u045A\u0435 \u0443 \u0438\u043D\u0442\u0435\u0440\u043D\u043E\u043C \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0443 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u0447\u043A\u0435 \u0441\u0432\u0440\u0445\u0435 \u0420\u0430\u0437\u043C\u0435\u043D\u0430 \u043F\u043E\u0434\u0430\u0442\u0430\u043A\u0430 \u0443 \u0443\u0441\u043B\u0443\u0437\u0438 \u043E\u0441\u0442\u0432\u0430\u0440\u0443\u0458\u0435 \u0441\u0435 \u043F\u0443\u0442\u0435\u043C \u0421\u041C\u0421 \u043F\u043E\u0440\u0443\u043A\u0430, \u043A\u0430\u043E \u0438 \u043F\u043E\u0437\u0438\u0432\u0438\u043C\u0430 \u0444\u0438\u043A\u0441\u043D\u043E\u0433 \u0438\u043B\u0438 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0430. \u0420\u0430\u0437\u043C\u0435\u043D\u0430 \u043F\u043E\u0437\u0438\u0432\u0430 \u043E\u0434\u043D\u043E\u0441\u0438 \u0441\u0435 \u0438\u0441\u043A\u0459\u0443\u0447\u0438\u0432\u043E \u043D\u0430 \u0437\u0430\u0445\u0442\u0435\u0432 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0430 \u0434\u0430 \u0441\u0435 \u043E\u0434\u0458\u0430\u0432\u0438, \u043A\u0430\u043E \u0438 \u043D\u0430 \u043F\u0440\u0443\u0436\u0430\u045A\u0435 \u0442\u0435\u0445\u043D\u0438\u0447\u043A\u0435 \u043F\u043E\u0434\u0440\u0448\u043A\u0435 \u0437\u0430 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u045A\u0435 \u0438\u043B\u0438 \u043E\u0434\u0458\u0430\u0432\u0443 \u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0442\u0435 \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0443 (\u0430\u043B\u0438 \u043D\u0435 \u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435 \u043E \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u043A\u0443, \u043F\u0440\u043E\u0432\u0430\u0458\u0434\u0435\u0440\u0443 \u0443\u0441\u043B\u0443\u0433\u0435 \u0438\u0442\u0434.)."
                )
              )
            )
          )
        );
      } else if (_domainConfig.config.subDomain === "pl" && _productCondition.isFunzarena) {
        return _react2.default.createElement(
          "section",
          { className: "terms" },
          _react2.default.createElement(
            _reactstrap.Container,
            { fluid: true },
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "no-gutters" },
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 1 Postanowienia og\xF3lne"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. Niniejszy regulamin (dalej: \u201ERegulamin\u201D) okre\u015Bla zasady dost\u0119pu do serwisu FUNZ ARENA oferowanego przez SAM MEDIA, siedziba: Van Diemenstraat 356, 1013CN Amsterdam, kontakt w sprawie reklamacji: reklamacje@teleaudio.pl, tel. 22 244 40 22 (9:30\u201317:00)."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. Us\u0142ugi realizowane w ramach Serwisu FUNZ ARENA s\u0105 p\u0142atne na warunkach przewidzianych w Regulaminie."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. Ka\u017Cdy u\u017Cytkownik zobowi\u0105zany jest do zapoznania si\u0119 z Regulaminem przed skorzystaniem z Us\u0142ugi. Korzystanie z Us\u0142ugi jest mo\u017Cliwe wy\u0142\u0105cznie po zaakceptowaniu Regulaminu."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "4. Z Us\u0142ug (zdefiniowanych poni\u017Cej) mog\u0105 korzysta\u0107 U\u017Cytkownicy sieci nast\u0119puj\u0105cych operator\xF3w: Orange Polska S.A. (ORANGE), T-Mobile Polska S.A. (T-MOBILE), P4 Sp. z o.o. (PLAY) oraz Polkomtel Sp. z o.o. (PLUS)."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "5. U\u017Cytkownicy zobowi\u0105zani s\u0105 do korzystania z Us\u0142ugi oraz z Serwisu zgodnie z obowi\u0105zuj\u0105cym na terytorium Rzeczypospolitej Polskiej prawem oraz postanowieniami niniejszego Regulaminu."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 2 ZASADY KORZYSTANIA Z US\u0141UG"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. Szczeg\xF3\u0142owy opis Us\u0142ug oferowanych przez Organizatora wraz z ich cenami dost\u0119pny jest w Serwisie: https://pl.funzarena.com/#/welcome?uid=fdf098fcc6"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. Organizator ma prawo dokonywa\u0107 aktualizacji oraz rozwoju funkcjonalno\u015Bci Us\u0142ug i Serwisu."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. Us\u0142ugi w Serwisie s\u0105 p\u0142atne. Us\u0142ug\u0119 mo\u017Cna zakupi\u0107 wy\u0142\u0105cznie poprzez przes\u0142anie wiadomo\u015Bci SMS o tre\u015Bci GAME, RACE, ARENA lub GRY na numer 92505. Koszt: 25 z\u0142 netto (30,75 z\u0142 brutto) za dost\u0119p na 30 dni lub inny, wskazany w materia\u0142ach promocyjnych."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "4. Przed dokonaniem p\u0142atno\u015Bci SMS Klient powinien upewni\u0107 si\u0119:"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "a. Czy w telefonie kom\xF3rkowym znajduje si\u0119 wystarczaj\u0105ca ilo\u015B\u0107 wolnej pami\u0119ci niezb\u0119dnej do odczytania wybranej tre\u015Bci. W przypadku niewystarczaj\u0105cej ilo\u015Bci pami\u0119ci tre\u015B\u0107 zostanie zam\xF3wiona i op\u0142acona, jednak Klient nie b\u0119dzie m\xF3g\u0142 jej odczyta\u0107;"
                    )
                  ),
                  _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "b. Czy posiadany telefon jest poprawnie skonfigurowany i umo\u017Cliwia odbieranie wiadomo\u015Bci SMS. Informacje dotycz\u0105ce konfiguracji telefonu Klient mo\u017Ce uzyska\u0107, kontaktuj\u0105c si\u0119 ze swoim Operatorem;"
                    )
                  ),
                  _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "c. Czy dana tre\u015B\u0107 jest oferowana dla posiadanego modelu telefonu kom\xF3rkowego."
                    )
                  )
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "5. Korzystanie z Us\u0142ugi wymaga dost\u0119pu do sieci Internet. Op\u0142aty za Us\u0142ug\u0119 nie obejmuj\u0105 koszt\xF3w transmisji danych, kt\xF3re U\u017Cytkownik ponosi zgodnie z taryf\u0105 Operatora."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "6. Us\u0142ugi dost\u0119pne s\u0105 na terenie Rzeczpospolitej Polskiej."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "7. U\u017Cytkownicy s\u0105 uprawnieni do przenoszenia Us\u0142ug oraz korzystania z nich podczas czasowego pobytu na terenie Unii Europejskiej lub Europejskiego Obszaru Gospodarczego, po pozytywnej weryfikacji rzeczywistego i sta\u0142ego miejsca zamieszkania na terytorium Rzeczpospolitej Polskiej."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "8. Us\u0142uga \u015Bwiadczona w ramach przenoszenia Us\u0142ug podczas czasowego pobytu za granic\u0105 jest realizowana w takim samym zakresie i na tych samych warunkach jak w Polsce."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "9. Zawarcie Umowy nast\u0119puje z chwil\u0105 rozpocz\u0119cia rozmowy telefonicznej w ramach Us\u0142ugi lub z chwil\u0105 wys\u0142ania przez U\u017Cytkownika SMS-a na numer podany w Regulaminie."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "10. Wysy\u0142aj\u0105c SMS-a, U\u017Cytkownik wyra\u017Ca zgod\u0119 na realizacj\u0119 Us\u0142ugi przed up\u0142ywem terminu do odst\u0105pienia od Umowy."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "11. U\u017Cytkownikowi nie przys\u0142uguje prawo odst\u0105pienia od Umowy zgodnie z art. 38 ustawy z dnia 30 maja 2014 r. o prawach konsumenta, poniewa\u017C spe\u0142nianie \u015Bwiadczenia rozpoczyna si\u0119 za wyra\u017An\u0105 zgod\u0105 U\u017Cytkownika przed up\u0142ywem terminu do odst\u0105pienia."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "12. Wyra\u017Cenie zgody na rozpocz\u0119cie \u015Bwiadczenia przed up\u0142ywem terminu odst\u0105pienia jest dobrowolne. Ze wzgl\u0119du na charakter Us\u0142ug \u015Bwiadczonych \u201Ena \u017C\u0105danie\u201D, Organizator mo\u017Ce rozpocz\u0105\u0107 \u015Bwiadczenie Us\u0142ugi po uzyskaniu wyra\u017Anej zgody U\u017Cytkownika."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 3 POZOSTA\u0141E ZASADY KORZYSTANIA Z US\u0141UG"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. Mo\u017Cliwo\u015B\u0107 skorzystania przez U\u017Cytkownika z Us\u0142ugi uzale\u017Cniona jest od nale\u017Cytego spe\u0142nienia wymog\xF3w okre\u015Blonych w niniejszym Regulaminie. W szczeg\xF3lno\u015Bci U\u017Cytkownik zobowi\u0105zany jest zapewni\u0107 we w\u0142asnym zakresie spe\u0142nienie nast\u0119puj\u0105cych minimalnych wymaga\u0144 technicznych:"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "a) telefon kom\xF3rkowy wyposa\u017Cony w aktywn\u0105 kart\u0119 SIM w sieci jednego z Operator\xF3w, posiadaj\u0105cy funkcjonalno\u015Bci umo\u017Cliwiaj\u0105ce aktywacj\u0119 i korzystanie z Serwisu, w tym odbieranie wiadomo\u015Bci SMS oraz brak blokad uniemo\u017Cliwiaj\u0105cych korzystanie z Us\u0142ugi Dost\u0119powej;"
                    )
                  ),
                  _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "b) po\u0142\u0105czenie z sieci\u0105 Internet;"
                    )
                  ),
                  _react2.default.createElement(
                    "li",
                    null,
                    " ",
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "c) komputer, telefon lub inne urz\u0105dzenie cyfrowe z zainstalowanym oprogramowaniem umo\u017Cliwiaj\u0105cym przegl\u0105danie stron internetowych (np. Internet Explorer, Google Chrome), prawid\u0142owo skonfigurowane, w szczeg\xF3lno\u015Bci w zakresie transmisji danych;"
                    )
                  ),
                  _react2.default.createElement(
                    "li",
                    null,
                    " ",
                    _react2.default.createElement(
                      "p",
                      { className: "terms-para" },
                      "d) prawid\u0142owa konfiguracja powy\u017Cszych urz\u0105dze\u0144, w szczeg\xF3lno\u015Bci w zakresie transmisji danych."
                    )
                  )
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. U\u017Cytkownik powinien by\u0107 uprawniony do korzystania z urz\u0105dze\u0144, o kt\xF3rych mowa powy\u017Cej, w zakresie umo\u017Cliwiaj\u0105cym korzystanie z Serwisu i Us\u0142ugi."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. Dodatkowe informacje dotycz\u0105ce funkcjonalno\u015Bci oraz interoperacyjno\u015Bci Us\u0142ug, w tym kompatybilno\u015Bci z modelem telefonu, oprogramowaniem komputera lub innego urz\u0105dzenia, a tak\u017Ce ewentualne techniczne \u015Brodki ochrony Us\u0142ug, mog\u0105 by\u0107 podane w Serwisie przy wybranych Us\u0142ugach."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "4. U\u017Cytkownik zobowi\u0105zany jest do ochrony has\u0142a oraz dost\u0119pu do telefonu kom\xF3rkowego, komputera lub konta umo\u017Cliwiaj\u0105cego korzystanie z Serwisu lub Us\u0142ug przed nieuprawnionym u\u017Cyciem przez osoby trzecie."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "5. U\u017Cytkownik uzyskuj\u0105cy dost\u0119p do Us\u0142ugi ma prawo korzysta\u0107 z niej wy\u0142\u0105cznie w zakresie okre\u015Blonym niniejszym Regulaminem, tj. wy\u0142\u0105cznie w celu odtwarzania Us\u0142ugi na telefonie, komputerze lub innym przeznaczonym do tego urz\u0105dzeniu. W szczeg\xF3lno\u015Bci U\u017Cytkownik nie jest uprawniony do kopiowania, zwielokrotniania, modyfikowania, prezentowania, publikowania ani rozpowszechniania Us\u0142ugi lub jej cz\u0119\u015Bci w jakiejkolwiek formie."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "Korzystanie z Us\u0142ugi dozwolone jest wy\u0142\u0105cznie na u\u017Cytek w\u0142asny U\u017Cytkownika (tj. osoby, na rzecz kt\xF3rej \u015Bwiadczona jest Us\u0142uga). Niedopuszczalne jest wykorzystywanie Us\u0142ugi lub jej cz\u0119\u015Bci w celach komercyjnych, w tym w ramach dzia\u0142alno\u015Bci gospodarczej, jej odsprzeda\u017C lub udost\u0119pnianie osobom trzecim."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 4 OGRANICZENIA. PRAWA AUTORSKIE"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. Mog\u0105 wyst\u0105pi\u0107 kr\xF3tkotrwa\u0142e przerwy w dost\u0119pie do Us\u0142ugi, nie d\u0142u\u017Csze ni\u017C 5 godzin miesi\u0119cznie, spowodowane pracami konserwacyjnymi lub technicznymi. W przypadku d\u0142u\u017Cszych przerw Organizator do\u0142o\u017Cy stara\u0144, aby usun\u0105\u0107 awari\u0119 w najkr\xF3tszym mo\u017Cliwym czasie."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. Us\u0142uga dost\u0119pna jest z wykorzystaniem transmisji danych, podczas kt\xF3rej mog\u0105 wyst\u0105pi\u0107 okoliczno\u015Bci niezale\u017Cne od Organizatora, takie jak warunki pogodowe, nieprawid\u0142owa instalacja, niska jako\u015B\u0107 sygna\u0142u lub awarie sieci."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. Us\u0142uga podlega ograniczeniom terytorialnym (geolokalizacyjnym) i jest dost\u0119pna dla U\u017Cytkownik\xF3w loguj\u0105cych si\u0119 z terytorium Rzeczypospolitej Polskiej lub zweryfikowanych jako posiadaj\u0105cych sta\u0142e miejsce zamieszkania w Polsce."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "4. Tre\u015Bci Us\u0142ug mog\u0105 stanowi\u0107 utwory chronione prawem autorskim. Organizator mo\u017Ce stosowa\u0107 systemy autoryzacji i szyfrowania. U\u017Cytkownik mo\u017Ce korzysta\u0107 z Us\u0142ug wy\u0142\u0105cznie do u\u017Cytku osobistego i nie jest uprawniony do ich publicznego lub komercyjnego udost\u0119pniania."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "5. Us\u0142ugi mog\u0105 podlega\u0107 ograniczeniom licencyjnym lub technicznym, w tym sprz\u0119towym. Informacje o takich ograniczeniach dost\u0119pne s\u0105 w Serwisie przy opisie danej Us\u0142ugi."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "6. Ograniczenie dost\u0119pu do Us\u0142ugi mo\u017Ce nast\u0105pi\u0107 w przypadku korzystania z niej jednocze\u015Bnie na kilku urz\u0105dzeniach lub pr\xF3by nieautoryzowanego dost\u0119pu do Konta U\u017Cytkownika."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "7. Zabrania si\u0119 dostarczania tre\u015Bci o charakterze bezprawnym."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 5 ODPOWIEDZIALNO\u015A\u0106"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. Organizator ponosi odpowiedzialno\u015B\u0107 za brak dostarczenia Us\u0142ugi w terminie oraz brak jej zgodno\u015Bci z Umow\u0105."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. W przypadku niedostarczenia Us\u0142ugi w terminie U\u017Cytkownik ma prawo wezwa\u0107 Organizatora do jej dostarczenia w trybie reklamacyjnym. Je\u017Celi Us\u0142uga nie zostanie dostarczona, U\u017Cytkownik mo\u017Ce odst\u0105pi\u0107 od Umowy."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. W przypadku \u015Bwiadczenia Us\u0142ugi w spos\xF3b niezgodny z Umow\u0105, U\u017Cytkownik mo\u017Ce \u017C\u0105da\u0107 doprowadzenia Us\u0142ugi do zgodno\u015Bci z Umow\u0105 poprzez z\u0142o\u017Cenie reklamacji."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 6 REKLAMACJE"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. U\u017Cytkownik ma prawo z\u0142o\u017Cy\u0107 reklamacj\u0119."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. Reklamacje mo\u017Cna sk\u0142ada\u0107 drog\u0105 elektroniczn\u0105 na adres reklamacje@teleaudio.pl lub pisemnie na adres Organizatora."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. Reklamacja powinna zawiera\u0107 imi\u0119 i nazwisko, numer MSISDN, opis przedmiotu reklamacji, okres jej dotycz\u0105cy oraz okoliczno\u015Bci uzasadniaj\u0105ce reklamacj\u0119."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "4. Reklamacja zostanie rozpatrzona nie p\xF3\u017Aniej ni\u017C w ci\u0105gu 14 dni od jej otrzymania."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "5. Odpowied\u017A na reklamacj\u0119 zostanie udzielona drog\u0105 elektroniczn\u0105 lub pisemn\u0105, zgodnie z form\u0105 zg\u0142oszenia."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "6. Organizator mo\u017Ce wezwa\u0107 U\u017Cytkownika do uzupe\u0142nienia brakuj\u0105cych informacji. Brak wsp\xF3\u0142pracy mo\u017Ce skutkowa\u0107 pozostawieniem reklamacji bez rozpatrzenia."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "7. U\u017Cytkownik ma prawo dochodzenia roszcze\u0144 na drodze s\u0105dowej lub pozas\u0105dowej."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\xA7 7 POSTANOWIENIA KO\u0143COWE. ZMIANY REGULAMINU"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "1. Organizator jest uprawniony do wprowadzania zmian Regulaminu."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "2. Zmiany Regulaminu mog\u0105 wynika\u0107 m.in. ze zmian przepis\xF3w prawa, wymog\xF3w administracyjnych, kwestii bezpiecze\u0144stwa, rozwoju Us\u0142ugi lub zmian technologicznych."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "3. Informacja o zmianach Regulaminu b\u0119dzie publikowana w Serwisie z co najmniej 14-dniowym wyprzedzeniem, o ile jest to mo\u017Cliwe."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "4. W przypadku istotnych zmian negatywnie wp\u0142ywaj\u0105cych na Us\u0142ug\u0119, U\u017Cytkownik mo\u017Ce wypowiedzie\u0107 Umow\u0119 w terminie 30 dni."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "5. W sprawach nieuregulowanych Regulaminem stosuje si\u0119 przepisy prawa polskiego."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "6. Regulamin wchodzi w \u017Cycie z dniem 21 maja 2025 r."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "WZ\xD3R FORMULARZA ODST\u0104PIENIA OD UMOWY"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "(formularz ten nale\u017Cy wype\u0142ni\u0107 i odes\u0142a\u0107 tylko w przypadku ch\u0119ci odst\u0105pienia od Umowy) \xA0"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "Adresat:\xA0\u2026\u2026. Ja niniejszym informuj\u0119 o moim odst\u0105pieniu od",
                  _react2.default.createElement("br", null),
                  "Umowy \u2026\u2026\u2026.. . Data zawarcia",
                  _react2.default.createElement("br", null),
                  "umowy.............................. Imi\u0119 i nazwisko",
                  _react2.default.createElement("br", null),
                  "U\u017Cytkownika...................... Adres",
                  _react2.default.createElement("br", null),
                  "U\u017Cytkownika................................ Podpis U\u017Cytkownika",
                  _react2.default.createElement("br", null),
                  "(tylko je\u017Celi formularz jest przesy\u0142any w wersji papierowej)",
                  _react2.default.createElement("br", null),
                  "Data..................... \xA0"
                )
              )
            )
          )
        );
      } else if (_domainConfig.config.subDomain === "portal" && _isGamiclub.isGameverse) {
        return _react2.default.createElement(
          "section",
          { className: "terms" },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12" },
              _react2.default.createElement(
                "div",
                { className: "terms-title-wrap" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-section-title" },
                  "Bendrosios s\u0105lygos ir privatumo politika"
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactstrap.Container,
            { fluid: true },
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0160ios Bendrosios s\u0105lygos taikomos produktams ir paslaugoms, teikiamoms per WAP, SMS, GPRS ir 3G, kuriuos teikia \u201EMobimilia BV\u201C arba jos susijusios \u012Fmon\u0117s (toliau \u2013 \u201ETiek\u0117jas\u201C). Tiek\u0117jas turi teis\u0119 retkar\u010Diais keisti \u0161ias Bendr\u0105sias s\u0105lygas be i\u0161ankstinio \u012Fsp\u0117jimo. Be Bendr\u0173j\u0173 s\u0105lyg\u0173, jums ir Tiek\u0117jui, naudojantis Tiek\u0117jo Paslaugomis (kaip apibr\u0117\u017Eta toliau), taip pat taikomos visos taikomos ir vie\u0161ai paskelbtos taisykl\u0117s, akcij\u0173 s\u0105lygos, gair\u0117s ir nuostatos, susijusios su paslaugomis. Visos tokios gair\u0117s, taisykl\u0117s, akcij\u0173 s\u0105lygos ir nuostatos laikomos neatskiriama \u0161i\u0173 Bendr\u0173j\u0173 s\u0105lyg\u0173 dalimi. Naudodamiesi Tiek\u0117jo Paslaugomis, j\u016Bs sutinkate laikytis \u0161i\u0173 Bendr\u0173j\u0173 s\u0105lyg\u0173, gairi\u0173, taisykli\u0173 ir akcij\u0173 s\u0105lyg\u0173."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Tiek\u0117jo apra\u0161ymas"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Naudodamas WAP, SMS, GPRS ir 3G paslaugas, Tiek\u0117jas suteikia vartotojams prieig\u0105 prie internetini\u0173 i\u0161tekli\u0173 tinklo, \u012Fskaitant internetinius \u017Eaidimus, tekstinius prane\u0161imus, turting\u0105 turin\u012F ir internetin\u0119 informacij\u0105, kuri\u0105 galima atsisi\u0173sti \u012F mobil\u0173j\u012F telefon\u0105 ar kitus \u012Frenginius (toliau \u2013 \u201EPaslaugos\u201C). Bendrosios s\u0105lygos visada taikomos visoms naujoms funkcijoms, \u012Fskaitant funkcijas, kurias Tiek\u0117jas gali \u012Fgyvendinti pl\u0117todamas, i\u0161pl\u0117sdamas ar tobulindamas savo paslaugas, taip pat bet kokioms naujoms funkcijoms, kurias Tiek\u0117jas prideda."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Prieinamumas"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Paslauga teikiama tokia, kokia yra (dabartiniame jos vystymosi etape), ir Tiek\u0117jas neprisiima jokios atsakomyb\u0117s bei nesuteikia joki\u0173 garantij\u0173 ar u\u017Etikrinim\u0173 tuo atveju, jei asmeniniai nustatymai, informacija ar prane\u0161imai nebus i\u0161saugoti, nebus i\u0161saugoti laiku, bus i\u0161trinti arba pateikti neteisingai. Nor\u0117dami u\u017Esisakyti Paslaug\u0105, turite tur\u0117ti prieig\u0105 prie interneto ir (arba) mobiliojo ry\u0161io abonement\u0105 bei sumok\u0117ti visus su tokia prieiga susijusius mokes\u010Dius. Turite padengti visas i\u0161laidas, susijusias su tokios prieigos suk\u016Brimu. Taip pat esate atsakingi u\u017E bet kokios reikalingos \u012Frangos, \u012Fskaitant mobil\u0173j\u012F telefon\u0105, asmenin\u012F kompiuter\u012F ar kitus \u012Frenginius, kurie gali b\u016Bti reikalingi ir tinkami naudoti su Paslauga, prijungim\u0105."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Mok\u0117jimas"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Prieig\u0105 prie m\u016Bs\u0173 internetini\u0173 paslaug\u0173 turite nemokamai. Naudodamiesi Paslaugomis, privalote mok\u0117ti sum\u0105, atitinkan\u010Di\u0105 tuo metu galiojan\u010Dius Tiek\u0117jo tarifus ir j\u016Bs\u0173 mobiliojo ry\u0161io operatoriaus taikomus tarifus. Mokes\u010Diai bus \u012Ftraukiami \u012F j\u016Bs\u0173 mobiliojo ry\u0161io operatoriaus s\u0105skait\u0105, kuri\u0105 gausite i\u0161 savo tinklo mobiliojo ry\u0161io operatoriaus. J\u016Bs mokate Tiek\u0117jui visus nacionalinius, vietinius ar kitus mokes\u010Dius, \u012Fskaitant, bet neapsiribojant, PVM, bet kokius mokes\u010Dius ar rinkliavas, taikomas Paslaug\u0173 naudojimo i\u0161laidoms, nepriklausomai nuo to, ar \u0161iuos mokes\u010Dius dabar ar ateityje nustato Europos, nacionalin\u0117s ar vietin\u0117s vald\u017Eios institucijos, ar bet kuris kitas \u012Fgaliotas mokes\u010Dius renkantis subjektas. Tiek\u0117jas pasilieka teis\u0119 keisti Paslaug\u0173 tarifus, paskelbdamas informacij\u0105 apie tokius pakeitimus savo svetain\u0117je."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Registracijos \u012Fsipareigojimas"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Siekiant u\u017Etikrinti saug\u0173 ir patikim\u0105 Paslaugos naudojim\u0105, be taikom\u0173 mokes\u010Di\u0173 sumok\u0117jimo, j\u016Bs garantuojate, kad: (a) j\u016Bs\u0173 asmenin\u0117 informacija (toliau \u2013 \u201ERegistracijos informacija\u201C), pateikta registracijos formoje, yra teisinga, tiksli ir i\u0161sami; ir (b) j\u016Bs sutinkate u\u017Etikrinti, kad Registracijos informacija visada b\u016Bt\u0173 teisinga, tiksli ir i\u0161sami. Jei Tiek\u0117jas turi pagr\u012Fst\u0105 prie\u017East\u012F \u012Ftarti, kad Registracijos informacija yra neteisinga, netiksli ar nei\u0161sami, Tiek\u0117jas turi teis\u0119 sustabdyti ar nutraukti j\u016Bs\u0173 paskyr\u0105 bei u\u017Edrausti tiek dabartin\u012F, tiek b\u016Bsim\u0105 Paslaugos ar jos sudedam\u0173j\u0173 dali\u0173 naudojim\u0105. J\u016Bs esate atsakingi u\u017E bet koki\u0173 slapta\u017Eod\u017Ei\u0173 ir (arba) paskyr\u0173, kuriuos jums suteik\u0117 Tiek\u0117jas, konfidencialumo i\u0161laikym\u0105 ir esate visi\u0161kai atsakingi u\u017E vis\u0105 veikl\u0105, vykdom\u0105 naudojant j\u016Bs\u0173 slapta\u017Eod\u012F ar paskyr\u0105. J\u016Bs \u012Fsipareigojate u\u017Edaryti savo paskyr\u0105 kiekvienos sesijos pabaigoje (u\u017Edarydami nar\u0161ykl\u0119) ir susisiekti su Tiek\u0117ju, jei pastebite ar \u012Ftariate, kad j\u016Bs\u0173 slapta\u017Eodis ar paskyra buvo panaudoti neteis\u0117tai arba kad d\u0117l bet kokios kitos prie\u017Easties saugumas ar apsauga neb\u0117ra u\u017Etikrinti. Tiek\u0117jas negali ir neatsakys u\u017E joki\u0105 \u017Eal\u0105, atsiradusi\u0105 d\u0117l to, kad nesilaik\u0117te \u0161io straipsnio nuostat\u0173."
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Tiek\u0117jo nuosavyb\u0117s teis\u0117s"
              ),
              _react2.default.createElement(
                "p",
                null,
                "\u0160ios Bendrosios s\u0105lygos taikomos produktams ir paslaugoms, teikiamoms per WAP, SMS, GPRS ir 3G, kuriuos teikia \u201EMobimilia BV\u201C arba jos susijusios \u012Fmon\u0117s (toliau \u2013 \u201ETiek\u0117jas\u201C). Tiek\u0117jas turi teis\u0119 retkar\u010Diais keisti \u0161ias Bendr\u0105sias s\u0105lygas be i\u0161ankstinio \u012Fsp\u0117jimo. Be Bendr\u0173j\u0173 s\u0105lyg\u0173, jums ir Tiek\u0117jui, naudojantis Tiek\u0117jo Paslaugomis (kaip apibr\u0117\u017Eta toliau), taip pat taikomos visos taikomos ir vie\u0161ai paskelbtos taisykl\u0117s, akcij\u0173 s\u0105lygos, gair\u0117s ir nuostatos, susijusios su paslaugomis. Visos tokios gair\u0117s, taisykl\u0117s, akcij\u0173 s\u0105lygos ir nuostatos laikomos neatskiriama \u0161i\u0173 Bendr\u0173j\u0173 s\u0105lyg\u0173 dalimi. Naudodamiesi Tiek\u0117jo Paslaugomis, j\u016Bs sutinkate laikytis \u0161i\u0173 Bendr\u0173j\u0173 s\u0105lyg\u0173, gairi\u0173, taisykli\u0173 ir akcij\u0173 s\u0105lyg\u0173."
              )
            )
          )
        );
      } else if (_domainConfig.config.subDomain === "bg" && _productCondition.isPlaynixzone) {
        return _react2.default.createElement(
          "section",
          { className: "terms" },
          _react2.default.createElement(
            _reactstrap.Container,
            { fluid: true },
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "no-gutters" },
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  {
                    className: "terms-section-title",
                    style: { marginBottom: "20px" }
                  },
                  "\u041E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F"
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0421\u043B\u0435\u0434\u043D\u0438\u0442\u0435 \u041E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0441\u0435 \u043E\u0442\u043D\u0430\u0441\u044F\u0442 \u0437\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0442\u0435 \u0438 \u0443\u0441\u043B\u0443\u0433\u0438\u0442\u0435, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u043D\u0438 \u0447\u0440\u0435\u0437 WAP, SMS, GPRS \u0438 3G \u043E\u0442 Mobimilia. \u0438\u043B\u0438 \u043D\u0435\u0439\u043D\u0438\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 (\u043D\u0430\u0440\u0438\u0447\u0430\u043D\u0438 \u043F\u043E-\u0434\u043E\u043B\u0443 \u201E\u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u201C). \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u044F \u0442\u0435\u0437\u0438 \u041E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435. \u0412 \u0434\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435 \u043A\u044A\u043C \u041E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430, \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u043D\u0430\u0441\u043E\u043A\u0438 \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u043C\u0438 \u0440\u0430\u0437\u043F\u043E\u0440\u0435\u0434\u0431\u0438, \u043F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430\u043D\u0438 \u0432\u044A\u0432 \u0432\u0440\u044A\u0437\u043A\u0430 \u0441 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435, \u0441\u0435 \u043E\u0442\u043D\u0430\u0441\u044F\u0442 \u0438 \u0437\u0430 \u0432\u0430\u0441 \u0438 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430, \u043A\u043E\u0433\u0430\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435 (\u043A\u0430\u043A\u0442\u043E \u0441\u0430 \u0434\u0435\u0444\u0438\u043D\u0438\u0440\u0430\u043D\u0438 \u0432 \u0442\u043E\u0437\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442). \u0412\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u043A\u0438\u0432\u0430 \u043D\u0430\u0441\u043E\u043A\u0438, \u043F\u0440\u0430\u0432\u0438\u043B\u0430, \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0438 \u0440\u0430\u0437\u043F\u043E\u0440\u0435\u0434\u0431\u0438 \u0441\u0435 \u0441\u0447\u0438\u0442\u0430\u0442 \u0437\u0430 \u043D\u0435\u0440\u0430\u0437\u0434\u0435\u043B\u043D\u0430 \u0447\u0430\u0441\u0442 \u043E\u0442 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0442\u0435 \u041E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F. \u0421 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435 \u043D\u0430 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430, \u0432\u0438\u0435 \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u044F\u0432\u0430\u0442\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435\u0442\u0435 \u043E\u0431\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0442\u0435 \u041E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u043A\u0430\u043A\u0442\u043E \u0438 \u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u043C\u0438\u0442\u0435 \u043D\u0430\u0441\u043E\u043A\u0438, \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043D\u0430 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0427\u0440\u0435\u0437 WAP, SMS, GPRS \u0438 3G \u0443\u0441\u043B\u0443\u0433\u0438, \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u043D\u0430 \u0441\u0432\u043E\u0438\u0442\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438 \u0434\u043E\u0441\u0442\u044A\u043F \u0434\u043E \u043C\u0440\u0435\u0436\u0430 \u043E\u0442 \u043E\u043D\u043B\u0430\u0439\u043D \u0440\u0435\u0441\u0443\u0440\u0441\u0438, \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u043E\u043D\u043B\u0430\u0439\u043D \u0438\u0433\u0440\u0438, \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0438 \u0441\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043C\u0443\u043B\u0442\u0438\u043C\u0435\u0434\u0438\u0439\u043D\u043E \u0441\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435 \u0438 \u043E\u043D\u043B\u0430\u0439\u043D \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u0438 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0438, \u043A\u043E\u0438\u0442\u043E \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0438\u0437\u0442\u0435\u0433\u043B\u0435\u043D\u0438 \u043D\u0430 \u043C\u043E\u0431\u0438\u043B\u043D\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 (\u201E\u0423\u0441\u043B\u0443\u0433\u0438\u201C). \u041E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0432\u0438\u043D\u0430\u0433\u0438 \u0441\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u0430\u0442 \u0437\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u043D\u043E\u0432\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0438, \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u0442\u0435\u0437\u0438, \u043A\u043E\u0438\u0442\u043E \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0432\u043D\u0435\u0434\u0440\u0438 \u043A\u0430\u0442\u043E \u0447\u0430\u0441\u0442 \u043E\u0442 \u0440\u0430\u0437\u0448\u0438\u0440\u044F\u0432\u0430\u043D\u0435\u0442\u043E, \u043D\u0430\u0434\u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0435\u0442\u043E \u0438\u043B\u0438 \u043F\u043E\u0434\u043E\u0431\u0440\u044F\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0442\u0435 \u0423\u0441\u043B\u0443\u0433\u0438, \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u0440\u0430\u0437\u0448\u0438\u0440\u0435\u043D\u0438\u044F \u043D\u0430 \u043D\u043E\u0432\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0438, \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0438 \u043E\u0442 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041D\u0430\u043B\u0438\u0447\u043D\u043E\u0441\u0442."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0423\u0441\u043B\u0443\u0433\u0430\u0442\u0430 \u0441\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F \u0432 \u0441\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0442\u043E, \u0432 \u043A\u043E\u0435\u0442\u043E \u0441\u0435 \u043D\u0430\u043C\u0438\u0440\u0430, \u0438 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u043D\u0435 \u043F\u043E\u0435\u043C\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u0438 \u043D\u0435 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430 \u0433\u0430\u0440\u0430\u043D\u0446\u0438\u0438 \u0432 \u0441\u043B\u0443\u0447\u0430\u0439 \u043D\u0430 \u043B\u0438\u0447\u043D\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438, \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0438\u043B\u0438 \u0441\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u044F, \u043A\u043E\u0438\u0442\u043E \u043D\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438, \u043D\u0435 \u0441\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438 \u043D\u0430\u0432\u0440\u0435\u043C\u0435 \u0438\u043B\u0438 \u0441\u0430 \u0438\u0437\u0442\u0440\u0438\u0442\u0438 \u0438\u043B\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0438 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u043D\u043E. \u0417\u0430 \u0434\u0430 \u0441\u0435 \u0430\u0431\u043E\u043D\u0438\u0440\u0430\u0442\u0435 \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0430\u0442\u0430, \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0438\u043C\u0430\u0442\u0435 \u0434\u043E\u0441\u0442\u044A\u043F \u0434\u043E \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0438/\u0438\u043B\u0438 \u043C\u043E\u0431\u0438\u043B\u0435\u043D \u0430\u0431\u043E\u043D\u0430\u043C\u0435\u043D\u0442 \u0438 \u0434\u0430 \u0437\u0430\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0432\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u043A\u0441\u0438, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u0442\u0430\u043A\u044A\u0432 \u0434\u043E\u0441\u0442\u044A\u043F. \u0412\u0438\u0435 \u043D\u043E\u0441\u0438\u0442\u0435 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u0437\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0440\u0430\u0437\u0445\u043E\u0434\u0438, \u043D\u0430\u043F\u0440\u0430\u0432\u0435\u043D\u0438 \u0437\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u043D\u0435\u0442\u043E \u043D\u0430 \u0442\u0430\u043A\u044A\u0432 \u0434\u043E\u0441\u0442\u044A\u043F. \u0412\u0438\u0435 \u0441\u044A\u0449\u043E \u0442\u0430\u043A\u0430 \u043D\u043E\u0441\u0438\u0442\u0435 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u0437\u0430 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0442\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u0432\u0430\u043D\u0435, \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u043D\u043E \u043C\u043E\u0431\u0438\u043B\u0435\u043D \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0435\u043D \u043A\u043E\u043C\u043F\u044E\u0442\u044A\u0440 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E, \u043A\u043E\u0435\u0442\u043E \u043C\u043E\u0436\u0435 \u0434\u0430 \u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0438 \u0432 \u0434\u043E\u0431\u0440\u043E \u0440\u0430\u0431\u043E\u0442\u043D\u043E \u0441\u044A\u0441\u0442\u043E\u044F\u043D\u0438\u0435, \u0437\u0430 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0423\u0441\u043B\u0443\u0433\u0430\u0442\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041F\u043B\u0430\u0449\u0430\u043D\u0435."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0418\u043C\u0430\u0442\u0435 \u0431\u0435\u0437\u043F\u043B\u0430\u0442\u0435\u043D \u0434\u043E\u0441\u0442\u044A\u043F \u0434\u043E \u043D\u0430\u0448\u0438\u0442\u0435 \u043E\u043D\u043B\u0430\u0439\u043D \u0443\u0441\u043B\u0443\u0433\u0438. \u0412\u044A\u0432 \u0432\u0440\u044A\u0437\u043A\u0430 \u0441 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435 \u0438 \u0442\u044F\u0445\u043D\u043E\u0442\u043E \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435, \u0432\u0438\u0435 \u043D\u043E\u0441\u0438\u0442\u0435 \u0437\u0430\u0434\u044A\u043B\u0436\u0435\u043D\u0438\u0435 \u0434\u0430 \u0437\u0430\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0441\u044A\u043E\u0442\u0432\u0435\u0442\u043D\u0430\u0442\u0430 \u0442\u0430\u043A\u0441\u0430 \u0441\u044A\u0433\u043B\u0430\u0441\u043D\u043E \u0430\u043A\u0442\u0443\u0430\u043B\u043D\u0438\u0442\u0435 \u0442\u0430\u0440\u0438\u0444\u0438 \u043D\u0430 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430, \u043A\u0430\u043A\u0442\u043E \u0438 \u0441\u044A\u0433\u043B\u0430\u0441\u043D\u043E \u0442\u0430\u0440\u0438\u0444\u0438\u0442\u0435, \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u0432\u0430\u043D\u0438 \u043E\u0442 \u0432\u0430\u0448\u0438\u044F \u043C\u043E\u0431\u0438\u043B\u0435\u043D \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440. \u0422\u0430\u043A\u0441\u0438\u0442\u0435 \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u0444\u0430\u043A\u0442\u0443\u0440\u0438\u0440\u0430\u043D\u0438 \u0447\u0440\u0435\u0437 \u0432\u0430\u0448\u0438\u044F \u043C\u043E\u0431\u0438\u043B\u0435\u043D \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0432\u044A\u0432 \u0432\u0430\u0448\u0430\u0442\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0430. \u0412\u0438\u0435 \u043F\u043B\u0430\u0449\u0430\u0442\u0435 \u043D\u0430 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0438 \u043C\u0435\u0441\u0442\u043D\u0438 \u0434\u0430\u043D\u044A\u0446\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438 \u0442\u0430\u043A\u0441\u0438, \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u043D\u043E, \u043D\u043E \u043D\u0435 \u0441\u0430\u043C\u043E, \u0414\u0414\u0421 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438 \u0434\u0430\u043D\u044A\u0446\u0438 \u0438 \u0442\u0430\u043A\u0441\u0438, \u043D\u0430\u043B\u0430\u0433\u0430\u043D\u0438 \u0441\u0435\u0433\u0430 \u0438\u043B\u0438 \u0432 \u0431\u044A\u0434\u0435\u0449\u0435 \u043E\u0442 \u0435\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0438, \u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0438\u043B\u0438 \u043C\u0435\u0441\u0442\u043D\u0438 \u0432\u043B\u0430\u0441\u0442\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438 \u0443\u043F\u044A\u043B\u043D\u043E\u043C\u043E\u0449\u0435\u043D\u0438 \u043E\u0440\u0433\u0430\u043D\u0438, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u0440\u0430\u0437\u0445\u043E\u0434\u0438\u0442\u0435 \u0437\u0430 \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435. \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u0441\u0438 \u0437\u0430\u043F\u0430\u0437\u0432\u0430 \u043F\u0440\u0430\u0432\u043E\u0442\u043E \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u044F \u0442\u0430\u0440\u0438\u0444\u0438\u0442\u0435 \u0437\u0430 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435, \u043A\u0430\u0442\u043E \u043F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0442\u0435\u0437\u0438 \u043F\u0440\u043E\u043C\u0435\u043D\u0438 \u043D\u0430 \u0441\u0432\u043E\u044F \u0443\u0435\u0431\u0441\u0430\u0439\u0442."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u0418\u0437\u0438\u0441\u043A\u0432\u0430\u043D\u0435 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F."
                ),
                _react2.default.createElement(
                  "p",
                  { className: "terms-para" },
                  "\u0417\u0430 \u0434\u0430 \u043E\u0441\u0438\u0433\u0443\u0440\u0438\u0442\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0442\u043E \u0438 \u0441\u0438\u0433\u0443\u0440\u043D\u043E \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0430\u0442\u0430, \u0412\u0438\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0430\u0442\u0435 \u0441\u043B\u0435\u0434\u043D\u043E\u0442\u043E, \u0432 \u0434\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435 \u043A\u044A\u043C \u043F\u043B\u0430\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u043C\u0438\u0442\u0435 \u0442\u0430\u043A\u0441\u0438: (\u0430) \u0412\u0430\u0448\u0430\u0442\u0430 \u043B\u0438\u0447\u043D\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F (\u201E\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F\u201C) \u0432\u044A\u0432 \u0444\u043E\u0440\u043C\u0443\u043B\u044F\u0440\u0430 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0435 \u0432\u044F\u0440\u043D\u0430, \u0442\u043E\u0447\u043D\u0430 \u0438 \u043F\u044A\u043B\u043D\u0430 \u0438 (\u0431) \u0412\u0438\u0435 \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u044F\u0432\u0430\u0442\u0435 \u0434\u0430 \u043E\u0441\u0438\u0433\u0443\u0440\u0438\u0442\u0435, \u0447\u0435 \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0442\u0430 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043E\u0441\u0442\u0430\u0432\u0430 \u0432\u044F\u0440\u043D\u0430, \u0442\u043E\u0447\u043D\u0430 \u0438 \u043F\u044A\u043B\u043D\u0430 \u043F\u043E \u0432\u0441\u044F\u043A\u043E \u0432\u0440\u0435\u043C\u0435. \u0410\u043A\u043E \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u0438\u043C\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u0442\u0435\u043B\u043D\u0438 \u043F\u0440\u0438\u0447\u0438\u043D\u0438 \u0434\u0430 \u043F\u043E\u0434\u043E\u0437\u0438\u0440\u0430, \u0447\u0435 \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0442\u0430 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0435 \u0435 \u0442\u043E\u0447\u043D\u0430 \u0438\u043B\u0438 \u043F\u044A\u043B\u043D\u0430, \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u0438\u043C\u0430 \u043F\u0440\u0430\u0432\u043E \u0434\u0430 \u0441\u043F\u0440\u0435 \u0438\u043B\u0438 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438 \u0412\u0430\u0448\u0438\u044F \u0430\u043A\u0430\u0443\u043D\u0442 \u0438 \u0434\u0430 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0430\u0442\u0430 \u043E\u0442 \u0412\u0430\u0448\u0430 \u0441\u0442\u0440\u0430\u043D\u0430. \u0412\u0438\u0435 \u043D\u043E\u0441\u0438\u0442\u0435 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u0437\u0430 \u043F\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442\u0442\u0430 \u043D\u0430 \u0432\u0441\u044F\u043A\u0430 \u043F\u0430\u0440\u043E\u043B\u0430 \u0438/\u0438\u043B\u0438 \u0430\u043A\u0430\u0443\u043D\u0442, \u0438\u0437\u0434\u0430\u0434\u0435\u043D\u0438 \u043E\u0442 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430, \u0438 \u043D\u043E\u0441\u0438\u0442\u0435 \u043F\u044A\u043B\u043D\u0430 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u0437\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u0435\u0442\u0438 \u0441\u044A\u0433\u043B\u0430\u0441\u043D\u043E \u0442\u044F\u0445. \u0412\u0438\u0435 \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u044F\u0432\u0430\u0442\u0435 \u0434\u0430 \u0437\u0430\u0442\u0432\u0430\u0440\u044F\u0442\u0435 \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438 \u0432 \u043A\u0440\u0430\u044F \u043D\u0430 \u0432\u0441\u044F\u043A\u0430 \u0441\u0435\u0441\u0438\u044F \u0438 \u0434\u0430 \u0443\u0432\u0435\u0434\u043E\u043C\u044F\u0432\u0430\u0442\u0435 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430, \u0430\u043A\u043E \u0437\u0430\u0431\u0435\u043B\u0435\u0436\u0438\u0442\u0435 \u0438\u043B\u0438 \u043F\u043E\u0434\u043E\u0437\u0438\u0440\u0430\u0442\u0435 \u043D\u0435\u043E\u0442\u043E\u0440\u0438\u0437\u0438\u0440\u0430\u043D\u043E \u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435. \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u043D\u0435 \u043D\u043E\u0441\u0438 \u043E\u0442\u0433\u043E\u0432\u043E\u0440\u043D\u043E\u0441\u0442 \u0437\u0430 \u043A\u0430\u043A\u0432\u0438\u0442\u043E \u0438 \u0434\u0430 \u0435 \u0449\u0435\u0442\u0438, \u043F\u0440\u043E\u0438\u0437\u0442\u0438\u0447\u0430\u0449\u0438 \u043E\u0442 \u043D\u0435\u0441\u043F\u0430\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0442\u0435\u0437\u0438 \u0437\u0430\u0434\u044A\u043B\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0432\u0430\u0448\u0430 \u0441\u0442\u0440\u0430\u043D\u0430."
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "terms-list" },
                _react2.default.createElement(
                  "h6",
                  { className: "terms-title" },
                  "\u041F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043E\u0441\u0442 \u043D\u0430 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430."
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  "\u0421\u043B\u0435\u0434\u043D\u0438\u0442\u0435 \u041E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0441\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u0430\u0442 \u0437\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0442\u0435 \u0438 \u0443\u0441\u043B\u0443\u0433\u0438\u0442\u0435, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u043D\u0438 \u0447\u0440\u0435\u0437 WAP, SMS, GPRS \u0438 3G \u043E\u0442 Mobimilia. \u0438\u043B\u0438 \u043D\u0435\u0439\u043D\u0438\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u0430 (\u043D\u0430\u0440\u0438\u0447\u0430\u043D\u0438 \u043F\u043E-\u0434\u043E\u043B\u0443 \u201E\u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u201C). \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u044A\u0442 \u043C\u043E\u0436\u0435 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u044F \u041E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u043D\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435. \u0412 \u0434\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435 \u043A\u044A\u043C \u041E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430, \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u043D\u0430\u0441\u043E\u043A\u0438 \u0438 \u0440\u0430\u0437\u043F\u043E\u0440\u0435\u0434\u0431\u0438, \u043F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430\u043D\u0438 \u0432\u044A\u0432 \u0432\u0440\u044A\u0437\u043A\u0430 \u0441 \u0443\u0441\u043B\u0443\u0433\u0438\u0442\u0435, \u0441\u044A\u0449\u043E \u0441\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u0430\u0442 \u0438 \u0441\u0435 \u0441\u0447\u0438\u0442\u0430\u0442 \u0437\u0430 \u0447\u0430\u0441\u0442 \u043E\u0442 \u041E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F. \u0421 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0423\u0441\u043B\u0443\u0433\u0438\u0442\u0435 \u043D\u0430 \u0414\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A\u0430, \u0432\u0438\u0435 \u0441\u0435 \u0441\u044A\u0433\u043B\u0430\u0441\u044F\u0432\u0430\u0442\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435\u0442\u0435 \u043E\u0431\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u0442\u0435\u0437\u0438 \u043E\u0431\u0449\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u043C\u0438\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430."
                )
              )
            )
          )
        );
      } else return _react2.default.createElement(
        "section",
        { className: "terms" },
        _react2.default.createElement(
          _reactstrap.Container,
          { fluid: true },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12" },
              _react2.default.createElement(
                "div",
                { className: "terms-title-wrap" },
                _react2.default.createElement(
                  "h2",
                  { className: "terms-section-title" },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "terms-condition-title",
                    defaultMessage: "Terms and Conditions"
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactstrap.Row,
            { className: "no-gutters" },
            _domainConfig.config.subDomain === "my" && (_isGamiclub.isGamiclub || _productCondition.isGamelords) && _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Owner and Data Controller"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "Owner and Data Controller Name"
                ),
                ": Sam Media Sdn Bhd"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "Address:"
                ),
                " Suite 2, Level 11, Menara Ilham, NO. 8 Jln Binjai, 50450 KL"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "Owner contact email:"
                ),
                " mycs@content-clubs.com"
              )
            ),
            _domainConfig.config.subDomain === "lt" && _isTheGamingClubs.isTheGamingClubs && _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Noteikumi un Nosac\u012Bjumi"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "NAUDOJIMOSI S\u0104LYGOS"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u201EGamingclub\u201C \u2013 tai auk\u0161\u010Diausios kokyb\u0117s SMS paslauga, prieinama Telia, \u201EBit\u0117s\u201C ir \u201ETele2\u201C GSM tinklo naudotojams."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0160i\u0105 paslaug\u0105 teikia \u201ESam Media\u201C (Prizeflix B.V. pagrindin\u0117 \u012Fmon\u0117), Van Diemenstraat 356, 1013CR - Amsterdamas, Olandija."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Kai patvirtinate paslaug\u0105, nukreipimo puslapyje \u012Fvesdami unikal\u0173 PIN numer\u012F arba rakta\u017Eod\u012F si\u0173sdami SMS \u017Einute, sutinkate su paslaugos naudojimosi s\u0105lygomis ir prisijungiate prie \u201EGamingclub\u201C paslaugos. Gausite unikali\u0105 nuorod\u0105, per kuri\u0105 bus galima pasiekti paslaug\u0105. \u201ETelia\u201C ir \u201EBit\u0117\u201C vartotojams: \u201EBit\u0117\u201C vartotojams: kiekvien\u0105 savait\u0119 b\u016Bsite apmokestinti 3,9 EUR, o prenumerata bus automati\u0161kai atnaujinta. \u201ETele 2\u201C ir \u201ETelia\u201C vartotojams: b\u016Bsite apmokestinti 7 EUR u\u017E prane\u0161im\u0105 ir gal\u0117site naudotis paslauga dvi savaites."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "\u0160ie mokes\u010Diai bus mokami i\u0161 j\u016Bs\u0173 i\u0161ankstinio mok\u0117jimo balanso prenumeratos prad\u017Eioje ir v\u0117liau kas savait\u0119 arba bus prid\u0117ti prie j\u016Bs\u0173 m\u0117nesin\u0117s mobiliojo telefono s\u0105skaitos u\u017E \u0161\u012F telefon\u0105. Tekstini\u0173 prane\u0161im\u0173 siuntimo mokestis taikomas pagal standartinius operatoriaus tarifus. Pagal j\u016Bs\u0173 plan\u0105 gali b\u016Bti taikomi operatoriaus duomen\u0173 mokes\u010Diai."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Paslaugos galite atsisakyti si\u0173sdami SMS \u017Einut\u0119 STOP GAMING numeriu 1335."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Paslaugos prenumeratorius privalo b\u016Bti mobiliojo telefono savininkas arba turi gauti atitinkam\u0105 savininko leidim\u0105 dar prie\u0161 prisijungiant prie paslaugos. Prie paslaugos jungtis norintys vaikai iki 18 met\u0173 privalo gauti t\u0117v\u0173 arba glob\u0117j\u0173 sutikim\u0105."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Nei vienas i\u0161 i\u0161vardyt\u0173 produkt\u0173 ar perpardav\u0117j\u0173 jokiu b\u016Bdu n\u0117ra susij\u0119s su \u201EGamingclub\u201C, jis neremia bei papildomai neskatina naudotis \u201EGamingclub\u201C."
              ),
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Galutin\u0117s s\u0105lygos"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Galutin\u0117s s\u0105lygos"
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "gen-terms-condition-title",
                  defaultMessage: "General Terms And Conditions And Privacy Policy."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "gen-terms-condition-desc",
                  defaultMessage: "The following General Terms and Conditions are applicable to the products and services supplied via WAP, SMS, GPRS and 3G by Sam Media Ltd., or enterprises affiliated to it, (hereinafter to be referred to as \u201Cthe Provider\u201D). The Provider is permitted to amend these General Terms and Conditions from time to time without notice. Apart from the General Terms and Conditions, any applicable and publicized rules, promotional conditions, guidelines and provisions pertaining to the services also apply to you and the Provider upon the use of the Services (as defined herein) of the Provider. All those guidelines, rules, promotional conditions and provisions will be considered an inextricable part of these General Terms and Conditions. By availing yourself to use the Services of the Provider, you agree to be bound by these General Terms and Conditions and the guidelines, rules and promotional conditions."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "provider-terms-condition-title",
                  defaultMessage: "Description Of The Provider."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "provider-terms-condition-desc",
                  defaultMessage: "By means of WAP, SMS, GPRS and 3G services, the Provider supplies its user\u2019s access to a network of on-line sources, including on-line games, text messages, rich content and on-line information material which may be downloaded onto mobile telephone or whatsoever devices (\u201CServices\u201D). The General Terms and Conditions are at all times applicable to all new facilities including facilities which the Provider may implement as part of the Provider\u2019s expansion, extension or improvement of the present Services, including any extension to new functions added by the Provider."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "availability-terms-condition-title",
                  defaultMessage: "Availability."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "availability-terms-condition-desc",
                  defaultMessage: "The Service is supplied as is (at the stage of development it happens to be in) and the Provider accepts no liability nor does it issue any guarantees or warranty in the event that personal configurations, information or messages are not saved, or not saved in due time, or if they are deleted or incorrectly delivered. In order to subscribe to the Service, you are required to have access to the Internet and/or a mobile communications subscription and pay any service fees associated with such access. You are required to pay all expenses incurred in creating such access. You are also responsible for seeing to the connection of any necessary equipment, including any mobile telephone or personal computer or whatever devices that may be necessary needed and are in working order and suitable for use in connection with the Service."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "payment-terms-condition-title",
                  defaultMessage: "Payment."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "payment-terms-condition-desc",
                  defaultMessage: "You have access to our on-line services free of charge. With regards to the Services and the use of it, you shall pay the amount corresponding to the applicable rates of the Provider in force at that time and according to the rates charged by your mobile operator. The charges shall be invoiced to you via your mobile operator through the mobile bill you receive from the mobile operator of your network. You pay the Provider all national and local or other taxes, including but not restricted to VAT, any taxes or levies imposed in lieu thereof, which taxes are based on the costs due to the use of the Services, regardless of whether those taxes are levied either now or in the future by European, national or local authorities or by any other body or bodies authorized to levy taxes. The Provider reserves the right to change the rates for the Service by posting details of such changes on its website."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "obligation-terms-condition-title",
                  defaultMessage: "Registration Obligation."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "obligation-terms-condition-desc",
                  defaultMessage: "In order to warrant safe and secure use of the Service, you guarantee the following, in addition to paying the applicable charges: (a) your personal information (hereinafter to be referred to as the \u201CRegistered Information\u201D) provided on the registration form is correct, true, accurate and complete and (b) you agree to ensure that the Registered Information is at all times correct, up to date, true, accurate and complete. If the Provider has a reasonable suspicion that the Registered Information does not reflect a true state of affairs, or is not accurate or complete, then the Provider is entitled to suspend or terminate your account and to withhold both current and future use of the Service, or any component of it. You yourself are responsible for maintaining the secrecy of any passwords and/or accounts issued to you by the Provider, and you are fully liable for all actions carried out involving the use of your password or account. You undertake at the end of each session to close your account (by closing your browser) and to contact the Provider if you notice or suspect that unauthorized use has been made of your password or account, or that security or protection is no longer guaranteed for any other reason. The Provider cannot and will not be liable for any damage arising from your failure to observe the stipulations of this article."
                })
              )
            ),
            _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "ownership-terms-condition-title",
                  defaultMessage: "Ownership Rights Of The Provider."
                })
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "ownership-terms-condition-desc",
                  defaultMessage: "The following General Terms and Conditions are applicable to the products and services supplied via WAP, SMS, GPRS and 3G by Sam Media Ltd., or enterprises affiliated to it, (hereinafter to be referred to as \u201Cthe Provider\u201D). The Provider is permitted to amend these General Terms and Conditions from time to time without notice. Apart from the General Terms and Conditions, any applicable and publicized rules, promotional conditions, guidelines and provisions pertaining to the services also apply to you and the Provider upon the use of the Services (as defined herein) of the Provider. All those guidelines, rules, promotional conditions and provisions will be considered an inextricable part of these General Terms and Conditions. By availing yourself to use the Services of the Provider, you agree to be bound by these General Terms and Conditions and the guidelines, rules and promotional conditions."
                })
              )
            ),
            _domainConfig.config.subDomain === "pt" && _productCondition.isGamelords && _react2.default.createElement(
              _reactstrap.Col,
              { xs: "12", className: "terms-list" },
              _react2.default.createElement(
                "h6",
                { className: "terms-title" },
                "Como cancelar?"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Ap\xF3s confirmar a aceita\xE7\xE3o do pagamento do servi\xE7o, o utilizador poder\xE1 aceder ou visualizar todos os produtos que estejam dispon\xEDveis dentro da servi\xE7o que subscreveu. O servi\xE7o permanecer\xE1 activo at\xE9 que o pr\xF3prio utilizador solicite o cancelamento do mesmo. Poder\xE1 faz\xEA-lo de forma gratuita em qualquer momento bastando para isso utilizar qualquer uma das ferramentas dispon\xEDveis para o efeito:"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Enviar a keyword \xB4SAIR\xB4 para o 62947."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Atrav\xE9s do servi\xE7o de apoio ao cliente:"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Hor\xE1rio de atendimento telef\xF3nico: dias \xFAteis (excepto feriados) das 09h00 \xE0s 18h00."
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Linha de Apoio ao Cliente:"
              ),
              _react2.default.createElement(
                "p",
                { className: "terms-para" },
                "Gamelords - 707 450 201"
              )
            )
          )
        )
      );
    }
  }]);

  return Terms;
}(_react.Component);

exports.default = Terms;

/***/ }),

/***/ "./src/components/TextModal/textModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _textModalPreview = __webpack_require__("./src/components/TextModal/textModalPreview.js");

var _textModalPreview2 = _interopRequireDefault(_textModalPreview);

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextModal = function (_Component) {
  _inherits(TextModal, _Component);

  function TextModal(props) {
    _classCallCheck(this, TextModal);

    var _this = _possibleConstructorReturn(this, (TextModal.__proto__ || Object.getPrototypeOf(TextModal)).call(this, props));

    _this.onOpenModal = function (data) {
      _this.setState({
        textmodalData: data,
        isOpen: true
      });
    };

    _this.onCloseModal = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.state = {
      isOpen: false,
      textmodalData: []
    };
    return _this;
  }

  _createClass(TextModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var gameCategoryTitleClass = "game-category-title";
      var gamesParams = {
        direction: 'horizontal',
        slidesPerView: 'auto',
        speed: 500
      };
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_textModalPreview2.default, {
          isModalOpen: this.state.isOpen,
          textmodalData: this.state.textmodalData,
          closeModal: this.onCloseModal
        }),
        this.props.text.map(function (data) {
          return _react2.default.createElement(
            "div",
            { key: data.id },
            _react2.default.createElement(
              _reactstrap.Row,
              null,
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12", className: "game-related-container" },
                _react2.default.createElement(
                  "div",
                  { className: "game-related-top" },
                  _react2.default.createElement(
                    "div",
                    {
                      className: "game-category",
                      style: _isGamiclub.isGamiclub ? { borderBottom: "1px solid green" } : _productCondition.isGameflares ? { borderBottom: "1px solid #FF394B" } : null
                    },
                    _react2.default.createElement(
                      "h2",
                      {
                        style: _isGamiclub.isGamiclub ? { color: "white", backgroundColor: "green" } : _productCondition.isGameflares ? { color: "white", backgroundColor: "#FF394B" } : null,
                        className: gameCategoryTitleClass
                      },
                      _react2.default.createElement("i", { className: "fa fa-sticky-note-o", "aria-hidden": "true" }),
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: data.categoryName,
                        defaultMessage: data.categoryName
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "game-list-row" },
              _react2.default.createElement(
                _reactstrap.Col,
                { xs: "12" },
                _react2.default.createElement(
                  _reactIdSwiper2.default,
                  _extends({}, gamesParams, { shouldSwiperUpdate: true }),
                  data.tips.map(function (value) {
                    return _react2.default.createElement(
                      "div",
                      { className: "swiper-wallpaper-card", key: value.id },
                      _react2.default.createElement(
                        _reactstrap.Card,
                        {
                          className: "wallpaper-card " + (_productCondition.isGameflares ? 'wallpaper-card-gameflares' : ''),
                          onClick: function onClick() {
                            return _this2.onOpenModal(value);
                          }
                        },
                        _react2.default.createElement(
                          "div",
                          { className: "wallpaper-card-inner" },
                          _react2.default.createElement(
                            "div",
                            { className: "wallpaper-thumb-wrap" },
                            _react2.default.createElement(_reactstrap.CardImg, {
                              className: "wallpaper-thumb",
                              top: true,
                              width: "auto",
                              height: "150",
                              src: value.img
                            })
                          ),
                          _react2.default.createElement(
                            "span",
                            { className: "wallpaper-title" },
                            value.title
                          )
                        )
                      )
                    );
                  })
                )
              )
            )
          );
        })
      );
    }
  }]);

  return TextModal;
}(_react.Component);

exports.default = TextModal;

/***/ }),

/***/ "./src/components/TextModal/textModalPreview.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactResponsiveModal = __webpack_require__("./node_modules/react-responsive-modal/lib/index.es.js");

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextModalPreview = function (_Component) {
  _inherits(TextModalPreview, _Component);

  function TextModalPreview(props) {
    _classCallCheck(this, TextModalPreview);

    return _possibleConstructorReturn(this, (TextModalPreview.__proto__ || Object.getPrototypeOf(TextModalPreview)).call(this, props));
  }

  _createClass(TextModalPreview, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _reactResponsiveModal2.default,
        {
          open: this.props.isModalOpen,
          onClose: this.props.closeModal,
          classNames: {
            overlay: "textModalOverlay",
            modal: "customModal textModal",
            closeButton: "customCloseButton",
            closeIcon: "customCloseIcon"
          }
        },
        _react2.default.createElement(
          "div",
          { className: "textModalPreview" },
          _react2.default.createElement(
            "h1",
            null,
            this.props.textmodalData.title
          ),
          _react2.default.createElement(
            "div",
            { className: "text_Modal_img" },
            _react2.default.createElement("img", { src: this.props.textmodalData.img })
          ),
          this.props.textmodalData.generalText && _react2.default.createElement(
            "p",
            { className: "text_Modal_generaltext" },
            this.props.textmodalData.generalText
          ),
          _react2.default.createElement(
            "ul",
            { className: "text_Modal_List" },
            this.props.textmodalData.description ? this.props.textmodalData.description.map(function (item) {
              return _react2.default.createElement(
                "div",
                { key: item.id },
                _react2.default.createElement(
                  "li",
                  null,
                  item.heading
                ),
                _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: item.details } })
              );
            }) : null
          )
        )
      );
    }
  }]);

  return TextModalPreview;
}(_react.Component);

exports.default = TextModalPreview;

/***/ }),

/***/ "./src/components/UploadVideos/VideoModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactResponsiveModal = __webpack_require__("./node_modules/react-responsive-modal/lib/index.es.js");

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoModal = function VideoModal(_ref) {
    var url = _ref.url,
        onCloseModal = _ref.onCloseModal,
        isModalOpen = _ref.isModalOpen,
        title = _ref.title,
        poster = _ref.poster;

    var customStyles = {
        customModal: {
            background: 'black'
        }
    };

    return _react2.default.createElement(
        _reactResponsiveModal2.default,
        { open: isModalOpen, onClose: onCloseModal,
            classNames: {
                modal: !_isGamiclub.isGamiclub ? "customModal" : "customModalGamiclub",
                closeButton: !_isGamiclub.isGamiclub ? "customCloseButton" : "customCloseButtonGamiclub",
                closeIcon: "customCloseIcon"
            },
            onOverlayClick: onCloseModal, center: true },
        _react2.default.createElement(
            'div',
            { className: 'wallpaperPreview' },
            _react2.default.createElement(
                'h3',
                { style: { color: 'white' } },
                title
            ),
            _react2.default.createElement(
                'video',
                { style: { maxWidth: '640px', height: 'auto' }, poster: poster, controls: true, disablePictureInPicture: true },
                _react2.default.createElement('source', { src: url, type: 'video/mp4' }),
                'Your browser does not support HTML5 Video'
            )
        )
    );
};
exports.default = VideoModal;

/***/ }),

/***/ "./src/components/UploadVideos/video.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _VideoModal = __webpack_require__("./src/components/UploadVideos/VideoModal.js");

var _VideoModal2 = _interopRequireDefault(_VideoModal);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Videos = function (_Component) {
    _inherits(Videos, _Component);

    function Videos(props) {
        _classCallCheck(this, Videos);

        var _this = _possibleConstructorReturn(this, (Videos.__proto__ || Object.getPrototypeOf(Videos)).call(this, props));

        _this.handleSelectedVideo = function (data) {
            _this.setState({
                selectedVideo: data.video_url,
                isModalOpen: true,
                selectedVideoTitle: data.title,
                poster: data.images_url
            });
        };

        _this.onCloseModal = function () {
            _this.setState({
                isModalOpen: false
            });
        };

        _this.state = {
            isModalOpen: false,
            selectedVideo: null,
            selectedVideoTitle: '',
            poster: ''
        };
        return _this;
    }

    _createClass(Videos, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                selectedVideo = _state.selectedVideo,
                isModalOpen = _state.isModalOpen,
                selectedVideoTitle = _state.selectedVideoTitle,
                poster = _state.poster;


            var gamesParams = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500
            };

            var gameCategoryTitleClass = "game-category-title";

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_VideoModal2.default, { url: selectedVideo, title: selectedVideoTitle, onCloseModal: this.onCloseModal, isModalOpen: isModalOpen, poster: poster }),
                this.props.video.map(function (item) {
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _reactstrap.Row,
                            null,
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12', className: 'game-related-container' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'game-related-top' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : null },
                                        _react2.default.createElement(
                                            'h2',
                                            { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : null, className: gameCategoryTitleClass },
                                            _react2.default.createElement('i', { className: 'fa fa-video-camera', 'aria-hidden': 'true' }),
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'VideosGamingTips',
                                                defaultMessage: item.category_name
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Row,
                            { className: 'game-list-row' },
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12' },
                                _react2.default.createElement(
                                    _reactIdSwiper2.default,
                                    _extends({}, gamesParams, { shouldSwiperUpdate: true }),
                                    item.data.map(function (each_item) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'swiper-wallpaper-card', key: each_item.id },
                                            _react2.default.createElement(
                                                _reactstrap.Card,
                                                { className: !_isGamiclub.isGamiclub ? "wallpaper-card" : "wallpaper-card-gamiclub", onClick: function onClick() {
                                                        return _this2.handleSelectedVideo(each_item);
                                                    } },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'wallpaper-card-inner' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'wallpaper-thumb-wrap' },
                                                        _react2.default.createElement(_reactstrap.CardImg, { className: 'wallpaper-thumb', style: { objectFit: 'cover', height: '150px' }, alt: each_item.title, src: each_item.images_url })
                                                    ),
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'wallpaper-title' },
                                                        _react2.default.createElement(
                                                            'strong',
                                                            null,
                                                            each_item.title
                                                        )
                                                    )
                                                )
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    );
                })
            );
        }
    }]);

    return Videos;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Videos);

/***/ }),

/***/ "./src/components/Uploads/Uploads.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain = _domainConfig.config.lang == 'ar' ? true : false;

var data = new FormData();

var Uploads = function (_Component) {
    _inherits(Uploads, _Component);

    function Uploads(props) {
        _classCallCheck(this, Uploads);

        var _this = _possibleConstructorReturn(this, (Uploads.__proto__ || Object.getPrototypeOf(Uploads)).call(this, props));

        _this.state = {
            gameTitle: '',
            gameDesc: '',
            gameImage: false,
            gameFile: false,
            gameType: '',
            platforms: '',
            categoryId: 0,
            categoryTypeId: 0,
            isValid: false,
            errorMessage: ''
        };

        _this.isValid = _this.isValid.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(Uploads, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getGameTypes();
            this.getCategories();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.user.isAuthenticated) {
                this.props.history.push('/login');
            }
        }
    }, {
        key: 'getGameTypes',
        value: function getGameTypes() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getCategoryTypes').then(function (response) {
                if (response.data.success) {
                    _this2.props.getGameTypes(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
                _this2.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'getCategories',
        value: function getCategories() {
            var _this3 = this;

            this.props.show();
            _axios2.default.get(vars.BASE_URL + '/getCategories').then(function (response) {
                _this3.props.hide();
                if (response.data.success) {
                    var dataFinal = response.data;
                    var categoriesArr = dataFinal.data;
                    dataFinal = _extends({}, dataFinal, { data: categoriesArr });
                    if (!(_domainConfig.config.subDomain === 'cz' && isGamiclub)) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'E-knihy';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'fr' && isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Heróis Verdes';
                        });
                    }
                    if (_domainConfig.config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    }
                    if (_domainConfig.config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"];
                            return excludes.indexOf(category.categoryName) == -1;
                        });
                    } else {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Videos Virales';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'rs') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Е-књиге';
                        });
                    }
                    if (_domainConfig.config.subDomain !== 'tr' && _domainConfig.config.subDomain !== 'qa' && _domainConfig.config.subDomain !== 'kw') {
                        dataFinal.data = dataFinal.data.filter(function (category) {
                            return category.categoryName != 'Facebook';
                        });
                    }
                    _this3.props.getCategories(dataFinal);
                }
            }).catch(function (error) {
                _this3.props.hide();
                (0, _helper.console_log)(error);
                _this3.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            switch (e.target.name) {
                case 'gameImage':
                    {
                        data.append('gameImage', e.target.files[0]);
                        this.setState({
                            gameImage: _typeof(e.target.files[0]) == 'object' ? true : false
                        });
                        break;
                    }
                case 'gameFile':
                    {
                        data.append('gameFile', e.target.files[0]);
                        this.setState({
                            gameFile: _typeof(e.target.files[0]) == 'object' ? true : false
                        });
                        break;
                    }
                case 'categoryId':
                    {
                        this.setState({
                            gameType: e.target.options[e.target.selectedIndex].title.split('_')[1],
                            platforms: e.target.options[e.target.selectedIndex].title.split('_')[1] == 'html5' ? 'html5' : 'android',
                            categoryId: e.target.value,
                            categoryTypeId: e.target.options[e.target.selectedIndex].title.split('_')[0]
                        });
                        break;
                    }
                default:
                    {
                        this.setState(_defineProperty({}, e.target.name, e.target.value));
                    }
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.state.gameTitle == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Please enter game title."
                });
                return false;
            }
            if (this.state.gameDesc == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Please enter game description."
                });
                return false;
            }
            if (!this.state.gameFile) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please enter game zip file."
                });
                return false;
            }
            if (!this.state.gameImage) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please enter game image."
                });
                return false;
            }
            if (this.state.categoryId == 0) {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select a category for the game."
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();

            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.addGame();
            }
        }
    }, {
        key: 'addGame',
        value: function addGame() {
            var _this4 = this;

            data.append('gameTitle', this.state.gameTitle);
            data.append('gameDesc', this.state.gameDesc);
            data.append('categoryId', this.state.categoryId);
            data.append('categoryTypeId', this.state.categoryTypeId);
            data.append('platforms', this.state.platforms);
            data.append('gameType', this.state.gameType);

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/addGame', data).then(function (response) {
                _this4.props.hide();
                if (response.data.success) {
                    _this4.setState({
                        gameTitle: '',
                        gameDesc: '',
                        gameImage: false,
                        gameFile: false,
                        gameType: '',
                        platforms: '',
                        categoryId: 0,
                        categoryTypeId: 0
                    });
                }
                _this4.forceUpdate();
            }).catch(function (error) {
                _this4.props.hide();
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Sorry, unable to add game details, please try again later.' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'uploads animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Upload Games'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'gameTitle' },
                                                'Game Title'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'gameTitle', name: 'gameTitle', placeholder: 'Game Title', value: this.state.gameTitle, onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'gameDesc' },
                                                'Game Description'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'textarea', id: 'gameDesc', name: 'gameDesc', placeholder: 'Game Description', value: this.state.gameDesc, onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'gameImage' },
                                                'Game Image'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'file', id: 'gameImage', name: 'gameImage', placeholder: 'Game Image', onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'gameFile' },
                                                'Game File'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'file', id: 'gameFile', name: 'gameFile', placeholder: 'Game File', onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'categoryId' },
                                                'Games Categories'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'categoryId', id: 'categoryId', onChange: this.onChange, value: this.state.categoryId },
                                                _react2.default.createElement(
                                                    'option',
                                                    { value: '0' },
                                                    'Category'
                                                ),
                                                this.props.categories.categories.length > 0 ? this.props.categories.categories.map(function (c) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: c.categoryId, value: c.categoryId, gametype: c.categoryTypeName.toLocaleLowerCase(), title: c.categoryTypeId + '_' + c.categoryTypeName.toLowerCase() },
                                                        c.categoryName + " [" + c.categoryTypeName + "]"
                                                    );
                                                }) : ''
                                            )
                                        )
                                    ),
                                    !this.state.isValid && this.state.errorMessage != '' ? _react2.default.createElement(
                                        _reactstrap.Alert,
                                        { color: 'danger' },
                                        this.state.errorMessage
                                    ) : ''
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'primary', onClick: this.onSubmit },
                                    _react2.default.createElement('i', { className: 'fa fa-upload' }),
                                    ' Upload'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Uploads;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer,
        categories: state.CategoryReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getGameTypes: _CategoryActions.getGameTypes,
        getCategories: _CategoryActions.getCategories
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Uploads);

/***/ }),

/***/ "./src/components/User/Users.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _UsersActions = __webpack_require__("./src/actions/UsersActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Users = function (_Component) {
    _inherits(Users, _Component);

    function Users(props) {
        _classCallCheck(this, Users);

        var _this = _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).call(this, props));

        _this.state = {
            username: '',
            accessType: '',
            password: '',
            showModal: false,
            edit_userId: '',
            edit_username: '',
            edit_accessType: '',
            edit_password: '',
            edit_isActive: false,
            edit_isValid: false,
            edit_errorMessage: '',
            isValid: false,
            errorMessage: ''
        };

        _this.isValid = _this.isValid.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.modalToggle = _this.modalToggle.bind(_this);
        _this.editUserSubmit = _this.editUserSubmit.bind(_this);
        _this.isValidEditForm = _this.isValidEditForm.bind(_this);
        _this.editUser = _this.editUser.bind(_this);
        _this.deleteUser = _this.deleteUser.bind(_this);
        _this.onEditChange = _this.onEditChange.bind(_this);
        return _this;
    }

    _createClass(Users, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getRoles();
            this.getUser();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.user.isAuthenticated) {
                this.props.history.push('/login');
            }
        }
    }, {
        key: 'getRoles',
        value: function getRoles() {
            var _this2 = this;

            _axios2.default.get(vars.BASE_URL + '/getRoles').then(function (response) {
                if (response.data.success) {
                    _this2.props.getRoles(response.data);
                }
            }).catch(function (error) {
                (0, _helper.console_log)(error);
                _this2.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();

            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.addUser({
                    username: this.state.username,
                    password: this.state.password,
                    roleName: this.state.accessType
                });
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.state.username == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Username field is required."
                });
                return false;
            }
            if (this.state.password == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Password field is required."
                });
                return false;
            }
            if (this.state.accessType == '') {
                this.setState({
                    isValid: false,
                    errorMessage: "Please select the role of the user"
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            this.setState(_defineProperty({}, e.target.name, e.target.value));
        }
    }, {
        key: 'addUser',
        value: function addUser(data) {
            var _this3 = this;

            this.props.show();
            _axios2.default.post(vars.BASE_URL + '/signup', data).then(function (response) {
                _this3.props.hide();
                if (response.data.success) {
                    _this3.getUser();
                }
                _this3.setState({
                    username: '',
                    accessType: '',
                    password: '',
                    isValid: false,
                    errorMessage: ''
                });
            }).catch(function (error) {
                _this3.props.hide();
                (0, _helper.console_log)(error);
                _this3.setState({ isValid: false, errorMessage: 'Sorry, cannot add user right now, please try again later.' });
            });
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            var _this4 = this;

            this.props.show();
            _axios2.default.get(vars.BASE_URL + '/getUsers').then(function (response) {
                _this4.props.hide();
                if (response.data.success) {
                    _this4.props.getUsers(response.data);
                }
            }).catch(function (error) {
                _this4.props.hide();
                (0, _helper.console_log)(error);
                _this4.setState({ isValid: false, errorMessage: 'Unable to fetch data.' });
            });
        }
    }, {
        key: 'modalToggle',
        value: function modalToggle(user) {
            this.setState({
                showModal: !this.state.showModal,
                edit_userId: user.userId,
                edit_username: user.username,
                edit_accessType: user.roleName,
                edit_isActive: user.isActive,
                edit_password: '',
                edit_isValid: false,
                edit_errorMessage: ''
            });
        }
    }, {
        key: 'isValidEditForm',
        value: function isValidEditForm() {
            if (this.state.edit_username == '') {
                this.setState({
                    edit_isValid: false,
                    edit_errorMessage: "Username field is required."
                });
                return false;
            }
            if (this.state.edit_password == '') {
                this.setState({
                    edit_isValid: false,
                    edit_errorMessage: "Password field is required."
                });
                return false;
            }
            if (this.state.edit_accessType == '') {
                this.setState({
                    edit_isValid: false,
                    edit_errorMessage: "Please select the role of the user"
                });
                return false;
            }

            return true;
        }
    }, {
        key: 'editUserSubmit',
        value: function editUserSubmit(e) {
            e.preventDefault();

            if (this.isValidEditForm()) {
                this.setState({ edit_isValid: true, edit_errorMessage: '' });
                this.editUser({
                    userId: this.state.edit_userId,
                    username: this.state.edit_username,
                    password: this.state.edit_password,
                    roleName: this.state.edit_accessType,
                    isActive: this.state.edit_isActive == "true" ? true : false
                });
            }
        }
    }, {
        key: 'onEditChange',
        value: function onEditChange(e) {
            this.setState(_defineProperty({}, e.target.name, e.target.value));
        }
    }, {
        key: 'editUser',
        value: function editUser(user) {
            var _this5 = this;

            this.props.show();
            _axios2.default.put(vars.BASE_URL + '/editUser', user, { headers: {
                    'Authorization': this.props.user.currentUser.token
                } }).then(function (response) {
                _this5.props.hide();
                if (response.data.success) {
                    _this5.modalToggle({ userId: '', username: '', isActive: false, roleName: '' });
                    _this5.getUser();
                    _this5.setState({
                        edit_userId: '',
                        edit_username: '',
                        edit_accessType: '',
                        edit_password: '',
                        edit_isValid: false,
                        edit_errorMessage: ''
                    });
                }
            }).catch(function (error) {
                _this5.props.hide();
                (0, _helper.console_log)(error);
                _this5.setState({ isValid: false, errorMessage: 'Sorry, cannot edit user right now, please try again later.' });
            });
        }
    }, {
        key: 'deleteUser',
        value: function deleteUser(user) {
            var _this6 = this;

            this.props.show();
            _axios2.default.delete(vars.BASE_URL + '/deleteUser', {
                data: {
                    userId: user.userId
                },
                headers: {
                    'Authorization': this.props.user.currentUser.token
                }
            }).then(function (response) {
                _this6.props.hide();
                if (response.data.success) {
                    _this6.getUser();
                }
            }).catch(function (error) {
                _this6.props.hide();
                (0, _helper.console_log)(error);
                _this6.setState({ isValid: false, errorMessage: 'Sorry, cannot delete user right now, please try again later.' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            return _react2.default.createElement(
                'div',
                { className: 'users animated fadeIn' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { xs: '12', md: '12' },
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardHeader,
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    'Add User'
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Form,
                                    { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'username' },
                                                'Username'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'username', name: 'username', placeholder: 'Username', value: this.state.username, onChange: this.onChange })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'accessType' },
                                                'Access Type'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9', size: 'sm' },
                                            _react2.default.createElement(
                                                _reactstrap.Input,
                                                { type: 'select', name: 'accessType', id: 'accessType', value: this.state.accessType, onChange: this.onChange },
                                                _react2.default.createElement(
                                                    'option',
                                                    { key: 0, value: '' },
                                                    'Select Role'
                                                ),
                                                this.props.users.roles ? this.props.users.roles.map(function (role) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { key: role.roleId, value: role.name },
                                                        role.name
                                                    );
                                                }) : ''
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        _reactstrap.FormGroup,
                                        { row: true },
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { md: '3' },
                                            _react2.default.createElement(
                                                _reactstrap.Label,
                                                { htmlFor: 'password' },
                                                'Password'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _reactstrap.Col,
                                            { xs: '12', md: '9' },
                                            _react2.default.createElement(_reactstrap.Input, { type: 'password', id: 'password', name: 'password', placeholder: 'Password', value: this.state.password, onChange: this.onChange })
                                        )
                                    ),
                                    !this.state.isValid && this.state.errorMessage != '' ? _react2.default.createElement(
                                        _reactstrap.Alert,
                                        { color: 'danger' },
                                        this.state.errorMessage
                                    ) : ''
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.CardFooter,
                                { className: 'card-footer-align-right' },
                                _react2.default.createElement(
                                    _reactstrap.Button,
                                    { type: 'submit', color: 'primary', onClick: this.onSubmit },
                                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                                    ' Create'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Row,
                    null,
                    _react2.default.createElement(
                        _reactstrap.Col,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Card,
                            null,
                            _react2.default.createElement(
                                _reactstrap.CardBody,
                                null,
                                _react2.default.createElement(
                                    _reactstrap.Table,
                                    { hover: true, responsive: true, size: 'lg', className: 'users-custom-table' },
                                    _react2.default.createElement(
                                        'thead',
                                        null,
                                        _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Username'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Access'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Date'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Status'
                                            ),
                                            _react2.default.createElement(
                                                'th',
                                                null,
                                                'Actions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tbody',
                                        null,
                                        this.props.users.users.length > 0 ? this.props.users.users.map(function (user, key) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: key },
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'strong',
                                                        null,
                                                        (0, _helper.jsUcfirst)(user.username)
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    (0, _helper.jsUcfirst)(user.roleName)
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    (0, _helper.formatDate)(user.createdAt)
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    user.isActive ? 'Active' : 'Inactive'
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', disabled: user.roleName == 'superadmin' ? true : false, color: 'success', onClick: _this7.modalToggle.bind(_this7, user) },
                                                        _react2.default.createElement('i', { className: 'fa fa-edit' })
                                                    ),
                                                    _react2.default.createElement(
                                                        _reactstrap.Button,
                                                        { size: 'sm', disabled: user.roleName == 'superadmin' ? true : false, color: 'danger', onClick: _this7.deleteUser.bind(_this7, user) },
                                                        _react2.default.createElement('i', { className: 'fa fa-trash' })
                                                    )
                                                )
                                            );
                                        }) : _react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: 5 },
                                                'No users added yet.'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactstrap.Modal,
                    { isOpen: this.state.showModal, toggle: this.modalToggle.bind(this, { userId: '', username: '', isActive: false, roleName: '' }), className: 'modal-lg' },
                    _react2.default.createElement(
                        _reactstrap.ModalHeader,
                        { toggle: this.modalToggle.bind(this, { userId: '', username: '', isActive: false, roleName: '' }) },
                        'Edit User'
                    ),
                    _react2.default.createElement(
                        _reactstrap.ModalBody,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Form,
                            { action: '', method: 'post', encType: 'multipart/form-data', className: 'form-horizontal' },
                            _react2.default.createElement(
                                _reactstrap.FormGroup,
                                { row: true },
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { md: '3' },
                                    _react2.default.createElement(
                                        _reactstrap.Label,
                                        { htmlFor: 'edit_username' },
                                        'Username'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { xs: '12', md: '9' },
                                    _react2.default.createElement(_reactstrap.Input, { type: 'text', id: 'edit_username', name: 'edit_username', placeholder: 'Username', value: this.state.edit_username, onChange: this.onEditChange })
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.FormGroup,
                                { row: true },
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { md: '3' },
                                    _react2.default.createElement(
                                        _reactstrap.Label,
                                        { htmlFor: 'edit_accessType' },
                                        'Access Type'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { xs: '12', md: '9', size: 'sm' },
                                    _react2.default.createElement(
                                        _reactstrap.Input,
                                        { type: 'select', name: 'edit_accessType', id: 'edit_accessType', value: this.state.edit_accessType, onChange: this.onEditChange },
                                        _react2.default.createElement(
                                            'option',
                                            { key: 0, value: '' },
                                            'Select Role'
                                        ),
                                        this.props.users.roles ? this.props.users.roles.map(function (role) {
                                            return _react2.default.createElement(
                                                'option',
                                                { key: role.roleId, value: role.name },
                                                role.name
                                            );
                                        }) : ''
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.FormGroup,
                                { row: true },
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { md: '3' },
                                    _react2.default.createElement(
                                        _reactstrap.Label,
                                        { htmlFor: 'edit_isActive' },
                                        'Status'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { xs: '12', md: '9', size: 'sm' },
                                    _react2.default.createElement(
                                        _reactstrap.Input,
                                        { type: 'select', name: 'edit_isActive', id: 'edit_isActive', value: this.state.edit_isActive, onChange: this.onEditChange },
                                        _react2.default.createElement(
                                            'option',
                                            { key: 0, value: true },
                                            'Active'
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { key: 1, value: false },
                                            'Inactive'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _reactstrap.FormGroup,
                                { row: true },
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { md: '3' },
                                    _react2.default.createElement(
                                        _reactstrap.Label,
                                        { htmlFor: 'edit_password' },
                                        'Password'
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactstrap.Col,
                                    { xs: '12', md: '9' },
                                    _react2.default.createElement(_reactstrap.Input, { type: 'password', id: 'edit_password', name: 'edit_password', placeholder: 'Password', value: this.state.edit_password, onChange: this.onEditChange })
                                )
                            ),
                            !this.state.edit_isValid && this.state.edit_errorMessage != '' ? _react2.default.createElement(
                                _reactstrap.Alert,
                                { color: 'danger' },
                                this.state.edit_errorMessage
                            ) : ''
                        )
                    ),
                    _react2.default.createElement(
                        _reactstrap.ModalFooter,
                        null,
                        _react2.default.createElement(
                            _reactstrap.Button,
                            { color: 'danger', onClick: this.modalToggle.bind(this, { userId: '', username: '', isActive: false, roleName: '' }) },
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel',
                                defaultMessage: ' Cancel'
                            })
                        ),
                        ' ',
                        _react2.default.createElement(
                            _reactstrap.Button,
                            { color: 'success', onClick: this.editUserSubmit },
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save',
                                defaultMessage: ' Save'
                            })
                        )
                    )
                )
            );
        }
    }]);

    return Users;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        show: _ActivityIndicatorActions.show,
        hide: _ActivityIndicatorActions.hide,
        getRoles: _UsersActions.getRoles,
        getUsers: _UsersActions.getUsers
    }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Users);

/***/ }),

/***/ "./src/components/wallpapers/wallpaper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIdSwiper = __webpack_require__("./node_modules/react-id-swiper/lib/index.js");

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _wallpapers_za = __webpack_require__("./src/constants/wallpapers_za.js");

var _wallpaperPreviewModal = __webpack_require__("./src/components/wallpapers/wallpaperPreviewModal.js");

var _wallpaperPreviewModal2 = _interopRequireDefault(_wallpaperPreviewModal);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Wallpapers = function (_Component) {
    _inherits(Wallpapers, _Component);

    function Wallpapers(props) {
        _classCallCheck(this, Wallpapers);

        var _this = _possibleConstructorReturn(this, (Wallpapers.__proto__ || Object.getPrototypeOf(Wallpapers)).call(this, props));

        _this.handleSelectedImage = function (data) {
            _this.setState({
                selectedImage: data.images_url,
                isModalOpen: true
            });
        };

        _this.onCloseModal = function () {
            _this.setState({
                isModalOpen: false
            });
        };

        _this.downloadImageFromURL = function (imageUrl) {
            if (imageUrl != null) {
                var imageData = imageUrl.split('/');
                var tempCount = imageData.length;
                var imageName = imageData[tempCount - 1];
                (0, _axios2.default)({
                    url: imageUrl,
                    method: 'GET',
                    responseType: 'blob',
                    crossdomain: true
                }).then(function (response) {
                    var url = window.URL.createObjectURL(new Blob([response.data]));
                    var link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', imageName);
                    document.body.appendChild(link);
                    link.click();
                }).catch(function (err) {
                    console.log('errr------', err);
                });
            }
        };

        _this.state = {
            isModalOpen: false,
            selectedImage: null
        };
        return _this;
    }

    _createClass(Wallpapers, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.scrollTo(0, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                selectedImage = _state.selectedImage,
                isModalOpen = _state.isModalOpen;

            var gamesParams = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                speed: 500
            };
            var gameCategoryTitleClass = "game-category-title";
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_wallpaperPreviewModal2.default, { imageUrl: selectedImage, onCloseModal: this.onCloseModal, isModalOpen: isModalOpen, downloadImageFromURL: this.downloadImageFromURL }),
                _wallpapers_za.wallpaper_za.map(function (category, index) {
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _reactstrap.Row,
                            null,
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12', className: 'game-related-container' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'game-related-top' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'game-category', style: _isGamiclub.isGamiclub ? { borderBottom: '1px solid green' } : null },
                                        _react2.default.createElement(
                                            'h2',
                                            { style: _isGamiclub.isGamiclub ? { color: 'white', backgroundColor: 'green' } : null, className: gameCategoryTitleClass },
                                            _react2.default.createElement('i', { className: 'fa fa-picture-o', 'aria-hidden': 'true' }),
                                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + category.category_name,
                                                defaultMessage: category.category_name
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactstrap.Row,
                            { className: 'game-list-row' },
                            _react2.default.createElement(
                                _reactstrap.Col,
                                { xs: '12' },
                                _react2.default.createElement(
                                    _reactIdSwiper2.default,
                                    _extends({}, gamesParams, { shouldSwiperUpdate: true }),
                                    category.images.map(function (imageData) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'swiper-wallpaper-card', key: imageData.id },
                                            _react2.default.createElement(
                                                _reactstrap.Card,
                                                { className: 'wallpaper-card',
                                                    onClick: function onClick() {
                                                        return _this2.handleSelectedImage(imageData);
                                                    }
                                                },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'wallpaper-card-inner' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'wallpaper-thumb-wrap' },
                                                        _react2.default.createElement(_reactstrap.CardImg, { className: 'wallpaper-thumb', top: true, width: '100%', src: imageData.images_url, alt: imageData.title })
                                                    ),
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'wallpaper-title' },
                                                        imageData.title
                                                    )
                                                )
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    );
                })
            );
        }
    }]);

    return Wallpapers;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        access: state.WelcomeReducer
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Wallpapers);

/***/ }),

/***/ "./src/components/wallpapers/wallpaperPreviewModal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactResponsiveModal = __webpack_require__("./node_modules/react-responsive-modal/lib/index.es.js");

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WallpaperPreviewModal = function WallpaperPreviewModal(_ref) {
    var imageUrl = _ref.imageUrl,
        onCloseModal = _ref.onCloseModal,
        isModalOpen = _ref.isModalOpen,
        downloadImageFromURL = _ref.downloadImageFromURL;

    var customStyles = {
        customModal: {
            background: 'black'
        }
    };

    return _react2.default.createElement(
        _reactResponsiveModal2.default,
        { open: isModalOpen, onClose: onCloseModal,
            classNames: {
                modal: "customModal",
                closeButton: "customCloseButton",
                closeIcon: "customCloseIcon"
            },
            onOverlayClick: onCloseModal, center: true },
        _react2.default.createElement(
            'div',
            { className: 'wallpaperPreview' },
            _react2.default.createElement('img', { src: imageUrl, className: 'wallpaperImage' }),
            _react2.default.createElement(
                'div',
                { className: 'downloadButton-contaoner' },
                _react2.default.createElement(
                    'button',
                    { className: 'downloadButton', onClick: function onClick() {
                            return downloadImageFromURL(imageUrl);
                        } },
                    'download'
                )
            )
        )
    );
};
exports.default = WallpaperPreviewModal;

/***/ }),

/***/ "./src/constants/domainConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = undefined;

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var domainConfig = {
    'asiacell': {
        country: 'iq',
        lang: 'ar',
        countryCode: '964'
    },
    'kz': {
        country: 'kz',
        lang: 'kk',
        countryCode: '7'
    },
    'orange': {
        country: 'ci',
        lang: 'fr',
        countryCode: '225'
    },
    'ci': {
        country: 'ci',
        lang: 'fr',
        countryCode: '225'
    },
    'cd': {
        country: 'cd',
        lang: 'fr',
        countryCode: '243'
    },
    'tn': {
        country: 'tn',
        lang: 'fr',
        countryCode: '216'
    },
    'sn': {
        country: 'sn',
        lang: 'fr',
        countryCode: '221'
    },
    'se': {
        country: 'se',
        lang: 'sv',
        countryCode: '46'
    },
    'cm': {
        country: 'cm',
        lang: 'fr',
        countryCode: '237'
    },
    'bf': {
        country: 'bf',
        lang: 'fr',
        countryCode: '226'
    },
    'nl': {
        country: 'nl',
        lang: 'be',
        countryCode: '31'
    },
    'be': {
        country: 'be',
        lang: window.navigator.language && window.navigator.language.split('-')[0] == 'fr' ? 'fr' : window.navigator.language && window.navigator.language.split('-')[0] == 'de' ? 'de' : 'be',
        countryCode: '32'
    },
    'no': {
        country: 'no',
        lang: 'no',
        countryCode: '47'
    },
    'kw': {
        country: 'kw',
        lang: 'en',
        countryCode: '965'
    },
    'ae': {
        country: 'ae',
        lang: 'en',
        countryCode: '971'
    },
    'bh': {
        country: 'bh',
        lang: 'en',
        countryCode: '973'
    },
    'za': {
        country: 'za',
        lang: 'en',
        countryCode: '27'
    },
    'dz': {
        country: 'dz',
        lang: 'fr',
        countryCode: '27'
    },
    'vn': {
        country: 'vn',
        lang: 'vi',
        countryCode: '84'
    },
    'eg': {
        country: 'eg',
        lang: _isGamiclub.isGamiclub ? 'en' : 'ar',
        countryCode: '20'
    },
    'my': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'tr': {
        country: 'tr',
        lang: 'tr',
        countryCode: '90'
    },
    'mase': {
        country: 'se',
        lang: 'sv',
        countryCode: '46'
    },
    'es': {
        country: 'es',
        lang: 'es',
        countryCode: '34'
    },
    'es2': {
        country: 'es',
        lang: 'es',
        countryCode: '34'
    },
    'th': {
        country: 'th',
        lang: window.location.hostname === 'th.gamezorix.com' ? 'th' : 'en',
        countryCode: '66'
    },
    'it': {
        country: 'it',
        lang: 'it',
        countryCode: '39'
    },
    'ru': {
        country: 'ru',
        lang: 'kk',
        countryCode: '7'
    },
    'hua': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'gmn': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'play': {
        country: 'my',
        lang: 'en',
        countryCode: ''
    },
    'pe': {
        country: 'pe',
        lang: 'es',
        countryCode: '51'
    },
    'pe-staging': {
        country: 'pe',
        lang: 'es',
        countryCode: '51'
    },
    'demo': {
        country: 'xx',
        lang: 'en',
        countryCode: ''
    },
    'iq': {
        country: 'iq',
        lang: _isGamiclub.isGamiclub ? 'en' : 'ar',
        countryCode: '964'
    },
    'idsale': {
        country: 'id',
        lang: 'en',
        countryCode: '62'
    },
    'id': {
        country: 'id',
        lang: 'en',
        countryCode: '62'
    },
    'pk': {
        country: 'pk',
        lang: 'en',
        countryCode: '62'
    },
    'sa': {
        country: 'sa',
        lang: 'en',
        countryCode: '966'
    },
    'maxis': {
        country: 'my',
        lang: 'en',
        countryCode: '60'
    },
    'gh': {
        country: 'gh',
        lang: 'en',
        countryCode: '233'
    },
    'gr': {
        country: 'gr',
        lang: 'el',
        countryCode: '30'
    },
    'ke': {
        country: 'ke',
        lang: 'en',
        countryCode: '254'
    },
    'qa': {
        country: 'qa',
        lang: 'en',
        countryCode: '974'
    },
    'rs': {
        country: 'rs',
        lang: 'cy',
        countryCode: '381'
    },
    'ch': {
        country: 'ch',
        lang: window.navigator.language && window.navigator.language.split('-')[0] == 'fr' ? 'fr' : 'de',
        countryCode: '41'
    },
    'ro': {
        country: 'ro',
        lang: 'ro',
        countryCode: '40'
    },
    'rsma': {
        country: 'rs',
        lang: 'en',
        countryCode: '381'
    },
    'cz': {
        country: 'cz',
        lang: 'cs',
        countryCode: '420'
    },
    'maae': {
        country: 'ae',
        lang: 'en',
        countryCode: '971'
    },
    'uk': {
        country: 'gb',
        lang: 'en',
        countryCode: '44'
    },
    'pt': {
        country: 'pt',
        lang: 'pt',
        countryCode: '351'
    },
    'lt': {
        country: 'lt',
        lang: 'lt',
        countryCode: '370'
    },
    'si': {
        country: 'si',
        lang: 'si',
        countryCode: '386'
    },
    'fr': {
        country: 'fr',
        lang: 'fr',
        countryCode: '33'
    },
    'pl': {
        country: 'pl',
        lang: 'pl',
        countryCode: '48'
    },
    'portal': {
        country: 'lt',
        lang: 'lt',
        countryCode: '370'
    },
    'bg': {
        country: 'bg',
        lang: 'bg',
        countryCode: '+359'
    }
};
var defaultConfig = {
    country: 'xx',
    lang: 'en',
    countryCode: ''
};

var config = exports.config = {};

var getSubdomain = function getSubdomain() {
    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    return parts[0];
};

var getConfigsForSubdomain = function getConfigsForSubdomain(subdomain) {
    var configForSubDomain = domainConfig[subdomain] || defaultConfig;
    configForSubDomain.subDomain = subdomain;
    return configForSubDomain;
};

if (getSubdomain() == 'localhost') exports.config = config = getConfigsForSubdomain('th'); //pass the subDomain to getConfigsForSubdomain which you want to simulate on localhost
else exports.config = config = getConfigsForSubdomain(getSubdomain());
console.log(config);

/***/ }),

/***/ "./src/constants/enableWithdraw.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWithdrawEnabled = undefined;

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var gamiclubSubDomains = ["fr", "ro", "cz", "rs", "pt"];
var gameLordsSubDomains = ["ch", "pt"];
var thegamingclubsSubDomains = ["lt", "si"];
var gamesqueensSubDomains = ["rs"];
var gameverseSubDomains = ["portal"];
var appspoolSubDomains = ["ch"];
var gameverseltSubDomains = ["portal"];
var funzarenaSubDomains = ["pl"];

var isWithdrawEnabled = exports.isWithdrawEnabled = function isWithdrawEnabled(subDomain) {
  return gamiclubSubDomains.includes(subDomain) && _isGamiclub.isGamiclub || gameLordsSubDomains.includes(subDomain) && _productCondition.isGamelords || thegamingclubsSubDomains.includes(subDomain) && _productCondition.isThegamingclubs || gamesqueensSubDomains.includes(subDomain) && _productCondition.isGamesqueens || gameverseSubDomains.includes(subDomain) && _isGamiclub.isGameverse || appspoolSubDomains.includes(subDomain) && _isAppspool.isAppspool || gameverseltSubDomains.includes(subDomain) && _productCondition.isGameverselt || funzarenaSubDomains.includes(subDomain) && _productCondition.isFunzarena;
};

/***/ }),

/***/ "./src/constants/heURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var peHEURL = exports.peHEURL = "http://n.game-vp.com/tallyman/v1/?action=validate-access&country=pe&domain=pe.game-lords.com&platform=mcb&product_page=https://loginprime.com/GOaAZO";

/***/ }),

/***/ "./src/constants/isAppspool.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isAppspool = exports.isAppspool = window.location.hostname.includes('appspool')
//  || window.location.hostname.includes('localhost')
? true : false;

/***/ }),

/***/ "./src/constants/isGamezClan.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isGamezClan = exports.isGamezClan = window.location.hostname.includes('gamezclan')
//  || window.location.hostname.includes('localhost')
? true : false;

/***/ }),

/***/ "./src/constants/isGamiclub.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isGamiclub = exports.isGamiclub = window.location.hostname.includes("gamiclub") || window.location.hostname.includes("beemobi") || window.location.hostname.includes("mobbfun") || window.location.hostname.includes("gameverse-lt") || window.location.hostname.includes("gami-hub") ? // window.location.hostname.includes("localhost")
true : false;

var isGameverse = exports.isGameverse = window.location.hostname.includes("gameverse-lt");

/***/ }),

/***/ "./src/constants/isOnlyBeemobi.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isOnlyBeemobi = exports.isOnlyBeemobi = window.location.hostname.includes('beemobi')
//  || window.location.hostname.includes('localhost')
? true : false;

/***/ }),

/***/ "./src/constants/isOnlyMobbfun.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isOnlyMobbfun = exports.isOnlyMobbfun = window.location.hostname.includes('mobbfun')
//  || window.location.hostname.includes('localhost')
? true : false;

/***/ }),

/***/ "./src/constants/isTheGamingClubs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isTheGamingClubs = exports.isTheGamingClubs = window.location.hostname.includes('thegamingclubs')
//  || window.location.hostname.includes('localhost')
? true : false;

/***/ }),

/***/ "./src/constants/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages = exports.messages = {
    nameEmpty: "Name cannot be empty.",
    emailEmpty: "Email Address cannot be empty.",
    emailNotValid: "Email Address is not valid, please enter a proper email address.",
    locationEmpty: "Location cannot be empty.",
    interests: "Select 3 area of interest.",
    profileSaved: "Profile details saved.",
    profilePic: "Profile picture saved.",
    addToFavorites: "Successfully added to favorites.",
    removeFromFavorites: "Successfully removed from favorites"
};

/***/ }),

/***/ "./src/constants/messages_ar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_ar = exports.messages_ar = {
    nameEmpty: "لا يمكن أن يكون الاسم فارغًا.",
    emailEmpty: "لا يمكن أن يكون عنوان البريد الإلكتروني فارغًا.",
    emailNotValid: "عنوان البريد الإلكتروني غير صحيح ، يرجى إدخال عنوان البريد الإلكتروني بشكل صحيح.",
    locationEmpty: "لا يمكن أن يكون الموقع فارغًا.",
    interests: "قم بإختيار 3 مجالات إهتمام.",
    profileSaved: "تم حفظ بيانات الملف الشخصي.",
    profilePic: "تم حفظ صورة الملف الشخصي.",
    addToFavorites: "تمت الاضافة بنجاح إلى المفضلة.",
    removeFromFavorites: "تمت الإزالة بنجاح من المفضلة."
};

/***/ }),

/***/ "./src/constants/messages_cy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_cy = exports.messages_cy = {
    nameEmpty: "Поље за име не може бити празно.",
    emailEmpty: "Поље за имејл адресу не може бити празно.",
    emailNotValid: "Имејл адреса није валидна, молимо Вас да унесете одговарајућу имејл адресу.",
    locationEmpty: "Поље за локацију не може бити празно.",
    profileSaved: "Профилни подаци снимљени.",
    profilePic: "Профилна слика снимљена.",
    addToFavorites: "Успешно сте додали у омиљене",
    removeFromFavorites: "Успешно сте додали у омиљене"
};

/***/ }),

/***/ "./src/constants/messages_cz.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_cz = exports.messages_cz = {
    nameEmpty: "Název nemůže být prázdný.",
    emailEmpty: "E-mailová adresa nemůže být prázdná.",
    emailNotValid: "E-mailová adresa není platná, zadejte prosím správnou e-mailovou adresu.",
    locationEmpty: "Místo nemůže být prázdné.",
    interests: "Vyberte 3 oblasti zájmu.",
    profileSaved: "Podrobnosti profilu uloženy.",
    profilePic: "Profilový obrázek byl uložen.",
    addToFavorites: "Úspěšně přidáno do oblíbených",
    removeFromFavorites: "Úspěšně odstraněno z oblíbených"
};

/***/ }),

/***/ "./src/constants/messages_de.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_de = exports.messages_de = {
    nameEmpty: "Name darf nicht leer sein.",
    emailEmpty: "E-Mail-Adresse darf nicht leer sein.",
    emailNotValid: "E-Mail-Adresse ist ungültig, bitte gib die korrekte E-Mail-Adresse ein.",
    locationEmpty: "Standort darf nicht leer sein.",
    profileSaved: "Profildetails gespeichert.",
    profilePic: "Profilbild gespeichert.",
    addToFavorites: "Erfolgreich zu deinen Favoriten hinzugefügt",
    removeFromFavorites: "Erfolgreich von deinen Favoriten entfernt"
};

/***/ }),

/***/ "./src/constants/messages_el.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_el = exports.messages_el = {
    nameEmpty: "Το όνομα δεν μπορεί να είναι κενό",
    emailEmpty: "Το email δεν μπορεί να είναι κενό",
    emailNotValid: "Το email δεν είναι σωστό. Παρακαλούμε εισάγετε μια έγκυρη διεύθυνση.",
    locationEmpty: "Η τοποθεσία δεν μπορεί να είναι κενή",
    interests: "Διάλεξε 3 κατηγορίες",
    profileSaved: "Οι λεπτομέρειες του προφίλ σου αποθηκεύτηκαν",
    profilePic: "Η φωτογραφία του προφίλ σου αποθηκεύτηκε",
    addToFavorites: "Αποθηκεύτηκε στα αγαπημένα",
    removeFromFavorites: "Αφαιρέθηκε από τα αγαπημένα"
};

/***/ }),

/***/ "./src/constants/messages_es.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_es = exports.messages_es = {
    nameEmpty: "El nombre no puede estar vacío.",
    emailEmpty: "La dirección de e-mail no puede estar vacía.",
    emailNotValid: "La dirección de e-mail no es válida; por favor, introduce una dirección de e-mail adecuada.",
    locationEmpty: "La ubicación no puede estar vacía.",
    interests: "Selecciona 3 áreas de interés.",
    profileSaved: "Datos del perfil guardados.",
    profilePic: "Foto del perfil guardada.",
    addToFavorites: "Añadido correctamente a tu favorito",
    removeFromFavorites: "Eliminado correctamente de tu favorito"
};

/***/ }),

/***/ "./src/constants/messages_fr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_fr = exports.messages_fr = {
    nameEmpty: "Le nom ne peut pas être vide.",
    emailEmpty: "L'adresse e-mail ne peut pas être vide.",
    emailNotValid: "L'adresse e-mail n'est pas valide, veuillez entrer une adresse e-mail correcte.",
    locationEmpty: "L'emplacement ne peut pas être vide.",
    interests: "Sélectionnez 3 domaines d'intérêt.",
    profileSaved: "Les détails du profil sont sauvegardés.",
    profilePic: "Sauvegarde de la photo de profil.",
    addToFavorites: "Ajouté avec succès à vos favoris",
    removeFromFavorites: "Retiré avec succès de la liste des favoris"
};

/***/ }),

/***/ "./src/constants/messages_it.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_it = exports.messages_it = {
    nameEmpty: "Il nome non può essere vuoto.",
    emailEmpty: "L'indirizzo e-mail non può essere vuoto.",
    emailNotValid: "L'indirizzo e-mail non è valido, inserisci un indirizzo e-mail corretto.",
    locationEmpty: "La posizione non può essere vuota.",
    interests: "Select 3 area of interest.",
    profileSaved: "Dato del profilo salvato",
    profilePic: "Foto del profilo salvata.",
    addToFavorites: "Aggiunto ai tuoi preferiti",
    removeFromFavorites: "Rimosso dai preferiti"
};

/***/ }),

/***/ "./src/constants/messages_kk.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_kk = exports.messages_kk = {
    nameEmpty: "Имя не может быть пустым",
    emailEmpty: "Адрес электронной почты не может быть пустым",
    emailNotValid: "Адрес электронной почты неверный. Пожалуйста, введите корректный адрес",
    locationEmpty: "Местоположение не может быть пустым",
    interests: "Выберите 3 группы интересов",
    profileSaved: "Информация о профиле сохранена",
    profilePic: "Изображение успешно сохранено ",
    addToFavorites: "Успешно добавлено в лист фаворитов",
    removeFromFavorites: "Успешно удалено из списка фаворитов"
};

/***/ }),

/***/ "./src/constants/messages_lt.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_lt = exports.messages_lt = {
    nameEmpty: "Vardas negali būti tuščias.",
    emailEmpty: "El. pašto adresas negali būti tuščias.",
    emailNotValid: "El. pašto adresas nėra galiojantis, prašome įvesti tinkamą el. pašto adresą.",
    locationEmpty: "Vieta negali būti tuščia.",
    interests: "Pasirinkite 3 kategorijas.",
    profileSaved: "Profilio informacija išsaugota.",
    profilePic: "Profilio nuotrauka išsaugota.",
    addToFavorites: "Sėkmingai pridėta prie mėgstamiausių.",
    removeFromFavorites: "Sėkmingai pašalinta iš mėgstamiausių."
};

/***/ }),

/***/ "./src/constants/messages_no.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_no = exports.messages_no = {
    nameEmpty: "Navn kan ikke være tomt.",
    emailEmpty: "E-postadresse kan ikke være tom.",
    emailNotValid: "E-postadressen er ikke gyldig, vennligst skriv inn en riktig e-postadresse.",
    locationEmpty: "Plassering kan ikke være tom.",
    interests: "Velg 3 interesseområder.",
    profileSaved: "Profildetaljer er lagret.",
    profilePic: "Profilbildet er lagret.",
    addToFavorites: "Vellykket lagt til din favoritt",
    removeFromFavorites: "vellykket fjernet fra favoritt"
};

/***/ }),

/***/ "./src/constants/messages_pt.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_pt = exports.messages_pt = {
    nameEmpty: "O nome não pode estar vazio.",
    emailEmpty: "O endereço de e-mail não pode estar vazio.",
    emailNotValid: "O endereço de e-mail não é válido, por favor, digite um endereço de e-mail apropriado.",
    locationEmpty: "O local não pode estar vazio.",
    interests: "Escolha 3 categorias.",
    profileSaved: "Detalhes do perfil salvos.",
    profilePic: "Imagem de perfil salva.",
    addToFavorites: "Adicionado com sucesso aos seus favorito.",
    removeFromFavorites: "removido com sucesso dos favoritos"
};

/***/ }),

/***/ "./src/constants/messages_ro.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_ro = exports.messages_ro = {
    nameEmpty: "Câmpul de nume nu poate fi gol.",
    emailEmpty: "Câmpul adresei de e-mail nu poate fi gol.",
    emailNotValid: "Adresa de e-mail nu este validă, vă rugăm să introduceți o adresă de e-mail corectă.",
    locationEmpty: "Câmpul locației nu poate fi gol.",
    interests: "Select 3 area of interest.",
    profileSaved: "Detaliile profilului au fost salvate.",
    profilePic: "Poza de profil a fost salvată.",
    addToFavorites: "A fost adăugat cu succes la favoritele dvs.",
    removeFromFavorites: "A fost eliminat cu succes din favoritele dvs."
};

/***/ }),

/***/ "./src/constants/messages_sv.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_sv = exports.messages_sv = {
    nameEmpty: "Namn kan inte vara tomt.",
    emailEmpty: "E-postadress kan inte vara tom.",
    emailNotValid: "E-postadressen är inte giltig, vänligen ange en riktig e-postadress.",
    locationEmpty: "Plats kan inte vara tomt.",
    interests: "Välj 3 intresseområde.",
    profileSaved: "Profiluppgifter sparade.",
    profilePic: "Profilbild sparad.",
    addToFavorites: "Framgångsrikt tillagt till din favorit",
    removeFromFavorites: "framgångsrikt borttaget från favorit"
};

/***/ }),

/***/ "./src/constants/messages_tr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_tr = exports.messages_tr = {
    nameEmpty: "İsim alanı boş bırakılamaz",
    emailEmpty: "Email adresi boş bırakılamaz",
    emailNotValid: "Geçersiz email, lütfen doğru bir adres girin",
    locationEmpty: "Lokasyon boş bırakılamaz",
    interests: "3 ilgi alanı seçiniz",
    profileSaved: "Profil ayarlari kaydedildi",
    profilePic: "Profil resmi kaydedildi",
    addToFavorites: "Favorilere başarıyla eklendi",
    removeFromFavorites: "Favorilerden başarıyla kaldırıldı"
};

/***/ }),

/***/ "./src/constants/messages_vi.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var messages_vi = exports.messages_vi = {
    nameEmpty: "Mục họ tên không được để trống",
    emailEmpty: "Địa chỉ email không được để trống",
    emailNotValid: "Địa chỉ email không hợp lệ, hãy điền lại thông tin",
    locationEmpty: "Nơi ở không được để trống",
    interests: "Hãy chọn 3 mục yêu thích của bạn",
    profileSaved: "Thông tin profile đã lưu",
    profilePic: "Ảnh đại diện đã lưu",
    addToFavorites: "Đã thêm vào thư mục yêu thích thành công",
    removeFromFavorites: "Đã xóa khỏi thư mục yêu thích thành công"
};

/***/ }),

/***/ "./src/constants/productCondition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isGameflares = exports.isGameflares = window.location.hostname.includes("gameflares") ? //  || window.location.hostname.includes('localhost')
true : false;

var isGamiway = exports.isGamiway = window.location.hostname.includes("gamiway") ? //  || window.location.hostname.includes('localhost')
true : false;

var isGamelords = exports.isGamelords = window.location.hostname.includes("game-lords") ? //  || window.location.hostname.includes('localhost')
true : false;

var isPlaynixzone = exports.isPlaynixzone = window.location.hostname.includes("playnixzone") ? // || window.location.hostname.includes("localhost")
true : false;

var isFunzarena = exports.isFunzarena = window.location.hostname.includes("funzarena") || window.location.hostname.includes("localhost") ? true : false;

var isgamiHub = exports.isgamiHub = window.location.hostname.includes("gami-hub") //||window.location.hostname.includes("localhost")
? true : false;

var isThegamingclubs = exports.isThegamingclubs = window.location.hostname.includes("thegamingclubs") ? // || window.location.hostname.includes("localhost")
true : false;

var isGamesqueens = exports.isGamesqueens = window.location.hostname.includes("gamesqueens") ? // || window.location.hostname.includes("localhost")
true : false;

var isGameverselt = exports.isGameverselt = window.location.hostname.includes("gameverse-lt") ? // || window.location.hostname.includes("localhost")
true : false;

/***/ }),

/***/ "./src/constants/publicURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PUBLIC_ROUTES = exports.PUBLIC_ROUTES = ["/terms-conditions"];

var isPublicRoute = exports.isPublicRoute = function isPublicRoute(pathname) {
  return PUBLIC_ROUTES.includes(pathname);
};

/***/ }),

/***/ "./src/constants/restrictedCategories.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCategoryAllowed = undefined;

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

// Categories that must be visible only on portal.gameverse-lt.com
var gameversePortalOnlyCategories = ["Grand Theft Auto"];
var isGameversePortal = _domainConfig.config.subDomain === "portal" && _productCondition.isGameverselt;

var isCategoryAllowed = exports.isCategoryAllowed = function isCategoryAllowed(categoryName) {
  return isGameversePortal || !gameversePortalOnlyCategories.includes(categoryName);
};

/***/ }),

/***/ "./src/constants/texts.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var textContentIDRoblox = exports.textContentIDRoblox = [{
  id: 1,
  categoryName: "Roblox Tips & Tricks",
  tips: [{
    id: 10,
    title: "PLAY ROBLOX GAME SMARTLY",
    generalText: "So, we are here to tell you about the proven tips to play Roblox game efficiently:",
    img: "https://cdn.game-lords.com/Text+Content/Play_Roblox_Game_Smartly.jpg",
    description: [{
      id: 101,
      heading: "Chatting With Other Players",
      details: "In this game, you can chat with other players with ease and without any hesitation. Press “/” button and type your message and press Enter. Please make sure that you should not use offensive and irrelevant messages in the chat box of the game. You will be reported for offensive use of the game and may lose your account access as the authorities may delete your account."
    }, {
      id: 102,
      heading: "Make Objects Fly",
      details: "You can make any object/vehicle fly; you need to insert the vehicle like skateboard etc. in the game from the insertion section of the game. Enter a plane tool also from the game section. By riding the skateboard, select the plane tool and ride the skateboard in the air. Fly with many other vehicles like it and enjoy the game with ease."
    }, {
      id: 103,
      heading: "Make Everything Freeze",
      details: "You can freeze everything goes freeze in the game. It can be done by pressing the “Ctrl” and “F1” buttons at the same time. By doing so for some time, the surrounding will freeze, and you can undo the same by pressing the same in the correct order."
    }, {
      id: 104,
      heading: "Use Of Dance Moves In Roblox",
      details: "You can see a lot of dance moves in the game’s shop. By buying them, you can make your Roblox do much stuff. One of the moves is the moonwalk if you want that your character can do a moonwalk then press Up arrow with “S” button and your character will perform the moonwalk with ease."
    }, {
      id: 105,
      heading: "Robux Is The Key To Success",
      details: "Roblox has a currency for the game, and that is Robux. You must not waste Robux anywhere as if you will not have Robux; then you will not be able to unlock many games. You will also earn Robux by winning the games, and you can also buy Robux from the game’s shop. Players can sell the account terms to the person for getting more Robux. You can also get free Roblox from any Roblox hack no survey online tool."
    }]
  }, {
    id: 20,
    title: "TIPS AND TRICKS TO PLAY ROBLOX GAME EFFICIENTLY",
    generalText: "Roblox is one of the most incredible selling and most adored pretending games in the realm of games. Roblox is a 3D game where you will experience a huge load of endeavours and rather than experiencing you can make your experiences in the game. Just imagine the presence where all that you might at any point need appears. So, we are here with amazing tips one can use to play the Roblox game efficiently:",
    img: "https://cdn.game-lords.com/Text+Content/Tips_And_Tricks_To_Play_Roblox_Game_Efficiently.jpg",
    description: [{
      id: 201,
      heading: "Chatting With Other Players",
      details: "In this game, you can visit easily and without even batting an eye. Press the “/” catch and type your message and press Enter. Mercifully guarantee that you should not use threatening and immaterial messages in the chatbox of the game. You will be represented unfriendly usage of the game and may lose your record access as the experts would delete your record."
    }, {
      id: 202,
      heading: "Make Objects Fly",
      details: "You can make any vehicle fly; you need to install the vehicle like a skateboard, etc in the game from the expansion section of the game. Enter a plane contraption moreover from the game region. By riding the skateboard, select the plane contraption and ride the skateboard recognizable in general. Fly with various vehicles like it and participate in the game without any problem."
    }, {
      id: 203,
      heading: "Make Everything Freeze",
      details: "You can freeze everything in the game. It might be done by crushing the “Ctrl” and “F1” secures all the while. Along these lines for a long time, the envelope will freeze, and you can fix something almost identical by pressing something very much like all setup"
    }, {
      id: 204,
      heading: "Use Of Dance Moves In Roblox",
      details: "You can see a lot of dance moves in the game shop, you can train your Roblox to do a lot of stuff. One of the moves is the moonwalk expecting that your individual can do a moonwalk then press the Up bolt with the “S” button and your individual will play out the moonwalk without any problem."
    }, {
      id: 205,
      heading: "Robux Is The Key To Success",
      details: "You can earn through Roblox, and that is known as Robux. You ought not to waste Robux wherever you will not have Robux; then you can not open many games. Players can sell the record terms to the person for getting more Robux."
    }]
  }]
}];

var textContentShopee = exports.textContentShopee = [{
  id: 3,
  categoryName: "Shopee Tips & Tricks",
  tips: [{
    id: 30,
    title: "Shopee Tips & Tricks for Online Shoppers",
    generalText: "Shopee has continued to provide the best shopping experience to its users. And with millions of active users and shoppers, we feel compelled to provide our readers with the six best Shopee tips and tricks to help you shop with ease and save more while shopping.",
    img: "https://cdn.game-lords.com/Text+Content/Shopee_tips_and_tricks.jpeg",
    description: [{
      id: 301,
      heading: "Use the filter section to narrow down your options.",
      details: "<p>Shopee has thousands of products listed on its platform that will make anyone spoilt for choices. However, if you use the filter section, it will help you narrow down the products based on your chosen criteria much faster and more conveniently.</p><p>The filter section is located in the app's top right corner, next to the searches. Depending on the type of product that you are looking for, you can choose to show products that are only shipped locally, select from Price Range, Delivery Method, Shop Rating, Service and Promotions, and more.</p>"
    }, {
      id: 302,
      heading: "Check the Product Ratings.",
      details: "<p>Should you buy this product or not? If you are uncertain, check out Product Ratings which include the reviews for the product, ranging from 1 to 5 stars. Reviews are thoughtful and honest, and they should be taken into account when making a decision.</p><p>Shopee allows users to include photos and videos in their reviews, providing you with plenty of information to make an informed decision before purchasing. The illustration shown for the product can be deceiving at times, but with reviews, you can see the actual products that buyers received.</p><p>Once you've received your item from Shopee, don't forget to leave your honest feedback to help others and earn coins in return. Sharing is caring!</p>"
    }, {
      id: 303,
      heading: "Grab Free Shipping Voucher.",
      details: "<p>One of the benefits of shopping at Shopee is that you can get a free shipping voucher. Yes, this is where you can shop without paying the shipping fee. However, keep in mind that each voucher has its own set of terms and conditions, so it's best to read them first.</p><p>How do you get the Free Shipping Voucher?</p><p>Step 1: Go to the Shopee App's homepage and click on \"Free Shipping.\"</p><p>Step 2: Click \"Claim Now\" to apply the Free Shipping Voucher to your account.</p><p>Step 3: Navigate to \"Me\" and then \"My Vouchers\" to see all of your vouchers, including Free Shipping Vouchers.</p><p>Tips: Look for products that provide free shipping with a minimum purchase of IDR 15.</p>"
    }, {
      id: 304,
      heading: "Make use of cashback.",
      details: "<p>For those who are unfamiliar with cashback apps such as ShopBack, it is a platform that rewards its users with cash when they make an online purchase through these apps allowing you to shop and earn!</p><p>The amount of cashback varies by the online store. Some stores provide cash back ranging from 5% to 30% and even more. Keep an eye out for additional promotions, especially if you are a new user.</p><p>How does it work</p><p>1. Download the app via Google Play Store or Apple App Store.</p><p>2. Register an account.</p><p>3. Find the online store you want to shop on ShopBack and begin adding items to your shopping cart.</p><p>4. Shop and earn money in your ShopBack account.</p><p>5. Withdraw your cashback by cashing out to your bank.</p><p>Another thing to remember is to check ShopBack for any available discount codes before you check out.</p><p>In addition, Shopee provides a cashback voucher in the form of coins that you can redeem when you make a future purchase. However, you must act quickly and use the coupon before it is completely redeemed.</p>"
    }, {
      id: 305,
      heading: "Use voucher code or redeem coins.",
      details: "<p>Want to save even more money when you shop at Shopee? Before you check out, use Shopee voucher codes, discounts and coin cashback, or redeem your collectible coins.</p><p>Did you know? Some stores offer vouchers or free shipping when you spend a minimum of IDR xx, as well as a Follow Prize when you follow their store! It's one of the Shop’s perks that users frequently overlook. Now that you're aware of this don't forget to visit the Shop's profile and redeem any available vouchers.</p><p>Some Shopee vouchers, such as Free Shipping and Discount & Coin Cashback, can be applied together before you check out, but it depends on the voucher terms and conditions whether the product meets the selection criteria.</p>"
    }, {
      id: 306,
      heading: "Shop during a special sale.",
      details: "<p>Shopee has many special sales on these dates, such as 8.8, 9.9, 10.10, and Payday sales and the best part is, there will be more sales and discounts from your favourite brands on that day.</p> <p>You'd be surprised as to how much money you can save while shopping on this day because many stores are offering discounts up to 60% off. Keep an eye out for Shocking Sales for your items if they are available, as you will receive additional discounts and price reductions.</p>"
    }]
  }]
}];

var textContentIDSquidGames = exports.textContentIDSquidGames = [{
  id: 1,
  categoryName: "Squid Game Tips & Tricks",
  tips: [{
    id: 10,
    title: "6 MUST-KNOW SURVIVAL TIPS WE LEARNED FROM ‘SQUID GAME’ — ONE FOR EVERY CHALLENGE",
    generalText: "Here are survival tips we can learn from Squid Game!",
    img: "https://cdn.game-lords.com/Text+Content/6_Must_Know_Survival_Tips_We_Learned_From_Squid_Game_One_For_Every_Challenge.jpg",
    description: [{
      id: 101,
      heading: "Red light, green light: Stick together!",
      details: "I think kids from all around the world inevitably played different versions of this game during their childhoods. “Red light, green light” requires players to run while the “it” is turned away from them, but freeze while the “it” is facing them. In this game, the lead character Seong Gi-hun hesitates to participate when he sees that those who are caught moving get shot. Despite his slow processing of the events happening before him, Gi-hun gets help twice.\nThe first time was when his childhood friend Cho Sang-woo advised him to just go along with the innocent-turned-murderous game so that he could live to see another day. The second time was when Abdul Ali saves Gi-hun from tripping before the satanic doll turns around to detect movement.\nJust when you thought the episode had turned into an “every man for himself” disaster, a good samaritan saves Gi-hun’s life. The survival tip here is obvious: stick together. Maybe then you’ll have a higher chance of staying alive."
    }, {
      id: 102,
      heading: "Sugar honeycomb: Happy accidents happen, be aware of your surroundings",
      details: "This game was anxiety-inducing and yet funny at the same time. I can’t explain it, but K-dramas have a way of mixing both in a twisted fashion. The honeycomb challenge required everyone to cut out a given shape carved on honeycomb candy using just a needle. If they break the shape, they die. It’s a simple challenge but faced with the threat of a gunshot to the head, it’s devastatingly nerve-wracking. Gi-hun would know, because he was so nervous that his sweat ended up dropping on his honeycomb. Thus, the happy accident happened.\nHe figures it out instantly and starts licking the honeycomb to melt it and cut out the shape easily. Upon seeing Gi-hun’s newly discovered hack, everyone else began to lick their honeycombs too, and so they survived the second game. Lucky for them, right? That said, Squid Game survival tips wouldn’t be complete without this: Being aware of your surroundings can help you crack the code. Pun intended."
    }, {
      id: 103,
      heading: "Tug of war: “Brains over brawns” is not dead",
      details: "This was my favourite challenge in the series because it proved that experience and intelligence can still win in physical games. There’s not much to explain in the rules of tug of war except that this version in Squid Game has the losing team falling to their graves. Gi-hun’s team almost lost all hope when they saw that their opponents were more brawny than their team. Gi-hun’s team, after all, had three women and one elderly man. How could they win? But the elderly man named Oh Il-Nam had years of experience behind him and rallied their team to apply a game-changing strategy. Who would have thought that tricks like putting the rope under your armpit, planting your feet on the ground for the first 10 seconds, and leaning back so that your stomach is facing the ceiling, were effective in winning Tug of War? On top of these Squid Game survival tips from tug of war, the losing team’s greatest flaw was that they had already underestimated Gi-hun’s team just because the team looked physically weaker. They failed to remember one fundamental principle: brains over brawns."
    }, {
      id: 104,
      heading: "Marbles: Be soft but not weak, be strong but not violent",
      details: "This episode was heart-shattering to say the least. My favourite supporting cast member got killed off. Ali was a ray of sunshine in Gi-hun’s team, but his kindness was also his undoing. In the game of marbles, the participants had to group into two and were suddenly hit with the shameless instruction that whoever wins all of their opponent’s marbles will be saved while the other will die. Ali, unfortunately, agreed to pair with Sang-woo, who actually lost the marbles game to Ali. However, seeing that Ali was very reluctant to be the cause of his death, Sang-woo took advantage of Ali’s trust and was able to trick him into handing over his marbles. Ali’s soft nature was also his weakness, while Sang-woo did what he had to do to survive, and he did it without violence. All’s fair in love and war, I guess?"
    }, {
      id: 105,
      heading: "The glass bridge: Having a good memory can save your life",
      details: "Step on regular glass, you die. Step on tempered glass, you can move on to the next pair of glass platforms on the glass bridge and face another life-threatening decision. Being the first ones in line is literally a death sentence, while being the last ones in line will give you a fighting chance. Luckily for Gi-hun, he was the very last. But he was too flustered to remember which of the first two glass platforms was regular or tempered. Were it not for Kang Sae-byeok’s help, he probably would have fallen. The tip is simple: Improve your memory. Among the Squid Game survival tips though, this would be my personal weakness. I have a horrible memory, plus I’m scared of heights. So yeah, my anxiety was quite triggered during this episode."
    }, {
      id: 106,
      heading: "The squid game: Don’t show weakness, don’t provoke anyone before a game",
      details: "Kang Sae-byeok was wounded before this last game. At first I didn’t understand why she didn’t just ask for a medic, but it quickly dawned on me that it would have given her opponents the signal to kill her right then and there. She was smart to hide it. But alas, she was killed off by Sang-woo even before the squid game started. Sang-woo’s mistake here, though, was that Gi-hun’s anger was irrevocably triggered because of Sang-woo’s lack of compassion and empathy. This eventually led him to defeat Sang-woo in the squid game and emerge as the victor. So kids, if you’re competing for something and you’re at the last stage of the game, mind your own business. Provoking and taunting your opponent might just be your downfall."
    }]
  }, {
    id: 20,
    title: "ESSENTIAL GUIDE TO ALL THE SQUID GAME ROUNDS",
    generalText: "Here are all the rounds in Squid Game, what they’re based on and how to play them.",
    img: "https://cdn.game-lords.com/Text+Content/Essential_Guide_To_All_The_Squid_Game_Rounds.jpg",
    description: [{
      id: 201,
      heading: "Ddakji",
      details: "It’s not technically a round in the tournament, but it’s certainly the gateway drug into the competition, with Seong Gi-hun and the rest of the contestants lured into the game by a wealthy businessman. The card-flipping game, known as Ddakji, is a traditional Korean game popular with children. Not dissimilar to pogs, the aim of the game is to throw your card in a manner that flips your opponent’s. Unlike in Squid Game, which sees the winner win petty cash (or a slap in the face), should you flip your opponent’s card in real life you get to keep said card."
    }, {
      id: 202,
      heading: "Red Light, Green Light",
      details: "The first round in the game (and the most infamous, thanks to the giant singing robot doll) sees the 456 contestants having to run across a field and cross a white line where the robot doll is standing, all within a five minute time limit. Those who fail to make it across in time are killed. The twist of the game is that players can only move when the robot has her back turned to the contestants, which they herald by shouting ‘green light’. When the robot shouts red light, and spins around to face the crowd, the contestants all have to freeze. If they are caught moving, or even hesitating, the robot’s motion detectors kick in, and the eyes (which double up as machine guns) shoot to kill (or in some cases, obliterate). The round is based on the playground game of the same name, but it is also called ‘Statues’ or ‘Grandmother’s Footsteps’ in the UK. In a similar fashion, a person starts out as the “Curator” (It, Granny, Pooh, etc.) and stands at the end of a field. Everyone else playing stands at the far end (distance depends upon playing area selected). The object of the game is for a “Statue” to tag the Curator, thereby becoming the Curator and resetting the game."
    }, {
      id: 203,
      heading: "Ppopgi",
      details: "The second round is the honeycomb game. The snack is made by mixing a small quantity of baking soda with sugar, making a light and crunchy candy. When it is still cooling, it is usually pressed flat and stamped with a light, patterned mould. When purchasing the candy as a street food, eaters try to trim their way around the outline on the snack without breaking the picture. If they are successful, they receive a second ppopgi for free. The street food was most popular in South Korea in the 1970s and 80s, but has enjoyed a bit of a renaissance in recent weeks due to Squid Game’s popularity. What makes Squid Game’s version of the game all the more terrifying (apart from the gun being pointed to your head) is removing the shape from the rest of the honeycomb. While several players try in desperation to chisel their honeycomb shapes out with a toothpick provided to each player, Seong Gi-hun and a select few remaining players devise a more ingenious solution to the game."
    }, {
      id: 204,
      heading: "Tug of War",
      details: "A game that’s familiar to most of the audience (and only really scary if you hate physical exercise), tug of war sees players split into two teams. One team of players holds one end of a large braided rope while the other team holds the opposite side of said rope. The goal of the game is to overpower the opposing team by pulling on the rope at the same time, dragging them across the dividing line drawn in the centre between the two. Naturally, in Squid Game the game curators have upped the ante and given the Sports Day favourite a deadly twist. Participants are chained to the rope, and stand on large platforms over a large, steep drop. If a team is overpowered and loses, they fall into this canyon, right before a guillotine chops the rope in half, sending them plummeting to their imminent death. In Squid Game, the Old Man had a couple of clever tricks up his sleeve to ensure he won this game."
    }, {
      id: 205,
      heading: "Marbles",
      details: "In the Squid Game version of Marbles, there are no concrete rules – players are asked to split off into teams of two and are given ten marbles each. You can play any game you like, provided there’s no violence, but whoever ends the game with all 20 marbles wins. We see many of the couples play wagers with their marbles, guessing odds and evens. Jang Deok-su plays a more physical game with his crony – whoever can get the most marbles into a small hole by the end of the round wins all 20 marbles. Meanwhile, Cho Sang-woo tricks his partner Ali into giving him all 20 of his marbles, despite Ali’s steadfast trust in him. It’s certainly the most heartbreaking round, as many people have partnered up with teammates they thought they could depend on. One emotional twist saw players 069 and 070, a husband and wife couple, pair up only to realise one must kill the other."
    }, {
      id: 206,
      heading: "Glass Stepping Stone Bridge",
      details: "Perhaps the most terrifying game of them all, the penultimate Squid Game round appears to be loosely based on hopscotch. Held in a huge room, players must navigate their way over a ‘bridge’ suspended high in the room. The bridge is comprised of pairs of glass panels – one made of typical glass, which is strong enough to hold the weight of two players, and one made of tempered glass, which will shatter and break when jumped on, seeing their player fall to their certain death. Players have 16 minutes to cross the room before being killed, and at the very end of the game all the glass panels shatter, which leads to catastrophic injuries even if the players made it across the room safely."
    }, {
      id: 207,
      heading: "Squid Game",
      details: "A genuine children’s game popular in South Korea (director Hwang Dong-hyuk used to play it when he was younger), Squid Game is the show’s very final round, and is the most physical. The game sees a large geometric structure drawn on a wide open space (be it on a field, or in sand), separating the teams into attacking and defending. The goal of the attackers is to cross the centre of the field before attempting to reach the “home” square drawn at the opposite side of the field. To make things more difficult, attackers are expected to this by just hopping. In Squid Game, Cho Sang-Woo and Seong Gi-Hun, childhood-besties-turned-bitter-rivals, are expected to play, and it’s little more than just a vicious fight to the death. Each of them has been given a blade just before the game starts, making the final round little more than a knife fight."
    }]
  }]
}];

/***/ }),

/***/ "./src/constants/theme.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var domainThemes = exports.domainThemes = {
  gamezorix: {
    logo: "img/gamezorix_logo.svg",
    color: "#ff9b00",
    productName: "Gamezorix",
    buttonColor: "#ff9b00"
  },
  playnixzone: {
    logo: "img/playnixzone_logo.png",
    productName: "playnixzone"
  },
  appspool: {
    logo: "/img/logo-appspool.png",
    productName: "Appspool"
  },
  thegamingclubs: {
    logo: "/img/gamingclub_logo.svg",
    productName: "GamingClubs"
  },
  gamezclan: {
    logo: "img/logo-gamezclan.png",
    productName: "Gamezclan"
  },
  gameflares: {
    logo: "img/gameflares-white.svg",
    color: "#FF394B",
    productName: "Gameflares",
    buttonColor: "#FF394B"
  },
  gamiway: {
    logo: "img/gamiway/gamiway.png",
    color: "#b347a0",
    productName: "Gamiway",
    buttonColor: "#b347a0"
  },
  vplay: {
    logo: "img/VPlay_Logo.svg"
  },
  "gameverse-lt": {
    logo: "img/GameVerse_Logo.svg",
    color: "green",
    productName: "Gameverse"
  },
  funzarena: {
    logo: "img/Funzarena_Logo.svg",
    productName: "funzarena"
  },
  mobbfun: {
    logo: "img/logo-mobbfun.png",
    productName: "Mobbfun",
    color: "green"
  },
  gamiclub: {
    logo: "img/logo-gamiclub.png",
    productName: "Gamiclub",
    color: "green"
  },
  beemobi: {
    logo: "img/logo-beemobi.png",
    productName: "Beemobi",
    color: "green"
  },
  "gami-hub": {
    logo: "img/Gamihub_logo.svg",
    productName: "GamiHub",
    color: "green"
  },
  gamesqueens: {
    logo: "img/gamegueens-logo.svg",
    productName: "gamegueens"
  }
};

/***/ }),

/***/ "./src/constants/variables.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getSubdomain = function getSubdomain() {
    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    return parts[0];
};

var BASE_URL = exports.BASE_URL = '';
var urlProfilePic = exports.urlProfilePic = '';
var ANALYTICS_API_URL = exports.ANALYTICS_API_URL = '';

if (getSubdomain() == 'localhost') {
    exports.ANALYTICS_API_URL = ANALYTICS_API_URL = 'http://localhost:3000/data';
    exports.BASE_URL = BASE_URL = 'http://localhost:3200/api';
} else {
    exports.ANALYTICS_API_URL = ANALYTICS_API_URL = 'https://de-pacman.sam-media.com/api/v2/mstore';
    exports.BASE_URL = BASE_URL = window.location.origin + '/api';
}

var cdnUrl = exports.cdnUrl = 'https://cdn.game-lords.com/games/';

/***/ }),

/***/ "./src/constants/videos.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var videos_es = exports.videos_es = [{
  id: 1,
  category_name: "Gaming Tips Video",
  data: [{
    id: 1,
    title: "Spider-Man - 9 Things Before Playing",
    images_url: "http://cdn.game-lords.com/Batch+2/es-video/Spider-Man+-+9+Things+Before+Playing.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/es-video/Spider-Man+-+9+Things+Before+Playing.mp4"
  }, {
    id: 2,
    title: "Far Cry 5 - 10 Tips & Tricks The Game Doesn't Tell You",
    images_url: "http://cdn.game-lords.com/Batch+2/es-video/Far+Cry+5+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/es-video/Far+Cry+5+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.mp4"
  }, {
    id: 3,
    title: "God Of War - 10 Tips & Tricks The Game Doesn't Tell You",
    images_url: "http://cdn.game-lords.com/Batch+2/es-video/God+Of+War+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/es-video/God+Of+War+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.mp4"
  }, {
    id: 4,
    title: "PUBG Mobile - 10 Tips & Tricks The Game Doesn't Tell You",
    images_url: "http://cdn.game-lords.com/Batch+2/es-video/PUBG+Mobile+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/es-video/PUBG+Mobile+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.mp4"
  }, {
    id: 5,
    title: "Top 10 Beginner Fortnite Battle Royale Tips",
    images_url: "http://cdn.game-lords.com/Batch+2/es-video/Top+10+Beginner+Fortnite+Battle+Royale+Tips.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/es-video/Top+10+Beginner+Fortnite+Battle+Royale+Tips.mp4"
  }]
}];

var videos_za_ci = exports.videos_za_ci = [{
  id: 1,
  category_name: "Sports Betting Tips & Tricks",
  data: [{
    id: 1,
    title: "3 Football Betting Strategies",
    images_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/3+Football+Betting+Strategies.png",
    video_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/3+Football+Betting+Strategies.mp4"
  }, {
    id: 2,
    title: "10 Sports Betting Tips",
    images_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/10+Sports+Betting+Tips.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/10+Sports+Betting+Tips.mp4"
  }, {
    id: 3,
    title: "Betting Strategy That Works",
    images_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Betting+Strategy+That+Works.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Betting+Strategy+That+Works.mp4"
  }, {
    id: 4,
    title: "Football betting tips and tricks",
    images_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Football+betting+tips+and+tricks.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Football+betting+tips+and+tricks.mp4"
  }, {
    id: 5,
    title: "Sports Betting Tips for 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Sports+Betting+Tips+for+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Sports+Betting+Tips+for+2021.mp4"
  }, {
    id: 6,
    title: "Tricks to Win Football Betting",
    images_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Tricks+to+Win+Football+Betting.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Tricks+to+Win+Football+Betting.mp4"
  }]
}];

var videos_no = exports.videos_no = [{
  id: 1,
  category_name: "Coin Master Tutorial",
  data: [{
    id: 1,
    title: "Coin Master - How To Get Unlimited Coin Master Spins",
    images_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Get+Unlimited+Coin+Master+Spins.png",
    video_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Get+Unlimited+Coin+Master+Spins.mp4"
  }, {
    id: 2,
    title: "Coin Master - How To Not Get Attacked",
    images_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Not+Get+Attacked.png",
    video_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Not+Get+Attacked.mp4"
  }, {
    id: 3,
    title: "Coin Master - Spins & Coins Cheats",
    images_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Spins+%26+Coins+Cheats.png",
    video_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Spins+%26+Coins+Cheats.mp4"
  }, {
    id: 4,
    title: "Coin Master - Tips & Tricks",
    images_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Tips+%26+Tricks.png",
    video_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Tips+%26+Tricks.mp4"
  }, {
    id: 5,
    title: "Coin Master - Full Bet Playing Blast into Space Event",
    images_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Full+Bet+Playing+Blast+into+Space+Event.png",
    video_url: "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Full+Bet+Playing+Blast+into+Space+Event.mp4"
  }]
}];

var videos_kw = exports.videos_kw = [{
  id: 1,
  category_name: "Games Trailers",
  data: [{
    id: 1,
    title: "Assault Fury Mission Combat",
    images_url: "http://cdn.game-lords.com/Batch+2/kw-video/Assault+Fury+Mission+Combat.JPG",
    video_url: "http://cdn.game-lords.com/Batch+2/kw-video/Assault+Fury+Mission+Combat.mp4"
  }, {
    id: 2,
    title: "Bazooka Gunner War Strike 3D",
    images_url: "http://cdn.game-lords.com/Batch+2/kw-video/Bazooka+Gunner+War+Strike+3D.JPG",
    video_url: "http://cdn.game-lords.com/Batch+2/kw-video/Bazooka+Gunner+War+Strike+3D.mp4"
  }, {
    id: 3,
    title: "Hill Truck Driver Off Road",
    images_url: "http://cdn.game-lords.com/Batch+2/kw-video/Hill+Truck+Driver+Off+Road.JPG",
    video_url: "http://cdn.game-lords.com/Batch+2/kw-video/Hill+Truck+Driver+Off+Road.mp4"
  }, {
    id: 4,
    title: "Jail Prison Break 2018",
    images_url: "http://cdn.game-lords.com/Batch+2/kw-video/Jail+Prison+Break+2018.JPG",
    video_url: "http://cdn.game-lords.com/Batch+2/kw-video/Jail+Prison+Break+2018.mp4"
  }, {
    id: 5,
    title: "Konan Survival Barbarian Exile",
    images_url: "http://cdn.game-lords.com/Batch+2/kw-video/Konan+Survival+Barbarian+Exile.JPG",
    video_url: "http://cdn.game-lords.com/Batch+2/kw-video/Konan+Survival+Barbarian+Exile.mp4"
  }]
}, {
  id: 2,
  category_name: "Among Us Tips & Tricks",
  data: [{
    id: 6,
    title: "50 Tips for Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.mp4"
  }, {
    id: 7,
    title: "HOW TO ALWAYS WIN AS IMPOSTOR IN AMONG US!!!",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.mp4"
  }, {
    id: 8,
    title: "Top 10 Tips & Tricks in Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.mp4"
  }, {
    id: 9,
    title: "Top 15 Tips & Tricks in Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.mp4"
  }, {
    id: 10,
    title: "Top 15 Tips & Tricks in Among Us #2",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.mp4"
  }, {
    id: 11,
    title: "Top 20 Impostor Tips and Tricks in Among Us - How to Be a Pro Impostor",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.mp4"
  }, {
    id: 12,
    title: "Top 50 Tips & Tricks in Among Us Compilation   Ultimate Guide To Become a Pro",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.mp4"
  }]
}, {
  id: 3,
  category_name: "Tiktok Tips & Tricks",
  data: [{
    id: 13,
    title: "How to get started on TikTok Tips and Tricks for 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4"
  }, {
    id: 14,
    title: "How To Skyrocket TikTok GROWTH in 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4"
  }, {
    id: 15,
    title: "Tiktok Mistakes To STOP Doing in 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4"
  }, {
    id: 16,
    title: "Tips To Grow FASTER on TikTok",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4"
  }]
}];

var videos_qa = exports.videos_qa = [{
  id: 1,
  category_name: "Cyberpunk 2077 Tips & Tricks",
  data: [{
    id: 1,
    title: "Cyberpunk 2077 - 8 Huge Mistakes You're Doing Right Now!",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.mp4"
  }, {
    id: 2,
    title: "Cyberpunk 2077 - Best Secret Legendary Items",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.mp4"
  }, {
    id: 3,
    title: "Cyberpunk 2077 - Crazy Powerful Hidden Weapons",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.mp4"
  }, {
    id: 4,
    title: "Cyberpunk 2077 – Before You Build Your Character",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.mp4"
  }, {
    id: 5,
    title: "Cyberpunk 2077 Advanced Gameplay Tips",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.mp4"
  }, {
    id: 6,
    title: "Ultimate Guide to The World of Cyberpunk 2077",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.mp4"
  }]
}, {
  id: 2,
  category_name: "Among Us Tips & Tricks",
  data: [{
    id: 7,
    title: "50 Tips for Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.mp4"
  }, {
    id: 8,
    title: "HOW TO ALWAYS WIN AS IMPOSTOR IN AMONG US!!!",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.mp4"
  }, {
    id: 9,
    title: "Top 10 Tips & Tricks in Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.mp4"
  }, {
    id: 10,
    title: "Top 15 Tips & Tricks in Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.mp4"
  }, {
    id: 11,
    title: "Top 15 Tips & Tricks in Among Us #2",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.mp4"
  }, {
    id: 12,
    title: "Top 20 Impostor Tips and Tricks in Among Us - How to Be a Pro Impostor",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.mp4"
  }, {
    id: 13,
    title: "Top 50 Tips & Tricks in Among Us Compilation   Ultimate Guide To Become a Pro",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.mp4"
  }]
}, {
  id: 3,
  category_name: "Fall Guys Tips & Tricks",
  data: [{
    id: 14,
    title: "Fall Guys - Ultimate Guide - How To Win Every Round",
    images_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.jpg",
    video_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.mp4"
  }, {
    id: 15,
    title: "Fall Guys Ultimate Tips and Tricks",
    images_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.jpg",
    video_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.mp4"
  }, {
    id: 16,
    title: "How To Win Every Level In Fall Guys",
    images_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.jpg",
    video_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.mp4"
  }]
}, {
  id: 4,
  category_name: "Tiktok Tips & Tricks",
  data: [{
    id: 17,
    title: "How to get started on TikTok Tips and Tricks for 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4"
  }, {
    id: 18,
    title: "How To Skyrocket TikTok GROWTH in 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4"
  }, {
    id: 19,
    title: "Tiktok Mistakes To STOP Doing in 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4"
  }, {
    id: 20,
    title: "Tips To Grow FASTER on TikTok",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4"
  }]
}];

var videos_ae = exports.videos_ae = [{
  id: 1,
  category_name: "Cyberpunk 2077 Tips & Tricks",
  data: [{
    id: 1,
    title: "Cyberpunk 2077 - 8 Huge Mistakes You're Doing Right Now!",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.mp4"
  }, {
    id: 2,
    title: "Cyberpunk 2077 - Best Secret Legendary Items",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.mp4"
  }, {
    id: 3,
    title: "Cyberpunk 2077 - Crazy Powerful Hidden Weapons",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.mp4"
  }, {
    id: 4,
    title: "Cyberpunk 2077 – Before You Build Your Character",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.mp4"
  }, {
    id: 5,
    title: "Cyberpunk 2077 Advanced Gameplay Tips",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.mp4"
  }, {
    id: 6,
    title: "Ultimate Guide to The World of Cyberpunk 2077",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.mp4"
  }]
}, {
  id: 2,
  category_name: "Among Us Tips & Tricks",
  data: [{
    id: 7,
    title: "50 Tips for Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.mp4"
  }, {
    id: 8,
    title: "HOW TO ALWAYS WIN AS IMPOSTOR IN AMONG US!!!",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.mp4"
  }, {
    id: 9,
    title: "Top 10 Tips & Tricks in Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.mp4"
  }, {
    id: 10,
    title: "Top 15 Tips & Tricks in Among Us",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.mp4"
  }, {
    id: 11,
    title: "Top 15 Tips & Tricks in Among Us #2",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.mp4"
  }, {
    id: 12,
    title: "Top 20 Impostor Tips and Tricks in Among Us - How to Be a Pro Impostor",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.mp4"
  }, {
    id: 13,
    title: "Top 50 Tips & Tricks in Among Us Compilation   Ultimate Guide To Become a Pro",
    images_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.mp4"
  }]
}, {
  id: 3,
  category_name: "Tiktok Tips & Tricks",
  data: [{
    id: 1,
    title: "How to get started on TikTok Tips and Tricks for 2021",
    images_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
    video_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4"
  }, {
    id: 2,
    title: "How To Skyrocket TikTok GROWTH in 2021",
    images_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
    video_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4"
  }, {
    id: 3,
    title: "Tiktok Mistakes To STOP Doing in 2021",
    images_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
    video_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4"
  }, {
    id: 4,
    title: "Tips To Grow FASTER on TikTok",
    images_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
    video_url: "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4"
  }]
}];

var videos_eg = exports.videos_eg = [{
  id: 1,
  category_name: "نصائح وحيل Fall Guys",
  data: [{
    id: 1,
    title: "Fall Guys - الدليل النهائي - كيف تربح كل جولة",
    images_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.jpg",
    video_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.mp4"
  }, {
    id: 2,
    title: "نصائح وحيل Fall Guys Ultimate",
    images_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.jpg",
    video_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.mp4"
  }, {
    id: 3,
    title: "كيف تربح كل المستويات في Fall Guys",
    images_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.jpg",
    video_url: "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.mp4"
  }]
}];

var videos_rs = exports.videos_rs = [{
  id: 1,
  category_name: "Cyberpunk 2077 - САВЕТИ",
  data: [{
    id: 1,
    title: "Cyberpunk 2077 - 8 Huge Mistakes You're Doing Right Now!",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.mp4"
  }, {
    id: 2,
    title: "Cyberpunk 2077 - Best Secret Legendary Items",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.mp4"
  }, {
    id: 3,
    title: "Cyberpunk 2077 - Crazy Powerful Hidden Weapons",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.mp4"
  }, {
    id: 4,
    title: "Cyberpunk 2077 – Before You Build Your Character",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.mp4"
  }, {
    id: 5,
    title: "Cyberpunk 2077 Advanced Gameplay Tips",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.mp4"
  }, {
    id: 6,
    title: "Ultimate Guide to The World of Cyberpunk 2077",
    images_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.jpg",
    video_url: "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.mp4"
  }]
}];

var videos_gmn = exports.videos_gmn = [{
  id: 1,
  category_name: "Around The World",
  data: [{
    id: 1,
    title: "Fun Fact 1",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+1.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+1.MP4"
  }, {
    id: 2,
    title: "Fun Fact 2",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+2.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+2.MP4"
  }, {
    id: 3,
    title: "Fun Fact 3",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+3.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+3.MP4"
  }, {
    id: 4,
    title: "Fun Fact 4",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+4.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+4.MP4"
  }, {
    id: 5,
    title: "Fun Fact 5",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+5.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+5.MP4"
  }, {
    id: 6,
    title: "Fun Fact 6",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+6.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+6.MP4"
  }, {
    id: 7,
    title: "Fun Fact 7",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+7.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+7.MP4"
  }, {
    id: 8,
    title: "Fun Fact 8",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+8.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+8.MP4"
  }, {
    id: 9,
    title: "Fun Fact 9",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+9.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+9.MP4"
  }, {
    id: 10,
    title: "Fun Fact 10",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+10.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+10.MP4"
  }, {
    id: 11,
    title: "Fun Fact 11",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+11.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+11.MP4"
  }, {
    id: 12,
    title: "Fun Fact 12",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+12.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+12.MP4"
  }, {
    id: 13,
    title: "Fun Fact 13",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+13.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+13.MP4"
  }, {
    id: 14,
    title: "Fun Fact 14",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+14.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+14.MP4"
  }, {
    id: 15,
    title: "Fun Fact 15",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+15.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+15.MP4"
  }, {
    id: 16,
    title: "Fun Fact 16",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+16.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+16.MP4"
  }, {
    id: 17,
    title: "Fun Fact 17",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+17.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+17.MP4"
  }, {
    id: 18,
    title: "Fun Fact 17",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+18.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+18.MP4"
  }, {
    id: 19,
    title: "Fun Fact 19",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+19.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+19.MP4"
  }, {
    id: 20,
    title: "Fun Fact 20",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+20.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+20.MP4"
  }, {
    id: 21,
    title: "Fun Fact 21",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+21.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+21.MP4"
  }, {
    id: 22,
    title: "Fun Fact 22",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+22.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+22.MP4"
  }, {
    id: 23,
    title: "Fun Fact 23",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+23.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+23.MP4"
  }, {
    id: 24,
    title: "Fun Fact 24",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+24.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+24.MP4"
  }, {
    id: 25,
    title: "Fun Fact 25",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+25.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+25.MP4"
  }, {
    id: 26,
    title: "Fun Fact 26",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+26.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+26.MP4"
  }, {
    id: 27,
    title: "Fun Fact 27",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+27.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+27.MP4"
  }, {
    id: 28,
    title: "Fun Fact 28",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+28.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+28.MP4"
  }, {
    id: 29,
    title: "Fun Fact 29",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+29.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+29.MP4"
  }]
}, {
  id: 2,
  category_name: "Basketball Best Shots",
  data: [{
    id: 1,
    title: "5 Star Basketball Camp Vol. 1 Pressure Defense with Ed Klimkowski",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/5+Star+Basketball+Camp+Vol.+1+Pressure+Defense+with+Ed+Klimkowski.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/5+Star+Basketball+Camp+Vol.+1+Pressure+Defense+with+Ed+Klimkowski.mp4"
  }, {
    id: 2,
    title: "2015 College Slam & 3-point Sizzle",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2015+College+Slam+%26+3-point+Sizzle.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2015+College+Slam+%26+3-point+Sizzle.MP4"
  }, {
    id: 3,
    title: "2016 State Farm Assist of the Year Champion - Kahlil Felder",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Champion+-+Kahlil+Felder.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Champion+-+Kahlil+Felder.MP4"
  }, {
    id: 4,
    title: "2016 State Farm Assist of the Year Recap",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Recap.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Recap.MP4"
  }]
}, {
  id: 3,
  category_name: "Best Videos",
  data: [{
    id: 1,
    title: "Fun Fact - Babies",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Babies.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Babies.MP4"
  }, {
    id: 2,
    title: "Fun Fact - Dogs",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Dogs.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Dogs.MP4"
  }, {
    id: 3,
    title: "Fun Fact - What with Sugar",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+What+with+Sugar.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+What+with+Sugar.MP4"
  }, {
    id: 4,
    title: "Get It Beauty-Makeup Tip - Korean-style Natural Makeup",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Korean-style+Natural+Makeup.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Korean-style+Natural+Makeup.MP4"
  }, {
    id: 5,
    title: "Get It Beauty-Makeup Tip - Makeup that Keeps the Moisture",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Makeup+that+Keeps+the+Moisture.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Makeup+that+Keeps+the+Moisture.MP4"
  }, {
    id: 6,
    title: "Health Tip - Excercise always",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tip+-+Excercise+always.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tip+-+Excercise+always.MP4"
  }, {
    id: 7,
    title: "Health Tips - Excercise better",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tips+-+Excercise+better.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tips+-+Excercise+better.MP4"
  }, {
    id: 8,
    title: "Nutritionist - Excercise",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Excercise.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Excercise.MP4"
  }, {
    id: 9,
    title: "Nutritionist - Hydration",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Hydration.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Hydration.MP4"
  }]
}, {
  id: 4,
  category_name: "Boxing & Workouts",
  data: [{
    id: 1,
    title: "Arm and Leg Raise",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Arm+and+Leg+Raise.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Arm+and+Leg+Raise.MP4"
  }, {
    id: 2,
    title: "Attack and Defense",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Attack+and+Defense.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Attack+and+Defense.MP4"
  }, {
    id: 3,
    title: "Condition training",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Condition+training.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Condition+training.MP4"
  }, {
    id: 4,
    title: "Core strength",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Core+strength.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Core+strength.MP4"
  }, {
    id: 5,
    title: "Lunges",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Lunges.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Lunges.MP4"
  }, {
    id: 6,
    title: "Punch Bag",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Punch+Bag.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Punch+Bag.MP4"
  }, {
    id: 7,
    title: "Push Ups",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Push+Ups.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Push+Ups.MP4"
  }, {
    id: 8,
    title: "Russian Kicks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Russian+Kicks.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Russian+Kicks.MP4"
  }, {
    id: 9,
    title: "Shadowboxing",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Shadowboxing.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Shadowboxing.MP4"
  }, {
    id: 10,
    title: "Sit Ups",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Sit+Ups.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Sit+Ups.MP4"
  }, {
    id: 11,
    title: "Stretching",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Stretching.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Stretching.MP4"
  }, {
    id: 12,
    title: "The Plank",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/The+Plank.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/The+Plank.MP4"
  }, {
    id: 13,
    title: "Tricep Dips",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Tricep+Dips.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Tricep+Dips.MP4"
  }]
}, {
  id: 5,
  category_name: "Chef Master",
  data: [{
    id: 1,
    title: "Baked Macaroni and Cheese",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Baked+Macaroni+and+Cheese.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Baked+Macaroni+and+Cheese.MP4"
  }, {
    id: 2,
    title: "Blooming Onion",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Blooming+Onion.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Blooming+Onion.MP4"
  }, {
    id: 3,
    title: "Borscht",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Borscht.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Borscht.MP4"
  }, {
    id: 4,
    title: "Broccoli Salad",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Broccoli+Salad.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Broccoli+Salad.MP4"
  }, {
    id: 5,
    title: "Buffalo Chicken Fingers",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Buffalo+Chicken+Fingers.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Buffalo+Chicken+Fingers.MP4"
  }, {
    id: 6,
    title: "Caramelized French Toast",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Caramelized+French+Toast.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Caramelized+French+Toast.MP4"
  }, {
    id: 7,
    title: "Cauliflower Sheep",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cauliflower+Sheep.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cauliflower+Sheep.MP4"
  }, {
    id: 8,
    title: "Cheese Fondue",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.MP4"
  }]
}, {
  id: 6,
  category_name: "Comedy",
  data: [{
    id: 1,
    title: "Cold You Hold This Please",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Cold+You+Hold+This+Please.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Cold+You+Hold+This+Please.MP4"
  }, {
    id: 2,
    title: "Flower I Love You",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Flower+I+Love+You.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Flower+I+Love+You.MP4"
  }, {
    id: 3,
    title: "I Need Some Help Please",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/I+Need+Some+Help+Please.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/I+Need+Some+Help+Please.MP4"
  }, {
    id: 4,
    title: "Please Try Your Facial",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Try+Your+Facial.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Try+Your+Facial.MP4"
  }, {
    id: 5,
    title: "Please Watch And Be Careful",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.MP4"
  }, {
    id: 6,
    title: "Please Watch And Be Careful",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.MP4"
  }, {
    id: 7,
    title: "That Way What Wrong",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/That+Way+What+Wrong.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/That+Way+What+Wrong.MP4"
  }, {
    id: 8,
    title: "Cheese Fondue",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.MP4"
  }]
}, {
  id: 7,
  category_name: "Did You Know...",
  data: [{
    id: 1,
    title: "5 facts on our inner voice",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../5+facts+on+our+inner+voice.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../5+facts+on+our+inner+voice.MP4"
  }, {
    id: 2,
    title: "2000 year old discoveries",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../2000+year+old+discoveries.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../2000+year+old+discoveries.MP4"
  }, {
    id: 3,
    title: "Cool Robot",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cool+Robot.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cool+Robot.MP4"
  }, {
    id: 4,
    title: "Cost of cyberattacks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cost+of+cyberattacks.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cost+of+cyberattacks.MP4"
  }, {
    id: 5,
    title: "Ditch the doctor",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Ditch+the+doctor.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Ditch+the+doctor.MP4"
  }, {
    id: 6,
    title: "Emails dont solve paper probs",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Emails+dont+solve+paper+probs.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Emails+dont+solve+paper+probs.MP4"
  }, {
    id: 7,
    title: "Flying drinks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Flying+drinks.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Flying+drinks.MP4"
  }, {
    id: 8,
    title: "Looking younger",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Looking+younger.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Looking+younger.MP4"
  }, {
    id: 9,
    title: "Nano chip",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Nano+chip.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Nano+chip.MP4"
  }, {
    id: 10,
    title: "Obesity pandemic",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Obesity+pandemic.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Obesity+pandemic.MP4"
  }, {
    id: 11,
    title: "Star Wars becomes reality",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Star+Wars+becomes+reality.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Star+Wars+becomes+reality.MP4"
  }, {
    id: 12,
    title: "UK Drone Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../UK+Drone+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../UK+Drone+Show.MP4"
  }, {
    id: 13,
    title: "VR Running of the Bulls!",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../VR+Running+of+the+Bulls!.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../VR+Running+of+the+Bulls!.MP4"
  }, {
    id: 14,
    title: "Why are the Dutch so tall",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Why+are+the+Dutch+so+tall.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Why+are+the+Dutch+so+tall.MP4"
  }, {
    id: 15,
    title: "World of drone racing",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../World+of+drone+racing.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../World+of+drone+racing.MP4"
  }]
}, {
  id: 8,
  category_name: "Football Clips",
  data: [{
    id: 1,
    title: "Wayne Rooney",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../5+facts+on+our+inner+voice.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wayne+Rooney.MP4"
  }, {
    id: 2,
    title: "Will Smith Penalty",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Will+Smith+Penalty.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Will+Smith+Penalty.MP4"
  }, {
    id: 3,
    title: "Wonderful Goal",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goal.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goal.MP4"
  }, {
    id: 4,
    title: "Wonderful Goals",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goals.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goals.MP4"
  }, {
    id: 5,
    title: "Zinedine Zidane",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Zinedine+Zidane.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Zinedine+Zidane.MP4"
  }]
}, {
  id: 9,
  category_name: "IOS 14 Tips and Tricks",
  data: [{
    id: 1,
    title: "IOS 14 Tips And Tricks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/IOS+14+Tips+And+Tricks/IOS+14+Tips+and+Tricks.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/IOS+14+Tips+And+Tricks/IOS+14+Tips+and+Tricks.MP4"
  }]
}, {
  id: 10,
  category_name: "Latest Video",
  data: [{
    id: 1,
    title: "5 Make up tips and Tricks for you",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/IOS+14+Tips+And+Tricks/IOS+14+Tips+and+Tricks.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/5+Make+up+tips+and+Tricks+for+you.MP4"
  }, {
    id: 2,
    title: "7 Make up tips and tricks for flawless skin",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/7+Make+up+tips+and+tricks+for+flawless+skin.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/7+Make+up+tips+and+tricks+for+flawless+skin.MP4"
  }, {
    id: 3,
    title: "2016 Chevrolet Camaro SS",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Chevrolet+Camaro+SS.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Chevrolet+Camaro+SS.MP4"
  }, {
    id: 4,
    title: "2016 Ford Mustang Fastback",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Ford+Mustang+Fastback.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Ford+Mustang+Fastback.MP4"
  }, {
    id: 5,
    title: "Angry Bull",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Angry+Bull.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Angry+Bull.MP4"
  }, {
    id: 6,
    title: "Animals Exoticos",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Animals+Exoticos.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Animals+Exoticos.MP4"
  }, {
    id: 7,
    title: "Arm and Leg Raise",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.MP4"
  }, {
    id: 8,
    title: "Attack and Defense",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Attack+and+Defense.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Attack+and+Defense.MP4"
  }, {
    id: 9,
    title: "Best Rugby Skills - Steps, Tricks, Offloads Compilation",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.MP4"
  }, {
    id: 10,
    title: "Best Rugby Skills 2018",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+2018.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+2018.MP4"
  }, {
    id: 11,
    title: "Channeled message from your spirit guides",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Channeled+message+from+your+spirit+guides.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Channeled+message+from+your+spirit+guides.MP4"
  }, {
    id: 12,
    title: "Coaches Clinic  Pete Herrman",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Coaches+Clinic++Pete+Herrman.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Coaches+Clinic++Pete+Herrman.MP4"
  }, {
    id: 13,
    title: "Ditch the doctor How about diagnosis by computer",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Ditch+the+doctor+How+about+diagnosis+by+computer.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Ditch+the+doctor+How+about+diagnosis+by+computer.MP4"
  }, {
    id: 14,
    title: "Dribble Drive Motion Skills",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Dribble+Drive+Motion+Skills.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Dribble+Drive+Motion+Skills.MP4"
  }, {
    id: 15,
    title: "ESPN s new deal dives into the world of drone racing",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.MP4"
  }, {
    id: 16,
    title: "HOW & WHEN You Will You Become SUCCESSFUL",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.MP4"
  }, {
    id: 17,
    title: "How to Post Natal Yoga  Breathing Exercise",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Breathing+Exercise.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Breathing+Exercise.MP4"
  }, {
    id: 18,
    title: "How to Post Natal Yoga  Chair Exercises",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Chair+Exercises.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Chair+Exercises.MP4"
  }]
}, {
  id: 11,
  category_name: "Make Up Tutorial",
  data: [{
    id: 1,
    title: "3CE Falling in fall makeup tutorial",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/3CE+Falling+in+fall+makeup+tutorial.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/3CE+Falling+in+fall+makeup+tutorial.MP4"
  }, {
    id: 2,
    title: "5 Makeup Tips for Beginners",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+for+Beginners.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+for+Beginners.MP4"
  }, {
    id: 3,
    title: "5 Makeup Tips You Need To Know",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+You+Need+To+Know.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+You+Need+To+Know.MP4"
  }, {
    id: 4,
    title: "5 Makeup Tricks for Beginners - Makeup Geek",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tricks+for+Beginners+-+Makeup+Geek.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tricks+for+Beginners+-+Makeup+Geek.MP4"
  }, {
    id: 5,
    title: "6 Makeup Tricks Every Girl Needs To Know",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/6+Makeup+Tricks+Every+Girl+Needs+To+Know.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/6+Makeup+Tricks+Every+Girl+Needs+To+Know.MP4"
  }, {
    id: 6,
    title: "7 Makeup Tips & Tricks For A Flawless Face",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/7+Makeup+Tips+%26+Tricks+For+A+Flawless+Face.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/7+Makeup+Tips+%26+Tricks+For+A+Flawless+Face.MP4"
  }, {
    id: 7,
    title: "Arm and Leg Raise",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.MP4"
  }, {
    id: 8,
    title: "8 Melt-Proof Makeup Tips for Summer",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/8+Melt-Proof+Makeup+Tips+for+Summer.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/8+Melt-Proof+Makeup+Tips+for+Summer.MP4"
  }, {
    id: 9,
    title: "10 Essential Makeup Tips For Dark Skin Tones  Beauty Junkie",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Essential+Makeup+Tips+For+Dark+Skin+Tones++Beauty+Junkie.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Essential+Makeup+Tips+For+Dark+Skin+Tones++Beauty+Junkie.MP4"
  }, {
    id: 10,
    title: "10 Fast & Easy Makeup Tips",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Fast+%26+Easy+Makeup+Tips.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Fast+%26+Easy+Makeup+Tips.MP4"
  }, {
    id: 11,
    title: "10 Makeup Tips for Oily Skin",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Makeup+Tips+for+Oily+Skin.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Makeup+Tips+for+Oily+Skin.MP4"
  }, {
    id: 12,
    title: "Beginner Eye Makeup Tips & Tricks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Eye+Makeup+Tips+%26+Tricks.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Eye+Makeup+Tips+%26+Tricks.MP4"
  }, {
    id: 13,
    title: "Beginner Makeup Tips & Starter Kit  Drugstore Faves",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Starter+Kit++Drugstore+Faves.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Starter+Kit++Drugstore+Faves.MP4"
  }, {
    id: 14,
    title: "Beginner Makeup Tips & Tricks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Tricks.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Tricks.MP4"
  }, {
    id: 15,
    title: "How To Apply Eyeshadow For Beginners  Makeup Tips And Tricks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Eyeshadow+For+Beginners++Makeup+Tips+And+Tricks.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Eyeshadow+For+Beginners++Makeup+Tips+And+Tricks.MP4"
  }, {
    id: 16,
    title: "How To Apply Foundation For Full Coverage  Foundation Routine And Makeup Tips",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Foundation+For+Full+Coverage++Foundation+Routine+And+Makeup+Tips.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Foundation+For+Full+Coverage++Foundation+Routine+And+Makeup+Tips.MP4"
  }, {
    id: 17,
    title: "Korean style natural makeup",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Korean+style+natural+makeup.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Korean+style+natural+makeup.MP4"
  }, {
    id: 18,
    title: "Makeup Mistakes to Avoid - Tips for a Flawless Face",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Mistakes+to+Avoid+-+Tips+for+a+Flawless+Face.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Mistakes+to+Avoid+-+Tips+for+a+Flawless+Face.MP4"
  }, {
    id: 19,
    title: "Makeup MISTAKES to AVOID! - 13 Tips for a Flawless Face",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+MISTAKES+to+AVOID!+-+13+Tips+for+a+Flawless+Face.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+MISTAKES+to+AVOID!+-+13+Tips+for+a+Flawless+Face.MP4"
  }, {
    id: 20,
    title: "Makeup that keeps the moisture",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+that+keeps+the+moisture.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+that+keeps+the+moisture.MP4"
  }, {
    id: 21,
    title: "Makeup Tips and Tricks for Aging Eyes - Sephora",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Tips+and+Tricks+for+Aging+Eyes+-+Sephora.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Tips+and+Tricks+for+Aging+Eyes+-+Sephora.MP4"
  }, {
    id: 22,
    title: "Most Flattering Eye Makeup For Your Eye Shape  NewBeauty Tips and Tutorials",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Most+Flattering+Eye+Makeup+For+Your+Eye+Shape++NewBeauty+Tips+and+Tutorials.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Most+Flattering+Eye+Makeup+For+Your+Eye+Shape++NewBeauty+Tips+and+Tutorials.MP4"
  }, {
    id: 23,
    title: "Natural Makeup Tips For Men",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+Makeup+Tips+For+Men.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+Makeup+Tips+For+Men.MP4"
  }, {
    id: 24,
    title: "Natural makeup tutorial korean style - Quick Everyday Makeup",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+makeup+tutorial+korean+style+-+Quick+Everyday+Makeup.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+makeup+tutorial+korean+style+-+Quick+Everyday+Makeup.MP4"
  }, {
    id: 25,
    title: "Over 40 makeup tips- under eyes",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Over+40+makeup+tips-+under+eyes.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Over+40+makeup+tips-+under+eyes.MP4"
  }, {
    id: 26,
    title: "Pro Makeup Artist Tips - Tip Tuesday",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Pro+Makeup+Artist+Tips+-+Tip+Tuesday.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Pro+Makeup+Artist+Tips+-+Tip+Tuesday.MP4"
  }, {
    id: 27,
    title: "Saundarya - Make Up Tips - Introduction To The Make Up Kit",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Saundarya+-+Make+Up+Tips+-+Introduction+To+The+Make+Up+Kit.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Saundarya+-+Make+Up+Tips+-+Introduction+To+The+Make+Up+Kit.MP4"
  }, {
    id: 28,
    title: "Summer Essentials  Easy Makeup And Beauty Tips For Summer",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Summer+Essentials++Easy+Makeup+And+Beauty+Tips+For+Summer.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Summer+Essentials++Easy+Makeup+And+Beauty+Tips+For+Summer.MP4"
  }, {
    id: 29,
    title: "The Best Foundation Tips For Oily Skin For Longer Lasting Makeup",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Foundation+Tips+For+Oily+Skin+For+Longer+Lasting+Makeup.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Foundation+Tips+For+Oily+Skin+For+Longer+Lasting+Makeup.MP4"
  }, {
    id: 30,
    title: "The Best Makeup Artist Tips You Need to Know  Mixed Makeup Masters",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Makeup+Artist+Tips+You+Need+to+Know++Mixed+Makeup+Masters.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Makeup+Artist+Tips+You+Need+to+Know++Mixed+Makeup+Masters.MP4"
  }, {
    id: 31,
    title: "The most amazing makeup tips you will ever learn",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+most+amazing+makeup+tips+you+will+ever+learn.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+most+amazing+makeup+tips+you+will+ever+learn.MP4"
  }, {
    id: 32,
    title: "Top 10 Celebrity Makeup Tips",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+10+Celebrity+Makeup+Tips.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+10+Celebrity+Makeup+Tips.MP4"
  }, {
    id: 33,
    title: "Top 25 Makeup Tips Tricks & Products for Pale Skin",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+25+Makeup+Tips+Tricks+%26+Products+for+Pale+Skin.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+25+Makeup+Tips+Tricks+%26+Products+for+Pale+Skin.MP4"
  }, {
    id: 34,
    title: "Tyra Banks Shares On-the-Go Makeup Tips",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Tyra+Banks+Shares+On-the-Go+Makeup+Tips.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Tyra+Banks+Shares+On-the-Go+Makeup+Tips.MP4"
  }]
}, {
  id: 12,
  category_name: "Master Fitness",
  data: [{
    id: 1,
    title: "1# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/1%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/1%23+Fitness.MP4"
  }, {
    id: 2,
    title: "2# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/2%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/2%23+Fitness.MP4"
  }, {
    id: 3,
    title: "3# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/3%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/3%23+Fitness.MP4"
  }, {
    id: 4,
    title: "4# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/4%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/4%23+Fitness.MP4"
  }, {
    id: 5,
    title: "5# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/5%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/5%23+Fitness.MP4"
  }, {
    id: 6,
    title: "6# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/6%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/6%23+Fitness.MP4"
  }, {
    id: 7,
    title: "7# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/7%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/7%23+Fitness.MP4"
  }, {
    id: 8,
    title: "8# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/8%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/8%23+Fitness.MP4"
  }, {
    id: 9,
    title: "9# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/9%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/9%23+Fitness.MP4"
  }, {
    id: 10,
    title: "10# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.MP4"
  }, {
    id: 11,
    title: "11# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/11%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/11%23+Fitness.MP4"
  }, {
    id: 12,
    title: "12# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/12%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/12%23+Fitness.MP4"
  }, {
    id: 13,
    title: "13# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/13%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/13%23+Fitness.MP4"
  }, {
    id: 14,
    title: "14# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/14%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/14%23+Fitness.MP4"
  }, {
    id: 15,
    title: "15# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/15%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/15%23+Fitness.MP4"
  }, {
    id: 16,
    title: "16# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/16%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/16%23+Fitness.MP4"
  }, {
    id: 17,
    title: "17# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/17%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/17%23+Fitness.MP4"
  }, {
    id: 18,
    title: "18# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/18%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/18%23+Fitness.MP4"
  }]
}, {
  id: 13,
  category_name: "New Cars Ready To Roll",
  data: [{
    id: 1,
    title: "2017 Audi Q3 2.0 TDI Quattro - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+Q3+2.0+TDI+Quattro+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+Q3+2.0+TDI+Quattro+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.mp4"
  }, {
    id: 2,
    title: "2017 Audi S4 Avant - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+S4+Avant+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+S4+Avant+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 3,
    title: "2017 BMW 335d xDrive Touring M Sport - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+335d+xDrive+Touring+M+Sport+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+335d+xDrive+Touring+M+Sport+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 4,
    title: "2017 BMW 650i Convertible - Exterior and Interior Walkaround - 2016 Paris Auto Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+650i+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+650i+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4"
  }, {
    id: 5,
    title: "2017 BMW M4 Competition Package - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M4+Competition+Package+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M4+Competition+Package+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 6,
    title: "2017 BMW M550d xDrive - Exterior and Interior Walkaround - 2016 Paris Auto Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M550d+xDrive+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M550d+xDrive+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4"
  }, {
    id: 7,
    title: "2017 Chavrolet Camaro LTG Auto X Concept 2.0L Turbo - Exterior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chavrolet+Camaro+LTG+Auto+X+Concept+2.0L+Turbo+-+Exterior+Walkaround+-+2016+SEMA.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chavrolet+Camaro+LTG+Auto+X+Concept+2.0L+Turbo+-+Exterior+Walkaround+-+2016+SEMA.mp4"
  }, {
    id: 8,
    title: "2017 Chevrolet Corvette Grand Sport Collector Edition - Exterior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chevrolet+Corvette+Grand+Sport+Collector+Edition+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chevrolet+Corvette+Grand+Sport+Collector+Edition+-+Exterior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 9,
    title: "2017 Dodge Charger Daytona - Exterior and Interior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Dodge+Charger+Daytona+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Dodge+Charger+Daytona+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 10,
    title: "10# Fitness",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.MP4"
  }, {
    id: 11,
    title: "2017 Ford F150 Raptor Pre Runner by Deberti Design - Exterior and Interior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Pre+Runner+by+Deberti+Design+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Pre+Runner+by+Deberti+Design+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 12,
    title: "2017 Ford F150 Raptor Racing Truck by Foutz Motorsports - Exterior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Racing+Truck+by+Foutz+Motorsports+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Racing+Truck+by+Foutz+Motorsports+-+Exterior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 13,
    title: "2017 Ford Mustang Fastback 825hp Carbon Fiber Body Kit by Speedkore - Exterior Walkaround 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+Mustang+Fastback+825hp+Carbon+Fiber+Body+Kit+by+Speedkore+-+Exterior+Walkaround+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+Mustang+Fastback+825hp+Carbon+Fiber+Body+Kit+by+Speedkore+-+Exterior+Walkaround+2016+SEMA.MP4"
  }, {
    id: 14,
    title: "2017 Honda Civic Type R Prototype - Exterior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Honda+Civic+Type+R+Prototype+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Honda+Civic+Type+R+Prototype+-+Exterior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 15,
    title: "2017 KIA Sorento 2.2 Diesel - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+KIA+Sorento+2.2+Diesel+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+KIA+Sorento+2.2+Diesel+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.mp4"
  }, {
    id: 16,
    title: "2017 Mercedes GLS350 Diesel 4Matic - Exterior and Interior Walkaround - 2016 Paris Auto Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+GLS350+Diesel+4Matic+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+GLS350+Diesel+4Matic+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4"
  }, {
    id: 17,
    title: "2017 Mercedes SL 500 - Exterior and Interior Walkaround - 2016 Paris Auto Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+SL+500+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+SL+500+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4"
  }, {
    id: 18,
    title: "2017 Mini Cooper Cabrio 136ch - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Cabrio+136ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Cabrio+136ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 19,
    title: "2017 Mini Cooper Clubman One 102ch - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Clubman+One+102ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Clubman+One+102ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 20,
    title: "2017 Mitsubishi L200 Double Cab Instyle 2.4 D - Exterior Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+L200+Double+Cab+Instyle+2.4+D+-+Exterior+Interior+Walkaround+-+2016+Paris+Motor+Show.jpg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+L200+Double+Cab+Instyle+2.4+D+-+Exterior+Interior+Walkaround+-+2016+Paris+Motor+Show.mp4"
  }, {
    id: 21,
    title: "2017 Mitsubishi Outlander PHEV Instyle - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+Outlander+PHEV+Instyle+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+Outlander+PHEV+Instyle+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 22,
    title: "2017 Nissan GTR with Rohan Izawa Metal Paint and Engraving - Exterior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+GTR+with+Rohan+Izawa+Metal+Paint+and+Engraving+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+GTR+with+Rohan+Izawa+Metal+Paint+and+Engraving+-+Exterior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 23,
    title: "2017 Nissan Micra - Exterior and Interior Walkaround Debut at 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Micra+-+Exterior+and+Interior+Walkaround+Debut+at+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Micra+-+Exterior+and+Interior+Walkaround+Debut+at+2016+Paris+Motor+Show.MP4"
  }, {
    id: 24,
    title: "2017 Nissan Navara - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Navara+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Navara+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 25,
    title: "2017 Porsche 911 Turbo S Convertible - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Porsche+911+Turbo+S+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Porsche+911+Turbo+S+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 26,
    title: "2017 Renault Megane GT - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Megane+GT+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Megane+GT+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 27,
    title: "2017 Renault Talisman Initiele - Exterior and Interior Walkaround - 2016 Paris Motor Show",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Talisman+Initiele+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Talisman+Initiele+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4"
  }, {
    id: 28,
    title: "2017 Tesla Model X P90D Ludicrous by Unplugged Performance at Toyo Stand SEMA 2016 - Walkaround",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Tesla+Model+X+P90D+Ludicrous+by+Unplugged+Performance+at+Toyo+Stand+SEMA+2016+-+Walkaround.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Tesla+Model+X+P90D+Ludicrous+by+Unplugged+Performance+at+Toyo+Stand+SEMA+2016+-+Walkaround.MP4"
  }, {
    id: 29,
    title: "Chevrolet Colorado ZH2 Hybrid Concept - Exterior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Chevrolet+Colorado+ZH2+Hybrid+Concept+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Chevrolet+Colorado+ZH2+Hybrid+Concept+-+Exterior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 30,
    title: "Jeep Comanche Concept - Exterior and Interior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Comanche+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Comanche+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4"
  }, {
    id: 31,
    title: "Jeep Crew Chief 715 Concept - Exterior and Interior Walkaround - 2016 SEMA",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Crew+Chief+715+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Crew+Chief+715+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4"
  }]
}, {
  id: 14,
  category_name: "Technology",
  data: [{
    id: 1,
    title: "2000 year old discoveries found in downtown La Paz",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/2000+year+old+discoveries+found+in+downtown+La+Paz.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/2000+year+old+discoveries+found+in+downtown+La+Paz.MP4"
  }, {
    id: 2,
    title: "Are real diamonds really forever",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Are+real+diamonds+really+forever.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Are+real+diamonds+really+forever.MP4"
  }, {
    id: 3,
    title: "Cardboard & home plastics make affordable prosthetics",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cardboard+%26+home+plastics+make+affordable+prosthetics.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cardboard+%26+home+plastics+make+affordable+prosthetics.MP4"
  }, {
    id: 4,
    title: "Cowmander in Chief  This bull got milk",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cowmander+in+Chief++This+bull+got+milk.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cowmander+in+Chief++This+bull+got+milk.MP4"
  }, {
    id: 5,
    title: "Ditch the doctor! How about diagnosis by computer",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ditch+the+doctor!+How+about+diagnosis+by+computer.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ditch+the+doctor!+How+about+diagnosis+by+computer.MP4"
  }, {
    id: 6,
    title: "ESPN s new deal dives into the world of drone racing",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.MP4"
  }, {
    id: 7,
    title: "Ever wished beer could fly Now it can!",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ever+wished+beer+could+fly+Now+it+can!.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ever+wished+beer+could+fly+Now+it+can!.MP4"
  }, {
    id: 8,
    title: "Hearing things Here are 5 facts on our inner voice",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Hearing+things+Here+are+5+facts+on+our+inner+voice.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Hearing+things+Here+are+5+facts+on+our+inner+voice.MP4"
  }, {
    id: 9,
    title: "House run on human waste  The end of energy companies",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/House+run+on+human+waste++The+end+of+energy+companies.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/House+run+on+human+waste++The+end+of+energy+companies.MP4"
  }, {
    id: 10,
    title: "Innovation  the ship that floats above the water",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Innovation++the+ship+that+floats+above+the+water.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Innovation++the+ship+that+floats+above+the+water.MP4"
  }, {
    id: 11,
    title: "Is spotty skin the answer to looking younger",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Is+spotty+skin+the+answer+to+looking+younger.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Is+spotty+skin+the+answer+to+looking+younger.MP4"
  }, {
    id: 12,
    title: "Just why are the Dutch so tall",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Just+why+are+the+Dutch+so+tall.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Just+why+are+the+Dutch+so+tall.MP4"
  }, {
    id: 13,
    title: "Less ping pong a sign of market wrong in the tech world",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Less+ping+pong+a+sign+of+market+wrong+in+the+tech+world.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Less+ping+pong+a+sign+of+market+wrong+in+the+tech+world.MP4"
  }, {
    id: 14,
    title: "Meet the robot that wants to get to know you",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Meet+the+robot+that+wants+to+get+to+know+you.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Meet+the+robot+that+wants+to+get+to+know+you.MP4"
  }, {
    id: 15,
    title: "Mission  Kids Into Space  accomplished!",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Mission++Kids+Into+Space++accomplished!.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Mission++Kids+Into+Space++accomplished!.MP4"
  }, {
    id: 16,
    title: "Overachiever  Sweden too good at recycling, needs trash",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Overachiever++Sweden+too+good+at+recycling%2C+needs+trash.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Overachiever++Sweden+too+good+at+recycling%2C+needs+trash.MP4"
  }, {
    id: 17,
    title: "Proof horror films can really make you sick with sound",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Proof+horror+films+can+really+make+you+sick+with+sound.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Proof+horror+films+can+really+make+you+sick+with+sound.MP4"
  }, {
    id: 18,
    title: "Rio s Museum of Tomorrow  A potential disaster",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Rio+s+Museum+of+Tomorrow++A+potential+disaster.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Rio+s+Museum+of+Tomorrow++A+potential+disaster.MP4"
  }, {
    id: 20,
    title: "Should we let our kids become screen time zombies",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Should+we+let+our+kids+become+screen+time+zombies.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Should+we+let+our+kids+become+screen+time+zombies.MP4"
  }, {
    id: 21,
    title: "Sleepover survival mode",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sleepover+survival+mode.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sleepover+survival+mode.MP4"
  }, {
    id: 22,
    title: "Stalkers  the facts and figures on who s following you",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Stalkers++the+facts+and+figures+on+who+s+following+you.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Stalkers++the+facts+and+figures+on+who+s+following+you.MP4"
  }, {
    id: 23,
    title: "Star Wars becomes reality in a post-apocalyptic mall",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.MP4"
  }, {
    id: 24,
    title: "Sugar tax  The answer to obesity pandemic",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sugar+tax++The+answer+to+obesity+pandemic.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sugar+tax++The+answer+to+obesity+pandemic.MP4"
  }, {
    id: 25,
    title: "Swallow this nano chip to know what s making you sick",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Swallow+this+nano+chip+to+know+what+s+making+you+sick.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Swallow+this+nano+chip+to+know+what+s+making+you+sick.MP4"
  }, {
    id: 26,
    title: "The exploding cost of cyberattacks",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+exploding+cost+of+cyberattacks.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+exploding+cost+of+cyberattacks.MP4"
  }, {
    id: 27,
    title: "The power of positive thinking",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+power+of+positive+thinking.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+power+of+positive+thinking.MP4"
  }, {
    id: 28,
    title: "The science behind salted slugs",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+science+behind+salted+slugs.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+science+behind+salted+slugs.MP4"
  }, {
    id: 29,
    title: "Tim Peake s blast-off to space   A life time ambition",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Tim+Peake+s+blast-off+to+space+++A+life+time+ambition.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Tim+Peake+s+blast-off+to+space+++A+life+time+ambition.MP4"
  }, {
    id: 30,
    title: "Top 3 VR Experiences  You ll believe it when you see it",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Top+3+VR+Experiences++You+ll+believe+it+when+you+see+it.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Top+3+VR+Experiences++You+ll+believe+it+when+you+see+it.MP4"
  }, {
    id: 31,
    title: "Turns out emails didn t solve our waste paper problems",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Turns+out+emails+didn+t+solve+our+waste+paper+problems.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Turns+out+emails+didn+t+solve+our+waste+paper+problems.MP4"
  }, {
    id: 32,
    title: "UK Drone Show  The latest consumer industry trends",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/UK+Drone+Show++The+latest+consumer+industry+trends.png",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/UK+Drone+Show++The+latest+consumer+industry+trends.MP4"
  }, {
    id: 33,
    title: "Whats keeping the gender balance in check",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Whats+keeping+the+gender+balance+in+check.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Whats+keeping+the+gender+balance+in+check.MP4"
  }, {
    id: 34,
    title: "Will half the Chinese male population die from smoking",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Will+half+the+Chinese+male+population+die+from+smoking.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Will+half+the+Chinese+male+population+die+from+smoking.MP4"
  }, {
    id: 35,
    title: "Your trash can save your wallet and the planet",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+trash+can+save+your+wallet+and+the+planet.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+trash+can+save+your+wallet+and+the+planet.MP4"
  }, {
    id: 36,
    title: "Your worst habits could mean you re the next Einstein",
    images_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+worst+habits+could+mean+you+re+the+next+Einstein.jpeg",
    video_url: "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+worst+habits+could+mean+you+re+the+next+Einstein.MP4"
  }]
}, {
  id: 15,
  category_name: "Tiktok Tips & Tricks",
  data: [{
    id: 1,
    title: "How to get started on TikTok Tips and Tricks for 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4"
  }, {
    id: 2,
    title: "How To Skyrocket TikTok GROWTH in 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4"
  }, {
    id: 3,
    title: "Tiktok Mistakes To STOP Doing in 2021",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4"
  }, {
    id: 4,
    title: "Tips To Grow FASTER on TikTok",
    images_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4"
  }]
}];

var videos_cz = exports.videos_cz = [{
  id: 1,
  category_name: "WhatsApp and Viber Tips & Tricks",
  data: [{
    id: 101,
    title: "7 SECRET WhatsApp Tips, Tricks, and Hacks",
    images_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/7+SECRET+WhatsApp+Tips%2C+Tricks%2C+and+Hacks.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/7+SECRET+WhatsApp+Tips%2C+Tricks%2C+and+Hacks.mp4"
  }, {
    id: 102,
    title: "How to Use Viber",
    images_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/How+to+Use+Viber.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/How+to+Use+Viber.mp4"
  }, {
    id: 103,
    title: "WhatsApp TIPS, TRICKS & HACKS",
    images_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+TIPS%2C+TRICKS+%26+HACKS.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+TIPS%2C+TRICKS+%26+HACKS.mp4"
  }, {
    id: 104,
    title: "WhatsApp Tricks and Tips 2022",
    images_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+Tricks+and+Tips+2022.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+Tricks+and+Tips+2022.mp4"
  }]
}];

var st_idx = 0;
var videos_za = exports.videos_za = [].concat(videos_kw, [videos_qa[0], videos_gmn[1], videos_gmn[3], videos_gmn[7]], videos_za_ci, [{
  id: 1,
  category_name: "Squid Game",
  data: [{
    id: 1,
    title: "How To Beat Every DEATH GAME In  SQUID GAME",
    images_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/How+To+Beat+Every+DEATH+GAME+In++SQUID+GAME.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/How+To+Beat+Every+DEATH+GAME+In++SQUID+GAME.mp4"
  }, {
    id: 2,
    title: "Squid Game 15 Things You Missed",
    images_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/Squid+Game+15+Things+You+Missed.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/Squid+Game+15+Things+You+Missed.mp4"
  }, {
    id: 3,
    title: "SQUID GAME Breakdown Every Easter Egg, Clue, Hidden Detail & Ending Explained",
    images_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Breakdown+Every+Easter+Egg%2C+Clue%2C+Hidden+Detail+%26+Ending+Explained.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Breakdown+Every+Easter+Egg%2C+Clue%2C+Hidden+Detail+%26+Ending+Explained.mp4"
  }, {
    id: 4,
    title: "SQUID GAME Ending Every Clue About Il-Nam   Things You Missed And Hidden Details",
    images_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Ending+Every+Clue+About+Il-Nam+++Things+You+Missed+And+Hidden+Details.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Ending+Every+Clue+About+Il-Nam+++Things+You+Missed+And+Hidden+Details.mp4"
  }, {
    id: 5,
    title: "Sugar Honeycomb - Squid Game No Blood (PG-13) Dalgona Candy",
    images_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/Sugar+Honeycomb+-+Squid+Game+No+Blood+(PG-13)+Dalgona+Candy.jpeg",
    video_url: "https://cdn.game-lords.com/Batch+2/Squid+Game/Sugar+Honeycomb+-+Squid+Game+No+Blood+(PG-13)+Dalgona+Candy.mp4"
  }]
}]).map(function (item, idx) {
  var new_data = item.data.map(function (i, eidx) {
    return _extends({}, i, {
      id: st_idx + eidx + 1
    });
  });
  st_idx = st_idx + new_data.length;
  return _extends({}, item, { id: idx + 1, data: new_data });
});

/***/ }),

/***/ "./src/constants/wallpapers_za.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var wallpaper_za = exports.wallpaper_za = [{
    id: 1,
    category_name: "Fortnite Battle Royale Tips",
    images: [{
        id: 1,
        title: "#1 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/1%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 2,
        title: "#2 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/2%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 3,
        title: "#3 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/3%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 4,
        title: "#4 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/4%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 5,
        title: "#5 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/5%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 6,
        title: "#6 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/6%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 7,
        title: "#7 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/7%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }, {
        id: 8,
        title: "#8 How to play Fortnite guide for absolute beginners",
        images_url: "https://cdn.game-lords.com/fortnitebattleroyaletips/8%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
    }]
}];

/***/ }),

/***/ "./src/containers/AccessDenied.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessDenied = function (_Component) {
    _inherits(AccessDenied, _Component);

    function AccessDenied() {
        _classCallCheck(this, AccessDenied);

        return _possibleConstructorReturn(this, (AccessDenied.__proto__ || Object.getPrototypeOf(AccessDenied)).apply(this, arguments));
    }

    _createClass(AccessDenied, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactstrap.Container,
                { className: 'restricted' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    { className: 'justify-content-center' },
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { md: '6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'clearfix' },
                            _react2.default.createElement(
                                'h1',
                                { className: 'float-left display-3 mr-4 red-text-color' },
                                _react2.default.createElement('i', { className: 'fa fa-warning' })
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'pt-3 golden-text-color', style: { fontWeight: 800 } },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'accessDenied',
                                    defaultMessage: 'Access Denied'
                                })
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'red-text-color float-left' },
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pageRestricted',
                                    defaultMessage: 'The page you are looking for is restricted.'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AccessDenied;
}(_react.Component);

exports.default = AccessDenied;

/***/ }),

/***/ "./src/containers/App.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _Home = __webpack_require__("./src/containers/Home.js");

var _Home2 = _interopRequireDefault(_Home);

var _Welcome = __webpack_require__("./src/containers/Welcome.js");

var _Welcome2 = _interopRequireDefault(_Welcome);

var _Page = __webpack_require__("./src/containers/Page404.js");

var _Page2 = _interopRequireDefault(_Page);

var _Page3 = __webpack_require__("./src/containers/Page500.js");

var _Page4 = _interopRequireDefault(_Page3);

var _AccessDenied = __webpack_require__("./src/containers/AccessDenied.js");

var _AccessDenied2 = _interopRequireDefault(_AccessDenied);

var _Header = __webpack_require__("./src/components/Header/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__("./src/components/Footer/Footer.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _Sidebar = __webpack_require__("./src/components/Sidebar/Sidebar.js");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Overlay = __webpack_require__("./src/components/Sidebar/Overlay.js");

var _Overlay2 = _interopRequireDefault(_Overlay);

var _ActivityIndicator = __webpack_require__("./src/components/ActivityIndicator/ActivityIndicator.js");

var _ActivityIndicator2 = _interopRequireDefault(_ActivityIndicator);

var _SplashScreen = __webpack_require__("./src/components/SplashScreen/SplashScreen.js");

var _SplashScreen2 = _interopRequireDefault(_SplashScreen);

var _Login = __webpack_require__("./src/components/Login/Login.js");

var _Login2 = _interopRequireDefault(_Login);

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _reactCookieConsent = __webpack_require__("./node_modules/react-cookie-consent/build/index.js");

var _reactCookieConsent2 = _interopRequireDefault(_reactCookieConsent);

var _PrivateRoute = __webpack_require__("./src/PrivateRoute.js");

var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);

var _helper = __webpack_require__("./src/utils/helper.js");

var _detectBrowser = __webpack_require__("./node_modules/detect-browser/index.js");

var _TwoStepLogin = __webpack_require__("./src/components/Login/TwoStepLogin.js");

var _TwoStepLogin2 = _interopRequireDefault(_TwoStepLogin);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isOnlyBeemobi = __webpack_require__("./src/constants/isOnlyBeemobi.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isTheGamingClubs = __webpack_require__("./src/constants/isTheGamingClubs.js");

var _isGamezClan = __webpack_require__("./src/constants/isGamezClan.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

var _domainTheme = __webpack_require__("./src/utils/domainTheme.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Containers


// Components

// Helpers


var browser = (0, _detectBrowser.detect)();

var frenchDomain = _domainConfig.config.lang == 'fr' && _domainConfig.config.subDomain != 'ch' ? true : false;
var swedishDomain = _domainConfig.config.lang == 'sv' ? true : false;
var belgiumDomain = _domainConfig.config.subDomain == 'be' ? true : false;
var norwayDomain = _domainConfig.config.lang == 'no' ? true : false;
var vietnamDomain = _domainConfig.config.lang == 'vi' ? true : false;
var arabicDomain = _domainConfig.config.lang == 'ar' ? true : false;
var turkeyDomain = _domainConfig.config.lang == 'tr' ? true : false;
var spanishDomain = _domainConfig.config.lang == 'es' ? true : false;
var itelianDomain = _domainConfig.config.subDomain == 'it' ? true : false;
var ghanaDomain = _domainConfig.config.subDomain == 'gh' ? true : false;
var rsDomain = _domainConfig.config.subDomain == 'rs' ? true : false;
var grDomain = _domainConfig.config.subDomain == 'gr' ? true : false;
var roDomain = _domainConfig.config.subDomain == 'ro' ? true : false;
var czDomain = _domainConfig.config.subDomain == 'cz' ? true : false;
var peDomain = _domainConfig.config.subDomain === 'pe' && !_isGamiclub.isGamiclub ? true : false;
var myDomain = _domainConfig.config.subDomain === 'my' && _isGamiclub.isGamiclub ? true : false;

var Aux = function Aux(props) {
    return props.children;
};

var App = function (_Component) {
    _inherits(App, _Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.toggleMaxisLoginBox = function (show) {
            _this.setState({ showMaxisLogin: show });
            _this.handleBodyClass(show);
        };

        _this.state = {
            showA2SHPopUp: true,
            showMaxisLogin: false // <-- Add this
        };
        _this.renderPromptAlertBox = _this.renderPromptAlertBox.bind(_this);
        _this.renderNotificationAlertBox = _this.renderNotificationAlertBox.bind(_this);
        _this.renderMaxisLoginBox = _this.renderMaxisLoginBox.bind(_this);
        _this.onA2HSClick = _this.onA2HSClick.bind(_this);
        _this.handleBodyClass = _this.handleBodyClass.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChangeEmail = _this.onChangeEmail.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }

    _createClass(App, [{
        key: 'handleBodyClass',
        value: function handleBodyClass(isOpen) {
            var body = document.querySelector('body');
            if (isOpen) {
                body.classList.add('modal-open'); // Background scrolling aur clicks disable
            } else {
                body.classList.remove('modal-open'); // Background scrolling aur clicks re-enable
            }
        }
    }, {
        key: 'onChangeEmail',
        value: function onChangeEmail(e) {
            this.setState({ email: e.target.value });
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode == 13) {
                this.onSubmit(e);
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var email = this.state.email;

            if (!email) {
                this.setState({ emailError: "Please enter email address" });
            } else {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    this.setState({ emailError: "Invalid email address" });
                } else {
                    sessionStorage.setItem("maxis_email", email);
                    this.toggleMaxisLoginBox(false);
                }
            }
        }
    }, {
        key: 'onA2HSClick',
        value: function onA2HSClick() {
            var promptEvent = window.deferredPrompt;
            if (!promptEvent) return;
            promptEvent.prompt();
            window.deferredPrompt = undefined;
        }
    }, {
        key: 'renderPromptAlertBox',
        value: function renderPromptAlertBox() {
            var _this2 = this;

            if (!this.state.showA2SHPopUp) return null;
            if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return null;
            return _react2.default.createElement(
                'div',
                { className: 'pwa-prompt' },
                _react2.default.createElement(
                    'button',
                    { className: 'close-icon', onClick: function onClick() {
                            _this2.setState({ showA2SHPopUp: false });
                        } },
                    _react2.default.createElement('i', { className: 'fa fa-times' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pwa-heading' },
                    'Para a\xF1adir Gamelords a la pantalla de inicio, abre las opciones y pulsa A\xF1adir a pantalla inicio                '
                ),
                browser.name === "chrome" ? _react2.default.createElement(
                    'div',
                    { className: 'pwa-buttons' },
                    _react2.default.createElement(
                        'button',
                        { onClick: function onClick() {
                                var promptEvent = window.deferredPrompt;
                                if (!promptEvent) return;
                                promptEvent.prompt();
                                window.deferredPrompt = undefined;
                                return;
                            } },
                        'A\xF1adir'
                    )
                ) : null
            );
        }
    }, {
        key: 'renderNotificationAlertBox',
        value: function renderNotificationAlertBox() {
            var _this3 = this;

            if (!this.state.showA2SHPopUp) return null;
            this.handleBodyClass(true);
            if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return null;
            return _react2.default.createElement(
                'div',
                { className: 'pwa-prompt pwa-notification' },
                _react2.default.createElement(
                    'button',
                    { className: 'close-icon', onClick: function onClick() {
                            _this3.setState({ showA2SHPopUp: false }, function () {
                                _this3.handleBodyClass(false); // Popup close hone par background enable
                            });
                        } },
                    _react2.default.createElement('i', { className: 'fa fa-times' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pwa-heading' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Need help? Our support team is ready to assist you.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Support Line:'
                        ),
                        ' ',
                        _react2.default.createElement(
                            'a',
                            { href: 'tel:1800819748' },
                            '1800819748'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Email:'
                        ),
                        ' ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:mycs@content-clubs.com' },
                            'mycs@content-clubs.com'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Subscription:'
                        ),
                        ' ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://checksubscription.com/?c=my' },
                            'https://checksubscription.com/?c=my'
                        )
                    ),
                    _domainConfig.config.subDomain !== 'my' && !_isGamiclub.isGamiclub && _react2.default.createElement(
                        'div',
                        { className: 'pwa-buttons' },
                        _react2.default.createElement(
                            'a',
                            { href: 'https://api.whatsapp.com/send/?phone=601111673277&text&type=phone_number&app_absent=0', className: 'conatct-us-btn', target: '_blank' },
                            _react2.default.createElement(
                                'button',
                                null,
                                _react2.default.createElement(
                                    'svg',
                                    { viewBox: '0 0 20 20', className: 'message-us-button_logo', width: '20px', height: '20px' },
                                    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C8.21764336,20 6.50261894,19.5321866 4.99604377,18.6597493 L1.09644722,19.9573724 C0.445123153,20.1741059 -0.17423773,19.5545345 0.0427170752,18.9032841 L1.34118515,15.0055699 C0.468152857,13.4986162 4.48352336e-12,11.7830015 4.48352336e-12,10 C4.48352336e-12,4.4771525 4.4771525,0 10,0 Z M10,1.66666667 C5.39762709,1.66666667 1.66666667,5.39762709 1.66666667,10 C1.66666667,11.6017128 2.11850111,13.1345631 2.95730951,14.4569627 C3.09146627,14.6684637 3.1233805,14.929089 3.04422002,15.1667113 L2.15025713,17.8501903 L4.83522181,16.956746 C5.07271735,16.8777174 5.33315744,16.9096255 5.54455056,17.0436501 C6.86661689,17.8818489 8.39890565,18.3333333 10,18.3333333 C14.6023729,18.3333333 18.3333333,14.6023729 18.3333333,10 C18.3333333,5.39762709 14.6023729,1.66666667 10,1.66666667 Z M6.55072391,5.00454308 C6.71472826,5.00454308 6.87873262,5.00454308 7.02048512,5.01164697 C7.1713032,5.02141482 7.37404224,4.94859994 7.57430887,5.46540794 C7.78034448,5.99642371 8.27235754,7.30442746 8.33334408,7.43584942 C8.39515477,7.56727138 8.43636189,7.72355696 8.35559593,7.90026623 C8.27318168,8.07786348 8.23032628,8.18886176 8.10835319,8.34070741 C7.98555596,8.49699298 7.85039659,8.68791003 7.73831322,8.80512421 C7.61551599,8.93832215 7.48694976,9.08039995 7.63199884,9.34679582 C7.77375134,9.61052774 8.26906097,10.4807543 9.00007535,11.1822634 C9.94042191,12.0871214 10.7324228,12.368613 10.9796656,12.500035 C11.2244359,12.6323449 11.369485,12.6074813 11.5112375,12.434324 C11.6554624,12.2576147 12.1252236,11.66 12.2900521,11.3936041 C12.4540565,11.1298722 12.618885,11.1716076 12.8438758,11.2621822 C13.0688667,11.3492048 14.279532,11.9903309 14.5243024,12.1217528 C14.7723692,12.2567268 14.9363736,12.3233257 14.9973601,12.434324 C15.0591708,12.5453223 15.0591708,13.0763381 14.8556076,13.6934885 C14.649572,14.3141909 13.6680183,14.8798381 13.1949605,14.955317 C12.769703,15.0219159 12.2323621,15.0494435 11.6431003,14.8487586 C11.1671235,14.6897973 10.6994329,14.5033465 10.2420581,14.2902153 C7.77375134,13.1411611 6.16090452,10.4638825 6.03893144,10.2907252 C5.91531006,10.113128 5.03347762,8.8512995 5.03347762,7.5468477 C5.03347762,6.24328389 5.66806732,5.60126983 5.89305822,5.33753792 C6.11887326,5.07025406 6.38589542,5.00454308 6.55072391,5.00454308 Z', fill: '#25D366' })
                                ),
                                'Whatsapp'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'renderMaxisLoginBox',
        value: function renderMaxisLoginBox() {
            var _this4 = this;

            if (!this.state.showMaxisLogin) return null;
            return _react2.default.createElement(
                'div',
                { className: 'pwa-prompt pwa-notification' },
                _react2.default.createElement(
                    'button',
                    { className: 'close-icon', onClick: function onClick() {
                            return _this4.toggleMaxisLoginBox(false);
                        } },
                    _react2.default.createElement('i', { className: 'fa fa-times' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pwa-heading' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        'You want to Signup / Login?'
                    ),
                    _react2.default.createElement('input', { autoFocus: true, type: 'email', name: 'email', value: this.state.email, className: 'LoginRoute-number', placeholder: 'Enter E-mail Address', onKeyUp: this.onKeyUp, onChange: this.onChangeEmail }),
                    _react2.default.createElement(
                        'div',
                        { className: 'pwa-buttons' },
                        _react2.default.createElement(
                            'button',
                            { type: 'submit', onClick: this.onSubmit, style: { backgroundColor: 'green' }, className: 'LoginRoute-button' },
                            'Login',
                            _react2.default.createElement('i', { className: 'icon-back' })
                        )
                    ),
                    this.state.emailError ? _react2.default.createElement(
                        'span',
                        { className: 'error-message' },
                        this.state.emailError
                    ) : null
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _getDomainTheme = (0, _domainTheme.getDomainTheme)(),
                productName = _getDomainTheme.productName;

            var routes_align_center = ["/404", "/500", "/restricted", "/404/", "/500/", "/restricted/"],
                app_body_class = routes_align_center.indexOf(this.props.location.pathname) == -1 ? "app-body flex-column" : "app-body flex-row align-items-center";
            if (browser.os === "Android OS" || browser.os === 'ios') {
                if (browser.name === "chrome" && parseInt(browser.version) < 51 || browser.name === "ie" && parseInt(browser.version) < 10 || browser.name === "firefox" && parseInt(browser.version) < 52 || browser.name === "safari" && parseInt(browser.version) < 7 || browser.name === "edge" && parseInt(browser.version) < 10 || browser.name === "opera" && parseInt(browser.version) < 16) {
                    return _react2.default.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100%' } },
                        _react2.default.createElement(
                            'div',
                            { style: { height: "20vh", width: "100%", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'red' } },
                            _react2.default.createElement(
                                'h3',
                                null,
                                ' ',
                                browser.name,
                                ' (version: ',
                                browser.version,
                                ') unsupported'
                            ),
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Please download latest browser version. '
                            )
                        )
                    );
                }
            }
            if (this.props.location.pathname == "/") {
                return _react2.default.createElement(_reactRouterDom.Route, { path: '/', name: 'Splash Screen', component: _SplashScreen2.default });
            } else {
                var cookieMsg = void 0,
                    moreInfo = void 0,
                    privacyLink = void 0,
                    btnText = void 0,
                    to = void 0;
                //let productName = isGamiclub ? (isOnlyBeemobi ? 'Beemobi' : isOnlyMobbfun ? 'Mobbfun' : 'Gamiclub') : isAppspool ? 'Appspool' : isGamezClan ? 'Gamezclan' : isGameflares ? 'Gameflares' : isGamiway ? 'Gamiway' : isTheGamingClubs ? 'GamingClubs' :'Gamelord'
                if (this.props.currentLang == 'fr' && _domainConfig.config.subDomain == 'cd') {
                    cookieMsg = 'Salut! Notre site Web utilise des cookies pour vous garantir la meilleure expérience possible avec Gamelord.';
                    moreInfo = 'Plus d\'informations';
                    privacyLink = 'http://n.game-lords.com/cd/tnc-game-lords?offer=1&device=pc&operator=CD_ORANGE&operatorSubmitted=Y&_next=privacy_policy.html&_extracted=cb1f85f2bd874c32be224af2512f5369&';
                    btnText = 'Je l\'ai!';
                    to = '/';
                } else if (this.props.currentLang == 'fr') {
                    cookieMsg = 'Salut! Notre site Web utilise des cookies pour vous garantir la meilleure exp\xE9rience possible avec ' + productName + '.';
                    moreInfo = 'Plus d\'informations';
                    privacyLink = '/privacy-policy';
                    btnText = 'Je l\'ai!';
                    to = '/privacy-policy';
                } else if (this.props.currentLang == 'de') {
                    cookieMsg = 'Hallo! Unsere Website verwendet Cookies, um sicherzustellen, dass Sie die bestm\xF6gliche Erfahrung damit machen ' + productName + '.';
                    moreInfo = 'Mehr Info';
                    privacyLink = '/privacy-policy';
                    btnText = 'Verstanden';
                    to = '/privacy-policy';
                } else if (this.props.currentLang == 'be') {
                    cookieMsg = 'Hoi! Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met ' + productName + ' krijgt.';
                    moreInfo = 'Meer Informatie';
                    privacyLink = '/privacy-policy';
                    btnText = 'Begrepen!';
                    to = '/privacy-policy';
                } else if (this.props.currentLang == 'ar') {
                    cookieMsg = 'مرحبا! يستخدم موقعنا ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة ممكنة مع غيملورد';
                    moreInfo = 'مزيد من المعلومات';
                    privacyLink = '/privacy-policy';
                    btnText = 'قبلت';
                    to = '/privacy-policy';
                } else if (_domainConfig.config.subDomain === 'pt') {
                    cookieMsg = 'Ol\xE1! Nosso site usa cookies para garantir que voc\xEA obtenha a melhor experi\xEAncia poss\xEDvel com a ' + productName + '.';
                    moreInfo = 'mais informações';
                    privacyLink = '/privacy-policy';
                    btnText = 'Entendi!';
                    to = '/privacy-policy';
                } else if (_domainConfig.config.subDomain === 'lt') {
                    cookieMsg = 'Sveiki! M\u016Bs\u0173 svetain\u0117 naudoja slapukus, kad u\u017Etikrint\u0173 geriausi\u0105 patirt\u012F su ' + productName + '.';
                    moreInfo = 'daugiau informacijos';
                    privacyLink = '/privacy-policy';
                    btnText = 'Supratau!';
                    to = '/privacy-policy';
                } else if (ghanaDomain) {
                    cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with Gamelord.';
                    moreInfo = 'more info';
                    privacyLink = 'http://n.lordgames.info/gh/tnc-gamelords?device=pc&offer=1';
                    btnText = 'Got it!';
                    to = '/privacy-policy';
                } else if (rsDomain) {
                    cookieMsg = '\u040B\u0430\u043E! \u041D\u0430\u0448\u0430 \u0432\u0435\u0431 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438 \u043A\u043E\u043B\u0430\u0447\u0438\u045B\u0435 \u043A\u0430\u043A\u043E \u0431\u0438 \u043E\u0441\u0438\u0433\u0443\u0440\u0430\u043B\u0430 \u043D\u0430\u0458\u0431\u043E\u0459\u0435 \u043C\u043E\u0433\u0443\u045B\u0435 \u0438\u0441\u043A\u0443\u0441\u0442\u0432\u043E \u043D\u0430 ' + productName + '.';
                    moreInfo = 'више информација';
                    privacyLink = '/privacy-policy';
                    btnText = 'разумем';
                    to = '/privacy-policy';
                } else if (swedishDomain) {
                    cookieMsg = 'Hej! Vår webbplats använder cookies för att säkerställa att du får den bästa möjliga upplevelsen med Gamelord.';
                    moreInfo = 'Mer information';
                    privacyLink = 'http://n.game-lords.com/se/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html&_extracted=b46947911ad34990bc9776146fc173b9&';
                    btnText = 'Jag förstår!';
                    to = '/';
                } else if (belgiumDomain) {
                    cookieMsg = 'Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met Gamelord krijgt.';
                    moreInfo = 'Meer informatie';
                    privacyLink = 'http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html';
                    btnText = 'Begrijp ik!';
                    to = '/';
                } else if (norwayDomain) {
                    cookieMsg = 'Hei! Nettsiden v\xE5r bruker informasjonskapsler for \xE5 sikre at du f\xE5r best mulig opplevelse med ' + productName + '.';
                    moreInfo = 'Mer info';
                    privacyLink = '/privacy-policy-no';
                    btnText = 'Skjønner!';
                    to = '/privacy-policy-no';
                } else if (vietnamDomain) {
                    cookieMsg = 'Xin Chào! Trang web của chúng tôi sử dụng cookie để đảm bảo bạn có được trải nghiệm tốt nhất có thể với Gamelord.';
                    moreInfo = 'Đọc thêm';
                    privacyLink = '/privacy-policy';
                    btnText = 'Tiếp tục!';
                    to = '/';
                } else if (turkeyDomain) {
                    cookieMsg = 'Merhaba! Web sitemiz, touchnote ile mümkün olan en iyi deneyimi elde etmek için çerezleri kullanır.';
                    moreInfo = 'Daha fazla bilgi';
                    privacyLink = '/privacy-policy';
                    btnText = 'Anladım!';
                    to = '/privacy-policy';
                } else if (this.props.currentLang === 'it') {
                    cookieMsg = 'Salve! Il nostro sito Web utilizza cookie per assicurarti la migliore esperienza possibile con ' + productName + '.';
                    moreInfo = 'maggiori informazioni';
                    privacyLink = '/privacy-policy';
                    btnText = 'Ok!';
                    to = '/privacy-policy';
                } else if (spanishDomain || _domainConfig.config.subDomain === "es2") {
                    cookieMsg = '\xA1Hola! Nuestro sitio web utiliza cookies para asegurarse de que obtiene la mejor experiencia posible con ' + productName + '.';
                    moreInfo = 'Más información';
                    privacyLink = '/privacy-policy';
                    btnText = '¡Entendido!';
                    to = '/privacy-policy';
                } else if (grDomain) {
                    cookieMsg = '\u0393\u03B5\u03B9\u03B1! \u039F \u03B9\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03CC\u03C2 \u03BC\u03B1\u03C2 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF cookies \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C3\u03C6\u03B1\u03BB\u03AF\u03C3\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03B1 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BC\u03B5 \u03C4\u03BF ' + productName + '.';
                    moreInfo = 'περισσότερες πληροφορίες';
                    privacyLink = '/privacy-policy';
                    btnText = 'Το έπιασα!';
                    to = '/privacy-policy';
                } else if (roDomain) {
                    cookieMsg = 'Bun\u0103! Site-ul nostru folose\u0219te cookie-uri pentru a v\u0103 asigura c\u0103 ve\u021Bi ob\u021Bine cea mai bun\u0103 experien\u021B\u0103 posibil\u0103 cu ' + productName + '.';
                    moreInfo = 'mai multe informații';
                    privacyLink = '/privacy-policy';
                    btnText = 'Am înțeles!';
                    to = '/privacy-policy';
                } else if (czDomain) {
                    cookieMsg = 'Dobr\xFD den! Na\u0161e webov\xE9 str\xE1nky pou\u017E\xEDvaj\xED soubory cookie, abychom v\xE1m zajistili co nejlep\u0161\xED zku\u0161enost s ' + productName + '.';
                    moreInfo = 'více informací';
                    privacyLink = '/privacy-policy';
                    btnText = 'Jasné!';
                    to = '/privacy-policy';
                } else if (_domainConfig.config.subDomain === 'si') {
                    cookieMsg = '\u017Divjo! Na\u0161a spletna stran uporablja pi\u0161kotke, da zagotovi najbolj\u0161o mo\u017Eno izku\u0161njo ' + productName;
                    moreInfo = 'více informací';
                    privacyLink = '/privacy-policy';
                    btnText = 'Jasné!';
                    to = '/privacy-policy';
                } else if (_domainConfig.config.subDomain === 'bg') {
                    cookieMsg = '\u0417\u0434\u0440\u0430\u0432\u0435\u0439\u0442\u0435! \u041D\u0430\u0448\u0438\u044F\u0442 \u0443\u0435\u0431\u0441\u0430\u0439\u0442 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430 \u0431\u0438\u0441\u043A\u0432\u0438\u0442\u043A\u0438, \u0437\u0430 \u0434\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0430, \u0447\u0435 \u0449\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0432\u044A\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439-\u0434\u043E\u0431\u0440\u043E\u0442\u043E \u043F\u0440\u0435\u0436\u0438\u0432\u044F\u0432\u0430\u043D\u0435 \u0441 ' + productName + '.';
                    moreInfo = 'повече информация';
                    privacyLink = '/privacy-policy';
                    btnText = 'Разбрах!';
                    to = '/privacy-policy';
                } else {
                    cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with ' + productName + '.';
                    moreInfo = 'more info';
                    privacyLink = '/privacy-policy';
                    btnText = 'Got it!';
                    to = '/privacy-policy';
                }

                var cookieStyle = { background: "#2B373B", direction: 'ltr' };
                if (this.props.currentLang == 'ar') {
                    cookieStyle.direction = 'rtl';
                } else {
                    cookieStyle.direction = 'ltr';
                }
                var host = window.location.hostname;
                var isChatbotDomain = _domainConfig.config.country === 'ae' && (_isGamiclub.isGamiclub || host.includes('game-lords'));

                return _react2.default.createElement(
                    'div',
                    { className: 'app ' + (_productCondition.isGameflares ? 'gameflares-body-bg' : ''), style: vietnamDomain ? { fontFamily: "Arial, sans-serif" } : {} },
                    _isGamiclub.isGamiclub && _domainConfig.config.subDomain === 'sn' || _isGamiclub.isGamiclub && _domainConfig.config.subDomain === 'my' || window.location.hostname.includes('vplay') ? null : _react2.default.createElement(
                        _reactCookieConsent2.default,
                        {
                            location: 'bottom',
                            buttonText: btnText,
                            cookieName: 'MobiotvCookie',
                            style: cookieStyle,
                            buttonStyle: { backgroundColor: "white", fontSize: "13px", margin: '5px', marginRight: '' + (isChatbotDomain ? '10%' : '5px') },
                            contentStyle: { flex: 'none' }

                        },
                        cookieMsg,
                        " ",
                        frenchDomain || swedishDomain || vietnamDomain || ghanaDomain ? _react2.default.createElement(
                            _reactRouterDom.Link,
                            { onClick: function onClick(e) {
                                    return window.location = privacyLink;
                                }, to: to },
                            _react2.default.createElement(
                                'p',
                                { style: { color: "skyblue" } },
                                moreInfo
                            )
                        ) : _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: to },
                            _react2.default.createElement(
                                'p',
                                { style: { color: "skyblue" } },
                                moreInfo
                            )
                        )
                    ),
                    peDomain ? this.renderPromptAlertBox() : null,
                    myDomain ? this.renderNotificationAlertBox() : null,
                    window.location.href.indexOf('/login') != -1 || window.location.href.indexOf('/twoStepLogin') != -1 ? _react2.default.createElement(
                        Aux,
                        null,
                        _react2.default.createElement(_reactRouterDom.Route, { path: '/login', name: 'Login Page', component: _Login2.default }),
                        _react2.default.createElement(_reactRouterDom.Route, { path: '/twoStepLogin', name: 'TwoStepLogin', component: _TwoStepLogin2.default })
                    ) : _react2.default.createElement(
                        Aux,
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_Header2.default, { changeLang: this.props.changeLang, currentLang: this.props.currentLang, isAdmin: this.props.user.isAdmin, pathName: this.props.location.pathname, onLoginClick: function onLoginClick() {
                                    return _this5.toggleMaxisLoginBox(true);
                                } }),
                            _react2.default.createElement(_Sidebar2.default, { changeLang: this.props.changeLang, currentLang: this.props.currentLang, isAdmin: this.props.user.isAdmin })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: app_body_class },
                            _react2.default.createElement(_reactRouterDom.Route, { path: '/404', name: 'Page 404', component: _Page2.default }),
                            _react2.default.createElement(_reactRouterDom.Route, { path: '/500', name: 'Page 500', component: _Page4.default }),
                            _react2.default.createElement(_reactRouterDom.Route, { path: '/restricted', name: 'Access Denied', component: _AccessDenied2.default }),
                            _domainConfig.config.subDomain !== 'pk' && _react2.default.createElement(_reactRouterDom.Route, { path: '/welcome', name: 'Welcome Page', component: _Welcome2.default }),
                            _react2.default.createElement(_reactRouterDom.Route, { name: 'Home', component: _Home2.default })
                        ),
                        window.location.hostname.includes('vplay') ? null : _react2.default.createElement(_Footer2.default, { isAdmin: this.props.user.isAdmin, changeLang: this.props.changeLang, currentLang: this.props.currentLang }),
                        _react2.default.createElement(_Overlay2.default, { isAdmin: this.props.user.isAdmin })
                    ),
                    _react2.default.createElement(_ActivityIndicator2.default, { isLoading: this.props.loader.isLoading }),
                    this.renderMaxisLoginBox()
                );
            }
        }
    }]);

    return App;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        loader: state.ActivityIndicatorReducer
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ }),

/***/ "./src/containers/Home.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _Domain = __webpack_require__("./src/components/Domain/Domain.js");

var _Domain2 = _interopRequireDefault(_Domain);

var _Country = __webpack_require__("./src/components/Country/Country.js");

var _Country2 = _interopRequireDefault(_Country);

var _Uploads = __webpack_require__("./src/components/Uploads/Uploads.js");

var _Uploads2 = _interopRequireDefault(_Uploads);

var _Users = __webpack_require__("./src/components/User/Users.js");

var _Users2 = _interopRequireDefault(_Users);

var _ManageCategories = __webpack_require__("./src/components/Category/ManageCategories.js");

var _ManageCategories2 = _interopRequireDefault(_ManageCategories);

var _AddCountryLanguage = __webpack_require__("./src/components/Country/AddCountryLanguage.js");

var _AddCountryLanguage2 = _interopRequireDefault(_AddCountryLanguage);

var _GameList = __webpack_require__("./src/components/GameDetail/GameList.js");

var _GameList2 = _interopRequireDefault(_GameList);

var _GameDetail = __webpack_require__("./src/components/GameDetail/GameDetail.js");

var _GameDetail2 = _interopRequireDefault(_GameDetail);

var _Favorites = __webpack_require__("./src/components/Favorites/Favorites.js");

var _Favorites2 = _interopRequireDefault(_Favorites);

var _SearchPage = __webpack_require__("./src/components/SearchPage/SearchPage.js");

var _SearchPage2 = _interopRequireDefault(_SearchPage);

var _Terms = __webpack_require__("./src/components/Terms/Terms.js");

var _Terms2 = _interopRequireDefault(_Terms);

var _PrivacyPolicy = __webpack_require__("./src/components/PrivacyPolicy/PrivacyPolicy.js");

var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);

var _PrivacyPolicyNo = __webpack_require__("./src/components/PrivacyPolicy/PrivacyPolicyNo.js");

var _PrivacyPolicyNo2 = _interopRequireDefault(_PrivacyPolicyNo);

var _NewPrivacyPolicy = __webpack_require__("./src/components/NewPrivacyPolicy/NewPrivacyPolicy.js");

var _NewPrivacyPolicy2 = _interopRequireDefault(_NewPrivacyPolicy);

var _AboVerwaltung = __webpack_require__("./src/components/StaticPages/AboVerwaltung.js");

var _AboVerwaltung2 = _interopRequireDefault(_AboVerwaltung);

var _AGB = __webpack_require__("./src/components/StaticPages/AGB.js");

var _AGB2 = _interopRequireDefault(_AGB);

var _Hilfe = __webpack_require__("./src/components/StaticPages/Hilfe.js");

var _Hilfe2 = _interopRequireDefault(_Hilfe);

var _Impressum = __webpack_require__("./src/components/StaticPages/Impressum.js");

var _Impressum2 = _interopRequireDefault(_Impressum);

var _HomePage = __webpack_require__("./src/components/HomePage/HomePage.js");

var _HomePage2 = _interopRequireDefault(_HomePage);

var _Account = __webpack_require__("./src/components/Account/Account.js");

var _Account2 = _interopRequireDefault(_Account);

var _FlashMessage = __webpack_require__("./src/components/FlashMessage/FlashMessage.js");

var _FlashMessage2 = _interopRequireDefault(_FlashMessage);

var _Login = __webpack_require__("./src/components/Login/Login.js");

var _Login2 = _interopRequireDefault(_Login);

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _GamesActions = __webpack_require__("./src/actions/GamesActions.js");

var _CategoryActions = __webpack_require__("./src/actions/CategoryActions.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _restrictedCategories = __webpack_require__("./src/constants/restrictedCategories.js");

var _TwoStepLogin = __webpack_require__("./src/components/Login/TwoStepLogin.js");

var _TwoStepLogin2 = _interopRequireDefault(_TwoStepLogin);

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isAppspool = __webpack_require__("./src/constants/isAppspool.js");

var _isGamezClan = __webpack_require__("./src/constants/isGamezClan.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _shuffleSeed = __webpack_require__("./node_modules/shuffle-seed/index.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _heURL = __webpack_require__("./src/constants/heURL.js");

var _Faq = __webpack_require__("./src/components/Faq/Faq.js");

var _Faq2 = _interopRequireDefault(_Faq);

var _ContactUs = __webpack_require__("./src/components/Faq/ContactUs/ContactUs.js");

var _ContactUs2 = _interopRequireDefault(_ContactUs);

var _DemoPage = __webpack_require__("./src/components/DemoPage/DemoPage.js");

var _DemoPage2 = _interopRequireDefault(_DemoPage);

var _DemoMaxisWelcome = __webpack_require__("./src/components/DemoPage/DemoMaxisWelcome.js");

var _DemoMaxisWelcome2 = _interopRequireDefault(_DemoMaxisWelcome);

var _GameDetailDemo = __webpack_require__("./src/components/GameDetail/GameDetailDemo.js");

var _GameDetailDemo2 = _interopRequireDefault(_GameDetailDemo);

var _SubscriptionPageMaxis = __webpack_require__("./src/components/StaticPages/SubscriptionPageMaxis.js");

var _SubscriptionPageMaxis2 = _interopRequireDefault(_SubscriptionPageMaxis);

var _publicURL = __webpack_require__("./src/constants/publicURL.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home(props) {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this.state = {
      loading: true
    };
    _this.callApis = _this.callApis.bind(_this);
    _this.goToPage = _this.goToPage.bind(_this);
    return _this;
  }

  _createClass(Home, [{
    key: "redirectToHTML",
    value: function redirectToHTML() {
      var _this2 = this;

      setTimeout(function () {
        _this2.props.history.push("/home/html?uid=" + _this2.props.access.uid);
      }, 1000);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      if (localStorage.getItem("authorized")) localStorage.removeItem("authorized");
      if (localStorage.getItem("maxis_email")) localStorage.removeItem("maxis_email");
      if (localStorage.getItem("reduxStore")) localStorage.removeItem("reduxStore");
      if (!JSON.parse(sessionStorage.getItem("authorized")) || !JSON.parse(sessionStorage.getItem("authorized")).success) {
        var is_staging = (0, _helper.getParameters)("is_staging");
        var uid = (0, _helper.getParameters)("uid");
        console.log("uid ", uid);
        var msisdn = (0, _helper.getParameters)("msisdn");
        var rid = (0, _helper.getParameters)("rid");
        var id = (0, _helper.getParameters)("id");
        var subdomain = _domainConfig.config.subDomain;
        var search = window.location.search;
        var isShowLoginTruePE = search.includes("show-login=true");
        var pathname = this.props.location.pathname;


        (0, _sendData.sendData)("", "", "", "Landed", {});

        if (_domainConfig.config.subDomain === "tr") {
          this.props.history.push("/twoStepLogin");
        } else if (_domainConfig.config.subDomain === "it") {
          window.location = "http://n.game-lords.com/it/super-cars?device=smart&offer=1";
        } else if (_domainConfig.config.subDomain === "my" && _isGamiclub.isGamiclub && !uid.exist && !rid.exist && !msisdn.exist && !id.exist) {
          this.getCategories().then(function () {
            return _this3.getGames("fdf098fcc6");
          }).then(function () {
            _this3.setState({ loading: false });
            _this3.props.history.push("/demo-maxis");
          }).catch(function (err) {
            console.log(err);
            _this3.setState({ loading: false });
            _this3.props.history.push("/login");
          });
        } else if (_domainConfig.config.subDomain === "sa" && !_isGamiclub.isGamiclub && id.exist) {
          _axios2.default.get(vars.BASE_URL + "/checkAccess?uid=MCB-GSD-" + id.value + "&subDomain=" + subdomain + "&domain=" + subdomain + ".game-lords.com").then(function (response) {
            var data = {
              success: response.data.success,
              uid: response.data.data.payload.token || "MCB-GSD-" + id.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid
              });
              _this3.props.addUid({ uid: data.uid });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getGames(data.uid);
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + ("?uid=" + data.uid));
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else {
              (0, _sendData.sendData)("", "", "", "Failure", {
                method: "uid",
                success: "false"
              });
              _this3.setState({ loading: false });
              _this3.props.history.push("/login");
            }
          }).catch(function (error) {
            (0, _helper.console_log)(error);
            _this3.setState({ loading: false });
          });
        } else if (_domainConfig.config.subDomain === "za" && is_staging.exist && is_staging.value === "true") {
          sessionStorage.setItem("staging", is_staging.value);
          _axios2.default.get(vars.BASE_URL + "/checkAccessStaging?uid=" + uid.value + "&subDomain=" + subdomain).then(function (response) {
            var data = {
              success: response.data.success,
              uid: uid.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid
              });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getGames(_this3.props.access.uid);
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + "?uid=" + data.uid);
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else {
              (0, _sendData.sendData)("", "", "", "Failure", {
                method: "uid",
                success: "false"
              });
              _this3.setState({ loading: false });
              _this3.props.history.push("/login");
            }
          }).catch(function (error) {
            (0, _sendData.sendData)("", "", "", "Failure", {
              method: "uid",
              success: "false"
            });
            (0, _helper.console_log)(error);
            _this3.setState({ loading: false });
          });
        } else if (_domainConfig.config.subDomain === "za" && uid.exist && rid.exist && !_isGamiclub.isGamiclub && !_isAppspool.isAppspool && !_isGamezClan.isGamezClan) {
          console.log("validation for uid and rid");
          _axios2.default.get(vars.BASE_URL + "/checkAccess?uid=" + uid.value + "&subDomain=" + subdomain).then(function (response) {
            var data = {
              success: response.data.success,
              uid: uid.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid
              });
              _this3.props.addUid({ uid: data.uid });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getGames(data.uid);
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + ("?uid=" + data.uid));
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else if (rid.exist) {
              _axios2.default.get(vars.BASE_URL + "/checkAccessWithRID?rid=" + rid.value + "&subDomain=" + subdomain).then(function (response) {
                var data = {
                  success: response.data.success,
                  uid: response.data.data.payload.token,
                  token: response.data.data.token,
                  subscriptionData: response.data.data.payload
                };
                sessionStorage.setItem("authorized", JSON.stringify(data));
                _this3.props.checkAccess(data);
                if (response.data.success) {
                  (0, _sendData.sendData)("", "", "", "Accessed", {
                    method: "rid",
                    success: "true",
                    uid: data.uid
                  });
                  _this3.props.addUid({ uid: data.uid });
                  _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
                  _this3.callApis().then(function () {
                    return _this3.getCategories();
                  }).then(function () {
                    return _this3.getGames(data.uid);
                  }).then(function () {
                    return _this3.getFavouriteGames();
                  }).then(function () {
                    _this3.setState({ loading: false });
                    _this3.props.history.push(_this3.props.location.pathname + ("?uid=" + data.uid));
                  }).catch(function (err) {
                    console.log(err);
                    _this3.setState({ loading: false });
                    _this3.props.history.push("/login");
                  });
                } else {
                  (0, _sendData.sendData)("", "", "", "Failure", {
                    method: "rid",
                    success: "false"
                  });
                  _this3.setState({ loading: false });
                  _this3.props.history.push("/login");
                }
              }).catch(function (error) {
                (0, _helper.console_log)(error);
                _this3.setState({ loading: false });
              });
            }
          }).catch(function (error) {
            (0, _helper.console_log)(error);
            _this3.setState({ loading: false });
          });
        } else if (_domainConfig.config.subDomain === "kw" && id.exist && _isGamiclub.isGamiclub) {
          var free_uid = "fdf098fcc6";
          _axios2.default.get(vars.BASE_URL + "/checkAccess?uid=" + free_uid + "&subDomain=" + subdomain).then(function (response) {
            var data = {
              success: response.data.success,
              uid: free_uid,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid
              });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getGames(_this3.props.access.uid);
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + "?uid=" + data.uid);
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else {
              (0, _sendData.sendData)("", "", "", "Failure", {
                method: "uid",
                success: "false"
              });
              _this3.setState({ loading: false });
              _this3.props.history.push("/login");
            }
          }).catch(function (error) {
            (0, _helper.console_log)(error);
            _this3.setState({ loading: false });
          });
        } else if (msisdn.exist) {
          var local_domain = _isGamiclub.isGamiclub ? subdomain + ".gamiclub.com" : subdomain + ".game-lords.com";
          var domain = window.location.hostname.includes("localhost") ? local_domain : window.location.hostname;
          _axios2.default.get(vars.BASE_URL + "/checkAccessWithMsisdn?msisdn=" + msisdn.value + "&domain=" + domain).then(function (response) {
            var data = {
              success: response.data.success,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "msisdn",
                status: "success",
                msisdn: msisdn
              });
              _this3.props.addUid({ uid: data.subscriptionData.token });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                return _this3.getGames(data.subscriptionData.token);
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + ("?uid=" + data.subscriptionData.token));
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else {
              (0, _sendData.sendData)("", "", "", "Failure", {
                method: "msisdn",
                success: "false"
              });
              _this3.setState({ loading: false });
              if (_domainConfig.config.subDomain === "pe" && !_isGamiclub.isGamiclub) {
                if (isShowLoginTruePE) _this3.props.history.push("/login");else window.location.replace(_heURL.peHEURL);
              } else _this3.props.history.push("/login");
            }
          }).catch(function (error) {
            (0, _helper.console_log)(error);
            (0, _sendData.sendData)("", "", "", "Failure", {
              method: "msisdn",
              success: "false"
            });
            _this3.setState({ loading: false });
          });
        } else if (rid.exist) {
          console.log("check only for rid");
          _axios2.default.get(vars.BASE_URL + "/checkAccessWithRID?rid=" + rid.value + "&subDomain=" + subdomain).then(function (response) {
            var data = {
              success: response.data.success,
              uid: response.data.data.payload.token,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "rid",
                success: "true",
                uid: data.uid
              });
              _this3.props.addUid({ uid: data.uid });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getGames(data.uid);
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + ("?uid=" + data.uid));
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else {
              (0, _sendData.sendData)("", "", "", "Failure", {
                method: "rid",
                success: "false"
              });
              _this3.setState({ loading: false });
              if (_domainConfig.config.subDomain === "pe" && !_isGamiclub.isGamiclub) {
                if (isShowLoginTruePE) _this3.props.history.push("/login");else window.location.replace(_heURL.peHEURL);
              } else _this3.props.history.push("/login");
            }
          }).catch(function (error) {
            (0, _helper.console_log)(error);
            _this3.setState({ loading: false });
          });
        } else if (uid.exist) {
          console.log("check only for uid");
          _axios2.default.get(vars.BASE_URL + "/checkAccess?uid=" + uid.value + "&subDomain=" + subdomain).then(function (response) {
            console.log("response for uid check ", response.data);
            var data = {
              success: response.data.success,
              uid: uid.value,
              token: response.data.data.token,
              subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data));
            _this3.props.checkAccess(data);
            if (response.data.success) {
              (0, _sendData.sendData)("", "", "", "Accessed", {
                method: "uid",
                success: "true",
                uid: data.uid
              });
              _this3.props.addUid({ uid: data.uid });
              _axios2.default.defaults.headers.common["authorization"] = response.data.data.token;
              _this3.callApis().then(function () {
                return _this3.getCategories();
              }).then(function () {
                return _this3.getGames(data.uid);
              }).then(function () {
                return _this3.getFavouriteGames();
              }).then(function () {
                _this3.setState({ loading: false });
                _this3.props.history.push(_this3.props.location.pathname + ("?uid=" + data.uid));
              }).catch(function (err) {
                console.log(err);
                _this3.setState({ loading: false });
                _this3.props.history.push("/login");
              });
            } else {
              (0, _sendData.sendData)("", "", "", "Failure", {
                method: "rid",
                success: "false"
              });
              _this3.setState({ loading: false });
              if (_domainConfig.config.subDomain === "pe" && !_isGamiclub.isGamiclub) {
                if (isShowLoginTruePE) _this3.props.history.push("/login");else window.location.replace(_heURL.peHEURL);
              } else _this3.props.history.push("/login");
            }
          }).catch(function (error) {
            (0, _helper.console_log)(error);
            _this3.setState({ loading: false });
          });
        } else {
          this.setState({ loading: false });
          if (_domainConfig.config.subDomain === "pe" && !_isGamiclub.isGamiclub) {
            if (isShowLoginTruePE) this.props.history.push("/login");else window.location.replace(_heURL.peHEURL);
          } else if (_productCondition.isFunzarena && (0, _publicURL.isPublicRoute)(pathname) && !uid.exist) {
            return;
          } else this.props.history.push("/login");
        }
      } else {
        this.setState({ loading: false });
        this.props.history.push(this.props.location.pathname + this.props.location.search);
      }
    }
  }, {
    key: "goToPage",
    value: function goToPage(path) {
      if (this.props.location.pathname != path) {
        this.props.history.push((0, _helper.appendUid)(path, this.props.access.uid));
      }
    }
  }, {
    key: "callApis",
    value: function callApis() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (_this4.props.account.interests.length <= 0) {
          var uid = (0, _helper.parseQueryString)(_this4.props.location.search)["uid"] || _this4.props.access.uid;
          _axios2.default.all([_axios2.default.get(vars.BASE_URL + "/interests?uid=" + uid)]).then(_axios2.default.spread(function (interests) {
            // for interests
            if (interests.data.data) {
              _this4.props.getInterests(interests.data.data);
            }
            resolve();
          })).then(function () {
            _axios2.default.get(vars.BASE_URL + "/getUserProfile?uid=" + uid).then(function (resp) {
              if (resp.data.data) {
                _this4.props.getDetails(resp.data.data);
              }
            }).catch(function (err) {
              console.log("error in getting user profile-------- ", err);
            });
          }).catch(function (err) {
            (0, _helper.console_log)(err);
            reject(err);
          });
        } else {
          _this4.props.getDetails(_this4.props.account.user);
          _this4.props.getInterests(_this4.props.account.interests);
          resolve();
        }
      });
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _axios2.default.get(vars.BASE_URL + "/getCategories").then(function (response) {
          if (response.data.success) {
            var dataFinal = response.data;
            var categoriesArr = dataFinal.data;
            dataFinal = _extends({}, dataFinal, { data: categoriesArr });
            dataFinal.data = dataFinal.data.filter(function (category) {
              return (0, _restrictedCategories.isCategoryAllowed)(category.categoryName);
            });
            if (_domainConfig.config.subDomain === "za" && !_isGamiclub.isGamiclub) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryTypeId != 4;
              });
            }
            if (_domainConfig.config.subDomain == "sa" || _domainConfig.config.subDomain == "iq" || _domainConfig.config.subDomain == "asiacell" || _domainConfig.config.subDomain == "qa") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "New Arrivals";
              });
            }
            if (!(_domainConfig.config.subDomain === "ch" && _isGamiclub.isGamiclub)) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "Astrology";
              });
            }
            if (!(_domainConfig.config.subDomain === "cz" && _isGamiclub.isGamiclub)) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "E-knihy";
              });
            }
            if (_domainConfig.config.subDomain === "fr" && _isGamiclub.isGamiclub) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                var excludes = ["Heróis Verdes", "Meu Emprego dos Sonhos"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (_domainConfig.config.subDomain === "my" && window.location.hostname.includes("gamiclub")) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (_domainConfig.config.subDomain === "es2" && window.location.hostname.includes("beemobi")) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                var excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            } else {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "Videos Virales";
              });
            }
            if (_domainConfig.config.subDomain !== "rs") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "Е-књиге";
              });
            }
            if (_domainConfig.config.subDomain !== "ae") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "IQ Games";
              });
            }
            if (_domainConfig.config.subDomain != "sa" && _domainConfig.config.subDomain != "iq" && (_domainConfig.config.subDomain != "kw" || !_isGamiclub.isGamiclub) && _domainConfig.config.subDomain != "ae" && _domainConfig.config.subDomain != "bh") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                var excludes = ["Motivation", "Tour", "Fun Gaming", "Athletics"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (_domainConfig.config.subDomain != "kw") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                var excludes = ["How It Works", "Alwan lara", "Chef Chadi Zeitouni Healthy Food", "Food Stories", "Maalem Hawl Al Aalam", "Maza Na2kol", "Modon men al 3alam", "Modon Men Asia", "Modon Wa Amaken", "Oumam Amthalokom", "Riyad Al Saleheen"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            if (_domainConfig.config.subDomain != "sn") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                var excludes = ["Cuisine", "Musique", "Apprends le français", "Courts métrages", "Visites"];
                return excludes.indexOf(category.categoryName) == -1;
              });
            }
            /*if(config.subDomain != 'my'){
                                dataFinal.data = dataFinal.data.filter((category) => {
                                     let excludes = ['Casual', 'Adrenaline Rush']
                                     return excludes.indexOf(category.categoryName) == -1
                                })
                            }*/
            /*if(config.subDomain === 'my'){
                                dataFinal.data = dataFinal.data.filter((category) => {
                                    if(category.categoryTypeName !== 'HTML5') { 
                                        return category;
                                    }    
                                    else {
                                        let excludes = ['Premium Games', 'Sports']
                                        return excludes.indexOf(category.categoryName) == -1
                                    }
                                })
                            }*/
            if (_domainConfig.config.subDomain !== "ae" && (_domainConfig.config.subDomain !== "kw" || !_isGamiclub.isGamiclub)) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName !== "Squid Games";
              });
            }
            if (_domainConfig.config.subDomain != "maxis" && _domainConfig.config.subDomain != "my" && _domainConfig.config.subDomain != "sa" && !_isGamiclub.isGamiclub && _domainConfig.config.subDomain != "ae" && !_isGamiclub.isGamiclub) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "Utilities";
              });
            }
            if (_domainConfig.config.subDomain != "idsale" || _domainConfig.config.subDomain != "gmn") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "On Sale";
              });
            }
            if (_domainConfig.config.subDomain !== "tr" && _domainConfig.config.subDomain !== "qa" && _domainConfig.config.subDomain !== "kw") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "Facebook";
              });
            }
            if (_domainConfig.config.subDomain == "idsale" || _domainConfig.config.subDomain === "gmn") {
              dataFinal.data = dataFinal.data.sort(function (category) {
                if (category.categoryName == "On Sale") return -1;else return 1;
              });
            }
            if (_domainConfig.config.subDomain === "kw" && !_isGamiclub.isGamiclub) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return ["How It Works", "Alwan lara", "Chef Chadi Zeitouni Healthy Food", "Food Stories", "Maalem Hawl Al Aalam", "Maza Na2kol", "Modon men al 3alam", "Modon Men Asia"].indexOf(category.categoryName) < 0;
              });
            }
            if (!(_domainConfig.config.subDomain == "es2")) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return category.categoryName != "Heroes";
              });
            }
            if (_domainConfig.config.subDomain === "sn") {
              dataFinal.data = dataFinal.data.filter(function (category) {
                if (category.categoryTypeName !== "VIDEO") return category;else return ["Cuisine", "Musique", "Apprends le français", "Courts métrages", "Visites"].includes(category.categoryName);
              });
            }
            if (_domainConfig.config.subDomain === "id" && _isOnlyMobbfun.isOnlyMobbfun) {
              dataFinal.data = (0, _shuffleSeed.shuffle)(dataFinal.data, "rzt457");
            }
            if (_domainConfig.config.subDomain !== "pt" && !_isGamiclub.isGamiclub) {
              dataFinal.data = dataFinal.data.filter(function (category) {
                return ["Heróis Verdes", "Meu Emprego dos Sonhos"].indexOf(category.categoryName) < 0;
              });
            }
            //if(config.subDomain === 'my'){
            dataFinal.data = dataFinal.data.filter(function (category) {
              if (category.categoryTypeName !== "HTML5") {
                return category;
              } else {
                var excludes = ["Premium Games", "Sports"];
                return excludes.indexOf(category.categoryName) == -1;
              }
            });
            //}
            _this5.props.getCategories(dataFinal);
            resolve();
          }
        }).catch(function (error) {
          (0, _helper.console_log)(error);
          _this5.setState({
            isValid: false,
            errorMessage: "Unable to fetch the data."
          });
          reject(error);
        });
      });
    }
  }, {
    key: "getGames",
    value: function getGames(uid) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        _axios2.default.get(vars.BASE_URL + "/getGames?uid=" + uid).then(function (response) {
          if (response.data.success) {
            response.data.data = response.data.data.filter(function (game) {
              return (0, _restrictedCategories.isCategoryAllowed)(game.categoryName);
            });
            if (!(_domainConfig.config.subDomain == "tr" || _domainConfig.config.subDomain == "no")) {
              response.data.data = response.data.data.filter(function (game) {
                return game.gameTitle != "Trusted Tarot" && game.gameTitle != "Coffee Reading";
              });
            }
            if (_domainConfig.config.subDomain == "no") {
              response.data.data = response.data.data.map(function (game) {
                return game.gameId == 455 ? _extends({}, game, { gameTitle: "Coffee Reading" }) : game;
              });
            }
            if (_domainConfig.config.subDomain != "tr") {
              response.data.data = response.data.data.filter(function (game) {
                return game.gameTitle != "Okey";
              });
            }
            if (_domainConfig.config.subDomain === "eg") {
              var excluded_games = ["Santa Claus The Pervert Part 1", "Place your bets! GTA is getting a real virtual casino", "Dargavs Welcome to the City of the Dead", "King Bacon Vs Vegans", "Jackpot", "Christmas Night Of Horror", "High Fly Valentine", "Horoscope", "Sacra Terra Kiss Of Death", "Haunted Legends Undertaker", "Stereotypo"];
              response.data.data = response.data.data.filter(function (game) {
                return excluded_games.indexOf(game.gameTitle) < 0;
              });
            }
            if (_domainConfig.config.subDomain === "ae" && !_isGamiclub.isGamiclub) {
              var included_games = ["VPN", "BestVPN"];
              var _excluded_games = response.data.data.filter(function (game) {
                return game.categoryName == "Utilities" && included_games.indexOf(game.gameTitle) < 0;
              }).map(function (game) {
                return game.gameTitle;
              });
              response.data.data = response.data.data.filter(function (game) {
                return _excluded_games.indexOf(game.gameTitle) < 0;
              });
            }
            if (!(_domainConfig.config.subDomain === "gh" || _domainConfig.config.subDomain === "ci")) {
              response.data.data = response.data.data.filter(function (game) {
                return game.gameTitle != "Fidget Pop It";
              });
            }
            if (_domainConfig.config.subDomain !== "demo") {
              var excluded = ["Balancer Ball 3D", "Bottle Knock Down", "Brain For Monster Truck", "Bull Fight", "Dogs Quiz", "Forsake The Rake", "Fruit Slice", "Horse Quiz", "Knock Down", "Physics Line", "Pixel Art", "Sheep Fight", "Slenderman Must Die Abandoned Graveyard", "Tough Muscle Man", "Unicorn Dash"];
              response.data.data = response.data.data.filter(function (game) {
                return excluded.indexOf(game.gameTitle) < 0;
              });
            }
            if (_domainConfig.config.subDomain === "demo") {
              var _excluded = ["Box Race", "Pacman", "Don't Miss", "Earth Attack", "Memory Game", "Mathematic", "Office Horror Story", "Rise Up", "Shadow Ninja", "Square Adventure", "Super Color Lines", "NINJA CLAN", "Fidget Spinner", "Snake Attack", "King Bacon Vs Vegans", "CATS VS DOGS", "Legend Of The Samurai", "Zombo", "CANDY GIRL", "Flappy Bird Multiplayer", "RUN, VOVAN, RUN", " BOX TOWER", "Connect 4", "Four Colors", "Math Game", "Slice Fruit", "Goose Game"];
              response.data.data = response.data.data.filter(function (game) {
                return _excluded.indexOf(game.gameTitle) < 0;
              });
            }
            if (_domainConfig.config.subDomain !== "pe") {
              var _excluded2 = ["Caller ID"];
              response.data.data = response.data.data.filter(function (game) {
                return _excluded2.indexOf(game.gameTitle) < 0;
              });
            }
            if (_domainConfig.config.subDomain !== "pe" && _domainConfig.config.subDomain !== "tr") {
              var _excluded3 = ["Photo Text Editor", "Photo Editor Application", "Pic Shop", "Retro Cam Pro", "Facial Twin Editor", "Valentine Love Mesh", "Love Photo", "Wild Side App"];
              response.data.data = response.data.data.filter(function (game) {
                return _excluded3.indexOf(game.gameTitle) < 0;
              });
            }
            if (_domainConfig.config.subDomain !== "gr" && _domainConfig.config.subDomain !== "cz" && _domainConfig.config.subDomain !== "ch" && _domainConfig.config.subDomain !== "fr") {
              var _excluded4 = ["PDF Merger", "QR Scanner"];
              response.data.data = response.data.data.filter(function (game) {
                return _excluded4.indexOf(game.gameTitle) < 0;
              });
            }
            if (_domainConfig.config.subDomain === "pe") {
              var _excluded5 = ["Brain it on the truck", "Don't Miss", "Pacman", "Earth Attack", "Brain For Monster Truck"];
              response.data.data = response.data.data.filter(function (game) {
                if (game.categoryName === "Adventure" && game.gameTitle === "Rise Up") {
                  return false;
                }
                return _excluded5.indexOf(game.gameTitle) < 0;
              });
            }
            _this6.props.getGames(response.data);
          }
          resolve();
        }).catch(function (error) {
          (0, _helper.console_log)(error);
          _this6.setState({
            isValid: false,
            errorMessage: "Unable to fetch the data."
          });
          reject(error);
        });
      });
    }
  }, {
    key: "getFavouriteGames",
    value: function getFavouriteGames() {
      var _this7 = this;

      var uid = (0, _helper.parseQueryString)(this.props.location.search)["uid"] || this.props.access.uid;
      _axios2.default.get(vars.BASE_URL + "/getFavorites?uid=" + uid).then(function (response) {
        if (response.data.success) {
          _this7.props.getFavouriteGames(response.data);
        }
      }).catch(function (error) {
        console.log("error in getting favs!!", error);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var uid = (0, _helper.getParameters)("uid");
      var pathname = this.props.location.pathname;

      if (_productCondition.isFunzarena && !uid.exist && !(0, _publicURL.isPublicRoute)(pathname)) {
        this.props.history.push("/login");
      }
      if (this.props.search.searchText != "") {
        return _react2.default.createElement(_SearchPage2.default, {
          goToPage: this.goToPage,
          path: this.props.location.pathname
        });
      } else {
        if (this.state.loading) {
          return _react2.default.createElement(
            "div",
            { className: "activity-indicator" },
            " ",
            _react2.default.createElement("img", {
              className: _isGamiclub.isGamiclub ? "icon-loader-gamiclub" : "icon-loader",
              src: _isGamiclub.isGamiclub ? "./img/ball-triangle.svg" : "./img/g-icon.svg",
              alt: "Loading..."
            })
          );
        } else {
          return _react2.default.createElement(
            "main",
            { className: "home main" },
            _react2.default.createElement(_FlashMessage2.default, { path: this.props.location.pathname }),
            _react2.default.createElement(
              _reactstrap.Container,
              null,
              _react2.default.createElement(
                _reactRouterDom.Switch,
                null,
                _react2.default.createElement(_reactRouterDom.Route, { path: "/domain", name: "Domain", component: _Domain2.default }),
                _react2.default.createElement(_reactRouterDom.Route, { path: "/country", name: "Country", component: _Country2.default }),
                _react2.default.createElement(_reactRouterDom.Route, {
                  path: "/manage-country",
                  name: "AddCountryLanguage",
                  component: _AddCountryLanguage2.default
                }),
                _react2.default.createElement(_reactRouterDom.Route, { path: "/manage-user", name: "Users", component: _Users2.default }),
                _react2.default.createElement(_reactRouterDom.Route, {
                  path: "/manage-categories",
                  name: "ManageCategories",
                  component: _ManageCategories2.default
                }),
                _react2.default.createElement(_reactRouterDom.Route, { path: "/uploads", name: "Uploads", component: _Uploads2.default })
              )
            ),
            _react2.default.createElement(
              _reactRouterDom.Switch,
              null,
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/category/:categoryId",
                name: "GameList",
                component: _GameList2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/detail/:gameId",
                name: "GameDetail",
                component: _GameDetail2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/play-maxis/:gameId",
                name: "GameDetailDemo",
                component: _GameDetailDemo2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/favorites", name: "Favorites", component: _Favorites2.default }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/search", name: "SearchPage", component: _SearchPage2.default }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/terms-conditions", name: "Terms", component: _Terms2.default }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/privacy-policy",
                name: "PrivacyPolicy",
                component: _domainConfig.config.subDomain === "es" && !_isGamiclub.isGamiclub ? _NewPrivacyPolicy2.default : _PrivacyPolicy2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/privacy-policy-no",
                name: "PrivacyPolicyNo",
                component: _PrivacyPolicyNo2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/abo-verwaltung",
                name: "AboVerwaltung",
                component: _AboVerwaltung2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/subscription-maxis",
                name: "AGB",
                component: _SubscriptionPageMaxis2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/agb", name: "AGB", component: _AGB2.default }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/hilfe", name: "Hilfe", component: _Hilfe2.default }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/impressum", name: "Impressum", component: _Impressum2.default }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/maxis-welcome",
                name: "DemoMaxisWelcome",
                component: _DemoMaxisWelcome2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/demo-maxis", name: "DemoPage", component: _DemoPage2.default }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/home", name: "HomePage", component: _HomePage2.default }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/account", name: "MyAccount", component: _Account2.default }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/twoStepLogin",
                name: "TwoStepLogin",
                component: _TwoStepLogin2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "/faq", name: "faq", component: _Faq2.default }),
              _react2.default.createElement(_reactRouterDom.Route, {
                path: "/contact-us",
                name: "ContactUs",
                component: _ContactUs2.default
              }),
              _react2.default.createElement(_reactRouterDom.Route, { path: "*", component: _Login2.default })
            )
          );
        }
      }
    }
  }]);

  return Home;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.AuthenticationReducer,
    access: state.WelcomeReducer,
    loader: state.ActivityIndicatorReducer,
    domains: state.DomainReducer,
    country: state.CountryReducer,
    users: state.UsersReducer,
    search: state.SearchReducer,
    account: state.AccountReducer,
    categories: state.CategoryReducer,
    games: state.GamesReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    checkAccess: _WelcomeActions.checkAccess,
    addUid: _WelcomeActions.addUid,
    getDetails: _AccountActions.getDetails,
    getInterests: _AccountActions.getInterests,
    getGames: _GamesActions.getGames,
    getCategories: _CategoryActions.getCategories,
    getFavouriteGames: _GamesActions.getFavouriteGames,
    setFavouriteGames: _GamesActions.setFavouriteGames
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);

/***/ }),

/***/ "./src/containers/Page404.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Page404 = function (_Component) {
    _inherits(Page404, _Component);

    function Page404() {
        _classCallCheck(this, Page404);

        return _possibleConstructorReturn(this, (Page404.__proto__ || Object.getPrototypeOf(Page404)).apply(this, arguments));
    }

    _createClass(Page404, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactstrap.Container,
                { className: 'page-404' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    { className: 'justify-content-center' },
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { md: '6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'clearfix' },
                            _react2.default.createElement(
                                'h1',
                                { className: 'float-left display-3 mr-4 white-text-color' },
                                '404'
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'pt-3 golden-text-color' },
                                'Oops! You\'re lost.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'text-muted float-left' },
                                'The page you are looking for was not found.'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Page404;
}(_react.Component);

exports.default = Page404;

/***/ }),

/***/ "./src/containers/Page500.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Page500 = function (_Component) {
    _inherits(Page500, _Component);

    function Page500() {
        _classCallCheck(this, Page500);

        return _possibleConstructorReturn(this, (Page500.__proto__ || Object.getPrototypeOf(Page500)).apply(this, arguments));
    }

    _createClass(Page500, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactstrap.Container,
                { className: 'page-500' },
                _react2.default.createElement(
                    _reactstrap.Row,
                    { className: 'justify-content-center' },
                    _react2.default.createElement(
                        _reactstrap.Col,
                        { md: '6' },
                        _react2.default.createElement(
                            'span',
                            { className: 'clearfix' },
                            _react2.default.createElement(
                                'h1',
                                { className: 'float-left display-3 mr-4 white-text-color' },
                                '500'
                            ),
                            _react2.default.createElement(
                                'h4',
                                { className: 'pt-3 golden-text-color' },
                                'Houston, we have a problem!'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'text-muted float-left' },
                                'The page you are looking for is temporarily unavailable.'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Page500;
}(_react.Component);

exports.default = Page500;

/***/ }),

/***/ "./src/containers/Welcome.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _axios = __webpack_require__("./node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _isIos = __webpack_require__("./node_modules/is-ios/index.js");

var _isIos2 = _interopRequireDefault(_isIos);

var _reactstrap = __webpack_require__("./node_modules/reactstrap/dist/reactstrap.es.js");

var _Banner = __webpack_require__("./src/components/Banner/Banner.js");

var _Banner2 = _interopRequireDefault(_Banner);

var _variables = __webpack_require__("./src/constants/variables.js");

var vars = _interopRequireWildcard(_variables);

var _HeaderActions = __webpack_require__("./src/actions/HeaderActions.js");

var _AccountActions = __webpack_require__("./src/actions/AccountActions.js");

var _ActivityIndicatorActions = __webpack_require__("./src/actions/ActivityIndicatorActions.js");

var _WelcomeActions = __webpack_require__("./src/actions/WelcomeActions.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _reactRouter = __webpack_require__("./node_modules/react-router/es/index.js");

var _sendData = __webpack_require__("./src/analytics/sendData.js");

var _isGamiclub = __webpack_require__("./src/constants/isGamiclub.js");

var _isOnlyMobbfun = __webpack_require__("./src/constants/isOnlyMobbfun.js");

var _productCondition = __webpack_require__("./src/constants/productCondition.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arabicDomain = _domainConfig.config.lang == "ar" ? true : false;
var kazakhDomain = _domainConfig.config.lang == "kk" ? true : false;
var frenchDomain = _domainConfig.config.lang == "fr" ? true : false;
var swedishDomain = _domainConfig.config.lang == "sv" ? true : false;
var norwayhDomain = _domainConfig.config.lang == "no" ? true : false;
var zaDomain = _domainConfig.config.country == "za" ? true : false;
var asiacellDomain = _domainConfig.config.subDomain == "iq" || _domainConfig.config.subDomain == "asiacell" ? true : false;
var vietnamDomain = _domainConfig.config.country == "vn" ? true : false;
var turkeyDomain = _domainConfig.config.lang == "tr" ? true : false;
var spanishDomain = _domainConfig.config.lang == "es" ? true : false;

var Welcome = function (_Component) {
  _inherits(Welcome, _Component);

  function Welcome(props) {
    _classCallCheck(this, Welcome);

    var _this = _possibleConstructorReturn(this, (Welcome.__proto__ || Object.getPrototypeOf(Welcome)).call(this, props));

    _this.state = {
      dataSent: false
    };
    return _this;
  }

  _createClass(Welcome, [{
    key: "componentWillMount",
    value: function componentWillMount() {}
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add("welcome-page-body");
      this.props.setHeaderTitle("!Más de 300 juegos html5 online!");
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _sendData.sendData)("", "", "", "viewed", { page: "homepage" });
      document.body.classList.remove("welcome-page-body");
    }
    // redirect(){
    //     if (config.subDomain == 'mase' || config.subDomain == 'th'){
    //         setTimeout(() => {
    //             this.props.history.push(appendUid('/home/html', this.props.access.uid));
    //         }, 1000);
    //     }
    // }

  }, {
    key: "render",
    value: function render() {
      var androidBtnStyle = {};
      if (asiacellDomain && !_isGamiclub.isGamiclub) {
        androidBtnStyle = {
          margin: "0 auto"
        };
      }
      var banner = [{
        imgUrl: "./img/stunt-driver-banner.jpg",
        offer: "Editors Choice",
        game_name: "Stunt Driver",
        category_name: "Racing Game"
      }, {
        imgUrl: "./img/stund-driver.jpg",
        offer: "Editors Choice",
        game_name: "Clan Attack",
        category_name: "Action Game"
      }];
      if (_isGamiclub.isGamiclub) {
        banner = [{
          imgUrl: "./img/Welcome-Page.png",
          offer: "",
          game_name: "",
          category_name: ""
        }];
      } else if (_domainConfig.config.lang == "ar") {
        banner[0].offer = "اختيار المحرر";
        banner[0].game_name = "السائق العنيد";
        banner[0].category_name = "لعبة السباق";
      } else if (_domainConfig.config.lang == "cy") {
        banner[0].offer = "ИЗБОР УРЕДНИКА";
        banner[1].offer = "ИЗБОР УРЕДНИКА";
        banner[0].game_name = "STUNT DRIVER";
        banner[0].category_name = "ТРКАЧКА ИГРА";
      } else if (_domainConfig.config.lang == "kk") {
        banner[0].offer = "Выбор редакции";
        banner[0].game_name = "Каскадер";
        banner[0].category_name = "Гонки";
      } else if (_domainConfig.config.lang == "fr") {
        banner[0].offer = "CHOIX DES RÉDACTEURS";
        banner[0].game_name = "CASCADEUR";
        banner[0].category_name = "Jeu de course";
      } else if (_domainConfig.config.lang == "sv") {
        banner[0].offer = "REDAKTÖRENS VAL";
        banner[0].game_name = "STUNTFÖRARE";
        banner[0].category_name = "Racingspel";
      } else if (_domainConfig.config.lang == "no") {
        banner[0].offer = "REDAKTØRENS VALG";
        banner[0].game_name = "STUNT DRIVER";
        banner[0].category_name = "Racing-spill";
      } else if (_domainConfig.config.country == "za") {
        banner[0].imgUrl = "./img/cricket-za.png";
        banner[0].offer = "";
        banner[0].game_name = "CRICKET BATTER";
        banner[0].category_name = "Sports Game";
      } else if (_domainConfig.config.country == "vn") {
        banner[0].offer = "Sự lựa chọn hàng đầu";
        banner[0].game_name = "STUNT DRIVER";
        banner[0].category_name = "Game đua xe";
      } else if (_domainConfig.config.lang == "tr") {
        banner[0].offer = "Editör’ün seçimi";
        banner[0].game_name = "STUNT DRIVER";
        banner[0].category_name = "Yarış oyunu";

        banner[1].offer = "Editör’ün seçimi";
        banner[1].game_name = "CLAN ATTACK";
        banner[1].category_name = "Macera oyunu";
      } else if (_domainConfig.config.lang == "es") {
        banner[0].offer = "ELECCIÓN DEL EDITOR";
        banner[0].game_name = "CONDUCTOR DOBLE DE ACCIÓN";
        banner[0].category_name = "Juego de carreras";

        banner[1].offer = "ELECCIÓN DEL EDITOR";
        banner[1].game_name = "CLAN ATTACK";
        banner[1].category_name = "Juego Acción";
      } else if (_domainConfig.config.lang == "it") {
        banner[0].offer = "SCELTI DALL EDITORE";
        banner[0].game_name = "STUNT DRIVER";
        banner[0].category_name = "GIOCO DI CORSE";

        banner[1].offer = "SCELTI DALL EDITORE";
        banner[1].game_name = "CLAN ATTACK";
        banner[1].category_name = "GIOCO DI AZIONE";
      } else if (_domainConfig.config.lang == "el") {
        banner[0].offer = "ΕΠΙΛΟΓΗ ΠΡΟΣΩΠΙΚΟΥ Staff Choice";
        banner[1].offer = "ΕΠΙΛΟΓΗ ΠΡΟΣΩΠΙΚΟΥ Staff Choice";
      }
      var blackFridayBanner = {
        imgUrl: "./img/Swing_robber_R2.jpg",
        offer: "",
        game_name: "",
        category_name: "",
        id: 159
        // id:31
      };
      if (_domainConfig.config.subDomain == "idsale" || _domainConfig.config.subDomain === "gmn") {
        banner = [blackFridayBanner];
        if (window.innerWidth < 768) banner[0].imgUrl = "./img/swing_robber.jpg";
      }

      return _react2.default.createElement(
        "div",
        null,
        !_isGamiclub.isGamiclub && _domainConfig.config.subDomain == "no" || _isGamiclub.isGamiclub && _domainConfig.config.subDomain == "ch" ? _react2.default.createElement(
          "button",
          {
            onClick: function onClick(e) {
              (0, _sendData.sendData)("", "", "", "WA chat clicked");
              window.open("https://wa.me/12028528006?text=Hello");
            },
            className: "whatsapp-button"
          },
          " ",
          _react2.default.createElement("img", { className: "whatsapp-img", src: "./img/whatsapp.png" }),
          " "
        ) : null,
        _react2.default.createElement(
          "div",
          { className: "welcome-page" },
          _react2.default.createElement(_Banner2.default, { bannerData: banner }),
          _react2.default.createElement(
            "div",
            { className: "category-options-wrap" },
            _react2.default.createElement(
              "div",
              { className: "category-options-inner" },
              _react2.default.createElement(
                _reactstrap.Row,
                { className: "justify-content-center" },
                _react2.default.createElement(
                  _reactstrap.Col,
                  { xs: "12" },
                  _react2.default.createElement(
                    "h6",
                    { className: "explore-text white-text-color" },
                    _isGamiclub.isGamiclub ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "welcome.text.gamiclub",
                      defaultMessage: "EXPLORE THE BEST CONTENT ONLINE TODAY!"
                    }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: "welcome.text",
                      defaultMessage: "EXPLORE THE BEST MOBILE GAMES ONLINE TODAY!"
                    })
                  ),
                  _domainConfig.config.subDomain === "es" && screen.width <= 768 && _react2.default.createElement(
                    "h6",
                    { className: "explore-text white-text-color" },
                    "!M\xE1s de 300 juegos html5 online!"
                  )
                )
              ),
              _react2.default.createElement(
                _reactstrap.Row,
                { className: "justify-content-center" },
                _react2.default.createElement(
                  _reactstrap.Col,
                  null,
                  _react2.default.createElement(
                    "div",
                    {
                      className: "buttons-wrap " + (_domainConfig.config.subDomain === "pe" ? "buttons-wrap-order" : "")
                    },
                    _react2.default.createElement(
                      "div",
                      {
                        className: "games-btn " + (_productCondition.isGameflares ? "games-btn-gameflares-bg" : _domainConfig.config.subDomain === "pe" ? "pe-games-btn" : "")
                      },
                      _react2.default.createElement(
                        "a",
                        { href: (0, _helper.appendUid)("#/home/html", this.props.access.uid) },
                        _isGamiclub.isGamiclub || _productCondition.isGameflares || _productCondition.isGamiway ? _react2.default.createElement("i", {
                          className: "fa fa-html5 " + (_productCondition.isGameflares ? "fa-gradient-gameflares" : _productCondition.isGamiway ? "fa-gradient-gamiway" : "fa-gradient-gamiclub"),
                          "aria-hidden": "true"
                        }) : _react2.default.createElement("img", {
                          src: "./img/icons/html5.svg",
                          style: { width: "36px" },
                          alt: "HTML5 Games"
                        }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "html5", defaultMessage: "HTML5" }),
                          _react2.default.createElement(
                            "span",
                            {
                              style: _isGamiclub.isGamiclub ? { color: "lightgreen" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                              className: "games-text"
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "games",
                              defaultMessage: "games"
                            })
                          )
                        )
                      )
                    ),
                    _domainConfig.config.subDomain === "pe" && window.location.hostname.includes("game-lords.com") ? _react2.default.createElement(
                      "div",
                      { className: "games-btn pe-games-btn" },
                      _react2.default.createElement(
                        "a",
                        { href: "https://pe-gamelord.striker-live.com/?uid=fdf098fcc6" },
                        _react2.default.createElement("img", { src: "./img/wc_logo_transparent.png", style: { width: "36px" }, alt: "Football Live Score" }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text world-cup-btn" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: "football-live-score-upper", defaultMessage: "Football Live Score" }),
                          _react2.default.createElement(
                            "span",
                            { className: "games-text" },
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "games", defaultMessage: "games" })
                          )
                        )
                      )
                    ) : null,
                    _domainConfig.config.subDomain === "maae" || _domainConfig.config.subDomain === "za" && _isIos2.default || _domainConfig.config.subDomain === "my" && window.location.hostname.includes("gamiclub.online") || _domainConfig.config.subDomain === "ae" && window.location.hostname.includes("game-lords.com") ? null : _react2.default.createElement(
                      "div",
                      {
                        className: "games-btn " + (_productCondition.isGameflares ? "games-btn-gameflares-bg" : _domainConfig.config.subDomain === "pe" ? "pe-games-btn" : ""),
                        style: androidBtnStyle
                      },
                      _react2.default.createElement(
                        "a",
                        {
                          href: (0, _helper.appendUid)("#/home/android", this.props.access.uid)
                        },
                        _isGamiclub.isGamiclub || _productCondition.isGameflares || _productCondition.isGamiway ? _react2.default.createElement("i", {
                          className: "fa fa-html5 " + (_productCondition.isGameflares ? "fa-gradient-gameflares" : _productCondition.isGamiway ? "fa-gradient-gamiway" : "fa-gradient-gamiclub"),
                          "aria-hidden": "true"
                        }) : _react2.default.createElement("img", {
                          src: "./img/icons/android.svg",
                          style: { width: "36px" },
                          alt: "Android Games"
                        }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "android-upper",
                            defaultMessage: "ANDROID"
                          }),
                          _react2.default.createElement(
                            "span",
                            {
                              style: _isGamiclub.isGamiclub ? { color: "lightgreen" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                              className: "games-text"
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "games",
                              defaultMessage: "games"
                            })
                          )
                        )
                      )
                    ),
                    _isGamiclub.isGamiclub && !(_isOnlyMobbfun.isOnlyMobbfun && _domainConfig.config.subDomain === "id") || _domainConfig.config.subDomain === "za" || _domainConfig.config.subDomain === "kw" || _domainConfig.config.subDomain === "pt" || _domainConfig.config.subDomain === "id" && _productCondition.isGamiway ? _react2.default.createElement(
                      "div",
                      { className: "games-btn" },
                      _react2.default.createElement(
                        "a",
                        {
                          href: (0, _helper.appendUid)("#/home/video", this.props.access.uid)
                        },
                        _react2.default.createElement("i", {
                          className: "fa fa-video-camera fa-gradient-gamiclub",
                          "aria-hidden": "true",
                          style: _productCondition.isGamiway ? { color: "#b347a0" } : !_isGamiclub.isGamiclub ? { color: "#f3ab1b" } : _productCondition.isGameflares ? { color: "#FF394B" } : null
                        }),
                        _react2.default.createElement(
                          "span",
                          { className: "btn-text" },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "videos",
                            defaultMessage: "VIDEOS"
                          }),
                          _react2.default.createElement(
                            "span",
                            {
                              style: _isGamiclub.isGamiclub ? { color: "lightgreen" } : _productCondition.isGameflares ? { color: "#FF394B" } : _productCondition.isGamiway ? { color: "#b347a0" } : null,
                              className: "games-text"
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: "vid-player",
                              defaultMessage: "player"
                            })
                          )
                        )
                      )
                    ) : null
                  )
                )
              ),
              _react2.default.createElement(
                _reactstrap.Row,
                { className: "justify-content-center" },
                _react2.default.createElement(
                  _reactstrap.Col,
                  { xs: "12" },
                  _react2.default.createElement(
                    "h6",
                    { className: "white-text-color kazakh-text" },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: "kazakhOnly", defaultMessage: " " })
                  )
                )
              ),
              window.location.hostname.includes("funzarena") && _react2.default.createElement(
                "h6",
                { className: "white-text-color kazakh-text" },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: "funzarena_text",
                  defaultMessage: "You do not have access. Send a text message with the word GAME to 92505\r\n(cost: PLN 30.75)"
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Welcome;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    access: state.WelcomeReducer,
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    show: _ActivityIndicatorActions.show,
    hide: _ActivityIndicatorActions.hide,
    checkAccess: _WelcomeActions.checkAccess,
    getDetails: _AccountActions.getDetails,
    getInterests: _AccountActions.getInterests,
    setHeaderTitle: _HeaderActions.setHeaderTitle
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Welcome);

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reduxPromise = __webpack_require__("./node_modules/redux-promise/lib/index.js");

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

__webpack_require__("./node_modules/font-awesome/css/font-awesome.min.css");

__webpack_require__("./node_modules/simple-line-icons/css/simple-line-icons.css");

__webpack_require__("./scss/core/_dropdown-menu-right.scss");

__webpack_require__("./node_modules/react-id-swiper/src/styles/scss/swiper.scss");

__webpack_require__("./node_modules/swiper/dist/css/swiper.min.css");

__webpack_require__("./node_modules/react-responsive-carousel/lib/styles/carousel.min.css");

__webpack_require__("./scss/style.scss");

var _App = __webpack_require__("./src/containers/App.js");

var _App2 = _interopRequireDefault(_App);

var _reducers = __webpack_require__("./src/reducers/index.js");

var _reducers2 = _interopRequireDefault(_reducers);

var _helper = __webpack_require__("./src/utils/helper.js");

var _en = __webpack_require__("./node_modules/react-intl/locale-data/en.js");

var _en2 = _interopRequireDefault(_en);

var _ar = __webpack_require__("./node_modules/react-intl/locale-data/ar.js");

var _ar2 = _interopRequireDefault(_ar);

var _kk = __webpack_require__("./node_modules/react-intl/locale-data/kk.js");

var _kk2 = _interopRequireDefault(_kk);

var _fr = __webpack_require__("./node_modules/react-intl/locale-data/fr.js");

var _fr2 = _interopRequireDefault(_fr);

var _sv = __webpack_require__("./node_modules/react-intl/locale-data/sv.js");

var _sv2 = _interopRequireDefault(_sv);

var _be = __webpack_require__("./node_modules/react-intl/locale-data/be.js");

var _be2 = _interopRequireDefault(_be);

var _no = __webpack_require__("./node_modules/react-intl/locale-data/no.js");

var _no2 = _interopRequireDefault(_no);

var _vi = __webpack_require__("./node_modules/react-intl/locale-data/vi.js");

var _vi2 = _interopRequireDefault(_vi);

var _tr = __webpack_require__("./node_modules/react-intl/locale-data/tr.js");

var _tr2 = _interopRequireDefault(_tr);

var _es = __webpack_require__("./node_modules/react-intl/locale-data/es.js");

var _es2 = _interopRequireDefault(_es);

var _it = __webpack_require__("./node_modules/react-intl/locale-data/it.js");

var _it2 = _interopRequireDefault(_it);

var _cy = __webpack_require__("./node_modules/react-intl/locale-data/cy.js");

var _cy2 = _interopRequireDefault(_cy);

var _de = __webpack_require__("./node_modules/react-intl/locale-data/de.js");

var _de2 = _interopRequireDefault(_de);

var _el = __webpack_require__("./node_modules/react-intl/locale-data/el.js");

var _el2 = _interopRequireDefault(_el);

var _ro = __webpack_require__("./node_modules/react-intl/locale-data/ro.js");

var _ro2 = _interopRequireDefault(_ro);

var _cs = __webpack_require__("./node_modules/react-intl/locale-data/cs.js");

var _cs2 = _interopRequireDefault(_cs);

var _pt = __webpack_require__("./node_modules/react-intl/locale-data/pt.js");

var _pt2 = _interopRequireDefault(_pt);

var _lt = __webpack_require__("./node_modules/react-intl/locale-data/lt.js");

var _lt2 = _interopRequireDefault(_lt);

var _si = __webpack_require__("./node_modules/react-intl/locale-data/si.js");

var _si2 = _interopRequireDefault(_si);

var _pl = __webpack_require__("./node_modules/react-intl/locale-data/pl.js");

var _pl2 = _interopRequireDefault(_pl);

var _bg = __webpack_require__("./node_modules/react-intl/locale-data/bg.js");

var _bg2 = _interopRequireDefault(_bg);

var _th = __webpack_require__("./node_modules/react-intl/locale-data/th.js");

var _th2 = _interopRequireDefault(_th);

var _ar3 = __webpack_require__("./src/translations/ar.json");

var _ar4 = _interopRequireDefault(_ar3);

var _en3 = __webpack_require__("./src/translations/en.json");

var _en4 = _interopRequireDefault(_en3);

var _kk3 = __webpack_require__("./src/translations/kk.json");

var _kk4 = _interopRequireDefault(_kk3);

var _fr3 = __webpack_require__("./src/translations/fr.json");

var _fr4 = _interopRequireDefault(_fr3);

var _sv3 = __webpack_require__("./src/translations/sv.json");

var _sv4 = _interopRequireDefault(_sv3);

var _be3 = __webpack_require__("./src/translations/be.json");

var _be4 = _interopRequireDefault(_be3);

var _no3 = __webpack_require__("./src/translations/no.json");

var _no4 = _interopRequireDefault(_no3);

var _vi3 = __webpack_require__("./src/translations/vi.json");

var _vi4 = _interopRequireDefault(_vi3);

var _tr3 = __webpack_require__("./src/translations/tr.json");

var _tr4 = _interopRequireDefault(_tr3);

var _es3 = __webpack_require__("./src/translations/es.json");

var _es4 = _interopRequireDefault(_es3);

var _it3 = __webpack_require__("./src/translations/it.json");

var _it4 = _interopRequireDefault(_it3);

var _cy3 = __webpack_require__("./src/translations/cy.json");

var _cy4 = _interopRequireDefault(_cy3);

var _de3 = __webpack_require__("./src/translations/de.json");

var _de4 = _interopRequireDefault(_de3);

var _el3 = __webpack_require__("./src/translations/el.json");

var _el4 = _interopRequireDefault(_el3);

var _ro3 = __webpack_require__("./src/translations/ro.json");

var _ro4 = _interopRequireDefault(_ro3);

var _cz = __webpack_require__("./src/translations/cz.json");

var _cz2 = _interopRequireDefault(_cz);

var _pt3 = __webpack_require__("./src/translations/pt.json");

var _pt4 = _interopRequireDefault(_pt3);

var _lt3 = __webpack_require__("./src/translations/lt.json");

var _lt4 = _interopRequireDefault(_lt3);

var _si3 = __webpack_require__("./src/translations/si.json");

var _si4 = _interopRequireDefault(_si3);

var _pl3 = __webpack_require__("./src/translations/pl.json");

var _pl4 = _interopRequireDefault(_pl3);

var _bg3 = __webpack_require__("./src/translations/bg.json");

var _bg4 = _interopRequireDefault(_bg3);

var _th3 = __webpack_require__("./src/translations/th.json");

var _th4 = _interopRequireDefault(_th3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Styles
// Import Font Awesome Icons Set

// Import Simple Line Icons Set

// Temp fix for reactstrap

// Import Swiper css

// Import Main styles for this application

// Views


//localisation


(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default), _toConsumableArray(_ar2.default), _toConsumableArray(_kk2.default), _toConsumableArray(_fr2.default), _toConsumableArray(_sv2.default), _toConsumableArray(_be2.default), _toConsumableArray(_no2.default), _toConsumableArray(_vi2.default), _toConsumableArray(_tr2.default), _toConsumableArray(_es2.default), _toConsumableArray(_it2.default), _toConsumableArray(_cy2.default), _toConsumableArray(_de2.default), _toConsumableArray(_el2.default), _toConsumableArray(_ro2.default), _toConsumableArray(_cs2.default), _toConsumableArray(_pt2.default), _toConsumableArray(_lt2.default), _toConsumableArray(_si2.default), _toConsumableArray(_pl2.default), _toConsumableArray(_bg2.default), _toConsumableArray(_th2.default)));

var messages = {
    'ar': _ar4.default,
    'en': _en4.default,
    'kk': _kk4.default,
    'fr': _fr4.default,
    'sv': _sv4.default,
    'be': _be4.default,
    'no': _no4.default,
    'vi': _vi4.default,
    'tr': _tr4.default,
    'es': _es4.default,
    'it': _it4.default,
    'cy': _cy4.default,
    'de': _de4.default,
    'el': _el4.default,
    'ro': _ro4.default,
    'cs': _cz2.default,
    'pt': _pt4.default,
    'lt': _lt4.default,
    'si': _si4.default,
    'pl': _pl4.default,
    'bg': _bg4.default,
    'th': _th4.default
};

var language = _domainConfig.config.lang;
var persistedState = typeof sessionStorage.getItem('reduxStore') != "undefined" ? JSON.parse(sessionStorage.getItem('reduxStore')) : null;
var connectWithReduxMiddleWare = (0, _redux.applyMiddleware)(_reduxPromise2.default)(_redux.createStore);
var store = persistedState != null ? connectWithReduxMiddleWare(_reducers2.default, persistedState) : connectWithReduxMiddleWare(_reducers2.default);
// const store = connectWithReduxMiddleWare(RootReducer);
store.subscribe(function () {
    sessionStorage.setItem('reduxStore', JSON.stringify(store.getState()));
});

var LangWrapper = function (_Component) {
    _inherits(LangWrapper, _Component);

    function LangWrapper() {
        _classCallCheck(this, LangWrapper);

        return _possibleConstructorReturn(this, (LangWrapper.__proto__ || Object.getPrototypeOf(LangWrapper)).apply(this, arguments));
    }

    _createClass(LangWrapper, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var h = document.querySelector("html");
            if (_domainConfig.config.lang === 'be') h.setAttribute("lang", "nl");else h.setAttribute("lang", _domainConfig.config.lang);
            if (_domainConfig.config.subDomain === 'eg') {
                var lang = (0, _helper.getParameters)("lang");
                if (lang.exist && lang.value === "en") _domainConfig.config.lang = "en";
                h.setAttribute("lang", "en");
            }
        }
    }, {
        key: 'changeLang',
        value: function changeLang(event) {
            var h = document.querySelector("html");
            if (_domainConfig.config.subDomain === 'dz') {
                if (event === 'fr') {
                    _domainConfig.config.lang = 'fr';
                    h.setAttribute("lang", "fr");
                }
                if (event === 'ar') {
                    _domainConfig.config.lang = 'ar';
                    h.setAttribute("lang", "ar");
                }
            }
            if (_domainConfig.config.subDomain === 'eg') {
                if (event === 'en') {
                    _domainConfig.config.lang = 'en';
                    h.setAttribute("lang", "en");
                }
                if (event === 'ar') {
                    _domainConfig.config.lang = 'ar';
                    h.setAttribute("lang", "ar");
                }
            }
            if (_domainConfig.config.subDomain === 'ch') {
                if (event === 'de') {
                    _domainConfig.config.lang = 'de';
                    h.setAttribute("lang", "de");
                }
                if (event === 'fr') {
                    _domainConfig.config.lang = 'fr';
                    h.setAttribute("lang", "fr");
                }
                if (event === 'it') {
                    _domainConfig.config.lang = 'it';
                    h.setAttribute("lang", "it");
                }
                if (event === 'en') {
                    _domainConfig.config.lang = 'en';
                    h.setAttribute("lang", "en");
                }
            }
            if (_domainConfig.config.subDomain === 'pl') {
                if (event === 'pl') {
                    _domainConfig.config.lang = 'pl';
                    h.setAttribute("lang", "pl");
                }
                if (event === 'en') {
                    _domainConfig.config.lang = 'en';
                    h.setAttribute("lang", "en");
                }
            }
            if (_domainConfig.config.subDomain === 'be') {
                if (event === 'de') {
                    _domainConfig.config.lang = 'de';
                    h.setAttribute("lang", "de");
                }
                if (event === 'fr') {
                    _domainConfig.config.lang = 'fr';
                    h.setAttribute("lang", "fr");
                }
                if (event === 'be') {
                    _domainConfig.config.lang = 'be';
                    h.setAttribute("lang", "nl");
                }
            }
            this.setState({});
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactIntl.IntlProvider,
                { locale: _domainConfig.config.lang, messages: messages[_domainConfig.config.lang] },
                _react2.default.createElement(
                    _reactRouterDom.HashRouter,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Switch,
                        null,
                        _react2.default.createElement(_App2.default, { changeLang: this.changeLang.bind(this), currentLang: _domainConfig.config.lang })
                    )
                )
            );
        }
    }]);

    return LangWrapper;
}(_react.Component);

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(LangWrapper, null)
), document.getElementById('root'));

/***/ }),

/***/ "./src/reducers/AccountReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    user: {},
    interests: []
};

var AccountReducer = exports.AccountReducer = function AccountReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case action_types.GET_DETAILS:
            return _extends({}, state, {
                user: action.data.user
            });
        case action_types.SET_DETAILS:
            return _extends({}, state, {
                user: action.data.user
            });
        case action_types.GET_INTERESTS:
            return _extends({}, state, {
                interests: action.data.interests
            });
        case action_types.SET_PROFILE_PIC:
            return _extends({}, state, {
                user: _extends({}, state.user, {
                    profilePic: action.data.profilePic
                })
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/ActivityIndicatorReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActivityIndicatorReducer = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    isLoading: false
};

var ActivityIndicatorReducer = exports.ActivityIndicatorReducer = function ActivityIndicatorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.IS_LOADING:
            return {
                isLoading: action.data.isLoading
            };
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/AuthenticationReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthenticationReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    isAuthenticated: false,
    currentUser: {},
    isAdmin: false
};

var AuthenticationReducer = exports.AuthenticationReducer = function AuthenticationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.LOGIN:
            return _extends({}, state, {
                isAuthenticated: action.data.success,
                currentUser: action.data.data,
                isAdmin: action.data.data && action.data.data.roleName == "superadmin" ? true : false
            });
        case _action_types.LOGOUT:
            return _extends({}, state, {
                isAuthenticated: false,
                currentUser: {},
                isAdmin: false
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/CategoryReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    gameType: [],
    category: [],
    categories: []
};

var CategoryReducer = exports.CategoryReducer = function CategoryReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.GET_GAME_TYPES:
            return _extends({}, state, {
                gameType: action.data.data
            });
        case _action_types.GET_CATEGORIES:
            return _extends({}, state, {
                categories: action.data.data
            });
        case _action_types.GET_CATEGORY_DETAIL:
            return _extends({}, state, {
                category: action.data
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/CountryReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CountryReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    countries: [],
    languages: [],
    countryDomain: [],
    countryManagement: {}
};

var CountryReducer = exports.CountryReducer = function CountryReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.GET_COUNTRIES:
            return _extends({}, state, {
                countries: action.data.data
            });
        case _action_types.GET_LANGUAGES:
            return _extends({}, state, {
                languages: action.data.data
            });
        case _action_types.GET_COUNTRIES_LANGUAGES_SUBDOMAIN:
            return _extends({}, state, {
                countryDomain: action.data.data
            });
        case _action_types.OPEN_COUNTRY_DETAILS:
            return _extends({}, state, {
                countryManagement: action.data
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/DomainReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DomainReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    domains: []

};

var DomainReducer = exports.DomainReducer = function DomainReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.GET_DOMAIN:
            return _extends({}, state, {
                domains: action.data.data
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/FlashMessageReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlashMessageReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    isShowing: false,
    message: '',
    type: true
};

var FlashMessageReducer = exports.FlashMessageReducer = function FlashMessageReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case action_types.SHOW_MESSAGE:
            return _extends({}, state, {
                isShowing: action.data.isShowing,
                message: action.data.message,
                type: action.data.type
            });
        case action_types.HIDE_MESSAGE:
            return _extends({}, state, {
                isShowing: action.data.isShowing
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/GamesReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GamesReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    games: [],
    gameDetail: [],
    similarGames: [],
    favoriteGames: [],
    searchedGames: [],
    categoryGames: []
};

var GamesReducer = exports.GamesReducer = function GamesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.GET_GAMES:
            return _extends({}, state, {
                games: action.data.data
            });
        case _action_types.GET_GAME_DETAIL:

            return _extends({}, state, {
                gameDetail: action.data
            });
        case _action_types.GET_SIMILAR_GAMES:
            return _extends({}, state, {
                similarGames: action.data
            });
        case _action_types.GET_SEARCHED_GAMES:
            return _extends({}, state, {
                searchedGames: action.data.data
            });
        case _action_types.GET_FAVOURITE_GAMES:
            return _extends({}, state, {
                favoriteGames: action.data.data
            });
        case _action_types.CATEGORY_GAMES:
            return _extends({}, state, {
                categoryGames: action.data.data
            });

        case _action_types.SET_FAVOURITE_GAME:
            (0, _helper.console_log)(action.data);
            return _extends({}, state, {
                games: action.data.games,
                favoriteGames: action.data.favoriteGames
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/HeaderReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeaderReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    title: '',
    flagForBack: false,
    showSearchBar: false
};

var HeaderReducer = exports.HeaderReducer = function HeaderReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case action_types.SET_HEADER_TITLE:
            return _extends({}, state, {
                title: action.data.title
            });
        // case action_types.ON_BACK_CLICK:
        //     return {
        //         ...state,
        //         flagForBack: action.data
        //     };
        // case action_types.RESET_BACK_CLICK:
        //     return {
        //         ...state,
        //         flagForBack: action.data
        //     };
        case action_types.SHOW_SEARCH:
            return _extends({}, state, {
                showSearchBar: action.data
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/SearchReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    searchText: ""
};

var SearchReducer = exports.SearchReducer = function SearchReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case action_types.SEARCH_TEXT:
            return _extends({}, state, {
                searchText: action.data.text
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/SplashScreenReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SplashScreenReducer = undefined;

var _action_types = __webpack_require__("./src/actions/action_types.js");

var action_types = _interopRequireWildcard(_action_types);

var _helper = __webpack_require__("./src/utils/helper.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    hideSplash: false
};

var SplashScreenReducer = exports.SplashScreenReducer = function SplashScreenReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case action_types.HIDE_SPLASH:
            return {
                hideSplash: action.data.hideSplash
            };
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/UsersReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UsersReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    roles: [],
    users: []
};

var UsersReducer = exports.UsersReducer = function UsersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.GET_ROLES:
            return _extends({}, state, {
                roles: action.data.data
            });
        case _action_types.GET_USERS:
            return _extends({}, state, {
                users: action.data.data
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/WelcomeReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WelcomeReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _action_types = __webpack_require__("./src/actions/action_types.js");

var _helper = __webpack_require__("./src/utils/helper.js");

var initialState = {
    hasAccess: false,
    uid: '',
    token: '',
    currentLang: ''
};

var WelcomeReducer = exports.WelcomeReducer = function WelcomeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _action_types.HAS_ACCESS:
            return _extends({}, state, {
                hasAccess: action.data.success,
                uid: action.data.uid,
                token: action.data.token,
                subscriptionData: action.data.subscriptionData
            });
        case _action_types.ADD_UID:
            return _extends({}, state, {
                uid: action.data.uid
            });
        case _action_types.CHANGE_LANGUAGE:
            return _extends({}, state, {
                currentLang: action.data
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _AuthenticationReducer = __webpack_require__("./src/reducers/AuthenticationReducer.js");

var _WelcomeReducer = __webpack_require__("./src/reducers/WelcomeReducer.js");

var _ActivityIndicatorReducer = __webpack_require__("./src/reducers/ActivityIndicatorReducer.js");

var _DomainReducer = __webpack_require__("./src/reducers/DomainReducer.js");

var _CountryReducer = __webpack_require__("./src/reducers/CountryReducer.js");

var _UsersReducer = __webpack_require__("./src/reducers/UsersReducer.js");

var _CategoryReducer = __webpack_require__("./src/reducers/CategoryReducer.js");

var _GamesReducer = __webpack_require__("./src/reducers/GamesReducer.js");

var _SplashScreenReducer = __webpack_require__("./src/reducers/SplashScreenReducer.js");

var _HeaderReducer = __webpack_require__("./src/reducers/HeaderReducer.js");

var _AccountReducer = __webpack_require__("./src/reducers/AccountReducer.js");

var _FlashMessageReducer = __webpack_require__("./src/reducers/FlashMessageReducer.js");

var _SearchReducer = __webpack_require__("./src/reducers/SearchReducer.js");

exports.default = (0, _redux.combineReducers)({
    AuthenticationReducer: _AuthenticationReducer.AuthenticationReducer,
    WelcomeReducer: _WelcomeReducer.WelcomeReducer,
    ActivityIndicatorReducer: _ActivityIndicatorReducer.ActivityIndicatorReducer,
    DomainReducer: _DomainReducer.DomainReducer,
    CountryReducer: _CountryReducer.CountryReducer,
    UsersReducer: _UsersReducer.UsersReducer,
    CategoryReducer: _CategoryReducer.CategoryReducer,
    GamesReducer: _GamesReducer.GamesReducer,
    SplashScreenReducer: _SplashScreenReducer.SplashScreenReducer,
    HeaderReducer: _HeaderReducer.HeaderReducer,
    AccountReducer: _AccountReducer.AccountReducer,
    FlashMessageReducer: _FlashMessageReducer.FlashMessageReducer,
    SearchReducer: _SearchReducer.SearchReducer
});

/***/ }),

/***/ "./src/translations/ar.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"العب واستمتع","sidebar.home":"الرئيسية","sidebar.myaccount":"حسابي","sidebar.notif":"الانذارات","sidebar.lang":"لغه","sidebar.lang.ar":"العربيه","sidebar.lang.fr":"French","sidebar.nonotif":"لا يوجد انذارات بعد","html5games":"ألعاب الاون لاين","androidGames":"ألعاب الاندرويد","favorite":"المفضله","welcome.text":"ألعب افضل الالعاب","welcome.text.gamiclub":"اكتشف أفضل محتوى عبر الإنترنت اليوم!","footer.copyright":"حقوق النشر محفوظة &copy;","accountDetails":"تفاصيل الحساب","accountName":"الاسم","accountEmail":"البريد الالكتروني","accountLocation":"المكان","accountInterests":"الاهتمام","accountChooseCategory":"اختر ٣ اصناف","accountEditPhoto":"تعديل الصورة","save":"حفظ","topCategories":"افضل الفئات","favGames":"العاب المفضّلة","viewAll":"اعرض الكل","noGameFound":" لا يوجد العاب ","cancel":"الغاء","gameDirectories":"موسوعه الالعاب","category":"فئة","noGamesFound":"لا يوجد العاب في هذه الفئة","platform":"برنامج","type":"نوع","games":"العاب","html5":"اون لاين","videos":"فيديو","vid-player":"لاعب","tnc":"البنود و الظروف","android-upper":"اندرويد","description":"وصف","downloadNow":"حمل الان","playNow":"العب الان","rate":"التقييم","relatedGames":"العاب مشابهة","noFavGames":"لا يوجد العاب مفضلّة","addFavGames":"اضف الالعاب للمفضلّة","discover":"اكتشف","noFavGamesFound":"لا يوجد العاب مفضلّة","favorites":"المفضله","accessDenied":"لا يمكنك الدخول","pageRestricted":"الصفحه غير متوفرة","privacyPolicy":"","kazakhOnly":"","areYouAlready":"هل انت عضو في ","thenConfirm":"من فضلك أكد رقم هاتفك وادخل عالم الالعاب","login":"تسجيل دخول","search.input.placeholder":"...ابحث","search.cancel.button":"الغي","Sports":"رياضة","Action":"اكشن","Adventure":"مغامرة","Fitness":"اللياقه البدنيه","Entertainment":"وسائل الترفيه","Premium Games":"العاب مميزه","RPG":"العاب ار بي جي","Virtual Reality":"الواقع الافتراضي","Arcade":"مغامرات","Racing":"سباق","privacy-policy-title":"سياسة خاصة","privacy-policy-desc":"تشرح سياسة الخصوصية هذه التزاماتنا وحقوقنا لمعلوماتك  يجب عليك قراءة سياسة الخصوصية بعناية. إذا كنت لا توافق على سياسة الخصوصية هذه ،يرجى عدم استخدام مواقعنا أو خدماتنا. سياسة الخصوصية مضمنة وموضوعية حسب الاقتضاء تحكم شروط الخدمة نفس الخدمات والمواقع كما هو مذكور في روط الخدمة. أي مصطلحات نستخدمها في سياسة الخصوصية الخاصة بنا دون تعريفها بنفس الشروط  التعريف كما هو الحال في شروط الخدمة. نجمع معلومات عن الطرق التالية:","privacy-policy-collect-info-head":"نجمع معلومات عن الطرق التالية:","privacy-policy-collect-info-desc1":"1. عندما تمنحها لنا أو تمنحنا إذنًا للحصول عليها إذا اخترت الاشتراك في خدمة ما من جانبنا ، سنقوم نحن أو مشغل شبكة المحمول الخاص بشبكتك بجمع معلوماتك المتعلقة بـ الدفع للاشتراك في خدماتنا. معلومات الحساب والفوترة التي تم جمعها بواسطة  مشغل المحمول يخضع لسياسات الخصوصية الخاصة بكل منها.","privacy-policy-collect-info-desc2":"2.  نحصل على معلومات فنية عند زيارة مواقعنا و / أو خدماتنا. قد نقوم بجمع معلومات فنية عنك كلما استخدمت خدماتنا. نقوم بجمع بيانات السجل في كل مرة تقوم فيها بتسجيل الدخول أو تسجيل الخروج من خدماتنا. كيف نستخدم المعلومات المجمعة ","privacy-policy-how-collect-info-head":"كيف نستخدم المعلومات المجمعة","privacy-policy-how-collect-info-subhead":"قد نستخدم معلوماتك للأغراض التالية تقديم الخدمة (الخدمات) التي تطلبها ؛","privacy-policy-how-collect-info-desc1":". فاتورة وجمع للخدمة (الخدمات) المقدمة لك.","privacy-policy-how-collect-info-desc2":"كم من الوقت نحافظ على معلوماتك","privacy-policy-how-long-head":"كم من الوقت نحافظ على معلوماتك","privacy-policy-how-long-desc":"نحتفظ بمعلوماتك طالما دعت الحاجة إلى تقديم خدماتنا لك. سنحتفظ بمعلوماتك عند الضرورة للامتثال لالتزاماتنا القانونية ، وحل النزاعات ، وفرض اتفاقياتنا. عندما لا نحتاج إلى استخدام معلوماتك ولم تعد هناك حاجة إلى الاحتفاظ بها للامتثال لالتزاماتنا القانونية أو التنظيمية ، فإننا إما سنحذفها من أنظمتنا أو نقوم بنزع طابعها الشخصي حتى لا نتمكن من تحديد هويتك.","privacy-policy-how-long-protect-head":"كيف نحمي معلوماتك أيضًا خارج الاتحاد الأوروبي","privacy-policy-how-long-protect-desc1":"نحن مهتمون بحماية خصوصيتك وبياناتك ، لكن لا يمكننا ضمان أو ضمان أمان أي معلومات ترسلها إلينا أو نضمن عدم إمكانية الوصول إلى معلوماتك أو الكشف عنها أو تغييرها أو إتلافها عن طريق خرق أيٍّ من معايير الصناعة الخاصة بنا ، الضمانات الفنية أو الإدارية. نعتمد ممارسات مناسبة لجمع البيانات وتخزينها ومعالجتها وتدابير أمنية للحماية من الوصول غير المصرح به أو العرضي أو تغيير أو الكشف أو إتلاف معلوماتك ومعلومات المعاملات والبيانات المخزنة على خدماتنا.","privacy-policy-how-long-protect-desc2":"حن مهتمون بحماية خصوصيتك وبياناتك ، لكن لا يمكننا ضمان أو ضمان أمان أي معلومات ترسلها إلينا أو نضمن عدم إمكانية الوصول إلى معلوماتك أو الكشف عنها أو تغييرها أو إتلافها عن طريق خرق أيٍّ من معايير الصناعة الخاصة بنا ، الضمانات الفنية أو الإدارية. نعتمد ممارسات مناسبة لجمع البيانات وتخزينها ومعالجتها وتدابير أمنية للحماية من الوصول غير المصرح به أو العرضي أو تغيير أو الكشف أو إتلاف معلوماتك ومعلومات المعاملات والبيانات المخزنة على خدماتنا.","privacy-policy-how-long-protect-desc3":"نظرًا لأننا نعمل على المستوى الدولي ، فقد يتم نقل معلوماتك ، بما في ذلك المعلومات الشخصية ، إلى الولايات المتحدة الأمريكية وسنغافورة و / أو أي بلد آخر غير بلد إقامتك. في هذه البلدان أيضًا ، نحرص على حماية معلوماتك الشخصية.","privacy-policy-acceptance-head":"قبول سياسة الخصوصية","privacy-policy-acceptance-desc":"باستخدام أي من خدماتنا ، فإنك توافق على جمع واستخدامنا لمعلوماتك وفقًا لسياسة الخصوصية هذه. نحن نحتفظ بالحق في تعديل سياسة الخصوصية هذه في أي وقت عن طريق نشر التغييرات على هذه الصفحة. يرجى التحقق من تاريخ المراجعة في أسفل هذه الصفحة لتحديد ما إذا كانت السياسة قد تم تعديلها منذ آخر مرة قمت بمراجعتها. إن استخدامك المستمر لأي جزء من موقعنا أو خدماتنا بعد نشر سياسة الخصوصية المحدثة سيشكل موافقتك على التغييرات.","privacy-policy-changes-head":"التغييرات في سياسة الخصوصية هذه","privacy-policy-changes-desc":"قد نجري تغييرات في سياسة الخصوصية الخاصة بنا من وقت لآخر. إذا قررنا تغيير سياسة الخصوصية الخاصة بنا ، فسنقوم بنشر هذه التغييرات على هذه الصفحة بحيث يمكنك دائمًا الوصول إلى أحدث سياسة الخصوصية.","privacy-policy-contact-us":"الاتصال بنا","privacy-policy-contact-us-desc":"إذا كان لديك سؤال حول سياسة الخصوصية هذه ، أو ممارسات المواقع ، أو تعاملاتك مع المواقع ، فيرجى الاتصال بنا عن طريق إرسال بريد إلكتروني إلى eg@apps4u.cc.","help":"تواصل معنا"}

/***/ }),

/***/ "./src/translations/be.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Speel Way Beyond","sidebar.home":"Huis","sidebar.myaccount":"Mijn Account","sidebar.notif":"Kennisgeving","sidebar.nonotif":"U heeft nog geen meldingen","html5games":"HTML5 Spellen","androidGames":"Android Spellen","favorite":"Favoriet","welcome.text":"Ontdek vandaag nog de beste mobiele games online!","footer.copyright":"&copy; 2020 Gamelords. Alle rechten voorbehouden","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Alle Rechten Voorbehouden","accountDetails":"Account Details","accountName":"Naam","accountEmail":"E-mail adres","accountLocation":"Locatie","accountInterests":"Interesse","accountChooseCategory":"Kies 3 categorieën","accountEditPhoto":"Foto bewerken","save":"Opslaan","topCategories":"Top Categorieën","favGames":"Favoriete Spellen","viewAll":"Bekijk alle","noGameFound":"Geen spellen gevonden","cancel":"Annuleren","gameDirectories":"Spel Directory's","category":"Categorie","noGamesFound":"Geen spellen gevonden onder deze categorie.","platform":"Platform","type":"Type","android-upper":"ANDROID","games":"spelletjes","html5":"HTML5","description":"Omschrijving","downloadNow":"Nu Downloaden","playNow":"Nu Spelen","rate":"Beoordelen","relatedGames":"Gerelateerde spellen","noFavGames":"Nog geen favoriete spellen","addFavGames":"Voeg uw favoriete spellen toe om toegang te krijgen en gemakkelijk en zonder gedoe te spelen","discover":"Ontdek","noFavGamesFound":"Geen favoriete spellen gevonden.","favorites":"Favorieten","accessDenied":"Verboden toegang","pageRestricted":"De pagina die u zoekt is beperkt.","privacyPolicy":"Privacybeleid","tnc":"Voorwaarden en Condities","kazakhOnly":"","areYouAlready":"Ben je al lid van ","thenConfirm":"Bevestig vervolgens uw mobiele nummer en krijg onbeperkte toegang tot al onze <strong> HTML5 </strong> en <strong> Android </strong> games","login":"Inloggen","Sports":"Sport","Action":"Actie","Adventure":"Avontuur","Fitness":"Geschiktheid","Entertainment":"Vermaak","Premium Games":"Premium Spellen","RPG":"RPG","Virtual Reality":"Virtuele realiteit","Arcade":"Arcade","Racing":"Racen","Motivation":"Motivatie","Tour":"Tour","Fun Gaming":"Fun Gaming","Athletics":"Atletiek","Inspiration":"Inspiratie","Into Nature":"De Natuur in","Political & Activism":"Politiek en Activisme","Travel":"Reizen","Foodbuzz":"Foodbuzz","Health and Nutrition":"Gezondheid en Voeding","Top Cars":"Topauto's","Fashion & Beauty":"Mode en schoonheid","E-Learning":"E-learning","Yoga":"Yoga","Just For Laugh":"Humor","Brain Boost":"Hersengymnastiek","Rugby":"Rugby","Economy":"Economie","Environment":"Milieu","Gaming":"Gaming","Lifestyle":"Lifestyle","Local Heroes":"Lokale helden","Technology":"Technologie","Tutorials":"Handleidingen","New Arrivals":"Net binnen","noVideosFound":"Geen video's gevonden in deze categorie","noFavVideos":"Nog geen favoriete video's","addFavVideos":"Voeg uw favoriete video's toe om ze moeiteloos te vinden en af te spelen","noFavVideosFound":"Geen favoriete video's gevonden","vid-player":"Speler","welcome.text.gamiclub":"ONTDEK VANDAAG DE BESTE INHOUD ONLINE!","search.input.placeholder":"Zoeken...","search.cancel.button":"Annuleren","privacy-policy-title":"Privacybeleid","privacy-policy-desc":"Dit privacybeleid legt onze verplichtingen en uw rechten met betrekking tot uw informatie uit. U dient het privacybeleid zorgvuldig te lezen. Als u het niet eens bent met dit privacybeleid, dient u geen gebruik te maken van onze websites of services. Het privacybeleid is naar behoren opgenomen en is onderworpen aan de servicevoorwaarden, en is van toepassing op dezelfde services en websites als die vermeld in de servicevoorwaarden. Alle termen die we in het privacybeleid gebruiken zonder deze te definiëren, hebben dezelfde definitie als in de servicevoorwaarden.","privacy-policy-collect-info-head":"WE VERZAMELEN INFORMATIE OP DE VOLGENDE MANIEREN:","privacy-policy-collect-info-desc1":"1. Wanneer u informatie aan ons geeft of ons toestemming geeft om informatie te verkrijgen. Als u ervoor kiest om u te abonneren op een service van ons, zullen wij of de mobiele operator van uw netwerk uw informatie verzamelen met betrekking tot de betaling voor het abonnement op onze services. Account- en factuurgegevens die door de mobiele operator worden verzameld, zijn onderhevig aan hun respectieve privacybeleid.","privacy-policy-collect-info-desc2":"2. We ontvangen technische informatie wanneer u onze websites en/of services bezoekt. We kunnen technische informatie over u verzamelen wanneer u onze services gebruikt. We verzamelen aanmeldgegevens elke keer dat u zich aan- of afmeldt bij onze services.","privacy-policy-how-collect-info-head":"HOE WE DE VERZAMELDE INFORMATIE GEBRUIKEN","privacy-policy-how-collect-info-subhead":" We kunnen uw gegevens gebruiken voor de volgende doeleinden:","privacy-policy-how-collect-info-desc1":"het leveren van de service(s) waar u om verzoekt;","privacy-policy-how-collect-info-desc2":"het factureren en innen voor de service(s) die aan u zijn geleverd.","privacy-policy-how-long-head":"HOE LANG WE UW INFORMATIE BEWAREN","privacy-policy-how-long-desc":"We bewaren uw gegevens zo lang als nodig is om onze services aan u te kunnen leveren. We bewaren uw gegevens indien nodig om te voldoen aan onze wettelijke verplichtingen, geschillen op te lossen en onze overeenkomsten af ​​te dwingen. Wanneer we uw informatie niet langer hoeven te gebruiken en het niet nodig is om deze te bewaren om te voldoen aan onze wettelijke of reglementaire verplichtingen, zullen we deze ofwel uit onze systemen verwijderen of depersonaliseren zodat we u niet langer kunnen identificeren.","privacy-policy-how-long-protect-head":"HOE WE UW GEGEVENS OOK BUITEN DE EU BESCHERMEN","privacy-policy-how-long-protect-desc1":"Er is ons veel gelegen aan het beschermen van uw privacy en gegevens, maar we kunnen de veiligheid van de informatie die u naar ons verzendt niet garanderen, of garanderen dat uw informatie niet wordt geopend, bekendgemaakt, gewijzigd of vernietigd door schending van een van de standaard fysieke, technische of bestuurlijke waarborgen van onze industrie. We hanteren passende methoden voor het verzamelen, opslaan en verwerken van gegevens en hanteren beveiligingsmaatregelen die bescherming bieden tegen ongeoorloofde of onbedoelde toegang, wijziging, openbaarmaking of vernietiging van uw informatie, transactie-informatie en gegevens die zijn opgeslagen op onze services.","privacy-policy-how-long-protect-desc2":"Geen enkele verzendmethode via het internet en geen enkele elektronische opslag is echter 100% veilig. Daarom kunnen we de absolute veiligheid ervan niet garanderen. We zullen onze beveiligingsprocedures blijven verbeteren naarmate er nieuwe technologie beschikbaar komt.","privacy-policy-how-long-protect-desc3":"Omdat we internationaal opereren, kan uw informatie, inclusief persoonlijke informatie, worden overgedragen naar en beschikbaar worden gemaakt in de VS of Singapore en/of een ander land dan het land waar u woont. Ook in deze landen nemen we alle redelijke maatregelen om uw persoonlijke informatie te beschermen.","privacy-policy-acceptance-head":"AANVAARDING VAN HET PRIVACYBELEID","privacy-policy-acceptance-desc":"Door een van onze services te gebruiken, stemt u in met het door ons verzamelen en gebruiken van uw informatie in overeenstemming met dit privacybeleid. We behouden ons het recht voor om dit privacybeleid op elk moment te wijzigen door de wijzigingen op deze pagina te plaatsen. Controleer de datum van herziening onderaan deze pagina om te bepalen of het beleid is gewijzigd sinds u het voor het laatst hebt bekeken. Als u een deel van onze website of services blijft gebruiken na het plaatsen van het bijgewerkte privacybeleid, betekent dit dat u akkoord gaat met de wijzigingen.","privacy-policy-changes-head":"WIJZIGINGEN IN DIT PRIVACYBELEID","privacy-policy-changes-desc":"We kunnen van tijd tot tijd wijzigingen aanbrengen in ons privacybeleid. Als we besluiten ons privacybeleid te wijzigen, zullen we die wijzigingen op deze pagina plaatsen, zodat u altijd het laatste privacybeleid kunt bekijken.","privacy-policy-contact-us":"CONTACT MET ONS OPNEMEN","privacy-policy-contact-us-desc":"Als u een vraag heeft over dit privacybeleid, de praktijken van de websites of uw omgang met de websites, kunt u contact met ons opnemen door een e-mail te sturen naar [e-mailadres].","unsubscribe":"Afmelden","sidebar.lang":"Talen","sidebar.lang.be":"Nederlandse","sidebar.lang.de":"Duitse","sidebar.lang.fr":"Frans","AN INFLUENCER'S CALLING 'EVERYONE HAD TO ACCEPT ME WHEN I ACCEPTED MYSELF'":"EEN INFLUENCER ROEPT 'IEDEREEN MOEST ME ACCEPTEREN TOEN IK MEZELF ACCEPTEERDE'","CRAZY CRAVINGS 'WHEN I'M BEHIND MY MASK, I'M BASICALLY SOMEONE NEW'":"GEKKE VERLANGENS 'ALS IK MIJN MASKER DRAAG, BEN IK EIGENLIJK IEMAND ANDERS'","I'M A CELEBRITY PET LUNA IS A PRICKLY UP-AND-COMER":"IK BEN EEN BEROEMDHEID, LUNA IS EEN AANSTEKELIJKE NIEUWKOMER","INSPIRE IN A MINUTE THE SUPERMODEL DISCOVERED AT 60":"INSPIRATIE IN EEN MINUUT: HET SUPERMODEL DAT OP 60 JARIGE LEEFTIJD WERD ONTDEKT","MY COOL SCHOOL CAMILLA'S STUDYING THE TRAPEZE":"MIJN COOLE CAMILLA VAN SCHOOL BESTUDEERT DE TRAPEZE","THE PILOTS FLYING A RESTORED WWII PLANE AROUND THE WORLD":"DE PILOTEN DIE EEN GERESTAUREERD WWII VLIEGTUIG ROND DE WERELD VLIEGEN","YOUNG CEO 'WHEN I LOOK AT A CAMERA, I SEE POWER IN ME & I SEE GREATNESS":"JONGE CEO: 'ALS IK NAAR EEN CAMERA KIJK, ZIE IK KRACHT EN MIJN GROOTSHEID'","CITY INNOVATIONS THE HIGHER YOU GO, THE GREENER IT GETS":"STADSVERNIEUWING, HOE HOGER JE GAAT, HOE GROENER HET WORDT","GREEN HEROES THE URBAN EXPERIENCE JUST GOT A SUSTAINABLE UPGRADE":"GROENE HELDEN: DE STAD KRIJGT EEN DUURZAME UPGRADE","INSPIRE IN A MINUTE FROM BULLIED BUG HUNTER TO KID AUTHOR":"INSPIRATIE IN EEN MINUUT: VAN GEPESTE INSECTENJAGER TOT JONGE AUTEUR","SIGHTS WITH HEIGHTS GHANA’S NATIONAL PARK CANOPY WALK":"BEZIENSWAARDIGHEDEN OP HOOGTE: GHANA'S NATIONAAL PARK HOOGTEWANDELING","SIGHTS WITH HEIGHTS THE CLIFF SIDE SANCTUARY BETWEEN HEAVEN AND EARTH":"BEZIENSWAARDIGHEDEN OP HOOGTE: DE KLIFZIJDE TUSSEN HEMEL EN AARDE","A PLACE TO CALL HOME FOR ABANDONED DOGS":"EEN OPVANGPLEK VOOR STRAATHONDEN","BARRY THE BEE WHISPERER’S MOST IMPORTANT FIGHT YET":"BARRY DE BIJENFLUISTERAAR: HET BELANGRIJKSTE GEVECHT TOT NU TOE","CEO ACTIVISM IS ON THE RISE":"CEO-ACTIVISME IS IN OPKOMST","INDIGENOUS HEROES NIGERIA'S ELIJAH IS SEEKING LEGAL JUSTICE FOR HIS PEOPLE":"INHEEMSE HELDEN: NIGERIA'S ELIJAH ZOEKT GERECHTIGHEID VOOR ZIJN VOLK.","INDONESIA TO BUILD A NEW CAPITAL DUE TO CLIMATE CHANGE":"INDONESIË BOUWT NIEUWE HOOFDSTAD ALS GEVOLG VAN DE KLIMAATVERANDERING","INSPIRE IN A MINUTE BREAKING BORDERS IS A TOUR YOU HAVE TO GO ON":"INSPIRATIE IN EEN MINUUT: HET DOORBREKEN VAN GRENZEN IS EEN MUST.","INSPIRE IN A MINUTE FIGHTING MENSTRUAL STIGMA IN NEPAL":"INSPIRATIE IN EEN MINUUT: STRIJD TEGEN HET MENSTRUATIESTIGMA IN NEPAL","INSPIRE IN A MINUTE HELPING KIDS FIGHT BACK & GET BETTER":"INSPIRATIE IN EEN MINUUT: EN HELP KINDEREN OM TERUG TE VECHTEN EN BETER TE WORDEN.","MORE THAN HALF OF WORLD’S FOREST WILDLIFE DISAPPEARED":"MEER DAN DE HELFT VAN DE BOSDIEREN IN DE WERELD IS VERDWENEN","MY SOCIAL MEDIA ACTIVISM IT'S TIME FOR EVERYONE TO #FILLTHEBOTTLE":"MIJN SOCIALMEDIA-ACTIVISME: HET IS TIJD VOOR IEDEREEN OM DE FLES TE VULLEN","PEACE BUILDERS CLOSING THE CYCLE OF VIOLENCE":"VREDESACTIVISTEN: SLUIT DE GEWELDSSPIRAAL","PEACE BUILDERS THE ART OF PEACEFUL RESISTANCE":"VREDESACTIVISTEN: DE KUNST VAN HET VREEDZAAM VERZET","PEACE BUILDERS THE UNITING FACTOR THAT'S BRINGING PEOPLE TOGETHER":"VREDESACTIVISME: DE VERENIGENDE FACTOR DIE MENSEN SAMENBRENGT","THE RESULTS ARE IN, TOKYO IS THE SAFEST CITY IN THE WORLD":"DE RESULTATEN ZIJN BINNEN, TOKYO IS DE VEILIGSTE STAD TER WERELD","HOW TO BE GREEN AT HOME NATURAL STAIN REMOVER":"HOE GROEN TE ZIJN IN HUIS NATUURLIJKE VLEKKENVERWIJDERAAR","WANNA BE A DJ START WITH THE BASICS FROM A PRO":"WIL JE DJ WORDEN? BEGIN MET DE BASIS VAN EEN PRO","BEST VR EXPERIENCES INTO THE SHARK TANK":"BESTE VR-ERVARINGEN IN DE HAAIENTANK","FROM HUMAN TO CYBORG":"VAN MENS TOT CYBORG","FUTURISTIC TRANSPORT GETTING AROUND NEVER LOOKED SO COOL":"FUTURISTISCH TRANSPORT DAT ER NOG NOOIT ZO COOL UITZAG","NASA’S NEXT DESTINATION IN 2026 TITAN":"NASA'S VOLGENDE BESTEMMING IN 2026: TITAAN","VISIT A SPACE PLACE KOROLEV, RUSSIA'S DEEP SPACE HISTORY":"BEZOEK EEN RUIMTEPLAATS: KOROLEV, RUSLAND'S DIEPE RUIMTEGESCHIEDENIS","VISIT A SPACE PLACE THE METEOR CRATER":"BEZOEK EEN RUIMTEPLAATS: DE METEOORKRATER","VISIT A SPACE PLACE THE NETHERLANDS' SPACE SIMULATOR":"BEZOEK EEN RUIMTEPLAATS: DE NEDERLANDSE RUIMTESIMULATOR","AMAZING TENNIS COURTS A COURT HIDDEN AMONG CLIFFS":"VERBAZINGWEKKENDE TENNISBANEN: EEN VELD DAT VERBORGEN LIGT TUSSEN DE KLIFFEN","BEST VR EXPERIENCES THE EXTREME SPORTS SIMULATOR":"BESTE VR-ERVARINGEN MET DE EXTREME SPORTSIMULATOR","DON’T EXPECT THE U.S. WOMEN’S FOOTBALL SQUAD AT THE WHITE HOUSE":"VERWACHT HET AMERIKAANSE VROUWENVOETBALTEAM NIET IN HET WITTE HUIS","FUTURE FEMALE FOOTBALLER COLOMBIA'S SALOME IS GONNA BE A PRO":"COLOMBIA'S SALOMÉ; TOEKOMSTIGE VROUWELIJKE VOETBALLER WORDT EEN PRO","MY UNDERGROUND SPORT ALAN NASTY NASH IS A CHAMP TOE WRESTLER":"MIJN OBSCURE SPORT: ALAN NASTY NASH IS EEN KAMPIOEN TEENWORSTELAAR.","MY UNDERGROUND SPORT KABADDI'S GROWING IN INDIA":"MIJN OBSCURE SPORT: KABADDI'S GROEIEN IN INDIA","SPORT FOR CHANGE A GOAL FOR INCLUSION":"SPORT VOOR VERANDERING: EEN DOEL VOOR INCLUSIE","SPORT FOR CHANGE THE INITIATIVE HITTING IT OUT OF THE PARK":"SPORT VOOR VERANDERING: HET INITIATIEF UIT HET PARK","THE 5 BEST SUMMER FOOTBALL TRANSFERS SO FAR!":"DE 5 BESTE ZOMERVOETBALTRANSFERS TOT NU TOE!","COACHES CLINIC PETE HERRMAN":"COACHKLINIEK. PETE HERRMAN","DRIBBLE DRIVE MOTION SKILLS":"DRIBBELEN: BEWEGINGSVAARDIGHEDEN","GAMCA COACHES CLINIC":"GAMCA-COACHKLINIEK","ROBERT TUTEIN (UTICA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"ROBERT TUTEIN (UTICA) - 2016 GEICO SPEL VAN HET JAAR GENOMINEERDE","RYAN KELLEY (ARCADIA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"RYAN KELLEY (ARCADIA) - 2016 GEICO SPEL VAN HET JAAR GENOMINEERDE","SAM BORST SMITH (ROCHESTER) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"SAM BORST SMITH (ROCHESTER) - 2016 GEICO SPEL VAN HET JAAR GENOMINEERDE","SPECIAL SPECTATORS VISITS THE COLLEGE SLAM DUNK & 3- POINT CHAMPIONSHIPS INTERSPORT":"SPECIALE TOESCHOUWERS BEZOEKEN DE COLLEGE SLAM DUNK EN 3-PUNTS KAMPIOENSCHAPPEN INTERSPORT","TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO SPEL VAN HET JAAR GENOMINEERDE","TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO SPEL VAN HET JAAR GENOMINEERDE","VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO SPEL VAN HET JAAR GENOMINEERDE","LEARN FREESTYLE FOOTBALL TRICKS LEMMENS AROUND THE WORLD":"LEER FREESTYLE VOETBALTRUCS: LEMMENS OVER DE HELE WERELD","PRO FOOTBALLER TRAINING A NEED FOR SPEED":"PRO-VOETBALTRAINING: EEN BEHOEFTE AAN SNELHEID","PRO FOOTBALLER TRAINING LEG-FOCUSED EXERCISES":"PRO-VOETBALTRAINING: BEENGERICHTE OEFENINGEN","PRO FOOTBALLER TRAINING MUSCLES-FOCUSED EXERCISES":"PRO-VOETBALTRAINING: SPIERGERICHTE OEFENINGEN","THERE’S NO POWER FROM KEEPING IT TO YOURSELF'":"ER IS GEEN KRACHT OM HET VOOR JEZELF TE HOUDEN'.","3 THINGS MALALA HAS SAID THAT WILL TOTALLY INSPIRE YOU":"3 DINGEN DIE MALALA HEEFT GEZEGD DIE JE VOLLEDIG ZULLEN INSPIREREN","BORDER ANGELS SAVING LIVES WITH WATER":"GRENSENGELEN REDDEN LEVENS MET WATER","BULLIED TO INFLUENCER 'PAINTING HELPS ME DODGE MY PROBLEMS":"VAN GEPEST TOT INFLUENCER: 'SCHILDEREN HELPT ME MIJN PROBLEMEN TE ONTWIJKEN'","BULLIED TO INFLUENCER 'YOU CAN BE THE LIGHT IN THE DARKNESS":"VAN GEPEST TOT INFLUENCER: 'JE KUNT HET LICHT IN DE DUISTERNIS ZIJN'.","PEACE BUILDERS FIGHTING GANGS WITH CLOWNING":"VREDESACTIVISTEN VECHTEN TEGEN BENDES MET CLOWNS","PEACEBUILDERS INSIDE THE COMMUNITY RING":"VREDESACTIVISTEN BINNEN DE GEMEENSCHAPSRING","SPORT FOR CHANGE A SURE SHOT TO FEMALE EMPOWERMENT IN ZIMBABWE":"SPORT VOOR VERANDERING: EEN TREFFER IN VROUWELIJKE EMPOWERMENT IN ZIMBABWE","YOUNG CEO MR. CORY’S COOKIES":"JONGE CEO: MR. CORY'S COOKIES","CRAZY CRAVINGS 'I'VE BEEN EATING CHALK FOR OVER TWENTY YEARS":"GEKKE VERLANGENS: 'IK EET AL MEER DAN TWINTIG JAAR KRIJT'.","DARGAVS WELCOME TO THE CITY OF THE DEAD":"DARGAVS WELKOM IN DE STAD VAN DE DODEN","HEROES NEIGHBORHOOD TOUR FRIDA KAHLO":"HELDENBUURT TOUR FRIDA KAHLO","SOLO TRIP HIDDEN GEMS OF BALI":"SOLO TRIP: VERBORGEN JUWEELTJES VAN BALI","SOLO TRIP HIDDEN GEMS OF BOGOR (INDONESIA)":"SOLO TRIP: VERBORGEN JUWEELTJES VAN BOGOR (INDONESIË)","SOLO TRIP THE HIDDEN GEMS OF ROTTERDAM":"SOLO TRIP: DE VERBORGEN JUWEELTJES VAN ROTTERDAM","SUGARY DRINK LOVERS, THIS ONE'S FOR YOU!":"LIEFHEBBER VAN ZOETE DRANKJES? DEZE IS VOOR JOU!","THE 5 MOST ICONIC ARMANI RED CARPET LOOKS OF ALL TIME":"DE 5 MEEST ICONISCHE LOOKS VAN DE ARMANI RED CARPET ALLER TIJDEN","THE MOST AMAZING ISLAND CANARY ISLANDS":"DE MEEST VERBAZINGWEKKENDE EILANDEN: CANARISCHE EILANDEN","THE MOST AMAZING ISLAND FAVIGNANA SICILY":"DE MEEST VERBAZINGWEKKENDE EILANDEN: FAVIGNANA SICILIË","THE MOST AMAZING ISLAND TEXEL":"DE MEEST VERBAZINGWEKKENDE EILANDEN: TEXEL","THESE NATIONS GIVE EXPATS THE BEST ONLINE LIFE":"DEZE LANDEN BIEDEN EXPATS HET BESTE ONLINE LEVEN","5 GAMES YOU WILL LOSE FRIENDS OVER":"5 GAMES WAARBIJ JE VRIENDEN ZAL VERLIEZEN","5 REASONS TO PLAY MONSTER HUNTER WORLD":"5 REDENEN OM MONSTER HUNTER WORLD TE SPELEN","BEST VR EXPERIENCES THE SURVIVAL TEST":"DE BESTE VR-ERVARING, DE OVERLEVINGSTEST","PLACE YOUR BETS! GTA IS GETTING A REAL VIRTUAL CASINO":"PLAATS JE WEDDENSCHAPPEN! GTA KRIJGT EEN ECHT VIRTUEEL CASINO","TOP 5 GAMING LAWSUITS":"TOP 5 GAMING-RECHTSZAKEN","TOP 5 HIGHEST GROSSING ARCADE GAMES":"TOP 5 DE BEST VERKOPENDE ARCADESPELLEN","TOP 5 LEGENDARY GAME COUPLES":"TOP 5 LEGENDARISCHE SPELCOMBINATIES","BUILDERS OF TOMORROW SOLAR WATER HEATER FROM PLASTIC BOTTLES":"BOUWERS VAN MORGEN MAKEN EEN ZONNEBOILER UIT PLASTIC FLESSEN","GOT PLASTIC HERE ARE FOUR INNOVATIVE WAYS TO DEAL WITH IT!":"PLASTIC? HIER ZIJN VIER INNOVATIEVE MANIEREN OM ER WAT MEE TE DOEN!","SAVING THE PLANET AND MAKING ART, ONE BUTT AT A TIME":"DE PLANEET REDDEN EN KUNST MAKEN, HET KAN","THE FASTEST WAY TO SAVE THE PLANET":"DE SNELSTE MANIER OM DE PLANEET TE REDDEN","THE UNIQUE ARTIST TURNING TIRES IN MASTERPIECES":"DE UNIEKE KUNSTENAAR DIE MEESTERWERKEN MAAKT VAN BANDEN","4 LESSONS TO LEARN FROM BUSINESS MOGUL ARIANNA HUFFINGTON":"4 LESSEN VAN BUSINESSVROUW ARIANNA HUFFINGTON","BUILDERS OF TOMORROW A FUTURE PAVED WITH PLASTIC":"BOUWERS VAN MORGEN: EEN TOEKOMST GEPLAVEID MET PLASTIC","JUST HOW VULNERABLE ARE JOBS TO ROBOT TAKEOVERS":"HOE KWETSBAAR ZIJN BANEN VOOR DE KOMST VAN ROBOTS","BEST RUGBY SKILLS - STEPS, TRICKS, OFFLOADS COMPILATION":"DE BESTE RUGBY-VAARDIGHEDEN: - STAPPEN, TRUCS, OFFLOADS COMPILATIE","BEST RUGBY SKILLS 2018":"DE BESTE RUGBY-VAARDIGHEDEN 2018","BEST RUGBY TRIES 2018":"DE BESTE RUGBY-TRIES 2018","CRAZIEST RUGBY SKILLS":"GEKSTE RUGBY-VAARDIGHEDEN","EPIC RUGBY SKILLS 2017":"EPISCHE RUGBY-VAARDIGHEDEN 2017","EPIC RUGBY STEPS 2018":"EPISCHE RUGBY-STAPPEN 2018","RUGBY BIG HITS 2018":"RUGBY GROTE HITS 2018","DITCH THE DOCTOR! HOW ABOUT DIAGNOSIS BY COMPUTER":"DUMP DE DOKTER! WAT DACHT JE VAN EEN DIAGNOSE MET DE COMPUTER?","ESPN'S NEW DEAL DIVES INTO THE WORLD OF DRONE RACING":"ESPN'S NIEUWE DEAL DUIKT IN DE WERELD VAN DE DRONERACING","EVER WISHED BEER COULD FLY NOW IT CAN!":"OOIT GEWENST DAT BIER KON VLIEGEN? NU HET KAN!","HEARING THINGS HERE ARE 5 FACTS ON OUR INNER VOICE":"HET HOREN VAN DE DINGEN HIER ZIJN 5 FEITEN OVER ONZE INNERLIJKE STEM","IS SPOTTY SKIN THE ANSWER TO LOOKING YOUNGER":"IS EEN VLEKKERIGE HUID HET ANTWOORD OP EEN JONGER UITERLIJK","JUST WHY ARE THE DUTCH SO TALL":"WAAROM ZIJN DE NEDERLANDERS ZO GROOT","MEET THE ROBOT THAT WANTS TO GET TO KNOW YOU":"MAAK KENNIS MET DE ROBOT DIE JE WIL LEREN KENNEN","STAR WARS BECOMES REALITY IN A POST-APOCALYPTIC MALL":"STAR WARS WORDT WERKELIJKHEID IN EEN POST-APOCALYPTISCH WINKELCENTRUM","SUGAR TAX THE ANSWER TO OBESITY PANDEMIC":"SUIKERBELASTING HET ANTWOORD OP DE ZWAARLIJVIGHEIDSPANDEMIE?","SWALLOW THIS NANO CHIP TO KNOW WHAT S MAKING YOU SICK":"SLIK DEZE NANO-CHIP OM TE WETEN WAT JE ZIEK MAAKT","THE EXPLODING COST OF CYBERATTACKS":"DE EXPLODERENDE KOSTEN VAN CYBERAANVALLEN","TURNS OUT EMAILS DIDN'T SOLVE OUR WASTE PAPER PROBLEMS":"E-MAILS HEBBEN ONS PAPIERAFVALPROBLEEM NIET OPGELOST.","UK DRONE SHOW THE LATEST CONSUMER INDUSTRY TRENDS":"UK DRONE TOONT DE LAATSTE TRENDS IN DE CONSUMENTENINDUSTRIE","VR RUNNING OF THE BULLS! A FEARFUL THRILLSEEKERS DREAM":"VR IN STIERENRENNEN! EEN ANGSTAANJAGENDE THRILLSEEKERS-DROOM","AMAZING WATERFALLS ZAMBIA'S JAW-DROPPING NATURAL WONDER":"VERBAZINGWEKKENDE WATERVALLEN: ZAMBIA'S ONGELOOFLIJKE NATUURWONDER","FAIRY TALE DREAM SPOTS THE PRETTIEST VILLAGE IN ANDALUCÍA":"SPROOKJESACHTIGE DROOMPLEKKEN: HET MOOISTE DORP VAN ANDALUSIË","FAIRY TALE DREAM SPOTS THE SINKING CASTLE OF SCALIGERA":"SPROOKJESACHTIGE DROOMPLEKKEN: HET ZINKENDE KASTEEL VAN SCALIGERA","MEDELLÍN IS THE BACKPACKING SPOT YOU'VE BEEN LOOKING FOR":"MEDELLÍN IS DE RUGZAKPLEK WAAR JE NAAR OP ZOEK WAS","SIGHTS WITH HEIGHTS THE NARROW BRIDGES OF CAMINITO DEL REY":"BEZIENSWAARDIGHEDEN MET HOOGTES DE SMALLE BRUGGEN VAN CAMINITO DEL REY","THIS DUTCH PARADE TAKES FLOWER POWER TO THE NEXT LEVEL":"DEZE NEDERLANDSE OPTOCHT BRENGT DE FLOWER POWER NAAR EEN HOGER NIVEAU.","INSTA RESTAURANT WE COULD ALL USE A BIT MORE PINK IN OUR LIVES":"INSTA RESTAURANT: WE KUNNEN ALLEMAAL WEL WAT MEER ROZE GEBRUIKEN IN ONS LEVEN","KFC IS TESTING MEATLESS CHICKEN WINGS AND NUGGETS":"KFC TEST VLEESLOZE WINGS EN NUGGETS","TURNING LEFTOVER BREAD INTO PANZANELLA & BRUSCHETTA CAPRESE":"MAAK VAN RESTJES BROOD PANZANELLA EN BRUSCHETTA CAPRESE","SALSAS FOR SUNNY DAYS SPICY MANGO SALSA":"SALSAS VOOR ZONNIGE DAGEN: PITTIGE MANGO SALSA","VEGAN ICE CREAM AVOCADO BANANA":"VEGANISTISCH IJS: AVOCADOBANAAN","VEGAN ICE CREAM COCONUT FUSION":"VEGANISTISCH IJS: KOKOSNOOTFUSIE","VEGAN ICE CREAM FRESH FRUIT POPSICLES":"VEGANISTISCH IJS: MET VERSE FRUITIJSJES","VEGAN ICE CREAM PINEAPPLE MINT LIME":"VEGANISTISCH IJS: ANANAS-MUNT LIMOEN","VEGAN ICE CREAM BANANA MATCHA":"VEGANISTISCH IJS: BANAAN MATCHA","BRAIN IMPLANTS ARE CLOSER THAN YOU MIGHT THINK":"HERSENIMPLANTATEN ZIJN DICHTERBIJ DAN JE ZOU DENKEN","THANKS, CHAMELEONS HUMANS MIGHT GET COLOR-CHANGING SKIN":"BEDANKT, KAMELEONMENSEN KRIJGEN MISSCHIEN EEN HUID DIE VAN KLEUR VERANDERT","ARM AND LEG RAISE":"ARM EN BEEN OMHOOG","CONDITION TRAINING":"CONDITIETRAINING","CORE STRENGTH":"KERNWAARDE","LUNGES":"LUNGES","PUNCH BAG":"BOKSZAK","SHADOW BOXING":"SCHADUWBOKSEN","STRETCHING":"REKKEN","2016 CHEVROLET CAMARO SS":"2016 CHEVROLET CAMARO SS","2016 FORD MUSTANG FASTBACK":"2016 FORD MUSTANG FASTBACK","2016 FORD MUSTANG GT4":"2016 FORD MUSTANG GT4","2016 TOYOTA PRIUS G RACING CAR":"2016 TOYOTA PRIUS G RACING CAR","2016 TOYOTA XTREME COROLLA":"2016 TOYOTA XTREME COROLLA","ARABIC EPS 1 - HOW TO INTRODUCE YOURSELF":"ARABISCHE EPS 1 - HOE STEL JE JEZELF VOOR?","ARABIC EPS 2 - THANK YO":"ARABISCH EPS 2 - DANK JE WEL","ENGLISH EPS 3 - ASKING ABOUT HOBBIES":"ENGELS EPS 3 - VRAGEN OVER HOBBY'S","ENGLISH EPS 4 - WHERE ARE YOU FROM":"ENGELS EPS 4 - WAAR KOM JE VANDAAN","FRENCH EPS 5 - HOW TO APOLOGIZE":"FRANS EPS 5 - HOE KUN JE JE VERONTSCHULDIGEN?","FRENCH EPS 6 - ASKING DO YOU SPEAK ENGLISH":"FRANS EPS 6 - VRAGEN OF JE ENGELS SPREEKT","ITALIAN EPS 7- APOLOGIES":"ITALIAANS EPS 7- VERONTSCHULDIGINGEN","ITALIAN EPS 8 - HOW MUCH":"ITALIAANS EPS 8 - HOEVEEL","SPANISH EPS 9 - WHERE ARE YOU FROM":"SPAANS EPS 9 - WAAR KOM JE VANDAAN","SPANISH EPS 10 - WHAT'S UP":"SPAANS EPS 10 - HOE GAAT HET","HOW TO POST NATAL YOGA BREATHING EXERCISE":"NA DE GEBOORTE: HOE KAN IK YOGA-ADEMHALINGSOEFENINGEN DOEN?","HOW TO IN 60 SECONDS":"HOE IN 60 SECONDEN","HOW TO POST NATAL YOGA - DANDASANA":"NA DE GEBOORTE - YOGA DANDASANA","HOW TO POST NATAL YOGA - IF BABY NEEDS ENTERTAINMENT":"NA DE GEBOORTE - YOGA, WAT ALS JE BABY ENTERTAINMENT NODIG HEEFT","PILATES HALF ROLL BACK":"PILATES HALVE ROL","BECOME FLEXIBLE WITH YOGA":"FLEXIBEL WORDEN MET YOGA","FIND PEACE AT HOME WITH YOGA":"VIND RUST IN HUIS MET YOGA","FIND PEACE WITH YOGA":"VIND VREDE MET YOGA","GET SLIM & FIT WITH YOGA":"SLANK EN FIT WORDEN MET YOGA","LEARN THE ART OF YOGA":"LEER DE KUNST VAN YOGA","LOST WEIGHT WITH YOGA":"GEWICHT VERLIEZEN MET YOGA","MASTER CORE YOGA POSES":"MEESTER YOGAPOSITIES","MIND OVER MATTER":"GEEST OVER DE MATERIE","ULTIMATE YOGA GUIDE":"ULTIEME YOGAGIDS","YOGA VILLAGE":"YOGADORP","YOGA YOUR WAY TO HEALTHY LIVING":"YOGA IS JE WEG NAAR EEN GEZOND LEVEN","ANIMALS EXOTICOS":"EXOTISCHE DIEREN","AUTOMATU":"AUTOMATU","BABIES AND MOVING TABLE PART 1":"BABY'S EN BEWEGENDE TAFEL DEEL 1","BAD KIDS THROW ORANGE PEELS PART 1":"ONDEUGENDE KINDEREN GOOIEN SINAASAPPELSCHILLEN DEEL 1","BIG BUNNY SCARES BABIES PART 1":"GROOT KONIJN MAAKT BABY'S BANG DEEL 1","BODYGUARDS":"LIJFWACHTEN","CAKE ON FACE":"TAART OP GEZICHT","CAN I CLICK YOUR PHOTO":"KAN IK OP JE FOTO KLIKKEN","CAR PARKING":"PARKEERGELEGENHEID","CAR FOR SALE":"AUTO TE KOOP","MAN FALLING ON LADDER":"MAN VALT VAN LADDER","MAN IN GARBAGE CAN PART 1":"MAN IN VUILNISBAK DEEL 1","PAINTING EXHIBITION":"SCHILDERIJENTENTOONSTELLING","RECKLESS BLIND MAN PART 1":"ROEKELOZE BLINDE MAN DEEL 1","ROLLER BLADER PART 1":"ROLLER BLADER DEEL 1","RUDE MAN ON BEACH PART 1":"ONBESCHOFTE MAN OP HET STRAND DEEL 1","SANTA CLAUS THE PERVERT PART 1":"KERSTMAN, DE VIEZERIK DEEL 1","BABY CARIER ON CAR":"WANDELWAGEN OP AUTO","BLEEDING NOSE":"BLOEDENDE NEUS","MONEY FALLING":"GELD DAT VALT","OPEN THIS PEN":"OPEN DEZE PEN","GLAMOROUS TOUCH":"GLAMOUREUZE TOETS","LIPS GLAMOROUS RED":"LIPPEN GLAMOUREUS ROOD","LIPS NATURAL":"LIPPEN NATUURLIJK","LIPS SPARKLING AND FULL":"LIPPEN SPRANKELEND EN VOL","MAKE-UP BLUSH":"MAKE-UP BLUSH","MAKE-UP BRONZER":"MAKE-UP BRONZER","MAKE-UP CONCEALER":"MAKE-UP CONCEALER","MAKE-UP EYEBROWS":"MAKE-UP WENKBRAUWEN","MAKE-UP FOUNDATION":"MAKE-UP FOUNDATION","SMOKEY EYES":"SMOKEY EYES","SPARKLING EYES":"SPRANKELENDE OGEN","5 MAKE UP TIPS AND TRICKS FOR YOU":"5 MAKE-UPTIPS EN TRUCS","7 MAKE UP TIPS AND TRICKS FOR FLAWLESS SKIN":"7 MAKE-UPTIPS EN TRUCS VOOR EEN VLEKKELOZE HUID","10 FAST AND EASY MAKE UP TIPS":"10 SNELLE EN EENVOUDIGE MAKE-UPTIPS","10 MAKE UP TIPS AND TRICKS FOR OILY SKIN":"10 MAKE-UPTIPS EN TRUCS VOOR DE VETTE HUID","13 MAKE UP MISTAKES TO AVOID":"13 MAKE-UPFOUTEN OM TE VOORKOMEN","101 TIPS FOR BEGINNER MAKE UP":"101 TIPS VOOR BEGINNERSMAKE-UP","ASIAN BEAUTY TIPS YOU MUST DO NOW":"AZIATISCHE SCHOONHEIDSTIPS DIE JE NU MOET DOEN","BEGINNER EVERY MAKE UP TIPS AND TRICKS FOR YOU":"BEGINNER MAKE-UPTIPS EN TRUCJES VOOR JOU","BEST MAKE UP ARTIST TIPS YOU NEED TO KNOW":"DE BESTE MAKE-UPTIPS DIE JE MOET WETEN","ESSENTIAL MAKE UP TIPS FOR SUMMER GLOW":"ESSENTIËLE MAKE-UPTIPS VOOR DE ZOMERSE GLOED","FLATTERING EYES MAKE UP FOR YOU":"VLEIENDE OGEN; MAKE-UPTIPS","FOUNDATION TRICKS FOR OILY SKIN":"FUNDERINGSTRUCJES VOOR DE VETTE HUID","FULL COVERAGE FOUNDATION ROUTINE FOR YOU":"VOLLEDIGE DEKKING EN BASISROUTINE","LOOK FIERCE WITH DRUGSTORE MAKE UP":"EEN SCHITTEREND UITERLIJK MET DROGISTERIJ-MAKE-UP","MAKE UP ESSENTIALS FOR DARK SKIN TONES":"MAKE-UPTIPS VOOR DONKERE HUIDSKLEUREN","MAKE UP TIPS FOR AGING EYES":"MAKE-UPTIPS VOOR OUDERE OGEN","MAKE UP TIPS FOR FLAWLESS SKIN":"MAKE-UPTIPS VOOR EEN ONBERISPELIJKE HUID","MUST KNOW MAKE UP TIPS":"ESSENTIELE MAKE-UPTIPS","MUST KNOW WAKE UP TIPS":"ESSENTIELE MAKE-UPTIPS","NATURAL MAKE UP KOREAN STYLE":"NATUURLIJKE MAKE-UP KOREAANSE STIJL","NATURAL MAKE UP TIPS FOR MEN":"NATUURLIJKE MAKE-UPTIPS VOOR MANNEN","NATURAL TO GLAMOROUS":"NATUURLIJK TOT GLAMOUREUS","OVER 40 AGED WOMAN MAKE UP TIPS":"MAKE-UPTIPS VOOR VROUWEN VAN 40+","PRO MAKE UP TIPS BY TATI":"PRO MAKE-UPTIPS DOOR TATI","SECRET MAKE UP TIPS AND TRICKS FOR BEGINNERS":"GEHEIME MAKE-UPTIPS EN TRUCS VOOR BEGINNERS","SIMPLE TIPS FOR EYESHADOW":"EENVOUDIGE TIPS VOOR OOGSCHADUW","SUMMER MAKE UP MELTPROOF TIPS":"ZOMERSE MAKE-UP: SMELTVEILIGE TIPS","TOP 10 SECRET TIPS OF CELEBRITIES":"TOP 10 GEHEIME TIPS VAN BEROEMDHEDEN","TOP 25 MAKE UP TIPS FOR PALE SKIN":"TOP 25 MAKE-UPTIPS VOOR EEN BLEKE HUID","TYRA BANKS MAKE UP TIPS":"TYRA BANKS MAKE-UPTIPS"}

/***/ }),

/***/ "./src/translations/bg.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Начало","sidebar.faq":"ЧЕСТО ЗАДАВАНИ ВЪПРОСИ","sidebar.contact":"КОНТАКТИ","sidebar.myaccount":"Моят акаунт","sidebar.notif":"Известия","sidebar.nonotif":"Все още нямате известия","html5games":"HTML5 игри","androidGames":"Android игри","android-upper":"Android","favorite":"Любими","splashscreen.text":"Играйте Way Beyond","welcome.text":"Открийте най-добрите онлайн игри за вашия телефон!","welcome.text.gamiclub":"Открийте най-доброто онлайн съдържание сега!","accountDetails":"Данни за акаунта","accountName":"Име","accountEmail":"Имейл адрес","accountLocation":"Местоположение","relatedVideo":"Свързано видео","accountInterests":"Интереси","accountChooseCategory":"Изберете 3 категории","accountEditPhoto":"Актуализиране на снимка","save":"Запази","topCategories":"Топ категории","favGames":"Любими игри","viewAll":"Виж всички","noGamesFound":"Не са намерени игри в тази категория","noVideosFound":"Не са намерени видеа в тази категория","cancel":"Отказ","gameDirectories":"Инструкции за игра","category":"Категория","platform":"Платформа","type":"Тип","android":"Android","games":"Игри","html5":"HTML5","videos":"Видеа","search.input.placeholder":"Търсене...","search.cancel.button":"Отказ","description":"Описание","downloadNow":"Свали сега","playNow":"Играй сега","rate":"Рейтинг","relatedGames":"Свързани игри","noFavGames":"Все още няма любими игри","addFavGames":"Добавете игри в любимите си за незабавно играене","discover":"Открий","noFavGamesFound":"Не са намерени любими игри","favorites":"Любими","accessDenied":"Достъпът е забранен","pageRestricted":"Страницата, която търсите, е ограничена.","averageRatingBasedOn":"средна оценка въз основа на","averageRatingReview":"отзиви","tnc":"УСЛОВИЯ И ПРЕДПОЛОЖЕНИЯ","contact_us":"Свържете се с нас","areYouAlready":"Вече сте член на","thenConfirm":"След това потвърдете номера на мобилния си и получете неограничен достъп до цялото ни съдържание","login":"Вход","Action":"Екшън","Adventure":"Приключение","Arcade":"Аркадни игри","Sport":"Спорт","Racing":"Състезания","Premium Games":"Премиум игри","RPG":"RPG игри","Virtual Reality":"Виртуална реалност","Motivation":"Мотивационни игри","Tour":"Тур","Fun Gaming":"Забавни игри","Athletics":"Лека атлетика","Inspiration":"Вдъхновение","Into Nature":"Природа","Political & Activism":"Политика и активизъм","Travel":"Пътувания","Foodbuzz":"Вкусни идеи","Health and Nutrition":"Здраве и хранене","Fitness":"Фитнес","Entertainment":"Развлечения","Top Cars":"Топ коли","Fashion & Beauty":"Мода и красота","E-Learning":"Е-обучение","Yoga":"Йога","Just For Laugh":"Смешни видеа","Brain Boost":"Игри за ума","Rugby":"Ръгби","Economy":"Икономика","Environment":"Околна среда","Gaming":"Гейминг","Lifestyle":"Начин на живот","Local Heroes":"Местни герои","Sports":"Спорт","Technology":"Технологии","Adrenaline Rush":"Адреналинова треска","Tutorials":"Уроци","New Arrivals":"Нови предложения","Casual":"Небрежен","noFavVideos":"Все още няма любими видеа","addFavVideos":"Добавете видеа в любимите си за бърз достъп","noFavVideosFound":"Все още няма любими видеа","footer.copyright.playnixzone":"Абонирайте се и се наслаждавайте на първокласни видеоклипове и филми от нашия онлайн магазин. Абонаментът осигурява достъп до ексклузивно съдържание на цена от 3,20 евро на седмица. Услугата е достъпна за Viacom, A1, Yettle. За потребители на Viacom, A1, Yettle, въведете активационния код от SMS съобщението, за да потвърдите абонамента си за Playnixzone. Трябва да сте над 16 години, за да получите достъп до услугите. С регистрацията си на нашия уебсайт и потвърждаването с ПИН, вие приемате нашите общи условия. Прекратяване на абонамента: Viacom, A1, Yettle: изпратете STOP PNX на 14703 Цените за отписване са същите като цените на основен SMS с вашия оператор. Допълнителна информация: Може да се прилагат допълнителни такси за данни от вашия мобилен оператор. Поддръжка на клиенти / контакт: За въпроси и поддръжка, моля, свържете се с нас чрез playnixzone.bg@silverlines.info. Собственик на услугата: Mobimilia, Van Diemenstraat 356, 1013 CR Амстердам, Нидерландия.","vid-player":"Плеър","privacyPolicy":"ПОЛИТИКА ЗА ПРИВАТИЧНОСТ","privacy-policy-title":"ПОЛИТИКА ЗА ПРИВАТИЧНОСТ","privacy-policy-desc":"Тази Политика за поверителност обяснява нашите ангажименти и вашите права относно вашата информация. Моля, прочетете внимателно Политиката за поверителност. Ако не сте съгласни с тази Политика за поверителност, не използвайте нашите сайтове или услуги. Политиката за поверителност е част и подлежи на Общите условия и управлява същите услуги и сайтове, посочени в Общите условия. Всички термини, използвани в Политиката за поверителност, ако не са дефинирани тук, имат същото значение като в Общите условия.","privacy-policy-collect-info-head":"Събираме информация по следните начини:","privacy-policy-collect-info-desc1":"1. Когато ни я предоставите или ни дадете разрешение да я получим. Ако изберете да се абонирате за услуга от нас, ние или доставчикът на мрежови услуги ще съберем информация за вашите плащания за абонамент за нашите услуги. Данните за сметка и таксуване, събрани от мобилния оператор, подлежат на тяхната собствена политика за поверителност.","privacy-policy-collect-info-desc2":"2. Получаваме техническа информация, когато посещавате нашите сайтове и/или услуги. Може да събираме техническа информация за вас всеки път, когато използвате услугите ни. Събираме лог данни всеки път, когато влизате или излизате от услугите ни.","privacy-policy-how-collect-info-head":"КАК ИЗПОЛЗВАМЕ СЪБРАНАТА ИНФОРМАЦИЯ","privacy-policy-how-collect-info-subhead":"Можем да използваме вашата информация за следните цели:","privacy-policy-how-collect-info-desc1":"· Да предоставяме услугите, които изисквате.","privacy-policy-how-collect-info-desc2":"· Таксуване и обработка за услугите, които ви предоставяме.","privacy-policy-how-long-head":"КАК ДЪЛГО МОЖЕМ ДА ПАЗИМ ВАШАТА ИНФОРМАЦИЯ","privacy-policy-how-long-desc":"Ще запазим вашите данни за период, необходим за предоставяне на нашите услуги. Ще съхраняваме данните ви толкова дълго, колкото е необходимо за спазване на нашите законови задължения, за разрешаване на спорове и за прилагане на нашите споразумения. Когато вече не е необходимо да използваме вашата информация и не е необходимо да я запазваме за спазване на правни или регулаторни изисквания, ще ги изтрием от нашите системи или ще ги обезличим, така че вече да не можем да ви идентифицираме.","privacy-policy-how-long-protect-head":"КАК ЗАЩИТАВАМЕ ВАШАТА ИНФОРМАЦИЯ ИЗВЪН ЕС","privacy-policy-how-long-protect-desc1":"Ние се грижим за поверителността и защитата на вашите данни, но не можем да гарантираме сигурността на всяка информация, която предавате на нас, нито можем да гарантираме, че вашата информация няма да бъде достъпена, разкрита, променена или унищожена в резултат на пробив във физическите, технически или управленски стандарти на нашата индустрия. Прилагаме подходящи практики за събиране, съхранение и обработка на данни и мерки за сигурност, за да защитим от неупълномощен или случайен достъп, промяна, разкриване или унищожаване на вашата информация, информация за транзакции и данни, съхранявани в нашите услуги.","privacy-policy-how-long-protect-desc2":"Въпреки това, нито един метод на предаване през интернет или метод за електронно съхранение не е 100% сигурен. Следователно не можем да гарантираме абсолютната сигурност. Ще продължим да подобряваме нашите мерки за сигурност с наличието на нови технологии.","privacy-policy-how-long-protect-desc3":"Тъй като оперираме международно, вашите данни, включително лични данни, могат да бъдат прехвърлени и достъпни в САЩ/Сингапур или в която и да е друга страна извън страната ви на пребиваване. И в тези държави вземаме разумни мерки за защитата на личните ви данни.","privacy-policy-acceptance-head":"ПРИЕМАМЕ ПОЛИТИКАТА ЗА ПОВЕРИТЕЛНОСТ","privacy-policy-acceptance-desc":"С използването на която и да е от нашите услуги се съгласявате със събирането и използването на вашата информация според настоящата Политика за поверителност. Запазваме правото да променяме тази Политика за поверителност по всяко време, като публикуваме промените на тази страница. Проверявайте датата на последна редакция в долната част на тази страница, за да видите дали политиката е била променена от последния преглед. Продължаването на използването на която и да е част от уебсайта или услугите ни след публикуване на обновената Политика за поверителност ще се счита за приемане на промените.","privacy-policy-changes-head":"ПРОМЕНИ В ПОЛИТИКАТА ЗА ПОВЕРИТЕЛНОСТ","privacy-policy-changes-desc":"С използването на която и да е от нашите услуги се съгласявате със събирането и използването на вашата информация според настоящата Политика за поверителност. Запазваме правото да променяме тази Политика за поверителност по всяко време, като публикуваме промените на тази страница. Проверявайте датата на последна редакция в долната част на тази страница, за да видите дали политиката е била променена от последния преглед. Продължаването на използването на която и да е част от уебсайта или услугите ни след публикуване на обновената Политика за поверителност ще се счита за приемане на промените.","privacy-policy-contact-us":"СВЪРЖЕТЕ СЕ С НАС","privacy-policy-contact-us-desc":"Ако имате въпроси относно тази Политика за поверителност, практиките на сайтовете или транзакциите си с нашите сайтове, свържете се с нас, като изпратите имейл на [Email Address]","unsubscribe":"Абониране/Отписване","AN INFLUENCER'S CALLING 'EVERYONE HAD TO ACCEPT ME WHEN I ACCEPTED MYSELF'":"Влиятел споделя „Всички трябваше да ме приемат, когато аз самият се прие“","CRAZY CRAVINGS 'WHEN I'M BEHIND MY MASK, I'M BASICALLY SOMEONE NEW'":"Дива страст „Когато съм зад маската, всъщност съм някой друг“","I'M A CELEBRITY PET LUNA IS A PRICKLY UP-AND-COMER":"Знаменито домашно животно: Луна е бодливо изгряваща звезда","INSPIRE IN A MINUTE THE SUPERMODEL DISCOVERED AT 60":"Вдъхновение за минута: Супермодел, открит на 60","MY COOL SCHOOL CAMILLA'S STUDYING THE TRAPEZE":"Моето готино училище: Камила учи на трапец","THE PILOTS FLYING A RESTORED WWII PLANE AROUND THE WORLD":"Пилоти обикалят света с реставриран самолет от Втората световна война","YOUNG CEO 'WHEN I LOOK AT A CAMERA, I SEE POWER IN ME & I SEE GREATNESS":"Младият изпълнителен директор: „Когато гледам в камерата, виждам сила и величие в себе си“","CITY INNOVATIONS THE HIGHER YOU GO, THE GREENER IT GETS":"Градски иновации: Колкото по-нависоко, толкова по-зелено става","GREEN HEROES THE URBAN EXPERIENCE JUST GOT A SUSTAINABLE UPGRADE":"Зелени герои: Градското преживяване стана по-устойчиво","INSPIRE IN A MINUTE FROM BULLIED BUG HUNTER TO KID AUTHOR":"Вдъхновение за минута: От тормозен ловец на насекоми до дете-автор","SIGHTS WITH HEIGHTS GHANA’S NATIONAL PARK CANOPY WALK":"Разходка по короните в национален парк на Гана","SIGHTS WITH HEIGHTS THE CLIFF SIDE SANCTUARY BETWEEN HEAVEN AND EARTH":"Приют на ръба на скала – между земята и небето","A PLACE TO CALL HOME FOR ABANDONED DOGS":"Място, което да наречеш дом за изоставени кучета","BARRY THE BEE WHISPERER’S MOST IMPORTANT FIGHT YET":"Най-важната битка на Барри, прошепвача на пчели","CEO ACTIVISM IS ON THE RISE":"Активизмът сред изпълнителните директори се увеличава","INDIGENOUS HEROES NIGERIA'S ELIJAH IS SEEKING LEGAL JUSTICE FOR HIS PEOPLE":"Индigenous герои: Елайджа от Нигерия търси правосъдие за своя народ","INDONESIA TO BUILD A NEW CAPITAL DUE TO CLIMATE CHANGE":"Индонезия ще построи нова столица поради климатичните промени","INSPIRE IN A MINUTE BREAKING BORDERS IS A TOUR YOU HAVE TO GO ON":"Вдъхновение за минута: „Breaking Borders“ е тур, който трябва да посетите","INSPIRE IN A MINUTE FIGHTING MENSTRUAL STIGMA IN NEPAL":"Вдъхновение за минута: Борба със стигмата около менструацията в Непал","INSPIRE IN A MINUTE HELPING KIDS FIGHT BACK & GET BETTER":"Вдъхновение за минута: Помагане на деца да се възстановят и да се справят","MORE THAN HALF OF WORLD’S FOREST WILDLIFE DISAPPEARED":"Повече от половината горска дива природа в света е изчезнала","MY SOCIAL MEDIA ACTIVISM IT'S TIME FOR EVERYONE TO #FILLTHEBOTTLE":"Моят соц. медия активизъм: Време е всички да #FILLTHEBOTTLE","PEACE BUILDERS CLOSING THE CYCLE OF VIOLENCE":"Строители на мир: Прекратяване на цикъла на насилие","PEACE BUILDERS THE ART OF PEACEFUL RESISTANCE":"Строители на мир: Изкуството на мирното съпротивление","PEACE BUILDERS THE UNITING FACTOR THAT'S BRINGING PEOPLE TOGETHER":"Строители на мир: Обединителният фактор, който събира хората","THE RESULTS ARE IN, TOKYO IS THE SAFEST CITY IN THE WORLD":"Резултатите са ясни: Токио е най-безопасният град в света","HOW TO BE GREEN AT HOME NATURAL STAIN REMOVER":"Как да бъдете еко у дома: естествено средство за премахване на петна","WANNA BE A DJ START WITH THE BASICS FROM A PRO":"Искаш да станеш DJ? Започни с основите от професионалист","BEST VR EXPERIENCES INTO THE SHARK TANK":"Най-добрите VR преживявания: В акулската бездна","FROM HUMAN TO CYBORG":"От човек към киборг","FUTURISTIC TRANSPORT GETTING AROUND NEVER LOOKED SO COOL":"Футуристичен транспорт: Пътуването никога не е изглеждало толкова готино","NASA’S NEXT DESTINATION IN 2026 TITAN":"Следващата дестинация на НАСА през 2026: Титан","VISIT A SPACE PLACE KOROLEV, RUSSIA'S DEEP SPACE HISTORY":"Посетете космическо място: Королев – люлката на съветските космически изследвания в Русия","VISIT A SPACE PLACE THE METEOR CRATER":"Посетете метеоритен кратер","VISIT A SPACE PLACE THE NETHERLANDS' SPACE SIMULATOR":"Посетете космическия симулатор в Нидерландия","AMAZING TENNIS COURTS A COURT HIDDEN AMONG CLIFFS":"Изумителни тенис кортове: корт, скрит между скалите","BEST VR EXPERIENCES THE EXTREME SPORTS SIMULATOR":"Най-добрите VR преживявания: симулатор за екстремни спортове","DON’T EXPECT THE U.S. WOMEN’S FOOTBALL SQUAD AT THE WHITE HOUSE":"Не очаквайте женския отбор по футбол на САЩ в Белия дом","FUTURE FEMALE FOOTBALLER COLOMBIA'S SALOME IS GONNA BE A PRO":"Бъдеща футболна звезда: Саломе от Колумбия ще стане професионалист","MY UNDERGROUND SPORT ALAN NASTY NASH IS A CHAMP TOE WRESTLER":"Моят подземен спорт: Алан Нейсти Наш е шампион по борба с пръсти на краката","MY UNDERGROUND SPORT KABADDI'S GROWING IN INDIA":"Моят скрит спорт: Кабади се разраства в Индия","SPORT FOR CHANGE A GOAL FOR INCLUSION":"Спорт за промяна: Цел за приобщаване","SPORT FOR CHANGE THE INITIATIVE HITTING IT OUT OF THE PARK":"Спорт за промяна: Инициативата, която разчупва рамките","THE 5 BEST SUMMER FOOTBALL TRANSFERS SO FAR!":"5-те най-добри летни трансфера във футбола досега!","COACHES CLINIC PETE HERRMAN":"Клиника за треньори: Пийт Херман","DRIBBLE DRIVE MOTION SKILLS":"Умения за движение: Дрибъл и шут","GAMCA COACHES CLINIC":"GAMCA клиника за треньори","ROBERT TUTEIN (UTICA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Робърт Тутейн (Утика) - номиниран за играта на годината GEICO 2016","RYAN KELLEY (ARCADIA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Райън Кели (Аркадия) - номиниран за играта на годината GEICO 2016","SAM BORST SMITH (ROCHESTER) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Сем Борст Смит (Рочестър) - номиниран за играта на годината GEICO 2016","SPECIAL SPECTATORS VISITS THE COLLEGE SLAM DUNK & 3- POINT CHAMPIONSHIPS INTERSPORT":"Специални зрители посещават колежанския шампионат по забиване и тройки INTERSPORT","TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Тенър Шийв (Wisconsin Lutheran College) - номиниран за играта на годината GEICO 2016","TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Тревор Кризенески (Concordia University Wisconsin) - номиниран за играта на годината GEICO 2016","VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Венки Джойс (Eastern Washington) - номиниран за играта на годината GEICO 2016","LEARN FREESTYLE FOOTBALL TRICKS LEMMENS AROUND THE WORLD":"Научете фрийстайл футболните трикове на Леменс по целия свят","PRO FOOTBALLER TRAINING A NEED FOR SPEED":"Тренировка на професионален футболист: нужда от скорост","PRO FOOTBALLER TRAINING LEG-FOCUSED EXERCISES":"Тренировка за професионален футболист: упражнения за краката","PRO FOOTBALLER TRAINING MUSCLES-FOCUSED EXERCISES":"Тренировка за професионален футболист: упражнения за мускулите на краката","THERE’S NO POWER FROM KEEPING IT TO YOURSELF'":"Няма сила в това да го държиш за себе си!","3 THINGS MALALA HAS SAID THAT WILL TOTALLY INSPIRE YOU":"3 цитата на Малала, които ще ви вдъхновят","BORDER ANGELS SAVING LIVES WITH WATER":"Гранични ангели спасяват животи с вода","BULLIED TO INFLUENCER 'PAINTING HELPS ME DODGE MY PROBLEMS":"От тормозен до влиятелен: „Рисуването ми помага да избегна проблемите“","BULLIED TO INFLUENCER 'YOU CAN BE THE LIGHT IN THE DARKNESS":"От тормозен до влиятелен: „Можеш да бъдеш светлината в мрака“","PEACE BUILDERS FIGHTING GANGS WITH CLOWNING":"Строители на мир: борба с банди чрез клоунада","PEACEBUILDERS INSIDE THE COMMUNITY RING":"Строители на мир: в общностния ринг","SPORT FOR CHANGE A SURE SHOT TO FEMALE EMPOWERMENT IN ZIMBABWE":"Спорт за промяна: сигурен удар за овластяване на жените в Зимбабве","YOUNG CEO MR. CORY’S COOKIES":"Млад изпълнителен директор: „Господин Кори и бисквитките му“","CRAZY CRAVINGS 'I'VE BEEN EATING CHALK FOR OVER TWENTY YEARS":"Дива страст: „Ям тебешир вече над двадесет години“","DARGAVS WELCOME TO THE CITY OF THE DEAD":"Даргавс: Добре дошли в града на мъртвите","HEROES NEIGHBORHOOD TOUR FRIDA KAHLO":"Обиколка на квартала на героите: Фрида Кало","SOLO TRIP HIDDEN GEMS OF BALI":"Самотно пътуване: скрити бисери на Бали","SOLO TRIP HIDDEN GEMS OF BOGOR (INDONESIA)":"Самотно пътуване: скритите бисери на Богор (Индонезия)","SOLO TRIP THE HIDDEN GEMS OF ROTTERDAM":"Самотно пътуване: скритите бисери на Ротердам","SUGARY DRINK LOVERS, THIS ONE'S FOR YOU!":"Любители на сладки напитки, това е за вас!","THE 5 MOST ICONIC ARMANI RED CARPET LOOKS OF ALL TIME":"5-те най-емблематични червени килими на Армани за всички времена","THE MOST AMAZING ISLAND CANARY ISLANDS":"Най-удивителният остров: Канарски острови","THE MOST AMAZING ISLAND FAVIGNANA SICILY":"Най-удивителният остров: Фавиняна, Сицилия","THE MOST AMAZING ISLAND TEXEL":"Най-удивителният остров: Тексел","THESE NATIONS GIVE EXPATS THE BEST ONLINE LIFE":"Тези държави дават на експатите най-добрия онлайн живот","5 GAMES YOU WILL LOSE FRIENDS OVER":"5 игри, заради които ще загубите приятели","5 REASONS TO PLAY MONSTER HUNTER WORLD":"5 причини да играете Monster Hunter World","BEST VR EXPERIENCES THE SURVIVAL TEST":"Най-добрите VR преживявания: тест за оцеляване","PLACE YOUR BETS! GTA IS GETTING A REAL VIRTUAL CASINO":"Слагайте залозите! GTA получава реално виртуално казино","TOP 5 GAMING LAWSUITS":"Топ 5 съдебни дела в гейминг индустрията","TOP 5 HIGHEST GROSSING ARCADE GAMES":"Топ 5 най-печеливши аркадни игри","TOP 5 LEGENDARY GAME COUPLES":"Топ 5 легендарни гейм двойки","BUILDERS OF TOMORROW SOLAR WATER HEATER FROM PLASTIC BOTTLES":"Строителите на утрешния ден: слънчев бойлер от пластмасови бутилки","GOT PLASTIC HERE ARE FOUR INNOVATIVE WAYS TO DEAL WITH IT!":"Имаш пластмаса? Ето четири иновативни начина да се справиш!","SAVING THE PLANET AND MAKING ART, ONE BUTT AT A TIME":"Спасяване на планетата и създаване на изкуство — по един отпадък наведнъж","THE FASTEST WAY TO SAVE THE PLANET":"Най-бързият начин да спасиш планетата","THE UNIQUE ARTIST TURNING TIRES IN MASTERPIECES":"Уникален артист превръща гуми в шедьоври","4 LESSONS TO LEARN FROM BUSINESS MOGUL ARIANNA HUFFINGTON":"4 урока от бизнес магнатката Ариана Хъфингтън","BUILDERS OF TOMORROW A FUTURE PAVED WITH PLASTIC":"Строителите на утрешния ден: бъдеще, застлано с пластмаса","JUST HOW VULNERABLE ARE JOBS TO ROBOT TAKEOVERS":"Колко уязвими са работните места за превземане от роботи","BEST RUGBY SKILLS - STEPS, TRICKS, OFFLOADS COMPILATION":"Най-добрите ръгби умения - компилация от стъпки, трикове и подавания","BEST RUGBY SKILLS 2018":"Най-добрите ръгби умения 2018","BEST RUGBY TRIES 2018":"Най-добрите ръгби опити 2018","CRAZIEST RUGBY SKILLS":"Най-лудите ръгби умения","EPIC RUGBY SKILLS 2017":"Епични ръгби умения 2017","EPIC RUGBY STEPS 2018":"Епични ръгби стъпки 2018","RUGBY BIG HITS 2018":"Големи ръгби сблъсъци 2018","DITCH THE DOCTOR! HOW ABOUT DIAGNOSIS BY COMPUTER":"Предай лекаря! Какво ще кажете за диагноза от компютър","ESPN'S NEW DEAL DIVES INTO THE WORLD OF DRONE RACING":"Новата сделка на ESPN разглежда света на дрон състезанията","EVER WISHED BEER COULD FLY NOW IT CAN!":"Някога мечтаехте бирата да лети? Сега може!","HEARING THINGS HERE ARE 5 FACTS ON OUR INNER VOICE":"Чувай неща: 5 факта за нашия вътрешен глас","IS SPOTTY SKIN THE ANSWER TO LOOKING YOUNGER":"Дали нацъфтялата кожа е отговорът за по-млад вид?","JUST WHY ARE THE DUTCH SO TALL":"Защо холандците са толкова високи?","MEET THE ROBOT THAT WANTS TO GET TO KNOW YOU":"Запознайте се с робота, който иска да ви опознае","STAR WARS BECOMES REALITY IN A POST-APOCALYPTIC MALL":"Star Wars става реалност в пост-апокалиптичен мол","SUGAR TAX THE ANSWER TO OBESITY PANDEMIC":"Данък върху захарта — отговорът на пандемията от затлъстяване","SWALLOW THIS NANO CHIP TO KNOW WHAT S MAKING YOU SICK":"Погълнете този наночип, за да разберете какво ви разболява","THE EXPLODING COST OF CYBERATTACKS":"Експлодиращата цена на кибератаките","TURNS OUT EMAILS DIDN'T SOLVE OUR WASTE PAPER PROBLEMS":"Оказва се, че имейлите не решиха проблема с отпадъците от хартия","UK DRONE SHOW THE LATEST CONSUMER INDUSTRY TRENDS":"Британско дрон шоу: последните потребителски тенденции","VR RUNNING OF THE BULLS! A FEARFUL THRILLSEEKERS DREAM":"VR бягане на бик! Мечта за търсачите на адреналин","AMAZING WATERFALLS ZAMBIA'S JAW-DROPPING NATURAL WONDER":"Удивителни водопади: зашеметяващото природно чудо на Замбия","FAIRY TALE DREAM SPOTS THE PRETTIEST VILLAGE IN ANDALUCÍA":"Приказни мечтани места: най-красивото село в Андалусия","FAIRY TALE DREAM SPOTS THE SINKING CASTLE OF SCALIGERA":"Приказни мечтани места: потъващият замък Скалигера","MEDELLÍN IS THE BACKPACKING SPOT YOU'VE BEEN LOOKING FOR":"Меделин е мястото за гръбначно пътуване, което търсите","SIGHTS WITH HEIGHTS THE NARROW BRIDGES OF CAMINITO DEL REY":"Атракции на височина: тесните мостове на Caminito Del Rey","THIS DUTCH PARADE TAKES FLOWER POWER TO THE NEXT LEVEL":"Тази холандска парада вдига силата на цветята на ново ниво","INSTA RESTAURANT WE COULD ALL USE A BIT MORE PINK IN OUR LIVES":"Инстаграм ресторант: всички бихме искали малко повече розово в живота си","KFC IS TESTING MEATLESS CHICKEN WINGS AND NUGGETS":"KFC тества безмесни пилешки крилца и нагетси","TURNING LEFTOVER BREAD INTO PANZANELLA & BRUSCHETTA CAPRESE":"Как да превърнете остатъчен хляб в панзанела и брускета капрезе","SALSAS FOR SUNNY DAYS SPICY MANGO SALSA":"Сосове за слънчеви дни: пикантен манго сос","VEGAN ICE CREAM AVOCADO BANANA":"Веган сладолед: авокадо и банан","VEGAN ICE CREAM COCONUT FUSION":"Веган сладолед: кокосов фюжън","VEGAN ICE CREAM FRESH FRUIT POPSICLES":"Веган сладолед: плодови близалки","VEGAN ICE CREAM PINEAPPLE MINT LIME":"Веган сладолед: ананас, мента и лайм","VEGAN ICE CREAM BANANA MATCHA":"Веган сладолед: банан и матча","BRAIN IMPLANTS ARE CLOSER THAN YOU MIGHT THINK":"Имплантите в мозъка са по-близо, отколкото мислите","THANKS, CHAMELEONS HUMANS MIGHT GET COLOR-CHANGING SKIN":"Благодарение на хамелеоните хората може да получат кожа, която променя цвета си","ARM AND LEG RAISE":"Повдигане на ръце и крака","CONDITION TRAINING":"Тренировка за кондиция","CORE STRENGTH":"Укрепване на централните мускули","LUNGES":"Напади","PUNCH BAG":"Боксова круша","SHADOW BOXING":"Бокс в сянка","STRETCHING":"Разтягания","2016 CHEVROLET CAMARO SS":"Насладете се на Chevrolet CAMARO SS 2016","2016 FORD MUSTANG FASTBACK":"Насладете се на Ford Mustang Fastback 2016","2016 FORD MUSTANG GT4":"Насладете се на Ford Mustang GT4 2016","2016 TOYOTA PRIUS G RACING CAR":"Насладете се на Toyota Prius G 2016","2016 TOYOTA XTREME COROLLA":"Насладете се на Toyota Extreme Corolla 2016","ARABIC EPS 1 - HOW TO INTRODUCE YOURSELF":"Научи арабски - как да се представяш","ARABIC EPS 2 - THANK YO":"Научи арабски - как да кажеш „благодаря“","ENGLISH EPS 3 - ASKING ABOUT HOBBIES":"Научи английски - как да говориш за хобита","ENGLISH EPS 4 - WHERE ARE YOU FROM":"Научи английски - откъде си?","FRENCH EPS 5 - HOW TO APOLOGIZE":"Научи френски - как да се извиняваш","FRENCH EPS 6 - ASKING DO YOU SPEAK ENGLISH":"Научи френски - как да попиташ „Говориш ли английски?“","ITALIAN EPS 7- APOLOGIES":"Научи италиански - извинения","ITALIAN EPS 8 - HOW MUCH":"Научи италиански - колко струва?","SPANISH EPS 9 - WHERE ARE YOU FROM":"Научи испански - откъде си?","SPANISH EPS 10 - WHAT'S UP":"Научи испански - какво става?","HOW TO POST NATAL YOGA BREATHING EXERCISE":"Дихателни упражнения за следродилна йога","HOW TO IN 60 SECONDS":"Как да - за 60 секунди","HOW TO POST NATAL YOGA - DANDASANA":"Следродилна йога - Dandasana","HOW TO POST NATAL YOGA - IF BABY NEEDS ENTERTAINMENT":"Следродилна йога - ако бебето се нуждае от забавление","PILATES HALF ROLL BACK":"Пилатес - Half Roll Back","BECOME FLEXIBLE WITH YOGA":"Станете гъвкави с йога","FIND PEACE AT HOME WITH YOGA":"Намерете мир у дома с йога","FIND PEACE WITH YOGA":"Намерете спокойствие с йога","GET SLIM & FIT WITH YOGA":"Станете стройни и в добра форма с йога","LEARN THE ART OF YOGA":"Научете изкуството на йога","LOST WEIGHT WITH YOGA":"Отслабнете с йога","MASTER CORE YOGA POSES":"Овладейте основните йога пози за центъра","MIND OVER MATTER":"Разум над материята","ULTIMATE YOGA GUIDE":"Крайното ръководство за йога","YOGA VILLAGE":"Йога село","YOGA YOUR WAY TO HEALTHY LIVING":"Йога - пътят към здравословен живот","ANIMALS EXOTICOS":"Екзотични животни","AUTOMATU":"Автомати","BABIES AND MOVING TABLE PART 1":"Бебета и въртяща се маса Част 1","BAD KIDS THROW ORANGE PEELS PART 1":"Досадни деца хвърлят портокалови кори Част 1","BIG BUNNY SCARES BABIES PART 1":"Голямо зайче плаши бебета Част 1","BODYGUARDS":"Тялохранители","CAKE ON FACE":"Торта в лицето","CAN I CLICK YOUR PHOTO":"Мога ли да те снимам?","CAR PARKING":"Паркиране","CAR FOR SALE":"Коли за продажба","MAN FALLING ON LADDER":"Мъж пада от стълба","MAN IN GARBAGE CAN PART 1":"Мъж в кофа за боклук Част 1","PAINTING EXHIBITION":"Изложба на рисунки","RECKLESS BLIND MAN PART 1":"Безразсъден слепец Част 1","ROLLER BLADER PART 1":"Каране на ролери Част 1","RUDE MAN ON BEACH PART 1":"Груб мъж на плажа Част 1","SANTA CLAUS THE PERVERT PART 1":"Дядо Коледа развратник Част 1","BABY CARIER ON CAR":"Детско столче в кола","BLEEDING NOSE":"Кървящ нос","MONEY FALLING":"Дъжд от пари","OPEN THIS PEN":"Погледни това химикалче","GLAMOROUS TOUCH":"Бляскав щрих","LIPS GLAMOROUS RED":"Бляскави червени устни","LIPS NATURAL":"Естествени устни","LIPS SPARKLING AND FULL":"Блестящи и пълни устни","MAKE-UP BLUSH":"Грим - руж","MAKE-UP BRONZER":"Грим - бронзър","MAKE-UP CONCEALER":"Грим - коректор","MAKE-UP EYEBROWS":"Грим - вежди","MAKE-UP FOUNDATION":"Грим - фон дьо тен","SMOKEY EYES":"Грим - опушени очи","SPARKLING EYES":"Грим - бляскави очи","5 MAKE UP TIPS AND TRICKS FOR YOU":"5 трика и съвета за грим за теб","7 MAKE UP TIPS AND TRICKS FOR FLAWLESS SKIN":"7 трика за перфектна кожа","10 FAST AND EASY MAKE UP TIPS":"10 бързи и лесни съвета за грим","10 MAKE UP TIPS AND TRICKS FOR OILY SKIN":"10 съвета за грим за мазна кожа","13 MAKE UP MISTAKES TO AVOID":"13 грешки в грима, които да избегнете","101 TIPS FOR BEGINNER MAKE UP":"101 съвет за начинаещи в грима","ASIAN BEAUTY TIPS YOU MUST DO NOW":"Азиатски съвети за красота, които трябва да опитате","BEGINNER EVERY MAKE UP TIPS AND TRICKS FOR YOU":"Грим за начинаещи - всички трикове и съвети за вас","BEST MAKE UP ARTIST TIPS YOU NEED TO KNOW":"Най-добрите съвети от гримьори, които трябва да знаете","ESSENTIAL MAKE UP TIPS FOR SUMMER GLOW":"Основни грим съвети за летен блясък","FLATTERING EYES MAKE UP FOR YOU":"Грим за привлекателен вид на очите","FOUNDATION TRICKS FOR OILY SKIN":"Трикове за фон дьо тен при мазна кожа","FULL COVERAGE FOUNDATION ROUTINE FOR YOU":"Рутини за пълно покритие с фон дьо тен","LOOK FIERCE WITH DRUGSTORE MAKE UP":"Изглеждай яко с грим от дрогерията","MAKE UP ESSENTIALS FOR DARK SKIN TONES":"Основни грим продукти за тъмни тонове кожа","MAKE UP TIPS FOR AGING EYES":"Съвети за грим за очи на зрели жени","MAKE UP TIPS FOR FLAWLESS SKIN":"Съвети за грим за безупречна кожа","MUST KNOW MAKE UP TIPS":"Съвети за грим, които трябва да знаете","MUST KNOW WAKE UP TIPS":"Съвети за събуждане, които трябва да знаете","NATURAL MAKE UP KOREAN STYLE":"Естествен грим в корейски стил","NATURAL MAKE UP TIPS FOR MEN":"Естествен грим съвети за мъже","NATURAL TO GLAMOROUS":"От естествено към бляскаво","OVER 40 AGED WOMAN MAKE UP TIPS":"Грим съвети за жени над 40","PRO MAKE UP TIPS BY TATI":"Професионални грим съвети от Тати","SECRET MAKE UP TIPS AND TRICKS FOR BEGINNERS":"Тайни трикове и съвети за грим за начинаещи","SIMPLE TIPS FOR EYESHADOW":"Прости съвети за избор на сенки","SUMMER MAKE UP MELTPROOF TIPS":"Съвети за устойчив грим през лятото","TOP 10 SECRET TIPS OF CELEBRITIES":"Топ 10 тайни съвета от знаменитости","TOP 25 MAKE UP TIPS FOR PALE SKIN":"Топ 25 грим съвета за бледа кожа","TYRA BANKS MAKE UP TIPS":"Грим съвети от Тайра Бенкс","ANIMALS CRUSH MATCH 3":"Животни Краш Мач 3","AGENTHAL2":"АгентХал2","APPLE AND ONION TROLLYDASH":"Ябълка и Лук: Количкова Надпревара","ADVENTURE TIME FANGS FOR THE MEMORIES":"Време за приключения: Зъби за спомени","BEN 10 THE CLOSE UPS QUIZ":"Бен 10: Куиз с близки кадри","BEN 10 NO ARM DONE":"Бен 10: Без вреда","BEN 10 WORLD RESCUE":"Бен 10: Спасение на света","ALICE LEWIS JIGSAW PUZZLE":"Алис Луис: Пъзел","2048 LLAMA EDITION":"2048 Лама Едишън","AMERICAN FOOTBALL":"Американски футбол","BEN 10 WILDVINE SHOOT":"Бен 10: Дивото лозо стрелба","APPLE ONION BOTTLE CATCH":"Ябълка и Лук: Хващане на бутилки","BEN 10 OMNITRIX GLITCH":"Бен 10: Оmnитрикс бъг","BANANAMAN SPACE CHASE":"Бананамeн: Космическо преследване","BARBIE SPARKLE MOUNTAIN RIDE":"Барби: Блестящата планинска езда","BEN 10 OMNICODE":"Бен 10: Оmникод","BEN 10 MATCH UP":"Бен 10: Съчетай двойките","APPLE ONION CAT RESCUE":"Ябълка и Лук: Спасение на котка","BEN 10 HERO TIME GAME":"Бен 10: Време за герой","AVALAUNCH":"Аваланч","BEN 10 ALIEN RUSH":"Бен 10: Извънземно бързане","BEN 10 DIAMONDHEAD SHOOT":"Бен 10: Диамантена глава – Стрелба","BEN 10 CHALLENGE":"Бен 10: Предизвикателството","BASKETBALL STARS 3":"Баскетболни звезди 3","BEACHY KEEN SPONGEBOB":"Спонджбоб: Плажно приключение","BATTER UP":"На бийзбол готови!","BATWHEELS BY YOU":"Batwheels: От теб по избор","BE COOL SCOOBY DOO NO GUTS NO TREATS":"Бъди готин, Скуби-Ду: Без смелост няма награда","BE COOL SCOOBY DOO THE MYSTERIOUS MANSION":"Бъди готин, Скуби-Ду: Тайнственото имение","BATTLE DAY BRAWL":"Боен ден: Схватка","BARBIE SPY":"Барби: Шпионин","BEARY SPOT ON":"Мечешко попадение","BEN 10 OVERFLOW FIGHT":"Бен 10: Овърфлоу битка","ADVENTURE TIME CANDY DIVE":"Време за приключения: Бонбонско гмуркане","BEANO BUSH CHUCKER CHALLENGE":"Беано: Хвърляне в храстите – Предизвикателство","ADVENTURE TIME ANGRY BETTY":"Време за приключения: Ядосаната Бети","BEAN SKIDDING":"Плъзгащ се боб","BEN 10 POWER SURGE":"Бен 10: Енергиен наплив","BEN 10 OMNITRIX SHADOW":"Бен 10: Сянката на Оmnитрикса","BEN 10 PENALTY POWER":"Бен 10: Силата на дузпите","BEN 10 SPOT THE DIFFERENCE":"Бен 10: Открий разликите","ADAM AND EVE SLEEPWALKER":"Адам и Ева: Сомнамбул","BACKYARD HOOPS":"Баскетбол в задния двор","BACKYARD JUNK":"Боклуци в задния двор","BEN 10 ALIENRIVALS V2":"Бен 10: Извънземни съперници V2","BEN 10 ESCAPE ROUTE":"Бен 10: Път за бягство","BEN 10 STEAM CAMP":"Бен 10: Парен лагер","BEN 10 CANNONBOLT SMASH":"Бен 10: Канонболт Смачкване","BARBIE MAKE UP":"Барби: Грим","BEATS BATTLE":"Битка с бийтове","ADVENTURE TIME GATE CRASHERS":"Време за приключения: Портални нашественици","ADVENTURE TIME THESE LUPMS":"Време за приключения: Тези бабуни","BEN 10 TOMB OF DOOM":"Бен 10: Гробница на гибелта","ALVIN SUPER RUN":"Алвин: Супер бягане","ADVENTURE TIME FIONNA FIGHTS":"Време за приключения: Фиона се бие","BERRIES":"Плодчета","ALL THAT EMPLOYEE":"Служител на шоуто All That","BEN 10 UNDERTOWN RUNNER":"Бен 10: Бягащ в Ъндъртаун","DOODLE TANKS":"Дудъл танкове","ABSOLUTE TALENT":"Абсолютен талант","CHARLIE THE DINO RESCUE TEAM":"Чарли и екипът за спасяване на динозаври","SHARDS":"Фрагменти","BAD SPIDER THIEF":"Лошият паяк крадец","CHAINSAW MAN FIGHTER":"Биецът с верижен трион","BLOCK PUZZLE":"Блок пъзел","CAVEMAN CHUCK ADVENTURE":"Приключението на Пещерняка Чък","PIRATES! THE MATCH-3":"Пирати! Мач-3","DOODLE GOD 8-BIT MANIA":"Дудъл Бог: 8-битова мания","GREEN DINO RUN":"Бягството на зеления динозавър","HELICOPTER FIGHTER":"Хеликоптер боец","TALES OF THE ORIENT - THE RISING SUN":"Приказки от Ориента – Изгряващото слънце","MALDIVES FRIENDS":"Приятели от Малдивите","GENIAL SANTA CLAUS2":"Веселият Дядо Коледа 2","DEATH BY NINJA":"Смърт от нинджа","CARE FORT":"Грижовна крепост","WOODVENTURE":"Дървено приключение","DOODLE KINGDOM":"Дудъл кралство","MR RACER":"Г-н Състезател","FIRE LORDS":"Господарите на огъня","CAR RACING SPEED":"Скоростно автомобилно състезание","ALCHEMY JAM":"Алхимичен джем","FRUIT DATING":"Плодови срещи","GUESS CELEB NAMES":"Познай името на звездата","GUN STRIKE FIRE":"Огнева атака","ZOMBUMP 372":"Зомбъмп 372","SRCH":"Търсене","FINDING MENG":"Откриване на Мън","CELL MACHINE":"Клетъчна машина","VINTAGE TRIPEAKS":"Ретро трипийкс","CALL OF SNIPER WW2":"Призивът на снайпериста: Втората световна","DOODLE GOD FANTASY WORLD OF MAGIC":"Дудъл Бог: Фантастичен свят на магията","DEMONS AND DUNGEONS":"Демони и подземия","SACRA TERRA KISS OF DEATH":"Сакра Терра: Целувката на смъртта","JAIL PRISON BREAK 2018":"Бягство от затвора 2018","US POLICE TRAIN TRANSPORTER TRUCK ROBOT STUNT GAME":"САЩ полицейски влак – транспортьор, камион, робот каскадьор","NEED THE SPEED":"Нужда от скорост","BAZOOKA GUNNER WAR STRIKE 3D":"Базука стрелец: Военен удар 3D","SEA FISHING":"Морски риболов","LAZY NINJA":"Мързеливият нинджа","SPIDER SIMULATOR AMAZING CITY 3D":"Паяк симулатор: Невероятният град 3D","FPS SHOOTER COUNTER TERRORIST":"FPS стрелец: Контратерорист","LEGENDARY TOWER STRATEGY":"Легендарна кулична стратегия","TURBO RACER":"Турбо състезател","BARDBARIAN":"Барбаринът","RONALDO KICK N RUN":"Роналдо: Ритни и тичай","TOWER DEFENSE 2D":"Кулична отбрана 2D","TINY MINER":"Малкият миньор","TNT KART":"ТНТ карт","WILD ANIMAL REAL HUNTER WILD SHOOTING GAMES":"Лов на диви животни: Игри със стрелба","HIT DODGE ZBANG":"Удари, избегни, сблъсък","3D BATTLE TRUCK":"3D боен камион","GLORY WARRIOR LORD OF DARKNESS":"Воин на славата: Господарят на мрака","PIXEL ART BOOK - COLOR BY NUMBER":"Пиксел арт книга – оцветяване по номера","POOL PRO":"Про билярд","CALL OF SNIPER DUTY":"Призивът на снайпериста","STEREOTYPO":"Стереотипо","NIGHTS AT TATTLETAIL HOUSE 3D":"Нощи в къщата на Татълтейл 3D","RISE OF NATION FAITH":"Възход на нацията: Вяра","BEAR HAVEN":"Меча убежище","FRIDAY 13TH JASON KILLER":"Петък 13-ти: Джейсън убиецът","ETERNAL THRONE":"Вечният трон","CHRISTMAS NIGHT OF HORROR":"Коледна нощ на ужаса","FRACTAL COMBAT X":"Фрактален бой X","WILD ANIMAL ZOO CITY SIMULATOR":"Симулатор: Зооград с диви животни","KONAN SURVIVAL BARBARIAN EXILE":"Конан: Оцеляване на изгнаника варварин","MIGHTY DUNGEONS":"Могъщи подземия","LEGENDARY HEROES":"Легендарни герои","HIGHWAY DRIVER 3D":"Шофьор на магистрала 3D","LORD OF MAGIC":"Господар на магията","PULIMURUGAN":"Пулимурган","PULIMURUGAN 3D":"Пулимурган 3D","HIGHWAY SPEED MOTO BIKE DRIVER":"Мотоциклетен шофьор със скорост по магистралата","ILLAM ESCAPE VR":"Бягство от Иллам VR","MATCH CONNECT":"Съвпадение и свързване","HIGH FLY VALENTINE":"Високолетящ Валентин","PIXEL SURVIVAL DEAD ZOMBIE":"Пиксел оцеляване: Мъртви зомбита","TRIVIA QUIZZES":"Тривия въпроси","MATH GAMES":"Математически игри","POEMS LOVE FAMILY FRIENDS":"Стихове: любов, семейство, приятели","SPELLING MASTER":"Майстор на правописа","NINJA GIRL SWING":"Нинджа момиче люлка","KAHVE FALI":"Кафе гадание","COLONIES":"Колонии","HIDDEN NUMBERS":"Скрити числа","HOROSCOPE":"Хороскоп","WORD CONNECT":"Свържи думите","GUESS AND FIND":"Познай и намери","IMPOSSIBLE BALL GLOW TWIST":"Невъзможната топка: светещ обрат","ULTIMATE UNDEAD INVASION APOCALYPSE":"Крайна инвазия на немъртвите: Апокалипсис","CRIMINAL PURSUIT 3D":"Преследване на престъпници 3D","INCREDIBLE MONSTER HERO SUPER PRISON ACTION":"Невероятният герой чудовище: Бягство от супер затвор","CONTRACT HUNTER ZOMBIE KILLER":"Наемен ловец: Убиец на зомбита","COMMANDO COMBAT TRAINING 3D":"Командос бойно обучение 3D","BORDER WAR ENEMY TERRITORY":"Гранична война: Вражеска територия","SNIPER CAR 3D":"Снайперистки автомобил 3D","COMBAT MENACE MADNESS 3D":"Бойна заплаха: Лудост 3D","RICE OF NOTION FAITH":"Възход на Нотион: Вяра","SNIPER TEAM 3D":"Снайперски отбор 3D","NINJA CLASH":"Нинджа сблъсък","GUNSHIP BATTLE OF WORLD HELLICOPTERS":"Вертолети: Световна въздушна битка","SHOOTING KING BOTTLE SHOOT":"Крал на стрелбата: Стреляне по бутилки","SEA BATTLE":"Морска битка","ARMY VEHICLE MADNESS":"Лудост с военни превозни средства","ARMY PHYSICS PALACE":"Физически дворец на армията","AIR STRIKE WAR":"Война с въздушни атаки","COMBANT DUTY MODERN STRIKE":"Бойно дежурство: Модерен удар","FRONTLINE COMMANDO WAR ONE MAN ARMY":"Командос на фронтовата линия: Армия от един човек","GRAVITY RACE BOY":"Момче в гравитационна надпревара","AEROPLANE PARKING GAME":"Игра за паркиране на самолет","AIR RACING":"Въздушни състезания","EYES - THE HORROR GAME":"Очите – игра на ужасите","DEAD ROADKILL HIGHWAY":"Мъртва магистрала","360 NINJA":"360 нинджа","HELI AIR GUNSHIP STRIKE WAR":"Въздушен удар с боен хеликоптер","DEAD ORBIT":"Мъртва орбита","SPACE EXPEDITION":"Космическа експедиция","CHOPTER MANIA":"Хеликоптерна мания","HAUNTED LEGENDS UNDERTAKER":"Обитавани легенди: Гробарят","DINO HUNTING 2018":"Лов на динозаври 2018","GRAND CRIME GANGSTA VICE MIAMI":"Голям криминален гангстер: Вайс Маями","SONNY THE MAD MAN":"Сони – лудият човек","CIRCUS RESCUE":"Цирково спасяване","PUSHING BOY":"Момчето тласкач","CLIMBING NINJA":"Катерещ се нинджа","ASSAULT FURY MISSION COMBAT":"Щурмова ярост: Бойна мисия","WILD RUN":"Див бяг","FLIGHT COMBAT":"Въздушен бой","CRAZY BOAT RACE":"Луда лодкова надпревара","BODYGUARD":"Бодигард","FIRE FYING DRAGON SIMULATOR WARRIOR SKY RIDER 3D":"Огнен летящ дракон: Воин – небесен ездач 3D","NINJA COMBAT SAMURAI WARRIOR":"Нинджа битка: Самурай воин","CAT RUN":"Котешки бяг","DINOSAUR HUNTER":"Ловец на динозаври","SUBWAY SURFERS - NEW YORK":"Subway Surfers – Ню Йорк","JURASSIC MANIA":"Юрска мания","FLYING KNIFE":"Летящ нож","ASIAN RANGER MADNESS":"Азиатски рейнджър: Лудост","TEMPLE RUMBLE JUNGLE ADVENTURE":"Храмови тътени: Джунглова приключения","BLOW YOUR WAY":"Взриви си пътя","IMPOSSIBLE ESCAPE 3D":"Невъзможно бягство 3D","GOOD KNIGHT PRINCESS RESCUE":"Добър рицар: Спасение на принцесата","MONSTER TRUCK UNLEASHED":"Освободен чудовищен камион","EXTREME BIKE MADNESS 3D":"Екстремна мото лудост 3D","FIRE TRUCK RACING 3D DELUXE":"Пожарни камиони: Надпревара 3D Делукс","PRADO PARKING GAME 2018":"Паркиране на Прадо 2018","SKI NINJA":"Ски нинджа","SPEED NIGHT CAR RACERS":"Нощни автомобилни състезатели","2 MOTO CAR RACING":"2 мото автомобилни състезания","CARTOON CAR CRASH DERBY DESTRUCTION WORLD":"Анимационен дерби свят: Разрушаване на коли","MOTO BIKE HILL RACER NITRO 3D":"Мото състезател по хълмове Нитро 3D","MOTOR BIKE RACER":"Мотоциклетен състезател","PARKING CHAMP":"Шампион по паркиране","MONSTER TRUCK EXTREME DASH":"Чудовищен камион: Екстремен спринт","CHAINED CARS RACING":"Състезания с оковани коли","REAL CAR DIFT RACE MANIA 3D":"Истински дрифт мания 3D","CAR PARKING REAL 3D SIMULATOR":"Реален 3D симулатор за паркиране","ZOMBIE ROADRASH":"Зомби пътна ярост","CITY MOTO RACER":"Градски мото състезател","BIKE TRIALS":"Мото изпитания","RACE AGAINST THE TRAFFIC":"Надпревара срещу трафика","MOTOCROSS BIKE RACING STUNT":"Мотокрос каскади и състезания","GHOST RIDE 3D SEASON 2":"Призрачно каране 3D Сезон 2","RACE ILLEGAL HIGH-SPEED 3D":"Незаконно високоскоростно състезание 3D","BOUNCY BOAT MADNESS PRO":"Подскачаща лодка: Лудост Про","ADRENALINE BMX":"Адреналин BMX","HORSE RACING DERBY GAME":"Конно дерби","MOUNTAIN CLIMB 4X4 CHALLENGE":"Планинско катерене 4x4","FINAL NIGHT ZOMBIE STREET FIGHT":"Последна нощ: Битка със зомбита","DRIVE SIMULATOR 2016":"Шофьорски симулатор 2016","3 BALL BILIARDS":"Билярд с 3 топки","TRIAL EXTREME 2 HD":"Екстремен траял 2 HD","BIKE ME":"Карай ме","GYMNASTICS ATHLETIC CONTEST":"Състезание по гимнастика","FOOTBALL ONLINE CHAMPIONSHIP":"Онлайн футболно първенство","CRICKET STREET CUP":"Улична купа по крикет","FIGHT CLUB REVOLUTION 2":"Боен клуб Революция 2","BRAZIL TRAINING COURSE":"Тренировъчен курс – Бразилия","MARBLE DUEL":"Мраморен дуел","TRIAL LEGENDS 2 PRO":"Легенди на траяла 2 Про","SLOG CRICKET":"Слог крикет","SPIDER HUNTER AMAZING CITY 3D":"Ловец на паяци: Удивителен град 3D","SUPER HILL BICYCLE RACING":"Супер колоездачна надпревара по хълмове","DART MASTER":"Майстор на дартса","ICE RAGE":"Ледна ярост","TAP SOCCER":"Тап футбол","MAHJONG DELUXE":"Маджонг Делукс","POOL BREAK PRO":"Професионален билярд Брейк","DESERT DEVIL MOTO RACE":"Пустинен дявол: Мото надпревара","privacy-policy-gr-head1":"1. Политика за поверителност: цели и обхват","privacy-policy-gr-Purposes-desc1":"Настоящата Политика за поверителност се отнася до предоставянето на услуги от компанията Sam Media BV, със седалище в Нидерландия (Van Diemenstraat 356 1013 CR Amsterdam) с ДДС номер VAT NL 8187 94 859 B01 и регистрационен номер 164831301000 в съответната търговска камара (наричана по-нататък „Компанията“).","privacy-policy-gr-Purposes-desc2":"Целта на настоящата Политика за поверителност е да опише начина на събиране и обработка на лични данни, които се получават чрез интернет или по други начини, както и практиките за поверителност на Компанията.","privacy-policy-gr-Purposes-desc3":"Компанията се ангажира да вземе всички подходящи мерки, за да защити и обработва личните данни законосъобразно, както е предвидено от Общия регламент за защита на данните (GDPR) 679/2016 и приложимите национални закони.","privacy-policy-gr-Purposes-desc4":"Услугите, предоставяни от Компанията, са предназначени за възрастни и следователно не се събират лични данни от лица, за които е известно, че са под 18 години, без предварително проверимо съгласие от притежателя на родителски права. Притежателят на родителските права има право по искане да бъде информиран за данните, предоставени от непълнолетния и/или да поиска тяхното изтриване. Ако Компанията разбере, че лице, което подава лични данни, е под 18 години, тя ще изтрие тези данни незабавно.","privacy-policy-gr-Purposes-desc5":"Тази Политика за поверителност е вградена в Общите условия, публикувани на уебсайта на Компанията, и заедно представляват едно цяло. Дейностите на Компанията се провеждат чрез уебсайта https://sam-media.com/","privacy-policy-gr-head2":"2. Дефиниции","privacy-policy-gr-desc6":"Лични данни: всяка информация, която се отнася до идентифицирано или идентифицируемо физическо лице. Идентифицируемо физическо лице е това, чиято идентичност може да бъде установена, пряко или косвено, особено чрез позоваване на идентифициращ признак като име, идентификационен номер, данни за местоположение или един или повече фактори, характеризиращи физическата, физиологичната, психическата, икономическата, културната или социалната идентичност на лицето.","privacy-policy-gr-desc69":"Субект на данни: всяко физическо лице, чиито лични данни са обект на обработка от или за сметка на Компанията.","privacy-policy-gr-desc7":"Обработка: всяка операция или набор от операции върху лични данни, независимо от използваните средства и процедури, като събиране, съхранение, използване, преглеждане, разкриване, архивиране, показване и унищожаване.","privacy-policy-gr-desc8":"Ограничение на обработката: маркиране на съхранени лични данни с цел ограничаване на тяхната обработка в бъдеще.","privacy-policy-gr-desc9":"Профилиране: всяка форма на автоматизирана обработка на лични данни, състояща се в използване на лични данни за оценка на определени лични аспекти, свързани с физическо лице.","privacy-policy-gr-desc10":"Архивна система: всяка структурирана колекция от лични данни, достъпна според конкретни критерии, независимо дали е централизиран, децентрализиран или разпределен по функционален или географски принцип.","privacy-policy-gr-desc11":"Прехвърляне: достъп до лични данни, например чрез разрешаване на достъп, предаване или публикуване.","privacy-policy-gr-desc12":"Администратор на данни: физическо или юридическо лице, което определя целите и средствата за обработка на личните данни.","privacy-policy-gr-desc13":"Процесор: физическо или юридическо лице, което обработва лични данни по указанията на администратора.","privacy-policy-gr-desc14":"Съгласие на субекта на данните: всяко свободно, конкретно, информирано и недвусмислено изразено желание, с което субектът на данните дава съгласие личните данни, отнасящи се до него, да бъдат обработвани.","privacy-policy-gr-head3":"3. Цел на обработката на данните","privacy-policy-gr-desc15":"Обработката на лични данни от Компанията се извършва единствено за целта, посочена при събирането им във връзка с предоставяне на услугите на Компанията, както и за всяка законна цел.","privacy-policy-gr-desc16":"Събраните лични данни улесняват създаването, подобряването и персонализирането на взаимоотношението на Компанията с получателите на нейните услуги.","privacy-policy-gr-desc17":"Обработката на лични данни се извършва винаги в рамките на закона и според принципите на добросъвестност. Поради това се събират и съхраняват само данни, които са необходими за постигане на целта на обработката. Компанията също предприема подходящи мерки за гарантиране на законосъобразността на обработката.","privacy-policy-gr-desc18":"Законността на обработката за посочената цел се основава на съгласието на крайния потребител съгласно чл. 6(1)(a) и чл. 9(2)(a) от GDPR и на изпълнение на договор, при който субектът на данните е страна, съгласно чл. 6(1)(b) от GDPR.","privacy-policy-gr-head4":"4. Видове лични данни, които се събират","privacy-policy-gr-desc19":"Видът лични данни, които се събират, включва пълно име, имейл адрес, информация за плащане или мобилен номер и подобни данни, които могат да бъдат поискани от време на време. Във всички случаи съществено условие за събиране и обработка на вашите лични данни е вашето изрично съгласие.","privacy-policy-gr-head5":"5. Начини на събиране на лични данни","privacy-policy-gr-desc20":"Събирането на лични данни се извършва или чрез доброволното им предоставяне от вас, или чрез автоматизирани средства. По-специално:","privacy-policy-gr-desc211":"Предоставяне на лична информация от самите субекти на данни","privacy-policy-gr-desc21":"Компанията събира лични данни, които вие доброволно предоставяте. Това включва следните случаи:","privacy-policy-gr-desc22":"- при регистрация на уебсайта на Компанията за получаване на мобилни развлекателни услуги, като тонове за обаждане, игри, снимки, новини и други;","privacy-policy-gr-desc23":"- при свързване за изтегляне на материали без регистрация чрез мобилния ви телефон;","privacy-policy-gr-desc24":"- при предоставяне на мнения, предложения, коментари или оплаквания към Компанията;","privacy-policy-gr-desc25":"- при участие в промоции, конкурси, анкети, форуми;","privacy-policy-gr-desc26":"- при трансфер на лични данни от трети страни, с които Компанията работи и на които имате доверие; този трансфер се извършва в рамките на целта, за която сте предоставили данните;","privacy-policy-gr-desc27":"- трансфер на лични данни към Компанията от публични бази данни.","privacy-policy-gr-desc28":"Събиране на лични данни чрез автоматизирани средства (бисквитки) - Политика на Компанията","privacy-policy-gr-desc29":"Бисквитките са малки текстови файлове, използвани за съхранение на данни относно вас и вашите предпочитания. Когато посещавате определени уебсайтове, те се поставят автоматично в предварително определена папка на вашия компютър от сървъра. Целта на бисквитките е да идентифицират уникално вашия компютър към сървъра. По този начин Компанията може да събира информация за използването на сайта, което улеснява навигацията ви и оценката и контрола на функционирането на уебсайта.","privacy-policy-gr-desc30":"С помощта на бисквитки Компанията може да разпознае вашия браузър и дали е инсталиран необходимия софтуер за достъп до определено съдържание на сайта. Чрез бисквитки Компанията може да определи общия брой посетители и да ви разпознае при връщане на сайта. Информация за вашата активност на сайта и други неперсонални данни могат да бъдат използвани, за да се показват реклами, които Компанията смята, че са релевантни за вас.","privacy-policy-gr-desc31":"Бисквитките могат да съхраняват паролата ви за даден сайт за лесен достъп при следващо посещение, както и данни за вашите предпочитания, за да ви се предостави персонализирано съдържание.","privacy-policy-gr-desc32":"Идентифицируема информация за вас не може да бъде събрана чрез бисквитки, освен ако не я предоставите доброволно, в който случай автоматизираните средства ще се използват за предоставяне на допълнителни данни за използването на уебсайта, с цел да бъдат по-полезни за вас. Такива случаи включват регистрация за услугите на Компанията или изпращане на електронна поща.","privacy-policy-gr-desc33":"Повечето браузъри приемат бисквитки по подразбиране, но вие можете да настроите браузъра си да отхвърля бисквитки или да ви уведомява, когато бисквитка се изпраща. Ако изберете да отхвърляте бисквитки, някои части на уебсайта може да не функционират правилно и може да нямате достъп до някои функции.","privacy-policy-gr-desc34":"Компанията може да използва бисквитки или подобни инструменти за свързване на използването на уебсайта  от вас с лични данни, събрани от нея или от доверен трети партньор.","privacy-policy-gr-desc35":"Това може да се случи например, ако сте поискали информация от Компанията за бъдещи продукти или промоции; бисквитките и историята на сърфиране могат да помогнат за персонализиране на съдържанието, което Компанията смята, че ще ви бъде интересно. В такъв случай, ако Компанията иска да свърже личните ви данни с бисквитки или история на сърфиране, тя ще поиска предварително вашето изрично съгласие.","privacy-policy-gr-desc36":"На сайта може да има реклами на трети страни, които също могат да съдържат бисквитки. Тези бисквитки са дефинирани от рекламодателя и Компанията не ги контролира. Проверявайте политиките за поверителност на тези рекламодатели за повече информация.","privacy-policy-gr-desc37":"Накрая, техническите услуги и други услуги на Компанията или нейни партньори могат автоматично да събират информация за посетителите на сайта за поддръжка, подобрения, сигурност и други законни причини. Тази информация може да включва IP адрес, тип браузър, дата, час и продължителност на посещението и конкретни страници, които сте посетили.","privacy-policy-gr-head6":"6. Практики на Компанията относно събирането на данни и информиране","privacy-policy-gr-desc38":"Всеки път, когато предоставяте личните си данни, Компанията гарантира, че сте информирани кой ги събира, как се събират, вида на използването и целта на събирането.","privacy-policy-gr-desc39":"Затова всеки път, когато предоставяте лични данни, Компанията ще ви уведоми за опциите ви относно използването им и при споделяне с трети страни.","privacy-policy-gr-desc40":"Когато личните ви данни се събират офлайн (напр. формуляр за абонамент), Компанията ще ви изпрати кратко уведомление, описващо как да получите пълния текст на тази Политика и друга информация за Компанията, за да сте напълно информирани и да дадете съгласието си.","privacy-policy-gr-desc41":"На сайта може да има връзки към трети сайтове. В някои случаи тези сайтове могат да показват логото на Компанията, без Компанията да управлява или носи отговорност за тяхното съдържание.","privacy-policy-gr-desc42":"На сайта могат да се появяват реклами на трети лица, където ще бъдете пренасочени към техните сайтове. Компанията не носи отговорност за практиките или политиките за поверителност на тези трети страни.","privacy-policy-gr-head7":"7. Права на субектите на личните данни","privacy-policy-gr-desc43":"Всеки субект на данни притежава следните права съгласно GDPR, които Компанията зачита и защитава:","privacy-policy-gr-desc43-a":"а) Право на информация: субектът има право да поиска информация за личните данни, които Компанията съхранява, включително видът на данните, лицата, които имат достъп, и причините за обработката.","privacy-policy-gr-desc43-b":"б) Право на достъп: субектът има право да поиска безплатен достъп до личните данни, които Компанията притежава.","privacy-policy-gr-desc43-c":"в) Право на корекция и допълване: субектът може да поиска корекция на неточни данни или допълване на непълни данни, когато това е необходимо за целите на обработката.","privacy-policy-gr-desc43-d":"д) Право на изтриване: субектът може да поиска изтриване на личните си данни, въпреки че някои данни може да се съхраняват за определен срок по законови или договорни причини.","privacy-policy-gr-desc43-e":"е) Право на ограничение на обработката: субектът може да поиска ограничаване на обработката при определени обстоятелства.","privacy-policy-gr-desc43-f":"ж) Право на преносимост на данните: субектът може да поиска прехвърляне на данните си към друг администратор.","privacy-policy-gr-desc43-g":"з) Право на възражение: субектът може да възрази срещу обработката на данните си, когато тя се базира на легитимни интереси на администратора.","privacy-policy-gr-desc43-h":"и) Права, свързани с автоматизирано вземане на решения и профилиране: субектът има право да не бъде подлаган на решение, основаващо се изцяло на автоматизирана обработка, което има правни последици или значително го засяга, освен в посочените в регламента случаи.","privacy-policy-gr-desc43-i":"й) Право на оттегляне на съгласие: субектът може по всяко време да оттегли съгласието си за обработка на личните данни.","privacy-policy-gr-desc43-j":"к) Право на блокиране на личните данни: в някои случаи Компанията ще блокира данните при подадено искане, като по-нататъшната обработка е възможна само в ограничен обхват.","privacy-policy-gr-desc44":"Ако субектът поиска спиране на използването на личните си данни, Компанията ще удовлетвори заявката, съхранявайки само информацията, необходима за спазване на приложимото национално законодателство.","privacy-policy-gr-desc45":"Субектът може да се свърже с Компанията, за да упражни правата си, а Компанията ще отговори в разумен срок, не по-късно от 30 дни.","privacy-policy-gr-head8":"8. Използване и обработка на личните данни от Компанията","privacy-policy-gr-desc46":"Компанията се ангажира, че използването на предоставените лични данни ще се извършва в съответствие с тази Политика и единствено за целите, за които са предоставени.","privacy-policy-gr-desc47":"Компанията може да използва личните данни, предоставени при регистрация, за изпращане на важна информация и актуализации относно акаунта ви и предоставяните услуги.","privacy-policy-gr-desc48":"При събиране на лични данни по искане за изтегляне на файлове или услуги, Компанията ще обработи искането, включително изпълнение на поръчки и плащания, ако има такива. Компанията няма да споделя данните ви с трети страни, освен с такива, чието участие е необходимо за изпълнение на поръчката или плащането.","privacy-policy-gr-head9":"9. Предаване на лични данни на трети страни","privacy-policy-gr-desc49":"Компанията се задължава да не предава личните данни на трети страни, които не са свързани или не си сътрудничат с нея, освен ако не получи вашето изрично съгласие. Ако Компанията получи лични данни от трети партньор, използването им ще бъде в съответствие с тази Политика.","privacy-policy-gr-desc50":"Тук са описани видовете други компании, които може да искат да ви изпращат информация за своите продукти и услуги и следователно биха искали да споделят вашите лични данни, при условие че сте дали съгласието си.","privacy-policy-gr-desc51":"Уебсайтът на Компанията може да бъде свързан с сайтове, управлявани от свързани компании. Макар членовете на групата да следват групови правила, посетителите трябва да консултират отделните политики за поверителност на тези свързани сайтове.","privacy-policy-gr-desc52":"Външен процесор, нает от Компанията, трябва да се съгласи по договор да обработва лични данни в съответствие с тази политика и условията да бъдат включени в договорите им.","privacy-policy-gr-desc53":"Лични данни могат да бъдат разкрити на трети страни само ако е необходимо или ако субектът дава изрично съгласие. Данните трябва да бъдат предоставени анонимно, когато е възможно.","privacy-policy-gr-desc54":"Компанията може да използва данните агрегирано и анонимно за изследователски цели.","privacy-policy-gr-desc55":"Партньори могат да предлагат изтегляния от името на Компанията, като събират лични данни от потребителите и предоставят на Компанията необходимата информация за изпълнение на заявките и плащанията.","privacy-policy-gr-desc56":"Компанията може да споделя лични данни с партньорски компании или групови дружества за постигане на целта на обработката.","privacy-policy-gr-desc57":"Всеки служител на Компанията преминава обучение по защита на данните и сигурност. Достъпът на служители и партньори е позволен само по законни причини.","privacy-policy-gr-desc59":"Компанията може да споделя лични данни с външни партньори, които подпомагат управлението на информационните дейности (например изпълнение на поръчки, статистически анализи). Тези партньори могат да използват данните само за предоставяне на услуги на Компанията.","privacy-policy-gr-desc60":"Компанията може да работи с външни фирми, които предоставят технологии за персонализиране на рекламни и маркетинг съобщения. Неперсонални данни и историята на сърфиране могат да бъдат споделяни с тези компании за рекламни и статистически цели, обикновено анонимно.","privacy-policy-gr-head10":"10. Съхранение, срок на задържане и сигурност на данните","privacy-policy-gr-desc61":"Периодът на съхранение на личните данни се определя от времето, необходимо за постигане на целта на събирането, както и от законовите изисквания. Подробности за съхранението и сроковете са в Политиката за задържане на данни на Компанията.","privacy-policy-gr-desc62":"Компанията предприема всички модерни технологични и организационни мерки за защита на личните данни срещу загуба, кражба и неразрешено използване, гарантирайки цялостта, конфиденциалността и наличността им. Компанията използва подходящи методи за проверка, че данните са точни и актуални.","privacy-policy-gr-head11":"11. Случаи на разкриване на лични данни","privacy-policy-gr-desc63":"Компанията може да разкрие лични данни без съгласието на субекта в следните случаи: а) за защита на законни права на Компанията или свързани дружества; б) за сигурността на посетителите на сайта; в) за защита срещу измами или при подозрение за престъпление; г) за управление на риска, обществения ред и сигурността; д) ако бъде поискано от компетентни държавни или съдебни органи; е) за съобразяване с приложимото законодателство или правни процедури.","privacy-policy-gr-head12":"12. Условия за трансгранично разкриване на лични данни","privacy-policy-gr-desc64":"Прехвърляне на лични данни извън страната е възможно само ако законодателството на приемащата държава осигурява адекватно ниво на защита на личните данни.","privacy-policy-gr-desc65":"В противен случай личните данни могат да бъдат прехвърлени само ако субектът е дал изрично съгласие или има споразумение за трансфер на данни с необходимите гаранции.","privacy-policy-gr-head13":"13. Прехвърляне на компанията","privacy-policy-gr-desc66":"Ако Компанията продаде част или цялата си дейност или активи или се включи в сливания или прехвърляния, тя може да прехвърли личните данни като част от такава сделка.","privacy-policy-gr-head14":"14. Промяна на условията на Политиката за поверителност","privacy-policy-gr-desc67":"Горните условия представляват пълното споразумение с Компанията, която запазва правото да променя, обновява или изтрива всички условия на настоящата Политика без предварително уведомление. Промените влизат в сила от момента на публикуване на актуализирания текст. Субектът трябва редовно да преглежда политиката за да е информиран за най-новите практики. Ако практиките бъдат променени съществено, данните ще продължат да се обработват съгласно политиката, при която са били събрани, освен ако не е дадено съобщение и субектът не е възразил.","privacy-policy-gr-head15":"15. Решаване на въпроси по защита на личните данни - контакти","privacy-policy-gr-desc68":"За упражняване на вашите права, или за въпроси относно поверителност, събиране и обработка на лични данни от Компанията, за упражняване на правото на преглед, корекция, изтриване или отказ от бъдеща комуникация, можете да се свържете с Компанията на електронен адрес HYPERLINK \"mailto:customer.support@lilymobile.gr\" sam-media.gr@cchelp.co, на телефон за обслужване 2112348373 или с писмо до седалището на Компанията в Нидерландия (Van Diemenstraat 356 1013 CR Amsterdam)","terms-condition-title":"Общи условия","gen-terms-condition-title":"Общи условия и Политика за поверителност.","gen-terms-condition-desc":"Следните Общи условия се прилагат за продуктите и услугите, предоставяни чрез WAP, SMS, GPRS и 3G от Sam Media Ltd. или свързани с нея компании (наричани по-долу „Доставчикът“). Доставчикът може периодично да променя тези Общи условия без предварително уведомление. В допълнение към Общите условия, всички правила, промоционални условия, насоки и приложими разпоредби, публикувани във връзка с услугите, също се прилагат към вас и Доставчика при използване на Услугите (както са дефинирани в този документ) на Доставчика. Всички тези насоки, правила, промоционални условия и разпоредби се считат за неразделна част от настоящите Общи условия. Използвайки Услугите на Доставчика, вие се съгласявате да бъдете обвързани от тези Общи условия, както и от приложимите насоки, правила и промоционални условия.","provider-terms-condition-title":"Описание на Доставчика.","provider-terms-condition-desc":"Чрез услугите WAP, SMS, GPRS и 3G, Доставчикът предоставя на своите потребители достъп до мрежа от онлайн ресурси, включително онлайн игри, текстови съобщения, мултимедийно съдържание и онлайн информационни материали, които могат да бъдат изтегляни на мобилни телефони или други устройства („Услуги“). Общите условия винаги се прилагат за всички нови функции, включително тези, които Доставчикът може да внедри като част от разширяването, надграждането или подобрението на текущите Услуги, включително разширения към нови функции, добавени от Доставчика.","availability-terms-condition-title":"Наличност.","availability-terms-condition-desc":"Услугата се предоставя в състоянието, в което се намира, и Доставчикът не поема никаква отговорност и не предлага гаранции в случай на лични настройки, информация или съобщения, които не са запазени, не са запазени навреме, или са изтрити или доставени неправилно. За да се абонирате за Услугата, трябва да имате интернет достъп и/или мобилен абонамент и да заплатите всички такси, свързани с този достъп. Вие сте отговорни за всички разходи, направени за осигуряване на този достъп. Също така носите отговорност за свързването на необходимото оборудване, включително мобилен телефон, персонален компютър или друго устройство, което може да е необходимо и в добро работно състояние за използване на Услугата.","payment-terms-condition-title":"Плащане.","payment-terms-condition-desc":"Имате безплатен достъп до нашите онлайн услуги. По отношение на Услугите и тяхното използване, дължите заплащане на съответната такса според действащите тарифи на Доставчика към момента, както и според тарифите, начислявани от вашия мобилен оператор. Таксите ще бъдат фактурирани чрез вашия мобилен оператор във вашата телефонна сметка. Заплащате на Доставчика всички национални и местни данъци или други налози, включително, но не само ДДС, или други данъци и такси, наложени сега или в бъдеще от европейски, национални или местни власти или други упълномощени органи, свързани с разходите за използване на Услугите. Доставчикът си запазва правото да променя тарифите за Услугите, като публикува подробности за тези промени на своя уебсайт.","obligation-terms-condition-title":"Задължение за регистрация.","obligation-terms-condition-desc":"За да се гарантира безопасното и защитено използване на Услугата, вие гарантирате следното, в допълнение към плащането на приложимите такси: (a) вашата лична информация („Регистрационна информация“) във формуляра за регистрация е вярна, точна и пълна, и (b) вие се съгласявате да осигурите, че Регистрационната информация винаги остава вярна, точна и пълна. Ако Доставчикът има основателно подозрение, че Регистрационната информация не е точна или пълна, той има право да спре или прекрати вашия акаунт и да ограничи използването на Услугата. Вие сте отговорни за поверителността на всяка парола и/или акаунт, издадени от Доставчика, и носите пълна отговорност за всички действия, извършени чрез тях. Съгласявате се да затваряте акаунта си в края на всяка сесия и да уведомите Доставчика, ако забележите или подозирате неоторизирано използване. Доставчикът не носи отговорност за каквито и да било щети, произтичащи от неспазването на тези задължения.","ownership-terms-condition-title":"Права на собственост на Доставчика.","ownership-terms-condition-desc":"Следните Общи условия се прилагат за продуктите и услугите, предоставяни чрез WAP, SMS, GPRS и 3G от Sam Media Ltd. или свързани с нея компании (наричани по-долу „Доставчикът“). Доставчикът може да променя Общите условия без предварително уведомление. Освен Общите условия, всички правила, промоционални условия, насоки и разпоредби, публикувани във връзка с услугите, също се прилагат и се считат за част от Общите условия. Използвайки Услугите на Доставчика, вие се съгласявате да бъдете обвързани от тези условия и приложимите правила."}

/***/ }),

/***/ "./src/translations/cy.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Почетна страна","sidebar.myaccount":"Мој профил","sidebar.notif":"Нотификација","sidebar.nonotif":"Немате нотификације још увек","html5games":"ХТМЛ5 игрице","androidGames":"Андроид игрице","android-upper":"Андроид","favorite":"Омиљено","splashscreen.text":"Играј Way Beyond","welcome.text":"ИСТРАЖУЈ НАЈБОЉЕ ОНЛАЈН МОБИЛНЕ ИГРИЦЕ ДАНАС!","accountDetails":"ПРОФИЛНИ ПОДАЦИ","accountName":"ИМЕ","accountEmail":"ИМЕЈЛ АДРЕСА","accountLocation":"ЛОКАЦИЈА","accountInterests":"ХОБИЈИ","accountChooseCategory":"Изабери 3 категорије","accountEditPhoto":"ИЗМЕНИ ФОТОГРАФИЈУ","save":"Сними","topCategories":"ТОП КАТЕГОРИЈЕ","favGames":"Омиљено","viewAll":"ВИДИ СВЕ","noGameFound":"Нема нађених игрица.","cancel":"Искључи","gameDirectories":"СПИСАК ИГРИЦА","category":"Категорија","noGamesFound":"No games found under this category.","platform":"Платформа","type":"Тип","android":"Андроид","games":"игрице","html5":"ХТМЛ5","videos":"ВИДЕОС","search.input.placeholder":"Тражи...","search.cancel.button":"Искључи","description":"Опис","downloadNow":"СКИНИ САДА","playNow":"ИГРАЈ САДА","rate":"Оцени","relatedGames":"СЛИЧНЕ ИГРИЦЕ","noFavGames":"Нема омиљених игрица још увек","addFavGames":"Додај своје омиљене игрице за приступ лакшем игрању без проблема","discover":"ОТКРИЈ","noFavGamesFound":"Нема омиљених игрица.","favorites":"Омиљено","accessDenied":"Приступ одбијен","pageRestricted":"Немате приступ страници коју тражите.","averageRatingBasedOn":" просечна оцена корисника на основу ","averageRatingReview":" прегледа","tnc":"Услови коришћења","contact_us":"Контакт","areYouAlready":"Да ли сте већ члан ","thenConfirm":"Онда потврдите свој мобилни број и добићете неограничен приступ свим нашим услугама!","login":"Улогуј се","Action":"Акција","Adventure":"Авантура","Arcade":"Аркада","Sport":"Спорт","Racing":"Racing","Premium Games":"Премијум игре","RPG":"РПГ","Virtual Reality":"Виртуелна стварност","Motivation":"Мотивација","Tour":"Тоур","Fun Gaming":"Забавно играње","Athletics":"Атлетика","Inspiration":"Инспирација","Into Nature":"У природу","Political & Activism":"Политички и активизам","Travel":"Путовање","Foodbuzz":"Фоодбузз","Health and Nutrition":"Здравље и исхрана","Fitness":"Фитнесс","Top Cars":"Топ Царс","Fashion & Beauty":"Мода и лепота","E-Learning":"Е-учење","Yoga":"Јога","Just For Laugh":"Само за смех","Brain Boost":"Браин Боост","Rugby":"Рагби","Economy":"Економија","Environment":"Животна средина","Gaming":"Игре","Lifestyle":"Начин живота","Local Heroes":"Локални хероји","Sports":"Спорт","Technology":"Технологија","Tutorials":"Туториали","New Arrivals":"Новопридошли","noFavVideos":"Још нема омиљених видео снимака","addFavVideos":"Додајте своје омиљене видео записе којима ћете лако приступити и репродуковати их без икаквих пасажа","noVideosFound":"Није пронађен ниједан видео запис","noFavVideosFound":"Није пронађен ниједан омиљен видео снимак","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Сва права задржана","footer.copyright":"&copy; 2020 Gamelords. Сва права задржана","welcome.text.gamiclub":"ИСТРАЖИТЕ НАЈБОЉИ САДРЖАЈ ДАНАС ОНЛИНЕ!","vid-player":"Плаиер","privacyPolicy":"Приватност","privacy-policy-title":"Приватност","privacy-policy-desc":"Ова политика приватности објашњава наше обавезе и Ваша права која се тичу Ваших података. Треба пажљиво прочитати Политику приватности. Ако се не слажете са  Политиком приватности, немојте користити наше странице или услуге. Политика приватности је прописно припојена и подложна Условима коришћења и уређује исте Услуге и Веб локације као и оне наведене у Условима коришћења. Сви термини које користимо у политици приватности без да их дефинишемо имају исту дефиницију као у Условима коришћења.","privacy-policy-collect-info-head":"СКУПЉАМО ПОДАТКЕ НА СЛЕДЕЋИ НАЧИН:","privacy-policy-collect-info-desc1":"1. Када нам их дате или нам дате дозволу да их скупљамо ако одлучите да се претплатите на наше Услуге, ми или мобилни оператер Ваше мреже ћемо да скупимо Ваше податке у вези са плаћањем претплате на наше Услуге. Подаци о рачуну и наплатама које је прикупио мобилни оператер подложни су њиховим правилима о приватности.","privacy-policy-collect-info-desc2":"2. Добијамо техничке информације када посећујете наше Веб локације и/или Услуге. Можемо прикупљати техничке податке о Вама кад год користите наше Услуге. Евиденцију података прикупљамо сваки пут када се пријавите или одјавите са наших Услуга.","privacy-policy-how-collect-info-head":"КАКО КОРИСТИМО СКУПЉЕНЕ ПОДАТКЕ","privacy-policy-how-collect-info-subhead":"Ваше податке можемо користити у следеће сврхе:","privacy-policy-how-collect-info-desc1":"· Да обезбедимо Услуге које тражите;","privacy-policy-how-collect-info-desc2":"· Да срачунамо и наплатимо Услуге које су вам пружене;","privacy-policy-how-long-head":"КОЛИКО ДУГО ЧУВАМО ВАШЕ ПОДАТКЕ","privacy-policy-how-long-desc":"Ми ћемо задржати Ваше податке онолико дуго колико је потребно да Вам пружимо наше Услуге. Задржаћемо Ваше податке ако су неопходни да бисмо испунили наше законске обавезе, решили спорове и спровели наше споразуме. Када више не будемо морали да користимо Ваше податке и када не буде потребе да их држимо да би удовољили нашим законским или регулаторним обавезама, уклонићемо их из наших система или их деперсонализирати тако да Вас више не можемо идентификовати.","privacy-policy-how-long-protect-head":"КАКО ШТИТИМО ВАШЕ ПОДАТКЕ ИЗВАН ЕУ","privacy-policy-how-long-protect-desc1":"Забринути смо за заштиту Ваше приватности и података, али не можемо гарантовати или гарантовати сигурност било каквих података које нам пошаљете или гарантовати да Ваши подаци неће бити доступни, обелодањени, измењени или уништени кршењем било ког физичког стандарда наше индустрије, техничке или менаџерске мере заштите. Прихватамо одговарајуће праксе прикупљања, складиштења и обраде и мере заштите како бисмо се заштитили од неовлашћеног или случајног приступа, измена, откривања или уништавања Ваших података, података о трансакцијама и података сачуваних на нашим Услугама.","privacy-policy-how-long-protect-desc2":"Међутим, ниједан начин преношења путем Интернета или начин електронског складиштења није 100% сигуран. Стога не можемо гарантовати његову апсолутну сигурност. Наставићемо да унапређујемо наше безбедносне поступке како нова технологија постане доступна.","privacy-policy-how-long-protect-desc3":"Будући да послујемо на међународном нивоу, Ваши подаци, укључујући личне податке, могу се пренети у САД/Сингапур и/или било коју другу земљу осим државе у којој пребивате. Такође, у овим земљама ми преузимамо сву разумну бригу да бисмо заштитили Ваше личне податке.","privacy-policy-acceptance-head":"ПРИХВАТАЊЕ ПОЛИТИКЕ ПРИВАТНОСТИ","privacy-policy-acceptance-desc":"Коришћењем било које од наших Услуга, Ви пристајете на наше прикупљање и коришћење Ваших података у складу са овим Правилима о приватности. Придржавамо право да изменимо ову Политику приватности у било ком тренутку објављивањем измена на овој страници. Проверите датум ревизије на дну ове странице да бисте утврдили да ли је смерница измењена од када сте је последњи пут прегледали. Ваша континуирана употреба било ког дела наше веб странице или услуга након објављивања ажуриране Политике приватности представљаће Ваше прихватање промена.","privacy-policy-changes-head":"ПРОМЕНЕ ОВЕ ПОЛИТИКЕ ПРИВАТНОСТИ","privacy-policy-changes-desc":"Можемо повремено да мењамо нашу Политику приватности. Ако одлучимо да изменимо нашу Политику приватности, те измене ћемо објавити на овој страници како бисте увек могли да приступите последњим Правилима о приватности.","privacy-policy-contact-us":"КОНТАКТИРАЈТЕ НАС","privacy-policy-contact-us-desc":"Ако имате питања у вези са овом Политиком приватности, поступцима Веб локација или односима са Веб локацијама, контактирајте нас слањем имејла на support@content-clubs..com.","unsubscribe":"Одјави се","withdraw_from_contract":"Одустанак од уговора"}

/***/ }),

/***/ "./src/translations/cz.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Domů","sidebar.myaccount":"Můj účet","sidebar.notif":"Oznámení","sidebar.nonotif":"Zatím nemáte žádná oznámení","html5games":"Hry HTML5","androidGames":"Hry pro Android","android-upper":"ANDROID","favorite":"Oblíbený","splashscreen.text":"Nová herní zkušenost","welcome.text":"PROZKOUMEJTE TY NEJLEPŠÍ MOBILNÍ ONLINE HRY JEŠTĚ DNES!","welcome.text.gamiclub":"PROZKOUMEJTE TEN NEJLEPŠÍ ONLINE OBSAH JEŠTĚ DNES!","accountDetails":"DETAILY ÚČTU","accountName":"JMÉNO","accountEmail":"EMAILOVÁ ADRESA","accountLocation":"UMÍSTĚNÍ","accountInterests":"ZÁJMY","accountChooseCategory":"Vyberte 3 kategorie","accountEditPhoto":"UPRAVIT FOTKU","save":"Uložit","topCategories":"TOP KATEGORIE","favGames":"OBLÍBENÉ HRY","viewAll":"ZOBRAZIT VŠE","noGamesFound":"V této kategorii nebyly nalezeny žádné hry","noVideosFound":"V této kategorii nebyla nalezena žádná videa","cancel":"Zrušit","gameDirectories":"HERNÍ ADRESÁŘE","category":"Kategorie","platform":"Plošinovka","type":"Typ","android":"Android","games":"hry","html5":"HTML5","videos":"VIDEA","search.input.placeholder":"Vyhledávání...","search.cancel.button":"Zrušit","description":"Popis","downloadNow":"STÁHNOUT TEĎ","playNow":"HRÁT HNED","rate":"Hodnotit","relatedGames":"SOUVISEJÍCÍ HRY","relatedVideo":"Související videa","noFavGames":"Zatím žádné oblíbené hry","addFavGames":"Přidejte své oblíbené hry a hrajte je snadno bez jakýchkoli potíží","discover":"OBJEVIT","noFavGamesFound":"Nebyly nalezeny žádné oblíbené hry.","favorites":"Oblíbený","accessDenied":"Přístup odepřen","pageRestricted":"Stránka, kterou hledáte, je omezená.","averageRatingBasedOn":" průměrného uživatelského hodnocení na základě","averageRatingReview":"recenzí","tnc":"PRAVIDLA A PODMÍNKY","contact_us":"Kontaktujte nás","areYouAlready":"Jste již členem ","thenConfirm":"Poté potvrďte své mobilní číslo a získejte neomezený přístup ke všem našim hrám HTML5 a Android","login":"Přihlásit se","Action":"Akce","Adventure":"Dobrodružství","Arcade":"Arkáda","Sport":"Sport","Racing":"Závodění","Premium Games":"Prémiové hry","RPG":"RPG","Virtual Reality":"Virtuální realita","Motivation":"Motivace","Tour":"Prohlídka","Fun Gaming":"Zábavné hraní","Athletics":"Atletika","Inspiration":"Inspirace","Into Nature":"Do přírody","Political & Activism":"Politika a aktivismus","Travel":"Cestovat","Foodbuzz":"Foodbuzz","Health and Nutrition":"Zdraví a výživa","Fitness":"Fitness","Top Cars":"Nejlepší auta","Fashion & Beauty":"Móda a krása","E-Learning":"E-learning","Yoga":"Jóga","Just For Laugh":"Jen pro smích","Brain Boost":"Posilování mozku","Rugby":"Ragby","Economy":"Ekonomika","Environment":"Životní prostředí","Gaming":"Hraní","Lifestyle":"Životní styl","Local Heroes":"Místní hrdinové","Sports":"Sport","Technology":"Technologie","Tutorials":"Tutoriály","New Arrivals":"Nově příchozí","noFavVideos":"Zatím žádná oblíbená videa","addFavVideos":"Přidejte svá oblíbená videa, abyste měli k nim snadný přístup a mohli je přehrávat bez jakýchkoli potíží","noFavVideosFound":"Nebyla nalezena žádná oblíbená videa.","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Všechna práva vyhrazena.","vid-player":"Hráč","privacyPolicy":"ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ","privacy-policy-title":"Zásady ochrany osobních údajů","privacy-policy-desc":"Tyto zásady ochrany osobních údajů vysvětlují naše závazky a vaše práva týkající se vašich údajů. Měli byste si pozorně přečíst Zásady ochrany osobních údajů. Pokud nesouhlasíte s těmito Zásadami ochrany osobních údajů, nepoužívejte prosím naše stránky ani služby. Zásady ochrany osobních údajů jsou řádně začleněny a podléhají podmínkám služby a řídí stejné služby a stránky jako ty, které jsou uvedeny v podmínkách služby. Jakékoli výrazy, které používáme v Zásadách ochrany osobních údajů, aniž bychom je definovali, mají stejnou definici jako v podmínkách služby.","privacy-policy-collect-info-head":"INFORMACE SBÍRÁME NÁSLEDUJÍCÍMI ZPŮSOBY","privacy-policy-collect-info-desc1":" 1. Když nám je dáte nebo nám dáte svolení k jejich získání. Pokud se rozhodnete předplatit si od nás Službu, budeme my nebo mobilní operátor vaší sítě shromažďovat vaše údaje související s platbou za předplatné našich Služeb. Údaje o účtu a fakturaci shromážděné mobilním operátorem podléhají jeho příslušným zásadám ochrany osobních údajů.","privacy-policy-collect-info-desc2":"2. Technické informace získáváme, když navštívíte naše stránky a/nebo služby Technické informace o vás můžeme shromažďovat, kdykoli používáte naše služby. Shromažďujeme data protokolu pokaždé, když se přihlásíte nebo odhlásíte z našich Služeb.","privacy-policy-how-collect-info-head":"JAK VYUŽÍVÁME SBÍRANÉ INFORMACE","privacy-policy-how-collect-info-subhead":"Vaše údaje můžeme použít pro následující účely:","privacy-policy-how-collect-info-desc1":"Pro účely poskytování služeb, které požadujete;","privacy-policy-how-collect-info-desc2":"Pro účely účtování za služby, které vám byly poskytnuty;","privacy-policy-how-long-head":"JAK DLOUHO UCHOVÁVÁME VAŠE INFORMACE","privacy-policy-how-long-desc":"Vaše údaje budeme uchovávat tak dlouho, jak to bude nutné k tomu, abychom vám mohli poskytovat naše služby. Vaše údaje budeme uchovávat tak, jak to bude nutné k plnění našich zákonných povinností, řešení sporů a vymáhání našich dohod. Když již vaše údaje nepotřebujeme používat a není nutné, abychom je uchovávali, abychom splnili naše zákonné nebo regulační povinnosti, buď je odstraníme z našich systémů, nebo je depersonalizujeme, abychom vás již nemohli identifikovat.","privacy-policy-how-long-protect-head":"JAK CHRÁNÍME VAŠE INFORMACE I MIMO EU","privacy-policy-how-long-protect-desc1":"Zajímáme se o ochranu vašeho soukromí a dat, ale nemůžeme zajistit ani zaručit bezpečnost jakýchkoli informací, které nám přenesete, ani zaručit, že vaše informace nebudou zpřístupněny, zveřejněny, pozměněny nebo zničeny porušením jakéhokoli našeho průmyslového standardu fyzického, technické nebo manažerské zabezpečení. Přijímáme vhodné postupy shromažďování, ukládání a zpracování dat a bezpečnostní opatření na ochranu před neoprávněným nebo náhodným přístupem, změnou, zveřejněním nebo zničením vašich informací, informací o transakcích a dat uložených v našich službách.","privacy-policy-how-long-protect-desc2":"Žádný způsob přenosu přes internet nebo způsob elektronického ukládání však není 100% bezpečný. Nemůžeme tedy zaručit jeho absolutní bezpečnost. Jakmile budou k dispozici nové technologie, budeme nadále vylepšovat naše bezpečnostní postupy.","privacy-policy-how-long-protect-desc3":"Protože působíme mezinárodně, mohou být vaše informace, včetně osobních údajů, přeneseny a zpřístupněny v USA/Singapuru a/nebo jakékoli jiné zemi, než je země vašeho bydliště. Také v těchto zemích věnujeme veškerou přiměřenou péči ochraně vašich osobních údajů.","privacy-policy-acceptance-head":"PŘIJETÍ ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ","privacy-policy-acceptance-desc":"Používáním kterékoli z našich služeb souhlasíte se shromažďováním a používáním vašich údajů v souladu s těmito zásadami ochrany osobních údajů. Vyhrazujeme si právo tyto Zásady ochrany osobních údajů kdykoli upravit zveřejněním změn na této stránce. Zkontrolujte prosím datum revize v dolní části této stránky, abyste zjistili, zda byla zásada změněna od doby, kdy jste ji naposledy viděli. Vaše další používání jakékoli části našich stránek nebo služeb po zveřejnění aktualizovaných zásad ochrany osobních údajů bude znamenat váš souhlas se změnami.","privacy-policy-changes-head":"ZMĚNY TĚCHTO ZÁSAD OCHRANY OSOBNÍCH ÚDAJŮ","privacy-policy-changes-desc":"V našich Zásadách ochrany osobních údajů můžeme čas od času provést změny. Pokud se rozhodneme změnit naše Zásady ochrany osobních údajů, zveřejníme tyto změny na této stránce, abyste měli vždy přístup k nejnovějším Zásadám ochrany osobních údajů.","privacy-policy-contact-us":"KONTAKTUJTE NÁS","privacy-policy-contact-us-desc":"Máte-li dotaz k těmto Zásadám ochrany osobních údajů, praktikám Stránek nebo vašemu jednání se Stránkami, kontaktujte nás prosím zasláním e-mailu na support@content-clubs.com.","unsubscribe":"ODHLÁSIT ODBĚR","withdraw_from_contract":"Odstoupení od smlouvy"}

/***/ }),

/***/ "./src/translations/de.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Startseite","sidebar.myaccount":"Mein Konto","sidebar.notif":"Benachrichtigung","sidebar.nonotif":"Du hast noch keine Benachrichtigungen","html5games":"HTML5-Spiele","androidGames":"Android-Spiele","android-upper":"ANDROID","favorite":"Favorit","splashscreen.text":"Spiele weit darüber hinaus","welcome.text":"ENTDECKE HEUTE DIE BESTEN MOBILSPIELE ONLINE!","welcome.text.gamiclub":"ENTDECKE HEUTE DEN BESTEN INHALT ONLINE!","accountDetails":"KONTODETAILS","accountName":"NAME","accountEmail":"E-MAIL-ADDRESSE","withdraw_from_contract":"Widerruf des Vertrags","accountLocation":"STANDORT","accountInterests":"INTERESSEN","accountChooseCategory":"3 Kategorien wählen","accountEditPhoto":"FOTO BEARBEITEN","save":"Speichern","topCategories":"TOP-KATEGORIEN","favGames":"Lieblingsspiele","viewAll":"ALLE ANSEHEN","noGamesFound":"Keine Spiele unter dieser Kategorie gefunden","noVideosFound":"Keine Videos unter dieser Kategorie gefunden","cancel":"Abbrechen","gameDirectories":"SPIELVERZEICHNISSE","category":"Kategorie","platform":"Plattform","type":"Art","android":"ANDROID","games":"spiele","html5":"HTML5","sidebar.lang":"Sprachen","sidebar.lang.fr":"Französisch","sidebar.lang.de":"Deutsche","sidebar.lang.be":"Niederländisch","sidebar.lang.en":"Englisch","sidebar.lang.it":"Italienisch","videos":"VIDEOS","search.input.placeholder":"Suche...","search.cancel.button":"Abbrechen","description":"Beschreibung","downloadNow":"JETZT DOWNLOADEN","playNow":"JETZT SPIELEN","rate":"Bewerten","relatedGames":"VERWANDTE SPIELE","noFavGames":"Noch keine Lieblingsspiele","addFavGames":"Füge deine Lieblingsspiele hinzu, um problemlos darauf zuzugreifen und zu spielen","discover":"ENTDECKEN","noFavGamesFound":"Keine Lieblingsspiele gefunden.","favorites":"Favorit","accessDenied":"Zugriff abgelehnt","pageRestricted":"Die gesuchte Seite ist eingeschränkt.","averageRatingBasedOn":" durchschnittliche Benutzerbewertung basierend auf ","averageRatingReview":" Bewertungen","tnc":"NUTZUNGSBEDINGUNGEN","no related games found":"Keine verwandten Spiele gefunden","contact_us":"Kontaktiere uns","areYouAlready":"Bist du schon Mitglied von ","thenConfirm":"Bestätigen Sie anschließend Ihre Handynummer und erhalten Sie uneingeschränkten Zugriff auf alle unsere Spiele <strong> HTML5 </ strong> und <strong> Android </ strong>","login":"Anmeldung","Action":"Aktion","Adventure":"Abenteuer","Arcade":"Arkade","Sport":"Sport","Racing":"Rennen","Premium Games":"Premium-Spiele","RPG":"Rollenspiel","Virtual Reality":"Virtuelle Realität","Motivation":"Motivation","Tour":"Tour","Fun Gaming":"Lustiges Gaming","Athletics":"Athletik","Inspiration":"Inspiration","Into Nature":"In die Natur","Political & Activism":"Politisches & Aktivismus","Travel":"Reisen","Foodbuzz":"Foodbuzz","Health and Nutrition":"Gesundheit und Ernährung","Fitness":"Fitness","Top Cars":"Top-Autos","Fashion & Beauty":"Mode & Schönheit","E-Learning":"E-Learning","Yoga":"Yoga","Just For Laugh":"Nur zum Spaß","Brain Boost":"Gehirn-Boost","Rugby":"Rugby","Economy":"Wirtschaft","Environment":"Umwelt","Gaming":"Gaming","Lifestyle":"Lifestyle","Local Heroes":"Lokale Helden","Sports":"Sports","Technology":"Technologie","Tutorials":"Tutorials","New Arrivals":"Neu eingetroffen","noFavVideos":"Noch keine Lieblingsvideos","addFavVideos":"Füge deine Lieblingsvideos hinzu, um problemlos darauf zuzugreifen und sie abzuspielen","noFavVideosFound":"Keine Lieblingsvideos gefunden","footer.copyright":"&copy; 2020 Gamelords. Alle Rechte Vorbehalten","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Alle Rechte Vorbehalten","footer.copyright.appspool":"&copy; 2020 Appspool. Alle Rechte Vorbehalten","vid-player":"spieler","privacyPolicy":"DATENSCHUTZRECHTE","privacy-policy-title":"DATENSCHUTZRECHTE","privacy-policy-desc":"Diese Datenschutzrichtlinie erläutert unsere Verpflichtungen und Ihre Rechte bezüglich Ihrer Daten. Sie sollten diese Datenschutzrichtlinie sorgfältig durchlesen. Wenn Sie dieser Datenschutzrichtlinie nicht zustimmen, bitten wir Sie die Nutzung unserer Websites oder Dienste zu unterlassen. Diese Datenschutzrichtlinie ist ordnungsgemäß in die Nutzungsbedingungen eingearbeitet und regelt die gleichen Dienste und Websites wie diejenigen, die in den Nutzungsbedingungen genannt werden. Jegliche Bedingungen, die wir in der Datenschutzrichtlinie verwenden, ohne sie zu definieren, haben dieselbe Definition wie in den Nutzungsbedingungen.","privacy-policy-collect-info-head":"WIR ERHEBEN DATEN FOLGENDERMAßEN:","privacy-policy-collect-info-desc1":"1. Wenn Sie sie uns zur Verfügung stellen oder uns die Erlaubnis erteilen, sie zu erheben. Wenn Sie sich für einen unserer Dienste entscheiden, werden wir oder der Mobilfunkbetreiber Ihres Netzwerks Ihre Zahlungsdaten für das Abonnement unserer Dienste einholen. Die vom Mobilfunkbetreiber gesammelten Konto- und Rechnungsdaten unterliegen ihrer jeweiligen Datenschutzrichtlinien.","privacy-policy-collect-info-desc2":"2. Wir erhalten technische Informationen, wenn Sie unsere Sites und/oder Dienste besuchen. Wir erheben ggf. technische Informationen über Sie, wann immer Sie unsere Dienste nutzen. Unser Dienst erfasst jedes Mal, wenn Sie sich bei unseren Diensten an- oder abmelden Logdaten.","privacy-policy-how-collect-info-head":"WIE WIR DIE ERHOBENEN DATEN VERWENDEN","privacy-policy-how-collect-info-subhead":"Wir nutzen Ihre Daten ggf. für die folgenden Zwecke: ","privacy-policy-how-collect-info-desc1":"Um die von Ihnen angefragten Dienste anzubieten. ","privacy-policy-how-collect-info-desc2":"Um Rechnungen für die Ihnen zur Verfügung gestellten Dienst(e) auszustellen.","privacy-policy-how-long-head":"WIE LANGE WIR IHRE DATEN SPEICHERN","privacy-policy-how-long-desc":"Wir werden Ihre Daten so lange speichern, wie dies für die Bereitstellung unserer Dienste erforderlich ist. Wir werden Ihre Daten speichern, um unseren gesetzlichen Verpflichtungen nachzukommen, Streitfragen beizulegen und unsere Vereinbarungen durchzusetzen. Wenn wir Ihre Daten nicht länger benötigen und wir sie nicht länger speichern müssen, um unseren gesetzlichen oder regulatorischen Verpflichtungen nachzukommen, werden wir sie entweder aus unserem System entfernen oder sie anonymisieren, sodass sie nicht mit Ihnen in Verbindung gebracht werden können.","privacy-policy-how-long-protect-head":"WIE WIR IHRE DATEN AUCH AUßERHALB DER EU SCHÜTZEN","privacy-policy-how-long-protect-desc1":"Wir sind bestrebt, Ihre Privatsphäre und Daten zu schützen, doch können wir weder die Sicherheit der von Ihnen an uns übermittelten Daten gewährleisten noch garantieren, dass Ihre Daten nicht durch eine Datenschutzverletung unserer Industriestandards, unserer physischen, technischen oder betrieblichen Sicherheitsmaßnahmen zugänglich gemacht, offengelegt, verändert oder zerstört werden. Wir bedienen uns geeigneter Verfahren zur Datenerhebung, -speicherung und -verarbeitung sowie Sicherheitsmaßnahmen zum Schutz vor unbefugtem oder versehentlichem Zugriff, Änderung, Offenlegung oder Vernichtung Ihrer in unseren Diensten gespeicherten Informationen, Transaktionsinformationen und Daten. ","privacy-policy-how-long-protect-desc2":"Keine Methode der Übertragung über das Internet und keine Methode der elektronischen Speicherung ist jedoch zu 100% sicher. Daher können wir keine absolute Sicherheit garantieren. Wir werden unsere Sicherheitsmaßnahmen kontinuierlich verbessern, sobald neue Technologien verfügbar werden. ","privacy-policy-how-long-protect-desc3":"Da wir international tätig sind, können Ihre Informationen, einschließlich personenbezogener Daten, in die USA/Singapur und/oder in jedes andere Land, das nicht Ihr Wohnsitzland ist, übertragen und dort zur Verfügung gestellt werden. Auch in diesen Ländern bemühen wir uns mit angemessener Sorgfalt, Ihre personenbezogenen Daten zu schützen.","privacy-policy-acceptance-head":"ANNAHME DER DATENSCHUTZRICHTLINIE","privacy-policy-acceptance-desc":"Indem Sie unsere Dienste nutzen, stimmen Sie der Erhebung und Verwendung Ihrer Daten in Übereinstimmung mit dieser Datenschutzrichtlinie zu. Wir behalten uns das Recht vor, diese Datenschutzrichtlinie jederzeit zu ändern, indem wir die jeweiligen Änderungen auf dieser Seite veröffentlichen. Bitte überprüfen Sie das Revisionsdatum unten auf dieser Seite, um festzustellen, ob die Richtlinie geändert wurde, seit sie sie das letzte Mal gelesen haben. Ihre Weiternutzung jeglicher Teile unserer Website oder Dienste, nach Veröffentlichung der aktualisierten Datenschutzerklärung, begründet Ihre Zustimmung zu den Änderungen.","privacy-policy-changes-head":"ÄNDERUNGEN DIESER DATENSCHUTZRICHTLINIE","privacy-policy-changes-desc":"Ggf. nehmen wir von Zeit zu Zeit Änderungen an unserer Datenschutzrichtlinie vor. Sollten wir uns dazu entschließen, unsere Datenschutzrichtlinie zu ändern, werden wir die Änderungen auf dieser Seite veröffentlichen, sodass Sie immer auf die neueste Version der Datenschutzrichtlinie zugreifen können.","privacy-policy-contact-us":"UNS KONTAKTIEREN","privacy-policy-contact-us-desc":"Wenn Sie Fragen zu dieser Datenschutzrichtlinie, den Vorgehensweise der Websites oder Ihrem Umgang mit ihnen haben, kontaktieren Sie uns bitte per E-Mail an support@content-supports.","unsubscribe":"Abmelden","mobile_number":"MSISDN","subscription_date":"Abonnementdatum","renewal_date":"Verlängerungsdatum","applied_plan":"Angewendeter Plan","service_name":"Servicename","weekly":"Wöchentlich","daily":"Täglich","monthly":"Monatlich"}

/***/ }),

/***/ "./src/translations/el.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Αρχική","sidebar.faq":"ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ","sidebar.contact":"EΠΙΚΟΙΝΩΝΙΑ","sidebar.myaccount":"Ο λογαριασμός μου","sidebar.notif":"Ειδοποίηση","sidebar.nonotif":"Δεν έχετε ακόμα ειδοποιήσεις","html5games":"Παιχνίδια HTML 5","androidGames":"Παιχνίδια Android","android-upper":"Android","favorite":"Αγαπημένα","splashscreen.text":"Παίξτε Way Beyond","welcome.text":"Ανακάλυψε τώρα τα καλύτερα online παιχνίδια για το κινητό σου!","welcome.text.gamiclub":"Ανάλυψε το καλύτερο online περιεχομένο τώρα!","accountDetails":"Πληροφορίες λογαριασμού","accountName":"Όνομα","accountEmail":"Διεύθυνση Email","accountLocation":"Τοποθεσία","relatedVideo":"Σχετικά βίντεο","accountInterests":"Ενδιαφέροντα","accountChooseCategory":"Διάλεξε 3 κατηγορίες","accountEditPhoto":"Ενημέρωση φωτογραφίας","save":"Αποθήκευση","topCategories":"Top κατηγορίες","favGames":"Αγαπημενα παιχνίδια","viewAll":"Δες τα όλα","noGamesFound":"Δεν βρέθηκαν παιχνίδια σε αυτή την κατηγορία","noVideosFound":"Δεν βρέθηκαν βίντεο σε αυτή την κατηγορία","cancel":"Ακύρωση","gameDirectories":"Οδηγίες παιχνιδιού","category":"Κατηγορία","platform":"Πλατφορμα","type":"Είδος","android":"Android","games":"Παιχνίδια","html5":"HTML 5","videos":"Βίντεο","search.input.placeholder":"Αναζήτηση...","search.cancel.button":"Ακύρωση","description":"Περιγραφή","downloadNow":"Κατέβασε τώρα","playNow":"Παίξε τώρα","rate":"Βαθμολογία","relatedGames":"Σχετικά παιχνίδια","noFavGames":"Δεν βρέθηκαν ακόμα αγαπημενα παιχνίδια","addFavGames":"Προσθέστε παιχνίδια στα αγαπημένα σας για ανεμπόδιστο παίξιμο","discover":"Ανακαλύψτε","noFavGamesFound":"Δεν βρέθηκαν αγαπημενα παιχνίδια","favorites":"Αγαπημένα","accessDenied":"Δεν επιτρέπεται η πρόσβαση","pageRestricted":"Η σελίδα που ψάχνετε είναι περιορισμένη.","averageRatingBasedOn":"μέσος όρος βαθμολογίας βάσει αξιολογήσεων ","averageRatingReview":"αποκαλύπτω","tnc":"ΟΡΟΙ ΚΑΙ ΠΡΟΫΠΟΘΕΣΕΙΣ","contact_us":"Contact Us","areYouAlready":"Είστε ήδη μέλος του ","thenConfirm":"Στη συνέχεια, επιβεβαιώστε τον αριθμό του κινητού σας και αποκτήστε απεριόριστη πρόσβαση σε όλο το περιεχόμενό μας","login":"Σύνδεση","Action":"Δράση","Adventure":"Περιπέτεια","Arcade":"Ηλεκτρονικά παιχνίδια","Sport":"Σπορ","Racing":"Αγώνες αυτοκινήτου","Premium Games":"Premium παιχνίδια","RPG":"Παιχνίδια RPG","Virtual Reality":"Εικονική πραγματικότητα","Motivation":"Παιχνίδια κινήτρου","Tour":"Περιήγηση","Fun Gaming":"Διασκεδαστικά παιχνίδια","Athletics":"Αθλήματα","Inspiration":"Παιχνίδια έμπνευσης","Into Nature":"Φύση","Political & Activism":"Πολιτκή και ακτιβισμός","Travel":"Ταξίδια","Foodbuzz":"Νόστιμες ιδεές","Health and Nutrition":"Υγεία και διατροφή","Fitness":"Ευεξία","Entertainment":"Ψυχαγωγικά","Top Cars":"Top αυτοκίνητα","Fashion & Beauty":"Μόδα και ομορφιά","E-Learning":"E-Learning","Yoga":"Γιόγκα","Just For Laugh":"Αστεία βίντεο","Brain Boost":"Παιχνίδια λογικής","Rugby":"Ράγκμπι","Economy":"Οικονομία","Environment":"Περιβάλλον","Gaming":"Παιχνίδια","Lifestyle":"Lifestyle","Local Heroes":"Τοπικοί ήρωες","Sports":"Αθλητικά","Technology":"Τεχνολογία","Tutorials":"Οδηγοί","New Arrivals":"Νέες αφίξεις","noFavVideos":"Κανένα αγαπημένο βίντεο ακόμα","addFavVideos":"Προσθέστε βίντεο στα αγαπημένα σας για άμεση πρόσβαση","noFavVideosFound":"Κανένα αγαπημένο βίντεο ακόμα","footer.copyright":"&copy; 2020 Gamelords. Όλα τα δικαιώματα διατηρούνται","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. All Rights Reserved","vid-player":"Παίκτης","privacyPolicy":"ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ","privacy-policy-title":"ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ","privacy-policy-desc":"Αυτή η Πολιτική Απορρήτου εξηγεί τις δεσμεύσεις μας και τα δικαιώματά σας σχετικά με τις πληροφορίες σας. Πρέπει να διαβάσετε προσεκτικά την Πολιτική απορρήτου. Εάν δεν συμφωνείτε με αυτήν την Πολιτική Απορρήτου, μην χρησιμοποιείτε τους Ιστότοπους ή τις Υπηρεσίες μας. Η Πολιτική Απορρήτου ενσωματώνεται δεόντως και υπόκειται στους Όρους Παροχής Υπηρεσιών και διέπει τις ίδιες Υπηρεσίες και Ιστότοπους με αυτούς που αναφέρονται στους Όρους Παροχής Υπηρεσιών. Όλοι οι όροι που χρησιμοποιούμε στην Πολιτική Απορρήτου χωρίς να τους καθορίσουμε έχουν τον ίδιο ορισμό με τους Όρους Παροχής Υπηρεσιών","privacy-policy-collect-info-head":"Συλλέγουμε τις πληροφορίες τους ακόλουθους τρόπους:","privacy-policy-collect-info-desc1":"1.Όταν μας το δώσετε ή μας δώσετε άδεια να το αποκτήσουμε Εάν επιλέξετε να εγγραφείτε σε μια Υπηρεσία από εμάς, εμείς ή ο πάροχος κινητής τηλεφωνίας του δικτύου σας θα συλλέξουμε τις πληροφορίες σας σχετικά με την πληρωμή για τη συνδρομή των Υπηρεσιών μας. Οι πληροφορίες λογαριασμού και χρέωσης που συλλέγονται από τον πάροχο κινητής τηλεφωνίας υπόκεινται στις αντίστοιχες πολιτικές απορρήτου τους.","privacy-policy-collect-info-desc2":"2.Λαμβάνουμε τεχνικές πληροφορίες όταν επισκέπτεστε τους Ιστότοπους ή / και τις Υπηρεσίες μας. Ενδέχεται να συλλέγουμε τεχνικές πληροφορίες για εσάς κάθε φορά που χρησιμοποιείτε τις Υπηρεσίες μας. Συλλέγουμε δεδομένα καταγραφής κάθε φορά που συνδέεστε ή αποσυνδέεστε από τις Υπηρεσίες μας.","privacy-policy-how-collect-info-head":"ΠΩΣ ΧΡΗΣΙΜΟΠΟΙΟΥΜΕ ΣΥΛΛΟΓΕΣ ΠΛΗΡΟΦΟΡΙΩΝ","privacy-policy-how-collect-info-subhead":"Μπορούμε να χρησιμοποιήσουμε τις πληροφορίες σας για τους ακόλουθους σκοπούς:","privacy-policy-how-collect-info-desc1":"· Παρέχετε τις Υπηρεσίες που ζητάτε.","privacy-policy-how-collect-info-desc2":"· Χρέωση και παραλαβή για τις Υπηρεσίες που σας παρέχονται.","privacy-policy-how-long-head":"ΠΩΣ ΜΠΟΡΕΙ ΝΑ ΚΡΑΤΟΥΜΕ ΤΙΣ ΠΛΗΡΟΦΟΡΙΕΣ ΣΑΣ","privacy-policy-how-long-desc":"Θα διατηρήσουμε τα στοιχεία σας για όσο διάστημα απαιτείται για να σας παρέχουμε τις Υπηρεσίες μας. Θα διατηρήσουμε τα στοιχεία σας όπως απαιτείται για να συμμορφωθούμε με τις νομικές μας υποχρεώσεις, να επιλύσουμε τις διαφορές και να επιβάλουμε τις συμφωνίες μας. Όταν δεν χρειάζεται πλέον να χρησιμοποιούμε τις πληροφορίες σας και δεν χρειάζεται να τις διατηρήσουμε ώστε να συμμορφώνεται με τις νομικές ή κανονιστικές μας υποχρεώσεις, είτε θα τις καταργήσουμε από τα συστήματά μας είτε θα τις αποπροσωποποιήσουμε ώστε να μην μπορούμε πλέον να σας αναγνωρίσουμε.","privacy-policy-how-long-protect-head":"ΠΩΣ ΠΡΟΣΤΑΤΕΥΟΥΜΕ ΤΙΣ ΠΛΗΡΟΦΟΡΙΕΣ ΣΑΣ ΕΞΩ ΑΠΟ ΤΗΝ ΕΕ","privacy-policy-how-long-protect-desc1":"Ανησυχούμε για την προστασία του απορρήτου και των δεδομένων σας, αλλά δεν μπορούμε να διασφαλίσουμε ή να εγγυηθούμε την ασφάλεια οποιωνδήποτε πληροφοριών μεταβιβάζετε σε εμάς ή να εγγυηθούμε ότι ενδέχεται να μην προσπελαστούν, να αποκαλυφθούν, να τροποποιηθούν ή να καταστραφούν οι πληροφορίες σας λόγω παραβίασης οποιουδήποτε από τα πρότυπα του βιομηχανικού μας φυσικού, τεχνικές ή διαχειριστικές διασφαλίσεις. Υιοθετούμε κατάλληλες πρακτικές συλλογής, αποθήκευσης και επεξεργασίας δεδομένων και μέτρα ασφαλείας για την προστασία από μη εξουσιοδοτημένη ή τυχαία πρόσβαση, αλλοίωση, αποκάλυψη ή καταστροφή των πληροφοριών σας, των πληροφοριών συναλλαγής και των δεδομένων που είναι αποθηκευμένα στις Υπηρεσίες μας.","privacy-policy-how-long-protect-desc2":"Ωστόσο, καμία μέθοδος μετάδοσης μέσω Διαδικτύου ή μέθοδος ηλεκτρονικής αποθήκευσης δεν είναι 100% ασφαλής. Επομένως, δεν μπορούμε να εγγυηθούμε την απόλυτη ασφάλειά του. Θα συνεχίσουμε να βελτιώνουμε τις διαδικασίες ασφαλείας μας καθώς διατίθεται νέα τεχνολογία.","privacy-policy-how-long-protect-desc3":"Επειδή λειτουργούμε διεθνώς, οι πληροφορίες σας, συμπεριλαμβανομένων των προσωπικών σας στοιχείων, ενδέχεται να μεταφερθούν και να διατεθούν στις ΗΠΑ / Σιγκαπούρη ή / και σε οποιαδήποτε άλλη χώρα εκτός από τη χώρα διαμονής σας. Επίσης σε αυτές τις χώρες, λαμβάνουμε κάθε λογική μέριμνα για την προστασία των προσωπικών σας στοιχείων.","privacy-policy-acceptance-head":"ΑΠΟΔΟΧΗ ΠΟΛΙΤΙΚΗΣ ΑΠΟΡΡΗΤΟΥ","privacy-policy-acceptance-desc":" Χρησιμοποιώντας οποιαδήποτε από τις Υπηρεσίες μας, συναινείτε στη συλλογή και τη χρήση των πληροφοριών σας σύμφωνα με την παρούσα Πολιτική Απορρήτου. Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτήν την Πολιτική Απορρήτου ανά πάσα στιγμή δημοσιεύοντας τις αλλαγές σε αυτήν τη σελίδα. Ελέγξτε την ημερομηνία αναθεώρησης στο κάτω μέρος αυτής της σελίδας για να διαπιστώσετε εάν η πολιτική έχει τροποποιηθεί από την τελευταία κριτική της. Η συνεχής χρήση οποιουδήποτε μέρους του Ιστότοπου ή των Υπηρεσιών μας μετά την ανάρτηση της ενημερωμένης Πολιτικής Απορρήτου θα αποτελεί αποδοχή των αλλαγών.","privacy-policy-changes-head":"ΑΠΟΔΟΧΗ ΠΟΛΙΤΙΚΗΣ ΑΠΟΡΡΗΤΟΥ","privacy-policy-changes-desc":"Χρησιμοποιώντας οποιαδήποτε από τις Υπηρεσίες μας, συναινείτε στη συλλογή και τη χρήση των πληροφοριών σας σύμφωνα με την παρούσα Πολιτική Απορρήτου. Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτήν την Πολιτική Απορρήτου ανά πάσα στιγμή δημοσιεύοντας τις αλλαγές σε αυτήν τη σελίδα. Ελέγξτε την ημερομηνία αναθεώρησης στο κάτω μέρος αυτής της σελίδας για να διαπιστώσετε εάν η πολιτική έχει τροποποιηθεί από την τελευταία κριτική της. Η συνεχής χρήση οποιουδήποτε μέρους του Ιστότοπου ή των Υπηρεσιών μας μετά την ανάρτηση της ενημερωμένης Πολιτικής Απορρήτου θα αποτελεί αποδοχή των αλλαγών.","privacy-policy-contact-us":"ΕΠΙΚΟΙΝΩΝΙΑ ΜΑΣ","privacy-policy-contact-us-desc":"Εάν έχετε κάποια ερώτηση σχετικά με αυτήν την Πολιτική Απορρήτου, τις πρακτικές των Ιστότοπων ή τις συναλλαγές σας με τους Ιστότοπους, επικοινωνήστε μαζί μας στέλνοντας ένα e-mail στη διεύθυνση [Email Address]","unsubscribe":"ΕΓΓΡΑΦΕΙΤΕ ΤΗΝ ΕΓΓΡΑΦΗ","AN INFLUENCER'S CALLING 'EVERYONE HAD TO ACCEPT ME WHEN I ACCEPTED MYSELF'":"Ιnfluencer δηλώνει \"Όλοι έπρεπε να με αποδεχθούν, όταν αποδέχθηκα τον εαυτό μου\"","CRAZY CRAVINGS 'WHEN I'M BEHIND MY MASK, I'M BASICALLY SOMEONE NEW'":"Τρελές επιθυμίες \"Πίσω από τη μάσκα, είμαι ένας άλλος άνθρωπος\"","I'M A CELEBRITY PET LUNA IS A PRICKLY UP-AND-COMER":"Το δημοφιλές κατοικίδιο Luna είναι ένα μαγκιόρικο ανερχόμενο αστέρι","INSPIRE IN A MINUTE THE SUPERMODEL DISCOVERED AT 60":"Έμπνευση του λεπτού: Super model έκανε το ντεμπούτο της στα 60","MY COOL SCHOOL CAMILLA'S STUDYING THE TRAPEZE":"Κουλ σχολείο: H Camilla εκπαιδεύεται ως ακροβάτρια","THE PILOTS FLYING A RESTORED WWII PLANE AROUND THE WORLD":"Οι πιλότοι πετούν σε όλο τον κόσμο με ένα ανακατασκευασμένο αεροπλάνο του 2ου παγκοσμίου πολέμου","YOUNG CEO 'WHEN I LOOK AT A CAMERA, I SEE POWER IN ME & I SEE GREATNESS":"Νεαρός διευθυντής δηλώνει \"όταν κοιτάζω την κάμερα, βλέπω δύναμη και υπεροχή\"","CITY INNOVATIONS THE HIGHER YOU GO, THE GREENER IT GETS":"Αστικές καινοτομίες. Όσο πιο ψηλά πας, τόσο περισσότερο πράσινο βλέπεις","GREEN HEROES THE URBAN EXPERIENCE JUST GOT A SUSTAINABLE UPGRADE":"Πράσινοι Ήρωες: H urban εμπειρία μόλις απέκτησε μια βιώσιμη αναβάθμιση","INSPIRE IN A MINUTE FROM BULLIED BUG HUNTER TO KID AUTHOR":"Έμπνευση του λεπτού: Από θύμα bullying σε παιδί συγγραφέας","SIGHTS WITH HEIGHTS GHANA’S NATIONAL PARK CANOPY WALK":"Περίπατος στο εθνικό πάρκο της Γκάνα","SIGHTS WITH HEIGHTS THE CLIFF SIDE SANCTUARY BETWEEN HEAVEN AND EARTH":"Το καταφύγιο δίπλα στον γκρεμό. Ισορροπώντας ανάμεσα σε γη και ουρανό.","A PLACE TO CALL HOME FOR ABANDONED DOGS":"Ένα σπίτι για εγκαταλελειμένα σκυλιά","BARRY THE BEE WHISPERER’S MOST IMPORTANT FIGHT YET":"Ο σημαντικός αγώνας του γητευτή των μελισσών","CEO ACTIVISM IS ON THE RISE":"Άνοδος στις ακτιβιστικές δράσεις των CEO","INDIGENOUS HEROES NIGERIA'S ELIJAH IS SEEKING LEGAL JUSTICE FOR HIS PEOPLE":"O Elijah από την Νιγηρία αποζητά δικαιοσύνη για το λαό του","INDONESIA TO BUILD A NEW CAPITAL DUE TO CLIMATE CHANGE":"Η Ινδονησία αλλάζει πρωτεύουσα λόγω της κλιματικής αλλαγής","INSPIRE IN A MINUTE BREAKING BORDERS IS A TOUR YOU HAVE TO GO ON":"Έμπνευση στο λεπτό: Oι εκδρομές των Breaking Borders διευρύνουν ορίζοντες","INSPIRE IN A MINUTE FIGHTING MENSTRUAL STIGMA IN NEPAL":"Έμπνευση στο λεπτό: Kαταπολεμώντας το στίγμα της περιόδου στο Νεπάλ","INSPIRE IN A MINUTE HELPING KIDS FIGHT BACK & GET BETTER":"Έμπνευση στο λεπτό: Βοηθώντας παιδιά να βελτιωθούν","MORE THAN HALF OF WORLD’S FOREST WILDLIFE DISAPPEARED":"Πάνω από το 50% της άγριας ζωής στα δάση έχει εξαφανιστεί παγκοσμίως","MY SOCIAL MEDIA ACTIVISM IT'S TIME FOR EVERYONE TO #FILLTHEBOTTLE":"Ακτιβισμός κοινωνικών μέσων. Ακολούθησε το κίνημα #fillthebottle","PEACE BUILDERS CLOSING THE CYCLE OF VIOLENCE":"Ειρηνοποιοί στην Κολομβία σταματάνε τη βία","PEACE BUILDERS THE ART OF PEACEFUL RESISTANCE":"Ειρηνοποιοί στο Πακιστάν κάνουν αντίσταση μέσω της τέχνης","PEACE BUILDERS THE UNITING FACTOR THAT'S BRINGING PEOPLE TOGETHER":"Ειρηνοποιοί: το κίνημα που φέρνει κοντά τους ανθρώπους","THE RESULTS ARE IN, TOKYO IS THE SAFEST CITY IN THE WORLD":"Σύμφωνα με έρευνα, το Τόκυο κρίθηκε ως η ασφαλέστερη πόλη στον κόσμο","HOW TO BE GREEN AT HOME NATURAL STAIN REMOVER":"Πως να φτίαξεις οικολογικό αφαιρετικό λεκέδων μόνος σου","WANNA BE A DJ START WITH THE BASICS FROM A PRO":"Γίνε DJ, μαθαίνοτας τα βασικά από επαγγελματίες","BEST VR EXPERIENCES INTO THE SHARK TANK":"Οι καλύτερες Virtual reality εμπειρίες. Τα σαγόνια του καρχαρία","FROM HUMAN TO CYBORG":"Απο τον άνθρωπό σε ανδροειδές","FUTURISTIC TRANSPORT GETTING AROUND NEVER LOOKED SO COOL":"Η μετακίνηση με φουτουριστικά μέσα, είναι πιο κουλ από ποτέ","NASA’S NEXT DESTINATION IN 2026 TITAN":"Η μετακίνηση με φουτουριστικά μέσα, είναι πιο κουλ από ποτέ","VISIT A SPACE PLACE KOROLEV, RUSSIA'S DEEP SPACE HISTORY":"Επισκέψου το Κορολιόφ. Το λίκνο της σοβιετικής εξερεύνησης του διαστήματος στη Ρωσιά","VISIT A SPACE PLACE THE METEOR CRATER":"Επισκέψου έναν μετεωρικό κρατήρα","VISIT A SPACE PLACE THE NETHERLANDS' SPACE SIMULATOR":"Επισκέψου τον διαστημικό προσωμοιωτή στην Ολλανδία","AMAZING TENNIS COURTS A COURT HIDDEN AMONG CLIFFS":"Επισκέψου τον διαστημικό προσωμοιωτή στην Ολλανδία","BEST VR EXPERIENCES THE EXTREME SPORTS SIMULATOR":"Η καλύτερη Virtual Reality εμπειρία σε αθλητικό προσωμοιωτή","DON’T EXPECT THE U.S. WOMEN’S FOOTBALL SQUAD AT THE WHITE HOUSE":"Η γυναικεία ομάδα ράγκμπυ κέρδισε το Παγκόσμιο Πρωτάθλημα, αλλά δεν θα παραστεί στον Λευκό οίκο","FUTURE FEMALE FOOTBALLER COLOMBIA'S SALOME IS GONNA BE A PRO":"η εκκολαπτόμενη παίκτρια ποδοσφαίρου από την Κολομβία λέγεται Σαλόμη και θα γίνει επαγγελματίας.","MY UNDERGROUND SPORT ALAN NASTY NASH IS A CHAMP TOE WRESTLER":"Επικίνδυνα σπορ: Ο Alan Nasty είναι πρωταθλητής στη πάλη με τα δάχτυλα των ποδιών","MY UNDERGROUND SPORT KABADDI'S GROWING IN INDIA":"MIJN OBSCURE SPORT: KABADDI'S GROEIEN IN INDIA","SPORT FOR CHANGE A GOAL FOR INCLUSION":"Επικίνδυνα σπορ: Το άθλημα Καμπαντί εξελίσσεται στη Ινδία","SPORT FOR CHANGE THE INITIATIVE HITTING IT OUT OF THE PARK":"Η αλλαγή μέσα από τα σπορ. Πώς το baseball μας φέρνει κοντά","THE 5 BEST SUMMER FOOTBALL TRANSFERS SO FAR!":"οι 5 καλύτερες καλοκαιρίνες μεταγραφές του καλοκαριού!","COACHES CLINIC PETE HERRMAN":"Κλινική Pete Herrman για προπονητές","DRIBBLE DRIVE MOTION SKILLS":"Η δεξιότητα της ντρίμπλας","GAMCA COACHES CLINIC":"Κλινική Gamca για προπονητές","ROBERT TUTEIN (UTICA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Υποψήφιος καλύτερος παίκτης για το 2016 στα βραβεία της Geico ο Robert Tutein από την Ουτίκα.","RYAN KELLEY (ARCADIA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Υποψήφιος καλύτερος παίκτης για το 2016 στα βραβεία της Geico ο RYAN KELLEY από την Πενσυλβάνια.","SAM BORST SMITH (ROCHESTER) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Υποψήφιος καλύτερος παίκτης για το 2016 στα βραβεία της Geico ο SAM BORST SMITH από το Ρότσεστερ.","SPECIAL SPECTATORS VISITS THE COLLEGE SLAM DUNK & 3- POINT CHAMPIONSHIPS INTERSPORT":"Ξεχωριστοί θεατές επισκέπτονται τo κολλέγιο μπάσκετ SLAM DUNK & 3- POINT CHAMPIONSHIPS","TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Υποψήφιος καλύτερος παίκτης για το 2016 στα βραβεία της Geico ο TANNER SCHIEVE από το Γουινσκόνσιν.","TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Υποψήφιος καλύτερος παίκτης για το 2016 στα βραβεία της Geico ο TREVOR KRIZENESKY από το Γουινσκόνσιν.","VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"Υποψήφιος καλύτερος παίκτης για το 2016 στα βραβεία της Geico ο VENKY JOIS από την Ουάσινγκτον.","LEARN FREESTYLE FOOTBALL TRICKS LEMMENS AROUND THE WORLD":"Μάθε τα καλύτερα ποδοσφαιρκά κόλπα του Lemmens","PRO FOOTBALLER TRAINING A NEED FOR SPEED":"Επαγγελματίας ποδοσφαίρου προπονείται για καλύτερη απόδοση","PRO FOOTBALLER TRAINING LEG-FOCUSED EXERCISES":"Επαγγελματίας ποδοσφαίρου εκτελεί εξειδικευμένες ασκήσεις για το μυικό σύστημα","PRO FOOTBALLER TRAINING MUSCLES-FOCUSED EXERCISES":"Επαγγελματίας ποδοσφαίρου εκτελεί εξειδικευμένες ασκήσεις για τα πόδια","THERE’S NO POWER FROM KEEPING IT TO YOURSELF'":"Δεν υπάρχει δύναμη στο να τα κρατάς όλα μέσα σου!","3 THINGS MALALA HAS SAID THAT WILL TOTALLY INSPIRE YOU":"3 Αποφθεύγματα της Mαλάλα που θα σε συγκλονίσουν.","BORDER ANGELS SAVING LIVES WITH WATER":"Οι άγγελοι των συνόρων σώζουν ζωές με νερό","BULLIED TO INFLUENCER 'PAINTING HELPS ME DODGE MY PROBLEMS":"Από τον εκφοβισμό στη θετική επιρροή. Η ζωγραφική με βοηθησε με τα προβληματα μου","BULLIED TO INFLUENCER 'YOU CAN BE THE LIGHT IN THE DARKNESS":"Απośśś","PEACE BUILDERS FIGHTING GANGS WITH CLOWNING":"Οι άγγελοι των συνόρων πολεμούν συμμορίες ντυμένοι κλόουν","PEACEBUILDERS INSIDE THE COMMUNITY RING":"Οι άγγελοι των συνόρων σε συνοικιακό ρινγκ","SPORT FOR CHANGE A SURE SHOT TO FEMALE EMPOWERMENT IN ZIMBABWE":"Η αλλαγή μέσα από τα σπορ. Μια σίγουρη κίνηση για την ενίσχυση της γυναίκας υπόληψης στην Ζιμπάμπουε","YOUNG CEO MR. CORY’S COOKIES":"Ο διευθύνων σύμβουλος της εταιρίας μπισκότων Cory's Cookies","CRAZY CRAVINGS 'I'VE BEEN EATING CHALK FOR OVER TWENTY YEARS":"Τρελές επιθυμίες \" έτρωγα κιμωλία για πάνω από 20 χρόνια\"","DARGAVS WELCOME TO THE CITY OF THE DEAD":"Ρωσία - Dargavs \"Καλωσήρθατε στην πόλη των νεκρών\"","HEROES NEIGHBORHOOD TOUR FRIDA KAHLO":"Βόλτα στη γειτονιά της Φρίντα Κάλο","SOLO TRIP HIDDEN GEMS OF BALI":"Ταξίδι; Τα κρυμμένα διαμάντια του Μπαλί","SOLO TRIP HIDDEN GEMS OF BOGOR (INDONESIA)":"Ταξίδι; Τα κρυμμένα διαμάντια του Μπογκόρ στην Ινδονησία","SOLO TRIP THE HIDDEN GEMS OF ROTTERDAM":"Ταξίδι; Τα κρυμμένα διαμάντια του Μπαλί Ροτερνταμ","SUGARY DRINK LOVERS, THIS ONE'S FOR YOU!":"Ποτά για αυτούς που αγαπάνε τη ζάχαρη","THE 5 MOST ICONIC ARMANI RED CARPET LOOKS OF ALL TIME":"Οι 5 καλύτερες εμφανίσεις του Αρμάνι στο κόκκινο χαλί","THE MOST AMAZING ISLAND CANARY ISLANDS":"Οι πανέμορφοι Κανάριοι νήσοι","THE MOST AMAZING ISLAND FAVIGNANA SICILY":"Φαβινιάνα - Το ποιο εντυωσιακό νησί είναι στη Σικελία","THE MOST AMAZING ISLAND TEXEL":"Τέξελ - Ένα εντυωσιακό νησί είναι στην Ολλανδία","THESE NATIONS GIVE EXPATS THE BEST ONLINE LIFE":"Αυτά τα κράτη πάρεχουν στους μετανάστες την καλύτερη online ζωή","5 GAMES YOU WILL LOSE FRIENDS OVER":"Τα 5 παιχνίδια που θα κολλήσεις","5 REASONS TO PLAY MONSTER HUNTER WORLD":"5 λόγοι να παίξεις Monsters Hunter World","BEST VR EXPERIENCES THE SURVIVAL TEST":"Το καλύτερο εικονικό παιχνίδι επιβίωσης","PLACE YOUR BETS! GTA IS GETTING A REAL VIRTUAL CASINO":"Ετοιμαστείτε να ποντάρετε! Το GTA αποκτά πραγματικό online καζίνο","TOP 5 GAMING LAWSUITS":"Οι τοπ 5 δικαστικές υποθέσεις στον χώρο του gaming","TOP 5 HIGHEST GROSSING ARCADE GAMES":"Tα τοπ 5 πιο επικερδή Αrcade παιχνίδια","TOP 5 LEGENDARY GAME COUPLES":"Tα τοπ 5 ζευγάρια στον χώρο του gaming","BUILDERS OF TOMORROW SOLAR WATER HEATER FROM PLASTIC BOTTLES":"Χτίζοντας το αύριο: Ηλιακός θερμοσίφωνας από πλαστικά μπουκάλια","GOT PLASTIC HERE ARE FOUR INNOVATIVE WAYS TO DEAL WITH IT!":"Σας περισσεύει πλαστικό; Ορίστε τέσσερεις καινοτόμοι τρόποι για να το αξιοποιήσετε","SAVING THE PLANET AND MAKING ART, ONE BUTT AT A TIME":"Σώζοντας τον πλανήτη και φτιάχνοντας τέχνη ένα οπίσθιο τη φορά.","THE FASTEST WAY TO SAVE THE PLANET":"O πιο γρήγορος τρόπος για να σώσεις τον πλανήτη","THE UNIQUE ARTIST TURNING TIRES IN MASTERPIECES":"Ένας μοναδικός καλλιτέχνης μετατρέπει τα λάστιχα σε έργα τέχνης","4 LESSONS TO LEARN FROM BUSINESS MOGUL ARIANNA HUFFINGTON":"4 μαθήματα από την μεγαλοεπιχειρηματία Arianna Huffington","BUILDERS OF TOMORROW A FUTURE PAVED WITH PLASTIC":"Χτίζοντας το αύριο: Ένα μέλλον στρωμένο με πλαστικό","JUST HOW VULNERABLE ARE JOBS TO ROBOT TAKEOVERS":"Πόσο ευάλωτες είναι κάποιες δουλειές στην αντικατάσταση με ρομπότ","BEST RUGBY SKILLS - STEPS, TRICKS, OFFLOADS COMPILATION":"Οι καλύτερες Rugby στιγμές - Συλλογική με βήματα, κόλπα και εντυπωσιακές στιγμές","BEST RUGBY SKILLS 2018":"Οι καλύτερες Rugby στιγμές του 2018","BEST RUGBY TRIES 2018":"Τα καλύτερα Rugby σκηνικά του 2018","CRAZIEST RUGBY SKILLS":"Οι πιο εντυπωσιακές Rugby ικανότητες","EPIC RUGBY SKILLS 2017":"Επικά Rugby ταλέντα του 2017","EPIC RUGBY STEPS 2018":"Επικά Rugby βήματα του 2018","RUGBY BIG HITS 2018":"Οι μεγαλύτερες Rugby επιτυχίες του 2018","DITCH THE DOCTOR! HOW ABOUT DIAGNOSIS BY COMPUTER":"Ξεφορτώσου το γιατρό. Πώς να κάνεις διάγνωση μέσω υπολογιστή","ESPN'S NEW DEAL DIVES INTO THE WORLD OF DRONE RACING":"Μια εις βάθος ματιά στους αγώνες δρόμου με Drones","EVER WISHED BEER COULD FLY NOW IT CAN!":"Έχετε ευχηθεί ποτέ να μπορούσε η μπύρα να πετάξει; Τώρα μπορεί!","HEARING THINGS HERE ARE 5 FACTS ON OUR INNER VOICE":"Πέντε γεγονότα αναφορικά με την εσωτερική μας φωνή","IS SPOTTY SKIN THE ANSWER TO LOOKING YOUNGER":"Είναι οι φακίδες η λύση για να μοιάζει κάποιος πιο νέος;","JUST WHY ARE THE DUTCH SO TALL":"Γιατί οι Δανοί είναι τόσο ψηλοί;","MEET THE ROBOT THAT WANTS TO GET TO KNOW YOU":"Συνάντησε το ρομπότ που θέλει να σε γνωρίσει","STAR WARS BECOMES REALITY IN A POST-APOCALYPTIC MALL":"Το Star Wars γίνεται πραγματικότητα σε ένα μετα αποκαλυπτικό εμπορικό κέντρο","SUGAR TAX THE ANSWER TO OBESITY PANDEMIC":"Ο φόρος της ζάχαρης είναι η απάντηση στην επιδημία της παχυσαρκίας.","SWALLOW THIS NANO CHIP TO KNOW WHAT S MAKING YOU SICK":"Κατάπιε αυτό το Nano chip για να ανακαλύψεις τι σε αρρωσταίνει.","THE EXPLODING COST OF CYBERATTACKS":"Το διαρκώς αυξανόμενο κόστος των ιντερνετικών επιθέσεων","TURNS OUT EMAILS DIDN'T SOLVE OUR WASTE PAPER PROBLEMS":"Πώς τα e-mail δεν έλυσαν την αυξημένη χρήση χαρτιού","UK DRONE SHOW THE LATEST CONSUMER INDUSTRY TRENDS":"Bρεττανικά drones δείχνουν τις πιο πρόσφατες τάσεις στην αγορά","VR RUNNING OF THE BULLS! A FEARFUL THRILLSEEKERS DREAM":"Παιχνίδι εικονικής πραγματικότητας με ταύρους! Ένα συναρπαστικό όνειρο γίνεται πραγματικότητα.","AMAZING WATERFALLS ZAMBIA'S JAW-DROPPING NATURAL WONDER":"Οι καταπληκτικοί καταρράκτες της Zambia. Ένα φυσικό θαύμα!","FAIRY TALE DREAM SPOTS THE PRETTIEST VILLAGE IN ANDALUCÍA":"Φανταστικά μέρη: To ομορφότερο χωριό στην Ανδαλουσία!","FAIRY TALE DREAM SPOTS THE SINKING CASTLE OF SCALIGERA":"Φανταστικά μέρη: To βυθιζόμενο κάστρο της Σκαλιγκέρα","MEDELLÍN IS THE BACKPACKING SPOT YOU'VE BEEN LOOKING FOR":"Medellin: To τουριστικό σημείο που πάντα αναζητούσατε.","SIGHTS WITH HEIGHTS THE NARROW BRIDGES OF CAMINITO DEL REY":"Αξιοθέατα σε μεγάλα ύψη. Οι στενές γέφυρες του Caminito Del Rey","THIS DUTCH PARADE TAKES FLOWER POWER TO THE NEXT LEVEL":"Αυτή η Ολλανδική παρέλαση πάει την \"Δύναμη των λουλουδιών\" σε άλλο επίπεδο","INSTA RESTAURANT WE COULD ALL USE A BIT MORE PINK IN OUR LIVES":"Εστιατόριο της στιγμής: Όλοι μπορούμε να βάλουμε λίγο περισσότερο ροζ στη ζωή μας","KFC IS TESTING MEATLESS CHICKEN WINGS AND NUGGETS":"Το KFC πειραματίζεται με φτερούγες και κοτομπουκιές δίχως κρέας","TURNING LEFTOVER BREAD INTO PANZANELLA & BRUSCHETTA CAPRESE":"Πώς να μετατρέψετε το εναπομείναν ψωμί σε Panzanella και Μπρουσκέτες","SALSAS FOR SUNNY DAYS SPICY MANGO SALSA":"Συνταγή για πικάντική μάνγκο σάλτσα","VEGAN ICE CREAM AVOCADO BANANA":"Συνταγή για vegan παγωτό με αβοκάντο και μπανάνα","VEGAN ICE CREAM COCONUT FUSION":"Συνταγή για vegan παγωτό με καρύδα","VEGAN ICE CREAM FRESH FRUIT POPSICLES":"Συνταγή για vegan γρανίτες με φρέσκα φρούτα","VEGAN ICE CREAM PINEAPPLE MINT LIME":"Συνταγή για vegan παγωτό με ανανά, μέντα και lime","VEGAN ICE CREAM BANANA MATCHA":"Συνταγή για vegan παγωτό με μπανάνα και τσάι matcha","BRAIN IMPLANTS ARE CLOSER THAN YOU MIGHT THINK":"Τα εμφυτεύματα εγκεφάλου είναι πιο κοντά στην πραγματικότητα από ότι νομίζετε","THANKS, CHAMELEONS HUMANS MIGHT GET COLOR-CHANGING SKIN":"Χάρη στους χαμαιλέοντες οι άνθρωποι ίσως μπορέσουν να αποκτήσουν δερμα που αλλάζει χρώματα","ARM AND LEG RAISE":"Σηκώματα χεριών και ποδιών","CONDITION TRAINING":"Ασκήσεις φυσικής κατάστασης","CORE STRENGTH":"Ενδυνάμωση κορμού","LUNGES":"Καθίσματα","PUNCH BAG":"Σάκος του μποξ","SHADOW BOXING":"Shadow boxing","STRETCHING":"Ανοίγματα","2016 CHEVROLET CAMARO SS":"Απολαύστε την Chevrolet CAMARO SS του 2016","2016 FORD MUSTANG FASTBACK":"Απολαύστε το Ford Mustang Fastback του 2016","2016 FORD MUSTANG GT4":"Απολαύστε το Ford Mustang GT4 του 2016","2016 TOYOTA PRIUS G RACING CAR":"Απολαύστε το Toyota Prius G του 2016","2016 TOYOTA XTREME COROLLA":"Απολαύστε το Toyota Extreme του 2016","ARABIC EPS 1 - HOW TO INTRODUCE YOURSELF":"Μάθε Αραβικά - Πως να συστήνεσαι","ARABIC EPS 2 - THANK YO":"Μάθε Αραβικά - Πως να λες \"ευχαριστώ\"","ENGLISH EPS 3 - ASKING ABOUT HOBBIES":"Μάθε Αγγλικά - Πως να συζητάς για χόμπι","ENGLISH EPS 4 - WHERE ARE YOU FROM":"Μάθε Αγγλικά - Πως να ρωτάς \"από που είσαι;\"","FRENCH EPS 5 - HOW TO APOLOGIZE":"Μάθε Γαλλικά - Πως να ζητάς \"συγνώμη\"","FRENCH EPS 6 - ASKING DO YOU SPEAK ENGLISH":"Μάθε Γαλλικά - Πως να ρωτάς \"μιλάς αγγλικά;\"","ITALIAN EPS 7- APOLOGIES":"Μάθε Ιταλικά - Πως να ζητάς \"συγνώμη\"","ITALIAN EPS 8 - HOW MUCH":"Μάθε Ιταλικά - Πως να ρωτάς \"πόσο κάνει\"","SPANISH EPS 9 - WHERE ARE YOU FROM":"Μάθε Ισπανικά - Πως να ρωτάς \"από που είσαι;\"","SPANISH EPS 10 - WHAT'S UP":"Μάθε Ισπανικά - Πως να λες \"τι γίνεται;\"","HOW TO POST NATAL YOGA BREATHING EXERCISE":"Αναπνοές Yoga για εγκύους","HOW TO IN 60 SECONDS":"60 δευτερόλεπτα κάνουν τη διαφορά","HOW TO POST NATAL YOGA - DANDASANA":"Yoga για εγκύους - Εάν το μωρό χρειάζεται ψυχαγώγηση","HOW TO POST NATAL YOGA - IF BABY NEEDS ENTERTAINMENT":"Yoga για εγκύους - Στάση Dandasana","PILATES HALF ROLL BACK":"PILATES - Μάθε το Half Roll Back","BECOME FLEXIBLE WITH YOGA":"Γίνε ευλίγιστός με Yoga","FIND PEACE AT HOME WITH YOGA":"Βρες τη γαλήνη στο σπίτι σου κάνοντας Yoga","FIND PEACE WITH YOGA":"Βρες τη γαλήνη κάνοντας Yoga","GET SLIM & FIT WITH YOGA":"Φτιάξε το σώμα που θες με Yoga","LEARN THE ART OF YOGA":"Μάθε την τέχνη της Yoga","LOST WEIGHT WITH YOGA":"Χάσε βάρος με τη Yoga","MASTER CORE YOGA POSES":"Στάσεις Yoga για τον κορμό","MIND OVER MATTER":"Έλεγξε το άγχος και την κούραση με τη δύναμη του μυαλού σου","ULTIMATE YOGA GUIDE":"Ο απόλυτος οδηγός yoga","YOGA VILLAGE":"Το χωριό της Yoga","YOGA YOUR WAY TO HEALTHY LIVING":"Βρες το δρόμο προς την υγιεινή ζωή με Yoga","ANIMALS EXOTICOS":"Εξωτικά ζώα","AUTOMATU":"Αυτόματα μηχανήματα","BABIES AND MOVING TABLE PART 1":"ΜΩΡΑ ΚΑΙ ΚΙΝΗΤΟΣ ΠΙΝΑΚΑΣ ΜΕΡΟΣ 1","BAD KIDS THROW ORANGE PEELS PART 1":"Άτακτα παιδιά πετάνε φλούδες από πορτοκάλι Μέρος 1","BIG BUNNY SCARES BABIES PART 1":"Μεγάλος κούνελος τρομάζει μωρά Μερός 1","BODYGUARDS":"Σωματοφύλακες","CAKE ON FACE":"Τουρτοπόλεμος","CAN I CLICK YOUR PHOTO":"Να σε βγάλω μια φωτογραφία;","CAR PARKING":"Θέσεις πάρκινγκ","CAR FOR SALE":"Αυτοκίνητα προς πώληση","MAN FALLING ON LADDER":"Άντρας πέφτει από σκάλα","MAN IN GARBAGE CAN PART 1":"Άντρας βρίσκεται μέσα στα σκουπίδια Μέρος 1","PAINTING EXHIBITION":"Έκθεση ζωγραφικής","RECKLESS BLIND MAN PART 1":"Ριψοκίνδυνος τυφλός άντρας Μέρος 1","ROLLER BLADER PART 1":"Roller Blades Μέρος 1","RUDE MAN ON BEACH PART 1":"Αγενήε άντρας στην παραλία","SANTA CLAUS THE PERVERT PART 1":"Ο ακόλαστος Άγιος Βασίλης","BABY CARIER ON CAR":"Παιδικό καθισματάκι αυτοκινήτου","BLEEDING NOSE":"Ρινορραγία","MONEY FALLING":"Βροχή χρημάτων","OPEN THIS PEN":"Δες αυτό το στυλό","GLAMOROUS TOUCH":"Πινελιές κομψότητας","LIPS GLAMOROUS RED":"Λαμπερά κόκκινα χείλη","LIPS NATURAL":"Φυσικά χείλη","LIPS SPARKLING AND FULL":"Αστραφτερά γεμάτα χείλη","MAKE-UP BLUSH":"Μακιγιάζ - Ρούζ","MAKE-UP BRONZER":"Μακιγιάζ - Μπρόνζερ","MAKE-UP CONCEALER":"Μακιγιάζ - Κονσίλερ","MAKE-UP EYEBROWS":"Μακιγιάζ - Φρύδια","MAKE-UP FOUNDATION":"Μακιγιάζ - Κάλυψη","SMOKEY EYES":"Μακιγιάζ - Smokey eyes","SPARKLING EYES":"Μακιγιάζ -Σπινθηροβόλα μάτια","5 MAKE UP TIPS AND TRICKS FOR YOU":"Μακιγιάζ- 5 έξυπνα τρικ για σένα","7 MAKE UP TIPS AND TRICKS FOR FLAWLESS SKIN":"Μακιγιάζ- 7 έξυπνα τρικ για αψεγάδιαστο δέρμα","10 FAST AND EASY MAKE UP TIPS":"10 έξυπνες ιδεές για εύκολο μακιγιάζ","10 MAKE UP TIPS AND TRICKS FOR OILY SKIN":"Μακιγιάζ- 10 ιδεές και έξυπνα έξυπνα τρικ για λιπαρά δέρματα","13 MAKE UP MISTAKES TO AVOID":"Μακιγιάζ- 13 λάθη που πρέπει να αποφύγετε","101 TIPS FOR BEGINNER MAKE UP":"Μακιγιάζ- 101 συμβουλές για αρχάριους","ASIAN BEAUTY TIPS YOU MUST DO NOW":"Ασιατική ομορφιά- συμβουλές που πρέπει να ακολουθήσεις","BEGINNER EVERY MAKE UP TIPS AND TRICKS FOR YOU":"Μακιγιάζ - Όλα τα τρικς και οι ιδεές για αρχάριους","BEST MAKE UP ARTIST TIPS YOU NEED TO KNOW":"Οι καλύτερες συμβουλές των make-up artists","ESSENTIAL MAKE UP TIPS FOR SUMMER GLOW":"Μακιγιάζ - Απαραίτητες συμβουλές για καλοκαρινή λάμψη","FLATTERING EYES MAKE UP FOR YOU":"Μακιγιάζ - Γοητευτικά μάτια","FOUNDATION TRICKS FOR OILY SKIN":"Συμβουλές για μακιγιάζ για λιπαρό δέρμα","FULL COVERAGE FOUNDATION ROUTINE FOR YOU":"Μακιγιάζ - Πλήρης καλυπτικότητα για σένα","LOOK FIERCE WITH DRUGSTORE MAKE UP":"Μακιγιάζ - Έντονο αποτέλεσμα με προϊόντα φαρμακείου","MAKE UP ESSENTIALS FOR DARK SKIN TONES":"Μακιγιάζ - Βασικά συμβουλές για σκούρα δέρματα","MAKE UP TIPS FOR AGING EYES":"Μακιγιάζ - Έξυπνες συμβουλές για τις ρυτίδες των ματιών","MAKE UP TIPS FOR FLAWLESS SKIN":"Μακιγιάζ - Έξυπνες συμβουλές για αψεγάδιαστο δέρμα","MUST KNOW MAKE UP TIPS":"Μακιγιάζ - Κόλπα που πρέπει να γνωρίζεις","MUST KNOW WAKE UP TIPS":"Μακιγιάζ - Τι να κάνεις αν έχεις μόλις ξυπνήσει","NATURAL MAKE UP KOREAN STYLE":"Κορεάτικο μακιγιάζ - Το φυσικό δέρμα","NATURAL MAKE UP TIPS FOR MEN":"Μακιγιάζ για άνδρες - Συμβουλές για φυσικό αποτέλεσμα","NATURAL TO GLAMOROUS":"Από το φυσικό στο φανταχτερό","OVER 40 AGED WOMAN MAKE UP TIPS":"Μακιγιάζ - Συμβουλές για γυναίκες άνω των 40","PRO MAKE UP TIPS BY TATI":"Μακιγιάζ - Επαγγελματικές συμβουλές από την Τατί","SECRET MAKE UP TIPS AND TRICKS FOR BEGINNERS":"Μακιγιάζ - Μυστικές συμβουλές και κόλπα για αρχάριους","SIMPLE TIPS FOR EYESHADOW":"Μακιγιάζ - Απλές συμβουλές για να διαλέξεις σκια ματιών","SUMMER MAKE UP MELTPROOF TIPS":"Κολπα για σταθερό make up το καλοκαίρι","TOP 10 SECRET TIPS OF CELEBRITIES":"Οι τοπ 10 μυστικές συμβουλές των διασήμων","TOP 25 MAKE UP TIPS FOR PALE SKIN":"Οι τοπ 25 συμβουλές μακιγιάζ για χλωμό δέρμα","TYRA BANKS MAKE UP TIPS":"Μυστικά μακιγιάζ από την Tyra Banks","privacy-policy-gr-head1":"1. Πολιτική Απορρήτου: Στόχοι και πεδίο ερφαρμογής","privacy-policy-gr-Purposes-desc1":"Η παρούσα Πολιτική Απορρήτού αναφέρεται στην παροχή Υπηρεσιών της εταιρεία με την επωνυμία Sam Media BV η οποία εδρεύει στην Ολλανδία (Van Diemenstraat 356  1013 CR Amsterdam) με ΑΦΜ VAT NL 8187 94 859 B01 και αριθμό εγγραφής 164831301000 στο οικείο Εμπορικό Επιμελητήριο (εφεξής, στην παρούσα θα καλείται η «Εταιρεία»).","privacy-policy-gr-Purposes-desc2":"Σκοπός της παρούσας Πολιτικής Απορρήτου αποτελεί η περιγραφή του τρόπου συλλογής και επεξεργασίας των προσωπικών δεδομένων, τα οποία λαμβάνονται, μέσω διαδικτύου ή με άλλους τρόπους καθώς επίσης, και οι πρακτικές απορρήτου της Εταιρείας.","privacy-policy-gr-Purposes-desc3":"Η Εταιρεία δεσμεύεται να λαμβάνει όλα τα κατάλληλα μέτρα προκειμένου να προστατεύει και να επεξεργάζεται νόμιμα τα προσωπικά δεδομένα, όπως προβλέπεται από τον Γενικό Κανονισμό Προστασίας Προσωπικών Δεδομένων της ΕΕ 679/2016 (ΓΚΠΔ) και τους κατ’ ιδίαν συναφείς Νόμους εφαρμογής του.","privacy-policy-gr-Purposes-desc4":"Οι Υπηρεσίες που παρέχονται από την Εταιρεία απευθύνονται σε ενήλικες και ως εκ τούτου, δεν συλλέγονται προσωπικές πληροφορίες από πρόσωπο, το οποίο είναι γνωστό ότι είναι κάτω των 18 ετών, χωρίς την προηγούμενη επαληθεύσιμη συγκατάθεση του ασκούντος την γονική μέριμνα. Σε κάθε περίπτωση, ο ασκών τη γονική μέριμνα έχει το δικαίωμα, κατόπιν αιτήματος του, να ενημερωθεί για τις πληροφορίες που δόθηκαν από τον ανήλικο και/ή να ζητήσει την διαγραφή τους. Εφόσον γίνει αντιληπτό από την Εταιρεία ότι ένα άτομο, το οποίο υποβάλλει τα προσωπικά του δεδομένα, είναι μικρότερο των 18 ετών, θα προβεί άμεσα στη διαγραφή τους.","privacy-policy-gr-Purposes-desc5":"Η εν λόγω Πολιτική Απορρήτου ενσωματώνεται στους ‘’Γενικούς Όρους & Προϋποθέσεις’’, οι οποίοι είναι αναρτημένοι στην ιστοσελίδα της Εταιρείας, με τους οποίους αποτελούν ενιαίο κείμενο. Οι δραστηριότητες της Εταιρείας διεξάγονται μέσω του ιστότοπου https://sam-media.com/","privacy-policy-gr-head2":"2. Ορισμοί","privacy-policy-gr-desc6":"Προσωπικά Δεδομένα: κάθε πληροφορία που αφορά ταυτοποιημένο ή ταυτοποιήσιμο φυσικό πρόσωπο. Το ταυτοποιήσιμο φυσικό πρόσωπο είναι εκείνο του οποίου η ταυτότητα μπορεί να εξακριβωθεί, άμεσα ή έμμεσα, ιδίως μέσω αναφοράς σε αναγνωριστικό στοιχείο ταυτότητας, όπως όνομα, σε αριθμό ταυτότητας, σε δεδομένα θέσης, σε έναν ή περισσότερους παράγοντες που προσιδιάζουν στη σωματική, φυσιολογική, ψυχολογική, οικονομική, πολιτιστική ή κοινωνική ταυτότητα του.","privacy-policy-gr-desc69":"Υποκείμενο Δεδομένων: κάθε φυσικό πρόσωπο του οποίου τα προσωπικά δεδομένα αποτελούν αντικείμενο επεξεργασίας από ή για λογαριασμό της Εταιρείας.","privacy-policy-gr-desc7":"Επεξεργασία: οποιαδήποτε δραστηριότητα που περιλαμβάνει προσωπικά δεδομένα, ανεξάρτητα από τα μέσα και τη διαδικασία που εφαρμόζεται, π.χ. η συλλογή, αποθήκευση, χρήση, αναθεώρηση, αποκάλυψη, αρχειοθέτηση, προβολή και καταστροφή προσωπικών δεδομένων.","privacy-policy-gr-desc8":"Περιορισμός της επεξεργασίας: η επισήμανση αποθηκευμένων δεδομένων προσωπικού χαρακτήρα με στόχο τον περιορισμό της επεξεργασίας τους στο μέλλον.","privacy-policy-gr-desc9":"Κατάρτιση προφίλ: οποιαδήποτε μορφή αυτοματοποιημένης επεξεργασίας δεδομένων προσωπικού χαρακτήρα που συνίσταται στη χρήση δεδομένων προσωπικού χαρακτήρα για την αξιολόγηση ορισμένων προσωπικών πτυχών ενός φυσικού προσώπου.","privacy-policy-gr-desc10":"Σύστημα αρχειοθέτησης: κάθε διαρθρωμένο σύνολο δεδομένων προσωπικού χαρακτήρα τα οποία είναι προσβάσιμα με γνώμονα συγκεκριμένα κριτήρια, είτε το σύνολο αυτό είναι συγκεντρωμένο είτε αποκεντρωμένο είτε κατανεμημένο σε λειτουργική ή γεωγραφική βάση.","privacy-policy-gr-desc11":"Διαβίβαση: η πρόσβαση στα προσωπικά δεδομένα, για παράδειγμα επιτρέποντας πρόσβαση, μετάδοση ή δημοσίευση.","privacy-policy-gr-desc12":"Υπεύθυνος επεξεργασίας: το φυσικό ή νομικό πρόσωπο που αποφασίζει για το σκοπό, τον τρόπο, το περιεχόμενο και τη διαδικασία επεξεργασίας δεδομένων προσωπικού χαρακτήρα.","privacy-policy-gr-desc13":"Εκτελών την επεξεργασία: το φυσικό ή νομικό πρόσωπο που επεξεργάζεται δεδομένα προσωπικού χαρακτήρα σύμφωνα με τις οδηγίες του υπεύθυνου επεξεργασίας δεδομένων.","privacy-policy-gr-desc14":"Συγκατάθεση του υποκειμένου των δεδομένων: κάθε ένδειξη βουλήσεως, ελεύθερη, συγκεκριμένη, ρητή και εν πλήρει επιγνώσει, με την οποία το υποκείμενο των δεδομένων εκδηλώνει ότι συμφωνεί, με δήλωση ή με σαφή θετική ενέργεια, να αποτελέσουν αντικείμενο επεξεργασίας τα δεδομένα προσωπικού χαρακτήρα που το αφορούν","privacy-policy-gr-head3":"3. Σκοπός Επεξεργασίας των Δεδομένων","privacy-policy-gr-desc15":"Η επεξεργασία των προσωπικών δεδομένων από την Εταιρεία γίνεται αποκλειστικά για τον σκοπό που υποδεικνύεται κατά την στιγμή της συλλογής στα πλαίσια παροχής των Υπηρεσιών της Εταιρείας καθώς και για κάθε νόμιμο σκοπό.","privacy-policy-gr-desc16":"Οι συλλεχθείσες πληροφορίες προσωπικού χαρακτήρα, που συλλέγονται από την Εταιρεία, διευκολύνουν την δημιουργία ή βελτίωση και την εξατομίκευση της σχέσης της Εταιρείας με τους αποδέκτες των Υπηρεσιών της.","privacy-policy-gr-desc17":"Η επεξεργασία των προσωπικών δεδομένων γίνεται πάντοτε στα πλαίσια του Νόμου και σύμφωνα με τις αρχές της καλής πίστης. Γι’ αυτό τον λόγο τα προσωπικά δεδομένα που συλλέγονται ή αποθηκεύονται είναι μόνο όσα κρίνονται απαραίτητα για την εκπλήρωση του σκοπού της επεξεργασίας τους. Επίσης, η Εταιρεία λαμβάνει όλα τα κατάλληλα μέτρα προς διασφάλιση της νομιμότητας της επεξεργασίας, η οποία πρέπει να ανταποκρίνεται στον σκοπό συλλογής των προσωπικών δεδομένων.","privacy-policy-gr-desc18":"Το σύννομο της επεξεργασίας των προσωπικών δεδομένων για το συγκεκριμένο σκοπό βασίζεται στη συγκατάθεση του Τελικού Χρήστη, σύμφωνα με το άρθρο 6 παράγραφος 1 στοιχείο α και άρθρο 9 παράγραφος 2 στοιχείο α του κανονισμού GDPR, και στην εκτέλεση της σύμβασης στην οποία είναι συμβαλλόμενο μέρος, ως υποκείμενο των δεδομένων (άρθρο 6 παράγραφος 1 στοιχείο β Κανονισμού GDPR)·","privacy-policy-gr-head4":"4. Είδη Προσωπικών Δεδομένων που συλλέγονται","privacy-policy-gr-desc19":"Το είδος προσωπικών δεδομένων που συλλέγονται συμπεριλαμβάνει το πλήρες ονοματεπώνυμό, την ηλεκτρονική διεύθυνση, πληροφορίες χρέωσης ή αριθμό κινητού τηλεφώνου και παρόμοια δεδομένα, όπως αυτά μπορεί να ζητηθούν ανά διαστήματα. Σε κάθε περίπτωση απαραίτητη προϋπόθεση της συλλογής και επεξεργασίας των προσωπικών σας δεδομένων είναι η ρητή παροχή συγκατάθεσης εκ μέρους σας.","privacy-policy-gr-head5":"5. Τρόποι Συλλογή των Προσωπικών Δεδομένων","privacy-policy-gr-desc20":"Η συλλογή των προσωπικών δεδομένων πραγματοποιείται είτε με την αυτόβουλη παροχή τους στην Εταιρεία από εσάς, είτε με αυτόματα μέσα. Ειδικότερα:","privacy-policy-gr-desc211":"Παροχή Προσωπικών Πληροφοριών από τα ίδια τα Υποκείμενα των Δεδομένων","privacy-policy-gr-desc21":"Η Εταιρεία συλλέγει προσωπικά δεδομένα, εσείς υποβάλλετε αυτοβούλως προσωπικές σας πληροφορίες. Το παραπάνω συντρέχει στις εξής περιπτώσεις:","privacy-policy-gr-desc22":"- κατά την εγγραφή σας στον Ιστότοπο της Εταιρείας για λήψη Υπηρεσιών ψυχαγωγικού περιεχομένου κινητών τηλεφώνων, όπως ήχους ειδοποιήσεων, παιχνίδια, φωτογραφίες, ειδήσεις και άλλα αντικείμενα,","privacy-policy-gr-desc23":"- κατά την πραγματοποίηση σύνδεσης σας με την επιλογή της λήψης αρχείων της Εταιρείας, χωρίς εγγραφή, στην ιστοσελίδα https://sam-media.com/, όπως στην περίπτωση των Μεμονωμένων Λήψεων ή Συνδρομών μέσω SMS με την χρήση του κινητού σας τηλεφώνου,","privacy-policy-gr-desc24":"- με την υποβολή από εσάς  απόψεων, προτάσεων, παρατηρήσεων ή παραπόνων στην Εταιρεία ή μέσω κάθε επικοινωνίας που πραγματοποιείται με την Εταιρεία,","privacy-policy-gr-desc25":"- κατά την υποβολή δήλωσης συμμετοχής σας σε δραστηριότητες της Εταιρείας όπως διαγωνισμούς, παιχνίδια, έρευνες, φόρουμ,","privacy-policy-gr-desc26":"- με την μεταφορά των προσωπικών σας δεδομένων από τρίτα μέρη με τα οποία η Εταιρεία συνεργάζεται και είναι αξιόπιστα. Η μεταφορά αυτή πραγματοποιείται στα πλαίσια επίτευξης του σκοπού για τον οποίο υποβάλλατε τα προσωπικά σας δεδομένα, δίνοντας την σχετική συγκατάθεση σας,","privacy-policy-gr-desc27":"- μεταφορά των προσωπικών σας δεδομένων στην Εταιρεία από δημόσιες βάσεις δεδομένων. ","privacy-policy-gr-desc28":"Συλλογή Προσωπικών Πληροφοριών μέσω Αυτοματοποιημένων Μέσων (Cookies)-Πολιτική της Εταιρείας","privacy-policy-gr-desc29":"Τα cookies αποτελούν μικρά αρχεία κειμένου τα οποία χρησιμοποιούνται για την αποθήκευση δεδομένων σχετικά με εσάς και τις προτιμήσεις σας. Κάθε φορά που πραγματοποείτε περιήγηση σε συγκεκριμένες ιστοσελίδες, τοποθετούνται αυτόματα σε προκαθορισμένο φάκελο του υπολογιστή σας, από τον διακομιστή. Σκοπός των cookies είναι να διακρίνουν μοναδικά τον υπολογιστή σας στον διακομιστή. Με αυτό τον τρόπο δίνεται η δυνατότητα στην Εταιρεία να συλλέγει πληροφορίες σε σχέση με τον διακομιστή ώστε να διευκολύνεται η περιήγηση σας στο διαδίκτυο, η αξιολόγηση και ο έλεγχος της λειτουργίας της ιστοεσλίδας.","privacy-policy-gr-desc30":"Με την χρήση των cookies η Εταιρεία μπορεί να αναγνωρίσει το πρόγραμμα περιήγησής σας στο διαδίκτυο και να προσδιορίσει εάν έχει εγκαταστήσει το λογισμικό ενεργοποίησης που απαιτείται για πρόσβαση σε συγκεκριμένο υλικό στις τοποθεσίες της Εταιρείας στο διαδίκτυο. Επίσης, μέσω των cookies η Εταιρεία μπορεί να προσδιορίσει το συνολικό αριθμό επισκεπτών στην  ιστοσελίδα της και να σας αναγνωρίσει όταν επιστρέψετε στον ιστότοπο της. Πληροφορίες σχετικά με τις δραστηριότητές σας στον ιστότοπο της Εταιρείας και άλλα μη προσωπικά δεδομένα σας, είναι δυνατό να χρησιμοποιηθούν, ώστε να εμφανίζονται μόνο οι ηλεκτρονικές διαφημίσεις που η Εταιρεία θεωρεί ότι ανταποκρίνονται στα ενδιαφέροντα σας.","privacy-policy-gr-desc31":"Τα cookies έχουν την δυνατότητα να αποθηκεύουν τον κωδικό πρόσβασής σας σε μια τοποθεσία για εύκολη σύνδεση, την οποία έχετε προηγουμένως επισκεφθεί καθώς επίσης να αποθηκεύσουν δεδομένα σχετικά με τις προτιμήσεις σας, για να σας παραπέμψουν σε μια προσαρμοσμένη σε αυτές ιστοσελίδα.","privacy-policy-gr-desc32":"Αναγνωρίσιμες πληροφορίες σχετικά με την ταυτότητα σας δεν είναι δυνατόν να συλλεχθούν μέσω των cookies ή άλλων συναφών μέσων αναγνώρισης. Το παραπάνω συμβαίνει αποκλειστικά και μόνο στην περίπτωση που ο Τελικός Χρήστης οικειοθελώς υποβάλλει αναγνωρίσιμη πληροφορία, οπότε τα αυτοματοποιμένα μέσα θα χρησιμοποιηθούν για να δώσουν περαιτέρω πληροφορίες σχετικά με την χρήση που πραγματοποιείτε στις ιστοσελίδες και/ή τα διαδραστικά (interactive) ηλεκτρονικά μηνύματα, με μοναδικό σκοπό να αυξηθεί η χρησιμότητά τους για εσάς. Τέτοιες περιπτώσεις ενδεικτικά αποτελούν η υποβολή αίτησης εγγραφής στις Υπηρεσίες της Εταιρείας ή η αποστολή ηλεκτρονικού μηνύματος.","privacy-policy-gr-desc33":"Στην πλειοψηφία του τα προγράμματα περιήγησης (browsers) είναι προγραμματισμένα να δέχονται cookies. Ωστόσο, υπάρχει η δυνατότητα να ρυθμίσετε το δικό σας πρόγραμμα περιήγησης κατά τέτοιο τρόπο ώστε να αρνείται την λήψη των cookies ή να ειδοποιείσθε κάθε φορά που λαμβάνει ένα cookie. Σημειώνεται ότι στη τελευταία περίπτωση είναι πιθανό ορισμένα μέρη της ιστοσελίδας να μην λειτουργήσουν σωστά σε περίπτωση που έχετε επιλέξει την απόρριψη των cookies και να μην έχετε πρόσβαση σε ορισμένες δυνατότητες.","privacy-policy-gr-desc34":"Είναι εφικτό, επίσης, η Εταιρεία να χρησιμοποιήσει cookies ή παρόμοια εργαλεία για να συσχετίσει τη χρήση του ιστότοπού της από εσάς με προσωπικά δεδομένα που λαμβάνονται από την ίδια ή ένα τρίτο μέρος, αξιόπιστο συνεργάτη της Εταιρείας.","privacy-policy-gr-desc35":"Το παραπάνω μπορεί να συμβεί ενδεικτικά στην περίπτωση που έχετε ζητήσει από την Εταιρεία την αποστολή πληροφοριών σχετικά με μελλοντικά προϊόντα ή προωθητικές ενέργειές της Εταιρείας, cookies ή/και ιστορικό περιήγησης στο διαδίκτυο σχετικά με τις δραστηριότητές σας στον ιστότοπό της Εταιρείας μπορεί να της επιτρέψουν να περιορίσει το υλικό που σας παρέσει σε αυτό που θεωρεί ότι θα βρείτε ενδιαφέρον, με βάση τις προηγούμενες ηλεκτρονικές σας δραστηριότητες και προτιμήσεις. Στην πιο πάνω περίπτωση που η εταιρεία επιθυμεί να συνδυάσει τα προσωπικά δεδομένα σας και cookies ή πληροφορίες ιστορικού περιήγησης στο διαδίκτυο  με αυτόν τον τρόπο, θα λάβει απαραίτητα την προηγούμενη ρητή συγκατάθεσή σας. ","privacy-policy-gr-desc36":"Στην ιστοσελίδα της Εταιρείας ενδέχεται να εμφανίζονται διαφημίσεις τρίτων, οι οποίες μπορούν, επίσης, να περιέχουν cookies. Τα συγκεκριμένα cookies ορίζονται από τον εκάστοτε διαφημιστή ή τον διαφημιζόμενο και η Εταιρεία δεν έχει την δυνατότητα να τα ελέγχει. Ως εκ τούτου, θα πρέπει να ελέγχετε την πολιτική απορρήτου του διαφημιστή ή διαφημιζόμενου, προκειμένου να διαπιστώσετε εάν γίνεται χρήση cookies και με ποιον τρόπο. ","privacy-policy-gr-desc37":"Τέλος, οι τεχνικές υπηρεσίες και άλλες υπηρεσίες της Εταιρείας ή συνεργάτες της δύνανται να συλλέγουν πληροφορίες σχετικά με τους επισκέπτες της ιστοσελίδας της Εταιρείας αυτόματα με σκοπό την συντήρηση, τη βελτίωση, ασφάλεια και άλλες νόμιμες αιτίες. Τέτοιες πληροφορίες μπορεί να περιλαμβάνουν τη διεύθυνση IP επισκεπτών, τον τύπο προγράμματος περιήγησης, την ημερομηνία, την ώρα και τη διάρκεια της επίσκεψης και συγκεκριμένες σελίδες που επισκεφθήκαte.","privacy-policy-gr-head6":"6. Πρακτικές της Εταιρείας αναφορικά με την συλλογή των Προσωπικών Δεδομένων και την ενημέρωση σας","privacy-policy-gr-desc38":"Κάθε φορά που παρέχετε τα προσωπικά σας Δεδομένα, η Εταιρεία διασφαλίζει ότι έχετε ενημερωθεί για το ποιος συλλέγει τις προσωπικές σας πληροφορίες, τον τρόπο συλλογής τους, το είδος της χρήσης που θα πραγματοποιηθεί από την Εταιρεία καθώς και τον σκοπό της συλλογής τους.","privacy-policy-gr-desc39":"Για αυτό τον λόγο κάθε φορά που παρέχετε τα προσωπικά σας δεδομένα, η Εταιρεία θα φροντίζει να σας ειδοποιεί σχετικά με τις επιλογές σας ως προς την χρήση των προσωπικών δεδομένων σας, καθώς και σε περίπτωση κοινής χρήσης των δεδομένων σας από την Εταιρεία με τρίτες εταιρείες.","privacy-policy-gr-desc40":"Όταν τα προσωπικά σας δεδομένα συλλέγονται χειροκίνητα ή με τρόπους μη συνδεόμενους με το διαδίκτυο (π.χ φόρμα συνδρομής), η Εταιρεία φροντίζει για την αποστολή σε εσάς μίας σύντομης ειδοποίησης, όπου θα περιγράφεται ο τρόπος λήψης του πλήρους κειμένου της παρούσας Πολιτικής και των άλλων πληροφοριών της Εταιρείας. Κατά αυτό τον τρόπο εξασφαλίζεται η αναλυτική ενημέρωση σας ως προς όλα τα ζητήματα που αφορούν τα προσωπικά σας δεδομέναν και την χρήση τους από την Εταιρεία, προκειμένου να παράσχετε στην Εταιρεία την ρητή συγκατάθεση σας.","privacy-policy-gr-desc41":"Στον ιστότοπο της Εταιρείας ενδέχεται να εμφανίζονται σύνδεσμοι που οδηγούν σε ιστότοπους άλλων εταιρειών. Σε κάποιες από τις παραπάνω περιπτώσεις, ενδέχεται οι τοποθεσίες τρίτων να φέρουν το λογότυπο της Εταιρείας, χωρίς ωστόσο η Εταιρεία να έχει την διαχείριση ή την ευθύνη για το περιεχόμενο αυτών των ιστότοπων.","privacy-policy-gr-desc42":"Στον ιστότοπο της Εταιρείας ενδέχεται να εμφανίζονται διαφημίσεις άλλων εταιρειών, στις ιστοσελίδες των οποίων μπορείτε να μεταφερθείτε μέσω συνδέσμου που εμφανίζεται στον ιστότοπο της Εταιρείας. Σε αυτήν την περίπτωση, η Εταιρεία δεν φέρει ευθύνη για τις πρακτικές που ακολουθούν τα τρίτα μέρη ή για τις πολιτικές απορρήτου τρίτων μερών ή τοπικών διαφημιστικών εταιρειών στο Internet. Έτσι, σε περίπτωση που ανακατευθυνθείτε από τον ιστότοπο της Εταιρείας μέσω ενός τέτοιου συνδέσμου ή με την επιλογή μιας διαφήμισης, στην ιστοσελίδα τρίτης εταιρείας, οφείλετε να ελέγξετε την ισχύουσα πολιτική απορρήτου του τρίτου μέρους ή τοποθεσίας διαφημιστή, ώστε να ενημερωθείτε για τον τρόπο που θα επεξεργαστούν οποιαδήποτε εκ των προσωπικών σας δεδομένων συλλέξουν.","privacy-policy-gr-head7":"7. Δικαιώματα των Υποκειμένων των Προσωπικών Δεδομένων","privacy-policy-gr-desc43":"Κάθε υποκείμενο δεδομένων έχει τα ακόλουθα δικαιώματα σύμφωνα με το ΓΚΠΔ τα οποία η Εταιρεία σέβεται και προστατεύει:","privacy-policy-gr-desc43-a":"α) Το δικαίωμα ενημέρωσης: το υποκείμενο δικαιούται μετά από αίτημα του να λάβει πληροφορίες σχετικά με τα προσωπικά δεδομένα του που τηρούνται από την Εταιρεία και συγκεκριμένα, το είδος των δεδομένων που έχουν υποβληθεί σε επεξεργασία, ποια πρόσωπα έχουν δικαίωμα επεξεργασίας και τους λόγους αυτής","privacy-policy-gr-desc43-b":"β) Το δικαίωμα πρόσβασης: το υποκείμενο έχει το δικαίωμα να ζητήσει από την Εταιρεία δωρεάν πρόσβαση στα προσωπικά δεδομένα που διαθέτει η τελευταία,","privacy-policy-gr-desc43-c":"γ) Το δικαίωμα διόρθωσης και συμπλήρωσης: Το υποκείμενο δικαιούται, κατόπιν σχετικής ειδοποίησης του προς την Εταιρεία, να αιτηθεί την διόρθωση τυχόν ανακριβών προσωπικών δεδομένων που το αφορούν καθώς και την συμπλήρωση ατελών δεδομένων του, υπό την προϋπόθεση ότι τα δεδομένα αυτά είναι αναγκαία για τους σκοπούς επεξεργασίας τους,","privacy-policy-gr-desc43-d":"δ) Το δικαίωμα διαγραφής: Το υποκείμενο δικαιούται κατόπιν σχετικού αιτήματος του προς την Εταιρεία, να ζητήσει  την διαγραφή των προσωπικών δεδομένων του που τηρούνται από την Εταιρεία. Ωστόσο, κάποια εκ των προσωπικών δεδομένων του υποκειμένου θα διαγράφονται μόνο μετά από μια καθορισμένη περίοδο διακράτησης, ιδίως επειδή σε ορισμένες περιπτώσεις η Εταιρεία υποχρεούται εκ του νόμου να διατηρεί τα δεδομένα, ή επειδή τα δεδομένα απαιτούνται για την εκπλήρωση των συμβατικών υποχρεώσεων της Εταιρείας απέναντι στο υποκείμενο.","privacy-policy-gr-desc43-e":"ε) Το δικαίωμα περιορισμού της επεξεργασίας: Το Υποκείμενο έχει δικαίωμα να ζητήσει τον περιορισμό της επεξεργασίας των προσωπικών του δεδομένων και ειδικότερα: 1) όταν αμφισβητείται η ακρίβειά τους, 2) η επεξεργασία είναι παράνομη, 3) τα δεδομένα δεν χρειάζονται πλέον στον υπεύθυνο επεξεργασίας, 4) έχει αντιρρήσεις ως προς την αυτοματοποιημένη επεξεργασία.","privacy-policy-gr-desc43-f":"στ) Το δικαίωμα στη φορητότητα δεδομένων: Το υποκείμενο δικαιούται να ζητήσει την μεταφορά των δεδομένων του σε άλλον υπεύθυνο επεξεργασίας","privacy-policy-gr-desc43-g":"ζ) Το δικαίωμα αντίρρησης: Το υποκείμενο μπορεί ανά πάσα στιγμή να προβάλλει αντιρρήσεις κατά της επεξεργασίας των προσωπικών δεδομένων του στο μέλλον, εάν η Εταιρεία επεξεργάζεται τα δεδομένα του στη βάση μίας εκ των νομικών αιτιολογήσεων που προβλέπονται στο άρθρο 6 (1ε ή 1στ) του Κανονισμού (ΕΕ) 2016/679. Εάν το υποκείμενο υποβάλλει αντιρρήσεις, η Εταιρεία θα σταματήσει την επεξεργασία των δεδομένων του, υπό την προϋπόθεση ότι δεν συντρέχουν νόμιμοι λόγοι για περαιτέρω επεξεργασία τους. Η επεξεργασία των δεδομένων του υποκειμένου για σκοπούς διαφήμισης δεν συνιστά νόμιμο λόγο.","privacy-policy-gr-desc43-h":"η) Δικαιώματα σχετικά με την αυτοματοποιημένη λήψη αποφάσεων και τη δημιουργία προφίλ: Το υποκείμενο των δεδομένων έχει το δικαίωμα να μην υπόκειται σε απόφαση που λαμβάνεται αποκλειστικά βάσει αυτοματοποιημένης επεξεργασίας, συμπεριλαμβανομένης της κατάρτισης προφίλ, η οποία παράγει έννομα αποτελέσματα που το αφορούν ή το επηρεάζει σημαντικά με παρόμοιο τρόπο. Τα παραπάνω δεν ισχύουν όταν η απόφαση: 1) είναι αναγκαία για τη σύναψη ή την εκτέλεση σύμβασης μεταξύ του υποκειμένου των δεδομένων και του υπευθύνου επεξεργασίας των δεδομένων, 2) επιτρέπεται από το δίκαιο της Ένωσης ή το δίκαιο κράτους μέλους στο οποίο υπόκειται ο υπεύθυνος επεξεργασίας ή 3) βασίζεται στη ρητή συγκατάθεση του υποκειμένου των δεδομένων.","privacy-policy-gr-desc43-i":"θ) Δικαίωμα ανάκλησης της συγκατάθεσής: Το υποκείμενο έχει ανά πάσα στιγμή το δικαίωμα να ανακαλέσει τη συγκατάθεσή του για την επεξεργασία των προσωπικών δεδομένων του στο μέλλον. Η νομιμότητα της επεξεργασίας των δεδομένων του υποκειμένου παραμένει ανεπηρέαστη από την ενέργεια αυτή, έως το σημείο ανάκλησης της συγκατάθεσής του.","privacy-policy-gr-desc43-j":"ι) Δικαίωμα δέσμευσης των προσωπικών δεδομένων σας: Σε ορισμένες περιπτώσεις που προβλέπονται από το νόμο, η Εταιρεία θα δεσμεύει τα δεδομένα των υποκειμένων, εάν υποβάλλουν σχετικό αίτημα. Περαιτέρω επεξεργασία δεσμευμένων δεδομένων γίνεται μόνο σε πολύ περιορισμένη έκταση.","privacy-policy-gr-desc44":"Εάν το Υποκείμενο ζητήσει από την Εταιρεία την διακοπή χρήσης των προσωπικών δεδομένων του, η Εταιρεία θα ικανοποιήσει αυτό το αίτημα, διατηρώντας μόνο τις πληροφορίες που είναι απαραίτητες για τη συμμόρφωση με την ισχύουσα εθνική νομοθεσία.","privacy-policy-gr-desc45":"Το υποκείμενο μπορεί να επικοινωνήσει με την Εταιρεία για να ασκήσει τα δικαιώματά του και η Εταιρεία θα ανταποκριθεί σε εύλογο χρονικό διάστημα, όχι σε περισσότερο από 30 ημέρες.","privacy-policy-gr-head8":"8. Χρήση και Επεξεργασία των Προσωπικών Δεδομένων από την Εταιρεία","privacy-policy-gr-desc46":"Η Εταιρεία δεσμεύεται ότι η χρήση των παρεχόμενων προσωπικών δεδομένων θα πραγματοποιείται κατά τρόπο σύμφωνο με την παρούσα Πολιτική και αποκλειστικά και μόνο για τους σκοπούς για τους οποίους υποβλήθηκαν τα προσωπικά δεδομένα.","privacy-policy-gr-desc47":"Η Εταιρεία διατηρεί την δυνατότητα χρήσης των προσωπικών δεδομένων που της παρείχατε κατά την εγγραφή σας στις Υπηρεσίες της, προκειμένου να σας στείλει σημαντικές πληροφορίες και ενημερώσεις σχετικά με τον λογαριασμό σας και την παροχή των υπηρεσιών που ζητήσατε.","privacy-policy-gr-desc48":"Στην περίπτωση συλλογής προσωπικών δεδομένων από το ίδιο το υποκείμενο κατά την υποβολή αιτήματός του στην Εταιρεία για λήψη αρχείων και υπηρεσιών της, η Εταιρεία θα προχωρήσει σε επεξεργασία του αιτήματος συνδρομής ή παροχής υπηρεσίας προς το υποκείμενο, συμπεριλαμβανομένης και της επεξεργασίας εκπλήρωσης παραγγελίας και πληρωμής, εάν υπάρχει. Ως εκ τούτου, η Εταιρεία δεν θα προχωρήσει σε διαμοιρασμό των στοιχείων με τρίτα μέρη, εκτός από εκείνα των οποίων η χρήση είναι απαραίτητη για την εκτέλεση εργασιών (όπως εκπλήρωση παραγγελίας και επεξεργασία πληρωμής), με σκοπό την ολοκλήρωση αγορών που πραγματοποιεί το υποκείμενο των δεδομένων και συνδρομών που αιτείται μέσω του https://sam-media.com/.","privacy-policy-gr-head9":"9. Διαβίβαση των Προσωπικών Δεδομένων σε τρίτα μέρη","privacy-policy-gr-desc49":"Η Εταιρεία δεσμεύεται να μην διαβιβάσει τα προσωπικά δεδομένα που συλλέγει σε τρίτα μέρη που δεν σχετίζονται και δεν συνεργάζονται μαζί της, εκτός εάν λάβει την ρητή συγκατάθεση σας. Εάν η Εταιρεία λάβει προσωπικά δεδομένα από ένα τρίτο μέρος-συνεργάτη, η χρήση των πληροφοριών απότην Εταιρεία θα διέπεται από την παρούσα Πολιτική Απορρήτου.","privacy-policy-gr-desc50":"Στην παρούσα Πολιτική περιγράφονται τα είδη των άλλων εταιρειών που ενδέχεται να επιθυμούν αποστολή πληροφοριών εσάς σχετικά με τα προϊόντα και υπηρεσίες τους και επομένως επιθυμούν να μοιραστούν τα προσωπικά δεδομένα σας, με την προϋπόθεση πως εσείς έχετε δώσει στην Εταιρεία την ρητή συγκατάθεση σας για να το πράξει.","privacy-policy-gr-desc51":"Ο ιστότοπος της Εταιρείας μπορεί, επίσης, να συνδέεται με τοποθεσίες που λειτουργούν από σχετιζόμενες εταιρείες με την Εταιρεία, όπως εταιρείες που είναι μέλη του Ομίλου της Εταιρείας. Αν και τα μέλη του Ομίλου της Εταιρείας  τηρούν τους κανόνες του Ομίλου, τα υποκείμενα των προσωπικών δεδομένων που επισκέπτονται αυτές τις σχετιζόμενες τοποθεσίες θα πρέπει να ανατρέχουν στις ξεχωριστές πολιτικές απορρήτου και πρακτικές τους, οι οποίες ενδέχεται να διαφέρουν σε ορισμένα θέματα από την παρούσα Πολιτική.","privacy-policy-gr-desc52":"Τρίτος, εκτελών την επεξεργασία για λογαριασμό της Εταιρείας, όπως ενδεικτικά ένας πάροχος υπηρεσιών, υποχρεούται να συμφωνήσει συμβατικά για την επεξεργασία προσωπικών δεδομένων σύμφωνα με την παρούσα πολιτική ενώ οι όροι αυτής της πολιτικής συμπεριλαμβάνονται στις σχετικές συμβάσεις.","privacy-policy-gr-desc53":"Είναι δυνατή αποκάλυψη των προσωπικών δεδομένων σε τρίτους μόνον εφόσον είναι απαραίτητο ή εφόσον το υποκείμενο χορηγήσει τη ρητή συγκατάθεσή του. Τα δεδομένα προσωπικού χαρακτήρα πρέπει να παρέχονται ανωνύμως, εφόσον κρίνεται σκόπιμο.","privacy-policy-gr-desc54":"Επίσης, η Εταιρεία δύναται να χρησιμοποιεί τα προσωπικά δεδομένα στο σύνολό τους, ανώνυμα, για ερευνητικούς σκοπούς.","privacy-policy-gr-desc55":"Συνεργαζόμενες τρίτες εταιρείες με την Εταιρεία μπορούν να προσφέρουν λήψεις δεδομένων και αρχείων στα υποκείμενα για λογαριασμό της Εταιρείας, συλλέγοντας προσωπικά δεδομένα εκ μέρους της Εταιρείας, όταν τα υποκείμενα πραγματοποιούν εγγραφή ή συνδέονται για μεμονωμένες λήψεις αρχείων και υπηρεσιών μέσω του κινητού τηλεφώνου τους. Τότε, η συνεργαζόμενη τρίτη εταιρεία παρέχει στην Εταιρεία τα προσωπικά δεδομένα που χρειάζεται για να προσφέρει στα υποκείμενα των δεδομένων λήψεις πληροφοριών και αρχείων της Εταιρείας και άλλες υπηρεσίες που έχουν αιτηθεί. Η συνεργάτης τρίτη εταιρεία της Εταιρείας παρέχει ακόμη στον πάροχο κινητής τηλεφωνίας του υποκειμένου των δεδομένων τις πληροφορίες που χρειάζεται για να προχωρήσει στις απαραίτητες χρεώσεις για τις λήψεις πληροφοριών και αρχείων και για άλλες υπηρεσίες που αγόρασε.","privacy-policy-gr-desc56":"Η Εταιρεία διατηρεί την δυνατότητα να μοιραστεί τα προσωπικά δεδομένα των υποκειμένων με συνεργαζόμενες εταιρείες με αυτήν ή με εταιρείες που ανήκουν στον όμιλο της Εταιρείας, προς επίτευξη πάντοτε του σκοπού της επεξεργασίας.","privacy-policy-gr-desc57":"Προς επίτευξη όλων των παραπάνω, κάθε υπάλληλος της Εταιρείας λαμβάνει την απαραίτητη εκπαίδευση σε θέματα προστασίας δεδομένων και ασφάλειας δεδομένων. Για να είναι επιτρεπτή η πρόσβαση των υπαλλήλων, αντιπροσώπων και συνεργατών της Εταιρείας πρέπει να δικαιολογείται από νόμιμο λόγο.","privacy-policy-gr-desc59":"Η Εταιρεία έχει την δυνατότητα διαμοιρασμού των προσωπικών δεδομένων των υποκειμένων με εξωτερικούς συνεργάτες ή αντιπροσώπους της, οι οποίοι την συνδράμουν στη διαχείριση των πληροφοριακών δραστηριοτήτων της (π.χ. εκπλήρωση παραγγελιών, στατιστικές αναλύσεις). Ωστόσο, σε αυτή την περίπτωση οι ανωτέρω μπορούν να χρησιμοποιήσουν τα εν λόγω δεδομένα μόνο για να παρέχουν στην Εταιρεία συγκεκριμένη υπηρεσία και όχι για οποιονδήποτε άλλο σκοπό.","privacy-policy-gr-desc60":"Η Εταιρεία μπορεί να συμβληθεί με τρίτες εταιρείες που κατέχουν την τεχνολογία που επιτρέπει στην Εταιρεία να προσαρμόσει τα διαφημιστικά και μάρκετινγκ μηνύματα που λαμβάνει το υποκείμενο στις διαδικτυακές τοποθεσίες της Εταιρείας. Τα μη προσωπικά δεδομένα και το ιστορικό περιήγησης στο διαδίκτυο σχετικά με τις δραστηριότητές των υποκειμένων στις τοποθεσίες αυτές μπορεί να μοιράζονται με αυτές τις εταιρείες, έτσι ώστε αυτή η προσαρμογή να μπορεί να επιτευχθεί. Αυτές οι εταιρείες δεν θα μοιραστούν τις παραπάνω πληροφορίες με οποιοδήποτε τρίτο μέρος, ούτε θα τις χρησιμοποιήσουν για οποιονδήποτε άλλο σκοπό. Ενδέχεται όμως να γίνει χρήση, ανώνυμα, του ιστορικού περιήγησης και άλλων δημογραφικών πληροφοριών αποκλειστικά για διαφημιστικούς-στατιστικούς σκοπούς από την Εταιρεία ή τους επιχειρηματικούς συνεργάτες της.","privacy-policy-gr-head10":"10. Αποθήκευση, Χρόνος Διατήρησης και Ασφάλεια των Δεδομένων","privacy-policy-gr-desc61":"Ο χρόνος αποθήκευσης των προσωπικών δεδομένων καθορίζεται από τον χρόνο που απαιτείται για την εκπλήρωση του σκοπού συλλογής τους καθώς και  από το νόμο. Τα στοιχεία της αποθήκευσης δεδομένων και των περιόδων διατήρησης καθορίζονται στην Πολιτική Διατήρησης Δεδομένων της Εταιρείας.","privacy-policy-gr-desc62":"Η Εταιρεία φροντίζει για την λήψη όλων των ενδεικνυόμενων από την σύγχρονη τεχνολογία, οργανωτικών και μη μέτρων, προς το σκοπό διαφύλαξης των προσωπικών δεδομένων που βρίσκονται στην κατοχή της έναντι των κινδύνων απώλειας, κλοπής και μη εξουσιοδοτημένης χρήσης, αποκάλυψης ή τροποποίησης με στόχο την εξασφάλιση της ακεραιότητας, της εμπιστευτικότητας και της διαθεσιμότητάς τους. Η Εταιρεία χρησιμοποιεί επίσης, εύλογες μεθόδους προς επιβεβαίωση ότι τα τηρούμενα προσωπικά δεδομένα είναι ακριβή, ενημερωμένα και κατάλληλα συμπληρωμένα.","privacy-policy-gr-head11":"11. Περιπτώσεις Αποκάλυψης των Προσωπικών Δεδομένων","privacy-policy-gr-desc63":"Οι περιπτώσεις που η Εταιρεία δικαιούται να αποκαλύψει τα προσωπικά δεδομένα των υποκειμένων χωρίς την συγκατάθεση τους, είναι οι εξής: α) προστασία νομίμων δικαιωμάτων της Εταιρείας ή άλλων εταιρειών εντός του Ομίλου της Εταιρείας ή των υπαλλήλων, αντιπροσώπων και συνεργατών της, β) για την ασφάλεια των επισκεπτών του ιστότοπού της, γ) για προστασία έναντι απάτης ή σε οποιαδήποτε περίπτωση τελέσεως ή υποψίας τελέσεως αξιόποινης πράξης, δ) για λόγους διαχείρισης κινδύνου, δημόσιας τάξης και ασφάλειας, εθνικού συμφέροντος, ε) εάν αυτό ζητηθεί αρμοδίως από τις κρατικές ή δικαστικές αρχές και  στ) για συμμόρφωση της Εταιρείας  με τις διατάξεις της νομοθεσίας ή τις νόμιμες διαδικασίες.","privacy-policy-gr-head12":"12. Προϋποθέσεις διασυνοριακής αποκάλυψης προσωπικών δεδομένων","privacy-policy-gr-desc64":"Είναι εφικτή η αποκάλυψη των προσωπικών δεδομένων στο εξωτερικό μόνο εφόσον το νομοθετικό πλαίσιο της χώρας όπου επιχειρείται η αποκάλυψη παρέχει επαρκές και ικανοποιητικό επίπεδο προστασίας των προσωπικών δεδομένων.","privacy-policy-gr-desc65":"Άλλως, τα δεδομένα προσωπικού χαρακτήρα μπορούν να μεταφερθούν σε αυτή τη χώρα μόνο υπό την προϋπόθεση ότι το πρόσωπο στο οποίο αναφέρονται έχει συναινέσει ρητά στη μεταφορά ή εάν υπάρχει σχετική συμφωνίας περί μεταφοράς δεδομένων, με την οποία παρέχονται όλες οι απαραίτητες εγγυήσεις για τη προστασία τους.","privacy-policy-gr-head13":"13. Μεταβίβαση Εταιρείας","privacy-policy-gr-desc66":"Αν η Εταιρεία πωλήσει μέρος ή όλη την επιχείρησή της ή πραγματοποιήσει μια πώληση ή μεταφορά περιουσιακών στοιχείων ή εμπλακεί γενικότερα σε μια συγχώνευση ή μεταφορά επιχείρησης, η Εταιρεία μπορεί να μεταφέρει τα προσωπικά δεδομένα των υποκειμένων σε ένα τρίτο μέρος ως τμήμα αυτής της συναλλαγής.","privacy-policy-gr-head14":"14. Τροποποίηση των όρων της Πολιτικής Απορρήτου","privacy-policy-gr-desc67":"Οι παραπάνω όροι αποτελούν την πλήρη συμφωνία με την Εταιρεία, η οποία διατηρεί το δικαίωμα να τροποποιεί ή να ανανεώνει ή να διαγράφει όλους τους όρους του παρόντος, χωρίς καμία προειδοποίηση. Η τροποποίηση ή ανανέωση θα ισχύει από την στιγμή που θα ενημερωθεί σχετικά το παρόν κείμενο για οποιαδήποτε αλλαγή. Επομένως, το υποκείμενο θα πρέπει να την εξετάζει τακτικά ώστε να είναι ενήμερο σχετικά με τις πλέον πρόσφατες πολιτικές και πρακτικές της Εταιρείας. Εάν η Εταιρεία αλλάξει ουσιωδώς τις πρακτικές της αναφορικά με τη συλλογή ή χρήση των προσωπικών δεδομένων, τα προσωπικά δεδομένα των υποκειμένων θα συνεχίσουν να διέπονται από την Πολιτική κάτω από την οποία έγινε η συλλογή τους, εκτός αν έχει παρασχεθεί σχετική ειδοποίηση και το υποκείμενο δεν είχε αντίρρηση για την αλλαγή.","privacy-policy-gr-head15":"15. Επίλυση θεμάτων προστασίας Προσωπικών Δεδομένων-Τρόποι Επικοινωνίας","privacy-policy-gr-desc68":"Για την άσκηση των δικαιωμάτων σας, όπως για την επίλυση θεμάτων απορρήτου, για θέματα σχετικά με τη συλλογή και επεξεργασία των προσωπικών δεδομένων σας από την Εταιρεία, για να ασκήσετε το δικαίωμα αναθεώρησης, διόρθωσης,  διαγραφής των προσωπικών δεδομένων σας ή διακοπής κάθε μελλοντικής επικοινωνίας μαζί σας, μπορείτε  να επικοινωνήσετε με την Εταιρεία στην ηλεκτρονική διεύθυνση  HYPERLINK \"mailto:customer.support@lilymobile.gr\" sam-media.gr@cchelp.co, με την εξυπηρέτηση πελατών τηλ. 2112348373 ή με επιστολή που αποστέλλετε στην έδρα της Εταιρείας που βρίσκονται στην Ολλανδία (Van Diemenstraat 356  1013 CR Amsterdam)"}

/***/ }),

/***/ "./src/translations/en.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Home","sidebar.myaccount":"My Account","sidebar.notif":"Notification","sidebar.nonotif":"You have no notifications yet","html5games":"HTML5 Games","androidGames":"Android Games","android-upper":"ANDROID","favorite":"Favorite","splashscreen.text":"Play Way Beyond","welcome.text":"EXPLORE THE BEST MOBILE GAMES ONLINE TODAY!","welcome.text.gamiclub":"EXPLORE THE BEST CONTENT ONLINE TODAY!","accountDetails":"ACCOUNT DETAILS","accountName":"NAME","accountEmail":"EMAIL ADDRESS","withdraw_from_contract":"Withdraw from Contract","accountLocation":"LOCATION","accountInterests":"INTERESTS","accountChooseCategory":"Choose 3 categories","accountEditPhoto":"EDIT PHOTO","save":"Save","topCategories":"TOP CATEGORIES","favGames":"FAVOURITE GAMES","viewAll":"VIEW ALL","noGamesFound":"No games found under this category","noVideosFound":"No videos found under this category","cancel":"Cancel","gameDirectories":"GAME DIRECTORIES","category":"Category","platform":"Platform","type":"Type","android":"ANDROID","games":"games","html5":"HTML5","videos":"VIDEOS","search.input.placeholder":"Search...","search.cancel.button":"Cancel","description":"Description","downloadNow":"DOWNLOAD NOW","playNow":"PLAY NOW","rate":"Rate","relatedGames":"RELATED GAMES","noFavGames":"No Favorite Games Yet","addFavGames":"Add your favorite games to access and play easily without any hassels","discover":"DISCOVER","noFavGamesFound":"No favorite games found.","favorites":"Favorite","accessDenied":"Access Denied","pageRestricted":"The page you are looking for is restricted.","averageRatingBasedOn":" average user rating based on ","averageRatingReview":" review","tnc":"Terms and Conditions","contact_us":"Contact Us","areYouAlready":"Are you already a member of ","thenConfirm":"Then confirm your mobile number and get unlimited access to all our <strong> HTML5 </strong> and <strong> Android </strong> games","login":"Login","Action":"Action","Adventure":"Adventure","Arcade":"Arcade","Sport":"Sport","Racing":"Racing","Premium Games":"Premium Games","RPG":"RPG","Virtual Reality":"Virtual Reality","Motivation":"Motivation","Tour":"Tour","Fun Gaming":"Fun Gaming","Athletics":"Athletics","Inspiration":"Inspiration","Casual":"Casual","Adrenaline Rush":"Adrenaline Rush","Into Nature":"Into Nature","Political & Activism":"Political & Activism","Travel":"Travel","Foodbuzz":"Foodbuzz","Health and Nutrition":"Health and Nutrition","Fitness":"Fitness","Top Cars":"Top Cars","Fashion & Beauty":"Fashion & Beauty","E-Learning":"E-Learning","Yoga":"Yoga","Just For Laugh":"Just For laugh","Brain Boost":"Brain Boost","Rugby":"Rugby","Economy":"Economy","Environment":"Environment","Gaming":"Gaming","Lifestyle":"Lifestyle","Local Heroes":"Local Heroes","Sports":"Sports","Technology":"Technology","Tutorials":"Tutorials","New Arrivals":"New Arrivals","noFavVideos":"No Favorite Videos Yet","addFavVideos":"Add your favorite videos to access and play easily without any hassels","noFavVideosFound":"No favorite videos found.","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. All Rights Reserved","footer.copyright.gameflares":"&copy; 2024 Gameflares. All Rights Reserved","footer.copyright.gamiway":"&copy; 2020 Gamiway. All Rights Reserved","footer.copyright.GamiHub":"&copy; 2026 GamiHub. All Rights Reserved","vid-player":"player","privacyPolicy":"Privacy Policy","privacy-policy-title":"","privacy-policy-desc":"","privacy-policy-collect-info-head":"","privacy-policy-collect-info-desc1":"","privacy-policy-collect-info-desc2":"","privacy-policy-how-collect-info-head":"","privacy-policy-how-collect-info-subhead":"","privacy-policy-how-collect-info-desc1":"","privacy-policy-how-collect-info-desc2":"","privacy-policy-how-long-head":"","privacy-policy-how-long-desc":"","privacy-policy-how-long-protect-head":"","privacy-policy-how-long-protect-desc1":"","privacy-policy-how-long-protect-desc2":"","privacy-policy-how-long-protect-desc3":"","privacy-policy-acceptance-head":"","privacy-policy-acceptance-desc":"","privacy-policy-changes-head":"","privacy-policy-changes-desc":"","privacy-policy-contact-us":"","privacy-policy-contact-us-desc":"","unsubscribe":"Unsubscribe","unsubscribe-ZA":"To unsubscribe, dial 135*997#","PROFILINE KIMLER BAKTI?":"Who viewed your Profile?","terms-condition-title":"","gen-terms-condition-title":"","gen-terms-condition-desc":"","provider-terms-condition-title":"","provider-terms-condition-desc":"","availability-terms-condition-title":"","availability-terms-condition-desc":"","payment-terms-condition-title":"","payment-terms-condition-desc":"","obligation-terms-condition-title":"","obligation-terms-condition-desc":"","ownership-terms-condition-title":"","ownership-terms-condition-desc":"","funzarena_text":"You do not have access. Send a text message with the word GAME to 92505 (cost: PLN 30.75)."}

/***/ }),

/***/ "./src/translations/es.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Play Way Beyond","sidebar.home":"Inicio","sidebar.myaccount":"Mi cuenta","sidebar.notif":"Notificación","sidebar.nonotif":"Aún no tienes notificaciones","html5games":"Juegos HTML5","androidGames":"Juegos Android","favorite":"Favorito","welcome.text":"¡Explora los mejores juegos para móvil ahora!","footer.copyright":"© 2018 Gamelords. Todos los derechos reservados","footer.copyright.beemobi":"© 2020 Beemobi. Todos los derechos reservados","averageRatingBasedOn":" calificación promedio basada en ","accountDetails":"Detalles de la cuenta","accountName":"Nombre","accountEmail":"Dirección de e-mail","accountLocation":"Ubicación","accountInterests":"Intereses","accountChooseCategory":"Elige 3 categorías","accountEditPhoto":"Editar foto","save":"Guardar","topCategories":"Categorías populares","VideosGamingTips":"Video de consejos de juego","favGames":"JUEGOS FAVORITOS","viewAll":"Ver todo","noGameFound":" No se han encontrado juegos ","cancel":"Cancelar","gameDirectories":"Directorios de juegos","category":"Categoría","noGamesFound":"No se encontraron juegos.","platform":"Plataforma","type":"Tipo","android-upper":"ANDROID","games":"Juegos","html5":"HTML5","description":"Descripción","downloadNow":"Descargar ahora","playNow":"Jugar ahora","rate":"Valorar","relatedGames":"Juegos relacionados","noFavGames":"No hay juegos favoritos aún","addFavGames":"Añade tus juegos favoritos para acceder y jugar fácilmente sin ninguna molestia","discover":"Descubrir","noFavGamesFound":"No se han encontrado juegos favoritos.","favorites":"Favoritos","accessDenied":"Acceso denegado","pageRestricted":"La página que estás buscando es restringida.","privacyPolicy":"Política de privacidad","tnc":"Términos y condiciones","kazakhOnly":"","areYouAlready":"¿Ya eres miembro de ","thenConfirm":"Entonces, confirma tu número de móvil y consigue acceso ilimitado a todos nuestros juegos HTML5 y Android","login":"Iniciar sesión","contact_us":"Atención al Cliente 900373556","search.input.placeholder":"buscar","search.cancel.button":"cancelar","Sports":"Deporte","Action":"Acción","Local Heroes":"Heroes locales","Adventure":"Aventura","Fitness":"Fitness","Entertainment":"Entretenimiento","Premium Games":"Juegos prémium","RPG":"RPG","Virtual Reality":"Realidad Virtual","Arcade":"Arcade","Racing":"CARRERAS","Motivation":"Motivación","Tour":"Tour","Fun Gaming":"Juegos divertidos","Athletics":"Atletismo","Inspiration":"Inspiración","Into Nature":"En la naturaleza","Political & Activism":"Política y Activismo","Travel":"Viajar","Foodbuzz":"Foodbuzz","Health and Nutrition":"Salud y Nutrición","Top Cars":"Mejores Autos","Fashion & Beauty":"Moda y Belleza","E-Learning":"E-Learning","Yoga":"Yoga","Just For Laugh":"Solo por Risa","Brain Boost":"Estimulación Mental","Rugby":"Rugby","Economy":"Economía","Environment":"Medio Ambiente","Gaming":"Juegos","Lifestyle":"Estilo de Vida","Technology":"Tecnología","Tutorials":"Tutoriales","New Arrivals":"Nuevas Llegadas","noVideosFound":"No se encontraron videos","noFavVideos":"Aún no hay videos favoritos","addFavVideos":"Agrega tus videos favoritos para encontrarlos y reproducirlos fácilmente","noFavVideosFound":"No se encontraron videos favoritos","vid-player":"Reproductor","welcome.text.gamiclub":"¡EXPLORA EL MEJOR CONTENIDO EN LÍNEA HOY!","unsubscribe":"Cancelación","privacy-policy-title":"Política de Privacidad","privacy-policy-desc":"Esta Política de Privacidad explica nuestros compromisos y sus derechos con relación a su información. Debería leer la Política de Privacidad cuidadosamente. Si usted no acepta esta Política de Privacidad, por favor, no use nuestros Sitios o Servicios. La Política de Privacidad está debidamente incorporada y sujeta a los Términos del Servicio y rige los mismos Servicios y Sitios que los mencionados en los Términos del Servicio. Cualquier término que utilicemos en la Política de Privacidad sin definirlos tendrán la misma definición que en los Términos del Servicio.","privacy-policy-collect-info-head":"RECOGEMOS LA INFORMACIÓN DE LAS FORMAS SIGUIENTES:","privacy-policy-collect-info-desc1":"1. Cuando usted nos la dé a nosotros o nos dé permiso para obtenerla is decide suscribirse a un Servicio nuestro, nosotros o el operador móvil de su red recopilaremos su información relacionada con el pago de la suscripción de nuestros Servicios. La información de facturación y de la cuenta recogida por el operador móvil está sujeta a sus respectivas políticas de privacidad.","privacy-policy-collect-info-desc2":"2. Obtenemos información técnica cuando visite nuestros Sitios y/o Servicios; podríamos recopilar información técnica sobre usted cuando utilice nuestros Servicios. Nosotros recopilamos datos de registro cada vez que inicia sesión o cierra sesión de nuestros Servicios.","privacy-policy-how-collect-info-head":"CÓMO UTILIZAMOS LA INFORMACIÓN RECOPILADA","privacy-policy-how-collect-info-subhead":"Podríamos utilizar su información con los siguientes fines:","privacy-policy-how-collect-info-desc1":"Proporcionar los Servicios que ha solicitado;","privacy-policy-how-collect-info-desc2":"Facturar y cobrar por los Servicios que le proporcionamos;","privacy-policy-how-long-head":"CUÁNTO TIEMPO GUARDAMOS SU INFORMACIÓN","privacy-policy-how-long-desc":"Retendremos su información el tiempo necesario para proporcionarle nuestros Servicios. Retendremos su información lo que sea necesario para cumplir nuestras obligaciones legales, resolver disputas y hacer cumplir nuestros acuerdos. Cuando ya no necesitemos utilizar su información y no haya necesidad de que la guardemos para cumplir nuestras obligaciones regulatorias o legales, o la eliminaremos de nuestros sistemas o la despersonalizaremos para que no podamos identificarle.","privacy-policy-how-long-protect-head":"CÓMO PROTEGEMOS SU INFORMACIÓN TAMBIÉN FUERA DE LA UE","privacy-policy-how-long-protect-desc1":"A nosotros nos preocupa proteger su privacidad y datos, pero no podemos asegurar ni garantizar la seguridad de ninguna información que nos transmita ni que no se pueda acceder, revelar, alterar o destruir su información traspasando cualquiera de nuestras protecciones físicas, técnicas o de dirección estándar en la industria. Adoptamos las medidas apropiadas de seguridad y prácticas de recogida, almacenamiento y procesamiento de datos para proteger ante el acceso, alteración, revelación o destrucción accidental o no autorizado de su información, información de transacciones y datos guardados en nuestros Servicios.","privacy-policy-how-long-protect-desc2":"No obstante, ningún método de transmisión en Internet o método de almacenamiento electrónico es 100 % seguro. Por lo tanto, no podemos garantizar su absoluta seguridad. Continuaremos mejorando nuestros procedimientos de seguridad según haya estando disponibles nuevas tecnologías.","privacy-policy-how-long-protect-desc3":"Debido a que operamos internacionalmente, su información, incluyendo la información personal, se podría transferir a, y estar disponible en EE. UU./Singapur y/o cualquier otro país distinto a su país de residencia. También tomamos todas las precauciones razonables en estos países para proteger su información personal.","privacy-policy-acceptance-head":"ACEPTACIÓN DE LA POLÍTICA DE PRIVACIDAD","privacy-policy-acceptance-desc":"Al utilizar cualquiera de nuestros Servicios, usted acepta que recopilemos y usemos su información de acuerdo con esta Política de Privacidad. Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento publicando los cambios en esta página. Por favor, compruebe la fecha de revisión en la parte inferior de esta página para determinar si la política se ha modificado desde que la revisó por última vez. Su uso continuado de cualquier parte de nuestro Sitio o Servicios tras la publicación de la Política de Privacidad actualizada constituirá su aceptación de los cambios.","privacy-policy-changes-head":"CAMBIOS A ESTA POLÍTICA DE PRIVACIDAD","privacy-policy-changes-desc":"Nosotros podríamos realizar cambios a nuestra Política de Privacidad de vez en cuando. Si decidimos cambiar nuestra Política de Privacidad, publicaremos esos cambios en esta página para que siempre pueda acceder a la última Política de Privacidad.","privacy-policy-contact-us":"CONTACTAR CON NOSOTROS","privacy-policy-contact-us-desc":"Si tiene alguna pregunta acerca de esta Política de Privacidad, las prácticas de los Sitios o sus relaciones con los Sitios, por favor, contacte con nosotros enviando un e-mail a support@content-clubs.com.","privacy-policy-contact-us-desc-the-beemobi":"Si tiene alguna pregunta acerca de esta Política de Privacidad, las prácticas de los Sitios o sus relaciones con los Sitios, por favor, contacte con nosotros enviando un e-mail a es-beemobi@cchelp.co.","newPrivacyPolicyTitle":"Política de privacidad","newPrivacyPolicyHead":"Esta aplicación recopila datos personales de sus usuarios.  Este documento puede imprimirse para futura consulta usando el comando de imprimir en los ajustes de cualquier navegador.","newPrivacyPolicyOwner":"Propietario y controlador de datos","newPrivacyPolicyOwner1":"Mobimilia BV","newPrivacyPolicyOwner2":"Van Diemenstraat 140","newPrivacyPolicyOwner3":"1013 CN Ámsterdam","newPrivacyPolicyOwner4":"Correo electrónico de contacto del propietario: info@mobimilia.com","newPrivacyPolicyDataCollected":"Tipos de datos recopilados","newPrivacyPolicyDataCollected1":"Entre los tipos de datos personales que esta aplicación recopila, por sí misma o a través de terceros, hay: cookies; datos de uso; identificadores de dispositivos únicos para publicidad (identificador de publicidad de Google o IDFA, por ejemplo).","newPrivacyPolicyDataCollected2":"Los detalles completos de cada tipo de datos personales recopilados se proporcionan en las secciones dedicadas de esta política de privacidad o con textos explicativos específicos mostrados antes de la recopilación de datos.","newPrivacyPolicyDataCollected3":"Podrían proporcionarse datos personales libremente por parte del usuario o, en caso de los datos de uso, recopilarse automáticamente al usar esta aplicación.","newPrivacyPolicyDataCollected4":"Salvo que se especifique de otra manera, todos los datos solicitados por esta aplicación son obligatorios y no proporcionar estos datos podría imposibilitar que esta aplicación proporcione sus servicios. En casos en los que esta aplicación afirme específicamente que algunos datos no son obligatorios, los usuarios son libres de no comunicar estos datos sin consecuencias para la disponibilidad o el funcionamiento del servicio.","newPrivacyPolicyDataCollected5":"Los usuarios que no estén seguros de qué datos personales son obligatorios pueden contactar con el propietario.","newPrivacyPolicyDataCollected6":"Cualquier uso de cookies u otras herramientas de seguimiento por parte de esta aplicación o de los propietarios de servicios de terceros usados por esta aplicación tiene como objetivo proporcionar el servicio que requiere el usuario, además de otros fines descritos en este documento y en la política de cookies, en caso de estar disponible.","newPrivacyPolicyDataCollected7":"Los usuarios son responsables de cualquier dato personal de un tercero obtenido, publicado o compartido a través de esta aplicación y de confirmar que tienen el consentimiento del tercero para proporcionar los datos al propietario.","newPrivacyPolicyModeAndPlace":"Modo y lugar de procesamiento de los datos","newPrivacyPolicyMethods":"Métodos de procesamiento","newPrivacyPolicyMethods1":"El propietario toma las medidas de seguridad adecuadas para evitar el acceso desautorizado, divulgación, modificación o destrucción desautorizada de los datos.","newPrivacyPolicyMethods2":"El procesamiento de datos se lleva a cabo usando ordenadores o herramientas informáticas, siguiendo procedimientos y modos de organización estrictamente relacionados con los objetivos indicados. Además del propietario, en algunos casos, los datos podrían ser accesibles para ciertos tipos de personas al mando relacionadas con el funcionamiento de esta aplicación (administración, ventas, mercadotecnia, jurídica, administración del sistema) o terceros externos (como proveedores de servicio técnico terceros, transportistas, proveedores de alojamiento, empresas informáticas, agencias de comunicación) designados, si fuera necesario, como procesadores de datos por parte del propietario. La lista actualizada de estas partes podría ser solicitada por parte del propietario en cualquier momento.","newPrivacyPolicyLegalBasis":"Base legal del procesamiento","newPrivacyPolicyLegalBasisHead":"El propietario podría procesar datos personales relativos a los usuarios si se aplica alguna de las siguientes:","newPrivacyPolicyLegalBasis1":"Los usuarios han dado su consentimiento para uno o más objetivos específicos. Nota: de conformidad con algunas normativas, el propietario podría estar autorizado a procesar datos personales hasta que el usuario rechaza dicho procesamiento (\"desvincularse\"), sin tener que depender del consentimiento o cualquier otra de las siguientes bases legales. Esto, no obstante, no se aplica cuando el procesamiento de los datos personales está sujeto a la Ley de protección de datos europea;","newPrivacyPolicyLegalBasis2":"la provisión de datos es necesaria para llevar a cabo un acuerdo con el usuario o para cualquier obligación previa al contrato del mismo;","newPrivacyPolicyLegalBasis3":"el procesamiento es necesario para el cumplimiento con una obligación legal a la que está sujeto el propietario;","newPrivacyPolicyLegalBasis4":"el procesamiento está relacionado con una tarea que se lleva a cabo en el interés público o en el ejercicio de una autoridad oficial conferida en el propietario;","newPrivacyPolicyLegalBasis5":"el procesamiento es necesario para los objetivos de los intereses legítimos del propietario o de una tercera parte.","newPrivacyPolicyLegalBasis6":"En cualquier caso, el propietario estará encantado de ayudar a aclarar la base legal específica que se aplica al procesamiento y, concretamente, si la provisión de datos personales es un requisito reglamentario o contractual o un requisito necesario para celebrar un contrato.","newPrivacyPolicyPlace":"Lugar","newPrivacyPolicyPlace1":"Los datos se procesan en las oficinas de operación del propietario y en cualquier otro lugar en el que se ubiquen las partes involucradas en el procesamiento.","newPrivacyPolicyPlace2":"Según la ubicación del usuario, las transferencias de datos podrían conllevar la transferencia de datos de un usuario a un país distinto al suyo. Para saber más sobre el lugar de procesamiento de dichos datos transferidos, los usuarios pueden comprobar la sección que contiene los detalles del procesamiento de datos personales.","newPrivacyPolicyPlace3":"Los usuarios también tienen derecho a conocer la base legal de las transferencias de datos a un país fuera de la Unión Europea o a cualquier organización internacional gobernada por las leyes internacionales públicas o establecida por dos o más países, como las Naciones Unidas, y las medidas de seguridad tomadas por el propietario para proteger sus datos.","newPrivacyPolicyPlace4":"Si una transferencia como esta tiene lugar, los usuarios pueden saber más comprobando las secciones relevantes de este documento o consultar al propietario usando la información proporcionada en la sección de contacto.","newPrivacyPolicyRetention":"Tiempo de retención","newPrivacyPolicyRetentionHead":"Los datos personales se procesarán y almacenarán el tiempo necesario según el objetivo por el que se hayan recopilado. Por lo tanto:","newPrivacyPolicyRetention1":"Los datos personales recopilados para fines del cumplimiento de un contrato entre el propietario y el usuario deberán retenerse hasta que dicho contrato se haya cumplido por completo.","newPrivacyPolicyRetention2":"Los datos personales recopilados para fines de los intereses legítimos del propietario se retendrán tanto como sea necesario para lograr dichos objetivos. Los usuarios pueden encontrar información específica relativa a los intereses legítimos del propietario en las secciones relevantes de este documento o contactando con el propietario.","newPrivacyPolicyRetention3":"El propietario podría tener permiso para retener datos personales por un mayor periodo de tiempo cuando el usuario haya dado su autorización a dicho procesamiento, siempre que dicho consentimiento no se retire. Además, el propietario podría estar obligado a retener datos personales durante un mayor periodo de tiempo cuando tenga que hacerlo debido a una obligación legal o tras la orden de una autoridad.","newPrivacyPolicyRetention4":"Cuando el periodo de retención finalice, se eliminarán los datos personales. Por lo tanto, el derecho de acceso, el derecho a eliminar, el derecho a rectificar y el derecho a la portabilidad de datos no pueden imponerse tras el vencimiento del periodo de retención.","newPrivacyPolicyRights":"Los derechos de los usuarios","newPrivacyPolicyRightsPara1":"Los usuarios pueden ejercer ciertos derechos en relación al procesamiento de sus datos por parte del propietario.","newPrivacyPolicyRightsPara2":"En concreto, los usuarios tienen el derecho a hacer lo siguiente:","newPrivacyPolicyRightsParaList1":"Retirar su consentimiento en cualquier momento. Los usuarios tienen derecho a retirar el consentimiento donde hayan dado previamente su consentimiento al procesamiento de sus datos personales.","newPrivacyPolicyRightsParaList2":"Rechazar el procesamiento de sus datos. Los usuarios tienen derecho a rechazar el procesamiento de sus datos si el procesamiento está siendo llevado a cabo con una base legal distinta al consentimiento. Se proporcionan más detalles en la sección dedicada a continuación.","newPrivacyPolicyRightsParaList3":"Acceder a sus datos. Los usuarios tienen derecho a saber si el propietario está procesando datos, obtener una divulgación en relación a ciertos aspectos del procesamiento y obtener una copia de los datos que se estén procesando.","newPrivacyPolicyRightsParaList4":"Verificar y pedir una rectificación. Los usuarios tienen derecho a verificar la veracidad de sus datos y pedir que se actualicen o se corrijan.","newPrivacyPolicyRightsParaList5":"Restringir el procesamiento de sus datos. Los usuarios tienen derecho, bajo ciertas circunstancias, a restringir el procesamiento de sus datos. En este caso, el propietario no procesará sus datos con un objetivo distinto a almacenarlos.","newPrivacyPolicyRightsParaList6":"Hacer que se eliminen sus datos personales o se retiren de otra manera. Los usuarios tienen derecho, bajo ciertas circunstancias, a conseguir la eliminación de sus datos por parte del propietario.","newPrivacyPolicyRightsParaList7":"Recibir sus datos y que se transfieran a otro controlador. Los usuarios tienen derecho a recibir sus datos en un formato estructurado, utilizado habitualmente y legible con una máquina y, si es posible técnicamente, a que se envíe a otro controlador sin impedimento alguno. Esta disposición es aplicable siempre que los datos se procesen por medios automáticos y que el procesamiento esté basado en el consentimiento del usuario, en un contrato del que forme parte el usuario o en obligaciones precontractuales del mismo.","newPrivacyPolicyRightsParaList8":"Presentar una queja. Los usuarios tienen derecho a presentar una queja ante su autoridad de protección de datos competente.","newPrivacyPolicyRightsDetails":"Detalles sobre el derecho a rechazar el procesamiento","newPrivacyPolicyRightsDetails1":"Mientras que los datos personales se procesan por un interés público, en el ejercicio de una autoridad oficial conferida en el propietario o con el objetivo de los intereses legítimos del propietario, los usuarios pueden rechazar dicho procesamiento proporcionando una base relacionada con su situación particular para justificar la objeción.","newPrivacyPolicyRightsDetails2":"Los usuarios deben saber que, aun así, si sus datos personales son procesados con fines directos de mercadotecnia, pueden rechazar dicho procesamiento en cualquier momento sin proporcionar justificación alguna. Para saber si el propietario está procesando datos personales con fines directos de mercadotecnia, los usuarios pueden consultar las secciones pertinentes de este documento.","newPrivacyPolicyRightsExercise":"Cómo ejercer estos derechos","newPrivacyPolicyRightsExercise1":"Cualquier solicitud para ejercer los derechos del usuario puede dirigirse al propietario a través de los datos de contacto proporcionados en este documento. Estas solicitudes pueden ejercerse gratuitamente y serán respondidas por el propietario lo antes posible y siempre en un plazo de un mes.","newPrivacyPolicyCookie":"Política de cookies","newPrivacyPolicyCookie1":"Esta aplicación utiliza cookies y otros identificadores. Para saber más, el usuario puede consultar la ","newPrivacyPolicyCookie2":"política de cookies.","newPrivacyPolicyAddInfo":"Información adicional sobre la recopilación y el procesamiento de datos","newPrivacyPolicyAddInfoLegalAction":"Acciones legales","newPrivacyPolicyAddInfoLegalAction1":"Los datos personales del usuario podrían usarse con fines legales por parte del propietario en el tribunal o en los momentos que lleven a posibles acciones legales como resultado del uso inadecuado de esta aplicación o de los servicios relacionados.","newPrivacyPolicyAddInfoLegalAction2":"El usuario afirma ser consciente de que el propietario podría ser obligado a revelar datos personales tras la solicitud de las autoridades públicas.","newPrivacyPolicyAddInfoPersonalData":"Información adicional sobre los datos personales del usuario","newPrivacyPolicyAddInfoPersonalData1":"Además de la información incluida en esta política de privacidad, esta aplicación puede proporcionar al usuario información adicional y contextual relativa a unos servicios particulares o a la recopilación y el procesamiento de datos personales bajo solicitud.","newPrivacyPolicyAddInfoMaintenance":"Registros y mantenimiento del sistema","newPrivacyPolicyAddInfoMaintenance1":"Con fines de funcionamiento y mantenimiento, esta aplicación y cualquier otro servicio de un tercero puede recopilar archivos que registren interacciones con esta aplicación (registros del sistema) y el uso de otros datos personales (como la dirección IP) con este objetivo.","newPrivacyPolicyAddInfoNotContained":"Información no incluida en esta política","newPrivacyPolicyAddInfoNotContained1":"Se podrían solicitar más detalles relativos a la recopilación del procesamiento de datos personales por parte del propietario en cualquier momento. Por favor, consulte la información de contacto al comienzo de este documento.","newPrivacyPolicyAddInfoDoNotTrack":"Cómo se gestionan las solicitudes de \"No realizar seguimiento\"","newPrivacyPolicyAddInfoDoNotTrack1":"Esta aplicación no admite solicitudes de \"No realizar seguimiento\". Para determinar si alguno de los servicios de terceros cumple con las solicitudes de \"No realizar seguimiento\", por favor, lea sus políticas de privacidad.","newPrivacyPolicyAddInfoChanges":"Cambios a esta política de privacidad","newPrivacyPolicyAddInfoChanges1":"El propietario se reserva el derecho a realizar cambios a esta política de privacidad en cualquier momento notificando a sus usuarios en esta página y posiblemente en esta aplicación o, hasta donde sea factible técnica y legalmente, enviando una notificación a los usuarios a través de cualquier información de contacto disponible para el propietario. Se recomienda encarecidamente comprobar esta página con frecuencia, consultando la fecha de la última modificación que aparece en la parte inferior.","newPrivacyPolicyAddInfoChanges2":"Si los cambios afectan a las actividades de procesamiento realizadas sobre la base del consentimiento del usuario, el propietario recopilará un nuevo consentimiento del usuario cuando sea necesario.","newPrivacyPolicyDefiner":"Definiciones y referencias legales","newPrivacyPolicyDefinerPersonalData":"Datos personales (o datos)","newPrivacyPolicyDefinerPersonalData1":"Cualquier información que, directa o indirectamente, o en relación con otra información, incluido un número de identificación personal, permita la identificación o capacidad de identificación de una persona física.","newPrivacyPolicyDefinerUsageData":"Datos de uso","newPrivacyPolicyDefinerUsageData1":"La información recopilada automáticamente a través de esta aplicación (o servicios de terceros empleados en esta aplicación), que pueden incluir: las direcciones IP o nombres de dominios de los ordenadores utilizados por los usuarios que usan esta aplicación, las direcciones URI (identificador de recurso uniforme), la hora de la solicitud, el método utilizado para enviar la solicitud al servidor, el tamaño del archivo recibido en respuesta, el código numérico que indica el estado de la respuesta del servidor (resultado exitoso, error, etc.), el país de origen, las funciones del navegador y el sistema operativo utilizado por el usuario, los distintos detalles del tiempo por visita (p. ej., el tiempo pasado en cada página dentro de la aplicación) y los detalles sobre la ruta seguida dentro de la aplicación con referencia especial a la secuencia de páginas visitadas y otros parámetros sobre el sistema operativo del dispositivo o el entorno informático del usuario.","newPrivacyPolicyDefinerUser":"Usuario","newPrivacyPolicyDefinerUser1":"La persona que utiliza esta aplicación que, salvo que se indique de otra manera, coincide con el sujeto de los datos.","newPrivacyPolicyDefinerSubject":"Sujeto de los datos","newPrivacyPolicyDefinerSubject1":"La persona física a la que se refieren los datos personales.","newPrivacyPolicyDefinerProcessor":"Procesador de datos (o supervisor de datos)","newPrivacyPolicyDefinerProcessor1":"La persona física o legal, autoridad pública, agencia u otro organismo que procesa los datos personales en nombre del controlador, según se describe en esta política de privacidad.","newPrivacyPolicyDefinerController":"Controlador de datos (o propietario)","newPrivacyPolicyDefinerController1":"La persona física o legal, autoridad pública, agencia u otro organismo que, individual o conjuntamente con otros, determina los objetivos y medios del procesamiento de datos personales, incluidas las medidas de seguridad relativas al funcionamiento y al uso de esta aplicación. El controlador de datos, salvo que se especifique de otra manera, es el propietario de esta aplicación.","newPrivacyPolicyDefinerApplication":"Esta aplicación","newPrivacyPolicyDefinerApplication1":"Los medios por los que los datos personales del usuario se recopilan y procesan.","newPrivacyPolicyDefinerService":"Servicio","newPrivacyPolicyDefinerService1":"El servicio proporcionado por esta aplicación según se describe en los términos relativos (si están disponibles) y en este sitio/aplicación.","newPrivacyPolicyDefinerEU":"Unión Europea (o UE)","newPrivacyPolicyDefinerEU1":"Salvo que se indique de otra manera, todas las referencias realizadas en este documento a la Unión Europea incluyen todos los miembros estado actuales de la Unión Europea y del Espacio Económico Europeo.","newPrivacyPolicyDefinerCookies":"Cookies","newPrivacyPolicyDefinerCookies1":"Conjuntos pequeños de datos almacenados en el dispositivo del usuario.","newPrivacyPolicyDefinerLegalInfo":"Información legal","newPrivacyPolicyDefinerLegalInfo1":"Esta declaración de privacidad se ha preparado en base a las disposiciones de varias legislaciones, incluido el Art. 13/14 del reglamento (UE) 2016/679 (Reglamento General de Protección de Datos).","newPrivacyPolicyDefinerLegalInfo2":"Esta política de privacidad está relacionada solo con esta aplicación, si no se indica de otra manera en este documento.","newPrivacyPolicyLatestUpdate":"Última actualización: 8 de mayo de 2020","newPrivacyPolicyPurpose":"Los objetivos del procesamiento","newPrivacyPolicyPurposeHead1":"Los datos relativos al usuario se recopilan para permitir al usuario que proporcione su servicio, cumpla con sus obligaciones legales, responda a solicitudes de ejecución, proteja sus derechos e intereses (o aquellos de sus usuarios o terceras partes), detecte cualquier actividad maliciosa o fraudulenta, así como lo siguiente: análisis, recomercializar y objetivo conductual, publicidad, rendimiento del contenido y pruebas de características (pruebas A/B) y gestión de etiquetas.","newPrivacyPolicyPurposeHead2":"Para información específica sobre los datos personales usados para cada objetivo, el usuario puede consultar la sección “Información detallada del procesamiento de datos personales”.","newPrivacyPolicyPurposeDetailedInfo":"Información detallada sobre el procesamiento de datos personales","newPrivacyPolicyPurposeDetailedInfoHead":"Los datos personales se recopilan con los siguientes objetivos y usando los siguientes servicios:","newPrivacyPolicyPurposeDetailedInfoAdvertising":"Publicidad","newPrivacyPolicyPurposeDetailedInfoAdvertising1":"Este tipo de servicio permite que se utilicen los datos de usuario para fines de comunicación publicitaria. Estos mensajes aparecen en la forma de carteles publicitarios y otros anuncios en esta aplicación, quizá basados en los intereses del usuario.","newPrivacyPolicyPurposeDetailedInfoAdvertising2":"Esto no quiere decir que todos los datos personales se utilicen con este objetivo. La información y las condiciones de uso se indican a continuación.","newPrivacyPolicyPurposeDetailedInfoAdvertising3":"Algunos de los servicios que se indican a continuación podrían usar cookies u otros identificadores para identificar usuarios o podrían usar la técnica de volver a captar conductas, p. ej., mostrar anuncios que se ajusten a los intereses y a la conducta del usuario, incluidos aquellos detectados fuera de esta aplicación. Para tener más información, por favor, consulte las políticas de privacidad de los servicios relevantes.","newPrivacyPolicyPurposeDetailedInfoAdvertising4":"Además de cualquier característica de exclusión ofrecida por cualquiera de los servicios a continuación, los usuarios podrían desvincularse visitando la página de desvinculación de Network Advertising Initiative.","newPrivacyPolicyPurposeDetailedInfoAdvertising5":"Los usuarios también podrían desvincularse de ciertas funciones publicitarias a través de los ajustes del dispositivo aplicables, como los ajustes de publicidad del dispositivo para móviles o los ajustes de publicidad en general.","newPrivacyPolicyPurposeDetailedInfoGoogleIreland":"Google Ads Similar Audiences (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleIreland1":"Similar Audiences es un servicio de objetivo conductual y de publicidad proporcionado por Google Ireland Limited que utiliza datos de la recomercialización de Google Ads para mostrar anuncios a usuarios con una conducta similar a usuarios que ya estén en la lista de recomercialización debido a su uso anterior de esta aplicación.","newPrivacyPolicyPurposeDetailedInfoGoogleIreland2":"Sobre la base de estos datos, se mostrarán anuncios personalizados a usuarios sugeridos por Público similar de Google Ads. Los usuarios que no quieran ser incluidos en Similar Audiences pueden desvincularse y desactivar el uso de las cookies de publicidad entrando en: Ajustes de Google Ads.","newPrivacyPolicyPurposeDetailedInfoGoogleIreland3":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleIreland4":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoAnalytics":"Analytics","newPrivacyPolicyPurposeDetailedInfoAnalytics1":"Los servicios incluidos en esta sección habilitan al propietario a que supervise y analice el tráfico web y pueden usarse para realizar un seguimiento de la conducta del usuario.","newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland":"Google Analytics (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland1":"Google Analytics es un servicio de análisis de web proporcionado por Google Ireland Limited (“Google”). Google usa los datos recopilados para realizar un seguimiento y examinar el uso de esta aplicación, preparar informes sobre sus actividades y compartirlos con otros servicios de Google.","newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland2":"Google podría usar los datos recopilados para contextualizar y personalizar los anuncios de su propia red de publicidad.","newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland3":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland4":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect":"Análisis recogido directamente (esta aplicación)","newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect1":"Esta aplicación utiliza un sistema de análisis interno que no involucra a terceros.","newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect2":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous":"Google Analytics con IP anónima (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous1":"Google Analytics es un servicio de análisis web proporcionado por Google Ireland Limited (“Google”). Google usa los datos recopilados para realizar un seguimiento y examinar el uso de esta aplicación, preparar informes sobre sus actividades y compartirlos con otros servicios de Google.","newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous2":"Google podría usar los datos recopilados para contextualizar y personalizar los anuncios de su propia red de publicidad.","newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous3":"Esta integración de Google Analytics anonimiza su dirección IP. Funciona acortando la dirección IP de los usuarios en los estados miembro de la Unión Europea o en otros estados contratantes al acuerdo del Espacio Económico Europeo. Solo en casos excepcionales se enviará al servidor de Google la dirección IP completa y acortada en los EE. UU.","newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous4":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous5":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoGoogleAds":"Google Ads conversion tracking (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleAds1":"Google Ads conversion tracking es un servicio de análisis proporcionado por Google Ireland Limited que relaciona datos de la red de publicidad de Google Ads con acciones realizadas en esta aplicación.","newPrivacyPolicyPurposeDetailedInfoGoogleAds2":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleAds3":"Lugar de procesamiento: Irlanda – Política de privacidad. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting":"Funciones de informes de publicidad de Google Analytics (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting1":"Google Analytics en esta aplicación tiene las funciones de informes de publicidad activadas, que recopila información adicional de la cookie de DoubleClick (actividad web) y de ID de publicidad de dispositivos (actividad de la aplicación). Permite al propietario analizar una conducta específica y datos de intereses (datos del tráfico y datos de interacciones de usuarios con publicidad) y, si está activada, datos demográficos (información sobre la edad y el género). Los usuarios pueden desvincularse del uso de cookies de Google visitando los Ajustes de publicidad de Google.","newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting2":"Datos personales procesados: cookies; identificadores de dispositivos únicos para publicidad (ID o IDFA del anunciante de Google, por ejemplo)); distintos tipos de datos según lo especificado en la política de privacidad del servicio.","newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting3":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoGoogleDemographics":"Google Analytics Demographics and Interests reports (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleDemographics1":"Google Analytics Demographics and Interests reports es una función de informes de publicidad de Google que aporta datos demográficos y de intereses en Google Analytics para esta aplicación (demografía se refiere a datos de la edad y el género). Los usuarios pueden desvincularse del uso de cookies de Google visitando los Ajustes de publicidad de Google.","newPrivacyPolicyPurposeDetailedInfoGoogleDemographics2":"Datos personales procesados: cookies; identificadores de dispositivos únicos para publicidad (ID o IDFA del anunciante de Google, por ejemplo).","newPrivacyPolicyPurposeDetailedInfoGoogleDemographics3":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoABTesting":"Rendimiento del contenido y pruebas de funciones (pruebas A/B)","newPrivacyPolicyPurposeDetailedInfoABTesting1":"Los servicios incluidos en esta sección permiten al propietario realizar un seguimiento y analizar la respuesta del usuario en lo relativo al tráfico web o a conductas sobre los cambios en la estructura, texto o cualquier otra parte de esta aplicación.","newPrivacyPolicyPurposeDetailedInfoGoogleOptimize":"Google Optimize (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleOptimize1":"Google Optimize es un servicio de pruebas A/B proporcionado por Google Ireland Limited ('Google'). Google podría usar datos personales para contextualizar y personalizar los anuncios de su propia red de publicidad.","newPrivacyPolicyPurposeDetailedInfoGoogleOptimize2":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleOptimize3":"Lugar de procesamiento: Irlanda – Política de privacidad. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoRemarketing":"Recomercialización y objetivo conductual","newPrivacyPolicyPurposeDetailedInfoRemarketing1":"Este tipo de servicio permite a esta aplicación y a sus socios informar, optimizar y proporcionar publicidad basada en el uso anterior de esta aplicación por parte del usuario.","newPrivacyPolicyPurposeDetailedInfoRemarketing2":"Esta actividad está facilitada por el seguimiento de datos de uso y por el uso de cookies y otros identificadores para recopilar información que, después, se transfiere a los socios que gestionan la recomercialización y la actividad de objetivo conductual.","newPrivacyPolicyPurposeDetailedInfoRemarketing3":"Algunos servicios ofrecen una opción de recomercialización basada en las listas de correos electrónicos.","newPrivacyPolicyPurposeDetailedInfoRemarketing4":"Además de cualquier función de desvinculación proporcionada por cualquiera de los servicios a continuación, los usuarios podrían desvincularse visitando la página de desvinculación de Network Advertising Initiative.","newPrivacyPolicyPurposeDetailedInfoRemarketing5":"Los usuarios también podrían desvincularse de ciertas funciones de publicidad a través de ajustes del dispositivo aplicables, como los ajustes de publicidad del dispositivo para móviles o los ajustes de publicidad en general.","newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion":"Google Ad Manager Audience Extension (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion1":"Google Ad Manager Audience Extension es un servicio de recomercialización y objetivo conductual proporcionado por Google Ireland Limited que realiza un seguimiento de las visitas de esta aplicación y permite que a unos socios de publicidad seleccionados se les muestre publicidad objetivo en la web.","newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion2":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion3":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing":"Google Ads Remarketing (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing1":"Google Ads Remarketing es un servicio de recomercialización y objetivo conductual proporcionado por Google Ireland Limited que relaciona la actividad de esta aplicación con la red de publicidad de Google Ads y la cookie de DoubleClick. Los usuarios pueden desvincularse del uso de cookies de Google para la personalización de anuncios visitando los Ajustes de publicidad de Google.","newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing2":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing3":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics":"Remarketing with Google Analytics (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics1":"Remarketing with Google Analytics es un servicio de recomercialización y objetivo conductual proporcionado por Google Ireland Limited que relaciona la actividad de seguimiento realizada por Google Analytics y sus cookies con la red de publicidad de Google Ads y la cookie de Doubleclick.","newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics2":"Datos personales procesados: cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics3":"Lugar de procesamiento: Irlanda – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoFacebookRemembering":"Facebook Remarketing (Facebook, Inc.)","newPrivacyPolicyPurposeDetailedInfoFacebookRemembering1":"Facebook Remarketing es un servicio de recomercialización y objetivo conductual proporcionado por Facebook, Inc. que relaciona la actividad de esta aplicación con la red de publicidad de Facebook.","newPrivacyPolicyPurposeDetailedInfoFacebookRemembering2":"Datos personales procesados: Cookies; datos de uso.","newPrivacyPolicyPurposeDetailedInfoFacebookRemembering3":"Lugar de procesamiento: Estados Unidos – Política de privacidad – Desvincularse. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoTagManagement":"Gestión de etiquetas","newPrivacyPolicyPurposeDetailedInfoTagManagement1":"Este tipo de servicio ayuda al propietario a gestionar las etiquetas o secuencias de comandos necesarias en esta aplicación de manera centralizada.","newPrivacyPolicyPurposeDetailedInfoTagManagement2":"Esto tiene como resultado el flujo de los datos de los usuarios a través de estos servicios, con la posibilidad de que haya una retención de estos datos.","newPrivacyPolicyPurposeDetailedInfoGoogleTagManager":"Google Tag Manager (Google Ireland Limited)","newPrivacyPolicyPurposeDetailedInfoGoogleTagManager1":"Google Tag Manager es un servicio de gestión de etiquetas proporcionado por Google Ireland Limited.","newPrivacyPolicyPurposeDetailedInfoGoogleTagManager2":"Datos personales procesados: Datos de uso.","newPrivacyPolicyPurposeDetailedInfoGoogleTagManager3":"Lugar de procesamiento: Irlanda – Política de privacidad. Participante de Privacy Shield.","newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData":"Más información sobre los datos personales","newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData1":"Análisis y predicciones basadas en los datos del usuario (“evaluación por perfil”)","newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData2":"El propietario podría usar los datos personales y de uso recopilados en esta aplicación para crear o actualizar perfiles de usuario. Este tipo de procesamiento de datos permite al propietario evaluar las elecciones, preferencias y conductas del usuario para los fines indicados en la sección pertinente de este documento.","newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData3":"También pueden crearse perfiles de usuario a través del uso de herramientas automatizadas, como algoritmos, que también pueden proporcionarlas terceras partes. Para saber más sobre las actividades de evaluación por perfil realizadas, los usuarios pueden comprobar las secciones pertinentes de este documento.","newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData4":"El usuario siempre tiene un derecho a rechazar este tipo de actividad de evaluación por perfil. Para saber más sobre los derechos del usuario y cómo ejercerlos, el usuario está invitado a consultar la sección de este documento que indica los derechos del mismo.","newPrivacyPolicyCookieGamelord":"Política de cookies de Game Lords","newPrivacyPolicyCookieGamelord1":"Las cookies y otros identificadores son fragmentos de código instalados en el dispositivo del usuario para ayudar al propietario a prestar el servicio de conformidad con los fines descritos.","newPrivacyPolicyCookieGamelord2":"Algunos de los fines para los que se utilizan estos identificadores podrían requerir el consentimiento del usuario. Siempre que se dé el consentimiento, éste podrá ser revocado con total libertad en cualquier momento, siguiendo las instrucciones indicadas en el presente documento.","newPrivacyPolicyCookieActivities":"Actividades estrictamente necesarias para el funcionamiento de esta aplicación y la prestación del Servicio","newPrivacyPolicyCookieActivities1":"Esta aplicación utiliza cookies u otros identificadores para llevar a cabo actividades que son estrictamente necesarias para su funcionamiento o prestación del servicio y, por lo tanto, no requieren el consentimiento del usuario. Los usuarios pueden desactivar dichos identificadores modificando la configuración de su navegador o dispositivo, tal como se describe con más detalle en el presente documento; sin embargo, esto puede afectar a las operaciones básicas o dar lugar a la interrupción del servicio.","newPrivacyPolicyCookieOtherActivities":"Otras actividades","newPrivacyPolicyCookieOtherActivitiesMeasurement":"Medición","newPrivacyPolicyCookieOtherActivitiesMeasurement1":"Esta aplicación utiliza cookies u otros identificadores para medir el tráfico y analizar el comportamiento del usuario con el objetivo de mejorar el servicio.","newPrivacyPolicyCookieOtherActivitiesMeasurementList1":"Analíticas","newPrivacyPolicyCookieOtherActivitiesMeasurementList2":"Los servicios de análisis son gestionados directamente por esta aplicación","newPrivacyPolicyCookieOtherActivitiesMeasurementList3":"Servicios analíticos anónimos","newPrivacyPolicyCookieOtherActivitiesMeasurementList4":"Pruebas de rendimiento y características de contenidos (pruebas A/B)","newPrivacyPolicyCookieOtherActivitiesTargeting":"Segmentación y publicidad","newPrivacyPolicyCookieOtherActivitiesTargeting1":"Esta aplicación utiliza cookies u otros identificadores para entregar contenido de marketing personalizado basado en el comportamiento del usuario; y para operar, servir y realizar el seguimiento de los anuncios.","newPrivacyPolicyCookieOtherActivitiesTargetingList1":"Publicidad","newPrivacyPolicyCookieOtherActivitiesTargetingList2":"Remarketing y la segmentación por comportamiento","newPrivacyPolicyCookieWithdrawConstent":"Cómo otorgar o revocar el consentimiento","newPrivacyPolicyCookieWithdrawConstent1":"Los usuarios pueden otorgar o revocar su consentimiento para el uso de cookies y otros identificadores estableciendo sus preferencias en la notificación de cookies o actualizándolas mediante el correspondiente componente de preferencias de consentimiento, si está disponible.","newPrivacyPolicyCookieWithdrawConstent2":"Además, los usuarios pueden gestionar las preferencias relacionadas directamente con los identificadores desde la configuración de su propio dispositivo e impedir, por ejemplo, el almacenamiento de identificadores de terceros. También es posible, mediante las correspondientes funcionalidades del navegador o del dispositivo, borrar los identificadores almacenados con anterioridad, incluidos los utilizados para recordar el consentimiento inicial del usuario. Los usuarios pueden, por ejemplo, conseguir información sobre cómo gestionar los identificadores en los navegadores que más se utilizan: Google Chrome, Mozilla Firefox, Apple Safari y Microsoft Internet Explorer.","newPrivacyPolicyCookieWithdrawConstent3":"En relación con los identificadores guardados por terceros, los usuarios pueden gestionar sus preferencias y revocar su consentimiento haciendo clic en el enlace correspondiente de exclusión voluntaria (si está disponible), utilizando los medios indicados en la política de privacidad de terceros o poniéndose en contacto con el tercero.","newPrivacyPolicyCookieWithdrawConstent4":"A pesar de lo anterior, por la presente se le informa a los usuarios que pueden seguir las instrucciones suministradas por YourOnlineChoices (EU), la Network Advertising Initiative (US), la Digital Advertising Alliance (US), DAAC (Canadá), DDAI (Japón) u otros servicios similares. Esas iniciativas permiten que los usuarios seleccionen sus preferencias de seguimiento para la mayoría de las herramientas publicitarias. Por consiguiente, el propietario recomienda a los usuarios que utilicen esos recursos junto con la información proporcionada en el presente documento.","newPrivacyPolicyCookieController":"Propietario y responsable de los datos","newPrivacyPolicyCookieController1":"Mobimilia BV","newPrivacyPolicyCookieController2":"Van Diemenstraat 140","newPrivacyPolicyCookieController3":"1013 CN Amsterdam","newPrivacyPolicyCookieController4":"Correo electrónico del propietario: info@mobimilia.com","newPrivacyPolicyCookieController5":"Puesto que el almacenamiento de cookies y otros identificadores de terceros a través de los servicios utilizados en esta aplicación no puede ser técnicamente controlado por el propietario, cualquier referencia explícita a identificadores almacenados por terceros debe ser considerada como indicativa. Para obtener más información, se ruega al usuario que consulte las políticas de privacidad de los servicios de terceros respectivos que se enumeran en el presente documento.","newPrivacyPolicyCookieController6":"Dada la evidente complejidad de las tecnologías relacionadas con las cookies y otros identificadores, se alienta a los usuarios para que se pongan en contacto con el propietario, en caso de que deseen recibir más información sobre el uso de dichos identificadores en esta aplicación.","terms-condition-title":"Términos y Condiciones","gen-terms-condition-title":"Términos Generales y Política de Privacidad","gen-terms-condition-desc":"Estos Términos Generales se aplican a los productos y servicios proporcionados a través de WAP, SMS, GPRS y 3G por Sam Media Ltd. o sus empresas relacionadas (en adelante, el 'Proveedor'). El Proveedor tiene derecho a cambiar estos Términos Generales de vez en cuando sin previo aviso. Además de los Términos Generales, cualquier norma aplicable publicada públicamente, términos promocionales, pautas y disposiciones relacionadas con los servicios también se aplicarán a usted y al Proveedor al utilizar los servicios del Proveedor (como se define a continuación). Todas estas pautas, normas, términos promocionales y disposiciones se considerarán parte integrante de estos Términos Generales. Al utilizar los servicios del Proveedor, usted acepta cumplir con estos Términos Generales, pautas, normas y términos promocionales.","provider-terms-condition-title":"Descripción del Proveedor","provider-terms-condition-desc":"Al utilizar los servicios de WAP, SMS, GPRS y 3G, el Proveedor brinda a los usuarios acceso a una red de recursos en línea, incluidos juegos en línea, mensajes de texto, contenido multimedia y información en línea, que puede descargarse a un teléfono móvil u otros dispositivos (los 'Servicios'). Los Términos Generales se aplican siempre a todas las nuevas características, incluidas aquellas que el Proveedor pueda implementar como parte de la expansión, desarrollo o mejora de los servicios del Proveedor, incluidas nuevas funcionalidades que el Proveedor añada.","availability-terms-condition-title":"Disponibilidad","availability-terms-condition-desc":"El servicio se proporciona tal como está (en su etapa de desarrollo actual), y el Proveedor no asume ninguna responsabilidad ni otorga garantías en caso de que la configuración personal, la información o los mensajes no se guarden, no se guarden a tiempo, se eliminen o se entreguen incorrectamente. Para suscribirse al Servicio, necesita acceso a Internet y/o una suscripción de telefonía móvil, y debe pagar cualquier tarifa asociada con dicho acceso. Usted es responsable de pagar todos los costos relacionados con dicho acceso. También es responsable de cualquier equipo necesario, incluidos teléfonos móviles o computadoras personales u otros dispositivos que puedan ser requeridos y que sean adecuados para utilizar el Servicio.","payment-terms-condition-title":"Pago","payment-terms-condition-desc":"Usted tiene acceso a nuestros servicios en línea de forma gratuita. Con respecto a los Servicios y su uso, debe pagar el monto correspondiente a las tarifas vigentes del Proveedor en ese momento y las tarifas aplicadas por su operador móvil. Las tarifas se le facturarán a través de su cuenta de operador móvil, que recibirá de su proveedor de red móvil. Usted paga al Proveedor todos los impuestos nacionales y locales u otros cargos, incluidos, entre otros, el IVA, cualquier impuesto o tasa que se aplique a los costos del uso del Servicio, independientemente de si estos impuestos se aplican ahora o en el futuro por las autoridades europeas, nacionales o locales, o cualquier otro organismo autorizado para recaudar impuestos. El Proveedor se reserva el derecho de cambiar las tarifas del Servicio publicando la información de dichos cambios en su sitio web.","obligation-terms-condition-title":"Obligación de Registro","obligation-terms-condition-desc":"Para garantizar el uso seguro y confiable del Servicio, usted garantiza lo siguiente, además de pagar las tarifas aplicables: (a) la información personal proporcionada en el formulario de registro (en adelante, 'Información Registrada') es verdadera, precisa, actual y completa, y (b) se compromete a garantizar que la Información Registrada sea siempre verdadera, actual, precisa y completa. Si el Proveedor tiene razones válidas para sospechar que la Información Registrada no es precisa o completa, el Proveedor tiene derecho a suspender o cancelar su cuenta y prohibir el uso actual o futuro del Servicio o sus componentes. Usted es responsable de mantener la confidencialidad de cualquier contraseña y/o cuenta emitida por el Proveedor, y es completamente responsable de todas las acciones realizadas bajo su contraseña o cuenta. Usted asume la obligación de cerrar su cuenta al final de cada sesión (cerrando el navegador) y ponerse en contacto con el Proveedor si sospecha que su contraseña o cuenta han sido utilizadas de manera no autorizada o si la seguridad o protección ya no están garantizadas. El Proveedor no puede y no será responsable de ningún daño que surja de su incapacidad para cumplir con las disposiciones de este artículo.","ownership-terms-condition-title":"Derechos de Propiedad del Proveedor","ownership-terms-condition-desc":"Estos Términos Generales se aplican a los productos y servicios proporcionados a través de WAP, SMS, GPRS y 3G por Sam Media Ltd. o sus empresas relacionadas (en adelante, el 'Proveedor'). El Proveedor tiene derecho a cambiar estos Términos Generales de vez en cuando sin previo aviso. Además de los Términos Generales, cualquier norma aplicable publicada públicamente, términos promocionales, pautas y disposiciones relacionadas con los servicios también se aplicarán a usted y al Proveedor al utilizar los servicios del Proveedor (como se define a continuación). Todas estas pautas, normas, términos promocionales y disposiciones se considerarán parte integrante de estos Términos Generales. Al utilizar los servicios del Proveedor, usted acepta cumplir con estos Términos Generales, pautas, normas y términos promocionales.","sidebar.lang":"Talen","sidebar.lang.be":"Nederlandse","sidebar.lang.de":"Duitse","sidebar.lang.fr":"Frans","AN INFLUENCER'S CALLING 'EVERYONE HAD TO ACCEPT ME WHEN I ACCEPTED MYSELF'":"El llamado de un influencer: 'Todos tuvieron que aceptarme cuando me acepté a mí mismo'","CRAZY CRAVINGS 'WHEN I'M BEHIND MY MASK, I'M BASICALLY SOMEONE NEW'":"Antojos locos: 'Cuando estoy detrás de mi máscara, básicamente soy alguien nuevo'","I'M A CELEBRITY PET LUNA IS A PRICKLY UP-AND-COMER":"Soy una celebridad: Luna es una nueva promesa espinosa","INSPIRE IN A MINUTE THE SUPERMODEL DISCOVERED AT 60":"Inspiración en un minuto: El supermodelo descubierto a los 60 años","MY COOL SCHOOL CAMILLA'S STUDYING THE TRAPEZE":"Mi escuela genial: Camilla está estudiando el trapecio","THE PILOTS FLYING A RESTORED WWII PLANE AROUND THE WORLD":"Los pilotos que están volando un avión restaurado de la Segunda Guerra Mundial alrededor del mundo","YOUNG CEO 'WHEN I LOOK AT A CAMERA, I SEE POWER IN ME & I SEE GREATNESS":"Joven CEO: 'Cuando miro a una cámara, veo poder en mí y veo grandeza'","CITY INNOVATIONS THE HIGHER YOU GO, THE GREENER IT GETS":"Innovaciones urbanas: cuanto más alto subes, más verde se pone","GREEN HEROES THE URBAN EXPERIENCE JUST GOT A SUSTAINABLE UPGRADE":"Héroes verdes: la experiencia urbana acaba de recibir una mejora sostenible","INSPIRE IN A MINUTE FROM BULLIED BUG HUNTER TO KID AUTHOR":"Inspiración en un minuto: De cazador de insectos acosado a joven autor","SIGHTS WITH HEIGHTS GHANA’S NATIONAL PARK CANOPY WALK":"Vistas desde lo alto: Paseo por el dosel en el Parque Nacional de Ghana","SIGHTS WITH HEIGHTS THE CLIFF SIDE SANCTUARY BETWEEN HEAVEN AND EARTH":"Vistas desde lo alto: El santuario en el acantilado entre el cielo y la tierra","A PLACE TO CALL HOME FOR ABANDONED DOGS":"Un lugar para llamar hogar para perros abandonados","BARRY THE BEE WHISPERER’S MOST IMPORTANT FIGHT YET":"Barry el susurrador de abejas: su lucha más importante hasta ahora","CEO ACTIVISM IS ON THE RISE":"El activismo de los CEOs está en aumento","INDIGENOUS HEROES NIGERIA'S ELIJAH IS SEEKING LEGAL JUSTICE FOR HIS PEOPLE":"Héroes indígenas: Elijah de Nigeria busca justicia legal para su gente","INDONESIA TO BUILD A NEW CAPITAL DUE TO CLIMATE CHANGE":"Indonesia construirá una nueva capital debido al cambio climático","INSPIRE IN A MINUTE BREAKING BORDERS IS A TOUR YOU HAVE TO GO ON":"Inspiración en un minuto: Romper fronteras es un recorrido que tienes que hacer","INSPIRE IN A MINUTE FIGHTING MENSTRUAL STIGMA IN NEPAL":"Inspiración en un minuto: Luchando contra el estigma menstrual en Nepal","INSPIRE IN A MINUTE HELPING KIDS FIGHT BACK & GET BETTER":"Inspiración en un minuto: Ayudando a los niños a luchar y mejorar","MORE THAN HALF OF WORLD’S FOREST WILDLIFE DISAPPEARED":"Más de la mitad de la fauna forestal del mundo ha desaparecido","MY SOCIAL MEDIA ACTIVISM IT'S TIME FOR EVERYONE TO #FILLTHEBOTTLE":"Mi activismo en redes sociales: Es hora de que todos llenen la botella","PEACE BUILDERS CLOSING THE CYCLE OF VIOLENCE":"Constructores de paz: Cerrando el ciclo de la violencia","PEACE BUILDERS THE ART OF PEACEFUL RESISTANCE":"Constructores de paz: El arte de la resistencia pacífica","PEACE BUILDERS THE UNITING FACTOR THAT'S BRINGING PEOPLE TOGETHER":"Constructores de paz: El factor de unión que está juntando a las personas","THE RESULTS ARE IN, TOKYO IS THE SAFEST CITY IN THE WORLD":"Los resultados están aquí: Tokio es la ciudad más segura del mundo","HOW TO BE GREEN AT HOME NATURAL STAIN REMOVER":"Cómo ser ecológico en casa: Quitamanchas natural","WANNA BE A DJ START WITH THE BASICS FROM A PRO":"¿Quieres ser DJ? Empieza con lo básico de un profesional","BEST VR EXPERIENCES INTO THE SHARK TANK":"Mejores experiencias de realidad virtual: En la jaula de tiburones","FROM HUMAN TO CYBORG":"De humano a ciborg","FUTURISTIC TRANSPORT GETTING AROUND NEVER LOOKED SO COOL":"Transporte futurista: Moverse nunca se vio tan genial","NASA’S NEXT DESTINATION IN 2026 TITAN":"El próximo destino de la NASA en 2026: Titán","VISIT A SPACE PLACE KOROLEV, RUSSIA'S DEEP SPACE HISTORY":"Visita un lugar espacial: Korolev, la historia del espacio profundo de Rusia","VISIT A SPACE PLACE THE METEOR CRATER":"Visita un lugar espacial: El cráter de meteorito","VISIT A SPACE PLACE THE NETHERLANDS' SPACE SIMULATOR":"Visita un lugar espacial: El simulador espacial de los Países Bajos","AMAZING TENNIS COURTS A COURT HIDDEN AMONG CLIFFS":"Asombrosas canchas de tenis: Una cancha escondida entre acantilados","BEST VR EXPERIENCES THE EXTREME SPORTS SIMULATOR":"Mejores experiencias de realidad virtual: El simulador de deportes extremos","DON’T EXPECT THE U.S. WOMEN’S FOOTBALL SQUAD AT THE WHITE HOUSE":"No esperes ver al equipo femenino de fútbol de EE.UU. en la Casa Blanca","FUTURE FEMALE FOOTBALLER COLOMBIA'S SALOME IS GONNA BE A PRO":"Futuro de futbolistas femeninas: Salomé de Colombia será profesional","MY UNDERGROUND SPORT ALAN NASTY NASH IS A CHAMP TOE WRESTLER":"Mi deporte subterráneo: Alan 'Nasty' Nash es un campeón en lucha de dedos","MY UNDERGROUND SPORT KABADDI'S GROWING IN INDIA":"Mi deporte subterráneo: El kabaddi está creciendo en India","SPORT FOR CHANGE A GOAL FOR INCLUSION":"Deporte para el cambio: Un gol por la inclusión","SPORT FOR CHANGE THE INITIATIVE HITTING IT OUT OF THE PARK":"Deporte para el cambio: La iniciativa que está triunfando","THE 5 BEST SUMMER FOOTBALL TRANSFERS SO FAR!":"¡Las 5 mejores transferencias de fútbol de verano hasta ahora!","COACHES CLINIC PETE HERRMAN":"Clínica de entrenadores: Pete Herrman","DRIBBLE DRIVE MOTION SKILLS":"Habilidades de movimiento con dribbling","GAMCA COACHES CLINIC":"CLÍNICA DE ENTRENADORES GAMCA","ROBERT TUTEIN (UTICA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"ROBERT TUTEIN (UTICA) - NOMINADO AL JUEGO DEL AÑO DE GEICO 2016","RYAN KELLEY (ARCADIA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"RYAN KELLEY (ARCADIA) - NOMINADO AL JUEGO DEL AÑO DE GEICO 2016","SAM BORST SMITH (ROCHESTER) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"SAM BORST SMITH (ROCHESTER) - NOMINADO AL JUEGO DEL AÑO DE GEICO 2016","SPECIAL SPECTATORS VISITS THE COLLEGE SLAM DUNK & 3- POINT CHAMPIONSHIPS INTERSPORT":"Espectadores especiales visitan el concurso de mates y triples universitario de Intersport","TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - NOMINADO AL JUEGO DEL AÑO DE GEICO 2016","TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - NOMINADO AL JUEGO DEL AÑO DE GEICO 2016","VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"VENKY JOIS (EASTERN WASHINGTON) - NOMINADO AL JUEGO DEL AÑO DE GEICO 2016","LEARN FREESTYLE FOOTBALL TRICKS LEMMENS AROUND THE WORLD":"APRENDE TRUCOS DE FÚTBOL FREESTYLE: LEMMENS ALREDEDOR DEL MUNDO","PRO FOOTBALLER TRAINING A NEED FOR SPEED":"ENTRENAMIENTO DE FÚTBOL PROFESIONAL: UNA NECESIDAD DE VELOCIDAD","PRO FOOTBALLER TRAINING LEG-FOCUSED EXERCISES":"ENTRENAMIENTO DE FÚTBOL PROFESIONAL: EJERCICIOS ENFOCADOS EN LAS PIERNAS","PRO FOOTBALLER TRAINING MUSCLES-FOCUSED EXERCISES":"ENTRENAMIENTO DE FÚTBOL PROFESIONAL: EJERCICIOS ENFOCADOS EN LOS MÚSCULOS","THERE’S NO POWER FROM KEEPING IT TO YOURSELF'":"NO HAY PODER EN GUARDÁRSELO PARA UNO MISMO","3 THINGS MALALA HAS SAID THAT WILL TOTALLY INSPIRE YOU":"3 COSAS QUE HA DICHO MALALA QUE TE INSPIRARÁN TOTALMENTE","BORDER ANGELS SAVING LIVES WITH WATER":"ÁNGELES FRONTERIZOS SALVANDO VIDAS CON AGUA","BULLIED TO INFLUENCER 'PAINTING HELPS ME DODGE MY PROBLEMS":"DE ACOSADO A INFLUENCER: 'PINTAR ME AYUDA A EVITAR MIS PROBLEMAS'","BULLIED TO INFLUENCER 'YOU CAN BE THE LIGHT IN THE DARKNESS":"DE ACOSADO A INFLUENCER: 'PUEDES SER LA LUZ EN LA OSCURIDAD'","PEACE BUILDERS FIGHTING GANGS WITH CLOWNING":"CONSTRUCTORES DE PAZ LUCHAN CONTRA BANDAS CON PAYASADAS","PEACEBUILDERS INSIDE THE COMMUNITY RING":"CONSTRUCTORES DE PAZ DENTRO DEL ANILLO COMUNITARIO","SPORT FOR CHANGE A SURE SHOT TO FEMALE EMPOWERMENT IN ZIMBABWE":"DEPORTE PARA EL CAMBIO: UN DISPARO SEGURO PARA EL EMPODERAMIENTO FEMENINO EN ZIMBABUE","YOUNG CEO MR. CORY’S COOKIES":"JOVEN CEO: LAS GALLETAS DE MR. CORY","CRAZY CRAVINGS 'I'VE BEEN EATING CHALK FOR OVER TWENTY YEARS":"ANTOJOS LOCOS: 'HE ESTADO COMIENDO TIZA POR MÁS DE VEINTE AÑOS'","DARGAVS WELCOME TO THE CITY OF THE DEAD":"DARGAVS: BIENVENIDO A LA CIUDAD DE LOS MUERTOS","HEROES NEIGHBORHOOD TOUR FRIDA KAHLO ":"TOUR POR EL BARRIO DE LOS HÉROES: FRIDA KAHLO","SOLO TRIP HIDDEN GEMS OF BALI":"VIAJE EN SOLITARIO: JOYAS OCULTAS DE BALI","SOLO TRIP HIDDEN GEMS OF BOGOR (INDONESIA)":"VIAJE EN SOLITARIO: JOYAS OCULTAS DE BOGOR (INDONESIA)","SOLO TRIP THE HIDDEN GEMS OF ROTTERDAM":"VIAJE EN SOLITARIO: LAS JOYAS OCULTAS DE RÓTERDAM","SUGARY DRINK LOVERS, THIS ONE'S FOR YOU!":"¡AMANTES DE LAS BEBIDAS AZUCARADAS, ESTA ES PARA USTEDES!","THE 5 MOST ICONIC ARMANI RED CARPET LOOKS OF ALL TIME":"LOS 5 LOOKS MÁS ICÓNICOS DE LA ALFOMBRA ROJA DE ARMANI DE TODOS LOS TIEMPOS","THE MOST AMAZING ISLAND CANARY ISLANDS":"LA ISLA MÁS ASOMBROSA: ISLAS CANARIAS","THE MOST AMAZING ISLAND FAVIGNANA SICILY":"LA ISLA MÁS ASOMBROSA: FAVIGNANA, SICILIA","THE MOST AMAZING ISLAND TEXEL":"LA ISLA MÁS ASOMBROSA: TEXEL","THESE NATIONS GIVE EXPATS THE BEST ONLINE LIFE":"ESTAS NACIONES OFRECEN A LOS EXPATRIADOS LA MEJOR VIDA ONLINE","5 GAMES YOU WILL LOSE FRIENDS OVER":"5 JUEGOS CON LOS QUE PERDERÁS AMIGOS","5 REASONS TO PLAY MONSTER HUNTER WORLD":"5 RAZONES PARA JUGAR MONSTER HUNTER WORLD","BEST VR EXPERIENCES THE SURVIVAL TEST":"MEJORES EXPERIENCIAS DE VR: LA PRUEBA DE SUPERVIVENCIA","PLACE YOUR BETS! GTA IS GETTING A REAL VIRTUAL CASINO":"¡APUESTA YA! GTA TENDRÁ UN VERDADERO CASINO VIRTUAL","TOP 5 GAMING LAWSUITS":"TOP 5 DEMANDAS DE JUEGOS","TOP 5 HIGHEST GROSSING ARCADE GAMES":"TOP 5 JUEGOS ARCADE MÁS VENDIDOS","TOP 5 LEGENDARY GAME COUPLES":"TOP 5 PAREJAS LEGENDARIAS DE JUEGOS","BUILDERS OF TOMORROW SOLAR WATER HEATER FROM PLASTIC BOTTLES":"CONSTRUCTORES DEL MAÑANA: CALENTADOR SOLAR DE AGUA HECHO CON BOTELLAS DE PLÁSTICO","GOT PLASTIC HERE ARE FOUR INNOVATIVE WAYS TO DEAL WITH IT!":"¿TIENES PLÁSTICO? ¡AQUÍ HAY CUATRO FORMAS INNOVADORAS DE TRATARLO!","SAVING THE PLANET AND MAKING ART, ONE BUTT AT A TIME":"SALVANDO EL PLANETA Y HACIENDO ARTE, UNA COLILLA A LA VEZ","THE FASTEST WAY TO SAVE THE PLANET":"LA FORMA MÁS RÁPIDA DE SALVAR EL PLANETA","THE UNIQUE ARTIST TURNING TIRES IN MASTERPIECES":"EL ARTISTA ÚNICO QUE TRANSFORMA LLANTAS EN OBRAS MAESTRAS","4 LESSONS TO LEARN FROM BUSINESS MOGUL ARIANNA HUFFINGTON":"4 LECCIONES PARA APRENDER DE LA MAGNATE DE NEGOCIOS ARIANNA HUFFINGTON","BUILDERS OF TOMORROW A FUTURE PAVED WITH PLASTIC":"CONSTRUCTORES DEL MAÑANA: UN FUTURO PAVIMENTADO CON PLÁSTICO","JUST HOW VULNERABLE ARE JOBS TO ROBOT TAKEOVERS":"¿CUÁN VULNERABLES SON LOS EMPLEOS ANTE LA LLEGADA DE LOS ROBOTS?","BEST RUGBY SKILLS - STEPS, TRICKS, OFFLOADS COMPILATION":"MEJORES HABILIDADES DE RUGBY: PASOS, TRUCOS, COMPILACIÓN DE PASES","BEST RUGBY SKILLS 2018":"MEJORES HABILIDADES DE RUGBY 2018","BEST RUGBY TRIES 2018":"MEJORES INTENTOS DE RUGBY 2018","CRAZIEST RUGBY SKILLS":"HABILIDADES DE RUGBY MÁS LOCAS","EPIC RUGBY SKILLS 2017":"HABILIDADES ÉPICAS DE RUGBY 2017","EPIC RUGBY STEPS 2018":"PASOS ÉPICOS DE RUGBY 2018","RUGBY BIG HITS 2018":"GRANDES IMPACTOS DE RUGBY 2018","DITCH THE DOCTOR! HOW ABOUT DIAGNOSIS BY COMPUTER":"¡DEJA AL DOCTOR! ¿QUÉ TAL UN DIAGNÓSTICO POR COMPUTADORA?","ESPN'S NEW DEAL DIVES INTO THE WORLD OF DRONE RACING":"EL NUEVO ACUERDO DE ESPN SE SUMERGE EN EL MUNDO DE LAS CARRERAS DE DRONES","EVER WISHED BEER COULD FLY NOW IT CAN!":"¿ALGUNA VEZ HAS DESEADO QUE LA CERVEZA PUDIERA VOLAR? ¡AHORA PUEDE!","HEARING THINGS HERE ARE 5 FACTS ON OUR INNER VOICE":"ESCUCHANDO COSAS: AQUÍ HAY 5 HECHOS SOBRE NUESTRA VOZ INTERIOR","IS SPOTTY SKIN THE ANSWER TO LOOKING YOUNGER":"¿ES LA PIEL MANCHADA LA RESPUESTA PARA VER MÁS JOVEN?","JUST WHY ARE THE DUTCH SO TALL":"¿POR QUÉ SON TAN ALTOS LOS HOLANDESES?","MEET THE ROBOT THAT WANTS TO GET TO KNOW YOU":"CONOCE AL ROBOT QUE QUIERE CONOCERTE","STAR WARS BECOMES REALITY IN A POST-APOCALYPTIC MALL":"STAR WARS SE CONVIERTE EN REALIDAD EN UN CENTRO COMERCIAL POST-APOCALÍPTICO","SUGAR TAX THE ANSWER TO OBESITY PANDEMIC":"¿LA IMPUESTO SOBRE EL AZÚCAR ES LA RESPUESTA A LA PANDEMIA DE OBESIDAD?","SWALLOW THIS NANO CHIP TO KNOW WHAT'S MAKING YOU SICK":"TRAGA ESTE CHIP NANOMÉTRICO PARA SABER QUÉ TE ENFERMA","THE EXPLODING COST OF CYBERATTACKS":"EL AUMENTO EXPLOSIVO DE LOS COSTOS DE LOS CIBERAATAQUES","TURNS OUT EMAILS DIDN'T SOLVE OUR WASTE PAPER PROBLEMS":"RESULTA QUE LOS CORREOS ELECTRÓNICOS NO RESOLVIERON NUESTROS PROBLEMAS DE PAPEL DESPERDICIADO","UK DRONE SHOW THE LATEST CONSUMER INDUSTRY TRENDS":"EL SHOW DE DRONES DEL REINO UNIDO MUESTRA LAS ÚLTIMAS TENDENCIAS EN LA INDUSTRIA DEL CONSUMO","VR RUNNING OF THE BULLS! A FEARFUL THRILLSEEKERS DREAM":"¡VR CORRIENDO CON LOS TOROS! UN SUEÑO PARA LOS QUE BUSCAN EMOCIÓN","AMAZING WATERFALLS ZAMBIA'S JAW-DROPPING NATURAL WONDER":"IMPRESIONANTES CATARATAS: LA INCREÍBLE MARAVILLA NATURAL DE ZAMBIA","FAIRY TALE DREAM SPOTS THE PRETTIEST VILLAGE IN ANDALUCÍA":"LUGARES DE SUEÑO DE CUENTO DE HADAS: EL PUEBLO MÁS BONITO DE ANDALUCÍA","FAIRY TALE DREAM SPOTS THE SINKING CASTLE OF SCALIGERA":"LUGARES DE SUEÑO DE CUENTO DE HADAS: EL CASTILLO HUNDIDO DE SCALIGERA","MEDELLÍN IS THE BACKPACKING SPOT YOU'VE BEEN LOOKING FOR":"MEDELLÍN ES EL LUGAR DE RUTA QUE HAS ESTADO BUSCANDO","SIGHTS WITH HEIGHTS THE NARROW BRIDGES OF CAMINITO DEL REY":"LUGARES CON ALTURAS: LOS PUENTES NARROS DE CAMINITO DEL REY","THIS DUTCH PARADE TAKES FLOWER POWER TO THE NEXT LEVEL":"ESTA DESFILE HOLANDÉS LLEVA EL PODER DE LAS FLORES A UN NUEVO NIVEL.","INSTA RESTAURANT WE COULD ALL USE A BIT MORE PINK IN OUR LIVES":"RESTAURANTE INSTA: TODOS PODRÍAN NECESITAR UN POCO MÁS DE ROSA EN NUESTRAS VIDAS","KFC IS TESTING MEATLESS CHICKEN WINGS AND NUGGETS":"KFC ESTÁ PROBANDO ALITAS Y NUGGETS SIN CARNE","TURNING LEFTOVER BREAD INTO PANZANELLA & BRUSCHETTA CAPRESE":"CONVERTIR EL PAN SOBRANTE EN PANZANELLA Y BRUSCHETTA CAPRESE","SALSAS FOR SUNNY DAYS SPICY MANGO SALSA":"SALSA PARA DÍAS SOLEADOS: SALSA DE MANGO PICANTE","VEGAN ICE CREAM AVOCADO BANANA":"HELADO VEGANO: AGUACATE Y PLÁTANO","VEGAN ICE CREAM COCONUT FUSION":"HELADO VEGANO: FUSIÓN DE COCO","VEGAN ICE CREAM FRESH FRUIT POPSICLES":"HELADO VEGANO: PULPITAS DE FRUTA FRESCA","VEGAN ICE CREAM PINEAPPLE MINT LIME":"HELADO VEGANO: PIÑA, MENTA Y LIMÓN","VEGAN ICE CREAM BANANA MATCHA":"HELADO VEGANO: PLÁTANO Y MATCHA","BRAIN IMPLANTS ARE CLOSER THAN YOU MIGHT THINK...":"LOS IMPLANTES CEREBRALES ESTÁN MÁS CERCA DE LO QUE PODRÍAS PENSAR","THANKS, CHAMELEONS HUMANS MIGHT GET COLOR-CHANGING SKIN":"GRACIAS, CAMALEONES: LOS HUMANOS PODRÍAN OBTENER PIEL QUE CAMBIA DE COLOR","ARM AND LEG RAISE":"LEVANTAMIENTO DE BRAZO Y PIERNA","CONDITION TRAINING":"ENTRENAMIENTO DE CONDICIÓN","CORE STRENGTH":"FUERZA DEL TRONCO","LUNGES":"ZANCADAS","PUNCH BAG":"SACO DE BOXEO","SHADOW BOXING":"BOXEO DE SOMBRA","STRETCHING":"ESTIRAMIENTOS","2016 CHEVROLET CAMARO SS":"2016 CHEVROLET CAMARO SS","2016 FORD MUSTANG FASTBACK":"2016 FORD MUSTANG FASTBACK","2016 FORD MUSTANG GT4":"2016 FORD MUSTANG GT4","2016 TOYOTA PRIUS G RACING CAR":"2016 TOYOTA PRIUS G COCHE DE CARRERAS","2016 TOYOTA XTREME COROLLA":"2016 TOYOTA XTREME COROLLA","ARABIC EPS 1 - HOW TO INTRODUCE YOURSELF":"ÁRABE EPS 1 - CÓMO PRESENTARTE","ARABIC EPS 2 - THANK YOU":"ÁRABE EPS 2 - GRACIAS","ENGLISH EPS 3 - ASKING ABOUT HOBBIES":"INGLÉS EPS 3 - PREGUNTANDO SOBRE HOBBIES","ENGLISH EPS 4 - WHERE ARE YOU FROM":"INGLÉS EPS 4 - ¿DE DÓNDE ERES?","FRENCH EPS 5 - HOW TO APOLOGIZE":"FRANCÉS EPS 5 - CÓMO DISCULPARSE","FRENCH EPS 6 - ASKING DO YOU SPEAK ENGLISH":"FRANCÉS EPS 6 - PREGUNTANDO SI HABLAS INGLÉS","ITALIAN EPS 7- APOLOGIES":"ITALIANO EPS 7 - DISCULPAS","ITALIAN EPS 8 - HOW MUCH":"ITALIANO EPS 8 - ¿CUÁNTO?","SPANISH EPS 9 - WHERE ARE YOU FROM":"ESPAÑOL EPS 9 - ¿DE DÓNDE ERES?","SPANISH EPS 10 - WHAT'S UP":"ESPAÑOL EPS 10 - ¿CÓMO ESTÁS?","HOW TO POST NATAL YOGA BREATHING EXERCISE":"CÓMO HACER EJERCICIOS DE RESPIRACIÓN DE YOGA POSTPARTO","HOW TO IN 60 SECONDS":"CÓMO HACER EN 60 SEGUNDOS","HOW TO POST NATAL YOGA - DANDASANA":"YOGA POSTPARTO - DANDASANA","HOW TO POST NATAL YOGA - IF BABY NEEDS ENTERTAINMENT":"YOGA POSTPARTO - SI EL BEBÉ NECESITA ENTRETENIMIENTO","PILATES  HALF ROLL BACK":"PILATES MEDIA ROLLO","BECOME FLEXIBLE WITH YOGA":"CONVIÉRTETE EN FLEXIBLE CON YOGA","FIND PEACE AT HOME WITH YOGA":"ENCUENTRA PAZ EN CASA CON YOGA","FIND PEACE WITH YOGA":"ENCUENTRA PAZ CON YOGA","GET SLIM & FIT WITH YOGA":"CONSIÉNTETE Y PONTE EN FORMA CON YOGA","LEARN THE ART OF YOGA":"APRENDE EL ARTE DEL YOGA","LOST WEIGHT WITH YOGA":"PERDÍ PESO CON YOGA","MASTER CORE YOGA POSES":"DOMINA LAS POSTURAS BÁSICAS DE YOGA","MIND OVER MATTER":"LA MENTE SOBRE LA MATERIA","ULTIMATE YOGA GUIDE":"GUÍA DEFINITIVA DE YOGA","YOGA VILLAGE":"ALDEA DEL YOGA","YOGA YOUR WAY TO HEALTHY LIVING":"YOGA: TU CAMINO HACIA UNA VIDA SALUDABLE","ANIMALS EXOTICOS":"ANIMALES EXÓTICOS","AUTOMATU":"AUTOMATU","BABIES AND MOVING TABLE PART 1":"BEBÉS Y MESA EN MOVIMIENTO PARTE 1","BAD KIDS THROW ORANGE PEELS PART 1":"NIÑOS MALOS TIRAN CÁSCARES DE NARANJA PARTE 1","BIG BUNNY SCARES BABIES PART 1":"EL GRAN CONEJO ASUSTA A LOS BEBÉS PARTE 1","BODYGUARDS":"GUARDIAS","CAKE ON FACE":"TARTA EN LA CARA","CAN I CLICK YOUR PHOTO":"¿PUEDO HACERTE UNA FOTO?","CAR PARKING":"APARCAMIENTO","CAR FOR SALE":"AUTO EN VENTA","MAN FALLING ON LADDER":"HOMBRE CAYENDO DE LA ESCALERA","MAN IN GARBAGE CAN PART 1":"HOMBRE EN EL CUBO DE BASURA PARTE 1","PAINTING EXHIBITION":"EXPOSICIÓN DE PINTURAS","RECKLESS BLIND MAN PART 1":"HOMBRE CIEGO TEMERARIO PARTE 1","ROLLER BLADER PART 1":"PATINADOR PARTE 1","RUDE MAN ON BEACH PART 1":"HOMBRE GROSIERO EN LA PLAYA PARTE 1","SANTA CLAUS THE PERVERT PART 1":"SANTA CLAUS, EL PERVERTIDO PARTE 1","BABY CARRIER ON CAR":"CARRITO DE BEBÉ EN EL AUTO","BLEEDING NOSE":"NARIZ SANGRANDO","MONEY FALLING":"DINERO CAYENDO","OPEN THIS PEN":"ABRE ESTE BOLÍGRAFO","GLAMOROUS TOUCH":"TOQUE GLAMUROSO","LIPS GLAMOROUS RED":"LABIOS ROJOS GLAMUROSOS","LIPS NATURAL":"LABIOS NATURALES","LIPS SPARKLING AND FULL":"LABIOS BRILLANTES Y LLENOS","MAKE-UP BLUSH":"MAQUILLAJE RUBOR","MAKE-UP BRONZER":"MAQUILLAJE BRONCEADOR","MAKE-UP CONCEALER":"MAQUILLAJE CORRECTOR","MAKE-UP EYEBROWS":"MAQUILLAJE CEJAS","MAKE-UP FOUNDATION":"MAQUILLAJE BASE","SMOKEY EYES":"OJOS AHUMADOS","SPARKLING EYES":"OJOS BRILLANTES","5 MAKE UP TIPS AND TRICKS FOR YOU":"5 CONSEJOS Y TRUCOS DE MAQUILLAJE PARA TI","7 MAKE UP TIPS AND TRICKS FOR FLAWLESS SKIN":"7 CONSEJOS Y TRUCOS DE MAQUILLAJE PARA UNA PIEL IMPECABLE","10 FAST AND EASY MAKE UP TIPS":"10 CONSEJOS RÁPIDOS Y FÁCILES DE MAQUILLAJE","10 MAKE UP TIPS AND TRICKS FOR OILY SKIN":"10 CONSEJOS Y TRUCOS DE MAQUILLAJE PARA PIEL GRASOSA","13 MAKE UP MISTAKES TO AVOID":"13 ERRORES DE MAQUILLAJE QUE DEBES EVITAR","101 TIPS FOR BEGINNER MAKE UP":"101 CONSEJOS PARA PRINCIPIANTES EN MAQUILLAJE","ASIAN BEAUTY TIPS YOU MUST DO NOW":"CONSEJOS DE BELLEZA ASIÁTICA QUE DEBES HACER AHORA","BEGINNER EVERY MAKE UP TIPS AND TRICKS FOR YOU":"CONSEJOS Y TRUCOS DE MAQUILLAJE PARA PRINCIPIANTES PARA TI","BEST MAKE UP ARTIST TIPS YOU NEED TO KNOW":"LOS MEJORES CONSEJOS DE MAQUILLAJE QUE NECESITAS SABER","ESSENTIAL MAKE UP TIPS FOR SUMMER GLOW":"CONSEJOS ESENCIALES DE MAQUILLAJE PARA UN BRILLO VERANIEGO","FLATTERING EYES MAKE UP FOR YOU":"MAQUILLAJE HALAGADOR PARA LOS OJOS","FOUNDATION TRICKS FOR OILY SKIN":"TRUCOS DE BASE PARA PIEL GRASOSA","FULL COVERAGE FOUNDATION ROUTINE FOR YOU":"RUTINA DE BASE DE COBERTURA COMPLETA PARA TI","LOOK FIERCE WITH DRUGSTORE MAKE UP":"LUCE IMPRESIONANTE CON MAQUILLAJE DE DROGUERÍA","MAKE UP ESSENTIALS FOR DARK SKIN TONES":"ESENCIALES DE MAQUILLAJE PARA TONOS DE PIEL OSCURA","MAKE UP TIPS FOR AGING EYES":"CONSEJOS DE MAQUILLAJE PARA OJOS MADUROS","MAKE UP TIPS FOR FLAWLESS SKIN":"CONSEJOS DE MAQUILLAJE PARA UNA PIEL IMPECABLE","MUST KNOW MAKE UP TIPS":"CONSEJOS DE MAQUILLAJE QUE DEBES CONOCER","MUST KNOW WAKE UP TIPS":"CONSEJOS ESENCIALES PARA DESPERTAR","NATURAL MAKE UP KOREAN STYLE":"MAQUILLAJE NATURAL ESTILO KOREANO","NATURAL MAKE UP TIPS FOR MEN":"CONSEJOS DE MAQUILLAJE NATURAL PARA HOMBRES","NATURAL TO GLAMOROUS":"DE NATURAL A GLAMUROSO","OVER 40 AGED WOMAN MAKE UP TIPS":"CONSEJOS DE MAQUILLAJE PARA MUJERES DE 40 AÑOS O MÁS","PRO MAKE UP TIPS BY TATI":"CONSEJOS DE MAQUILLAJE PROFESIONALES POR TATI","SECRET MAKE UP TIPS AND TRICKS FOR BEGINNERS":"CONSEJOS Y TRUCOS SECRETOS DE MAQUILLAJE PARA PRINCIPIANTES","SIMPLE TIPS FOR EYESHADOW":"CONSEJOS SENCILLOS PARA SOMBRA DE OJOS","SUMMER MAKE UP MELTPROOF TIPS":"CONSEJOS DE MAQUILLAJE RESISTENTE AL CALOR PARA EL VERANO","TOP 10 SECRET TIPS OF CELEBRITIES":"LOS 10 MEJORES CONSEJOS SECRETOS DE CELEBRIDADES","TOP 25 MAKE UP TIPS FOR PALE SKIN":"LOS 25 MEJORES CONSEJOS DE MAQUILLAJE PARA PIEL PÁLIDA","TYRA BANKS MAKE UP TIPS":"CONSEJOS DE MAQUILLAJE DE TYRA BANKS","SPIDER-MAN - 9 THINGS BEFORE PLAYING":"SPIDER-MAN - 9 COSAS QUE DEBES SABER ANTES DE JUGAR","FAR CRY 5 - 10 TIPS & TRICKS THE GAME DOESN'T TELL YOU":"FAR CRY 5 - 10 CONSEJOS Y TRUCOS QUE EL JUEGO NO TE DICE","GOD OF WAR - 10 TIPS & TRICKS THE GAME DOESN'T TELL YOU":"GOD OF WAR - 10 CONSEJOS Y TRUCOS QUE EL JUEGO NO TE DICE","PUBG MOBILE - 10 TIPS & TRICKS THE GAME DOESN'T TELL YOU":"PUBG MOBILE - 10 CONSEJOS Y TRUCOS QUE EL JUEGO NO TE DICE","TOP 10 BEGINNER FORTNITE BATTLE ROYALE TIPS":"TOP 10 CONSEJOS PARA PRINCIPIANTES EN FORTNITE BATTLE ROYALE","BABY CARIER ON CAR":"PORTABEBÉS EN EL COCHE"}

/***/ }),

/***/ "./src/translations/fr.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Accueil","sidebar.myaccount":"Mon compte","sidebar.notif":"Notification","sidebar.nonotif":"Vous n'avez pas encore de notification","html5games":"Jeux HTML5","androidGames":"Jeux Android","android-upper":"ANDROID","favorite":"Favoris","splashscreen.text":"Jouez bien au-delà","welcome.text":"DÉCOUVREZ LES MEILLEURS JEUX MOBILES EN LIGNE AUJOURD'HUI!","welcome.text.gamiclub":"DÉCOUVREZ LES MEILLEURS CONTENUS EN LIGNE DÈS AUJOURD'HUI!","accountDetails":"DÉTAILS DU COMPTE","accountName":"NOM","accountEmail":"ADRESSE E-MAIL","accountLocation":"LIEU","accountInterests":"INTÉRÊTS","accountChooseCategory":"Choisissez 3 catégories","accountEditPhoto":"MODIFIER LA PHOTO","save":"Sauvegarder","topCategories":"CATÉGORIES PRINCIPALES","favGames":"JEUX PRÉFÉRÉS","viewAll":"TOUT AFFICHER","noGamesFound":"Aucun jeu trouvé dans cette catégorie","noVideosFound":"Aucune vidéo trouvée dans cette catégorie","cancel":"Annuler","gameDirectories":"RÉPERTOIRE DES JEUX","category":"Catégorie","platform":"Plateforme","type":"Type","android":"ANDROID","games":"jeux","html5":"HTML5","videos":"VIDÉOS","search.input.placeholder":"Recherche...","search.cancel.button":"Annuler","description":"Description","downloadNow":"TÉLÉCHARGER","playNow":"démarrer","rate":"Noter","sidebar.lang":"Langues","sidebar.lang.fr":"Française","sidebar.lang.de":"Allemande","sidebar.lang.be":"Néerlandaise","sidebar.lang.en":"Anglaise","sidebar.lang.it":"Italienne","relatedGames":"JEUX ASSOCIÉS","noFavGames":"Aucun jeu préféré pour le moment","addFavGames":"Ajoutez vos jeux préférés pour y accéder et y jouer facilement","discover":"DÉCOUVRIR","noFavGamesFound":"Aucun jeu préféré trouvé","favorites":"Favori","accessDenied":"Accès refusé","pageRestricted":"La page que vous recherchez est restreinte.","averageRatingBasedOn":" Note moyenne des utilisateurs basée sur ","averageRatingReview":" avis","tnc":"Termes et conditions","contact_us":"Nous contacter","areYouAlready":"Etes-vous client de ","thenConfirm":"Confirmez ensuite votre numéro de mobile et obtenez un accès illimité à tous nos services!","login":"S'identifier","Action":"Action","Adventure":"Aventure","Arcade":"Arcade","Sport":"Sport","Racing":"Course","Utilities":"outils","Premium Games":"Jeux premium","no related games found":"Aucun jeu connexe trouvé","RPG":"RPG","Virtual Reality":"Réalité virtuelle","Motivation":"Motivation","Tour":"Visites","Fun Gaming":"Jeux amusants","Athletics":"Athlétisme","Inspiration":"Inspiration","Into Nature":"Nature","Political & Activism":"Politique et activisme","Travel":"Voyages","Foodbuzz":"Nourriture","Health and Nutrition":"Santé et nutrition","Fitness":"Fitness","Top Cars":"Voitures","Fashion & Beauty":"Mode et beauté","E-Learning":"Formation en ligne","Yoga":"Yoga","Just For Laugh":"Juste pour rire","Brain Boost":"Stimulation mentale","Rugby":"Rugby","Economy":"Économie","Environment":"Environnement","Gaming":"Jeux","Lifestyle":"Style de vie","Local Heroes":"Héros locaux","Sports":"Sports","Technology":"Technologie","Tutorials":"Tutoriels","New Arrivals":"Nouvelles entrées","noFavVideos":"Pas encore de vidéos préférées","addFavVideos":"Ajoutez vos vidéos préférées pour y accéder et les lire facilement","noFavVideosFound":"Aucune vidéo préférée trouvée","footer.copyright":"&copy; 2020 Gamelords. Tous Droits Réservés","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Tous Droits Réservés","footer.copyright.appspool":"&copy; 2020 Appspool. Tous Droits Réservés","vid-player":"joueur","privacyPolicy":"Politique de confidentialité","privacy-policy-title":"Politique de confidentialité","privacy-policy-desc":"Cette Politique de confidentialité explique nos engagements et vos droits concernant vos données. Nous vous recommandons de lire attentivement cette Politique de confidentialité. Si vous n'êtes pas d'accord avec cette Politique de confidentialité, veuillez ne pas utiliser nos sites et services. La Politique de confidentialité est correctement constituée et sujette aux Conditions d'utilisation. Elle régit les mêmes services et sites que ceux mentionnés dans les Conditions d'utilisation. Tous les termes que nous utilisons dans la Politique de confidentialité sans les définir ont la même définition que dans les Conditions d'utilisation.","privacy-policy-collect-info-head":"NOUS COLLECTONS DES DONNÉES DE DIFFÉRENTES MANIÈRES :","privacy-policy-collect-info-desc1":"1. Lorsque vous nous les fournissez ou lorsque vous nous donner la permission de les acquérir lorsque vous vous abonnez à l’un de nos services, nous ou l'opérateur mobile de votre réseau recueillons vos données relatives au paiement de l'abonnement à nos services. Les données de compte et de facturation collectées par l'opérateur mobile sont soumises à sa propre Politique de confidentialité. ","privacy-policy-collect-info-desc2":"2. Nous obtenons des informations techniques lorsque vous visitez nos sites et/ou services. Nous pouvons recueillir des informations techniques vous concernant lorsque vous utilisez nos services. Notre service recueille des données de log chaque fois que vous vous connectez ou vous déconnectez de nos services","privacy-policy-how-collect-info-head":"COMMENT UTILISONS-NOUS LES DONNÉES COLLECTÉES ?","privacy-policy-how-collect-info-subhead":"Nous pouvons utiliser vos données personnelles aux fins suivantes : ","privacy-policy-how-collect-info-desc1":"Vous fournir le(s) service(s) que vous avez demandé(s).","privacy-policy-how-collect-info-desc2":"Facturer et obtenir le paiement pour les service(s) qui vous est/sont fourni(s)","privacy-policy-how-long-head":"COMBIEN DE TEMPS CONSERVONS-NOUS VOS DONNÉES ?","privacy-policy-how-long-desc":"Nous conserverons vos donnés aussi longtemps que nécessaire afin de vous fournir nos services. Il est possible que nous conservions vos données personnelles afin de nous conformer aux obligations légales, pour résoudre les conflits potentiels et faire respecter nos accords. Lorsque vos données personnelles ne sont plus utiles dans le cadre d’obligations légales ou réglementaires, nous les effacerons de nos systèmes ou bien nous les dépersonnaliserons pour que vous ne soyez plus identifiable.","privacy-policy-how-long-protect-head":"COMMENT PROTÉGEONS-NOUS VOS DONNÉES AUSSI À L’EXTÉRIEUR DE L’UE ?","privacy-policy-how-long-protect-desc1":"Nous accordons beaucoup d’importance à la protection de votre vie privée et de vos données, mais nous ne pouvons pas garantir la sécurité des données que vous nous transmettez. Nous ne pouvons pas non plus vous garantir que vos donnés ne seront pas consultées, divulguées, modifiées ou détruites dans le cas d’une violation de nos normes de protection physique, technique ou de gestion. Nous adoptons des pratiques appropriées de collecte, de stockage et de traitement des données ainsi que des mesures de sécurité pour nous protéger contre des accès non autorisés ou accidentels, ","privacy-policy-how-long-protect-desc2":"contre la modification, la divulgation ou la destruction de vos informations, des données de transactions et des données stockées en utilisant nos services. Toutefois, aucune méthode de transmission sur internet ou de stockage électronique n'est sûre à 100 %. Par conséquent, nous ne pouvons garantir une sécurité absolue. Nous continuerons à améliorer nos procédures de sécurité à mesure que de nouvelles technologies deviendront disponibles. Du fait de notre présence internationale, vos données, y compris vos informations personnelles, peuvent être transférées et rendues disponibles aux ","privacy-policy-how-long-protect-desc3":"États-Unis / à Singapour et/ou dans un autre pays que celui de votre résidence. Dans ces pays également, nous prenons toutes les précautions raisonnables pour protéger vos informations personnelles.","privacy-policy-acceptance-head":"ACCEPTATION DE LA POLITIQUE DE CONFIDENTIALITÉ","privacy-policy-acceptance-desc":"En utilisant l'un de nos services, vous consentez à ce que nous recueillions et utilisions vos données conformément à la présente Politique de confidentialité. Nous nous réservons le droit de modifier cette Politique de confidentialité à tout moment en affichant les modifications sur cette page. Veuillez vérifier la date de révision au bas de cette page pour déterminer si la politique a été modifiée depuis votre dernière lecture. Votre utilisation continue de n’importe quelle partie de notre site ou de nos services après l'affichage de la Politique de confidentialité mise à jour aura valeur d’acceptation de votre part des modifications.","privacy-policy-changes-head":"MODIFICATIONS APPORTÉES À CETTE POLITIQUE DE CONFIDENTIALITÉ","privacy-policy-changes-desc":"Il est possible que nous modifions notre Politique de confidentialité de temps à autre. Si nous décidons de modifier notre Politique de confidentialité, nous afficherons ces modifications sur cette page afin que vous puissiez continuer à avoir accès à la dernière Politique de confidentialité.","privacy-policy-contact-us":"NOUS CONTACTER","privacy-policy-contact-us-desc":"Si vous avez des questions au sujet de cette Politique de confidentialité, des pratiques utilisées par les sites ou concernant vos transactions avec les sites, veuillez nous écrire à l’adresse support@content-clubs.com.","unsubscribe":"Se désabonner","mobile_number":"MSISDN","subscription_date":"Date d'abonnement","renewal_date":"Date de renouvellement","applied_plan":"Plan appliqué","service_name":"Nom du service","weekly":"Hebdomadaire","daily":"Du Quotidien","monthly":"Mensuel","withdraw_from_contract":"Rétractation du contrat","AN INFLUENCER'S CALLING 'EVERYONE HAD TO ACCEPT ME WHEN I ACCEPTED MYSELF'":"L’APPEL D’UN INFLUENCEUR « TOUT LE MONDE DEVAIT M’ACCEPTER QUAND JE ME SUIS ACCEPTÉ ».","CRAZY CRAVINGS 'WHEN I'M BEHIND MY MASK, I'M BASICALLY SOMEONE NEW'":"DES ENVIES FOLLES « QUAND JE SUIS DERRIÈRE MON MASQUE, JE SUIS FONDAMENTALEMENT QUELQU’UN DE NOUVEAU ».","I'M A CELEBRITY PET LUNA IS A PRICKLY UP-AND-COMER":"JE SUIS UNE CÉLÉBRITÉ - LUNA EST QUELQU’UN DE DIFFICILE","INSPIRE IN A MINUTE THE SUPERMODEL DISCOVERED AT 60":"INSPIRATION EN UNE MINUTE - LE TOP MODEL DÉCOUVERT À 60 ANS","MY COOL SCHOOL CAMILLA'S STUDYING THE TRAPEZE":"MA CAMILLA COOL DE L’ÉCOLE APPREND LE TRAPÈZE","THE PILOTS FLYING A RESTORED WWII PLANE AROUND THE WORLD":"LES PILOTES VOLENT AUTOUR DU MONDE DANS UN AVION RESTAURÉ DE LA 2E GUERRE MONDIALE","YOUNG CEO 'WHEN I LOOK AT A CAMERA, I SEE POWER IN ME & I SEE GREATNESS":"JEUNE PDG - « QUAND JE REGARDE UNE CAMÉRA, JE VOIS DU POUVOIR EN MOI ET JE VOIS DE LA GRANDEUR »","CITY INNOVATIONS THE HIGHER YOU GO, THE GREENER IT GETS":"LES INNOVATIONS DE LA VILLE - PLUS ON MONTE, PLUS C’EST VERT","GREEN HEROES THE URBAN EXPERIENCE JUST GOT A SUSTAINABLE UPGRADE":"LES HÉROS VERTS - L’EXPÉRIENCE URBAINE VIENT DE SUBIR UNE AMÉLIORATION DURABLE","INSPIRE IN A MINUTE FROM BULLIED BUG HUNTER TO KID AUTHOR":"INSPIRATION EN UNE MINUTE - UN CHASSEUR D’INSECTES MALTRAITÉ DEVIENT UN AUTEUR DE LIVRES POUR ENFANTS","SIGHTS WITH HEIGHTS GHANA’S NATIONAL PARK CANOPY WALK":"VUE D’EN HAUT - PROMENADE DANS LA CANOPÉE DU PARC NATIONAL DU GHANA","SIGHTS WITH HEIGHTS THE CLIFF SIDE SANCTUARY BETWEEN HEAVEN AND EARTH":"VUE D’EN HAUT - SANCTUAIRE À FLANC DE FALAISE ENTRE CIEL ET TERRE","A PLACE TO CALL HOME FOR ABANDONED DOGS":"UN REFUGE POUR LES CHIENS ABANDONNÉS","BARRY THE BEE WHISPERER’S MOST IMPORTANT FIGHT YET":"LE COMBAT LE PLUS IMPORTANT DE BARRY, L’HOMME QUI MURMURAIT À L’OREILLE DES ABEILLES","CEO ACTIVISM IS ON THE RISE":"LES PDG DEVIENNENT PLUS MILITANTS","INDIGENOUS HEROES NIGERIA'S ELIJAH IS SEEKING LEGAL JUSTICE FOR HIS PEOPLE":"LE HÉROS INDIGÈNE NIGÉRIAN ELIJAH CHERCHE À OBTENIR LA JUSTICE POUR SON PEUPLE","INDONESIA TO BUILD A NEW CAPITAL DUE TO CLIMATE CHANGE":"L’INDONÉSIE VA CONSTRUIRE UNE NOUVELLE CAPITALE EN RAISON DU CHANGEMENT CLIMATIQUE","INSPIRE IN A MINUTE BREAKING BORDERS IS A TOUR YOU HAVE TO GO ON":"INSPIRATION EN UNE MINUTE - VOUS DEVEZ BRISER LES FRONTIÈRES","INSPIRE IN A MINUTE FIGHTING MENSTRUAL STIGMA IN NEPAL":"INSPIRATION EN UNE MINUTE - LA LUTTE CONTRE LES STIGMATES MENSTRUELS AU NÉPAL","INSPIRE IN A MINUTE HELPING KIDS FIGHT BACK & GET BETTER":"INSPIRATION EN UNE MINUTE - AIDER LES ENFANTS À SE DÉFENDRE ET À S’AMÉLIORER","MORE THAN HALF OF WORLD’S FOREST WILDLIFE DISAPPEARED":"PLUS DE LA MOITIÉ DE LA FAUNE FORESTIÈRE MONDIALE A DISPARU","MY SOCIAL MEDIA ACTIVISM IT'S TIME FOR EVERYONE TO #FILLTHEBOTTLE":"MON ACTIVISME SUR LES RÉSEAUX SOCIAUX - IL EST TEMPS POUR TOUT LE MONDE DE #REMPLIRLABOUTEILLE","PEACE BUILDERS CLOSING THE CYCLE OF VIOLENCE":"LES ARTISANS DE LA PAIX - METTRE FIN AU CYCLE DE LA VIOLENCE","PEACE BUILDERS THE ART OF PEACEFUL RESISTANCE":"LES ARTISANS DE LA PAIX - L’ART DE LA RÉSISTANCE PACIFIQUE","PEACE BUILDERS THE UNITING FACTOR THAT'S BRINGING PEOPLE TOGETHER":"LES ARTISANS DE LA PAIX - LE FACTEUR D’UNITÉ QUI RASSEMBLE LES GENS","THE RESULTS ARE IN, TOKYO IS THE SAFEST CITY IN THE WORLD":"LES RÉSULTATS SONT LÀ : TOKYO EST LA VILLE LA PLUS SÛRE DU MONDE","HOW TO BE GREEN AT HOME NATURAL STAIN REMOVER":"COMMENT ÊTRE VERT À LA MAISON - DÉTACHANT NATUREL","WANNA BE A DJ START WITH THE BASICS FROM A PRO":"VOUS VOULEZ DEVENIR DJ - COMMENCEZ AVEC LES CONSEILS D’UN PRO","BEST VR EXPERIENCES INTO THE SHARK TANK":"LES MEILLEURES EXPÉRIENCES DE RV - DANS LA FOSSE AUX REQUINS","FROM HUMAN TO CYBORG":"DE L’HUMAIN AU CYBORG","FUTURISTIC TRANSPORT GETTING AROUND NEVER LOOKED SO COOL":"LES TRANSPORTS FUTURISTES N’ONT JAMAIS EU L’AIR AUSSI COOL","NASA’S NEXT DESTINATION IN 2026 TITAN":"LA PROCHAINE DESTINATION DE LA NASA EN 2026 : TITAN","VISIT A SPACE PLACE KOROLEV, RUSSIA'S DEEP SPACE HISTORY":"VISITEZ UN LIEU DE L’ESPACE - KOROLEV, L’HISTOIRE SPATIALE PROFONDE DE LA RUSSIE","VISIT A SPACE PLACE THE METEOR CRATER":"VISITER UN LIEU DE L’ESPACE - LE CRATÈRE DE MÉTÉORES","VISIT A SPACE PLACE THE NETHERLANDS' SPACE SIMULATOR":"VISITEZ UN LIEU DE L’ESPACE - LE SIMULATEUR SPATIAL DES PAYS-BAS","AMAZING TENNIS COURTS A COURT HIDDEN AMONG CLIFFS":"INCROYABLES COURTS DE TENNIS - UN COURT CACHÉ DANS LES FALAISES","BEST VR EXPERIENCES THE EXTREME SPORTS SIMULATOR":"LES MEILLEURES EXPÉRIENCES DE RV - LE SIMULATEUR DE SPORTS EXTRÊMES","DON’T EXPECT THE U.S. WOMEN’S FOOTBALL SQUAD AT THE WHITE HOUSE":"N’ESPÉRE PAS QUE L’ÉQUIPE FÉMININE DE FOOTBALL AMÉRICAIN SE RENDE À LA MAISON BLANCHE","FUTURE FEMALE FOOTBALLER COLOMBIA'S SALOME IS GONNA BE A PRO":"LA FUTURE FOOTBALLEUSE COLOMBIENNE SALOME VA PASSER PRO","MY UNDERGROUND SPORT ALAN NASTY NASH IS A CHAMP TOE WRESTLER":"SPORT CLANDESTIN - ALAN NASTY NASH EST UN CHAMPION DE LUTTE","MY UNDERGROUND SPORT KABADDI'S GROWING IN INDIA":"SPORT CLANDESTIN - LE KABADDI SE DÉVELOPPE EN INDE","SPORT FOR CHANGE A GOAL FOR INCLUSION":"LE CHANGEMENT PAR LE SPORT - UN OBJECTIF D’INCLUSION","SPORT FOR CHANGE THE INITIATIVE HITTING IT OUT OF THE PARK":"LE CHANGEMENT PAR LE SPORT - L’INITIATIVE QUI SORT DU LOT","THE 5 BEST SUMMER FOOTBALL TRANSFERS SO FAR!":"LES 5 MEILLEURS TRANSFERTS DE FOOTBALL D’ÉTÉ À CE JOUR !","COACHES CLINIC PETE HERRMAN":"LA CLINIQUE DES ENTRAÎNEURS - PETE HERRMAN","DRIBBLE DRIVE MOTION SKILLS":"COMPÉTENCES EN MOUVEMENT DE DRIBBLE","GAMCA COACHES CLINIC":"CLINIQUE DES ENTRAÎNEURS DE LA GAMCA","ROBERT TUTEIN (UTICA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"ROBERT TUTEIN (UTICA) - NOMINÉ JOUEUR GEICO DE L’ANNÉE 2016","RYAN KELLEY (ARCADIA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"RYAN KELLEY (ARCADIA) - NOMINÉ JOUEUR GEICO DE L’ANNÉE 2016","SAM BORST SMITH (ROCHESTER) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"SAM BORST SMITH (ROCHESTER) - NOMINÉ JOUEUR GEICO DE L’ANNÉE 2016","SPECIAL SPECTATORS VISITS THE COLLEGE SLAM DUNK & 3- POINT CHAMPIONSHIPS INTERSPORT":"DES SPECTATEURS SPÉCIAUX VISITENT LE COLLÈGE - CHAMPIONNAT INTERSPORT DE DUNK ET DE 3 POINTS","TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - NOMINÉ JOUEUR GEICO DE L’ANNÉE 2016","TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - NOMINÉ JOUEUR GEICO DE L’ANNÉE 2016","VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"VENKY JOIS (EASTERN WASHINGTON) - NOMINÉ JOUEUR GEICO DE L’ANNÉE 2016","LEARN FREESTYLE FOOTBALL TRICKS LEMMENS AROUND THE WORLD":"APPRENDRE DES FIGURES DE FOOTBALL FREESTYLE - LEMMENS AUTOUR DU MONDE","PRO FOOTBALLER TRAINING A NEED FOR SPEED":"ENTRAÎNEMENT DES FOOTBALLEURS PROFESSIONNELS - UN BESOIN DE RAPIDITÉ","PRO FOOTBALLER TRAINING LEG-FOCUSED EXERCISES":"UN FOOTBALLEUR PROFESSIONNEL S’ENTRAÎNE À FAIRE DES EXERCICES AXÉS SUR LES JAMBES","PRO FOOTBALLER TRAINING MUSCLES-FOCUSED EXERCISES":"UN FOOTBALLEUR PROFESSIONNEL S’ENTRAÎNE À DES EXERCICES AXÉS SUR LES MUSCLES","THERE’S NO POWER FROM KEEPING IT TO YOURSELF'":"IL N’Y A AUCUN POUVOIR À TOUT GARDER POUR SOI","3 THINGS MALALA HAS SAID THAT WILL TOTALLY INSPIRE YOU":"3 CHOSES QUE MALALA A DITES ET QUI VOUS INSPIRERONT TOTALEMENT","BORDER ANGELS SAVING LIVES WITH WATER":"LES ANGES DES FRONTIÈRES SAUVENT DES VIES GRÂCE À L’EAU","BULLIED TO INFLUENCER 'PAINTING HELPS ME DODGE MY PROBLEMS":"D’INTIMIDÉ À INFLUENCEUR - « LA PEINTURE M’AIDE À ÉCHAPPER À MES PROBLÈMES »","BULLIED TO INFLUENCER 'YOU CAN BE THE LIGHT IN THE DARKNESS":"D’INTIMIDÉ À INFLUENCEUR - « VOUS POUVEZ ÊTRE LA LUMIÈRE DANS L’OBSCURITÉ »","PEACE BUILDERS FIGHTING GANGS WITH CLOWNING":"LES ARTISANS DE LA PAIX - LUTTER CONTRE LES GANGS EN FAISANT LE CLOWN","PEACEBUILDERS INSIDE THE COMMUNITY RING":"LES ARTISANS DE LA PAIX - DANS LE CERCLE COMMUNAUTAIRE","SPORT FOR CHANGE A SURE SHOT TO FEMALE EMPOWERMENT IN ZIMBABWE":"LE CHANGEMENT PAR LE SPORT - UNE CHANCE POUR L’AUTONOMISATION DES FEMMES AU ZIMBABWE","YOUNG CEO MR. CORY’S COOKIES":"JEUNE PDG - LES COOKIES DE M. CORY","CRAZY CRAVINGS 'I'VE BEEN EATING CHALK FOR OVER TWENTY YEARS":"ENVIES FOLLES - « JE MANGE DE LA CRAIE DEPUIS PLUS DE VINGT ANS »","DARGAVS WELCOME TO THE CITY OF THE DEAD":"DARGAVS - BIENVENUE DANS LA VILLE DES MORTS","HEROES NEIGHBORHOOD TOUR FRIDA KAHLO":"VISITE DU QUARTIER DES HÉROS - FRIDA KAHLO","SOLO TRIP HIDDEN GEMS OF BALI":"VOYAGE EN SOLO - LES JOYAUX CACHÉS DE BALI","SOLO TRIP HIDDEN GEMS OF BOGOR (INDONESIA)":"VOYAGE EN SOLO - LES JOYAUX CACHÉS DE BOGOR (INDONÉSIE)","SOLO TRIP THE HIDDEN GEMS OF ROTTERDAM":"VOYAGE EN SOLO - LES JOYAUX CACHÉS DE ROTTERDAM","SUGARY DRINK LOVERS, THIS ONE'S FOR YOU!":"AMATEURS DE BOISSONS SUCRÉES, VOUS ALLEZ DORER CELLE-LÀ !","THE 5 MOST ICONIC ARMANI RED CARPET LOOKS OF ALL TIME":"LES 5 LOOKS TAPIS ROUGE ARMANI LES PLUS EMBLÉMATIQUES DE TOUS LES TEMPS","THE MOST AMAZING ISLAND CANARY ISLANDS":"LÎLE LA PLUS ÉTONNANTE - LES CANARIES","THE MOST AMAZING ISLAND FAVIGNANA SICILY":"L’ÎLE LA PLUS ÉTONNANTE - FAVIGNANA EN SICILE","THE MOST AMAZING ISLAND TEXEL":"L’ÎLE LA PLUS ÉTONNANTE - TEXEL","THESE NATIONS GIVE EXPATS THE BEST ONLINE LIFE":"CES NATIONS OFFRENT AUX EXPATRIÉS LA MEILLEURE VIE EN LIGNE","5 GAMES YOU WILL LOSE FRIENDS OVER":"5 JEUX QUI VOUS FERONT PERDRE DES AMIS","5 REASONS TO PLAY MONSTER HUNTER WORLD":"5 RAISONS DE JOUER À MONSTER HUNTER: WORLD","BEST VR EXPERIENCES THE SURVIVAL TEST":"LES MEILLEURES EXPÉRIENCES DE RV - LE TEST DE SURVIE","PLACE YOUR BETS! GTA IS GETTING A REAL VIRTUAL CASINO":"FAITES VOS JEUX ! UN VÉRITABLE CASINO VIRTUEL DANS GTA","TOP 5 GAMING LAWSUITS":"LES 5 PRINCIPAUX PROCÈS EN MATIÈRE DE JEUX","TOP 5 HIGHEST GROSSING ARCADE GAMES":"LES 5 JEUX D’ARCADE QUI RAPPORTENT LE PLUS","TOP 5 LEGENDARY GAME COUPLES":"TOP 5 DES COUPLES DE JOUEURS LÉGENDAIRES","BUILDERS OF TOMORROW SOLAR WATER HEATER FROM PLASTIC BOTTLES":"LES BÂTISSEURS DE DEMAIN - UN CHAUFFE-EAU SOLAIRE AVEC DES BOUTEILLES EN PLASTIQUE","GOT PLASTIC HERE ARE FOUR INNOVATIVE WAYS TO DEAL WITH IT!":"ON A DU PLASTIQUE - VOICI QUATRE FAÇONS INNOVANTES D’EN FAIRE QUELQUE CHOSE !","SAVING THE PLANET AND MAKING ART, ONE BUTT AT A TIME":"SAUVER LA PLANÈTE ET FAIRE DE L’ART, PETIT À PETIT","THE FASTEST WAY TO SAVE THE PLANET":"LE MOYEN LE PLUS RAPIDE DE SAUVER LA PLANÈTE","THE UNIQUE ARTIST TURNING TIRES IN MASTERPIECES":"L’ARTISTE UNIQUE QUI TRANSFORME LES PNEUS EN CHEFS-D’ŒUVRE","4 LESSONS TO LEARN FROM BUSINESS MOGUL ARIANNA HUFFINGTON":"4 LEÇONS À TIRER DE LA REINE DU BUSINESS ARIANNA HUFFINGTON","BUILDERS OF TOMORROW A FUTURE PAVED WITH PLASTIC":"LES BÂTISSEURS DE DEMAIN - UN AVENIR PAVÉ DE PLASTIQUE","JUST HOW VULNERABLE ARE JOBS TO ROBOT TAKEOVERS":"À QUEL POINT LES EMPLOIS SONT MENACÉS PAR LA ROBOTISATION","BEST RUGBY SKILLS - STEPS, TRICKS, OFFLOADS COMPILATION":"LES MEILLEURES TECHNIQUES DE RUGBY - COMPILATION D’AVANCÉES, DE TECHNIQUES ET D’OFFLOADS","BEST RUGBY SKILLS 2018":"LES MEILLEURES COMPÉTENCES EN RUGBY EN 2018","BEST RUGBY TRIES 2018":"LES PLUS BEAUX ESSAIS DE RUGBY EN 2018","CRAZIEST RUGBY SKILLS":"LES TRUCS LES PLUS FOUS EN RUGBY","EPIC RUGBY SKILLS 2017":"COMPÉTENCES ÉPIQUES EN RUGBY EN 2017","EPIC RUGBY STEPS 2018":"LES MOUVEMENTS ÉPIQUES EN RUGBY EN 2018","RUGBY BIG HITS 2018":"LES GRANDS SUCCÈS EN RUGBY EN 2018","DITCH THE DOCTOR! HOW ABOUT DIAGNOSIS BY COMPUTER":"PLUS BESOIN D’ALLER CHEZ LE MÉDECIN ! QUE DIRIEZ-VOUS D’UN DIAGNOSTIC PAR ORDINATEUR ?","ESPN'S NEW DEAL DIVES INTO THE WORLD OF DRONE RACING":"LE NOUVEAU PROGRAMME D’ESPN PLONGE DANS LE MONDE DES COURSES DE DRONES","EVER WISHED BEER COULD FLY NOW IT CAN!":"VOUS AVEZ DÉJÀ SOUHAITÉ QUE LA BIÈRE PUISSE VOLER ? MAINTENANT, ELLE LE PEUT !","HEARING THINGS HERE ARE 5 FACTS ON OUR INNER VOICE":"ENTENDRE LES CHOSES - VOICI 5 FAITS SUR NOTRE VOIX INTÉRIEURE","IS SPOTTY SKIN THE ANSWER TO LOOKING YOUNGER":"LA PEAU TACHETÉE EST-ELLE LA RÉPONSE À UNE APPARENCE PLUS JEUNE ?","JUST WHY ARE THE DUTCH SO TALL":"POURQUOI LES NÉERLANDAIS SONT-ILS SI GRANDS ?","MEET THE ROBOT THAT WANTS TO GET TO KNOW YOU":"VOICI UN ROBOT QUI VEUT FAIRE VOTRE CONNAISSANCE","STAR WARS BECOMES REALITY IN A POST-APOCALYPTIC MALL":"STAR WARS DEVIENT RÉALITÉ DANS UN CENTRE COMMERCIAL POST-APOCALYPTIQUE","SUGAR TAX THE ANSWER TO OBESITY PANDEMIC":"TAXE SUR LE SUCRE - LA RÉPONSE À LA PANDÉMIE D’OBÉSITÉ","SWALLOW THIS NANO CHIP TO KNOW WHAT S MAKING YOU SICK":"AVALEZ CETTE NANO-PUCE POUR SAVOIR CE QUI VOUS REND MALADE","THE EXPLODING COST OF CYBERATTACKS":"L’EXPLOSION DU COÛT DES CYBERATTAQUES","TURNS OUT EMAILS DIDN'T SOLVE OUR WASTE PAPER PROBLEMS":"IL S’AVÈRE QUE LES E-MAILS N’ONT PAS RÉSOLU NOTRE PROBLÈME DU GASPILLAGE DE PAPIER","UK DRONE SHOW THE LATEST CONSUMER INDUSTRY TRENDS":"AU ROYAUME-UNI, UN DRONE MONTRENT LES DERNIÈRES TENDANCES DE L’INDUSTRIE DE LA CONSOMMATION","VR RUNNING OF THE BULLS! A FEARFUL THRILLSEEKERS DREAM":"COURSE DE TAUREAUX EN RV ! UN RÊVE POUR LES AMATEURS DE SENSATIONS FORTES","AMAZING WATERFALLS ZAMBIA'S JAW-DROPPING NATURAL WONDER":"CHUTES D’EAU ÉTONNANTES - LE JOYAU NATUREL DE LA ZAMBIE","FAIRY TALE DREAM SPOTS THE PRETTIEST VILLAGE IN ANDALUCÍA":"LIEUX FÉÉRIQUES - LE PLUS JOLI VILLAGE D’ANDALOUSIE","FAIRY TALE DREAM SPOTS THE SINKING CASTLE OF SCALIGERA":"LIEUX FÉÉRIQUES - LE CHÂTEAU FLOTTANT DE SCALIGERA","MEDELLÍN IS THE BACKPACKING SPOT YOU'VE BEEN LOOKING FOR":"MEDELLÍN UN LIEU DE RÊVE POUR LA RANDONNÉE","SIGHTS WITH HEIGHTS THE NARROW BRIDGES OF CAMINITO DEL REY":"VUE D’EN HAUT - LES PONTS ÉTROITS DU CAMINITO DEL REY","THIS DUTCH PARADE TAKES FLOWER POWER TO THE NEXT LEVEL":"CETTE PARADE NÉERLANDAISE MONTRE À QUEL POINT LE POUVOIR DES FLEURS PEUT ÊTRE EXCEPTIONNEL","INSTA RESTAURANT WE COULD ALL USE A BIT MORE PINK IN OUR LIVES":"RESTAURANT INSTA - NOUS POURRIONS TOUS METTRE PLUS DE ROSE DANS NOTRE VIE","KFC IS TESTING MEATLESS CHICKEN WINGS AND NUGGETS":"KFC TESTE DES AILES ET DES NUGGETS DE POULET SANS VIANDE","TURNING LEFTOVER BREAD INTO PANZANELLA & BRUSCHETTA CAPRESE":"TRANSFORMER VOS RESTES DE PAIN EN PANZANELLA ET BRUSCHETTA CAPRESE","SALSAS FOR SUNNY DAYS SPICY MANGO SALSA":"SALSAS POUR LES JOURNÉES ENSOLEILLÉES - SALSA ÉPICÉE À LA MANGUE","VEGAN ICE CREAM AVOCADO BANANA":"CRÈME GLACÉE VÉGANE - AVOCAT BANANE","VEGAN ICE CREAM COCONUT FUSION":"CRÈME GLACÉE VÉGANE - FUSION DE NOIX DE COCO","VEGAN ICE CREAM FRESH FRUIT POPSICLES":"CRÈME GLACÉE VÉGANE - GLACES À L’EAU AUX FRUITS FRAIS","VEGAN ICE CREAM PINEAPPLE MINT LIME":"CRÈME GLACÉE VÉGANE - ANANAS MENTHE CITRON","VEGAN ICE CREAM BANANA MATCHA":"CRÈME GLACÉE VÉGANE - BANANE MATCHA","BRAIN IMPLANTS ARE CLOSER THAN YOU MIGHT THINK...":"LES IMPLANTS CÉRÉBRAUX NE RELÈVENT PLUS DE LA SCIENCE FICTION...","THANKS, CHAMELEONS HUMANS MIGHT GET COLOR-CHANGING SKIN":"GRÂCE AUX CAMÉLÉONS, LES HUMAINS POURRAIENT AVOIR LA PEAU QUI CHANGE DE COULEUR","ARM AND LEG RAISE":"LEVER LES BRAS ET LES JAMBES","CONDITION TRAINING":"L’ENTRAÎNEMENT DE CONDITIONNEMENT","CORE STRENGTH":"FORCE DE BASE","LUNGES":"FENTES","PUNCH BAG":"SAC DE FRAPPE","SHADOW BOXING":"SHADOW-BOXING","STRETCHING":"ÉTIREMENTS","2016 CHEVROLET CAMARO SS":"CHEVROLET CAMARO SS 2016","2016 FORD MUSTANG FASTBACK":"FORD MUSTANG FASTBACK 2016","2016 FORD MUSTANG GT4":"FORD MUSTANG GT4 2016","2016 TOYOTA PRIUS G RACING CAR":"VOITURE DE COURSE TOYOTA PRIUS G 2016","2016 TOYOTA XTREME COROLLA":"TOYOTA XTREME COROLLA 2016","ARABIC EPS 1 - HOW TO INTRODUCE YOURSELF":"ARABE EPS 1 - COMMENT SE PRÉSENTER","ARABIC EPS 2 - THANK YO":"ARABE EPS 2 - MERCI","ENGLISH EPS 3 - ASKING ABOUT HOBBIES":"ANGLAIS EPS 3 - SE RENSEIGNER SUR LES LOISIRS","ENGLISH EPS 4 - WHERE ARE YOU FROM":"ANGLAIS EPS 4 - D’OÙ VENEZ-VOUS ?","FRENCH EPS 5 - HOW TO APOLOGIZE":"FRANÇAIS EPS 5 - COMMENT S’EXCUSER","FRENCH EPS 6 - ASKING DO YOU SPEAK ENGLISH":"FRANÇAIS EPS 6 - DEMANDER « PARLEZ-VOUS ANGLAIS ? »","ITALIAN EPS 7- APOLOGIES":"ITALIEN EPS 7 - S’EXCUSER","ITALIAN EPS 8 - HOW MUCH":"ITALIEN EPS 8 - COMBIEN ?","SPANISH EPS 9 - WHERE ARE YOU FROM":"ESPAGNOL EPS 9 - D’OÙ VENEZ-VOUS ?","SPANISH EPS 10 - WHAT'S UP":"ESPAGNOL EPS 10 - QUOI DE NEUF ?","HOW TO POST NATAL YOGA BREATHING EXERCISE":"COMMENT FAIRE DES EXERCICES DE RESPIRATION DE YOGA POSTNATAL","HOW TO IN 60 SECONDS":"COMMENT FAIRE EN 60 SECONDES","HOW TO POST NATAL YOGA - DANDASANA":"COMMENT FAIRE DU YOGA POSTNATAL - DANDASANA","HOW TO POST NATAL YOGA - IF BABY NEEDS ENTERTAINMENT":"COMMENT FAIRE DU YOGA POSTNATAL - SI BÉBÉ A BESOIN DE DIVERTISSEMENT","PILATES HALF ROLL BACK":"PILATES - LE CULBUTO","BECOME FLEXIBLE WITH YOGA":"DEVENIR FLEXIBLE GRÂCE AU YOGA","FIND PEACE AT HOME WITH YOGA":"TROUVER LA PAIX À LA MAISON GRÂCE AU YOGA","FIND PEACE WITH YOGA":"TROUVER LA PAIX GRÂCE AU YOGA","GET SLIM & FIT WITH YOGA":"MAIGRIR ET RETROUVER LA FORME GRÂCE AU YOGA","LEARN THE ART OF YOGA":"APPRENDRE L’ART DU YOGA","LOST WEIGHT WITH YOGA":"PERDRE DU POIDS GRÂCE AU YOGA","MASTER CORE YOGA POSES":"MAÎTRISER LES POSTURES DE YOGA DE BASE","MIND OVER MATTER":"L’ESPRIT PREND L’AVANTAGE SUR LA MATIÈRE","ULTIMATE YOGA GUIDE":"LE GUIDE ULTIME DU YOGA","YOGA VILLAGE":"VILLAGE YOGA","YOGA YOUR WAY TO HEALTHY LIVING":"LE YOGA, UN MOYEN DE VIVRE SAINEMENT","ANIMALS EXOTICOS":"ANIMAUX EXOTIQUES","AUTOMATU":"AUTOMATU","BABIES AND MOVING TABLE PART 1":"BÉBÉS ET TABLE ROULANTE - PARTIE 1","BAD KIDS THROW ORANGE PEELS PART 1":"LES MAUVAIS ENFANTS LANCENT DES PELURES D’ORANGE - PARTIE 1","BIG BUNNY SCARES BABIES PART 1":"LE GRAND LAPIN FAIT PEUR AUX BÉBÉS - PARTIE 1","BODYGUARDS":"GARDES DU CORPS","CAKE ON FACE":"GATEAU SUR LE VISAGE","CAN I CLICK YOUR PHOTO":"PUIS-JE CLIQUER SUR VOTRE PHOTO ?","CAR PARKING":"STATIONNEMENT DES VOITURES","CAR FOR SALE":"VOITURE À VENDRE","MAN FALLING ON LADDER":"HOMME TOMBANT SUR UNE ÉCHELLE","MAN IN GARBAGE CAN PART 1":"L’HOMME DANS LA POUBELLE - PARTIE 1","PAINTING EXHIBITION":"EXPOSITION DE PEINTURE","RECKLESS BLIND MAN PART 1":"UN AVEUGLE TÉMÉRAIRE - PARTIE 1","ROLLER BLADER PART 1":"ROLLER - PARTIE 1","RUDE MAN ON BEACH PART 1":"L’HOMME IMPOLI SUR LA PLAGE - PARTIE 1","SANTA CLAUS THE PERVERT PART 1":"LE PÈRE NOËL PERVERT - PARTIE 1","BABY CARIER ON CAR":"SIÈGE BÉBÉ SUR UNE VOITURE","BLEEDING NOSE":"SAIGNEMENT DE NEZ","MONEY FALLING":"CHUTE D’ARGENT","OPEN THIS PEN":"OUVREZ CE STYLO","GLAMOROUS TOUCH":"UNE TOUCHE DE GLAMOUR","LIPS GLAMOROUS RED":"LÈVRES ROUGE GLAMOUR","LIPS NATURAL":"LÈVRES NATURELLES","LIPS SPARKLING AND FULL":"LÈVRES PÉTILLANTES ET PLEINES","MAKE-UP BLUSH":"BLUSH DE MAQUILLAGE","MAKE-UP BRONZER":"BRONZANT DE MAQUILLAGE","MAKE-UP CONCEALER":"CORRECTEUR DE MAQUILLAGE","MAKE-UP EYEBROWS":"MAQUILLAGE DES SOURCILS","MAKE-UP FOUNDATION":"FOND DE TEINT","SMOKEY EYES":"DES YEUX CHARBONNEUX","SPARKLING EYES":"DES YEUX QUI BRILLENT","5 MAKE UP TIPS AND TRICKS FOR YOU":"5 CONSEILS ET ASTUCES DE MAQUILLAGE","7 MAKE UP TIPS AND TRICKS FOR FLAWLESS SKIN":"7 CONSEILS ET ASTUCES DE MAQUILLAGE POUR UNE PEAU SANS DÉFAUT","10 FAST AND EASY MAKE UP TIPS":"10 CONSEILS DE MAQUILLAGE SIMPLES ET RAPIDES","10 MAKE UP TIPS AND TRICKS FOR OILY SKIN":"10 CONSEILS ET ASTUCES DE MAQUILLAGE POUR LES PEAUX GRASSES","13 MAKE UP MISTAKES TO AVOID":"13 ERREURS DE MAQUILLAGE À ÉVITER","101 TIPS FOR BEGINNER MAKE UP":"101 CONSEILS DE MAQUILLAGE POUR DÉBUTANTE","ASIAN BEAUTY TIPS YOU MUST DO NOW":"CONSEILS BEAUTÉ ASIATIQUES À SUIVRE DÈS MAINTENANT","BEGINNER EVERY MAKE UP TIPS AND TRICKS FOR YOU":"TOUS LES CONSEILS ET ASTUCES DE MAQUILLAGE POUR DÉBUTANTE","BEST MAKE UP ARTIST TIPS YOU NEED TO KNOW":"LES MEILLEURS CONSEILS D’ARTISTES MAQUILLEURS QUE VOUS DEVEZ CONNAÎTRE","ESSENTIAL MAKE UP TIPS FOR SUMMER GLOW":"CONSEILS ESSENTIELS DE MAQUILLAGE POUR UN VISAGE ÉCLATANT EN ÉTÉ","FLATTERING EYES MAKE UP FOR YOU":"MAQUILLAGE POUR DES YEUX MAGNIFIQUES","FOUNDATION TRICKS FOR OILY SKIN":"ASTUCES DE FOND DE TEINT POUR LES PEAUX GRASSES","FULL COVERAGE FOUNDATION ROUTINE FOR YOU":"ROUTINE DE COUVERTURE TOTALE AVEC DU FOND DE TEINT","LOOK FIERCE WITH DRUGSTORE MAKE UP":"UN LOOK FÉROCE AVEC DU MAQUILLAGE DE SUPERMARCHÉ","MAKE UP ESSENTIALS FOR DARK SKIN TONES":"LES ESSENTIELS DU MAQUILLAGE POUR LES PEAUX FONCÉES","MAKE UP TIPS FOR AGING EYES":"CONSEILS DE MAQUILLAGE POUR LES YEUX VIEILLISSANTS","MAKE UP TIPS FOR FLAWLESS SKIN":"CONSEILS DE MAQUILLAGE POUR UNE PEAU SANS DÉFAUT","MUST KNOW MAKE UP TIPS":"CONSEILS DE MAQUILLAGE INDISPENSABLES","MUST KNOW WAKE UP TIPS":"CONSEILS INDISPENSABLES POUR BIEN SE RÉVEILLER","NATURAL MAKE UP KOREAN STYLE":"MAQUILLAGE NATUREL DE STYLE CORÉEN","NATURAL MAKE UP TIPS FOR MEN":"CONSEILS DE MAQUILLAGE NATUREL POUR LES HOMMES","NATURAL TO GLAMOROUS":"DU NATUREL AU GLAMOUR","OVER 40 AGED WOMAN MAKE UP TIPS":"CONSEILS DE MAQUILLAGE POUR LES FEMMES DE PLUS DE 40 ANS","PRO MAKE UP TIPS BY TATI":"CONSEILS DE MAQUILLAGE PRO PAR TATI","SECRET MAKE UP TIPS AND TRICKS FOR BEGINNERS":"TRUCS ET ASTUCES SECRETS DE MAQUILLAGE POUR LES DÉBUTANTES","SIMPLE TIPS FOR EYESHADOW":"CONSEILS SIMPLES SUR LE FARD À PAUPIÈRES","SUMMER MAKE UP MELTPROOF TIPS":"CONSEILS POUR UN MAQUILLAGE INTACT EN ÉTÉ","TOP 10 SECRET TIPS OF CELEBRITIES":"TOP 10 DES CONSEILS SECRETS DES CÉLÉBRITÉS","TOP 25 MAKE UP TIPS FOR PALE SKIN":"TOP 25 DES CONSEILS DE MAQUILLAGE POUR UNE PEAU PÂLE","TYRA BANKS MAKE UP TIPS":"CONSEILS MAQUILLAGE DE TYRA BANKS"}

/***/ }),

/***/ "./src/translations/it.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Gioca a Way Beyond","sidebar.home":"Pagina principale","sidebar.myaccount":"Il mio account","sidebar.notif":"Notifica","sidebar.nonotif":"Non hai ancora notifiche","html5games":"Giochi HTML5","androidGames":"Giochi Android","favorite":"Preferiti","welcome.text":"ESPLORA I MIGLIORI GIOCHI PER DISPOSITIVI MOBILI ONLINE OGGI!","welcome.text.gamiclub":"ESPLORA I MIGLIORI GIOCHI PER DISPOSITIVI MOBILI ONLINE OGGI!","footer.copyright":"&copy; 2020 Gamelords. Tutti i diritti riservati","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Tutti i diritti riservati","footer.copyright.appspool":"&copy; 2020 Appspool. Tutti i diritti riservati","accountDetails":"DETTAGLI ACCOUNT","accountName":"NOME","accountEmail":"INDIRIZZO EMAIL","accountLocation":"POSIZIONE","accountInterests":"INTERESSI","accountChooseCategory":"Scegli il tuo genere","accountEditPhoto":"MODIFICA FOTO","save":"Salva","averageRatingBasedOn":" valutazione media degli utenti basata su recensioni ","topCategories":"LE MIGLIORI CATEGORIE","favGames":"GIOCHI PREFERITI","viewAll":"VEDI TUTTO","noGameFound":"Nessun gioco trovato.","cancel":"Annulla","gameDirectories":"DIRECTORIES DI GIOCO","category":"Categoria","noGamesFound":"Nessun gioco trovato.","platform":"Piattaforma","type":"Digita","android-upper":"ANDROID","games":"Giochi","html5":"HTML5","description":"Descrizione","downloadNow":"SCARICA ORA","playNow":"GIOCA ORA","rate":"Voto","relatedGames":"GIOCHI SIMILI","noFavGames":"Ancora nessun gioco preferito","addFavGames":"Aggiungi i tuoi giochi preferiti per accedervi e giocare facilmente","discover":"SCOPRI","noFavGamesFound":"Nessun gioco preferito trovato.","favorites":"Preferiti","accessDenied":"Accesso negato","pageRestricted":"La pagina che stai cercando è soggetta a restrizione.","privacyPolicy":"INFORMATIVA SULLA PRIVACY","tnc":"Termini e Condizioni","kazakhOnly":"","areYouAlready":"Sei già membro di ","thenConfirm":"Quindi conferma il tuo numero di cellulare e ottieni l'accesso illimitato a tutti i nostri giochi HTML5 e Android.","login":"Accedi","contact_us":"Contattaci","search.input.placeholder":"Ricerca","search.cancel.button":"Annulla","Sports":"Sport","Action":"Azione","Adventure":"Avventura","Fitness":"Fitness","Entertainment":"Intrattenimento","Premium Games":"Giochi premium","RPG":"RPG","Virtual Reality":"Realtà virtuale","Arcade":"Arcade","Racing":"Corsa","New Arrivals":"Nuovi arrivi","Utilities":"Utilità popolari","unsubscribe":"ANNULLA L'ISCRIZIONE","sidebar.lang":"Le lingue","sidebar.lang.fr":"Francese","sidebar.lang.de":"Tedesco","sidebar.lang.en":"Inglese","sidebar.lang.it":"Italiana","privacy-policy-title":"INFORMATIVA SULLA PRIVACY","privacy-policy-desc":"La presente Informativa sulla privacy chiarisce gli impegni della società e i diritti dell'utente in merito alle informazioni personali. Vi consigliamo di leggere attentamente l'Informativa sulla privacy. Nel caso in cui non foste d’accordo con la presente Informativa sulla privacy, vi preghiamo di non utilizzare i nostri Siti o Servizi. L'Informativa sulla privacy è incorporata in maniera appropriata nei ed è soggetta ai Termini di servizio, e regola i Servizi e i Siti citati dagli stessi Termini di servizio. Per tutti i termini che saranno utilizzati all’interno dell’Informativa sulla privacy, che non saranno definiti in maniera specifica, varrà l’accezione specificata all’interno dei Termini di servizio.","privacy-policy-collect-info-head":"RACCOGLIAMO LE INFORMAZIONI COME SEGUE:","privacy-policy-collect-info-desc1":"1. Quando ce le fornite o ci date il permesso di ottenerle nel momento in cui sottoscrivete uno dei nostri servizi, noi o il vostro operatore telefonico raccoglieremo le vostre informazioni relative al pagamento per la sottoscrizione ai nostri servizi. Le informazioni su account e fatturazione raccolte dal vostro operatore saranno soggette alle sue regole sulla privacy.","privacy-policy-collect-info-desc2":"2. Riceviamo informazioni tecniche ogni volta che visitate i nostri siti e/o servizi. Potremmo raccogliere informazioni tecniche su di voi ogni volta che utilizzate i nostri servizi. Il nostro servizio raccoglie i dati di accesso ogni volta che si effettua il login o il logout per i nostri servizi.","privacy-policy-how-collect-info-head":"COME UTILIZZIAMO LE INFORMAZIONI RACCOLTE","privacy-policy-how-collect-info-subhead":"Potremmo utilizzare le vostre informazioni per i seguenti scopi:","privacy-policy-how-collect-info-desc1":"offrire i Servizi richiesti, emettere fattura e riscuotere ","privacy-policy-how-collect-info-desc2":"il pagamento per il/i Servizio/i fornito/i all'utente.","privacy-policy-how-long-head":"PER QUANTO TEMPO CONSERVIAMO LE INFORMAZIONI","privacy-policy-how-long-desc":"Conserveremo le vostre informazioni per tutto il tempo necessario a fornirvi i nostri servizi. Conserveremo le vostre informazioni secondo necessità per adempiere ai nostri obblighi legali, risolvere le controversie e far rispettare i nostri accordi. Nel momento in cui non dovessimo più utilizzare le vostre informazioni e non sia necessario conservarle per adempiere ai nostri obblighi legali o regolamentari, le rimuoveremo dai nostri sistemi o le spersonalizzeremo, impedendo così che possano essere utilizzate per identificarvi.","privacy-policy-how-long-protect-head":"COME PROTEGGIAMNO LE INFORAMZIONI, ANCHE AL DI FUORI DELL’UE","privacy-policy-how-long-protect-desc1":"Ci preoccupiamo di proteggere la vostra privacy e i vostri dati, ma non possiamo assicurare o garantire la sicurezza delle informazioni che ci trasmettete, né garantire che le vostre informazioni non possano essere accessibili, divulgate, alterate o distrutte da una violazione di qualsiasi delle nostre misure di sicurezza fisiche, tecniche o gestionali, che sono conformi agli standard del settore.","privacy-policy-how-long-protect-desc2":"Adottiamo adeguate pratiche di raccolta, memorizzazione ed elaborazione dei dati, nonché misure di sicurezza volte a proteggere da accessi non autorizzati o accidentali, alterazioni, divulgazione o distruzione delle vostre informazioni, delle informazioni sulle vostre operazioni e dei dati memorizzati nei nostri Servizi. Tuttavia, nessun metodo di trasmissione via Internet o di archiviazione elettronica è sicuro al 100%. Pertanto, non possiamo garantire la loro assoluta sicurezza.","privacy-policy-how-long-protect-desc3":"Potenzieremo ulteriormente le nostre procedure di sicurezza con la disponibilità di nuove tecnologie. Dal momento che operiamo a livello internazionale, le vostre informazioni, comprese le informazioni personali, possono essere trasferite e rese disponibili negli USA/Singapore e/o in qualsiasi altro paese diverso dal vostro paese di residenza. Anche in questi paesi, ci prendiamo cura di proteggere le vostre informazioni personali.","privacy-policy-acceptance-head":"ACCETTAZIONE DELL'INFORMATIVA SULLA PRIVACY","privacy-policy-acceptance-desc":"Utilizzando uno qualsiasi dei nostri Servizi, accettate la raccolta e l'utilizzo delle vostre informazioni in conformità con la presente Informativa sulla privacy. Ci riserviamo il diritto di modificare questa Informativa sulla privacy in qualsiasi momento, riportandone le modifiche su questa pagina. Verificate la data di revisione in fondo a questa pagina per stabilire se l'Informativa è stata modificata dall'ultima volta che l'avete esaminata. L'uso continuato di qualsiasi parte del nostro Sito o dei nostri Servizi a seguito della pubblicazione dell'Informativa sulla privacy aggiornata equivarrà all'accettazione delle modifiche.","privacy-policy-changes-head":"MODIFICHE A QUESTA INFORMATIVA SULLA PRIVACY","privacy-policy-changes-desc":"Di tanto in tanto, potremmo apportare modifiche alla nostra Informativa sulla privacy. Nel caso in cui dovessimo decidere di modificare la nostra Informativa sulla privacy, pubblicheremo tali modifiche su questa pagina, in modo che possiate sempre consultare la versione più recente dell'Informativa sulla privacy.","privacy-policy-contact-us":"COME CONTATTARCI","privacy-policy-contact-us-desc":"Se avete domande sulla presente Informativa sulla privacy, sulle prassi dei Siti o sui vostri rapporti con i Siti, contattateci inviando una e-mail a support@content-clubs.com.","infoPrivacy":"Info Privacy","compatibilityTerms":"Terminali Compatibili","serviceMgmt":"Gestione servizio"}

/***/ }),

/***/ "./src/translations/kk.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Играй за гранью","sidebar.home":"Начальная страница","sidebar.myaccount":"Личный кабинет","sidebar.notif":"Уведомление","sidebar.nonotif":"У вас нет уведомлений пока что","html5games":"HTML5 игры","androidGames":"Андроид игры","favorite":"Фавориты","welcome.text":"Лучшие мобильные игры онлайн за сегодня!","footer.copyright":"&copy; 2020 Gamelords. Все права защищены","accountDetails":"Информация об аккаунте","accountName":"Имя","accountEmail":"Email адрес","accountLocation":"Местоположение","accountInterests":"Интересы","accountChooseCategory":"Выберите 3 категории","accountEditPhoto":"Редактировать фото","save":"Сохранить","topCategories":"ТОП категории","favGames":"Любимые игры","viewAll":"Посмотреть все","noGameFound":"Игры не найдены","cancel":"Закрыть","gameDirectories":"Каталоги игр","category":"Категории","noGamesFound":"Не найдено игр для этой категории","platform":"Платформа","type":"Тип","android-upper":"Андроид","games":"Игры","html5":"HTML5","description":"Описание","downloadNow":"Скачать сейчас","playNow":"Играть сейчас","rate":"Оценить","relatedGames":"Похожие игры","noFavGames":"Нет любимых игр","addFavGames":"Добавляйте свои любимые игры для доступа и играйте без каких-либо проблем","discover":"Узнать больше","noFavGamesFound":"Не найдено","favorites":"Фавориты","accessDenied":"Доступ запрещен","pageRestricted":"Страница, которую вы ищете ограничена для просмотра","privacyPolicy":"","tnc":"","kazakhOnly":"Воспользоваться сервисом Game Lords на указанных ниже условиях могут любые физические лица, достигшие 16 лет и являющиеся абонентами оператора сотовой связи АО 'Кселл', с ТМ Kcell и Activ. Стоимость для абонентов Kcell, Activ - 50 тенге/день. Отказаться от услуги Вы можете: Отправка SMS с текстом СТОП GLS на 2083 (SMS бесплатно). Контакты службы поддержки: support@bam-boo.eu","areYouAlready":"Вы уже являетесь участником сервиса ","thenConfirm":"В таком случае, пожалуйста, введите ниже Ваш номер телефона и получите неограниченный доступ ко всем нашим играм на <strong>HTML5</strong> и <strong>Android</strong>","login":"авторизоваться","search.input.placeholder":"Поиск...","search.cancel.button":"Закрыть","Sports":"Спорт","Action":"Экшн","Adventure":"Приключения","Fitness":"Фитнес","Entertainment":"Развлечения","Premium Games":"Премиум игры","RPG":"RPG","Virtual Reality":"Виртуальная реальность","Arcade":"Аркады","Racing":"Гонки"}

/***/ }),

/***/ "./src/translations/lt.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Pradžia","sidebar.myaccount":"Mano Paskyra","sidebar.notif":"Pranešimas","sidebar.nonotif":"Jūs dar neturite pranešimų","html5games":"HTML5 Žaidimai","androidGames":"Android Žaidimai","android-upper":"ANDROID","favorite":"Mėgstamiausi","splashscreen.text":"Žaisk Daugiau","welcome.text":"NARŠYKITE GERIAUSIUS INTERNETINIUS MOBILIUOSIUS ŽAIDIMUS ŠIANDIEN!","welcome.text.gamiclub":"NARŠYKITE GERIAUSIĄ INTERNETINĮ TURINĮ ŠIANDIEN!","accountDetails":"PASKYROS DUOMENYS","accountName":"VARDAS","accountEmail":"EL. PAŠTO ADRESAS","withdraw_from_contract":"Atsisakyti sutarties","accountLocation":"VIETA","accountInterests":"POMĖGIAI","accountChooseCategory":"Pasirinkite 3 kategorijas","accountEditPhoto":"KEISTI NUOTRAUKĄ","save":"Išsaugoti","topCategories":"TOP KATEGORIJOS","favGames":"MĖGSTAMIAUSI ŽAIDIMAI","viewAll":"PERŽIŪRĖTI VISUS","noGamesFound":"Pagal šią kategoriją žaidimų nerasta","noVideosFound":"Pagal šią kategoriją vaizdo įrašų nerasta","cancel":"Atšaukti","gameDirectories":"ŽAIDIMŲ KATALOGAI","category":"Kategorija","platform":"Platforma","type":"Tipas","android":"ANDROID","games":"žaidimai","html5":"HTML5","videos":"VAIZDO","search.input.placeholder":"Ieškoti...","search.cancel.button":"Atšaukti","description":"Aprašymas","downloadNow":"ŽAISTI DABAR","playNow":"ŽAISTI DABAR","rate":"Įvertinti","relatedGames":"SUSIJĘ ŽAIDIMAI","noFavGames":"Nėra mėgstamų žaidimų","addFavGames":"Pridėkite savo mėgstamus žaidimus, kad galėtumėte lengvai juos pasiekti ir žaisti be rūpesčių","discover":"ATRASKITE","noFavGamesFound":"Nėra mėgstamų žaidimų","favorites":"Mėgstamiausi","accessDenied":"Prieiga Neleistina","pageRestricted":"Puslapis, kurio ieškote, yra apribotas.","averageRatingBasedOn":" vidutinė vartotojų įvertinimas pagal ","averageRatingReview":" įvertinimus","tnc":"SĄLYGOS IR TAISYKLĖS","contact_us":"Susisiekite su mumis","areYouAlready":"Ar jau esate narys ","thenConfirm":"Tada patvirtinkite savo mobiliojo telefono numerį ir gaukite neribotą prieigą prie visų mūsų HTML5 ir Android žaidimų","thenConfirmAlt":"Tada patvirtinkite savo mobiliojo telefono numerį ir gaukite neribotą prieigą prie viso mūsų turinio","login":"Prisijungti","Action":"Veiksmas","Adventure":"Nuotykiai","Arcade":"Arkada","Sport":"Sportas","Racing":"Lenktynės","Premium Games":"Premium Žaidimai","RPG":"RPG","Virtual Reality":"Virtuali Realybė","Motivation":"Motyvacija","Tour":"Turai","Fun Gaming":"Linksmi Žaidimai","Athletics":"Atletika","Inspiration":"Įkvėpimas","Into Nature":"Gamtoje","Political & Activism":"Politika ir Aktyvizmas","Travel":"Kelionės","Foodbuzz":"Maisto Buzz","Health and Nutrition":"Sveikata ir Mityba","Fitness":"Fitnesas","Top Cars":"Geriausi Automobiliai","Fashion & Beauty":"Mada ir Grožis","E-Learning":"Elektroninis Mokymasis","Yoga":"Joga","Just For Laugh":"Tik Juokams","Brain Boost":"Smegenų Pagalba","Rugby":"Regbis","Economy":"Ekonomika","Environment":"Aplinka","Gaming":"Žaidimai","Lifestyle":"Gyvenimo Būdas","Local Heroes":"Vietos Heros","Sports":"Sportas","Technology":"Technologijos","Tutorials":"Pamokos","Utilities":"Įrankiai","New Arrivals":"Nauji Atvykėliai","noFavVideos":"Nėra mėgstamų vaizdo įrašų","addFavVideos":"Pridėkite savo mėgstamus vaizdo įrašus, kad galėtumėte lengvai juos pasiekti ir žiūrėti be rūpesčių","noFavVideosFound":"Nėra mėgstamų vaizdo įrašų","footer.copyright":"&copy; 2020 Gamelords. Visos teisės saugomos","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Visos teisės saugomos","footer.copyright.gameverse-lt":"&copy; 2026 Gameverse. Visos teisės saugomos","vid-player":"Grotuvas","privacyPolicy":"PRIVATUMO POLITIKA","privacy-policy-title":"PRIVATUMO POLITIKA","privacy-policy-desc":"Ši Privatumo Politika paaiškina mūsų įsipareigojimus ir jūsų teises, susijusias su jūsų informacija. Jūs turite atidžiai perskaityti Privatumo Politiką. Jei nesutinkate su šia Privatumo Politika, prašome nenaudoti mūsų Svetainių ar Paslaugų. Privatumo Politika yra tinkamai integruota ir taikoma toms pačioms Paslaugoms ir Svetainėms, kaip nurodyta Naudojimo Sąlygose. Bet kokie terminai, kuriuos naudojame Privatumo Politikoje be apibrėžimų, turi tą pačią reikšmę, kaip ir Naudojimo Sąlygose.","privacy-policy-collect-info-head":"RENKAME INFORMACIJĄ ŠIAIS BŪDAIS:","privacy-policy-collect-info-desc1":"Kai jūs mums ją suteikiate arba suteikiate leidimą ją gauti. Jei nuspręsite užsisakyti paslaugą iš mūsų, mes arba jūsų mobiliojo tinklo operatorius surinksime jūsų mokėjimo už mūsų paslaugas duomenis. Mobiliojo tinklo operatoriaus surinkti paskyros ir sąskaitų duomenys yra taikomi jų privatumo politikoms.","privacy-policy-collect-info-desc2":"Gavome techninę informaciją, kai lankotės mūsų Svetainėse ir/ar Paslaugose. Mes galime rinkti techninę informaciją apie jus kiekvieną kartą, kai naudojatės mūsų Paslaugomis. Mes renkame prisijungimo duomenis kiekvieną kartą, kai prisijungiate arba atsijungiate nuo mūsų Paslaugų.","privacy-policy-how-collect-info-head":"KAIP NAUDOJAME SURINKTĄ INFORMACIJĄ","privacy-policy-how-collect-info-subhead":"Mes galime naudoti jūsų informaciją šiems tikslams:","privacy-policy-how-collect-info-desc1":" · Teikti užsakytas paslaugas;","privacy-policy-how-collect-info-desc2":" · Apmokestinti ir rinkti mokestį už jums suteiktas paslaugas;","privacy-policy-how-long-head":"KIEK LAIKO LAIKOME JŪSŲ INFORMACIJĄ","privacy-policy-how-long-desc":"Mes laikysime jūsų informaciją tiek laiko, kiek reikia teikti mūsų paslaugas jums. Mes laikysime jūsų informaciją tiek, kiek reikia mūsų teisinių įsipareigojimų vykdymui, ginčų sprendimui ir mūsų susitarimų vykdymui. Kai nebereikės naudoti jūsų informacijos ir nebus daugiau reikalinga ją laikyti siekiant vykdyti mūsų teisines ar reguliavimo pareigas, mes pašalinsime ją iš savo sistemų arba despersonalizuosime ją taip, kad nebūtų galima jūsų identifikuoti.","privacy-policy-how-long-protect-head":"KAIP APSAUGOME JŪSŲ INFORMACIJĄ, TAIP PAT UŽ ES RIBŲ","privacy-policy-how-long-protect-desc1":"Mes rūpinamės jūsų privatumu ir duomenimis, tačiau negalime užtikrinti ar garantuoti bet kokios informacijos, kurią mums siunčiate, saugumo arba garantuoti, kad jūsų informacija negalės būti prieinama, atskleista, pakeista ar sunaikinta pažeidus bet kurias mūsų fizines, technines ar valdymo pramonės standartų apsaugos priemones. Mes naudojame tinkamas duomenų rinkimo, saugojimo ir tvarkymo praktikas bei saugumo priemones, kad apsaugotume nuo neteisėtos ar atsitiktinės prieigos, pakeitimo, atskleidimo ar sunaikinimo jūsų informacijos, sandorių informacijos ir duomenų, saugomų mūsų Paslaugose.","privacy-policy-how-long-protect-desc2":"Tačiau joks interneto perdavimo būdas arba elektroninio saugojimo metodas nėra 100% saugus. Todėl negalime garantuoti absoliutaus saugumo. Mes toliau tobulinsime savo saugumo procedūras, kai tik bus prieinamos naujos technologijos.","privacy-policy-how-long-protect-desc3":"Kadangi mes veikiame tarptautiniu mastu, jūsų informacija, įskaitant asmeninę informaciją, gali būti perduodama ir prieinama JAV/Singapūre ir/ar bet kurioje kitoje šalyje, kuri nėra jūsų gyvenamoji šalis. Taip pat šiose šalyse mes imamės visų pagrįstų priemonių jūsų asmeninės informacijos apsaugai.","privacy-policy-acceptance-head":"PRIVATUMO POLITIKOS PRIĖMIMAS","privacy-policy-acceptance-desc":"Naudodamiesi bet kuria iš mūsų Paslaugų, jūs sutinkate su mūsų informacijos rinkimu ir naudojimu pagal šią Privatumo Politiką. Mes pasiliekame teisę bet kuriuo metu keisti šią Privatumo Politiką, paskelbdami pakeitimus šiame puslapyje. Patikrinkite šio puslapio peržiūros datą, kad nustatytumėte, ar politika buvo pakeista nuo paskutinio karto, kai ją peržiūrėjote. Toliau naudodamiesi bet kuria mūsų Svetainės ar Paslaugų dalimi po atnaujintos Privatumo Politikos paskelbimo, jūs priimate pakeitimus.","privacy-policy-changes-head":"ŠIOS PRIVATUMO POLITIKOS PAKEITIMAI","privacy-policy-changes-desc":"Mes galime keisti savo Privatumo Politiką laikas nuo laiko. Jei nuspręsime keisti savo Privatumo Politiką, paskelbsime tuos pakeitimus šiame puslapyje, kad visada galėtumėte prieiti prie naujausios Privatumo Politikos.","privacy-policy-contact-us":"KONTAKTAI","privacy-policy-contact-us-desc":"Jei turite kokių nors klausimų apie šią Privatumo Politiką, Svetainių praktikas arba savo santykius su Svetainėmis, prašome susisiekti su mumis el. paštu support@content-clubs.com.","privacy-policy-contact-us-desc-the-gamingclubs":"Jei turite kokių nors klausimų apie šią Privatumo Politiką, Svetainių praktikas arba savo santykius su Svetainėmis, prašome susisiekti su mumis el. paštu lt-thegamingclubs@cchelp.co","unsubscribe":"ATŠAUKTI PRENUMERATĄ","terms-condition-title":"Sąlygos ir nuostatos","gen-terms-condition-title":"Bendrosios sąlygos ir privatumo politika","gen-terms-condition-desc":"Šios Bendrosios sąlygos taikomos produktams ir paslaugoms, teikiamoms per WAP, SMS, GPRS ir 3G Sam Media Ltd., arba su juo susijusių įmonių (toliau – „Tiekėjas“). Tiekėjas turi teisę laikas nuo laiko keisti šias Bendrąsias sąlygas be išankstinio įspėjimo. Be Bendrųjų sąlygų, bet kokios galiojančios ir viešai paskelbtos taisyklės, reklamos sąlygos, gairės ir nuostatos, susijusios su paslaugomis, taip pat taikomos jums ir Tiekėjui naudojant Tiekėjo paslaugas (kaip apibrėžta toliau). Visos šios gairės, taisyklės, reklamos sąlygos ir nuostatos bus laikomos neatskiriama šių Bendrųjų sąlygų dalimi. Naudodamiesi Tiekėjo paslaugomis, jūs sutinkate laikytis šių Bendrųjų sąlygų, gairių, taisyklių ir reklamos sąlygų.","provider-terms-condition-title":"Tiekėjo aprašymas","provider-terms-condition-desc":"Naudodamasis WAP, SMS, GPRS ir 3G paslaugomis, Tiekėjas suteikia vartotojams prieigą prie internetinių šaltinių tinklo, įskaitant internetinius žaidimus, teksto žinutes, turtingą turinį ir internetinę informaciją, kuri gali būti atsisiųsta į mobilųjį telefoną ar kitus įrenginius („Paslaugos“). Bendrosios sąlygos visada taikomos visoms naujoms galimybėms, įskaitant galimybes, kurias Tiekėjas gali įgyvendinti kaip dalį Tiekėjo paslaugų plėtros, išplėtimo ar tobulinimo, įskaitant bet kokias naujas funkcijas, kurias Tiekėjas prideda.","availability-terms-condition-title":"Prieinamumas","availability-terms-condition-desc":"Paslauga teikiama tokia, kokia yra (dabartiniame jos kūrimo etape), ir Tiekėjas neprisiima jokios atsakomybės ir neteikia jokių garantijų ar garantijų tuo atveju, jei asmeniniai nustatymai, informacija ar žinutės nėra išsaugomos, laiku neišsaugomos, ištrinamos ar neteisingai pristatomos. Norint prenumeruoti Paslaugą, jums reikia turėti prieigą prie interneto ir (arba) mobiliojo ryšio prenumeratą ir sumokėti bet kokius su tokia prieiga susijusius mokesčius. Jūs turite sumokėti visas išlaidas, susijusias su tokios prieigos sukūrimu. Jūs taip pat esate atsakingas už bet kokios būtinos įrangos, įskaitant mobilųjį telefoną ar asmeninį kompiuterį ar kitus įrenginius, prijungimą, kurie gali būti reikalingi ir yra tinkami naudoti su Paslauga.","payment-terms-condition-title":"Apmokėjimas","payment-terms-condition-desc":"Jūs turite prieigą prie mūsų internetinių paslaugų nemokamai. Kalbant apie Paslaugas ir jų naudojimą, turite sumokėti sumą, atitinkančią tuo metu galiojančius Tiekėjo tarifus ir jūsų mobiliojo operatoriaus taikomus tarifus. Mokesčiai bus išrašyti jums per jūsų mobiliojo operatoriaus sąskaitą, kurią gausite iš savo tinklo mobiliojo operatoriaus. Jūs sumokate Tiekėjui visus nacionalinius ir vietinius ar kitus mokesčius, įskaitant, bet neapsiribojant PVM, bet kokius mokesčius ar rinkliavas, kurie yra taikomi už Paslaugų naudojimo sąnaudas, nepaisant to, ar šie mokesčiai yra taikomi dabar ar ateityje Europos, nacionalinėmis ar vietinėmis valdžios institucijomis arba bet kokiu kitu įgaliotu mokesčių rinkimo subjektu. Tiekėjas pasilieka teisę keisti Paslaugų tarifus, paskelbdamas tokių pakeitimų informaciją savo svetainėje.","obligation-terms-condition-title":"Registracijos pareiga","obligation-terms-condition-desc":"Siekiant užtikrinti saugų ir patikimą Paslaugos naudojimą, jūs garantuojate šiuos dalykus, be to, kad sumokate taikomus mokesčius: (a) jūsų asmeninė informacija (toliau vadinama „Registruota informacija“), pateikta registracijos formoje, yra teisinga, tikra, tiksli ir išsami ir (b) jūs sutinkate užtikrinti, kad Registruota informacija visada būtų teisinga, atnaujinta, tikra, tiksli ir išsami. Jei Tiekėjas turi pagrįstų įtarimų, kad Registruota informacija neatitinka tikrovės, nėra tiksli ar išsami, Tiekėjas turi teisę sustabdyti arba nutraukti jūsų paskyrą ir uždrausti tiek dabartinį, tiek būsimą Paslaugos arba jos komponentų naudojimą. Jūs esate atsakingas už bet kokių slaptažodžių ir (arba) paskyrų, išduotų jums Tiekėjo, slaptumo palaikymą ir esate visiškai atsakingas už visus veiksmus, atliktus naudojant jūsų slaptažodį ar paskyrą. Jūs prisiimate pareigą kiekvienos sesijos pabaigoje uždaryti savo paskyrą (uždarydami naršyklę) ir susisiekti su Tiekėju, jei pastebite ar įtariate, kad jūsų slaptažodis ar paskyra buvo neteisėtai naudojami arba dėl kokios nors kitos priežasties saugumas ar apsauga nebeužtikrinama. Tiekėjas negali ir nebus atsakingas už bet kokią žalą, atsirandančią dėl jūsų nesugebėjimo laikytis šio straipsnio nuostatų.","ownership-terms-condition-title":"Tiekėjo nuosavybės teisės","ownership-terms-condition-desc":"Šios Bendrosios sąlygos taikomos produktams ir paslaugoms, teikiamoms per WAP, SMS, GPRS ir 3G Sam Media Ltd., arba su juo susijusių įmonių (toliau – „Tiekėjas”). Tiekėjas turi teisę laikas nuo laiko keisti šias Bendrąsias sąlygas be išankstinio įspėjimo. Be Bendrųjų sąlygų, bet kokios galiojančios ir viešai paskelbtos taisyklės, reklamos sąlygos, gairės ir nuostatos, susijusios su paslaugomis, taip pat taikomos jums ir Tiekėjui naudojant Tiekėjo paslaugas (kaip apibrėžta toliau). Visos šios gairės, taisyklės, reklamos sąlygos ir nuostatos bus laikomos neatskiriama šių Bendrųjų sąlygų dalimi. Naudodamiesi Tiekėjo paslaugomis, jūs sutinkate laikytis šių Bendrųjų sąlygų, gairių, taisyklių ir reklamos sąlygų."}

/***/ }),

/***/ "./src/translations/no.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Ta spillet et steg videre","sidebar.home":"Hjem","sidebar.myaccount":"Min konto","sidebar.notif":"Melding","sidebar.nonotif":"Du har ingen varsler ennå","html5games":"HTML5-spill","androidGames":"Android-spill","favorite":"Favoritt","welcome.text":"Utforsk de beste mobilspillene på nett i dag!","footer.copyright":"© 2020 Gamelords. Alle rettigheter reservert","accountDetails":"Kontodetaljer","accountName":"Navn","accountEmail":"E-postadresse","accountLocation":"Plassering","accountInterests":"Interesser","accountChooseCategory":"Velg 3 kategorier","accountEditPhoto":"Rediger bilde","save":"Lagre","topCategories":"Toppkategorier","favGames":"Favorittspill","viewAll":"Vis alt","noGameFound":" Ingen spill funnet. ","cancel":"Avbryt","gameDirectories":"Spill-kataloger","category":"Kategori","noGamesFound":"Ingen spill funnet.","noVideosFound":"Ingen videoer funnet under denne kategorien","noFavVideos":"Ingen favorittvideoer ennå","addFavVideos":"Legg til favorittvideoene dine for å få tilgang til og spille enkelt uten problemer","noFavVideosFound":"Ingen favorittvideoer funnet","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Alle rettigheter forbeholdt","vid-player":"Spiller","Motivation":"Motivasjon","Tour":"Tur","Fun Gaming":"Morsom Spill","Athletics":"Friidrett","Inspiration":"Inspirasjon","Into Nature":"Inn i Naturen","Political & Activism":"Politisk og Aktivisme","Travel":"Reise","Foodbuzz":"Foodbuzz","Health and Nutrition":"Helse og Ernæring","Top Cars":"Topp biler","Fashion & Beauty":"Mote Og Skjønnhet","E-Learning":"E-Læring","Yoga":"Yoga","Just For Laugh":"Bare for Latter","Brain Boost":"Hjerneforsterkning","Rugby":"Rugby","Economy":"Økonomi","Environment":"Miljø","Gaming":"Gaming","Lifestyle":"Livsstil","Local Heroes":"Lokale Helter","Technology":"Teknologi","Tutorials":"Guider","New Arrivals":"Nyankomne","platform":"Plattform","type":"Type","android-upper":"ANDROID","games":"spill","html5":"HTML5","videos":"VIDEOER","welcome.text.gamiclub":"Utforsk det beste innholdet på nettet i dag!","description":"Description","downloadNow":"Last ned nå","playNow":"Spill nå","rate":"Vurder","relatedGames":"Relaterte spill","noFavGames":"Ingen favorittspill ennå","addFavGames":"Legg til favorittspillene dine for å enkelt få tilgang og spille uten noen problemer","discover":"Oppdag","noFavGamesFound":"Ingen favorittspill funnet.","favorites":"Favoritter","accessDenied":"Tilgang nektet","pageRestricted":"Siden du leter etter er begrenset.","privacyPolicy":"personvernpolicy","tnc":"Vilkår og betingelser","areYouAlready":"Er du allerede medlem av ","thenConfirm":"Bekreft i så fall mobilnummeret ditt og få ubegrenset tilgang til alle våre <strong>HTML5-</strong> og <strong>Android-</strong>spill","login":"LOGG INN","search.input.placeholder":"Søk...","search.cancel.button":"Avbryt","averageRatingBasedOn":" gjennomsnittlig brukervurdering basert på ","averageRatingReview":" anmeldelser","subscription_details":"ABBONEMENTSOPPLYSNINGER","mobile_number":"Mobilnummer","subscription_date":"Abonnementsdato","renewal_date":"Fornyelsesdato","expiry_date":"Utløpsdato","applied_plan":"Anvendt plan","service_name":"Tjenestenavn","weekly":"Ukentlig","Sports":"Sport","Action":"Action","Adventure":"Eventyr","Fitness":"Fitness","Entertainment":"Underholdning","Premium Games":"Premium-spill","RPG":"RPG","Virtual Reality":"Virtuell virkelighet","Arcade":"Arkade","Racing":"Racing"}

/***/ }),

/***/ "./src/translations/pl.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Graj i baw się","sidebar.home":"Strona główna","sidebar.myaccount":"Moje konto","sidebar.notif":"Powiadomienia","sidebar.lang":"Język","sidebar.lang.pl":"Polski","sidebar.lang.en":"Angielski","sidebar.nonotif":"Brak powiadomień","html5games":"Gry online","androidGames":"Gry na Androida","favorite":"Ulubione","welcome.text":"Graj w najlepsze gry","welcome.text.gamiclub":"Odkryj najlepsze treści online już dziś!","footer.copyright":"Wszelkie prawa zastrzeżone &copy;","accountDetails":"Szczegóły konta","accountName":"Imię i nazwisko","accountEmail":"E-mail","accountLocation":"Miejsce","accountInterests":"Zainteresowania","accountChooseCategory":"Wybierz 3 kategorie","accountEditPhoto":"Edytuj zdjęcie","save":"Zapisz","topCategories":"Najlepsze kategorie","favGames":"Ulubione gry","viewAll":"Pokaż wszystko","noGameFound":"Brak gier","cancel":"Anuluj","gameDirectories":"Encyklopedia gier","category":"Kategoria","noGamesFound":"Brak gier w tej kategorii","platform":"Platforma","type":"Rodzaj","games":"Gry","html5":"Online","videos":"Wideo","vid-player":"Odtwarzacz","tnc":"Regulamin","android-upper":"ANDROID","description":"Opis","downloadNow":"Pobierz teraz","playNow":"Graj teraz","rate":"Ocena","relatedGames":"Podobne gry","noFavGames":"Brak ulubionych gier","addFavGames":"Dodaj gry do ulubionych","discover":"Odkryj","noFavGamesFound":"Nie znaleziono ulubionych gier","favorites":"Ulubione","accessDenied":"Brak dostępu","pageRestricted":"Strona niedostępna","privacyPolicy":"","kazakhOnly":"","areYouAlready":"Czy jesteś członkiem ","thenConfirm":"Potwierdź swój numer telefonu i wejdź do świata gier","login":"Zaloguj się","search.input.placeholder":"Szukaj...","search.cancel.button":"Anuluj","Sports":"Sport","Action":"Akcja","Adventure":"Przygoda","Fitness":"Fitness","Entertainment":"Rozrywka","Premium Games":"Gry premium","RPG":"Gry RPG","Virtual Reality":"Wirtualna rzeczywistość","Arcade":"Arcade","Racing":"Wyścigi","privacy-policy-title":"Polityka prywatności","privacy-policy-desc":"Niniejsza polityka prywatności wyjaśnia nasze zobowiązania i prawa dotyczące Twoich danych. Powinieneś uważnie przeczytać politykę prywatności. Jeśli nie zgadzasz się z tą polityką, prosimy o niekorzystanie z naszych stron ani usług. Polityka prywatności stanowi integralną część regulaminu i podlega jego warunkom. Wszelkie terminy używane w niniejszej polityce, a niezdefiniowane, mają takie same znaczenie jak w regulaminie. Zbieramy informacje w następujący sposób:","privacy-policy-collect-info-head":"Zbieramy informacje w następujący sposób:","privacy-policy-collect-info-desc1":"1. Kiedy je nam przekazujesz lub wyrażasz na to zgodę. Jeśli zdecydujesz się zasubskrybować naszą usługę, my lub Twój operator sieci komórkowej zbierzemy Twoje dane dotyczące płatności za subskrypcję naszych usług. Dane konta i rozliczeń zbierane przez operatora podlegają jego polityce prywatności.","privacy-policy-collect-info-desc2":"2. Uzyskujemy dane techniczne, gdy odwiedzasz nasze strony i/lub korzystasz z naszych usług. Możemy gromadzić dane techniczne za każdym razem, gdy korzystasz z naszych usług. Zbieramy dane logów za każdym razem, gdy logujesz się lub wylogowujesz z naszych usług. Jak wykorzystujemy zebrane dane:","privacy-policy-how-collect-info-head":"Jak wykorzystujemy zebrane informacje","privacy-policy-how-collect-info-subhead":"Możemy wykorzystywać Twoje dane do następujących celów, w tym do świadczenia żądanej usługi:","privacy-policy-how-collect-info-desc1":"· Rozliczanie i pobieranie opłat za usługi świadczone na Twoją rzecz.","privacy-policy-how-collect-info-desc2":"Jak długo przechowujemy Twoje dane","privacy-policy-how-long-head":"Jak długo przechowujemy Twoje dane","privacy-policy-how-long-desc":"Przechowujemy Twoje dane tak długo, jak to konieczne do świadczenia naszych usług. Zachowamy je, gdy będzie to niezbędne do spełnienia wymogów prawnych, rozwiązania sporów lub egzekwowania naszych umów. Gdy dane nie będą już potrzebne, usuniemy je lub zanonimizujemy, aby nie było możliwe zidentyfikowanie Twojej osoby.","privacy-policy-how-long-protect-head":"Jak chronimy Twoje dane również poza UE","privacy-policy-how-long-protect-desc1":"Dbamy o ochronę Twojej prywatności i danych, jednak nie możemy zagwarantować pełnego bezpieczeństwa żadnych informacji przesyłanych do nas ani zapewnić, że nie zostaną one ujawnione, zmienione czy zniszczone wskutek naruszenia zabezpieczeń technicznych lub administracyjnych. Stosujemy odpowiednie praktyki w zakresie zbierania, przechowywania i przetwarzania danych oraz środki bezpieczeństwa chroniące przed nieuprawnionym dostępem, zmianą, ujawnieniem czy zniszczeniem Twoich danych.","privacy-policy-how-long-protect-desc2":"Dbamy o ochronę Twojej prywatności i danych, jednak nie możemy zagwarantować pełnego bezpieczeństwa żadnych informacji przesyłanych do nas ani zapewnić, że nie zostaną one ujawnione, zmienione czy zniszczone wskutek naruszenia zabezpieczeń technicznych lub administracyjnych. Stosujemy odpowiednie praktyki w zakresie zbierania, przechowywania i przetwarzania danych oraz środki bezpieczeństwa chroniące przed nieuprawnionym dostępem, zmianą, ujawnieniem czy zniszczeniem Twoich danych.","privacy-policy-how-long-protect-desc3":"Ponieważ działamy na arenie międzynarodowej, Twoje dane mogą być przekazywane do USA, Singapuru lub innego kraju poza miejscem Twojego zamieszkania. W tych krajach również dbamy o ochronę Twoich danych osobowych.","privacy-policy-acceptance-head":"Akceptacja polityki prywatności","privacy-policy-acceptance-desc":"Korzystając z naszych usług, wyrażasz zgodę na gromadzenie i wykorzystywanie Twoich danych zgodnie z niniejszą polityką prywatności. Zastrzegamy sobie prawo do wprowadzania zmian w polityce prywatności w dowolnym momencie poprzez ich opublikowanie na tej stronie. Sprawdź datę ostatniej aktualizacji na dole strony, aby zobaczyć, czy wprowadzono zmiany. Dalsze korzystanie z naszych usług oznacza akceptację zmian.","privacy-policy-changes-head":"Zmiany w polityce prywatności","privacy-policy-changes-desc":"Od czasu do czasu możemy wprowadzać zmiany w naszej polityce prywatności. Jeśli zdecydujemy się na wprowadzenie zmian, opublikujemy je na tej stronie, abyś zawsze miał dostęp do najnowszej wersji.","privacy-policy-contact-us":"Skontaktuj się z nami","privacy-policy-contact-us-desc":"Jeśli masz pytania dotyczące niniejszej polityki prywatności, praktyk na stronie lub Twojej interakcji z serwisem, skontaktuj się z nami wysyłając e-mail na adres: eg@apps4u.cc.","help":"Skontaktuj się z nami","funzarena_text":"Nie masz dostępu. Wyślij sms o treści GAME na 92505 (koszt 30,75 zł)","withdraw_from_contract":"Wypłata z kontraktu"}

/***/ }),

/***/ "./src/translations/pt.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Início","sidebar.myaccount":"Minha Conta","sidebar.notif":"Notificação","sidebar.nonotif":"Você ainda não tem notificações","html5games":"Jogos HTML5","androidGames":"Jogos Android","android-upper":"ANDROID","favorite":"Favorito","splashscreen.text":"Jogue Muito Além","welcome.text":"EXPLORE OS MELHORES JOGOS DE TELEMÓVEL ON-LINE HOJE!","welcome.text.gamiclub":"EXPLORE O MELHOR CONTEÚDO ON-LINE HOJE!","accountDetails":"DETALHES DA CONTA","accountName":"NOME","accountEmail":"ENDEREÇO DE E-MAIL","accountLocation":"LOCALIZAÇÃO","accountInterests":"INTERESSES","accountChooseCategory":"Escolha 3 categorias","accountEditPhoto":"ALTERAR FOTO","save":"Salvar","topCategories":"TOP CATEGORIAS","favGames":"JOGOS FAVORITOS","viewAll":"VER TUDO","noGamesFound":"Nenhum jogo encontrado sob esta categoria","noVideosFound":"Nenhum vídeo encontrado sob esta categoria","cancel":"Cancelar","gameDirectories":"DIRETÓRIOS DE JOGOS","category":"Categoria","platform":"Plataforma","type":"Tipo","android":"ANDROID","games":"jogos","html5":"HTML5","videos":"VIDEOS","search.input.placeholder":"Buscar...","search.cancel.button":"Cancelar","description":"Descrição","downloadNow":"JOGAR Agora","playNow":"JOGAR AGORA","rate":"Avaliar","relatedGames":"JOGOS RELACIONADOS","noFavGames":"Nenhum jogo favorito ainda","addFavGames":"Adicione os seus jogos favoritos para aceder e jogar facilmente sem complicações","discover":"DESCOBRIR","noFavGamesFound":"Nenhum jogo favorito ainda","favorites":"Favoritos","accessDenied":"Acesso Negado","pageRestricted":"A página que você está procurando é restrita.","averageRatingBasedOn":" de avaliação média do usuário com base em ","averageRatingReview":" avaliações","tnc":"TERMOS E CONDIÇÕES","contact_us":"Contact Us","areYouAlready":"Você já é um membro da ","thenConfirm":"Depois confirme seu número de telemóvel e obtenha acesso ilimitado a todos os nossos jogos HTML5 e Android","thenConfirmAlt":"Depois confirme seu número de telemóvel e obtenha acesso ilimitado a todo o nosso conteúdo","login":"Iniciar Sessão","Action":"Ação","Adventure":"Aventura","Arcade":"Arcade","Sport":"Desportos","Racing":"Corrida","Premium Games":"Jogos Premium","RPG":"RPG","Virtual Reality":"Realidade Virtual","Motivation":"Motivation","Tour":"Tour","Fun Gaming":"Fun Gaming","Athletics":"Athletics","Inspiration":"Inspiração","Into Nature":"Na Natureza","Political & Activism":"Política e Ativismo","Travel":"Viagens","Foodbuzz":"Foodbuzz","Health and Nutrition":"Saúde e Nutrição","Fitness":"Fitness","Top Cars":"Melhores Carros","Fashion & Beauty":"Moda e Beleza","E-Learning":"Aprendizagem On-line","Yoga":"Ioga","Just For Laugh":"Só Risadas","Brain Boost":"Reforço Cerebral","Rugby":"Rugby","Economy":"Economia","Environment":"Meio Ambiente","Gaming":"Jogos Eletrônicos","Lifestyle":"Estilo de Vida","Local Heroes":"Heróis Locais","Sports":"Desportos","Technology":"Tecnologia","Tutorials":"Tutoriais","Utilities":"Utilitários","New Arrivals":"Recém Chegados","noFavVideos":"Nenhum vídeo favorito ainda","addFavVideos":"Adicione seus vídeos favoritos para ter acesso e jogar facilmente sem complicações","noFavVideosFound":"Nenhum vídeo favorito encontrado","footer.copyright":"&copy; 2020 Gamelords. Todos os direitos reservados","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Todos os direitos reservados","vid-player":"Jogador","privacyPolicy":"POLÍTICA DE PRIVACIDADE","privacy-policy-title":"POLÍTICA DE PRIVACIDADE","privacy-policy-desc":"Esta Política de Privacidade explica nossos compromissos e seus direitos em relação às suas informações. Você deve ler atentamente a Política de Privacidade. Se você não concordar com esta Política de Privacidade, por favor, não utilize nossos Sites ou Serviços. A Política de Privacidade está devidamente incorporada e sujeita aos Termos de Serviço e rege os mesmos Serviços e Sites que os mencionados nos Termos de Serviço. Quaisquer termos que utilizamos na Política de Privacidade sem defini-los têm a mesma definição que nos Termos de Serviço.","privacy-policy-collect-info-head":"COLETAMOS INFORMAÇÕES DAS SEGUINTES FORMAS:","privacy-policy-collect-info-desc1":"Quando você nos dá ou nos dá permissão para obtê-las Se você optar por assinar um Serviço conosco, nós ou a operadora móvel de sua rede coletaremos suas informações relacionadas ao pagamento da assinatura de nossos Serviços. As informações de conta e faturamento coletadas pela operadora de telefonia móvel estão sujeitas às respectivas políticas de privacidade.","privacy-policy-collect-info-desc2":"Recebemos informações técnicas quando você visita nossos Sites e/ou Serviços. Podemos coletar informações técnicas a seu respeito sempre que você utilizar nossos Serviços. Coletamos dados de registro toda vez que você faz login ou logout de nossos Serviços.","privacy-policy-how-collect-info-head":"COMO USAMOS AS INFORMAÇÕES COLETADAS","privacy-policy-how-collect-info-subhead":"Podemos utilizar suas informações para os seguintes propósitos:","privacy-policy-how-collect-info-desc1":" · Prestar o(s) serviço(s) solicitado(s);","privacy-policy-how-collect-info-desc2":" · Cobrar e cobrar pelo(s) Serviço(s) que lhe for(em) fornecido(s) a você;","privacy-policy-how-long-head":"QUANTO TEMPO GUARDAMOS SUAS INFORMAÇÕES","privacy-policy-how-long-desc":"Conservaremos suas informações pelo tempo necessário para fornecer nossos serviços a você. Conservaremos suas informações conforme necessário para cumprir com nossas obrigações legais, resolver disputas e fazer cumprir nossos acordos. Quando não precisarmos mais usar suas informações e não houver mais necessidade de mantê-las para cumprir com nossas obrigações legais ou regulatórias, as removeremos de nossos sistemas ou as despersonalizaremos para que não possamos mais identificá-lo.","privacy-policy-how-long-protect-head":"COMO PROTEGEMOS SUAS INFORMAÇÕES TAMBÉM FORA DA UE","privacy-policy-how-long-protect-desc1":"Estamos preocupados em proteger sua privacidade e dados, mas não podemos assegurar ou garantir a segurança de qualquer informação que você nos transmita ou garantir que suas informações não possam ser acessadas, divulgadas, alteradas ou destruídas por violação de qualquer uma de nossas salvaguardas físicas, técnicas ou gerenciais padrão da indústria. Adotamos práticas apropriadas de coleta, armazenamento e processamento de dados e medidas de segurança para proteger contra acesso não autorizado ou acidental, alteração, divulgação ou destruição de suas informações, informações sobre transações e dados armazenados em nossos Serviços.","privacy-policy-how-long-protect-desc2":"Entretanto, nenhum método de transmissão pela Internet ou método de armazenamento eletrônico é 100% seguro. Portanto, não podemos garantir sua segurança absoluta. Continuaremos a melhorar nossos procedimentos de segurança à medida que novas tecnologias se tornem disponíveis.","privacy-policy-how-long-protect-desc3":"Como operamos internacionalmente, suas informações, incluindo informações pessoais, poderão ser transferidas e disponibilizadas nos EUA/Singapura e/ou em qualquer outro país que não seja seu país de residência. Também nesses países, tomamos todos os cuidados razoáveis para proteger suas informações pessoais.","privacy-policy-acceptance-head":"ACEITAÇÃO DA POLÍTICA DE PRIVACIDADE","privacy-policy-acceptance-desc":"Ao utilizar qualquer de nossos Serviços, você consente com nossa coleta e uso de suas informações de acordo com esta Política de Privacidade. Reservamo-nos o direito de modificar esta Política de Privacidade a qualquer momento, colocando as alterações nesta página. Favor verificar a data de revisão no final desta página para determinar se a política foi modificada desde a última vez que você a revisou. Seu uso continuado de qualquer parte de nosso Site ou Serviços após a publicação da Política de Privacidade atualizada constituirá sua aceitação das mudanças.","privacy-policy-changes-head":"ALTERAÇÕES A ESTA POLÍTICA DE PRIVACIDADE","privacy-policy-changes-desc":"Podemos fazer mudanças em nossa Política de Privacidade de tempos em tempos. Se decidirmos mudar nossa Política de Privacidade, publicaremos essas mudanças nesta página para que você possa sempre acessar a mais recente Política de Privacidade.","privacy-policy-contact-us":"CONTATANDO-NOS","privacy-policy-contact-us-desc":"Se você tiver alguma dúvida sobre esta Política de Privacidade, as práticas dos Sites, ou suas relações com os Sites, por favor, entre em contato conosco enviando um e-mail para support@content-clubs.com.","unsubscribe":"CANCELAR INSCRIÇÃO","terms-condition-title":"Termos e Condições","gen-terms-condition-title":"Termos e Condições Gerais e Política de Privacidade.","gen-terms-condition-desc":"Os seguintes Termos e Condições Gerais aplicam-se aos produtos e serviços fornecidos via WAP, SMS, GPRS e 3G pela Sam Media Ltd., ou por empresas a ela afiliadas (doravante denominadas \"o Fornecedor\"). O Fornecedor pode alterar estes Termos e Condições Gerais periodicamente sem aviso prévio. Além dos Termos e Condições Gerais, quaisquer regras, condições promocionais, diretrizes e disposições aplicáveis e publicadas relativas aos serviços também se aplicam a você e ao Fornecedor ao utilizar os Serviços (conforme definido neste documento) do Fornecedor. Todas essas diretrizes, regras, condições promocionais e disposições serão consideradas parte integrante destes Termos e Condições Gerais. Ao utilizar os Serviços do Fornecedor, você concorda em ficar vinculado por estes Termos e Condições Gerais e pelas diretrizes, regras e condições promocionais.","provider-terms-condition-title":"Descrição do Fornecedor.","provider-terms-condition-desc":"Por meio dos serviços WAP, SMS, GPRS e 3G, o Fornecedor fornece aos seus usuários acesso a uma rede de fontes online, incluindo jogos online, mensagens de texto, conteúdo rico e material informativo online que pode ser baixado para telefones móveis ou quaisquer dispositivos (“Serviços”). Os Termos e Condições Gerais são sempre aplicáveis a todas as novas funcionalidades, incluindo aquelas que o Fornecedor possa implementar como parte da sua expansão, extensão ou melhoria dos Serviços atuais, incluindo qualquer extensão para novas funções adicionadas pelo Fornecedor.","availability-terms-condition-title":"Disponibilidade.","availability-terms-condition-desc":"O Serviço é fornecido no estado em que se encontra (no estágio de desenvolvimento em que se encontra), e o Fornecedor não aceita nenhuma responsabilidade nem oferece garantias em caso de configurações pessoais, informações ou mensagens que não sejam salvas, ou não sejam salvas em tempo hábil, ou sejam excluídas ou entregues incorretamente. Para se inscrever no Serviço, você deve ter acesso à Internet e/ou uma assinatura de comunicação móvel e pagar quaisquer taxas de serviço associadas a esse acesso. Você é responsável por todas as despesas incorridas para criar esse acesso. Você também é responsável por conectar o equipamento necessário, incluindo qualquer telefone móvel, computador pessoal ou qualquer outro dispositivo que possa ser necessário e esteja em bom funcionamento para o uso do Serviço.","payment-terms-condition-title":"Pagamento.","payment-terms-condition-desc":"Você tem acesso aos nossos serviços online gratuitamente. Com relação aos Serviços e seu uso, você deverá pagar o valor correspondente às tarifas aplicáveis do Fornecedor em vigor naquele momento e de acordo com as tarifas cobradas pela sua operadora móvel. As cobranças serão faturadas a você através da sua operadora móvel por meio da fatura do telefone. Você paga ao Fornecedor todos os impostos nacionais e locais ou outros tributos, incluindo, mas não se limitando ao IVA, quaisquer impostos ou taxas impostas em substituição, baseadas nos custos do uso dos Serviços, independentemente de esses tributos serem cobrados agora ou no futuro por autoridades europeias, nacionais ou locais, ou por qualquer outro órgão autorizado. O Fornecedor reserva-se o direito de alterar as tarifas do Serviço publicando os detalhes dessas alterações em seu site.","obligation-terms-condition-title":"Obrigação de Registro.","obligation-terms-condition-desc":"Para garantir o uso seguro e protegido do Serviço, você garante o seguinte, além de pagar os encargos aplicáveis: (a) suas informações pessoais (doravante denominadas “Informações Registradas”) fornecidas no formulário de registro são corretas, verdadeiras, precisas e completas e (b) você concorda em garantir que as Informações Registradas estejam sempre corretas, atualizadas, verdadeiras, precisas e completas. Se o Fornecedor tiver uma suspeita razoável de que as Informações Registradas não refletem a realidade, ou não são precisas ou completas, o Fornecedor terá o direito de suspender ou encerrar sua conta e restringir o uso atual e futuro do Serviço, ou qualquer componente do mesmo. Você é responsável por manter o sigilo de qualquer senha e/ou conta emitida para você pelo Fornecedor, e é totalmente responsável por todas as ações realizadas com o uso da sua senha ou conta. Você se compromete a encerrar sua conta (fechando o navegador) ao final de cada sessão e a entrar em contato com o Fornecedor se perceber ou suspeitar de uso não autorizado da sua senha ou conta, ou se a segurança estiver comprometida por qualquer outro motivo. O Fornecedor não poderá ser responsabilizado por quaisquer danos decorrentes do não cumprimento das estipulações deste artigo.","ownership-terms-condition-title":"Direitos de Propriedade do Fornecedor.","ownership-terms-condition-desc":"Os seguintes Termos e Condições Gerais aplicam-se aos produtos e serviços fornecidos via WAP, SMS, GPRS e 3G pela Sam Media Ltd., ou por empresas a ela afiliadas (doravante denominadas \"o Fornecedor\"). O Fornecedor pode alterar estes Termos e Condições Gerais periodicamente sem aviso prévio. Além dos Termos e Condições Gerais, quaisquer regras, condições promocionais, diretrizes e disposições aplicáveis e publicadas relativas aos serviços também se aplicam a você e ao Fornecedor ao utilizar os Serviços (conforme definido neste documento) do Fornecedor. Todas essas diretrizes, regras, condições promocionais e disposições serão consideradas parte integrante destes Termos e Condições Gerais. Ao utilizar os Serviços do Fornecedor, você concorda em ficar vinculado por estes Termos e Condições Gerais e pelas diretrizes, regras e condições promocionais.","withdraw_from_contract":"Retirada do contrato"}

/***/ }),

/***/ "./src/translations/ro.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Prima Pagină","sidebar.myaccount":"Contul meu","sidebar.notif":"Notificare","sidebar.nonotif":"Nu aveți încă notificări","html5games":"Jocuri HTML5","androidGames":"Jocuri Android","android-upper":"ANDROID","favorite":"Favorit","splashscreen.text":"Joacă Way Beyond","welcome.text":"EXPLORAȚI CELE MAI BUNE JOCURI MOBILE ONLINE ASTĂZI!","welcome.text.gamiclub":"EXPLORAȚI CEL MAI BUN CONȚINUT ONLINE ASTĂZI!","accountDetails":"DETALII CONT","accountName":"NUME","accountEmail":"ADRESA DE E-MAIL","accountLocation":"LOCAȚIA","accountInterests":"INTERESE","accountChooseCategory":"Alegeți 3 categorii","accountEditPhoto":"EDITAȚI POZA","save":"Salvare","topCategories":"CATEGORII DE TOP","favGames":"JOCURI FAVORITE","viewAll":"VEDEȚI TOTUL","noGamesFound":"Nu au fost găsite jocuri în această categorie","noVideosFound":"Nu au fost găsite videoclipuri în această categorie","cancel":"Anulare","gameDirectories":"REGISTRELE DE ADRESE DE JOC","category":"Categorie","platform":"Platformă","type":"Tip","android":"ANDROID","games":"games","html5":"HTML5","videos":"VIDEOS","search.input.placeholder":"Căutare","search.cancel.button":"Anulare","description":"Descriere","downloadNow":"DESCĂRCAȚI ACUM","playNow":"JUCAȚI ACUM","rate":"Rată","relatedVideo":"VIDEOCLIPURI CONEXE","relatedGames":"JOCURI CONEXE","noFavGames":"Incă nu există jocuri favorite","addFavGames":"Adăugați jocurile dvs preferate pentru a le accesa și juca cu ușurință fără probleme","discover":"DESCOPERIȚI","noFavGamesFound":"Nu au fost găsite jocuri favorite.","favorites":"Favorit","accessDenied":"Acces respins","pageRestricted":"Pagina pe care o căutați este restricționată.","averageRatingBasedOn":" medie de rating de utilizator bazat pe [numărul] recenzie ","averageRatingReview":"recenzie","tnc":"TERMENII ȘI CONDIȚIILE","contact_us":"Contact Us","areYouAlready":"Sunteți deja membru al Gamiclub? ","thenConfirm":"Apoi confirmați numărul de telefon mobil și obțineți acces nelimitat la toate jocurile noastre HTML5 și Android.","login":"Logare","Action":"Acțiune","Adventure":"Aventură","Arcade":"Arcadă","Sport":"Sport","Racing":"Curse","Premium Games":"Jocuri premium","RPG":"Jocuri de rol","Virtual Reality":"Realitate virtuală","Motivation":"Motivație","Tour":"Turneu","Fun Gaming":"Jocuri distractive","Athletics":"Atletism","Inspiration":"Inspirație","Into Nature":"În natură","Political & Activism":"Politică și activism","Travel":"Călătorie","Foodbuzz":"Jocuri de gătit","Health and Nutrition":"Sănătate și Nutriție","Fitness":"Fitness","Top Cars":"Mașini de top","Fashion & Beauty":"Modă și frumusețe","E-Learning":"E-Learning","Yoga":"Yoga","Just For Laugh":"Doar pentru râs","Brain Boost":"Creșterea creierului","Rugby":"Rugby","Economy":"Economie","Environment":"Mediu înconjurător","Gaming":"Jocuri","Lifestyle":"Stil de viață","Local Heroes":"Eroi locali","Sports":"Sporturi","Technology":"Tehnologie","Tutorials":"Tutoriale","New Arrivals":"Sosiri noi","noFavVideos":"Incă nu există videoclipuri favorite","addFavVideos":"Adăugați jocurile dvs preferate pentru a le accesa și juca cu ușurință fără probleme","noFavVideosFound":"Nu au fost găsite videoclipuri favorite","footer.copyright.gamiclub":"© 2020 Gamiclub. Toate drepturile rezervate.","vid-player":"Jucător","privacyPolicy":"POLITICA DE CONFIDENȚIALITATE","privacy-policy-title":"POLITICA DE CONFIDENȚIALITATE","privacy-policy-desc":"Această Politică de confidențialitate explică angajamentele noastre și drepturile dvs. cu privire la informațiile dvs. Trebuie să citiți cu atenție Politica de confidențialitate. Dacă nu sunteți de acord cu această Politică de confidențialitate, vă rugăm să nu utilizați Site-urile sau Serviciile noastre. Politica de confidențialitate este încorporată în mod corespunzător și este supusă Termenilor și condițiilor și reglementează aceleași Servicii și Site-uri ca cele menționate în Termenii și condițiile. Orice termeni pe care îi folosim în Politica de confidențialitate fără a le defini au aceeași definiție ca și în Termenii și condițiile.","privacy-policy-collect-info-head":"COLECTĂM INFORMAȚII ÎN URMĂTOARELE MODURI:","privacy-policy-collect-info-desc1":" 1. Când ne-le dați dvs sau ne dați permisiunea să le obținem. Dacă alegeți să vă abonați la un Serviciu oferit de noi, noi sau operatorul de telefonie mobilă al rețelei dvs. vă vom colecta informațiile legate de plata pentru abonamentul Serviciilor noastre. Informațiile despre cont și facturare colectate de operatorul de telefonie mobilă sunt supuse politicilor lor de confidențialitate respective.","privacy-policy-collect-info-desc2":"2. Obținem informații tehnice atunci când vizitați Site-urile și / sau Serviciile noastre. Putem colecta informații tehnice despre dvs. ori de câte ori utilizați serviciile noastre. Colectăm date de jurnal de fiecare dată când vă conectați sau vă deconectați de la Serviciile noastre.","privacy-policy-how-collect-info-head":"CUM UTILIZĂM INFORMAȚIILE COLECTATE","privacy-policy-how-collect-info-subhead":" Putem folosi informațiile dvs. în următoarele scopuri:","privacy-policy-how-collect-info-desc1":" · Furnizarea Serviciilor pe care le solicitați;","privacy-policy-how-collect-info-desc2":"· Facturarea și încasarea pentru Serviciul (serviciile) oferit (e);","privacy-policy-how-long-head":"CÂT TIMP PĂSTRĂM INFORMAȚIILE DVS.","privacy-policy-how-long-desc":"Vă vom păstra informațiile atât timp cât este necesar pentru a vă oferi Serviciile noastre. Vom păstra informațiile dvs. după cum este necesar pentru a ne respecta obligațiile legale, pentru a rezolva litigiile și pentru a ne pune în aplicare acordurile. Când nu mai trebuie să folosim informațiile dvs. și nu este nevoie să le păstrăm pentru a respecta obligațiile noastre legale sau de reglementare, fie le vom elimina din sistemele noastre, fie le vom depersonaliza, astfel încât să nu vă mai putem identifica.","privacy-policy-how-long-protect-head":"CUM PROTEJĂM INFORMAȚIILE DUMNEAVOASTRĂ ÎN AFARA UE","privacy-policy-how-long-protect-desc1":" Ne preocupăm să vă protejăm confidențialitatea și datele, dar nu putem asigura sau garanta securitatea oricăror informații pe care ni le transmiteți sau garanta că informațiile dvs. nu pot fi accesate, dezvăluite, modificate sau distruse prin încălcarea oricărei garanții fizice, tehnice sau manageriale standarde din industria noastră. Adoptăm practici adecvate de colectare, stocare și prelucrare a datelor și măsuri de securitate pentru a proteja împotriva accesului neautorizat sau accidental, modificării, divulgării sau distrugerii informațiilor dvs., informațiilor despre tranzacții și datelor stocate în Serviciile noastre.","privacy-policy-how-long-protect-desc2":" Cu toate acestea, nicio metodă de transmitere prin internet sau metodă de stocare electronică nu este 100% sigură. Prin urmare, nu putem garanta securitatea lor absolută. Vom continua să ne îmbunătățim procedurile de securitate pe măsură ce noua tehnologie devine disponibilă.","privacy-policy-how-long-protect-desc3":"Deoarece operăm la nivel internațional, informațiile dvs., inclusiv informații personale, pot fi transferate și puse la dispoziție în SUA / Singapore și / sau în orice altă țară decât țara Dvs. de reședință. De asemenea, în aceste țări, avem toată grija rezonabilă pentru a vă proteja informațiile personale.","privacy-policy-acceptance-head":"ACCEPTAREA POLITICII DE CONFIDENȚIALITATE","privacy-policy-acceptance-desc":"Prin utilizarea oricăruia dintre Serviciile noastre, sunteți de acord cu colectarea și utilizarea informațiilor dvs. în conformitate cu această Politică de confidențialitate. Ne rezervăm dreptul de a modifica această politică de confidențialitate în orice moment, postând modificările pe această pagină. Vă rugăm să verificați data revizuirii din partea de jos a acestei pagini pentru a determina dacă politica a fost modificată de la ultima revizuire de către dvs. Utilizarea în continuare a oricărei porțiuni a Site-ului sau Serviciilor noastre după publicarea Politicii de confidențialitate actualizate va constitui acceptarea modificărilor.","privacy-policy-changes-head":"MODIFICĂRI LA ACEASTA POLITICĂ DE CONFIDENȚIALITATE","privacy-policy-changes-desc":"Este posibil să facem modificări în Politica noastră de confidențialitate din când în când. Dacă decidem să schimbăm Politica noastră de confidențialitate, vom posta aceste modificări pe această pagină, astfel încât să puteți accesa întotdeauna cea mai recentă Politică de confidențialitate.","privacy-policy-contact-us":"CUM SA NE CONTACTAȚI","privacy-policy-contact-us-desc":"Dacă aveți o întrebare despre această Politică de confidențialitate, despre practicile site-urilor sau despre relațiile dvs. cu site-urile, vă rugăm să ne contactați trimițând un e-mail la [Adresa de e-mail].","unsubscribe":"DEZABONARE","AN INFLUENCER'S CALLING 'EVERYONE HAD TO ACCEPT ME WHEN I ACCEPTED MYSELF'":"APELUL UNUI INFLUENCER „TOȚI A TREBUIT SĂ MĂ ACCEPTE CÂND M-AM ACCEPTAT PE MINE ÎNSUMI”\r","CRAZY CRAVINGS 'WHEN I'M BEHIND MY MASK, I'M BASICALLY SOMEONE NEW'":"POFTE NEBUNE „CÂND SUNT ÎN SPATELE MĂȘTII MELE, SUNT PRACTIC CINEVA NOU”\r","I'M A CELEBRITY PET LUNA IS A PRICKLY UP-AND-COMER":"SUNT UN ANIMAL DE COMPANIE CELEBRU LUNA ESTE O PROMIȚĂTOARE ÎNȚEPĂTOARE\r","INSPIRE IN A MINUTE THE SUPERMODEL DISCOVERED AT 60":"INSPIRAȚI ÎNTR-UN MINUT SUPERMODELUL DESCOPERIT LA 60\r","MY COOL SCHOOL CAMILLA'S STUDYING THE TRAPEZE":"ȘCOALA MEA MIȘTO CAMILLA STUDIAZĂ TRAPEZA\r","THE PILOTS FLYING A RESTORED WWII PLANE AROUND THE WORLD":"PILOȚII CARE ZBOARĂ ÎN JURUL LUMII CU UN AVION DE AL DOILEA RĂZBOI MONDIAL RESTAURAT\r","YOUNG CEO 'WHEN I LOOK AT A CAMERA, I SEE POWER IN ME & I SEE GREATNESS":"UN TÂNĂR CEO 'CÂND MĂ UIT LA O CAMERĂ, VĂD PUTERE ÎN MINE ȘI VĂD MĂREȚIE'\r","CITY INNOVATIONS THE HIGHER YOU GO, THE GREENER IT GETS":"INOVAȚII ALE ORAȘULUI: CU CÂT MERGI MAI SUS, CU ATÂT DEVINE MAI VERDE\r","GREEN HEROES THE URBAN EXPERIENCE JUST GOT A SUSTAINABLE UPGRADE":"EROI VERZI, EXPERIENȚA URBANĂ TOCMAI A OBȚINUT UN UPGRADE DURABIL\r","INSPIRE IN A MINUTE FROM BULLIED BUG HUNTER TO KID AUTHOR":"INSPIRAȚI INTR-UN MINUT DE LA VÂNĂTORUL DE INSECTE HĂRȚUIT LA AUTORUL COPIILOR\r","SIGHTS WITH HEIGHTS GHANA’S NATIONAL PARK CANOPY WALK":"VEDERI CU ÎNĂLȚIMI, PLIMBAREA CU BALDACHIN ÎN PARCUL NAȚIONAL DIN GHANA\r","SIGHTS WITH HEIGHTS THE CLIFF SIDE SANCTUARY BETWEEN HEAVEN AND EARTH":"VEDERI CU ÎNĂLȚIMI SANCTUARUL DIN STÂNCĂ ÎNTRE CER ȘI PĂMÂNT\r","A PLACE TO CALL HOME FOR ABANDONED DOGS":"UN LOC DE CHEMAT ACASĂ PENTRU CÂINII ABANDONAȚI\r","BARRY THE BEE WHISPERER’S MOST IMPORTANT FIGHT YET":"CEA MAI IMPORTANTĂ LUPTĂ DE PÂNĂ ACUM A LUI ALBINA BARRY ȘOPTITORUL\r","CEO ACTIVISM IS ON THE RISE":"ACTIVISMUL CEO ESTE ÎN CREȘTERE\r","INDIGENOUS HEROES NIGERIA'S ELIJAH IS SEEKING LEGAL JUSTICE FOR HIS PEOPLE":"EROI INDIGENI, ELIA DIN NIGERIA CAUTĂ DREPTATE LEGALĂ PENTRU POPORUL SĂU\r","INDONESIA TO BUILD A NEW CAPITAL DUE TO CLIMATE CHANGE":"INDONEZIA VA CONSTRUI O NOUĂ CAPITALĂ DIN CAUZA SCHIMBĂRILOR CLIMATICE\r","INSPIRE IN A MINUTE BREAKING BORDERS IS A TOUR YOU HAVE TO GO ON":"INSPIRAȚI INTR-UN MINUT, BREAKING BORDERS ESTE UN TUR PE CARE TREBUIE SA-L FACEȚI\r","INSPIRE IN A MINUTE FIGHTING MENSTRUAL STIGMA IN NEPAL":"INSPIRAȚI ÎNTR-UN MINUT, LUPTA ÎMPOTRIVA STIGMATULUI MENSTRUAL ÎN NEPAL\r","INSPIRE IN A MINUTE HELPING KIDS FIGHT BACK & GET BETTER":"INSPIRAȚI ÎNTR-UN MINUT, AJUTÂND COPIII SĂ SE LUPTE ȘI SĂ SE ÎMBUNĂTĂȚEASCĂ\r","MORE THAN HALF OF WORLD’S FOREST WILDLIFE DISAPPEARED":"MAI MULT DE JUMĂTATE DIN FAUNA SĂLBATICĂ DE PĂDURE A LUMII A DISPĂRUT\r","MY SOCIAL MEDIA ACTIVISM IT'S TIME FOR EVERYONE TO #FILLTHEBOTTLE":"ACTIVISMUL MEU DE PE REȚELELE SOCIALE, ESTE TIMPUL CA TOATĂ LUMEA SĂ #UMPLESTICLA\r","PEACE BUILDERS CLOSING THE CYCLE OF VIOLENCE":"CONSTRUCTORI DE PACE, ÎNCHIDEREA CICLULUI DE VIOLENȚĂ\r","PEACE BUILDERS THE ART OF PEACEFUL RESISTANCE":"CONSTRUCTORI DE PACE, ARTA REZISTENȚEI PAȘNICE\r","PEACE BUILDERS THE UNITING FACTOR THAT'S BRINGING PEOPLE TOGETHER":"CONSTRUCTORI DE PACE, FACTORUL UNIFICĂTOR CARE ADUCE PE OAMENI ÎMPREUNĂ\r","THE RESULTS ARE IN, TOKYO IS THE SAFEST CITY IN THE WORLD":"REZULTATELE SUNT GATA, TOKYO ESTE CEL MAI SIGUR ORAȘ DIN LUME\r","HOW TO BE GREEN AT HOME NATURAL STAIN REMOVER":"CUM SĂ FIȚI VERDE ACASĂ, SOLUȚIE NATURALĂ DE CURĂȚARE DE PETE\r","WANNA BE A DJ START WITH THE BASICS FROM A PRO":"VREȚI SA FIȚI UN DJ, INCEPEȚI CU ELEMENTELE DE BAZĂ DE LA UN PROFESIONIST\r","BEST VR EXPERIENCES INTO THE SHARK TANK":"CELE MAI BUNE EXPERIENȚE DE REALITATE VIRTUALĂ, ÎN REZERVUL RECHINULUI\r","FROM HUMAN TO CYBORG":"DE LA OM LA CIBORG\r","FUTURISTIC TRANSPORT GETTING AROUND NEVER LOOKED SO COOL":"TRANSPORT FUTURIST, DEPLASAREA ÎN JUR NU A ARĂTAT NICIODATĂ ATÂT DE MIȘTO\r","NASA’S NEXT DESTINATION IN 2026 TITAN":"URMĂTOARA DESTINAȚIE A NASA ÎN 2026, TITAN\r","VISIT A SPACE PLACE KOROLEV, RUSSIA'S DEEP SPACE HISTORY":"VIZITAȚI UN LOC SPAȚIAL, KOROLEV, ISTORIA SPAȚIULUI PROFUND AL RUSIEI\r","VISIT A SPACE PLACE THE METEOR CRATER":"VIZITAȚI UN LOC SPAȚIAL, CRATERUL METEORIC\r","VISIT A SPACE PLACE THE NETHERLANDS' SPACE SIMULATOR":"VIZITAȚI UN LOC SPAȚIAL, SIMULATORUL SPAȚIAL AL OLANDEI\r","AMAZING TENNIS COURTS A COURT HIDDEN AMONG CLIFFS":"TERENURI DE TENIS UIMITOARE, UN TEREN ASCUNS PRINTRE STÂNCI\r","BEST VR EXPERIENCES THE EXTREME SPORTS SIMULATOR":"CELE MAI BUNE EXPERIENȚE DE REALITATE VIRTUALĂ, SIMULATORUL DE SPORTURI EXTREME\r","DON’T EXPECT THE U.S. WOMEN’S FOOTBALL SQUAD AT THE WHITE HOUSE":"NU TE AȘTEPTA LA ECHIPA DE FOTBAL FEMININ DIN SUA LA CASA ALBĂ\r","FUTURE FEMALE FOOTBALLER COLOMBIA'S SALOME IS GONNA BE A PRO":"VIITOARE FOTBALISTĂ, SALOME DIN COLUMBIA VA FI UN PROFESIONIST\r","MY UNDERGROUND SPORT ALAN NASTY NASH IS A CHAMP TOE WRESTLER":"SPORTUL MEU SUBTERAN, ALAN NASTY NASH ESTE UN LUPTĂTOR CAMPION DE LA PICIOR\r","MY UNDERGROUND SPORT KABADDI'S GROWING IN INDIA":"SPORTUL MEU SUBTERAN, KABADDI ESTE ÎN CREȘTERE ÎN INDIA\r","SPORT FOR CHANGE A GOAL FOR INCLUSION":"SPORT PENTRU SCHIMBARE, UN OBIECTIV PENTRU INCLUZIUNE\r","SPORT FOR CHANGE THE INITIATIVE HITTING IT OUT OF THE PARK":"SPORT PENTRU SCHIMBARE, INIȚIATIVA LOVIND-O AFARĂ DIN PARC\r","THE 5 BEST SUMMER FOOTBALL TRANSFERS SO FAR!":"CELE MAI BUNE 5 TRANSFERURI DE FOTBAL DE VARĂ DE PÂNĂ ACUM!\r","COACHES CLINIC PETE HERRMAN":"CLINICA DE ANTRENORI, PETE HERRMAN\r","DRIBBLE DRIVE MOTION SKILLS":"CONDUCERE DRIBLING, ABILITĂȚI DE MIȘCARE\r","GAMCA COACHES CLINIC":"CLINICA DE ANTRENORI GAMCA\r","ROBERT TUTEIN (UTICA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"ROBERT TUTEIN (UTICA) - NOMINALIZAT GEICO AL JOCUL ANULUI 2016\r","RYAN KELLEY (ARCADIA) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"RYAN KELLEY (ARCADIA) - NOMINALIZAT GEICO AL JOCUL ANULUI 2016\r","SAM BORST SMITH (ROCHESTER) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"SAM BORST SMITH (ROCHESTER) - NOMINALIZAT GEICO AL JOCUL ANULUI 2016\r","SPECIAL SPECTATORS VISITS THE COLLEGE SLAM DUNK & 3- POINT CHAMPIONSHIPS INTERSPORT":"VIZITE SPECIALE DE SPECTATORI, COLEGIUL SLAM DUNK ȘI CAMPIONATELE ÎN 3 PUNCTE INTERSPORT\r","TANNER SCHIEVE (WISCONSIN LUTHERAN COLLEGE) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TANNER SCHIEVE (COLEGIUL LUTERAN DIN WISCONSIN) - NOMINALIZAT GEICO AL JOCUL ANULUI 2016\r","TREVOR KRIZENESKY (CONCORDIA UNIVERSITY WISCONSIN) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"TREVOR KRIZENESKY (UNIVERSITATEA CONCORDIA WISCONSIN) - NOMINALIZAT GEICO AL JOCUL ANULUI 2016\r","VENKY JOIS (EASTERN WASHINGTON) - 2016 GEICO PLAY OF THE YEAR NOMINEE":"VENKY JOIS (ESTUL WASHINGTONULUI) - NOMINALIZAT GEICO AL JOCUL ANULUI 2016\r","LEARN FREESTYLE FOOTBALL TRICKS LEMMENS AROUND THE WORLD":"ÎNVĂȚAȚI TRUCURI DE FOTBAL FREESTYLE, LEMMENS ÎN JURUL LUMII\r","PRO FOOTBALLER TRAINING A NEED FOR SPEED":"PREGĂTIREA FOTBALISTULUI PROFESIONIST, O NEVOIE DE VITEZĂ\r","PRO FOOTBALLER TRAINING LEG-FOCUSED EXERCISES":"PREGĂTIREA FOTBALISTULUI PROFESIONIST, EXERCIȚII AXATE PE PICIOR\r","PRO FOOTBALLER TRAINING MUSCLES-FOCUSED EXERCISES":"PREGĂTIREA FOTBALISTULUI PROFESIONIST, EXERCIȚII AXATE PE MUȘCHI\r","THERE’S NO POWER FROM KEEPING IT TO YOURSELF'":"NU EXISTĂ NICIO PUTERE DE A-L PĂSTRA PENTRU TINE\r","3 THINGS MALALA HAS SAID THAT WILL TOTALLY INSPIRE YOU":"3 LUCRURI SPUSE DE MALALA CARE TE VOR INSPIRA ÎN TOTALITATE\r","BORDER ANGELS SAVING LIVES WITH WATER":"ÎNGERI DE GRANIȚĂ, SALVAREA DE VIEȚI CU APĂ\r","BULLIED TO INFLUENCER 'PAINTING HELPS ME DODGE MY PROBLEMS":"DE LA HĂRȚUIT LA INFLUENCER „PICTURA MĂ AJUTĂ SĂ MĂ FERESC DE PROBLEMELE MELE”\r","BULLIED TO INFLUENCER 'YOU CAN BE THE LIGHT IN THE DARKNESS":"DE LA HĂRȚUIT LA INFLUENCER „PUTEȚI FI LUMINA ÎN ÎNTUNERIC“\r","PEACE BUILDERS FIGHTING GANGS WITH CLOWNING":"CONSTRUCTORII DE PACE CARE LUPTA ÎMPOTRIVA BANDELOR CU CLOWNING\r","PEACEBUILDERS INSIDE THE COMMUNITY RING":"CONSTRUCTORII DE PACE ÎN INTERIORUL INELULUI COMUNITĂȚII\r","SPORT FOR CHANGE A SURE SHOT TO FEMALE EMPOWERMENT IN ZIMBABWE":"SPORTUL PENTRU SCHIMBARE, O LOVITURĂ SIGURĂ PENTRU EMANCIPAREA FEMEILOR ÎN ZIMBABWE\r","YOUNG CEO MR. CORY’S COOKIES":"COOKIE-URILE TÂNĂRULUI CEO DOMNUL CORY\r","CRAZY CRAVINGS 'I'VE BEEN EATING CHALK FOR OVER TWENTY YEARS":"POFTE NEBUNE \"MĂNÂNC CRETĂ DE PESTE DOUĂZECI DE ANI\"\r","DARGAVS WELCOME TO THE CITY OF THE DEAD":"BUN VENITUL LUI DARGAV ÎN ORAȘUL MORȚILOR\r","HEROES NEIGHBORHOOD TOUR FRIDA KAHLO":"TURUL CARTIERULUI EROILOR FRIDA KAHLO\r","SOLO TRIP HIDDEN GEMS OF BALI":"EXCURSIE SOLO, COMORILE ASCUNSE DIN BALI\r","SOLO TRIP HIDDEN GEMS OF BOGOR (INDONESIA)":"EXCURSIE SOLO, COMORILE ASCUNSE DIN BOGOR (INDONEZIA)\r","SOLO TRIP THE HIDDEN GEMS OF ROTTERDAM":"EXCURSIE SOLO, COMORILE ASCUNSE DIN ROTTERDAM\r","SUGARY DRINK LOVERS, THIS ONE'S FOR YOU!":"IUBITORII DE BĂUTURI ZAHAROASE, ACESTA ESTE PENTRU DVS.!\r","THE 5 MOST ICONIC ARMANI RED CARPET LOOKS OF ALL TIME":"CELE MAI ICONICE 5 CHIPURI LA COVOARE ROȘII ARMANI DIN TOATE TIMPURILE\r","THE MOST AMAZING ISLAND CANARY ISLANDS":"CEA MAI UIMITOARE INSULĂ, INSULELE CANARE\r","THE MOST AMAZING ISLAND FAVIGNANA SICILY":"CEA MAI UIMITOARE INSULĂ, FAVIGNANA SICILIA\r","THE MOST AMAZING ISLAND TEXEL":"CEA MAI UIMITOARE INSULĂ, TEXEL\r","THESE NATIONS GIVE EXPATS THE BEST ONLINE LIFE":"ACESTE NAȚIUNI OFERĂ EXPAȚILOR CEA MAI BUNĂ VIAȚĂ ONLINE\r","5 GAMES YOU WILL LOSE FRIENDS OVER":"5 JOCURI DIN CAUZA CĂRORA VEȚI PIERDE PRIETENI\r","5 REASONS TO PLAY MONSTER HUNTER WORLD":"5 MOTIVE PENTRU A JUCA MONSTER HUNTER WORLD\r","BEST VR EXPERIENCES THE SURVIVAL TEST":"CELE MAI BUNE EXPERIENȚE DE REALITATE VIRTUALĂ, TESTUL DE SUPRAVIEȚUIRE\r","PLACE YOUR BETS! GTA IS GETTING A REAL VIRTUAL CASINO":"PLASAȚI-VĂ PARIURILE! GTA DEVINE UN ADEVĂRAT CAZINO VIRTUAL\r","TOP 5 GAMING LAWSUITS":"TOP 5 PROCESE LEGATE DE JOCURI\r","TOP 5 HIGHEST GROSSING ARCADE GAMES":"TOP 5 JOCURI ARCADE CU CELE MAI MARI ÎNCASĂRI\r","TOP 5 LEGENDARY GAME COUPLES":"TOP 5 CUPLURI DE JOC LEGENDARE\r","BUILDERS OF TOMORROW SOLAR WATER HEATER FROM PLASTIC BOTTLES":"CONSTRUCTORII DE MÂINE, ÎNCĂLZITOR SOLAR DE APĂ DIN STICLE DE PLASTIC\r","GOT PLASTIC HERE ARE FOUR INNOVATIVE WAYS TO DEAL WITH IT!":"AVEȚI LUCRURI DIN PLASTIC, IATĂ PATRU MODURI INOVATOARE DE A FACE CEVA CU ELE!\r","SAVING THE PLANET AND MAKING ART, ONE BUTT AT A TIME":"SALVAREA PLANETEI FĂCÂND ARTĂ, CÂTE O ȚINTĂ LA RÂND\r","THE FASTEST WAY TO SAVE THE PLANET":"CEL MAI RAPID MOD DE A SALVA PLANETA\r","THE UNIQUE ARTIST TURNING TIRES IN MASTERPIECES":"ARTISTUL UNIC CARE TRANSFORMĂ ANVELOPELE ÎN CAPODOPERE\r","4 LESSONS TO LEARN FROM BUSINESS MOGUL ARIANNA HUFFINGTON":"4 LECȚII DE ÎNVĂȚAT DE LA MOGULUL DE AFACERI ARIANNA HUFFINGTON\r","BUILDERS OF TOMORROW A FUTURE PAVED WITH PLASTIC":"CONSTRUCTORII DE MÂINE, UN VIITOR PAVAT CU PLASTIC\r","JUST HOW VULNERABLE ARE JOBS TO ROBOT TAKEOVERS":"CÂT DE VULNERABILE SUNT LOCURILE DE MUNCA LA PRELUAREA DE CĂTRE ROBOȚI\r","BEST RUGBY SKILLS - STEPS, TRICKS, OFFLOADS COMPILATION":"CELE MAI BUNE ABILITĂȚI DE RUGBY - COMPILAȚIE DE PAȘI, TRUCURI, DESCĂRCĂRI\r","BEST RUGBY SKILLS 2018":"CELE MAI BUNE ABILITĂȚI DE RUGBY 2018\r","BEST RUGBY TRIES 2018":"CELE MAI BUNE ÎNCERCĂRI DE RUGBY 2018\r","CRAZIEST RUGBY SKILLS":"CELE MAI NEBUNE ABILITĂȚI DE RUGBY\r","EPIC RUGBY SKILLS 2017":"ABILITĂȚI EPICE DE RUGBY 2017\r","EPIC RUGBY STEPS 2018":"PAȘI EPICI DE RUGBY 2018\r","RUGBY BIG HITS 2018":"HITURI MARI DE RUGBY 2018\r","DITCH THE DOCTOR! HOW ABOUT DIAGNOSIS BY COMPUTER":"RENUNȚAȚI LA DOCTOR! CE ZICEȚI DE DIAGNOSTIC PRIN CALCULATOR\r","ESPN'S NEW DEAL DIVES INTO THE WORLD OF DRONE RACING":"NOUL ACORD A LUI ESPN SE ARUNCĂ IN LUMEA CURSELOR CU DRONE\r","EVER WISHED BEER COULD FLY NOW IT CAN!":"V-AȚI DORIT VREODATĂ CĂ BEREA AR PUTEA ZBURA, ACUM POATE!\r","HEARING THINGS HERE ARE 5 FACTS ON OUR INNER VOICE":"AUZIȚI CHESTII, IATĂ 5 FAPTE DESPRE VOCEA NOASTRĂ INTERIOARĂ\r","IS SPOTTY SKIN THE ANSWER TO LOOKING YOUNGER":"ESTE PIELEA PATATĂ RASPUNSUL LA UN ASPECT MAI TÂNĂR?\r","JUST WHY ARE THE DUTCH SO TALL":"DE CE SUNT OLANDEZII ATÂT DE ÎNALȚI\r","MEET THE ROBOT THAT WANTS TO GET TO KNOW YOU":"ÎNTÂLNIȚI ROBOTUL CARE VREA SĂ VĂ CUNOASCĂ\r","STAR WARS BECOMES REALITY IN A POST-APOCALYPTIC MALL":"RĂZBOIUL STELELOR DEVINE REALITATE ÎNTR-UN MALL POST-APOCALIPTIC\r","SUGAR TAX THE ANSWER TO OBESITY PANDEMIC":"TAXA PE ZAHĂR, RĂSPUNSUL LA PANDEMIA DE OBEZITATE\r","SWALLOW THIS NANO CHIP TO KNOW WHAT S MAKING YOU SICK":"ÎNGHIȚIȚI ACEST NANOCIP CA SĂ CE VĂ ÎMBOLNĂVEȘTE\r","THE EXPLODING COST OF CYBERATTACKS":"COSTUL EXPLOZIV AL ATACURILOR CIBERNETICE\r","TURNS OUT EMAILS DIDN'T SOLVE OUR WASTE PAPER PROBLEMS":"SE PARE CĂ E-MAILURILE NU NE-AU REZOLVAT PROBLEMELE LEGATE DE DEȘEURI DE HÂRTIE\r","UK DRONE SHOW THE LATEST CONSUMER INDUSTRY TRENDS":"SPECTACOLUL DE DRONE DIN MAREA BRITANIE, CELE MAI RECENTE TENDINȚE DIN INDUSTRIA DE CONSUM\r","VR RUNNING OF THE BULLS! A FEARFUL THRILLSEEKERS DREAM":"ALERGAREA TAURILOR ÎN REALITATE VIRTUALĂ ! VISUL UNUI CĂUTĂTOR DE FIORI ÎNFRICOȘAT\r","AMAZING WATERFALLS ZAMBIA'S JAW-DROPPING NATURAL WONDER":"CASCADE UIMITOARE, MINUNEA NATURALĂ DIN ZAMBIA CARE TE LASĂ CU GURA CĂSCATĂ\r","FAIRY TALE DREAM SPOTS THE PRETTIEST VILLAGE IN ANDALUCÍA":"VISUL DE BASM ZĂREȘTE CEL MAI FRUMOS SAT DIN ANDALUSIA\r","FAIRY TALE DREAM SPOTS THE SINKING CASTLE OF SCALIGERA":"VISUL DE BASM ZĂREȘTE CASTELUL SCUFUNDĂTOR DIN SCALIGERA\r","MEDELLÍN IS THE BACKPACKING SPOT YOU'VE BEEN LOOKING FOR":"MEDELLÍN ESTE DESTINAȚIA DE BACKPACKING PE CARE ÎL CĂUTAȚI\r","SIGHTS WITH HEIGHTS THE NARROW BRIDGES OF CAMINITO DEL REY":"OBIECTIVE TURISTICE CU ÎNĂLȚIMI, PODURILE ÎNGUSTE DIN CAMINITO DEL REY\r","THIS DUTCH PARADE TAKES FLOWER POWER TO THE NEXT LEVEL":"ACEASTĂ PARADĂ OLANDEZĂ DUCE PUTEREA FLORILOR LA NIVELUL URMĂTOR\r","INSTA RESTAURANT WE COULD ALL USE A BIT MORE PINK IN OUR LIVES":"RESTAURANT INSTA, AM PUTEA FOLOSI CU TOȚII UN PIC MAI MULT ROZ ÎN VIAȚA NOASTRĂ\r","KFC IS TESTING MEATLESS CHICKEN WINGS AND NUGGETS":"KFC TESTEAZĂ ARIPI DE PUI ȘI NUGGETURI FĂRĂ CARNE\r","TURNING LEFTOVER BREAD INTO PANZANELLA & BRUSCHETTA CAPRESE":"TRANSFORMAREA RESTURILOR DE PÂINE ÎN PANZANELLA ȘI BRUSCHETTA CAPRESE\r","SALSAS FOR SUNNY DAYS SPICY MANGO SALSA":"SOSURI SALSA PENTRU ZILELE ÎNSORITE, SALSA PICANTĂ DE MANGO\r","VEGAN ICE CREAM AVOCADO BANANA":"ÎNGHEȚATĂ VEGANĂ, BANANĂ ȘI AVOCADO\r","VEGAN ICE CREAM COCONUT FUSION":"ÎNGHEȚATĂ VEGANĂ, FUZIUNE CU NUCĂ DE COCOS\r","VEGAN ICE CREAM FRESH FRUIT POPSICLES":"ÎNGHEȚATĂ VEGANĂ, POPSICLE-URI DIN FRUCTE PROASPETE\r","VEGAN ICE CREAM PINEAPPLE MINT LIME":"ÎNGHEȚATĂ VEGANĂ, ANANAS, MENTĂ ȘI LĂMÂIE VERDE\r","VEGAN ICE CREAM BANANA MATCHA":"ÎNGHEȚATĂ VEGANĂ, BANANA MATCHA\r","BRAIN IMPLANTS ARE CLOSER THAN YOU MIGHT THINK...":"IMPLANTURILE CEREBRALE SUNT MAI APROAPE DECÂT AI PUTEA CREDE ...\r","THANKS, CHAMELEONS HUMANS MIGHT GET COLOR-CHANGING SKIN":"MULȚUMIM, CAMELEONI! OAMENII AR PUTEA OBȚINE O PIELE CARE ÎȘI SCHIMBĂ CULOAREA\r","ARM AND LEG RAISE":"RIDICAREA BRAȚELOR ȘI PICIOARELOR\r","CONDITION TRAINING":"FORMAREA CONDIȚIEI\r","CORE STRENGTH":"PUTEREA PRINCIPALĂ\r","LUNGES":"PLĂMÂNII\r","PUNCH BAG":"SAC DE LOVIT\r","SHADOW BOXING":"BOXUL CU UMBRA\r","STRETCHING":"ÎNTINDERE\r","2016 CHEVROLET CAMARO SS":"2016 CHEVROLET CAMARO SS\r","2016 FORD MUSTANG FASTBACK":"2016 FORD MUSTANG FASTBACK\r","2016 FORD MUSTANG GT4":"2016 FORD MUSTANG GT4\r","2016 TOYOTA PRIUS G RACING CAR":"2016 TOYOTA PRIUS G MAȘINĂ DE CURSE\r","2016 TOYOTA XTREME COROLLA":"2016 TOYOTA XTREME COROLLA\r","ARABIC EPS 1 - HOW TO INTRODUCE YOURSELF":"ARABĂ EPS 1 - CUM SĂ VĂ PREZENTAȚI\r","ARABIC EPS 2 - THANK YO":"ARABĂ EPS 2 - VĂ MULȚUMESC\r","ENGLISH EPS 3 - ASKING ABOUT HOBBIES":"ENGLEZĂ EPS 3 - INTREBARE DESPRE HOBBY-URI\r","ENGLISH EPS 4 - WHERE ARE YOU FROM":"ENGLEZĂ EPS 4 - DE UNDE SUNTEȚI\r","FRENCH EPS 5 - HOW TO APOLOGIZE":"FRANCEZĂ EPS 5 - CUM SĂ VĂ CEREȚI SCUZE\r","FRENCH EPS 6 - ASKING DO YOU SPEAK ENGLISH":"FRANCEZĂ EPS 6 - ÎNTREBAREA VORBIȚI ENGLEZĂ\r","ITALIAN EPS 7- APOLOGIES":"ITALIANĂ EPS 7- SCUZELE\r","ITALIAN EPS 8 - HOW MUCH":"ITALIANĂ EPS 8 - CĂT\r","SPANISH EPS 9 - WHERE ARE YOU FROM":"SPANIOLĂ EPS 9 - DE UNDE SUNTEȚI\r","SPANISH EPS 10 - WHAT'S UP":"SPANIOLĂ EPS 10 - CE MAI FACEȚI\r","HOW TO POST NATAL YOGA BREATHING EXERCISE":"CUM SĂ POSTAȚI UN EXERCIȚIU DE RESPIRAȚIE DE YOGA NATALĂ\r","HOW TO IN 60 SECONDS":"CUM SĂ, ÎN 60 DE SECUNDE\r","HOW TO POST NATAL YOGA - DANDASANA":"CUM SĂ POSTAȚI YOGA NATALĂ - DANDASANA\r","HOW TO POST NATAL YOGA - IF BABY NEEDS ENTERTAINMENT":"CUM SĂ POSTAȚI YOGA NATALĂ - DACĂ COPILUL ARE NEVOIE DE DIVERTISMENT\r","PILATES HALF ROLL BACK":"EXERCIȚIU PILATES JUMĂTATE DE RULĂ ÎNAPOI\r","BECOME FLEXIBLE WITH YOGA":"DEVENIȚI FLEXIBIL CU YOGA\r","FIND PEACE AT HOME WITH YOGA":"GĂSIȚI PACE ACASĂ CU YOGA\r","FIND PEACE WITH YOGA":"GĂSIȚI PACE CU YOGA\r","GET SLIM & FIT WITH YOGA":"DEVENIȚI SLIM ȘI FIT CU YOGA\r","LEARN THE ART OF YOGA":"ÎNVĂȚAȚI ARTA DE YOGA\r","LOST WEIGHT WITH YOGA":"SLĂBIȚI CU YOGA\r","MASTER CORE YOGA POSES":"STĂPÂNIȚI POZELE DE BAZĂ DE YOGA\r","MIND OVER MATTER":"MINTE ASUPRA MATERIEI\r","ULTIMATE YOGA GUIDE":"GHID ULTIM DE YOGA\r","YOGA VILLAGE":"SATUL YOGA\r","YOGA YOUR WAY TO HEALTHY LIVING":"YOGA-ȚI-VĂ DRUMUL SPRE VIAȚA SĂNĂTOASĂ\r","ANIMALS EXOTICOS":"ANIMALE EXOTICE\r","AUTOMATU":"AUTOMATU\r","BABIES AND MOVING TABLE PART 1":"BEBELUȘI ȘI MESE ÎN MIȘCARE PARTEA 1\r","BAD KIDS THROW ORANGE PEELS PART 1":"COPIII RĂI ARUNCĂ COJI DE PORTOCALE PARTEA 1\r","BIG BUNNY SCARES BABIES PART 1":"IEPURAȘUL MARE SPERIE BEBELUȘII PARTEA 1\r","BODYGUARDS":"GĂRZI PERSONALE\r","CAKE ON FACE":"TURTĂ PE FAȚĂ\r","CAN I CLICK YOUR PHOTO":"POT FACE CLIC PE POZA DVS.\r","CAR PARKING":"PARCARE MAȘINI\r","CAR FOR SALE":"MAȘINĂ DE VÂNZARE\r","MAN FALLING ON LADDER":"OMUL CARE CADE PE SCARĂ\r","MAN IN GARBAGE CAN PART 1":"OMUL ÎN COȘ DE GUNOI PARTEA 1\r","PAINTING EXHIBITION":"EXPOZIȚIE DE PICTURĂ\r","RECKLESS BLIND MAN PART 1":"ORB NESĂBUIT PARTEA 1\r","ROLLER BLADER PART 1":"ROLLERBLADER PARTEA 1\r","RUDE MAN ON BEACH PART 1":"OM NEPOLITICOS PE PLAJA PARTEA 1\r","SANTA CLAUS THE PERVERT PART 1":"PERVERSUL MOȘ CRĂCIUN PARTEA 1\r","BABY CARIER ON CAR":"CĂRUCIOR PENTRU BEBELUȘI PE MAȘINĂ\r","BLEEDING NOSE":"NAS SÂNGERĂTOR\r","MONEY FALLING":"CĂDEREA DE BANI\r","OPEN THIS PEN":"DESCHIDEȚI ACEST PIX\r","GLAMOROUS TOUCH":"ATINGERE GLAMOROSĂ\r","LIPS GLAMOROUS RED":"BUZE, ROȘU GLAMOROS\r","LIPS NATURAL":"BUZE, NATURALE\r","LIPS SPARKLING AND FULL":"BUZE, STRĂLUCITOARE ȘI PLINE\r","MAKE-UP BLUSH":"BLUSH DE MACHIAJ\r","MAKE-UP BRONZER":"BRONZĂTOR DE MACHIAJ\r","MAKE-UP CONCEALER":"CORECTOR DE MACHIAJ\r","MAKE-UP EYEBROWS":"SPRÂNCENE DE MACHIAJ\r","MAKE-UP FOUNDATION":"FUNDAȚIE MACHIAJ\r","SMOKEY EYES":"OCHI FUMURII\r","SPARKLING EYES":"OCHI STRĂLUCITORI\r","5 MAKE UP TIPS AND TRICKS FOR YOU":"5 SFATURI ȘI TRUCURI DE MACHIAJ PENTRU DVS.\r","7 MAKE UP TIPS AND TRICKS FOR FLAWLESS SKIN":"7 SFATURI ȘI TRUCURI DE MACHIAJ PENTRU O PIELE IMPECABILĂ\r","10 FAST AND EASY MAKE UP TIPS":"10 SFATURI RAPIDE ȘI UȘOARE DE MACHIAJ\r","10 MAKE UP TIPS AND TRICKS FOR OILY SKIN":"10 SFATURI ȘI TRUCURI DE MACHIAJ PENTRU O PIELE GRASĂ\r","13 MAKE UP MISTAKES TO AVOID":"13 GREȘELI DE MACHIAJ DE EVITAT\r","101 TIPS FOR BEGINNER MAKE UP":"101 SFATURI PENTRU MACHIAJUL ÎNCEPĂTOR\r","ASIAN BEAUTY TIPS YOU MUST DO NOW":"SFATURI DE FRUMUSEȚE ASIATICE PE CARE TREBUIE SĂ LE FACEȚI ACUM\r","BEGINNER EVERY MAKE UP TIPS AND TRICKS FOR YOU":"ÎNCEPĂTOARE, TOATE SFATURILE ȘI TRUCURILE DE MACHIAJ PENTRU DVS.\r","BEST MAKE UP ARTIST TIPS YOU NEED TO KNOW":"CELE MAI BUNE SFATURI DE MAKE-UP ARTIST PE CARE TREBUIE SĂ LE ȘTIȚI\r","ESSENTIAL MAKE UP TIPS FOR SUMMER GLOW":"SFATURI DE MACHIAJ ESENȚIALE PENTRU STRĂLUCIRE DE VARĂ\r","FLATTERING EYES MAKE UP FOR YOU":"MACHIAJ CU OCHII MĂGULITORI PENTRU DVS.\r","FOUNDATION TRICKS FOR OILY SKIN":"TRUCURI CU FUNDAȚIA PENTRU O PIELE GRASĂ\r","FULL COVERAGE FOUNDATION ROUTINE FOR YOU":"RUTINĂ DE FUNDAȚIE CU ACOPERIRE COMPLETĂ PENTRU DVS.\r","LOOK FIERCE WITH DRUGSTORE MAKE UP":"ARĂTAȚI FEROCE CU MACHIAJUL FARMACIEI\r","MAKE UP ESSENTIALS FOR DARK SKIN TONES":"ELEMENTE ESENȚIALE DE MACHIAJ PENTRU TONURILE DE PIELE ÎNCHISE\r","MAKE UP TIPS FOR AGING EYES":"SFATURI DE MACHIAJ PENTRU OCHI CE SE ÎMBĂTRÂNESC\r","MAKE UP TIPS FOR FLAWLESS SKIN":"SFATURI DE MACHIAJ PENTRU O PIELE IMPECABILĂ\r","MUST KNOW MAKE UP TIPS":"SFATURI DE MACHIAJ CARE TREBUIE ȘTIUTE\r","MUST KNOW WAKE UP TIPS":"SFATURI DE TREZIRE CARE TREBUIE ȘTIUTE\r","NATURAL MAKE UP KOREAN STYLE":"MACHIAJ NATURAL, STIL COREEAN\r","NATURAL MAKE UP TIPS FOR MEN":"SFATURI DE MACHIAJ NATURAL PENTRU BĂRBAȚI\r","NATURAL TO GLAMOROUS":"DE LA NATURAL LA GLAMOROS\r","OVER 40 AGED WOMAN MAKE UP TIPS":"SFATURI DE MACHIAJ PENTRU FEMEI PESTE 40 DE ANI\r","PRO MAKE UP TIPS BY TATI":"SFATURI PRO DE MACHIAJ DE CĂTRE TATI\r","SECRET MAKE UP TIPS AND TRICKS FOR BEGINNERS":"SFATURI ȘI TRUCURI SECRETE DE MACHIAJ PENTRU ÎNCEPĂTORI\r","SIMPLE TIPS FOR EYESHADOW":"SFATURI SIMPLE PENTRU FARD DE PLEOAPE\r","SUMMER MAKE UP MELTPROOF TIPS":"SFATURI DE MACHIAJ DE VARĂ REZISTENT LA TOPIRE\r","TOP 10 SECRET TIPS OF CELEBRITIES":"TOP 10 SFATURI SECRETE ALE VEDETELOR\r","TOP 25 MAKE UP TIPS FOR PALE SKIN":"TOP 25 SFATURI DE MACHIAJ PENTRU O PIELE PALIDĂ\r","TYRA BANKS MAKE UP TIPS":"SFATURI DE MACHIAJ DE CĂTRE TYRA BANKS","withdraw_from_contract":"Retragere din contract"}

/***/ }),

/***/ "./src/translations/si.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"Domov","sidebar.myaccount":"Moj račun","sidebar.notif":"Obvestilo","sidebar.nonotif":"Še nimate obvestil","html5games":"HTML5 igre","androidGames":"Android igre","android-upper":"ANDROID","favorite":"Najljubše","splashscreen.text":"Igrajte Way Beyond","welcome.text":"RAZISKUJTE NAJBOLJŠE MOBILNE IGRE NA MREŽI DANES!","welcome.text.gamiclub":"RAZISKUJTE NAJBOLJŠO VSEBINO NA MREŽI DANES!","accountDetails":"PODROBNOSTI RAČUNA","accountName":"IME","accountEmail":"E-NASLOV","accountLocation":"LOKACIJA","accountInterests":"INTERESI","accountChooseCategory":"Izberite 3 kategorije","accountEditPhoto":"UREDI FOTOGRAFIJO","save":"Shrani","topCategories":"NAJVIŠJE KATEGORIJE","favGames":"NAJLJUBŠE IGRE","viewAll":"POGLEJ VSE","noGamesFound":"Nobene igre niso bile najdene v tej kategoriji","noVideosFound":"Nobeni videi niso bili najdeni v tej kategoriji","cancel":"Prekliči","gameDirectories":"IMENIKI IGRE","category":"Kategorija","platform":"Platforma","type":"Vrsta","android":"ANDROID","games":"igre","html5":"HTML5","videos":"VIDEJI","search.input.placeholder":"Išči...","search.cancel.button":"Prekliči","description":"Opis","downloadNow":"PRIDOBITE ZDAJ","playNow":"IGRAJTE ZDAJ","rate":"Ocenite","relatedGames":"PODOBNE IGRE","noFavGames":"Še ni najljubših iger","addFavGames":"Dodajte svoje najljubše igre za enostaven dostop in igranje brez težav","discover":"ODKRIJTE","noFavGamesFound":"Nobene najljubše igre niso bile najdene.","favorites":"Najljubše","accessDenied":"Dostop Zavrnjen","pageRestricted":"Stran, ki jo iščete, je omejena.","averageRatingBasedOn":" povprečna ocena uporabnikov na podlagi ","averageRatingReview":" ocene","tnc":"Pogoji in določila","contact_us":"Kontaktirajte nas","areYouAlready":"Ali ste že član ","thenConfirm":"Potem potrdite svoje mobilno številko in pridobite neomejen dostop do vseh naših <strong> HTML5 </strong> in <strong> Android </strong> iger","login":"Prijava","Action":"Akcija","Adventure":"Avantura","Arcade":"Arkada","Sport":"Šport","Racing":"Dirke","Premium Games":"Premium igre","RPG":"RPG","Virtual Reality":"Virtualna realnost","Motivation":"Motivacija","Tour":"Turizem","Fun Gaming":"Zabavno igranje","Athletics":"Atletika","Inspiration":"Inpiracija","Casual":"Priložnostno","Adrenaline Rush":"Adrenalinski udar","Into Nature":"V naravo","Political & Activism":"Politika in aktivizem","Travel":"Potovanje","Foodbuzz":"Foodbuzz","Health and Nutrition":"Zdravje in prehrana","Fitness":"Fitnes","Top Cars":"Najboljši avtomobili","Fashion & Beauty":"Moda in lepota","E-Learning":"E-učenje","Yoga":"Joga","Just For Laugh":"Samo za smeh","Brain Boost":"Povečanje možganske moči","Rugby":"Ragbi","Economy":"Gospodarstvo","Environment":"Okolje","Gaming":"Igranje","Lifestyle":"Življenjski slog","Local Heroes":"Lokalni junaki","Sports":"Šport","Technology":"Tehnologija","Tutorials":"Vodniki","New Arrivals":"Nove prihajajoče","noFavVideos":"Še ni najljubših videov","addFavVideos":"Dodajte svoje najljubše videe za enostaven dostop in gledanje brez težav","noFavVideosFound":"Nobeni najljubši videi niso bili najdeni.","footer.copyright.gamiclub":"&copy; 2020 Gamiclub. Vse pravice pridržane","footer.copyright.gameflares":"&copy; 2024 Gameflares. Vse pravice pridržane","footer.copyright.gamiway":"&copy; 2020 Gamiway. Vse pravice pridržane","vid-player":"predvajalnik","privacyPolicy":"Politika zasebnosti","privacy-policy-title":"","privacy-policy-desc":"Ta Politika zasebnosti pojasnjuje naše obveznosti in vaše pravice v zvezi z vašimi informacijami. Politiko zasebnosti bi morali natančno prebrati. Če se ne strinjate s to Politiko zasebnosti, prosimo, ne uporabljajte naših spletnih mest ali storitev. Politika zasebnosti je ustrezno vključena in podvržena Pogoji uporabe ter ureja iste storitve in spletna mesta kot tiste, navedene v Pogojih uporabe. Kakršni koli izrazi, ki jih uporabljamo v Politiki zasebnosti, ne da bi jih definirali, imajo enako definicijo kot v Pogojih uporabe.","privacy-policy-collect-info-head":"ZBIRAMO INFORMACIJE NA NASLEDNJE NAČINE:","privacy-policy-collect-info-desc1":"1. Ko nam jo posredujete ali nam dovoljujete, da jo pridobimo. Če se odločite za naročnino na storitev pri nas, bomo mi ali mobilni operater vaše mreže zbrali vaše informacije, povezane s plačilom za naročnino na naše storitve. Informacije o računu in obračunu, ki jih zbere mobilni operater, so predmet njihovih ustreznih politik zasebnosti.","privacy-policy-collect-info-desc2":"2. Pridobimo tehnične informacije, ko obiščete naša spletna mesta in/ali storitve. Tehnične informacije o vas lahko zbiramo, kadar koli uporabljate naše storitve. Zbiramo podatke o dnevniku vsakič, ko se prijavite ali odjavite iz naših storitev.","privacy-policy-how-collect-info-head":"KAKO UPORABLJAMO ZBIRANE INFORMACIJE","privacy-policy-how-collect-info-subhead":"Vaše informacije lahko uporabimo za naslednje namene:","privacy-policy-how-collect-info-desc1":"Provide the Service(s) you request;","privacy-policy-how-collect-info-desc2":"Zaračunati in zbrati plačilo za storitev(e), ki vam je bila(j) zagotovljena(a);","privacy-policy-how-long-head":"KAKO DOLGO HRANIMO VAŠE INFORMACIJE","privacy-policy-how-long-desc":"Vaše informacije bomo hranili, dokler bo to potrebno za zagotavljanje naših storitev vam. Vaše informacije bomo hranili, kolikor je potrebno za izpolnjevanje naših pravnih obveznosti, reševanje sporov in uveljavljanje naših dogovorov. Ko jih ne bomo več potrebovali in ne bo potrebe, da jih hranimo za izpolnjevanje naših pravnih ali regulativnih obveznosti, jih bomo bodisi odstranili iz naših sistemov bodisi depersonalizirali, tako da vas ne bomo mogli več identificirati.","privacy-policy-how-long-protect-head":"KAKO ŠČITIMO VAŠE INFORMACIJE TUDI IZVEN EU","privacy-policy-how-long-protect-desc1":"Zaskrbljeni smo za zaščito vaše zasebnosti in podatkov, vendar ne moremo zagotoviti ali jamčiti varnosti informacij, ki nam jih posredujete, ali zagotoviti, da vaših informacij ne morejo dostopati, razkriti, spremeniti ali uničiti zaradi kršitve katere koli od naših standardnih fizičnih, tehničnih ali upravljalskih zaščit. Sprejemamo ustrezne prakse zbiranja, shranjevanja in obdelave podatkov ter varnostne ukrepe za zaščito pred nepooblaščenim ali naključnim dostopom, spremembo, razkritjem ali uničenjem vaših informacij, informacij o transakcijah in podatkov, shranjenih v naših storitvah","privacy-policy-how-long-protect-desc2":"Zaskrbljeni smo za zaščito vaše zasebnosti in podatkov, vendar ne moremo zagotoviti ali jamčiti varnosti informacij, ki nam jih posredujete, ali zagotoviti, da vaših informacij ne morejo dostopati, razkriti, spremeniti ali uničiti zaradi kršitve katere koli od naših standardnih fizičnih, tehničnih ali upravljalskih zaščit. Sprejemamo ustrezne prakse zbiranja, shranjevanja in obdelave podatkov ter varnostne ukrepe za zaščito pred nepooblaščenim ali naključnim dostopom, spremembo, razkritjem ali uničenjem vaših informacij, informacij o transakcijah in podatkov, shranjenih v naših storitvah","privacy-policy-how-long-protect-desc3":"Ker delujemo mednarodno, so lahko vaše informacije, vključno z osebnimi podatki, prenesene in na voljo v ZDA/Singapurju in/ali v katerikoli drugi državi, ki ni vaša država prebivališča. Tudi v teh državah skrbimo, da zaščitimo vaše osebne podatke.","privacy-policy-acceptance-head":"Sprejemanje politike zasebnosti","privacy-policy-acceptance-desc":"Z uporabo katerekoli od naših storitev soglašate z zbiranjem in uporabo vaših informacij v skladu s to politiko zasebnosti. Pridržujemo si pravico, da to politiko zasebnosti kadarkoli spremenimo z objavo sprememb na tej strani. Prosimo, preverite datum revizije na dnu te strani, da ugotovite, ali je bila politika spremenjena od vaše zadnje preglede. Vaša nadaljnja uporaba kateregakoli dela našega spletnega mesta ali storitev po objavi posodobljene politike zasebnosti bo štela kot vaše sprejemanje sprememb.","privacy-policy-changes-head":"SPREMEMBE TE POLITIKE ZASEBNOSTI","privacy-policy-changes-desc":"Občasno lahko spremenimo našo politiko zasebnosti. Če se odločimo spremeniti našo politiko zasebnosti, bomo te spremembe objavili na tej strani, tako da boste vedno imeli dostop do najnovejše politike zasebnosti.","privacy-policy-contact-us":"KONTAKTIRANJE Z NAMI","privacy-policy-contact-us-desc":"Če imate vprašanje glede te politike zasebnosti, praks spletnih mest ali svojih poslovanj s spletnimi mesti, nas prosimo kontaktirajte tako, da pošljete e-pošto na si-gamingclub@cchelp.co.","unsubscribe":"Odjava","terms-condition-title":"Pravila in pogoji","gen-terms-condition-title":"Splšna pravila in pogoji ter politika zasebnosti.","gen-terms-condition-desc":"Naslednja splošna pravila in pogoji veljajo za proizvode in storitve, ki jih prek WAP-a, SMS-a, GPRS-a in 3G zagotavlja Sam Media Ltd. ali podjetja, povezana z njo (v nadaljevanju 'Zagotovitelj'). Zagotovitelj ima pravico, da ta splošna pravila in pogoje občasno spreminja brez predhodnega obvestila. Poleg splošnih pravil in pogojev se na vas in Zagotovitelja ob uporabi storitev (kot je opredeljeno tukaj) uveljavijo tudi morebitna veljavna in objavljena pravila, promocijski pogoji, smernice in določila, ki se nanašajo na storitve. Vse te smernice, pravila, promocijski pogoji in določila bodo šteta za nerazdružljiv del teh splošnih pravil in pogojev. Z uporabo storitev Zagotovitelja se strinjate, da vas vežejo ta splošna pravila in pogoji ter smernice, pravila in promocijski pogoji.","provider-terms-condition-title":"Opis Zagotovitelja.","provider-terms-condition-desc":"S pomočjo storitev WAP, SMS, GPRS in 3G Zagotovitelj uporabnikom omogoča dostop do mreže spletnih virov, vključno s spletnimi igrami, besedilnimi sporočili, bogato vsebino in spletnimi informacijskimi materiali, ki jih je mogoče prenesti na mobilni telefon ali druge naprave ('Storitve'). Splošna pravila in pogoji se ves čas uporabljajo za vse nove naprave, vključno z napravami, ki jih lahko Zagotovitelj uvede v okviru širitve, razširitve ali izboljšanja trenutnih storitev, vključno z vsako razširitvijo na nove funkcije, ki jih doda Zagotovitelj.","availability-terms-condition-title":"Dostopnost","availability-terms-condition-desc":"Storitev se zagotavlja takšna, kot je (v fazi razvoja, v kateri se nahaja), in Zagotovitelj ne prevzema nobene odgovornosti niti ne daje nobenih garancij ali jamstev v primeru, da osebne konfiguracije, informacije ali sporočila niso shranjena, niso shranjena pravočasno ali če so izbrisana ali napačno dostavljena. Za naročilo storitve morate imeti dostop do interneta in/ali naročnino na mobilne komunikacije ter plačati vse stroške storitev, povezane s takšnim dostopom. Dolžni ste poravnati vse stroške, ki nastanejo pri ustvarjanju takšnega dostopa. Prav tako ste odgovorni za povezovanje vse potrebne opreme, vključno z mobilnim telefonom, osebnim računalnikom ali drugimi napravami, ki so lahko potrebne in so v delovnem stanju ter primerne za uporabo v povezavi s storitvijo.","payment-terms-condition-title":"Plačilo","payment-terms-condition-desc":"Dostopate do naših spletnih storitev brezplačno. V zvezi s storitvami in njihovo uporabo boste plačali znesek, ki ustreza veljavnim tarifam Zagotovitelja, ki so v tistem trenutku v veljavi, in glede na tarife, ki jih zaračunava vaš mobilni operater. Stroški vam bodo zaračunani prek vašega mobilnega operaterja na mobilnem računu, ki ga prejemate od mobilnega operaterja vaše mreže. Zagotovitelju plačate vse nacionalne, lokalne ali druge davke, vključno, vendar ne omejeno na DDV, vse davke ali dajatve, ki jih nadomestijo, pri čemer so ti davki temelji na stroških zaradi uporabe storitev, ne glede na to, ali so ti davki zaračunani zdaj ali v prihodnosti s strani evropskih, nacionalnih ali lokalnih oblasti ali katerekoli druge avtoritete ali organov, pooblaščenih za pobiranje davkov. Zagotovitelj si pridržuje pravico do spremembe tarif za storitev z objavo podrobnosti takšnih sprememb na svoji spletni strani.","obligation-terms-condition-title":"Obveznost registracije","obligation-terms-condition-desc":"Da bi zagotovili varno in zanesljivo uporabo storitve, zagotavljate naslednje, poleg plačila ustreznih stroškov: (a) vaše osebne informacije (v nadaljevanju 'Registrirane informacije'), ki ste jih navedli na registracijskem obrazcu, so pravilne, resnične, natančne in popolne, ter (b) strinjate se, da boste zagotovili, da so Registrirane informacije ves čas pravilne, posodobljene, resnične, natančne in popolne. Če ima Zagotovitelj utemeljeno sum, da Registrirane informacije ne odražajo resničnega stanja ali niso natančne ali popolne, ima pravico, da začasno ustavi ali prekine vaš račun ter zadrži tako trenutno kot prihodnjo uporabo storitve ali katerega koli njenega dela. Sami ste odgovorni za ohranjanje skrivnosti vseh gesel in/ali računov, ki vam jih je dodelil Zagotovitelj, in ste popolnoma odgovorni za vse dejavnosti, ki jih opravite z uporabo vašega gesla ali računa. Obvezujete se, da ob koncu vsake seje zaprete svoj račun (s tako, da zaprete svoj brskalnik) in da kontaktirate Zagotovitelja, če opazite ali sumite, da je bilo nepooblaščeno uporabo vašega gesla ali računa, ali da varnost ali zaščita iz kakršnega koli drugega razloga ni več zagotovljena. Zagotovitelj ne more in ne bo odgovoren za nobeno škodo, ki nastane zaradi vaše nespoštovanja določil tega člena.","ownership-terms-condition-title":"Pravice lastništva Zagotovitelja.","ownership-terms-condition-desc":"Naslednja splošna pravila in pogoji veljajo za proizvode in storitve, ki jih prek WAP-a, SMS-a, GPRS-a in 3G zagotavlja Sam Media Ltd. ali podjetja, povezana z njo (v nadaljevanju 'Zagotovitelj'). Zagotovitelj ima pravico, da ta splošna pravila in pogoje občasno spreminja brez predhodnega obvestila. Poleg splošnih pravil in pogojev se na vas in Zagotovitelja ob uporabi storitev (kot je opredeljeno tukaj) uveljavijo tudi morebitna veljavna in objavljena pravila, promocijski pogoji, smernice in določila, ki se nanašajo na storitve. Vse te smernice, pravila, promocijski pogoji in določila bodo šteta za nerazdružljiv del teh splošnih pravil in pogojev. Z uporabo storitev Zagotovitelja se strinjate, da vas vežejo ta splošna pravila in pogoji ter smernice, pravila in promocijski pogoji.","FINDING MENG":"ISKANJE MENGA","ALCHEMY JAM":"ALKIMIJSKI DŽEM","CELL MACHINE":"CELIČNA NAPRAVA","TALES OF THE ORIENT - THE RISING SUN":"ZGODBE ORIENTA - VZHAJAJOČE SONCE","MR RACER":"GOSPOD DIRKAČ","WOODVENTURE":"LESNA PUSTOLOVŠČINA","FRUIT DATING":"ZMENKI Z SADJEM","PIRATES! THE MATCH-3":"PIRATI! MATCH-3","ZOMBUMP 372":"ZOMBUMP 372","CARE FORT":"SKRB ZA TRDNJAVO","SHARDS":"DELCI","DOODLE GOD FANTASY WORLD OF MAGIC":"DOODLE GOD: FANTAZIJSKI SVET MAGIJE","HELICOPTER FIGHTER":"HELIKOPTERSKI BOREC","GUN STRIKE FIRE":"STRELSKA AKCIJA","BAD SPIDER THIEF":"SLAB PAJKOV TAT","CAR RACING SPEED":"HITROST DIRKE AVTOMOBILOV","CHAINSAW MAN FIGHTER":"BOJEVNIK S SEKIRNO","GENIAL SANTA CLAUS2":"GENIALNI BOŽIČEK 2","SRCH":"ISKANJE","DOODLE GOD 8-BIT MANIA":"DOODLE GOD: 8-BITNA NOROST","WORLD OF WIZARDS":"SVET ČAROVNIKOV","DEATH BY NINJA":"SMRT ZARADI NINJA","MALDIVES FRIENDS":"PRIJATELJI MALDIVOV","ABSOLUTE TALENT":"ABSOLUTNI TALENT","CARD-JITSU":"KARTIČNA JITSU","CAVEMAN CHUCK ADVENTURE":"PUSTOLOVŠČINA PRAČLOVEKA CHUCKA","FIRE LORDS":"GOSPODARJI OGNJA","VINTAGE TRIPEAKS":"VINTAGE TRI VRHOVI","CALL OF SNIPER WW2":"KLIC SNAJPERJA WW2","GREEN DINO RUN":"ZELENI DINOZAVER: DIRKA","CHRISTMAS GIFT SHOOT":"STRELJANJE BOŽIČNIH DARIL","DOODLE KINGDOM":"DOODLE KRALJESTVO","CHARLIE THE DINO RESCUE TEAM":"CHARLIE, EKIPA ZA REŠEVANJE DINOZAVROV","BLOCK PUZZLE":"BLOKOVKA","GUESS CELEB NAMES":"UGANI IMENA ZNANIH OSEB","DOODLE TANKS":"DOODLE TANKI","LEGENDARY TOWER STRATEGY":"LEGENDARNA STRATEGIJA STOLPA","POOL PRO":"PROFI BILJARD","TINY MINER":"MAJHN RUDAR","JAIL PRISON BREAK 2018":"ZBEŽNIK IZ ZAPORA 2018","CALL OF SNIPER DUTY":"KLIC DOLŽNOSTI SNAJPERJA","PIXEL ART BOOK - COLOR BY NUMBER":"KNJIGA UMETNOSTI S PIKSELII - BARVAJ PO ŠTEVILKAH","SACRA TERRA KISS OF DEATH":"SACRA TERRA POLJUB SMRTI","SPIDER SIMULATOR AMAZING CITY 3D":"SIMULATOR PAJKA: NEVERJETNO MESTO 3D","TNT KART":"TNT KART","FPS SHOOTER COUNTER TERRORIST":"FPS STRELEC: PROTITERORIST","STEREOTYPO":"STEREOTIP","LAZY NINJA":"LENOBNI NINJA","US POLICE TRAIN TRANSPORTER TRUCK ROBOT STUNT GAME":"IGRA ROBOTA ZA PREVOZ POLICIJSKEGA VLAKA ZDA","TURBO RACER":"TURBO DIRKAČ","BAZOOKA GUNNER WAR STRIKE 3D":"BAZOOKAR: VOJNA AKCIJA 3D","3D BATTLE TRUCK":"3D BOJNI TOVORNJAK","NEED THE SPEED":"POTREBUJEM HITROST","WILD ANIMAL REAL HUNTER WILD SHOOTING GAMES":"PRAVI LOVEC NA DIVJE ŽIVALI: DIVJE STRELJAŠKE IGRE","GLORY WARRIOR LORD OF DARKNESS":"SLAVNI BOJEVNIK: GOSPODAR TEME","SEA FISHING":"MORSKO RIBOLOV","BARDBARIAN":"BARBAR BARD","RONALDO KICK N RUN":"RONALDO: UDAREC IN BEŽANJE","DEMONS AND DUNGEONS":"DEMONTI IN JEČE","LEGENDARY HEROES":"LEGENDARNI JUNAKI","RISE OF NATION FAITH":"VZPON VERE NARODA","FRACTAL COMBAT X":"FRAKTALNI BOJ X","CHRISTMAS NIGHT OF HORROR":"BOŽIČNA NOČ GROZE","BEAR HAVEN":"ZAVETIŠČE MEDVEDOV","NIGHTS AT TATTLETAIL HOUSE 3D":"NOČI V HIŠI TATTLETAIL 3D","WILD ANIMAL ZOO CITY SIMULATOR":"SIMULATOR MESTNEGA ZOOLOŠKEGA VRTA DIVJIH ŽIVALI","LORD OF MAGIC":"GOSPOD MAGIJE","FRIDAY 13TH JASON KILLER":"PETEK 13 JASONOV UBIJALC","MIGHTY DUNGEONS":"MOČNE JEČE","ETERNAL THRONE":"VEČNI PRESTOL","KONAN SURVIVAL BARBARIAN EXILE":"KONAN: PREŽIVETJE BARBARINA V IZGNANSTVU","HIGHWAY DRIVER 3D":"VOŽNJA PO AVTOCESTI 3D","SNIPER TEAM 3D":"EKIPA SNAJPERJEV 3D","PULIMURUGAN 3D":"PULIMURUGAN 3D","ILLAM ESCAPE VR":"POBEG IZ ILLAMA VR","PULIMURUGAN":"PULIMURUGAN","HIGHWAY SPEED MOTO BIKE DRIVER":"VOŽNJA MOTORJA PO AVTOCESTI","CONTRACT HUNTER ZOMBIE KILLER":"POGODBENI LOVEC: UBIJALC ZOMBIEV","ARMY VEHICLE MADNESS":"NOROST VOJAŠKIH VOZIL","AIR RACING":"ZRAČNE DIRKE","GUNSHIP BATTLE OF WORLD HELLICOPTERS":"BITKA HELIKOPTERJEV SVETOVNE VOJSKE","COMMANDO COMBAT TRAINING 3D":"USPOSABLJANJE KOMANDOSA 3D","HELI AIR GUNSHIP STRIKE WAR":"ZRAČNI NAPAD HELIKOPTERJEV: VOJNA","DEAD ORBIT":"MRTVA ORBITA","360 NINJA":"360 NINJA","EYES - THE HORROR GAME":"OČI - IGRA GROZE","SPACE EXPEDITION":"VESOLJSKA EKSPEDICIJA","COMBANT DUTY MODERN STRIKE":"MODERNA NALOGA V BOJU","FRONTLINE COMMANDO WAR ONE MAN ARMY":"VOJNA NA PRVI ČRTI: EN ČLOVEK, VOJSKA","INCREDIBLE MONSTER HERO SUPER PRISON ACTION":"NEVERJETNI JUNAK POŠASTI: SUPER ZAPORNIŠKA AKCIJA","NINJA CLASH":"NINJA SPOPAD","ARMY PHYSICS PALACE":"VOJAŠKA FIZIKA: PALAČA","SEA BATTLE":"MORSKA BITKA","ULTIMATE UNDEAD INVASION APOCALYPSE":"KONČNA INVAZIJA NEDOUMNIH: APOKALIPSA","DEAD ROADKILL HIGHWAY":"MRTVA AVTOCESTA: UBILAŠKA POT","SHOOTING KING BOTTLE SHOOT":"KRALJ STRELJANJA: STRELJANJE STEKLENIC","SNIPER CAR 3D":"SNAJPERJI AVTO 3D","AIR STRIKE WAR":"ZRAČNI NAPAD: VOJNA","CRIMINAL PURSUIT 3D":"KRIMINALNA SLEDENJA 3D","COMBAT MENACE MADNESS 3D":"BOJEVANJE: NOROST 3D","RICE OF NOTION FAITH":"RIŽ PREPRIČANJA","GRAVITY RACE BOY":"FANT GRAVITACIJSKE DIRKE","AEROPLANE PARKING GAME":"IGRA PARKIRANJA LETALA","CIRCUS RESCUE":"REŠEVANJE CIRKUSA","NINJA COMBAT SAMURAI WARRIOR":"NINJA BOJEVANJE: SAMURAJSKI JUNAK","GRAND CRIME GANGSTA VICE MIAMI":"VELIKI KRIMINAL: GANGSTER VICE MIAMI","BODYGUARD":"TELOHRANITELJ","ASIAN RANGER MADNESS":"AZIJSKI RANGER: NOROST","FLIGHT COMBAT":"ZRAČNO BOJEVANJE","SONNY THE MAD MAN":"SONNY NORI ČLOVEK","SUBWAY SURFERS - NEW YORK":"PODZEMNI SURFERJI - NEW YORK","TOWER DEFENSE 2D":"OBRANA STOLPA 2D","WILD RUN":"DIVJI TEK","GOOD KNIGHT PRINCESS RESCUE":"DOBER VITEZ: REŠEVANJE PRINCESKE","DINOSAUR HUNTER":"LOVEC NA DINOZAVRE","ASSAULT FURY MISSION COMBAT":"NAPADNA JEZA: BOJNA NALOGA","HAUNTED LEGENDS UNDERTAKER":"UBOGI LEGEND: POKOPALIŠČE","BORDER WAR ENEMY TERRITORY":"MEJNA VOJNA: SOVRAŽNO OZEMLJE","PUSHING BOY":"FANT, KI POTISKA","CHOPTER MANIA":"NOREČNOST HELIKOPTERJEV","IMPOSSIBLE ESCAPE 3D":"NEMOGOČI POBEG 3D","DINO HUNTING 2018":"LOV NA DINOZAVRE 2018","TEMPLE RUMBLE JUNGLE ADVENTURE":"TEMPPEL: BITKA V DŽUNGLI","CRAZY BOAT RACE":"NORA DIRKA ČOLNOV","CAT RUN":"MAČJI TEK","JURASSIC MANIA":"JURSKA NOROST","FLYING KNIFE":"LETALIŠKI NOŽ","BLOW YOUR WAY":"PIHAJ SI POT","CLIMBING NINJA":"NINJA PLEZANJE","SPELLING MASTER":"UČITELJ ČRKVOVANJA","GUESS AND FIND":"UGANI IN NAJDI","MATH GAMES":"MATEMATIČNE IGRE","TRIVIA QUIZZES":"TRIVIALNI KVIZI","NINJA GIRL SWING":"NINJA DEKLICA: GUGALNICA","MATCH CONNECT":"POVEŽI PARE","POEMS LOVE FAMILY FRIENDS":"PESMI: LJUBEZEN, DRUŽINA, PRIJATELJI","HIGH FLY VALENTINE":"VISOKOLETEČI VALENTIN","PIXEL SURVIVAL DEAD ZOMBIE":"PREŽIVETJE PIKSLOV: MRTVI ZOMBJI","COLONIES":"KOLONIJE","HOROSCOPE":"HOROSKOP","HIDDEN NUMBERS":"SKRITE ŠTEVILKE","IMPOSSIBLE BALL GLOW TWIST":"NEMOGOČA ŽOGA: SVETLEČ OBRAZ","WORD CONNECT":"POVEŽI BESEDE","KAHVE FALI":"KAVA: NAPOVED","HIT DODGE ZBANG":"ZADENI IN SE IZOGNI: ZBANG","RACE AGAINST THE TRAFFIC":"DIRKA PROTI PROMETU","SKI NINJA":"NINJA SMUČAR","REAL CAR DIFT RACE MANIA 3D":"RESNIČNA DRIFT DIRKA AVTOMOBILOV 3D","2 MOTO CAR RACING":"2 MOTO DIRKE AVTOMOBILOV","ADRENALINE BMX":"ADRENALINSKI BMX","CAR PARKING REAL 3D SIMULATOR":"RESNIČNI 3D SIMULATOR PARKIRANJA AVTOMOBILOV","MOUNTAIN CLIMB 4X4 CHALLENGE":"IZZIV 4X4 PLEZANJA PO HRIBIH","MOTOCROSS BIKE RACING STUNT":"MOTOCROSS DIRKE: TRIKI NA MOTORJIH","SPEED NIGHT CAR RACERS":"NOČNE DIRKE AVTOMOBILOV: HITROST","CHAINED CARS RACING":"DIRKA AVTOMOBILOV S POVEZAVAMI","EXTREME BIKE MADNESS 3D":"EKSTREMNA NOROST NA KOLESIH 3D","ANT RAID":"NAPAD MRAVELJ","PARKING CHAMP":"PRVAK PARKIRANJA","FIRE TRUCK RACING 3D DELUXE":"DIRKA GASILSKIH VOZIL 3D DELUXE","BIKE TRIALS":"PREIZKUŠNJE S KOLESI","CITY MOTO RACER":"MESTNI MOTO DIRKAČ","MOTO BIKE HILL RACER NITRO 3D":"DIRKAČ MOTORNIH KOLES PO HRIBIH NITRO 3D","GHOST RIDE 3D SEASON 2":"DUHOVNA VOŽNJA 3D: 2. SEZONA","MONSTER TRUCK EXTREME DASH":"EKSTREMNA DIRKA Z MONSTER TRKOM","BOUNCY BOAT MADNESS PRO":"NOROST SKAKAJOČIH ČOLNOV PRO","CARTOON CAR CRASH DERBY DESTRUCTION WORLD":"KARIKATURA AVTOMOBILOV: DERBI UNIČENJA SVETA","MOTOR BIKE RACER":"DIRKAČ MOTORNIH KOLES","HORSE RACING DERBY GAME":"DIRKA KONJ: DERBI IGRA","PRADO PARKING GAME 2018":"IGRA PARKIRANJA PRADO 2018","MOTO BIKE RACER":"DIRKAČ MOTORNIH KOLES","ZOMBIE ROADRASH":"ZOMBIEVA CESTA","MONSTER TRUCK UNLEASHED":"POŠASTNI TOVORNJAK NA PROSTOSTI","RACE ILLEGAL HIGH-SPEED 3D":"DIRKA ILEGALNIH VISOKIH HITROSTI 3D","DART MASTER":"MOJSTER PUŠČIC","MARBLE DUEL":"DUEL KROGLIC","FOOTBALL ONLINE CHAMPIONSHIP":"SVETOVNO PRVENSTVO V NOGOMETU NA SPLETU","FIGHT CLUB REVOLUTION 2":"REVOLUCIJA BORILNEGA KLUBA 2","SLOG CRICKET":"SLOG KRIKETA","TRIAL LEGENDS 2 PRO":"PREIZKUS LEGENDARNEGA 2 PRO","SUPER HILL BICYCLE RACING":"SUPER DIRKE PO HRIBIH S KOLESI","3 BALL BILIARDS":"3 ŽOGICE BILJARD","DESERT DEVIL MOTO RACE":"DIRKA MOTORJEV V PUŠČAVSKEM PEKLU","TAP SOCCER":"DOTAKNI SE NOGOMETA","BIKE ME":"Kolo ME","FINAL NIGHT ZOMBIE STREET FIGHT":"ZADNJA NOČ ZOMBIJEV NA ULICI","CRICKET STREET CUP":"Ulični pokal V KRIKETU","GYMNASTICS ATHLETIC CONTEST":"ATLETSKO TEKMOVANJE V GIMNASTIKI","ICE RAGE":"ZAMRZNJENA JEZA","DRIVE SIMULATOR 2016":"SIMULATOR VOŽNJE 2016","TRIAL EXTREME 2 HD":"EKSTREMNI PREIZKUS 2 HD","BRAZIL TRAINING COURSE":"BRAZILSKI TRENING","MAHJONG DELUXE":"MAHJONG DELUXE","POOL BREAK PRO":"PRO ODMOR V BILJARDU","SPIDER HUNTER AMAZING CITY 3D":"Lovec na pajke: neverjetno mesto 3D","BEN 10 WORLD RESCUE":"BEN 10 SVET REŠI","BEN 10 NO ARM DONE":"BEN 10 BREZ ŠKODE","BEN 10 WILDVINE SHOOT":"BEN 10 DIVJA TRTA STRELJA","2048 LLAMA EDITION":"2048 LLAMA IZDAJA","ADVENTURE TIME FANGS FOR THE MEMORIES":"ČAS ZA PUSTOLOVŠČINE ZOBJE ZA SPOMINE","APPLE AND ONION TROLLYDASH":"JABOLKO IN ČEBULA TROLLEYDASH","ALICE LEWIS JIGSAW PUZZLE":"ALICE LEWIS SESTAVLJANKA","ANIMALS CRUSH MATCH 3":"ŽIVALI ZMEČKAJ TEKMA 3","AMERICAN FOOTBALL":"AMERIŠKI NOGOMET","BEN 10 THE CLOSE UPS QUIZ":"BEN 10 KVIZ BLIŽNJIH POSNETKOV","AGENTHAL2":"AGENTHAL2","AVALAUNCH":"AVALAUNCH","BARBIE SPARKLE MOUNTAIN RIDE":"BARBIE SIJAJNA GORSKA VOŽNJA","BANANAMAN SPACE CHASE":"BANANAMAN VESOLJSKI PREGANJANJE","APPLE ONION BOTTLE CATCH":"JABOLKO ČEBULA LOV NA STEKLENICO","BEN 10 OMNICODE":"BEN 10 OMNIKODA","BEN 10 MATCH UP":"BEN 10 UJEMANJE","BEN 10 HERO TIME GAME":"BEN 10 IGRA ČASA JUNAKOV","BEN 10 OMNITRIX GLITCH":"BEN 10 OMNITRIX NAPAKA","APPLE ONION CAT RESCUE":"JABOLKO ČEBULA REŠITEV MAČKE","BEN 10 ALIEN RUSH":"BEN 10 TUJEC HITRITEV","BATWHEELS BY YOU":"BATWHEELS ZATE","BATTLE DAY BRAWL":"BITKA DNEVA PRETEP","BE COOL SCOOBY DOO NO GUTS NO TREATS":"NAJ BO COOL SCOOBY DOO BREZ POGUMA BREZ POSLASTIC","BEACHY KEEN SPONGEBOB":"PLAŽNO ZANOSEN SPONGEBOB","BEN 10 CHALLENGE":"BEN 10 IZZIV","BATTER UP":"POTEZITE GOR","BE COOL SCOOBY DOO THE MYSTERIOUS MANSION":"NAJ BO COOL SCOOBY DOO SKRIVNOSTNA DVORANA","BASKETBALL STARS 3":"KOŠARKARSKE ZVEZDE 3","BEN 10 DIAMONDHEAD SHOOT":"BEN 10 DIAMANTNA GLAVA STRELJA","BEN 10 SPOT THE DIFFERENCE":"BEN 10 OPAZI RAZLIKO","ADVENTURE TIME ANGRY BETTY":"ČAS ZA PUSTOLOVŠČINE JEZNA BETTY","BARBIE SPY":"BARBIE VOHUN","BEN 10 OMNITRIX SHADOW":"BEN 10 OMNITRIX SENCA","BEN 10 PENALTY POWER":"BEN 10 KAZENSKA MOČ","ADAM AND EVE SLEEPWALKER":"ADAM IN EVA HODILEC V SNU","BEARY SPOT ON":"MEDVEDJA NATANČNO","BEN 10 POWER SURGE":"BEN 10 MOČ SUNEK","BEN 10 OVERFLOW FIGHT":"BEN 10 PREKORAČITEV BOJA","ADVENTURE TIME CANDY DIVE":"ČAS ZA PUSTOLOVŠČINE SLADKARSKI SKOK","BEAN SKIDDING":"FIŽOL DRSEČI","BEANO BUSH CHUCKER CHALLENGE":"BEANO GRMOVNIK METALSKI IZZIV","BEN 10 STEAM CAMP":"BEN 10 PARNI Tabor","BEN 10 ESCAPE ROUTE":"BEN 10 POT POBEGA","BEN 10 ALIENRIVALS V2":"BEN 10 TUJI RIVALI V2","BEATS BATTLE":"RITMIČNA BITKA","BARBIE MAKE UP":"BARBIE LIČENJE","BACKYARD JUNK":"DVORIŠČNO SMETJE","BACKYARD HOOPS":"DVORIŠČNI KOŠ","BEN 10 CANNONBOLT SMASH":"BEN 10 TOP BOLTI UDAR","BEN 10 TOMB OF DOOM":"BEN 10 GROBNICA USODE","ALL THAT EMPLOYEE":"VSE TO ZAPOSLENI","BERRIES":"JAGODE","BEN 10 UNDERTOWN RUNNER":"BEN 10 PODMESTNI TEKAČ","ADVENTURE TIME THESE LUPMS":"ČAS ZA PUSTOLOVŠČINE TE GRČE","ADVENTURE TIME GATE CRASHERS":"ČAS ZA PUSTOLOVŠČINE VRAT LOMILCI","ALVIN SUPER RUN":"ALVIN SUPER TEK","ADVENTURE TIME FIONNA FIGHTS":"ČAS ZA PUSTOLOVŠČINE FIONNA BORI","ADVENTURE TIME ELEMENTA":"ČAS ZA PUSTOLOVŠČINE ELEMENTA","ADVENTURES IN BABYSITTING":"PUSTOLOVŠČINE V VARSTVU OTROK","ACME ROCKET DASH":"ACME RAKETNI ŠPRINT","FIRE FYING DRAGON SIMULATOR WARRIOR SKY RIDER 3D":"OGNJENI LETEČI ZMAJ SIMULATOR BOJEVNIK NEBESNI JAHALCI 3D","withdraw_from_contract":"Odstop od pogodbe"}

/***/ }),

/***/ "./src/translations/sv.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Spela Way Beyond","sidebar.home":"Hem","sidebar.myaccount":"Mitt konto","sidebar.notif":"Meddelande","sidebar.nonotif":"Du har inga meddelanden än","html5games":"HTML5-spel","androidGames":"Android-spel","favorite":"Favorit","welcome.text":"Utforska de bästa mobilspelen online idag!","footer.copyright":"&copy; 2020 Gamelords. Alla rättigheter reserverade","accountDetails":"Kontouppgifter","accountName":"Namn","accountEmail":"E-postadress","accountLocation":"Plats","accountInterests":"Intressen","accountChooseCategory":"Välj 3 kategorier","accountEditPhoto":"Redigera foto","save":"Save","topCategories":"Toppkategorier","favGames":"Favoritspel","viewAll":"Visa alla","noGameFound":" Inga spel hittades ","cancel":"Avbryt","gameDirectories":"Spelkataloger","category":"Kategori","noGamesFound":"Inga spel hittades under denna kategori.","platform":"Plattform","type":"Typ","android-upper":"ANDROID","games":"spel","html5":"HTML5","description":"Beskrivning","downloadNow":"Ladda ned nu","playNow":"Spela nu","rate":"Betygsätt","relatedGames":"Relaterade spel","noFavGames":"Inga favoritspel än","addFavGames":"Lägg till dina favoritspel för att enkelt komma åt och spela utan några problem","discover":"Upptäck","noFavGamesFound":"Inga favoritspel hittades.","favorites":"Favoriter","accessDenied":"Åtkomst nekad","pageRestricted":"Sidan du söker är begränsad.","privacyPolicy":"Integritetspolicy","tnc":"Regler & Villkor","kazakhOnly":"","areYouAlready":"Är du redan en medlem av ","thenConfirm":"Bekräfta då ditt mobilnummer och få obegränsad tillgång till alla våra tjänster!","login":"Logga in","search.input.placeholder":"Sök","search.cancel.button":"Avbryt","Sports":"Sporter","Action":"Action","Adventure":"Äventyr","Fitness":"Fitness","Entertainment":"Underhållning","Premium Games":"Premium-spel","RPG":"RPG","Virtual Reality":"Virtual Reality","Arcade":"Arkad","Racing":"Racing","unsubscribe":"Avsluta prenumerationen"}

/***/ }),

/***/ "./src/translations/th.json":
/***/ (function(module, exports) {

module.exports = {"sidebar.home":"หน้าแรก","sidebar.myaccount":"บัญชีของฉัน","sidebar.notif":"การแจ้งเตือน","sidebar.nonotif":"คุณยังไม่มีการแจ้งเตือน","html5games":"เกม HTML5","androidGames":"เกม Android","android-upper":"ANDROID","favorite":"รายการโปรด","splashscreen.text":"เล่นได้เหนือทุกขีดจำกัด","welcome.text":"สำรวจเกมมือถือออนไลน์ที่ดีที่สุดวันนี้!","welcome.text.gamiclub":"สำรวจคอนเทนต์ออนไลน์ที่ดีที่สุดวันนี้!","accountDetails":"รายละเอียดบัญชี","accountName":"ชื่อ","accountEmail":"อีเมล","withdraw_from_contract":"ยกเลิกสัญญา","accountLocation":"ตำแหน่งที่ตั้ง","accountInterests":"ความสนใจ","accountChooseCategory":"เลือก 3 หมวดหมู่","accountEditPhoto":"แก้ไขรูปภาพ","save":"บันทึก","topCategories":"หมวดหมู่ยอดนิยม","favGames":"เกมโปรด","viewAll":"ดูทั้งหมด","noGamesFound":"ไม่พบเกมในหมวดหมู่นี้","noVideosFound":"ไม่พบวิดีโอในหมวดหมู่นี้","cancel":"ยกเลิก","gameDirectories":"หมวดหมู่เกม","category":"หมวดหมู่","platform":"แพลตฟอร์ม","type":"ประเภท","android":"ANDROID","games":"เกม","html5":"HTML5","videos":"วิดีโอ","search.input.placeholder":"ค้นหา...","search.cancel.button":"ยกเลิก","description":"รายละเอียด","downloadNow":"ดาวน์โหลดเลย","playNow":"เล่นเลย","rate":"ให้คะแนน","relatedGames":"เกมที่เกี่ยวข้อง","noFavGames":"ยังไม่มีเกมโปรด","addFavGames":"เพิ่มเกมโปรดเพื่อให้เข้าถึงและเล่นได้ง่าย","discover":"ค้นพบ","noFavGamesFound":"ไม่พบเกมโปรด","favorites":"รายการโปรด","accessDenied":"ปฏิเสธการเข้าถึง","pageRestricted":"หน้าที่คุณกำลังค้นหาถูกจำกัดการเข้าถึง","averageRatingBasedOn":" คะแนนเฉลี่ยจากผู้ใช้ อ้างอิงจาก ","averageRatingReview":" รีวิว","tnc":"ข้อกำหนดและเงื่อนไข","contact_us":"ติดต่อเรา","areYouAlready":"คุณเป็นสมาชิกของ ","thenConfirm":"ยืนยันหมายเลขโทรศัพท์มือถือเพื่อเข้าเล่นเกม <strong>HTML5</strong> และ <strong>Android</strong> ทั้งหมดได้ไม่จำกัด","login":"เข้าสู่ระบบ","Action":"แอ็กชัน","Adventure":"ผจญภัย","Arcade":"อาร์เคด","Sport":"กีฬา","Racing":"แข่งรถ","Premium Games":"เกมพรีเมียม","RPG":"RPG","Virtual Reality":"เสมือนจริง","Motivation":"แรงบันดาลใจ","Tour":"ท่องเที่ยว","Fun Gaming":"เกมสนุก","Athletics":"กรีฑา","Inspiration":"แรงบันดาลใจ","Casual":"เล่นสบาย ๆ","Adrenaline Rush":"ความตื่นเต้นเร้าใจ","Into Nature":"สัมผัสธรรมชาติ","Political & Activism":"การเมืองและกิจกรรมเพื่อสังคม","Travel":"ท่องเที่ยว","Foodbuzz":"อาหาร","Health and Nutrition":"สุขภาพและโภชนาการ","Fitness":"ฟิตเนส","Top Cars":"รถยอดนิยม","Fashion & Beauty":"แฟชั่นและความงาม","E-Learning":"การเรียนออนไลน์","Yoga":"โยคะ","Just For Laugh":"เพื่อความสนุก","Brain Boost":"ฝึกสมอง","Rugby":"รักบี้","Economy":"เศรษฐกิจ","Environment":"สิ่งแวดล้อม","Gaming":"เกม","Lifestyle":"ไลฟ์สไตล์","Local Heroes":"ฮีโร่ท้องถิ่น","Sports":"กีฬา","Technology":"เทคโนโลยี","Tutorials":"บทแนะนำ","New Arrivals":"มาใหม่","noFavVideos":"ยังไม่มีวิดีโอโปรด","addFavVideos":"เพิ่มวิดีโอโปรดเพื่อให้เข้าถึงและรับชมได้ง่าย","noFavVideosFound":"ไม่พบวิดีโอโปรด","footer.copyright.gamiclub":"&copy; 2020 Gamiclub สงวนลิขสิทธิ์","footer.copyright.gameflares":"&copy; 2024 Gameflares สงวนลิขสิทธิ์","footer.copyright.gamiway":"&copy; 2020 Gamiway สงวนลิขสิทธิ์","footer.copyright.GamiHub":"&copy; 2026 GamiHub สงวนลิขสิทธิ์","vid-player":"เครื่องเล่น","privacyPolicy":"นโยบายความเป็นส่วนตัว","privacy-policy-title":"นโยบายความเป็นส่วนตัว","privacy-policy-desc":"นโยบายความเป็นส่วนตัวฉบับนี้อธิบายถึงหน้าที่ของเราและสิทธิของคุณเกี่ยวกับข้อมูลของคุณ โปรดอ่านนโยบายความเป็นส่วนตัวอย่างละเอียด หากคุณไม่ยอมรับนโยบายนี้ โปรดอย่าใช้เว็บไซต์หรือบริการของเรา นโยบายความเป็นส่วนตัวนี้ถือเป็นส่วนหนึ่งของข้อกำหนดการให้บริการและใช้บังคับกับบริการและเว็บไซต์เดียวกันกับที่ระบุไว้ในข้อกำหนดการให้บริการ คำใด ๆ ที่ใช้ในนโยบายความเป็นส่วนตัวโดยไม่ได้ให้คำนิยาม ให้มีความหมายเช่นเดียวกับที่กำหนดไว้ในข้อกำหนดการให้บริการ","privacy-policy-collect-info-head":"เราเก็บรวบรวมข้อมูลด้วยวิธีต่อไปนี้","privacy-policy-collect-info-desc1":"1. เมื่อคุณให้ข้อมูลแก่เรา หรืออนุญาตให้เราเก็บข้อมูล หากคุณเลือกสมัครใช้บริการของเรา เราหรือผู้ให้บริการเครือข่ายโทรศัพท์มือถือของคุณจะเก็บรวบรวมข้อมูลที่เกี่ยวข้องกับการชำระค่าสมัครใช้บริการ ข้อมูลบัญชีและการเรียกเก็บเงินที่ผู้ให้บริการเครือข่ายโทรศัพท์มือถือเก็บรวบรวมจะอยู่ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการรายนั้น","privacy-policy-collect-info-desc2":"2. เราได้รับข้อมูลทางเทคนิคเมื่อคุณเข้าใช้เว็บไซต์และ/หรือบริการของเรา เราอาจเก็บรวบรวมข้อมูลทางเทคนิคเกี่ยวกับคุณทุกครั้งที่คุณใช้บริการ รวมถึงข้อมูลบันทึกเมื่อคุณเข้าสู่ระบบหรือออกจากระบบของเรา","privacy-policy-how-collect-info-head":"วิธีที่เราใช้ข้อมูลที่เก็บรวบรวม","privacy-policy-how-collect-info-subhead":"เราอาจใช้ข้อมูลของคุณเพื่อวัตถุประสงค์ต่อไปนี้","privacy-policy-how-collect-info-desc1":"ให้บริการตามที่คุณร้องขอ","privacy-policy-how-collect-info-desc2":"เรียกเก็บเงินและรับชำระค่าบริการที่จัดหาให้แก่คุณ","privacy-policy-how-long-head":"ระยะเวลาที่เราเก็บรักษาข้อมูลของคุณ","privacy-policy-how-long-desc":"เราจะเก็บรักษาข้อมูลของคุณเท่าที่จำเป็นเพื่อให้บริการแก่คุณ และเท่าที่จำเป็นต่อการปฏิบัติตามหน้าที่ทางกฎหมาย การระงับข้อพิพาท และการบังคับใช้ข้อตกลงของเรา เมื่อเราไม่จำเป็นต้องใช้ข้อมูลของคุณอีกต่อไป และไม่จำเป็นต้องเก็บรักษาไว้เพื่อปฏิบัติตามหน้าที่ตามกฎหมายหรือข้อบังคับ เราจะลบข้อมูลออกจากระบบหรือทำให้ข้อมูลไม่สามารถระบุตัวบุคคลได้","privacy-policy-how-long-protect-head":"วิธีที่เราปกป้องข้อมูลของคุณ รวมถึงนอกสหภาพยุโรป","privacy-policy-how-long-protect-desc1":"เราให้ความสำคัญกับการคุ้มครองความเป็นส่วนตัวและข้อมูลของคุณ อย่างไรก็ตาม เราไม่อาจรับรองหรือรับประกันความปลอดภัยของข้อมูลที่คุณส่งให้เรา หรือรับประกันว่าข้อมูลของคุณจะไม่ถูกเข้าถึง เปิดเผย เปลี่ยนแปลง หรือทำลายจากการละเมิดมาตรการรักษาความปลอดภัยทางกายภาพ ทางเทคนิค หรือทางการจัดการตามมาตรฐานอุตสาหกรรมของเรา เราใช้แนวปฏิบัติที่เหมาะสมในการเก็บรวบรวม จัดเก็บ และประมวลผลข้อมูล รวมถึงมาตรการรักษาความปลอดภัยเพื่อป้องกันการเข้าถึง การเปลี่ยนแปลง การเปิดเผย หรือการทำลายข้อมูล ข้อมูลธุรกรรม และข้อมูลที่จัดเก็บในบริการของเราโดยไม่ได้รับอนุญาตหรือโดยอุบัติเหตุ","privacy-policy-how-long-protect-desc2":"อย่างไรก็ตาม ไม่มีวิธีการส่งข้อมูลผ่านอินเทอร์เน็ตหรือการจัดเก็บข้อมูลทางอิเล็กทรอนิกส์ใดที่ปลอดภัยร้อยเปอร์เซ็นต์ เราจึงไม่สามารถรับประกันความปลอดภัยได้อย่างสมบูรณ์ และจะปรับปรุงกระบวนการรักษาความปลอดภัยอย่างต่อเนื่องเมื่อมีเทคโนโลยีใหม่","privacy-policy-how-long-protect-desc3":"เนื่องจากเราดำเนินงานในระดับสากล ข้อมูลของคุณ รวมถึงข้อมูลส่วนบุคคล อาจถูกโอนและเปิดให้เข้าถึงในสหรัฐอเมริกา สิงคโปร์ และ/หรือประเทศอื่นนอกเหนือจากประเทศที่คุณพำนัก เราจะใช้ความระมัดระวังตามสมควรเพื่อคุ้มครองข้อมูลส่วนบุคคลของคุณในประเทศเหล่านั้นด้วย","privacy-policy-acceptance-head":"การยอมรับนโยบายความเป็นส่วนตัว","privacy-policy-acceptance-desc":"เมื่อใช้บริการใด ๆ ของเรา คุณยินยอมให้เราเก็บรวบรวมและใช้ข้อมูลของคุณตามนโยบายความเป็นส่วนตัวฉบับนี้ เราขอสงวนสิทธิ์ในการแก้ไขนโยบายนี้ได้ทุกเมื่อโดยประกาศการเปลี่ยนแปลงไว้ในหน้านี้ โปรดตรวจสอบวันที่แก้ไขที่ด้านล่างของหน้าเพื่อดูว่านโยบายมีการเปลี่ยนแปลงนับจากครั้งล่าสุดที่คุณตรวจสอบหรือไม่ การที่คุณยังคงใช้เว็บไซต์หรือบริการส่วนใดของเราหลังจากประกาศนโยบายฉบับปรับปรุง ถือว่าคุณยอมรับการเปลี่ยนแปลงดังกล่าว","privacy-policy-changes-head":"การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวฉบับนี้","privacy-policy-changes-desc":"เราอาจปรับปรุงนโยบายความเป็นส่วนตัวเป็นครั้งคราว หากเราตัดสินใจเปลี่ยนแปลงนโยบาย เราจะประกาศการเปลี่ยนแปลงไว้ในหน้านี้ เพื่อให้คุณสามารถเข้าถึงนโยบายความเป็นส่วนตัวฉบับล่าสุดได้เสมอ","privacy-policy-contact-us":"ติดต่อเรา","privacy-policy-contact-us-desc":"หากคุณมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้ แนวปฏิบัติของเว็บไซต์ หรือการใช้เว็บไซต์ของคุณ โปรดติดต่อเราทางอีเมลที่ support@content-clubs.com","unsubscribe":"ยกเลิกการสมัครสมาชิก","unsubscribe-ZA":"หากต้องการยกเลิกการสมัครสมาชิก กด 135*997#","PROFILINE KIMLER BAKTI?":"ใครดูโปรไฟล์ของคุณ?","terms-condition-title":"ข้อกำหนดและเงื่อนไข","gen-terms-condition-title":"ข้อกำหนดและเงื่อนไขทั่วไปและนโยบายความเป็นส่วนตัว","gen-terms-condition-desc":"ข้อกำหนดและเงื่อนไขทั่วไปต่อไปนี้ใช้บังคับกับผลิตภัณฑ์และบริการที่ให้ผ่าน WAP, SMS, GPRS และ 3G โดย Sam Media Ltd. หรือบริษัทในเครือ (ต่อไปนี้เรียกว่า “ผู้ให้บริการ”) ผู้ให้บริการอาจแก้ไขข้อกำหนดและเงื่อนไขทั่วไปเหล่านี้เป็นครั้งคราวโดยไม่ต้องแจ้งให้ทราบล่วงหน้า นอกเหนือจากข้อกำหนดและเงื่อนไขทั่วไปแล้ว กฎ เงื่อนไขส่งเสริมการขาย แนวทาง และข้อกำหนดต่าง ๆ ที่เกี่ยวข้องกับบริการและได้ประกาศใช้ ย่อมใช้บังคับกับคุณและผู้ให้บริการเมื่อมีการใช้บริการของผู้ให้บริการด้วย แนวทาง กฎ เงื่อนไขส่งเสริมการขาย และข้อกำหนดทั้งหมดดังกล่าวถือเป็นส่วนหนึ่งที่แยกออกจากข้อกำหนดและเงื่อนไขทั่วไปนี้ไม่ได้ เมื่อใช้บริการของผู้ให้บริการ คุณตกลงที่จะผูกพันตามข้อกำหนดและเงื่อนไขทั่วไป รวมถึงแนวทาง กฎ และเงื่อนไขส่งเสริมการขายเหล่านี้","provider-terms-condition-title":"รายละเอียดของผู้ให้บริการ","provider-terms-condition-desc":"ผู้ให้บริการให้ผู้ใช้เข้าถึงแหล่งข้อมูลออนไลน์ผ่านบริการ WAP, SMS, GPRS และ 3G รวมถึงเกมออนไลน์ ข้อความ เนื้อหามัลติมีเดีย และข้อมูลออนไลน์ที่อาจดาวน์โหลดลงในโทรศัพท์มือถือหรืออุปกรณ์อื่น (“บริการ”) ข้อกำหนดและเงื่อนไขทั่วไปนี้ใช้กับสิ่งอำนวยความสะดวกใหม่ทั้งหมดเสมอ รวมถึงสิ่งที่ผู้ให้บริการอาจนำมาใช้ในการขยาย ต่อเติม หรือปรับปรุงบริการปัจจุบัน ตลอดจนฟังก์ชันใหม่ใด ๆ ที่ผู้ให้บริการเพิ่มขึ้น","availability-terms-condition-title":"ความพร้อมให้บริการ","availability-terms-condition-desc":"บริการนี้จัดให้ตามสภาพที่เป็นอยู่และตามขั้นตอนการพัฒนาในขณะนั้น ผู้ให้บริการไม่รับผิดและไม่ให้คำรับรองหรือการรับประกันในกรณีที่การตั้งค่าส่วนบุคคล ข้อมูล หรือข้อความไม่ได้รับการบันทึก ไม่ได้รับการบันทึกภายในเวลาที่เหมาะสม ถูกลบ หรือส่งอย่างไม่ถูกต้อง ในการสมัครใช้บริการ คุณต้องสามารถเข้าถึงอินเทอร์เน็ตและ/หรือมีบริการสื่อสารเคลื่อนที่ และต้องชำระค่าธรรมเนียมทั้งหมดที่เกี่ยวข้องกับการเข้าถึงดังกล่าว คุณเป็นผู้รับผิดชอบค่าใช้จ่ายทั้งหมดในการจัดให้มีการเข้าถึง รวมทั้งรับผิดชอบการเชื่อมต่อและความพร้อมใช้งานของอุปกรณ์ที่จำเป็น เช่น โทรศัพท์มือถือ คอมพิวเตอร์ส่วนบุคคล หรืออุปกรณ์อื่นที่จำเป็นและเหมาะสมต่อการใช้บริการ","payment-terms-condition-title":"การชำระเงิน","payment-terms-condition-desc":"คุณสามารถเข้าถึงบริการออนไลน์ของเราได้โดยไม่เสียค่าเข้าถึง สำหรับบริการและการใช้บริการ คุณต้องชำระเงินตามอัตราค่าบริการของผู้ให้บริการที่ใช้บังคับในขณะนั้นและตามอัตราที่ผู้ให้บริการเครือข่ายโทรศัพท์มือถือของคุณเรียกเก็บ ค่าใช้จ่ายจะถูกเรียกเก็บผ่านผู้ให้บริการเครือข่ายโทรศัพท์มือถือในใบแจ้งค่าบริการโทรศัพท์มือถือของคุณ คุณต้องชำระภาษีระดับประเทศ ระดับท้องถิ่น หรือภาษีและค่าธรรมเนียมอื่นทั้งหมดที่เกี่ยวข้องกับค่าใช้บริการ รวมถึงแต่ไม่จำกัดเพียงภาษีมูลค่าเพิ่ม ไม่ว่าภาษีดังกล่าวจะถูกเรียกเก็บในปัจจุบันหรืออนาคตโดยหน่วยงานระดับยุโรป ระดับประเทศ ระดับท้องถิ่น หรือหน่วยงานอื่นที่มีอำนาจ ผู้ให้บริการขอสงวนสิทธิ์ในการเปลี่ยนแปลงอัตราค่าบริการโดยประกาศรายละเอียดการเปลี่ยนแปลงบนเว็บไซต์","obligation-terms-condition-title":"หน้าที่ในการลงทะเบียน","obligation-terms-condition-desc":"เพื่อให้การใช้บริการมีความปลอดภัย นอกเหนือจากการชำระค่าบริการที่เกี่ยวข้อง คุณรับรองว่า (ก) ข้อมูลส่วนบุคคลที่ให้ไว้ในแบบฟอร์มลงทะเบียน (“ข้อมูลที่ลงทะเบียน”) ถูกต้อง เป็นความจริง แม่นยำ และครบถ้วน และ (ข) คุณจะดูแลให้ข้อมูลที่ลงทะเบียนถูกต้อง เป็นปัจจุบัน เป็นความจริง แม่นยำ และครบถ้วนอยู่เสมอ หากผู้ให้บริการมีเหตุอันควรสงสัยว่าข้อมูลดังกล่าวไม่ตรงกับความเป็นจริง ไม่แม่นยำ หรือไม่ครบถ้วน ผู้ให้บริการมีสิทธิ์ระงับหรือยุติบัญชีของคุณ และจำกัดการใช้บริการทั้งในปัจจุบันและอนาคตทั้งหมดหรือบางส่วน คุณมีหน้าที่รักษารหัสผ่านและ/หรือบัญชีที่ผู้ให้บริการออกให้เป็นความลับ และรับผิดชอบอย่างเต็มที่ต่อการดำเนินการทั้งหมดที่เกิดขึ้นโดยใช้รหัสผ่านหรือบัญชีของคุณ คุณตกลงที่จะปิดบัญชีเมื่อสิ้นสุดแต่ละเซสชันและติดต่อผู้ให้บริการทันทีหากพบหรือสงสัยว่ามีการใช้รหัสผ่านหรือบัญชีโดยไม่ได้รับอนุญาต หรือความปลอดภัยไม่อาจรับประกันได้ด้วยเหตุอื่น ผู้ให้บริการไม่รับผิดชอบต่อความเสียหายที่เกิดจากการที่คุณไม่ปฏิบัติตามข้อกำหนดในข้อนี้","ownership-terms-condition-title":"สิทธิความเป็นเจ้าของของผู้ให้บริการ","ownership-terms-condition-desc":"ข้อกำหนดและเงื่อนไขทั่วไปต่อไปนี้ใช้บังคับกับผลิตภัณฑ์และบริการที่ให้ผ่าน WAP, SMS, GPRS และ 3G โดย Sam Media Ltd. หรือบริษัทในเครือ (ต่อไปนี้เรียกว่า “ผู้ให้บริการ”) ผู้ให้บริการอาจแก้ไขข้อกำหนดและเงื่อนไขทั่วไปเหล่านี้เป็นครั้งคราวโดยไม่ต้องแจ้งให้ทราบล่วงหน้า นอกเหนือจากข้อกำหนดและเงื่อนไขทั่วไปแล้ว กฎ เงื่อนไขส่งเสริมการขาย แนวทาง และข้อกำหนดต่าง ๆ ที่เกี่ยวข้องกับบริการและได้ประกาศใช้ ถือเป็นส่วนหนึ่งที่แยกออกจากข้อกำหนดและเงื่อนไขทั่วไปนี้ไม่ได้ เมื่อใช้บริการของผู้ให้บริการ คุณตกลงที่จะผูกพันตามข้อกำหนดและเงื่อนไขทั่วไป รวมถึงแนวทาง กฎ และเงื่อนไขส่งเสริมการขายเหล่านี้","funzarena_text":"คุณไม่มีสิทธิ์เข้าถึง ส่งข้อความคำว่า GAME ไปที่ 92505 (ค่าบริการ PLN 30.75)","CANDY SAGA":"ตำนานลูกกวาด","THIEF CHALLENGE":"ภารกิจท้าทายจอมโจร","RUN VOVAN RUN":"วิ่งเลย โวแวน","DOMINO BLOCK":"โดมิโนบล็อก","LEGEND OF THE SAMURAI":"ตำนานซามูไร","SLITTERG":"สลิตเตอร์จี","MIND READER":"นักอ่านใจ","CONNECT 4":"เรียงสี่","HUNGRY SPIDER":"แมงมุมหิวโหย","CATS VS DOGS":"แมวปะทะสุนัข","WORDOKU":"เวิร์ดโดกุ","NINJA CLAN":"ตระกูลนินจา","HERO IN SUPER ACTION":"ฮีโร่ยอดนักสู้","CANDY GIRL":"สาวน้อยลูกกวาด","STONE AGE":"ยุคหิน","FLAPPY CHANGE":"ฟลัปปี้เชนจ์","BOX TOWER":"หอคอยกล่อง","MASTER CHESS":"ปรมาจารย์หมากรุก","GOOSE GAME":"เกมห่าน","RISE UP":"ทะยานขึ้น","VIRTU PIANO":"เปียโนเสมือน","CLASSIC BACKGAMMON":"แบ็กแกมมอนคลาสสิก","FLAPPY BIRD":"ฟลัปปี้เบิร์ด","BOAT RUSH":"เรือซิ่ง","SWING ROBBER":"จอมโจรโหนเชือก","KING BACON VS VEGANS":"ราชาเบคอนปะทะวีแกน","AIR WOLVES":"หมาป่าเวหา","CRICKET BATTER":"นักตีคริกเก็ต","KUNOICHI RUN":"คุโนะอิจิวิ่ง","TRIVIA QUIZ MANIA":"มหกรรมตอบคำถาม","ZOMBO":"ซอมโบ","BLUE JUMP":"บลูจัมป์","THE QUIZ":"เกมตอบคำถาม","SUPER CARS":"ซูเปอร์คาร์","CRAZY COWBOY":"คาวบอยสุดบ้า","MATH GAME":"เกมคณิตศาสตร์","SPACE INVADERS":"ผู้บุกรุกอวกาศ","BATTLESHIP":"เรือรบ","SNAKE ATTACK":"งูจู่โจม","NEON HOCKEY":"นีออนฮอกกี้","FIDGET SPINNER":"ฟิดเจ็ตสปินเนอร์","SLICE FRUIT":"ฟันผลไม้","AZTEC ESCAPE":"หลบหนีจากแอซเท็ก","CLAN ATTACK":"ศึกตระกูล","JEWEL MATCH":"จับคู่อัญมณี","FOUR COLORS":"สี่สี","TEMPLE RUMBLE JUNGLE ADVENTURE":"ศึกวิหารผจญภัยในป่า","HIGHWAY SPEED MOTO BIKE DRIVER":"นักบิดมอเตอร์ไซค์ทางด่วน","NINJA CLASH":"ศึกนินจา","GLORY WARRIOR LORD OF DARKNESS":"นักรบแห่งศักดิ์ศรี จ้าวแห่งความมืด","HIGHWAY DRIVER 3D":"นักขับทางด่วน 3D","GHOST RIDE 3D SEASON 2":"ขี่ผี 3D ซีซัน 2","HILL TRUCK DRIVER OFF ROAD":"นักขับรถบรรทุกออฟโรดบนเขา","BUG O LYMPICS PREMIUM":"มหกรรมกีฬาแมลงพรีเมียม","CHOPTER MANIA":"มหกรรมเฮลิคอปเตอร์","MIGHTY DUNGEONS":"ดันเจียนทรงพลัง","FRIDAY 13TH JASON KILLER":"ศุกร์ 13 เจสันนักฆ่า","CRIMINAL PURSUIT 3D":"ไล่ล่าอาชญากร 3D","PIXEL CUP SOCCER 16":"ฟุตบอลพิกเซลคัพ 16","CIRCUS RESCUE":"กู้ภัยคณะละครสัตว์","BODYGUARD":"บอดี้การ์ด","ULTIMATE UNDEAD INVASION APOCALYPSE":"มหาวิบัติการรุกรานของผีดิบ","BORDER WAR ENEMY TERRITORY":"สงครามชายแดน ดินแดนศัตรู","GALAXY IRON FIST":"หมัดเหล็กแห่งกาแล็กซี","RACE ILLEGAL HIGH-SPEED 3D":"แข่งรถผิดกฎหมายความเร็วสูง 3D","FOOTBALL KICKS":"เตะฟุตบอล","MOTORBIKE GP":"มอเตอร์ไซค์จีพี","FLIGHT COMBAT":"ศึกเวหา","FREDDY BRICKS":"เฟรดดี้บริกส์","360 NINJA":"นินจา 360","2 MOTO CAR RACING":"แข่งรถและมอเตอร์ไซค์ 2","JAIL PRISON BREAK 2018":"แหกคุก 2018","RACE AGAINST THE TRAFFIC":"ซิ่งฝ่าการจราจร","SPACE EXPEDITION":"ภารกิจสำรวจอวกาศ","GIGA JUMP":"กิกะจัมป์","TABLE ZOMBIE":"ซอมบี้บนโต๊ะ","HIT DODGE ZBANG":"โจมตี หลบ และระเบิด","BIKE TRIALS":"มอเตอร์ไซค์วิบาก","DESERT DEVIL MOTO RACE":"ปีศาจทะเลทรายแข่งมอเตอร์ไซค์","BASKETBALL SHOT":"ชู้ตบาสเกตบอล","KONAN SURVIVAL BARBARIAN EXILE":"โคนัน คนเถื่อนผู้ถูกเนรเทศ","MOBILEANN SECURITY":"ระบบรักษาความปลอดภัยมือถือ","BLOW YOUR WAY":"ระเบิดเปิดทาง","FLYING DRAGON":"มังกรบิน","PROTOXIDE DEATH RACE":"โปรโตไซด์ เดธเรซ","CITY MOTO RACER":"นักบิดเมือง","DEMONS AND DUNGEONS":"ปีศาจและดันเจียน","JURASSIC VR":"จูราสสิก VR","LAVIT MAN RUNNING":"ลาวิตแมนวิ่ง","HAPPY PETS RUN":"สัตว์เลี้ยงแสนสุขวิ่ง","CRICKET STREET CUP":"คริกเก็ตสตรีทคัพ","RISE OF NATION FAITH":"รุ่งอรุณแห่งศรัทธา","CRISTIANO RONALDO FOOTY":"คริสเตียโน โรนัลโด ฟุตบอล","INCREDIBLE MONSTER HERO SUPER PRISON ACTION":"ฮีโร่อสูรบุกคุกสุดเดือด","PULIMURUGAN 3D":"ปูลิมูรูกัน 3D","ETERNAL THRONE":"บัลลังก์นิรันดร์","CRAZY BOAT RACE":"แข่งเรือสุดบ้า","CAR PARKING REAL 3D SIMULATOR":"จำลองจอดรถเสมือนจริง 3D","STREET RACER 3D":"นักซิ่งข้างถนน 3D","MEDIEVAL WARS":"สงครามยุคกลาง","ASSAULT FURY MISSION COMBAT":"ภารกิจจู่โจมเดือด","EXTREME BIKE MADNESS 3D":"มอเตอร์ไซค์สุดขีด 3D","POOL BREAK PRO":"พูลเบรกโปร","BEAR HAVEN":"แดนหมี","JEWEL OCEAN":"มหาสมุทรอัญมณี","DEAD ROADKILL HIGHWAY":"ทางหลวงมรณะ","SWIFT FILE TRANSFER":"ถ่ายโอนไฟล์รวดเร็ว","ALL INSIDE BUT ONE":"ทุกคนข้างใน เหลือเพียงหนึ่ง","ILLAM ESCAPE VR":"หลบหนีจากอิลลัม VR","KIDS IQ":"ไอคิวสำหรับเด็ก","DESERT STORMFRONT":"แนวรบพายุทะเลทราย","AIR RACING":"แข่งเครื่องบิน","LEGENDARY HEROES":"วีรบุรุษในตำนาน","COLOR BOUNCE":"สีกระเด้ง","CHAINED CARS RACING":"แข่งรถโซ่","FUNNY BUNNY EASTER":"กระต่ายอีสเตอร์แสนสนุก","LORD OF MAGIC":"จ้าวแห่งเวทมนตร์","HEART SWEET HEART PRO G":"หัวใจหวานใจ","BUNNY BUSTER":"นักปราบกระต่าย","MARBLE DUEL":"ดวลลูกแก้ว","PULIMURUGAN":"ปูลิมูรูกัน","3D BATTLE TRUCK":"รถบรรทุกศึก 3D","BAZOOKA GUNNER WAR STRIKE 3D":"มือปืนบาซูก้าสงคราม 3D","BRAZIL TRAINING COURSE":"หลักสูตรฝึกซ้อมบราซิล","DOODLE TANKS":"รถถังดูเดิล","ABSOLUTE TALENT":"พรสวรรค์ขั้นสุด","CHARLIE THE DINO RESCUE TEAM":"ชาร์ลีกับทีมกู้ภัยไดโนเสาร์","SHARDS":"เศษผลึก","BAD SPIDER THIEF":"โจรแมงมุมตัวร้าย","CHAINSAW MAN FIGHTER":"นักสู้มนุษย์เลื่อยยนต์","BLOCK PUZZLE":"ปริศนาบล็อก","CAVEMAN CHUCK ADVENTURE":"การผจญภัยของชัคมนุษย์ถ้ำ","PIRATES! THE MATCH-3":"โจรสลัด! จับคู่ 3","DOODLE GOD 8-BIT MANIA":"ดูเดิลก็อด มหกรรม 8 บิต","GREEN DINO RUN":"ไดโนเสาร์เขียววิ่ง","HELICOPTER FIGHTER":"นักรบเฮลิคอปเตอร์","TALES OF THE ORIENT - THE RISING SUN":"ตำนานตะวันออก - อาทิตย์อุทัย","MALDIVES FRIENDS":"เพื่อนแห่งมัลดีฟส์","GENIAL SANTA CLAUS2":"ซานตาคลอสแสนสนุก 2","DEATH BY NINJA":"ตายด้วยคมนินจา","CARE FORT":"ป้อมปราการแห่งการดูแล","WOODVENTURE":"ผจญภัยแดนไม้","DOODLE KINGDOM":"อาณาจักรดูเดิล","MR RACER":"มิสเตอร์เรเซอร์","FIRE LORDS":"จ้าวแห่งเพลิง","CAR RACING SPEED":"แข่งรถความเร็วสูง","ALCHEMY JAM":"แอลเคมีแจม","FRUIT DATING":"นัดเดตผลไม้","GUESS CELEB NAMES":"ทายชื่อคนดัง","GUN STRIKE FIRE":"ปืนจู่โจมเพลิง","ZOMBUMP 372":"ซอมบัมป์ 372","SRCH":"ค้นหา","FINDING MENG":"ตามหาเมิ่ง","CELL MACHINE":"เครื่องจักรเซลล์","VINTAGE TRIPEAKS":"ไตรพีกส์วินเทจ","CALL OF SNIPER WW2":"เสียงเรียกแห่งสไนเปอร์ สงครามโลกครั้งที่ 2","DOODLE GOD FANTASY WORLD OF MAGIC":"ดูเดิลก็อด โลกแฟนตาซีแห่งเวทมนตร์","SACRA TERRA KISS OF DEATH":"ซาคราเทอร์รา จุมพิตมรณะ","US POLICE TRAIN TRANSPORTER TRUCK ROBOT STUNT GAME":"เกมตำรวจสหรัฐ รถไฟขนส่ง รถบรรทุก และหุ่นยนต์ผาดโผน","NEED THE SPEED":"ต้องการความเร็ว","SEA FISHING":"ตกปลาทะเล","LAZY NINJA":"นินจาจอมขี้เกียจ","SPIDER SIMULATOR AMAZING CITY 3D":"จำลองแมงมุมในเมืองมหัศจรรย์ 3D","FPS SHOOTER COUNTER TERRORIST":"เกมยิง FPS ต่อต้านผู้ก่อการร้าย","LEGENDARY TOWER STRATEGY":"กลยุทธ์หอคอยในตำนาน","TURBO RACER":"นักซิ่งเทอร์โบ","BARDBARIAN":"บาร์ดบาเรียน","RONALDO KICK N RUN":"โรนัลโด เตะแล้ววิ่ง","TOWER DEFENSE 2D":"ป้องกันหอคอย 2D","TINY MINER":"นักขุดตัวจิ๋ว","TNT KART":"ทีเอ็นทีคาร์ต","WILD ANIMAL REAL HUNTER WILD SHOOTING GAMES":"นักล่าสัตว์ป่า เกมยิงล่าสัตว์","PIXEL ART BOOK - COLOR BY NUMBER":"สมุดภาพพิกเซล - ระบายสีตามตัวเลข","POOL PRO":"พูลโปร","CALL OF SNIPER DUTY":"ภารกิจสไนเปอร์","STEREOTYPO":"สเตอริโอไทโป","NIGHTS AT TATTLETAIL HOUSE 3D":"ค่ำคืนที่บ้านแทตเทิลเทล 3D","CHRISTMAS NIGHT OF HORROR":"คืนคริสต์มาสสยองขวัญ","FRACTAL COMBAT X":"แฟรกทัลคอมแบต X","WILD ANIMAL ZOO CITY SIMULATOR":"จำลองเมืองสวนสัตว์ป่า","MATCH CONNECT":"จับคู่เชื่อมต่อ","HIGH FLY VALENTINE":"วาเลนไทน์โบยบิน","PIXEL SURVIVAL DEAD ZOMBIE":"พิกเซลเอาชีวิตรอดจากซอมบี้","TRIVIA QUIZZES":"คำถามรอบรู้","MATH GAMES":"เกมคณิตศาสตร์","POEMS LOVE FAMILY FRIENDS":"บทกวีแห่งรัก ครอบครัว และมิตรภาพ","SPELLING MASTER":"ปรมาจารย์สะกดคำ","NINJA GIRL SWING":"สาวนินจาโหนเชือก","KAHVE FALI":"ทำนายกากกาแฟ","COLONIES":"อาณานิคม","HIDDEN NUMBERS":"ตัวเลขที่ซ่อนอยู่","HOROSCOPE":"ดวงชะตา","WORD CONNECT":"เชื่อมคำ","GUESS AND FIND":"ทายและค้นหา","IMPOSSIBLE BALL GLOW TWIST":"ลูกบอลเรืองแสงสุดหิน","CONTRACT HUNTER ZOMBIE KILLER":"นักล่ารับจ้าง ผู้สังหารซอมบี้","COMMANDO COMBAT TRAINING 3D":"ฝึกการรบคอมมานโด 3D","SNIPER CAR 3D":"รถสไนเปอร์ 3D","COMBAT MENACE MADNESS 3D":"มหันตภัยการรบสุดคลั่ง 3D","RICE OF NOTION FAITH":"รุ่งอรุณแห่งศรัทธา","SNIPER TEAM 3D":"ทีมสไนเปอร์ 3D","GUNSHIP BATTLE OF WORLD HELLICOPTERS":"ศึกเฮลิคอปเตอร์รบโลก","SHOOTING KING BOTTLE SHOOT":"ราชานักยิง ยิงขวด","SEA BATTLE":"ยุทธนาวี","ARMY VEHICLE MADNESS":"มหกรรมยานพาหนะกองทัพ","ARMY PHYSICS PALACE":"พระราชวังฟิสิกส์กองทัพ","AIR STRIKE WAR":"สงครามโจมตีทางอากาศ","COMBANT DUTY MODERN STRIKE":"หน้าที่รบ จู่โจมสมัยใหม่","FRONTLINE COMMANDO WAR ONE MAN ARMY":"คอมมานโดแนวหน้า กองทัพคนเดียว","GRAVITY RACE BOY":"เด็กชายแข่งแรงโน้มถ่วง","AEROPLANE PARKING GAME":"เกมจอดเครื่องบิน","EYES - THE HORROR GAME":"ดวงตา - เกมสยองขวัญ","HELI AIR GUNSHIP STRIKE WAR":"สงครามจู่โจมเฮลิคอปเตอร์รบ","DEAD ORBIT":"วงโคจรมรณะ","HAUNTED LEGENDS UNDERTAKER":"ตำนานหลอน สัปเหร่อ","DINO HUNTING 2018":"ล่าไดโนเสาร์ 2018","GRAND CRIME GANGSTA VICE MIAMI":"อาชญากรรมครั้งใหญ่ แก๊งสเตอร์แห่งไมอามี","SONNY THE MAD MAN":"ซอนนี ชายคลั่ง","PUSHING BOY":"เด็กชายจอมผลัก","CLIMBING NINJA":"นินจานักปีน","WILD RUN":"วิ่งสุดป่า","FIRE FYING DRAGON SIMULATOR WARRIOR SKY RIDER 3D":"จำลองมังกรไฟบิน นักรบขี่เวหา 3D","NINJA COMBAT SAMURAI WARRIOR":"ศึกนินจา นักรบซามูไร","CAT RUN":"แมววิ่ง","DINOSAUR HUNTER":"นักล่าไดโนเสาร์","SUBWAY SURFERS - NEW YORK":"ซับเวย์เซิร์ฟเฟอร์ส - นิวยอร์ก","JURASSIC MANIA":"มหกรรมจูราสสิก","FLYING KNIFE":"มีดบิน","ASIAN RANGER MADNESS":"เรนเจอร์เอเชียสุดคลั่ง","IMPOSSIBLE ESCAPE 3D":"หลบหนีสุดหิน 3D","GOOD KNIGHT PRINCESS RESCUE":"อัศวินผู้กล้า ช่วยเจ้าหญิง","MONSTER TRUCK UNLEASHED":"ปลดปล่อยรถบรรทุกยักษ์","FIRE TRUCK RACING 3D DELUXE":"แข่งรถดับเพลิง 3D ดีลักซ์","PRADO PARKING GAME 2018":"เกมจอดปราโด 2018","SKI NINJA":"นินจาสกี","SPEED NIGHT CAR RACERS":"นักซิ่งรถกลางคืน","CARTOON CAR CRASH DERBY DESTRUCTION WORLD":"โลกการทำลายล้าง ดาร์บีรถการ์ตูน","MOTO BIKE HILL RACER NITRO 3D":"นักบิดขึ้นเขาไนโตร 3D","MOTOR BIKE RACER":"นักแข่งมอเตอร์ไซค์","PARKING CHAMP":"แชมป์จอดรถ","MONSTER TRUCK EXTREME DASH":"รถบรรทุกยักษ์ซิ่งสุดขีด","REAL CAR DIFT RACE MANIA 3D":"มหกรรมแข่งรถดริฟต์เสมือนจริง 3D","ZOMBIE ROADRASH":"ซอมบี้ถนนเดือด","MOTOCROSS BIKE RACING STUNT":"แข่งและผาดโผนมอเตอร์ไซค์วิบาก","BOUNCY BOAT MADNESS PRO":"เรือเด้งสุดคลั่ง โปร","ADRENALINE BMX":"อะดรีนาลีน BMX","HORSE RACING DERBY GAME":"เกมดาร์บีแข่งม้า","MOUNTAIN CLIMB 4X4 CHALLENGE":"ภารกิจพิชิตภูเขา 4x4","FINAL NIGHT ZOMBIE STREET FIGHT":"คืนสุดท้าย ศึกซอมบี้ข้างถนน","DRIVE SIMULATOR 2016":"จำลองการขับรถ 2016","3 BALL BILIARDS":"บิลเลียด 3 ลูก","TRIAL EXTREME 2 HD":"ไทรอัลเอ็กซ์ตรีม 2 HD","BIKE ME":"ไบค์มี","GYMNASTICS ATHLETIC CONTEST":"การแข่งขันยิมนาสติก","FOOTBALL ONLINE CHAMPIONSHIP":"ฟุตบอลชิงแชมป์ออนไลน์","FIGHT CLUB REVOLUTION 2":"ไฟต์คลับ เรโวลูชัน 2","TRIAL LEGENDS 2 PRO":"ตำนานไทรอัล 2 โปร","SLOG CRICKET":"สล็อกคริกเก็ต","SPIDER HUNTER AMAZING CITY 3D":"นักล่าแมงมุมในเมืองมหัศจรรย์ 3D","SUPER HILL BICYCLE RACING":"แข่งจักรยานขึ้นเขาสุดมัน","DART MASTER":"ปรมาจารย์ปาเป้า","ICE RAGE":"ความเดือดดาลแห่งน้ำแข็ง","TAP SOCCER":"แตะฟุตบอล","MAHJONG DELUXE":"ไพ่นกกระจอกดีลักซ์","ANIMALS CRUSH MATCH 3":"จับคู่สัตว์ 3 ตัว","AGENTHAL2":"เอเจนต์ฮาล 2","APPLE AND ONION TROLLYDASH":"แอปเปิลกับออเนียน รถเข็นซิ่ง","ADVENTURE TIME FANGS FOR THE MEMORIES":"แอดเวนเจอร์ไทม์ เขี้ยวแห่งความทรงจำ","BEN 10 THE CLOSE UPS QUIZ":"เบ็นเท็น เกมทายภาพระยะใกล้","BEN 10 NO ARM DONE":"เบ็นเท็น ภารกิจไร้แขน","BEN 10 WORLD RESCUE":"เบ็นเท็น กู้โลก","ALICE LEWIS JIGSAW PUZZLE":"จิ๊กซอว์อลิซ ลูอิส","2048 LLAMA EDITION":"2048 ฉบับลามา","AMERICAN FOOTBALL":"อเมริกันฟุตบอล","BEN 10 WILDVINE SHOOT":"เบ็นเท็น ไวลด์ไวน์ยิง","APPLE ONION BOTTLE CATCH":"แอปเปิลกับออเนียน รับขวด","BEN 10 OMNITRIX GLITCH":"เบ็นเท็น ออมนิทริกซ์ขัดข้อง","BANANAMAN SPACE CHASE":"บานาน่าแมน ไล่ล่าในอวกาศ","BARBIE SPARKLE MOUNTAIN RIDE":"บาร์บี้ ขี่ม้าบนภูเขาประกาย","BEN 10 OMNICODE":"เบ็นเท็น ออมนิโค้ด","BEN 10 MATCH UP":"เบ็นเท็น จับคู่","APPLE ONION CAT RESCUE":"แอปเปิลกับออเนียน ช่วยแมว","BEN 10 HERO TIME GAME":"เบ็นเท็น ถึงเวลาฮีโร่","AVALAUNCH":"อะวาลอนช์","BEN 10 ALIEN RUSH":"เบ็นเท็น เอเลียนรัช","BEN 10 DIAMONDHEAD SHOOT":"เบ็นเท็น ไดมอนด์เฮดยิง","BEN 10 CHALLENGE":"ภารกิจท้าทายเบ็นเท็น","BASKETBALL STARS 3":"ดาวบาสเกตบอล 3","BEACHY KEEN SPONGEBOB":"สพันจ์บ็อบผจญภัยชายหาด","BATTER UP":"เตรียมตีลูก","BATWHEELS BY YOU":"แบตวีลส์ในแบบคุณ","BE COOL SCOOBY DOO NO GUTS NO TREATS":"สคูบี้ดู ถ้าไม่กล้าก็อดรางวัล","BE COOL SCOOBY DOO THE MYSTERIOUS MANSION":"สคูบี้ดู คฤหาสน์ปริศนา","BATTLE DAY BRAWL":"ศึกเดือดวันประจัญบาน","BARBIE SPY":"บาร์บี้สายลับ","BEARY SPOT ON":"หมีแม่นเป้า","BEN 10 OVERFLOW FIGHT":"เบ็นเท็น ศึกโอเวอร์โฟลว์","ADVENTURE TIME CANDY DIVE":"แอดเวนเจอร์ไทม์ ดำดิ่งแดนลูกกวาด","BEANO BUSH CHUCKER CHALLENGE":"บีโน ภารกิจขว้างพุ่มไม้","ADVENTURE TIME ANGRY BETTY":"แอดเวนเจอร์ไทม์ เบ็ตตี้โกรธ","BEAN SKIDDING":"ถั่วลื่นไถล","BEN 10 POWER SURGE":"เบ็นเท็น พลังทะลัก","BEN 10 OMNITRIX SHADOW":"เบ็นเท็น เงาออมนิทริกซ์","BEN 10 PENALTY POWER":"เบ็นเท็น พลังยิงจุดโทษ","BEN 10 SPOT THE DIFFERENCE":"เบ็นเท็น จับผิดภาพ","ADAM AND EVE SLEEPWALKER":"อดัมกับอีฟ คนละเมอ","BACKYARD HOOPS":"บาสหลังบ้าน","BACKYARD JUNK":"ของเก่าหลังบ้าน","BEN 10 ALIENRIVALS V2":"เบ็นเท็น คู่แข่งเอเลียน V2","BEN 10 ESCAPE ROUTE":"เบ็นเท็น เส้นทางหลบหนี","BEN 10 STEAM CAMP":"เบ็นเท็น ค่ายไอน้ำ","BEN 10 CANNONBOLT SMASH":"เบ็นเท็น แคนนอนโบลต์ถล่ม","BARBIE MAKE UP":"แต่งหน้าบาร์บี้","BEATS BATTLE":"ศึกจังหวะ","ADVENTURE TIME GATE CRASHERS":"แอดเวนเจอร์ไทม์ ผู้บุกประตู","ADVENTURE TIME THESE LUPMS":"แอดเวนเจอร์ไทม์ เจ้าก้อนจอมป่วน","BEN 10 TOMB OF DOOM":"เบ็นเท็น สุสานมรณะ","ALVIN SUPER RUN":"อัลวิน ซูเปอร์รัน","ADVENTURE TIME FIONNA FIGHTS":"แอดเวนเจอร์ไทม์ ฟิโอนาต่อสู้","BERRIES":"ผลไม้ตระกูลเบอร์รี","ALL THAT EMPLOYEE":"พนักงานออลแดต","BEN 10 UNDERTOWN RUNNER":"เบ็นเท็น นักวิ่งอันเดอร์ทาวน์"}

/***/ }),

/***/ "./src/translations/tr.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Play Way Beyond","sidebar.home":"Anasayfa","sidebar.myaccount":"Hesabım","sidebar.notif":"Bildirim","sidebar.nonotif":"Henüz bildirim bulunmamaktadır","html5games":"HTML5 Oyunlar","androidGames":"Android Oyunlar","favorite":"Sık kullanılanlar","welcome.text":"Hemen en iyi online mobil oyunları keşfet!","footer.copyright":"© 2018 Gamelords. Tüm hakları saklıdır.","accountDetails":"Hesap Ayarları","accountName":"İsim","accountEmail":"Email Adresi","accountLocation":"Lokasyon","accountInterests":"İlgi alanları","accountChooseCategory":"3 Kategori seçin","accountEditPhoto":"Fotoğrafı Düzenle","save":"Kaydet","topCategories":"En popüler kategoriler","favGames":"Favori Oyunlar","viewAll":"Hepsini gör","noGameFound":" Oyun bulunamadı ","cancel":"İptal","gameDirectories":"Oyun Dizinleri","category":"Kategori","noGamesFound":"Bu kategoride oyun bulunamadı","platform":"Platform","type":"Yaz","android-upper":"ANDROID","games":"Oyunlar","html5":"HTML5","description":"Description","downloadNow":"Hemen indir","playNow":"Hemen oyna","rate":"Puan","relatedGames":"İlgili oyunlar","noFavGames":"Henüz favori oyun eklemediniz","addFavGames":"Favori videolarınıza kolayca erişmek ve izlemek için sık kullanılanlara ekleyin.","discover":"Keşfet","noFavGamesFound":"Favori oyun bulunamadı","favorites":"Favoriler","accessDenied":"Erişim reddedildi","pageRestricted":"Aradığınız sayfa engellendi","privacyPolicy":"Gizlillik Politikası","tnc":"Şartlar ve Koşullar","kazakhOnly":"","areYouAlready":"Zaten üye misiniz ","thenConfirm":"O zaman telefon numaranızı girin ve içeriğimize limitsiz erişim sağlayın","login":"giriş","search.input.placeholder":"Arat","search.cancel.button":"İptal","Sports":"Spor","Action":"Aksiyon","Adventure":"Macera","Fitness":"Träning","Entertainment":"Eğlence","Premium Games":"Premium Oyunlar","RPG":"RPG","Virtual Reality":"Sanal Gerçeklik","Arcade":"Arcade oyun","Racing":"Yarış","pleaseLogin":"Devam etmek için lütfen giriş yapınız","loginUsing":"Mesajla gelen kullanıcı adını ve şifreyi kullanarak giriş yapın","usernameRequired":"Kullanıcı adı gerekli","passwordRequired":"Şifre gerekli","username":"Kullanıcı adı","password":"Şifre"}

/***/ }),

/***/ "./src/translations/vi.json":
/***/ (function(module, exports) {

module.exports = {"splashscreen.text":"Chơi không giới hạn","sidebar.home":"Trang chủ","sidebar.myaccount":"Tài khoản của tôi","sidebar.notif":"Thông báo","sidebar.nonotif":"Bạn chưa có thông báo nào","html5games":"HTML5 Games","androidGames":"ANDROID Games","favorite":"Mục ưa thích","welcome.text":"Khám phá kho game độc quyền ngay hôm nay!","footer.copyright":"© 2019 Bản quyền Gamelord","accountDetails":"Thông tin tài khoản","accountName":"Tên","accountEmail":"Địa chỉ email","accountLocation":"Nơi ở","accountInterests":"Sở thích của bạn","accountChooseCategory":"Chon 3 mục","accountEditPhoto":"Sửa ảnh","save":"Lưu","topCategories":"Các thư mục chính","favGames":"Game yêu thích","viewAll":"Xem tất cả","noGameFound":" Không tìm thấy game nào ","cancel":"Hủy","gameDirectories":"Thư mục game","category":"Thư muc","noGamesFound":"Không có game nào được tìm thấy trong thư mục này","platform":"Nền tảng","type":"Loại","android-upper":"ANDROID","games":"games","html5":"HTML5","description":"Description","downloadNow":"Tải ngay","playNow":"Chơi ngay","rate":"Đánh giá","relatedGames":"Games cùng loại","noFavGames":"Chưa có game yêu thích","addFavGames":"Thêm game yêu thích của bạn vào thư mục riêng","discover":"Khám phá","noFavGamesFound":"Không tìm thấy game yêu thích","favorites":"Yêu thích","accessDenied":"Không có quyền truy cập","pageRestricted":"Trang này bị hạn chế","privacyPolicy":"Chính sách riêng tư","tnc":"Điều khoản & Điều kiện","kazakhOnly":"","areYouAlready":"Bạn đã đăng ký thành viên của ","thenConfirm":"Hãy xác nhận số điện thoại và thỏa thích chơi trọn bộ game <strong>HTML </strong> và <strong> Android </strong> cực hot","login":"Đăng nhập","search.input.placeholder":"Tìm kiếm...","search.cancel.button":"Hủy","averageRatingBasedOn":" sao đánh giá từ người dùng dựa trên ","averageRatingReview":" lượt xem","Sports":"Thể thao","Action":"Hành động","Adventure":"Phiêu lưu","Fitness":"Gym","Entertainment":"Giải trí","Premium Games":"Games độc quyền","RPG":"RPG","Virtual Reality":"Thực tế ảo","Arcade":"Nhập vai","Racing":"Đua xe"}

/***/ }),

/***/ "./src/utils/domainTheme.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDomainTheme = undefined;

var _theme = __webpack_require__("./src/constants/theme.js");

var getDomainTheme = exports.getDomainTheme = function getDomainTheme() {
    var product = window.location.hostname.split('.')[1];

    var defaultTheme = {
        logo: "img/logo.png",
        productName: "Gamelords"
    };

    return _theme.domainThemes[product] || defaultTheme;
};

/***/ }),

/***/ "./src/utils/helper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParameters = exports.validURL = exports.filterGames = exports.shuffle = exports.loggedInDetail = exports.appendUid = exports.formatDate = exports.jsUcfirst = exports.parseQueryString = exports.console_log = undefined;

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _domainConfig = __webpack_require__("./src/constants/domainConfig.js");

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var console_log = exports.console_log = function console_log(param1, param2) {
    if (param2) {
        console.log(param1, param2);
    } else {
        console.log(param1);
    }
};

var parseQueryString = exports.parseQueryString = function parseQueryString(url) {
    var urlParams = {};
    url.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function ($0, $1, $2, $3) {
        urlParams[$1] = $3;
    });

    return urlParams;
};

var jsUcfirst = exports.jsUcfirst = function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var formatDate = exports.formatDate = function formatDate(date) {
    return (0, _moment2.default)(date).format("DD MMM YYYY");
};

var appendUid = exports.appendUid = function appendUid(route, uid) {
    if (uid) {
        var val = route + '?uid=' + uid;
        return val;
    } else return route;
};

var authorizedData = sessionStorage.getItem("authorized") ? JSON.parse(sessionStorage.getItem("authorized")) : null;
var loggedInDetail = exports.loggedInDetail = authorizedData;

var shuffle = exports.shuffle = function shuffle(videoArray) {
    var ctr = videoArray.length;
    var temp = void 0;
    var index = void 0;

    // While there are elements in the array
    while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = videoArray[ctr];
        videoArray[ctr] = videoArray[index];
        videoArray[index] = temp;
    }
    return videoArray;
};

var filterGames = exports.filterGames = function filterGames(game) {
    if ((_domainConfig.config.subDomain == 'iq' || _domainConfig.config.subDomain == 'asiacell') && game.gameImage.indexOf('Batch+2') == -1 || _domainConfig.config.subDomain != 'iq' || _domainConfig.config.subDomain == 'asiacell') {
        return true;
    }
    return false;
};

var validURL = exports.validURL = function validURL(str) {
    var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (regexp.test(str)) {
        return true;
    } else {
        return false;
    }
};
var hashToQuery = function hashToQuery() {
    var d = window.location.hash.slice(1);
    d = d.split("?");
    return d[d.length - 1];
};

var keysLowerCase = function keysLowerCase(obj) {
    var keys = Object.keys(obj);
    var n = keys.length;
    var res = {};
    while (n--) {
        res[keys[n].toLowerCase()] = obj[keys[n]];
    }
    return res;
};

var getParameters = exports.getParameters = function getParameters(params) {
    var queryStrings = keysLowerCase(_querystring2.default.parse(window.location.search.slice(1)));
    var hashQueryStrings = keysLowerCase(_querystring2.default.parse(hashToQuery()));
    var d = queryStrings[params] || hashQueryStrings[params];
    return {
        exist: d && d.length > 0 ? true : false,
        value: d
    };
};

/***/ }),

/***/ "./src/utils/login.utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFlag = exports.getPlaceHolder = exports.isvalid = exports.parse = undefined;

var _libphonenumberJs = __webpack_require__("./node_modules/libphonenumber-js/index.js");

var _countryFlagsSvg = __webpack_require__("./node_modules/country-flags-svg/dist/index.js");

var parse = function parse(msisdn, country) {
    if (country === "xx") return msisdn;
    try {
        var parsed = (0, _libphonenumberJs.parsePhoneNumber)(msisdn, country.toUpperCase());
        return parsed.number.replace("+", "");
    } catch (e) {
        return msisdn;
    }
};

var isvalid = function isvalid(msisdn, country) {
    if (country === "xx") return true;
    try {
        var parsed = (0, _libphonenumberJs.parsePhoneNumber)(msisdn, country.toUpperCase());
        return parsed.isPossible();
    } catch (e) {
        return false;
    }
};

var getPlaceHolder = function getPlaceHolder(country) {
    if (country === 'xx') return "";
    country = country.toUpperCase();
    return (0, _libphonenumberJs.getCountryCallingCode)(country) + "xxxxxxxx";
};

var getFlag = function getFlag(country) {
    if (country === "xx") return null;else return (0, _countryFlagsSvg.findFlagUrlByIso2Code)(country.toUpperCase());
};

exports.parse = parse;
exports.isvalid = isvalid;
exports.getPlaceHolder = getPlaceHolder;
exports.getFlag = getFlag;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
module.exports = __webpack_require__("./src/index.js");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

/******/ });


// WEBPACK FOOTER //
// index.bundle.js